export type AppLanguage = "en" | "hi" | "pt" | "fr" | "es";

export interface AppLanguageOption {
  label: string;
  value: AppLanguage;
  flag: string;
  code: string;
}

export const APP_LANGUAGES: AppLanguageOption[] = [
  { label: "English",   value: "en", flag: "🇬🇧", code: "EN" },
  { label: "हिन्दी",   value: "hi", flag: "🇮🇳", code: "HI" },
  { label: "Português", value: "pt", flag: "🇧🇷", code: "PT" },
  { label: "Français",  value: "fr", flag: "🇫🇷", code: "FR" },
  { label: "Español",   value: "es", flag: "🇪🇸", code: "ES" },
];

export const TRANSLATIONS: Record<AppLanguage, Record<string, string>> = {
  en: {
    "crmwa.newNumbers": "New numbers",
    "crmwa.newNumbersHint": "People who wrote to you from a number that is not saved in the CRM.",
    "crmwa.tabNew": "Waiting",
    "crmwa.tabBlocked": "Blocked",
    "crmwa.searchPlaceholder": "Search name or number…",
    "crmwa.firstMessage": "First message",
    "crmwa.lastMessage": "Latest",
    "crmwa.noName": "Name not shared",
    "crmwa.notSaved": "Not in your CRM yet",
    "crmwa.createLead": "Create lead",
    "crmwa.block": "Block as spam",
    "crmwa.unblock": "Unblock",
    "crmwa.blockedBadge": "Blocked",
    "crmwa.leadBadge": "Lead created",
    "crmwa.openChat": "Open chat",
    "crmwa.emptyTitle": "No new numbers",
    "crmwa.emptySub": "When someone new messages your WhatsApp number, they appear here for you to review. Saved contacts never show up here.",
    "crmwa.emptyBlockedTitle": "No blocked numbers",
    "crmwa.emptyBlockedSub": "Numbers you block as spam are listed here, so you can unblock them any time.",
    "crmwa.selectTitle": "Select a number",
    "crmwa.selectSub": "Read what they wrote, then create a lead or block the number.",
    "crmwa.whatTheyWrote": "What they wrote",
    "crmwa.blockedNote": "Messages from this number are ignored. Unblock it to see new messages.",
    "crmwa.blockConfirmTitle": "Block this number?",
    "crmwa.blockConfirmSub": "New messages from it will be ignored. You can unblock it later from the Blocked tab.",
    "crmwa.cancel": "Cancel",
    "crmwa.blockConfirm": "Yes, block",
    "crmwa.blockedToast": "Number blocked",
    "crmwa.unblockedToast": "Number unblocked",
    "crmwa.leadCreatedToast": "Lead created",
    "crmwa.leadCreatedSub": "The chat is now in your Inbox.",
    "crmwa.errorTitle": "Something went wrong",
    "crmwa.loadError": "Could not load the numbers.",
    "crmwa.sheetTitle": "Create lead",
    "crmwa.sheetSub": "Turn this WhatsApp number into a lead your team can follow up.",
    "crmwa.fldName": "Person's name",
    "crmwa.fldNameHint": "From their WhatsApp profile. You can correct it.",
    "crmwa.fldCompany": "Company (optional)",
    "crmwa.fldCompanyHint": "Leave empty to use their name and number.",
    "crmwa.fldOwner": "Lead owner",
    "crmwa.ownerOnlyYou": "This lead will be yours.",
    "crmwa.fldNote": "Note (optional)",
    "crmwa.notePlaceholder": "Anything the team should know…",
    "crmwa.accountWillBe": "Account name",
    "crmwa.contactWillBe": "Contact",
    "crmwa.you": "You",
    "crmwa.creating": "Creating…",
    "crmwa.whatHappens": "This creates an account, a contact with this mobile number and a deal, and moves the chat into your Inbox.",
    "crmwa.close": "Close",
    "crmwa.mobile": "Mobile",
    "crmwa.pickOwner": "Choose who owns this lead",
    "crmwa.freeTextNote": "You can reply with free text for 24 hours after their last message.",
    "crmai.headerBtn": "Linc AI",
    "crmai.barOn": "Linc AI is answering this chat",
    "crmai.barSuggest": "Linc AI writes suggested replies for you",
    "crmai.barPaused": "You have this chat. Linc AI stays quiet for a while.",
    "crmai.barHandoff": "Linc AI handed this chat to you.",
    "crmai.barStopped": "Linc AI is stopped in this chat.",
    "crmai.stoppedSpam": "It looked like spam.",
    "crmai.stoppedFlood": "The customer sent too many messages too fast.",
    "crmai.stoppedPerson": "It was switched off here.",
    "crmai.takeOver": "I'll handle it",
    "crmai.stop": "Stop AI here",
    "crmai.handBack": "Let Linc AI answer",
    "crmai.draftTitle": "Linc AI suggests",
    "crmai.draftHandoff": "Linc AI thinks a person should take over",
    "crmai.draftUse": "Use this reply",
    "crmai.draftDiscard": "Discard",
    "crmai.takeOverToast": "Linc AI will stay quiet in this chat",
    "crmai.stopToast": "Linc AI stopped in this chat",
    "crmai.handBackToast": "Linc AI will answer again",
    "crmai.settings": "Linc AI replies",
    "crmai.settingsSub": "Choose who Linc AI answers for, and how.",
    "crmai.master": "Master switch",
    "crmai.masterHint": "Off means Linc AI never writes to anyone.",
    "crmai.modeOff": "Off",
    "crmai.modeSuggest": "Suggest",
    "crmai.modeAuto": "Auto",
    "crmai.modeSuggestHint": "Linc AI writes a draft. A person reviews and sends it.",
    "crmai.modeAutoHint": "Linc AI answers by itself and hands over when needed.",
    "crmai.team": "Salespeople",
    "crmai.teamHint": "Linc AI answers the chats of accounts owned by people set to Suggest or Auto.",
    "crmai.unowned": "Chats with no owner",
    "crmai.coreLocked": "Only a Super Admin or Root can change this.",
    "crmai.limits": "Limits",
    "crmai.maxInRow": "Linc AI messages in a row, then hand over",
    "crmai.maxPerHour": "Most Linc AI messages per hour",
    "crmai.maxPerDay": "Most Linc AI messages per day",
    "crmauto.chip": "Unreviewed",
    "crmauto.chipTip": "Added automatically from a WhatsApp message. Check the name and number, then tap Confirm.",
    "crmauto.confirm": "Confirm contact",
    "crmauto.confirmTip": "I checked this contact",
    "crmauto.confirmedTitle": "Confirmed",
    "crmauto.confirmedText": "The Unreviewed tag is gone.",
    "crmauto.settingTitle": "Auto-add new WhatsApp numbers",
    "crmauto.settingHint": "When someone new writes on WhatsApp, add them as a contact automatically (tagged Unreviewed) so Linc AI can answer. Spam, flooding and blocked numbers are never added. Only a Super Admin or Root can change this.",
    "crmauto.settingSwitch": "Add new numbers automatically",
    "crmauto.perDay": "Most contacts added automatically per day",
    "legal.bannerTitleUpdated": "Legal documents updated.",
    "legal.bannerLeadUpdated": "We’ve updated",
    "legal.bannerTitleNew": "Please accept our legal documents.",
    "legal.bannerLeadNew": "Please review",
    "legal.dialogTitleUpdated": "Updated legal documents",
    "legal.dialogTitleNew": "Legal documents",
    "legal.dialogBodyUpdated": "We’ve updated the documents below. Please review them and confirm to continue.",
    "legal.dialogBodyNew": "Please review the documents below and confirm to continue.",
    "invite.acceptTitle": "Join this company",
    "invite.acceptText": "Before you join, please confirm the agreement.",
    "invite.acceptButton": "Accept invitation",
    "pay.offlineLive": "This page updates by itself.",
    "pay.cardPaused": "Card payment is paused while your bank transfer waits.",
    "pay.outcomeApprovedTitle": "Your payment was confirmed",
    "pay.outcomeApprovedBody": "Your plan is active now. Continue to start using LumberLinq.",
    "pay.outcomeContinue": "Continue",
    "pay.outcomeRejectedTitle": "Your payment could not be confirmed",
    "pay.outcomeReversedTitle": "Your payment was reversed",
    "pay.outcomeTryAgainBody": "You can submit it again or pay another way.",
    "pay.outcomeTryAgain": "Pay again",
    "sp.seePlans": "See plans",
    "sp.backToWaiting": "Back to my payment",
    "sp.yourSelection": "Your selection",
    "adminOffline.waTemplate": "WhatsApp message when approved: template name",
    "adminOffline.waTemplateLang": "Template language (for example en or hi)",
    "adminOffline.waValues": "Order of values in that template (comma separated: name, plan, amount, company, date, reference, method)",
    "adminOffline.waRejectedTemplate": "Template name when a payment could not be confirmed",
    "adminOffline.waRejectedLang": "Language of that template",
    "adminOffline.waPlanEndingTemplate": "Template name 3 days before a plan ends",
    "adminOffline.waPlanEndingLang": "Language of that template",
    "adminOffline.waValuesHint": "Each message above is sent only when its template name is filled in and approved at Meta. \"Payment confirmed\" values default to name, plan, amount; \"could not be confirmed\" sends name, amount, reference; \"plan ends\" sends name, plan, date. Use the language exactly as Meta shows it (en, or en_US).",
    "adminOffline.waTemplateHint": "Name of a UTILITY template that Meta has approved, with three variables: first name, plan, amount. Leave empty to send no WhatsApp message. The customer always gets a push and an e-mail.",
    "sp.seeAll": "See all features",
    "sp.showLess": "Show less",
    "sp.chooseHint": "Choose a plan to continue",
    "pay.billingIncomplete": "Please complete the billing details marked in red.",
    "pay.termsNotSaved": "We could not save your agreement to the terms. Please try again.",
    "pay.reviewAndPay": "Review and pay",
    "crmai.timing": "Timing",
    "crmai.delay": "Wait before answering (seconds)",
    "crmai.pause": "Quiet after a person replies (hours)",
    "crmai.offTitle": "When Linc AI is off",
    "crmai.offHint": "Customers get this message instead, at most once per quiet period in each chat.",
    "crmai.offSwitch": "Send this message when Linc AI is off",
    "crmai.offText": "Message",
    "crmai.offPlaceholder": "Thanks for your message! Our team will reply soon.",
    "crmai.knowledge": "What Linc AI may use",
    "crmai.links": "Links it may share (one per line)",
    "crmai.linksPlaceholder": "Pricing: https://…\nFree trial: https://…",
    "crmai.facts": "Facts about LumberLinq (no prices)",
    "crmai.factsPlaceholder": "What LumberLinq does, who it is for, how a trial works…",
    "crmai.helpNotes": "For how-to questions it also uses your Linc AI Help notes.",
    "crmai.try": "Try a customer message",
    "crmai.tryPlaceholder": "Type what a customer might write…",
    "crmai.tryBtn": "Try it",
    "crmai.trying": "Thinking…",
    "crmai.tryIntent": "Understood as",
    "crmai.tryHandoff": "Would hand over to a person",
    "crmai.today": "Today",
    "crmai.statAuto": "Answered",
    "crmai.statDrafts": "Drafts",
    "crmai.statHandoffs": "Handed over",
    "crmai.statTokens": "Tokens used",
    "crmai.save": "Save",
    "crmai.saving": "Saving…",
    "crmai.saved": "Saved",
    "crmai.savedSub": "Linc AI settings updated.",
    "crmai.loadError": "Could not load the Linc AI settings.",
    "crmai.abuseTitle": "Spam and too many messages",
    "crmai.abuseHint": "Linc AI stops in a chat for a while, then answers again by itself. A second stop within a week lasts until a person switches it on. A customer who sends too many messages gets one polite notice first; confident spam gets none.",
    "crmai.floodMinutes": "Stop after too many messages (minutes)",
    "crmai.spamHours": "Stop after spam (hours)",
    "crmai.floodNotice": "Notice sent before a stop for too many messages",
    "crmai.floodNoticePlaceholder": "Leave empty to use: I can't answer more messages right now. If this is about LumberLinq, a team member will reply to you soon.",
    "crmai.resumesAt": "It resumes by itself at",
    "crmfile.kindImage": "Photo",
    "crmfile.kindVideo": "Video",
    "crmfile.kindAudio": "Voice message",
    "crmfile.kindSticker": "Sticker",
    "crmfile.kindDoc": "Document",
    "crmfile.receiving": "Receiving…",
    "crmfile.failed": "Could not be saved. Open WhatsApp on the phone to see it.",
    "crmfile.download": "Download",
    "crmfile.attach": "Attach a file",
    "crmfile.tooBigImage": "A picture can be up to 5 MB.",
    "crmfile.tooBigFile": "A file can be up to 10 MB.",
    "crmfile.notSent": "File not sent",
    "crmfile.captionHint": "your text goes with it",
    "crmfile.captionPlaceholder": "Add a message to go with the file (optional)…",
    "crmfile.remove": "Remove the file",
    "crmverify.title": "Approve WhatsApp access?",
    "crmverify.text": "Someone on this WhatsApp number is asking LumberLinq's assistant for help with your account:",
    "crmverify.hint": "Approve only if it is you. They can then get help notes your role allows, for 15 minutes. Nothing can be changed.",
    "crmverify.more": "more request(s) waiting",
    "crmverify.approve": "Approve",
    "crmverify.deny": "Deny",
    "crmverify.approvedTitle": "Approved",
    "crmverify.approvedSub": "The WhatsApp chat can now get help for 15 minutes.",
    "crmverify.deniedTitle": "Denied",
    "crmverify.deniedSub": "That number is blocked for an hour.",
    "crmverify.expired": "This request has expired or was already handled.",
    "crmverify.settingTitle": "Customer support on WhatsApp",
    "crmverify.settingHint": "A customer who asks for help with their own account must prove who they are first: an Approve tap in their logged-in app, or a code sent to their registered email. Then Linc AI answers only from help notes their role allows, and plan facts only after an app approval by a company Owner or Admin. Nothing is ever changed over WhatsApp.",
    "crmverify.settingSwitch": "Allow customer support on WhatsApp",
    "crmqr.button": "Ready-made messages",
    "crmqr.title": "Ready-made messages",
    "crmqr.sub": "Pick one for common questions and marketing. You can edit it before sending.",
    "crmqr.search": "Search, e.g. price, demo, offline…",
    "crmqr.all": "All",
    "crmqr.emptyTitle": "No message found",
    "crmqr.emptySub": "Try other words or clear the filters.",
    "crmqr.clear": "Clear filters",
    "crmqr.hint": "The customer's first name is filled in. The message goes into the box, and you press Send.",
    "crmqr.cat.welcome": "Welcome",
    "crmqr.cat.product": "Product",
    "crmqr.cat.pricing": "Pricing",
    "crmqr.cat.start": "Get started",
    "crmqr.cat.help": "Help",
    "crmqr.cat.qa": "Common questions",
    "crmqr.cat.followup": "Follow-up",
    "crmqr.cat.closing": "Closing",
    "tallysheet.tu.stockAllOrigins": "All origins",
    "tallysheet.tu.stockOriginUnknown": "Origin unknown",
    "tallysheet.tu.pickOrigin": "Pick an origin",
    "inventory.rowOnlyFree": "Only {free} free of {need} — tap to fix",
    "inventory.rowNoneFree": "None free — tap to fix",
    "rowClash.needsOne": "row was added at the same place as someone else's rows",
    "rowClash.needsMany": "rows were added at the same place as someone else's rows",
    "rowClash.prev": "Previous clashing row",
    "rowClash.next": "Next clashing row",
    "rowClash.showOnlyTip": "Show only the rows two people added at the same place",
    "rowClash.showAll": "Show all rows",
    "rowClash.showOnly": "Show only these",
    "rowClash.change": "Change",
    "rowClash.markCheckedTip": "Clear these marks for everyone — nothing is moved or removed",
    "rowClash.markChecked": "Mark as checked",
    "rowClash.title": "Rows added at the same place",
    "rowClash.intro": "Two people added rows at the same place in this sheet. Both sets are kept. Choose the order, or remove one set if the same logs were measured twice.",
    "rowClash.rows": "Rows:",
    "rowClash.wasThere": "Were there first",
    "rowClash.wasPlaced": "Were placed next to them",
    "rowClash.chooseLabel": "What should happen?",
    "rowClash.current": "Now",
    "rowClash.cannotMove": "A Custom-Made job is tied to one of these rows, so the order can't be changed.",
    "rowClash.confirmRemove": "This deletes these rows for everyone. It can't be undone. Tap again to confirm.",
    "rowClash.confirmYes": "Yes, remove",
    "rowClash.apply": "Apply",
    "rowClash.loadFailed": "Could not load this clash. Check your connection and try again.",
    "rowClash.noRoom": "There is no room to put the rows there. Reload the sheet and try again.",
    "rowClash.applyFailed": "Could not apply this. Reload the sheet and try again.",
    "rowClash.someone": "someone",
    "rowClash.opt.mineAfter": "Keep both — mine after theirs",
    "rowClash.opt.mineFirst": "Keep both — mine first",
    "rowClash.opt.dropMine": "Keep theirs, drop mine",
    "rowClash.opt.deleteTheirs": "Keep mine, delete theirs",
    "rowClash.opt.firstThen": "Keep both — {first}'s rows first, then {second}'s",
    "rowClash.opt.keepOnly": "Keep {keep}'s rows, remove {remove}'s",
    "rowClash.hint.order": "{first} first, then {second} — each set stays together",
    "rowClash.hint.remove": "Removes {count} row(s) added by {name}",
    "rowClash.placedTitle": "Rows added at the same place",
    "rowClash.placedBody": "{count} of your rows were placed after rows {names} added at the same place. Use \"Clashing rows\" above the sheet to check or change this.",
    "rowClash.placedAsIs": "{count} of your rows were saved, but someone else added rows at the same place. Use \"Clashing rows\" above the sheet to check them.",
    "syncIssues.keepMine": "Keep mine (save over their change)",
    "syncIssues.rowConflict": "Someone else changed these rows while you were offline. Keep mine, or Discard to keep theirs.",
    "tallysheet.rowConflict.title": "Changed by someone else",
    "tallysheet.rowConflict.message": "Someone else changed these rows after you opened this sheet. Row:",
    "tallysheet.rowConflict.choice": "Keep mine saves your version over theirs. Show their change saves your other rows, then reloads the sheet — your change to these rows is dropped.",
    "tallysheet.rowConflict.keepMine": "Keep mine",
    "tallysheet.rowConflict.showTheirs": "Show their change",
    "tallysheet.rowConflict.status": "Not saved — someone else changed a row",
    "upload.sending": "Sending",
    "offline.keepOffline": "Keep offline",
    "offline.removeFromOffline": "Remove from offline",
    "offline.keptOffline": "Saved on this phone — it works offline with its tally sheet.",
    "offline.keepOfflineLater": "It will be saved on this phone at the next sync.",
    "offline.removedFromOffline": "No longer kept offline (still kept if it is from the last 90 days or still open).",
    "offline.syncTitle": "Offline sync",
    "offline.lastSynced": "Last synced {when}",
    "offline.lastSyncedNever": "Not synced yet on this phone",
    "offline.justNow": "just now",
    "offline.minAgo": "{n} min ago",
    "offline.hoursAgo": "{n} h ago",
    "offline.daysAgo": "{n} days ago",
    "offline.syncNow": "Sync now",
    "offline.youAreOffline": "You are offline — changes are saved on this phone and sent when you're back online.",
    "syncIssues.tryAgain": "Try again",
    "offline.waitingSync": "waiting to sync",
    "offline.waitingSyncHint": "Saved on this phone — they will be sent when the internet is back",
    "offlineLock.title": "Offline for too long",
    "offlineLock.lead": "This phone has been offline for 15 days or more, so the app is locked to keep your data safe.",
    "offlineLock.changesSafe": "{n} unsynced change(s) are kept safe on this phone.",
    "offlineLock.waiting": "Connect to the internet to continue. You will then choose what happens to these changes.",
    "offlineLock.checking": "Connecting…",
    "offlineLock.askTitle": "Sync your old changes?",
    "offlineLock.askBody": "You have {n} change(s) from before. Yes: they are sent now, then you are logged out. No: they are deleted, then you are logged out.",
    "offlineLock.yes": "Yes, sync them",
    "offlineLock.no": "No, delete them",
    "offlineLock.deletedTitle": "Old changes deleted",
    "offlineLock.deletedBody": "Your {n} old change(s) were deleted because you chose No.",
    "offline.removedTitle": "Offline changes removed",
    "offline.removedBody": "{n} change(s) you made offline on this phone were removed, because another user logged in on it before they could sync. Please enter them again if still needed.",
    "offline.notSynced": "not synced",
    "offline.notSyncedHint": "Changes on this phone that are not saved on the server yet — tap to see them",
    "offline.itemSyncing": "item syncing…",
    "offline.itemsSyncing": "items syncing…",
    "upload.of": "of",
    "upload.left": "left",
    "upload.processing": "Processing…",
    "upload.sent": "sent",
    "upload.retry": "Retry",
    "upload.cancel": "Cancel upload",
    "recon.piecesNotComparable": "The unloading tally is a different kind (Round vs Square), so pieces can't be compared — only the volume difference is used.",
    "tallysheet.tu.reconReceived": "Received (reconciled):",
    "tallysheet.tu.reconLoaded": "loaded",
    "tallysheet.tu.reconRecordedOnly": "recorded only (lot already milled / sold) — correct stock with an Adjustment",
    "recon.notReceived.title": "This Stock Unit isn't in inventory yet.",
    "recon.notReceived.text": "Receive it into inventory first — then reconcile, so the difference goes into stock.",
    "recon.notReceived.askReceive": "Ask someone who can receive stock to receive it first.",
    "recon.notReceived.done": "Received into inventory — you can reconcile now.",
    "recon.notReceived.failed": "Couldn't receive it. Open the Stock Unit and check product, site and tally rows.",
    "recon.stockWillChange": "Locking puts what really arrived into stock:",
    "invInOut.reconAlreadyAppliedTitle": "Reconciliation already applied",
    "invInOut.reconAlreadyAppliedText": "This Stock Unit's reconciliation already changed its stock by {cbm} CBM. If this adjustment is for the same shortage, stock is now corrected twice — undo it with an opposite adjustment.",
    "tallysheet.tu.openingChipHint": "Stock the company already had on day one (added with Opening Stock).",
    "receive.volumeFromTallies": "This lot's volume comes from its Stock Unit tallies — correct the tally instead.",
    "invOverview.openingStock": "Opening Stock",
    "invOverview.openingStockHint": "Add stock you already have",
    "tallysheet.tu.openingTitle": "Opening stock",
    "tallysheet.tu.openingSteps": "Stock you already have. Save, fill in the tally (sizes and pieces), then press Receive into Inventory. No transport mode needed; a consignment is optional — link one only if you want the purchase record.",
    "tallysheet.tu.openingDone": "Stock you already had — added to inventory. Link a consignment only if you want the purchase record.",
    "appSettings.productTourSection": "Product tours",
    "appSettings.productTourEnabled": "Show product tours",
    "appSettings.productTourHint": "When on, each user sees each page's tour once — finished or skipped, it never shows again on any of their devices. When off, no tour shows and the Tour button is hidden.",
    "home.page.dashboard": "Dashboard",
    "home.page.tallySheets": "Tally sheets",
    "home.page.consignments": "Consignments",
    "home.page.inventory": "Inventory",
    "home.restricted.title": "This page isn't part of your role yet",
    "home.restricted.text": "Your company admin decides which pages your role can open. You can ask them for access, or keep working on the pages below.",
    "home.restricted.canOpen": "Pages you can open",
    "home.restricted.goHome": "Go to my home page",
    "home.welcome.title": "Your account is ready",
    "home.setup.title": "Setting up your access…",
    "home.setup.text": "Your plan is active. We are getting your pages ready, this takes a few seconds.",
    "home.welcome.text": "Your admin hasn't given your role any page yet. Ask them for access — they'll get a notification right away.",
    "home.welcome.profile": "My profile",
    "home.welcome.logout": "Log out",
    "home.request.button": "Request access",
    "home.request.sent": "Request sent",
    "home.request.sentNote": "Your company admins have been told. You'll see the page once they update your role.",
    "home.request.failed": "Couldn't send the request. Please try again.",
    "home.roleHint.startsOn": "No Dashboard in this role — members will start on:",
    "home.roleHint.none": "This role opens no main page yet — members will see a welcome screen and can request access.",
    "plan.module.qualityGrading": "Quality Grading",
    "plan.module.inventoryModule": "Inventory Module",
    "plan.module.processModule": "Process Module",
    "plan.module.dedicatedSupport": "Dedicated Support",
    "plan.value.unlimited": "Unlimited",
    "plan.feature.teamMembers": "Team Members",
    "plan.feature.businessPartners": "Business Partners",
    "plan.feature.productsSpecies": "Products / Species",
    "plan.feature.loadingSites": "Locations",
    "plan.feature.tallySheets": "Tally Sheets",
    "plan.feature.shipments": "Consignments",
    "plan.feature.transportUnits": "Stock Units",
    "plan.feature.photoUploads": "Photo Uploads",
    "plan.feature.photoRetention": "Photo Retention",
    "plan.feature.storage": "Storage",
    "plan.feature.exportPdfExcel": "Export PDF & Excel",
    "plan.feature.importExcel": "Import Excel",
    "plan.feature.basicReports": "Basic Reports",
    "plan.feature.reconciliationReport": "Reconciliation Report",
    "plan.feature.usersActivityReport": "Users Activity Report",
    "plan.feature.advancedAnalytics": "Advanced Analytics",
    "plan.feature.aiImport": "AI Import",
    "plan.feature.prioritySupport": "Priority Support",
    "plan.feature.consignments": "Consignments",
    "plan.feature.exportTallyPdfExcel": "Export Tally (PDF+Excel)",
    "plan.feature.exportShipmentPdfExcel": "Export Consignment (PDF+Excel)",
    "plan.feature.importTallyExcel": "Import Tally (Excel)",
    "plan.feature.importShipmentExcel": "Import Consignment (Excel)",
    "plan.unit.users": "users",
    "plan.unit.records": "records",
    "plan.unit.sheets": "sheets",
    "plan.unit.sites": "sites",
    "plan.unit.units": "units",
    "plan.unit.photos": "photos",
    "plan.unit.days": "days",
    "plan.unit.mb": "MB",
    "plan.unit.creditsMonth": "credits/month",
    "common.monthly": "Monthly",
    "common.yearly": "Yearly",
    "plan.compare.show": "Show",
    "plan.compare.allFeatures": "All Features",
    "plan.compare.common": "Common",
    "plan.compare.differences": "Differences",
    "plan.savePercentTemplate": "Save {pct}%",
    "plan.saveUpTo20": "Save up to 20%",
    "plan.perMo": "/ mo",
    "plan.perYr": "/ yr",
    "common.language": "Language",
    "common.slowConnection": "Slow connection — things may take a little longer",
    "common.dismiss": "Dismiss",
    "planManagement.unavailableTitle": "Manage your plan",
    "planManagement.unavailableDesc": "This isn't available in the app. Please contact your account administrator.",
    "planManagement.backToDashboard": "Back to Dashboard",
    "planManagement.contactAdmin": "Contact your account administrator.",
    "accountSetup.iosAllSetTitle": "You're all set",
    "accountSetup.iosAllSetDesc": "Your account is ready to use. Start exploring LumberLinq now.",
    "accountSetup.iosAllSetGoToDashboard": "Go to Dashboard",
    "common.offlineStaleData": "Offline — showing cached data from",
    "common.offlineNotIncluded": "changes on this phone are not synced yet, so they are not included here.",
    "common.preparingOfflineData": "Preparing offline data…",
    "common.syncAreaBusinessPartners": "Business Partners",
    "common.syncAreaProducts": "Products",
    "common.syncAreaLoadingSites": "Locations",
    "common.syncAreaTransportUnits": "Stock Units",
    "common.syncAreaDashboard": "Dashboard",
    "common.search": "Search",
    "common.status": "Status",
    "common.filter": "Filter",
    "common.actions": "Actions",
    "common.name": "Name",
    "common.email": "Email",
    "common.user": "User",
    "common.password": "Password",
    "common.phone": "Phone",
    "common.country": "Country",
    "common.state": "State",
    "common.city": "City",
    "common.reset": "Reset",
    "common.delete": "Delete",
    "common.uploading": "Uploading...",
    "common.edit": "Edit",
    "common.active": "Active",
    "common.inactive": "Inactive",
    "common.blocked": "Blocked",
    "header.darkMode": "Dark Mode",
    "header.newBtn": "New",
    "header.searchHint": "Search or jump to…",
    "header.useClassic": "Use classic header",
    "header.useNew": "Use new header",
    "menuDock.useDock": "Use dock menu",
    "menuDock.useClassic": "Use classic menu",
    "menuDock.useDockRow": "Dock menu",
    "menuDock.iconsLabel": "Icons",
    "menuDock.iconSet.lucide": "Lucide",
    "menuDock.iconSet.phosphor": "Phosphor",
    "menuDock.iconSet.classic": "Classic",
    "menuDock.more": "More",
    "menuDock.navLabel": "Main menu",
    "menuDock.hideBar": "Hide bottom bar",
    "menuDock.focusMode": "Focus mode (hide both bars)",
    "menuDock.showBottomBar": "Show bottom bar",
    "menuDock.showBars": "Show bars",
    "menuDock.viewGroup": "View",
    "menuDock.railPin": "Pin the menu open",
    "menuDock.railUnpin": "Unpin the menu",
    "companyForm.regionalSettings": "Regional Settings",
    "companyForm.currency": "Company Currency",
    "companyForm.currencyHint": "Used as the default for new consignments and payments and for dashboard totals. Existing records keep their own currency.",
    "companyForm.timezone": "Company Time Zone",
    "companyForm.timezoneHint": "Monthly plan allowances reset on this clock. New team members start on it too.",
    "quickSearch.lockedStock": "Stock results are not part of your current plan.",
    "quickSearch.lockedMill": "Mill job results are not part of your current plan.",
    "quickSearch.seePlans": "See plans",
    "appSettings.nav.upgrade": "Upgrade",
    "appSettings.inventoryLocked": "Inventory settings are available on plans that include the Inventory module.",
    "tallyImport.button": "Import from Tally",
    "tallyImport.tooltip": "Import parties from a Tally export (Excel/CSV)",
    "tallyImport.dialogHeader": "Import Business Partners from Tally",
    "tallyImport.title": "Importing from Tally",
    "tallyImport.hint": "Export your list of ledgers from Tally to Excel or CSV and keep the Sundry Debtors and Sundry Creditors (other ledgers are not imported). Debtors become Buyers and creditors become Sellers. The Tax ID / GSTIN is optional. If the first rows of the file are a report title, use \"Skip rows at the top\" below.",
    "menuDock.railHide": "Hide the menu",
    "menuDock.railShow": "Show the menu",
    "menuDock.hideHeader": "Hide top bar",
    "menuDock.showHeader": "Show top bar",
    "menuDock.askLinc": "Ask Linc (AI help)",
    "header.lightMode": "Light Mode",
    "header.fontSize": "Font Size",
    "header.theme": "Theme",
    "header.preferences": "Preferences",
    "notification.bellLabel": "Notifications",
    "notification.title": "Notifications",
    "notification.markAllRead": "Mark all read",
    "notification.empty": "You're all caught up",
    "notification.disabled": "Notifications are not available right now",
    "notification.accept": "Accept",
    "notification.decline": "Decline",
    "notification.accepted": "Accepted",
    "notification.switchHint": "You can now switch to it anytime from your profile menu",
    "notification.declined": "Declined",
    "notification.viewAll": "View all",
    "business.subtitle":
      "Manage your trading partners and business relationships",
    "common.cancel": "Cancel",
    "common.pcs": "pcs",
    "common.loading": "Loading...",
    "common.unknown": "Unknown",
    "common.save": "Save",
    "sfs.pickStockUnit": "Which Stock Unit?",
    "sfs.pickConsignment": "Which consignment?",
    "sfs.searchPlaceholder": "Type a number or name",
    "sfs.searchHint": "Type at least 2 letters or digits to search.",
    "sfs.searching": "Searching…",
    "sfs.searchNone": "Nothing found. Try another number or name.",
    "sfs.searchFailed": "The search did not work. Please try again.",
    "tally.keypad.addRowBelow": "Add row below",
    "common.update": "Update",
    "common.logout": "Logout",
    "common.clear": "Clear",
    "common.saving": "Saving…",
    "common.saved": "Saved!",
    "common.saveFailed": "Failed",
    "common.add": "Add",
    "common.remove": "Remove",
    "common.calculate": "Calculate",
    "common.yes": "Yes",
    "common.no": "No",
    "common.stayOnPage": "Stay on This Page",
    "common.signInAgain": "Sign In Again",
    "common.ok": "Ok",
    "common.confirmation": "Confirmation",
    "common.or": "or",
    "common.required": "Required.",
    "common.isRequired": "is required.",
    "common.sectionHasErrors": "This section has validation errors.",
    "common.success": "Success",
    "common.error": "Error",
    "common.created": "Created",
    "common.somethingWentWrong": "Something went wrong. Please try again.",
    "common.switchCompany": "Switch Company",
    "common.accountMenu": "Account menu",
    "common.confirmSwitchCompany": "Switch Company",
    "common.switchCompanyConfirmMessage": "Switch your active company to {{companyName}}? You'll be moved into this company's data and settings.",
    "common.switchCompanyBlockedUnsynced": "You have changes that haven't finished syncing yet. Please wait for the sync to complete before switching company.",
    "common.leaveCompany": "Leave company",
    "common.leaveCompanyConfirmMessage": "Leave {{companyName}}? You'll lose access to this company, but your own account and its own company are unaffected.",
    "common.info": "Info",
    "common.validationError": "Validation Error",
    "common.noRecordsFound": "No records found.",
    "common.pendingSync": "Pending sync",
    "common.syncFailed": "Sync failed",
    "common.needsRename": "Needs rename",
    "syncIssues.title": "Sync Issues",
    "syncIssues.subtitle": "Items created offline that the server permanently rejected — review and discard, or fix and re-create manually.",
    "syncIssues.emptyState": "No sync issues — everything created offline has synced successfully.",
    "syncIssues.colType": "Type",
    "syncIssues.colItem": "Item",
    "syncIssues.colError": "Error",
    "syncIssues.colCreated": "Created",
    "syncIssues.discard": "Discard",
    "syncIssues.confirmDiscard": "Discard this item permanently? It was never saved to the server and this cannot be undone.",
    "syncIssues.confirmDiscardHeader": "Discard item",
    "syncIssues.discardedTitle": "Discarded",
    "syncIssues.discardedDetail": "The item has been removed.",
    "syncIssues.renamePlaceholder": "New name",
    "syncIssues.renameAndRetry": "Rename & Retry",
    "syncIssues.retrySuccessTitle": "Synced",
    "syncIssues.retrySuccessDetail": "Created successfully with the new name.",
    "syncIssues.retryFailedTitle": "Still failed",
    "common.records": "records",
    "common.chooseColumns": "Choose Columns",
    "common.searchKeyword": "Search keyword",
    "common.hello": "Hello",
    "common.companyId": "Company ID",
    "common.firstName": "First Name",
    "common.lastName": "Last Name",
    "common.useDefault": "Use Default",
    "common.view": "View",
    "common.data": "Data",
    "common.createdAt": "Created At",
    "common.undo": "Undo",
    "common.redo": "Redo",
    "common.import": "Import",
    "common.refresh": "Refresh",
    "common.downloadFailed": "Download Failed",
    "common.downloadFailedDetail": "Could not save the file. Please try again.",
    "common.open": "Open",
    "common.copy": "Copy",
    "common.revoke": "Revoke",
    "common.back": "Back",
    "common.itemsSelected": "Items Selected",
    "common.generalInformation": "General Information",
    "common.operationalDetails": "Operational Details",
    "common.location": "Location",
    "common.locationRequired": "Location is required.",
    "common.pickupLocationRequired": "Pickup Location is required.",
    "common.operatingProfile": "Operating Profile",
    "common.profile": "Profile",
    "common.paymentTerms": "Payment Terms",
    "common.incoterms": "Incoterms",
    "common.billNo": "Bill No",
    "common.billOfLadingNo": "Bill of Lading No",
    "common.billNumberRequired": "Bill number is required",
    "common.requiredForExport": "Required for export",
    "common.ewaybillLrFile": "E-Waybill / LR File",
    "common.billFile": "Bill File",
    "common.blFile": "BL File",
    "common.totalUsers": "Total Users",
    "common.configured": "Configured",
    "common.noAccess": "No Access",
    "common.avgCoverage": "Avg Coverage",
    "tallysheet.createTransportUnit": "Create Stock Unit",
    "tallysheet.saveStartTally": "Save & start tally",
    "su.editDetails": "Edit details",
    "su.directionMoveShort": "Move",
    "su.moreDetails": "More details",
    "su.lessDetails": "Fewer details",
    "su.loadingTab": "Loading…",
    "su.detailsTitle": "Stock Unit details",
    "su.allSaved": "All changes saved",
    "su.unsaved": "Unsaved changes",
    "su.saving": "Saving…",
    "su.moreActions": "More actions",
    "su.receiveSub": "Starts stock tracking.",
    "su.lockMenu": "Lock Stock Unit",
    "su.lockSub": "Stops further edits.",
    "su.deleteMenu": "Delete Stock Unit",
    "su.deleteSub": "Asks you to confirm first.",
    "su.appScreenOn": "Try app-style layout",
    "su.appScreenOff": "Back to the classic layout",
    "su.appScreenSub": "The grid fills the screen and its heading stays in view",
    "su.auditMenu": "Share link access audit",
    "su.auditSub": "Who opened this Stock Unit through a share link",
    "su.confirmOutSub": "Takes this stock out of inventory.",
    "su.notInInventory": "Not in inventory",
    "su.inInventory": "In inventory",
    "su.sections": "Stock Unit sections",
    "su.lockedTitle": "Save the Stock Unit to start the tally",
    "su.lockedSub": "Every row is stored against the Stock Unit, so it needs its ID first.",
    "su.lockedChip": "Locked",
    "su.lockedPlaceholder": "Photos, Summary, Reconciliation and Inventory open here too.",
    "su.newHint": "Fill in the details, then save. The tally opens as soon as the Stock Unit exists.",
    "su.newReady": "Stock Unit saved. The tally is ready.",
    "tallysheet.selectProduct": "Select Product",
    "tallysheet.selectMode": "Select Mode",
    "tallysheet.selectLoadingSite": "Select Location",
    "common.pageReport": "Showing {first} to {last} of {totalRecords} entries",
    "common.unsavedChangesHeader": "Unsaved Changes",
    "common.unsavedChangesMessage":
      "You have unsaved changes. Are you sure you want to leave without saving?",
    "common.leaveLabel": "Leave",
    "common.stayLabel": "Stay",
    "login.alreadyHaveAccount": "Already have an account?",
    "login.signInNow": "Sign in now!",
    "login.signUp": "Sign Up",
    "login.nameRequired": "Name is required.",
    "login.usernameRequired": "Username is required.",
    "login.validEmailRequired": "Please enter a valid email address.",
    "login.checkEmailTitle": "Check your e-mail",
    "login.checkEmailBody": "We sent a verification link to",
    "login.checkEmailResent": "A new link was sent.",
    "login.checkEmailSignIn": "Sign in",
    "login.emailExists": "Email already exists.",
    "login.passwordRequired": "Password is required.",
    "login.securityCheckLoading": "Loading security check…",
    "login.securityCheckUnavailable": "Security check unavailable — sign in is blocked until it loads.",
    "login.securityCheckRequired": "Please complete the security check before continuing.",
    "login.choosePassword": "Choose a password",
    "login.tooSimple": "Too simple",
    "login.averageComplexity": "Average complexity",
    "login.complexPassword": "Complex password",
    "login.dontHaveAccount": "Don't have an account?",
    "login.createToday": "Create today!",
    "login.welcomeBack": "Welcome back",
    "login.welcomeBackSub": "Sign in to your LumberLinq account.",
    "login.createYourAccount": "Create your account",
    "login.createYourAccountSub": "Start managing your timber business in minutes.",
    "login.signIn": "Sign In",
    "login.emailRequired": "Email is required.",
    "login.forgotPassword": "Forgot Password?",
    "login.loggedInAs": "You're already logged in as",
    "login.loggedInEmail": "Logged in as",
    "login.errorNotification": "Error Notification",
    "login.userNotRegistered":
      "No account exists for this email. Please sign up first.",
    "login.userAlreadyRegistered":
      "This account already exists. Please sign in instead.",
    "login.socialLoginFailed": "Social login failed. Please try again.",
    "login.referredBy": "You were referred by",
    "login.referredGeneric": "You were referred to LumberLinq.",
    "login.referredSignInInstead": "Sign in instead",
    "login.signInWithApple": "Sign in with Apple",
    "login.signUpWithApple": "Sign up with Apple",
    "login.appleNoAccount": "No LumberLinq account is linked to this Apple ID. Create a free account on the web, then sign in here.",
    "login.registrationDisabled": "Signups are temporarily paused — we've saved your spot and will email you the moment they reopen.",
    "login.userBlocked": "This user has been blocked and can no longer login.",
    "login.blockedSummary": "User blocked",
    "business.title": "Business Partners",
    "business.newPartner": "New Partner",
    "business.bulkImport": "Bulk Import",
    "business.moreActions": "More actions",
    "business.selectRows": "Select rows",
    "business.selectedCount": "selected",
    "business.sortNameAsc": "Name A–Z",
    "business.sortNameDesc": "Name Z–A",
    "business.sortType": "Type",
    "business.sortCountry": "Country",
    "common.done": "Done",
    "common.sort": "Sort",
    "common.activate": "Activate",
    "business.deleteSelected": "Delete Selected",
    "business.searchPlaceholder": "Search by Name, Email, Contact, Tax ID",
    "business.allStatus": "All Status",
    "business.edit": "Edit Business Partner",
    "business.create": "Create Business Partner",
    "business.identity": "Identity",
    "business.companyName": "Company Name",
    "business.companyDetails": "Company Details",
    "business.companyRegistration": "Company Registration",
    "business.industry": "Industry",
    "business.web": "Web",
    "business.companyBranding": "Company Branding",
    "business.logoUrl": "Logo URL",
    "business.logoPreview": "Company logo preview",
    "business.contactPerson": "Contact Person",
    "business.partyType": "Party Type",
    // Short forms for TABLE COLUMN HEADERS only. The full labels above stay in use on the
    // create/edit form, where the field needs naming in full. A column header is read in the
    // context of its own column, so the terse form is clearer AND fits one line on a phone —
    // the long ones were wrapping to two lines and pushing the sort icon onto a third.
    "business.contactPersonShort": "Contact",
    "business.partyTypeShort": "Type",
    "business.selectType": "Select Type",
    "business.referenceCode": "Reference Code",
    "business.registrationType": "Registration Type",
    "business.taxId": "Tax ID",
    "company.reportingCurrency": "Reporting Currency",
    "company.reportingCurrencyHint": "Dashboard and report totals are converted into this currency.",
    "shipments.fxRateToBase": "Exchange Rate to Reporting Currency",
    "shipments.convertedAmount": "Converted Amount",
    "dashV5.convertedTooltip": "Converted to the reporting currency using booked exchange rates on each consignment. Amounts without a booked rate are excluded.",
    "dashV5.approxConverted": "approx., converted",
    "dashV5.noRate": "no rate",
    "dashV5.noRateTooltip": "No booked exchange rate — excluded from the converted total. Set the Exchange Rate to Reporting Currency on the consignment.",
    "business.partyCategory": "Party Category",
    "business.selectCategory": "Select Category",
    "business.activePartner": "Active Partner",
    "business.contactLocation": "Contact & Location",
    "business.website": "Website",
    "business.address1": "Address Line 1",
    "business.address2": "Address Line 2",
    "business.zipCode": "Zip Code",
    "business.operations": "Operations",
    "business.linkedUserId": "Linked User ID",
    "business.externalCode": "External Code",
    "business.tags": "Tags",
    "business.selectTags": "Select Tags",
    "business.notes": "Notes",
    "business.attachFiles": "Attach Files",
    "business.bankAccounts": "Bank Accounts",
    "business.bankName": "Bank Name",
    "business.accountNo": "Account No",
    "business.confirmAccountNo": "Confirm Account No",
    "business.accountNoMismatch": "Account numbers don't match",
    "business.currency": "Currency",
    "business.addBankAccount": "Add Bank Account",
    "business.savePartner": "Save Partner",
    "business.updatePartner": "Update Partner",
    "business.noPartnersFound": "No partners found.",
    "business.regType": "Reg. Type",
    "route.login.header": "Welcome Back!",
    "route.buyers.manage": "View and manage existing buyer profiles",
    "layout.searchMenu": "Search menu...",
    "layout.noMenuItems": "No menu items found.",
    "layout.footerRights": "All Rights Reserved.",
    "layout.poweredBy": "Powered By Lumber Linq",
    "layout.loveApp": "Love our app?",
    "layout.useForBusiness": "Use it for your own business!",
    "user.add": "Add user",
    "user.create": "Create User",
    "user.inputDetails": "Input new user details to the system",
    "user.manage": "Manage User",
    "user.manageProfiles": "View and administer user profiles",
    "user.profile": "Edit Profile",
    "user.profileSubheader": "Modify your personal user details",
    "user.confirmDeletion": "Confirm User Deletion",
    "user.deleteConfirm": "Are you sure you want to delete this user?",
    "user.typeEmail": "Please confirm by typing the user's email below:",
    "user.emailPlaceholder": "User Email",
    "user.addEmailAddress": "Add Email Address",
    "user.invalidEmail": "Invalid Email Address",
    "user.enterEmail": "Enter Email Address",
    "user.invitationAccepted": "Invitation accepted",
    "user.resend": "Resend",
    "user.admin": "Admin",
    "user.cannotUndo": "This action cannot be undone.",
    "shipment.namePlural": "Consignments",
    "tallysheet.namePlural": "Tallysheets",
    "tallysheet.all": "All Tallysheet",
    "tallysheet.manageDetails": "View and manage existing tallysheet details",
    "containerPrivacy.title": "Container Privacy",
    "subscription.title": "Subscription",
    "subscription.selectUpdatePlan": "Select or update your subscription plan",
    "subscription.view": "View Subscription",
    "subscription.subheader": "Subheader Subscription",
    "utility.costEstimate": "Cost Estimate",
    "utility.volumeEstimation": "Volume Estimation",
    "utility.volumeCostEstimation": "Volume and Cost Estimation",
    "utility.unitConversion": "Unit Conversion",
    "utility.calculator": "Calculator",
    "utility.selectUnit": "Select Unit",
    "utility.generateSlab": "Generate Slab Prices",
    "utility.decimalPlace": "Decimal Place",
    "utility.decimalPlaces": "Decimal places",
    "utility.from": "From",
    "utility.to": "To",
    "utility.unit": "Unit",
    "utility.fromValue": "From Value",
    "utility.fromUnit": "From Unit",
    "utility.toValue": "To Value",
    "utility.toUnit": "To Unit",
    "utility.reverse": "Reverse",
    "utility.useCommonUnits": "Use common units for all rows",
    "utility.width": "Width",
    "utility.widthUnit": "Width Unit",
    "utility.thickness": "Thickness",
    "utility.thicknessUnit": "Thickness Unit",
    "utility.length": "Length",
    "utility.lengthUnit": "Length Unit",
    "utility.price": "Price",
    "utility.priceUnit": "Price Unit",
    "utility.quantity": "Quantity",
    "utility.total": "Total",
    "utility.rate": "Rate",
    "utility.slabOfRate": "Slab of Rate",
    "utility.slabPriceSize": "Slab Price Size",
    "utility.slabSize": "Slab Size",
    "utility.upperSlabs": "Upper Slabs",
    "utility.lowerSlabs": "Lower Slabs",
    "utility.slabPrice": "Slab Price",
    "utility.volumeOnly": "Volume only",
    "utility.volumeAndCost": "Volume + Cost",
    "utility.clearAll": "Clear all",
    "utility.clearAllConfirm": "Remove all items and start again?",
    "utility.addItem": "Add item",
    "utility.item": "Item",
    "utility.duplicateItem": "Duplicate item",
    "utility.removeItem": "Remove item",
    "utility.itemRemoved": "Item removed",
    "utility.totals": "Totals",
    "utility.pieces": "Pieces",
    "utility.cftNote": "CFT is worked out as CBM × 35.3147. Figures are rounded only when shown, and money to 2 decimals.",
    "utility.copySummary": "Copy summary",
    "utility.copyFailed": "Could not copy",
    "utility.swap": "Swap",
    "utility.saveConversion": "Save to history",
    "utility.allUnits": "Same value in every unit",
    "utility.history": "Saved conversions",
    "utility.historyEmpty": "Tap the bookmark to save a conversion and it will show up here.",
    "utility.clearHistory": "Clear history",
    "utility.clearHistoryConfirm": "Remove all saved conversions?",
    "utility.useThis": "Use this conversion",
    "utility.incompleteTitle": "Incomplete data",
    "utility.incompleteBody": "Enter a value and choose both units first.",
    "utility.duplicateTitle": "Already saved",
    "utility.duplicateBody": "This conversion is already in your saved list.",
    "utility.savedTitle": "Saved",
    "utility.baseSection": "Base price",
    "utility.baseRange": "Base slab range",
    "utility.stepSection": "Slab steps",
    "utility.rangeSection": "Slabs to show",
    "utility.priceLadder": "Price ladder",
    "utility.slabs": "slabs",
    "utility.copyAll": "Copy all",
    "utility.negativeRate": "Some prices are below zero. Reduce the price step or the number of lower slabs.",
    "utility.baseSlab": "Your slab",
    "utility.ladderEmpty": "Enter the rate, slab of rate, slab size and price step to see your price ladder.",
    "dashboardNew.title": "Dashboard",
    "menu.dashboard": "Dashboard",
    "menu.dashboardNew": "Dashboard New",
    "menu.shipments": "Consignments",
    "menu.tallysheets": "Tallysheets",
    "menu.newTallysheet": "New Tallysheet",
    "menu.products": "Products",
    "menu.loadingSites": "Locations",
    "menu.businessPartners": "Business Partners",
    "menu.containerPrivacy": "Container Privacy",
    "menu.company": "Company",
    "menu.companyProfile": "Company Profile",
    "menu.companyBranding": "Company Branding",
    "menu.subscription": "Subscription",
    "menu.utility": "Utility",
    "menu.directory": "Directory",
    "menu.tools": "Tools",
    "menu.section.overview": "Overview",
    "menu.section.operations": "Operations",
    "menu.section.data": "Data & Reports",
    "menu.section.platform": "Platform",
    "sidebar.recent": "Recent",
    "sidebar.copied": "Copied",
    "sidebar.new": "New",
    "sidebar.newConsignment": "Consignment",
    "sidebar.newStockUnit": "Stock Unit",
    "sidebar.newBusinessPartner": "Business Partner",
    "sidebar.newProduct": "Product",
    "sidebar.newLocation": "Location",
    "menu.costEstimate": "Cost Estimate",
    "menu.volumeEstimate": "Volume Estimate",
    "menu.volumeEstimates": "Volume Estimates",
    "menu.unitConversion": "Unit Conversion",
    "menu.slabGenerator": "Slab Generator",
    "menu.generateSlab": "Generate Slab",
    "menu.users": "Users",
    "menu.addUser": "Add User",
    "menu.manageUsers": "Manage Users",
    "menu.userProfile": "User Profile",
    "menu.editProfile": "Edit Profile",
    "menu.addBusinessPartner": "Add Business Partner",
    "menu.viewBusinessPartner": "View Business Partner",
    "menu.viewBusinessPartners": "View Business Partners",
    "menu.addProduct": "Add Product",
    "menu.viewProduct": "View Product",
    "menu.viewProducts": "View Products",
    "menu.addLoadingSite": "Add Location",
    "menu.viewLoadingSite": "View Location",
    "menu.viewLoadingSites": "View Locations",
    "menu.addTallysheet": "Add Tallysheet",
    "menu.viewTallysheet": "View Tallysheet",
    "menu.listTallysheet": "List Tallysheet",
    "menu.addShipment": "Add Consignment",
    "menu.viewShipment": "View Consignment",
    "menu.listShipments": "List Consignments",
    "menu.storage": "Storage",
    "menu.branding": "Branding",
    "menu.admin": "Admin",
    "menu.adminDashboard": "Admin Dashboard",
    "menu.subscriptionDashboard": "Subscription Dashboard",
    "menu.reports": "Reports",
    "menu.financialReport": "Financial Report",
    "menu.reconciliationReport": "Reconciliation Report",
    "menu.accessField": "Access Field",
    "menu.tallysheetAccessField": "Tallysheet Access Field",
    "menu.businessPartnerReport": "Business Partner Report",
    "menu.shipmentReport": "Consignment Report",
    "menu.productReport": "Product Report",
    "menu.loadingSiteReport": "Location Report",
    "menu.transportUnitReport": "Stock Unit Report",
    "menu.tallysheetReport": "Tallysheet Report",
    "menu.operators": "Operators",
    "menu.addTransportUnit": "Add Stock Unit",
    "menu.transportUnitFieldAccess": "Stock Unit Field Access",
    "menu.tallyReport": "Tally Report",
    "menu.analytics": "Analytics",
    "route.companyProfile": "Your Company Profile",
    "route.companyProfileDetails":
      "View or edit your company's profile details",
    "route.companyLogo": "Manage your company logo",
    "route.convertUnitsHeader": "Convert Units",
    "route.convertUnitsSubheader":
      "Enter your measurements and select units for conversion",
    "route.costEstimateHeader": "Estimate Your Costs",
    "route.costEstimateSubheader":
      "Input your parameters and calculate the projected cost",
    "route.containerPrivacyHeader": "Manage Container Privacy Configurations",
    "route.containerPrivacySubheader":
      "View and customize privacy levels for container fields",
    "dashboardNew.company": "Company",
    "dashboardNew.role": "Role",
    "dashboardNew.filterRange": "Filter Range",
    "dashboardNew.refresh": "Refresh",
    "dashboardNew.noData": "No data",
    "dashboardNew.originDestination": "Origin vs Destination CBM (30d)",
    "dashboardNew.topPartners": "Top Partners by Volume",
    "dashboardNew.fleetHealth": "Fleet Health",
    "dashboardNew.shipmentPipeline": "Consignment Pipeline",
    "dashboardNew.tallyAccuracy": "Tally Accuracy by Port",
    "dashboardNew.liveOperations": "Live Operations",
    "dashboardNew.alerts": "Alerts & Exceptions",
    "dashboardNew.recentActivity": "Recent Activity",
    "shipment.list": "Consignments",
    "shipment.singular": "Consignment",
    "shipment.new": "New Consignment",
    "shipment.searchPlaceholder":
      "Search anything (BL, Order, Export Ref, Shipper...)",
    "shipment.blNumber": "Document No.",
    "shipment.type": "Type",
    "shipment.date": "Date",
    "shipment.buyerOrder": "Buyer Order",
    "shipment.exportRef": "Export Ref",
    "shipment.shipper": "Shipper",
    "shipment.consignee": "Consignee",
    "shipment.noFound": "No consignments found.",
    "shipment.noFoundSub": "Create a new consignment to get started.",
    "shipment.noBl": "No BL#",
    "shipment.sharedLinks": "Shared Links",
    "shipment.newLink": "New Share Link",
    "shipment.access": "Access",
    "shipment.expiry": "Expiry",
    "shipment.active": "Active",
    "shipment.oneTime": "One Time",
    "shipment.used": "Used",
    "shipment.createEdit": "Consignment - Create / Edit",
    "shipment.create": "Create Consignment",
    "shipment.edit": "Edit Consignment",
    "shipment.saveConsignment": "Save Consignment",
    "shipment.updateConsignment": "Update Consignment",
    "shipment.coreDetailsShort": "Core Details",
    "shipment.financialsPaymentsHtml": "Financials &amp; Payments",
    "shipment.financials": "Financials",
    "shipment.localAuditSpaced": "Local / Audit",
    "shipment.consignmentInfo": "Consignment Info",
    "shipment.documents": "Documents",
    "shipment.financialPayments": "Financial & Payments",
    "shipment.localAudit": "Local/Audit",
    "shipment.breadcrumbs": "Breadcrumbs",
    "shipment.details": "Consignment Details",
    "shipmentForm.tabDeal": "Deal",
    "shipmentForm.tabRoute": "Route & Timing",
    "shipmentForm.tabMoney": "Money",
    "shipmentForm.dealTitle": "The deal",
    "shipmentForm.dealBasics": "Type, mode and date",
    "shipmentForm.dealBasicsHelp": "Pick the type first: it decides which fields appear in every tab.",
    "shipmentForm.references": "References",
    "shipmentForm.referencesHelp": "The numbers your team and your partners use to find this consignment.",
    "shipmentForm.referencesHelpLocal": "The bill and invoice numbers used to find this consignment.",
    "shipmentForm.parties": "Parties",
    "shipmentForm.partiesHelp": "At least one of Shipper, Consignee or Notify Party must be your own company. It is filled in for you when the type makes it obvious.",
    "shipmentForm.ownerMissing": "One of the parties must be your own company.",
    "shipmentForm.buyerDetails": "Buyer details",
    "shipmentForm.buyerDetailsHelpSale": "Needed before the goods leave: the buyer's tax number and who receives the goods.",
    "shipmentForm.buyerDetailsHelpPurchase": "Optional for a purchase. Your own tax number is filled in for you.",
    "shipmentForm.notes": "Notes",
    "shipmentForm.routeTitle": "Route and timing",
    "shipmentForm.timing": "Dates, destination and terms",
    "shipmentForm.timingHelp": "When it leaves and arrives, and the agreed shipping terms. The same day is fine.",
    "shipmentForm.transit": "Transit time",
    "shipmentForm.sameDay": "Same day",
    "shipmentForm.days": "days",
    "shipmentForm.docsTitle": "Documents",
    "shipmentForm.docChecklist": "Documents on file",
    "shipmentForm.docChecklistNote": "A number or an uploaded file counts. This list only reminds you; it never blocks saving. Add a fumigation certificate under Other documents with the label Fumigation.",
    "shipmentForm.docNumbers": "Document numbers",
    "shipmentForm.docNumbersHelp": "Certificate and permit numbers for this consignment.",
    "shipmentForm.coNo": "Certificate of Origin No",
    "shipmentForm.fumigationNo": "Fumigation Certificate No",
    "shipmentForm.insuranceDetails": "Insurance details",
    "shipmentForm.ewayNo": "E-way Bill No",
    "shipmentForm.quickLabels": "Quick labels",
    "shipmentForm.doc.bl": "Bill of Lading",
    "shipmentForm.doc.bill": "Bill",
    "shipmentForm.doc.invoice": "Commercial invoice",
    "shipmentForm.doc.packing": "Packing list",
    "shipmentForm.doc.co": "Certificate of Origin",
    "shipmentForm.doc.phyto": "Phytosanitary certificate",
    "shipmentForm.doc.fumigation": "Fumigation certificate",
    "shipmentForm.doc.eway": "E-way bill / LR",
    "shipmentForm.sumLabel": "Consignment summary",
    "shipmentForm.noBlYet": "Not entered yet",
    "shipmentForm.unsaved": "Unsaved changes",
    "shipmentForm.status": "Status",
    "shipmentForm.changeStatus": "Change status",
    "shipmentForm.sumToggle": "Show or hide the summary",
    "shipmentForm.stepperLabel": "Progress of this consignment",
    "shipmentForm.invoice": "Invoice",
    "shipmentForm.outstanding": "Outstanding",
    "shipmentForm.readyLabel": "ready",
    "shipmentForm.type.EXPORT": "Export",
    "shipmentForm.type.IMPORT": "Import",
    "shipmentForm.type.DOMESTIC_SALE": "Domestic Sale",
    "shipmentForm.type.DOMESTIC_PURCHASE": "Domestic Purchase",
    "shipmentForm.type.TRADING": "Trading",
    "shipmentForm.mode.SEA": "Sea",
    "shipmentForm.mode.AIR": "Air",
    "shipmentForm.mode.ROAD": "Road",
    "shipmentForm.mode.RAIL": "Rail",
    "shipmentForm.ready.type": "Type and mode chosen",
    "shipmentForm.ready.parties": "Seller and buyer chosen",
    "shipmentForm.ready.bl": "Bill of Lading number",
    "shipmentForm.ready.bill": "Bill number",
    "shipmentForm.ready.dates": "Departure and arrival dates",
    "shipmentForm.ready.ports": "Ports of loading and discharge",
    "shipmentForm.ready.vehicle": "Route and vehicle details",
    "shipmentForm.ready.rail": "Origin and destination stations",
    "shipmentForm.ready.units": "At least one Stock Unit added",
    "shipmentForm.ready.docs": "All expected documents on file",
    "shipmentForm.ready.invoice": "Invoice amount entered",
    "shipmentForm.ready.terms": "Payment terms chosen",
    "shipmentForm.depRequired": "Estimated Departure is required",
    "shipmentForm.arrRequired": "Estimated Arrival is required",
    "shipmentForm.billRequired": "Bill number is required",
    "shipmentForm.blRequired": "Bill of Lading number is required for a sea consignment",
    "shipmentForm.requiredHere": "Required",
    "shipmentForm.paymentTermsNeeded": "Payment terms are needed once an invoice amount is entered",
    "shipmentForm.paymentTermsHint": "Needed once you enter an invoice amount: it gives the due date and the overdue reminders.",
    "shipmentForm.savePaymentsFirst": "Save the consignment first to record payments.",
    "shipmentForm.pricePerCbm": "Invoice per CBM",
    "shipmentForm.paidSoFar": "Paid so far",
    "shipmentForm.receivedSoFar": "Received so far",
    "shipmentForm.stockHelpBtn": "Which Stock Units appear here?",
    "shipmentForm.stockHint": "Type part of a Stock Unit ID, container / truck number or product. Press ? to see which Stock Units are listed.",
    "shipmentForm.stockHintNew": "Type part of a Stock Unit ID, container / truck number or product. Units you add are linked when you save. Press ? to see which are listed.",
    "shipmentForm.stockHelp.title": "Which Stock Units are listed?",
    "shipmentForm.stockHelp.lead": "The list shows Stock Units of your company that fit this consignment.",
    "shipmentForm.stockHelp.shown": "Listed",
    "shipmentForm.stockHelp.hidden": "Not listed",
    "shipmentForm.stockHelp.s1": "Not yet in any consignment",
    "shipmentForm.stockHelp.s2": "The right direction: Stock Out on a sale, Stock In on a purchase",
    "shipmentForm.stockHelp.s3": "Received or confirmed does not matter",
    "shipmentForm.stockHelp.h1": "Already in another consignment",
    "shipmentForm.stockHelp.h2": "The opposite direction (a Stock Out never shows on a purchase)",
    "shipmentForm.stockHelp.h3": "Move Between Sites units and mill-output records",
    "shipmentForm.stockHelp.h4": "Nothing typed yet, or no match for the ID, Transport ID, container / truck number or product",
    "shipmentForm.stockHelp.tip": "Cannot find it? Check its Direction on the Stock Unit screen.",
    "shipmentForm.stockHelp.locked": "Adding is switched off when the consignment is Closed, Cancelled, or a sale that has already left.",
    "shipmentForm.statusDialogTitle": "Change status",
    "shipmentForm.statusForwardNote": "Stock has been received for this consignment, so the status can only move forward.",
    "shipmentForm.receiveMark": "Offers Receive into Inventory",
    "shipmentForm.current": "Current",
    "shipmentForm.setStatus": "Set status",
    "shipmentForm.statusPressUpdate": "Press Update to save the new status.",
    "shipmentForm.statusPressSave": "Press Save to keep the new status.",
    "shipmentForm.statusForwardTitle": "Status can only move forward",
    "shipmentForm.statusForwardSub": "Stock has already been received for this consignment. The status can still move forward, but not back and not to Cancelled.",
    "shipmentForm.activity": "Activity",
    "shipmentForm.activityTip": "Who made this consignment, when it changed and its status history",
    "loginBar.signedIn": "You are already signed in.",
    "loginBar.continue": "Continue to LumberLinq",
    "loginBar.switch": "Sign in as someone else",
    "shipmentForm.priceCheckHigh": "This price per CBM is much higher than your earlier consignments (about {typical}). Please check the amount.",
    "shipmentForm.priceCheckLow": "This price per CBM is much lower than your earlier consignments (about {typical}). Please check the amount.",
    "shipment.status.SHIPPED": "Shipped",
    "shipmentForm.raw.backToConsignments": "Back to Consignments",
    "shipmentForm.raw.goodsHaveArrivedReadyToReceiveInto": "Goods have arrived — ready to receive into inventory?",
    "shipmentForm.raw.filledIn": "Filled in",
    "shipmentForm.raw.thisTabHasValidationErrors": "This tab has validation errors",
    "shipmentForm.raw.consignmentDateIsRequired": "Consignment Date is required",
    "shipmentForm.raw.blType": "BL Type",
    "shipmentForm.raw.searchShipper": "Search Shipper",
    "shipmentForm.raw.searchConsignee": "Search Consignee",
    "shipmentForm.raw.searchNotifyParty": "Search Notify Party",
    "shipmentForm.raw.arrivalCannotBeBeforeDeparture": "Arrival cannot be before departure",
    "shipmentForm.raw.countryOfDestination": "Country of Destination",
    "shipmentForm.raw.portCarrierDetails": "Port & Carrier Details",
    "shipmentForm.raw.portOfLoadingIsRequired": "Port of Loading is required",
    "shipmentForm.raw.portOfDischargeIsRequired": "Port of Discharge is required",
    "shipmentForm.raw.otherNotListed": "Other (Not Listed)",
    "shipmentForm.raw.enterShippingLineName": "Enter shipping line name",
    "shipmentForm.raw.customShippingLine": "Custom Shipping Line",
    "shipmentForm.raw.vesselName": "Vessel Name",
    "shipmentForm.raw.voyageNumber": "Voyage Number",
    "shipmentForm.raw.flightNumber": "Flight Number",
    "shipmentForm.raw.roadTransportDetails": "Road Transport Details",
    "shipmentForm.raw.vehicleLrNo": "Vehicle / LR No",
    "shipmentForm.raw.railMovementDetails": "Rail Movement Details",
    "shipmentForm.raw.originStationIcd": "Origin Station / ICD",
    "shipmentForm.raw.destinationStationIcd": "Destination Station / ICD",
    "shipmentForm.raw.railOperator": "Rail Operator",
    "shipmentForm.raw.searchByStockUnitIdTransportId": "Search by Stock Unit ID, Transport ID, container / truck no., or product…",
    "shipmentForm.raw.openInStockUnitEditorNewTab": "Open in Stock Unit editor (new tab)",
    "shipmentForm.raw.noTransportUnitsAddedYetStartBy": "No transport units added yet. Start by searching above.",
    "shipmentForm.raw.whoCanSeeThisDocumentInShares": "Who can see this document in shares and exports",
    "shipmentForm.raw.dropOrClickToUpload": "Drop or click to upload",
    "shipmentForm.raw.noDocumentsAttached": "No documents attached",
    "shipmentForm.raw.max5FilesReached": "Max 5 files reached",
    "shipmentForm.raw.label": "Label",
    "shipmentForm.raw.fileLabelMax16Chars": "File label (max 16 chars)",
    "shipmentForm.raw.attach": "Attach",
    "shipmentForm.raw.fileSSelected": "file(s) selected",
    "shipmentForm.raw.dropOrClickToAddMultipleFiles": "Drop or click to add multiple files",
    "shipmentForm.raw.selectCurrency": "Select Currency",
    "shipmentForm.raw.days": "Days",
    "shipmentForm.raw.describePaymentTerms": "Describe payment terms…",
    "shipmentForm.raw.customTerms": "Custom Terms",
    "shipmentForm.raw.dueDate": "Due Date",
    "shipmentForm.raw.outstandingReceivable": "Outstanding Receivable",
    "shipmentForm.raw.outstandingPayable": "Outstanding Payable",
    "shipmentForm.raw.paymentDetails": "Payment Details",
    "shipmentForm.raw.paymentDate": "Payment Date *",
    "shipmentForm.raw.utrLCNoRef": "UTR / L/C No / Ref",
    "shipmentForm.raw.amountCurrency": "Amount & Currency",
    "shipmentForm.raw.amount": "Amount *",
    "shipmentForm.raw.optionalContextForThisPayment": "Optional context for this payment…",
    "shipmentForm.raw.noPaymentsRecordedYet": "No payments recorded yet.",
    "shipmentForm.raw.editPayment": "Edit payment",
    "shipmentForm.raw.deletePayment": "Delete payment",
    "shipmentForm.raw.totalReceived": "Total Received:",
    "shipmentForm.raw.totalPaid": "Total Paid:",
    "shipmentForm.raw.previousTabAltLeft": "Previous tab (Alt + Left)",
    "shipmentForm.raw.nextTabAltRight": "Next tab (Alt + Right)",
    "shipmentForm.lastUpdated": "Last updated",
    "shipmentForm.statusHistory": "Status history",
    "shipmentForm.noHistory": "No status history to show.",
    "shipment.status.DRAFT": "Draft",
    "shipment.status.CONFIRMED": "Confirmed",
    "shipment.status.PLANNED": "Planned",
    "shipment.status.STUFFING": "Stuffing",
    "shipment.status.STUFFED": "Stuffed",
    "shipment.status.GATE_OUT": "Gate Out",
    "shipment.status.IN_TRANSIT": "In Transit",
    "shipment.status.ARRIVED": "Arrived",
    "shipment.status.UNSTUFFING": "Unstuffing",
    "shipment.status.DELIVERED": "Delivered",
    "shipment.status.CLOSED": "Closed",
    "shipment.status.CANCELLED": "Cancelled",
    "shipment.statusGroup.planning": "Planning",
    "shipment.statusGroup.loading": "Loading",
    "shipment.statusGroup.way": "On the way",
    "shipment.statusGroup.arrival": "Arrival",
    "shipment.statusGroup.finished": "Finished",
    "shipment.statusMeaning.DRAFT": "Being prepared",
    "shipment.statusMeaning.CONFIRMED": "Deal agreed",
    "shipment.statusMeaning.PLANNED": "Shipment arranged",
    "shipment.statusMeaning.STUFFING.sale": "You are loading the goods",
    "shipment.statusMeaning.STUFFING.buy": "The supplier is loading the goods",
    "shipment.statusMeaning.STUFFED.sale": "Loaded and sealed",
    "shipment.statusMeaning.STUFFED.buy": "Loaded at the supplier",
    "shipment.statusMeaning.GATE_OUT.sale": "Left the yard or port gate",
    "shipment.statusMeaning.GATE_OUT.buy": "The supplier has loaded and shipped it",
    "shipment.statusMeaning.IN_TRANSIT.sale": "On the way to the buyer",
    "shipment.statusMeaning.IN_TRANSIT.buy": "On the way to you",
    "shipment.statusMeaning.ARRIVED.sale": "Reached the destination",
    "shipment.statusMeaning.ARRIVED.buy": "Reached your port or yard",
    "shipment.statusMeaning.UNSTUFFING.sale": "Container is being unloaded",
    "shipment.statusMeaning.UNSTUFFING.buy": "Container is being unloaded",
    "shipment.statusMeaning.DELIVERED.sale": "The buyer has the goods",
    "shipment.statusMeaning.DELIVERED.buy": "The goods are with you",
    "shipment.statusMeaning.CLOSED": "Finished and settled",
    "shipment.statusMeaning.CANCELLED": "Called off",
    "shipment.statusEffect.DRAFT": "Nothing changes in stock. Use it while details are still missing.",
    "shipment.statusEffect.CONFIRMED": "Nothing changes in stock.",
    "shipment.statusEffect.PLANNED": "Nothing changes in stock.",
    "shipment.statusEffect.STUFFING.sale": "Nothing changes in stock. The Stock Units show under In Consignment.",
    "shipment.statusEffect.STUFFING.buy": "Nothing changes in stock. The Stock Units show under In Consignment.",
    "shipment.statusEffect.STUFFED.sale": "Nothing changes in stock. The Stock Units show under In Transit.",
    "shipment.statusEffect.STUFFED.buy": "Nothing changes in stock. The Stock Units show under In Transit.",
    "shipment.statusEffect.GATE_OUT.sale": "Nothing changes in stock. The Stock Units show under In Transit.",
    "shipment.statusEffect.GATE_OUT.buy": "Nothing changes in stock. The Stock Units show under In Transit.",
    "shipment.statusEffect.IN_TRANSIT.sale": "Nothing changes in stock (stock goes down only when you Confirm Stock-Out). From here on no new Stock Unit can be added to this sale.",
    "shipment.statusEffect.IN_TRANSIT.buy": "Nothing changes in stock (stock goes up only when you receive it into inventory). The Stock Units show under In Transit.",
    "shipment.statusEffect.ARRIVED.sale": "Nothing changes in stock. New Stock Units can no longer be added to this sale.",
    "shipment.statusEffect.ARRIVED.buy": "Stock does not go up yet. You will be asked to receive the Stock Units into inventory (Receive into Inventory).",
    "shipment.statusEffect.UNSTUFFING.sale": "Nothing changes in stock.",
    "shipment.statusEffect.UNSTUFFING.buy": "Stock does not go up yet. You will be asked to receive the Stock Units into inventory (Receive into Inventory).",
    "shipment.statusEffect.DELIVERED.sale": "Stock goes down only when you Confirm Stock-Out on each Stock Unit, not from this status. New Stock Units can no longer be added.",
    "shipment.statusEffect.DELIVERED.buy": "Receive any Stock Unit not yet received. Stock goes up only when you receive it into inventory, not from this status.",
    "shipment.statusEffect.CLOSED": "No more Stock Units can be added. Stock quantities do not change.",
    "shipment.statusEffect.CANCELLED": "Stock quantities do not change and no more Stock Units can be added. If stock was already received or confirmed, correct it with Add Adjustment.",
    "shipment.paymentSummaryTitle": "Payment Summary",
    "shipment.invoiceAmount": "Invoice Amount",
    "shipment.received": "Received",
    "shipment.paid": "Paid",
    "shipment.salesPaymentStatus": "Sales Payment Status",
    "shipment.purchasePaymentStatus": "Purchase Payment Status",
    "shipment.coreDetails": "Core Consignment Details",
    "shipment.saveChanges": "Save Changes",
    "shipment.listSubtitle": "Track, filter, and manage consignment operations",
    "shipment.filterBl": "Filter BL",
    "shipment.filterBuyerOrder": "Filter Buyer Order",
    "shipment.filterExportRef": "Filter Export Ref",
    "shipment.filterShipper": "Filter Shipper",
    "shipment.filterConsignee": "Filter Consignee",
    "shipment.filterStatus": "Filter Status",
    "shipment.viewDetails": "View consignment details",
    "shipment.payments": "Payments",
    "common.confirm": "Confirm",
    "shipment.changeStatus": "Change Status",
    "shipment.receiveIntoInventory": "Receive into Inventory",
    "share.actions": "Share actions",
    "share.duration": "Duration",
    "share.accessLimit": "Access limit",
    "share.customAccessCount": "Custom access count",
    "share.allowDownload": "Allow export & file downloads",
    "share.protectedAudience": "Protected audience",
    "share.companyIdNotFound": "company ID does not exist",
    "share.emailNotFound": "not a registered LumberLinq user",
    "share.createLink": "Create Link",
    "share.createTallysheetLink": "Create tallysheet link",
    "share.tallysheetSharedLinks": "Tallysheet Shared Links",
    "share.audience": "Audience",
    "share.createdBy": "Created by",
    "share.limit": "Limit",
    "share.download": "Download",
    "share.noLinksFound": "No shared links found.",
    "share.public": "Anyone with the link",
    "share.protected": "LumberLinq users only",
    "share.private": "My team only",
    "share.publicTooltip": "Accessible to anyone with this link — no login required",
    "share.protectedTooltip": "Only LumberLinq users can view — login required",
    "share.privateTooltip": "Only your team members can view this",
    "share.accessMode": "Access mode",
    "share.linkSettings": "Link settings",
    "share.allowDownloadHint": "When off, viewers cannot export the tally or download consignment files.",
    "share.linkPreview": "Show details in link preview",
    "share.linkPreviewHintPublic": "When on, WhatsApp, Telegram and other chat apps show pieces, volume and products (only fields your access settings allow).",
    "share.linkPreviewHintLocked": "When on, chat apps show a locked card with the Stock Unit count. No other details are shown.",
    "share.preview": "Preview",
    "share.linkInventory": "Shared Links",
    "share.specificCompanyIds": "Specific Company IDs",
    "share.specificEmails": "Specific Email Addresses",
    "share.anyLumberlinqUser": "Any Lumberlinq User",
    "share.manageAudience": "Manage Audience",
    "share.audienceEmails": "Email Addresses",
    "share.audienceCompanies": "Company IDs",
    "share.addEntry": "Add",
    "share.audienceMinOne": "At least one entry is required",
    "share.audienceDeleteGate": "Add a new entry first to enable removal",
    "share.audienceNoEntries": "No entries yet",
    "share.audienceEmailPlaceholder": "Enter email address",
    "share.audienceCompanyPlaceholder": "Enter company ID",
    "share.never": "Never",
    "share.noRestriction": "No restriction",
    "share.missingTransportUnit": "Missing stock unit",
    "share.saveOrLoadTransportUnit": "Save or load a stock unit before creating a share link.",
    "share.tallysheetLinkCreated": "Tallysheet link created",
    "share.linkCopiedToClipboard": "Share link copied to clipboard.",
    "share.linkFailed": "Link failed",
    "shareAudit.title": "Share Link Access Audit",
    "shareAudit.accesses": "accesses",
    "shareAudit.noAccesses": "No share link accesses recorded yet.",
    "shareAudit.emptyHint": "Every time someone opens a share link, it will appear here.",
    "shareAudit.allowed": "Allowed",
    "shareAudit.denied": "Denied",
    "shareAudit.uniqueVisitors": "Unique Visitors",
    "shareAudit.bots": "Bots",
    "shareAudit.emailUser": "Email / User",
    "shareAudit.accessedAt": "Accessed At",
    "shareAudit.ipAddress": "IP Address",
    "shareAudit.location": "Location",
    "shareAudit.browser": "Browser",
    "shareAudit.os": "OS",
    "shareAudit.shareLink": "Share Link",
    "shareAudit.anonymous": "Anonymous",
    "shareAudit.noEntries": "No audit entries found.",
    "share.unableToCreateTallysheetLink": "Unable to create tallysheet share link.",
    "share.oneDay": "1 day",
    "share.sevenDays": "7 days",
    "share.thirtyDays": "30 days",
    "share.ninetyDays": "90 days",
    "share.neverExpires": "Never expires",
    "tallysheet.rowLimit.title": "Tally sheet is full",
    "tallysheet.rowLimit.message": "A tally sheet can hold at most {max} rows. Start a new tally sheet for the rest.",
    "tallysheet.rowLimit.importMessage": "These rows would take the tally sheet past {max} rows, so nothing was imported. Import fewer rows or use a new tally sheet.",
    "share.publicExpiryHint": "Public links always expire, so an old link cannot be opened by someone who finds it later.",
    "share.disableAll": "Disable all",
    "share.disableAllConfirm": "Switch off all links of this record? Nobody will be able to open them any more.",
    "share.disableAllDone": "Links switched off",
    "share.oneTime": "One time",
    "share.threeAccesses": "3 accesses",
    "share.fiveAccesses": "5 accesses",
    "share.tenAccesses": "10 accesses",
    "share.custom": "Custom",
    "share.viewSharedLinks": "View shared links",
    "share.copyDirectLink": "Copy direct link",
    "share.openDirectLink": "Open direct link",
    "share.copyLink": "Copy Link",
    "share.openLink": "Open Link",
    "share.anyoneWithLink": "Anyone with link can access",
    "share.requiresVerification": "Requires verification",
    "share.restrictedUsersOnly": "Restricted users only",
    "share.addEmailAddress": "Add Lumberlinq email address",
    "share.addCompanyId": "Add company ID",
    "share.missingDetails": "Missing details",
    "share.completeRestrictions": "Please complete the selected sharing restrictions.",
    "share.generatingLink": "Generating link...",
    "share.pleaseWait": "Please wait",
    "share.linkCreated": "Link created",
    "share.tallysheetLinkGenerated": "Tallysheet share link generated.",
    "share.linkGeneratedSuccessfully": "Share link generated successfully",
    "share.failed": "Failed",
    "share.unableToCreateShareLink": "Unable to create share link",
    "share.unableToLoadSharedLinks": "Unable to load shared links.",
    "share.docAccess": "Document Access",
    "share.docAccessHint": "Control what viewers can do with each document type",
    "share.doc_bl": "BL File",
    "share.doc_ewaybill": "E-Waybill / LR",
    "share.doc_co": "Cert. of Origin",
    "share.doc_phyto": "Phytosanitary",
    "share.doc_invoice": "Commercial Invoice",
    "share.doc_other": "Other Documents",
    "share.docFull": "Full Access",
    "share.docViewOnly": "View Only",
    "share.docFilenameOnly": "Filename Only",
    "share.docHidden": "Hidden",
    "share.copied": "Copied",
    "share.linkCopied": "Link copied",
    "share.transportIdCopied": "Transport ID copied!",
    "share.confirmRevoke": "Are you sure you want to revoke this link?",
    "share.confirmActivate": "Are you sure you want to activate this link?",
    "share.generateShareLink": "Generate Share Link",
    "share.generateShareQuestion": "Do you want to generate",
    "share.shareLinkSuffix": "share link?",
    "share.unableToUpdateLinkStatus": "Unable to update link status.",
    "subscription.transactions": "Transactions",
    "subscription.purchase": "Purchase",
    "subscription.customerCode": "Customer Code",
    "subscription.currentName": "Current Subscription Name",
    "subscription.refresh": "Refresh",
    "subscription.validTill": "Current Subscription Valid Till",
    "subscription.lastPayment": "Last Payment Made On",
    "subscription.paymentDue": "Payment Due On",
    "subscription.paidTill": "Paid Till",
    "subscription.status": "Subscription Status",
    "subscription.downgradedTitle": "You're on the Free Plan",
    "subscription.downgradedBody": "Your paid subscription lapsed and this account was automatically moved to the free plan. You still have full access to everything you've already created — you just can't add new items beyond the free plan's limits. Renew anytime to unlock full access again.",
    "subscription.utcNote":
      "Please note that our system operates based on Coordinated Universal Time (UTC). Therefore, the time of your subscription's activation and expiration will be calculated based on this time zone. If you are in a different time zone, there may be a perceived difference in the timing of your subscription's start and end dates",
    "subscription.autoPay": "Auto-Pay (EMandate)",
    "subscription.cancelAutoPay": "Cancel Auto-Pay",
    "utility.title": "Utility",
    "utility.slabCalculator": "Slab Calculator",
    "utility.slabSubheader":
      "Input slab dimensions to generate price estimations per size difference",
    "tallysheet.settings": "Settings",
    "tallysheet.validationRules": "Validation Rules",
    "tallysheet.configurationSettings": "Configuration Settings",
    "tallysheet.transportDetails": "Transport Details",
    "tallysheet.tu.direction": "Direction",
    "tallysheet.tu.directionChangeHeader": "Change Direction?",
    "tallysheet.tu.directionChangeMessage": "Changing Direction may reset some Inventory-related fields — continue?",
    "tallysheet.tu.directionStockIn": "Stock In",
    "tallysheet.tu.directionStockOut": "Stock Out",
    "tallysheet.tu.directionMove": "Move Between Sites",
    "tallysheet.tu.gridStyle": "Tally Layout",
    "tallysheet.tu.gridStyleClassicHint": "One product per line, chosen now.",
    "tallysheet.tu.gridStyleFlexibleHint": "Pick products per row once you start tallying — no need to choose one now.",
    "tallysheet.tu.directionChangeHint": "Saved — the direction can't be changed after saving.",
    "tallysheet.tu.gridStyleChangeHint": "Saved — the layout can't be changed after saving.",
    "tallysheet.tu.destinationSite": "Destination Site",
    "tallysheet.tu.destinationSiteRequired": "Destination Site is required.",
    "tallysheet.tu.origin": "Origin",
    "tallysheet.tu.originOptional": "Origin (optional)",
    "tallysheet.tu.quality": "Quality",
    "tallysheet.tu.qualityOptional": "Quality (optional)",
    "tallysheet.tu.qualityMixed": "Mixed / Any",
    "tallysheet.tu.cbmInStock": "CBM in stock",
    "tallysheet.tu.inStockSuffix": "free",
    "tallysheet.tu.clickForCft": "Click to show in CFT",
    "tallysheet.tu.clickForCbm": "Click to show in CBM",
    "tallysheet.tu.afterThisSave": "Remaining after save",
    "tallysheet.tu.heldByThisSheet": "Held by this sheet",
    "tallysheet.tu.stockFree": "Free",
    "tallysheet.tu.stockHeld": "Held",
    "tallysheet.tu.stockInStock": "In stock",
    "tallysheet.tu.stockRowSizeTip": "The row you clicked: free for this sheet, held by other Stock Outs, and the total in stock (this length or longer)",
    "tallysheet.tu.stockAvailability": "Stock Availability",
    "tallysheet.tu.noStock": "No stock",
    "tallysheet.tu.stockCantVerifyOffline": "Can't verify — offline",
    "tallysheet.tu.noStockAtSite": "No stock at",
    "tallysheet.tu.availableAtSite": "available at",
    "tallysheet.tu.stockBreakdownTitle": "Stock Breakdown",
    "tallysheet.tu.stockOrigin": "Origin",
    "tallysheet.tu.stockQuality": "Quality",
    "tallysheet.tu.stockPieces": "Pieces",
    "tallysheet.tu.stockSeal": "Seal",
    "tallysheet.tu.stockSupplier": "Supplier",
    "tallysheet.tu.stockNoContributors": "No contributing Stock Units found.",
    "tallysheet.tu.confirmDeleteHeader": "Confirm Delete",
    "tallysheet.tu.confirmDeleteMessage": "Are you sure you want to delete Stock Unit ({transportId})?",
    "tallysheet.tu.deleteConfirmAccept": "Yes, Delete",
    "tallysheet.tu.deletedSuccess": "Stock Unit deleted successfully",
    "tallysheet.tu.deleteNotAllowedHeader": "Delete Not Allowed",
    "tallysheet.tu.deleteNotAllowedFallback": "This Stock Unit cannot be deleted right now.",
    "tallysheet.tu.deleteFailedHeader": "Delete Failed",
    "tallysheet.tu.deleteFailedMessage": "Unable to delete Stock Unit. Please try again later.",
    "tallysheet.fulfill.title": "Fulfillment Plan",
    "tallysheet.fulfill.size": "Size",
    "tallysheet.fulfill.grade": "Grade",
    "tallysheet.fulfill.inStock": "In Stock",
    "tallysheet.fulfill.allocate": "Use",
    "tallysheet.fulfill.waste": "Waste",
    "tallysheet.fulfill.why": "Why",
    "tallysheet.fulfill.required": "Required",
    "tallysheet.fulfill.covered": "Covered",
    "tallysheet.fulfill.short": "Short",
    "tallysheet.fulfill.moreOptions": "More options",
    "tallysheet.fulfill.noStock": "No practical stock match for this size, origin and quality.",
    "tallysheet.fulfill.tierExact": "Exact match",
    "tallysheet.fulfill.tierTrim": "Longer — trim",
    "tallysheet.fulfill.tierResaw": "Re-saw from larger",
    "tallysheet.fulfill.tierGrade": "Different grade",
    "tallysheet.fulfill.tierOrigin": "Different origin",
    "tallysheet.fulfill.tierShort": "Shorter — confirm",
    "tallysheet.fulfill.tierMixed": "Mixed lengths — verify",
    "tallysheet.quick.button": "Quick Tally",
    "tallysheet.quick.tooltip": "Type shorthand like 4x3x7 250 Ghana A — the system builds the rows",
    "tallysheet.quick.title": "Quick Tally",
    "tallysheet.quick.hint": "One entry per comma or line: size, pieces, then optional origin and quality. Example: 4x3x7 250 Ghana A",
    "tallysheet.quick.notes": "Notes",
    "tallysheet.quick.apply": "Add rows",
    "tallysheet.quick.noDimensions": "No size found (e.g. 4x3x7)",
    "tallysheet.quick.noPieces": "Pieces count missing",
    "tallysheet.quick.lengthMissing": "Length missing — fill in the grid",
    "tallysheet.flex.button": "Flexible Layout",
    "tallysheet.flex.classicOption": "Standard Layout",
    "tallysheet.flex.searchProducts": "Search products...",
    "tallysheet.flex.noProductsFound": "No products found",
    "tallysheet.flex.pickProductFirst": "Pick a product first to see its stock",
    "tallysheet.flex.switchTooltip": "Standard: one product per line. Flexible: product/origin/quality per row, plus pick-from-stock sizing",
    "tallysheet.flex.cascadeTitle": "Row Product",
    "tallysheet.flex.stockTitle": "Pick from stock",
    "tallysheet.flex.noProductYet": "No product picked yet",
    "tallysheet.flex.sameAsLine": "Same as line",
    "tallysheet.flex.typedSoFar": "Typed so far",
    "tallysheet.flex.showAll": "Show all",
    "tallysheet.flex.requestCustomMade": "Not available — request it custom-made",
    "tallysheet.flex.cancelRequest": "Cancel request",
    "tallysheet.flex.cancelRequestHeader": "Cancel the mill request?",
    "tallysheet.flex.cancelRequestMessage": "The mill will no longer cut this size for this row. You can ask again later.",
    "tallysheet.flex.cancelRequestYes": "Yes, cancel request",
    "tallysheet.flex.cancelRequestDone": "Mill request cancelled",
    "tallysheet.flex.noneMatchExactly": "None of these match exactly:",
    "tallysheet.flex.stockStaleNotice": "Showing stock as of your last sync — may be outdated.",
    "tallysheet.flex.availablePcs": "pcs available for this size",
    "tallysheet.flex.availableCbm": "CBM available",
    "tallysheet.flex.availableStockTooltip": "Available stock excludes what's already reserved by other saved Stock-Out rows and active mill tasks — not confirmed out yet, but already spoken for. Change this under Company → Inventory settings.",
    "tallysheet.flex.customMadeLockedTitle": "Row locked — mill task in progress",
    "tallysheet.flex.customMadeLockedDetail": "This row's material is already being cut by a mill task and can't be edited or deleted until that job completes. It unlocks automatically once finished — no action needed.",
    "tallysheet.flex.importUnavailable": "Import isn't available in Flexible View — switch to Standard Layout to import.",
    "tallysheet.flex.customMadeLockedTooltipProducing": "Locked — a mill task is actively cutting this size right now. It unlocks automatically once that job finishes.",
    "tallysheet.flex.customMadeLockedTooltipWaiting": "Locked — a mill task has been created for this size and is queued to start. It unlocks automatically once that job finishes.",
    "tallysheet.flex.customMadeLockedTooltipPaused": "Locked — the mill task for this size has started and is paused right now. It unlocks automatically once that job finishes or is cancelled.",
    "tally.aiReview.needsOne": "row needs a look — the AI wasn't sure or couldn't read a value",
    "tally.aiReview.needsMany": "rows need a look — the AI wasn't sure or couldn't read a value",
    "tally.aiReview.showOnly": "Show only these",
    "tally.aiReview.showAll": "Show all rows",
    "tally.aiReview.showOnlyTip": "Show only these rows",
    "tally.aiReview.prev": "Previous row to check",
    "tally.aiReview.next": "Next row to check",
    "tally.aiReview.row": "Row",
    "tally.warn.lengthRange": "Length is outside the set range — value kept",
    "tally.warn.girthRange": "Girth is outside the set range — value kept",
    "tally.errorNav.lengthMissing": "Row {row}: Length is missing",
    "tally.errorNav.girthMissing": "Row {row}: Girth is missing",
    "tally.errorNav.bothMissing": "Row {row}: Length and Girth are missing",
    "tally.warn.divisibleBy5": "Length is not divisible by 5 — value kept",
    "tallysheet.flex.deleteRowConfirm": "Delete this row?",
    "tallysheet.flex.stockStatusLabel": "Stock Status",
    "tallysheet.flex.stockStatusNotReserved": "Red dot — no exact match yet, nothing reserved for this row",
    "tallysheet.flex.stockStatusMillTask": "Producing / Waiting to start — held by an active mill task",
    "tallysheet.flex.stockStatusReserved": "No badge — matched to real stock and reserved",
    "company.includeReservations.label": "Count in-progress work against available stock",
    "company.includeReservations.hint": "On by default — stock already claimed by saved Stock-Out rows or active mill tasks won't show as available until it's confirmed or released. Turn off to see the raw physical total instead.",
    "tallysheet.flex.back": "Back",
    "tallysheet.flex.next": "Next",
    "tallysheet.flex.done": "Done",
    "tallysheet.flex.scEnter": "open wizard / picker · on Pieces: next filled row",
    "tallysheet.flex.scAltEnter": "stock picker anytime",
    "tallysheet.flex.scCtrlEnter": "new row",
    "tallysheet.flex.scCtrlBackspace": "clear row",
    "tallysheet.flex.shortcutsLabel": "Shortcuts",
    "tallysheet.flex.shapeSubtitleSquare": "🔵 This is a Square tally — only Square-cut products are shown. Round products won't appear here.",
    "tallysheet.flex.shapeRedirect": "Need a different shape (e.g. round logs)? Switch to Standard Layout — each product line there gets its own tally type.",
    "tallysheet.flex.lockedTooltip": "Locked — this sheet already has saved rows. Pick a layout before saving.",
    "tallysheet.flex.confirmSwitchHeader": "Switch to Flexible Layout?",
    "tallysheet.flex.confirmSwitchMessage": "You have unsaved rows. Switching is safe, but consider saving first. Continue?",
    "tallysheet.tu.stockAnyOrigin": "Any origin",
    "tallysheet.tu.stockAnyQuality": "Any quality",
    "tallysheet.tu.additionalProducts": "Additional Products",
    "tallysheet.tu.products": "Products",
    "tallysheet.tu.addAnotherProduct": "Add another product",
    "tallysheet.tu.viewStock": "View stock availability",
    "tallysheet.tu.removeLineConfirmHeader": "Delete Tallysheet",
    "tallysheet.tu.removeLineConfirmMessage": "Deleting the tallysheet for {product} will permanently delete {count} tally record(s) linked to it. Type CONFIRM to proceed.",
    "tallysheet.tu.removeLine": "Remove this product line",
    "tallysheet.tu.removeLineHeader": "Remove Product Line",
    "tallysheet.tu.removeLineMessage": "If this line already has tally rows, they must be removed first — otherwise saving will be blocked.",
    "tallysheet.tu.typeSwitchHeader": "Tally Type Will Change",
    "tallysheet.tu.typeSwitchMessage": "Changing the product on {lines} switches its tally type — existing tally rows for that line will be permanently deleted. Continue?",
    "tallysheet.overStock.header": "Saving Past Available Stock",
    "tallysheet.overStock.message": "{line} would be tallied at {total} CBM, but only {available} CBM is available in stock. Please state why you want to proceed anyway:",
    "tallysheet.overStock.reasonPlaceholder": "Reason (required)",
    "tallysheet.overStock.proceed": "Save Anyway",
    "tallysheet.stockUnitId": "Stock Unit ID",
    "tallysheet.tu.tooltipStockUnitId": "System-assigned identity for this Stock Unit — unique, set automatically, never editable. Generated the moment you save.",
    "tallysheet.stockUnitIdPending": "Pending",
    "tallysheet.transportId": "Transport ID",
    "tallysheet.transportModeDetails": "Transport Mode Details",
    "tallysheet.tu.tooltipTransportId": "Optional reference for the actual truck/container/vehicle used — can repeat (e.g. the same truck may come more than once)",
    "tallysheet.tu.tooltipContainerNumber": "ISO container number assigned by the carrier — 4 letters + 6 digits + check digit (e.g. MSCU1234567)",
    "tallysheet.tu.tooltipSealNo": "Physical security seal fixed to the container door — referenced in phytosanitary and customs clearance documents (e.g. SNHR123456)",
    "tallysheet.tu.tooltipLoadingSite": "Where the timber was originally loaded — the origin location (forest, yard, mill, or port)",
    "tallysheet.tu.tooltipRoute": "Travel path of the truck from location to destination (e.g. Raipur to Kandla Port)",
    "tallysheet.tu.tooltipVehicleRegNo": "Official registration plate of the truck or trailer (e.g. MH04-AB-1234)",
    "tallysheet.tu.tooltipWagonNo": "Railway wagon number as printed on the railcar (e.g. BOXN-67890)",
    "tallysheet.chooseColumns": "Choose Columns",
    "tallysheet.colPreset.simple": "Simple",
    "tallysheet.colPreset.detailed": "Detailed",
    "tallysheet.colPreset.custom": "Custom",
    "tallysheet.colGroup.measurements": "Measurements",
    "tallysheet.colGroup.volume": "Volume",
    "tallysheet.colGroup.allowances": "Allowances",
    "tallysheet.colGroup.other": "Other",
    "tallysheet.editSettings": "Edit tally settings",
    "tallysheet.decimalsShort": "decimals",
    "tallysheet.globalSearch": "Global Search",
    "tallysheet.transportUnits": "Stock Units",
    "tallysheet.unit": "unit",
    "tallysheet.units": "units",
    "tallysheet.transportUnitsSubtitle": "Review stock units, open tallies, and manage secure share links",
    "tallysheet.viewTallysheet": "View tallysheet",
    "tallysheet.thisPage": "this page",
    "tallysheet.allPages": "all pages",
    "tallysheet.sortNewest": "Newest first",
    "tallysheet.sortOldest": "Oldest first",
    "tallysheet.sortStockUnitId": "Stock Unit ID",
    "tallysheet.sortProduct": "Product",
    "tallysheet.fullReportPdf": "Full report (PDF)",
    "tallysheet.copyTransportId": "Copy transport ID",
    "tallysheet.operations": "Operations",
    "tallysheet.newTallysheet": "New Tallysheet",
    "tallysheet.syncedTitle": "Synced",
    "tallysheet.syncedDetail": "This stock unit has synced to the server.",
    "tallysheet.newTransportUnit": "New Stock Unit",
    "tallysheet.newTallysheetSubtitle": "Capture stock unit details, tally measurements, photos, and summary in one workflow.",
    "tallysheet.editTransportUnit": "Edit Stock Unit",
    "tallysheet.viewTransportUnit": "View Stock Unit",
    "tallysheet.editTransportUnitSubtitle": "Update stock unit details, tally measurements, photos, and summary in one workflow.",
    "tallysheet.viewTransportUnitSubtitle": "Review stock unit details, tally measurements, photos, and summary in one workflow.",
    "tallysheet.transportUnit": "Stock Unit",
    "tallysheet.switchingTu": "Loading stock unit…",
    "tallysheet.tuLoadFailed": "Failed to load this stock unit.",
    "tallysheet.tallysheet": "Tallysheet",
    "tallysheet.roundTallysheet": "Round Tallysheet",
    "tallysheet.squareTallysheet": "Square Tallysheet",
    "tallysheet.measurementGrid": "Measurement grid",
    "tallysheet.measurementGridSubtitle": "Capture, validate, import, and save tally measurements",
    "tallysheet.rows": "Rows",
    "tallysheet.columnsSelected": "Columns",
    "tallysheet.editActions": "Edit",
    "tallysheet.viewControls": "View",
    "tallysheet.dataActions": "Data",
    "tallysheet.voiceControls": "Voice",
    "tallysheet.photos": "Photos",
    "tallysheet.summary": "Summary",
    "tallysheet.reconciliation": "Reconciliation",
    "tallysheet.goToRow": "Go to Row",
    "tallysheet.export": "Export",
    "tallysheet.quickExcelExport": "Quick Excel",
    "tallysheet.exportOptions": "Export Options…",
    "export.companyDetails": "Company Details",
    "export.chartsAndStats": "Charts & Stats",
    "export.showMaskedFields": "Show Masked Fields",
    "export.watermark": "Watermark",
    "export.packingList": "Packing List",
    "export.surveyReport": "Survey Report",
    "export.certificate": "Certificate",
    "tallysheet.save": "Save",
    "tallysheet.sr": "Sr",
    "tallysheet.orderKey": "Order Key",
    "tallysheet.girth": "Girth",
    "tallysheet.lengthAllowanceShort": "Length Allow.",
    "tallysheet.girthAllowanceShort": "Girth Allow.",
    "tallysheet.netLength": "Net Length",
    "tallysheet.netGirth": "Net Girth",
    "tallysheet.net": "Net",
    "tallysheet.gross": "Gross",
    "tallysheet.allowance": "Allowance",
    "tallysheet.volBasisHint": "Showing net volume — tap for gross",
    "tallysheet.volBasisHintGross": "Showing gross volume — tap for net",
    "tallysheet.volBasisWhy": "Net is used for stock, sales and mill jobs. Gross is the size as first measured. Tap Net or Gross to switch.",
    "tallysheet.volBreakdownTitle": "Net vs Gross Volume",
    "tallysheet.volBreakdownExplain": "Net is what counts for stock, sales and mill jobs. Gross is the size as first measured, before the bark and trim allowance.",
    "tallysheet.switchToGross": "Switch to Gross",
    "tallysheet.switchToNet": "Switch to Net",
    "tallysheet.grossCbm": "Gross CBM",
    "tallysheet.grossCft": "Gross CFT",
    "tallysheet.netCbm": "Net CBM",
    "tallysheet.netCft": "Net CFT",
    "tallysheet.supplier": "Supplier",
    "tallysheet.buyer": "Buyer",
    "tallysheet.driver": "Driver",
    "tallysheet.route": "Route",
    "tallysheet.expectedDelivery": "Expected Delivery",
    "tallysheet.mode": "Mode",
    "tallysheet.seaPort": "Sea Port",
    "tallysheet.locationMode": "Location & Mode",
    "tallysheet.totalPieces": "Total Pieces",
    "tallysheet.netVolumeCbm": "Net Vol. (CBM)",
    "tallysheet.avgCft": "Avg CFT",
    "tallysheet.weight": "Weight (kg)",
    "tallysheet.photoCount": "Photos",
    "tallysheet.metrics": "Metrics",
    "tallysheet.divisibleBy5": "Divisible by 5",
    "tallysheet.divisibleBy5On": "Divisible by 5 ON",
    "tallysheet.divisibleBy5Off": "Divisible by 5 OFF",
    "tallysheet.lengthRange": "Length Range",
    "tallysheet.lengthRangeOn": "Length Range ON",
    "tallysheet.widthRange": "Width Range",
    "tallysheet.thickRange": "Thickness Range",
    "tallysheet.rangeOn": "On",
    "tallysheet.rangeOff": "Off",
    "tallysheet.rangeHint": "Values outside the range are marked as a warning (amber) and kept.",
    "tallysheet.resetToCompanyDefaults": "Reset to company defaults",
    "tallysheet.resetConfirm": "This changes units, allowances and rules for this tally.",
    "tallysheet.resetYes": "Reset",
    "tallysheet.lengthRangeOff": "Length Range OFF",
    "tallysheet.girthRange": "Girth Range",
    "tallysheet.girthRangeOn": "Girth Range ON",
    "tallysheet.girthRangeOff": "Girth Range OFF",
    "tallysheet.unitOfMeasure": "Unit of Measure",
    "tallysheet.copyPreviousLength": "Copy Previous Length",
    "tallysheet.enterNavMode": "↵ Mode",
    "tallysheet.enterNavModeTooltip": "<b>Row mode:</b> Enter on Length → moves to Girth; Enter on Girth → creates a new row.<br><b>Column mode:</b> Enter on Length → creates a new row (stays in Length column); Enter on Girth → moves to next row&#39;s Girth (creates new row if on last row).<br><b>Ctrl+Enter</b> (any mode) → force action, bypasses validation.",
    "tallysheet.allowances": "Allowances",
    "tallysheet.lengthAllowance": "Length Allowance",
    "tallysheet.girthAllowance": "Girth Allowance",
    "tallysheet.allowancesLocked": "Allowances are locked once rows exceed",
    "tallysheet.columns": "Columns",
    "tallysheet.showColumns": "Show columns",
    "tallysheet.saveFormSettings": "Save Form Settings",
    "tallysheet.confirmSave": "Confirm Save",
    "tallysheet.uomChangeTitle": "Change Unit of Measure?",
    "tallysheet.uomChangeMessage": "This tally already has rows entered. How should the existing {field} values be handled for the new unit?",
    "tallysheet.uomChangeKeep": "Keep numbers as typed",
    "tallysheet.uomChangeKeepHint": "Recalculate using the same numbers under the new unit — use this if you typed the right numbers but had the wrong unit selected.",
    "tallysheet.uomChangeConvert": "Convert values",
    "tallysheet.uomChangeConvertHint": "Rewrite the existing numbers into the new unit, keeping the same physical measurement.",
    "tallysheet.uomChangeCancel": "Cancel",
    "account.profilePicture": "Profile Picture",
    "account.yourRole": "Your Role",
    "account.details": "Account Details",
    "account.personalDetails": "Personal Details",
    "account.detailsHint": "Your sign-in email and a verified mobile number",
    "account.personalHint": "About you, so your team and documents show the right name",
    "account.addressHeading": "Address",
    "account.changePassword": "Change Password",
    "account.emailNotVerified":
      "Email is not verified. Please verify your email address.",
    "account.mobile": "Mobile",
    "account.enterMobile": "Enter mobile Number",
    "account.mobileNotVerified":
      "Mobile is not verified. Please verify your mobile number.",
    "account.sendOtp": "Send OTP",
    "account.editMobile": "Edit Mobile",
    "account.dateOfBirth": "Date of Birth",
    "account.gender": "Gender",
    "account.next": "Next",
    "account.otpSentTo": "OTP has been sent to",
    "account.enterOtpBelow":
      "Please enter the OTP below to verify your phone number.",
    "account.resendOtpIn": "Resend OTP in",
    "account.seconds": "seconds",
    "account.resend": "Resend",
    "account.sendOtpWhatsapp": "Send code on WhatsApp",
    "account.sendOtpSms": "Send code by SMS",
    "account.otpWhatsappNote": "The code arrives on WhatsApp from LumberLinq. Tap Copy code, then paste it here.",
    "account.otpWhatsappFailed": "We could not send the code on WhatsApp. Check that this number is on WhatsApp, or send the code by SMS.",
    "account.otpUseSms": "Send by SMS instead",
    "account.otpUseWhatsapp": "Send on WhatsApp instead",
    "account.otpPickHint": "Get your 6-digit code on WhatsApp or SMS",
    "account.otpWaDelivered": "The code is on your WhatsApp now. Open the chat, tap Copy code and paste it here.",
    "account.otpWaNotDelivered": "WhatsApp could not deliver the code (the number may not be on WhatsApp). Please send the code by SMS instead.",
    "account.otpWaPending": "Not on your phone yet? Wait a little, resend it, or send the code by SMS.",
    "account.confirm": "Confirm",
    "account.oldPassword": "Old Password",
    "account.newPassword": "New Password",
    "account.confirmPassword": "Confirm Password",
    "account.oldPasswordRequired": "Old Password is required.",
    "account.passwordMinLength": "Password must be at least 8 characters long.",
    "account.passwordStrengthHint": "Password must contain at least one letter and one number.",
    "account.passwordChangeFailed": "Failed to change password. Please try again.",
    "account.confirmPasswordRequired": "Confirm Password is required.",
    "account.passwordsMismatch": "Passwords do not match.",
    "account.mustBeAtLeast13": "You must be at least 13 years old.",
    "user.mustBeAtLeast13": "You must be at least 13 years old.",
    "account.notValidEmail": "is not a valid email",
    "account.passwordRule":
      "must contain at least 1 uppercase, 1 lowercase letter, and 1 number",
    "account.mustBeAtLeast": "must be at least",
    "account.charactersLong": "characters long",
    "account.profileUpdated": "Profile updated successfully.",
    "account.profileLoadFailed": "Unable to load profile details.",
    "account.noProfileChanges": "No profile changes to update.",
    "account.saveAllHint": "Saves Account Details, Personal Details and Timezone together.",
    "account.requiredAddressFields": "Please complete all required address fields before continuing.",
    "account.requiredFields": "Please complete all required fields before continuing.",
    "account.updateFailed": "An error occurred while updating the record.",
    "account.verificationRequired": "Verification Required",
    "account.verifyMobileAndEmail": "Please verify your mobile and email first.",
    "account.mobileVerified": "Mobile verified",
    "account.mobileAlreadyVerified": "Your mobile number is already verified.",
    "account.mobileLocked": "Verified mobile number cannot be changed from this screen.",
    "account.otpSent": "OTP Sent",
    "account.otpError": "OTP Error",
    "account.otpUnableToSend": "Unable to send OTP.",
    "account.tryAgainLater": "Please try again later",
    "account.maxOtpAttempts": "You have reached the maximum number of OTP resend attempts.",
    "account.otpValidated": "OTP Validated",
    "account.otpInvalidTitle": "OTP is Invalid",
    "account.otpInvalid": "Invalid OTP.",
    "account.otpDigit": "OTP digit",
    "account.invalidMobileOnly": "Only mobile numbers are allowed. Please enter a valid mobile number.",
    "account.invalidPhoneFormat": "Invalid phone number format.",
    Male: "Male",
    Female: "Female",
    "Prefer not to say": "Prefer not to say",
    "product.name": "Product",
    "product.multipleProducts": "Products",
    "product.multipleProductsBreakdown": "Products in this unit",
    "product.namePlural": "Products",
    "product.subtitle": "Manage timber products, species and HS codes",
    "product.all": "All Products",
    "product.update": "Update Product",
    "product.manageDetails": "View and manage existing product details",
    "product.editDetails": "Edit details of existing products",
    "product.hsCode": "HS Code",
    "product.formula": "Formula",
    "product.selectFormula": "Select Formula",
    "product.quickAdd": "Add new product",
    "product.quickAddTitle": "New Product",
    "product.nameRequiredHint": "Name must be at least 5 characters.",
    "product.hsCodeHint": "HS Code must be 4-8 digits.",
    "product.quickAddedDetail": "Product created and selected.",
    "product.quickAddError": "Could not create the product. Please try again.",
    "product.description": "Description",
    "product.species": "Species",
    "product.usedIn": "Used In",
    "product.selectSpecies": "Select Species",
    "product.productCode": "Product Code",
    "product.photos": "Product Photos",
    "product.addPhoto": "Add Photo",
    "product.setAsDP": "Set as Display Picture",
    "product.formulasGuide": "Formulas Guide",
    "product.formulaGuide.roundTitle": "Round Log",
    "product.formulaGuide.roundFormula": "Hoppus formula: (Girth × Girth × Length) ÷ 160,000",
    "product.formulaGuide.roundWhen": "For round, unprocessed logs and roundwood.",
    "product.formulaGuide.roundChoose": "Choose this when the cross-section is circular — whole logs, rawwood, and unprocessed round timber.",
    "product.formulaGuide.squareTitle": "Square / Sawn",
    "product.formulaGuide.squareFormula": "Volumetric formula: Length × Width × Height",
    "product.formulaGuide.squareWhen": "For sawn or square-cut timber.",
    "product.formulaGuide.squareChoose": "Choose this when the timber is rectangular or square-cut — planks, beams, lumber, and dressed wood.",
    "product.formulaGuide.notSure": "Not sure which to pick?",
    "product.formulaGuide.tip": "Round cross-section → Round Log. Rectangular or square-cut → Square / Sawn.",
    "product.formulaPicker": "Formula Picker",
    "product.deletionRestriction": "Product Deletion Restriction",
    "product.addNew": "Add New Product",
    "product.bulkImport": "Bulk Import",
    "product.create": "Create Product",
    "product.inputDetails": "Input new product details",
    "loadingSite.name": "Location Name",
    "loadingSite.namePlural": "Locations",
    "loadingSite.quickAdd": "Add new location",
    "loadingSite.quickAddTitle": "New Location",
    "loadingSite.nameRequired": "Name must be at least 3 characters.",
    "loadingSite.quickAddedDetail": "Location created and selected.",
    "loadingSite.quickAddError": "Could not create the location. Please try again.",
    "loadingSite.all": "All Locations",
    "loadingSite.update": "Update Location",
    "loadingSite.manageProfiles":
      "View and manage existing location profiles",
    "loadingSite.editDetails": "Edit details of existing locations",
    "loadingSite.contactPerson": "Contact Person",
    "loadingSite.operatingHours": "Operating Hours",
    "loadingSite.capacity": "Capacity",
    "loadingSite.capacityCbm": "Capacity (CBM)",
    "loadingSite.currentVolume": "Current Volume",
    "loadingSite.machinesInstalled": "Machine(s) Installed",
    "loadingSite.notes": "Notes",
    "loadingSite.addNew": "Add New Location",
    "loadingSite.bulkImport": "Bulk Import",
    "loadingSite.create": "Create Location",
    "loadingSite.inputDetails": "Input new location details",
    "location.selectCountry": "Select a Country",
    "location.selectState": "Select a State",
    "location.selectCity": "Select a City",
    "location.country": "Country",
    "location.state": "State / Province",
    "location.city": "City",
    "location.address1": "Address Line 1",
    "location.address2": "Address Line 2",
    "location.postalCode": "Postal Code",
    "location.cityUnavailableOffline": "City list unavailable offline. Connect once online to load cities for this state.",
    "location.cityNotAvailableOffline": "Not available offline",
    "mediaCapture.takePhoto": "Take Photo",
    "mediaCapture.recordVideo": "Record Video (max 30s)",
    "mediaCapture.chooseGallery": "Choose from Gallery",
    "mediaCapture.browseFiles": "Browse Files",
    "mediaCapture.videoTooLongTitle": "Video Too Long",
    "mediaCapture.videoTooLongDetail": "Video must be 30 seconds or under. Please retry.",
    "mediaCapture.captureFailedTitle": "Capture Failed",
    "mediaCapture.captureFailedDetail": "Could not capture media. Please try again.",
    "mediaCapture.pasteRejectedTitle": "Pasted file not accepted",
    "mediaCapture.pasteRejectedDetail": "This upload box does not accept that file type.",
    "sfs.title": "Where should these files go?",
    "sfs.filesReady": "file(s) ready",
    "sfs.consignment": "Consignment documents",
    "sfs.consignmentHint": "BL, invoice, certificates and more",
    "sfs.stockUnit": "Stock Unit documents",
    "sfs.stockUnitHint": "Photos and papers of a stock unit",
    "sfs.aiImport": "AI Import",
    "sfs.aiImportHint": "Read a tally sheet from a photo or PDF",
    "sfs.aiNeedsImage": "Needs a photo or a PDF",
    "sfs.ticket": "Support ticket",
    "sfs.ticketHint": "Attach to a new ticket",
    "sfs.pickPlace": "Choose a place",
    "sfs.pickDocType": "Which document type?",
    "sfs.back": "Back",
    "sfs.cancel": "Cancel",
    "sfs.discard": "Discard files",
    "sfs.noAccess": "You do not have access to upload files anywhere. Please ask your admin.",
    "sfs.note": "Nothing is uploaded yet. The screen you choose will ask you to confirm.",
    "sfs.toast.title": "Files are waiting",
    "sfs.toast.consignment": "Open the consignment you want, then press Attach here.",
    "sfs.toast.consignmentHere": "Press Attach here on this consignment's Documents tab.",
    "sfs.toast.aiImportHere": "Press Attach here above this tally sheet.",
    "sfs.toast.stockUnit": "Open a Stock Unit, go to its Photos tab, then press Attach here.",
    "sfs.toast.stockUnitHere": "Press Attach here on this Stock Unit's Photos tab.",
    "sfs.toast.aiImport": "Open the tally sheet you want, then press Attach here.",
    "sfs.toast.ticket": "Fill in the ticket. The files are already added.",
    "sfs.waiting.consignment": "open the Consignment you want and press Attach here",
    "sfs.waiting.stockUnit": "open a Stock Unit, Photos tab, and press Attach here",
    "sfs.waiting.aiImport": "open a tally sheet and press Attach here",
    "sfs.waiting.ticket": "adding to your new ticket",
    "sfs.banner.hint": "Waiting to be attached to a record.",
    "sfs.banner.attach": "Attach here",
    "sfs.banner.discard": "Discard",
    "sfs.blocked.locked": "This consignment is locked, so files cannot be added.",
    "sfs.blocked.shipped": "This Stock Unit has been shipped and is locked, so files cannot be added.",
    "sfs.blocked.viewMode": "This tally sheet is view-only right now. Switch to edit mode first, then attach the files.",
    "sfs.blocked.slot": "This document type is not available on this consignment.",
    "sfs.blocked.readonly": "You can only view this document type here.",
    "sfs.blocked.busy": "Another upload is in progress. Please wait.",
    "mediaCapture.paste": "Paste",
    "mediaCapture.pasteNothingTitle": "Nothing to paste",
    "mediaCapture.pasteNothing": "No file found on the clipboard. Copy a file first, or use Share → LumberLinq from the other app.",
    "mediaCapture.pasteTextOnly": "The clipboard has text, not a file. Copy a file first, or use Share → LumberLinq from the other app.",
    "mediaCapture.pasteNoImage": "No image found on the clipboard. Copy an image or take a screenshot first, then tap Paste.",
    "sfs.native.failedTitle": "Some files could not be read",
    "sfs.native.failed": "Some shared files were too big or could not be opened. Please try sharing them again.",
    "avatar.changePhoto": "Change Photo",
    "avatar.chooseFile": "Choose File",
    "avatar.removePhoto": "Remove Photo",
    "avatar.cropTitle": "Adjust Your Photo",
    "avatar.cropHint": "Drag to reposition • Scroll or pinch to zoom",
    "avatar.cropConfirm": "Use Photo",
    "avatar.cropCancel": "Cancel",
    "avatar.uploading": "Uploading...",
    "avatar.uploadSuccess": "Profile picture updated",
    "permEditor.viewAddedNote": "The View right was turned on too, because this right needs it.",
    "permEditor.actionsRemovedNote": "Rights that need View were turned off too.",
    "permEditor.needsView": "Needs View",
    "avatar.uploadFailed": "Upload failed",
    "avatar.retry": "Retry",
    "avatar.confirmRemoveTitle": "Remove Profile Picture?",
    "avatar.confirmRemoveMessage": "Your avatar will go back to showing your initials.",
    "avatar.invalidFileType": "Please choose an image file (JPG, PNG or WEBP).",
    "avatar.fileTooLarge": "Image must be smaller than 5 MB.",
    "dashV3.title": "Operations Dashboard",
    "dashV3.subtitle": "Real-time overview of your timber trade operations",
    "dashV3.dateFrom": "From",
    "dashV3.dateTo": "To",
    "dashV3.apply": "Apply",
    "dashV3.refresh": "Refresh",
    "dashV3.staleSnapshot": "Offline — showing a cached snapshot from",
    "dashV3.loading": "Loading dashboard...",
    "offline.unavailableTitle": "Needs a connection",
    "offline.unavailableLead": "This feature isn't available while you're offline.",
    "offline.unavailableBody": "Export, import, reports, consignments, and inventory all need a live connection. Stock Units, Business Partners, Products, and Locations still work offline.",
    "offline.goToDashboard": "Go to Dashboard",
    "offline.autoReturnHint": "You'll be taken back here automatically once you're back online.",
    "dashV3.kpi.partners": "Business Partners",
    "dashV3.kpi.active": "Active",
    "dashV3.kpi.inactive": "Inactive",
    "dashV3.kpi.shipments": "Consignments",
    "dashV3.kpi.transportUnits": "Stock Units",
    "dashV3.kpi.unassigned": "Unassigned",
    "dashV3.kpi.volume": "Total Volume",
    "dashV3.kpi.pieces": "Total Pieces",
    "dashV3.kpi.cbm": "CBM",
    "dashV3.kpi.cft": "CFT",
    "dashV3.chart.byTradeType": "Consignments by Trade Type",
    "dashV3.chart.byMode": "Transport Mode",
    "dashV3.chart.volumeTrend": "Volume Trend",
    "dashV3.chart.topProducts": "Top Products by Volume (CFT)",
    "dashV3.chart.siteUtilization": "Location Utilization",
    "dashV3.chart.paymentStatus": "Payment Status",
    "dashV3.upcoming.departures": "Upcoming Departures",
    "dashV3.upcoming.arrivals": "Upcoming Arrivals",
    "dashV3.upcoming.next7days": "Next 7 Days",
    "dashV3.upcoming.noDepartures": "No departures in the next 7 days",
    "dashV3.upcoming.noArrivals": "No arrivals in the next 7 days",
    "dashV3.upcoming.blNo": "BL / Bill No",
    "dashV3.upcoming.shipper": "Shipper",
    "dashV3.upcoming.consignee": "Consignee",
    "dashV3.upcoming.date": "Date",
    "dashV3.upcoming.port": "Port",
    "dashV3.recent.title": "Recent Stock Units",
    "dashV3.recent.transportId": "Transport ID",
    "dashV3.recent.product": "Product",
    "dashV3.recent.site": "Location",
    "dashV3.recent.pieces": "Pieces",
    "dashV3.recent.volume": "Volume",
    "dashV3.recent.created": "Created",
    "dashV3.subscription.title": "Subscription",
    "dashV3.subscription.package": "Package",
    "dashV3.subscription.validTill": "Valid Till",
    "dashV3.subscription.daysLeft": "days left",
    "dashV3.subscription.expiringSoon": "Subscription expiring soon!",
    "dashV3.subscription.renew": "Renew Now",
    "dashV3.partners.byCountry": "Partners by Country",
    "dashV3.kpi.upcoming": "Upcoming",
    "dashV3.kpi.tallyUnits": "Tally Units",
    "dashV3.upcoming.pol": "Port of Loading",
    "dashV3.upcoming.pod": "Port of Discharge",
    "dashV3.upcoming.mode": "Mode",
    "dashV3.subscription.expiring": "Subscription expiring soon —",
    "dashV3.subscription.status": "Status",
    "dashV3.subscription.days": "days remaining",
    "dashV3.recent.id": "Transport ID",
    "dashV3.recent.cbm": "CBM",
    "dashV3.recent.cft": "CFT",
    "dashV3.recent.viewAll": "View All",
    "dashV3.site.name": "Site",
    "dashV3.site.country": "Country",
    "dashV3.site.capacity": "Capacity",
    "dashV3.site.noCapacitySet": "No capacity set for this site",
    "dashV3.site.current": "Current",
    "dashV3.site.util": "Utilization",
    "dashV3.noData": "No data available for the selected period",

    "report.title": "Reports",
    "report.from": "From",
    "report.to": "To",
    "report.inventory.title": "Inventory Report",
    "report.inventory.subtitle": "Stock levels, movement history, adjustments and mill jobs",
    "report.inventory.unitsAbbrev": "SUs",
    "report.bp.title": "Business Partner Report",
    "report.bp.subtitle":
      "Comprehensive analysis of business partner transactions, volumes and payments",
    "report.bp.search": "Search Business Partner",
    "report.bp.selectBp": "Select a business partner to generate report",
    "report.bp.period": "Report Period",
    "report.bp.from": "From Date",
    "report.bp.to": "To Date",
    "report.bp.generate": "Generate Report",
    "report.bp.generating": "Generating...",
    "report.bp.exportExcel": "Export Excel",
    "report.bp.exportPdf": "Export PDF",
    "report.bp.noData": "No consignment data found for the selected period.",
    "report.bp.profile": "Partner Profile",
    "report.bp.partyType": "Party Type",
    "report.bp.category": "Category",
    "report.bp.regType": "Registration Type",
    "report.bp.taxId": "Tax ID",
    "report.bp.active": "Active",
    "report.bp.inactive": "Inactive",
    "report.bp.owner": "Owner",
    "report.kpi.totalShipments": "Total Consignments",
    "report.kpi.asSeller": "As Seller",
    "report.kpi.asBuyer": "As Buyer",
    "report.kpi.totalCbm": "Net CBM",
    "report.kpi.totalCft": "Net CFT",
    "report.kpi.totalPieces": "Total Pieces",
    "report.payment.sellerTitle": "Payment — As Seller",
    "report.payment.buyerTitle": "Payment — As Buyer",
    "report.payment.totalInvoiced": "Total Invoiced",
    "report.payment.received": "Fully Received",
    "report.payment.partially": "Partially Paid",
    "report.payment.invoiced": "Invoiced (Sent)",
    "report.payment.notInvoiced": "Not Invoiced",
    "report.payment.overdue": "Overdue",
    "report.payment.outstanding": "Outstanding",
    "report.payment.cancelled": "Cancelled",
    "report.payment.totalPayable": "Total Payable",
    "report.payment.paid": "Paid",
    "report.payment.pending": "Pending",
    "report.payment.disputed": "Disputed",
    "report.chart.monthlyVolume": "Monthly Volume & Consignments",
    "chart.emptyTitle": "No data yet",
    "chart.emptyHint": "This chart fills in once there are records.",
    "report.chart.monthlyInvoice": "Monthly Invoice Amount",
    "report.chart.tradeRoleSplit": "Trade Role Split",
    "report.chart.paymentStatus": "Payment Status",
    "report.table.transactions": "Consignment Transactions",
    "report.table.date": "Date",
    "report.table.role": "Role",
    "report.table.tradeType": "Trade Type",
    "report.table.pol": "Port of Loading",
    "report.table.pod": "Port of Discharge",
    "report.table.origin": "Country of Origin",
    "report.table.destination": "Destination",
    "report.table.currency": "Currency",
    "report.table.invoiceAmt": "Invoice Amount",
    "report.table.cbm": "Net CBM",
    "report.table.cft": "Net CFT",
    "report.table.pieces": "Pieces",
    "report.table.units": "Stock Units",
    "report.table.payStatus": "Pay Status",
    "report.table.blNo": "B/L No.",
    "report.table.status": "Status",
    "report.table.products": "Products",
    "report.table.sites": "Locations",
    "report.products.title": "Products Summary",
    "report.products.name": "Product",
    "report.products.hsCode": "HS Code",
    "report.products.cbm": "Net CBM",
    "report.products.cft": "Net CFT",
    "report.products.pieces": "Pieces",
    "report.products.units": "Stock Units",
    "report.products.shipments": "Consignments",
    "report.sites.title": "Locations Summary",
    "report.sites.name": "Site Name",
    "report.sites.location": "Location",
    "report.sites.cbm": "Net CBM",
    "report.sites.cft": "Net CFT",
    "report.sites.pieces": "Pieces",
    "report.sites.units": "Stock Units",
    "report.sites.shipments": "Consignments",
    "report.role.seller": "Seller",
    "report.role.buyer": "Buyer",
    "report.role.notify": "Notify Party",
    "report.generatedAt": "Generated",
    "report.generate": "Generate",
    "report.loading": "Loading report...",
    "report.empty": "Select filters and click Generate to view the report.",
    "report.noData": "No data found for selected period.",
    "report.export.excel": "Export Excel",
    "report.export.pdf": "Export PDF",
    "report.filter.from": "From",
    "report.filter.to": "To",
    "report.filter.all": "All",
    "report.filter.clear": "Clear filters",
    "report.tab.overview": "Overview",
    "report.tab.transactions": "Transactions",
    "report.tab.financial": "Financial",
    "report.tab.products": "Products",
    "report.tab.sites": "Sites",
    "report.tab.trend": "Monthly Trend",
    "report.tab.byCurrency": "By Currency",
    "report.tab.partners": "Top Partners",
    "report.kpi.totalInvoiced": "Total Invoiced",
    "report.kpi.overdue": "Overdue",
    "report.kpi.units": "Stock Units",
    "report.col.date": "Date",
    "report.col.month": "Month",
    "report.col.tradeType": "Trade Type",
    "report.col.status": "Status",
    "report.col.shipper": "Shipper",
    "report.col.consignee": "Consignee",
    "report.col.polPod": "POL / POD",
    "report.col.currency": "Currency",
    "report.col.invoiceAmt": "Invoice Amt",
    "report.col.invoiced": "Invoiced",
    "report.col.salesStatus": "Sales Status",
    "report.col.cbm": "CBM",
    "report.col.netCbm": "Net CBM",
    "report.col.cft": "CFT",
    "report.col.netCft": "Net CFT",
    "report.col.pieces": "Pieces",
    "report.col.units": "Units",
    "report.col.shipments": "Consignments",
    "report.col.blNo": "B/L No.",
    "report.col.product": "Product",
    "report.col.hsCode": "HS Code",
    "report.col.avgCbmPerUnit": "Avg Net CBM/Unit",
    "report.col.currentStock": "Current Stock",
    "report.col.lots": "lots",
    "report.col.topPartners": "Top Partners",
    "report.col.topSites": "Top Sites",
    "report.col.topProducts": "Top Products",
    "report.col.site": "Site",
    "report.col.location": "Location",
    "report.col.capacity": "Capacity",
    "report.col.utilization": "Utilization",
    "report.col.millThroughput": "Mill Throughput CBM",
    "report.col.runs": "mill jobs",
    "report.col.partner": "Partner",
    "report.col.totalInvoiced": "Total Invoiced",
    "report.col.fullyPaid": "Fully Paid",
    "report.col.partiallyPaid": "Partially Paid",
    "report.col.overdue": "Overdue",
    "report.col.outstanding": "Outstanding",
    "report.col.sellerOutstanding": "Seller Outstanding",
    "report.col.buyerTotal": "Buyer Total",
    "report.col.buyerPaid": "Buyer Paid",
    "report.col.buyerPending": "Buyer Pending",
    "report.col.netPosition": "Net Position",
    "report.col.totalAmt": "Total Amount",
    "report.col.received": "Received",
    "report.col.paid": "Paid",
    "report.col.payable": "Payable",
    "report.shipment.title": "Consignment Report",
    "report.shipment.tradeType": "Trade Type",
    "report.shipment.status": "Status",
    "report.shipment.financialByCurrency": "Financial by Currency",
    "report.shipment.monthlyTrend": "Monthly Trend",
    "report.product.title": "Product Report",
    "report.product.distinctProducts": "Distinct Products",
    "report.site.title": "Location Report",
    "report.site.distinctSites": "Distinct Sites",
    "report.site.noCapacity": "No capacity data available",
    "report.financial.title": "Financial Summary Report",
    "report.financial.currency": "Currency",
    "report.financial.currencyPlaceholder": "e.g. USD",
    "report.financial.revenue": "Revenue (Received)",
    "report.financial.cost": "Cost (Paid)",
    "report.financial.receivable": "Receivable",
    "report.financial.payable": "Payable",
    "report.financial.overdue": "Overdue",
    "report.financial.topRevenuePartners": "Top Revenue Partners (As Seller)",
    "report.financial.topCostPartners": "Top Cost Partners (As Buyer)",
    "report.financial.tradeTypeSummary": "By Trade Type",
    "report.chart.byTradeType": "By Trade Type",
    "report.chart.sellerPayStatus": "Seller Payment Status",
    "report.chart.topLoadingPorts": "Top Ports of Loading",
    "report.chart.topProductsByCbm": "Top Products by Net CBM",
    "report.chart.monthlyProductTrend": "Monthly Product Trend",
    "report.chart.siteCbm": "Net CBM by Location",
    "report.chart.utilization": "Site Utilization",
    "report.chart.monthlyTrend": "Monthly Throughput",
    "report.chart.financialOverview": "Financial Overview",
    "report.chart.receivablesBreakdown": "Receivables Breakdown",
    "report.chart.monthlyInvoicedTrend": "Monthly Invoiced Trend",
    "report.tab.units": "Stock Units",
    "report.tab.tallies": "Tally Sheets",
    "report.col.transportId": "Transport ID",
    "report.col.unitNumber": "Unit No.",
    "report.col.mode": "Mode",
    "report.col.shipment": "Consignment",
    "report.col.type": "Type",
    "report.col.created": "Created",
    "report.tu.title": "Stock Unit Report",
    "report.operator.title": "Operator Performance Report",
    "report.operator.totalOperators": "Total Operators",
    "report.operator.activeOperators": "Active Operators",
    "report.operator.runsCompleted": "Mill Jobs Completed",
    "report.operator.totalOutputCbm": "Total Output CBM",
    "report.operator.avgOutturn": "Avg Outturn",
    "report.operator.byOperator": "By Operator",
    "report.operator.name": "Name",
    "report.operator.employeeCode": "Employee Code",
    "report.operator.specializations": "Specializations",
    "report.operator.active": "Active",
    "report.operator.activeYes": "Active",
    "report.operator.activeNo": "Inactive",
    "report.operator.inputCbm": "Input CBM",
    "report.operator.outputCbm": "Output CBM",
    "report.operator.bestOutturn": "Best Outturn",
    "report.operator.avgDuration": "Avg Duration (hrs)",
    "report.tu.totalUnits": "Total Units",
    "report.tu.linked": "Linked to Consignment",
    "report.tu.inStock": "In Stock (Inventory)",
    "report.tu.unlinked": "Unlinked",
    "report.tu.statusBreakdown": "Status Breakdown",
    "report.tu.modeBreakdown": "Transport Mode",
    "report.tu.monthlyTrend": "Monthly Trend",
    "report.tu.statusSummary": "Status Summary",
    "report.tally.title": "Tally Sheet Report",
    "report.tally.totalTallies": "Total Tallies",
    "report.tally.roundTallies": "Round Timber",
    "report.tally.squareTallies": "Square Timber",
    "report.tally.flexibleGrid": "Flexible Grid",
    "report.tally.typeBreakdown": "Type Breakdown",
    "report.tally.monthlyCbm": "Monthly CBM by Type",
    "report.tally.shrinkageChart": "Source vs Destination CBM",
    "report.tally.noShrinkageData": "No destination data available.",
    "report.tally.avgCbm": "Avg Net CBM / Tally",
    "report.tally.avgPieces": "Avg Pieces / Tally",
    "report.tally.tallies": "Tallies",
    "report.tally.destCbm": "Dest. CBM",
    "report.tally.shrinkage": "Shrinkage %",

    "report.financial.actualReceived": "Actual Received",
    "report.financial.actualPaid": "Actual Paid",
    "report.financial.totalReceived": "Total Received",
    "report.financial.totalPaid": "Total Paid",
    "report.financial.netCashflow": "Net Cashflow",
    "report.financial.receivables": "Receivables",
    "report.financial.minAmount": "Min amount",
    "report.financial.maxAmount": "Max amount",
    "report.financial.paymentStatus": "Payment status",
    "report.financial.paymentFrom": "Payment from",
    "report.financial.paymentTo": "Payment to",
    "report.financial.payables": "Payables",
    "report.col.txnType": "Type",
    "report.col.paymentMode": "Mode",
    "report.col.reference": "Reference",
    "report.col.notes": "Notes",

    "report.recon.title": "Reconciliation Report",
    "report.recon.subtitle": "Source vs Destination tally variance analysis",
    "report.recon.totalTallies": "Total Tallies",
    "report.recon.reconciled": "Reconciled",
    "report.recon.pending": "Pending",
    "report.recon.srcCbm": "Source CBM",
    "report.recon.srcPieces": "Source Pieces",
    "report.recon.dstCbm": "Dest. CBM",
    "report.recon.dstPieces": "Dest. Pieces",
    "report.recon.varianceCbm": "CBM Variance",
    "report.recon.variancePieces": "Pieces Variance",
    "report.recon.shrinkage": "Shrinkage %",
    "report.recon.millLoss": "Mill Loss CBM",
    "report.recon.reconStatus": "Reconciliation Status",
    "report.recon.shrinkageDist": "Shrinkage Distribution",

    // ── Inventory ──────────────────────────────────────────────
    "inventory.title": "Inventory",
    "inventory.overview": "Overview",
    "inventory.inOut": "In / Out",
    "inventory.processing": "Mill Jobs",
    "inventory.available": "Available",
    "inventory.inProcess": "In a mill job",
    "inventory.inShipment": "In Consignment",
    "inventory.shipped": "Shipped",
    "inventory.lotStock": "Lot Stock",
    "inventory.openLots": "open lots",
    "inventory.atForest": "At Forest",
    "inventory.inTransit": "In Transit",
    "inventory.atMill": "At Mill",
    "inventory.atYard": "At Yard",
    "inventory.receiveIntoInventory": "Receive into Inventory",
    "inventory.receiveNeedsRows": "Add at least one tally row before receiving into inventory",
    "inventory.receivedIntoInventory": "Received into Inventory",
    "inventory.receiveConfirmMessage": "Add Stock Unit {transportId} to inventory? This will record it as an incoming stock movement.",
    "inventory.yesReceive": "Yes, Receive",
    "inventory.received": "Received",
    "inventory.receivedDetail": "{transportId} has been added to inventory.",
    "inventory.confirmStockOut": "Confirm Stock-Out",
    "inventory.confirmChecking": "Checking stock…",
    "inventory.confirmStockOutMessage": "Confirm Stock Unit {transportId} has shipped out? This will permanently debit the matching stock.",
    "inventory.confirmStockOutMultiProductIntro": "This stock unit has {count} products, which will be permanently debited as follows: {breakdown}. Continue?",
    "inventory.confirmStockOutBatchIntro": "This will be drawn from {count} lots: {breakdown}. Continue?",
    "inventory.confirmStockOutInsufficientWarning": "Warning: not enough stock for one or more of these products — confirming may fail.",
    "inventory.stockShortTitle": "Not enough stock — nothing was saved",
    "inventory.stockShortHint": "Fix these rows, or turn on “Let sales continue past available stock” in Application Settings → Inventory Policy.",
    "inventory.stockShortLineNone": "{label}: needs {need} pcs, no stock",
    "inventory.stockShortLineOnly": "{label}: needs {need} pcs, only {free} free",
    "inventory.confirmBlockedNoStock": "Can't confirm — these rows have no free stock of their size (wood another Stock Out is holding is not free):",
    "inventory.confirmBlockedNoStockHint": "Change the size, remove the row, or ask the mill to make it.",
    "inventory.confirmUnsavedChanges": "Save the tally first — it has unsaved rows. Confirming only counts saved rows, and the tally locks afterwards.",
    "inventory.receiveUnsavedChanges": "Save the tally first — it has unsaved rows. Only saved rows are received into stock, and the tally locks right after.",
    "tallysheet.tu.soldPastStock": "Sold past available stock — reason: {reason}",
    "tallysheet.tu.soldPastStockBy": " (by {by})",
    "statement.soldPastStock": "Sold past available stock",
    "inventory.rowExceedsStockReview": "Exceeds stock — tap to review",
    "inventory.rowInsufficientStockFix": "Not enough in stock — tap to fix",
    "inventory.rowNotReservedHint": "No stock is currently reserved for this row.",
    "inventory.resolvedOriginAuto": "oldest stock",
    "inventory.shippedLockedMessage": "This stock unit has been confirmed and shipped — editing is locked. An admin can still make changes.",
    "inventory.rowNeedsLookSingular": "row needs a quick look",
    "inventory.rowNeedsLookPlural": "rows need a quick look",
    "inventory.review": "Review",
    "inventory.yesConfirm": "Yes, Confirm",
    "inventory.confirmStockOutTooltip": "Permanently debit stock for this Stock Unit's tallied contents",
    "inventory.stockOutConfirmed": "Stock-Out Confirmed",
    "inventory.stockOutConfirmedDetail": "{transportId} has been debited from inventory.",
    "inventory.newProcessingRun": "New Mill Job",
    "inventory.outturn": "Outturn",
    "inventory.inputCbm": "Input CBM",
    "inventory.outputCbm": "Output CBM",
    "inventory.stockByLocation": "Stock by Location",
    "inventory.whereIsYourMaterial": "Where is your material right now?",
    "inventory.daysInYard": "Days in Yard",
    "inventory.runCode": "Mill Job ID",
    "inventory.millLocation": "Mill / Location",
    "inventory.processingDate": "Mill Job Date",
    "inventory.selectInputTus": "Select input Stock Units",
    "inventory.recordOutput": "Record Output",
    "inventory.movementLedger": "Movement Ledger",
    "loading-site.siteType": "Site Type",
    "loading-site.siteType.FOREST": "Forest",
    "loading-site.siteType.MILL": "Mill / Sawmill",
    "loading-site.siteType.YARD": "Yard / Staging",
    "loading-site.siteType.PORT": "Port / Harbour",
    "loading-site.siteType.WAREHOUSE": "Warehouse",
    // -- Common extras
    "common.locked": "Locked",
    "common.reconciled": "Reconciled",
    "common.confirmDeletion": "Confirm Deletion",
    "common.amount": "Amount",
    "common.size": "Size",
    // -- Tallysheet lock & AI import
    "tallysheet.lockedBanner": "This tallysheet is locked — no further edits are allowed.",
    "tallysheet.summaryOutdated": "Summary may be outdated. Rows were saved after this tab was last loaded.",
    "tallysheet.lockButton": "Lock",
    "tallysheet.lockTooltip": "Lock this tallysheet permanently",
    "tallysheet.lockNeedsRows": "Add at least one tally row before locking",
    "tallysheet.lockNoPhotosWarning": "No photos uploaded yet for this Stock Unit. You can still lock it, but photos usually cannot be added easily afterward.",
    "tallysheet.lockGoToPhotos": "Go to Photos",
    "tallysheet.lockDialogHeader": "Lock Tallysheet",
    "tallysheet.lockIrreversible": "This action is irreversible.",
    "tallysheet.lockOnceNote": "Once locked, no tally entries can be added or modified.",
    "tallysheet.lockTypeConfirm": "Type LOCK to confirm:",
    "tallysheet.lockPermanently": "Lock Permanently",
    "tallysheet.inventoryTab": "Inventory",
    "tallysheet.aiImport": "AI Import",
    "tallysheet.aiImportTooltip": "AI Import — upload a handwritten tallysheet image",
    "tallysheet.lengthRequired": "Length required",
    "tallysheet.girthRequired": "Girth required",
    "tallysheet.enterRowNumber": "Enter Row Number",
    // -- Inventory extensions
    "inventory.notYetInInventory": "Not yet in inventory",
    "inventory.receiveToStartTracking": "Receive this Stock Unit to start tracking inventory movements.",
    "inventory.clickToReceive": "Click the button below to receive this Stock Unit into inventory.",
    "inventory.notInInventoryBanner": "Not in Inventory — receive this Stock Unit to start stock tracking.",
    "inventory.statusLabel": "Inventory Status",
    "inventory.statusColon": "Inventory Status:",
    "inventory.movementHistory": "Movement History",
    "inventory.noMovementsYet": "No movements recorded yet.",
    "inventory.addToInventoryTooltip": "Add this Stock Unit to the inventory system",
    "inventory.productRequiredTooltip": "Add a Product before receiving into inventory",
    "inventory.moveComingSoon": "Move between sites — coming soon",
    "inventory.loadingSiteRequiredTooltip": "Location is required before receiving into inventory",
    "inventory.loadingSiteRequiredBanner": "Select a Location before receiving this Stock Unit into inventory — otherwise the stock won't be trackable.",
    "inventory.transportModeRequiredTooltip": "Add Transport Mode before receiving into inventory",
    "inventory.transportModeRequiredForStockOut": "Add Transport Mode before confirming stock-out",
    "inventory.dateAndTime": "Date & Time",
    "inventory.movementType": "Movement Type",
    // -- Shipment extras
    "shipment.lockedTooltip": "Locked — no further edits allowed",
    "shipment.exportTooltip": "Export consignment to Excel or PDF",
    "shipment.noTransportUnitsShared": "No stock units are available for this shared consignment.",
    // -- Payment panel
    "payment.loadingData": "Loading payment data...",
    "payment.invoice": "Invoice",
    "payment.salesStatus": "Sales Status",
    "payment.paidOut": "Paid Out",
    "payment.purchaseStatus": "Purchase Status",
    "payment.unableToLoad": "Unable to load payment summary.",
    "payment.record": "Record Payment",
    "payment.typeLabel": "Payment Type",
    "payment.receivable": "Receivable (Money In)",
    "payment.payable": "Payable (Money Out)",
    "payment.selectType": "Select type",
    "payment.modeLabel": "Payment Mode",
    "payment.selectMode": "Select mode",
    "payment.referenceNo": "Reference No",
    "payment.referencePlaceholder": "Cheque no / TT ref / UTR",
    "payment.notesPlaceholder": "Optional notes",
    "payment.save": "Save Payment",
    "payment.history": "Payment History",
    // -- Storage
    "storage.title": "Storage Usage",
    "storage.subtitle": "Track your file storage across all tallies, documents and business partners",
    "storage.usedRing": "used",
    "storage.used": "Used",
    "storage.quota": "Quota",
    "storage.free": "Free",
    "storage.files": "Files",
    "storage.filesCount": "files",
    "storage.warningPrefix": "You have used",
    "storage.warningBannerSuffix": "of your storage. Consider deleting unused files.",
    "storage.fullBanner": "Storage full! New file uploads are blocked. Please free up space or upgrade your plan.",
    "storage.addedBy": "Added By",
    "storage.noFilesFound": "No files found.",
    // -- Dashboard V4
    "dashV4.businessPulse": "Business Pulse",
    "dashV4.inventorySnapshot": "Inventory Snapshot",
    "dashV4.fullInventory": "Full Inventory",
    "dashV4.availableStock": "Available Stock",
    "dashV4.inProcessing": "In a mill job",
    "dashV4.inShipment": "In Consignment",
    "dashV4.shippedThisMonth": "Shipped This Month",
    "dashV4.activeSites": "Active Sites",
    "dashV4.locations": "locations",
    "dashV4.noInventoryData": "No inventory data yet.",
    "dashV4.setUpInventory": "Set up inventory →",
    "dashV4.volumeTrend": "Volume Trend (CBM)",
    "dashV4.upcomingShipments": "Upcoming Consignments",
    "dashV4.departures": "Departures",
    "dashV4.arrivals": "Arrivals",
    "dashV4.geographySites": "Geography & Sites",
    "dashV4.recentTUs": "Recent Stock Units",
    "dashV4.standardPlan": "Standard Plan",
    "dashV4.validTill": "Valid till",
    "dashV4.daysLeft": "days left",
    "dashV4.manage": "Manage",
    "dashV4.active": "active",
    "dashV4.inactive": "inactive",
    "dashV4.upcoming": "upcoming",
    "dashV4.unassigned": "unassigned",
    // -- Dashboard V5
    "dashV5.title": "Dashboard",
    "dashV5.subtitle": "Business, Financial & Inventory Overview",
    "dashV5.financialHealth": "Financial Health",
    "dashV5.totalInvoiced": "Total Invoiced",
    "dashV5.totalReceived": "Received",
    "dashV5.outstanding": "Outstanding",
    "dashV5.overdue": "Overdue",
    "dashV5.payables": "Payables",
    "dashV7.currentTooltip": "Always current — not limited to the selected date range",
    "dashV8.goodMorning": "Good morning",
    "dashV8.periodNote": "The period sets: volume, Stock Units, pieces, consignments, invoiced and received. Everything else shows the situation right now.",
    "dashV8.vsPrevious": "vs the period before",
    "dashV8.details": "Details",
    "dashV8.freeToSell": "free to sell",
    "dashV8.free": "Free",
    "dashV8.held": "Held",
    "dashV8.inMill": "In a mill",
    "dashV8.allCounted": "All Stock Units counted",
    "dashV8.toCount": "still to count",
    "dashV8.goodAfternoon": "Good afternoon",
    "dashV8.goodEvening": "Good evening",
    "dashV8.focus": "Everything this company does",
    "dashV8.newSince": "new since",
    "dashV8.period": "Period",
    "dashV8.p.today": "Today",
    "dashV8.p.7d": "7 days",
    "dashV8.p.30d": "30 days",
    "dashV8.p.month": "This month",
    "dashV8.p.pick": "Pick dates",
    "dashV8.activeUntil": "active until",
    "dashV8.item": "item",
    "dashV8.items": "items",
    "dashV8.more": "more",
    "dashV8.showAll": "Show all",
    "dashV8.showLess": "Show less",
    "dashV8.open": "Open",
    "dashV8.review": "Review",
    "dashV8.count": "Count",
    "dashV8.see": "See",
    "dashV8.needMine1": "You have 1 mill task",
    "dashV8.needMineN": "You have {n} mill tasks",
    "dashV8.taskNeedsAccept": "{code} needs accepting",
    "dashV8.taskRunning": "{code} is running",
    "dashV8.needOverdue1": "1 payment is overdue",
    "dashV8.needOverdueN": "{n} payments are overdue",
    "dashV8.overdueSub": "{amount} to collect",
    "dashV8.overdueSubDays": "{amount} to collect · oldest {days} days",
    "dashV8.needHolds1": "1 Stock Out holding wood for 60+ days",
    "dashV8.needHoldsN": "{n} Stock Outs holding wood for 60+ days",
    "dashV8.needHoldsSub": "{cbm} m³ is blocked from sale",
    "dashV8.needRecon1": "1 Stock Unit is not counted",
    "dashV8.needReconN": "{n} Stock Units are not counted",
    "dashV8.needReconSub": "Counted so far: {pct}%",
    "dashV8.needUnassigned1": "1 Stock Unit is not on a consignment yet",
    "dashV8.needUnassignedN": "{n} Stock Units are not on a consignment yet",
    "dashV8.needMillQueued1": "1 mill job is waiting to start",
    "dashV8.needMillQueuedN": "{n} mill jobs are waiting to start",
    "dashV8.needArrivals1": "1 consignment arrives this week",
    "dashV8.needArrivalsN": "{n} consignments arrive this week",
    "dashV8.needArrivalsSub": "first on {date}",
    "dashV8.vsLastMonth": "vs last month",
    "dashV8.millRunning": "Mill jobs running",
    "dashV8.trends": "Trends",
    "dashV8.tab.volume": "Volume",
    "dashV8.tab.products": "Products",
    "dashV8.tab.types": "Types",
    "dashV8.tab.transport": "Transport",
    "dashV8.tab.payments": "Payments",
    "dashV8.chip.STOCK": "Stock",
    "dashV8.chip.MILL": "Mill",
    "dashV8.chip.CONSIGNMENT": "Consignments",
    "dashV8.chip.MONEY": "Money",
    "dashV8.chip.RECON": "Counts",
    "dashV8.chip.TALLY": "Stock Units",
    "dashV8.chip.TEAM": "Team",
    "dashV8.chip.MINE": "Mine",
    "dashV8.dayToday": "Today",
    "dashV8.dayYesterday": "Yesterday",
    "dashV8.evt.STOCK_IN": "Stock received",
    "dashV8.evt.STOCK_OUT": "Stock Out confirmed",
    "dashV8.evt.STOCK_COUNT": "Count done",
    "dashV8.evt.STOCK_ADJUST": "Stock adjusted",
    "dashV8.evt.MILL_DONE": "Mill job {ref} finished",
    "dashV8.evt.CONSIGNMENT_NEW": "Consignment {ref} created",
    "dashV8.evt.PAYMENT_IN": "Payment received",
    "dashV8.evt.PAYMENT_OUT": "Payment made",
    "dashV8.evt.TALLY_NEW": "Stock Unit {ref} created",
    "dashV8.evt.TEAM_GRANT": "Right {ref} given",
    "dashV8.evt.TEAM_REVOKE": "Right {ref} taken away",
    "dashV8.teamFor": "for {name}",
    "dashV8.feedNote": "Only finished business events are listed. Saving or editing tally rows is never shown; a Stock Unit appears once, when it is created.",
    "dashV7.needsTitle": "Needs you today",
    "dashV7.allClear": "All clear. Nothing is waiting for you today.",
    "dashV7.needOverdue": "overdue payments to collect",
    "dashV7.needRecon": "Stock Units waiting to be reconciled",
    "dashV7.needUnassigned": "Stock Units not on a consignment yet",
    "dashV7.needMyTasks": "mill jobs on your list",
    "dashV7.needMillQueued": "mill jobs waiting to start",
    "dashV7.chipAll": "All",
    "dashV7.cat.STOCK": "Stock",
    "dashV7.cat.MILL": "Mill",
    "dashV7.cat.CONSIGNMENT": "Consignments",
    "dashV7.cat.MONEY": "Money",
    "dashV7.cat.TEAM": "Team",
    "dashV7.ev.STOCK_IN": "Stock received",
    "dashV7.ev.STOCK_OUT": "Stock sent out",
    "dashV7.ev.STOCK_COUNT": "Stock counted",
    "dashV7.ev.STOCK_ADJUST": "Stock adjusted",
    "dashV7.ev.MILL_DONE": "Mill job finished",
    "dashV7.ev.CONSIGNMENT_NEW": "Consignment created",
    "dashV7.ev.PAYMENT_IN": "Payment received",
    "dashV7.ev.PAYMENT_OUT": "Payment made",
    "dashV7.ev.TEAM_GRANT": "Right given",
    "dashV7.ev.TEAM_REVOKE": "Right taken away",
    "dashV7.severalSizes": "several sizes",
    "dashV7.with": "with",
    "dashV7.noActivity": "Nothing has happened here lately.",
    "dashV7.showMore": "Show more",
    "dashV7.activityFailed": "The latest activity could not be loaded just now.",
    "dashV7.upcomingTooltip": "Always shows the next 7 days — independent of the date range above",
    "dashV5.receivablesAging": "Receivables Aging",
    "dashV5.shipmentsLabel": "consignments",
    "dashV5.reconciliation": "Reconciliation Status",
    "dashV5.totalTUs": "Total Stock Units",
    "dashV5.reconciled": "Reconciled",
    "dashV5.pending": "Pending",
    "dashV5.locked": "Locked",
    "dashV5.netDiscrepancy": "Net Discrepancy",
    "dashV5.tuId": "Stock Unit ID",
    "dashV5.sourceCbm": "Source CBM",
    "dashV5.destCbm": "Dest. CBM",
    "dashV5.discrepancy": "Diff",
    "dashV5.noDiscrepancies": "No discrepancies — all reconciled Stock Units match.",
    "dashV5.avgOutturn": "Avg Outturn",
    "dashV5.netGain": "Net Gain (Mill Jobs)",
    "dashV5.runsLabel": "mill jobs",
    "dashV5.outturnNote": "Output > 100% means volume gain from round-to-square milling.",
    "dashV5.paymentFlow": "Payment Flow",
    "dashV5.mixedCurrencies": "Multiple currencies",
    "dashV5.showingCurrencyOnly": "Showing only:",
    "dashV5.otherCurrencies": "other currencies",
    "dashV5.perCurrencyBreakdown": "Per-currency breakdown",
    // -- Dashboard V6
    "dashV6.title": "Dashboard",
    "dashV6.subtitle": "Role-aware, real-time business overview",
    "dashV6.liveTooltip": "Live — updates automatically",
    "dashV6.offlineTooltip": "Offline — showing cached data, not live",
    "dashV6.myMillTasks": "My Active Mill Tasks",
    "dashV6.millBoard": "Mill Job Board",
    "dashV6.viewAllRuns": "View All Mill Jobs",
    "dashV6.queued": "Queued",
    "dashV6.inProgress": "In Progress",
    "dashV6.completedToday": "Completed Today",
    "dashV6.machineUtil": "Machines Busy",
    "dashV6.topOperators": "Top Operators by Active Load",
    "dashV6.status.DRAFT": "Queued",
    "dashV6.status.IN_PROGRESS": "In Progress",
    "dashV6.status.COMPLETED": "Completed",
    "dashV6.priority.HIGH": "High",
    "dashV6.priority.MEDIUM": "Medium",
    "dashV6.priority.LOW": "Low",
    "dashV6.recentActivity": "Recent Activity",
    "dashV6.granted": "granted",
    "dashV6.revoked": "revoked",
    "dashV6.forUser": "for",
    // -- Common extras
    "common.export": "Export",
    "common.next": "Next",
    "common.retry": "Retry",
    "common.clearFilters": "Clear Filters",
    "common.saveAll": "Save All",
    "common.resetDefaults": "Reset to Defaults",
    "common.configure": "Configure",
    "common.disable": "Disable",
    "common.close": "Close",
    "common.skip": "Skip",
    "common.continue": "Continue",
    "common.deactivate": "Deactivate",
    "common.reactivate": "Reactivate",
    "common.preview": "Preview",
    "common.openNewTab": "Open in new tab",
    "common.resetAllToDefaults": "Reset all to defaults",
    "common.renew": "Renew",
    "common.manage": "Manage",
    "common.apply": "Apply",
    "common.saveTimezone": "Save Timezone",
    // -- Shipment lock dialog
    "shipment.lockDialogHeader": "Lock Consignment",
    "shipment.lockButtonTooltip": "Lock this consignment permanently — no edits after lock",
    "shipment.lockDescription": "Once locked, this consignment cannot be edited by anyone. All changes will be permanently frozen.",
    // -- Reconciliation lock
    "recon.lockDialogHeader": "Lock Reconciliation",
    "recon.lockIrreversible": "This action is permanent and irreversible.",
    "recon.lockDescription": "Once locked, no one can modify reconciliation data — not even the account owner. The tallysheet itself remains accessible and viewable.",
    "recon.lockReasonLabel": "Reason (optional)",
    "recon.lockReasonPlaceholder": "e.g. Confirmed against discharge survey",
    "recon.varianceDetected": "Variance detected",
    "recon.varianceChoiceLabel": "How should this be applied to inventory?",
    "recon.applyAutoLabel": "Apply automatically now",
    "recon.applyAutoDesc": "Inventory will be corrected to match the actual arrived quantity.",
    "recon.applyAutoNeedsReceive": "Receive this Stock Unit first — there's no stock yet to correct.",
    "recon.applyManualLabel": "I'll handle it manually",
    "recon.applyManualDesc": "Inventory keeps the original quantity — adjust it yourself later if needed.",
    "recon.lockTypeConfirm": "Type LOCK to confirm",
    "recon.confirmLockButton": "Confirm Lock Reconciliation",
    // -- Inventory processing page
    "invProc.title": "Mill Jobs",
    "invProc.subtitle": "Mill jobs: stock from one Lot sawn into a new Lot",
    "invProc.totalRuns": "Total Mill Jobs",
    "invProc.avgOutturn": "Avg Outturn",
    "invProc.cbmProcessed": "CBM Milled (Input)",
    "invProc.noRuns": "No mill jobs yet.",
    "invProc.noRunsHint": "Click New Mill Job to turn round logs into sawn timber.",
    "invProc.stepLocation": "Location & Date",
    "invProc.millLocationLabel": "Mill",
    "invProc.millPlaceholder": "Search or type mill name",
    "invProc.millRequired": "Mill location is required.",
    "invProc.notesLabel": "Notes (optional)",
    "invProc.tuSelectionHint": "Showing AVAILABLE round-type Stock Units. Select all that will go into the saw.",
    "invProc.noTusFound": "No available round-log Stock Units found.",
    "invProc.noTusHint": "Receive round log Stock Units into inventory first.",
    "invProc.selected": "Selected:",
    "invProc.totalInput": "Total input:",
    "invProc.outputProduct": "Output Product",
    "invProc.outputProductPlaceholder": "Search or type product name",
    "invProc.noProductFound": "No products found",
    "invProc.noSiteFound": "No yards found",
    "invProc.acSearchMessage": "{0} results are available",
    "invProc.acEmptySelectionMessage": "No item selected",
    "invProc.storeAt": "Store At",
    "invProc.storePlaceholder": "Yard name",
    "invProc.outputVolume": "Output Volume (CBM)",
    "invProc.fifoPanelTitle": "Which purchase does this count against?",
    "invProc.fifoPanelHint": "Oldest purchase is used first. You can edit the split below if needed.",
    "invProc.fifoPanelMismatch": "The edited amounts must add up to the same total CBM as what went into the mill.",
    "invProc.fifoPanelCbmLabel": "CBM",
    "invProc.fifoPanelPiecesLabel": "Pieces",
    "invProc.outputPiecesLabel": "Output Pieces",
    "invProc.inputPiecesLabel": "How many pieces going in?",
    "invProc.useFullVolume": "Use full volume",
    "invProc.useAllPieces": "All pieces",
    "invProc.inputPiecesOptionalHint": "Optional — you can also enter this when finishing the job.",
    "invProc.inputPiecesExceeds": "More than the pieces in this stock",
    "invProc.inputPiecesUsed": "Input pieces used",
    "invProc.inputPiecesHint": "Pieces taken from the input stock. Output pieces can be more — one piece can make many.",
    "invProc.inputPiecesReadOnlyHint": "Input can't be changed after the job is finished. Use a stock adjustment to correct it.",
    "invProc.inputPiecesRequired": "Enter the input pieces used before finishing the job.",
    "invProc.confirmSave": "Confirm & Save",
    "invProc.inputHeader": "INPUT",
    "invProc.outputHeader": "OUTPUT",
    "invProc.inputTUs": "Input Stock Units",
    "invProc.lossLabel": "Conversion",
    "invProc.step1.title": "What goes to the mill?",
    "invProc.step2.title": "What came out?",
    "invProc.inputCbmLabel": "How much going in? (CBM)",
    "invProc.moreDetails": "More details (optional)",
    "invProc.selectTUs": "Select stock units (optional)",
    "invProc.confirmJobSave": "Record Mill Job",
    "invProc.outputMethod": "How to enter output?",
    "invProc.directVolume": "Enter total CBM",
    "invProc.directVolumeDesc": "Type total output volume",
    "invProc.viaTally": "Measure log-by-log (Tally Sheet)",
    "invProc.viaTallyDesc": "Open tally sheet to count pieces",
    "invProc.viaCsv": "CSV / Excel",
    "invProc.viaCsvDesc": "Upload measurement spreadsheet",
    "invProc.viaAi": "AI Import",
    "invProc.viaAiDesc": "Scan or upload a document",
    "invProc.draftNote": "The mill job will be saved as Draft. Complete the output after saving.",
    "invProc.notesPlaceholder": "e.g. 4×8 planks, custom order",
    "invProc.inputCbmLabelHelp": "How much is going into the saw?",
    "invProc.assignTo": "Assign to operator",
    "invProc.needsAccept": "Assigned to you · Accept",
    "invProc.assignedToYou": "Assigned to you",
    "invProc.assignedTo": "Assigned to",
    "invProc.createdBy": "Created by",
    "invProc.you": "You",
    "invProc.acceptedLabel": "Accepted",
    "invProc.onlyAssignedCanAct": "This task is assigned to another operator. Only that operator or a manager can work on it.",
    "invProc.acceptTask": "Accept Task",
    "invProc.accepted": "Task accepted",
    "invProc.myTasks": "My Tasks",
    "invProc.big.accept": "Accept",
    "invProc.big.start": "Start",
    "invProc.big.done": "Done",
    "invProc.big.resume": "Start Again",
    "invProc.big.pause": "Pause",
    "invProc.declineButton": "Can't do it",
    "invProc.declineTitle": "Can't do this task",
    "invProc.declineIntro": "The task goes back to your manager. Tell them why.",
    "invProc.declineReasonLabel": "Why can't you do it?",
    "invProc.declineReasonPlaceholder": "e.g. machine broken, wrong logs, not at this mill",
    "invProc.declineConfirm": "Send back",
    "invProc.declineDone": "Task sent back to your manager",
    "invProc.declineNeedsInternet": "This needs internet. Try again when you are online.",
    "invProc.declinedCouldNot": "couldn't do this task",
    "invProc.declinedHint": "It is not assigned to anyone now. Cancel it and create a new task for another operator.",
    "invProc.myTasksSubtitle": "Your mill work. Tap a big button to move a task forward.",
    "invProc.myTasksEmpty": "No tasks for you right now",
    "invProc.myTasksEmptyHint": "New tasks given to you will show here.",
    "invProc.big.refresh": "Refresh",
    "user.millOperator": "Mill operator",
    "user.millOperatorPill": "Operator",
    "user.millOperatorOnTitle": "Mill operator on",
    "user.millOperatorOffTitle": "Mill operator off",
    "user.millOperatorOnMessage": "This person can now be assigned mill tasks.",
    "user.millOperatorRightsAdded": "This person can now be assigned mill tasks. View Mill Jobs and Run Mill Jobs were added to their access.",
    "user.millOperatorRoleMissing": "Their role \"{{role}}\" does not include View Mill Jobs and Run Mill Jobs, so they cannot accept tasks yet. Add those to the role, or pick another role.",
    "user.millOperatorFailed": "Could not change mill operator. Please try again.",
    "user.inviteAsMillOperator": "This person is a mill operator",
    "user.inviteAsMillOperatorHint": "They can be assigned mill tasks after they join.",
    "operator.linkLogin": "Link a login",
    "operator.linkLoginHint": "Pick the team member this operator is, so they can see and accept their tasks. This can be set only once.",
    "operator.noLogin": "No login",
    "operator.noLoginHint": "This operator has no login, so they cannot see or accept tasks. Tap to link one.",
    "operator.noOperatorsHint": "No mill operators yet. Turn on \"Mill operator\" for a person in Manage Users.",
    "invProc.assignHint": "Leave blank to save as Draft — assign later.",
    "invProc.willBeAssigned": "Job will be created and assigned to the selected operator.",
    "invProc.willBeDraft": "No operator selected — job will be saved as Draft.",
    "invProc.outputPending": "Pending — recorded after milling is done.",
    "invProc.assignDate": "Expected date",
    "invProc.jobCard": "YOUR JOB TODAY",
    "invProc.startJob": "Start Job",
    "invProc.customMade.requested": "Requested",
    "invProc.customMade.sourceChoiceLabel": "Source stock",
    "invProc.customMade.pickMyself": "Pick source myself",
    "invProc.customMade.letOperatorDecide": "Let operator decide",
    "invProc.customMade.operatorPicksLater": "The operator will pick the source lot when they start this job.",
    "invProc.customMade.chooseLotToStart": "Choose source lot",
    "invProc.customMade.rowWaiting": "Waiting to start",
    "invProc.customMade.rowProducing": "Producing…",
    "invProc.customMade.rowPaused": "Paused at mill",
    "invProc.customMade.peekTitle": "Mill task",
    "invProc.customMade.peekUnavailable": "Could not load this task's details.",
    "invProc.customMade.dialogTitle": "Request Custom-Made",
    "invProc.customMade.dialogExplainer": "We couldn't find this exact size in stock — request it be cut at the mill.",
    "invProc.customMade.sizeUnknown": "size unknown — verify before choosing",
    "invProc.lotHeldBy": "Held by",
    "invProc.customMade.sizeTooSmall": "smaller than needed",
    "invProc.customMade.tooSmallWarning": "This lot is smaller than what's needed — a mill can only cut down, not add material.",
    "invProc.customMade.inputCbmLabel": "How much going in? (CBM)",
    "invProc.customMade.inputCbmHint": "Your row needs about",
    "invProc.customMade.previewOutturn": "preview outturn",
    "invProc.customMade.inputCbmTooLow": "This is less than what's needed — increase it to allow for mill loss. Your row needs at least",
    "invProc.customMade.priorityLabel": "Priority",
    "invProc.customMade.priorityLow": "Low",
    "invProc.customMade.priorityMedium": "Medium",
    "invProc.customMade.priorityHigh": "High",
    "invProc.customMade.priorityHighHint": "This will block a shipment until it's done — flagged as High priority.",
    "invProc.customMade.neededByLabel": "Needed by",
    "invProc.customMade.neededByHint": "Optional. You and the mill are reminded once if the job is still open after this day.",
    "invProc.customMade.targetLabel": "Order needs",
    "invProc.customMade.late": "Late",
    "invProc.customMade.short": "Short",
    "invProc.customMade.shortBy": "short by",
    "invProc.customMade.madeOf": "Made",
    "invProc.customMade.stillMissing": "pcs are still missing. The order is still short: ask the mill again for the rest.",
    "invProc.customMade.inputBelowTarget": "The input volume is smaller than what the order needs. Check it before cutting.",
    "invProc.customMade.submitCta": "Request It",
    "invProc.customMade.requestedToast": "Custom-made request sent",
    "invProc.customMade.requestFailed": "Could not send the request",
    "invProc.customMade.queuedOfflineRunCode": "Queued — will sync",
    "invProc.customMade.queuedOfflineToast": "Custom-Made request saved offline",
    "invProc.customMade.queuedOfflineDetail": "Will be sent automatically once you're back online.",
    "invProc.customMade.staleLotsNotice": "Showing lots as of your last sync — may be outdated.",
    "invProc.customMade.recommended": "Recommended",
    "invProc.customMade.estimatedOutturn": "Estimated outturn",
    "invProc.customMade.viewSizes": "View sizes",
    "common.optional": "optional",
    "invProc.customMade.tuPreparing": "Preparing",
    "invProc.customMade.tuPreparingTooltip": "One or more items on this sheet are being produced at the mill.",
    "invProc.completeJob": "Job Done",
    "invProc.cancelJob": "Cancel Mill Job",
    "invProc.pauseJob": "Pause",
    "invProc.resumeJob": "Resume",
    "invProc.pauseReasonLabel": "Why are you pausing this?",
    "invProc.pauseReasonPlaceholder": "e.g. Urgent order came in",
    "invProc.filterStatus": "Status",
    "invProc.filterAll": "All",
    "invProc.filterDraft": "Draft",
    "invProc.filterRunning": "Running",
    "invProc.filterPaused": "Paused",
    "invProc.filterFinished": "Finished",
    "invProc.filterCompleted": "Completed",
    "invProc.filterCancelled": "Cancelled",
    "invProc.sortLabel": "Sort",
    "invProc.sortNewest": "Newest First",
    "invProc.sortOldest": "Oldest First",
    "invProc.sortCode": "Mill Job ID A-Z",
    "invProc.noJobToday": "No job assigned today.",
    "invProc.jobAssignedBy": "Assigned by",
    "invProc.editOutput": "Edit Output",
    "invProc.outputAboveInput": "The output is more than what went into the mill. Sawing cannot make more wood than it was given: check the output tally and the input volume.",
    "invProc.directEntry": "Direct Volume",
    "invProc.viaTallySheet": "Via Tally Sheet",
    "invProc.taskNo": "Task No",
    "invProc.viewInMill": "View in Mill",
    "invProc.sourceOrder": "Source Order",
    "invProc.viewSourceOrder": "View source order",
    "invProc.selectTallySheet": "Search tally sheet (ID or container #)...",
    "invProc.tallyLinked": "Tally sheet linked — CBM auto-filled",
    "invProc.directDesc": "Enter total CBM manually",
    "invProc.tallyDesc": "Record pieces → CBM auto-totals",
    "invProc.csvImport": "CSV / Excel",
    "invProc.csvDesc": "Import spreadsheet → verify in tally",
    "invProc.aiImport": "AI Import",
    "invProc.aiDesc": "Scan document → verify in tally",
    "invProc.openTally": "Open Tally →",
    "invProc.tallyTypeLabel": "Tally Type",
    "invProc.tallyTypeRound": "Round",
    "invProc.tallyTypeSquare": "Square",
    "invProc.tallyTypeDerivedHint": "Auto-detected from product",
    "invProc.tallyTypePickProduct": "Choose the output product first. The tally type (Round or Square) is then set from it.",
    "invProc.odWhatCameOut": "What came out",
    "invProc.odHowRecord": "How do you record it?",
    "invProc.odTotals": "Totals",
    "invProc.odSquareRule": "The input is sawn timber (Square), so the output is Square too. Sawn timber can't be milled into round logs.",
    "invProc.volumeUnit": "Volume unit",
    "invProc.odChooseProductFirst": "Choose the output product first. Then you can pick how to record it.",
    "invProc.odTotalsFromTally": "The totals appear here once you have saved the tally.",
    "invProc.odProductTypeLocked": "This job's tally already holds {type} rows, so only {type} products are offered.",
    "invProc.noProductOfType": "No {type} product found",
    "invProc.odDraftSaving": "Saving your choice…",
    "invProc.odDraftSaved": "Your choice is saved",
    "invProc.odDraftError": "Could not save your choice yet.",
    "invProc.soFar": "so far",
    "invProc.recordedSoFar": "Recorded so far",
    "invProc.recordedBeforeCancel": "Recorded before cancelling",
    "invProc.notStockYet": "Not stock yet. It becomes stock when the job is done.",
    "invProc.cancelWithOutputWarn": "Job <b>{run}</b> already has {cbm} CBM ({pcs} pieces) recorded in its output tally. If you cancel, that tally is kept only as a record and none of it becomes stock. To put it into stock, finish the job instead.",
    "invProc.cancelAnyway": "Cancel anyway",
    "invProc.keepJob": "Keep job",
    "invProc.atMill": "At the mill",
    "invProc.atMillJobs": "Jobs running",
    "invProc.atMillInput": "Input held",
    "invProc.atMillOutput": "Output so far",
    "invProc.atMillNote": "Not stock yet",
    "invProc.openingTally": "Opening tally…",
    "invProc.preparingRun": "Preparing the new mill job…",
    "invProc.odTotalsLocked": "Choose the output product first, then enter the totals.",
    "invProc.odPrepareSizes": "Prepare sizes (optional)",
    "invProc.odPrepareSizesHint": "The tally opens with these sizes ready at 0 pieces. The Operator layout shows them as cards.",
    "invProc.odSizesReady": "{n} sizes ready",
    "invProc.odSizesNotSaved": "The sizes could not be saved. Pick them again with Pick sizes in the Operator layout.",
    "invProc.odEditInputPieces": "Change input pieces",
    "millOp.layoutAria": "Tally layout",
    "millOp.layoutGrid": "Grid",
    "millOp.layoutOperator": "Operator",
    "millOp.loadError": "Could not load the sheet.",
    "millOp.retry": "Try again",
    "millOp.outputPieces": "Output pieces",
    "millOp.outputVolume": "Output volume",
    "millOp.volumeUnit": "Volume unit",
    "millOp.input": "Input",
    "millOp.outturn": "Outturn",
    "millOp.ofInput": "of the input volume",
    "millOp.moreThanInput": "more than the input: check the sizes",
    "millOp.saved": "Saved",
    "millOp.saving": "Saving…",
    "millOp.unsaved": "Unsaved",
    "millOp.saveFailed": "Could not save",
    "millOp.show": "Show",
    "millOp.sheetSizes": "Sheet sizes",
    "millOp.used": "Used",
    "millOp.view": "View",
    "millOp.textSize": "Text size",
    "millOp.cardSize": "Card size",
    "millOp.cardTiny": "Tiny",
    "millOp.cardSmall": "Small",
    "millOp.cardMedium": "Medium",
    "millOp.cardLarge": "Large",
    "millOp.tapSound": "Tap sound",
    "millOp.keepScreenOn": "Keep screen on",
    "millOp.keepScreenOnUnsupported": "This device or browser cannot keep the screen on.",
    "millOp.unitsNote": "Units follow the sheet settings. To change them, open Settings in the Grid layout.",
    "millOp.resetView": "Reset to default",
    "millOp.oneLess": "One piece less",
    "millOp.oneMore": "One piece more",
    "millOp.piecesTapToType": "Pieces. Tap to type a number",
    "millOp.noUsed": "No sizes used yet. Switch to “Sheet sizes” and tap +.",
    "millOp.noSizesTitle": "No sizes on this sheet yet",
    "millOp.noSizesText": "Pick the sizes you expect, or add a new size.",
    "millOp.newSize": "New size",
    "millOp.pickSizes": "Pick sizes",
    "millOp.autoSaves": "Saves by itself a moment after your last tap",
    "millOp.screenStaysOn": "Screen stays on",
    "millOp.undo": "Undo",
    "millOp.setPieces": "Set pieces",
    "millOp.piecesForSize": "Pieces for this size",
    "millOp.clear": "Clear",
    "millOp.newSizeHint": "Tap a box, then a quick value or the keys",
    "millOp.width": "Width",
    "millOp.thickness": "Thickness",
    "millOp.length": "Length",
    "millOp.addSize": "Add size",
    "millOp.pickHint": "Tick the sizes you expect. You can still add any new size later.",
    "millOp.searchSize": "Search a size, e.g. 4 x 2",
    "millOp.listView": "List",
    "millOp.chipView": "Chips",
    "millOp.addAll": "Add all",
    "millOp.hasPieces": "has pieces",
    "millOp.noSuggestions": "No earlier sizes found yet. Use “New size”.",
    "millOp.addNSizes": "Add {n} sizes",
    "millOp.removeNSizes": "Remove {n} sizes",
    "millOp.onSheet": "On this sheet",
    "millOp.sameAsLast": "Same as the last job {code}",
    "millOp.mostUsed": "Most used",
    "millOp.recent": "Recent",
    "millOp.changeToast": "{size}: {from} → {to} pcs",
    "invProc.odTypeFromInput": "because the input is sawn timber",
    "invProc.squareInputRoundBlocked": "Sawn timber (Square input) can't be milled into round logs. Choose a Square output product.",
    "invProc.tallyTypeMismatch": "This job's tally already has rows in a {tally} tally, but the output product is a {product} product. Pick a {tally} output product, or switch to Direct Volume.",
    "invProc.tallyTypeLinkedHint": "From linked tally",
    "invProc.linkedTally": "Linked",
    "invProc.tallyRows": "rows",
    "invProc.cbmFromTally": "Auto-filled from tally",
    "invProc.tallyManualHint": "Record pieces manually in the tally, then return here",
    "invProc.csvHint": "CSV import dialog will open automatically",
    "invProc.aiHint": "AI import dialog will open automatically",
    "invProc.dispatchOutput": "Send to Consignment →",
    "invProc.selectShipment": "Select Consignment",
    "invProc.shipmentPlaceholder": "Choose an active consignment...",
    "invProc.confirmDispatch": "Confirm Dispatch",
    "tally.processingBanner": "Recording output for Mill Job:",
    "tally.outputLockedTitle": "This output is final",
    "tally.outputLockedText": "This Mill Job is finished and its wood is already in stock as a new Lot, so this tally is read-only — it always matches the stock it created. To change the output, use Edit Output on the Mill Job. To correct a stock figure, use Add Adjustment. Both keep a record.",
    "tally.returnToRun": "Done — Back to the Mill Job",
    "tally.saveAndReturnToRun": "Save & back to the Mill Job",
    // -- Field operator UI (ROLE_USER locked)
    "field.stockIn.title": "Record Stock Arrival",
    "field.millRun.title": "Your Job",
    "field.sendOut.title": "Record Dispatch",
    "field.selectProduct": "What arrived?",
    "field.cbmAmount": "How much? (CBM)",
    "field.location": "Where is it stored?",
    "field.submitBtn": "Done",
    "field.noJobAssigned": "No job assigned today.",
    // -- Inventory in-out page
    "invInOut.title": "In / Out Ledger",
    "invInOut.subtitle": "Every inventory movement with timestamp and details",
    "invInOut.addAdjustment": "Add Adjustment",
    "invInOut.adjTooltip": "Record a manual stock correction",
    "invInOut.exportTooltip": "Export filtered ledger to Excel",
    "invInOut.dateRange": "Date Range",
    "invInOut.allDates": "All dates",
    "invInOut.movements": "movements",
    "invInOut.netChange": "Net change",
    "invInOut.businessPartner": "Business Partner",
    "invInOut.noMovements": "No movements found.",
    "invInOut.clearFiltersHint": "Try clearing the filters above.",
    "invInOut.adjDialogHeader": "Add Inventory Adjustment",
    "invInOut.tuPlaceholder": "Search Stock Unit, container / truck no. or product",
    "ledger.s.received": "Received",
    "ledger.s.at": "at",
    "ledger.s.as": "as",
    "ledger.s.dispatched": "Dispatched",
    "ledger.s.from": "from",
    "ledger.s.on": "on",
    "ledger.s.to": "to",
    "ledger.s.sentToMill": "Sent to mill",
    "ledger.s.forJob": "for job",
    "ledger.s.job": "Job",
    "ledger.s.produced": "produced",
    "ledger.s.into": "into",
    "ledger.s.addedToConsignment": "added to consignment",
    "ledger.s.allowance": "Round allowance",
    "ledger.s.tallyCorrected": "Tally corrected by",
    "ledger.s.stockCorrected": "Stock corrected by",
    "Reconciliation": "Reconciliation",
    "Allowance": "Allowance",
    "Tally correction": "Tally correction",
    "ledger.s.reconciled": "Reconciled",
    "ledger.col.whatHappened": "What happened",
    "ledger.col.by": "By",
    "ledger.job.show": "Whole job",
    "ledger.job.in": "In",
    "ledger.job.out": "Out",
    "ledger.job.started": "Started",
    "ledger.job.finished": "Finished",
    "ledger.job.notFinished": "Not finished yet",
    "ledger.job.wastage": "Wastage",
    "invInOut.tuRequired": "Select a Stock Unit.",
    "invInOut.reason": "Reason",
    "invInOut.reasonPlaceholder": "Select reason",
    "invInOut.reasonRequired": "Select a reason.",
    "invInOut.cbmChange": "CBM Change",
    "invInOut.cbmHint": "Negative = loss, positive = gain",
    "invInOut.piecesChange": "Pieces Change",
    "terms.open": "What do Stock Unit, Lot and Mill Job mean?",
    "terms.flowLabel": "How stock moves: Stock In, Lot, Mill Job, new Lot, Stock Out",
    "terms.stockIn": "Stock In",
    "terms.stockOut": "Stock Out",
    "terms.lot": "Lot",
    "terms.newLot": "New Lot",
    "terms.millJob": "Mill Job",
    "terms.suName": "Stock Unit",
    "terms.suText": "One load — a container, truck or wagon — with its tally rows. Stock In = bought, Stock Out = sold. Its rows lock once received / confirmed.",
    "terms.lotText": "A pile of the same wood in stock (product, site, origin, quality). Stock In is received into it; Stock Outs and Mill Jobs take from it — oldest Lot first.",
    "terms.lotOld": "(called Batch before)",
    "terms.jobText": "Wood sent from a Lot to the mill; it records what went in, what came out and the waste, and makes a new Lot.",
    "terms.jobOld": "(called Processing / Mill Run before)",
    "terms.more": "How stock moves — full guide",
    "so.fromPurchase": "From purchase",
    "so.whereFrom": "Where it came from",
    "so.show": "Show",
    "so.showPath": "Show the whole path",
    "so.hidePath": "Hide the path",
    "so.error": "Could not trace this.",
    "so.nothing": "Nothing taken from stock yet.",
    "so.inputNote": "Before a mill job the figures are the wood that went in, so they include that job's waste. Net volume.",
    "so.in": "in",
    "so.out": "out",
    "so.waste": "waste",
    "so.now": "Now",
    "so.adjusted": "Adjusted",
    "so.reconciled": "Reconciled",
    "so.allowance": "Allowance",
    "so.traceToPurchase": "Trace to purchase",
    "so.kind.LOT": "Lot",
    "so.kind.MILL_JOB": "Mill Job",
    "so.kind.STOCK_UNIT": "Stock Unit",
    "so.kind.OPENING_STOCK": "Opening stock",
    "so.kind.HAND": "Lot entered by hand",
    "so.kind.ADJUSTMENT": "Added by adjustment",
    "so.kind.NOT_TRACED": "Not traced",
    "adj.what": "Stock Unit, Stock Out or lot",
    "adj.whatPlaceholder": "Search Stock In / Stock Out unit, container / truck no., lot or product",
    "adj.kind.IN": "Stock In",
    "adj.kind.OUT": "Stock Out",
    "adj.kind.LOT": "Lot",
    "adj.reconHint": "Reconciliation difference — enter it size by size:",
    "adj.noLot": "This Stock Unit is not received into a lot yet — nothing to adjust.",
    "adj.outLine": "Which line of this Stock Out",
    "adj.outLinePlaceholder": "Pick lot · size · pieces",
    "adj.noOutLines": "This Stock Out has not taken any stock yet — nothing to adjust.",
    "adj.batchNow": "now has",
    "adj.dir.gain": "Add to stock",
    "adj.dir.loss": "Take off stock",
    "adj.dir.outGain": "Sent less than recorded",
    "adj.dir.outLoss": "Sent more than recorded",
    "adj.size": "Size",
    "adj.sizePlaceholder": "Pick a size",
    "adj.anotherSize": "Another size…",
    "adj.sec.what": "What to adjust",
    "adj.sec.amount": "Size and amount",
    "adj.sec.why": "Why",
    "adj.origin": "Origin",
    "adj.quality": "Quality",
    "adj.originNote": "The adjustment goes into this Lot — its origin and quality stay the same.",
    "adj.volume": "Volume",
    "adj.sizeSearch": "Search size, e.g. 4x3x6",
    "adj.width": "Width (in)",
    "adj.thick": "Thickness (in)",
    "adj.length": "Length (ft)",
    "adj.pieces": "Pieces",
    "adj.cbm": "CBM",
    "adj.maxPcs": "Up to {n} pcs of this in stock",
    "adj.pcsInStock": "{n} pcs",
    "adj.tooMuch": "That is more than this lot / size really has.",
    "adj.outNoteTitle": "Stock Out adjusted",
    "adj.outNote": "Stock is corrected; the Stock Out's rows stay as they were. Consignment / invoice totals are NOT changed — fix those too if needed.",
    "adj.offline": "Adjustments need a connection.",
    "adj.saved": "Adjustment recorded — stock in hand updated.",
    "adj.roundPart": "Round logs (no size)",
    "adj.reason.RECONCILIATION_DELTA": "Reconciliation delta",
    "adj.reason.RECONCILIATION_AFTER_MILLING": "Reconciliation after milling",
    "adj.reason.DAMAGE": "Damage",
    "adj.reason.MOISTURE_LOSS": "Moisture / drying loss",
    "adj.reason.MEASUREMENT_ERROR": "Measurement error",
    "adj.reason.MANUAL_CORRECTION": "Manual correction",
    "adj.reason.OTHER": "Other",
    "adj.notesRequired": "Please describe what happened (required when the reason is Other).",
    "adj.large.title": "This is a large adjustment",
    "adj.large.text": "Check the amount carefully — a typo (such as an extra zero) would change your stock a lot.",
    "adj.large.confirm": "I have checked this amount",
    "adj.holdShortTitle": "Other Stock Outs now short",
    "adj.holdShortText": "These open Stock Outs hold more of this lot than it now has: {units}",
    "adj.alreadyAdjusted": "adjusted",
    "ledger.s.adjustedAfterConfirm": "Adjusted after confirm",
    "ledger.s.recordedOnly": "(recorded only — no stock change)",
    "invInOut.postAdjustment": "Post Adjustment",
    "invInOut.descPlaceholder": "Describe what happened (optional)",
    // -- Inventory overview page
    "invOverview.title": "Inventory Overview",
    "invOverview.subtitle": "Live stock snapshot across all locations",
    "invOverview.thisMonth": "This month",
    "invOverview.clearStageHint": "Click the same stage to clear filter",
    "invOverview.filterTooltip": "Click to filter stock table",
    "invOverview.openTu": "Open Stock Unit",
    "invOverview.noStock": "No stock in inventory yet.",
    "invOverview.noStockHint": "Click Stock In to record your first stock arrival.",
    "invOverview.showAllTus": "Show all",
    "invOverview.receiveHint": "Truck arrived — record new stock",
    "invOverview.processHint": "Send logs to the mill",
    "invOverview.dispatchHint": "Stock going out",
    "invOverview.recordInInventory": "Record in Inventory",
    "invOverview.linkedToInventory": "In Inventory",
    "invOverview.modeToggle": "View mode",
    // -- Inventory mode toggle (ADMIN/Accountant only)
    "inv.modeSimple": "Simple",
    "inv.modeAdvanced": "Advanced",
    "inv.modeTooltip": "Simple: fewer fields · Advanced: full tracking",
    "inv.stockIn": "Stock In",
    "inv.millRun": "Mill Job",
    "inv.sendOut": "Send Out",
    // -- Inventory Lots / Wizards
    "lot.receive": "Stock In",
    "lot.process": "→ Mill",
    "lot.sendToMill": "Send to mill",
    "lot.more.label": "More",
    "lot.more.details": "View details",
    "lot.more.statement": "Stock statement",
    "lot.more.openJob": "Open mill job",
    "lot.more.rename": "Rename lot",
    "lot.warn.short": "Short of contract by",
    "lot.dispatch": "Send Out",
    "lot.stockBatch": "Stock Lots",
    "lot.inputLotLabel": "Input Stock Lot",
    "lot.selectLotPlaceholder": "Select stock lot (optional)",
    "lot.searchLotPlaceholder": "Search product, origin, lot code or mill job…",
    "lot.searchLotEmpty": "No lot matches your search",
    "lot.pickSearchPlaceholder": "Search product, lot, Stock Unit, container, BL…",
    "lot.pickOriginPlaceholder": "Origin: all",
    "lot.pickOriginUnknown": "Origin unknown",
    "lot.pickOpenLots": "open lots",
    "lot.pickFree": "CBM free",
    "lot.pickMadeBy": "made by",
    "lot.pickHide": "hide",
    "lot.pickStockUnit": "Stock Unit",
    "lot.pickContainer": "Container / truck · Transport ID",
    "lot.pickSource": "source",
    "lot.pickThisLot": "this lot",
    "lot.pickUnitsCount": "Stock Units",
    "lot.pickReceived": "received into this lot",
    "lot.pickTraced": "traced through the mill job",
    "lot.pickClose": "Close",
    // -- Mill Operators
    "operator.label": "Operator",
    "operator.multiCompanyBadge": "Multi-company",
    "operator.multiCompanyTooltip": "This person is also active in another company — their account isn't exclusive to yours.",
    "operator.selectPlaceholder": "Assign operator (optional)",
    "operator.title": "Mill Operators",
    "operator.subtitle": "Manage mill operators and track performance",
    "operator.backToInventory": "Back to Inventory",
    "operator.addOperator": "Add Operator",
    "machine.title": "Machines",
    "machine.subtitle": "Manage mill machines and equipment",
    "machine.backToInventory": "Back to Inventory",
    "machine.addMachine": "Add Machine",
    "machine.editMachine": "Edit Machine",
    "machine.name": "Name",
    "machine.namePlaceholder": "e.g. Re-saw 2",
    "machine.type": "Type",
    "machine.typePlaceholder": "e.g. Re-saw, Edger, Cross-cut",
    "machine.location": "Location",
    "machine.status": "Status",
    "machine.active": "Active",
    "machine.inactive": "Inactive",
    "machine.deactivate": "Deactivate",
    "machine.reactivate": "Reactivate",
    "machine.confirmMachine": "Confirm",
    "machine.searchPlaceholder": "Search machines...",
    "machine.allLocations": "All Locations",
    "machine.allStatus": "All Status",
    "machine.needsReview": "Needs Review",
    "machine.needsReviewTooltip": "Imported from a Location's free-text field — please confirm this is correct",
    "machine.importFromLocations": "Import from Locations",
    "machine.statTotal": "Total Machines",
    "machine.machineSingular": "machine",
    "machine.machinePlural": "machines",
    "machine.emptyState": "No machines yet. Add one, or import from your existing Locations.",
    "shortcuts.title": "Keyboard Shortcuts",
    "shortcuts.macHint": "⌘ = Cmd on Mac. The Save/Delete form shortcuts below currently only work on Mac keyboards.",
    "shortcuts.group.anywhere": "Anywhere",
    "shortcuts.group.search": "Inside Search",
    "shortcuts.group.tally": "Tally Entry",
    "shortcuts.group.forms": "Product / Location Forms",
    "shortcuts.group.photos": "Photo Viewer",
    "shortcuts.group.calculator": "Calculator",
    "shortcuts.group.aiChat": "AI Chat",
    "shortcuts.globalSearch": "Open Global Search",
    "shortcuts.openSearch": "Open search",
    "shortcuts.calculator": "Open Calculator",
    "shortcuts.quickSearch": "Open Quick Search",
    "shortcuts.showShortcuts": "Show this list",
    "shortcuts.expandMenu": "Expand sidebar menu",
    "shortcuts.moveSelection": "Move selection up/down",
    "shortcuts.openSelected": "Open highlighted result",
    "shortcuts.closeSearch": "Close",
    "shortcuts.saveTally": "Save tally changes",
    "shortcuts.tallyEnter": "Next field / next row (adds a row at the end)",
    "shortcuts.tallyAddRowBelow": "Add a row below (Round tally)",
    "shortcuts.tallyStockPicker": "Pick from stock (flexible Square layout)",
    "shortcuts.tallyForceNext": "Move on without the value check (flexible Square layout: adds a row below)",
    "shortcuts.tallyMoveCells": "Move between cells",
    "shortcuts.saveForm": "Save (Mac only)",
    "shortcuts.deleteForm": "Delete, while editing (Mac only)",
    "shortcuts.prevNextPhoto": "Previous / next photo",
    "shortcuts.closePhoto": "Close photo viewer",
    "shortcuts.calcDigits": "Enter digits",
    "shortcuts.calcOperators": "Operators",
    "shortcuts.calcPercent": "Percent",
    "shortcuts.calcEquals": "Calculate",
    "shortcuts.calcBackspace": "Delete last digit",
    "shortcuts.calcClearOrClose": "Clear, then close",
    "shortcuts.aiChatSend": "Send message",
    "shortcuts.aiChatNewLine": "New line, without sending",
    "globalSearch.help.viewAllShortcuts": "View all keyboard shortcuts",
    "globalSearch.trigger": "Global Search",
    "unifiedSearch.trigger": "Search",
    "unifiedSearch.placeholder": "Search anything, or type a calculation…",
    "unifiedSearch.shortcutHint": "/",
    "unifiedSearch.mode.auto": "Auto",
    "unifiedSearch.mode.records": "Records",
    "unifiedSearch.mode.stock": "Stock",
    "unifiedSearch.mode.calculator": "Calculator",
    "unifiedSearch.autoInterpreting": "Searching as",
    "unifiedSearch.mathOpenHint": "tap or press enter to open calculator",
    "globalSearch.placeholder": "Search stock units, consignments, partners, products, sites, users…",
    "globalSearch.shortcutHint": "/",
    "globalSearch.searching": "Searching…",
    "globalSearch.noResults": "No matches found",
    "globalSearch.minChars": "Keep typing to search…",
    "globalSearch.category.transportUnit": "Stock Units",
    "globalSearch.category.shipment": "Consignments",
    "globalSearch.category.businessPartner": "Business Partners",
    "globalSearch.category.product": "Products",
    "globalSearch.category.loadingSite": "Locations",
    "globalSearch.category.user": "Users",
    "globalSearch.category.menuItem": "Pages",
    "globalSearch.askLinc.cta": "Ask Linc",
    "globalSearch.askLinc.subtitle": "Ask Linc about your records and stock",
    "globalSearch.calculatorTooltip": "Calculator",
    "globalSearch.mathOpenHint": "Tap to keep calculating",
    "globalSearch.help.toggleTooltip": "How to search",
    "globalSearch.help.intro": "Search across:",
    "globalSearch.help.shortcutText": "Press / anywhere to open this search. Type at least 2 characters — short codes work from 2, longer names match from 4.",
    "globalSearch.recentTitle": "Recent",
    "quickSearch.trigger": "Quick Search",
    "quickSearch.placeholder": "e.g. 4x3x7 teak ghana a",
    "quickSearch.fuzzyTooltip": "Fuzzy-matched — not an exact hit",
    "quickSearch.unrecognizedTooltip": "Not recognized as a species, origin, or grade — ignored",
    "quickSearch.recent": "Recent searches",
    "planLimit.dialogTitle": "Plan Limit Reached",
    "planLimit.dialogUsage": "You've used {used} of {limit} {feature}.",
    "planLimit.manageButton": "Manage {feature}",
    "planLimit.upgradeButton": "Upgrade Plan",
    "quickSearch.searching": "Searching...",
    "quickSearch.notFound": "No matches — try a different spelling or fewer details.",
    "quickSearch.availableNow": "Available now",
    "quickSearch.pendingStockIn": "Pending stock-in",
    "quickSearch.groups": "groups",
    "quickSearch.pcs": "pcs",
    "quickSearch.eta": "ETA",
    "quickSearch.details": "Purchasing details",
    "shipment.tuAllProducts": "All products in this unit",
    "quickSearch.invoiceAmount": "Invoice amount",
    "quickSearch.billNo": "Bill No",
    "quickSearch.billOfLadingNo": "Bill of Lading No",
    "quickSearch.viewConsignment": "View Consignment",
    "quickSearch.mixedConsignments": "Mixed — tap for breakdown",
    "quickSearch.noPurchasingInfo": "No purchasing info on file for this stock.",
    "quickSearch.calculator": "Calculator",
    "quickSearch.quickPrice": "Quick price",
    "quickSearch.pricePerCbm": "Price / CBM",
    "quickSearch.pricePerCft": "Price / CFT",
    "quickSearch.inProcess": "In a mill job",
    "quickSearch.didYouMean": "Did you mean",
    "quickSearch.arrivingSoon": "Arriving soon",
    "quickSearch.departingSoon": "Departing soon",
    "quickSearch.preparing": "Preparing",
    "quickSearch.hint": "Type a species, dimensions, origin, or quality — in any order.",
    "quickSearch.help.toggleTooltip": "How this works",
    "quickSearch.help.back": "Back to search",
    "quickSearch.help.basicsTitle": "The basics",
    "quickSearch.help.basicsText": "Mix species, size, origin, or quality in any order — nothing is required.",
    "quickSearch.help.sizesTitle": "Sizes",
    "quickSearch.help.sizesExactText": "Exact size, no words needed:",
    "quickSearch.help.sizesRangeText": "Or a range — add a comparator and a named measurement:",
    "quickSearch.help.sizesTypeText": "Plain numbers alone can be unclear — add \"square\" or \"round\" to say which:",
    "quickSearch.help.sizesAnyText": "Use \"?\" for a size you don't mind — \"4x3x?\" means 4x3, any length:",
    "quickSearch.help.speciesTitle": "Species, origin, quality",
    "quickSearch.help.speciesText": "Typos are fine — close matches are found automatically. A \"?\" mark means it was a guess, not exact.",
    "quickSearch.help.legendTitle": "What the result groups mean",
    "quickSearch.help.legendAvailable": "Available Now — ready to use today",
    "quickSearch.help.legendPending": "Pending Stock-In — tallied, not yet received into Inventory",
    "quickSearch.help.legendProcess": "In a mill job — being sawn or re-sawn right now",
    "quickSearch.help.legendArriving": "Arriving / Departing / Preparing — upcoming shipments",
    "quickSearch.help.aiTitle": "Ask AI",
    "quickSearch.help.aiText": "Struggling to phrase it? Ask AI understands messier, natural language. Uses AI credits (Forest plan) — regular search always stays free.",
    "commandCenter.title": "Command Center",
    "commandCenter.asOf": "As of",
    "commandCenter.offlineNoCopyTitle": "Not saved on this phone yet",
    "commandCenter.offlineNoCopyText": "Open Command Center once while online. After that, the last numbers are saved on this phone and you can see them offline.",
    "commandCenter.tab.overview": "Overview",
    "commandCenter.tab.inventory": "Inventory",
    "commandCenter.tab.floor": "Floor & Yield",
    "commandCenter.tab.money": "Money",
    "commandCenter.tab.consignments": "Consignments",
    "commandCenter.cons.arriving": "Arriving this week",
    "commandCenter.cons.leaving": "Leaving this week",
    "commandCenter.cons.preparing": "Being prepared",
    "commandCenter.cons.shipped": "Shipped this month",
    "commandCenter.cons.inShipment": "in shipment",
    "commandCenter.cons.arrives": "Arrives",
    "commandCenter.cons.departs": "Departs",
    "commandCenter.cons.all": "All consignments",
    "commandCenter.howSure": "How sure are the numbers",
    "commandCenter.counted": "counted",
    "commandCenter.notCountedYet": "Stock Units not counted yet",
    "commandCenter.reviewThem": "Review them",
    "commandCenter.allSizes": "All sizes",
    "commandCenter.allSites": "All sites",
    "commandCenter.btn.open": "Open",
    "commandCenter.btn.review": "Review",
    "commandCenter.btn.count": "Count",
    "commandCenter.btn.see": "See",
    "commandCenter.btn.assign": "Assign",
    "commandCenter.attn.noMachineOne": "Mill job {code} has no machine",
    "commandCenter.attn.noMachineMany": "{n} running mill jobs have no machine",
    "commandCenter.attn.holdsOne": "1 Stock Out holding wood for 60+ days",
    "commandCenter.attn.holdsMany": "{n} Stock Outs holding wood for 60+ days",
    "commandCenter.attn.holdsSub": "{cbm} m³ is blocked from sale",
    "commandCenter.tabShort.inventory": "Stock",
    "commandCenter.tabShort.floor": "Floor",
    "commandCenter.tabShort.consignments": "Loads",
    "commandCenter.confidence": "Confidence",
    "commandCenter.inventoryConfidence": "Inventory Confidence",
    "commandCenter.of": "of",
    "commandCenter.reconciledCopy": "stock units are reconciled",
    "commandCenter.reviewUnreconciled": "Review what's unreconciled",
    "commandCenter.stockOnHand": "Stock on hand",
    "commandCenter.machinesRunning": "Machines running",
    "commandCenter.owedToYou": "Owed to you",
    "commandCenter.thisWeek": "This week (out / in)",
    "commandCenter.thisWeekTitle": "This week",
    "commandCenter.split.out": "Out",
    "commandCenter.split.in": "In",
    "commandCenter.preparing": "preparing",
    "commandCenter.jobsWithoutMachine": "running without a machine",
    "commandCenter.needsAttention": "Needs Your Attention",
    "commandCenter.allClear": "All clear — nothing needs attention right now.",
    "commandCenter.stockAtGlance": "Stock at a Glance",
    "commandCenter.product": "Product",
    "commandCenter.site": "Site",
    "commandCenter.origin": "Origin",
    "commandCenter.quality": "Quality",
    "commandCenter.dims": "Dimensions",
    "commandCenter.available": "Available",
    "commandCenter.round": "Round",
    "commandCenter.viewAllGroups": "View all groups",
    "commandCenter.sortNewest": "Newest",
    "commandCenter.sortMostStock": "Most stock",
    "commandCenter.sortAz": "A–Z",
    "commandCenter.added": "Added",
    "commandCenter.showLess": "Show less",
    "commandCenter.rangeOf": "of",
    "commandCenter.conversionYield": "Yield by species",
    "commandCenter.avgOutturn": "Average outturn",
    "commandCenter.netVolume": "Net volume from mill jobs",
    "commandCenter.reconciliationStatus": "Reconciliation Status",
    "commandCenter.total": "Total",
    "commandCenter.reconciled": "Reconciled",
    "commandCenter.pending": "Pending",
    "commandCenter.locked": "Locked",
    "commandCenter.siteUtilisation": "Site Utilisation",
    "commandCenter.floorNow": "On the floor now",
    "commandCenter.operator": "Operator",
    "commandCenter.machine": "Machine",
    "commandCenter.location": "Location",
    "commandCenter.started": "Started",
    "commandCenter.status": "Status",
    "commandCenter.noActiveRuns": "No active mill jobs right now.",
    "commandCenter.toCollect": "To collect",
    "commandCenter.toPay": "To pay",
    "commandCenter.overdueToCollect": "Overdue to collect",
    "commandCenter.overdueToPay": "Overdue to pay",
    "commandCenter.overdueToCollectByAge": "Overdue to collect by age",
    "commandCenter.invoices": "invoices",
    "commandCenter.inTotal": "in total",
    "commandCenter.received": "Received",
    "commandCenter.paidOut": "Paid",
    "commandCenter.futureDated": "This payment date is in the future — please check it",
    "commandCenter.futureDatedShort": "future date",
    "commandCenter.last30Days": "(last 30 days)",
    "commandCenter.attn.overdueCollectOne": "1 invoice to collect is overdue",
    "commandCenter.attn.overdueCollectMany": "{n} invoices to collect are overdue",
    "commandCenter.attn.atRisk": "{amount} {cur} at risk",
    "commandCenter.attn.overduePayOne": "1 invoice you owe is past due",
    "commandCenter.attn.overduePayMany": "{n} invoices you owe are past due",
    "commandCenter.attn.toPaySub": "{amount} {cur} to pay",
    "commandCenter.attn.pendingReconOne": "1 stock unit still pending reconciliation",
    "commandCenter.attn.pendingReconMany": "{n} stock units still pending reconciliation",
    "commandCenter.attn.netDiscrepancy": "{v} CBM net discrepancy",
    "commandCenter.attn.tallySyncOne": "1 tally correction needs your decision",
    "commandCenter.attn.tallySyncMany": "{n} tally corrections need your decision",
    "commandCenter.attn.tallySyncSub": "Stock was not changed automatically — review in Inventory → In & Out",
    "tallySync.title": "Tally corrections waiting for you",
    "tallySync.subtitle": "A tally was changed after this stock was received. The stock was NOT changed automatically.",
    "tallySync.change": "Tally changed stock by",
    "tallySync.reasonNegative": "Would take the lot below zero, and your company does not allow selling past available stock (Application Settings → Inventory Policy).",
    "tallySync.reasonReconLocked": "The reconciliation is already locked, so the arrived (destination) figures now decide the stock.",
    "tallySync.reasonShipped": "This Stock Unit was already shipped.",
    "tallySync.reasonOther": "Needs a person to decide.",
    "tallySync.apply": "Apply to stock",
    "tallySync.dismiss": "Dismiss",
    "tallySync.appliedToast": "Stock updated",
    "tallySync.dismissedToast": "Tally correction dismissed — stock unchanged",
    "tallySync.actionFailed": "Could not complete",
    "tallySync.noPermission": "You don't have permission to change stock.",
    "commandCenter.attn.siteFull": "{name} is at {pct}% of capacity",
    "commandCenter.attn.siteSub": "{cur} of {cap} CBM",
    "commandCenter.attn.departingOne": "1 consignment departing this week",
    "commandCenter.attn.departingMany": "{n} consignments departing this week",
    "commandCenter.attn.soonest": "Soonest: {date}",
    "commandCenter.money.atSavedRates": "At saved exchange rates",
    "commandCenter.money.partial": "Partial",
    "commandCenter.money.partialTip": "Some amounts have no exchange rate, so they are not in this total",
    "commandCenter.money.noRate": "no rate",
    "commandCenter.money.noRateCountOne": "1 consignment has no exchange rate — not in the totals",
    "commandCenter.money.noRateCountMany": "{n} consignments have no exchange rate — not in the totals",
    "commandCenter.money.addRate": "Add rate",
    "commandCenter.money.unmatchedOne": "1 payment is in another currency with no rate — not counted",
    "commandCenter.money.unmatchedMany": "{n} payments are in another currency with no rate — not counted",
    "commandCenter.money.net": "Net position",
    "commandCenter.money.inFavour": "in your favour",
    "commandCenter.money.youOweMore": "you owe more",
    "commandCenter.money.overdueByAge": "Overdue by age",
    "commandCenter.money.nothingOverdue": "Nothing overdue",
    "commandCenter.money.overdueOne": "{amount} overdue · 1 invoice",
    "commandCenter.money.overdueMany": "{amount} overdue · {n} invoices",
    "commandCenter.money.invoiceOne": "1 invoice",
    "commandCenter.money.invoiceMany": "{n} invoices",
    "commandCenter.money.dueToday": "Due today",
    "commandCenter.money.dueTomorrow": "Tomorrow",
    "commandCenter.money.inDays": "in {n} days",
    "commandCenter.money.lateOne": "1 day late",
    "commandCenter.money.lateMany": "{n} days late",
    "commandCenter.notAssigned": "Not assigned",
    "commandCenter.notStarted": "Not started",
    "commandCenter.waiting": "Waiting",
    "commandCenter.days": "days",
    "commandCenter.openJob": "Open job",
    "commandCenter.moneyToday": "Money Today",
    "commandCenter.totalReceivable": "Total receivable",
    "commandCenter.totalPayable": "Total payable",
    "commandCenter.overdue": "Overdue",
    "commandCenter.overdueCount": "Overdue invoices",
    "commandCenter.recentPayments": "Recent payments",
    "commandCenter.noRecentPayments": "No recent payments.",
    "commandCenter.dueSoon": "Due soon",
    "commandCenter.noDueSoon": "Nothing due soon.",
    "commandCenter.consignmentRadar": "Next 7 days",
    "commandCenter.recentActivity": "Recent consignments",
    "commandCenter.tradeMix": "Trade Mix",
    "quickSearch.ai.toggle": "Ask AI",
    "quickSearch.ai.toggleTooltip": "Forest plan — understands messier phrasing than the regular search, costs AI credits per use",
    "quickSearch.ai.ask": "Ask AI",
    "quickSearch.ai.creditsUsedThisCall": "Credits used",
    "quickSearch.ai.used": "of your AI credits used",
    "quickSearch.ai.outOfCredits": "Out of AI credits for this period. The regular search still works with no credit cost.",
    "quickSearch.ai.rateLimited": "Daily AI usage limit reached. Try again tomorrow, or use the regular search.",
    "quickSearch.ai.forestOnly": "Ask AI is available on the Forest plan. The regular search still works.",
    "quickSearch.ai.genericError": "AI couldn't answer that — try the regular search instead.",
    "invProc.machineLabel": "Machine (optional)",
    "invProc.machinePlaceholder": "Select machine",
    "operator.name": "Name",
    "operator.employeeCode": "Employee Code",
    "operator.expertise": "Expertise",
    "operator.hireDate": "Hire Date",
    "operator.active": "Active",
    "operator.inactive": "Inactive",
    "operator.runsCompleted": "Mill Jobs Completed",
    "operator.avgOutturn": "Avg Outturn",
    "operator.bestOutturn": "Best Outturn",
    "operator.searchPlaceholder": "Search operators...",
    "operator.allExpertise": "All Expertise",
    "operator.allStatus": "All Status",
    "operator.statTotal": "Total",
    "operator.operatorSingular": "operator",
    "operator.operatorPlural": "operators",
    "operator.viewPerformance": "View Performance",
    "operator.performance": "Performance",
    "operator.deactivate": "Deactivate",
    "operator.noOperatorsFound": "No operators found",
    "operator.noOperatorsSub": "Adjust filters or add your first mill operator to get started.",
    "operator.editOperator": "Edit Operator",
    "operator.reactivate": "Reactivate",
    "operator.currentlyAssigned": "Currently Assigned",
    "operator.pending": "Pending",
    "operator.noTasks": "No tasks",
    "operator.viewFullHistory": "View Full History",
    "operator.fullHistory": "Full History",
    "operator.taskCode": "Task",
    "operator.materials": "Materials",
    "operator.processingDate": "Mill Job Date",
    "operator.outturn": "Outturn",
    "common.from": "From",
    "common.to": "To",
    // -- Lot card detail keys
    "lot.noOpenLots": "No open stock lots yet. Click Receive to add stock.",
    "lot.showMore": "Show more",
    "lot.showLess": "Show less",
    "lot.availableCbm": "available",
    // -- Stock Batches card source trace + "find a batch" search
    "lot.seeDeliveries": "See deliveries",
    "lot.seeConsignments": "See consignments",
    "lot.otherDeliveries": "Other deliveries",
    "lot.whereFrom": "See where this lot came from",
    "lot.madeAtMill": "Made at the mill",
    "lot.purchasedFrom": "Purchased from",
    "lot.category.millOutput": "Mill Output",
    "lot.category.openingStock": "Starting Stock",
    "lot.category.notLinked": "No Purchase on File",
    "lot.category.partiallyLinked": "Partially Linked",
    "lot.category.linked": "Linked to a Purchase",
    "lot.millActivity.queued": "Queued for Milling",
    "lot.millActivity.running": "At the Mill Now",
    "lot.millActivity.paused": "Paused",
    "lot.millActivity.partiallyMilled": "Partially Milled",
    "lot.cancelledAttemptsNote": "This lot has had {count} cancelled mill attempt(s).",
    "lot.viewCancelledAttempt": "View",
    "lot.filter.all": "All",
    "lot.filter.attention": "Needs Attention",
    "lot.filter.atMill": "At the Mill",
    "lot.filter.fromMill": "From the Mill",
    "lot.filter.finished": "Depleted",
    "lot.status.open": "Open",
    "lot.status.depleted": "Depleted",
    "lot.status.closed": "Closed",
    "lot.status.empty": "Empty",
    "lot.status.help": "Open — stock you can use · Empty — still open but nothing left in it · Depleted — all stock used (milled or sold) · Closed — closed by hand, no more activity",
    "lot.sort.label": "Sort",
    "lot.sort.newest": "Newest First",
    "lot.sort.oldest": "Oldest First",
    "lot.sort.name": "Name A-Z",
    "lot.sort.amountDesc": "Most Stock First",
    "lot.sort.amountAsc": "Least Stock First",
    "lot.category.notLinkedHelp": "This lot's delivery isn't linked to a recorded purchase. Normal for a domestic pickup logged without a formal purchase order — but check the delivery's Consignment field if you expected one.",
    "lot.category.partiallyLinkedHelp": "Some of this lot's deliveries are linked to a purchase, but at least one isn't.",
    "inv.millWarningHeader": "Check Before You Start",
    "mpc.title": "Check before you start",
    "mpc.checking": "Checking…",
    "mpc.notReconciled": "isn't reconciled yet.",
    "mpc.diff": "The unloading count shows",
    "mpc.noCount": "The unloading count hasn't been entered yet.",
    "mpc.alreadyConfirmed": "— milling without reconciling was already confirmed.",
    "mpc.closedWithoutCount": "was closed without an unloading count — what arrived was never checked.",
    "mpc.reconcileNow": "Reconcile now",
    "mpc.afterStart": "Once the mill job starts, the difference can only be recorded — stock is then corrected with an adjustment.",
    "mpc.typeConfirm": "Type CONFIRM to start without reconciling",
    "mpc.confirmHint": "One word — spaces at the ends are fine.",
    "mpc.confirmOk": "Confirmed — you can go on.",
    "recon.afterMill.title": "This Stock Unit wasn’t reconciled before milling.",
    "recon.afterMill.titleSold": "This Stock Unit wasn’t reconciled before stock was sold.",
    "recon.afterMill.cantApply": "already used this stock, so reconciling here can’t change stock any more. To set it right, correct the stock with an adjustment:",
    "recon.afterMill.pooledNote": "Tip: earlier mill jobs or sales have already used wood up to this Stock Unit, so your count is only recorded. Correct any difference with an adjustment.",
    "inv.smartSearch.label": "Find item",
    "legal.agree.prefix": "I agree to the",
    "legal.agree.terms": "Terms of Service",
    "legal.agree.and": "and",
    "legal.agree.privacy": "Privacy Policy",
    "legal.agree.required": "Please tick “I agree” to continue.",
    "inv.smartSearch.openStatement": "Open full statement for",
    "recon.afterMill.noCount": "No unloading count was entered — type the difference you found in the adjustment.",
    "recon.afterMill.step1": "Record what arrived: enter the unloading count below and lock as usual. This keeps supplier records and reports correct.",
    "recon.afterMill.step2": "Correct the stock: after locking, use “Correct with an adjustment” — it opens already filled in.",
    "recon.afterMill.recorded": "Difference recorded:",
    "recon.afterMill.correctBtn": "Correct with an adjustment",
    "recon.afterMill.askAdjust": "Ask someone with adjustment rights to correct the stock.",
    "recon.afterMill.lockRecordsOnly": "this lock records it only; correct stock afterwards with an adjustment.",
    "adj.negative.title": "This takes the lot below zero",
    "adj.negative.typeConfirm": "Type CONFIRM to post it anyway",
    "inv.millWarningNotLinked": "Lot {lotCode} doesn't have a purchase record linked to it. You can still start the Mill Job — link it to a purchase first if you have that information.",
    "inv.millWarningPartial": "Some of lot {lotCode}'s deliveries aren't linked to a purchase record. You can still start the Mill Job.",
    "inv.millWarningContinue": "Continue Anyway",
    "inventory.receiveNotLinkedWarning": "This delivery isn't linked to a purchase record (Consignment) yet.",
    "lot.unitNumber": "Container/Truck/Train No.",
    "origin.cameFrom": "Came from",
    "origin.stockUnitsWord": "Stock Units",
    "origin.blsWord": "BLs",
    "origin.order": "Order",
    "origin.via": "via",
    "origin.noStockUnit": "No Stock Unit — starting stock",
    "origin.returned": "Returned goods — no Stock Unit",
    "lot.loading": "Loading...",
    "lot.searchPlaceholder": "Search by ID",
    "lot.searchIncludeClosed": "Also search depleted lots",
    "lot.searchResultSingular": "lot found",
    "lot.searchResultPlural": "lots found",
    "lot.receivedCbm": "Received",
    "lot.purchasedCbm": "contracted",
    "lot.daysOld": "days old",
    "lot.procurementOutturn": "procurement outturn",
    "lot.openingBalance": "Opening balance",
    "lot.openingBalanceNote": "Prior stock — no purchase trail",
    // -- Receive wizard
    "receive.wizard.title": "Stock Arrived",
    "receive.wizard.editTitle": "Edit Stock Lot",
    "receive.step1.title": "What arrived and where from?",
    "receive.step2.title": "How much arrived?",
    "receive.step3.title": "How much did you receive?",
    "receive.step4.title": "Confirm receipt",
    "receive.selectSite": "Select storage site",
    "receive.selectSupplier": "Select supplier",
    "receive.quantity": "Received CBM",
    "receive.pieces": "Number of pieces",
    "receive.purchaseDate": "Purchase date",
    "receive.confirmed": "Record Stock In",
    "receive.moreDetails": "Add purchase details (optional)",
    "receive.isOpeningBalance": "This is prior stock (opening balance)",
    // -- Dispatch wizard
    "dispatch.wizard.title": "Send Stock Out",
    "dispatch.step1.title": "Which stock is going out?",
    "dispatch.step2.title": "Where is it going?",
    "dispatch.step3.title": "Dispatch details",
    "dispatch.step4.title": "Confirm dispatch",
    "dispatch.counterparty": "Customer / destination",
    "dispatch.reference": "Invoice / reference number",
    "dispatch.confirmed": "Confirm Send Out",
    "dispatch.destination": "Going to (buyer / destination)",
    "dispatch.linkTrade": "Link to Trade Record / Consignment (optional)",
    "dispatch.invoiceRef": "Invoice / order reference (optional)",
    "dispatch.actingAs": "Dispatching as",
    "dispatch.actingNow": "now",
    "dispatch.shipment": "Link to Consignment",
    "dispatch.shipment.placeholder": "Select consignment (optional)",
    "dispatch.stepSplit.title": "Confirm stock split",
    "dispatch.stepSplit.hint": "Oldest stock first — you can adjust the split below.",
    "dispatch.filters.toggle": "Filters (optional)",
    "dispatch.filters.product": "Product",
    "dispatch.filters.widthIn": "Width (in)",
    "dispatch.filters.thicknessIn": "Thickness (in)",
    "dispatch.filters.origin": "Origin",
    "dispatch.filters.quality": "Quality",
    "dispatch.roundLogs": "Round logs",
    "dispatch.unsorted": "Unsorted",
    "dispatch.qtyPlaceholder": "Quantity",
    "dispatch.noStock": "No matching stock found.",
    "dispatch.itemsAdded": "Items added",
    "dispatch.shortfall": "Short by",
    "dispatch.shortfallSuffix": "— add more lots or reduce quantity",
    "receive.origin": "Origin (country)",
    "receive.originPlaceholder": "e.g. Ghana, Brazil",
    "receive.quality": "Quality / grade",
    "receive.salePrice": "Sale price",
    "receive.size": "Size (Width × Thickness × Length)",
    "receive.lengthOpenEnded": "no max",
    "receive.lengthOpenEndedHint": "Leave the second length blank for open-ended (e.g. \"7ft+\").",
    "tally.qualityForTu": "Quality — all logs in this stock unit",
    "tally.qualityPerRow": "Per-row (set individually)",
    "tally.qualityForTuHint": "Leave blank to set quality per row in the grid.",
    "tally.qualityForTuHintRound": "Applies to all logs in this stock unit.",
    "tally.qualityNone": "No quality set",
    "tally.qualityNoneShort": "None",
    "tally.qualityEnableLabel": "Enable Quality for this Stock Unit",
    "tally.qualityDisabledHint": "Quality tracking is off for this stock unit. Existing quality data is kept and will reappear if you turn this back on.",
    "tally.qualityDisableConfirmTitle": "Disable Quality?",
    "tally.qualityDisableConfirmBodyPrefix": "This will permanently clear the Quality grade from",
    "tally.qualityDisableConfirmBodySuffix": "row(s) in this stock unit. This cannot be undone.",
    "tally.qualityDisableConfirmInputLabel": "Type CONFIRM to proceed",
    "tally.qualityDisableConfirmButton": "Disable & Clear Quality",
    "tally.qualityDisableCancelButton": "Cancel",
    "tally.qualityDisabledToastTitle": "Quality Disabled",
    "tally.qualityDisabledToastDetail": "Quality tracking has been turned off and cleared for this stock unit.",
    "tally.qualityDisableFailed": "Failed to disable Quality. Please try again.",
    "tally.saveNow": "Save Now",
    "tally.settingsSaving": "Saving…",
    "tally.settingsSaved": "Saved",
    "tally.settingsSaveFailedRetry": "Save failed — tap to retry",
    "tally.settingsAutoSaveFailed": "Couldn't save your settings changes. Please check your connection and try again.",
    "quality.renameGrades": "Rename grades",
    "quality.renameGradesTitle": "Quality Grade Labels",
    "quality.renameGradesHint": "These names appear everywhere quality is shown — old entries update automatically.",
    "chain.viewChain": "View Lot Chain",
    "trace.fullTrace": "Full Trace",
    "statement.title": "Stock Statement",
    "statement.subtitle": "Proof of what came in, went to the mill, was sold and is still in stock",
    "statement.openStatement": "Stock Statement",
    "statement.unit": "Volume unit",
    "statement.exportPdf": "PDF",
    "statement.exportExcel": "Excel",
    "statement.searchPlaceholder": "Stock Unit, container / truck no., lot, mill job or BL number",
    "statement.suggest.recent": "Recent",
    "statement.suggest.stockUnits": "Stock Units",
    "statement.suggest.batches": "Lots",
    "statement.suggest.millJobs": "Mill jobs",
    "statement.suggest.consignments": "Consignments (BL)",
    "statement.suggest.none": "No match - try a Stock Unit, container / truck no., lot, mill job or BL number",
    "statement.show": "Show statement",
    "statement.emptyTitle": "Prove any stock in one place",
    "statement.emptyText": "Type a Stock Unit, container, lot, mill job or BL number. You get the balance sheet, mill wastage, every entry and whether it matches the lot records.",
    "statement.notFound": "Nothing found for that code",
    "statement.notFoundHint": "Check the spelling, or try the Stock Unit ID, container number, LOT-…, PR-… or BL number.",
    "statement.generated": "Generated",
    "statement.balanced": "Balanced",
    "statement.balancedSub": "Every lot matches its record and stock in equals stock out",
    "statement.difference": "Difference found",
    "statement.differenceSub": "A lot does not match its record — see the lot marked in red",
    "statement.balanceSheet": "Balance sheet",
    "statement.inSide": "Stock in",
    "statement.outSide": "Stock out and left",
    "statement.totalIn": "Total in",
    "statement.totalOut": "Total out and left",
    "statement.opening": "Starting stock",
    "statement.received": "Received",
    "statement.producedOutside": "Produced from other lots",
    "statement.adjustedNet": "Adjustments (net)",
    "statement.allowanceNet": "Allowance (girth & length)",
    "statement.story": "What happened, step by step",
    "statement.storySub": "In date order, in plain words",
    "statement.step.startingStock": "Starting stock",
    "statement.step.cameIn": "Came in",
    "statement.step.allowance": "Allowance taken off (bark and trim)",
    "statement.step.sentToMill": "Sent to mill",
    "statement.step.millMade": "Mill made",
    "statement.step.sold": "Sold and gone out",
    "statement.step.correction": "Correction",
    "statement.step.heldForSale": "Held for a sale — not gone out yet",
    "statement.step.heldForJob": "Held for a mill job — not started yet",
    "statement.step.stillInStock": "Still in stock",
    "statement.storyMillSentence": "The mill used {in} and made {out}. {loss} was sawdust and offcuts ({pct}%).",
    "statement.storyNothingSold": "Nothing has been sold yet.",
    "statement.storyHeldSentence": "{pieces} pieces are booked for {code} and will leave stock when that sale is confirmed.",
    "statement.storySoldSentence": "{cbm} has gone out to customers.",
    "statement.allowance": "Allowance",
    "statement.allowanceHint": "Bark and trim deducted from the measured logs — gross measure minus net measure.",
    "statement.kind.ALLOWANCE": "Allowance",
    "statement.sold": "Sold / dispatched",
    "statement.sentToMillOutside": "Sent to mill (output not in this statement)",
    "statement.sentToMillShort": "Sent to mill",
    "statement.wastage": "Mill wastage",
    "statement.closing": "Still in stock",
    "statement.held": "Held",
    "statement.free": "Free",
    "statement.heldPartOf": "of",
    "statement.heldRestOther": "rest on other Lots",
    "stockInHand.title": "Stock in Hand",
    "stockInHand.subtitle": "What is really in stock now — held and free, by product and size",
    "stockInHand.inStock": "In stock",
    "stockInHand.held": "Held",
    "stockInHand.free": "Free",
    "stockInHand.overHeld": "Over-held",
    "stockInHand.overHeldHint": "Some Stock Outs or mill jobs hold more wood than their batch contains. Open the old drafts and release or finish them.",
    "stockInHand.negativeStock": "Negative stock",
    "stockInHand.negativeStockHint": "A count or sale took more than a batch held, so its balance is below zero. Open the batch and correct it with an Adjustment (add what is missing).",
    "stockInHand.explain": "In stock = Held + Free. Held is kept for open Stock Outs and Mill Jobs; Free can still be sold or milled. Net volume.",
    "stockInHand.searchPlaceholder": "Search product, size (4x3x6), origin, site or Lot",
    "stockInHand.rows": "rows",
    "stockInHand.groupBy": "Group by product",
    "stockInHand.expandAll": "Expand all",
    "stockInHand.collapseAll": "Collapse all",
    "stockInHand.sizeOne": "size",
    "stockInHand.sizeMany": "sizes",
    "stockInHand.sortBy": "Sort",
    "stockInHand.sortDefault": "Default order",
    "stockInHand.sortFree": "Free: high to low",
    "stockInHand.sortIn": "In stock: high to low",
    "stockInHand.sortSize": "Size",
    "stockInHand.sortProduct": "Product A–Z",
    "stockInHand.searchShort": "Search product or size",
    "stockInHand.howCounted": "How is this counted?",
    "stockInHand.hideHow": "Hide",
    "stockInHand.splitTitle": "Held vs free",
    "stockInHand.product": "Product",
    "stockInHand.size": "Size",
    "stockInHand.site": "Site",
    "stockInHand.lot": "Lot",
    "stockInHand.lots": "Lots",
    "stockInHand.round": "Round logs",
    "stockInHand.tipIn": "All the wood physically on hand, whether or not it is kept for something.",
    "stockInHand.tipHeld": "Part of the stock kept for open Stock Outs and Mill Jobs. It is still yours and can still be sold or milled.",
    "stockInHand.tipFree": "In stock minus Held: what is available right now for a new sale or Mill Job.",
    "stockInHand.roundPcs": "Round",
    "stockInHand.squarePcs": "Square",
    "stockInHand.logsUnit": "logs",
    "stockInHand.openStatement": "Stock Statement",
    "stockInHand.holdsTitle": "Held by open Stock Outs",
    "stockInHand.holdsHint": "Wood promised to Stock Outs that are not confirmed yet. Release a forgotten one to free its wood.",
    "stockInHand.holdsShowAll": "Show all",
    "stockInHand.holdsShowFewer": "Show fewer",
    "stockInHand.idleToday": "Idle today",
    "stockInHand.idleDays": "Idle {n} d",
    "stockInHand.release": "Release",
    "stockInHand.releaseSure": "Release its holds?",
    "stockInHand.releaseYes": "Yes, release",
    "stockInHand.released": "Holds released — it holds again when someone opens or saves that Stock Out.",
    "stockInHand.releaseFailed": "Could not release the holds — try again.",
    "stockInHand.openUnit": "Open this Stock Out",
    "stockInHand.empty": "No stock in hand yet",
    "stockInHand.noMatch": "Nothing matches this search",
    "stockInHand.failed": "Could not load stock",
    "stockInHand.footnote": "Rows list sizes with free stock. Held per row = open Stock Outs at that exact size; Mill Job holds are already taken off Free and counted in the Held total at the top.",
    "statement.whereItWent": "Where the stock went",
    "statement.millJobs": "Mill jobs",
    "statement.outturn": "Outturn",
    "statement.input": "In",
    "statement.output": "Out",
    "statement.jobPartial": "Only one side of this job is in this statement, so its wastage is not counted here.",
    "statement.batches": "Lots",
    "statement.producedBy": "Produced by",
    "statement.fromBatch": "from",
    "statement.matchesRecord": "Matches record",
    "statement.differenceShort": "Difference",
    "statement.negativeStock": "Negative stock",
    "statement.negativeStockTooltip": "This lot's own stock number is below zero — likely a correction (Reconciliation or Adjustment) was entered without accounting for stock already sent to the mill or sold. Please double check.",
    "statement.produced": "Produced",
    "statement.milled": "To mill",
    "statement.adjusted": "Adjusted",
    "statement.pcs": "pcs",
    "statement.batchRecord": "Lot record",
    "statement.differenceBy": "difference",
    "statement.notInStockTitle": "Not in stock now",
    "statement.notInStockLeft": "It left stock through confirmed Stock Outs:",
    "statement.notInStockNone": "No lot holds this now, and no confirmed Stock Out of it was found.",
    "statement.diffPanelTitle": "Where, how much and why",
    "statement.diffPanelWhyBtn": "Why? What to do?",
    "statement.diffPanelHide": "Hide",
    "statement.diffPanelRecord": "Lot record",
    "statement.diffPanelMoves": "movements add up to",
    "statement.diffPanelWhyLabel": "Why:",
    "statement.diffPanelWhy": "The saved number of the lot and the total of its own movements were changed separately — for example a change made outside the normal screens, or a movement that was not recorded.",
    "statement.diffPanelDoLabel": "What to do:",
    "statement.diffPanelDo": "Open the lot and check its movements. Correct it with Add Adjustment so the record and the history agree again. Do not edit the number directly.",
    "statement.heldForSale": "Held for sale",
    "statement.heldForJob": "Held for mill job",
    "statement.showEntries": "Show entries",
    "statement.hideEntries": "Hide entries",
    "statement.when": "Date & time",
    "statement.entry": "Entry",
    "statement.reference": "Reference",
    "statement.partner": "Partner",
    "statement.noEntries": "No ledger entries.",
    "statement.timeline": "Timeline",
    "statement.proof": "Built from inventory ledger entries:",
    "statement.netVolume": "volumes are net",
    "statement.piecesIndicative": "some entries have no piece count, so piece totals are indicative",
    "statement.type.STOCK_UNIT": "Stock Unit",
    "statement.type.BATCH": "Lot",
    "statement.type.MILL_JOB": "Mill Job",
    "statement.type.CONSIGNMENT": "Consignment",
    "statement.kind.OPENING": "Starting stock",
    "statement.kind.RECEIVED": "Received",
    "statement.kind.PRODUCED": "Produced by mill",
    "statement.kind.MILLED": "Sent to mill",
    "statement.kind.SOLD": "Sold / dispatched",
    "statement.kind.ADJUSTED": "Adjusted",
    "statement.kind.RECONCILED": "Reconciled",
    "statement.kind.ASSIGNED": "Added to consignment",
    "statement.kind.OTHER": "Other",
    "statement.modeItem": "One item",
    "statement.modeFilter": "Filter stock",
    "statement.filterProduct": "Product",
    "statement.filterOrigin": "Origin",
    "statement.filterSite": "Site",
    "statement.filterQuality": "Quality",
    "statement.filterSize": "Size (any unit)",
    "statement.sizePlaceholder": "3x2x8 ft · 76 x 50 mm · girth 90cm x 8m",
    "statement.sizeInvalid": "Size not understood — try 3x2x8 ft, 76 x 50 mm or girth 90cm",
    "statement.filterFrom": "From",
    "statement.filterTo": "To",
    "statement.filterHint": "Leave a field empty for any. No dates = from the beginning up to now.",
    "statement.any": "Any",
    "statement.clear": "Clear",
    "statement.emptyFilterText": "Pick any filters and press Show statement — or press it with no filters for all stock.",
    "statement.noResults": "No stock matches these filters",
    "statement.noResultsHint": "Remove a filter or widen the dates.",
    "statement.type.FILTER": "Filtered stock",
    "statement.periodStatement": "Period statement",
    "statement.periodStatementSub": "Closing figures are as of the end date; stock in equals stock out",
    "statement.groups": "Stock groups",
    "statement.group": "Product · origin · site",
    "statement.batchesLower": "lots",
    "statement.inShort": "In",
    "statement.sizeNow": "This size now",
    "statement.total": "Total",
    "statement.inventoryReportLink": "Stock Statement",
    "trace.seeWhereFrom": "See where this came from",
    "trace.rel.includesStockUnit": "Includes Stock Unit",
    "trace.rel.linkedToConsignment": "Linked to Consignment",
    "trace.rel.receivedInto": "Received into",
    "trace.rel.dispatchedFrom": "Dispatched from",
    "trace.rel.fedAsInput": "Fed as input to",
    "trace.rel.drewStockFrom": "Drew stock from",
    "trace.rel.receivedIntoLot": "Received into this Lot",
    "trace.rel.producedByJob": "Produced by Mill Job",
    "trace.rel.milledInto": "Milled into",
    "trace.rel.soldVia": "Sold via",
    "trace.rel.sentOutUnlinked": "Sent out (unlinked)",
    "trace.rel.fedFromLot": "Fed from Lot",
    "trace.rel.fedFromUnit": "Fed from Stock Unit",
    "trace.rel.mainOutput": "Main output",
    "trace.rel.byproduct": "Byproduct output",
    "trace.date.created": "Created",
    "trace.date.shipped": "Shipped",
    "trace.date.purchased": "Purchased",
    "trace.date.produced": "Produced",
    "trace.date.completed": "Completed",
    "trace.date.started": "Started",
    "trace.date.scheduled": "Scheduled",
    "trace.date.openingStock": "Opening stock",
    "trace.story.showMore": "Show more",
    "trace.story.sharesNote": "This split is a calculation (oldest stock first), not a recorded fact.",
    "trace.share.adjustment": "Wood from an adjustment",
    "trace.share.hand": "Lot entered by hand",
    "trace.label.printAll": "Print labels for all Stock Units",
    "trace.label.popup": "Allow pop-ups to print the labels.",
    "trace.unlinked.one": "Not yet linked to a sale",
    "trace.unlinked.many": "{n} dispatches not yet linked to a sale",
    "trace.search.placeholder": "Search a container, BL, Stock Unit, Lot or Mill Job…",
    "trace.search.none": "Nothing found",
    "trace.search.hintTitle": "Trace any number",
    "trace.search.hintSub": "Type a container number, BL, Stock Unit, Lot or Mill Job above to see its whole story.",
    "trace.view.story": "Story",
    "trace.view.graph": "Graph",
    "trace.story.cameFrom": "Where it came from",
    "trace.story.wentTo": "Where it went",
    "trace.story.nothingBefore": "Nothing before this. The story starts here.",
    "trace.story.nothingAfter": "Nothing after this yet.",
    "trace.story.truncated": "Very long chain: only the nearest steps are shown. Open a step to go further.",
    "trace.story.madeFrom": "Made from",
    "trace.story.couldNot": "Could not load the story. Please try again.",
    "trace.kind.stockUnit": "Stock Unit",
    "trace.kind.lot": "Lot",
    "trace.kind.millJob": "Mill Job",
    "trace.kind.consignment": "Consignment",
    "trace.kind.sentOut": "Sent out",
    "trace.label.print": "Print label",
    "trace.label.title": "Stock Unit label",
    "trace.label.printBtn": "Print",
    "trace.label.scan": "Scan to see the whole story of this wood",
    "trace.label.scanSub": "Where it came from, what the mill made of it, and where it went.",
    "trace.couldNotLoad": "Could not load this trace",
    "trace.pickAncestorTitle": "Which one?",
    "trace.pickAncestorHint": "This came from more than one purchase — pick one to explore.",
    "trace.history": "History",
    "trace.noHistory": "No history recorded yet",
    "trace.consignment": "Consignment",
    "trace.viewConsignment": "View Consignment",
    "trace.viewDispatches": "View dispatches",
    "trace.quickView": "Quick view",
    "trace.loadingTrace": "Loading...",
    "trace.zoomIn": "Zoom in",
    "trace.zoomOut": "Zoom out",
    "trace.zoomReset": "Reset zoom",
    "trace.viewLot": "View Lot",
    "trace.viewRun": "View Mill Job",
    "lot.lotCode": "Lot Code",
    "lot.quality": "Quality",
    "lot.received": "Received",
    "lot.currentStock": "Current Stock",
    "lot.supplier": "Supplier",
    "lot.purchasePrice": "Purchase Price",
    "lot.purchaseDate": "Purchase Date",
    "processing.millSite": "Mill Site",
    "processing.machine": "Machine",
    "processing.operator": "Operator",
    "processing.input": "Input",
    "processing.output": "Output",
    "processing.outturn": "Outturn",
    "chain.sourceLot": "Source Lot",
    "chain.rootLot": "Original Source",
    "chain.earlierLot": "Earlier Lot",
    "chain.thisLot": "This Lot",
    "chain.outputLot": "Output Lot",
    "chain.recovery": "recovery",
    "chain.received": "received",
    "chain.remaining": "available",
    "chain.dispatches": "Dispatched",
    "chain.directDispatch": "Direct Dispatch",
    "chain.noChain": "No upstream or downstream links for this lot yet.",
    "chain.finished": "Finished",
    "inventory.viewTask": "View Task",
    "inventory.created": "Created",
    "inventory.lastUpdated": "Last Updated",
    "inventory.by": "by",
    "inventory.viewOrder": "View Order",
    "inventory.viewInTallysheet": "View in Tallysheet",
    // -- Manage users
    "user.invite": "Invite User",
    "user.sendInvite": "Send Invite",
    "user.teamMembers": "Team Members",
    "user.accessRights": "Access Rights",
    "user.deactivateTooltip": "Deactivate — blocks login, data preserved",
    "user.reactivateTooltip": "Reactivate — restore login access",
    "user.resendInvitation": "Resend invitation",
    "user.block": "Block",
    "user.unblock": "Unblock",
    "user.blockTooltip": "Block user — login disabled, data preserved",
    "user.unblockTooltip": "Unblock user — restore login access",
    "user.revokeInvitation": "Revoke invitation",
    "user.deleteExpiredInvitation": "Delete expired invitation",
    "user.deleteInvitation": "Delete invitation",
    "user.revoked": "Revoked",
    "user.invitationResentTitle": "Invitation resent",
    "user.invitationResentMessage": "Invitation resent to {{email}}.",
    "user.invitationResendFailed": "Could not resend invitation.",
    "user.confirmBlockTitle": "Block user?",
    "user.confirmBlockMessage": "{{email}} will be blocked and will not be able to login anymore.",
    "user.confirmUnblockTitle": "Unblock user?",
    "user.confirmUnblockMessage": "{{email}} will be able to login again.",
    "user.blockedSuccessTitle": "User blocked",
    "user.blockedSuccessMessage": "{{email}} has been blocked and can no longer login.",
    "user.blockedFailedMessage": "Could not block user.",
    "user.unblockedSuccessTitle": "User unblocked",
    "user.unblockedSuccessMessage": "{{email}} can now login again.",
    "user.unblockedFailedMessage": "Could not unblock user.",
    "user.confirmRevokeInvitationTitle": "Revoke invitation?",
    "user.confirmRevokeInvitationMessage": "{{email}} will no longer be able to use this invitation link.",
    "user.confirmDeleteInvitationTitle": "Delete invitation?",
    "user.confirmDeleteInvitationMessage": "The invitation for {{email}} will be permanently deleted.",
    "user.invitationRevokedTitle": "Invitation revoked",
    "user.invitationRevokedMessage": "The invitation for {{email}} has been revoked.",
    "user.invitationRevokeFailed": "Could not revoke invitation.",
    "user.invitationDeletedTitle": "Invitation deleted",
    "user.invitationDeletedMessage": "The invitation for {{email}} has been deleted.",
    "user.invitationDeleteFailed": "Could not delete invitation.",
    "user.actionNotAllowedTitle": "Action not allowed",
    "user.pendingRevokeOnly": "Pending invitations can only be revoked.",
    "user.expiredDeleteOnly": "Expired invitations can only be deleted.",
    "user.onlyExpiredOrRevokedDelete": "Only expired or revoked invitations can be deleted.",
    "user.expired": "Expired",
    "user.declined": "Declined",
    "user.declinedTooltip": "The invitee declined this invite in-app — the email link is still valid if they change their mind",
    "user.membershipBasedTooltip": "Member via multi-company access — their own account lives elsewhere. You can remove their membership in this company, but their account itself is managed on their side.",
    "user.removeFromCompany": "Remove from company",
    "user.confirmRemoveMemberTitle": "Remove Member",
    "user.confirmRemoveMemberMessage": "{{email}} will lose access to this company. Their own account and any other companies they belong to are unaffected.",
    "user.memberRemovedTitle": "Member removed",
    "user.memberRemovedMessage": "{{email}} no longer has access to this company.",
    "user.memberRemoveFailedMessage": "Failed to remove member.",
    "user.removeAdminBtn": "Remove Admin",
    "user.confirmMakeAdminTitle": "Make Admin",
    "user.confirmMakeAdminMessage": "{{email}} will get full admin access to this company, including managing users. You can remove it later.",
    "user.madeAdminTitle": "Admin added",
    "user.madeAdminMessage": "{{email}} is now an admin.",
    "user.makeAdminFailedMessage": "Could not make this user an admin.",
    "user.confirmRemoveAdminTitle": "Remove Admin",
    "user.confirmRemoveAdminMessage": "{{email}} will stay in the company as a regular member but will lose admin access.",
    "user.removedAdminTitle": "Admin removed",
    "user.removedAdminMessage": "{{email}} is now a regular member.",
    "user.removeAdminFailedMessage": "Could not remove admin rights.",
    "user.emailAddresses": "Email Addresses",
    "user.roleTemplate": "Role Template",
    "user.roleTemplatePlaceholder": "Select a role template",
    "user.inviteDialogHeader": "Invite User",
    "user.upgradeToAdd": "User limit reached — upgrade your plan",
    "plan.featureNotAvailable": "This feature is not available on your current plan.",
    "plan.availableOnGroveAndAbove": "Available on Tree and above. Upgrade to unlock.",
    "plan.upgradeNow": "Upgrade Plan",
    // -- User delete
    "user.deleteUser": "Delete user",
    "user.confirmDeleteTitle": "⚠ Delete User — This Cannot Be Undone",
    "user.deleteWarning1": "All active sessions for this user will be revoked immediately.",
    "user.deleteWarning2": "All data created by this user (tallies, consignments, stock units) will remain, with authorship shown as \"Deleted User\".",
    "user.deleteWarning3": "After 30 days, all personal information (name, email, phone) will be anonymised and cannot be recovered.",
    "user.deleteWarning4": "THIS ACTION IS PERMANENT AND CANNOT BE UNDONE.",
    "user.deleteEmailConfirmLabel": "Type the user's email address to confirm deletion",
    "user.deleteEmailConfirmPlaceholder": "Type email to confirm",
    "user.deleteEmailMismatch": "Email does not match. You must type exactly: {{email}}",
    "user.deletedSuccessTitle": "User permanently deleted",
    "user.deletedSuccessMessage": "{{email}} has been deleted and all sessions have been revoked.",
    "user.deletedFailedMessage": "Could not delete user. Please try again.",
    "user.cannotDeleteNoAdmin": "Cannot delete this user. At least one owner or admin must remain in the company.",
    // -- Self-delete
    "user.selfDeleteTitle": "Delete My Account",
    "user.selfDeleteSubtitle": "Permanently delete your personal account and all associated data.",
    "user.selfDeleteWarning": "This will immediately revoke ALL your active sessions and permanently delete your account.\n\n• All data you created (tallies, consignments, stock units) will remain in the system, with authorship shown as \"Deleted User\".\n• After 30 days your personal details (name, email, phone) will be anonymised and cannot be recovered.\n• Your email address will be released and can be used to create a new account.\n\nThis action CANNOT be undone. There is no recovery option.",
    "user.selfDeleteEmailConfirm": "Type your email address to confirm",
    "user.selfDeleteEmailPlaceholder": "Type your email to confirm",
    "user.selfDeleteButton": "Delete My Account",
    "user.selfDeleteSuccess": "Your account has been deleted. You have been logged out.",
    "user.selfDeleteFailed": "Could not delete your account. Please try again.",
    "user.soleAdminWarningTitle": "You Are the Only Admin",
    "user.soleAdminWarningBody": "Deleting your account will permanently shut down your company workspace. All users will be immediately logged out and will lose access to LumberLinq.",
    "user.soleAdminAffectedLabel": "Users who will lose access",
    "user.soleAdminReassignHint": "Strongly recommended: assign admin rights to another user before deleting your account.",
    "user.soleAdminReassignButton": "Assign Admin First",
    "user.soleAdminDeleteAnyway": "Delete Anyway & Shut Down",
    "user.soleAdminShutdownWarning": "This will immediately log out all company users and cancel the subscription.",
    "user.soleAdminShutdownSuccess": "Your account has been deleted. All company users have been logged out and the subscription has been terminated.",
    "user.assignAdminStepTitle": "Assign New Admin",
    "user.assignAdminSubtitle": "Select a team member to take over as administrator before you leave.",
    "user.makeAdminBtn": "Make Admin",
    "user.adminAssignedSuccess": "Admin rights transferred. You can now delete your account.",
    "user.continueToDelete": "Continue to Delete Account",
    "user.shutdownConsentLabel": "I understand that all users will be immediately logged out, the company workspace will be shut down, and the subscription will expire.",
    "user.deleteAndShutdown": "Delete & Shut Down Company",
    "user.noOtherUsers": "There are no other active users to assign admin rights to.",
    "user.promotingAdmin": "Assigning admin…",
    "user.notificationPreferencesTitle": "Notification Preferences",
    "user.marketingPushOptInLabel": "Marketing notifications",
    "user.marketingPushOptInDescription": "Get notified about new features and offers.",
    "user.dangerZoneTitle": "Danger Zone",
    "user.dangerZoneSubtitle": "Irreversible and destructive actions.",
    // -- Auth flows
    "auth.sendResetLink": "Send Reset Link",
    "auth.backToLogin": "Back to Login",
    "auth.resetPassword": "Reset Password",
    "auth.createMyAccount": "Create My Account",
    "auth.iAcceptClose": "I Accept & Close",
    "auth.tryDifferentEmail": "Try a different email",
    "auth.sessionExpired": "Session Expired",
    "auth.sessionExpiredMessage": "Your session has ended for security reasons. Please sign in again to continue where you left off.",
    "auth.confirmLogout": "Confirm Logout",
    "auth.logoutConfirmMessage": "Are you sure you want to logout?",
    "auth.logoutSuccess": "Logout Successful",
    "auth.logoutSuccessMsg": "You have been successfully logged out.",
    "auth.logoutFailed": "Logout failed",
    "auth.logoutFailedMsg": "Error while logging out",
    "confirmLogoutDevices.header": "Already signed in elsewhere",
    "confirmLogoutDevices.questionWithDevice": "Log out from that device and continue signing in here?",
    "confirmLogoutDevices.messageGeneric": "Log out from it and continue signing in here?",
    "confirmLogoutDevices.openApp": "Open LumberLinq",
    "confirmLogoutDevices.openAppTitle": "You are signed in",
    "confirmLogoutDevices.openAppHint": "Tap the button to go back to the app.",
    "confirmLogoutDevices.messageWithDevicePrefix": "You are currently logged in on ",
    "confirmLogoutDevices.messageWithDeviceNear": " near ",
    "confirmLogoutDevices.messageWithDeviceSuffix": ". Are you sure you want to log out from that device and log in here instead?",
    "confirmLogoutDevices.acceptLabel": "Cancel",
    "confirmLogoutDevices.rejectLabel": "Log out & continue",
    "forcedLogout.header": "Signed Out",
    "forcedLogout.bodyGeneric": "You were signed out because your account signed in from another device.",
    "forcedLogout.explanation": "This session was signed out because your account just signed in from another device:",
    "forcedLogout.goToLogin": "Go to Login",
    // -- Layout
    "layout.copyCompanyId": "Copy Company ID",
    "layout.productTour": "Product Tour",
    // -- Loading site documents
    "siteDocs.uploadDialogHeader": "Upload Documents",
    "siteDocs.upload": "Upload",
    "siteDocs.downloadFile": "Download File",
    "siteDocs.changeCategory": "Click to change category",
    // -- RBAC settings
    "rbac.enableAcl": "Enable Access Control",
    "rbac.disableAcl": "Disable Access Control",
    "rbac.title": "Access Control",
    "rbac.subtitle": "Control exactly what each user can see and do in LumberLinq.",
    "rbac.perUserStatus": "Per-User Access Control is",
    "rbac.enabled": "ENABLED",
    "rbac.disabled": "DISABLED",
    "rbac.disabledDesc": "When disabled, all users have full access to everything. Enable to assign granular permissions per person.",
    "rbac.enabledDesc": "Active — permissions are enforced in real time. Revoking a permission takes effect on the user's next API call.",
    "rbac.userPermissions": "User Permissions",
    "rbac.configureHint": "Click the configure button to assign or revoke permissions for each user.",
    "rbac.permissions": "Permissions",
    "rbac.lastModified": "Last Modified",
    "rbac.noPermissions": "No permissions — user cannot access anything",
    "rbac.noUsers": "No non-admin users found.",
    "rbac.notActiveTitle": "Access Control is not active",
    "rbac.notActiveDesc": "When enabled, you can assign exactly which features each user can access.",
    "rbac.notActiveDesc2": "Existing behaviour is fully preserved until you enable this.",
    "rbac.disableFullAccess": "All users will immediately regain full access to everything.",
    "rbac.disablePreserved": "Your existing permission configurations are preserved — they will reactivate automatically if you re-enable Access Control.",
    "rbac.configureTooltip": "Assign / revoke permissions",
    // -- Onboarding
    "onboarding.welcome": "Welcome to Lumberlinq",
    // -- Admin / root module
    "admin.packages": "Packages",
    "admin.subscriptionPackages": "Subscription Packages",
    "admin.packageListSubtitle": "Manage plans, pricing and feature sets visible to customers",
    "admin.totalPlans": "Total Plans",
    "admin.trialPlans": "Trial Plans",
    "admin.featured": "Featured",
    "admin.trial": "Trial",
    "admin.mostPopular": "Most Popular",
    "admin.perMonth": "/mo",
    "admin.free": "Free",
    "admin.dayTrialSuffix": "d trial",
    "admin.features": "features",
    "admin.extendable": "Extendable",
    "admin.noPackagesYet": "No packages yet",
    "admin.createFirstSubscriptionPackage": "Create your first subscription package to get started.",
    "admin.coupons": "Coupons",
    "admin.taxConfig": "Tax Config",
    "admin.companySupport": "Company Support",
    "admin.tickets": "Tickets",
    "admin.appSettings": "App Settings",
    "admin.dashboard": "Admin Dashboard",
    "admin.newPackage": "New Package",
    "admin.savePackage": "Save Package",
    "admin.createPackage": "Create Package",
    "admin.editPackage": "Edit Package",
    "admin.deactivate": "Deactivate",
    "admin.activate": "Activate",
    "admin.addFeature": "Add Feature",
    "admin.newCoupon": "New Coupon",
    "admin.saveCoupon": "Save Coupon",
    "admin.newTaxRule": "New Tax Rule",
    "admin.addFirstRule": "Add First Rule",
    "admin.extendSubscription": "Extend Subscription",
    "admin.extend": "Extend",
    "admin.suspend": "Suspend",
    "admin.reactivate": "Reactivate",
    "admin.printReport": "Print Report",
    "admin.support": "Support",
    "admin.resolveAll": "Resolve All",
    "admin.closeAll": "Close All",
    "admin.assignAll": "Assign All",
    "admin.inProgress": "In Progress",
    "admin.awaitingUser": "Awaiting User",
    "admin.resolve": "Resolve",
    "admin.saveChanges": "Save Changes",
    "admin.resetFilters": "Reset filters",
    "admin.clearSelection": "Clear selection",
    "admin.openSupportDashboard": "Open Support Dashboard",
    "admin.hideFromListings": "Hide from subscription listings",
    "admin.makeVisible": "Make visible again",
    "admin.overview": "Overview",
    "admin.ticketDetails": "Ticket Details",
    "admin.companyContext": "Company Context",
    "admin.activityTrail": "Activity Trail",
    "admin.valueExtracted": "Value Extracted in This Period",
    "admin.featureUsageBreakdown": "Feature Usage Breakdown",
    "admin.salesNarrative": "Sales Narrative",
    "admin.loginTrend": "Login Trend (Weekly)",
    "admin.extendSubscriptionDialog": "Extend Subscription",
    "admin.editPackageTooltip": "Edit package details, pricing and features",
    "admin.autoGenerateKey": "Auto-generate key from name",
    "admin.inactivePackagesTooltip": "Inactive packages are hidden from the public pricing page",
    "admin.trialPackagesTooltip": "Trial packages are free and time-limited. The pricing section is hidden for trial plans.",
    "admin.removeAttachment": "Remove attachment",
    "admin.suspendAccount": "Suspend Account",
    "admin.reactivateAccount": "Reactivate Account",
    "admin.unitLabelTooltip": "Unit label shown next to the number (e.g. GB, users, tallies). Leave blank for boolean features.",
    "admin.allowTrialExtension": "Allow super-admins to extend the trial for individual companies",
    "admin.maxTrialExtensions": "Maximum number of times the trial can be extended per company",
    "admin.descriptionTooltip": "Optional rich text description. Rendered as HTML inside the plan card. Leave blank if not needed.",
    "admin.trialNoPricing": "Trial plans have no pricing",
    "admin.discountedPriceTooltip": "The discounted price customers actually pay per month in INR",
    "admin.originalPriceTooltip": "The original price shown with a strikethrough to show savings",
    "admin.discountedMonthlyUsd": "Discounted monthly price in USD",
    "admin.totalYearlyUsd": "Total yearly price at a discount in USD",
    "admin.displayOrder": "Display order on pricing card",
    "admin.editFeature": "Edit feature",
    "admin.deleteFeature": "Delete feature",
    // -- Field access
    "fieldAccess.resetTooltip": "Reset all to defaults",
    "fieldAccess.resetLabel": "Reset to Defaults",
    "fieldAccess.confirmResetTitle": "Reset to LumberLinq Defaults?",
    "fieldAccess.confirmResetMessage": "This will discard all your custom Public, Protected, and Private access settings for every field and restore LumberLinq's default configuration. This cannot be undone.",
    // -- App Usage Report
    "appUsage.planSubscription": "Plan & Subscription",
    "appUsage.title": "App Usage Report",
    "appUsage.desc": "Live view of your feature usage vs. plan limits. Upgrade before you hit a ceiling.",
    "appUsage.failedToLoad": "Failed to load usage data.",
    "appUsage.validTill": "Valid Till",
    "appUsage.timeRemaining": "Time Remaining",
    "appUsage.nearLimit": "Near Limit",
    "appUsage.featureUsage": "Feature Usage",
    "appUsage.aiCredits": "AI Import Credits",
    "appUsage.aiCreditsOf": "of",
    "appUsage.aiCreditsPageCredits": "page credits",
    "appUsage.featureAccess": "Feature Access",
    "appUsage.active": "Active",
    "appUsage.inactive": "Inactive",
    "appUsage.expiredOn": "Expired on",
    "report.users.title": "Users Report",
    "report.users.subtitle": "All users registered under your organisation",
    "report.users.admins": "Admins",
    "report.users.role": "Role",
    "report.users.type": "Type",
    "report.users.timezone": "Timezone",
    "report.users.joined": "Joined",
    "report.users.noUsersFound": "No users found",
    // -- Stock Unit form placeholders & validation
    "tallysheet.searchProduct": "Search Product",
    "tallysheet.searchLoadingSite": "Search Location",
    "tallysheet.tuIdRequired": "Transport ID is required.",
    "tallysheet.tuIdDuplicate": "This Transport ID already exists.",
    "tallysheet.tuMinLength": "Minimum 5 characters.",
    "tallysheet.productRequired": "Product is required.",
    "tallysheet.modeRequired": "Mode is required.",
    "tallysheet.containerNumRequired": "Container Number is required.",
    "tallysheet.vehicleNumRequired": "Vehicle Number is required.",
    "tallysheet.driverNameRequired": "Driver Name is required.",
    "tallysheet.expectedDeliveryRequired": "Expected Delivery is required.",
    "tallysheet.expectedArrivalRequired": "Expected Arrival is required.",
    "tallysheet.expectedPickupRequired": "Expected Pickup Time is required.",
    "tallysheet.pickupLocRequired": "Pickup Location is required.",
    "tallysheet.carNumRequired": "Car Number is required.",
    // -- Additional menu items
    "menu.usersReport": "Users Report",
    "menu.inventoryReport": "Inventory Report",
    // -- Location list subtitle
    "loadingSite.subtitle": "View and manage existing location profiles",
    // -- Inventory Report page
    "invReport.available": "Available",
    "invReport.openLots": "Open Lots (Available)",
    "invReport.lots": "lots",
    "invReport.reserved": "reserved",
    "invReport.inProcessing": "In a mill job",
    "invReport.inShipment": "In Consignment",
    "invReport.shippedMonth": "Shipped (Month)",
    "invReport.cbmThisMonth": "CBM this month",
    "invReport.stockByStage": "Stock by Stage",
    "invReport.movementsByType": "Movements by Type",
    "invReport.stockBySite": "Stock by Site",
    "invReport.movementLog": "Movement Log",
    "invReport.adjustments": "Adjustments",
    "invReport.processingRuns": "Mill Jobs",
    "invReport.filterByType": "Filter by type",
    "invReport.colType": "Type",
    "invReport.colTransportUnit": "Stock Unit",
    "invReport.colSite": "Site",
    "invReport.colReference": "Reference",
    "invReport.colPartner": "Partner",
    "invReport.colDate": "Date",
    "invReport.colRunCode": "Mill Job ID",
    "invReport.colMillSite": "Mill Site",
    "invReport.colInputCbm": "Input CBM",
    "invReport.colOutputCbm": "Output CBM",
    "invReport.colLossCbm": "Loss CBM",
    "invReport.colOutturn": "Outturn %",
    "invReport.colCbmDelta": "CBM Δ",
    "invReport.colPcsDelta": "Pcs Δ",
    "invReport.colNotes": "Notes",
    "invReport.noMovements": "No movements found for the selected filters.",
    "invReport.noProcessingRuns": "No mill jobs found.",
    "invReport.adjustmentsInfo": "Adjustments are manual CBM/piece corrections applied to existing inventory records. Showing adjustments within the selected date range.",
    "invReport.noAdjustments": "No adjustments recorded in this period.",
    "invReport.noStageData": "No stage data",
    "invReport.noMovementsRange": "No movements in range",
    "invReport.noSiteStockData": "No site stock data",
    "invReport.pendingCustomMadeTooltip": "Stock Units waiting on a Custom-Made / re-saw request",
    // -- Business Partner form extras
    "business.activateDeactivate": "Activate / Deactivate Business Partner",
    "business.partnerActiveHint": "Partner is active and visible in transactions",
    "business.partnerInactiveHint": "Partner is inactive and hidden from new transactions",
    "business.contactInfo": "Contact Information",
    "business.addressSection": "Address",
    "business.attachments": "Attachments",
    "business.dropFiles": "Drop files here or click to browse",
    "business.saveFirst": "Save the partner first to attach files",
    "business.maxPerFile": "per file",
    "business.uploadedFiles": "Uploaded Files",
    "business.removeAccount": "Remove account",
    "business.ifscSwift": "IFSC / SWIFT",
    "business.noBankAccounts": "No bank accounts added yet. Click to add one.",
    "business.backToList": "Back to list",
    "business.minCharsRequired": "Min 2 characters required.",
    "business.validGstin": "Enter a valid GSTIN.",
    "business.taxIdMin3Chars": "Tax ID must be at least 3 characters.",
    "business.gstin": "GSTIN",
    "business.quickAdd": "Add new business partner",
    "business.quickAddTitle": "New Business Partner",
    "business.quickAddedDetail": "Business partner created and selected.",
    "business.quickAddError": "Could not create the business partner. Please try again.",
    "business.validEmail": "Valid email required.",
    "business.countryRequired": "Country is required.",
    "business.selectCountryFirst": "Select country first",
    "business.selectStateFirst": "Select state first",
    "common.max": "Max",
    "common.min": "Min",
    "common.company": "Company",
    "chart.histogram": "Histogram",
    "chart.scatter": "Scatter",
    "chart.line": "Line",
    // -- Cookie consent (GDPR-compliant)
    "cookie.reject": "Reject Non-Essential",
    "cookie.manage": "Manage",
    "cookie.acceptAll": "Accept All",
    "cookie.savePreferences": "Save Preferences",
    "cookie.preferences": "Cookie & Privacy Preferences",
    "cookie.title": "We use cookies 🍪",
    "cookie.desc": "We use cookies to keep you signed in and improve your experience. Analytics cookies require your consent.",
    "cookie.gdprNote": "In accordance with GDPR / CCPA, we only activate Analytics cookies with your explicit consent. See our Privacy Policy for full details.",
    "cookie.titleApp": "We use analytics 📊",
    "cookie.descApp": "This app uses analytics to keep you signed in and improve your experience. Analytics require your consent.",
    "cookie.gdprNoteApp": "In accordance with GDPR / CCPA, we only activate Analytics with your explicit consent. See our Privacy Policy for full details.",
    "cookie.privacyLink": "Privacy Policy",
    "cookie.essential": "Essential (Always On)",
    "cookie.essentialDesc": "Required for login, session security, and saved preferences. Retention: session + 7-day refresh token. Cannot be disabled.",
    "cookie.alwaysOn": "Always On",
    "cookie.functional": "Functional",
    "cookie.functionalDesc": "Remembers your language, theme, and font size preferences across sessions. Retention: 1 year. Cannot be disabled.",
    "cookie.analytics": "Analytics (Google Analytics)",
    "cookie.analyticsDesc": "We use Google Analytics (GA4) to understand feature usage and improve the product. Google may collect your IP address, approximate location (city-level), device type, and browsing behaviour within this app. This data is processed by Google LLC under their Privacy Policy (policies.google.com). No personal data is sold. Retention: 90 days (our data) / 14 months (GA default). You can opt out at any time by disabling this toggle or via Google's opt-out browser add-on.",
    "cookie.dataController": "Data Controller: Rikexim Private Limited · Data Processor: Google LLC (Google Analytics)",
    // -- Terms & misc
    "common.termsConditions": "Terms & Conditions",
    "common.acceptContinue": "Accept & Continue",
    // -- Tallysheet Insights section
    "tallysheet.insights": "Tallysheet Insights",
    "tallysheet.totalVolume": "Total Volume",
    "tallysheet.avgVolume": "Average Volume",
    "tallysheet.activeFilter": "Active Filter",
    "tallysheet.clearFilter": "Clear Filter",
    "tallysheet.totalCft": "Total CFT",
    "tallysheet.aggregated": "Aggregated",
    "tallysheet.mainVisualization": "Main Visualization",
    "tallysheet.girthVsVolume": "Girth vs Volume",
    "tallysheet.lengthDistribution": "Length Distribution",
    "tallysheet.girthHistogram": "Girth Histogram Table",
    "tallysheet.lengthHistogram": "Length Histogram Table",
    "tallysheet.metric": "Metric",
    "tallysheet.inProcessTooltip": "This stock is being used by an active mill job right now.",
    "tallysheet.notInStock": "Not In Stock",
    "tallysheet.notInStockTooltip": "This stock unit hasn't been received into inventory yet.",
    "tallysheet.noSummary": "No Summary Available",
    "tallysheet.addDataForInsights": "Add tally data first to generate insights and visualizations.",
    "tallysheet.dynamicAnalytics": "Dynamic Analytics — Length · Girth · Volume",
    "tallysheet.exploreTrends": "Explore trends across",
    "tallysheet.optimizedRecords": "optimized records",
    "tallysheet.clickRangesToFilter": "Click ranges to filter",
    "tallysheet.bins": "bins",
    // -- Stock Unit field labels
    "tallysheet.vehicleNumber": "Vehicle Number",
    "tallysheet.driverName": "Driver Name",
    "tallysheet.enterDriverName": "Enter Driver Name",
    "tallysheet.containerNumber": "Container Number",
    "tallysheet.sealNumber": "Seal Number",
    "tallysheet.fumigationType": "Fumigation Type",
    "tallysheet.selectFumigationType": "Select a Fumigation Type",
    "fumigation.methylBromide": "Methyl Bromide Fumigation",
    "fumigation.phosphine": "Phosphine Fumigation",
    "fumigation.sulfurylFluoride": "Sulfuryl Fluoride Fumigation",
    "fumigation.ethyleneOxide": "Ethylene Oxide Fumigation",
    "fumigation.heatTreatment": "Heat Treatment",
    "fumigation.controlledAtmosphere": "Controlled Atmosphere (CA) Fumigation",
    "fumigation.vacuum": "Vacuum Fumigation",
    "fumigation.other": "Other",
    "tallysheet.carNumber": "Car Number",
    "tallysheet.railwayLine": "Railway Line",
    "tallysheet.selectDate": "Select Date",
    "tallysheet.selectDateTime": "Select Date & Time",
    "tallysheet.expectedArrival": "Expected Arrival",
    "tallysheet.pickupLocation": "Pickup Location",
    // -- Business Partner dropdown options
    "bp.buyer": "Buyer",
    "bp.seller": "Seller",
    "bp.both": "Both",
    "bp.company": "Company",
    "bp.individual": "Individual",
    "bp.exporter": "Exporter",
    "bp.importer": "Importer",
    "bp.domestic": "Domestic",
    "bp.international": "International",
    // -- Dashboard chart trade type labels
    "dash.domesticSale": "Domestic Sale",
    // -- Loading site
    "loading-site.selectSiteType": "Select site type",
    // -- Reconciliation
    "recon.locked": "Reconciliation Locked",
    "recon.lockedBy": "Reconciliation locked by",
    // -- Field Access pages
    "fieldAccess.accessControl": "Access Control",
    "fieldAccess.tallyTitle": "Stock Unit Field Access",
    "fieldAccess.shipmentTitle": "Consignment Field Access",
    "fieldAccess.searchPlaceholder": "Search fields…",
    "fieldAccess.pubLegend": "Anyone with the link",
    "fieldAccess.proLegend": "LumberLinq users only",
    "fieldAccess.priLegend": "My team only",
    "fieldAccess.mode.PUBLIC": "Anyone with the link",
    "fieldAccess.mode.PROTECTED": "LumberLinq users only",
    "fieldAccess.mode.PRIVATE": "My team only",
    "access.hint.PUBLIC": "No sign-in needed",
    "access.hint.PROTECTED": "Signed in to LumberLinq, any company",
    "access.hint.PRIVATE": "Only people in your company",
    "fieldAccess.privateAlways": "Your company — always sees every field",
    "fieldAccess.hidden": "Hidden",
    "fieldAccess.view": "View",
    "fieldAccess.alwaysVisible": "Always visible",
    "fieldAccess.alwaysVisibleHint": "This column is always shown on shared links. It cannot be hidden.",
    "fieldAccess.history": "History",
    "fieldAccess.historyTitle": "Who changed what",
    "fieldAccess.historyEmpty": "No changes recorded yet.",
    "fieldAccess.historyFailed": "Could not load the history.",
    "fieldAccess.historyWhen": "When",
    "fieldAccess.historyWho": "Who",
    "fieldAccess.historyField": "Field",
    "fieldAccess.historyMode": "Link type",
    "fieldAccess.historyChange": "Change",
    "fieldAccess.historyReset": "Reset to defaults",
    "fieldAccess.historyNote": "Shows the last 200 changes. Changes made before this list existed are not shown.",
    "fieldAccess.preview": "Preview as visitor",
    "fieldAccess.previewTitle": "What a visitor sees",
    "fieldAccess.previewHint": "Based on the settings on this screen. Crossed-out fields are hidden from this kind of visitor.",
    "fieldAccess.previewVisibleCount": "fields visible",
    "fieldAccess.previewSectionOff": "This whole section is switched off.",
    "fieldAccess.presets": "Presets",
    "fieldAccess.presetsTitle": "Apply a preset",
    "fieldAccess.presetsLead": "Start from a ready-made set instead of switching fields one by one. You see what changes before anything is saved. Money, tax and audit fields, and the supplier and buyer, are never switched on by a preset.",
    "fieldAccess.presetMinimal": "Public (minimal)",
    "fieldAccess.presetMinimalHint": "Status, route and quantities only. Safe for anyone with the link.",
    "fieldAccess.presetBuyer": "Buyer",
    "fieldAccess.presetBuyerHint": "Adds documents, parties and transport details a buyer needs.",
    "fieldAccess.presetAgent": "Agent",
    "fieldAccess.presetAgentHint": "Adds contacts, locations and tally details for a forwarding agent.",
    "fieldAccess.presetApplyTo": "Apply to",
    "fieldAccess.presetApply": "Apply preset",
    "fieldAccess.presetNoChange": "This preset changes nothing for the chosen link type.",
    "fieldAccess.presetWillShow": "{count} field(s) will be shown:",
    "fieldAccess.presetWillHide": "{count} field(s) will be hidden:",
    "fieldAccess.presetPublicWarning": "Careful: {count} field(s) will become visible to anyone with the link, without logging in.",
    "fieldAccess.publicWarnTitle": "Show to everyone?",
    "fieldAccess.publicWarnMessage": "Anyone with the link, without logging in, will see \"{field}\". Continue?",
    "fieldAccess.publicWarnAccept": "Yes, show it",
    "tallysheet.tu.hiddenDetails": "Some details are not shared on this link.",
    "tallysheet.exportDownloadOff": "Export (download off)",
    "tallysheet.exportDownloadOffHint": "The sender has not allowed downloads on this link.",
    "sharePack.button": "Download pack",
    "sharePack.title": "Download pack",
    "sharePack.lead": "Everything this link carries, in one ZIP: summary PDF, Excel workbook, documents and photos.",
    "sharePack.loading": "Checking what is inside…",
    "sharePack.partSummary": "Summary PDF",
    "sharePack.partSummaryHint": "An overview to read and print",
    "sharePack.partWorkbook": "Excel workbook",
    "sharePack.partWorkbookHint": "Every figure, ready to filter",
    "sharePack.partDocuments": "Documents",
    "sharePack.partDocumentsHint": "{count} file(s) · {size}",
    "sharePack.partPhotos": "Photos",
    "sharePack.partPhotosHint": "{count} photo(s) · {size}",
    "sharePack.noneInside": "There is nothing to download on this link.",
    "sharePack.snapshotNote": "A snapshot of today. Later changes by the sender are not included.",
    "sharePack.stockUnits": "{count} Stock Unit(s)",
    "sharePack.start": "Download",
    "sharePack.preparing": "Preparing your pack. A large pack can take a minute.",
    "sharePack.downloading": "Downloading {percent}%",
    "sharePack.done": "Your pack has been downloaded.",
    "sharePack.failed": "The pack could not be downloaded.",
    "sharePack.busy": "The server is busy building other packs. Please try again in a minute.",
    "sharePack.pickOne": "Choose at least one part.",
    "sharePack.close": "Close",
    "sharePack.reconciliationField": "Reconciliation figures in the Download pack (loaded vs received)",
    "fileCounts.ownTitle": "Consignment documents",
    "fileCounts.ofTypes": "{have} of {total} types",
    "fileCounts.missing": "missing",
    "fileCounts.unitsTitle": "Stock Units ({count})",
    "fileCounts.photos": "photos",
    "fileCounts.files": "files",
    "fileCounts.unitTitle": "Files of this Stock Unit",
    "fileCounts.noFiles": "No files yet.",
    "fileCounts.tipOwn": "{count} consignment file(s)",
    "fileCounts.tipUnits": "Stock Units: {photos} photo(s), {files} file(s)",
    "fileCounts.typeBL": "BL",
    "fileCounts.typeInvoice": "Invoice",
    "fileCounts.typeCO": "Certificate of Origin",
    "fileCounts.typePhyto": "Phytosanitary",
    "fileCounts.typeEWaybill": "E-Waybill",
    "fileCounts.typeOther": "Other",
    "fieldAccess.viewOnly": "View Only",
    "fieldAccess.edit": "Edit",
    "fieldAccess.editable": "Editable",
    "fieldAccess.loading": "Loading field configuration…",
    "fieldAccess.fields": "fields",
    "fieldAccess.stockUnitsNote": "Stock Unit details on a share link are set in Stock Unit Field Access, not here.",
    "fieldAccess.fieldColumn": "Field",
    "fieldAccess.noMatch": "No fields match your search.",
    "fieldAccess.group.transportUnit": "Stock Unit",
    "fieldAccess.group.roundTallyGrid": "Round Tally Grid",
    "fieldAccess.group.squareTallyGrid": "Square Tally Grid",
    "fieldAccess.group.photosSummary": "Photos & Summary",
    "fieldAccess.group.shipmentDetails": "Consignment Details",
    "fieldAccess.group.documentDetails": "Document Details",
    "fieldAccess.group.transportCargo": "Transport / Cargo",
    "fieldAccess.group.financials": "Financials",
    "fieldAccess.group.parties": "Parties",
    "fieldAccess.group.systemAudit": "System / Audit",
    "fieldAccess.field.transportId": "Transport ID",
    "fieldAccess.field.transportMode": "Transport Mode",
    "fieldAccess.field.unitVehicleNumber": "Unit / Vehicle Number",
    "fieldAccess.field.fumigation": "Fumigation",
    "fieldAccess.field.driver": "Driver",
    "fieldAccess.field.route": "Route",
    "fieldAccess.field.contactPerson": "Contact Person",
    "fieldAccess.field.expectedDelivery": "Expected Delivery / Pickup",
    "fieldAccess.field.sr": "Sr",
    "fieldAccess.field.length": "Length",
    "fieldAccess.field.girth": "Girth",
    "fieldAccess.field.lengthAllowance": "Length Allowance",
    "fieldAccess.field.girthAllowance": "Girth Allowance",
    "fieldAccess.field.netLength": "Net Length",
    "fieldAccess.field.netGirth": "Net Girth",
    "fieldAccess.field.grossCbm": "Gross CBM",
    "fieldAccess.field.grossCft": "Gross CFT",
    "fieldAccess.field.netCbm": "Net CBM",
    "fieldAccess.field.netCft": "Net CFT",
    "fieldAccess.field.width": "Width",
    "fieldAccess.field.thickness": "Thickness",
    "fieldAccess.field.pieces": "Pieces",
    "fieldAccess.field.widthAllowance": "Width Allowance",
    "fieldAccess.field.thicknessAllowance": "Thickness Allowance",
    "fieldAccess.field.netWidth": "Net Width",
    "fieldAccess.field.netThickness": "Net Thickness",
    "fieldAccess.field.photosDocuments": "Photos / Documents",
    "fieldAccess.field.summary": "Summary",
    "fieldAccess.field.chartData": "Chart Data",
    "fieldAccess.field.lengthHistogram": "Length Histogram",
    "fieldAccess.field.girthHistogram": "Girth Histogram",
    "fieldAccess.field.sawnSquareSummary": "Sawn Square Summary",
    "fieldAccess.field.modeOfTransportFmt": "Mode Of Transport",
    "fieldAccess.field.portOfLoadingFmt": "Port Of Loading",
    "fieldAccess.field.portOfDischargeFmt": "Port Of Discharge",
    "fieldAccess.field.blNumberFmt": "Bl Number",
    "fieldAccess.field.blType": "Bl Type",
    "fieldAccess.field.packingListNo": "Packing List No",
    "fieldAccess.field.commercialInvoiceNo": "Commercial Invoice No",
    "fieldAccess.field.certificateOfOrigin": "Certificate Of Origin",
    "fieldAccess.field.fumigationCertificate": "Fumigation Certificate",
    "fieldAccess.field.insuranceDetails": "Insurance Details",
    "fieldAccess.field.approvedBy": "Approved By",
    "fieldAccess.field.buyerTaxNumber": "Buyer Tax Number",
    "fieldAccess.field.createdBy": "Created By",
    "fieldAccess.field.deliveryContact": "Delivery Contact",
    "fieldAccess.field.transporterName": "Transporter Name",
    "fieldAccess.field.vehicleOrLrNo": "Vehicle or LR No.",
    "fieldAccess.field.transportUnitNumber": "Stock Unit Number",
    "fieldAccess.field.insuranceValue": "Insurance Value",
    "fieldAccess.field.cargoType": "Cargo Type",
    "fieldAccess.field.grossWeight": "Gross Weight",
    "fieldAccess.field.netWeight": "Net Weight",
    "fieldAccess.field.transportUnits": "Stock Units",
    "fieldAccess.field.freightTerms": "Freight Terms",
    "fieldAccess.field.totalInvoiceAmount": "Total Invoice Amount",
    "fieldAccess.field.salesPaymentStatus": "Sales Payment Status",
    "fieldAccess.field.purchasePaymentStatus": "Purchase Payment Status",
    "fieldAccess.field.notifyParty": "Notify Party",
    "fieldAccess.field.exporterRefNo": "Exporter Ref No",
    "fieldAccess.field.buyerOrderNo": "Buyer Order No",
    "fieldAccess.field.countryOfOrigin": "Country Of Origin",
    "fieldAccess.field.countryOfDestination": "Country Of Destination",
    "fieldAccess.field.fromLocation": "From Location",
    "fieldAccess.field.toLocation": "To Location",
    "fieldAccess.field.remarks": "Remarks",
    "fieldAccess.field.vesselOrFlight": "Vessel Or Flight",
    "fieldAccess.field.voyageOrFlightNo": "Voyage Or Flight No",
    "fieldAccess.field.shippingLine": "Shipping Line",
    // -- Manage Users page
    "user.member": "Member",
    "user.role": "Role",
    "user.login": "Login",
    "user.lastActive": "Last Active",
    "user.totalMembers": "Total Members",
    "user.pendingInvites": "Pending Invites",
    "user.pendingInvitations": "Pending Invitations",
    "user.invitedBy": "Invited by",
    "user.noTeamMembers": "No team members yet",
    "user.inviteToStart": "Click Invite User to get started.",
    "user.statusPending": "Pending",
    "user.expires": "Expires",
    "user.role.owner": "Owner",
    "user.role.user": "User",
    "user.role.fieldOperator": "Field Operator — Tally add & view only",
    "user.role.supervisor": "Supervisor — Tally + Consignments + Export",
    "user.role.analyst": "Analyst — View & export everything, no edits",
    "user.role.manager": "Manager — All features except user management",
    "user.role.custom": "Custom — No permissions (configure manually)",
    // -- Shipment form raw string labels
    "shipment.shipmentType": "Consignment Type",
    "shipment.modeOfTransport": "Mode of Transport",
    "shipment.shipmentDate": "Consignment Date",
    "shipment.finalDestination": "Final Destination",
    "shipment.estimatedDeparture": "Estimated Departure",
    "shipment.estimatedArrival": "Estimated Arrival",
    "shipment.partiesReferences": "Parties &amp; References",
    "shipment.documentNumbers": "Document Numbers",
    "shipment.invoicePayments": "Invoice &amp; Payments",
    "shipment.auditStatus": "Audit &amp; Status",
    "shipment.goodsDispatchLocal": "Goods / Dispatch (Local)",
    "shipment.shipmentTypeRequired": "Consignment Type is required",
    "shipment.modeOfTransportRequired": "Mode of Transport is required",
    "shipment.estimatedDepartureRequired": "Estimated Departure is required",
    "shipment.otherDocuments": "Other Documents",
    // -- Transport mode groups
    "transport.group.regularSizedCargo": "Regular Sized Cargo",
    "transport.group.reeferContainer": "Reefer Container",
    "transport.group.oddSizedContainer": "Odd Sized Container",
    "transport.group.truck": "Truck",
    "transport.group.trailer": "Trailer",
    "transport.group.train": "Train",
    "transport.group.other": "Other",
    // -- Transport mode items
    "transport.item.20DryStandard": "20 Dry Standard",
    "transport.item.40DryStandard": "40 Dry Standard",
    "transport.item.40DryHigh": "40 Dry High",
    "transport.item.45DryHigh": "45 Dry High",
    "transport.item.20Tank": "20 Tank",
    "transport.item.40Tank": "40 Tank",
    "transport.item.20ReeferStandard": "20 Reefer Standard",
    "transport.item.40ReeferHigh": "40 Reefer High",
    "transport.item.20OpenTop": "20 Open Top",
    "transport.item.40OpenTop": "40 Open Top",
    "transport.item.40OpenTopHigh": "40 Open Top High",
    "transport.item.40FlatStandard": "40 Flat Standard",
    "transport.item.40FlatHigh": "40 Flat High",
    "transport.item.20Flat": "20 Flat",
    "transport.item.smallTruck": "Small Truck",
    "transport.item.mediumTruck": "Medium Truck",
    "transport.item.largeTruck": "Large Truck",
    "transport.item.articulatedTruck": "Articulated Truck",
    "transport.item.flatbedTrailer": "Flatbed Trailer",
    "transport.item.dryVanTrailer": "Dry Van Trailer",
    "transport.item.reeferTrailer": "Reefer Trailer",
    "transport.item.lowboyTrailer": "Lowboy Trailer",
    "transport.item.tankerTrailer": "Tanker Trailer",
    "transport.item.boxcar": "Boxcar",
    "transport.item.flatcar": "Flatcar",
    "transport.item.tankCar": "Tank Car",
    "transport.item.reeferCar": "Reefer Car",
    "transport.item.hopperCar": "Hopper Car",
    "transport.item.selfPickup": "Self Pickup",
    "BOTH": "BOTH",
    "COMPANY": "COMPANY",
    "Invoice Details": "Invoice Details",
    "Freight Terms": "Freight Terms",
    "Payment Terms": "Payment Terms",
    "Customer Payment Terms": "Customer Payment Terms",
    "Supplier Payment Terms": "Supplier Payment Terms",
    "Select terms...": "Select terms...",
    "Save the shipment first to record payments and payment terms.": "Save the consignment first to record payments and payment terms.",
    "At least one of Shipper, Consignee or Notify Party must be your company. Based on shipment type, your company may be auto-filled and locked.": "At least one of Shipper, Consignee or Notify Party must be your company. Based on consignment type, your company may be auto-filled and locked.",
    "Manage shipment details, parties, documents &amp; financials": "Manage consignment details, parties, documents &amp; financials",
    "Financials &amp; Payments": "Financials &amp; Payments",
    "Invoice &amp; Payments": "Invoice &amp; Payments",
    "Immediate / Advance": "Immediate / Advance",
    "Cash on Delivery (COD)": "Cash on Delivery (COD)",
    "L/C – Sight": "L/C – Sight",
    "L/C – Usance (days)": "L/C – Usance (days)",
    "DP – Documents against Payment (days)": "DP – Documents against Payment (days)",
    "DA – Documents against Acceptance (days)": "DA – Documents against Acceptance (days)",
    "Open Account (days)": "Open Account (days)",
    "Net 7 Days": "Net 7 Days",
    "Net 15 Days": "Net 15 Days",
    "Net 30 Days": "Net 30 Days",
    "Net 45 Days": "Net 45 Days",
    "Net 60 Days": "Net 60 Days",
    "Net 90 Days": "Net 90 Days",
    "Other (Custom)": "Other (Custom)",
    "Timezone": "Timezone",
    "Your Timezone": "Your Timezone",
    "Select timezone": "Select timezone",
    "Timestamps throughout the app will display in this timezone.": "Timestamps throughout the app will display in this timezone.",
    "Asia/Kolkata (IST, UTC+5:30)": "Asia/Kolkata (IST, UTC+5:30)",
    "Trial": "Trial",
    "Trial 7 days": "Trial 7 days",
    "Subscription expired. Limited access": "Subscription expired. Limited access",
    "Transaction History": "Transaction History",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "Transaction ID": "Transaction ID",
    "Choose Your Plan": "Choose Your Plan",
    "Select the plan that best fits your needs": "Select the plan that best fits your needs",
    "Company Profile": "Company Profile",
    "Your Company Profile": "Your Company Profile",
    "Company Profile Management": "Company Profile Management",
    "Registering as an individual": "Registering as an individual",
    "Set up company identity, address, and operating profile": "Set up company identity, address, and operating profile",
    "Legal Entity Type": "Legal Entity Type",
    "Select Legal Entity of Company": "Select Legal Entity of Company",
    "Private Limited": "Private Limited",
    "Public Limited": "Public Limited",
    "Partnership": "Partnership",
    "Proprietorship": "Proprietorship",
    "Corporation (Inc)": "Corporation (Inc)",
    "LLP": "LLP",
    "LLC": "LLC",
    "Branding": "Branding",
    "Brand Identity": "Brand Identity",
    "Use a direct image URL. The default RIK Exim logo is used when this field is empty.": "Use a direct image URL. The default RIK Exim logo is used when this field is empty.",
    "Buyer Tax Number": "Buyer Tax Number",
    "Round Log": "Round Log",
    "Square / Sawn": "Square / Sawn",
    "For round, unprocessed logs. Uses the Hoppus formula: (girth ÷ 4)² × length.": "For round, unprocessed logs. Uses the Hoppus formula: (girth ÷ 4)² × length.",
    "For square or sawn timber. Uses volumetric formula: length × width × height.": "For square or sawn timber. Uses volumetric formula: length × width × height.",
    "Formula guide": "Formula guide",
    "Tax Number": "Tax Number",
    "Available": "Available",
    "In Process": "In a mill job",
    "In Shipment": "In Consignment",
    "Shipped": "Shipped",
    "Stock by Location": "Stock by Location",
    "sites": "sites",
    "TUs": "Stock Units",
    "Filtered": "Filtered",
    "At Forest": "At Forest",
    "In Transit": "In Transit",
    "At Mill": "At Mill",
    "At Yard": "At Yard",
    "AVAILABLE": "Available",
    "IN_PROCESS": "In a mill job",
    "PROCESSED": "Milled",
    "IN_SHIPMENT": "In Consignment",
    "SHIPPED": "Shipped",
    "COMPLETED": "Completed",
    "Completed": "Completed",
    "ROUND": "Round",
    "SQUARE": "Square",
    "All": "All",
    "IN": "In",
    "OUT": "Out",
    "Proc IN": "Sent to mill",
    "Proc OUT": "Made by mill",
    "Adjustment": "Adjustment",
    "Received": "Received",
    "Dispatched": "Dispatched",
    "Sold": "Sold",
    "New Processing Run": "New Mill Job",
    "Theme": "Theme",
    "Lara Light Blue": "Lara Light Blue",
    "Lara Dark Blue": "Lara Dark Blue",
    "Lara Light Indigo": "Lara Light Indigo",
    "Lara Dark Indigo": "Lara Dark Indigo",
    "Bootstrap Light": "Bootstrap Light",
    "Bootstrap Dark": "Bootstrap Dark",
    "Saga Blue": "Saga Blue",
    "Vela Blue (Dark)": "Vela Blue (Dark)",
    "Material Light": "Material Light",
    "Arya Blue (Dark)": "Arya Blue (Dark)",
    "YARD": "Yard",
    "FOREST": "Forest",
    "MILL": "Mill",
    "PORT": "Port",
    "WAREHOUSE": "Warehouse",
    "common.previous": "Previous",
    // -- Payment / Checkout
    "pay.secureCheckout": "Secure Checkout",
    "pay.completeSubscription": "Complete Your Subscription",
    "pay.oneStepAway": "You're one step away from unlocking full access to LumberLinq",
    "pay.stepPlanSelected": "Plan Selected",
    "pay.stepAccountSetup": "Account Setup",
    "pay.stepPayment": "Payment",
    "pay.billingDetails": "Billing Details",
    "pay.billingDetailsDesc": "This information will appear on your invoice",
    "pay.optional": "Optional",
    "pay.taxIdHint": "Recommended for proper tax invoicing.",
    "pay.sslNote": "Your billing information is encrypted with SSL. We never store your payment card details.",
    "pay.annual": "Annual",
    "pay.monthly": "Monthly",
    "pay.basePrice": "Base Price",
    "pay.starts": "Starts",
    "pay.ends": "Ends",
    "pay.promoCode": "Promo Code",
    "pay.applyCode": "Apply code →",
    "pay.enterCode": "Enter code",
    "pay.taxes": "Taxes",
    "pay.discountApplied": "Discount Applied",
    "pay.upgradeCreditApplied": "Upgrade Credit",
    "pay.upgradeCreditNote": "Credit for the unused time remaining on your current plan.",
    "pay.farFutureQueueBanner": "You already have active coverage until {date}. This purchase won't start until then.",
    "pay.farFutureQueueHeader": "This won't start for a while",
    "pay.farFutureQueueMessage": "You already have an active plan running until {date}. This new purchase will be queued to start only after that — it won't take effect now. Continue anyway?",
    "pay.farFutureQueueAccept": "Yes, queue it anyway",
    "pay.farFutureQueueReject": "No, cancel",
    "pay.promoApplied": "Coupon Applied!",
    "pay.promoChange": "Remove",
    "pay.promoEnterFirst": "Please enter a coupon code.",
    "pay.promoGenericError": "This code isn't valid. Please check and try again.",
    "pay.promoErr.notFound": "We could not find this code. Please check it and try again.",
    "pay.promoErr.notStarted": "This code is not active yet.",
    "pay.promoErr.expired": "This code has expired.",
    "pay.promoErr.usedUp": "This code has reached its usage limit and can't be used any more.",
    "pay.promoErr.currency": "This code is not valid for the selected currency.",
    "pay.promoErr.period": "This code is not valid for the selected billing period.",
    "pay.promoErr.inrOnly": "This code is only valid for INR billing.",
    "pay.promoErr.alreadyUsed": "Your company has already used this code.",
    "pay.promoErr.ownCode": "You cannot use a referral code that belongs to your own company.",
    "pay.amountPayable": "Amount Payable",
    "pay.autoRenewal": "Auto Renewal",
    "pay.autoRenewalHint": "Automatically renew at end of billing period",
    "pay.autoRenewalRequiredMonthly": "Required for monthly plans — cancel anytime from subscriptions page",
    "pay.autoRenewalUsdNotSupported": "Auto-renewal is available for INR billing only",
    "pay.autoRenewalCouponDisabled": "One-time discount applied — auto-renewal disabled. Enable it after payment from your Subscription page at full price.",
    "pay.autoRenewalLifetimeCoupon": "Lifetime discount: auto-renewal will continue at this discounted price",
    "pay.iHaveReadAccept": "I have read and accept the",
    "pay.tncError": "You must accept the Terms & Conditions to proceed.",
    "pay.sslSecured": "SSL Secured",
    "pay.encrypted": "Encrypted",
    "pay.tncFooterNote": "Clicking \"Accept\" also checks the agreement checkbox.",
    "pay.orderSummary": "Order Summary",
    "pay.yr": "yr",
    "pay.mo": "mo",
    // -- Tour
    "tour.next": "Next →",
    "tour.prev": "← Back",
    "tour.done": "Done ✓",
    "tour.progress": "{{current}} of {{total}}",
    "tour.header.welcome.title": "Welcome to LumberLinq!",
    "tour.header.welcome.desc": "Let's take a quick tour of the key features. You can <strong>dismiss</strong> this at any time by clicking the × button.",
    "tour.header.menu.title": "Navigation Menu",
    "tour.header.menu.desc": "Click here to <strong>open or collapse</strong> the sidebar navigation.",
    "tour.header.logo.title": "LumberLinq Logo",
    "tour.header.logo.desc": "Click the logo to <strong>return to the Dashboard</strong> from anywhere.",
    "tour.header.language.title": "Language",
    "tour.header.language.desc": "Switch the app language between <strong>English, Hindi, and Portuguese</strong>.",
    "tour.header.fontSize.title": "Font Size",
    "tour.header.fontSize.desc": "Adjust the <strong>text size</strong> to your comfort level.",
    "tour.header.theme.title": "Theme",
    "tour.header.theme.desc": "Pick a <strong>colour theme</strong> that suits your preference.",
    "tour.header.darkMode.title": "Dark Mode",
    "tour.header.darkMode.desc": "Toggle between <strong>Light and Dark</strong> display modes.",
    "tour.header.profile.title": "Your Profile",
    "tour.header.profile.desc": "Access your <strong>account settings, subscription, and logout</strong> from here.",
    "tour.header.help.title": "Help & Support",
    "tour.header.help.desc": "Find <strong>guides, FAQs, and support tickets</strong> whenever you need help. That's all — enjoy LumberLinq!",
    "tour.shipments.header.title": "Consignments",
    "tour.shipments.header.desc": "Manage all your <strong>export consignments</strong> from this page.",
    "tour.shipments.new.title": "New Consignment",
    "tour.shipments.new.desc": "Click here to <strong>create a new consignment</strong> and start adding stock units.",
    "tour.shipments.filter.title": "Filter & Search",
    "tour.shipments.filter.desc": "Use these filters to <strong>search consignments</strong> by date, status, or business partner.",
    "tour.shipments.table.title": "Consignments Table",
    "tour.shipments.table.desc": "Each row is a consignment. Click a row to <strong>view details, tally sheets, and documents</strong>.",
    "tour.shipments.delete.title": "Delete Consignment",
    "tour.shipments.delete.desc": "Use the delete action carefully — <strong>removed consignments cannot be recovered</strong>.",
    "tour.tally.header.title": "Tally Sheet",
    "tour.tally.header.desc": "Record and manage <strong>log measurements</strong> for this stock unit.",
    "tour.tally.settings.title": "Tally Settings",
    "tour.tally.settings.desc": "Configure <strong>formula, unit, and measurement defaults</strong> for this tally.",
    "tour.tally.grid.title": "Entry Grid",
    "tour.tally.grid.desc": "Enter each log's <strong>girth, length, and quantity</strong> directly in the grid. Totals update automatically.",
    "tour.tally.export.title": "Export",
    "tour.tally.export.desc": "Export the tally as a <strong>PDF or Excel file</strong> for sharing or records.",
    "tour.tally.save.title": "Save Tally",
    "tour.tally.save.desc": "Click Save to <strong>submit the tally</strong> data to the consignment.",
    "tour.reports.header.title": "Reports",
    "tour.reports.header.desc": "Generate detailed <strong>business and tally reports</strong> from this section.",
    "tour.reports.filter.title": "Report Filters",
    "tour.reports.filter.desc": "Set the <strong>date range, business partner, and consignment</strong> to narrow the report.",
    "tour.reports.generate.title": "Generate Report",
    "tour.reports.generate.desc": "Click Generate to <strong>build the report</strong> with your selected filters.",
    "tour.reports.export.title": "Export Report",
    "tour.reports.export.desc": "Download the report as <strong>PDF or Excel</strong> for offline use.",
    "tour.bp.header.title": "Business Partners",
    "tour.bp.header.desc": "Manage your <strong>buyers and sellers</strong> from this page.",
    "tour.bp.new.title": "Add Partner",
    "tour.bp.new.desc": "Click here to <strong>add a new buyer or seller</strong> to your directory.",
    "tour.bp.stats.title": "Partner Stats",
    "tour.bp.stats.desc": "A quick overview of <strong>total buyers and sellers</strong> in your account.",
    "tour.bp.filter.title": "Filter Partners",
    "tour.bp.filter.desc": "Search or filter partners by <strong>name, type, or country</strong>.",
    "tour.bp.table.title": "Partners Table",
    "tour.bp.table.desc": "Click a partner row to <strong>edit details or view their consignment history</strong>.",
    "tour.products.header.title": "Products",
    "tour.products.header.desc": "Define the <strong>timber products</strong> used in your tally sheets.",
    "tour.products.new.title": "Add Product",
    "tour.products.new.desc": "Click here to <strong>create a new timber product</strong> with its formula and unit.",
    "tour.products.stats.title": "Product Stats",
    "tour.products.stats.desc": "See the <strong>total number of products</strong> configured in your account.",
    "tour.products.table.title": "Products Table",
    "tour.products.table.desc": "Click a product row to <strong>edit its name, formula, or default unit</strong>.",
    "tour.loadingSite.header.title": "Locations",
    "tour.loadingSite.header.desc": "Track all <strong>forest, yard, mill, and port locations</strong> from here.",
    "tour.loadingSite.new.title": "Add Location",
    "tour.loadingSite.new.desc": "Click here to <strong>register a new location</strong> in your account.",
    "tour.loadingSite.stats.title": "Location Stats",
    "tour.loadingSite.stats.desc": "A summary of <strong>total locations</strong> by type.",
    "tour.loadingSite.table.title": "Locations Table",
    "tour.loadingSite.table.desc": "Click a location row to <strong>edit its name, type, and location</strong>.",
    "tour.users.header.title": "Users",
    "tour.users.header.desc": "Manage all <strong>team members</strong> who have access to your LumberLinq account.",
    "tour.users.add.title": "Invite User",
    "tour.users.add.desc": "Click here to <strong>invite a new team member</strong> by email.",
    "tour.users.stats.title": "User Stats",
    "tour.users.stats.desc": "See how many <strong>active users and available seats</strong> your plan allows.",
    "tour.users.table.title": "Users Table",
    "tour.users.table.desc": "Manage roles and permissions — click a user row to <strong>edit or deactivate</strong>.",
    "tour.dashboardV7.header.title": "Your Business Pulse",
    "tour.dashboardV7.header.desc": "Your <strong>Dashboard</strong> — pick a date range and refresh here to see live numbers across your whole operation.",
    "tour.dashboardV7.pulse.title": "Business Pulse",
    "tour.dashboardV7.pulse.desc": "Quick <strong>KPI cards</strong> for partners, shipments, stock units, volume, and pieces — click any card to jump straight to that list.",
    "tour.dashboardV7.financial.title": "Financial Health",
    "tour.dashboardV7.financial.desc": "Track <strong>revenue, outstanding balances, and aging</strong> at a glance.",
    "tour.dashboardV7.inventory.title": "Inventory Snapshot",
    "tour.dashboardV7.inventory.desc": "A live view of <strong>stock levels across your sites</strong> — click 'Full Inventory' for the complete picture.",
    "tour.dashboardV7.recon.title": "Reconciliation",
    "tour.dashboardV7.recon.desc": "See how much of your tally data is <strong>reconciled against shipments</strong>, and jump in to fix any gaps.",
    "tour.dashboardV7.charts.title": "Trends & Charts",
    "tour.dashboardV7.charts.desc": "Visualize <strong>volume trends and top products</strong> over your selected date range.",
    "tour.dashboardV7.activity.title": "Recent Activity",
    "tour.dashboardV7.activity.desc": "An audit trail of <strong>recent account and permission changes</strong> across your team.",
    "tour.inventoryOverview.header.title": "Inventory Overview",
    "tour.inventoryOverview.header.desc": "A live picture of <strong>where your stock is right now</strong> — at Forest, in Transit, at Mill, in a mill job, at Yard, or in Consignment.",
    "tour.inventoryOverview.actions.title": "Opening Stock and Mill Job",
    "tour.inventoryOverview.actions.desc": "The main actions: <strong>add your opening stock (stock you already have) or start a mill job</strong>. New deliveries come in through their Stock Unit (Stock In) and are received into a Lot.",
    "tour.inventoryOverview.lots.title": "Open Stock Lots",
    "tour.inventoryOverview.lots.desc": "Every <strong>open lot</strong> currently in the system — click a lot for its full movement history and chain.",
    "tour.inventoryInOut.header.title": "Stock Movement Ledger",
    "tour.inventoryInOut.header.desc": "Every <strong>stock movement</strong> ever recorded. Use Add Adjustment to correct a discrepancy, or Export for a spreadsheet copy.",
    "tour.inventoryInOut.filter.title": "Filter by Type & Date",
    "tour.inventoryInOut.filter.desc": "Narrow the ledger to a <strong>movement type</strong> (In, Out, Adjustment, and more) or a <strong>date range</strong>.",
    "tour.inventoryInOut.table.title": "Movement Ledger",
    "tour.inventoryInOut.table.desc": "Each row is one <strong>movement event</strong> — tap an id in it to see the Stock Unit, Lot, Mill Job or Consignment behind it.",
    "tour.inventoryProcessing.header.title": "Mill Jobs",
    "tour.inventoryProcessing.header.desc": "This is where <strong>mill jobs</strong> happen, including Custom-Made / Re-saw — start a new mill job to turn stock from a Lot into a new Lot.",
    "tour.inventoryProcessing.stats.title": "Mill Job Performance",
    "tour.inventoryProcessing.stats.desc": "Total mill jobs, <strong>average outturn</strong>, and total volume milled — a quick health check on your mill's efficiency.",
    "tour.inventoryProcessing.table.title": "Mill Jobs",
    "tour.inventoryProcessing.table.desc": "Every mill job, its <strong>status</strong>, and its input/output — click a row for full details, including the source order that triggered it.",
    "tour.inventoryOperators.header.title": "Mill Operators",
    "tour.inventoryOperators.header.desc": "Manage the <strong>operators</strong> who work on mill jobs — add a new operator here.",
    "tour.inventoryOperators.stats.title": "Team Snapshot",
    "tour.inventoryOperators.stats.desc": "Total and <strong>active operator</strong> counts at a glance.",
    "tour.inventoryOperators.search.title": "Search & Filter",
    "tour.inventoryOperators.search.desc": "Find an operator by <strong>name, employee code, or email</strong>, or filter by expertise and active status.",
    "tour.rbacSettings.toggle.title": "Role-Based Access Control",
    "tour.rbacSettings.toggle.desc": "Turn on <strong>RBAC</strong> to give each team member only the access they need, instead of everyone seeing everything.",
    "tour.rbacSettings.tabs.title": "Users & Roles",
    "tour.rbacSettings.tabs.desc": "Manage access two ways: per-user (<strong>User Permissions</strong>) or by assigning a reusable <strong>Role</strong>.",
    "tour.rbacSettings.usersTable.title": "User Permissions",
    "tour.rbacSettings.usersTable.desc": "Every team member and how much of the system they can access — click <strong>Configure</strong> on a row to fine-tune it.",
    "tour.rbacSettings.rolesTab.title": "Access Roles",
    "tour.rbacSettings.rolesTab.desc": "Create a <strong>reusable role</strong> (like 'Accountant' or 'Yard Supervisor') once, then assign it to any number of users.",
    "tour.subscriptionManagement.accordion.title": "Subscribe in 4 Steps",
    "tour.subscriptionManagement.accordion.desc": "Choose a plan, review it, add billing details, then pay — each step <strong>unlocks the next</strong> as you complete it.",
    "tour.subscriptionManagement.packageSelect.title": "1. Select Package",
    "tour.subscriptionManagement.packageSelect.desc": "Pick the <strong>plan and billing cycle</strong> that fits your business.",
    "tour.subscriptionManagement.billing.title": "3. Billing Details",
    "tour.subscriptionManagement.billing.desc": "Enter your <strong>company and tax details</strong> for the invoice.",
    "tour.subscriptionManagement.pay.title": "4. Evaluate Order & Pay",
    "tour.subscriptionManagement.pay.desc": "Review the <strong>final total</strong>, apply a promo code if you have one, and complete payment.",
    // -- Support Tickets
    "ticket.supportTitle": "Support Tickets",
    "ticket.subtitle": "Raise a request, track progress, and get help from our team.",
    "ticket.newTicket": "New Ticket",
    "ticket.searchPlaceholder": "Search by subject, ticket number or category…",
    "ticket.filter": "Filter:",
    "ticket.replies": "replies",
    "ticket.lastActivity": "Last activity",
    "ticket.noTickets": "No tickets yet",
    "ticket.noTicketsHint": "Haven't raised a support request? We're here to help.",
    "ticket.raiseFirst": "Raise First Ticket",
    "ticket.submitted": "Ticket Submitted!",
    "ticket.submitReceived": "Your support request has been received.",
    "ticket.respondTime": "Our team will respond within 24 hours.",
    "ticket.yourId": "Your Ticket ID",
    "ticket.viewTicket": "View Ticket",
    "ticket.allTickets": "All Tickets",
    "ticket.raiseTitle": "Raise a Support Ticket",
    "ticket.raiseHint": "Describe your issue and we will get back to you promptly.",
    "ticket.subject": "Subject",
    "ticket.subjectPlaceholder": "Briefly describe your issue",
    "ticket.subjectRequired": "Subject is required.",
    "ticket.maxChars": "Max 255 characters.",
    "ticket.selectCategory": "Select category",
    "ticket.categoryRequired": "Category is required.",
    "ticket.descriptionPlaceholder": "Provide as much detail as possible — steps to reproduce, error messages, screenshots context, etc.",
    "ticket.descriptionRequired": "Description is required.",
    "ticket.submitTicket": "Submit Ticket",
    "ticket.priority": "Priority",
    "ticket.resolved": "Resolved",
    "ticket.closed": "Closed",
    "ticket.howDidWeDo": "How did we do?",
    "ticket.csatPrompt": "Your ticket has been resolved. Rate your support experience:",
    "ticket.optionalComment": "Optional comment…",
    "ticket.submitRating": "Submit Rating",
    "ticket.yourRating": "Your rating:",
    "ticket.replyPlaceholder": "Type your reply here…",
    "ticket.attachFile": "Attach file",
    "ticket.sendReply": "Send Reply",
    "ticket.ticketClosed": "This ticket is closed. Please open a new ticket if you need further assistance.",
    "ticket.status.all": "All",
    "ticket.status.open": "Open",
    "ticket.status.inProgress": "In Progress",
    "ticket.status.awaitingReply": "Awaiting My Reply",
    "ticket.status.resolved": "Resolved",
    "ticket.status.closed": "Closed",
    "ticket.priority.low": "Low",
    "ticket.priority.medium": "Medium",
    "ticket.priority.high": "High",
    "ticket.priority.critical": "Critical",
    "ticket.priority.low.desc": "Low — general question",
    "ticket.priority.medium.desc": "Medium — non-urgent issue",
    "ticket.priority.high.desc": "High — affecting my work",
    "ticket.priority.critical.desc": "Critical — system down / data loss",
    "ticket.category.billing": "Billing & Payments",
    "ticket.category.technical": "Technical Issue",
    "ticket.category.account": "Account & Access",
    "ticket.category.featureRequest": "Feature Request",
    "ticket.category.subscription": "Subscription",
    "ticket.category.dataRecovery": "Data Recovery",
    "ticket.category.other": "Other",
    "ticket.csat.1": "Very Unhappy",
    "ticket.csat.2": "Unhappy",
    "ticket.csat.3": "Neutral",
    "ticket.csat.4": "Happy",
    "ticket.csat.5": "Very Happy",
    // -- AI Chat
    "ai.chat.title": "LumberLinq AI Assistant",
    "ai.chat.placeholder": "Ask about LumberLinq…",
    "ai.chat.footerNote": "Answers grounded in our Knowledge Base",
    "ai.chat.send": "Send",
    "ai.chat.newChat": "New Chat",
    "ai.chat.thinking": "Thinking…",
    "ai.chat.sources": "Sources",
    "ai.chat.noSessions": "No previous conversations",
    "ai.chat.deleteSession": "Delete conversation",
    "ai.chat.emailTranscript": "Email transcript",
    "ai.chat.feedback.good": "Helpful",
    "ai.chat.feedback.bad": "Not helpful",
    "ai.chat.attachFile": "Attach file",
    "ai.chat.disclaimer": "AI answers are based on our knowledge base and may not always be fully accurate. Always verify important information.",
    "ai.chat.modeAuto": "Auto",
    "ai.chat.titleAuto": "Linc AI",
    "ai.chat.autoSub": "Ask anything · Linc picks the right answer",
    "ai.chat.autoPlaceholder": "Ask how to do something, or about your stock and payments…",
    "ai.chat.autoGreeting": "Hi, I'm Linc AI 👋",
    "ai.chat.autoTitle": "One place for every question",
    "ai.chat.autoDesc": "Ask how to do something in LumberLinq, or ask about your own stock, consignments and payments. I'll pick the right way to answer, and only show what your account is allowed to see.",
    "ai.chat.goToScreen": "Go to screen",
    "ai.chat.dataPartFailed": "I could answer the how-to part of your question, but the live-data part could not be answered right now.",
    "ai.chat.starter.createConsignment": "Create a Consignment",
    "ai.chat.starter.inviteTeam": "Invite a team member",
    "ai.chat.starter.shareTally": "Share a tally sheet",
    "ai.chat.starter.stockNow": "Stock right now",
    "ai.chat.starter.toPay": "Payments due",
    "ai.chat.starterQ.createConsignment": "How do I create a new Consignment?",
    "ai.chat.starterQ.inviteTeam": "How do I invite a team member?",
    "ai.chat.starterQ.shareTally": "How do I share a tally sheet with a buyer?",
    "ai.chat.starterQ.stockNow": "How much stock do we have right now?",
    "ai.chat.starterQ.toPay": "What's outstanding to be paid this month?",
    "ai.chat.starterQ.myAccess": "What can I do with my account?",
    "ai.chat.starterQ.shipmentsMonth": "How many shipments this month?",
    "ai.chat.starterQ.profitMargin": "What's our profit margin this quarter?",
    "ai.chat.starterQ.machines": "Which machines are running right now?",
    "ai.chat.starterQ.health": "How is our business doing overall?",
    "ai.chat.starter.myAccess": "What can I do?",
    "lincPreview.button": "What Linc shows this person",
    "lincPreview.title": "What Linc shows this person",
    "lincPreview.intro": "This is what Linc (the AI assistant) is allowed to tell this person, based on their access and the company plan. Nothing is sent to the AI to show this.",
    "lincPreview.modulesAssumed": "You are signed in as platform staff, so the module switches (Inventory, Mill Jobs, Linc Data) are not checked here.",
    "lincPreview.why.plan": "{items} isn't included in this company's current plan (the company would need to upgrade or add it)",
    "lincPreview.why.permission": "this account doesn't have access to {items} (an admin on the team can grant it from Manage Roles)",
    "lincPreview.why.also": "; also ",
    "lincPreview.why.and": " and ",
    "lincPreview.why.dataPlan": "Linc Data isn't turned on for this company's plan (the company would need to add it or upgrade)",
    "lincPreview.why.dataRight": "this account doesn't have the right to use Linc Data (an admin on the team can grant it from Manage Roles)",
    "lincPreview.tileAreas": "Areas",
    "lincPreview.tileQuestions": "Live-data questions",
    "lincPreview.tileSections": "Help notes",
    "lincPreview.tileAnswers": "Ready-made answers",
    "lincPreview.areasTitle": "Areas of the app",
    "lincPreview.questionsTitle": "Live-data questions (Linc Data)",
    "lincPreview.notesTitle": "Help notes",
    "lincPreview.allowed": "Allowed",
    "lincPreview.notAllowed": "Not allowed",
    "lincPreview.withheld": "withheld",
    "lincPreview.showWithheld": "Show withheld sections",
    "lincPreview.error": "Could not load the preview. Please try again.",
    "lincPreview.close": "Close",
    // -- Round Tally Summary (premium redesign)
    "tallySummaryRound.title": "Round Tally Summary",
    "tallySummaryRound.subtitle": "Volume, piece count, and distribution insights for this round-log lot",
    "tallySummaryRound.piecesAnalyzed": "pieces analyzed",
    "tallySummaryRound.histogram": "Histogram",
    "tallySummaryRound.bubble": "Bubble",
    "tallySummaryRound.line": "Line",
    "tallySummaryRound.mainVisualization": "Main Visualization",
    "tallySummaryRound.girthVsVolume": "Girth vs Volume",
    "tallySummaryRound.lengthDistribution": "Length Distribution",
    "tallySummaryRound.bubbleTitle": "Girth x Length x Volume",
    "tallySummaryRound.activeFilterLabel": "Active Filter",
    "tallySummaryRound.clearFilter": "Clear Filter",
    "tallySummaryRound.spotlightPiece": "Spotlighting piece #",
    "tallySummaryRound.kpiTotalPieces": "Total Pieces",
    "tallySummaryRound.kpiTotalNetCbm": "Total Net CBM",
    "tallySummaryRound.kpiTotalNetCft": "Total Net CFT",
    "tallySummaryRound.kpiAuthoritative": "Authoritative lot total",
    "tallySummaryRound.distributionTitle": "Per-Piece Distribution",
    "tallySummaryRound.avgVolume": "Average Volume / Piece",
    "tallySummaryRound.minVolume": "Smallest Piece",
    "tallySummaryRound.maxVolume": "Largest Piece",
    "tallySummaryRound.outlierWatchTitle": "Data Quality - Outlier Watch",
    "tallySummaryRound.outlierCleanLot": "Clean lot - no measurement outliers detected",
    "tallySummaryRound.outlierFlaggedCount": "piece(s) flagged for review",
    "tallySummaryRound.outlierFreePercent": "Outlier-free",
    "tallySummaryRound.outlierExpand": "View flagged pieces",
    "tallySummaryRound.outlierCollapse": "Hide flagged pieces",
    "tallySummaryRound.outlierColRow": "Row #",
    "tallySummaryRound.outlierColGirth": "Girth",
    "tallySummaryRound.outlierColLength": "Length",
    "tallySummaryRound.outlierColVolume": "Volume",
    "tallySummaryRound.outlierColDeviation": "Deviation",
    "tallySummaryRound.outlierSeverityMild": "Mild",
    "tallySummaryRound.outlierSeverityExtreme": "Extreme",
    "tallySummaryRound.outlierNotEnoughData": "Not enough pieces to assess outliers (minimum 8 required)",
    "tallySummaryRound.outlierAboveRange": "above expected range",
    "tallySummaryRound.outlierBelowRange": "below expected range",
    "tallySummaryRound.rowPositionHint": "Position in the tally sheet as entered, not a permanent ID",
    "tallySummaryRound.girthHistogramTitle": "Girth Distribution",
    "tallySummaryRound.girthHistogramDesc": "Pieces grouped in 5 cm girth bands",
    "tallySummaryRound.lengthHistogramTitle": "Length Distribution Table",
    "tallySummaryRound.lengthHistogramDesc": "Pieces grouped by entered length",
    "tallySummaryRound.metric": "Metric",
    "tallySummaryRound.noDataTitle": "No Summary Available",
    "tallySummaryRound.noDataDesc": "Add tally data first to generate insights and visualizations.",
    "tallySummaryRound.lotSnapshot": "Lot Snapshot",
    "tallySummaryRound.kpiAvgCft": "Average CFT / Piece",
    "tallySummaryRound.distributionHelp": "Average, smallest, and largest net volume (CBM) per individual log in the current view.",
    "tallySummaryRound.outlierHelp": "Flags logs whose volume is statistically unusual compared to the rest of this lot - a quick way to catch mismeasured or mistyped entries before you finalize or share this tally.",
    "tallySummaryRound.axisGirth": "Girth (cm)",
    "tallySummaryRound.axisLength": "Length (cm)",
    "tallySummaryRound.axisPieces": "Pieces",
    "tallySummaryRound.axisVolume": "Volume (m³)",
    "tallySummaryRound.rowAverage": "Average",
    "tallySummaryRound.rowSmallest": "Smallest",
    "tallySummaryRound.rowLargest": "Largest",
    "tallySummaryRound.colVolume": "Volume",
    "tallySummaryRound.colGirth": "Girth",
    "tallySummaryRound.colLength": "Length",
    "tallySummaryRound.normalGirthRange": "Normal Girth Range",
    "tallySummaryRound.normalLengthRange": "Normal Length Range",
    "tallySummaryRound.dimGirthAbnormal": "Girth abnormal",
    "tallySummaryRound.dimLengthAbnormal": "Length abnormal",
    "tallySummaryRound.dimBothAbnormal": "Girth & Length abnormal",
    "tallySummaryRound.girthVsVolumeHelp": "Shows how each log's volume relates to its girth - larger girth generally means more volume, but length still plays a role too.",
    "tallySummaryRound.holdTitle": "Which logs hold your volume",
    "tallySummaryRound.holdSubLogs": "Biggest first · share of {total} CBM",
    "tallySummaryRound.holdSubBands": "Girth bands, biggest first · share of {total} CBM",
    "tallySummaryRound.holdInsightOne": "Your biggest log holds {pct}% of the lot's volume.",
    "tallySummaryRound.holdInsightMany": "Your {n} biggest logs hold {pct}% of the lot's volume.",
    "tallySummaryRound.holdInsightBand": "Logs of {band} cm girth hold {pct}% of the volume.",
    "tallySummaryRound.holdRow": "Row {n}",
    "tallySummaryRound.holdMeta": "{girth} cm girth · {length} cm long",
    "tallySummaryRound.holdBandMeta": "{n} logs",
    "tallySummaryRound.holdShowAll": "Show all {n}",
    "tallySummaryRound.holdShowLess": "Show less",
    "tallySummaryRound.emptyHidden": "{n} empty hidden · Show",
    "tallySummaryRound.emptyHide": "Hide empty",
    "tallySummaryRound.holdInsightTop": "Your biggest {k}% of logs hold {pct}% of the volume.",
    "tallySummaryRound.holdTopLogs": "Biggest single logs",
    "tallySummaryRound.holdTabBands": "By size band",
    "tallySummaryRound.holdTabLogs": "Biggest logs",
    "tallySummaryRound.holdBandMetaOne": "{n} log",
    "emailVerification.linkValidHours": "Link valid for 24 hours",
    "emailVerification.resendButton": "Resend Verification Email",
    "emailVerification.alreadyVerifiedPill": "Email already verified — please continue",
    "emailVerification.nowVerifiedGoToLogin": "Your email is verified! Please log in to continue.",
    "emailVerification.stillNotVerified": "Not verified yet — please check your email and click the link first.",
    "emailVerification.resendCountdown": "Resend available in {{seconds}}s",
    "emailVerification.attemptsRemaining": "{{count}} of 3 resend attempts remaining",
    "emailVerification.maxAttemptsReached": "Maximum resend attempts reached. Please contact support.",
    "emailVerification.emailInputPlaceholder": "Enter your email address",
    "emailVerification.emailInputHint": "Enter the email you used to sign up to resend the verification link.",
    "emailVerification.toastSuccessSummary": "Email Sent",
    "emailVerification.toastErrorSummary": "Resend Failed",
    "emailVerification.refreshErrorSummary": "Couldn't check yet",
    "emailVerification.refreshErrorBody": "We could not check your e-mail status just now. Please try again in a moment.",
    "login.securityCheckRetry": "Retry security check",
    "login.securityCheckStuck": "Taking longer than usual — tap retry below",
    "login.securityCheckExpired": "Verification expired — tap refresh to continue",
    "login.securityCheckErrored": "Security check couldn't load — tap retry",
    "login.signInCancelledSummary": "Sign-in Cancelled",
    "login.signInCancelledDetail": "It looks like sign-in didn't finish. Please try again when you're ready.",
    "tallyStatusBar.row": "row",
    "tallyStatusBar.rows": "rows",
    "tallyStatusBar.piecesUnit": "pcs",
    "tallyStatusBar.updated": "updated",
    "tallyStatusBar.removed": "removed",
    "tallyStatusBar.totalRowsTooltip": "Total rows",
    "tallyStatusBar.totalPiecesTooltip": "Total pieces",
    "tallyStatusBar.availableNowTooltip": "Available now",
    "tallyStatusBar.afterThisSave": "Remaining:",
    "tallyStatusBar.grossCbmTooltip": "Gross CBM",
    "tallyStatusBar.grossCbmUnit": "Gross CBM",
    "tallyStatusBar.grossCftUnit": "Gross CFT",
    "tallyStatusBar.grossCftTooltip": "Gross CFT",
    "tallyStatusBar.netCbmUnit": "Net CBM",
    "tallyStatusBar.netCftUnit": "Net CFT",
    "tallyStatusBar.netCbmTooltip": "Net CBM (after allowances)",
    "tallyStatusBar.netCftTooltip": "Net CFT (after allowances)",
    "tallyStatusBar.avgCftTooltip": "Average CFT per log",
    "tallyStatusBar.unsavedChangesTooltip": "rows with unsaved changes",
    "tallyStatusBar.unsavedUnit": "unsaved",
    "tallyStatusBar.allChangesSavedTooltip": "All changes saved",
    "tallyStatusBar.allSaved": "All saved",
    "tallyStatusBar.savedPrefix": "Saved —",
    "tallyStatusBar.deletedPrefix": "Deleted —",
    "tallyStatusBar.unsavedPressSave": "unsaved — press Save",
    "tallyStatusBar.lastSaved": "Last saved",
    "tallyStatusBar.hideVoiceControls": "Hide voice controls",
    "tallyStatusBar.showVoiceControls": "Show voice controls",
    "tallyStatusBar.addRow": "Add row",
    "tallyStatusBar.deleteSelected": "Delete selected",
    "tallyStatusBar.saveCtrlS": "Save (Ctrl+S)",
    "tallyStatusBar.saveTimeout": "Save is taking too long — check your connection",
    "tallyStatusBar.saveFailed": "Save failed — try again",
    "tallyStatusBar.deletingRows": "Deleting rows...",
    "tallyStatusBar.deleteFailed": "Delete failed — try again",
    "tallyStatusBar.fixHighlightedCells": "Fix highlighted cells before saving",
    "tallyStatusBar.noModifiedRows": "No modified rows",
    "tallyStatusBar.saveMsg1": "Saving your changes",
    "tallyStatusBar.saveMsg2": "Crunching the numbers",
    "tallyStatusBar.saveMsg3": "Syncing with server",
    "tallyStatusBar.saveMsg4": "Almost there",
    "tallyStatusBar.saveMsg5": "Still working on it",
    "tallyStatusBar.saveMsg6": "Hang tight, nearly done",
    "tallyStatusBar.saveMsg7": "Finalising your data",
    "tallyStatusBar.saveMsg8": "Just a moment more",
    "subscriptionPackage.cancelAutoRenewalFailedTitle": "Couldn't cancel auto-renewal",
    "subscriptionPackage.cancelAutoRenewalFailedMessage": "Unable to cancel your current auto-renewal subscription. Please try again or contact support.",
    "subscriptionPackage.saveErrorTitle": "Something went wrong",
    "subscriptionPackage.saveErrorMessage": "We couldn't save your selection. Please try again.",
    "subscriptionPackage.cta.selected": "Selected {name}",
    "subscriptionPackage.cta.startTrial": "Start {days}-Day Free Trial",
    "subscriptionPackage.cta.choose": "Choose {name}",
    "subscriptionPackage.trialNote": "{days}-day free trial included",
    "appSettings.title": "Application Settings",
    "appSettings.subtitle": "Manage general settings for your company",
    "appSettings.nav.paymentReminders": "Payment Reminders",
    "paymentReminders.title": "Payment Reminders",
    "paymentReminders.subtitle": "Automatically remind business partners about payments, and get a daily report",
    "paymentReminders.enable": "Enable Payment Reminders",
    "paymentReminders.daysBefore": "Start reminding",
    "paymentReminders.daysBefore.suffix": "days before the due date",
    "paymentReminders.sendTime": "Send time",
    "paymentReminders.timezone": "Timezone",
    "paymentReminders.externalReminders": "Remind business partners by email",
    "paymentReminders.externalReminders.desc": "Sends a payment reminder to the buyer or seller on your shipments and trade events",
    "paymentReminders.adminReport": "Send me a daily report",
    "paymentReminders.adminReport.desc": "A summary of everything due or overdue, with a PDF attached",
    "paymentReminders.channelEmail": "Email",
    "paymentReminders.channelPush": "Push notification",
    "paymentReminders.timeline.title": "Reminder Timeline",
    "paymentReminders.timeline.desc": "Preview of which days a reminder is sent, counting down to the due date",
    "paymentReminders.timeline.due": "Due",
    "paymentReminders.timeline.overdue": "Overdue (daily)",
    "paymentReminders.recipients.title": "Who receives the report?",
    "paymentReminders.recipients.desc": "Anyone with Financial Health access receives the daily report. Grant it to more people in",
    "paymentReminders.recipients.link": "Access Control",
    "paymentReminders.save": "Save Changes",
    "paymentReminders.saved": "Payment reminder settings saved",
    "paymentReminders.saveError": "Could not save these settings. Please try again.",
    "appSettings.nav.currency": "Currency",
    "appSettings.nav.inventoryPolicy": "Inventory Policy",
    "appSettings.nav.branding": "Branding",
    "appSettings.nav.tallyDefaults": "Tally Defaults",
    "tallyDefaults.subtitle": "Default measurement units, allowances, and validation rules new Stock Units start with — override per Stock Unit anytime.",
    "tallyDefaults.square": "Square",
    "tallyDefaults.round": "Round",
    "tallyDefaults.unitOfMeasure": "Unit of Measure",
    "tallyDefaults.widthUom": "Width UoM",
    "tallyDefaults.thickUom": "Thickness UoM",
    "tallyDefaults.lengthUom": "Length UoM",
    "tallyDefaults.girthUom": "Girth UoM",
    "tallyDefaults.decimals": "Decimals",
    "tallyDefaults.mode": "Entry Mode",
    "tallyDefaults.allowances": "Allowances",
    "tallyDefaults.widthAllowance": "Width Allowance",
    "tallyDefaults.thickAllowance": "Thickness Allowance",
    "tallyDefaults.lengthAllowance": "Length Allowance",
    "tallyDefaults.girthAllowance": "Girth Allowance",
    "tallyDefaults.lengthAdjustments": "Length Adjustments",
    "tallyDefaults.copyPrevLength": "Copy Previous Length",
    "tallyDefaults.addToLength": "Add to Length",
    "tallyDefaults.addToLengthValue": "Add to Length Value",
    "tallyDefaults.validationRules": "Validation Rules",
    "tallyDefaults.divisibleBy5": "Divisible by 5",
    "tallyDefaults.girthRange": "Girth Range",
    "tallyDefaults.lengthRange": "Length Range",
    "tallyDefaults.min": "Min",
    "tallyDefaults.max": "Max",
    "tallyDefaults.quickSearch": "Quick Search",
    "tallyDefaults.toleranceHint": "How far a plain size search may drift from the number typed and still count as a match — real timber rarely measures exactly to nominal size.",
    "tallyDefaults.searchToleranceSquare": "Square Match Tolerance",
    "tallyDefaults.searchToleranceRound": "Round Match Tolerance",
    "tallyDefaults.resetTitle": "Reset Tally Defaults?",
    "tallyDefaults.resetBody": "This resets every default on this page back to the original values. Stock Units that already have their own saved settings are not affected.",
    "appSettings.resetAll": "Reset All to Default",
    "appSettings.resetAllTitle": "Reset All Settings",
    "appSettings.resetAllBody": "This resets Payment Reminders, Currency, Inventory Policy, and Branding (if available) back to their default values. This can't be undone.",
    "common.resetToDefault": "Reset to Default",
    "account.language.label": "Language",
    "account.language.hint": "This is the language you'll see across LumberLinq, on any device.",
    "currency.subtitle": "Set the currency your reports and dashboards are shown in.",
    "currency.resetTitle": "Reset Currency",
    "currency.resetBody": "This clears your reporting currency back to unset. This can't be undone.",
    "inventoryPolicy.subtitle": "Company-wide stock policy — applies to every user.",
    "inventoryPolicy.allowOversell": "Let sales continue past available stock",
    "inventoryPolicy.allowOversell.hint": "Off by default — a sale is blocked once it would use more than what's actually in stock.",
    "inventoryPolicy.detailedTracking": "Track which purchase a Mill Job's wood comes from",
    "inventoryPolicy.detailedTracking.hint": "Off by default — turn on to see and adjust which purchase a pooled Lot's stock is counted against when it's milled.",
    "inventoryPolicy.resetTitle": "Reset Inventory Policy",
    "inventoryPolicy.resetBody": "This restores both toggles to their default values. This can't be undone.",
    "company.manageBranding": "Manage Branding",
    "company.manageBrandingHint": "Upload or set your company logo in Application Settings.",
    "company.signpost.text": "Looking for Currency, Inventory Policy, Payment Reminders, or Branding?",
    "company.signpost.link": "Application Settings",
    "branding.lockedTitle": "Custom branding is a Forest plan feature",
    "branding.lockedBody": "Upload your own company logo across the app, exports, and emails on the Forest plan.",
    "branding.upgradeCta": "Upgrade to Forest",
    "branding.chooseFile": "Choose File",
    "branding.dimensionHint": "PNG, JPG, or WEBP, ideally around 584×158px (matches the LumberLinq logo's own size) — minimum 200×50px, under 5 MB.",
    "branding.resetTitle": "Reset Logo",
    "branding.resetBody": "This clears your custom logo and shows the default LumberLinq logo again. This can't be undone.",
    "paymentReminders.resetTitle": "Reset Payment Reminders",
    "paymentReminders.resetBody": "This restores all Payment Reminders settings to their default values. This can't be undone.",
    "notifPrefs.sectionTitle": "Push Notification Categories",
    "sessions.title": "Where You Are Signed In",
    "sessions.subtitle": "These devices are signed in to your account. Sign out any you do not recognise or no longer use.",
    "sessions.thisDevice": "This device",
    "sessions.onlineNow": "Online now",
    "sessions.unknownDevice": "Unknown device",
    "sessions.slotWeb": "Browser",
    "sessions.slotApp": "App",
    "sessions.signOut": "Sign out",
    "sessions.signOutOthers": "Sign out all other devices",
    "sessions.cancel": "Cancel",
    "sessions.confirmHeader": "Sign out this device?",
    "sessions.confirmMessage": "{device} will be signed out and will need to log in again.",
    "sessions.confirmOthersHeader": "Sign out all other devices?",
    "sessions.confirmOthersMessage": "Every device except this one will be signed out and will need to log in again.",
    "sessions.signedOutToast": "The device was signed out.",
    "sessions.signedOutOthersToast": "All other devices were signed out.",
    "sessions.signOutFailed": "Could not sign the device out. Please try again.",
    "sessions.loadFailed": "Could not load your devices.",
    "sessions.retry": "Try again",
    "sessions.empty": "No devices found.",
    "notifPrefs.sectionHint": "Turn off a category if you don't want it to buzz your phone or browser — you'll still see it in your notification bell either way.",
    "pushPrompt.title": "Turn on notifications?",
    "pushPrompt.body": "Get notified the moment a shipment status changes, someone shares a tally with you, or your team sends an invite.",
    "pushPrompt.enable": "Enable",
    "pushPrompt.notNow": "Not now",
    "appFeedback.menu": "Give Feedback",
    "appFeedback.title": "Give Feedback",
    "appFeedback.subtitle": "Tell us how LumberLinq is working for you",
    "appFeedback.question": "How is LumberLinq working for you?",
    "appFeedback.rate.sad": "Not good",
    "appFeedback.rate.neutral": "Okay",
    "appFeedback.rate.happy": "Good",
    "appFeedback.rate.love": "Love it",
    "appFeedback.likeLabel": "What do you like most?",
    "appFeedback.improveLabel": "What should we improve?",
    "appFeedback.privateNote": "Only the LumberLinq team sees this.",
    "appFeedback.showSection": "On our website",
    "appFeedback.showName": "Show my name on the LumberLinq website",
    "appFeedback.showNameHint": "Shown as first name + initial, e.g. \"Sanjay B.\", after our team approves it.",
    "appFeedback.showCompany": "Also show my company name",
    "appFeedback.showCompanyHint": "Off unless you turn it on.",
    "appFeedback.send": "Send Feedback",
    "appFeedback.back": "Back",
    "appFeedback.thanksTitle": "Thank you!",
    "appFeedback.thanksBody": "Your feedback has reached our team.",
    "appFeedback.error": "Could not send your feedback. Please try again.",
    "appFeedback.promptTitle": "How's LumberLinq working for you?",
    "appFeedback.promptBody": "One tap — it helps us make it better.",
    "appFeedback.notNow": "Not now",
    "appFeedback.done": "Done",
    "appFeedback.chooseRating": "Pick how you feel first",
    "adminFeedback.title": "Feedback Review",
    "pay.offlineOr": "or",
    "pay.offlineProofLabel": "Proof of payment (optional)",
    "pay.offlineProofChoose": "Choose a photo or PDF",
    "pay.offlineProofHint": "A screenshot of the transfer or a photo of the cheque helps us confirm faster. JPG, PNG, WEBP, HEIC or PDF, up to 8 MB.",
    "pay.offlineProofAttach": "Attach proof",
    "pay.offlineProofReplace": "Replace proof",
    "pay.offlineProofSavedTitle": "Proof saved",
    "pay.offlineProofSavedBody": "We will see it when we check your payment.",
    "pay.offlineProofError": "Your payment is saved, but the proof could not be uploaded. Try again from the waiting card.",
    "pay.offlineProofBadTypeTitle": "File not allowed",
    "pay.offlineProofBadType": "Choose a photo (JPG, PNG, WEBP, HEIC) or a PDF.",
    "pay.offlineProofTooBigTitle": "File too big",
    "pay.offlineProofTooBig": "The file must be 8 MB or smaller.",
    "adminOffline.viewProof": "View proof",
    "adminOffline.noProof": "No proof attached",
    "adminOffline.proofTitle": "Proof of payment",
    "adminOffline.proofHint": "This is what the customer says they paid. Always confirm the money in your bank statement before approving.",
    "adminOffline.extra": "Extra",
    "adminOffline.overWarn": "More than the amount due. Extra",
    "pay.offlineTurnOffAuto": "Turn off Auto renewal above to pay by bank transfer or cheque.",
    "pay.offlineNotForMonthly": "Monthly plans renew automatically, so bank transfer or cheque is not available. Choose a longer plan to use it.",
    "pay.offlineButton": "Pay by bank transfer / cheque (INR)",
    "pay.offlineWaitingTitle": "Your payment is waiting for confirmation",
    "pay.offlineWaitingBody": "We check the bank and switch your plan on. You will get a message as soon as it is done.",
    "pay.offlineTitle": "Pay by bank transfer / cheque",
    "pay.offlineAmountToPay": "Amount to pay",
    "pay.offlineAmountHint": "This includes GST and your coupon discount. Please pay exactly this amount.",
    "pay.offlineAccountName": "Account name",
    "pay.offlineBank": "Bank",
    "pay.offlineAccountNumber": "Account number",
    "pay.offlineBranch": "Branch",
    "pay.offlineChequeTo": "Cheque payable to",
    "pay.offlineChequeAddress": "Send the cheque to",
    "pay.offlineRemarks": "Write in remarks",
    "pay.offlineRemarksHint": "Write this reference in the payment remarks (or on the back of the cheque) so we can find your payment.",
    "pay.offlineIPaid": "I have paid — enter the details",
    "pay.offlineHowPaid": "How did you pay?",
    "pay.offlineUtr": "UTR number of the transfer",
    "pay.offlineChequeNo": "Cheque number",
    "pay.offlineRefError": "Enter the UTR / cheque number (at least 4 characters).",
    "pay.offlineTransferDate": "Date of the transfer",
    "pay.offlineChequeDate": "Date on the cheque",
    "pay.offlineYourBank": "Your bank (optional)",
    "pay.offlineNote": "Note for us (optional)",
    "pay.offlineGstHint": "Your GST invoice is sent to you when the payment is confirmed.",
    "pay.offlineCancel": "Cancel",
    "pay.offlineSubmit": "Submit payment details",
    "pay.offlineSentTitle": "Details received",
    "pay.offlineSentBody": "We will confirm your payment and switch your plan on. You will get a message.",
    "pay.offlineLoadError": "Could not load the bank details. Please try again.",
    "pay.offlineSubmitError": "We could not save your payment details. Nothing was charged — please try again.",
    "adminOffline.title": "Offline Payments",
    "lincLearning.title": "Linc Learning",
    "lincLearning.subtitle": "Questions the Assistant got wrong, and the rule changes waiting for your approval",
    "lincLearning.tabFindings": "Failed questions",
    "lincLearning.tabProposals": "Proposals",
    "lincLearning.tabRuleBook": "Rule book",
    "lincLearning.grade.OK": "Correct",
    "lincLearning.grade.PART": "Partly right",
    "lincLearning.grade.WRONG": "Wrong",
    "lincLearning.grade.NONE": "No answer",
    "lincLearning.allGrades": "All results",
    "lincLearning.allRuns": "All check runs",
    "lincLearning.handledAll": "Handled or not",
    "lincLearning.handledYes": "Handled",
    "lincLearning.handledNo": "Not handled",
    "lincLearning.search": "Search question or group",
    "lincLearning.colQuestion": "Question",
    "lincLearning.colAnswer": "Answer given",
    "lincLearning.colTrue": "True answer",
    "lincLearning.colNote": "Note",
    "lincLearning.markHandled": "Mark handled",
    "lincLearning.unmark": "Mark not handled",
    "lincLearning.prev": "Previous",
    "lincLearning.next": "Next",
    "lincLearning.page": "Page",
    "lincLearning.empty": "Nothing here.",
    "lincLearning.kind.WORD": "Trade word",
    "lincLearning.kind.ASK_BACK": "Ask back",
    "lincLearning.kind.DEFINITION": "Definition",
    "lincLearning.kind.NEW_DATA": "New data needed",
    "lincLearning.kind.OTHER": "Other",
    "lincLearning.status.PROPOSED": "Waiting",
    "lincLearning.status.APPROVED": "Approved",
    "lincLearning.status.REJECTED": "Rejected",
    "lincLearning.approve": "Approve",
    "lincLearning.reject": "Reject",
    "lincLearning.undo": "Put back to waiting",
    "lincLearning.noteHint": "Note (optional)",
    "lincLearning.reviewNow": "Run the review now",
    "lincLearning.reviewNote": "The review also runs by itself every second day.",
    "lincLearning.addWord": "Add a trade word",
    "lincLearning.word": "Word (for example silly)",
    "lincLearning.means": "What it means",
    "lincLearning.add": "Add",
    "lincLearning.evidence": "Questions behind this",
    "lincLearning.seen": "times asked",
    "lincLearning.companies": "companies",
    "lincLearning.source": "Source",
    "lincLearning.decidedBy": "Decided by",
    "lincLearning.termsTitle": "Trade words the Assistant knows",
    "lincLearning.defsTitle": "Written definitions",
    "lincLearning.rulebookNote": "The built-in rule book changes only with a software release. Approved trade words are added on top and take effect at once.",
    "lincLearning.done": "Saved",
    "lincLearning.failed": "Could not complete this",
    "adminOffline.subtitle": "Confirm bank transfers and cheques paid by customers",
    "adminOffline.waiting": "waiting",
    "adminOffline.bankDetails": "Bank details",
    "adminOffline.refresh": "Refresh",
    "adminOffline.noAccessTitle": "No access",
    "adminOffline.noAccessBody": "Only the payment approvers can open this page.",
    "adminOffline.search": "Search company, UTR, e-mail",
    "adminOffline.tabWaiting": "Waiting",
    "adminOffline.tabApproved": "Approved",
    "adminOffline.tabRejected": "Rejected",
    "adminOffline.tabReversed": "Reversed",
    "offlineHist.bannerTitle": "Your payment is waiting to be confirmed",
    "offlineHist.bannerBody": "Your plan starts as soon as it is confirmed, and we will email you.",
    "offlineHist.viewDetails": "Details",
    "offlineHist.withdraw": "Withdraw",
    "offlineHist.withdrawTitle": "Withdraw this payment?",
    "offlineHist.withdrawConfirm": "Use this if you typed a wrong UTR or cheque number, or paid another way. The payment will not be confirmed, and you can submit it again.",
    "offlineHist.withdrawYes": "Yes, withdraw",
    "offlineHist.withdrawNo": "Keep it",
    "offlineHist.withdrawnTitle": "Payment withdrawn",
    "offlineHist.withdrawnBody": "You can submit your payment details again or pay online.",
    "offlineHist.withdrawError": "We could not withdraw the payment. Please try again.",
    "offlineHist.title": "Bank transfer and cheque payments",
    "offlineHist.subtitle": "Payments you reported for your company",
    "offlineHist.submitted": "Submitted",
    "offlineHist.reason": "Reason",
    "offlineHist.statusWaiting": "Waiting for confirmation",
    "offlineHist.statusConfirmed": "Confirmed",
    "offlineHist.statusRejected": "Not confirmed",
    "offlineHist.statusReversed": "Reversed",
    "offlineHist.statusWithdrawn": "Withdrawn",
    "offlineHist.buyBlocked": "A bank transfer / cheque payment is waiting for confirmation. You can choose another plan after it is confirmed, not confirmed or withdrawn.",
    "adminOffline.tabWithdrawn": "Withdrawn",
    "adminOffline.otherPlanWarn": "This company already got another active plan after this payment was submitted:",
    "adminOffline.otherPlanConfirm": "I checked this and still want to approve (a second plan will be added)",
    "adminOffline.colCompany": "Company",
    "adminOffline.colPayment": "Payment",
    "adminOffline.colAmount": "Amount",
    "adminOffline.colPlan": "Plan",
    "adminOffline.colStatus": "Status",
    "adminOffline.colSubmitted": "Submitted",
    "adminOffline.received": "Received",
    "adminOffline.shortBy": "Short by",
    "adminOffline.approve": "Approve",
    "adminOffline.reject": "Reject",
    "adminOffline.reverse": "Reverse",
    "adminOffline.cancel": "Cancel",
    "adminOffline.save": "Save",
    "adminOffline.emptyTitle": "Nothing here",
    "adminOffline.emptyBody": "Payments that customers submit by bank transfer or cheque will show up here.",
    "adminOffline.approveTitle": "Approve payment",
    "adminOffline.dateOnPayment": "Date",
    "adminOffline.amountDue": "Amount due",
    "adminOffline.checkStatement": "Check your bank statement first. Approve only when the money has reached the bank.",
    "adminOffline.receivedAmount": "Amount received in the bank",
    "adminOffline.shortWarn": "Less than the amount due. Short by",
    "adminOffline.acceptShort": "Accept the short payment (for example, tax deducted at source)",
    "adminOffline.note": "Note",
    "adminOffline.approvedOk": "Payment approved. The plan is active.",
    "adminOffline.rejectTitle": "Reject payment",
    "adminOffline.rejectReason": "Reason",
    "adminOffline.rejectHint": "The customer sees this reason.",
    "adminOffline.rejectedOk": "Payment rejected. The customer was told.",
    "adminOffline.reverseTitle": "Reverse payment (bounced cheque / refund)",
    "adminOffline.chooseOption": "Choose what happens to the plan",
    "adminOffline.optDeactivate": "Deactivate the plan now",
    "adminOffline.optDeactivateSub": "The company loses the paid plan at once.",
    "adminOffline.optGrace": "Give a grace period",
    "adminOffline.optGraceSub": "The plan stays active for 7, 15 or 30 more days, then ends.",
    "adminOffline.optKeep": "Keep the plan active",
    "adminOffline.optKeepSub": "Only record the reversal. You settle it with the customer.",
    "adminOffline.optRefund": "Refund and deactivate",
    "adminOffline.optRefundSub": "Record the refund you paid and end the plan now.",
    "adminOffline.graceDays": "Grace period (days)",
    "adminOffline.refundAmount": "Refund amount",
    "adminOffline.refundRef": "Bank reference of the refund",
    "adminOffline.creditNoteNo": "Credit note number (optional)",
    "adminOffline.creditNoteHint": "The app does not make credit notes. Enter the number once your finance team has issued it.",
    "adminOffline.commissionWarn": "Affiliate commission is not reversed automatically. Check it by hand.",
    "adminOffline.reversedOk": "Payment reversed. The customer was told.",
    "adminOffline.optionOn": "Offer this option to customers",
    "adminOffline.optionOnHint": "Customers see it on the payment page for INR plans, once all required fields are filled.",
    "adminOffline.accountName": "Account name",
    "adminOffline.bank": "Bank",
    "adminOffline.accountNumber": "Account number",
    "adminOffline.branch": "Branch",
    "adminOffline.chequePayableTo": "Cheque payable to",
    "adminOffline.chequeAddress": "Address to send cheques",
    "adminOffline.instructions": "Extra instructions for customers",
    "adminOffline.lastUpdated": "Last changed by",
    "adminOffline.settingsSaved": "Bank details saved",
    "adminOffline.errorTitle": "Could not complete",
    "adminOffline.errorGeneric": "Something went wrong. Please try again.",
    "adminFeedback.subtitle": "Approve feedback before it appears on lumberlinq.com",
    "adminFeedback.pending": "Pending",
    "adminFeedback.approved": "Approved",
    "adminFeedback.rejected": "Rejected",
    "adminFeedback.approve": "Approve",
    "adminFeedback.reject": "Reject",
    "adminFeedback.reset": "Move to Pending",
    "adminFeedback.colPerson": "Person",
    "adminFeedback.colRating": "Rating",
    "adminFeedback.colFeedback": "Feedback",
    "adminFeedback.colWebsite": "On website",
    "adminFeedback.colSource": "Source",
    "adminFeedback.colDate": "Date",
    "adminFeedback.sourcePublic": "Website form",
    "adminFeedback.sourceApp": "In app",
    "adminFeedback.willShowAs": "Will show as",
    "adminFeedback.notOptedIn": "Name not shown (not opted in)",
    "adminFeedback.noName": "No name given",
    "adminFeedback.emptyTitle": "Nothing here yet",
    "adminFeedback.emptyBody": "No feedback in this list.",
    "adminFeedback.liked": "Liked",
    "adminFeedback.problem": "Problem (private)",
    "adminFeedback.search": "Search name, company or text",
    "adminFeedback.statusChanged": "Feedback updated",
    "adminFeedback.loadError": "Could not load feedback",
    "adminFeedback.withCompany": "with company",
    "adminFeedback.refresh": "Refresh",
    "appSettings.feedbackSection": "Feedback & App Store Ratings",
    "appSettings.feedbackPromptEnabled": "Ask users for feedback in the app",
    "appSettings.feedbackPromptHint": "Shows a small \"How's LumberLinq working for you?\" card on the Dashboard. Answers go to Feedback Review, never to the app stores.",
    "appSettings.feedbackPromptAfterDays": "Ask after (days since sign-up)",
    "appSettings.feedbackPromptRepeatDays": "Don't ask again for (days)",
    "appSettings.storeReviewEnabled": "Request App Store / Play Store rating",
    "appSettings.storeReviewHint": "Uses Apple's and Google's own rating popup on iPhone and Android. Triggered by usage only — never linked to the feedback card.",
    "appSettings.storeReviewAfterTallies": "After this many tally sheets",
    "appSettings.storeReviewAfterDays": "Or after (days since sign-up)",
    "notifPrefs.pushStatusTitle": "Push Notifications",
    "notifPrefs.pushGrantedHint": "Push notifications are turned on for this device.",
    "notifPrefs.pushPromptHint": "Turn on notifications to get alerts on this device.",
    "notifPrefs.pushDeniedNativeHint": "Notifications are turned off for this device.",
    "notifPrefs.pushDeniedWebHint": "Notifications are blocked for this site — enable them in your browser's settings.",
    "notifPrefs.pushUnsupportedHint": "This device or browser doesn't support push notifications.",
    "notifPrefs.pushEnableButton": "Enable",
    "notifPrefs.openSettingsButton": "Open Settings",
    "notifPrefs.teamInvites": "Team invites",
    "notifPrefs.teamInvites.hint": "When someone invites you to a team, or your invite is accepted or declined.",
    "notifPrefs.security": "Security alerts",
    "notifPrefs.security.hint": "Login and account security notices. Critical alerts, like a password change, are always sent regardless of this setting.",
    "notifPrefs.billing": "Billing & payments",
    "notifPrefs.billing.hint": "Subscription renewals, payment reminders, invoices, and bank transfer / cheque payment updates.",
    "notifPrefs.shipments": "Shipments",
    "notifPrefs.shipments.hint": "Updates on your shipments and consignments.",
    "notifPrefs.tally": "Tally sheets",
    "notifPrefs.tally.hint": "Updates on tally sheets you're working on.",
    "notifPrefs.inventoryProcess": "Inventory & mill jobs",
    "notifPrefs.inventoryProcess.hint": "Stock movements and mill job updates.",
    "notifPrefs.masterData": "Products, partners & locations",
    "notifPrefs.masterData.hint": "Changes to products, business partners, or locations.",
    "notifPrefs.shareLinks": "Shared links",
    "notifPrefs.shareLinks.hint": "Activity on links you've shared with others.",
    "notifPrefs.affiliate": "Affiliate program",
    "notifPrefs.affiliate.hint": "Application status, commissions, and payouts for your affiliate account.",
    "notifPrefs.crm": "Sales CRM",
    "notifPrefs.crm.hint": "Leads assigned to you, task reminders, replies, commission and payout updates, and target milestones.",
    "common.typeConfirm": "Type CONFIRM to proceed",
    "paymentReminders.offBanner": "Payment Reminders is off — these settings are saved but won't take effect until you turn it on above.",
    "settingsNudge.title": "Finish setting up your workspace",
    "settingsNudge.body": "Currency, branding, payment reminders and more — all in one place.",
    "settingsNudge.cta": "Open Application Settings",
    "paymentReminders.testEmail.title": "Send test emails",
    "paymentReminders.testEmail.desc": "Preview the exact reminder + report format before turning this on for real Business Partners. Never touches live data.",
    "paymentReminders.testEmail.cta": "Send Test",
    "Mill Jobs": "Mill Jobs",
    "Stock in Hand": "Stock in Hand",
    "crm.liveCall.button": "Video call",
    "crm.liveCall.title": "Video call",
    "crm.liveCall.starting": "Starting the call…",
    "crm.liveCall.startFailed": "Could not start the call.",
    "crm.liveCall.retry": "Try again",
    "crm.liveCall.inProgress": "A call is in progress.",
    "crm.liveCall.rejoin": "Rejoin",
    "crm.liveCall.end": "End call",
    "crm.liveCall.endConfirm": "End the call for everyone?",
    "crm.liveCall.openTab": "Open in a new tab",
    "crm.liveCall.frameHint": "If the call does not show here, open it in a new tab.",
    "crm.liveCall.inviteTitle": "Invite a guest",
    "crm.liveCall.makeLink": "Make guest link",
    "crm.liveCall.newLink": "Make a new link",
    "crm.liveCall.copyLink": "Copy",
    "crm.liveCall.linkCopied": "Copied",
    "crm.liveCall.newLinkNote": "Making a new link stops the old one from working. The link works for a few hours.",
    "crm.liveCall.cancelLink": "Cancel link",
    "crm.liveCall.linkCancelled": "The guest link no longer works.",
    "crm.liveCall.whoJoined": "Who joined",
    "crm.liveCall.noOneJoined": "Nobody has joined through the link yet.",
    "crm.liveCall.admitNote": "Every guest waits until you let them in: press Admit in the call. Guests cannot send files unless you allow it in the call settings.",
    "crm.liveCall.codeNote": "A link sent by e-mail also needs a 6-digit code that goes to that same address, so a forwarded link is of no use. Do not forward a link you copied yourself either.",
    "crm.liveCall.emailPlaceholder": "Guest e-mail",
    "crm.liveCall.sendEmail": "Send by e-mail",
    "crm.liveCall.emailSent": "The invitation was sent.",
    "crm.liveCall.enterEmail": "Enter the guest's e-mail address.",
    "crm.liveCall.phoneNote": "To present your screen, use a computer. Phones can join and talk.",
    "live.title": "Join the video call",
    "live.host": "Host",
    "live.name": "Your name",
    "live.email": "Your e-mail",
    "live.join": "Join the call",
    "live.joining": "Joining…",
    "live.loading": "Loading…",
    "live.privacy": "We use your name and e-mail only for this call. The call is not recorded.",
    "live.phoneNote": "You can join from a phone. Allow the camera and microphone when asked.",
    "live.linkOnly": "This link is for you only. Please do not forward it.",
    "live.waitNote": "After you join, the host lets you in. This can take a moment.",
    "live.codeIntro": "To make sure it is you, we send a 6-digit code to the address your invitation went to:",
    "live.sendCode": "Send me a code",
    "live.sendAgain": "Send again",
    "live.codeSent": "Code sent. It works for 10 minutes.",
    "live.codeLabel": "6-digit code",
    "cw.focusOn": "Full screen: hide the top bar",
    "cw.focusOff": "Show the top bar",
    "ch.help": "Help",
    "ch.guest.title": "Having trouble joining?",
    "ch.guest.t1": "Use a computer or a phone with a camera and a microphone. Chrome, Edge, Safari and Firefox all work.",
    "ch.guest.t2": "When your browser asks, press Allow for the camera and the microphone.",
    "ch.guest.t3": "After you press Join, the host has to let you in. Please wait a moment.",
    "ch.guest.t4": "No picture or sound? Click the camera or lock icon in the address bar, choose Allow, then refresh the page.",
    "ch.guest.t5": "Stuck on \"Starting the call…\"? Check your internet, then press Retry or Open in a new tab.",
    "ch.guest.t6": "This link is for you only. If someone else needs to join, ask the LumberLinq team to invite them.",
    "ch.customer.title": "How screen support works",
    "ch.customer.t1": "Support asks to see your screen. Nothing starts until you press the share button yourself.",
    "ch.customer.t2": "Choose the LumberLinq tab only. Do not choose your whole screen or another window.",
    "ch.customer.t3": "Support can only look. They cannot click or type for you, and nothing is recorded.",
    "ch.customer.t4": "Press Stop at the top whenever you want to end it. A phone or the app cannot share a screen: use Chrome or Edge on a computer.",
    "ch.host.title": "Video call playbook",
    "ch.host.t1": "Start the call from the account or the deal. You join as the host.",
    "ch.host.t2": "Sending the link by e-mail is safest: the guest needs a 6-digit code that goes to that address.",
    "ch.host.t3": "Every guest waits until you press Admit in the call. Admit only people you know.",
    "ch.host.t4": "See \"Who joined\" below. If somebody unknown is in, remove them in the call and press Cancel link.",
    "ch.host.t5": "Never forward a guest link yourself. Make a new link for each person.",
    "ch.host.t6": "Press End call when you finish. A Video call entry is added to the account timeline. Nothing is recorded.",
    "ch.check.run": "Check my setup",
    "ch.check.testing": "Testing…",
    "ch.check.browserOk": "This browser can join a call.",
    "ch.check.browserBad": "This browser cannot join a call. Use Chrome, Edge, Safari or Firefox.",
    "ch.check.onlineOk": "Your internet is connected.",
    "ch.check.onlineBad": "You seem to be offline. Check your internet.",
    "ch.check.camOk": "Camera works.",
    "ch.check.camBad": "Camera is blocked or not found. Allow it in the address bar, then test again.",
    "ch.check.micOk": "Microphone works.",
    "ch.check.micBad": "Microphone is blocked or not found. Allow it in the address bar, then test again.",
    "ch.check.shareOk": "You can share your screen.",
    "ch.check.shareNo": "This device cannot share a screen (phones and the app cannot). You can still talk and chat.",
    "live.ended": "This call has ended.",
    "live.expired": "This link has expired. Please ask for a new one.",
    "live.off": "Video calls are switched off right now.",
    "live.invalid": "This link is not valid.",
    "live.failed": "Could not join. Please try again.",
    "live.securityWait": "Please complete the security check.",
    "live.frameHint": "If the call does not show here, open it in a new tab.",
    "live.openTab": "Open in a new tab",
    "ss.title": "Screen support",
    "ss.joining": "Connecting…",
    "ss.failed": "Could not connect. Please try again.",
    "ss.retry": "Try again",
    "ss.howTitle": "How to share your LumberLinq tab",
    "ss.step1": "Press the screen-share button (the monitor icon) at the bottom of the call.",
    "ss.step2": "Choose the tab called LumberLinq (\"This tab\"). Do not choose a window or your whole screen.",
    "ss.step3": "You can stop at any time with your browser's Stop sharing button, or press Stop session here.",
    "ss.noShare": "Screen sharing does not work on a phone or in the app. Open LumberLinq in a computer browser (Chrome, Edge, Firefox or Safari) to share your LumberLinq tab. You can still talk and chat with support here.",
    "ss.liveBanner": "Support can see only the tab you choose to share. Nothing is recorded.",
    "ss.stop": "Stop session",
    "ss.stopConfirm": "Stop this screen support session?",
    "ss.openTab": "Open in a new tab",
    "ss.frameHint": "If the call does not show here, open it in a new tab.",
    "ss.tabOnly": "Only your LumberLinq browser tab is shared, nothing else.",
    "ss.card.title": "Screen support",
    "ss.card.ask": "Ask support to see my LumberLinq tab",
    "ss.card.askHint": "Support can look at your LumberLinq browser tab to help you. Only that tab is shared, you choose to start it, and you can stop at any time. Nothing is recorded.",
    "ss.card.waiting": "Waiting for support to answer…",
    "ss.card.cancel": "Cancel request",
    "ss.card.invited": "Support would like to see your LumberLinq tab.",
    "ss.card.invitedOther": "Support asked another person of your company to share their screen.",
    "ss.card.share": "Share my LumberLinq tab",
    "ss.card.notNow": "Not now",
    "ss.card.live": "A screen support session is open.",
    "ss.card.liveOther": "A screen support session is open with another person of your company.",
    "ss.card.rejoin": "Open session",
    "ss.card.ended": "The last screen support session ended.",
    "ss.card.declined": "The last screen support request was declined.",
    "ss.card.expired": "The last screen support request expired.",
    "ss.card.requestFailed": "Could not send the request.",
    "ss.prompt.title": "Support would like to see your screen",
    "ss.prompt.body": "Support is waiting for you. You choose to start it and you can stop at any time. Nothing is recorded.",
    "ss.prompt.open": "Open now",
    "ss.prompt.later": "Not now",
    "ss.prompt.ticket": "Open the ticket",
  },
  hi: {
    "crmwa.newNumbers": "नए नंबर",
    "crmwa.newNumbersHint": "वे लोग जिन्होंने CRM में सेव न किए गए नंबर से आपको संदेश भेजा।",
    "crmwa.tabNew": "प्रतीक्षा में",
    "crmwa.tabBlocked": "ब्लॉक किए गए",
    "crmwa.searchPlaceholder": "नाम या नंबर खोजें…",
    "crmwa.firstMessage": "पहला संदेश",
    "crmwa.lastMessage": "ताज़ा",
    "crmwa.noName": "नाम साझा नहीं किया",
    "crmwa.notSaved": "अभी आपके CRM में नहीं है",
    "crmwa.createLead": "लीड बनाएँ",
    "crmwa.block": "स्पैम के रूप में ब्लॉक करें",
    "crmwa.unblock": "अनब्लॉक करें",
    "crmwa.blockedBadge": "ब्लॉक",
    "crmwa.leadBadge": "लीड बन गई",
    "crmwa.openChat": "चैट खोलें",
    "crmwa.emptyTitle": "कोई नया नंबर नहीं",
    "crmwa.emptySub": "जब कोई नया व्यक्ति आपके WhatsApp नंबर पर संदेश भेजेगा, वह आपकी समीक्षा के लिए यहाँ दिखेगा। सेव किए गए संपर्क यहाँ कभी नहीं दिखते।",
    "crmwa.emptyBlockedTitle": "कोई ब्लॉक किया हुआ नंबर नहीं",
    "crmwa.emptyBlockedSub": "स्पैम के रूप में ब्लॉक किए गए नंबर यहाँ दिखते हैं, ताकि आप कभी भी उन्हें अनब्लॉक कर सकें।",
    "crmwa.selectTitle": "एक नंबर चुनें",
    "crmwa.selectSub": "पढ़ें कि उन्होंने क्या लिखा, फिर लीड बनाएँ या नंबर ब्लॉक करें।",
    "crmwa.whatTheyWrote": "उन्होंने क्या लिखा",
    "crmwa.blockedNote": "इस नंबर के संदेश अनदेखे किए जाते हैं। नए संदेश देखने के लिए अनब्लॉक करें।",
    "crmwa.blockConfirmTitle": "यह नंबर ब्लॉक करें?",
    "crmwa.blockConfirmSub": "इससे आने वाले नए संदेश अनदेखे होंगे। आप इसे बाद में \"ब्लॉक किए गए\" टैब से अनब्लॉक कर सकते हैं।",
    "crmwa.cancel": "रद्द करें",
    "crmwa.blockConfirm": "हाँ, ब्लॉक करें",
    "crmwa.blockedToast": "नंबर ब्लॉक हो गया",
    "crmwa.unblockedToast": "नंबर अनब्लॉक हो गया",
    "crmwa.leadCreatedToast": "लीड बन गई",
    "crmwa.leadCreatedSub": "चैट अब आपके इनबॉक्स में है।",
    "crmwa.errorTitle": "कुछ गड़बड़ हुई",
    "crmwa.loadError": "नंबर लोड नहीं हो सके।",
    "crmwa.sheetTitle": "लीड बनाएँ",
    "crmwa.sheetSub": "इस WhatsApp नंबर को ऐसी लीड बनाएँ जिस पर आपकी टीम फ़ॉलो-अप कर सके।",
    "crmwa.fldName": "व्यक्ति का नाम",
    "crmwa.fldNameHint": "उनकी WhatsApp प्रोफ़ाइल से। आप इसे सुधार सकते हैं।",
    "crmwa.fldCompany": "कंपनी (वैकल्पिक)",
    "crmwa.fldCompanyHint": "खाली छोड़ें तो उनका नाम और नंबर इस्तेमाल होगा।",
    "crmwa.fldOwner": "लीड का मालिक",
    "crmwa.ownerOnlyYou": "यह लीड आपकी होगी।",
    "crmwa.fldNote": "नोट (वैकल्पिक)",
    "crmwa.notePlaceholder": "टीम को जो जानना चाहिए…",
    "crmwa.accountWillBe": "खाते का नाम",
    "crmwa.contactWillBe": "संपर्क",
    "crmwa.you": "आप",
    "crmwa.creating": "बना रहे हैं…",
    "crmwa.whatHappens": "इससे एक खाता, इस मोबाइल नंबर वाला संपर्क और एक डील बनती है, और चैट आपके इनबॉक्स में आ जाती है।",
    "crmwa.close": "बंद करें",
    "crmwa.mobile": "मोबाइल",
    "crmwa.pickOwner": "चुनें कि इस लीड का मालिक कौन होगा",
    "crmwa.freeTextNote": "उनके आख़िरी संदेश के बाद 24 घंटे तक आप सामान्य टेक्स्ट से जवाब दे सकते हैं।",
    "crmai.headerBtn": "Linc AI",
    "crmai.barOn": "Linc AI इस चैट का जवाब दे रहा है",
    "crmai.barSuggest": "Linc AI आपके लिए सुझाए गए जवाब लिखता है",
    "crmai.barPaused": "यह चैट आपके पास है। Linc AI कुछ समय के लिए चुप रहेगा।",
    "crmai.barHandoff": "Linc AI ने यह चैट आपको सौंप दी है।",
    "crmai.barStopped": "इस चैट में Linc AI बंद है।",
    "crmai.stoppedSpam": "यह स्पैम जैसा लगा।",
    "crmai.stoppedFlood": "ग्राहक ने बहुत तेज़ी से बहुत ज़्यादा संदेश भेजे।",
    "crmai.stoppedPerson": "इसे यहाँ बंद किया गया था।",
    "crmai.takeOver": "मैं संभालूँगा/संभालूँगी",
    "crmai.stop": "यहाँ AI बंद करें",
    "crmai.handBack": "Linc AI को जवाब देने दें",
    "crmai.draftTitle": "Linc AI का सुझाव",
    "crmai.draftHandoff": "Linc AI को लगता है कि किसी व्यक्ति को संभालना चाहिए",
    "crmai.draftUse": "यह जवाब इस्तेमाल करें",
    "crmai.draftDiscard": "हटाएँ",
    "crmai.takeOverToast": "इस चैट में Linc AI चुप रहेगा",
    "crmai.stopToast": "इस चैट में Linc AI बंद हो गया",
    "crmai.handBackToast": "Linc AI फिर से जवाब देगा",
    "crmai.settings": "Linc AI जवाब",
    "crmai.settingsSub": "चुनें कि Linc AI किसके लिए और कैसे जवाब दे।",
    "crmai.master": "मुख्य स्विच",
    "crmai.masterHint": "बंद का मतलब है कि Linc AI किसी को कुछ नहीं लिखेगा।",
    "crmai.modeOff": "बंद",
    "crmai.modeSuggest": "सुझाव",
    "crmai.modeAuto": "ऑटो",
    "crmai.modeSuggestHint": "Linc AI ड्राफ़्ट लिखता है। कोई व्यक्ति देखकर भेजता है।",
    "crmai.modeAutoHint": "Linc AI खुद जवाब देता है और ज़रूरत पड़ने पर सौंप देता है।",
    "crmai.team": "सेल्स टीम",
    "crmai.teamHint": "Linc AI उन खातों की चैट का जवाब देता है जिनके मालिक सुझाव या ऑटो पर हैं।",
    "crmai.unowned": "बिना मालिक वाली चैट",
    "crmai.coreLocked": "इसे केवल सुपर एडमिन या रूट बदल सकते हैं।",
    "crmai.limits": "सीमाएँ",
    "crmai.maxInRow": "लगातार Linc AI संदेश, फिर सौंपना",
    "crmai.maxPerHour": "प्रति घंटे अधिकतम Linc AI संदेश",
    "crmai.maxPerDay": "प्रति दिन अधिकतम Linc AI संदेश",
    "crmauto.chip": "अप्रमाणित",
    "crmauto.chipTip": "WhatsApp संदेश से अपने आप जोड़ा गया। नाम और नंबर जाँचें, फिर Confirm दबाएँ।",
    "crmauto.confirm": "संपर्क की पुष्टि करें",
    "crmauto.confirmTip": "मैंने यह संपर्क जाँच लिया है",
    "crmauto.confirmedTitle": "पुष्टि हो गई",
    "crmauto.confirmedText": "अप्रमाणित टैग हट गया।",
    "crmauto.settingTitle": "नए WhatsApp नंबर अपने आप जोड़ें",
    "crmauto.settingHint": "जब कोई नया व्यक्ति WhatsApp पर लिखे तो उसे अपने आप संपर्क के रूप में जोड़ें (अप्रमाणित टैग के साथ), ताकि Linc AI जवाब दे सके। स्पैम, बाढ़ और ब्लॉक किए गए नंबर कभी नहीं जोड़े जाते। इसे केवल Super Admin या Root बदल सकते हैं।",
    "crmauto.settingSwitch": "नए नंबर अपने आप जोड़ें",
    "crmauto.perDay": "प्रतिदिन अपने आप जोड़े जाने वाले अधिकतम संपर्क",
    "legal.bannerTitleUpdated": "कानूनी दस्तावेज़ अपडेट हुए हैं।",
    "legal.bannerLeadUpdated": "हमने अपडेट किया है:",
    "legal.bannerTitleNew": "कृपया हमारे कानूनी दस्तावेज़ स्वीकार करें।",
    "legal.bannerLeadNew": "कृपया देखें:",
    "legal.dialogTitleUpdated": "अपडेट किए गए कानूनी दस्तावेज़",
    "legal.dialogTitleNew": "कानूनी दस्तावेज़",
    "legal.dialogBodyUpdated": "हमने नीचे दिए दस्तावेज़ अपडेट किए हैं। कृपया उन्हें पढ़ें और जारी रखने के लिए पुष्टि करें।",
    "legal.dialogBodyNew": "कृपया नीचे दिए दस्तावेज़ पढ़ें और जारी रखने के लिए पुष्टि करें।",
    "invite.acceptTitle": "इस कंपनी से जुड़ें",
    "invite.acceptText": "जुड़ने से पहले कृपया सहमति की पुष्टि करें।",
    "invite.acceptButton": "आमंत्रण स्वीकार करें",
    "pay.offlineLive": "यह पेज अपने आप अपडेट होता है।",
    "pay.cardPaused": "आपका बैंक ट्रांसफर प्रतीक्षा में है, इसलिए कार्ड भुगतान रोका गया है।",
    "pay.outcomeApprovedTitle": "आपका भुगतान पक्का हो गया",
    "pay.outcomeApprovedBody": "आपका प्लान अब चालू है। LumberLinq का उपयोग शुरू करने के लिए आगे बढ़ें।",
    "pay.outcomeContinue": "आगे बढ़ें",
    "pay.outcomeRejectedTitle": "आपका भुगतान पक्का नहीं हो सका",
    "pay.outcomeReversedTitle": "आपका भुगतान उलट दिया गया",
    "pay.outcomeTryAgainBody": "आप इसे दोबारा जमा कर सकते हैं या दूसरे तरीके से भुगतान कर सकते हैं।",
    "pay.outcomeTryAgain": "फिर से भुगतान करें",
    "sp.seePlans": "प्लान देखें",
    "sp.backToWaiting": "मेरे भुगतान पर वापस",
    "sp.yourSelection": "आपका चयन",
    "adminOffline.waTemplate": "स्वीकृति पर WhatsApp संदेश: टेम्पलेट का नाम",
    "adminOffline.waTemplateLang": "टेम्पलेट की भाषा (जैसे en या hi)",
    "adminOffline.waValues": "उस टेम्पलेट में मानों का क्रम (अल्पविराम से: name, plan, amount, company, date, reference, method)",
    "adminOffline.waRejectedTemplate": "भुगतान की पुष्टि न होने पर टेम्पलेट का नाम",
    "adminOffline.waRejectedLang": "उस टेम्पलेट की भाषा",
    "adminOffline.waPlanEndingTemplate": "प्लान खत्म होने से 3 दिन पहले टेम्पलेट का नाम",
    "adminOffline.waPlanEndingLang": "उस टेम्पलेट की भाषा",
    "adminOffline.waValuesHint": "ऊपर का हर संदेश तभी जाता है जब उसका टेम्पलेट नाम भरा हो और Meta से स्वीकृत हो। भाषा वैसी ही लिखें जैसी Meta दिखाता है (en या en_US)।",
    "adminOffline.waTemplateHint": "Meta द्वारा स्वीकृत UTILITY टेम्पलेट का नाम, तीन वेरिएबल के साथ: पहला नाम, प्लान, राशि। WhatsApp संदेश न भेजने के लिए खाली छोड़ें। ग्राहक को पुश और ई-मेल हमेशा मिलता है।",
    "sp.seeAll": "सभी सुविधाएँ देखें",
    "sp.showLess": "कम दिखाएँ",
    "sp.chooseHint": "आगे बढ़ने के लिए एक प्लान चुनें",
    "pay.billingIncomplete": "कृपया लाल रंग में चिह्नित बिलिंग विवरण पूरे करें।",
    "pay.termsNotSaved": "हम शर्तों पर आपकी सहमति सहेज नहीं सके। कृपया फिर कोशिश करें।",
    "pay.reviewAndPay": "देखें और भुगतान करें",
    "crmai.timing": "समय",
    "crmai.delay": "जवाब देने से पहले प्रतीक्षा (सेकंड)",
    "crmai.pause": "किसी व्यक्ति के जवाब के बाद चुप्पी (घंटे)",
    "crmai.offTitle": "जब Linc AI बंद हो",
    "crmai.offHint": "ग्राहकों को इसके बजाय यह संदेश मिलता है, हर चैट में एक शांत अवधि में अधिकतम एक बार।",
    "crmai.offSwitch": "Linc AI बंद होने पर यह संदेश भेजें",
    "crmai.offText": "संदेश",
    "crmai.offPlaceholder": "आपके संदेश के लिए धन्यवाद! हमारी टीम जल्द जवाब देगी।",
    "crmai.knowledge": "Linc AI क्या इस्तेमाल कर सकता है",
    "crmai.links": "लिंक जो वह साझा कर सकता है (हर पंक्ति में एक)",
    "crmai.linksPlaceholder": "कीमतें: https://…\nफ़्री ट्रायल: https://…",
    "crmai.facts": "LumberLinq के बारे में तथ्य (कीमतें नहीं)",
    "crmai.factsPlaceholder": "LumberLinq क्या करता है, किसके लिए है, ट्रायल कैसे काम करता है…",
    "crmai.helpNotes": "कैसे-करें सवालों के लिए वह आपके Linc AI Help नोट्स भी इस्तेमाल करता है।",
    "crmai.try": "ग्राहक का संदेश आज़माएँ",
    "crmai.tryPlaceholder": "लिखें कि ग्राहक क्या लिख सकता है…",
    "crmai.tryBtn": "आज़माएँ",
    "crmai.trying": "सोच रहा है…",
    "crmai.tryIntent": "समझा गया",
    "crmai.tryHandoff": "किसी व्यक्ति को सौंप देगा",
    "crmai.today": "आज",
    "crmai.statAuto": "जवाब दिए",
    "crmai.statDrafts": "ड्राफ़्ट",
    "crmai.statHandoffs": "सौंपे गए",
    "crmai.statTokens": "टोकन इस्तेमाल",
    "crmai.save": "सहेजें",
    "crmai.saving": "सहेज रहे हैं…",
    "crmai.saved": "सहेजा गया",
    "crmai.savedSub": "Linc AI सेटिंग्स अपडेट हो गईं।",
    "crmai.loadError": "Linc AI सेटिंग्स लोड नहीं हो सकीं।",
    "crmai.abuseTitle": "स्पैम और बहुत ज़्यादा संदेश",
    "crmai.abuseHint": "Linc AI किसी चैट में कुछ समय के लिए रुकता है, फिर खुद दोबारा जवाब देता है। एक हफ़्ते में दूसरी बार रुकने पर वह तब तक बंद रहता है जब तक कोई व्यक्ति उसे चालू न करे। बहुत ज़्यादा संदेश भेजने वाले ग्राहक को पहले एक विनम्र सूचना मिलती है; पक्के स्पैम को कोई सूचना नहीं मिलती।",
    "crmai.floodMinutes": "बहुत ज़्यादा संदेशों के बाद रुकना (मिनट)",
    "crmai.spamHours": "स्पैम के बाद रुकना (घंटे)",
    "crmai.floodNotice": "बहुत ज़्यादा संदेशों पर रुकने से पहले भेजी जाने वाली सूचना",
    "crmai.floodNoticePlaceholder": "खाली छोड़ें तो यह इस्तेमाल होगा: मैं अभी और संदेशों का जवाब नहीं दे सकता। अगर यह LumberLinq के बारे में है, तो हमारी टीम जल्द आपको जवाब देगी।",
    "crmai.resumesAt": "यह खुद फिर चालू होगा:",
    "crmfile.kindImage": "फ़ोटो",
    "crmfile.kindVideo": "वीडियो",
    "crmfile.kindAudio": "वॉइस संदेश",
    "crmfile.kindSticker": "स्टिकर",
    "crmfile.kindDoc": "दस्तावेज़",
    "crmfile.receiving": "प्राप्त हो रहा है…",
    "crmfile.failed": "सहेजा नहीं जा सका। देखने के लिए फ़ोन पर WhatsApp खोलें।",
    "crmfile.download": "डाउनलोड",
    "crmfile.attach": "फ़ाइल जोड़ें",
    "crmfile.tooBigImage": "फ़ोटो 5 MB तक की हो सकती है।",
    "crmfile.tooBigFile": "फ़ाइल 10 MB तक की हो सकती है।",
    "crmfile.notSent": "फ़ाइल नहीं भेजी गई",
    "crmfile.captionHint": "आपका लिखा संदेश इसके साथ जाएगा",
    "crmfile.captionPlaceholder": "फ़ाइल के साथ जाने वाला संदेश जोड़ें (वैकल्पिक)…",
    "crmfile.remove": "फ़ाइल हटाएँ",
    "crmverify.title": "WhatsApp एक्सेस मंज़ूर करें?",
    "crmverify.text": "इस WhatsApp नंबर पर कोई LumberLinq के असिस्टेंट से आपके खाते में मदद माँग रहा है:",
    "crmverify.hint": "केवल तभी मंज़ूर करें जब यह आप हों। तब वे 15 मिनट तक आपकी भूमिका के अनुसार मदद नोट्स पा सकेंगे। कुछ भी बदला नहीं जा सकता।",
    "crmverify.more": "और अनुरोध प्रतीक्षा में",
    "crmverify.approve": "मंज़ूर करें",
    "crmverify.deny": "अस्वीकार करें",
    "crmverify.approvedTitle": "मंज़ूर",
    "crmverify.approvedSub": "WhatsApp चैट अब 15 मिनट तक मदद पा सकती है।",
    "crmverify.deniedTitle": "अस्वीकृत",
    "crmverify.deniedSub": "वह नंबर एक घंटे के लिए ब्लॉक है।",
    "crmverify.expired": "यह अनुरोध समाप्त हो गया है या पहले ही निपटाया जा चुका है।",
    "crmverify.settingTitle": "WhatsApp पर ग्राहक सहायता",
    "crmverify.settingHint": "जो ग्राहक अपने खाते में मदद माँगता है उसे पहले साबित करना होगा कि वह कौन है: अपने लॉगिन ऐप में मंज़ूरी का टैप, या पंजीकृत ईमेल पर भेजा गया कोड। उसके बाद Linc AI केवल वही मदद नोट्स बताता है जो उनकी भूमिका को अनुमत हैं, और प्लान की जानकारी केवल कंपनी के Owner या Admin की ऐप-मंज़ूरी के बाद। WhatsApp पर कभी कुछ बदला नहीं जाता।",
    "crmverify.settingSwitch": "WhatsApp पर ग्राहक सहायता की अनुमति दें",
    "crmqr.button": "तैयार संदेश",
    "crmqr.title": "तैयार संदेश",
    "crmqr.sub": "आम सवालों और मार्केटिंग के लिए एक चुनें। भेजने से पहले आप इसे बदल सकते हैं।",
    "crmqr.search": "खोजें, जैसे कीमत, डेमो, ऑफ़लाइन…",
    "crmqr.all": "सभी",
    "crmqr.emptyTitle": "कोई संदेश नहीं मिला",
    "crmqr.emptySub": "दूसरे शब्द आज़माएँ या फ़िल्टर हटाएँ।",
    "crmqr.clear": "फ़िल्टर हटाएँ",
    "crmqr.hint": "ग्राहक का पहला नाम अपने आप भर जाता है। संदेश बॉक्स में आता है, और आप भेजें दबाते हैं।",
    "crmqr.cat.welcome": "स्वागत",
    "crmqr.cat.product": "प्रोडक्ट",
    "crmqr.cat.pricing": "कीमत",
    "crmqr.cat.start": "शुरुआत",
    "crmqr.cat.help": "मदद",
    "crmqr.cat.qa": "आम सवाल",
    "crmqr.cat.followup": "फ़ॉलो-अप",
    "crmqr.cat.closing": "समापन",
    "tallysheet.tu.stockAllOrigins": "सभी मूल",
    "tallysheet.tu.stockOriginUnknown": "मूल अज्ञात",
    "tallysheet.tu.pickOrigin": "मूल चुनें",
    "inventory.rowOnlyFree": "{need} में से केवल {free} उपलब्ध — ठीक करने के लिए टैप करें",
    "inventory.rowNoneFree": "कुछ भी उपलब्ध नहीं — ठीक करने के लिए टैप करें",
    "rowClash.needsOne": "पंक्ति किसी और की पंक्तियों वाली जगह पर जोड़ी गई",
    "rowClash.needsMany": "पंक्तियाँ किसी और की पंक्तियों वाली जगह पर जोड़ी गईं",
    "rowClash.prev": "पिछली टकराने वाली पंक्ति",
    "rowClash.next": "अगली टकराने वाली पंक्ति",
    "rowClash.showOnlyTip": "सिर्फ़ वे पंक्तियाँ दिखाएँ जो दो लोगों ने एक ही जगह जोड़ीं",
    "rowClash.showAll": "सभी पंक्तियाँ दिखाएँ",
    "rowClash.showOnly": "सिर्फ़ ये दिखाएँ",
    "rowClash.change": "बदलें",
    "rowClash.markCheckedTip": "सबके लिए ये निशान हटाएँ — कुछ भी हिलाया या हटाया नहीं जाएगा",
    "rowClash.markChecked": "जाँच लिया",
    "rowClash.title": "एक ही जगह जोड़ी गई पंक्तियाँ",
    "rowClash.intro": "इस शीट में दो लोगों ने एक ही जगह पंक्तियाँ जोड़ीं। दोनों सेट रखे गए हैं। क्रम चुनें, या अगर एक ही लट्ठे दो बार नापे गए तो एक सेट हटाएँ।",
    "rowClash.rows": "पंक्तियाँ:",
    "rowClash.wasThere": "पहले से थीं",
    "rowClash.wasPlaced": "उनके बाद रखी गईं",
    "rowClash.chooseLabel": "क्या करना है?",
    "rowClash.current": "अभी",
    "rowClash.cannotMove": "इनमें से एक पंक्ति से कस्टम-मेड काम जुड़ा है, इसलिए क्रम नहीं बदला जा सकता।",
    "rowClash.confirmRemove": "इससे ये पंक्तियाँ सबके लिए हट जाएँगी। यह वापस नहीं होगा। पक्का करने के लिए फिर दबाएँ।",
    "rowClash.confirmYes": "हाँ, हटाएँ",
    "rowClash.apply": "लागू करें",
    "rowClash.loadFailed": "यह टकराव लोड नहीं हो सका। कनेक्शन जाँचें और फिर कोशिश करें।",
    "rowClash.noRoom": "वहाँ पंक्तियाँ रखने की जगह नहीं है। शीट दोबारा लोड करके फिर कोशिश करें।",
    "rowClash.applyFailed": "यह लागू नहीं हो सका। शीट दोबारा लोड करके फिर कोशिश करें।",
    "rowClash.someone": "कोई",
    "rowClash.opt.mineAfter": "दोनों रखें — मेरी उनके बाद",
    "rowClash.opt.mineFirst": "दोनों रखें — मेरी पहले",
    "rowClash.opt.dropMine": "उनकी रखें, मेरी हटाएँ",
    "rowClash.opt.deleteTheirs": "मेरी रखें, उनकी हटाएँ",
    "rowClash.opt.firstThen": "दोनों रखें — पहले {first} की पंक्तियाँ, फिर {second} की",
    "rowClash.opt.keepOnly": "{keep} की पंक्तियाँ रखें, {remove} की हटाएँ",
    "rowClash.hint.order": "पहले {first}, फिर {second} — हर सेट साथ रहेगा",
    "rowClash.hint.remove": "{name} की जोड़ी {count} पंक्ति(याँ) हटेंगी",
    "rowClash.placedTitle": "एक ही जगह जोड़ी गई पंक्तियाँ",
    "rowClash.placedBody": "आपकी {count} पंक्तियाँ उन पंक्तियों के बाद रखी गईं जो {names} ने उसी जगह जोड़ी थीं। जाँचने या बदलने के लिए शीट के ऊपर \"टकराने वाली पंक्तियाँ\" देखें।",
    "rowClash.placedAsIs": "आपकी {count} पंक्तियाँ सेव हो गईं, पर किसी और ने भी उसी जगह पंक्तियाँ जोड़ी हैं। शीट के ऊपर इन्हें जाँचें।",
    "syncIssues.keepMine": "मेरा रखें (उनके बदलाव के ऊपर सेव करें)",
    "syncIssues.rowConflict": "आपके ऑफ़लाइन रहते किसी और ने ये पंक्तियाँ बदलीं। 'मेरा रखें' चुनें, या उनका रखने के लिए हटाएँ।",
    "tallysheet.rowConflict.title": "किसी और ने बदला",
    "tallysheet.rowConflict.message": "आपके यह शीट खोलने के बाद किसी और ने ये पंक्तियाँ बदलीं। पंक्ति:",
    "tallysheet.rowConflict.choice": "'मेरा रखें' आपका बदलाव उनके ऊपर सेव करता है। 'उनका बदलाव देखें' आपकी बाकी पंक्तियाँ सेव करके शीट दोबारा लोड करता है — इन पंक्तियों पर आपका बदलाव हट जाएगा।",
    "tallysheet.rowConflict.keepMine": "मेरा रखें",
    "tallysheet.rowConflict.showTheirs": "उनका बदलाव देखें",
    "tallysheet.rowConflict.status": "सेव नहीं हुआ — किसी और ने एक पंक्ति बदली",
    "upload.sending": "भेजा जा रहा है",
    "offline.keepOffline": "ऑफ़लाइन रखें",
    "offline.removeFromOffline": "ऑफ़लाइन से हटाएं",
    "offline.keptOffline": "इस फ़ोन पर सेव — यह अपनी टैली शीट के साथ ऑफ़लाइन काम करेगा।",
    "offline.keepOfflineLater": "अगले सिंक पर यह इस फ़ोन पर सेव हो जाएगा।",
    "offline.removedFromOffline": "अब ऑफ़लाइन नहीं रखा गया (पिछले 90 दिनों का या खुला हो तो फिर भी रहेगा)।",
    "offline.syncTitle": "ऑफ़लाइन सिंक",
    "offline.lastSynced": "पिछला सिंक {when}",
    "offline.lastSyncedNever": "इस फ़ोन पर अभी तक सिंक नहीं हुआ",
    "offline.justNow": "अभी",
    "offline.minAgo": "{n} मिनट पहले",
    "offline.hoursAgo": "{n} घंटे पहले",
    "offline.daysAgo": "{n} दिन पहले",
    "offline.syncNow": "अभी सिंक करें",
    "offline.youAreOffline": "आप ऑफ़लाइन हैं — बदलाव इस फ़ोन पर सेव हैं और ऑनलाइन होने पर भेजे जाएंगे।",
    "syncIssues.tryAgain": "फिर से कोशिश करें",
    "offline.waitingSync": "सिंक होने की प्रतीक्षा में",
    "offline.waitingSyncHint": "इस फ़ोन पर सेव — इंटरनेट आने पर भेजे जाएंगे",
    "offlineLock.title": "बहुत समय से ऑफ़लाइन",
    "offlineLock.lead": "यह फ़ोन 15 दिन या उससे ज़्यादा समय से ऑफ़लाइन है, इसलिए आपका डेटा सुरक्षित रखने के लिए ऐप लॉक है।",
    "offlineLock.changesSafe": "{n} बिना सिंक किए बदलाव इस फ़ोन पर सुरक्षित हैं।",
    "offlineLock.waiting": "जारी रखने के लिए इंटरनेट से जुड़ें। फिर आप तय करेंगे कि इन बदलावों का क्या करना है।",
    "offlineLock.checking": "कनेक्ट हो रहा है…",
    "offlineLock.askTitle": "अपने पुराने बदलाव सिंक करें?",
    "offlineLock.askBody": "आपके पास पहले के {n} बदलाव हैं। हाँ: अभी भेजे जाएंगे, फिर आप लॉग आउट होंगे। नहीं: हटा दिए जाएंगे, फिर आप लॉग आउट होंगे।",
    "offlineLock.yes": "हाँ, सिंक करें",
    "offlineLock.no": "नहीं, हटा दें",
    "offlineLock.deletedTitle": "पुराने बदलाव हटाए गए",
    "offlineLock.deletedBody": "आपके {n} पुराने बदलाव हटा दिए गए क्योंकि आपने नहीं चुना।",
    "offline.removedTitle": "ऑफ़लाइन बदलाव हटाए गए",
    "offline.removedBody": "इस फ़ोन पर ऑफ़लाइन किए गए आपके {n} बदलाव हटा दिए गए, क्योंकि सिंक होने से पहले किसी दूसरे उपयोगकर्ता ने इस पर लॉग इन किया। ज़रूरत हो तो उन्हें फिर से दर्ज करें।",
    "offline.notSynced": "सिंक नहीं",
    "offline.notSyncedHint": "इस फ़ोन पर ऐसे बदलाव जो अभी सर्वर पर सेव नहीं हुए — देखने के लिए टैप करें",
    "offline.itemSyncing": "आइटम सिंक हो रहा है…",
    "offline.itemsSyncing": "आइटम सिंक हो रहे हैं…",
    "upload.of": "में से",
    "upload.left": "बाकी",
    "upload.processing": "प्रोसेस हो रहा है…",
    "upload.sent": "भेजा गया",
    "upload.retry": "फिर से",
    "upload.cancel": "अपलोड रद्द करें",
    "recon.piecesNotComparable": "अनलोडिंग टैली अलग प्रकार की है (राउंड बनाम स्क्वायर), इसलिए पीस की तुलना नहीं हो सकती — केवल मात्रा का अंतर लिया जाता है।",
    "tallysheet.tu.reconReceived": "प्राप्त (मिलान के बाद):",
    "tallysheet.tu.reconLoaded": "लोड किया",
    "tallysheet.tu.reconRecordedOnly": "केवल दर्ज (लॉट पहले ही मिल/बिक चुका) — स्टॉक एडजस्टमेंट से ठीक करें",
    "recon.notReceived.title": "यह स्टॉक यूनिट अभी इन्वेंटरी में नहीं है।",
    "recon.notReceived.text": "पहले इसे इन्वेंटरी में प्राप्त करें — फिर मिलान करें, ताकि अंतर स्टॉक में जाए।",
    "recon.notReceived.askReceive": "स्टॉक प्राप्त करने वाले व्यक्ति से पहले इसे प्राप्त करवाएँ।",
    "recon.notReceived.done": "इन्वेंटरी में प्राप्त हुआ — अब आप मिलान कर सकते हैं।",
    "recon.notReceived.failed": "प्राप्त नहीं हो सका। स्टॉक यूनिट खोलकर प्रोडक्ट, साइट और टैली पंक्तियाँ जाँचें।",
    "recon.stockWillChange": "लॉक करने पर जो सच में आया वही स्टॉक में जाएगा:",
    "invInOut.reconAlreadyAppliedTitle": "मिलान पहले ही लागू",
    "invInOut.reconAlreadyAppliedText": "इस स्टॉक यूनिट के मिलान ने पहले ही स्टॉक {cbm} CBM बदल दिया है। अगर यह एडजस्टमेंट उसी कमी के लिए है, तो स्टॉक दो बार ठीक हुआ है — उल्टे एडजस्टमेंट से वापस करें।",
    "tallysheet.tu.openingChipHint": "कंपनी के पास पहले दिन से मौजूद स्टॉक (ओपनिंग स्टॉक से जोड़ा गया)।",
    "receive.volumeFromTallies": "इस लॉट की मात्रा उसके स्टॉक यूनिट की टैली से आती है — इसके बजाय टैली ठीक करें।",
    "invOverview.openingStock": "ओपनिंग स्टॉक",
    "invOverview.openingStockHint": "जो स्टॉक पहले से है उसे जोड़ें",
    "tallysheet.tu.openingTitle": "ओपनिंग स्टॉक",
    "tallysheet.tu.openingSteps": "आपके पास पहले से मौजूद स्टॉक। सेव करें, टैली भरें (साइज़ और पीस), फिर इन्वेंटरी में प्राप्त करें दबाएँ। ट्रांसपोर्ट मोड की ज़रूरत नहीं; कंसाइनमेंट वैकल्पिक है — खरीद का रिकॉर्ड चाहिए तभी जोड़ें।",
    "tallysheet.tu.openingDone": "आपके पास पहले से मौजूद स्टॉक — इन्वेंटरी में जोड़ दिया गया। खरीद का रिकॉर्ड चाहिए तभी कंसाइनमेंट जोड़ें।",
    "appSettings.productTourSection": "प्रोडक्ट टूर",
    "appSettings.productTourEnabled": "प्रोडक्ट टूर दिखाएँ",
    "appSettings.productTourHint": "चालू होने पर हर उपयोगकर्ता हर पेज का टूर एक बार देखता है — पूरा करने या छोड़ने के बाद वह उनके किसी भी डिवाइस पर दोबारा नहीं दिखता। बंद होने पर कोई टूर नहीं दिखता और टूर बटन छिप जाता है।",
    "home.page.dashboard": "डैशबोर्ड",
    "home.page.tallySheets": "टैली शीट",
    "home.page.consignments": "कंसाइनमेंट",
    "home.page.inventory": "इन्वेंटरी",
    "home.restricted.title": "यह पेज अभी आपकी भूमिका में शामिल नहीं है",
    "home.restricted.text": "आपकी कंपनी का एडमिन तय करता है कि आपकी भूमिका कौन से पेज खोल सकती है। आप उनसे एक्सेस माँग सकते हैं, या नीचे दिए पेजों पर काम जारी रख सकते हैं।",
    "home.restricted.canOpen": "पेज जो आप खोल सकते हैं",
    "home.restricted.goHome": "मेरे होम पेज पर जाएँ",
    "home.welcome.title": "आपका अकाउंट तैयार है",
    "home.setup.title": "आपका एक्सेस तैयार हो रहा है…",
    "home.setup.text": "आपका प्लान चालू हो गया है। हम आपके पेज तैयार कर रहे हैं, इसमें कुछ सेकंड लगते हैं।",
    "home.welcome.text": "आपके एडमिन ने अभी आपकी भूमिका को कोई पेज नहीं दिया है। उनसे एक्सेस माँगें — उन्हें तुरंत सूचना मिल जाएगी।",
    "home.welcome.profile": "मेरी प्रोफ़ाइल",
    "home.welcome.logout": "लॉग आउट",
    "home.request.button": "एक्सेस माँगें",
    "home.request.sent": "अनुरोध भेजा गया",
    "home.request.sentNote": "आपके कंपनी एडमिन को बता दिया गया है। भूमिका अपडेट होते ही आपको पेज दिखेगा।",
    "home.request.failed": "अनुरोध नहीं भेजा जा सका। कृपया फिर से कोशिश करें।",
    "home.roleHint.startsOn": "इस भूमिका में डैशबोर्ड नहीं है — सदस्य यहाँ से शुरू करेंगे:",
    "home.roleHint.none": "यह भूमिका अभी कोई मुख्य पेज नहीं खोलती — सदस्यों को स्वागत स्क्रीन दिखेगी और वे एक्सेस माँग सकते हैं।",
    "plan.module.qualityGrading": "गुणवत्ता ग्रेडिंग",
    "plan.module.inventoryModule": "इन्वेंटरी मॉड्यूल",
    "plan.module.processModule": "प्रोसेस मॉड्यूल",
    "plan.module.dedicatedSupport": "समर्पित सहायता",
    "plan.value.unlimited": "असीमित",
    "plan.feature.teamMembers": "टीम सदस्य",
    "plan.feature.businessPartners": "व्यापार भागीदार",
    "plan.feature.productsSpecies": "उत्पाद / प्रजातियाँ",
    "plan.feature.loadingSites": "स्थान",
    "plan.feature.tallySheets": "टैली शीट",
    "plan.feature.shipments": "कंसाइनमेंट",
    "plan.feature.transportUnits": "परिवहन इकाइयाँ",
    "plan.feature.photoUploads": "फोटो अपलोड",
    "plan.feature.photoRetention": "फोटो प्रतिधारण",
    "plan.feature.storage": "स्टोरेज",
    "plan.feature.exportPdfExcel": "PDF और Excel निर्यात",
    "plan.feature.importExcel": "Excel आयात",
    "plan.feature.basicReports": "बुनियादी रिपोर्ट",
    "plan.feature.reconciliationReport": "सामंजस्य रिपोर्ट",
    "plan.feature.usersActivityReport": "उपयोगकर्ता गतिविधि रिपोर्ट",
    "plan.feature.advancedAnalytics": "उन्नत विश्लेषण",
    "plan.feature.aiImport": "AI आयात",
    "plan.feature.prioritySupport": "प्राथमिकता सहायता",
    "plan.feature.consignments": "कंसाइनमेंट",
    "plan.feature.exportTallyPdfExcel": "टैली निर्यात (PDF+Excel)",
    "plan.feature.exportShipmentPdfExcel": "कंसाइनमेंट निर्यात (PDF+Excel)",
    "plan.feature.importTallyExcel": "टैली आयात (Excel)",
    "plan.feature.importShipmentExcel": "कंसाइनमेंट आयात (Excel)",
    "plan.unit.users": "उपयोगकर्ता",
    "plan.unit.records": "रिकॉर्ड",
    "plan.unit.sheets": "शीट",
    "plan.unit.sites": "साइट",
    "plan.unit.units": "इकाइयाँ",
    "plan.unit.photos": "फोटो",
    "plan.unit.days": "दिन",
    "plan.unit.mb": "MB",
    "plan.unit.creditsMonth": "क्रेडिट/माह",
    "common.monthly": "मासिक",
    "common.yearly": "वार्षिक",
    "plan.compare.show": "दिखाएं",
    "plan.compare.allFeatures": "सभी सुविधाएँ",
    "plan.compare.common": "सामान्य",
    "plan.compare.differences": "अंतर",
    "plan.savePercentTemplate": "{pct}% बचाएं",
    "plan.saveUpTo20": "20% तक बचाएं",
    "plan.perMo": "/ माह",
    "plan.perYr": "/ वर्ष",
    "common.language": "भाषा",
    "common.slowConnection": "धीमा कनेक्शन — काम करने में थोड़ा अधिक समय लग सकता है",
    "common.dismiss": "खारिज करें",
    "planManagement.unavailableTitle": "अपनी योजना प्रबंधित करें",
    "planManagement.unavailableDesc": "यह ऐप में उपलब्ध नहीं है। कृपया अपने खाता प्रशासक से संपर्क करें।",
    "planManagement.backToDashboard": "डैशबोर्ड पर वापस जाएं",
    "planManagement.contactAdmin": "कृपया अपने खाता प्रशासक से संपर्क करें।",
    "accountSetup.iosAllSetTitle": "आप तैयार हैं",
    "accountSetup.iosAllSetDesc": "आपका खाता उपयोग के लिए तैयार है। अभी LumberLinq का उपयोग शुरू करें।",
    "accountSetup.iosAllSetGoToDashboard": "डैशबोर्ड पर जाएं",
    "common.offlineStaleData": "ऑफ़लाइन — कैश्ड डेटा दिखाया जा रहा है, दिनांक:",
    "common.offlineNotIncluded": "बदलाव इस फ़ोन पर हैं जो अभी सिंक नहीं हुए, इसलिए यहाँ शामिल नहीं हैं।",
    "common.preparingOfflineData": "ऑफ़लाइन डेटा तैयार किया जा रहा है…",
    "common.syncAreaBusinessPartners": "व्यापार भागीदार",
    "common.syncAreaProducts": "उत्पाद",
    "common.syncAreaLoadingSites": "स्थान",
    "common.syncAreaTransportUnits": "स्टॉक यूनिट",
    "common.syncAreaDashboard": "डैशबोर्ड",
    "common.search": "खोजें",
    "common.status": "स्थिति",
    "common.filter": "फिल्टर",
    "common.actions": "कार्रवाई",
    "common.name": "नाम",
    "common.email": "ईमेल",
    "common.user": "यूजर",
    "common.password": "पासवर्ड",
    "common.phone": "फोन",
    "common.country": "देश",
    "common.state": "राज्य",
    "common.city": "शहर",
    "common.reset": "रीसेट",
    "common.delete": "हटाएं",
    "common.uploading": "अपलोड हो रहा है...",
    "common.edit": "संपादित करें",
    "common.active": "सक्रिय",
    "common.inactive": "निष्क्रिय",
    "common.blocked": "ब्लॉक",
    "header.darkMode": "डार्क मोड",
    "header.newBtn": "नया",
    "header.searchHint": "खोजें या सीधे जाएँ…",
    "header.useClassic": "पुराना हेडर उपयोग करें",
    "header.useNew": "नया हेडर उपयोग करें",
    "menuDock.useDock": "डॉक मेनू उपयोग करें",
    "menuDock.useClassic": "क्लासिक मेनू उपयोग करें",
    "menuDock.useDockRow": "डॉक मेनू",
    "menuDock.iconsLabel": "आइकन",
    "menuDock.iconSet.lucide": "Lucide",
    "menuDock.iconSet.phosphor": "Phosphor",
    "menuDock.iconSet.classic": "क्लासिक",
    "menuDock.more": "और",
    "menuDock.navLabel": "मुख्य मेनू",
    "menuDock.hideBar": "नीचे की बार छिपाएँ",
    "menuDock.focusMode": "फ़ोकस मोड (दोनों बार छिपाएँ)",
    "menuDock.showBottomBar": "नीचे की बार दिखाएँ",
    "menuDock.showBars": "बार दिखाएँ",
    "menuDock.viewGroup": "दृश्य",
    "menuDock.railPin": "मेनू को खुला रखें",
    "menuDock.railUnpin": "मेनू को खुला रखना बंद करें",
    "companyForm.regionalSettings": "क्षेत्रीय सेटिंग्स",
    "companyForm.currency": "कंपनी की मुद्रा",
    "companyForm.currencyHint": "नई खेपों और भुगतानों की डिफ़ॉल्ट मुद्रा के रूप में और डैशबोर्ड के कुल के लिए उपयोग होती है। मौजूदा रिकॉर्ड अपनी मुद्रा रखते हैं।",
    "companyForm.timezone": "कंपनी का समय क्षेत्र",
    "companyForm.timezoneHint": "मासिक प्लान सीमाएँ इसी घड़ी पर रीसेट होती हैं। नए टीम सदस्य भी इसी से शुरू होते हैं।",
    "quickSearch.lockedStock": "स्टॉक के नतीजे आपके मौजूदा प्लान में शामिल नहीं हैं।",
    "quickSearch.lockedMill": "मिल जॉब के नतीजे आपके मौजूदा प्लान में शामिल नहीं हैं।",
    "quickSearch.seePlans": "प्लान देखें",
    "appSettings.nav.upgrade": "अपग्रेड",
    "appSettings.inventoryLocked": "इन्वेंटरी सेटिंग्स उन प्लान में उपलब्ध हैं जिनमें इन्वेंटरी मॉड्यूल शामिल है।",
    "tallyImport.button": "Tally से आयात करें",
    "tallyImport.tooltip": "Tally के एक्सपोर्ट (Excel/CSV) से पार्टियाँ आयात करें",
    "tallyImport.dialogHeader": "Tally से बिज़नेस पार्टनर आयात करें",
    "tallyImport.title": "Tally से आयात",
    "tallyImport.hint": "अपनी लेजर सूची को Tally से Excel या CSV में एक्सपोर्ट करें और केवल Sundry Debtors और Sundry Creditors रखें (अन्य लेजर आयात नहीं होते)। डेबिटर खरीदार और क्रेडिटर विक्रेता बनते हैं। टैक्स आईडी / GSTIN वैकल्पिक है। यदि फ़ाइल की शुरुआती पंक्तियों में रिपोर्ट का शीर्षक है, तो नीचे \"ऊपर की पंक्तियाँ छोड़ें\" का उपयोग करें।",
    "menuDock.railHide": "मेनू छिपाएँ",
    "menuDock.railShow": "मेनू दिखाएँ",
    "menuDock.hideHeader": "ऊपर की बार छिपाएँ",
    "menuDock.showHeader": "ऊपर की बार दिखाएँ",
    "menuDock.askLinc": "Linc से पूछें (AI सहायता)",
    "header.lightMode": "लाइट मोड",
    "header.fontSize": "फ़ॉन्ट साइज़",
    "notification.bellLabel": "सूचनाएं",
    "notification.title": "सूचनाएं",
    "notification.markAllRead": "सभी को पढ़ा हुआ चिह्नित करें",
    "notification.empty": "आप सभी अपडेट हैं",
    "notification.disabled": "सूचनाएं अभी उपलब्ध नहीं हैं",
    "notification.accept": "स्वीकार करें",
    "notification.decline": "अस्वीकार करें",
    "notification.accepted": "स्वीकृत",
    "notification.switchHint": "अब आप इसे अपने प्रोफ़ाइल मेनू से कभी भी स्विच कर सकते हैं",
    "notification.declined": "अस्वीकृत",
    "notification.viewAll": "सभी देखें",
    "header.theme": "थीम",
    "header.preferences": "प्राथमिकताएं",
    "business.subtitle": "अपने व्यापार भागीदारों का प्रबंधन करें",
    "common.cancel": "रद्द करें",
    "common.pcs": "पीस",
    "common.loading": "लोड हो रहा है...",
    "common.unknown": "अज्ञात",
    "common.save": "सेव",
    "sfs.pickStockUnit": "कौन सी स्टॉक यूनिट?",
    "sfs.pickConsignment": "कौन सा कंसाइनमेंट?",
    "sfs.searchPlaceholder": "नंबर या नाम लिखें",
    "sfs.searchHint": "खोजने के लिए कम से कम 2 अक्षर या अंक लिखें।",
    "sfs.searching": "खोज रहे हैं…",
    "sfs.searchNone": "कुछ नहीं मिला। कोई और नंबर या नाम आज़माएँ।",
    "sfs.searchFailed": "खोज नहीं हो सकी। कृपया फिर कोशिश करें।",
    "tally.keypad.addRowBelow": "नीचे पंक्ति जोड़ें",
    "common.update": "अपडेट",
    "common.logout": "लॉगआउट",
    "common.clear": "साफ करें",
    "common.saving": "सेव हो रहा है…",
    "common.saved": "सेव हो गया!",
    "common.saveFailed": "विफल",
    "common.add": "जोड़ें",
    "common.remove": "हटाएं",
    "common.calculate": "कैलकुलेट",
    "common.yes": "हाँ",
    "common.no": "नहीं",
    "common.stayOnPage": "इस पेज पर रहें",
    "common.signInAgain": "फिर से साइन इन करें",
    "common.ok": "ठीक है",
    "common.confirmation": "पुष्टि",
    "common.or": "या",
    "common.required": "आवश्यक है.",
    "common.isRequired": "आवश्यक है.",
    "common.sectionHasErrors": "इस अनुभाग में सत्यापन त्रुटियाँ हैं।",
    "common.success": "सफल",
    "common.error": "त्रुटि",
    "common.created": "बनाया गया",
    "common.somethingWentWrong": "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
    "common.switchCompany": "कंपनी बदलें",
    "common.accountMenu": "खाता मेनू",
    "common.confirmSwitchCompany": "कंपनी बदलें",
    "common.switchCompanyConfirmMessage": "अपनी सक्रिय कंपनी को {{companyName}} में बदलें? आप इस कंपनी के डेटा और सेटिंग्स में स्थानांतरित हो जाएंगे।",
    "common.switchCompanyBlockedUnsynced": "आपके कुछ बदलाव अभी तक सिंक नहीं हुए हैं। कंपनी बदलने से पहले कृपया सिंक पूरा होने की प्रतीक्षा करें।",
    "common.leaveCompany": "कंपनी छोड़ें",
    "common.leaveCompanyConfirmMessage": "{{companyName}} छोड़ें? आप इस कंपनी तक पहुंच खो देंगे, लेकिन आपका अपना खाता और उसकी अपनी कंपनी प्रभावित नहीं होंगे।",
    "common.info": "जानकारी",
    "common.validationError": "सत्यापन त्रुटि",
    "common.noRecordsFound": "कोई रिकॉर्ड नहीं मिला.",
    "common.pendingSync": "सिंक लंबित",
    "common.syncFailed": "सिंक विफल",
    "common.needsRename": "नाम बदलना आवश्यक",
    "syncIssues.title": "सिंक समस्याएं",
    "syncIssues.subtitle": "ऑफ़लाइन बनाई गई वस्तुएं जिन्हें सर्वर ने स्थायी रूप से अस्वीकार कर दिया — समीक्षा करें और हटाएं, या ठीक करके मैन्युअल रूप से पुनः बनाएं।",
    "syncIssues.emptyState": "कोई सिंक समस्या नहीं — ऑफ़लाइन बनाई गई हर चीज़ सफलतापूर्वक सिंक हो गई है।",
    "syncIssues.colType": "प्रकार",
    "syncIssues.colItem": "आइटम",
    "syncIssues.colError": "त्रुटि",
    "syncIssues.colCreated": "बनाया गया",
    "syncIssues.discard": "हटाएं",
    "syncIssues.confirmDiscard": "इस आइटम को स्थायी रूप से हटाएं? यह कभी सर्वर पर सहेजा नहीं गया था और इसे पूर्ववत नहीं किया जा सकता।",
    "syncIssues.confirmDiscardHeader": "आइटम हटाएं",
    "syncIssues.discardedTitle": "हटा दिया गया",
    "syncIssues.discardedDetail": "आइटम हटा दिया गया है।",
    "syncIssues.renamePlaceholder": "नया नाम",
    "syncIssues.renameAndRetry": "नाम बदलें और पुनः प्रयास करें",
    "syncIssues.retrySuccessTitle": "सिंक हो गया",
    "syncIssues.retrySuccessDetail": "नए नाम से सफलतापूर्वक बनाया गया।",
    "syncIssues.retryFailedTitle": "फिर विफल",
    "common.records": "रिकॉर्ड",
    "common.chooseColumns": "कॉलम चुनें",
    "common.searchKeyword": "कीवर्ड खोजें",
    "common.hello": "नमस्ते",
    "common.companyId": "कंपनी ID",
    "common.firstName": "पहला नाम",
    "common.lastName": "अंतिम नाम",
    "common.useDefault": "डिफ़ॉल्ट उपयोग करें",
    "common.view": "देखें",
    "common.data": "डेटा",
    "common.createdAt": "बनाया गया",
    "common.undo": "पूर्ववत",
    "common.redo": "फिर से करें",
    "common.import": "इंपोर्ट",
    "common.refresh": "रिफ्रेश",
    "common.downloadFailed": "डाउनलोड विफल",
    "common.downloadFailedDetail": "फ़ाइल सहेजी नहीं जा सकी। कृपया पुनः प्रयास करें।",
    "common.open": "खोलें",
    "common.copy": "कॉपी",
    "common.revoke": "रद्द करें",
    "common.pageReport": "{totalRecords} में से {first} से {last} दिखा रहे हैं",
    "common.unsavedChangesHeader": "असहेजे परिवर्तन",
    "common.unsavedChangesMessage":
      "आपके परिवर्तन सहेजे नहीं गए हैं। क्या आप बिना सहेजे छोड़ना चाहते हैं?",
    "common.leaveLabel": "छोड़ें",
    "common.stayLabel": "रुकें",
    "login.alreadyHaveAccount": "पहले से खाता है?",
    "login.signInNow": "अभी साइन इन करें!",
    "login.signUp": "साइन अप",
    "login.nameRequired": "नाम आवश्यक है.",
    "login.usernameRequired": "यूजरनेम आवश्यक है.",
    "login.validEmailRequired": "कृपया मान्य ईमेल पता दर्ज करें.",
    "login.checkEmailTitle": "अपना ईमेल देखें",
    "login.checkEmailBody": "हमने सत्यापन लिंक भेजा है:",
    "login.checkEmailResent": "नया लिंक भेज दिया गया।",
    "login.checkEmailSignIn": "साइन इन",
    "login.emailExists": "ईमेल पहले से मौजूद है.",
    "login.passwordRequired": "पासवर्ड आवश्यक है.",
    "login.securityCheckLoading": "सुरक्षा जांच लोड हो रही है…",
    "login.securityCheckUnavailable": "सुरक्षा जांच उपलब्ध नहीं है — जब तक यह लोड नहीं होती, साइन इन अवरुद्ध है.",
    "login.securityCheckRequired": "जारी रखने से पहले कृपया सुरक्षा जांच पूरी करें.",
    "login.choosePassword": "पासवर्ड चुनें",
    "login.tooSimple": "बहुत सरल",
    "login.averageComplexity": "औसत जटिलता",
    "login.complexPassword": "मजबूत पासवर्ड",
    "login.dontHaveAccount": "खाता नहीं है?",
    "login.createToday": "आज बनाएं!",
    "login.welcomeBack": "वापसी पर स्वागत है",
    "login.welcomeBackSub": "अपने LumberLinq खाते में साइन इन करें।",
    "login.createYourAccount": "अपना खाता बनाएं",
    "login.createYourAccountSub": "कुछ ही मिनटों में अपना लकड़ी का कारोबार संभालना शुरू करें।",
    "login.signIn": "साइन इन",
    "login.emailRequired": "ईमेल आवश्यक है.",
    "login.forgotPassword": "पासवर्ड भूल गए?",
    "login.loggedInAs": "आप पहले से लॉग इन हैं",
    "login.loggedInEmail": "ईमेल से लॉग इन",
    "login.errorNotification": "त्रुटि सूचना",
    "login.userNotRegistered":
      "इस ईमेल के लिए कोई खाता मौजूद नहीं है। कृपया पहले साइन अप करें।",
    "login.userAlreadyRegistered":
      "यह खाता पहले से मौजूद है। कृपया साइन इन करें।",
    "login.socialLoginFailed": "सोशल लॉगिन विफल रहा। कृपया फिर से प्रयास करें।",
    "login.referredBy": "आपको रेफ़र किया है",
    "login.referredGeneric": "आपको LumberLinq के लिए रेफ़र किया गया है।",
    "login.referredSignInInstead": "इसके बजाय साइन इन करें",
    "login.signInWithApple": "Apple से साइन इन करें",
    "login.signUpWithApple": "Apple से साइन अप करें",
    "login.appleNoAccount": "इस Apple ID से कोई LumberLinq खाता जुड़ा नहीं है। वेब पर मुफ़्त खाता बनाएँ, फिर यहाँ साइन इन करें।",
    "login.registrationDisabled":
      "साइनअप अस्थायी रूप से रोक दिए गए हैं — हमने आपकी जगह सुरक्षित कर ली है और जैसे ही वे फिर से शुरू होंगे, हम आपको ईमेल करेंगे।",
    "business.title": "बिजनेस पार्टनर",
    "business.newPartner": "नया पार्टनर",
    "business.bulkImport": "बल्क इम्पोर्ट",
    "business.moreActions": "और विकल्प",
    "business.selectRows": "पंक्तियाँ चुनें",
    "business.selectedCount": "चुने गए",
    "business.sortNameAsc": "नाम A–Z",
    "business.sortNameDesc": "नाम Z–A",
    "business.sortType": "प्रकार",
    "business.sortCountry": "देश",
    "common.done": "हो गया",
    "common.sort": "क्रम",
    "common.activate": "सक्रिय करें",
    "business.deleteSelected": "चयनित हटाएं",
    "business.searchPlaceholder": "नाम, ईमेल, संपर्क, टैक्स ID से खोजें",
    "business.allStatus": "सभी स्थितियां",
    "business.edit": "बिजनेस पार्टनर संपादित करें",
    "business.create": "बिजनेस पार्टनर बनाएं",
    "business.identity": "पहचान",
    "business.companyName": "कंपनी का नाम",
    "business.companyDetails": "कंपनी विवरण",
    "business.companyRegistration": "कंपनी पंजीकरण",
    "business.industry": "उद्योग",
    "business.web": "वेब",
    "business.companyBranding": "कंपनी ब्रांडिंग",
    "business.logoUrl": "लोगो URL",
    "business.logoPreview": "कंपनी लोगो पूर्वावलोकन",
    "business.contactPerson": "संपर्क व्यक्ति",
    "business.partyType": "पार्टी प्रकार",
    "business.contactPersonShort": "संपर्क",
    "business.partyTypeShort": "प्रकार",
    "business.selectType": "प्रकार चुनें",
    "business.referenceCode": "रेफरेंस कोड",
    "business.registrationType": "रजिस्ट्रेशन प्रकार",
    "business.taxId": "टैक्स ID",
    "company.reportingCurrency": "रिपोर्टिंग मुद्रा",
    "company.reportingCurrencyHint": "डैशबोर्ड और रिपोर्ट के कुल इसी मुद्रा में परिवर्तित किए जाते हैं।",
    "shipments.fxRateToBase": "रिपोर्टिंग मुद्रा में विनिमय दर",
    "shipments.convertedAmount": "परिवर्तित राशि",
    "dashV5.convertedTooltip": "प्रत्येक कंसाइनमेंट पर बुक की गई विनिमय दर का उपयोग करके रिपोर्टिंग मुद्रा में परिवर्तित। बिना बुक की गई दर वाली राशियाँ शामिल नहीं हैं।",
    "dashV5.approxConverted": "लगभग, परिवर्तित",
    "dashV5.noRate": "दर नहीं",
    "dashV5.noRateTooltip": "कोई बुक की गई विनिमय दर नहीं — परिवर्तित कुल से बाहर रखा गया। कंसाइनमेंट पर रिपोर्टिंग मुद्रा में विनिमय दर सेट करें।",
    "business.partyCategory": "पार्टी श्रेणी",
    "business.selectCategory": "श्रेणी चुनें",
    "business.activePartner": "सक्रिय पार्टनर",
    "business.contactLocation": "संपर्क और स्थान",
    "business.website": "वेबसाइट",
    "business.address1": "पता पंक्ति 1",
    "business.address2": "पता पंक्ति 2",
    "business.zipCode": "ज़िप कोड",
    "business.operations": "ऑपरेशन",
    "business.linkedUserId": "लिंक्ड यूजर ID",
    "business.externalCode": "बाहरी कोड",
    "business.tags": "टैग",
    "business.selectTags": "टैग चुनें",
    "business.notes": "नोट्स",
    "business.attachFiles": "फाइलें जोड़ें",
    "business.bankAccounts": "बैंक खाते",
    "business.bankName": "बैंक का नाम",
    "business.accountNo": "खाता संख्या",
    "business.confirmAccountNo": "खाता संख्या की पुष्टि करें",
    "business.accountNoMismatch": "खाता संख्या मेल नहीं खाती",
    "business.currency": "मुद्रा",
    "business.addBankAccount": "बैंक खाता जोड़ें",
    "business.savePartner": "पार्टनर सेव करें",
    "business.updatePartner": "पार्टनर अपडेट करें",
    "business.noPartnersFound": "कोई पार्टनर नहीं मिला.",
    "business.regType": "रजि. प्रकार",
    "route.login.header": "वापसी पर स्वागत है!",
    "route.buyers.manage": "मौजूदा खरीदार प्रोफाइल देखें और प्रबंधित करें",
    "layout.searchMenu": "मेनू खोजें...",
    "layout.noMenuItems": "कोई मेनू आइटम नहीं मिला.",
    "layout.footerRights": "सर्वाधिकार सुरक्षित.",
    "layout.poweredBy": "Lumber Linq द्वारा संचालित",
    "layout.loveApp": "ऐप पसंद आया?",
    "layout.useForBusiness": "इसे अपने व्यवसाय के लिए उपयोग करें!",
    "user.add": "यूजर जोड़ें",
    "user.create": "यूजर बनाएं",
    "user.inputDetails": "सिस्टम में नए यूजर का विवरण दर्ज करें",
    "user.manage": "यूजर प्रबंधित करें",
    "user.manageProfiles": "यूजर प्रोफाइल देखें और प्रबंधित करें",
    "user.profile": "प्रोफाइल संपादित करें",
    "user.profileSubheader": "अपना व्यक्तिगत यूजर विवरण बदलें",
    "user.confirmDeletion": "यूजर हटाने की पुष्टि",
    "user.deleteConfirm": "क्या आप वाकई इस यूजर को हटाना चाहते हैं?",
    "user.typeEmail": "कृपया नीचे यूजर का ईमेल लिखकर पुष्टि करें:",
    "user.emailPlaceholder": "यूजर ईमेल",
    "user.addEmailAddress": "ईमेल पता जोड़ें",
    "user.invalidEmail": "अमान्य ईमेल पता",
    "user.enterEmail": "ईमेल पता दर्ज करें",
    "user.invitationAccepted": "निमंत्रण स्वीकार किया",
    "user.resend": "फिर भेजें",
    "user.admin": "एडमिन",
    "user.cannotUndo": "यह कार्रवाई वापस नहीं की जा सकती.",
    "shipment.namePlural": "कंसाइनमेंट्स",
    "tallysheet.namePlural": "टैलीशीट्स",
    "tallysheet.all": "सभी टैलीशीट",
    "tallysheet.manageDetails": "मौजूदा टैलीशीट विवरण देखें और प्रबंधित करें",
    "containerPrivacy.title": "कंटेनर गोपनीयता",
    "subscription.title": "सब्सक्रिप्शन",
    "subscription.selectUpdatePlan":
      "अपना सब्सक्रिप्शन प्लान चुनें या अपडेट करें",
    "subscription.view": "सब्सक्रिप्शन देखें",
    "subscription.subheader": "सब्सक्रिप्शन उपशीर्षक",
    "utility.costEstimate": "लागत अनुमान",
    "utility.volumeEstimation": "वॉल्यूम अनुमान",
    "utility.volumeCostEstimation": "वॉल्यूम और लागत अनुमान",
    "utility.unitConversion": "यूनिट कन्वर्ज़न",
    "utility.calculator": "कैलकुलेटर",
    "utility.selectUnit": "यूनिट चुनें",
    "utility.generateSlab": "स्लैब कीमतें जनरेट करें",
    "utility.decimalPlace": "दशमलव स्थान",
    "utility.decimalPlaces": "दशमलव स्थान",
    "utility.from": "से",
    "utility.to": "तक",
    "utility.unit": "यूनिट",
    "utility.fromValue": "प्रारंभ मान",
    "utility.fromUnit": "प्रारंभ यूनिट",
    "utility.toValue": "परिणाम मान",
    "utility.toUnit": "परिणाम यूनिट",
    "utility.reverse": "उलटें",
    "utility.useCommonUnits": "सभी पंक्तियों के लिए सामान्य यूनिट उपयोग करें",
    "utility.width": "चौड़ाई",
    "utility.widthUnit": "चौड़ाई यूनिट",
    "utility.thickness": "मोटाई",
    "utility.thicknessUnit": "मोटाई यूनिट",
    "utility.length": "लंबाई",
    "utility.lengthUnit": "लंबाई यूनिट",
    "utility.price": "कीमत",
    "utility.priceUnit": "कीमत यूनिट",
    "utility.quantity": "मात्रा",
    "utility.total": "कुल",
    "utility.rate": "दर",
    "utility.slabOfRate": "दर का स्लैब",
    "utility.slabPriceSize": "स्लैब कीमत आकार",
    "utility.slabSize": "स्लैब आकार",
    "utility.upperSlabs": "ऊपरी स्लैब",
    "utility.lowerSlabs": "निचले स्लैब",
    "utility.slabPrice": "स्लैब कीमत",
    "utility.volumeOnly": "सिर्फ़ वॉल्यूम",
    "utility.volumeAndCost": "वॉल्यूम + लागत",
    "utility.clearAll": "सब साफ़ करें",
    "utility.clearAllConfirm": "सभी आइटम हटाकर फिर से शुरू करें?",
    "utility.addItem": "आइटम जोड़ें",
    "utility.item": "आइटम",
    "utility.duplicateItem": "आइटम की कॉपी बनाएं",
    "utility.removeItem": "आइटम हटाएं",
    "utility.itemRemoved": "आइटम हटाया गया",
    "utility.totals": "कुल",
    "utility.pieces": "नग",
    "utility.cftNote": "CFT = CBM × 35.3147 से निकाला जाता है। आँकड़े केवल दिखाते समय राउंड होते हैं और रकम 2 दशमलव तक।",
    "utility.copySummary": "सारांश कॉपी करें",
    "utility.copyFailed": "कॉपी नहीं हो सका",
    "utility.swap": "अदला-बदली",
    "utility.saveConversion": "इतिहास में सहेजें",
    "utility.allUnits": "हर यूनिट में वही मान",
    "utility.history": "सहेजे गए कन्वर्ज़न",
    "utility.historyEmpty": "कन्वर्ज़न सहेजने के लिए बुकमार्क दबाएं, वह यहाँ दिखेगा।",
    "utility.clearHistory": "इतिहास साफ़ करें",
    "utility.clearHistoryConfirm": "सभी सहेजे गए कन्वर्ज़न हटाएं?",
    "utility.useThis": "यह कन्वर्ज़न उपयोग करें",
    "utility.incompleteTitle": "जानकारी अधूरी है",
    "utility.incompleteBody": "पहले मान डालें और दोनों यूनिट चुनें।",
    "utility.duplicateTitle": "पहले से सहेजा है",
    "utility.duplicateBody": "यह कन्वर्ज़न आपकी सूची में पहले से है।",
    "utility.savedTitle": "सहेजा गया",
    "utility.baseSection": "आधार कीमत",
    "utility.baseRange": "आधार स्लैब रेंज",
    "utility.stepSection": "स्लैब के चरण",
    "utility.rangeSection": "दिखाने वाले स्लैब",
    "utility.priceLadder": "कीमत सीढ़ी",
    "utility.slabs": "स्लैब",
    "utility.copyAll": "सब कॉपी करें",
    "utility.negativeRate": "कुछ कीमतें शून्य से कम हैं। कीमत का अंतर या निचले स्लैब घटाएं।",
    "utility.baseSlab": "आपका स्लैब",
    "utility.ladderEmpty": "कीमत सीढ़ी देखने के लिए रेट, स्लैब ऑफ़ रेट, स्लैब साइज़ और कीमत अंतर भरें।",
    "dashboardNew.title": "डैशबोर्ड",
    "menu.dashboard": "डैशबोर्ड",
    "menu.dashboardNew": "नया डैशबोर्ड",
    "menu.shipments": "कंसाइनमेंट्स",
    "menu.tallysheets": "टैलीशीट्स",
    "menu.newTallysheet": "नई टैलीशीट",
    "menu.products": "प्रोडक्ट्स",
    "menu.loadingSites": "स्थान",
    "menu.businessPartners": "बिजनेस पार्टनर",
    "menu.containerPrivacy": "कंटेनर गोपनीयता",
    "menu.company": "कंपनी",
    "menu.companyProfile": "कंपनी प्रोफाइल",
    "menu.companyBranding": "कंपनी ब्रांडिंग",
    "menu.subscription": "सब्सक्रिप्शन",
    "menu.utility": "यूटिलिटी",
    "menu.directory": "डायरेक्टरी",
    "menu.tools": "टूल्स",
    "menu.section.overview": "अवलोकन",
    "menu.section.operations": "संचालन",
    "menu.section.data": "डेटा और रिपोर्ट",
    "menu.section.platform": "प्लेटफ़ॉर्म",
    "sidebar.recent": "हाल के",
    "sidebar.copied": "कॉपी हो गया",
    "sidebar.new": "नया",
    "sidebar.newConsignment": "कंसाइनमेंट",
    "sidebar.newStockUnit": "स्टॉक यूनिट",
    "sidebar.newBusinessPartner": "बिज़नेस पार्टनर",
    "sidebar.newProduct": "प्रोडक्ट",
    "sidebar.newLocation": "स्थान",
    "menu.costEstimate": "लागत अनुमान",
    "menu.volumeEstimate": "वॉल्यूम अनुमान",
    "menu.volumeEstimates": "वॉल्यूम अनुमान",
    "menu.unitConversion": "यूनिट कन्वर्ज़न",
    "menu.slabGenerator": "स्लैब जनरेटर",
    "menu.generateSlab": "स्लैब जनरेट करें",
    "menu.users": "यूजर्स",
    "menu.addUser": "यूजर जोड़ें",
    "menu.manageUsers": "यूजर प्रबंधित करें",
    "menu.userProfile": "यूजर प्रोफाइल",
    "menu.editProfile": "प्रोफाइल संपादित करें",
    "menu.addBusinessPartner": "बिजनेस पार्टनर जोड़ें",
    "menu.viewBusinessPartner": "बिजनेस पार्टनर देखें",
    "menu.viewBusinessPartners": "बिजनेस पार्टनर देखें",
    "menu.addProduct": "उत्पाद जोड़ें",
    "menu.viewProduct": "उत्पाद देखें",
    "menu.viewProducts": "उत्पाद देखें",
    "menu.addLoadingSite": "स्थान जोड़ें",
    "menu.viewLoadingSite": "स्थान देखें",
    "menu.viewLoadingSites": "स्थान देखें",
    "menu.addTallysheet": "टैलीशीट जोड़ें",
    "menu.viewTallysheet": "टैलीशीट देखें",
    "menu.listTallysheet": "टैलीशीट सूची",
    "menu.addShipment": "कंसाइनमेंट जोड़ें",
    "menu.viewShipment": "कंसाइनमेंट देखें",
    "menu.listShipments": "कंसाइनमेंट सूची",
    "menu.storage": "स्टोरेज",
    "menu.branding": "ब्रांडिंग",
    "menu.admin": "एडमिन",
    "menu.adminDashboard": "एडमिन डैशबोर्ड",
    "menu.subscriptionDashboard": "सब्सक्रिप्शन डैशबोर्ड",
    "menu.reports": "रिपोर्ट्स",
    "menu.financialReport": "वित्तीय रिपोर्ट",
    "menu.reconciliationReport": "मिलान रिपोर्ट",
    "menu.accessField": "एक्सेस फ़ील्ड",
    "menu.tallysheetAccessField": "टैलीशीट एक्सेस फ़ील्ड",
    "menu.businessPartnerReport": "बिजनेस पार्टनर रिपोर्ट",
    "menu.shipmentReport": "कंसाइनमेंट रिपोर्ट",
    "menu.productReport": "उत्पाद रिपोर्ट",
    "menu.loadingSiteReport": "स्थान रिपोर्ट",
    "menu.transportUnitReport": "स्टॉक यूनिट रिपोर्ट",
    "menu.tallysheetReport": "टैलीशीट रिपोर्ट",
    "menu.operators": "ऑपरेटर",
    "menu.addTransportUnit": "परिवहन इकाई जोड़ें",
    "menu.transportUnitFieldAccess": "परिवहन इकाई फ़ील्ड एक्सेस",
    "menu.tallyReport": "टैली रिपोर्ट",
    "menu.analytics": "विश्लेषण",
    "menu.usersReport": "यूजर रिपोर्ट",
    "menu.inventoryReport": "इन्वेंटरी रिपोर्ट",
    "route.companyProfile": "आपकी कंपनी प्रोफाइल",
    "route.companyProfileDetails":
      "अपनी कंपनी प्रोफाइल विवरण देखें या संपादित करें",
    "route.companyLogo": "अपनी कंपनी लोगो प्रबंधित करें",
    "route.convertUnitsHeader": "यूनिट बदलें",
    "route.convertUnitsSubheader":
      "अपने माप दर्ज करें और कन्वर्ज़न के लिए यूनिट चुनें",
    "route.costEstimateHeader": "अपनी लागत का अनुमान लगाएं",
    "route.costEstimateSubheader":
      "पैरामीटर दर्ज करें और अनुमानित लागत कैलकुलेट करें",
    "route.containerPrivacyHeader":
      "कंटेनर गोपनीयता कॉन्फ़िगरेशन प्रबंधित करें",
    "route.containerPrivacySubheader":
      "कंटेनर फ़ील्ड के गोपनीयता स्तर देखें और बदलें",
    "dashboardNew.company": "कंपनी",
    "dashboardNew.role": "भूमिका",
    "dashboardNew.filterRange": "फिल्टर रेंज",
    "dashboardNew.refresh": "रीफ्रेश",
    "dashboardNew.noData": "कोई डेटा नहीं",
    "dashboardNew.originDestination": "मूल बनाम गंतव्य CBM (30 दिन)",
    "dashboardNew.topPartners": "वॉल्यूम के अनुसार शीर्ष पार्टनर",
    "dashboardNew.fleetHealth": "फ्लीट स्वास्थ्य",
    "dashboardNew.shipmentPipeline": "कंसाइनमेंट पाइपलाइन",
    "dashboardNew.tallyAccuracy": "पोर्ट के अनुसार टैली सटीकता",
    "dashboardNew.liveOperations": "लाइव ऑपरेशन",
    "dashboardNew.alerts": "अलर्ट और अपवाद",
    "dashboardNew.recentActivity": "हाल की गतिविधि",
    "shipment.list": "कंसाइनमेंट",
    "shipment.singular": "कंसाइनमेंट",
    "shipment.new": "नया कंसाइनमेंट",
    "shipment.searchPlaceholder":
      "कुछ भी खोजें (BL, ऑर्डर, एक्सपोर्ट रेफ, शिपर...)",
    "shipment.blNumber": "दस्तावेज़ नंबर",
    "shipment.type": "प्रकार",
    "shipment.date": "तारीख",
    "shipment.buyerOrder": "खरीदार ऑर्डर",
    "shipment.exportRef": "एक्सपोर्ट रेफ",
    "shipment.shipper": "शिपर",
    "shipment.consignee": "कंसाइनी",
    "shipment.noFound": "कोई कंसाइनमेंट नहीं मिला.",
    "shipment.noFoundSub": "शुरू करने के लिए एक नया कंसाइनमेंट बनाएं।",
    "shipment.noBl": "कोई BL# नहीं",
    "shipment.sharedLinks": "शेयर्ड लिंक",
    "shipment.newLink": "नया शेयर लिंक",
    "shipment.access": "एक्सेस",
    "shipment.expiry": "समाप्ति",
    "shipment.active": "सक्रिय",
    "shipment.oneTime": "एक बार",
    "shipment.used": "उपयोग हुआ",
    "shipment.createEdit": "कंसाइनमेंट - बनाएं / संपादित करें",
    "shipment.create": "कंसाइनमेंट बनाएं",
    "shipment.edit": "कंसाइनमेंट संपादित करें",
    "shipment.saveConsignment": "कंसाइनमेंट सेव करें",
    "shipment.updateConsignment": "कंसाइनमेंट अपडेट करें",
    "shipment.details": "कंसाइनमेंट विवरण",
    "shipmentForm.tabDeal": "डील",
    "shipmentForm.tabRoute": "रूट और समय",
    "shipmentForm.tabMoney": "पैसा",
    "shipmentForm.dealTitle": "डील की जानकारी",
    "shipmentForm.dealBasics": "प्रकार, माध्यम और तारीख",
    "shipmentForm.dealBasicsHelp": "पहले प्रकार चुनें: यही तय करता है कि हर टैब में कौन-से फ़ील्ड दिखेंगे।",
    "shipmentForm.references": "संदर्भ नंबर",
    "shipmentForm.referencesHelp": "वे नंबर जिनसे आपकी टीम और आपके पार्टनर इस कंसाइनमेंट को ढूँढते हैं।",
    "shipmentForm.referencesHelpLocal": "वे बिल और इनवॉइस नंबर जिनसे यह कंसाइनमेंट ढूँढा जाता है।",
    "shipmentForm.parties": "पक्ष",
    "shipmentForm.partiesHelp": "शिपर, कंसाइनी या नोटिफ़ाई पार्टी में से कम से कम एक आपकी अपनी कंपनी होनी चाहिए। प्रकार से स्पष्ट हो तो वह अपने-आप भर जाती है।",
    "shipmentForm.ownerMissing": "पक्षों में से एक आपकी अपनी कंपनी होनी चाहिए।",
    "shipmentForm.buyerDetails": "खरीदार की जानकारी",
    "shipmentForm.buyerDetailsHelpSale": "माल निकलने से पहले ज़रूरी: खरीदार का टैक्स नंबर और माल कौन लेगा।",
    "shipmentForm.buyerDetailsHelpPurchase": "खरीद के लिए वैकल्पिक। आपका अपना टैक्स नंबर अपने-आप भर जाता है।",
    "shipmentForm.notes": "नोट्स",
    "shipmentForm.routeTitle": "रूट और समय",
    "shipmentForm.timing": "तारीखें, गंतव्य और शर्तें",
    "shipmentForm.timingHelp": "कब निकलेगा और कब पहुँचेगा, और तय शिपिंग शर्तें। एक ही दिन भी चलेगा।",
    "shipmentForm.transit": "ट्रांज़िट समय",
    "shipmentForm.sameDay": "उसी दिन",
    "shipmentForm.days": "दिन",
    "shipmentForm.docsTitle": "दस्तावेज़",
    "shipmentForm.docChecklist": "फ़ाइल में दस्तावेज़",
    "shipmentForm.docChecklistNote": "नंबर या अपलोड की गई फ़ाइल गिनी जाती है। यह सूची सिर्फ़ याद दिलाती है; सेव करने से कभी नहीं रोकती। फ़्यूमिगेशन सर्टिफ़िकेट को \"अन्य दस्तावेज़\" में लेबल Fumigation के साथ जोड़ें।",
    "shipmentForm.docNumbers": "दस्तावेज़ नंबर",
    "shipmentForm.docNumbersHelp": "इस कंसाइनमेंट के सर्टिफ़िकेट और परमिट नंबर।",
    "shipmentForm.coNo": "सर्टिफ़िकेट ऑफ़ ओरिजिन नंबर",
    "shipmentForm.fumigationNo": "फ़्यूमिगेशन सर्टिफ़िकेट नंबर",
    "shipmentForm.insuranceDetails": "बीमा विवरण",
    "shipmentForm.ewayNo": "ई-वे बिल नंबर",
    "shipmentForm.quickLabels": "त्वरित लेबल",
    "shipmentForm.doc.bl": "बिल ऑफ़ लैडिंग",
    "shipmentForm.doc.bill": "बिल",
    "shipmentForm.doc.invoice": "कमर्शियल इनवॉइस",
    "shipmentForm.doc.packing": "पैकिंग लिस्ट",
    "shipmentForm.doc.co": "सर्टिफ़िकेट ऑफ़ ओरिजिन",
    "shipmentForm.doc.phyto": "फ़ाइटोसैनिटरी सर्टिफ़िकेट",
    "shipmentForm.doc.fumigation": "फ़्यूमिगेशन सर्टिफ़िकेट",
    "shipmentForm.doc.eway": "ई-वे बिल / एलआर",
    "shipmentForm.sumLabel": "कंसाइनमेंट सारांश",
    "shipmentForm.noBlYet": "अभी दर्ज नहीं",
    "shipmentForm.unsaved": "बिना सेव बदलाव",
    "shipmentForm.status": "स्थिति",
    "shipmentForm.changeStatus": "स्थिति बदलें",
    "shipmentForm.sumToggle": "सारांश दिखाएँ या छिपाएँ",
    "shipmentForm.stepperLabel": "इस कंसाइनमेंट की प्रगति",
    "shipmentForm.invoice": "इनवॉइस",
    "shipmentForm.outstanding": "बकाया",
    "shipmentForm.readyLabel": "तैयार",
    "shipmentForm.type.EXPORT": "निर्यात",
    "shipmentForm.type.IMPORT": "आयात",
    "shipmentForm.type.DOMESTIC_SALE": "घरेलू बिक्री",
    "shipmentForm.type.DOMESTIC_PURCHASE": "घरेलू खरीद",
    "shipmentForm.type.TRADING": "ट्रेडिंग",
    "shipmentForm.mode.SEA": "समुद्र",
    "shipmentForm.mode.AIR": "हवाई",
    "shipmentForm.mode.ROAD": "सड़क",
    "shipmentForm.mode.RAIL": "रेल",
    "shipmentForm.ready.type": "प्रकार और माध्यम चुना",
    "shipmentForm.ready.parties": "विक्रेता और खरीदार चुने",
    "shipmentForm.ready.bl": "बिल ऑफ़ लैडिंग नंबर",
    "shipmentForm.ready.bill": "बिल नंबर",
    "shipmentForm.ready.dates": "प्रस्थान और आगमन की तारीखें",
    "shipmentForm.ready.ports": "लोडिंग और डिस्चार्ज पोर्ट",
    "shipmentForm.ready.vehicle": "रूट और वाहन की जानकारी",
    "shipmentForm.ready.rail": "आरंभ और गंतव्य स्टेशन",
    "shipmentForm.ready.units": "कम से कम एक स्टॉक यूनिट जोड़ी",
    "shipmentForm.ready.docs": "सभी अपेक्षित दस्तावेज़ फ़ाइल में",
    "shipmentForm.ready.invoice": "इनवॉइस राशि दर्ज",
    "shipmentForm.ready.terms": "भुगतान शर्तें चुनीं",
    "shipmentForm.depRequired": "अनुमानित प्रस्थान आवश्यक है",
    "shipmentForm.arrRequired": "अनुमानित आगमन आवश्यक है",
    "shipmentForm.billRequired": "बिल नंबर आवश्यक है",
    "shipmentForm.blRequired": "समुद्री कंसाइनमेंट के लिए बिल ऑफ़ लैडिंग नंबर आवश्यक है",
    "shipmentForm.requiredHere": "आवश्यक",
    "shipmentForm.paymentTermsNeeded": "इनवॉइस राशि दर्ज होने पर भुगतान शर्तें ज़रूरी हैं",
    "shipmentForm.paymentTermsHint": "इनवॉइस राशि दर्ज करते ही ज़रूरी: इससे देय तारीख और देरी की याद दिलाने वाले अलर्ट बनते हैं।",
    "shipmentForm.savePaymentsFirst": "भुगतान दर्ज करने के लिए पहले कंसाइनमेंट सेव करें।",
    "shipmentForm.pricePerCbm": "प्रति CBM इनवॉइस",
    "shipmentForm.paidSoFar": "अब तक चुकाया",
    "shipmentForm.receivedSoFar": "अब तक प्राप्त",
    "shipmentForm.stockHelpBtn": "यहाँ कौन-सी स्टॉक यूनिट दिखती हैं?",
    "shipmentForm.stockHint": "स्टॉक यूनिट ID, कंटेनर / ट्रक नंबर या प्रोडक्ट का कुछ हिस्सा लिखें। कौन-सी यूनिट दिखती हैं यह जानने के लिए ? दबाएँ।",
    "shipmentForm.stockHintNew": "स्टॉक यूनिट ID, कंटेनर / ट्रक नंबर या प्रोडक्ट का कुछ हिस्सा लिखें। जोड़ी गई यूनिट सेव करने पर लिंक होती हैं। कौन-सी दिखती हैं यह जानने के लिए ? दबाएँ।",
    "shipmentForm.stockHelp.title": "कौन-सी स्टॉक यूनिट दिखती हैं?",
    "shipmentForm.stockHelp.lead": "सूची में आपकी कंपनी की वही स्टॉक यूनिट दिखती हैं जो इस कंसाइनमेंट से मेल खाती हैं।",
    "shipmentForm.stockHelp.shown": "दिखती हैं",
    "shipmentForm.stockHelp.hidden": "नहीं दिखतीं",
    "shipmentForm.stockHelp.s1": "अभी किसी कंसाइनमेंट में नहीं",
    "shipmentForm.stockHelp.s2": "सही दिशा: बिक्री में Stock Out, खरीद में Stock In",
    "shipmentForm.stockHelp.s3": "रिसीव या कन्फ़र्म हुई हो या नहीं, फ़र्क नहीं पड़ता",
    "shipmentForm.stockHelp.h1": "पहले से किसी दूसरे कंसाइनमेंट में",
    "shipmentForm.stockHelp.h2": "उल्टी दिशा (Stock Out खरीद में कभी नहीं दिखती)",
    "shipmentForm.stockHelp.h3": "साइटों के बीच मूव यूनिट और मिल-आउटपुट रिकॉर्ड",
    "shipmentForm.stockHelp.h4": "अभी कुछ लिखा नहीं, या ID, ट्रांसपोर्ट ID, कंटेनर / ट्रक नंबर या प्रोडक्ट से मेल नहीं",
    "shipmentForm.stockHelp.tip": "नहीं मिली? स्टॉक यूनिट स्क्रीन पर उसकी Direction (दिशा) जाँचें।",
    "shipmentForm.stockHelp.locked": "कंसाइनमेंट Closed, Cancelled हो, या बिक्री का माल निकल चुका हो, तो जोड़ना बंद रहता है।",
    "shipmentForm.statusDialogTitle": "स्थिति बदलें",
    "shipmentForm.statusForwardNote": "इस कंसाइनमेंट का स्टॉक रिसीव हो चुका है, इसलिए स्थिति सिर्फ़ आगे बढ़ सकती है।",
    "shipmentForm.receiveMark": "Receive into Inventory का विकल्प देती है",
    "shipmentForm.current": "वर्तमान",
    "shipmentForm.setStatus": "स्थिति सेट करें",
    "shipmentForm.statusPressUpdate": "नई स्थिति सेव करने के लिए Update दबाएँ।",
    "shipmentForm.statusPressSave": "नई स्थिति रखने के लिए Save दबाएँ।",
    "shipmentForm.statusForwardTitle": "स्थिति सिर्फ़ आगे बढ़ सकती है",
    "shipmentForm.statusForwardSub": "इस कंसाइनमेंट का स्टॉक रिसीव हो चुका है। स्थिति आगे बढ़ सकती है, पर पीछे नहीं और Cancelled भी नहीं।",
    "shipmentForm.activity": "गतिविधि",
    "shipmentForm.activityTip": "इसे किसने बनाया, कब बदला और स्थिति का इतिहास",
    "loginBar.signedIn": "आप पहले से साइन इन हैं।",
    "loginBar.continue": "LumberLinq पर जारी रखें",
    "loginBar.switch": "किसी और के रूप में साइन इन करें",
    "shipmentForm.priceCheckHigh": "प्रति CBM यह भाव आपके पहले के कंसाइनमेंट से काफ़ी ज़्यादा है (लगभग {typical})। कृपया राशि जाँचें।",
    "shipmentForm.priceCheckLow": "प्रति CBM यह भाव आपके पहले के कंसाइनमेंट से काफ़ी कम है (लगभग {typical})। कृपया राशि जाँचें।",
    "shipment.status.SHIPPED": "भेजा गया",
    "shipmentForm.raw.backToConsignments": "कंसाइनमेंट सूची पर वापस",
    "shipmentForm.raw.goodsHaveArrivedReadyToReceiveInto": "माल पहुँच गया — इन्वेंटरी में रिसीव करें?",
    "shipmentForm.raw.filledIn": "भरा हुआ",
    "shipmentForm.raw.thisTabHasValidationErrors": "इस टैब में सुधार वाली त्रुटियाँ हैं",
    "shipmentForm.raw.consignmentDateIsRequired": "कंसाइनमेंट की तारीख आवश्यक है",
    "shipmentForm.raw.blType": "BL प्रकार",
    "shipmentForm.raw.searchShipper": "शिपर खोजें",
    "shipmentForm.raw.searchConsignee": "कंसाइनी खोजें",
    "shipmentForm.raw.searchNotifyParty": "नोटिफ़ाई पार्टी खोजें",
    "shipmentForm.raw.arrivalCannotBeBeforeDeparture": "आगमन प्रस्थान से पहले नहीं हो सकता",
    "shipmentForm.raw.countryOfDestination": "गंतव्य देश",
    "shipmentForm.raw.portCarrierDetails": "पोर्ट और कैरियर विवरण",
    "shipmentForm.raw.portOfLoadingIsRequired": "लोडिंग पोर्ट आवश्यक है",
    "shipmentForm.raw.portOfDischargeIsRequired": "डिस्चार्ज पोर्ट आवश्यक है",
    "shipmentForm.raw.otherNotListed": "अन्य (सूची में नहीं)",
    "shipmentForm.raw.enterShippingLineName": "शिपिंग लाइन का नाम लिखें",
    "shipmentForm.raw.customShippingLine": "अपनी शिपिंग लाइन",
    "shipmentForm.raw.vesselName": "जहाज़ का नाम",
    "shipmentForm.raw.voyageNumber": "वॉयेज नंबर",
    "shipmentForm.raw.flightNumber": "फ़्लाइट नंबर",
    "shipmentForm.raw.roadTransportDetails": "सड़क परिवहन विवरण",
    "shipmentForm.raw.vehicleLrNo": "वाहन / LR नंबर",
    "shipmentForm.raw.railMovementDetails": "रेल परिवहन विवरण",
    "shipmentForm.raw.originStationIcd": "आरंभ स्टेशन / ICD",
    "shipmentForm.raw.destinationStationIcd": "गंतव्य स्टेशन / ICD",
    "shipmentForm.raw.railOperator": "रेल ऑपरेटर",
    "shipmentForm.raw.searchByStockUnitIdTransportId": "स्टॉक यूनिट ID, ट्रांसपोर्ट ID, कंटेनर / ट्रक नंबर या प्रोडक्ट से खोजें…",
    "shipmentForm.raw.openInStockUnitEditorNewTab": "स्टॉक यूनिट एडिटर में खोलें (नया टैब)",
    "shipmentForm.raw.noTransportUnitsAddedYetStartBy": "अभी कोई स्टॉक यूनिट नहीं जोड़ी। ऊपर खोजकर शुरू करें।",
    "shipmentForm.raw.whoCanSeeThisDocumentInShares": "शेयर और एक्सपोर्ट में यह दस्तावेज़ कौन देख सकता है",
    "shipmentForm.raw.dropOrClickToUpload": "छोड़ें या अपलोड के लिए क्लिक करें",
    "shipmentForm.raw.noDocumentsAttached": "कोई दस्तावेज़ संलग्न नहीं",
    "shipmentForm.raw.max5FilesReached": "अधिकतम 5 फ़ाइलें पूरी हो गईं",
    "shipmentForm.raw.label": "लेबल",
    "shipmentForm.raw.fileLabelMax16Chars": "फ़ाइल लेबल (अधिकतम 16 अक्षर)",
    "shipmentForm.raw.attach": "संलग्न करें",
    "shipmentForm.raw.fileSSelected": "फ़ाइल चुनी गईं",
    "shipmentForm.raw.dropOrClickToAddMultipleFiles": "कई फ़ाइलें जोड़ने के लिए छोड़ें या क्लिक करें",
    "shipmentForm.raw.selectCurrency": "मुद्रा चुनें",
    "shipmentForm.raw.days": "दिन",
    "shipmentForm.raw.describePaymentTerms": "भुगतान शर्तें लिखें…",
    "shipmentForm.raw.customTerms": "अपनी शर्तें",
    "shipmentForm.raw.dueDate": "देय तारीख",
    "shipmentForm.raw.outstandingReceivable": "बकाया प्राप्य",
    "shipmentForm.raw.outstandingPayable": "बकाया देय",
    "shipmentForm.raw.paymentDetails": "भुगतान विवरण",
    "shipmentForm.raw.paymentDate": "भुगतान की तारीख *",
    "shipmentForm.raw.utrLCNoRef": "UTR / L/C नंबर / संदर्भ",
    "shipmentForm.raw.amountCurrency": "राशि और मुद्रा",
    "shipmentForm.raw.amount": "राशि *",
    "shipmentForm.raw.optionalContextForThisPayment": "इस भुगतान के बारे में वैकल्पिक जानकारी…",
    "shipmentForm.raw.noPaymentsRecordedYet": "अभी कोई भुगतान दर्ज नहीं।",
    "shipmentForm.raw.editPayment": "भुगतान संपादित करें",
    "shipmentForm.raw.deletePayment": "भुगतान हटाएँ",
    "shipmentForm.raw.totalReceived": "कुल प्राप्त:",
    "shipmentForm.raw.totalPaid": "कुल चुकाया:",
    "shipmentForm.raw.previousTabAltLeft": "पिछला टैब (Alt + बायाँ)",
    "shipmentForm.raw.nextTabAltRight": "अगला टैब (Alt + दायाँ)",
    "shipmentForm.lastUpdated": "अंतिम अपडेट",
    "shipmentForm.statusHistory": "स्थिति का इतिहास",
    "shipmentForm.noHistory": "दिखाने के लिए कोई स्थिति इतिहास नहीं।",
    "shipment.status.DRAFT": "ड्राफ़्ट",
    "shipment.status.CONFIRMED": "पुष्ट",
    "shipment.status.PLANNED": "नियोजित",
    "shipment.status.STUFFING": "स्टफ़िंग",
    "shipment.status.STUFFED": "स्टफ़्ड",
    "shipment.status.GATE_OUT": "गेट आउट",
    "shipment.status.IN_TRANSIT": "रास्ते में",
    "shipment.status.ARRIVED": "पहुँचा",
    "shipment.status.UNSTUFFING": "अनस्टफ़िंग",
    "shipment.status.DELIVERED": "डिलीवर हुआ",
    "shipment.status.CLOSED": "बंद",
    "shipment.status.CANCELLED": "रद्द",
    "shipment.statusGroup.planning": "योजना",
    "shipment.statusGroup.loading": "लोडिंग",
    "shipment.statusGroup.way": "रास्ते में",
    "shipment.statusGroup.arrival": "आगमन",
    "shipment.statusGroup.finished": "समाप्त",
    "shipment.statusMeaning.DRAFT": "तैयार किया जा रहा है",
    "shipment.statusMeaning.CONFIRMED": "सौदा तय हुआ",
    "shipment.statusMeaning.PLANNED": "शिपमेंट की व्यवस्था हुई",
    "shipment.statusMeaning.STUFFING.sale": "आप माल लोड कर रहे हैं",
    "shipment.statusMeaning.STUFFING.buy": "सप्लायर माल लोड कर रहा है",
    "shipment.statusMeaning.STUFFED.sale": "लोड और सील हो गया",
    "shipment.statusMeaning.STUFFED.buy": "सप्लायर के यहाँ लोड हुआ",
    "shipment.statusMeaning.GATE_OUT.sale": "यार्ड या पोर्ट के गेट से निकला",
    "shipment.statusMeaning.GATE_OUT.buy": "सप्लायर ने लोड करके भेज दिया",
    "shipment.statusMeaning.IN_TRANSIT.sale": "खरीदार के पास रास्ते में",
    "shipment.statusMeaning.IN_TRANSIT.buy": "आपके पास रास्ते में",
    "shipment.statusMeaning.ARRIVED.sale": "गंतव्य पर पहुँचा",
    "shipment.statusMeaning.ARRIVED.buy": "आपके पोर्ट या यार्ड पर पहुँचा",
    "shipment.statusMeaning.UNSTUFFING.sale": "कंटेनर खाली किया जा रहा है",
    "shipment.statusMeaning.UNSTUFFING.buy": "कंटेनर खाली किया जा रहा है",
    "shipment.statusMeaning.DELIVERED.sale": "खरीदार को माल मिल गया",
    "shipment.statusMeaning.DELIVERED.buy": "माल आपके पास है",
    "shipment.statusMeaning.CLOSED": "पूरा और निपटाया हुआ",
    "shipment.statusMeaning.CANCELLED": "रद्द किया गया",
    "shipment.statusEffect.DRAFT": "स्टॉक में कुछ नहीं बदलता। जब तक जानकारी अधूरी हो, इसे इस्तेमाल करें।",
    "shipment.statusEffect.CONFIRMED": "स्टॉक में कुछ नहीं बदलता।",
    "shipment.statusEffect.PLANNED": "स्टॉक में कुछ नहीं बदलता।",
    "shipment.statusEffect.STUFFING.sale": "स्टॉक में कुछ नहीं बदलता। स्टॉक यूनिट \"In Consignment\" में दिखती हैं।",
    "shipment.statusEffect.STUFFING.buy": "स्टॉक में कुछ नहीं बदलता। स्टॉक यूनिट \"In Consignment\" में दिखती हैं।",
    "shipment.statusEffect.STUFFED.sale": "स्टॉक में कुछ नहीं बदलता। स्टॉक यूनिट \"In Transit\" में दिखती हैं।",
    "shipment.statusEffect.STUFFED.buy": "स्टॉक में कुछ नहीं बदलता। स्टॉक यूनिट \"In Transit\" में दिखती हैं।",
    "shipment.statusEffect.GATE_OUT.sale": "स्टॉक में कुछ नहीं बदलता। स्टॉक यूनिट \"In Transit\" में दिखती हैं।",
    "shipment.statusEffect.GATE_OUT.buy": "स्टॉक में कुछ नहीं बदलता। स्टॉक यूनिट \"In Transit\" में दिखती हैं।",
    "shipment.statusEffect.IN_TRANSIT.sale": "स्टॉक में कुछ नहीं बदलता (स्टॉक सिर्फ़ Confirm Stock-Out करने पर घटता है)। अब से इस बिक्री में नई स्टॉक यूनिट नहीं जुड़ सकती।",
    "shipment.statusEffect.IN_TRANSIT.buy": "स्टॉक में कुछ नहीं बदलता (स्टॉक सिर्फ़ इन्वेंटरी में रिसीव करने पर बढ़ता है)। स्टॉक यूनिट \"In Transit\" में दिखती हैं।",
    "shipment.statusEffect.ARRIVED.sale": "स्टॉक में कुछ नहीं बदलता। इस बिक्री में अब नई स्टॉक यूनिट नहीं जुड़ सकती।",
    "shipment.statusEffect.ARRIVED.buy": "स्टॉक अभी नहीं बढ़ता। स्टॉक यूनिट को इन्वेंटरी में रिसीव करने (Receive into Inventory) के लिए पूछा जाएगा।",
    "shipment.statusEffect.UNSTUFFING.sale": "स्टॉक में कुछ नहीं बदलता।",
    "shipment.statusEffect.UNSTUFFING.buy": "स्टॉक अभी नहीं बढ़ता। स्टॉक यूनिट को इन्वेंटरी में रिसीव करने (Receive into Inventory) के लिए पूछा जाएगा।",
    "shipment.statusEffect.DELIVERED.sale": "स्टॉक इस स्थिति से नहीं, हर स्टॉक यूनिट पर Confirm Stock-Out करने पर घटता है। अब नई स्टॉक यूनिट नहीं जुड़ सकती।",
    "shipment.statusEffect.DELIVERED.buy": "जो स्टॉक यूनिट अभी रिसीव नहीं हुई उसे रिसीव करें। स्टॉक इस स्थिति से नहीं, इन्वेंटरी में रिसीव करने पर बढ़ता है।",
    "shipment.statusEffect.CLOSED": "अब और स्टॉक यूनिट नहीं जुड़ सकती। स्टॉक की मात्रा नहीं बदलती।",
    "shipment.statusEffect.CANCELLED": "स्टॉक की मात्रा नहीं बदलती और नई स्टॉक यूनिट नहीं जुड़ सकती। यदि स्टॉक पहले ही रिसीव या कन्फ़र्म हो चुका है, तो Add Adjustment से सुधारें।",
    "shipment.paymentSummaryTitle": "भुगतान सारांश",
    "shipment.invoiceAmount": "इनवॉइस राशि",
    "shipment.received": "प्राप्त हुआ",
    "shipment.paid": "भुगतान किया गया",
    "shipment.salesPaymentStatus": "बिक्री भुगतान स्थिति",
    "shipment.purchasePaymentStatus": "खरीद भुगतान स्थिति",
    "shipment.coreDetails": "मुख्य कंसाइनमेंट विवरण",
    "shipment.saveChanges": "बदलाव सेव करें",
    "shipment.listSubtitle": "कंसाइनमेंट ऑपरेशन ट्रैक, फिल्टर और प्रबंधित करें",
    "shipment.filterBl": "BL फिल्टर करें",
    "shipment.filterBuyerOrder": "खरीदार ऑर्डर फिल्टर करें",
    "shipment.filterExportRef": "एक्सपोर्ट रेफ फिल्टर करें",
    "shipment.filterShipper": "शिपर फिल्टर करें",
    "shipment.filterConsignee": "कंसाइनी फिल्टर करें",
    "shipment.filterStatus": "स्थिति फिल्टर करें",
    "shipment.viewDetails": "कंसाइनमेंट विवरण देखें",
    "shipment.payments": "भुगतान",
    "common.confirm": "पुष्टि करें",
    "shipment.changeStatus": "स्थिति बदलें",
    "shipment.receiveIntoInventory": "इन्वेंटरी में प्राप्त करें",
    "share.actions": "शेयर क्रियाएं",
    "share.duration": "अवधि",
    "share.accessLimit": "एक्सेस सीमा",
    "share.customAccessCount": "कस्टम एक्सेस संख्या",
    "share.allowDownload": "एक्सपोर्ट और फ़ाइल डाउनलोड की अनुमति दें",
    "share.protectedAudience": "सुरक्षित दर्शक",
    "share.companyIdNotFound": "कंपनी ID मौजूद नहीं है",
    "share.emailNotFound": "LumberLinq का पंजीकृत उपयोगकर्ता नहीं है",
    "share.createLink": "लिंक बनाएं",
    "share.createTallysheetLink": "टैलीशीट लिंक बनाएं",
    "share.tallysheetSharedLinks": "टैलीशीट शेयर्ड लिंक",
    "share.audience": "दर्शक",
    "share.createdBy": "द्वारा बनाया गया",
    "share.limit": "सीमा",
    "share.download": "डाउनलोड",
    "share.noLinksFound": "कोई शेयर्ड लिंक नहीं मिला.",
    "share.public": "लिंक वाला कोई भी",
    "share.protected": "केवल LumberLinq उपयोगकर्ता",
    "share.private": "केवल मेरी टीम",
    "share.publicTooltip": "इस लिंक वाले किसी के लिए भी सुलभ — लॉगिन की आवश्यकता नहीं",
    "share.protectedTooltip": "केवल LumberLinq उपयोगकर्ता देख सकते हैं — लॉगिन आवश्यक",
    "share.privateTooltip": "केवल आपके टीम के सदस्य इसे देख सकते हैं",
    "share.accessMode": "एक्सेस मोड",
    "share.linkSettings": "लिंक सेटिंग्स",
    "share.allowDownloadHint": "बंद होने पर, दर्शक टैली एक्सपोर्ट या कंसाइनमेंट फ़ाइलें डाउनलोड नहीं कर सकते।",
    "share.linkPreview": "लिंक प्रीव्यू में विवरण दिखाएँ",
    "share.linkPreviewHintPublic": "चालू होने पर, WhatsApp, Telegram और अन्य चैट ऐप्स पीस, वॉल्यूम और प्रोडक्ट दिखाते हैं (केवल वही फ़ील्ड जो आपकी एक्सेस सेटिंग्स अनुमति देती हैं)।",
    "share.linkPreviewHintLocked": "चालू होने पर, चैट ऐप्स स्टॉक यूनिट की गिनती के साथ एक लॉक कार्ड दिखाते हैं। कोई अन्य विवरण नहीं दिखाया जाता।",
    "share.preview": "प्रीव्यू",
    "share.linkInventory": "शेयर लिंक",
    "share.specificCompanyIds": "विशिष्ट कंपनी ID",
    "share.specificEmails": "विशिष्ट ईमेल पते",
    "share.anyLumberlinqUser": "कोई भी Lumberlinq उपयोगकर्ता",
    "share.manageAudience": "दर्शक प्रबंधन",
    "share.audienceEmails": "ईमेल पते",
    "share.audienceCompanies": "कंपनी आईडी",
    "share.addEntry": "जोड़ें",
    "share.audienceMinOne": "कम से कम एक प्रविष्टि आवश्यक है",
    "share.audienceDeleteGate": "हटाने की अनुमति पाने के लिए पहले एक नई प्रविष्टि जोड़ें",
    "share.audienceNoEntries": "अभी कोई प्रविष्टि नहीं",
    "share.audienceEmailPlaceholder": "ईमेल पता दर्ज करें",
    "share.audienceCompanyPlaceholder": "कंपनी आईडी दर्ज करें",
    "share.never": "कभी नहीं",
    "share.noRestriction": "कोई प्रतिबंध नहीं",
    "share.missingTransportUnit": "स्टॉक यूनिट नहीं मिली",
    "share.saveOrLoadTransportUnit": "शेयर लिंक बनाने से पहले स्टॉक यूनिट सेव या लोड करें.",
    "share.tallysheetLinkCreated": "टैलीशीट लिंक बना",
    "share.linkCopiedToClipboard": "शेयर लिंक क्लिपबोर्ड पर कॉपी हुआ.",
    "share.linkFailed": "लिंक विफल",
    "shareAudit.title": "शेयर लिंक एक्सेस ऑडिट",
    "shareAudit.accesses": "एक्सेस",
    "shareAudit.noAccesses": "अभी तक कोई शेयर लिंक एक्सेस दर्ज नहीं है.",
    "shareAudit.emptyHint": "जब भी कोई शेयर लिंक खोलेगा, वह यहां दिखाई देगा.",
    "shareAudit.allowed": "अनुमत",
    "shareAudit.denied": "अस्वीकृत",
    "shareAudit.uniqueVisitors": "यूनिक विजिटर",
    "shareAudit.bots": "बॉट्स",
    "shareAudit.emailUser": "ईमेल / यूजर",
    "shareAudit.accessedAt": "एक्सेस समय",
    "shareAudit.ipAddress": "IP पता",
    "shareAudit.location": "स्थान",
    "shareAudit.browser": "ब्राउज़र",
    "shareAudit.os": "OS",
    "shareAudit.shareLink": "शेयर लिंक",
    "shareAudit.anonymous": "अनाम",
    "shareAudit.noEntries": "कोई ऑडिट एंट्री नहीं मिली.",
    "share.unableToCreateTallysheetLink": "टैलीशीट शेयर लिंक नहीं बनाया जा सका.",
    "share.oneDay": "1 दिन",
    "share.sevenDays": "7 दिन",
    "share.thirtyDays": "30 दिन",
    "share.ninetyDays": "90 दिन",
    "share.neverExpires": "कभी समाप्त नहीं",
    "tallysheet.rowLimit.title": "टैली शीट भर गई है",
    "tallysheet.rowLimit.message": "एक टैली शीट में अधिकतम {max} पंक्तियाँ हो सकती हैं। बाकी के लिए नई टैली शीट शुरू करें।",
    "tallysheet.rowLimit.importMessage": "ये पंक्तियाँ टैली शीट को {max} पंक्तियों से आगे ले जाएँगी, इसलिए कुछ भी इम्पोर्ट नहीं हुआ। कम पंक्तियाँ इम्पोर्ट करें या नई टैली शीट लें।",
    "share.publicExpiryHint": "सार्वजनिक लिंक हमेशा समाप्त होते हैं, इसलिए पुराना लिंक बाद में किसी को मिलने पर भी नहीं खुलेगा।",
    "share.disableAll": "सभी बंद करें",
    "share.disableAllConfirm": "इस रिकॉर्ड के सभी लिंक बंद करें? कोई भी इन्हें अब नहीं खोल पाएगा।",
    "share.disableAllDone": "लिंक बंद कर दिए गए",
    "share.oneTime": "एक बार",
    "share.threeAccesses": "3 एक्सेस",
    "share.fiveAccesses": "5 एक्सेस",
    "share.tenAccesses": "10 एक्सेस",
    "share.custom": "कस्टम",
    "share.viewSharedLinks": "शेयर्ड लिंक देखें",
    "share.copyDirectLink": "डायरेक्ट लिंक कॉपी करें",
    "share.openDirectLink": "डायरेक्ट लिंक खोलें",
    "share.copyLink": "लिंक कॉपी करें",
    "share.openLink": "लिंक खोलें",
    "share.anyoneWithLink": "लिंक वाला कोई भी एक्सेस कर सकता है",
    "share.requiresVerification": "सत्यापन आवश्यक",
    "share.restrictedUsersOnly": "केवल सीमित उपयोगकर्ता",
    "share.addEmailAddress": "Lumberlinq ईमेल पता जोड़ें",
    "share.addCompanyId": "कंपनी ID जोड़ें",
    "share.missingDetails": "विवरण अधूरा",
    "share.completeRestrictions": "चयनित शेयर प्रतिबंध पूरे करें.",
    "share.generatingLink": "लिंक बन रहा है...",
    "share.pleaseWait": "कृपया प्रतीक्षा करें",
    "share.linkCreated": "लिंक बना",
    "share.tallysheetLinkGenerated": "टैलीशीट शेयर लिंक जनरेट हुआ.",
    "share.linkGeneratedSuccessfully": "शेयर लिंक सफलतापूर्वक जनरेट हुआ",
    "share.failed": "विफल",
    "share.unableToCreateShareLink": "शेयर लिंक नहीं बनाया जा सका",
    "share.unableToLoadSharedLinks": "शेयर्ड लिंक लोड नहीं हो सके.",
    "share.docAccess": "दस्तावेज़ पहुंच",
    "share.docAccessHint": "प्रत्येक दस्तावेज़ के लिए दर्शक की पहुंच नियंत्रित करें",
    "share.doc_bl": "BL फ़ाइल",
    "share.doc_ewaybill": "ई-वेबिल / LR",
    "share.doc_co": "उत्पत्ति प्रमाण पत्र",
    "share.doc_phyto": "फाइटोसेनिटरी",
    "share.doc_invoice": "वाणिज्यिक चालान",
    "share.doc_other": "अन्य दस्तावेज़",
    "share.docFull": "पूर्ण पहुंच",
    "share.docViewOnly": "केवल देखें",
    "share.docFilenameOnly": "केवल फ़ाइल नाम",
    "share.docHidden": "छिपा हुआ",
    "share.copied": "कॉपी हुआ",
    "share.linkCopied": "लिंक कॉपी हुआ",
    "share.transportIdCopied": "ट्रांसपोर्ट ID कॉपी हुआ!",
    "share.confirmRevoke": "क्या आप वाकई यह लिंक रद्द करना चाहते हैं?",
    "share.confirmActivate": "क्या आप वाकई यह लिंक सक्रिय करना चाहते हैं?",
    "share.generateShareLink": "शेयर लिंक जनरेट करें",
    "share.generateShareQuestion": "क्या आप जनरेट करना चाहते हैं",
    "share.shareLinkSuffix": "शेयर लिंक?",
    "share.unableToUpdateLinkStatus": "लिंक स्थिति अपडेट नहीं हो सकी.",
    "subscription.transactions": "लेनदेन",
    "subscription.purchase": "खरीद",
    "subscription.customerCode": "ग्राहक कोड",
    "subscription.currentName": "वर्तमान सब्सक्रिप्शन नाम",
    "subscription.refresh": "रीफ़्रेश करें",
    "subscription.validTill": "वर्तमान सब्सक्रिप्शन वैध तक",
    "subscription.lastPayment": "अंतिम भुगतान किया गया",
    "subscription.paymentDue": "भुगतान देय",
    "subscription.paidTill": "भुगतान तक",
    "subscription.status": "सब्सक्रिप्शन स्थिति",
    "subscription.downgradedTitle": "आप फ्री प्लान पर हैं",
    "subscription.downgradedBody": "आपका पेड सब्सक्रिप्शन समाप्त हो गया और यह अकाउंट अपने आप फ्री प्लान पर स्थानांतरित कर दिया गया है. आपके द्वारा पहले से बनाई गई हर चीज़ तक आपकी पूरी पहुंच बनी हुई है — बस आप फ्री प्लान की सीमा से अधिक नई चीज़ें नहीं जोड़ सकते. पूरी पहुंच फिर से पाने के लिए कभी भी रिन्यू करें.",
    "subscription.utcNote":
      "कृपया ध्यान दें कि हमारा सिस्टम Coordinated Universal Time (UTC) के आधार पर काम करता है. इसलिए आपके सब्सक्रिप्शन की सक्रियता और समाप्ति का समय इसी टाइम ज़ोन के आधार पर कैलकुलेट होगा. यदि आप अलग टाइम ज़ोन में हैं, तो शुरू और समाप्ति समय में अंतर महसूस हो सकता है",
    "subscription.autoPay": "स्वतः-भुगतान (EMandate)",
    "subscription.cancelAutoPay": "स्वतः-भुगतान रद्द करें",
    "utility.title": "यूटिलिटी",
    "utility.slabCalculator": "स्लैब कैलकुलेटर",
    "utility.slabSubheader":
      "आकार अंतर के अनुसार कीमत अनुमान जनरेट करने के लिए स्लैब आयाम दर्ज करें",
    "tallysheet.settings": "सेटिंग्स",
    "tallysheet.validationRules": "वैलिडेशन नियम",
    "tallysheet.configurationSettings": "कॉन्फ़िगरेशन सेटिंग्स",
    "tallysheet.transportDetails": "ट्रांसपोर्ट विवरण",
    "tallysheet.tu.direction": "दिशा",
    "tallysheet.tu.directionChangeHeader": "दिशा बदलें?",
    "tallysheet.tu.directionChangeMessage": "दिशा बदलने से कुछ इन्वेंटरी-संबंधित फ़ील्ड रीसेट हो सकते हैं — जारी रखें?",
    "tallysheet.tu.directionStockIn": "स्टॉक इन",
    "tallysheet.tu.directionStockOut": "स्टॉक आउट",
    "tallysheet.tu.directionMove": "साइटों के बीच स्थानांतरण",
    "tallysheet.tu.gridStyle": "टैली लेआउट",
    "tallysheet.tu.gridStyleClassicHint": "प्रति लाइन एक उत्पाद, अभी चुनें.",
    "tallysheet.tu.gridStyleFlexibleHint": "तालियां शुरू करते ही प्रति-पंक्ति उत्पाद चुनें — अभी चुनने की आवश्यकता नहीं.",
    "tallysheet.tu.directionChangeHint": "सहेजा गया — सेव करने के बाद दिशा बदली नहीं जा सकती.",
    "tallysheet.tu.gridStyleChangeHint": "सहेजा गया — सेव करने के बाद लेआउट बदला नहीं जा सकता.",
    "tallysheet.tu.destinationSite": "गंतव्य साइट",
    "tallysheet.tu.destinationSiteRequired": "गंतव्य साइट आवश्यक है।",
    "tallysheet.tu.origin": "मूल स्थान",
    "tallysheet.tu.originOptional": "मूल स्थान (वैकल्पिक)",
    "tallysheet.tu.quality": "गुणवत्ता",
    "tallysheet.tu.qualityOptional": "गुणवत्ता (वैकल्पिक)",
    "tallysheet.tu.qualityMixed": "मिश्रित / कोई भी",
    "tallysheet.tu.cbmInStock": "सीबीएम स्टॉक में",
    "tallysheet.tu.inStockSuffix": "उपलब्ध",
    "tallysheet.tu.clickForCft": "CFT में देखने के लिए क्लिक करें",
    "tallysheet.tu.clickForCbm": "CBM में देखने के लिए क्लिक करें",
    "tallysheet.tu.afterThisSave": "सेव के बाद शेष",
    "tallysheet.tu.heldByThisSheet": "इस शीट के पास",
    "tallysheet.tu.stockFree": "उपलब्ध",
    "tallysheet.tu.stockHeld": "होल्ड",
    "tallysheet.tu.stockInStock": "स्टॉक में",
    "tallysheet.tu.stockRowSizeTip": "जिस पंक्ति पर क्लिक किया: इस शीट के लिए उपलब्ध, दूसरे स्टॉक आउट के लिए होल्ड, और कुल स्टॉक (यही लंबाई या लंबी)",
    "tallysheet.tu.stockAvailability": "स्टॉक उपलब्धता",
    "tallysheet.tu.noStock": "स्टॉक में नहीं",
    "tallysheet.tu.stockCantVerifyOffline": "सत्यापित नहीं किया जा सकता — ऑफ़लाइन",
    "tallysheet.tu.noStockAtSite": "यहां स्टॉक नहीं है",
    "tallysheet.tu.availableAtSite": "यहां उपलब्ध है",
    "tallysheet.tu.stockBreakdownTitle": "स्टॉक विवरण",
    "tallysheet.tu.stockOrigin": "मूल",
    "tallysheet.tu.stockQuality": "गुणवत्ता",
    "tallysheet.tu.stockPieces": "टुकड़े",
    "tallysheet.tu.stockSeal": "सील",
    "tallysheet.tu.stockSupplier": "आपूर्तिकर्ता",
    "tallysheet.tu.stockNoContributors": "कोई योगदान देने वाला स्टॉक यूनिट नहीं मिला।",
    "tallysheet.tu.confirmDeleteHeader": "हटाने की पुष्टि करें",
    "tallysheet.tu.confirmDeleteMessage": "क्या आप वाकई स्टॉक यूनिट ({transportId}) को हटाना चाहते हैं?",
    "tallysheet.tu.deleteConfirmAccept": "हाँ, हटाएं",
    "tallysheet.tu.deletedSuccess": "स्टॉक यूनिट सफलतापूर्वक हटाई गई",
    "tallysheet.tu.deleteNotAllowedHeader": "हटाने की अनुमति नहीं",
    "tallysheet.tu.deleteNotAllowedFallback": "यह स्टॉक यूनिट अभी हटाई नहीं जा सकती।",
    "tallysheet.tu.deleteFailedHeader": "हटाना विफल",
    "tallysheet.tu.deleteFailedMessage": "स्टॉक यूनिट हटाने में असमर्थ। कृपया बाद में पुनः प्रयास करें।",
    "tallysheet.fulfill.title": "पूर्ति योजना",
    "tallysheet.fulfill.size": "आकार",
    "tallysheet.fulfill.grade": "ग्रेड",
    "tallysheet.fulfill.inStock": "स्टॉक में",
    "tallysheet.fulfill.allocate": "उपयोग",
    "tallysheet.fulfill.waste": "अपव्यय",
    "tallysheet.fulfill.why": "कारण",
    "tallysheet.fulfill.required": "आवश्यक",
    "tallysheet.fulfill.covered": "पूर्ण",
    "tallysheet.fulfill.short": "कम",
    "tallysheet.fulfill.moreOptions": "और विकल्प",
    "tallysheet.fulfill.noStock": "इस आकार, मूल और गुणवत्ता के लिए कोई व्यावहारिक स्टॉक नहीं मिला।",
    "tallysheet.fulfill.tierExact": "सटीक मिलान",
    "tallysheet.fulfill.tierTrim": "लंबा — ट्रिम करें",
    "tallysheet.fulfill.tierResaw": "बड़े से पुनः-चीरा",
    "tallysheet.fulfill.tierGrade": "अलग ग्रेड",
    "tallysheet.fulfill.tierOrigin": "अलग मूल",
    "tallysheet.fulfill.tierShort": "छोटा — पुष्टि करें",
    "tallysheet.fulfill.tierMixed": "मिश्रित लंबाई — जांचें",
    "tallysheet.quick.button": "क्विक टैली",
    "tallysheet.quick.tooltip": "4x3x7 250 Ghana A जैसा शॉर्टहैंड लिखें — सिस्टम पंक्तियां बना देगा",
    "tallysheet.quick.title": "क्विक टैली",
    "tallysheet.quick.hint": "प्रति कॉमा या लाइन एक प्रविष्टि: आकार, टुकड़े, फिर वैकल्पिक मूल और गुणवत्ता। उदाहरण: 4x3x7 250 Ghana A",
    "tallysheet.quick.notes": "टिप्पणियां",
    "tallysheet.quick.apply": "पंक्तियां जोड़ें",
    "tallysheet.quick.noDimensions": "कोई आकार नहीं मिला (जैसे 4x3x7)",
    "tallysheet.quick.noPieces": "टुकड़ों की संख्या अनुपस्थित",
    "tallysheet.quick.lengthMissing": "लंबाई अनुपस्थित — ग्रिड में भरें",
    "tallysheet.flex.button": "फ्लेक्सिबल लेआउट",
    "tallysheet.flex.classicOption": "स्टैंडर्ड लेआउट",
    "tallysheet.flex.searchProducts": "उत्पाद खोजें...",
    "tallysheet.flex.noProductsFound": "कोई उत्पाद नहीं मिला",
    "tallysheet.flex.pickProductFirst": "स्टॉक देखने के लिए पहले एक उत्पाद चुनें",
    "tallysheet.flex.switchTooltip": "स्टैंडर्ड: प्रति-लाइन एक उत्पाद। फ्लेक्सिबल: प्रति-पंक्ति उत्पाद/मूल/गुणवत्ता, साथ ही स्टॉक से आकार चुनना",
    "tallysheet.flex.cascadeTitle": "पंक्ति उत्पाद",
    "tallysheet.flex.stockTitle": "स्टॉक से चुनें",
    "tallysheet.flex.noProductYet": "अभी तक कोई उत्पाद नहीं चुना गया",
    "tallysheet.flex.sameAsLine": "लाइन के समान",
    "tallysheet.flex.typedSoFar": "अब तक लिखा",
    "tallysheet.flex.showAll": "सभी दिखाएं",
    "tallysheet.flex.requestCustomMade": "उपलब्ध नहीं — इसे कस्टम-मेड बनवाने का अनुरोध करें",
    "tallysheet.flex.cancelRequest": "अनुरोध रद्द करें",
    "tallysheet.flex.cancelRequestHeader": "मिल का अनुरोध रद्द करें?",
    "tallysheet.flex.cancelRequestMessage": "मिल अब इस पंक्ति के लिए यह साइज़ नहीं काटेगी। आप बाद में फिर अनुरोध कर सकते हैं।",
    "tallysheet.flex.cancelRequestYes": "हाँ, रद्द करें",
    "tallysheet.flex.cancelRequestDone": "मिल का अनुरोध रद्द हुआ",
    "tallysheet.flex.noneMatchExactly": "इनमें से कोई भी बिल्कुल मेल नहीं खाता:",
    "tallysheet.flex.stockStaleNotice": "आपके अंतिम सिंक तक का स्टॉक दिखाया जा रहा है — पुराना हो सकता है।",
    "tallysheet.flex.availablePcs": "टुकड़े इस आकार के लिए उपलब्ध",
    "tallysheet.flex.availableCbm": "CBM उपलब्ध",
    "tallysheet.flex.availableStockTooltip": "उपलब्ध स्टॉक में वह मात्रा शामिल नहीं है जो पहले से ही अन्य सेव की गई स्टॉक-आउट पंक्तियों और सक्रिय मिल कार्यों द्वारा आरक्षित है — अभी पुष्टि नहीं हुई, लेकिन पहले से तय है। इसे कंपनी → इन्वेंटरी सेटिंग्स में बदलें।",
    "tallysheet.flex.customMadeLockedTitle": "पंक्ति लॉक — मिल कार्य जारी है",
    "tallysheet.flex.customMadeLockedDetail": "इस पंक्ति की सामग्री पहले से ही मिल कार्य द्वारा काटी जा रही है और जब तक वह कार्य पूरा नहीं हो जाता, इसे संपादित या हटाया नहीं जा सकता। कार्य पूरा होते ही यह अपने आप अनलॉक हो जाएगी — कोई कार्रवाई आवश्यक नहीं।",
    "tallysheet.flex.importUnavailable": "फ्लेक्सिबल व्यू में इंपोर्ट उपलब्ध नहीं है — इंपोर्ट करने के लिए स्टैंडर्ड लेआउट पर स्विच करें।",
    "tallysheet.flex.customMadeLockedTooltipProducing": "लॉक — एक मिल कार्य अभी इस आकार को काट रहा है। वह कार्य पूरा होते ही यह अपने आप अनलॉक हो जाएगी।",
    "tallysheet.flex.customMadeLockedTooltipWaiting": "लॉक — इस आकार के लिए एक मिल कार्य बनाया गया है और शुरू होने की कतार में है। वह कार्य पूरा होते ही यह अपने आप अनलॉक हो जाएगी।",
    "tallysheet.flex.customMadeLockedTooltipPaused": "लॉक — इस आकार का मिल कार्य शुरू हो चुका है और अभी रुका हुआ है। वह कार्य पूरा या रद्द होते ही यह अपने आप अनलॉक हो जाएगी।",
    "tally.aiReview.needsOne": "पंक्ति को जाँचना है — AI को भरोसा नहीं था या कोई मान पढ़ नहीं सका",
    "tally.aiReview.needsMany": "पंक्तियों को जाँचना है — AI को भरोसा नहीं था या कोई मान पढ़ नहीं सका",
    "tally.aiReview.showOnly": "सिर्फ़ ये दिखाएँ",
    "tally.aiReview.showAll": "सभी पंक्तियाँ दिखाएँ",
    "tally.aiReview.showOnlyTip": "सिर्फ़ ये पंक्तियाँ दिखाएँ",
    "tally.aiReview.prev": "पिछली जाँचने वाली पंक्ति",
    "tally.aiReview.next": "अगली जाँचने वाली पंक्ति",
    "tally.aiReview.row": "पंक्ति",
    "tally.warn.lengthRange": "लंबाई तय सीमा से बाहर है — मान रखा गया है",
    "tally.warn.girthRange": "गोलाई तय सीमा से बाहर है — मान रखा गया है",
    "tally.errorNav.lengthMissing": "पंक्ति {row}: लंबाई नहीं भरी है",
    "tally.errorNav.girthMissing": "पंक्ति {row}: गोलाई नहीं भरी है",
    "tally.errorNav.bothMissing": "पंक्ति {row}: लंबाई और गोलाई नहीं भरी हैं",
    "tally.warn.divisibleBy5": "लंबाई 5 से विभाज्य नहीं है — मान रखा गया है",
    "tallysheet.flex.deleteRowConfirm": "इस पंक्ति को हटाएं?",
    "tallysheet.flex.stockStatusLabel": "स्टॉक स्थिति",
    "tallysheet.flex.stockStatusNotReserved": "लाल बिंदु — अभी तक कोई सटीक मिलान नहीं, इस पंक्ति के लिए कुछ भी आरक्षित नहीं",
    "tallysheet.flex.stockStatusMillTask": "प्रोड्यूसिंग / शुरू होने का इंतजार — एक सक्रिय मिल कार्य द्वारा रोका गया",
    "tallysheet.flex.stockStatusReserved": "कोई बैज नहीं — वास्तविक स्टॉक से मेल खाया और आरक्षित",
    "company.includeReservations.label": "उपलब्ध स्टॉक में चल रहे काम को शामिल करें",
    "company.includeReservations.hint": "डिफ़ॉल्ट रूप से चालू — सेव की गई स्टॉक-आउट पंक्तियों या सक्रिय मिल कार्यों द्वारा पहले से दावा किया गया स्टॉक तब तक उपलब्ध नहीं दिखेगा जब तक पुष्टि या जारी नहीं किया जाता। वास्तविक भौतिक कुल देखने के लिए इसे बंद करें।",
    "tallysheet.flex.back": "पीछे",
    "tallysheet.flex.next": "आगे",
    "tallysheet.flex.done": "पूर्ण",
    "tallysheet.flex.scEnter": "विज़ार्ड/पिकर खोलें · टुकड़ों पर: अगली भरी पंक्ति",
    "tallysheet.flex.scAltEnter": "स्टॉक पिकर कभी भी",
    "tallysheet.flex.scCtrlEnter": "नई पंक्ति",
    "tallysheet.flex.scCtrlBackspace": "पंक्ति साफ़ करें",
    "tallysheet.flex.shortcutsLabel": "शॉर्टकट",
    "tallysheet.flex.shapeSubtitleSquare": "🔵 यह एक स्क्वायर टैली है — केवल चौकोर-कटे उत्पाद दिखाए जाते हैं। गोल उत्पाद यहां नहीं दिखेंगे।",
    "tallysheet.flex.shapeRedirect": "अलग आकार चाहिए (जैसे गोल लट्ठे)? स्टैंडर्ड लेआउट पर स्विच करें — वहां हर उत्पाद लाइन का अपना टैली प्रकार होता है।",
    "tallysheet.flex.lockedTooltip": "लॉक — इस शीट में पहले से सहेजी गई पंक्तियां हैं। सहेजने से पहले लेआउट चुनें।",
    "tallysheet.flex.confirmSwitchHeader": "फ्लेक्सिबल लेआउट पर स्विच करें?",
    "tallysheet.flex.confirmSwitchMessage": "आपके पास असहेजी गई पंक्तियां हैं। स्विच करना सुरक्षित है, लेकिन पहले सहेजने पर विचार करें। जारी रखें?",
    "tallysheet.tu.stockAnyOrigin": "कोई भी मूल",
    "tallysheet.tu.stockAnyQuality": "कोई भी गुणवत्ता",
    "tallysheet.tu.additionalProducts": "अतिरिक्त उत्पाद",
    "tallysheet.tu.products": "उत्पाद",
    "tallysheet.tu.viewStock": "स्टॉक उपलब्धता देखें",
    "tallysheet.tu.removeLineConfirmHeader": "टैलीशीट हटाएं",
    "tallysheet.tu.removeLineConfirmMessage": "{product} की टैलीशीट हटाने से इससे जुड़े {count} टैली रिकॉर्ड स्थायी रूप से हट जाएंगे। जारी रखने के लिए CONFIRM लिखें।",
    "tallysheet.tu.addAnotherProduct": "एक और उत्पाद जोड़ें",
    "tallysheet.tu.removeLine": "इस उत्पाद लाइन को हटाएं",
    "tallysheet.tu.removeLineHeader": "उत्पाद लाइन हटाएं",
    "tallysheet.tu.removeLineMessage": "यदि इस लाइन में पहले से टैली पंक्तियाँ हैं, तो उन्हें पहले हटाना होगा — अन्यथा सहेजना अवरुद्ध हो जाएगा।",
    "tallysheet.tu.typeSwitchHeader": "टैली प्रकार बदल जाएगा",
    "tallysheet.tu.typeSwitchMessage": "{lines} पर उत्पाद बदलने से इसका टैली प्रकार बदल जाता है — उस लाइन की मौजूदा टैली पंक्तियाँ स्थायी रूप से हटा दी जाएंगी। जारी रखें?",
    "tallysheet.overStock.header": "उपलब्ध स्टॉक से अधिक सहेजना",
    "tallysheet.overStock.message": "{line} को {total} सीबीएम पर टैली किया जाएगा, लेकिन स्टॉक में केवल {available} सीबीएम उपलब्ध है। कृपया बताएं कि आप फिर भी क्यों जारी रखना चाहते हैं:",
    "tallysheet.overStock.reasonPlaceholder": "कारण (आवश्यक)",
    "tallysheet.overStock.proceed": "फिर भी सहेजें",
    "tallysheet.stockUnitId": "स्टॉक यूनिट ID",
    "tallysheet.tu.tooltipStockUnitId": "इस स्टॉक यूनिट की पहचान — सिस्टम द्वारा अपने आप बनाई जाती है, अद्वितीय है, बदली नहीं जा सकती। सेव करते ही बन जाती है।",
    "tallysheet.stockUnitIdPending": "लंबित",
    "tallysheet.transportId": "ट्रांसपोर्ट ID",
    "tallysheet.transportModeDetails": "ट्रांसपोर्ट मोड विवरण",
    "tallysheet.tu.tooltipTransportId": "असली ट्रक/कंटेनर/वाहन के लिए वैकल्पिक संदर्भ — दोहराया जा सकता है (जैसे एक ही ट्रक फिर से आ सकता है)",
    "tallysheet.tu.tooltipContainerNumber": "वाहक द्वारा निर्धारित ISO कंटेनर नंबर — 4 अक्षर + 6 अंक + चेक डिजिट (जैसे MSCU1234567)",
    "tallysheet.tu.tooltipSealNo": "कंटेनर के दरवाजे पर लगी भौतिक सुरक्षा सील — फाइटोसेनिटरी और सीमाशुल्क दस्तावेज़ों में संदर्भित (जैसे SNHR123456)",
    "tallysheet.tu.tooltipLoadingSite": "जहाँ से लकड़ी मूल रूप से लोड की गई — उत्पत्ति स्थान (जंगल, यार्ड, मिल, या बंदरगाह)",
    "tallysheet.tu.tooltipRoute": "स्थान से गंतव्य तक ट्रक का यात्रा मार्ग (जैसे रायपुर से कांडला पोर्ट)",
    "tallysheet.tu.tooltipVehicleRegNo": "ट्रक या ट्रेलर की आधिकारिक रजिस्ट्रेशन प्लेट (जैसे MH04-AB-1234)",
    "tallysheet.tu.tooltipWagonNo": "रेलवे वैगन नंबर जैसा रेलकार पर मुद्रित है (जैसे BOXN-67890)",
    "tallysheet.chooseColumns": "कॉलम चुनें",
    "tallysheet.colPreset.simple": "सरल",
    "tallysheet.colPreset.detailed": "विस्तृत",
    "tallysheet.colPreset.custom": "कस्टम",
    "tallysheet.colGroup.measurements": "माप",
    "tallysheet.colGroup.volume": "आयतन",
    "tallysheet.colGroup.allowances": "छूट",
    "tallysheet.colGroup.other": "अन्य",
    "tallysheet.editSettings": "टैली सेटिंग्स बदलें",
    "tallysheet.decimalsShort": "दशमलव",
    "tallysheet.globalSearch": "ग्लोबल खोज",
    "tallysheet.transportUnits": "स्टॉक यूनिट्स",
    "tallysheet.unit": "इकाई",
    "tallysheet.units": "इकाइयाँ",
    "tallysheet.transportUnitsSubtitle": "स्टॉक यूनिट्स देखें, टैली खोलें और सुरक्षित शेयर लिंक प्रबंधित करें",
    "tallysheet.viewTallysheet": "टैलीशीट देखें",
    "tallysheet.thisPage": "यह पेज",
    "tallysheet.allPages": "सभी पेज",
    "tallysheet.sortNewest": "नए पहले",
    "tallysheet.sortOldest": "पुराने पहले",
    "tallysheet.sortStockUnitId": "स्टॉक यूनिट ID",
    "tallysheet.sortProduct": "प्रोडक्ट",
    "tallysheet.fullReportPdf": "पूरी रिपोर्ट (PDF)",
    "tallysheet.copyTransportId": "ट्रांसपोर्ट ID कॉपी करें",
    "tallysheet.operations": "ऑपरेशन",
    "tallysheet.newTallysheet": "नई टैलीशीट",
    "tallysheet.syncedTitle": "सिंक हो गया",
    "tallysheet.syncedDetail": "यह स्टॉक यूनिट सर्वर से सिंक हो गई है।",
    "tallysheet.newTransportUnit": "नई स्टॉक यूनिट",
    "tallysheet.newTallysheetSubtitle": "स्टॉक यूनिट विवरण, टैली माप, फोटो और सारांश एक ही वर्कफ्लो में कैप्चर करें.",
    "tallysheet.editTransportUnit": "स्टॉक यूनिट संपादित करें",
    "tallysheet.viewTransportUnit": "स्टॉक यूनिट देखें",
    "tallysheet.editTransportUnitSubtitle": "स्टॉक यूनिट विवरण, टैली माप, फोटो और सारांश एक ही वर्कफ्लो में अपडेट करें.",
    "tallysheet.viewTransportUnitSubtitle": "स्टॉक यूनिट विवरण, टैली माप, फोटो और सारांश एक ही वर्कफ्लो में देखें.",
    "tallysheet.transportUnit": "स्टॉक यूनिट",
    "tallysheet.switchingTu": "स्टॉक यूनिट लोड हो रही है…",
    "tallysheet.tuLoadFailed": "यह स्टॉक यूनिट लोड नहीं हो सकी.",
    "tallysheet.tallysheet": "टैलीशीट",
    "tallysheet.roundTallysheet": "राउंड टैलीशीट",
    "tallysheet.squareTallysheet": "स्क्वायर टैलीशीट",
    "tallysheet.measurementGrid": "माप ग्रिड",
    "tallysheet.measurementGridSubtitle": "टैली माप कैप्चर, वैलिडेट, इंपोर्ट और सेव करें",
    "tallysheet.rows": "पंक्तियां",
    "tallysheet.columnsSelected": "कॉलम",
    "tallysheet.editActions": "संपादन",
    "tallysheet.viewControls": "व्यू",
    "tallysheet.dataActions": "डेटा",
    "tallysheet.voiceControls": "वॉयस",
    "tallysheet.photos": "फोटो",
    "tallysheet.summary": "सारांश",
    "tallysheet.reconciliation": "रिकन्सिलिएशन",
    "tallysheet.goToRow": "पंक्ति पर जाएं",
    "tallysheet.export": "एक्सपोर्ट",
    "export.companyDetails": "कंपनी विवरण",
    "export.chartsAndStats": "चार्ट और आंकड़े",
    "export.showMaskedFields": "मास्क्ड फ़ील्ड दिखाएं",
    "export.watermark": "वॉटरमार्क",
    "export.packingList": "पैकिंग लिस्ट",
    "export.surveyReport": "सर्वे रिपोर्ट",
    "export.certificate": "प्रमाण पत्र",
    "tallysheet.save": "सेव",
    "tallysheet.sr": "क्रम",
    "tallysheet.orderKey": "ऑर्डर की",
    "tallysheet.girth": "गिर्थ",
    "tallysheet.lengthAllowanceShort": "लंबाई छूट",
    "tallysheet.girthAllowanceShort": "गिर्थ छूट",
    "tallysheet.netLength": "नेट लंबाई",
    "tallysheet.netGirth": "नेट गिर्थ",
    "tallysheet.net": "शुद्ध",
    "tallysheet.gross": "सकल",
    "tallysheet.allowance": "छूट",
    "tallysheet.volBasisHint": "शुद्ध आयतन दिख रहा है — सकल के लिए टैप करें",
    "tallysheet.volBasisHintGross": "सकल आयतन दिख रहा है — शुद्ध के लिए टैप करें",
    "tallysheet.volBasisWhy": "स्टॉक, बिक्री और मिल काम के लिए शुद्ध (Net) गिना जाता है। सकल (Gross) वह नाप है जो पहले ली गई थी। बदलने के लिए Net या Gross पर टैप करें।",
    "tallysheet.volBreakdownTitle": "शुद्ध बनाम सकल आयतन",
    "tallysheet.volBreakdownExplain": "स्टॉक, बिक्री और मिल काम में शुद्ध (Net) गिना जाता है। सकल (Gross) वह नाप है जो छाल और छंटाई की छूट घटाने से पहले ली गई थी।",
    "tallysheet.switchToGross": "सकल (Gross) पर बदलें",
    "tallysheet.switchToNet": "शुद्ध (Net) पर बदलें",
    "tallysheet.grossCbm": "ग्रॉस CBM",
    "tallysheet.grossCft": "ग्रॉस CFT",
    "tallysheet.netCbm": "नेट CBM",
    "tallysheet.netCft": "नेट CFT",
    "tallysheet.supplier": "सप्लायर",
    "tallysheet.buyer": "बायर",
    "tallysheet.driver": "ड्राइवर",
    "tallysheet.route": "रूट",
    "tallysheet.expectedDelivery": "अपेक्षित डिलीवरी",
    "tallysheet.mode": "मोड",
    "tallysheet.seaPort": "सी पोर्ट",
    "tallysheet.locationMode": "स्थान और मोड",
    "tallysheet.totalPieces": "कुल पीस",
    "tallysheet.netVolumeCbm": "नेट वॉल्यूम (CBM)",
    "tallysheet.avgCft": "औसत CFT",
    "tallysheet.weight": "वजन (kg)",
    "tallysheet.photoCount": "फोटो",
    "tallysheet.metrics": "मेट्रिक्स",
    "tallysheet.divisibleBy5": "5 से विभाज्य",
    "tallysheet.divisibleBy5On": "5 से विभाज्य ON",
    "tallysheet.divisibleBy5Off": "5 से विभाज्य OFF",
    "tallysheet.lengthRange": "लंबाई सीमा",
    "tallysheet.lengthRangeOn": "लंबाई सीमा ON",
    "tallysheet.widthRange": "चौड़ाई सीमा",
    "tallysheet.thickRange": "मोटाई सीमा",
    "tallysheet.rangeOn": "चालू",
    "tallysheet.rangeOff": "बंद",
    "tallysheet.rangeHint": "सीमा से बाहर के मान चेतावनी (पीले) रंग में दिखेंगे और रखे जाएँगे।",
    "tallysheet.resetToCompanyDefaults": "कंपनी की डिफ़ॉल्ट सेटिंग पर लौटें",
    "tallysheet.resetConfirm": "इस टैली की इकाइयाँ, छूट और नियम बदल जाएँगे।",
    "tallysheet.resetYes": "रीसेट करें",
    "tallysheet.lengthRangeOff": "लंबाई सीमा OFF",
    "tallysheet.girthRange": "गिर्थ सीमा",
    "tallysheet.girthRangeOn": "गिर्थ सीमा ON",
    "tallysheet.girthRangeOff": "गिर्थ सीमा OFF",
    "tallysheet.unitOfMeasure": "माप की यूनिट",
    "tallysheet.copyPreviousLength": "पिछली लंबाई कॉपी करें",
    "tallysheet.enterNavMode": "↵ Mode",
    "tallysheet.enterNavModeTooltip": "<b>पंक्ति मोड:</b> Length पर Enter → Girth; Girth पर Enter → नई पंक्ति।<br><b>कॉलम मोड:</b> Length पर Enter → नई पंक्ति (Length कॉलम में रहें); Girth पर Enter → अगली पंक्ति का Girth (अंतिम पंक्ति पर नई पंक्ति बनाता है)।<br><b>Ctrl+Enter</b> (किसी भी मोड में) → सत्यापन को छोड़कर जबरन आगे बढ़ें।",
    "tallysheet.allowances": "छूट",
    "tallysheet.lengthAllowance": "लंबाई छूट",
    "tallysheet.girthAllowance": "गिर्थ छूट",
    "tallysheet.allowancesLocked":
      "जब पंक्तियां इससे अधिक हों तो छूट लॉक हो जाती है",
    "tallysheet.columns": "कॉलम",
    "tallysheet.showColumns": "कॉलम दिखाएं",
    "tallysheet.saveFormSettings": "फॉर्म सेटिंग्स सेव करें",
    "tallysheet.confirmSave": "सेव पुष्टि",
    "tallysheet.uomChangeTitle": "माप की इकाई बदलें?",
    "tallysheet.uomChangeMessage":
      "इस टैली में पहले से पंक्तियाँ दर्ज हैं। नई इकाई के लिए मौजूदा {field} मान कैसे संभाले जाएं?",
    "tallysheet.uomChangeKeep": "संख्याएँ जैसी टाइप की गई थीं वैसी रखें",
    "tallysheet.uomChangeKeepHint":
      "नई इकाई के अंतर्गत उन्हीं संख्याओं से पुनर्गणना करें — उपयोग करें यदि आपने सही संख्याएँ टाइप कीं लेकिन गलत इकाई चुनी थी।",
    "tallysheet.uomChangeConvert": "मान परिवर्तित करें",
    "tallysheet.uomChangeConvertHint":
      "समान भौतिक माप बनाए रखते हुए मौजूदा संख्याओं को नई इकाई में फिर से लिखें।",
    "tallysheet.uomChangeCancel": "रद्द करें",
    "account.profilePicture": "प्रोफ़ाइल तस्वीर",
    "account.yourRole": "आपकी भूमिका",
    "account.details": "खाता विवरण",
    "account.personalDetails": "व्यक्तिगत विवरण",
    "account.detailsHint": "आपका साइन-इन ईमेल और सत्यापित मोबाइल नंबर",
    "account.personalHint": "आपके बारे में, ताकि आपकी टीम और दस्तावेज़ों में सही नाम दिखे",
    "account.addressHeading": "पता",
    "account.changePassword": "पासवर्ड बदलें",
    "account.emailNotVerified":
      "ईमेल सत्यापित नहीं है. कृपया अपना ईमेल पता सत्यापित करें.",
    "account.mobile": "मोबाइल",
    "account.enterMobile": "मोबाइल नंबर दर्ज करें",
    "account.mobileNotVerified":
      "मोबाइल सत्यापित नहीं है. कृपया अपना मोबाइल नंबर सत्यापित करें.",
    "account.sendOtp": "OTP भेजें",
    "account.editMobile": "मोबाइल संपादित करें",
    "account.dateOfBirth": "जन्म तिथि",
    "account.gender": "लिंग",
    "account.next": "आगे",
    "account.otpSentTo": "OTP भेजा गया है",
    "account.enterOtpBelow":
      "फोन नंबर सत्यापित करने के लिए नीचे OTP दर्ज करें.",
    "account.resendOtpIn": "OTP फिर भेजें",
    "account.seconds": "सेकंड",
    "account.resend": "फिर भेजें",
    "account.sendOtpWhatsapp": "WhatsApp पर कोड भेजें",
    "account.sendOtpSms": "SMS से कोड भेजें",
    "account.otpWhatsappNote": "कोड LumberLinq की ओर से WhatsApp पर आएगा। Copy code दबाएँ, फिर यहाँ पेस्ट करें।",
    "account.otpWhatsappFailed": "हम WhatsApp पर कोड नहीं भेज सके। जाँचें कि यह नंबर WhatsApp पर है, या कोड SMS से भेजें।",
    "account.otpUseSms": "इसके बजाय SMS से भेजें",
    "account.otpUseWhatsapp": "इसके बजाय WhatsApp पर भेजें",
    "account.otpPickHint": "अपना 6 अंकों का कोड WhatsApp या SMS पर पाएँ",
    "account.otpWaDelivered": "कोड अब आपके WhatsApp पर है। चैट खोलें, Copy code दबाएँ और यहाँ पेस्ट करें।",
    "account.otpWaNotDelivered": "WhatsApp कोड नहीं पहुँचा सका (हो सकता है यह नंबर WhatsApp पर न हो)। कृपया कोड SMS से भेजें।",
    "account.otpWaPending": "अभी तक फ़ोन पर नहीं आया? थोड़ा रुकें, फिर से भेजें, या कोड SMS से भेजें।",
    "account.confirm": "पुष्टि करें",
    "account.oldPassword": "पुराना पासवर्ड",
    "account.newPassword": "नया पासवर्ड",
    "account.confirmPassword": "पासवर्ड पुष्टि करें",
    "account.oldPasswordRequired": "पुराना पासवर्ड आवश्यक है.",
    "account.passwordMinLength": "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए.",
    "account.passwordStrengthHint": "पासवर्ड में कम से कम एक अक्षर और एक अंक होना चाहिए.",
    "account.passwordChangeFailed": "पासवर्ड बदलने में विफल. कृपया पुनः प्रयास करें.",
    "account.confirmPasswordRequired": "पासवर्ड पुष्टि आवश्यक है.",
    "account.passwordsMismatch": "पासवर्ड मेल नहीं खाते.",
    "account.mustBeAtLeast13": "आपकी आयु कम से कम 13 वर्ष होनी चाहिए.",
    "user.mustBeAtLeast13": "आपकी आयु कम से कम 13 वर्ष होनी चाहिए.",
    "account.notValidEmail": "मान्य ईमेल नहीं है",
    "account.passwordRule":
      "में कम से कम 1 अपरकेस, 1 लोअरकेस अक्षर और 1 नंबर होना चाहिए",
    "account.mustBeAtLeast": "कम से कम",
    "account.charactersLong": "अक्षर लंबा होना चाहिए",
    "account.profileUpdated": "प्रोफाइल सफलतापूर्वक अपडेट हुई.",
    "account.profileLoadFailed": "प्रोफाइल विवरण लोड नहीं हो सका.",
    "account.noProfileChanges": "अपडेट करने के लिए कोई प्रोफाइल बदलाव नहीं है.",
    "account.saveAllHint": "खाता विवरण, व्यक्तिगत विवरण और टाइमज़ोन एक साथ सहेजता है।",
    "account.requiredAddressFields": "जारी रखने से पहले सभी आवश्यक पते के फ़ील्ड पूरे करें.",
    "account.requiredFields": "जारी रखने से पहले सभी आवश्यक फ़ील्ड पूरे करें.",
    "account.updateFailed": "रिकॉर्ड अपडेट करते समय त्रुटि हुई.",
    "account.verificationRequired": "सत्यापन आवश्यक",
    "account.verifyMobileAndEmail": "पहले अपना मोबाइल और ईमेल सत्यापित करें.",
    "account.mobileVerified": "मोबाइल सत्यापित",
    "account.mobileAlreadyVerified": "आपका मोबाइल नंबर पहले से सत्यापित है.",
    "account.mobileLocked": "सत्यापित मोबाइल नंबर इस स्क्रीन से बदला नहीं जा सकता.",
    "account.otpSent": "OTP भेजा गया",
    "account.otpError": "OTP त्रुटि",
    "account.otpUnableToSend": "OTP भेजा नहीं जा सका.",
    "account.tryAgainLater": "कृपया बाद में फिर प्रयास करें",
    "account.maxOtpAttempts": "आप OTP फिर से भेजने के अधिकतम प्रयासों तक पहुंच गए हैं.",
    "account.otpValidated": "OTP सत्यापित",
    "account.otpInvalidTitle": "OTP अमान्य है",
    "account.otpInvalid": "अमान्य OTP.",
    "account.otpDigit": "OTP अंक",
    "account.invalidMobileOnly": "केवल मोबाइल नंबर स्वीकार हैं. कृपया मान्य मोबाइल नंबर दर्ज करें.",
    "account.invalidPhoneFormat": "अमान्य फोन नंबर प्रारूप.",
    Male: "पुरुष",
    Female: "महिला",
    "Prefer not to say": "बताना नहीं चाहते",
    "product.name": "प्रोडक्ट",
    "product.multipleProducts": "प्रोडक्ट्स",
    "product.multipleProductsBreakdown": "इस यूनिट में प्रोडक्ट्स",
    "product.namePlural": "प्रोडक्ट्स",
    "product.subtitle": "लकड़ी के प्रोडक्ट, प्रजाति और HS कोड प्रबंधित करें",
    "product.all": "सभी प्रोडक्ट्स",
    "product.update": "प्रोडक्ट अपडेट करें",
    "product.manageDetails": "मौजूदा प्रोडक्ट विवरण देखें और प्रबंधित करें",
    "product.editDetails": "मौजूदा प्रोडक्ट्स का विवरण संपादित करें",
    "product.hsCode": "HS कोड",
    "product.formula": "फॉर्मूला",
    "product.selectFormula": "फॉर्मूला चुनें",
    "product.quickAdd": "नया उत्पाद जोड़ें",
    "product.quickAddTitle": "नया उत्पाद",
    "product.nameRequiredHint": "नाम कम से कम 5 अक्षर का होना चाहिए।",
    "product.hsCodeHint": "HS कोड 4-8 अंकों का होना चाहिए।",
    "product.quickAddedDetail": "उत्पाद बनाया गया और चुना गया।",
    "product.quickAddError": "उत्पाद नहीं बनाया जा सका। कृपया पुनः प्रयास करें।",
    "product.description": "विवरण",
    "product.species": "प्रजाति",
    "product.usedIn": "उपयोग में",
    "product.selectSpecies": "प्रजाति चुनें",
    "product.productCode": "उत्पाद कोड",
    "product.photos": "उत्पाद फ़ोटो",
    "product.addPhoto": "फ़ोटो जोड़ें",
    "product.setAsDP": "प्रदर्शन चित्र सेट करें",
    "product.formulasGuide": "फॉर्मूला गाइड",
    "product.formulaGuide.roundTitle": "गोल लट्ठा",
    "product.formulaGuide.roundFormula": "हॉपस सूत्र: (घेरा × घेरा × लंबाई) ÷ 160,000",
    "product.formulaGuide.roundWhen": "गोल, अनप्रोसेस्ड लट्ठों और राउंडवुड के लिए।",
    "product.formulaGuide.roundChoose": "यह चुनें जब क्रॉस-सेक्शन गोल हो — साबुत लट्ठे, कच्ची लकड़ी और अनप्रोसेस्ड गोल लकड़ी।",
    "product.formulaGuide.squareTitle": "चौकोर / चिरी लकड़ी",
    "product.formulaGuide.squareFormula": "आयतनात्मक सूत्र: लंबाई × चौड़ाई × ऊंचाई",
    "product.formulaGuide.squareWhen": "चिरी हुई या चौकोर-कट लकड़ी के लिए।",
    "product.formulaGuide.squareChoose": "यह चुनें जब लकड़ी आयताकार या चौकोर-कट हो — तख्ते, बीम, लम्बर और तैयार लकड़ी।",
    "product.formulaGuide.notSure": "कौन सा चुनें?",
    "product.formulaGuide.tip": "गोल क्रॉस-सेक्शन → गोल लट्ठा। आयताकार या चौकोर-कट → चौकोर / चिरी लकड़ी।",
    "product.formulaPicker": "फॉर्मूला पिकर",
    "product.deletionRestriction": "प्रोडक्ट हटाने पर प्रतिबंध",
    "product.addNew": "नया प्रोडक्ट जोड़ें",
    "product.bulkImport": "बल्क इम्पोर्ट",
    "product.create": "प्रोडक्ट बनाएं",
    "product.inputDetails": "नए प्रोडक्ट का विवरण दर्ज करें",
    "loadingSite.name": "स्थान का नाम",
    "loadingSite.namePlural": "स्थान",
    "loadingSite.quickAdd": "नया स्थान जोड़ें",
    "loadingSite.quickAddTitle": "नया स्थान",
    "loadingSite.nameRequired": "नाम कम से कम 3 अक्षर का होना चाहिए।",
    "loadingSite.quickAddedDetail": "स्थान बनाया गया और चुना गया।",
    "loadingSite.quickAddError": "स्थान नहीं बनाया जा सका। कृपया पुनः प्रयास करें।",
    "loadingSite.all": "सभी स्थान",
    "loadingSite.update": "स्थान अपडेट करें",
    "loadingSite.manageProfiles":
      "मौजूदा स्थान प्रोफाइल देखें और प्रबंधित करें",
    "loadingSite.editDetails": "मौजूदा स्थानों का विवरण संपादित करें",
    "loadingSite.contactPerson": "संपर्क व्यक्ति",
    "loadingSite.operatingHours": "कार्य समय",
    "loadingSite.capacity": "क्षमता",
    "loadingSite.capacityCbm": "क्षमता (CBM)",
    "loadingSite.currentVolume": "वर्तमान वॉल्यूम",
    "loadingSite.machinesInstalled": "स्थापित मशीनें",
    "loadingSite.notes": "नोट्स",
    "loadingSite.addNew": "नया स्थान जोड़ें",
    "loadingSite.bulkImport": "बल्क इम्पोर्ट",
    "loadingSite.create": "स्थान बनाएं",
    "loadingSite.inputDetails": "नया स्थान विवरण दर्ज करें",
    "location.selectCountry": "देश चुनें",
    "location.selectState": "राज्य चुनें",
    "location.selectCity": "शहर चुनें",
    "location.country": "देश",
    "location.state": "राज्य / प्रांत",
    "location.city": "शहर",
    "location.address1": "पता पंक्ति 1",
    "location.address2": "पता पंक्ति 2",
    "location.postalCode": "पिन कोड",
    "location.cityUnavailableOffline": "ऑफ़लाइन होने पर शहरों की सूची उपलब्ध नहीं है। इस राज्य के शहर लोड करने के लिए एक बार ऑनलाइन कनेक्ट करें।",
    "location.cityNotAvailableOffline": "ऑफ़लाइन उपलब्ध नहीं है",
    "mediaCapture.takePhoto": "फ़ोटो लें",
    "mediaCapture.recordVideo": "वीडियो रिकॉर्ड करें (अधिकतम 30 सेकंड)",
    "mediaCapture.chooseGallery": "गैलरी से चुनें",
    "mediaCapture.browseFiles": "फ़ाइलें ब्राउज़ करें",
    "mediaCapture.videoTooLongTitle": "वीडियो बहुत लंबा है",
    "mediaCapture.videoTooLongDetail": "वीडियो 30 सेकंड या उससे कम का होना चाहिए। कृपया पुनः प्रयास करें।",
    "mediaCapture.captureFailedTitle": "कैप्चर विफल",
    "mediaCapture.captureFailedDetail": "मीडिया कैप्चर नहीं किया जा सका। कृपया पुनः प्रयास करें।",
    "mediaCapture.pasteRejectedTitle": "पेस्ट की गई फ़ाइल स्वीकार नहीं",
    "mediaCapture.pasteRejectedDetail": "यह अपलोड बॉक्स इस प्रकार की फ़ाइल स्वीकार नहीं करता।",
    "sfs.title": "ये फ़ाइलें कहाँ जानी चाहिए?",
    "sfs.filesReady": "फ़ाइल(ें) तैयार",
    "sfs.consignment": "कंसाइनमेंट दस्तावेज़",
    "sfs.consignmentHint": "BL, इनवॉइस, प्रमाणपत्र और बहुत कुछ",
    "sfs.stockUnit": "स्टॉक यूनिट दस्तावेज़",
    "sfs.stockUnitHint": "स्टॉक यूनिट की फ़ोटो और कागज़ात",
    "sfs.aiImport": "AI इंपोर्ट",
    "sfs.aiImportHint": "फ़ोटो या PDF से टैली शीट पढ़ें",
    "sfs.aiNeedsImage": "फ़ोटो या PDF चाहिए",
    "sfs.ticket": "सपोर्ट टिकट",
    "sfs.ticketHint": "नए टिकट में जोड़ें",
    "sfs.pickPlace": "जगह चुनें",
    "sfs.pickDocType": "कौन सा दस्तावेज़ प्रकार?",
    "sfs.back": "वापस",
    "sfs.cancel": "रद्द करें",
    "sfs.discard": "फ़ाइलें हटाएँ",
    "sfs.noAccess": "आपको कहीं भी फ़ाइल अपलोड करने की अनुमति नहीं है। कृपया अपने एडमिन से पूछें।",
    "sfs.note": "अभी कुछ अपलोड नहीं हुआ है। जो स्क्रीन आप चुनेंगे वह आपसे पुष्टि माँगेगी।",
    "sfs.toast.title": "फ़ाइलें इंतज़ार में हैं",
    "sfs.toast.consignment": "जो कंसाइनमेंट चाहिए उसे खोलें, फिर यहाँ जोड़ें दबाएँ।",
    "sfs.toast.consignmentHere": "इस कंसाइनमेंट के दस्तावेज़ टैब पर यहाँ जोड़ें दबाएँ।",
    "sfs.toast.aiImportHere": "इस टैली शीट के ऊपर यहाँ जोड़ें दबाएँ।",
    "sfs.toast.stockUnit": "एक स्टॉक यूनिट खोलें, उसके फ़ोटो टैब पर जाएँ, फिर यहाँ जोड़ें दबाएँ।",
    "sfs.toast.stockUnitHere": "इस स्टॉक यूनिट के फ़ोटो टैब पर यहाँ जोड़ें दबाएँ।",
    "sfs.toast.aiImport": "जो टैली शीट चाहिए उसे खोलें, फिर यहाँ जोड़ें दबाएँ।",
    "sfs.toast.ticket": "टिकट भरें। फ़ाइलें पहले से जुड़ी हुई हैं।",
    "sfs.waiting.consignment": "जो कंसाइनमेंट चाहिए उसे खोलें और यहाँ जोड़ें दबाएँ",
    "sfs.waiting.stockUnit": "एक स्टॉक यूनिट खोलें, फ़ोटो टैब में जाएँ और यहाँ जोड़ें दबाएँ",
    "sfs.waiting.aiImport": "एक टैली शीट खोलें और यहाँ जोड़ें दबाएँ",
    "sfs.waiting.ticket": "आपके नए टिकट में जोड़ी जा रही हैं",
    "sfs.banner.hint": "किसी रिकॉर्ड से जुड़ने का इंतज़ार।",
    "sfs.banner.attach": "यहाँ जोड़ें",
    "sfs.banner.discard": "हटाएँ",
    "sfs.blocked.locked": "यह कंसाइनमेंट लॉक है, इसलिए फ़ाइलें नहीं जोड़ी जा सकतीं।",
    "sfs.blocked.shipped": "यह स्टॉक यूनिट शिप हो चुकी है और लॉक है, इसलिए फ़ाइलें नहीं जोड़ी जा सकतीं।",
    "sfs.blocked.viewMode": "यह टैली शीट अभी केवल देखने के लिए है। पहले एडिट मोड चालू करें, फिर फ़ाइलें जोड़ें।",
    "sfs.blocked.slot": "यह दस्तावेज़ प्रकार इस कंसाइनमेंट पर उपलब्ध नहीं है।",
    "sfs.blocked.readonly": "आप यहाँ यह दस्तावेज़ प्रकार केवल देख सकते हैं।",
    "sfs.blocked.busy": "एक और अपलोड चल रहा है। कृपया प्रतीक्षा करें।",
    "mediaCapture.paste": "पेस्ट करें",
    "mediaCapture.pasteNothingTitle": "पेस्ट करने के लिए कुछ नहीं",
    "mediaCapture.pasteNothing": "क्लिपबोर्ड पर कोई फ़ाइल नहीं मिली। पहले फ़ाइल कॉपी करें, या दूसरे ऐप से शेयर → LumberLinq इस्तेमाल करें।",
    "mediaCapture.pasteTextOnly": "क्लिपबोर्ड में टेक्स्ट है, फ़ाइल नहीं। पहले फ़ाइल कॉपी करें, या दूसरे ऐप से शेयर → LumberLinq इस्तेमाल करें।",
    "mediaCapture.pasteNoImage": "क्लिपबोर्ड पर कोई इमेज नहीं मिली। पहले कोई इमेज कॉपी करें या स्क्रीनशॉट लें, फिर पेस्ट करें दबाएँ।",
    "sfs.native.failedTitle": "कुछ फ़ाइलें पढ़ी नहीं जा सकीं",
    "sfs.native.failed": "कुछ शेयर की गई फ़ाइलें बहुत बड़ी थीं या खुल नहीं सकीं। कृपया उन्हें फिर से शेयर करें।",
    "avatar.changePhoto": "फ़ोटो बदलें",
    "avatar.chooseFile": "फ़ाइल चुनें",
    "avatar.removePhoto": "फ़ोटो हटाएं",
    "avatar.cropTitle": "अपनी फ़ोटो समायोजित करें",
    "avatar.cropHint": "स्थिति बदलने के लिए खींचें • ज़ूम के लिए स्क्रॉल या पिंच करें",
    "avatar.cropConfirm": "फ़ोटो उपयोग करें",
    "avatar.cropCancel": "रद्द करें",
    "avatar.uploading": "अपलोड हो रहा है...",
    "avatar.uploadSuccess": "प्रोफ़ाइल तस्वीर अपडेट हो गई",
    "permEditor.viewAddedNote": "देखने (View) का अधिकार भी चालू कर दिया गया, क्योंकि इस अधिकार को इसकी ज़रूरत है।",
    "permEditor.actionsRemovedNote": "जिन अधिकारों को View चाहिए, वे भी बंद कर दिए गए।",
    "permEditor.needsView": "View ज़रूरी",
    "avatar.uploadFailed": "अपलोड विफल",
    "avatar.retry": "पुनः प्रयास करें",
    "avatar.confirmRemoveTitle": "प्रोफ़ाइल तस्वीर हटाएं?",
    "avatar.confirmRemoveMessage": "आपका अवतार वापस आपके आद्याक्षर दिखाएगा।",
    "avatar.invalidFileType": "कृपया एक इमेज फ़ाइल चुनें (JPG, PNG या WEBP)।",
    "avatar.fileTooLarge": "इमेज 5 MB से छोटी होनी चाहिए।",
    "dashV3.title": "संचालन डैशबोर्ड",
    "dashV3.subtitle": "आपके लकड़ी व्यापार संचालन का रीयल-टाइम अवलोकन",
    "dashV3.dateFrom": "से",
    "dashV3.dateTo": "तक",
    "dashV3.apply": "लागू करें",
    "dashV3.refresh": "ताज़ा करें",
    "dashV3.staleSnapshot": "ऑफ़लाइन — कैश्ड स्नैपशॉट दिखाया जा रहा है, दिनांक:",
    "dashV3.loading": "डैशबोर्ड लोड हो रहा है...",
    "offline.unavailableTitle": "कनेक्शन आवश्यक है",
    "offline.unavailableLead": "ऑफ़लाइन होने पर यह सुविधा उपलब्ध नहीं है।",
    "offline.unavailableBody": "एक्सपोर्ट, इम्पोर्ट, रिपोर्ट, कंसाइनमेंट और इन्वेंटरी के लिए लाइव कनेक्शन आवश्यक है। स्टॉक यूनिट, बिजनेस पार्टनर, प्रोडक्ट और स्थान अभी भी ऑफ़लाइन काम करते हैं।",
    "offline.goToDashboard": "डैशबोर्ड पर जाएं",
    "offline.autoReturnHint": "ऑनलाइन वापस आते ही आपको स्वतः यहां वापस ले जाया जाएगा।",
    "dashV3.kpi.partners": "व्यावसायिक भागीदार",
    "dashV3.kpi.active": "सक्रिय",
    "dashV3.kpi.inactive": "निष्क्रिय",
    "dashV3.kpi.shipments": "कंसाइनमेंट",
    "dashV3.kpi.transportUnits": "परिवहन इकाइयाँ",
    "dashV3.kpi.unassigned": "असाइन नहीं",
    "dashV3.kpi.volume": "कुल मात्रा",
    "dashV3.kpi.pieces": "कुल टुकड़े",
    "dashV3.kpi.cbm": "CBM",
    "dashV3.kpi.cft": "CFT",
    "dashV3.chart.byTradeType": "व्यापार प्रकार अनुसार कंसाइनमेंट",
    "dashV3.chart.byMode": "परिवहन माध्यम",
    "dashV3.chart.volumeTrend": "मात्रा प्रवृत्ति",
    "dashV3.chart.topProducts": "शीर्ष उत्पाद (CFT अनुसार)",
    "dashV3.chart.siteUtilization": "स्थान उपयोग",
    "dashV3.chart.paymentStatus": "भुगतान स्थिति",
    "dashV3.upcoming.departures": "आगामी प्रस्थान",
    "dashV3.upcoming.arrivals": "आगामी आगमन",
    "dashV3.upcoming.next7days": "अगले 7 दिन",
    "dashV3.upcoming.noDepartures": "अगले 7 दिनों में कोई प्रस्थान नहीं",
    "dashV3.upcoming.noArrivals": "अगले 7 दिनों में कोई आगमन नहीं",
    "dashV3.upcoming.blNo": "BL / बिल नं.",
    "dashV3.upcoming.shipper": "शिपर",
    "dashV3.upcoming.consignee": "कंसाइनी",
    "dashV3.upcoming.date": "तारीख",
    "dashV3.upcoming.port": "बंदरगाह",
    "dashV3.recent.title": "हाल की परिवहन इकाइयाँ",
    "dashV3.recent.transportId": "परिवहन आईडी",
    "dashV3.recent.product": "उत्पाद",
    "dashV3.recent.site": "स्थान",
    "dashV3.recent.pieces": "टुकड़े",
    "dashV3.recent.volume": "मात्रा",
    "dashV3.recent.created": "बनाया गया",
    "dashV3.subscription.title": "सदस्यता",
    "dashV3.subscription.package": "पैकेज",
    "dashV3.subscription.validTill": "तक वैध",
    "dashV3.subscription.daysLeft": "दिन शेष",
    "dashV3.subscription.expiringSoon": "सदस्यता जल्द समाप्त हो रही है!",
    "dashV3.subscription.renew": "अभी नवीनीकरण करें",
    "dashV3.partners.byCountry": "देश अनुसार भागीदार",
    "dashV3.kpi.upcoming": "आगामी",
    "dashV3.kpi.tallyUnits": "टैली इकाइयाँ",
    "dashV3.upcoming.pol": "लोडिंग बंदरगाह",
    "dashV3.upcoming.pod": "डिस्चार्ज बंदरगाह",
    "dashV3.upcoming.mode": "माध्यम",
    "dashV3.subscription.expiring": "सदस्यता जल्द समाप्त हो रही है —",
    "dashV3.subscription.status": "स्थिति",
    "dashV3.subscription.days": "दिन शेष",
    "dashV3.recent.id": "परिवहन आईडी",
    "dashV3.recent.cbm": "CBM",
    "dashV3.recent.cft": "CFT",
    "dashV3.recent.viewAll": "सभी देखें",
    "dashV3.site.name": "साइट",
    "dashV3.site.country": "देश",
    "dashV3.site.capacity": "क्षमता",
    "dashV3.site.noCapacitySet": "इस स्थान के लिए कोई क्षमता निर्धारित नहीं है",
    "dashV3.site.current": "वर्तमान",
    "dashV3.site.util": "उपयोग",
    "dashV3.noData": "चयनित अवधि के लिए कोई डेटा उपलब्ध नहीं",

    "report.title": "रिपोर्ट",
    "report.from": "से",
    "report.to": "तक",
    "report.inventory.title": "इन्वेंटरी रिपोर्ट",
    "report.inventory.subtitle": "स्टॉक स्तर, मूवमेंट इतिहास, एडजस्टमेंट और मिल जॉब",
    "report.inventory.unitsAbbrev": "SUs",
    "report.bp.title": "व्यावसायिक साझेदार रिपोर्ट",
    "report.bp.subtitle":
      "व्यावसायिक साझेदार के लेनदेन, मात्रा और भुगतान का विस्तृत विश्लेषण",
    "report.bp.search": "व्यावसायिक साझेदार खोजें",
    "report.bp.selectBp": "रिपोर्ट बनाने के लिए कोई साझेदार चुनें",
    "report.bp.period": "रिपोर्ट अवधि",
    "report.bp.from": "आरंभ तिथि",
    "report.bp.to": "समाप्ति तिथि",
    "report.bp.generate": "रिपोर्ट बनाएं",
    "report.bp.generating": "बन रही है...",
    "report.bp.exportExcel": "Excel निर्यात",
    "report.bp.exportPdf": "PDF निर्यात",
    "report.bp.noData": "चयनित अवधि के लिए कोई कंसाइनमेंट डेटा नहीं मिला।",
    "report.bp.profile": "साझेदार प्रोफ़ाइल",
    "report.bp.partyType": "पक्ष प्रकार",
    "report.bp.category": "श्रेणी",
    "report.bp.regType": "पंजीकरण प्रकार",
    "report.bp.taxId": "कर ID",
    "report.bp.active": "सक्रिय",
    "report.bp.inactive": "निष्क्रिय",
    "report.bp.owner": "स्वामी",
    "report.kpi.totalShipments": "कुल कंसाइनमेंट",
    "report.kpi.asSeller": "विक्रेता के रूप में",
    "report.kpi.asBuyer": "क्रेता के रूप में",
    "report.kpi.totalCbm": "कुल Net CBM",
    "report.kpi.totalCft": "कुल Net CFT",
    "report.kpi.totalPieces": "कुल नग",
    "report.payment.sellerTitle": "भुगतान — विक्रेता के रूप में",
    "report.payment.buyerTitle": "भुगतान — क्रेता के रूप में",
    "report.payment.totalInvoiced": "कुल बिल राशि",
    "report.payment.received": "पूर्ण प्राप्त",
    "report.payment.partially": "आंशिक भुगतान",
    "report.payment.invoiced": "बिल भेजा (प्रतीक्षित)",
    "report.payment.notInvoiced": "बिल नहीं भेजा",
    "report.payment.overdue": "बकाया",
    "report.payment.outstanding": "शेष राशि",
    "report.payment.cancelled": "रद्द",
    "report.payment.totalPayable": "कुल देय",
    "report.payment.paid": "भुगतान किया",
    "report.payment.pending": "लंबित",
    "report.payment.disputed": "विवादित",
    "report.chart.monthlyVolume": "मासिक मात्रा और कंसाइनमेंट",
    "chart.emptyTitle": "अभी कोई डेटा नहीं",
    "chart.emptyHint": "रिकॉर्ड जुड़ते ही यह चार्ट भर जाएगा।",
    "report.chart.monthlyInvoice": "मासिक बिल राशि",
    "report.chart.tradeRoleSplit": "व्यापार भूमिका विभाजन",
    "report.chart.paymentStatus": "भुगतान स्थिति",
    "report.table.transactions": "कंसाइनमेंट लेनदेन",
    "report.table.date": "तिथि",
    "report.table.role": "भूमिका",
    "report.table.tradeType": "व्यापार प्रकार",
    "report.table.pol": "लोडिंग बंदरगाह",
    "report.table.pod": "डिस्चार्ज बंदरगाह",
    "report.table.origin": "मूल देश",
    "report.table.destination": "गंतव्य",
    "report.table.currency": "मुद्रा",
    "report.table.invoiceAmt": "बिल राशि",
    "report.table.cbm": "Net CBM",
    "report.table.cft": "Net CFT",
    "report.table.pieces": "टुकड़े",
    "report.table.units": "स्टॉक यूनिट",
    "report.table.payStatus": "भुगतान स्थिति",
    "report.table.blNo": "B/L नं.",
    "report.table.status": "स्थिति",
    "report.table.products": "उत्पाद",
    "report.table.sites": "स्थान",
    "report.products.title": "उत्पाद सारांश",
    "report.products.name": "उत्पाद",
    "report.products.hsCode": "HS कोड",
    "report.products.cbm": "Net CBM",
    "report.products.cft": "Net CFT",
    "report.products.pieces": "टुकड़े",
    "report.products.units": "परिवहन इकाइयाँ",
    "report.products.shipments": "कंसाइनमेंट",
    "report.sites.title": "स्थान सारांश",
    "report.sites.name": "साइट नाम",
    "report.sites.location": "स्थान",
    "report.sites.cbm": "Net CBM",
    "report.sites.cft": "Net CFT",
    "report.sites.pieces": "टुकड़े",
    "report.sites.units": "परिवहन इकाइयाँ",
    "report.sites.shipments": "कंसाइनमेंट",
    "report.role.seller": "विक्रेता",
    "report.role.buyer": "क्रेता",
    "report.role.notify": "अधिसूचना पक्ष",
    "report.generatedAt": "बनाई गई",
    "report.generate": "रिपोर्ट बनाएं",
    "report.loading": "रिपोर्ट लोड हो रही है...",
    "report.empty": "फ़िल्टर चुनें और रिपोर्ट देखने के लिए जनरेट करें।",
    "report.noData": "चुनी गई अवधि के लिए कोई डेटा नहीं मिला।",
    "report.export.excel": "एक्सेल निर्यात",
    "report.export.pdf": "PDF निर्यात",
    "report.filter.from": "से",
    "report.filter.to": "तक",
    "report.filter.all": "सभी",
    "report.filter.clear": "फ़िल्टर साफ़ करें",
    "report.tab.overview": "अवलोकन",
    "report.tab.transactions": "लेनदेन",
    "report.tab.financial": "वित्तीय",
    "report.tab.products": "उत्पाद",
    "report.tab.sites": "साइटें",
    "report.tab.trend": "मासिक ट्रेंड",
    "report.tab.byCurrency": "मुद्रा अनुसार",
    "report.tab.partners": "शीर्ष साझेदार",
    "report.kpi.totalInvoiced": "कुल चालान",
    "report.kpi.overdue": "अतिदेय",
    "report.kpi.units": "परिवहन इकाइयां",
    "report.col.date": "तारीख",
    "report.col.month": "माह",
    "report.col.tradeType": "व्यापार प्रकार",
    "report.col.status": "स्थिति",
    "report.col.shipper": "निर्यातक",
    "report.col.consignee": "आयातक",
    "report.col.polPod": "POL / POD",
    "report.col.currency": "मुद्रा",
    "report.col.invoiceAmt": "चालान राशि",
    "report.col.invoiced": "चालान किया",
    "report.col.salesStatus": "बिक्री स्थिति",
    "report.col.cbm": "CBM",
    "report.col.netCbm": "Net CBM",
    "report.col.cft": "CFT",
    "report.col.netCft": "Net CFT",
    "report.col.pieces": "नग",
    "report.col.units": "इकाइयां",
    "report.col.shipments": "कंसाइनमेंट",
    "report.col.blNo": "B/L नं.",
    "report.col.product": "उत्पाद",
    "report.col.hsCode": "HS कोड",
    "report.col.avgCbmPerUnit": "प्रति इकाई औसत CBM",
    "report.col.currentStock": "वर्तमान स्टॉक",
    "report.col.lots": "लॉट",
    "report.col.topPartners": "शीर्ष साझेदार",
    "report.col.topSites": "शीर्ष साइटें",
    "report.col.topProducts": "शीर्ष उत्पाद",
    "report.col.site": "साइट",
    "report.col.location": "स्थान",
    "report.col.capacity": "क्षमता",
    "report.col.utilization": "उपयोग",
    "report.col.millThroughput": "मिल थ्रूपुट CBM",
    "report.col.runs": "मिल जॉब",
    "report.col.partner": "साझेदार",
    "report.col.totalInvoiced": "कुल चालान",
    "report.col.fullyPaid": "पूर्ण भुगतान",
    "report.col.partiallyPaid": "आंशिक भुगतान",
    "report.col.overdue": "अतिदेय",
    "report.col.outstanding": "बकाया",
    "report.col.sellerOutstanding": "विक्रेता बकाया",
    "report.col.buyerTotal": "क्रेता कुल",
    "report.col.buyerPaid": "क्रेता भुगतान",
    "report.col.buyerPending": "क्रेता लंबित",
    "report.col.netPosition": "शुद्ध स्थिति",
    "report.col.totalAmt": "कुल राशि",
    "report.col.received": "प्राप्त",
    "report.col.paid": "भुगतान किया",
    "report.col.payable": "देय",
    "report.shipment.title": "कंसाइनमेंट रिपोर्ट",
    "report.shipment.tradeType": "व्यापार प्रकार",
    "report.shipment.status": "स्थिति",
    "report.shipment.financialByCurrency": "मुद्रा अनुसार वित्तीय",
    "report.shipment.monthlyTrend": "मासिक ट्रेंड",
    "report.product.title": "उत्पाद रिपोर्ट",
    "report.product.distinctProducts": "अलग उत्पाद",
    "report.site.title": "स्थान रिपोर्ट",
    "report.site.distinctSites": "अलग साइटें",
    "report.site.noCapacity": "क्षमता डेटा उपलब्ध नहीं",
    "report.financial.title": "वित्तीय सारांश रिपोर्ट",
    "report.financial.currency": "मुद्रा",
    "report.financial.currencyPlaceholder": "जैसे USD",
    "report.financial.revenue": "राजस्व (प्राप्त)",
    "report.financial.cost": "लागत (भुगतान)",
    "report.financial.receivable": "प्राप्य",
    "report.financial.payable": "देय",
    "report.financial.overdue": "अतिदेय",
    "report.financial.topRevenuePartners": "शीर्ष राजस्व साझेदार",
    "report.financial.topCostPartners": "शीर्ष लागत साझेदार",
    "report.financial.tradeTypeSummary": "व्यापार प्रकार अनुसार",
    "report.chart.byTradeType": "व्यापार प्रकार अनुसार",
    "report.chart.sellerPayStatus": "विक्रेता भुगतान स्थिति",
    "report.chart.topLoadingPorts": "शीर्ष लोडिंग पोर्ट",
    "report.chart.topProductsByCbm": "Net CBM अनुसार शीर्ष उत्पाद",
    "report.chart.monthlyProductTrend": "मासिक उत्पाद ट्रेंड",
    "report.chart.siteCbm": "स्थान अनुसार Net CBM",
    "report.chart.utilization": "साइट उपयोग",
    "report.chart.monthlyTrend": "मासिक थ्रूपुट",
    "report.chart.financialOverview": "वित्तीय अवलोकन",
    "report.chart.receivablesBreakdown": "प्राप्य विवरण",
    "report.chart.monthlyInvoicedTrend": "मासिक चालान ट्रेंड",
    "report.tab.units": "परिवहन इकाइयां",
    "report.tab.tallies": "टैली शीट",
    "report.col.transportId": "परिवहन ID",
    "report.col.unitNumber": "इकाई नं.",
    "report.col.mode": "माध्यम",
    "report.col.shipment": "कंसाइनमेंट",
    "report.col.type": "प्रकार",
    "report.col.created": "बनाई गई",
    "report.tu.title": "परिवहन इकाई रिपोर्ट",
    "report.operator.title": "ऑपरेटर प्रदर्शन रिपोर्ट",
    "report.operator.totalOperators": "कुल ऑपरेटर",
    "report.operator.activeOperators": "सक्रिय ऑपरेटर",
    "report.operator.runsCompleted": "पूरे हुए मिल जॉब",
    "report.operator.totalOutputCbm": "कुल आउटपुट CBM",
    "report.operator.avgOutturn": "औसत आउटटर्न",
    "report.operator.byOperator": "ऑपरेटर के अनुसार",
    "report.operator.name": "नाम",
    "report.operator.employeeCode": "कर्मचारी कोड",
    "report.operator.specializations": "विशेषज्ञता",
    "report.operator.active": "सक्रिय",
    "report.operator.activeYes": "सक्रिय",
    "report.operator.activeNo": "निष्क्रिय",
    "report.operator.inputCbm": "इनपुट CBM",
    "report.operator.outputCbm": "आउटपुट CBM",
    "report.operator.bestOutturn": "सर्वश्रेष्ठ आउटटर्न",
    "report.operator.avgDuration": "औसत अवधि (घंटे)",
    "report.tu.totalUnits": "कुल इकाइयां",
    "report.tu.linked": "कंसाइनमेंट से जुड़ी",
    "report.tu.inStock": "स्टॉक में (इन्वेंटरी)",
    "report.tu.unlinked": "असंलग्न",
    "report.tu.statusBreakdown": "स्थिति विवरण",
    "report.tu.modeBreakdown": "परिवहन माध्यम",
    "report.tu.monthlyTrend": "मासिक ट्रेंड",
    "report.tu.statusSummary": "स्थिति सारांश",
    "report.tally.title": "टैली शीट रिपोर्ट",
    "report.tally.totalTallies": "कुल टैली",
    "report.tally.roundTallies": "गोल लकड़ी",
    "report.tally.squareTallies": "वर्गाकार लकड़ी",
    "report.tally.flexibleGrid": "लचीला ग्रिड",
    "report.tally.typeBreakdown": "प्रकार विवरण",
    "report.tally.monthlyCbm": "प्रकार अनुसार मासिक CBM",
    "report.tally.shrinkageChart": "स्रोत बनाम गंतव्य CBM",
    "report.tally.noShrinkageData": "कोई गंतव्य डेटा उपलब्ध नहीं।",
    "report.tally.avgCbm": "औसत CBM / टैली",
    "report.tally.avgPieces": "औसत नग / टैली",
    "report.tally.tallies": "टैली",
    "report.tally.destCbm": "गंतव्य CBM",
    "report.tally.shrinkage": "संकुचन %",

    "inventory.inOut": "इन / आउट",
    "inventory.receiveIntoInventory": "इन्वेंटरी में प्राप्त करें",
    "inventory.receiveNeedsRows": "इन्वेंटरी में प्राप्त करने से पहले टैली में कम से कम एक पंक्ति जोड़ें",
    "inventory.receivedIntoInventory": "इन्वेंटरी में प्राप्त किया गया",
    "inventory.receiveConfirmMessage": "स्टॉक यूनिट {transportId} को इन्वेंटरी में जोड़ें? इससे इसे आने वाले स्टॉक मूवमेंट के रूप में दर्ज किया जाएगा.",
    "inventory.yesReceive": "हाँ, प्राप्त करें",
    "inventory.received": "प्राप्त हुआ",
    "inventory.receivedDetail": "{transportId} को इन्वेंटरी में जोड़ दिया गया है.",
    "inventory.confirmStockOut": "स्टॉक-आउट की पुष्टि करें",
    "inventory.confirmChecking": "स्टॉक जाँच रहे हैं…",
    "inventory.confirmStockOutMessage": "पुष्टि करें कि स्टॉक यूनिट {transportId} भेज दी गई है? इससे संबंधित स्टॉक स्थायी रूप से घटा दिया जाएगा.",
    "inventory.confirmStockOutMultiProductIntro": "इस स्टॉक यूनिट में {count} उत्पाद हैं, जिन्हें इस प्रकार स्थायी रूप से घटाया जाएगा: {breakdown}. जारी रखें?",
    "inventory.confirmStockOutBatchIntro": "यह {count} लॉट से लिया जाएगा: {breakdown}. जारी रखें?",
    "inventory.confirmStockOutInsufficientWarning": "चेतावनी: इनमें से एक या अधिक उत्पादों के लिए पर्याप्त स्टॉक नहीं है — पुष्टि विफल हो सकती है.",
    "inventory.stockShortTitle": "पर्याप्त स्टॉक नहीं है — कुछ भी सेव नहीं हुआ",
    "inventory.stockShortHint": "इन पंक्तियों को ठीक करें, या Application Settings → Inventory Policy में “Let sales continue past available stock” चालू करें।",
    "inventory.stockShortLineNone": "{label}: {need} पीस चाहिए, स्टॉक नहीं है",
    "inventory.stockShortLineOnly": "{label}: {need} पीस चाहिए, केवल {free} उपलब्ध",
    "inventory.confirmBlockedNoStock": "पुष्टि नहीं हो सकती — इन पंक्तियों के साइज़ का खाली स्टॉक नहीं है (जो लकड़ी दूसरे स्टॉक आउट ने रोक रखी है वह खाली नहीं है):",
    "inventory.confirmBlockedNoStockHint": "साइज़ बदलें, पंक्ति हटाएं, या मिल से बनवाने का अनुरोध करें।",
    "inventory.confirmUnsavedChanges": "पहले टैली सेव करें — इसमें बिना सेव की पंक्तियाँ हैं। पुष्टि केवल सेव की गई पंक्तियों को गिनती है, और उसके बाद टैली लॉक हो जाती है।",
    "inventory.receiveUnsavedChanges": "पहले टैली सेव करें — इसमें बिना सेव की पंक्तियाँ हैं। केवल सेव की गई पंक्तियाँ स्टॉक में आती हैं, और उसके तुरंत बाद टैली लॉक हो जाती है।",
    "tallysheet.tu.soldPastStock": "उपलब्ध स्टॉक से ज़्यादा बेचा गया — कारण: {reason}",
    "tallysheet.tu.soldPastStockBy": " ({by} द्वारा)",
    "statement.soldPastStock": "उपलब्ध स्टॉक से ज़्यादा बेचा गया",
    "inventory.rowExceedsStockReview": "स्टॉक से अधिक — समीक्षा के लिए टैप करें",
    "inventory.rowInsufficientStockFix": "स्टॉक में पर्याप्त नहीं — ठीक करने के लिए टैप करें",
    "inventory.rowNotReservedHint": "इस पंक्ति के लिए फिलहाल कोई स्टॉक आरक्षित नहीं है।",
    "inventory.resolvedOriginAuto": "सबसे पुराना स्टॉक",
    "inventory.shippedLockedMessage": "इस स्टॉक यूनिट की पुष्टि हो चुकी है और इसे भेज दिया गया है — संपादन लॉक है। केवल एक व्यवस्थापक बदलाव कर सकता है।",
    "inventory.rowNeedsLookSingular": "पंक्ति पर एक नज़र डालें",
    "inventory.rowNeedsLookPlural": "पंक्तियों पर एक नज़र डालें",
    "inventory.review": "समीक्षा करें",
    "inventory.yesConfirm": "हाँ, पुष्टि करें",
    "inventory.confirmStockOutTooltip": "इस स्टॉक यूनिट की तालिकाबद्ध सामग्री के लिए स्टॉक स्थायी रूप से घटाएं",
    "inventory.stockOutConfirmed": "स्टॉक-आउट की पुष्टि हुई",
    "inventory.stockOutConfirmedDetail": "{transportId} को इन्वेंटरी से घटा दिया गया है.",

    "report.financial.actualReceived": "वास्तविक प्राप्त",
    "report.financial.actualPaid": "वास्तविक भुगतान",
    "report.financial.totalReceived": "कुल प्राप्त",
    "report.financial.totalPaid": "कुल भुगतान",
    "report.financial.netCashflow": "शुद्ध नकदी प्रवाह",
    "report.financial.receivables": "प्राप्य",
    "report.financial.minAmount": "न्यूनतम राशि",
    "report.financial.maxAmount": "अधिकतम राशि",
    "report.financial.paymentStatus": "भुगतान स्थिति",
    "report.financial.paymentFrom": "भुगतान तिथि से",
    "report.financial.paymentTo": "भुगतान तिथि तक",
    "report.financial.payables": "देय",
    "report.col.txnType": "प्रकार",
    "report.col.paymentMode": "माध्यम",
    "report.col.reference": "संदर्भ",
    "report.col.notes": "नोट्स",

    "report.recon.title": "सुलह रिपोर्ट",
    "report.recon.subtitle": "स्रोत बनाम गंतव्य टैली विचरण विश्लेषण",
    "report.recon.totalTallies": "कुल टैली",
    "report.recon.reconciled": "सुलह हो गई",
    "report.recon.pending": "लंबित",
    "report.recon.srcCbm": "स्रोत CBM",
    "report.recon.srcPieces": "स्रोत नग",
    "report.recon.dstCbm": "गंतव्य CBM",
    "report.recon.dstPieces": "गंतव्य नग",
    "report.recon.varianceCbm": "CBM विचरण",
    "report.recon.variancePieces": "नग विचरण",
    "report.recon.shrinkage": "संकुचन %",
    "report.recon.millLoss": "मिल हानि CBM",
    "report.recon.reconStatus": "सुलह स्थिति",
    "report.recon.shrinkageDist": "संकुचन वितरण",
    // -- Common extras
    "common.locked": "लॉक",
    "common.reconciled": "सुलह हुआ",
    "common.confirmDeletion": "हटाने की पुष्टि",
    "common.amount": "राशि",
    "common.size": "आकार",
    // -- Tallysheet lock & AI import
    "tallysheet.lockedBanner": "यह टैलीशीट लॉक है — अब कोई संपादन नहीं किया जा सकता।",
    "tallysheet.summaryOutdated": "सारांश पुराना हो सकता है। अंतिम बार टैब लोड होने के बाद पंक्तियाँ सहेजी गई हैं।",
    "tallysheet.lockButton": "लॉक",
    "tallysheet.lockTooltip": "इस टैलीशीट को स्थायी रूप से लॉक करें",
    "tallysheet.lockNeedsRows": "लॉक करने से पहले टैली में कम से कम एक पंक्ति जोड़ें",
    "tallysheet.lockNoPhotosWarning": "इस स्टॉक यूनिट में अभी कोई फोटो नहीं है। आप फिर भी लॉक कर सकते हैं, पर बाद में फोटो जोड़ना आसान नहीं रहेगा।",
    "tallysheet.lockGoToPhotos": "फ़ोटो पर जाएँ",
    "tallysheet.lockDialogHeader": "टैलीशीट लॉक करें",
    "tallysheet.lockIrreversible": "यह क्रिया वापस नहीं की जा सकती।",
    "tallysheet.lockOnceNote": "लॉक होने के बाद कोई भी टैली प्रविष्टि जोड़ी या बदली नहीं जा सकती।",
    "tallysheet.lockTypeConfirm": "पुष्टि के लिए LOCK टाइप करें:",
    "tallysheet.lockPermanently": "स्थायी रूप से लॉक करें",
    "tallysheet.inventoryTab": "इन्वेंटरी",
    "tallysheet.aiImport": "AI इंपोर्ट",
    "tallysheet.aiImportTooltip": "AI इंपोर्ट — हस्तलिखित टैलीशीट की छवि अपलोड करें",
    "tallysheet.lengthRequired": "लंबाई आवश्यक है",
    "tallysheet.girthRequired": "गिर्थ आवश्यक है",
    "tallysheet.enterRowNumber": "पंक्ति संख्या दर्ज करें",
    // -- Inventory extensions
    "inventory.notYetInInventory": "अभी तक इन्वेंटरी में नहीं",
    "inventory.historyLoadFailedTitle": "इतिहास लोड नहीं हो सका",
    "inventory.historyLoadFailedSub": "ऑनलाइन वापस आने पर पुनः प्रयास करें",
    "inventory.receiveToStartTracking": "इन्वेंटरी मूवमेंट ट्रैक करने के लिए इस स्टॉक यूनिट को प्राप्त करें।",
    "inventory.clickToReceive": "इस स्टॉक यूनिट को इन्वेंटरी में प्राप्त करने के लिए नीचे बटन दबाएं।",
    "inventory.notInInventoryBanner": "इन्वेंटरी में नहीं — स्टॉक ट्रैकिंग शुरू करने के लिए इस स्टॉक यूनिट को प्राप्त करें।",
    "inventory.statusLabel": "इन्वेंटरी स्थिति",
    "inventory.statusColon": "इन्वेंटरी स्थिति:",
    "inventory.movementHistory": "मूवमेंट इतिहास",
    "inventory.noMovementsYet": "अभी तक कोई मूवमेंट दर्ज नहीं।",
    "inventory.addToInventoryTooltip": "इस स्टॉक यूनिट को इन्वेंटरी सिस्टम में जोड़ें",
    "inventory.productRequiredTooltip": "इन्वेंटरी में प्राप्त करने से पहले उत्पाद जोड़ें",
    "inventory.moveComingSoon": "साइटों के बीच स्थानांतरण — जल्द आ रहा है",
    "inventory.loadingSiteRequiredTooltip": "इन्वेंटरी में प्राप्त करने से पहले स्थान आवश्यक है",
    "inventory.loadingSiteRequiredBanner": "इस स्टॉक यूनिट को इन्वेंटरी में प्राप्त करने से पहले एक स्थान चुनें — अन्यथा स्टॉक ट्रैक नहीं किया जा सकेगा।",
    "inventory.transportModeRequiredTooltip": "इन्वेंटरी में प्राप्त करने से पहले परिवहन मोड जोड़ें",
    "inventory.transportModeRequiredForStockOut": "स्टॉक-आउट की पुष्टि करने से पहले परिवहन मोड जोड़ें",
    "inventory.dateAndTime": "तिथि और समय",
    "inventory.movementType": "मूवमेंट प्रकार",
    "inventory.lotStock": "लॉट स्टॉक",
    "inventory.openLots": "खुले लॉट",
    // -- Shipment extras
    "shipment.lockedTooltip": "लॉक — अब संपादन नहीं किया जा सकता",
    "shipment.exportTooltip": "कंसाइनमेंट को Excel या PDF में एक्सपोर्ट करें",
    "shipment.noTransportUnitsShared": "इस साझा कंसाइनमेंट के लिए कोई स्टॉक यूनिट उपलब्ध नहीं।",
    // -- Payment panel
    "payment.loadingData": "भुगतान डेटा लोड हो रहा है...",
    "payment.invoice": "चालान",
    "payment.salesStatus": "बिक्री स्थिति",
    "payment.paidOut": "भुगतान किया",
    "payment.purchaseStatus": "खरीद स्थिति",
    "payment.unableToLoad": "भुगतान सारांश लोड नहीं हो सका।",
    "payment.record": "भुगतान दर्ज करें",
    "payment.typeLabel": "भुगतान प्रकार",
    "payment.receivable": "प्राप्य (धन प्राप्ति)",
    "payment.payable": "देय (धन भुगतान)",
    "payment.selectType": "प्रकार चुनें",
    "payment.modeLabel": "भुगतान माध्यम",
    "payment.selectMode": "माध्यम चुनें",
    "payment.referenceNo": "संदर्भ संख्या",
    "payment.referencePlaceholder": "चेक नं / TT संदर्भ / UTR",
    "payment.notesPlaceholder": "वैकल्पिक नोट्स",
    "payment.save": "भुगतान सेव करें",
    "payment.history": "भुगतान इतिहास",
    // -- Storage
    "storage.title": "स्टोरेज उपयोग",
    "storage.subtitle": "सभी टैली, दस्तावेज़ और बिजनेस पार्टनर में अपनी फ़ाइल स्टोरेज ट्रैक करें",
    "storage.usedRing": "उपयोग",
    "storage.used": "उपयोग",
    "storage.quota": "कोटा",
    "storage.free": "मुक्त",
    "storage.files": "फ़ाइलें",
    "storage.filesCount": "फ़ाइलें",
    "storage.warningPrefix": "आपने उपयोग किया",
    "storage.warningBannerSuffix": "अपनी स्टोरेज का। अनुपयोगी फ़ाइलें हटाने पर विचार करें।",
    "storage.fullBanner": "स्टोरेज भर गया! नई फ़ाइल अपलोड बंद हैं। कृपया जगह खाली करें या अपना प्लान अपग्रेड करें।",
    "storage.addedBy": "जोड़ने वाला",
    "storage.noFilesFound": "कोई फ़ाइल नहीं मिली।",
    // -- Dashboard V4
    "dashV4.businessPulse": "बिजनेस पल्स",
    "dashV4.inventorySnapshot": "इन्वेंटरी स्नैपशॉट",
    "dashV4.fullInventory": "पूर्ण इन्वेंटरी",
    "dashV4.availableStock": "उपलब्ध स्टॉक",
    "dashV4.inProcessing": "मिल जॉब में",
    "dashV4.inShipment": "कंसाइनमेंट में",
    "dashV4.shippedThisMonth": "इस महीने शिप हुआ",
    "dashV4.activeSites": "सक्रिय साइट्स",
    "dashV4.locations": "स्थान",
    "dashV4.noInventoryData": "अभी कोई इन्वेंटरी डेटा नहीं।",
    "dashV4.setUpInventory": "इन्वेंटरी सेट करें →",
    "dashV4.volumeTrend": "वॉल्यूम ट्रेंड (CBM)",
    "dashV4.upcomingShipments": "आगामी कंसाइनमेंट",
    "dashV4.departures": "प्रस्थान",
    "dashV4.arrivals": "आगमन",
    "dashV4.geographySites": "भूगोल और साइट्स",
    "dashV4.recentTUs": "हाल की स्टॉक यूनिट्स",
    "dashV4.standardPlan": "मानक प्लान",
    "dashV4.validTill": "तक वैध",
    "dashV4.daysLeft": "दिन शेष",
    "dashV4.manage": "प्रबंधित करें",
    "dashV4.active": "सक्रिय",
    "dashV4.inactive": "निष्क्रिय",
    "dashV4.upcoming": "आगामी",
    "dashV4.unassigned": "असाइन नहीं",
    // -- Dashboard V5
    "dashV5.title": "डैशबोर्ड",
    "dashV5.subtitle": "व्यापार, वित्त और इन्वेंटरी अवलोकन",
    "dashV5.financialHealth": "वित्तीय स्थिति",
    "dashV5.totalInvoiced": "कुल चालान",
    "dashV5.totalReceived": "प्राप्त",
    "dashV5.outstanding": "बकाया",
    "dashV5.overdue": "अतिदेय",
    "dashV5.payables": "देय राशि",
    "dashV7.currentTooltip": "हमेशा वर्तमान — चयनित तिथि सीमा तक सीमित नहीं",
    "dashV8.goodMorning": "सुप्रभात",
    "dashV8.periodNote": "अवधि इन पर लागू होती है: मात्रा, स्टॉक यूनिट, टुकड़े, खेप, बिल की गई और प्राप्त राशि। बाकी सब अभी की स्थिति दिखाता है।",
    "dashV8.vsPrevious": "पिछली अवधि से",
    "dashV8.details": "विवरण",
    "dashV8.freeToSell": "बिक्री के लिए उपलब्ध",
    "dashV8.free": "उपलब्ध",
    "dashV8.held": "रोका हुआ",
    "dashV8.inMill": "मिल में",
    "dashV8.allCounted": "सभी स्टॉक यूनिट गिनी गईं",
    "dashV8.toCount": "गिनना बाकी",
    "dashV8.goodAfternoon": "नमस्कार",
    "dashV8.goodEvening": "शुभ संध्या",
    "dashV8.focus": "इस कंपनी का सब कुछ",
    "dashV8.newSince": "नए — पिछली बार से:",
    "dashV8.period": "अवधि",
    "dashV8.p.today": "आज",
    "dashV8.p.7d": "7 दिन",
    "dashV8.p.30d": "30 दिन",
    "dashV8.p.month": "इस महीने",
    "dashV8.p.pick": "तिथियाँ चुनें",
    "dashV8.activeUntil": "सक्रिय · अंतिम तिथि:",
    "dashV8.item": "काम",
    "dashV8.items": "काम",
    "dashV8.more": "और",
    "dashV8.showAll": "सब दिखाएँ",
    "dashV8.showLess": "कम दिखाएँ",
    "dashV8.open": "खोलें",
    "dashV8.review": "जाँचें",
    "dashV8.count": "गिनें",
    "dashV8.see": "देखें",
    "dashV8.needMine1": "आपके पास 1 मिल काम है",
    "dashV8.needMineN": "आपके पास {n} मिल काम हैं",
    "dashV8.taskNeedsAccept": "{code} को स्वीकार करना है",
    "dashV8.taskRunning": "{code} चल रहा है",
    "dashV8.needOverdue1": "1 भुगतान बकाया है",
    "dashV8.needOverdueN": "{n} भुगतान बकाया हैं",
    "dashV8.overdueSub": "{amount} वसूलना है",
    "dashV8.overdueSubDays": "{amount} वसूलना है · सबसे पुराना {days} दिन",
    "dashV8.needHolds1": "1 स्टॉक आउट 60+ दिन से लकड़ी रोके है",
    "dashV8.needHoldsN": "{n} स्टॉक आउट 60+ दिन से लकड़ी रोके हैं",
    "dashV8.needHoldsSub": "{cbm} m³ बिक्री से रुका है",
    "dashV8.needRecon1": "1 स्टॉक यूनिट की गिनती नहीं हुई",
    "dashV8.needReconN": "{n} स्टॉक यूनिट की गिनती नहीं हुई",
    "dashV8.needReconSub": "अब तक गिनती: {pct}%",
    "dashV8.needUnassigned1": "1 स्टॉक यूनिट अभी किसी खेप में नहीं है",
    "dashV8.needUnassignedN": "{n} स्टॉक यूनिट अभी किसी खेप में नहीं हैं",
    "dashV8.needMillQueued1": "1 मिल जॉब शुरू होने की प्रतीक्षा में है",
    "dashV8.needMillQueuedN": "{n} मिल जॉब शुरू होने की प्रतीक्षा में हैं",
    "dashV8.needArrivals1": "इस हफ़्ते 1 खेप पहुँच रही है",
    "dashV8.needArrivalsN": "इस हफ़्ते {n} खेप पहुँच रही हैं",
    "dashV8.needArrivalsSub": "पहली {date} को",
    "dashV8.vsLastMonth": "पिछले महीने से",
    "dashV8.millRunning": "चल रहे मिल जॉब",
    "dashV8.trends": "रुझान",
    "dashV8.tab.volume": "मात्रा",
    "dashV8.tab.products": "उत्पाद",
    "dashV8.tab.types": "प्रकार",
    "dashV8.tab.transport": "परिवहन",
    "dashV8.tab.payments": "भुगतान",
    "dashV8.chip.STOCK": "स्टॉक",
    "dashV8.chip.MILL": "मिल",
    "dashV8.chip.CONSIGNMENT": "खेप",
    "dashV8.chip.MONEY": "पैसा",
    "dashV8.chip.RECON": "गिनती",
    "dashV8.chip.TALLY": "स्टॉक यूनिट",
    "dashV8.chip.TEAM": "टीम",
    "dashV8.chip.MINE": "मेरा",
    "dashV8.dayToday": "आज",
    "dashV8.dayYesterday": "कल",
    "dashV8.evt.STOCK_IN": "स्टॉक प्राप्त",
    "dashV8.evt.STOCK_OUT": "स्टॉक आउट पक्का हुआ",
    "dashV8.evt.STOCK_COUNT": "गिनती पूरी",
    "dashV8.evt.STOCK_ADJUST": "स्टॉक समायोजित",
    "dashV8.evt.MILL_DONE": "मिल जॉब {ref} पूरा",
    "dashV8.evt.CONSIGNMENT_NEW": "खेप {ref} बनाई गई",
    "dashV8.evt.PAYMENT_IN": "भुगतान मिला",
    "dashV8.evt.PAYMENT_OUT": "भुगतान किया गया",
    "dashV8.evt.TALLY_NEW": "स्टॉक यूनिट {ref} बनी",
    "dashV8.evt.TEAM_GRANT": "अधिकार {ref} दिया गया",
    "dashV8.evt.TEAM_REVOKE": "अधिकार {ref} वापस लिया गया",
    "dashV8.teamFor": "{name} के लिए",
    "dashV8.feedNote": "केवल पूरी हो चुकी व्यावसायिक घटनाएँ दिखती हैं। टैली की पंक्तियाँ सहेजना या बदलना कभी नहीं दिखता; स्टॉक यूनिट बनने पर एक बार दिखती है।",
    "dashV7.needsTitle": "आज आपके ध्यान के लिए",
    "dashV7.allClear": "सब ठीक है। आज कुछ भी आपका इंतज़ार नहीं कर रहा।",
    "dashV7.needOverdue": "वसूली के लिए बकाया भुगतान",
    "dashV7.needRecon": "मिलान के इंतज़ार में स्टॉक यूनिट",
    "dashV7.needUnassigned": "अभी तक किसी खेप से न जुड़ी स्टॉक यूनिट",
    "dashV7.needMyTasks": "आपकी सूची में मिल जॉब",
    "dashV7.needMillQueued": "शुरू होने की प्रतीक्षा में मिल जॉब",
    "dashV7.chipAll": "सभी",
    "dashV7.cat.STOCK": "स्टॉक",
    "dashV7.cat.MILL": "मिल",
    "dashV7.cat.CONSIGNMENT": "खेप",
    "dashV7.cat.MONEY": "पैसा",
    "dashV7.cat.TEAM": "टीम",
    "dashV7.ev.STOCK_IN": "स्टॉक प्राप्त",
    "dashV7.ev.STOCK_OUT": "स्टॉक बाहर भेजा",
    "dashV7.ev.STOCK_COUNT": "स्टॉक की गिनती",
    "dashV7.ev.STOCK_ADJUST": "स्टॉक समायोजित",
    "dashV7.ev.MILL_DONE": "मिल जॉब पूरा",
    "dashV7.ev.CONSIGNMENT_NEW": "खेप बनाई गई",
    "dashV7.ev.PAYMENT_IN": "भुगतान मिला",
    "dashV7.ev.PAYMENT_OUT": "भुगतान किया गया",
    "dashV7.ev.TEAM_GRANT": "अधिकार दिया गया",
    "dashV7.ev.TEAM_REVOKE": "अधिकार वापस लिया गया",
    "dashV7.severalSizes": "कई साइज़",
    "dashV7.with": "के साथ",
    "dashV7.noActivity": "हाल में यहाँ कुछ नहीं हुआ।",
    "dashV7.showMore": "और दिखाएँ",
    "dashV7.activityFailed": "ताज़ा गतिविधि अभी लोड नहीं हो सकी।",
    "dashV7.upcomingTooltip": "हमेशा अगले 7 दिन दिखाता है — ऊपर दी गई तिथि सीमा से स्वतंत्र",
    "dashV5.receivablesAging": "प्राप्य की आयु",
    "dashV5.shipmentsLabel": "कंसाइनमेंट",
    "dashV5.reconciliation": "समाधान स्थिति",
    "dashV5.totalTUs": "कुल स्टॉक यूनिट",
    "dashV5.reconciled": "समाधान हुआ",
    "dashV5.pending": "लंबित",
    "dashV5.locked": "लॉक",
    "dashV5.netDiscrepancy": "शुद्ध अंतर",
    "dashV5.tuId": "स्टॉक यूनिट ID",
    "dashV5.sourceCbm": "स्रोत CBM",
    "dashV5.destCbm": "गंतव्य CBM",
    "dashV5.discrepancy": "अंतर",
    "dashV5.noDiscrepancies": "कोई अंतर नहीं — सभी रिकंसाइल स्टॉक यूनिट मेल खाते हैं।",
    "dashV5.avgOutturn": "औसत आउटटर्न",
    "dashV5.netGain": "शुद्ध लाभ (मिल जॉब)",
    "dashV5.runsLabel": "मिल जॉब",
    "dashV5.outturnNote": "100% से अधिक का मतलब राउंड-से-स्क्वायर मिलिंग में मात्रा वृद्धि।",
    "dashV5.paymentFlow": "भुगतान प्रवाह",
    "dashV5.mixedCurrencies": "कई मुद्राएँ",
    "dashV5.showingCurrencyOnly": "केवल दिखा रहा है:",
    "dashV5.otherCurrencies": "अन्य मुद्राएँ",
    "dashV5.perCurrencyBreakdown": "मुद्रा-वार विवरण",
    // -- Dashboard V6
    "dashV6.title": "डैशबोर्ड",
    "dashV6.subtitle": "भूमिका-आधारित, रीयल-टाइम व्यवसाय अवलोकन",
    "dashV6.liveTooltip": "लाइव — स्वतः अपडेट होता है",
    "dashV6.offlineTooltip": "ऑफ़लाइन — कैश्ड डेटा दिखा रहा है, लाइव नहीं",
    "dashV6.myMillTasks": "मेरे सक्रिय मिल कार्य",
    "dashV6.millBoard": "मिल जॉब बोर्ड",
    "dashV6.viewAllRuns": "सभी मिल जॉब देखें",
    "dashV6.queued": "कतार में",
    "dashV6.inProgress": "प्रगति में",
    "dashV6.completedToday": "आज पूर्ण",
    "dashV6.machineUtil": "मशीनें व्यस्त",
    "dashV6.topOperators": "सक्रिय कार्यभार अनुसार शीर्ष ऑपरेटर",
    "dashV6.status.DRAFT": "कतार में",
    "dashV6.status.IN_PROGRESS": "प्रगति में",
    "dashV6.status.COMPLETED": "पूर्ण",
    "dashV6.priority.HIGH": "उच्च",
    "dashV6.priority.MEDIUM": "मध्यम",
    "dashV6.priority.LOW": "निम्न",
    "dashV6.recentActivity": "हाल की गतिविधि",
    "dashV6.granted": "प्रदान किया",
    "dashV6.revoked": "वापस लिया",
    "dashV6.forUser": "के लिए",
    // -- Common extras
    "common.export": "एक्सपोर्ट",
    "common.next": "आगे",
    "common.retry": "पुनः प्रयास",
    "common.clearFilters": "फिल्टर हटाएं",
    "common.saveAll": "सभी सेव करें",
    "common.resetDefaults": "डिफ़ॉल्ट पर रीसेट",
    "common.configure": "कॉन्फ़िगर करें",
    "common.disable": "अक्षम करें",
    "common.close": "बंद करें",
    "common.skip": "छोड़ें",
    "common.continue": "जारी रखें",
    "common.deactivate": "निष्क्रिय करें",
    "common.reactivate": "सक्रिय करें",
    "common.preview": "पूर्वावलोकन",
    "common.openNewTab": "नए टैब में खोलें",
    "common.resetAllToDefaults": "सभी को डिफ़ॉल्ट पर रीसेट करें",
    "common.renew": "नवीनीकरण करें",
    "common.manage": "प्रबंधित करें",
    "common.apply": "लागू करें",
    "common.saveTimezone": "टाइमज़ोन सेव करें",
    // -- Shipment lock dialog
    "shipment.lockDialogHeader": "कंसाइनमेंट लॉक करें",
    "shipment.lockButtonTooltip": "इस कंसाइनमेंट को स्थायी रूप से लॉक करें — लॉक के बाद कोई संपादन नहीं",
    "shipment.lockDescription": "एक बार लॉक होने पर, यह कंसाइनमेंट किसी के द्वारा संपादित नहीं किया जा सकता। सभी परिवर्तन स्थायी रूप से फ्रीज हो जाएंगे।",
    // -- Reconciliation lock
    "recon.lockDialogHeader": "रिकन्सिलिएशन लॉक करें",
    "recon.lockIrreversible": "यह क्रिया स्थायी और वापस नहीं की जा सकती।",
    "recon.lockDescription": "एक बार लॉक होने पर, कोई भी रिकन्सिलिएशन डेटा संशोधित नहीं कर सकता — खाता स्वामी भी नहीं। टैलीशीट देखने योग्य रहेगी।",
    "recon.lockReasonLabel": "कारण (वैकल्पिक)",
    "recon.lockReasonPlaceholder": "जैसे, डिस्चार्ज सर्वे के अनुसार पुष्टि की गई",
    "recon.varianceDetected": "अंतर पाया गया",
    "recon.varianceChoiceLabel": "इसे इन्वेंटरी पर कैसे लागू किया जाए?",
    "recon.applyAutoLabel": "अभी अपने आप लागू करें",
    "recon.applyAutoDesc": "इन्वेंटरी को वास्तव में पहुंची मात्रा से मिलाकर ठीक किया जाएगा।",
    "recon.applyAutoNeedsReceive": "पहले इस स्टॉक यूनिट को Receive करें — अभी सुधारने के लिए कोई स्टॉक नहीं है।",
    "recon.applyManualLabel": "मैं इसे खुद संभालूँगा",
    "recon.applyManualDesc": "इन्वेंटरी पुरानी मात्रा में ही रहेगी — जरूरत पड़ने पर बाद में खुद ठीक करें।",
    "recon.lockTypeConfirm": "पुष्टि के लिए LOCK टाइप करें",
    "recon.confirmLockButton": "रिकन्सिलिएशन लॉक करें",
    // -- Inventory processing page
    "invProc.title": "मिल जॉब",
    "invProc.subtitle": "मिल जॉब: एक लॉट का स्टॉक चीरकर नया लॉट",
    "invProc.totalRuns": "कुल मिल जॉब",
    "invProc.avgOutturn": "औसत आउटटर्न",
    "invProc.cbmProcessed": "मिल हुआ CBM (इनपुट)",
    "invProc.noRuns": "अभी तक कोई मिल जॉब नहीं।",
    "invProc.noRunsHint": "राउंड लॉग से कटी लकड़ी बनाने के लिए नया मिल जॉब क्लिक करें।",
    "invProc.stepLocation": "स्थान और तिथि",
    "invProc.millLocationLabel": "मिल",
    "invProc.millPlaceholder": "मिल का नाम खोजें",
    "invProc.millRequired": "मिल स्थान आवश्यक है।",
    "invProc.notesLabel": "नोट्स (वैकल्पिक)",
    "invProc.tuSelectionHint": "उपलब्ध राउंड-प्रकार की स्टॉक यूनिट दिखाई जा रही हैं। सभी चुनें जो आरी में जाएंगी।",
    "invProc.noTusFound": "कोई उपलब्ध राउंड लॉग स्टॉक यूनिट नहीं मिली।",
    "invProc.noTusHint": "पहले राउंड लॉग स्टॉक यूनिट को इन्वेंटरी में प्राप्त करें।",
    "invProc.selected": "चयनित:",
    "invProc.totalInput": "कुल इनपुट:",
    "invProc.outputProduct": "आउटपुट प्रोडक्ट",
    "invProc.outputProductPlaceholder": "प्रोडक्ट का नाम खोजें",
    "invProc.noProductFound": "कोई प्रोडक्ट नहीं मिला",
    "invProc.noSiteFound": "कोई यार्ड नहीं मिला",
    "invProc.acSearchMessage": "{0} परिणाम उपलब्ध हैं",
    "invProc.acEmptySelectionMessage": "कोई आइटम चुना नहीं गया",
    "invProc.storeAt": "स्टोर करें",
    "invProc.storePlaceholder": "यार्ड का नाम",
    "invProc.outputVolume": "आउटपुट वॉल्यूम (CBM)",
    "invProc.fifoPanelTitle": "यह किस खरीद के हिसाब से गिना जाएगा?",
    "invProc.fifoPanelHint": "सबसे पुरानी खरीद पहले इस्तेमाल होती है। ज़रूरत पड़ने पर आप नीचे बंटवारा बदल सकते हैं।",
    "invProc.fifoPanelMismatch": "बदली गई मात्राओं का कुल योग मिल में गई कुल CBM के बराबर होना चाहिए।",
    "invProc.fifoPanelCbmLabel": "CBM",
    "invProc.fifoPanelPiecesLabel": "पीस",
    "invProc.outputPiecesLabel": "आउटपुट पीस",
    "invProc.inputPiecesLabel": "कितने पीस अंदर जा रहे हैं?",
    "invProc.useFullVolume": "पूरा वॉल्यूम",
    "invProc.useAllPieces": "सभी पीस",
    "invProc.inputPiecesOptionalHint": "वैकल्पिक — आप इसे जॉब पूरा करते समय भी भर सकते हैं।",
    "invProc.inputPiecesExceeds": "इस स्टॉक के पीस से ज़्यादा",
    "invProc.inputPiecesUsed": "इस्तेमाल हुए इनपुट पीस",
    "invProc.inputPiecesHint": "इनपुट स्टॉक से लिए गए पीस। आउटपुट पीस ज़्यादा हो सकते हैं — एक पीस से कई बन सकते हैं।",
    "invProc.inputPiecesReadOnlyHint": "जॉब पूरा होने के बाद इनपुट नहीं बदला जा सकता। सुधार के लिए स्टॉक एडजस्टमेंट करें।",
    "invProc.inputPiecesRequired": "जॉब पूरा करने से पहले इस्तेमाल हुए इनपुट पीस भरें।",
    "invProc.confirmSave": "पुष्टि और सेव",
    "invProc.inputHeader": "इनपुट",
    "invProc.outputHeader": "आउटपुट",
    "invProc.inputTUs": "इनपुट स्टॉक यूनिट",
    "invProc.lossLabel": "रूपांतरण",
    "invProc.step1.title": "मिल में क्या जाएगा?",
    "invProc.step2.title": "क्या निकला?",
    "invProc.inputCbmLabel": "कितना जा रहा है? (CBM)",
    "invProc.moreDetails": "अधिक विवरण (वैकल्पिक)",
    "invProc.selectTUs": "स्टॉक यूनिट चुनें (वैकल्पिक)",
    "invProc.confirmJobSave": "मिल जॉब दर्ज करें",
    "invProc.outputMethod": "आउटपुट कैसे दर्ज करें?",
    "invProc.directVolume": "कुल CBM दर्ज करें",
    "invProc.directVolumeDesc": "कुल आउटपुट वॉल्यूम टाइप करें",
    "invProc.viaTally": "लॉग-दर-लॉग मापें (टैली शीट)",
    "invProc.viaTallyDesc": "टैली शीट से पीस गिनें",
    "invProc.viaCsv": "CSV / Excel",
    "invProc.viaCsvDesc": "माप स्प्रेडशीट अपलोड करें",
    "invProc.viaAi": "AI Import",
    "invProc.viaAiDesc": "दस्तावेज़ स्कैन या अपलोड करें",
    "invProc.draftNote": "मिल जॉब ड्राफ्ट के रूप में सेव होगा। सेव करने के बाद आउटपुट पूरा करें।",
    "invProc.notesPlaceholder": "जैसे 4×8 प्लैंक, कस्टम ऑर्डर",
    "invProc.inputCbmLabelHelp": "आरी में कितना जा रहा है?",
    "invProc.assignTo": "ऑपरेटर को असाइन करें",
    "invProc.needsAccept": "आपको असाइन · स्वीकार करें",
    "invProc.assignedToYou": "आपको असाइन",
    "invProc.assignedTo": "असाइन किया गया",
    "invProc.createdBy": "बनाने वाले",
    "invProc.you": "आप",
    "invProc.acceptedLabel": "स्वीकार किया",
    "invProc.onlyAssignedCanAct": "यह काम किसी दूसरे ऑपरेटर को असाइन है। केवल वही ऑपरेटर या मैनेजर इस पर काम कर सकता है।",
    "invProc.acceptTask": "काम स्वीकार करें",
    "invProc.accepted": "काम स्वीकार किया गया",
    "invProc.myTasks": "मेरे काम",
    "invProc.big.accept": "स्वीकार करें",
    "invProc.big.start": "शुरू करें",
    "invProc.big.done": "काम पूरा",
    "invProc.big.resume": "फिर शुरू करें",
    "invProc.big.pause": "रोकें",
    "invProc.declineButton": "नहीं कर सकता",
    "invProc.declineTitle": "यह काम नहीं कर सकता",
    "invProc.declineIntro": "यह काम आपके मैनेजर के पास वापस जाएगा। उन्हें कारण बताएं।",
    "invProc.declineReasonLabel": "आप यह क्यों नहीं कर सकते?",
    "invProc.declineReasonPlaceholder": "जैसे मशीन खराब, गलत लकड़ी, इस मिल पर नहीं",
    "invProc.declineConfirm": "वापस भेजें",
    "invProc.declineDone": "काम मैनेजर को वापस भेज दिया गया",
    "invProc.declineNeedsInternet": "इसके लिए इंटरनेट चाहिए। ऑनलाइन होने पर फिर कोशिश करें।",
    "invProc.declinedCouldNot": "यह काम नहीं कर सके",
    "invProc.declinedHint": "अब यह किसी को असाइन नहीं है। इसे रद्द करें और दूसरे ऑपरेटर के लिए नया काम बनाएं।",
    "invProc.myTasksSubtitle": "आपका मिल का काम। काम आगे बढ़ाने के लिए बड़ा बटन दबाएं।",
    "invProc.myTasksEmpty": "अभी आपके लिए कोई काम नहीं है",
    "invProc.myTasksEmptyHint": "आपको दिए गए नए काम यहां दिखेंगे।",
    "invProc.big.refresh": "रीफ्रेश करें",
    "user.millOperator": "मिल ऑपरेटर",
    "user.millOperatorPill": "ऑपरेटर",
    "user.millOperatorOnTitle": "मिल ऑपरेटर चालू",
    "user.millOperatorOffTitle": "मिल ऑपरेटर बंद",
    "user.millOperatorOnMessage": "अब इस व्यक्ति को मिल के काम दिए जा सकते हैं।",
    "user.millOperatorRightsAdded": "अब इस व्यक्ति को मिल के काम दिए जा सकते हैं। View Mill Jobs और Run Mill Jobs अधिकार जोड़ दिए गए।",
    "user.millOperatorRoleMissing": "इनके रोल \"{{role}}\" में View Mill Jobs और Run Mill Jobs नहीं है, इसलिए ये अभी काम स्वीकार नहीं कर सकते। रोल में ये अधिकार जोड़ें या दूसरा रोल चुनें।",
    "user.millOperatorFailed": "मिल ऑपरेटर नहीं बदला जा सका। फिर से कोशिश करें।",
    "user.inviteAsMillOperator": "यह व्यक्ति मिल ऑपरेटर है",
    "user.inviteAsMillOperatorHint": "जुड़ने के बाद इन्हें मिल के काम दिए जा सकते हैं।",
    "operator.linkLogin": "लॉगिन जोड़ें",
    "operator.linkLoginHint": "यह ऑपरेटर कौन सा टीम सदस्य है, चुनें, ताकि वे अपने काम देख और स्वीकार कर सकें। यह सिर्फ एक बार सेट होता है।",
    "operator.noLogin": "लॉगिन नहीं",
    "operator.noLoginHint": "इस ऑपरेटर का लॉगिन नहीं है, इसलिए वे काम देख या स्वीकार नहीं कर सकते। जोड़ने के लिए टैप करें।",
    "operator.noOperatorsHint": "अभी कोई मिल ऑपरेटर नहीं है। Manage Users में किसी व्यक्ति के लिए \"मिल ऑपरेटर\" चालू करें।",
    "invProc.assignHint": "ड्राफ्ट के रूप में सेव करने के लिए खाली छोड़ें — बाद में असाइन करें।",
    "invProc.willBeAssigned": "काम बनाया जाएगा और चुने गए ऑपरेटर को असाइन होगा।",
    "invProc.willBeDraft": "कोई ऑपरेटर नहीं चुना — काम ड्राफ्ट के रूप में सेव होगा।",
    "invProc.outputPending": "लंबित — मिलिंग के बाद दर्ज होगा।",
    "invProc.assignDate": "अपेक्षित तिथि",
    "invProc.jobCard": "आज का काम",
    "invProc.startJob": "काम शुरू करें",
    "invProc.customMade.requested": "अनुरोधित",
    "invProc.customMade.sourceChoiceLabel": "स्रोत स्टॉक",
    "invProc.customMade.pickMyself": "मैं खुद चुनूंगा",
    "invProc.customMade.letOperatorDecide": "ऑपरेटर तय करेगा",
    "invProc.customMade.operatorPicksLater": "जब ऑपरेटर यह काम शुरू करेगा, तब वह स्रोत लॉट चुनेगा।",
    "invProc.customMade.chooseLotToStart": "स्रोत लॉट चुनें",
    "invProc.customMade.rowWaiting": "शुरू होने की प्रतीक्षा में",
    "invProc.customMade.rowProducing": "उत्पादन जारी है…",
    "invProc.customMade.rowPaused": "मिल में रुका हुआ",
    "invProc.customMade.peekTitle": "मिल कार्य",
    "invProc.customMade.peekUnavailable": "इस कार्य का विवरण लोड नहीं हो सका।",
    "invProc.customMade.dialogTitle": "कस्टम-मेड का अनुरोध करें",
    "invProc.customMade.dialogExplainer": "हमें यह सटीक साइज़ स्टॉक में नहीं मिला — इसे मिल में कटवाने का अनुरोध करें।",
    "invProc.customMade.sizeUnknown": "साइज़ अज्ञात — चुनने से पहले जांच लें",
    "invProc.lotHeldBy": "इस्तेमाल में:",
    "invProc.customMade.sizeTooSmall": "आवश्यकता से छोटा",
    "invProc.customMade.tooSmallWarning": "यह लॉट आवश्यकता से छोटा है — मिल केवल काट सकती है, सामग्री नहीं जोड़ सकती।",
    "invProc.customMade.inputCbmLabel": "कितना अंदर जा रहा है? (CBM)",
    "invProc.customMade.inputCbmHint": "आपकी पंक्ति को लगभग आवश्यकता है",
    "invProc.customMade.previewOutturn": "अनुमानित आउटटर्न",
    "invProc.customMade.inputCbmTooLow": "यह आवश्यकता से कम है — मिल में होने वाले नुकसान की भरपाई के लिए इसे बढ़ाएं। आपकी पंक्ति को कम से कम चाहिए",
    "invProc.customMade.priorityLabel": "प्राथमिकता",
    "invProc.customMade.priorityLow": "कम",
    "invProc.customMade.priorityMedium": "मध्यम",
    "invProc.customMade.priorityHigh": "उच्च",
    "invProc.customMade.priorityHighHint": "यह पूरा होने तक शिपमेंट को रोक देगा — इसे उच्च प्राथमिकता के रूप में चिह्नित किया गया है।",
    "invProc.customMade.neededByLabel": "कब तक चाहिए",
    "invProc.customMade.neededByHint": "वैकल्पिक। इस दिन के बाद भी काम खुला रहे तो आपको और मिल को एक बार याद दिलाया जाएगा।",
    "invProc.customMade.targetLabel": "ऑर्डर को चाहिए",
    "invProc.customMade.late": "देरी",
    "invProc.customMade.short": "कम",
    "invProc.customMade.shortBy": "कम",
    "invProc.customMade.madeOf": "बना",
    "invProc.customMade.stillMissing": "पीस अभी भी कम हैं। ऑर्डर अब भी अधूरा है: बाकी के लिए मिल से फिर अनुरोध करें।",
    "invProc.customMade.inputBelowTarget": "इनपुट मात्रा ऑर्डर की ज़रूरत से कम है। काटने से पहले जाँच लें।",
    "invProc.customMade.submitCta": "अनुरोध करें",
    "invProc.customMade.requestedToast": "कस्टम-मेड अनुरोध भेजा गया",
    "invProc.customMade.requestFailed": "अनुरोध नहीं भेजा जा सका",
    "invProc.customMade.queuedOfflineRunCode": "कतारबद्ध — सिंक होगा",
    "invProc.customMade.queuedOfflineToast": "कस्टम-मेड अनुरोध ऑफ़लाइन सहेजा गया",
    "invProc.customMade.queuedOfflineDetail": "ऑनलाइन होते ही यह स्वतः भेज दिया जाएगा।",
    "invProc.customMade.staleLotsNotice": "आपके अंतिम सिंक तक के लॉट दिखाए जा रहे हैं — पुराने हो सकते हैं।",
    "invProc.customMade.recommended": "अनुशंसित",
    "invProc.customMade.estimatedOutturn": "अनुमानित आउटटर्न",
    "invProc.customMade.viewSizes": "आकार देखें",
    "common.optional": "वैकल्पिक",
    "invProc.customMade.tuPreparing": "तैयार हो रहा है",
    "invProc.customMade.tuPreparingTooltip": "इस शीट की एक या अधिक वस्तुएं मिल में तैयार की जा रही हैं।",
    "invProc.completeJob": "काम पूरा",
    "invProc.cancelJob": "मिल जॉब रद्द करें",
    "invProc.pauseJob": "रोकें",
    "invProc.resumeJob": "फिर से शुरू करें",
    "invProc.pauseReasonLabel": "आप इसे क्यों रोक रहे हैं?",
    "invProc.pauseReasonPlaceholder": "जैसे, ज़रूरी ऑर्डर आ गया",
    "invProc.filterStatus": "स्थिति",
    "invProc.filterAll": "सभी",
    "invProc.filterDraft": "ड्राफ्ट",
    "invProc.filterRunning": "चल रहा है",
    "invProc.filterPaused": "रुका हुआ",
    "invProc.filterFinished": "पूरा हो गया",
    "invProc.filterCompleted": "पूर्ण",
    "invProc.filterCancelled": "रद्द",
    "invProc.sortLabel": "क्रम",
    "invProc.sortNewest": "सबसे नया पहले",
    "invProc.sortOldest": "सबसे पुराना पहले",
    "invProc.sortCode": "मिल जॉब ID A-Z",
    "invProc.noJobToday": "आज कोई काम असाइन नहीं हुआ।",
    "invProc.jobAssignedBy": "असाइन किया",
    "invProc.editOutput": "आउटपुट संपादित करें",
    "invProc.outputAboveInput": "आउटपुट मिल में गए माल से ज़्यादा है। आरी से जितनी लकड़ी दी गई उससे ज़्यादा नहीं बन सकती: आउटपुट टैली और इनपुट वॉल्यूम जाँचें।",
    "invProc.directEntry": "सीधा वॉल्यूम",
    "invProc.viaTallySheet": "टैली शीट से",
    "invProc.taskNo": "कार्य संख्या",
    "invProc.viewInMill": "मिल में देखें",
    "invProc.sourceOrder": "स्रोत ऑर्डर",
    "invProc.viewSourceOrder": "स्रोत ऑर्डर देखें",
    "invProc.selectTallySheet": "टैली शीट खोजें...",
    "invProc.tallyLinked": "टैली शीट जोड़ी — CBM भरा गया",
    "invProc.directDesc": "कुल CBM मैन्युअल रूप से दर्ज करें",
    "invProc.tallyDesc": "पीस रिकॉर्ड करें → CBM स्वतः जुड़ेगा",
    "invProc.csvImport": "CSV / Excel",
    "invProc.csvDesc": "स्प्रेडशीट आयात करें → टैली में जाँचें",
    "invProc.aiImport": "AI आयात",
    "invProc.aiDesc": "दस्तावेज़ स्कैन करें → टैली में जाँचें",
    "invProc.openTally": "टैली खोलें →",
    "invProc.tallyTypeLabel": "टैली प्रकार",
    "invProc.tallyTypeRound": "राउंड",
    "invProc.tallyTypeSquare": "स्क्वायर",
    "invProc.tallyTypeDerivedHint": "उत्पाद से स्वतः पहचाना",
    "invProc.tallyTypePickProduct": "पहले आउटपुट प्रोडक्ट चुनें। फिर टैली का प्रकार (राउंड या स्क्वायर) उसी से तय होगा।",
    "invProc.odWhatCameOut": "क्या बनकर निकला",
    "invProc.odHowRecord": "इसे कैसे दर्ज करेंगे?",
    "invProc.odTotals": "कुल",
    "invProc.odSquareRule": "इनपुट चीरी हुई लकड़ी (स्क्वायर) है, इसलिए आउटपुट भी स्क्वायर होगा। चीरी हुई लकड़ी से गोल लट्ठे नहीं बन सकते।",
    "invProc.volumeUnit": "वॉल्यूम इकाई",
    "invProc.odChooseProductFirst": "पहले आउटपुट प्रोडक्ट चुनें। फिर चुन सकेंगे कि कैसे दर्ज करना है।",
    "invProc.odTotalsFromTally": "टैली सेव करने के बाद कुल यहाँ दिखेंगे।",
    "invProc.odProductTypeLocked": "इस जॉब की टैली में पहले से {type} पंक्तियाँ हैं, इसलिए केवल {type} प्रोडक्ट दिखाए जाते हैं।",
    "invProc.noProductOfType": "कोई {type} प्रोडक्ट नहीं मिला",
    "invProc.odDraftSaving": "आपका चुनाव सेव हो रहा है…",
    "invProc.odDraftSaved": "आपका चुनाव सेव हो गया",
    "invProc.odDraftError": "आपका चुनाव अभी सेव नहीं हो सका।",
    "invProc.soFar": "अब तक",
    "invProc.recordedSoFar": "अब तक दर्ज",
    "invProc.recordedBeforeCancel": "रद्द करने से पहले दर्ज",
    "invProc.notStockYet": "अभी स्टॉक नहीं है। जॉब पूरा होने पर यह स्टॉक बनेगा।",
    "invProc.cancelWithOutputWarn": "जॉब <b>{run}</b> की आउटपुट टैली में पहले से {cbm} CBM ({pcs} पीस) दर्ज है। रद्द करने पर वह टैली केवल रिकॉर्ड के रूप में रहेगी और उसमें से कुछ भी स्टॉक नहीं बनेगा। इसे स्टॉक में डालने के लिए जॉब पूरा करें।",
    "invProc.cancelAnyway": "फिर भी रद्द करें",
    "invProc.keepJob": "जॉब रखें",
    "invProc.atMill": "मिल में",
    "invProc.atMillJobs": "चल रहे जॉब",
    "invProc.atMillInput": "रोका हुआ इनपुट",
    "invProc.atMillOutput": "अब तक का आउटपुट",
    "invProc.atMillNote": "अभी स्टॉक नहीं",
    "invProc.openingTally": "टैली खुल रही है…",
    "invProc.preparingRun": "नया मिल जॉब तैयार हो रहा है…",
    "invProc.odTotalsLocked": "पहले आउटपुट प्रोडक्ट चुनें, फिर कुल दर्ज करें।",
    "invProc.odPrepareSizes": "साइज़ तैयार करें (वैकल्पिक)",
    "invProc.odPrepareSizesHint": "टैली इन साइज़ के साथ 0 पीस पर खुलेगी। ऑपरेटर लेआउट इन्हें कार्ड की तरह दिखाता है।",
    "invProc.odSizesReady": "{n} साइज़ तैयार",
    "invProc.odSizesNotSaved": "साइज़ सेव नहीं हो सके। ऑपरेटर लेआउट में साइज़ चुनें से फिर चुनें।",
    "invProc.odEditInputPieces": "इनपुट पीस बदलें",
    "millOp.layoutAria": "टैली लेआउट",
    "millOp.layoutGrid": "ग्रिड",
    "millOp.layoutOperator": "ऑपरेटर",
    "millOp.loadError": "शीट लोड नहीं हो सकी।",
    "millOp.retry": "फिर कोशिश करें",
    "millOp.outputPieces": "आउटपुट पीस",
    "millOp.outputVolume": "आउटपुट वॉल्यूम",
    "millOp.volumeUnit": "वॉल्यूम इकाई",
    "millOp.input": "इनपुट",
    "millOp.outturn": "आउटटर्न",
    "millOp.ofInput": "इनपुट वॉल्यूम का",
    "millOp.moreThanInput": "इनपुट से ज़्यादा: साइज़ जाँचें",
    "millOp.saved": "सेव हो गया",
    "millOp.saving": "सेव हो रहा है…",
    "millOp.unsaved": "सेव नहीं हुआ",
    "millOp.saveFailed": "सेव नहीं हो सका",
    "millOp.show": "दिखाएँ",
    "millOp.sheetSizes": "शीट के साइज़",
    "millOp.used": "इस्तेमाल हुए",
    "millOp.view": "दृश्य",
    "millOp.textSize": "टेक्स्ट साइज़",
    "millOp.cardSize": "कार्ड साइज़",
    "millOp.cardTiny": "बहुत छोटा",
    "millOp.cardSmall": "छोटा",
    "millOp.cardMedium": "मध्यम",
    "millOp.cardLarge": "बड़ा",
    "millOp.tapSound": "टैप की आवाज़",
    "millOp.keepScreenOn": "स्क्रीन चालू रखें",
    "millOp.keepScreenOnUnsupported": "यह डिवाइस या ब्राउज़र स्क्रीन चालू नहीं रख सकता।",
    "millOp.unitsNote": "इकाइयाँ शीट की सेटिंग के अनुसार हैं। बदलने के लिए ग्रिड लेआउट में सेटिंग खोलें।",
    "millOp.resetView": "डिफ़ॉल्ट पर वापस",
    "millOp.oneLess": "एक पीस कम",
    "millOp.oneMore": "एक पीस ज़्यादा",
    "millOp.piecesTapToType": "पीस। नंबर लिखने के लिए टैप करें",
    "millOp.noUsed": "अभी कोई साइज़ इस्तेमाल नहीं हुआ। “शीट के साइज़” चुनें और + दबाएँ।",
    "millOp.noSizesTitle": "इस शीट में अभी कोई साइज़ नहीं",
    "millOp.noSizesText": "अपेक्षित साइज़ चुनें, या नया साइज़ जोड़ें।",
    "millOp.newSize": "नया साइज़",
    "millOp.pickSizes": "साइज़ चुनें",
    "millOp.autoSaves": "आख़िरी टैप के थोड़ी देर बाद अपने-आप सेव होता है",
    "millOp.screenStaysOn": "स्क्रीन चालू रहेगी",
    "millOp.undo": "पूर्ववत",
    "millOp.setPieces": "पीस सेट करें",
    "millOp.piecesForSize": "इस साइज़ के पीस",
    "millOp.clear": "साफ़",
    "millOp.newSizeHint": "एक बॉक्स दबाएँ, फिर तेज़ मान या कीज़",
    "millOp.width": "चौड़ाई",
    "millOp.thickness": "मोटाई",
    "millOp.length": "लंबाई",
    "millOp.addSize": "साइज़ जोड़ें",
    "millOp.pickHint": "अपेक्षित साइज़ चुनें। नया साइज़ बाद में भी जोड़ सकते हैं।",
    "millOp.searchSize": "साइज़ खोजें, जैसे 4 x 2",
    "millOp.listView": "सूची",
    "millOp.chipView": "चिप्स",
    "millOp.addAll": "सभी जोड़ें",
    "millOp.hasPieces": "पीस हैं",
    "millOp.noSuggestions": "अभी पहले के साइज़ नहीं मिले। “नया साइज़” इस्तेमाल करें।",
    "millOp.addNSizes": "{n} साइज़ जोड़ें",
    "millOp.removeNSizes": "{n} साइज़ हटाएँ",
    "millOp.onSheet": "इस शीट पर",
    "millOp.sameAsLast": "पिछले जॉब जैसा {code}",
    "millOp.mostUsed": "सबसे ज़्यादा इस्तेमाल",
    "millOp.recent": "हाल के",
    "millOp.changeToast": "{size}: {from} → {to} पीस",
    "invProc.odTypeFromInput": "क्योंकि इनपुट चीरी हुई लकड़ी है",
    "invProc.squareInputRoundBlocked": "चीरी हुई लकड़ी (स्क्वायर इनपुट) से गोल लट्ठे नहीं बन सकते। स्क्वायर आउटपुट प्रोडक्ट चुनें।",
    "invProc.tallyTypeMismatch": "इस जॉब की टैली में पहले से {tally} टैली की पंक्तियाँ हैं, लेकिन आउटपुट प्रोडक्ट {product} है। {tally} आउटपुट प्रोडक्ट चुनें, या डायरेक्ट वॉल्यूम पर जाएं।",
    "invProc.tallyTypeLinkedHint": "जुड़े टैली से",
    "invProc.linkedTally": "जोड़ा गया",
    "invProc.tallyRows": "पंक्तियाँ",
    "invProc.cbmFromTally": "टैली से स्वतः भरा",
    "invProc.tallyManualHint": "टैली में पीस रिकॉर्ड करें, फिर यहाँ वापस आएं",
    "invProc.csvHint": "CSV आयात डायलॉग स्वतः खुलेगा",
    "invProc.aiHint": "AI आयात डायलॉग स्वतः खुलेगा",
    "invProc.dispatchOutput": "कंसाइनमेंट में भेजें →",
    "invProc.selectShipment": "कंसाइनमेंट चुनें",
    "invProc.shipmentPlaceholder": "सक्रिय कंसाइनमेंट चुनें...",
    "invProc.confirmDispatch": "भेजना पुष्टि करें",
    "tally.processingBanner": "मिल जॉब के लिए आउटपुट दर्ज हो रहा है:",
    "tally.outputLockedTitle": "यह आउटपुट अंतिम है",
    "tally.outputLockedText": "यह मिल जॉब पूरा हो चुका है और इसकी लकड़ी नए लॉट के रूप में स्टॉक में जुड़ चुकी है, इसलिए यह टैली केवल देखने के लिए है — ताकि यह हमेशा स्टॉक से मेल खाए। आउटपुट बदलने के लिए मिल जॉब पर Edit Output का उपयोग करें। स्टॉक की संख्या सुधारने के लिए Add Adjustment का उपयोग करें। दोनों का रिकॉर्ड रहता है।",
    "tally.returnToRun": "हो गया — मिल जॉब पर वापस",
    "tally.saveAndReturnToRun": "सेव करें और मिल जॉब पर वापस",
    "field.stockIn.title": "स्टॉक आना दर्ज करें",
    "field.millRun.title": "आपका काम",
    "field.sendOut.title": "भेजना दर्ज करें",
    "field.selectProduct": "क्या आया?",
    "field.cbmAmount": "कितना? (CBM)",
    "field.location": "कहाँ रखा जाएगा?",
    "field.submitBtn": "हो गया",
    "field.noJobAssigned": "आज कोई काम नहीं।",
    // -- Inventory in-out page
    "invInOut.title": "इन / आउट लेजर",
    "invInOut.subtitle": "हर इन्वेंटरी मूवमेंट का टाइमस्टैम्प और विवरण",
    "invInOut.addAdjustment": "एडजस्टमेंट जोड़ें",
    "invInOut.adjTooltip": "मैन्युअल स्टॉक सुधार दर्ज करें",
    "invInOut.exportTooltip": "फ़िल्टर किया गया लेजर Excel में एक्सपोर्ट करें",
    "invInOut.dateRange": "तिथि सीमा",
    "invInOut.allDates": "सभी तिथियाँ",
    "invInOut.movements": "मूवमेंट",
    "invInOut.netChange": "कुल बदलाव",
    "invInOut.businessPartner": "बिजनेस पार्टनर",
    "invInOut.noMovements": "कोई मूवमेंट नहीं मिली।",
    "invInOut.clearFiltersHint": "ऊपर दिए फिल्टर हटाकर देखें।",
    "invInOut.adjDialogHeader": "इन्वेंटरी एडजस्टमेंट जोड़ें",
    "invInOut.tuPlaceholder": "स्टॉक यूनिट, कंटेनर / ट्रक नंबर या प्रोडक्ट से खोजें",
    "ledger.s.received": "प्राप्त",
    "ledger.s.at": "पर",
    "ledger.s.as": "के रूप में",
    "ledger.s.dispatched": "भेजा गया",
    "ledger.s.from": "से",
    "ledger.s.on": "पर",
    "ledger.s.to": "को",
    "ledger.s.sentToMill": "मिल में भेजा",
    "ledger.s.forJob": "जॉब के लिए",
    "ledger.s.job": "जॉब",
    "ledger.s.produced": "ने बनाया",
    "ledger.s.into": "में",
    "ledger.s.addedToConsignment": "कंसाइनमेंट में जोड़ा",
    "ledger.s.allowance": "राउंड अलाउंस",
    "ledger.s.tallyCorrected": "टैली सुधार",
    "ledger.s.stockCorrected": "स्टॉक सुधार",
    "Reconciliation": "रिकंसिलिएशन",
    "Allowance": "अलाउंस",
    "Tally correction": "टैली सुधार",
    "ledger.s.reconciled": "रिकंसाइल किया",
    "ledger.col.whatHappened": "क्या हुआ",
    "ledger.col.by": "किसने",
    "ledger.job.show": "पूरा जॉब",
    "ledger.job.in": "इनपुट",
    "ledger.job.out": "आउटपुट",
    "ledger.job.started": "शुरू",
    "ledger.job.finished": "पूरा हुआ",
    "ledger.job.notFinished": "अभी पूरा नहीं",
    "ledger.job.wastage": "वेस्टेज",
    "invInOut.tuRequired": "स्टॉक यूनिट चुनें।",
    "invInOut.reason": "कारण",
    "invInOut.reasonPlaceholder": "कारण चुनें",
    "invInOut.reasonRequired": "कारण चुनें।",
    "invInOut.cbmChange": "CBM परिवर्तन",
    "invInOut.cbmHint": "ऋणात्मक = हानि, धनात्मक = लाभ",
    "invInOut.piecesChange": "पीस परिवर्तन",
    "terms.open": "स्टॉक यूनिट, लॉट और मिल जॉब का मतलब?",
    "terms.flowLabel": "स्टॉक कैसे चलता है: स्टॉक इन, लॉट, मिल जॉब, नया लॉट, स्टॉक आउट",
    "terms.stockIn": "स्टॉक इन",
    "terms.stockOut": "स्टॉक आउट",
    "terms.lot": "लॉट",
    "terms.newLot": "नया लॉट",
    "terms.millJob": "मिल जॉब",
    "terms.suName": "स्टॉक यूनिट",
    "terms.suText": "एक लोड — कंटेनर, ट्रक या वैगन — उसकी टैली पंक्तियों के साथ। स्टॉक इन = खरीदा, स्टॉक आउट = बेचा। प्राप्त / कन्फ़र्म होने के बाद पंक्तियाँ लॉक।",
    "terms.lotText": "स्टॉक में एक जैसी लकड़ी का ढेर (प्रोडक्ट, साइट, मूल, क्वालिटी)। स्टॉक इन इसमें आता है; स्टॉक आउट और मिल जॉब इससे लेते हैं — सबसे पुराना लॉट पहले।",
    "terms.lotOld": "(पहले बैच कहते थे)",
    "terms.jobText": "लॉट से मिल भेजी गई लकड़ी; क्या गया, क्या बना और कितना वेस्ट हुआ, दर्ज करता है और नया लॉट बनाता है।",
    "terms.jobOld": "(पहले प्रोसेसिंग / मिल रन कहते थे)",
    "terms.more": "स्टॉक कैसे चलता है — पूरी गाइड",
    "so.fromPurchase": "किस खरीद से",
    "so.whereFrom": "यह कहाँ से आया",
    "so.show": "दिखाएँ",
    "so.showPath": "पूरा रास्ता दिखाएँ",
    "so.hidePath": "रास्ता छिपाएँ",
    "so.error": "इसे ट्रेस नहीं कर सके।",
    "so.nothing": "अभी स्टॉक से कुछ नहीं लिया गया।",
    "so.inputNote": "मिल जॉब से पहले के आँकड़े अंदर गई लकड़ी के हैं, इसलिए उनमें उस जॉब का वेस्ट शामिल है। नेट वॉल्यूम।",
    "so.in": "अंदर",
    "so.out": "बाहर",
    "so.waste": "वेस्ट",
    "so.now": "अभी",
    "so.adjusted": "एडजस्ट",
    "so.reconciled": "रिकंसाइल",
    "so.allowance": "अलाउंस",
    "so.traceToPurchase": "खरीद तक ट्रेस करें",
    "so.kind.LOT": "लॉट",
    "so.kind.MILL_JOB": "मिल जॉब",
    "so.kind.STOCK_UNIT": "स्टॉक यूनिट",
    "so.kind.OPENING_STOCK": "ओपनिंग स्टॉक",
    "so.kind.HAND": "हाथ से बनाया लॉट",
    "so.kind.ADJUSTMENT": "एडजस्टमेंट से जोड़ा",
    "so.kind.NOT_TRACED": "ट्रेस नहीं हुआ",
    "adj.what": "स्टॉक यूनिट, स्टॉक आउट या लॉट",
    "adj.whatPlaceholder": "स्टॉक इन / स्टॉक आउट यूनिट, कंटेनर / ट्रक नंबर, लॉट या प्रोडक्ट खोजें",
    "adj.kind.IN": "स्टॉक इन",
    "adj.kind.OUT": "स्टॉक आउट",
    "adj.kind.LOT": "लॉट",
    "adj.reconHint": "रिकंसिलिएशन अंतर — इसे साइज़ के हिसाब से दर्ज करें:",
    "adj.noLot": "यह स्टॉक यूनिट अभी किसी लॉट में नहीं आई है — एडजस्ट करने को कुछ नहीं।",
    "adj.outLine": "इस स्टॉक आउट की कौन सी लाइन",
    "adj.outLinePlaceholder": "लॉट · साइज़ · पीस चुनें",
    "adj.noOutLines": "इस स्टॉक आउट ने अभी कोई स्टॉक नहीं लिया — एडजस्ट करने को कुछ नहीं।",
    "adj.batchNow": "में अभी है",
    "adj.dir.gain": "स्टॉक में जोड़ें",
    "adj.dir.loss": "स्टॉक से घटाएँ",
    "adj.dir.outGain": "दर्ज से कम भेजा",
    "adj.dir.outLoss": "दर्ज से ज़्यादा भेजा",
    "adj.size": "साइज़",
    "adj.sizePlaceholder": "साइज़ चुनें",
    "adj.anotherSize": "दूसरा साइज़…",
    "adj.sec.what": "क्या बदलना है",
    "adj.sec.amount": "साइज़ और मात्रा",
    "adj.sec.why": "क्यों",
    "adj.origin": "मूल देश",
    "adj.quality": "क्वालिटी",
    "adj.originNote": "एडजस्टमेंट इसी लॉट में जाएगा — इसका मूल देश और क्वालिटी वही रहेंगे।",
    "adj.volume": "वॉल्यूम",
    "adj.sizeSearch": "साइज़ खोजें, जैसे 4x3x6",
    "adj.width": "चौड़ाई (इंच)",
    "adj.thick": "मोटाई (इंच)",
    "adj.length": "लंबाई (फ़ुट)",
    "adj.pieces": "पीस",
    "adj.cbm": "CBM",
    "adj.maxPcs": "स्टॉक में इसके {n} पीस तक",
    "adj.pcsInStock": "{n} पीस",
    "adj.tooMuch": "यह इस लॉट / साइज़ में असल में जितना है उससे ज़्यादा है।",
    "adj.outNoteTitle": "स्टॉक आउट एडजस्ट हुआ",
    "adj.outNote": "स्टॉक सुधर गया; स्टॉक आउट की लाइनें वैसी ही रहेंगी। कंसाइनमेंट / इनवॉइस टोटल नहीं बदलते — ज़रूरत हो तो उन्हें भी ठीक करें।",
    "adj.offline": "एडजस्टमेंट के लिए इंटरनेट चाहिए।",
    "adj.saved": "एडजस्टमेंट दर्ज — हाथ में स्टॉक अपडेट हुआ।",
    "adj.roundPart": "गोल लट्ठे (बिना साइज़)",
    "adj.reason.RECONCILIATION_DELTA": "मिलान अंतर",
    "adj.reason.RECONCILIATION_AFTER_MILLING": "मिलिंग के बाद मिलान",
    "adj.reason.DAMAGE": "क्षति",
    "adj.reason.MOISTURE_LOSS": "नमी / सुखाई में कमी",
    "adj.reason.MEASUREMENT_ERROR": "माप की गलती",
    "adj.reason.MANUAL_CORRECTION": "मैन्युअल सुधार",
    "adj.reason.OTHER": "अन्य",
    "adj.notesRequired": "कृपया बताएं क्या हुआ (कारण 'अन्य' होने पर आवश्यक)।",
    "adj.large.title": "यह बड़ा एडजस्टमेंट है",
    "adj.large.text": "राशि ध्यान से जांचें — एक गलती (जैसे अतिरिक्त शून्य) से आपका स्टॉक बहुत बदल जाएगा।",
    "adj.large.confirm": "मैंने यह राशि जांच ली है",
    "adj.holdShortTitle": "दूसरे स्टॉक आउट अब कम पड़ेंगे",
    "adj.holdShortText": "ये खुले स्टॉक आउट इस लॉट से अब उससे ज़्यादा रोके हुए हैं जितना उसमें है: {units}",
    "adj.alreadyAdjusted": "एडजस्ट",
    "ledger.s.adjustedAfterConfirm": "कन्फ़र्म के बाद एडजस्ट",
    "ledger.s.recordedOnly": "(सिर्फ़ दर्ज — स्टॉक नहीं बदला)",
    "invInOut.postAdjustment": "एडजस्टमेंट पोस्ट करें",
    "invInOut.descPlaceholder": "क्या हुआ बताएं (वैकल्पिक)",
    // -- Inventory overview page
    "invOverview.title": "इन्वेंटरी अवलोकन",
    "invOverview.subtitle": "सभी स्थानों पर लाइव स्टॉक स्नैपशॉट",
    "invOverview.thisMonth": "इस महीने",
    "invOverview.clearStageHint": "फिल्टर हटाने के लिए उसी स्टेज पर क्लिक करें",
    "invOverview.filterTooltip": "स्टॉक टेबल फिल्टर करने के लिए क्लिक करें",
    "invOverview.openTu": "स्टॉक यूनिट खोलें",
    "invOverview.noStock": "अभी इन्वेंटरी में कोई स्टॉक नहीं।",
    "invOverview.noStockHint": "स्टॉक इन पर क्लिक करें और पहली स्टॉक एंट्री दर्ज करें।",
    "invOverview.showAllTus": "सभी दिखाएं",
    "invOverview.receiveHint": "ट्रक आया — नया स्टॉक दर्ज करें",
    "invOverview.processHint": "लॉग मिल में भेजें",
    "invOverview.dispatchHint": "स्टॉक जा रहा है",
    "invOverview.recordInInventory": "इन्वेंटरी में दर्ज करें",
    "invOverview.linkedToInventory": "इन्वेंटरी में है",
    "invOverview.modeToggle": "व्यू मोड",
    "inv.modeSimple": "सरल",
    "inv.modeAdvanced": "उन्नत",
    "inv.modeTooltip": "सरल: कम फ़ील्ड · उन्नत: पूर्ण ट्रैकिंग",
    "inv.stockIn": "स्टॉक इन",
    "inv.millRun": "मिल जॉब",
    "inv.sendOut": "स्टॉक आउट",
    // -- Inventory Lots / Wizards
    "lot.receive": "स्टॉक इन",
    "lot.process": "→ मिल",
    "lot.sendToMill": "मिल में भेजें",
    "lot.more.label": "और",
    "lot.more.details": "विवरण देखें",
    "lot.more.statement": "स्टॉक स्टेटमेंट",
    "lot.more.openJob": "मिल जॉब खोलें",
    "lot.more.rename": "लॉट का नाम बदलें",
    "lot.warn.short": "कॉन्ट्रैक्ट से कम",
    "lot.dispatch": "भेजें",
    "lot.stockBatch": "स्टॉक लॉट",
    "lot.inputLotLabel": "इनपुट स्टॉक लॉट",
    "lot.selectLotPlaceholder": "स्टॉक लॉट चुनें (वैकल्पिक)",
    "lot.searchLotPlaceholder": "उत्पाद, मूल देश, लॉट कोड या मिल जॉब खोजें…",
    "lot.searchLotEmpty": "आपकी खोज से कोई लॉट मेल नहीं खाता",
    "lot.pickSearchPlaceholder": "उत्पाद, लॉट, Stock Unit, कंटेनर, BL खोजें…",
    "lot.pickOriginPlaceholder": "मूल देश: सभी",
    "lot.pickOriginUnknown": "मूल देश अज्ञात",
    "lot.pickOpenLots": "खुले लॉट",
    "lot.pickFree": "CBM उपलब्ध",
    "lot.pickMadeBy": "बनाया गया",
    "lot.pickHide": "छुपाएं",
    "lot.pickStockUnit": "Stock Unit",
    "lot.pickContainer": "कंटेनर / ट्रक · ट्रांसपोर्ट ID",
    "lot.pickSource": "स्रोत",
    "lot.pickThisLot": "यह लॉट",
    "lot.pickUnitsCount": "Stock Unit",
    "lot.pickReceived": "इस लॉट में प्राप्त",
    "lot.pickTraced": "मिल जॉब से होकर आया",
    "lot.pickClose": "बंद करें",
    // -- Mill Operators
    "operator.label": "ऑपरेटर",
    "operator.multiCompanyBadge": "मल्टी-कंपनी",
    "operator.multiCompanyTooltip": "यह व्यक्ति किसी अन्य कंपनी में भी सक्रिय है — इनका खाता केवल आपकी कंपनी तक सीमित नहीं है।",
    "operator.selectPlaceholder": "ऑपरेटर असाइन करें (वैकल्पिक)",
    "operator.title": "मिल ऑपरेटर",
    "operator.subtitle": "मिल ऑपरेटरों को प्रबंधित करें और प्रदर्शन को ट्रैक करें",
    "operator.backToInventory": "इन्वेंटरी पर वापस जाएं",
    "operator.addOperator": "ऑपरेटर जोड़ें",
    "machine.title": "मशीनें",
    "machine.subtitle": "मिल मशीनों और उपकरणों का प्रबंधन करें",
    "machine.backToInventory": "इन्वेंटरी पर वापस जाएं",
    "machine.addMachine": "मशीन जोड़ें",
    "machine.editMachine": "मशीन संपादित करें",
    "machine.name": "नाम",
    "machine.namePlaceholder": "उदा. रीसॉ 2",
    "machine.type": "प्रकार",
    "machine.typePlaceholder": "उदा. रीसॉ, एजर, क्रॉस-कट",
    "machine.location": "स्थान",
    "machine.status": "स्थिति",
    "machine.active": "सक्रिय",
    "machine.inactive": "निष्क्रिय",
    "machine.deactivate": "निष्क्रिय करें",
    "machine.reactivate": "पुनः सक्रिय करें",
    "machine.confirmMachine": "पुष्टि करें",
    "machine.searchPlaceholder": "मशीनें खोजें...",
    "machine.allLocations": "सभी स्थान",
    "machine.allStatus": "सभी स्थिति",
    "machine.needsReview": "समीक्षा आवश्यक",
    "machine.needsReviewTooltip": "किसी स्थान के फ्री-टेक्स्ट फ़ील्ड से आयात किया गया — कृपया पुष्टि करें कि यह सही है",
    "machine.importFromLocations": "स्थानों से आयात करें",
    "machine.statTotal": "कुल मशीनें",
    "machine.machineSingular": "मशीन",
    "machine.machinePlural": "मशीनें",
    "machine.emptyState": "अभी तक कोई मशीन नहीं। एक जोड़ें, या अपने मौजूदा स्थानों से आयात करें।",
    "shortcuts.title": "कीबोर्ड शॉर्टकट",
    "shortcuts.macHint": "⌘ = Mac पर Cmd। नीचे दिए गए सेव/डिलीट फॉर्म शॉर्टकट अभी सिर्फ Mac कीबोर्ड पर काम करते हैं।",
    "shortcuts.group.anywhere": "कहीं भी",
    "shortcuts.group.search": "सर्च के अंदर",
    "shortcuts.group.tally": "टैली एंट्री",
    "shortcuts.group.forms": "प्रोडक्ट / लोकेशन फॉर्म",
    "shortcuts.group.photos": "फोटो व्यूअर",
    "shortcuts.group.calculator": "कैलकुलेटर",
    "shortcuts.group.aiChat": "AI चैट",
    "shortcuts.globalSearch": "वैश्विक खोज खोलें",
    "shortcuts.openSearch": "खोज खोलें",
    "shortcuts.calculator": "कैलकुलेटर खोलें",
    "shortcuts.quickSearch": "त्वरित खोज खोलें",
    "shortcuts.showShortcuts": "यह सूची दिखाएं",
    "shortcuts.expandMenu": "साइडबार मेनू खोलें",
    "shortcuts.moveSelection": "चयन ऊपर/नीचे ले जाएं",
    "shortcuts.openSelected": "चयनित परिणाम खोलें",
    "shortcuts.closeSearch": "बंद करें",
    "shortcuts.saveTally": "टैली बदलाव सेव करें",
    "shortcuts.tallyEnter": "अगला फ़ील्ड / अगली पंक्ति (अंत में नई पंक्ति जुड़ती है)",
    "shortcuts.tallyAddRowBelow": "नीचे पंक्ति जोड़ें (राउंड टैली)",
    "shortcuts.tallyStockPicker": "स्टॉक से चुनें (फ़्लेक्सिबल स्क्वायर लेआउट)",
    "shortcuts.tallyForceNext": "मान जाँचे बिना आगे बढ़ें (फ़्लेक्सिबल स्क्वायर लेआउट: नीचे पंक्ति जोड़ता है)",
    "shortcuts.tallyMoveCells": "सेल के बीच जाएँ",
    "shortcuts.saveForm": "सेव करें (सिर्फ Mac)",
    "shortcuts.deleteForm": "एडिट करते समय डिलीट करें (सिर्फ Mac)",
    "shortcuts.prevNextPhoto": "पिछली / अगली फोटो",
    "shortcuts.closePhoto": "फोटो व्यूअर बंद करें",
    "shortcuts.calcDigits": "अंक दर्ज करें",
    "shortcuts.calcOperators": "ऑपरेटर",
    "shortcuts.calcPercent": "प्रतिशत",
    "shortcuts.calcEquals": "गणना करें",
    "shortcuts.calcBackspace": "आखिरी अंक मिटाएं",
    "shortcuts.calcClearOrClose": "साफ करें, फिर बंद करें",
    "shortcuts.aiChatSend": "संदेश भेजें",
    "shortcuts.aiChatNewLine": "नई पंक्ति, बिना भेजे",
    "globalSearch.help.viewAllShortcuts": "सभी कीबोर्ड शॉर्टकट देखें",
    "globalSearch.trigger": "वैश्विक खोज",
    "unifiedSearch.trigger": "खोजें",
    "unifiedSearch.placeholder": "कुछ भी खोजें, या गणना टाइप करें…",
    "unifiedSearch.shortcutHint": "/",
    "unifiedSearch.mode.auto": "ऑटो",
    "unifiedSearch.mode.records": "रिकॉर्ड्स",
    "unifiedSearch.mode.stock": "स्टॉक",
    "unifiedSearch.mode.calculator": "कैलकुलेटर",
    "unifiedSearch.autoInterpreting": "इस रूप में खोज रहे हैं",
    "unifiedSearch.mathOpenHint": "कैलकुलेटर खोलने के लिए टैप करें या एंटर दबाएँ",
    "globalSearch.placeholder": "स्टॉक यूनिट, कंसाइनमेंट, पार्टनर, प्रोडक्ट, साइट, यूज़र खोजें…",
    "globalSearch.shortcutHint": "/",
    "globalSearch.searching": "खोजा जा रहा है…",
    "globalSearch.noResults": "कोई परिणाम नहीं मिला",
    "globalSearch.minChars": "खोजने के लिए टाइप करना जारी रखें…",
    "globalSearch.category.transportUnit": "स्टॉक यूनिट",
    "globalSearch.category.shipment": "कंसाइनमेंट",
    "globalSearch.category.businessPartner": "बिज़नेस पार्टनर",
    "globalSearch.category.product": "प्रोडक्ट",
    "globalSearch.category.loadingSite": "लोकेशन",
    "globalSearch.category.user": "यूज़र",
    "globalSearch.category.menuItem": "पेज",
    "globalSearch.askLinc.cta": "Linc से पूछें",
    "globalSearch.askLinc.subtitle": "अपने रिकॉर्ड और स्टॉक के बारे में Linc से पूछें",
    "globalSearch.calculatorTooltip": "कैलकुलेटर",
    "globalSearch.mathOpenHint": "आगे गणना करने के लिए टैप करें",
    "globalSearch.help.toggleTooltip": "कैसे खोजें",
    "globalSearch.help.intro": "इनमें खोजें:",
    "globalSearch.help.shortcutText": "यह सर्च कहीं से भी खोलने के लिए / दबाएं। कम से कम 2 अक्षर टाइप करें — छोटे कोड 2 अक्षर से ही मिल जाते हैं, लंबे नाम 4 अक्षर से।",
    "globalSearch.recentTitle": "हाल की खोजें",
    "quickSearch.trigger": "त्वरित खोज",
    "quickSearch.placeholder": "उदा. 4x3x7 सागौन घाना ए",
    "quickSearch.fuzzyTooltip": "अनुमानित मिलान — सटीक नहीं",
    "quickSearch.unrecognizedTooltip": "प्रजाति, मूल या ग्रेड के रूप में पहचाना नहीं गया — अनदेखा किया गया",
    "quickSearch.recent": "हाल की खोजें",
    "planLimit.dialogTitle": "प्लान सीमा पूर्ण",
    "planLimit.dialogUsage": "आपने {limit} में से {used} {feature} का उपयोग किया है।",
    "planLimit.manageButton": "{feature} प्रबंधित करें",
    "planLimit.upgradeButton": "प्लान अपग्रेड करें",
    "quickSearch.searching": "खोज रहे हैं...",
    "quickSearch.notFound": "कोई परिणाम नहीं मिला — अलग वर्तनी या कम विवरण आज़माएं।",
    "quickSearch.availableNow": "अभी उपलब्ध",
    "quickSearch.pendingStockIn": "स्टॉक-इन लंबित",
    "quickSearch.groups": "समूह",
    "quickSearch.pcs": "पीस",
    "quickSearch.eta": "अनुमानित समय",
    "quickSearch.details": "खरीद विवरण",
    "shipment.tuAllProducts": "इस यूनिट में सभी उत्पाद",
    "quickSearch.invoiceAmount": "इनवॉइस राशि",
    "quickSearch.billNo": "बिल नंबर",
    "quickSearch.billOfLadingNo": "बिल ऑफ लैडिंग नंबर",
    "quickSearch.viewConsignment": "कंसाइनमेंट देखें",
    "quickSearch.mixedConsignments": "मिश्रित — विवरण के लिए टैप करें",
    "quickSearch.noPurchasingInfo": "इस स्टॉक के लिए कोई खरीद जानकारी दर्ज नहीं है।",
    "quickSearch.calculator": "कैलकुलेटर",
    "quickSearch.quickPrice": "त्वरित मूल्य",
    "quickSearch.pricePerCbm": "मूल्य / CBM",
    "quickSearch.pricePerCft": "मूल्य / CFT",
    "quickSearch.inProcess": "मिल जॉब में",
    "quickSearch.didYouMean": "क्या आपका मतलब था",
    "quickSearch.arrivingSoon": "जल्द आने वाला",
    "quickSearch.departingSoon": "जल्द रवाना होने वाला",
    "quickSearch.preparing": "तैयार हो रहा है",
    "quickSearch.hint": "प्रजाति, आयाम, मूल या गुणवत्ता टाइप करें — किसी भी क्रम में।",
    "quickSearch.help.toggleTooltip": "यह कैसे काम करता है",
    "quickSearch.help.back": "खोज पर वापस जाएं",
    "quickSearch.help.basicsTitle": "मूल बातें",
    "quickSearch.help.basicsText": "प्रजाति, आकार, मूल या गुणवत्ता को किसी भी क्रम में मिलाएं — कुछ भी ज़रूरी नहीं है।",
    "quickSearch.help.sizesTitle": "आकार",
    "quickSearch.help.sizesExactText": "सटीक आकार, कोई शब्द ज़रूरी नहीं:",
    "quickSearch.help.sizesRangeText": "या एक सीमा — तुलनात्मक शब्द और नाम वाला माप जोड़ें:",
    "quickSearch.help.sizesTypeText": "सिर्फ संख्याएं कभी-कभी स्पष्ट नहीं होतीं — बताने के लिए \"square\" या \"round\" जोड़ें:",
    "quickSearch.help.sizesAnyText": "जो माप मायने न रखे वहां \"?\" लगाएं — \"4x3x?\" यानी 4x3, कोई भी लंबाई:",
    "quickSearch.help.speciesTitle": "प्रजाति, मूल, गुणवत्ता",
    "quickSearch.help.speciesText": "टाइपो कोई समस्या नहीं — नज़दीकी मिलान अपने आप मिल जाता है। \"?\" चिह्न का मतलब है यह एक अनुमान था, सटीक नहीं।",
    "quickSearch.help.legendTitle": "परिणाम समूहों का मतलब",
    "quickSearch.help.legendAvailable": "अभी उपलब्ध — आज ही उपयोग के लिए तैयार",
    "quickSearch.help.legendPending": "स्टॉक-इन लंबित — तली हुई, अभी इन्वेंट्री में प्राप्त नहीं हुई",
    "quickSearch.help.legendProcess": "मिल जॉब में — अभी चीरा या दोबारा चीरा जा रहा है",
    "quickSearch.help.legendArriving": "आगमन / प्रस्थान / तैयारी — आने वाली शिपमेंट",
    "quickSearch.help.aiTitle": "एआई से पूछें",
    "quickSearch.help.aiText": "वाक्य बनाने में दिक्कत? एआई से पूछें अस्पष्ट, स्वाभाविक भाषा को समझता है। इसमें एआई क्रेडिट लगते हैं (Forest प्लान) — सामान्य खोज हमेशा मुफ़्त रहती है।",
    "commandCenter.title": "कमांड सेंटर",
    "commandCenter.asOf": "समय",
    "commandCenter.offlineNoCopyTitle": "इस फ़ोन पर अभी सेव नहीं है",
    "commandCenter.offlineNoCopyText": "ऑनलाइन रहते हुए एक बार कमांड सेंटर खोलें। उसके बाद आख़िरी आँकड़े इस फ़ोन पर सेव हो जाएँगे और आप उन्हें ऑफ़लाइन देख सकेंगे।",
    "commandCenter.tab.overview": "अवलोकन",
    "commandCenter.tab.inventory": "इन्वेंटरी",
    "commandCenter.tab.floor": "फ्लोर और यील्ड",
    "commandCenter.tab.money": "पैसा",
    "commandCenter.tab.consignments": "कंसाइनमेंट",
    "commandCenter.cons.arriving": "इस हफ़्ते पहुँच रहे",
    "commandCenter.cons.leaving": "इस हफ़्ते रवाना",
    "commandCenter.cons.preparing": "तैयार हो रहे",
    "commandCenter.cons.shipped": "इस महीने भेजा गया",
    "commandCenter.cons.inShipment": "खेप में",
    "commandCenter.cons.arrives": "पहुँचेगी",
    "commandCenter.cons.departs": "रवाना होगी",
    "commandCenter.cons.all": "सभी खेप",
    "commandCenter.howSure": "आँकड़े कितने भरोसेमंद हैं",
    "commandCenter.counted": "गिने गए",
    "commandCenter.notCountedYet": "स्टॉक यूनिट अभी गिनी नहीं गईं",
    "commandCenter.reviewThem": "जाँचें",
    "commandCenter.allSizes": "सभी साइज़",
    "commandCenter.allSites": "सभी साइट",
    "commandCenter.btn.open": "खोलें",
    "commandCenter.btn.review": "जाँचें",
    "commandCenter.btn.count": "गिनें",
    "commandCenter.btn.see": "देखें",
    "commandCenter.btn.assign": "सौंपें",
    "commandCenter.attn.noMachineOne": "मिल जॉब {code} के पास मशीन नहीं है",
    "commandCenter.attn.noMachineMany": "{n} चल रहे मिल जॉब के पास मशीन नहीं है",
    "commandCenter.attn.holdsOne": "1 स्टॉक आउट 60+ दिन से लकड़ी रोके है",
    "commandCenter.attn.holdsMany": "{n} स्टॉक आउट 60+ दिन से लकड़ी रोके हैं",
    "commandCenter.attn.holdsSub": "{cbm} m³ बिक्री से रुका है",
    "commandCenter.tabShort.inventory": "स्टॉक",
    "commandCenter.tabShort.floor": "फ़्लोर",
    "commandCenter.tabShort.consignments": "लोड",
    "commandCenter.confidence": "विश्वास",
    "commandCenter.inventoryConfidence": "इन्वेंटरी विश्वास",
    "commandCenter.of": "में से",
    "commandCenter.reconciledCopy": "स्टॉक यूनिट्स समाधानित हैं",
    "commandCenter.reviewUnreconciled": "असमाधानित की समीक्षा करें",
    "commandCenter.stockOnHand": "उपलब्ध स्टॉक",
    "commandCenter.machinesRunning": "चल रही मशीनें",
    "commandCenter.owedToYou": "आपको प्राप्य",
    "commandCenter.thisWeek": "इस सप्ताह (बाहर / अंदर)",
    "commandCenter.thisWeekTitle": "इस सप्ताह",
    "commandCenter.split.out": "बाहर",
    "commandCenter.split.in": "अंदर",
    "commandCenter.preparing": "तैयार हो रहा है",
    "commandCenter.jobsWithoutMachine": "बिना मशीन के चल रहे",
    "commandCenter.needsAttention": "ध्यान देने योग्य",
    "commandCenter.allClear": "सब ठीक है — अभी कुछ भी ध्यान देने योग्य नहीं है।",
    "commandCenter.stockAtGlance": "एक नज़र में स्टॉक",
    "commandCenter.product": "उत्पाद",
    "commandCenter.site": "साइट",
    "commandCenter.origin": "मूल",
    "commandCenter.quality": "गुणवत्ता",
    "commandCenter.dims": "आयाम",
    "commandCenter.available": "उपलब्ध",
    "commandCenter.round": "राउंड",
    "commandCenter.viewAllGroups": "सभी समूह देखें",
    "commandCenter.sortNewest": "नवीनतम",
    "commandCenter.sortMostStock": "सबसे ज़्यादा स्टॉक",
    "commandCenter.sortAz": "A–Z",
    "commandCenter.added": "जोड़ा गया",
    "commandCenter.showLess": "कम दिखाएँ",
    "commandCenter.rangeOf": "में से",
    "commandCenter.conversionYield": "प्रजाति के अनुसार उपज",
    "commandCenter.avgOutturn": "औसत आउटटर्न",
    "commandCenter.netVolume": "मिल जॉब से शुद्ध मात्रा",
    "commandCenter.reconciliationStatus": "समाधान स्थिति",
    "commandCenter.total": "कुल",
    "commandCenter.reconciled": "समाधानित",
    "commandCenter.pending": "लंबित",
    "commandCenter.locked": "लॉक",
    "commandCenter.siteUtilisation": "साइट उपयोग",
    "commandCenter.floorNow": "अभी फ़्लोर पर",
    "commandCenter.operator": "ऑपरेटर",
    "commandCenter.machine": "मशीन",
    "commandCenter.location": "स्थान",
    "commandCenter.started": "प्रारंभ",
    "commandCenter.status": "स्थिति",
    "commandCenter.noActiveRuns": "अभी कोई चालू मिल जॉब नहीं।",
    "commandCenter.toCollect": "वसूली बाकी",
    "commandCenter.toPay": "भुगतान बाकी",
    "commandCenter.overdueToCollect": "अतिदेय वसूली",
    "commandCenter.overdueToPay": "अतिदेय भुगतान",
    "commandCenter.overdueToCollectByAge": "आयु अनुसार अतिदेय वसूली",
    "commandCenter.invoices": "इनवॉइस",
    "commandCenter.inTotal": "कुल",
    "commandCenter.received": "प्राप्त",
    "commandCenter.paidOut": "भुगतान किया",
    "commandCenter.futureDated": "यह भुगतान तिथि भविष्य की है — कृपया जाँचें",
    "commandCenter.futureDatedShort": "भविष्य की तिथि",
    "commandCenter.last30Days": "(पिछले 30 दिन)",
    "commandCenter.attn.overdueCollectOne": "वसूली का 1 इनवॉइस अतिदेय है",
    "commandCenter.attn.overdueCollectMany": "वसूली के {n} इनवॉइस अतिदेय हैं",
    "commandCenter.attn.atRisk": "{amount} {cur} जोखिम में",
    "commandCenter.attn.overduePayOne": "आपका 1 देय इनवॉइस अतिदेय है",
    "commandCenter.attn.overduePayMany": "आपके {n} देय इनवॉइस अतिदेय हैं",
    "commandCenter.attn.toPaySub": "{amount} {cur} भुगतान बाकी",
    "commandCenter.attn.pendingReconOne": "1 स्टॉक यूनिट का समाधान बाकी है",
    "commandCenter.attn.pendingReconMany": "{n} स्टॉक यूनिट्स का समाधान बाकी है",
    "commandCenter.attn.netDiscrepancy": "{v} CBM शुद्ध अंतर",
    "commandCenter.attn.tallySyncOne": "1 टैली सुधार पर आपका निर्णय चाहिए",
    "commandCenter.attn.tallySyncMany": "{n} टैली सुधारों पर आपका निर्णय चाहिए",
    "commandCenter.attn.tallySyncSub": "स्टॉक अपने-आप नहीं बदला गया — इन्वेंटरी → इन और आउट में देखें",
    "tallySync.title": "आपके निर्णय की प्रतीक्षा में टैली सुधार",
    "tallySync.subtitle": "यह स्टॉक प्राप्त होने के बाद टैली बदली गई। स्टॉक अपने-आप नहीं बदला गया।",
    "tallySync.change": "टैली से स्टॉक में बदलाव",
    "tallySync.reasonNegative": "लॉट शून्य से नीचे चला जाएगा, और आपकी कंपनी उपलब्ध स्टॉक से अधिक बिक्री की अनुमति नहीं देती (एप्लिकेशन सेटिंग्स → इन्वेंटरी नीति)।",
    "tallySync.reasonReconLocked": "मिलान पहले ही लॉक है, इसलिए अब पहुँचे (गंतव्य) आँकड़े स्टॉक तय करते हैं।",
    "tallySync.reasonShipped": "यह स्टॉक यूनिट पहले ही भेजी जा चुकी है।",
    "tallySync.reasonOther": "किसी व्यक्ति को निर्णय लेना होगा।",
    "tallySync.apply": "स्टॉक में लागू करें",
    "tallySync.dismiss": "खारिज करें",
    "tallySync.appliedToast": "स्टॉक अपडेट हुआ",
    "tallySync.dismissedToast": "टैली सुधार खारिज — स्टॉक अपरिवर्तित",
    "tallySync.actionFailed": "पूरा नहीं हो सका",
    "tallySync.noPermission": "आपको स्टॉक बदलने की अनुमति नहीं है।",
    "commandCenter.attn.siteFull": "{name} क्षमता के {pct}% पर है",
    "commandCenter.attn.siteSub": "{cap} में से {cur} CBM",
    "commandCenter.attn.departingOne": "इस सप्ताह 1 कंसाइनमेंट रवाना",
    "commandCenter.attn.departingMany": "इस सप्ताह {n} कंसाइनमेंट रवाना",
    "commandCenter.attn.soonest": "सबसे पहले: {date}",
    "commandCenter.money.atSavedRates": "सहेजी गई विनिमय दरों पर",
    "commandCenter.money.partial": "आंशिक",
    "commandCenter.money.partialTip": "कुछ राशियों की विनिमय दर नहीं है, इसलिए वे इस कुल में शामिल नहीं हैं",
    "commandCenter.money.noRate": "दर नहीं",
    "commandCenter.money.noRateCountOne": "1 कंसाइनमेंट की विनिमय दर नहीं है — कुल में शामिल नहीं",
    "commandCenter.money.noRateCountMany": "{n} कंसाइनमेंट्स की विनिमय दर नहीं है — कुल में शामिल नहीं",
    "commandCenter.money.addRate": "दर जोड़ें",
    "commandCenter.money.unmatchedOne": "1 भुगतान दूसरी मुद्रा में है और उसकी दर नहीं है — गिना नहीं गया",
    "commandCenter.money.unmatchedMany": "{n} भुगतान दूसरी मुद्रा में हैं और उनकी दर नहीं है — गिने नहीं गए",
    "commandCenter.money.net": "शुद्ध स्थिति",
    "commandCenter.money.inFavour": "आपके पक्ष में",
    "commandCenter.money.youOweMore": "आपको अधिक देना है",
    "commandCenter.money.overdueByAge": "आयु अनुसार अतिदेय",
    "commandCenter.money.nothingOverdue": "कुछ भी अतिदेय नहीं",
    "commandCenter.money.overdueOne": "{amount} अतिदेय · 1 इनवॉइस",
    "commandCenter.money.overdueMany": "{amount} अतिदेय · {n} इनवॉइस",
    "commandCenter.money.invoiceOne": "1 इनवॉइस",
    "commandCenter.money.invoiceMany": "{n} इनवॉइस",
    "commandCenter.money.dueToday": "आज देय",
    "commandCenter.money.dueTomorrow": "कल",
    "commandCenter.money.inDays": "{n} दिन में",
    "commandCenter.money.lateOne": "1 दिन देर",
    "commandCenter.money.lateMany": "{n} दिन देर",
    "commandCenter.notAssigned": "असाइन नहीं",
    "commandCenter.notStarted": "शुरू नहीं हुआ",
    "commandCenter.waiting": "प्रतीक्षा में",
    "commandCenter.days": "दिन",
    "commandCenter.openJob": "जॉब खोलें",
    "commandCenter.moneyToday": "आज का पैसा",
    "commandCenter.totalReceivable": "कुल प्राप्य",
    "commandCenter.totalPayable": "कुल देय",
    "commandCenter.overdue": "अतिदेय",
    "commandCenter.overdueCount": "अतिदेय चालान",
    "commandCenter.recentPayments": "हाल के भुगतान",
    "commandCenter.noRecentPayments": "कोई हाल का भुगतान नहीं।",
    "commandCenter.dueSoon": "जल्द देय",
    "commandCenter.noDueSoon": "जल्द कुछ भी देय नहीं।",
    "commandCenter.consignmentRadar": "अगले 7 दिन",
    "commandCenter.recentActivity": "हाल की खेप",
    "commandCenter.tradeMix": "व्यापार मिश्रण",
    "quickSearch.ai.toggle": "AI से पूछें",
    "quickSearch.ai.toggleTooltip": "फॉरेस्ट प्लान — नियमित खोज से अधिक अस्पष्ट वाक्यांश समझता है, हर उपयोग पर AI क्रेडिट खर्च होता है",
    "quickSearch.ai.ask": "AI से पूछें",
    "quickSearch.ai.creditsUsedThisCall": "उपयोग किए गए क्रेडिट",
    "quickSearch.ai.used": "आपके AI क्रेडिट उपयोग हुए",
    "quickSearch.ai.outOfCredits": "इस अवधि के लिए AI क्रेडिट समाप्त। नियमित खोज बिना किसी क्रेडिट लागत के अभी भी काम करती है।",
    "quickSearch.ai.rateLimited": "दैनिक AI उपयोग सीमा पूरी हो गई। कल फिर कोशिश करें, या नियमित खोज का उपयोग करें।",
    "quickSearch.ai.forestOnly": "AI से पूछें फॉरेस्ट प्लान पर उपलब्ध है। नियमित खोज अभी भी काम करती है।",
    "quickSearch.ai.genericError": "AI उसका उत्तर नहीं दे सका — इसके बजाय नियमित खोज आज़माएं।",
    "invProc.machineLabel": "मशीन (वैकल्पिक)",
    "invProc.machinePlaceholder": "मशीन चुनें",
    "operator.name": "नाम",
    "operator.employeeCode": "कर्मचारी कोड",
    "operator.expertise": "विशेषज्ञता",
    "operator.hireDate": "नियुक्ति तिथि",
    "operator.active": "सक्रिय",
    "operator.inactive": "निष्क्रिय",
    "operator.runsCompleted": "पूरे हुए मिल जॉब",
    "operator.avgOutturn": "औसत आउटटर्न",
    "operator.bestOutturn": "सर्वश्रेष्ठ आउटटर्न",
    "operator.searchPlaceholder": "ऑपरेटर खोजें...",
    "operator.allExpertise": "सभी विशेषज्ञता",
    "operator.allStatus": "सभी स्थिति",
    "operator.statTotal": "कुल",
    "operator.operatorSingular": "ऑपरेटर",
    "operator.operatorPlural": "ऑपरेटर",
    "operator.viewPerformance": "प्रदर्शन देखें",
    "operator.performance": "प्रदर्शन",
    "operator.deactivate": "निष्क्रिय करें",
    "operator.noOperatorsFound": "कोई ऑपरेटर नहीं मिला",
    "operator.noOperatorsSub": "फ़िल्टर समायोजित करें या शुरू करने के लिए अपना पहला मिल ऑपरेटर जोड़ें।",
    "operator.editOperator": "ऑपरेटर संपादित करें",
    "operator.reactivate": "पुनः सक्रिय करें",
    "operator.currentlyAssigned": "वर्तमान में सौंपा गया",
    "operator.pending": "लंबित",
    "operator.noTasks": "कोई कार्य नहीं",
    "operator.viewFullHistory": "पूरा इतिहास देखें",
    "operator.fullHistory": "पूरा इतिहास",
    "operator.taskCode": "कार्य",
    "operator.materials": "सामग्री",
    "operator.processingDate": "मिल जॉब तिथि",
    "operator.outturn": "आउटटर्न",
    "common.from": "से",
    "common.to": "तक",
    // -- Lot card detail keys
    "lot.noOpenLots": "अभी कोई स्टॉक लॉट नहीं। प्राप्त करें पर क्लिक करें।",
    "lot.showMore": "और दिखाएं",
    "lot.showLess": "कम दिखाएं",
    "lot.availableCbm": "उपलब्ध",
    "lot.seeDeliveries": "डिलीवरी देखें",
    "lot.seeConsignments": "कंसाइनमेंट देखें",
    "lot.otherDeliveries": "अन्य डिलीवरी",
    "lot.whereFrom": "देखें यह लॉट कहां से आया",
    "lot.madeAtMill": "मिल में बनाया गया",
    "lot.purchasedFrom": "यहाँ से खरीदा गया",
    "lot.category.millOutput": "मिल से बना",
    "lot.category.openingStock": "शुरुआती स्टॉक",
    "lot.category.notLinked": "कोई खरीद रिकॉर्ड नहीं",
    "lot.category.partiallyLinked": "आंशिक रूप से जुड़ा",
    "lot.category.linked": "खरीद से जुड़ा",
    "lot.millActivity.queued": "मिल के लिए तैयार",
    "lot.millActivity.running": "अभी मिल में",
    "lot.millActivity.paused": "रुका हुआ",
    "lot.millActivity.partiallyMilled": "आंशिक रूप से मिल्ड",
    "lot.cancelledAttemptsNote": "इस लॉट के {count} मिल प्रयास रद्द हो चुके हैं।",
    "lot.viewCancelledAttempt": "देखें",
    "lot.filter.all": "सभी",
    "lot.filter.attention": "ध्यान देने योग्य",
    "lot.filter.atMill": "मिल में",
    "lot.filter.fromMill": "मिल से बना",
    "lot.filter.finished": "समाप्त",
    "lot.status.open": "खुला",
    "lot.status.depleted": "समाप्त",
    "lot.status.closed": "बंद",
    "lot.status.empty": "खाली",
    "lot.status.help": "खुला — इस्तेमाल के लिए स्टॉक · खाली — खुला है पर कुछ बचा नहीं · समाप्त — पूरा स्टॉक इस्तेमाल (मिल या बिक्री) · बंद — हाथ से बंद किया, आगे कोई काम नहीं",
    "lot.sort.label": "क्रम",
    "lot.sort.newest": "सबसे नया पहले",
    "lot.sort.oldest": "सबसे पुराना पहले",
    "lot.sort.name": "नाम A-Z",
    "lot.sort.amountDesc": "ज़्यादा स्टॉक पहले",
    "lot.sort.amountAsc": "कम स्टॉक पहले",
    "lot.category.notLinkedHelp": "इस लॉट की डिलीवरी किसी दर्ज खरीद से जुड़ी नहीं है। बिना खरीद ऑर्डर के दर्ज की गई घरेलू डिलीवरी के लिए यह सामान्य है — लेकिन अगर आपको खरीद जुड़ी होने की उम्मीद थी, तो डिलीवरी का कंसाइनमेंट फ़ील्ड जांचें।",
    "lot.category.partiallyLinkedHelp": "इस लॉट की कुछ डिलीवरी खरीद से जुड़ी हैं, लेकिन कम से कम एक नहीं है।",
    "inv.millWarningHeader": "शुरू करने से पहले जांच लें",
    "mpc.title": "शुरू करने से पहले जाँचें",
    "mpc.checking": "जाँच हो रही है…",
    "mpc.notReconciled": "का मिलान अभी नहीं हुआ है।",
    "mpc.diff": "उतराई की गिनती में अंतर है",
    "mpc.noCount": "उतराई की गिनती अभी दर्ज नहीं हुई है।",
    "mpc.alreadyConfirmed": "— बिना मिलान के मिल चलाने की पुष्टि पहले हो चुकी है।",
    "mpc.closedWithoutCount": "उतराई की गिनती के बिना बंद किया गया — जो आया वह कभी जाँचा नहीं गया।",
    "mpc.reconcileNow": "अभी मिलान करें",
    "mpc.afterStart": "मिल का काम शुरू होने के बाद अंतर सिर्फ़ दर्ज हो सकेगा — स्टॉक फिर एडजस्टमेंट से ठीक होगा।",
    "mpc.typeConfirm": "बिना मिलान के शुरू करने के लिए CONFIRM लिखें",
    "mpc.confirmHint": "एक शब्द — आगे-पीछे की जगह चलेगी।",
    "mpc.confirmOk": "पुष्टि हो गई — आगे बढ़ें।",
    "recon.afterMill.title": "इस स्टॉक यूनिट का मिलान मिल से पहले नहीं हुआ।",
    "recon.afterMill.titleSold": "इस स्टॉक यूनिट का मिलान स्टॉक बिकने से पहले नहीं हुआ।",
    "recon.afterMill.cantApply": "ने यह स्टॉक पहले ही इस्तेमाल कर लिया, इसलिए यहाँ मिलान करने से स्टॉक नहीं बदलेगा। सही करने के लिए एडजस्टमेंट से स्टॉक ठीक करें:",
    "recon.afterMill.pooledNote": "सुझाव: पहले के मिल जॉब या बिक्री इस स्टॉक यूनिट की लकड़ी तक पहुँच चुके हैं, इसलिए आपकी गिनती सिर्फ़ दर्ज होती है। अंतर को एडजस्टमेंट से ठीक करें।",
    "inv.smartSearch.label": "आइटम खोजें",
    "legal.agree.prefix": "मैं",
    "legal.agree.terms": "सेवा की शर्तों",
    "legal.agree.and": "और",
    "legal.agree.privacy": "गोपनीयता नीति से सहमत हूँ",
    "legal.agree.required": "आगे बढ़ने के लिए “सहमत हूँ” पर टिक करें।",
    "inv.smartSearch.openStatement": "पूरा स्टेटमेंट खोलें:",
    "recon.afterMill.noCount": "उतराई की गिनती दर्ज नहीं हुई — जो अंतर मिला वह एडजस्टमेंट में लिखें।",
    "recon.afterMill.step1": "जो आया उसे दर्ज करें: नीचे उतराई की गिनती डालें और हमेशा की तरह लॉक करें। इससे सप्लायर रिकॉर्ड और रिपोर्ट सही रहते हैं।",
    "recon.afterMill.step2": "स्टॉक ठीक करें: लॉक के बाद “एडजस्टमेंट से ठीक करें” दबाएँ — यह पहले से भरा हुआ खुलेगा।",
    "recon.afterMill.recorded": "अंतर दर्ज हुआ:",
    "recon.afterMill.correctBtn": "एडजस्टमेंट से ठीक करें",
    "recon.afterMill.askAdjust": "स्टॉक ठीक करने के लिए एडजस्टमेंट अधिकार वाले व्यक्ति से कहें।",
    "recon.afterMill.lockRecordsOnly": "यह लॉक सिर्फ़ दर्ज करता है; बाद में स्टॉक एडजस्टमेंट से ठीक करें।",
    "adj.negative.title": "इससे लॉट शून्य से नीचे चला जाएगा",
    "adj.negative.typeConfirm": "फिर भी दर्ज करने के लिए CONFIRM लिखें",
    "inv.millWarningNotLinked": "लॉट {lotCode} से कोई खरीद रिकॉर्ड जुड़ा नहीं है। आप फिर भी मिल जॉब शुरू कर सकते हैं — अगर जानकारी है तो पहले इसे खरीद से जोड़ लें।",
    "inv.millWarningPartial": "लॉट {lotCode} की कुछ डिलीवरी खरीद रिकॉर्ड से जुड़ी नहीं हैं। आप फिर भी मिल जॉब शुरू कर सकते हैं।",
    "inv.millWarningContinue": "फिर भी जारी रखें",
    "inventory.receiveNotLinkedWarning": "यह डिलीवरी अभी किसी खरीद रिकॉर्ड (कंसाइनमेंट) से जुड़ी नहीं है।",
    "lot.unitNumber": "कंटेनर/ट्रक/ट्रेन नंबर",
    "origin.cameFrom": "कहाँ से आया",
    "origin.stockUnitsWord": "स्टॉक यूनिट",
    "origin.blsWord": "BL",
    "origin.order": "ऑर्डर",
    "origin.via": "के ज़रिए",
    "origin.noStockUnit": "कोई स्टॉक यूनिट नहीं — शुरुआती स्टॉक",
    "origin.returned": "वापस आया माल — कोई स्टॉक यूनिट नहीं",
    "lot.loading": "लोड हो रहा है...",
    "lot.searchPlaceholder": "आईडी से खोजें",
    "lot.searchIncludeClosed": "समाप्त लॉट भी खोजें",
    "lot.searchResultSingular": "लॉट मिला",
    "lot.searchResultPlural": "लॉट मिले",
    "lot.receivedCbm": "प्राप्त",
    "lot.purchasedCbm": "अनुबंधित",
    "lot.daysOld": "दिन पुराना",
    "lot.procurementOutturn": "खरीद आउटटर्न",
    "lot.openingBalance": "प्रारंभिक शेष",
    "lot.openingBalanceNote": "पुराना स्टॉक — कोई खरीद रिकॉर्ड नहीं",
    // -- Receive wizard
    "receive.wizard.title": "स्टॉक आया",
    "receive.wizard.editTitle": "स्टॉक लॉट संपादित करें",
    "receive.step1.title": "क्या आया और कहाँ से?",
    "receive.step2.title": "कितना आया?",
    "receive.step3.title": "आपने कितना प्राप्त किया?",
    "receive.step4.title": "रसीद की पुष्टि करें",
    "receive.selectSite": "भंडारण स्थल चुनें",
    "receive.selectSupplier": "आपूर्तिकर्ता चुनें",
    "receive.quantity": "प्राप्त CBM",
    "receive.pieces": "टुकड़ों की संख्या",
    "receive.purchaseDate": "खरीद तिथि",
    "receive.confirmed": "स्टॉक इन दर्ज करें",
    "receive.moreDetails": "खरीद विवरण जोड़ें (वैकल्पिक)",
    "receive.isOpeningBalance": "यह पुराना स्टॉक है (प्रारंभिक शेष)",
    // -- Dispatch wizard
    "dispatch.wizard.title": "स्टॉक बाहर भेजें",
    "dispatch.step1.title": "कौन सा स्टॉक जा रहा है?",
    "dispatch.step2.title": "कहाँ जा रहा है?",
    "dispatch.step3.title": "डिस्पैच विवरण",
    "dispatch.step4.title": "डिस्पैच की पुष्टि करें",
    "dispatch.counterparty": "ग्राहक / गंतव्य",
    "dispatch.reference": "चालान / संदर्भ संख्या",
    "dispatch.confirmed": "भेजने की पुष्टि करें",
    "dispatch.destination": "किसके पास जा रहा है (खरीदार / गंतव्य)",
    "dispatch.linkTrade": "ट्रेड रिकॉर्ड / कंसाइनमेंट से लिंक करें (वैकल्पिक)",
    "dispatch.invoiceRef": "चालान / ऑर्डर संदर्भ (वैकल्पिक)",
    "dispatch.actingAs": "भेज रहे हैं",
    "dispatch.actingNow": "अभी",
    "dispatch.shipment": "कंसाइनमेंट से लिंक करें",
    "dispatch.shipment.placeholder": "कंसाइनमेंट चुनें (वैकल्पिक)",
    "dispatch.stepSplit.title": "स्टॉक विभाजन की पुष्टि करें",
    "dispatch.stepSplit.hint": "सबसे पुराना स्टॉक पहले — आप नीचे विभाजन समायोजित कर सकते हैं।",
    "dispatch.filters.toggle": "फ़िल्टर (वैकल्पिक)",
    "dispatch.filters.product": "उत्पाद",
    "dispatch.filters.widthIn": "चौड़ाई (इंच)",
    "dispatch.filters.thicknessIn": "मोटाई (इंच)",
    "dispatch.filters.origin": "मूल स्थान",
    "dispatch.filters.quality": "गुणवत्ता",
    "dispatch.roundLogs": "गोल लट्ठे",
    "dispatch.unsorted": "अवर्गीकृत",
    "dispatch.qtyPlaceholder": "मात्रा",
    "dispatch.noStock": "कोई मिलान स्टॉक नहीं मिला।",
    "dispatch.itemsAdded": "जोड़ी गई वस्तुएं",
    "dispatch.shortfall": "कमी",
    "dispatch.shortfallSuffix": "— अधिक लॉट जोड़ें या मात्रा घटाएं",
    "receive.origin": "मूल (देश)",
    "receive.originPlaceholder": "जैसे घाना, ब्राज़ील",
    "receive.quality": "गुणवत्ता / ग्रेड",
    "receive.salePrice": "बिक्री मूल्य",
    "receive.size": "आकार (चौड़ाई × मोटाई × लंबाई)",
    "receive.lengthOpenEnded": "कोई अधिकतम नहीं",
    "receive.lengthOpenEndedHint": "खुले अंत के लिए दूसरी लंबाई खाली छोड़ें (जैसे \"7ft+\")।",
    "tally.qualityForTu": "गुणवत्ता — इस स्टॉक यूनिट के सभी लट्ठे",
    "tally.qualityPerRow": "प्रति-पंक्ति (अलग से सेट करें)",
    "tally.qualityForTuHint": "ग्रिड में प्रति-पंक्ति गुणवत्ता सेट करने के लिए खाली छोड़ें।",
    "tally.qualityForTuHintRound": "इस स्टॉक यूनिट के सभी लट्ठों पर लागू होता है।",
    "tally.qualityNone": "कोई गुणवत्ता सेट नहीं",
    "tally.qualityNoneShort": "कोई नहीं",
    "tally.qualityEnableLabel": "इस स्टॉक यूनिट के लिए गुणवत्ता सक्षम करें",
    "tally.qualityDisabledHint": "इस स्टॉक यूनिट के लिए गुणवत्ता ट्रैकिंग बंद है। मौजूदा गुणवत्ता डेटा सुरक्षित रहेगा और इसे फिर से चालू करने पर वापस दिखाई देगा।",
    "tally.qualityDisableConfirmTitle": "गुणवत्ता अक्षम करें?",
    "tally.qualityDisableConfirmBodyPrefix": "यह इस स्टॉक यूनिट में",
    "tally.qualityDisableConfirmBodySuffix": "पंक्ति(यों) से गुणवत्ता ग्रेड को स्थायी रूप से हटा देगा। इसे पूर्ववत नहीं किया जा सकता।",
    "tally.qualityDisableConfirmInputLabel": "जारी रखने के लिए CONFIRM टाइप करें",
    "tally.qualityDisableConfirmButton": "गुणवत्ता अक्षम करें और हटाएं",
    "tally.qualityDisableCancelButton": "रद्द करें",
    "tally.qualityDisabledToastTitle": "गुणवत्ता अक्षम की गई",
    "tally.qualityDisabledToastDetail": "इस स्टॉक यूनिट के लिए गुणवत्ता ट्रैकिंग बंद कर दी गई है और डेटा हटा दिया गया है।",
    "tally.qualityDisableFailed": "गुणवत्ता अक्षम करने में विफल। कृपया पुनः प्रयास करें।",
    "tally.saveNow": "अभी सेव करें",
    "tally.settingsSaving": "सेव हो रहा है…",
    "tally.settingsSaved": "सेव हो गया",
    "tally.settingsSaveFailedRetry": "सेव विफल — पुनः प्रयास के लिए टैप करें",
    "tally.settingsAutoSaveFailed": "आपकी सेटिंग्स सेव नहीं हो सकीं। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।",
    "quality.renameGrades": "ग्रेड नाम बदलें",
    "quality.renameGradesTitle": "गुणवत्ता ग्रेड लेबल",
    "quality.renameGradesHint": "ये नाम हर जगह दिखाई देंगे जहाँ गुणवत्ता दिखाई जाती है — पुरानी प्रविष्टियाँ स्वतः अपडेट हो जाती हैं।",
    "chain.viewChain": "लॉट चेन देखें",
    "trace.fullTrace": "पूरी ट्रेस",
    "statement.title": "स्टॉक स्टेटमेंट",
    "statement.subtitle": "क्या आया, मिल में गया, बिका और कितना स्टॉक बचा — उसका प्रमाण",
    "statement.openStatement": "स्टॉक स्टेटमेंट",
    "statement.unit": "वॉल्यूम इकाई",
    "statement.exportPdf": "PDF",
    "statement.exportExcel": "Excel",
    "statement.searchPlaceholder": "स्टॉक यूनिट, कंटेनर / ट्रक नंबर, लॉट, मिल जॉब या BL नंबर",
    "statement.suggest.recent": "हाल ही में",
    "statement.suggest.stockUnits": "स्टॉक यूनिट",
    "statement.suggest.batches": "लॉट",
    "statement.suggest.millJobs": "मिल जॉब",
    "statement.suggest.consignments": "कंसाइनमेंट (BL)",
    "statement.suggest.none": "कुछ नहीं मिला - स्टॉक यूनिट, कंटेनर / ट्रक नंबर, लॉट, मिल जॉब या BL नंबर लिखें",
    "statement.show": "स्टेटमेंट दिखाएँ",
    "statement.emptyTitle": "किसी भी स्टॉक का प्रमाण एक जगह",
    "statement.emptyText": "स्टॉक यूनिट, कंटेनर, लॉट, मिल जॉब या BL नंबर लिखें। बैलेंस शीट, मिल वेस्टेज, हर एंट्री और लॉट रिकॉर्ड से मिलान दिखेगा।",
    "statement.notFound": "इस कोड के लिए कुछ नहीं मिला",
    "statement.notFoundHint": "स्पेलिंग जाँचें, या स्टॉक यूनिट ID, कंटेनर नंबर, LOT-…, PR-… या BL नंबर डालें।",
    "statement.generated": "बनाया गया",
    "statement.balanced": "मिलान सही",
    "statement.balancedSub": "हर लॉट अपने रिकॉर्ड से मिलता है और आवक = जावक",
    "statement.difference": "अंतर मिला",
    "statement.differenceSub": "एक लॉट अपने रिकॉर्ड से नहीं मिलता — लाल निशान वाला लॉट देखें",
    "statement.balanceSheet": "बैलेंस शीट",
    "statement.inSide": "आवक",
    "statement.outSide": "जावक और बचा हुआ",
    "statement.totalIn": "कुल आवक",
    "statement.totalOut": "कुल जावक और बचा",
    "statement.opening": "शुरुआती स्टॉक",
    "statement.received": "प्राप्त",
    "statement.producedOutside": "दूसरे लॉट से बना",
    "statement.adjustedNet": "समायोजन (शुद्ध)",
    "statement.allowanceNet": "छूट (गोलाई और लंबाई)",
    "statement.story": "क्या हुआ, एक-एक कदम",
    "statement.storySub": "तारीख के क्रम में, आसान शब्दों में",
    "statement.step.startingStock": "शुरुआती स्टॉक",
    "statement.step.cameIn": "आया",
    "statement.step.allowance": "छूट घटाई गई (छाल और छंटाई)",
    "statement.step.sentToMill": "मिल भेजा",
    "statement.step.millMade": "मिल ने बनाया",
    "statement.step.sold": "बिका और बाहर गया",
    "statement.step.correction": "सुधार",
    "statement.step.heldForSale": "बिक्री के लिए रोका — अभी बाहर नहीं गया",
    "statement.step.heldForJob": "मिल काम के लिए रोका — अभी शुरू नहीं हुआ",
    "statement.step.stillInStock": "अभी स्टॉक में",
    "statement.storyMillSentence": "मिल ने {in} लिया और {out} बनाया। {loss} बुरादा और कटन था ({pct}%)।",
    "statement.storyNothingSold": "अभी कुछ नहीं बिका है।",
    "statement.storyHeldSentence": "{code} के लिए {pieces} पीस बुक हैं और वह बिक्री पक्की होने पर स्टॉक से निकलेंगे।",
    "statement.storySoldSentence": "{cbm} ग्राहकों को भेजा गया है।",
    "statement.allowance": "छूट",
    "statement.allowanceHint": "मापे गए लट्ठों से छाल और छंटाई घटाई गई — सकल माप में से शुद्ध माप।",
    "statement.kind.ALLOWANCE": "छूट",
    "statement.sold": "बेचा / भेजा",
    "statement.sentToMillOutside": "मिल में भेजा (आउटपुट इस स्टेटमेंट में नहीं)",
    "statement.sentToMillShort": "मिल में भेजा",
    "statement.wastage": "मिल वेस्टेज",
    "statement.closing": "स्टॉक में बचा",
    "statement.held": "रोका गया",
    "statement.free": "उपलब्ध",
    "statement.heldPartOf": "कुल",
    "statement.heldRestOther": "बाकी दूसरे लॉट पर",
    "stockInHand.title": "हाथ में स्टॉक",
    "stockInHand.subtitle": "अभी सच में कितना स्टॉक है — होल्ड और उपलब्ध, प्रोडक्ट और साइज़ के हिसाब से",
    "stockInHand.inStock": "स्टॉक में",
    "stockInHand.held": "होल्ड",
    "stockInHand.free": "उपलब्ध",
    "stockInHand.overHeld": "अतिरिक्त होल्ड",
    "stockInHand.overHeldHint": "कुछ स्टॉक आउट या मिल जॉब अपने बैच में मौजूद लकड़ी से ज़्यादा रोके हुए हैं। पुराने ड्राफ़्ट खोलकर उन्हें छोड़ें या पूरा करें।",
    "stockInHand.negativeStock": "नकारात्मक स्टॉक",
    "stockInHand.negativeStockHint": "किसी गिनती या बिक्री ने बैच में मौजूद से ज़्यादा ले लिया, इसलिए उसका बैलेंस शून्य से नीचे है। बैच खोलकर एडजस्टमेंट से ठीक करें (जो कम है वह जोड़ें)।",
    "stockInHand.explain": "स्टॉक में = होल्ड + उपलब्ध। होल्ड खुले स्टॉक आउट और मिल जॉब के लिए रखा है; उपलब्ध अभी बेचा या मिल में भेजा जा सकता है। नेट वॉल्यूम।",
    "stockInHand.searchPlaceholder": "प्रोडक्ट, साइज़ (4x3x6), मूल देश, साइट या लॉट खोजें",
    "stockInHand.rows": "पंक्तियाँ",
    "stockInHand.groupBy": "उत्पाद के अनुसार समूह",
    "stockInHand.expandAll": "सभी खोलें",
    "stockInHand.collapseAll": "सभी समेटें",
    "stockInHand.sizeOne": "साइज़",
    "stockInHand.sizeMany": "साइज़",
    "stockInHand.sortBy": "क्रम",
    "stockInHand.sortDefault": "डिफ़ॉल्ट क्रम",
    "stockInHand.sortFree": "उपलब्ध: ज़्यादा से कम",
    "stockInHand.sortIn": "स्टॉक में: ज़्यादा से कम",
    "stockInHand.sortSize": "साइज़",
    "stockInHand.sortProduct": "प्रोडक्ट A–Z",
    "stockInHand.searchShort": "प्रोडक्ट या साइज़ खोजें",
    "stockInHand.howCounted": "यह कैसे गिना जाता है?",
    "stockInHand.hideHow": "छिपाएँ",
    "stockInHand.splitTitle": "होल्ड बनाम उपलब्ध",
    "stockInHand.product": "प्रोडक्ट",
    "stockInHand.size": "साइज़",
    "stockInHand.site": "साइट",
    "stockInHand.lot": "लॉट",
    "stockInHand.lots": "लॉट",
    "stockInHand.round": "गोल लकड़ी",
    "stockInHand.tipIn": "जो भी लकड़ी वास्तव में मौजूद है, चाहे किसी काम के लिए रखी हो या नहीं।",
    "stockInHand.tipHeld": "खुले स्टॉक आउट और मिल जॉब के लिए रखा गया हिस्सा। यह अब भी आपका है और बेचा या मिल में भेजा जा सकता है।",
    "stockInHand.tipFree": "स्टॉक में घटा होल्ड: अभी नई बिक्री या मिल जॉब के लिए उपलब्ध।",
    "stockInHand.roundPcs": "गोल",
    "stockInHand.squarePcs": "चौकोर",
    "stockInHand.logsUnit": "लट्ठे",
    "stockInHand.openStatement": "स्टॉक स्टेटमेंट",
    "stockInHand.holdsTitle": "खुले स्टॉक-आउट द्वारा रोका गया",
    "stockInHand.holdsHint": "उन स्टॉक-आउट के लिए रोकी गई लकड़ी जिनकी पुष्टि नहीं हुई है। भूले हुए को छोड़कर लकड़ी खाली करें।",
    "stockInHand.holdsShowAll": "सभी दिखाएं",
    "stockInHand.holdsShowFewer": "कम दिखाएं",
    "stockInHand.idleToday": "आज सक्रिय",
    "stockInHand.idleDays": "{n} दिन से निष्क्रिय",
    "stockInHand.release": "छोड़ें",
    "stockInHand.releaseSure": "इसकी होल्ड छोड़ें?",
    "stockInHand.releaseYes": "हाँ, छोड़ें",
    "stockInHand.released": "होल्ड छोड़ दिए गए — कोई उस स्टॉक-आउट को खोले या सेव करे तो फिर रुक जाएगा।",
    "stockInHand.releaseFailed": "होल्ड नहीं छोड़ पाए — फिर कोशिश करें।",
    "stockInHand.openUnit": "यह स्टॉक-आउट खोलें",
    "stockInHand.empty": "अभी हाथ में कोई स्टॉक नहीं",
    "stockInHand.noMatch": "इस खोज से कुछ नहीं मिला",
    "stockInHand.failed": "स्टॉक लोड नहीं हुआ",
    "stockInHand.footnote": "पंक्तियों में वही साइज़ हैं जिनमें उपलब्ध स्टॉक है। पंक्ति का होल्ड = उसी साइज़ के खुले स्टॉक आउट; मिल जॉब का होल्ड पहले ही उपलब्ध से घटा है और ऊपर के कुल होल्ड में गिना गया है।",
    "statement.whereItWent": "स्टॉक कहाँ गया",
    "statement.millJobs": "मिल जॉब",
    "statement.outturn": "आउटटर्न",
    "statement.input": "इनपुट",
    "statement.output": "आउटपुट",
    "statement.jobPartial": "इस जॉब का एक ही हिस्सा इस स्टेटमेंट में है, इसलिए वेस्टेज यहाँ नहीं गिना गया।",
    "statement.batches": "लॉट",
    "statement.producedBy": "इससे बना",
    "statement.fromBatch": "लॉट से",
    "statement.matchesRecord": "रिकॉर्ड से मेल",
    "statement.differenceShort": "अंतर",
    "statement.negativeStock": "नकारात्मक स्टॉक",
    "statement.negativeStockTooltip": "इस लॉट का स्टॉक शून्य से कम दिख रहा है — शायद सुधार (मिलान या समायोजन) करते समय पहले से मिल भेजे या बेचे गए स्टॉक का ध्यान नहीं रखा गया। कृपया जांच लें।",
    "statement.produced": "बना",
    "statement.milled": "मिल में",
    "statement.adjusted": "समायोजित",
    "statement.pcs": "पीस",
    "statement.batchRecord": "लॉट रिकॉर्ड",
    "statement.differenceBy": "अंतर",
    "statement.notInStockTitle": "अभी स्टॉक में नहीं",
    "statement.notInStockLeft": "यह कन्फर्म किए गए Stock Out से स्टॉक से निकला:",
    "statement.notInStockNone": "अभी किसी लॉट में यह नहीं है, और इसका कोई कन्फर्म Stock Out नहीं मिला।",
    "statement.diffPanelTitle": "कहाँ, कितना और क्यों",
    "statement.diffPanelWhyBtn": "क्यों? क्या करें?",
    "statement.diffPanelHide": "छुपाएँ",
    "statement.diffPanelRecord": "लॉट रिकॉर्ड",
    "statement.diffPanelMoves": "मूवमेंट का जोड़",
    "statement.diffPanelWhyLabel": "क्यों:",
    "statement.diffPanelWhy": "लॉट की सहेजी संख्या और उसके मूवमेंट का जोड़ अलग-अलग बदले गए — जैसे सामान्य स्क्रीन के बाहर किया गया बदलाव, या दर्ज न हुआ मूवमेंट।",
    "statement.diffPanelDoLabel": "क्या करें:",
    "statement.diffPanelDo": "लॉट खोलकर उसके मूवमेंट जाँचें। Add Adjustment से सुधारें ताकि रिकॉर्ड और इतिहास फिर मिल जाएँ। संख्या सीधे न बदलें।",
    "statement.heldForSale": "बिक्री के लिए रोका",
    "statement.heldForJob": "मिल जॉब के लिए रोका",
    "statement.showEntries": "एंट्री दिखाएँ",
    "statement.hideEntries": "एंट्री छिपाएँ",
    "statement.when": "तारीख और समय",
    "statement.entry": "एंट्री",
    "statement.reference": "संदर्भ",
    "statement.partner": "पार्टनर",
    "statement.noEntries": "कोई एंट्री नहीं।",
    "statement.timeline": "समयरेखा",
    "statement.proof": "इन्वेंटरी लेजर एंट्री से बना:",
    "statement.netVolume": "वॉल्यूम शुद्ध (नेट) है",
    "statement.piecesIndicative": "कुछ एंट्री में पीस नहीं हैं, इसलिए पीस कुल अनुमानित है",
    "statement.type.STOCK_UNIT": "स्टॉक यूनिट",
    "statement.type.BATCH": "लॉट",
    "statement.type.MILL_JOB": "मिल जॉब",
    "statement.type.CONSIGNMENT": "कंसाइनमेंट",
    "statement.kind.OPENING": "शुरुआती स्टॉक",
    "statement.kind.RECEIVED": "प्राप्त",
    "statement.kind.PRODUCED": "मिल से बना",
    "statement.kind.MILLED": "मिल में भेजा",
    "statement.kind.SOLD": "बेचा / भेजा",
    "statement.kind.ADJUSTED": "समायोजित",
    "statement.kind.RECONCILED": "मिलान सुधार",
    "statement.kind.ASSIGNED": "कंसाइनमेंट में जोड़ा",
    "statement.kind.OTHER": "अन्य",
    "statement.modeItem": "एक आइटम",
    "statement.modeFilter": "स्टॉक फ़िल्टर",
    "statement.filterProduct": "प्रोडक्ट",
    "statement.filterOrigin": "मूल देश",
    "statement.filterSite": "साइट",
    "statement.filterQuality": "क्वालिटी",
    "statement.filterSize": "साइज़ (कोई भी इकाई)",
    "statement.sizePlaceholder": "3x2x8 ft · 76 x 50 mm · girth 90cm x 8m",
    "statement.sizeInvalid": "साइज़ समझ नहीं आया — 3x2x8 ft, 76 x 50 mm या girth 90cm लिखें",
    "statement.filterFrom": "से",
    "statement.filterTo": "तक",
    "statement.filterHint": "किसी भी के लिए खाली छोड़ें। तारीख नहीं = शुरू से अब तक।",
    "statement.any": "कोई भी",
    "statement.clear": "साफ़ करें",
    "statement.emptyFilterText": "कोई भी फ़िल्टर चुनें और स्टेटमेंट दिखाएँ दबाएँ — या सभी स्टॉक के लिए बिना फ़िल्टर दबाएँ।",
    "statement.noResults": "इन फ़िल्टर से कोई स्टॉक नहीं मिला",
    "statement.noResultsHint": "कोई फ़िल्टर हटाएँ या तारीखें बढ़ाएँ।",
    "statement.type.FILTER": "फ़िल्टर किया स्टॉक",
    "statement.periodStatement": "अवधि स्टेटमेंट",
    "statement.periodStatementSub": "अंत की तारीख तक के आंकड़े; आवक = जावक",
    "statement.groups": "स्टॉक समूह",
    "statement.group": "प्रोडक्ट · मूल · साइट",
    "statement.batchesLower": "लॉट",
    "statement.inShort": "आवक",
    "statement.sizeNow": "यह साइज़ अभी",
    "statement.total": "कुल",
    "statement.inventoryReportLink": "स्टॉक स्टेटमेंट",
    "trace.seeWhereFrom": "यह कहाँ से आया देखें",
    "trace.rel.includesStockUnit": "इसमें स्टॉक यूनिट शामिल",
    "trace.rel.linkedToConsignment": "कंसाइनमेंट से जुड़ा",
    "trace.rel.receivedInto": "इसमें प्राप्त हुआ",
    "trace.rel.dispatchedFrom": "यहाँ से भेजा गया",
    "trace.rel.fedAsInput": "इनपुट के रूप में दिया गया",
    "trace.rel.drewStockFrom": "से स्टॉक लिया",
    "trace.rel.receivedIntoLot": "इस लॉट में प्राप्त हुआ",
    "trace.rel.producedByJob": "मिल जॉब से बना",
    "trace.rel.milledInto": "में मिल किया गया",
    "trace.rel.soldVia": "बेचा गया (कंसाइनमेंट)",
    "trace.rel.sentOutUnlinked": "भेजा गया (बिना लिंक)",
    "trace.rel.fedFromLot": "लॉट से आया",
    "trace.rel.fedFromUnit": "स्टॉक यूनिट से आया",
    "trace.rel.mainOutput": "मुख्य उत्पादन",
    "trace.rel.byproduct": "उप-उत्पाद",
    "trace.date.created": "बनाया गया",
    "trace.date.shipped": "भेजा गया",
    "trace.date.purchased": "खरीदा गया",
    "trace.date.produced": "बना",
    "trace.date.completed": "पूरा हुआ",
    "trace.date.started": "शुरू हुआ",
    "trace.date.scheduled": "निर्धारित",
    "trace.date.openingStock": "प्रारंभिक स्टॉक",
    "trace.story.showMore": "और दिखाएँ",
    "trace.story.sharesNote": "यह हिस्सा गणना है (सबसे पुराना स्टॉक पहले), दर्ज तथ्य नहीं।",
    "trace.share.adjustment": "समायोजन से जुड़ी लकड़ी",
    "trace.share.hand": "हाथ से जोड़ा गया लॉट",
    "trace.label.printAll": "सभी स्टॉक यूनिट के लेबल प्रिंट करें",
    "trace.label.popup": "लेबल प्रिंट करने के लिए पॉप-अप की अनुमति दें।",
    "trace.unlinked.one": "अभी किसी बिक्री से जुड़ा नहीं",
    "trace.unlinked.many": "{n} डिस्पैच अभी किसी बिक्री से जुड़े नहीं",
    "trace.search.placeholder": "कंटेनर, BL, स्टॉक यूनिट, लॉट या मिल जॉब खोजें…",
    "trace.search.none": "कुछ नहीं मिला",
    "trace.search.hintTitle": "कोई भी नंबर ट्रेस करें",
    "trace.search.hintSub": "ऊपर कंटेनर नंबर, BL, स्टॉक यूनिट, लॉट या मिल जॉब लिखें और उसकी पूरी कहानी देखें।",
    "trace.view.story": "कहानी",
    "trace.view.graph": "ग्राफ़",
    "trace.story.cameFrom": "यह कहाँ से आया",
    "trace.story.wentTo": "यह कहाँ गया",
    "trace.story.nothingBefore": "इससे पहले कुछ नहीं। कहानी यहीं से शुरू होती है।",
    "trace.story.nothingAfter": "इसके बाद अभी कुछ नहीं।",
    "trace.story.truncated": "बहुत लंबी कड़ी: सिर्फ़ नज़दीकी चरण दिख रहे हैं। आगे जाने के लिए कोई चरण खोलें।",
    "trace.story.madeFrom": "इससे बना",
    "trace.story.couldNot": "कहानी लोड नहीं हो सकी। कृपया फिर कोशिश करें।",
    "trace.kind.stockUnit": "स्टॉक यूनिट",
    "trace.kind.lot": "लॉट",
    "trace.kind.millJob": "मिल जॉब",
    "trace.kind.consignment": "कंसाइनमेंट",
    "trace.kind.sentOut": "भेजा गया",
    "trace.label.print": "लेबल प्रिंट करें",
    "trace.label.title": "स्टॉक यूनिट लेबल",
    "trace.label.printBtn": "प्रिंट",
    "trace.label.scan": "इस लकड़ी की पूरी कहानी देखने के लिए स्कैन करें",
    "trace.label.scanSub": "यह कहाँ से आई, मिल ने इससे क्या बनाया, और कहाँ गई।",
    "trace.couldNotLoad": "यह ट्रेस लोड नहीं हो सका",
    "trace.pickAncestorTitle": "कौन सा?",
    "trace.pickAncestorHint": "यह एक से ज़्यादा खरीद से आया है — देखने के लिए एक चुनें।",
    "trace.history": "इतिहास",
    "trace.noHistory": "अभी तक कोई इतिहास दर्ज नहीं हुआ",
    "trace.consignment": "खेप",
    "trace.viewConsignment": "खेप देखें",
    "trace.viewDispatches": "डिस्पैच देखें",
    "trace.quickView": "जल्दी देखें",
    "trace.loadingTrace": "लोड हो रहा है...",
    "trace.zoomIn": "ज़ूम इन",
    "trace.zoomOut": "ज़ूम आउट",
    "trace.zoomReset": "ज़ूम रीसेट करें",
    "trace.viewLot": "लॉट देखें",
    "trace.viewRun": "मिल जॉब देखें",
    "lot.lotCode": "लॉट कोड",
    "lot.quality": "गुणवत्ता",
    "lot.received": "प्राप्त",
    "lot.currentStock": "मौजूदा स्टॉक",
    "lot.supplier": "आपूर्तिकर्ता",
    "lot.purchasePrice": "खरीद मूल्य",
    "lot.purchaseDate": "खरीद तिथि",
    "processing.millSite": "मिल साइट",
    "processing.machine": "मशीन",
    "processing.operator": "ऑपरेटर",
    "processing.input": "इनपुट",
    "processing.output": "आउटपुट",
    "processing.outturn": "आउटटर्न",
    "chain.sourceLot": "स्रोत लॉट",
    "chain.rootLot": "मूल स्रोत",
    "chain.earlierLot": "पहले का लॉट",
    "chain.thisLot": "यह लॉट",
    "chain.outputLot": "आउटपुट लॉट",
    "chain.recovery": "रिकवरी",
    "chain.received": "प्राप्त",
    "chain.remaining": "उपलब्ध",
    "chain.dispatches": "डिस्पैच किया",
    "chain.directDispatch": "सीधा डिस्पैच",
    "chain.noChain": "इस लॉट के लिए अभी कोई ऊपरी या निचला लिंक नहीं है।",
    "chain.finished": "पूर्ण हुआ",
    "inventory.viewTask": "कार्य देखें",
    "inventory.created": "बनाया गया",
    "inventory.lastUpdated": "आखिरी अपडेट",
    "inventory.by": "द्वारा",
    "inventory.viewOrder": "ऑर्डर देखें",
    "inventory.viewInTallysheet": "टैली शीट में देखें",
    // -- Manage users
    "user.invite": "उपयोगकर्ता आमंत्रित करें",
    "user.sendInvite": "आमंत्रण भेजें",
    "user.teamMembers": "टीम सदस्य",
    "user.accessRights": "एक्सेस अधिकार",
    "user.deactivateTooltip": "निष्क्रिय — लॉगिन बंद, डेटा सुरक्षित",
    "user.reactivateTooltip": "सक्रिय — लॉगिन पुनः स्थापित करें",
    "user.resendInvitation": "आमंत्रण पुनः भेजें",
    "user.expired": "समाप्त",
    "user.declined": "अस्वीकृत",
    "user.declinedTooltip": "आमंत्रित व्यक्ति ने इन-ऐप आमंत्रण अस्वीकार किया — यदि वे अपना मन बदलते हैं तो ईमेल लिंक अभी भी मान्य है",
    "user.membershipBasedTooltip": "मल्टी-कंपनी एक्सेस के माध्यम से सदस्य — उनका अपना खाता कहीं और है। आप इस कंपनी में उनकी सदस्यता हटा सकते हैं, लेकिन उनका खाता उनकी ओर से प्रबंधित होता है।",
    "user.removeFromCompany": "कंपनी से हटाएं",
    "user.confirmRemoveMemberTitle": "सदस्य हटाएं",
    "user.confirmRemoveMemberMessage": "{{email}} इस कंपनी तक पहुंच खो देंगे। उनका अपना खाता और वे जिन अन्य कंपनियों से जुड़े हैं, वे प्रभावित नहीं होंगे।",
    "user.memberRemovedTitle": "सदस्य हटाया गया",
    "user.memberRemovedMessage": "{{email}} के पास अब इस कंपनी तक पहुंच नहीं है।",
    "user.memberRemoveFailedMessage": "सदस्य को हटाने में विफल।",
    "user.removeAdminBtn": "एडमिन हटाएं",
    "user.confirmMakeAdminTitle": "एडमिन बनाएं",
    "user.confirmMakeAdminMessage": "{{email}} को इस कंपनी का पूरा एडमिन एक्सेस मिलेगा, जिसमें यूज़र मैनेज करना भी शामिल है। आप इसे बाद में हटा सकते हैं।",
    "user.madeAdminTitle": "एडमिन जोड़ा गया",
    "user.madeAdminMessage": "{{email}} अब एडमिन है।",
    "user.makeAdminFailedMessage": "इस यूज़र को एडमिन नहीं बनाया जा सका।",
    "user.confirmRemoveAdminTitle": "एडमिन हटाएं",
    "user.confirmRemoveAdminMessage": "{{email}} कंपनी में सामान्य सदस्य के रूप में रहेगा, लेकिन एडमिन एक्सेस खो देगा।",
    "user.removedAdminTitle": "एडमिन हटाया गया",
    "user.removedAdminMessage": "{{email}} अब सामान्य सदस्य है।",
    "user.removeAdminFailedMessage": "एडमिन अधिकार नहीं हटाए जा सके।",
    "user.emailAddresses": "ईमेल पते",
    "user.roleTemplate": "भूमिका टेम्पलेट",
    "user.roleTemplatePlaceholder": "भूमिका टेम्पलेट चुनें",
    "user.inviteDialogHeader": "उपयोगकर्ता आमंत्रित करें",
    "user.upgradeToAdd": "उपयोगकर्ता सीमा पूर्ण — अपना प्लान अपग्रेड करें",
    "plan.featureNotAvailable": "यह सुविधा आपके वर्तमान प्लान में उपलब्ध नहीं है।",
    "plan.availableOnGroveAndAbove": "Tree और उससे ऊपर के प्लान में उपलब्ध। अनलॉक करने के लिए अपग्रेड करें।",
    "plan.upgradeNow": "प्लान अपग्रेड करें",
    // -- Auth flows
    "auth.sendResetLink": "रीसेट लिंक भेजें",
    "auth.backToLogin": "लॉगिन पर वापस",
    "auth.resetPassword": "पासवर्ड रीसेट करें",
    "auth.createMyAccount": "मेरा खाता बनाएं",
    "auth.iAcceptClose": "मैं स्वीकार करता/करती हूँ और बंद करें",
    "auth.tryDifferentEmail": "दूसरा ईमेल आज़माएं",
    "auth.sessionExpired": "सत्र समाप्त",
    "auth.sessionExpiredMessage": "सुरक्षा कारणों से आपका सत्र समाप्त हो गया है। जहाँ से आपने छोड़ा था वहाँ से जारी रखने के लिए कृपया फिर से साइन इन करें।",
    "auth.confirmLogout": "लॉगआउट की पुष्टि करें",
    "auth.logoutConfirmMessage": "क्या आप वाकई लॉगआउट करना चाहते हैं?",
    "auth.logoutSuccess": "लॉगआउट सफल",
    "auth.logoutSuccessMsg": "आप सफलतापूर्वक लॉगआउट हो गए हैं।",
    "auth.logoutFailed": "लॉगआउट विफल",
    "auth.logoutFailedMsg": "लॉगआउट में त्रुटि हुई",
    "confirmLogoutDevices.header": "आप कहीं और पहले से लॉग इन हैं",
    "confirmLogoutDevices.questionWithDevice": "क्या आप उस डिवाइस से लॉगआउट करके यहां साइन इन जारी रखना चाहते हैं?",
    "confirmLogoutDevices.messageGeneric": "क्या आप उससे लॉगआउट करके यहां साइन इन जारी रखना चाहते हैं?",
    "confirmLogoutDevices.openApp": "LumberLinq खोलें",
    "confirmLogoutDevices.openAppTitle": "आप साइन इन हो गए हैं",
    "confirmLogoutDevices.openAppHint": "ऐप में वापस जाने के लिए बटन दबाएँ।",
    "confirmLogoutDevices.messageWithDevicePrefix": "आप वर्तमान में इस डिवाइस पर लॉग इन हैं: ",
    "confirmLogoutDevices.messageWithDeviceNear": " के पास ",
    "confirmLogoutDevices.messageWithDeviceSuffix": "। क्या आप निश्चित हैं कि आप उस डिवाइस से लॉगआउट करके यहां लॉग इन करना चाहते हैं?",
    "confirmLogoutDevices.acceptLabel": "रद्द करें",
    "confirmLogoutDevices.rejectLabel": "लॉगआउट करें और जारी रखें",
    "forcedLogout.header": "साइन आउट कर दिया गया",
    "forcedLogout.bodyGeneric": "आपको साइन आउट कर दिया गया है क्योंकि आपके खाते ने किसी अन्य डिवाइस से साइन इन किया है।",
    "forcedLogout.explanation": "यह सत्र साइन आउट कर दिया गया क्योंकि आपके खाते ने अभी किसी अन्य डिवाइस से साइन इन किया:",
    "forcedLogout.goToLogin": "लॉगिन पर जाएं",
    // -- Layout
    "layout.copyCompanyId": "कंपनी ID कॉपी करें",
    "layout.productTour": "प्रोडक्ट टूर",
    // -- Loading site documents
    "siteDocs.uploadDialogHeader": "दस्तावेज़ अपलोड करें",
    "siteDocs.upload": "अपलोड",
    "siteDocs.downloadFile": "फ़ाइल डाउनलोड करें",
    "siteDocs.changeCategory": "श्रेणी बदलने के लिए क्लिक करें",
    // -- RBAC settings
    "rbac.enableAcl": "एक्सेस कंट्रोल सक्षम करें",
    "rbac.disableAcl": "एक्सेस कंट्रोल अक्षम करें",
    "rbac.title": "एक्सेस कंट्रोल",
    "rbac.subtitle": "LumberLinq में हर यूजर क्या देख और कर सकता है, इसे नियंत्रित करें.",
    "rbac.perUserStatus": "प्रति-यूजर एक्सेस कंट्रोल है",
    "rbac.enabled": "सक्षम",
    "rbac.disabled": "अक्षम",
    "rbac.disabledDesc": "अक्षम होने पर सभी यूजर को हर चीज़ की पूरी एक्सेस होती है. प्रति व्यक्ति विस्तृत अनुमतियां देने के लिए इसे सक्षम करें.",
    "rbac.enabledDesc": "सक्रिय — अनुमतियां रीयल टाइम में लागू होती हैं. अनुमति हटाने का असर यूजर की अगली API कॉल पर होगा.",
    "rbac.userPermissions": "यूजर अनुमतियां",
    "rbac.configureHint": "हर यूजर के लिए अनुमतियां देने या हटाने के लिए कॉन्फ़िगर बटन पर क्लिक करें.",
    "rbac.permissions": "अनुमतियां",
    "rbac.lastModified": "अंतिम बदलाव",
    "rbac.noPermissions": "कोई अनुमति नहीं — यूजर कुछ भी एक्सेस नहीं कर सकता",
    "rbac.noUsers": "कोई गैर-एडमिन यूजर नहीं मिला.",
    "rbac.notActiveTitle": "एक्सेस कंट्रोल सक्रिय नहीं है",
    "rbac.notActiveDesc": "सक्षम होने पर आप तय कर सकते हैं कि हर यूजर कौन से फीचर एक्सेस कर सकता है.",
    "rbac.notActiveDesc2": "इसे सक्षम करने तक मौजूदा व्यवहार पूरी तरह सुरक्षित रहेगा.",
    "rbac.disableFullAccess": "सभी यूजर को तुरंत हर चीज़ की पूरी एक्सेस मिल जाएगी.",
    "rbac.disablePreserved": "आपकी मौजूदा अनुमति कॉन्फ़िगरेशन सुरक्षित रहेंगी — एक्सेस कंट्रोल फिर सक्षम करने पर वे अपने-आप फिर सक्रिय हो जाएंगी.",
    "rbac.configureTooltip": "अनुमतियाँ असाइन / रद्द करें",
    // -- Onboarding
    "onboarding.welcome": "Lumberlinq में आपका स्वागत है",
    // -- Admin / root module
    "admin.packages": "पैकेज",
    "admin.subscriptionPackages": "सब्सक्रिप्शन पैकेज",
    "admin.packageListSubtitle": "ग्राहकों को दिखने वाले प्लान, कीमत और फीचर सेट प्रबंधित करें",
    "admin.totalPlans": "कुल प्लान",
    "admin.trialPlans": "ट्रायल प्लान",
    "admin.featured": "फीचर्ड",
    "admin.trial": "ट्रायल",
    "admin.mostPopular": "सबसे लोकप्रिय",
    "admin.perMonth": "/माह",
    "admin.free": "मुफ्त",
    "admin.dayTrialSuffix": "दिन का ट्रायल",
    "admin.features": "फीचर",
    "admin.extendable": "बढ़ाया जा सकता है",
    "admin.noPackagesYet": "अभी कोई पैकेज नहीं",
    "admin.createFirstSubscriptionPackage": "शुरू करने के लिए अपना पहला सब्सक्रिप्शन पैकेज बनाएं.",
    "admin.coupons": "कूपन",
    "admin.taxConfig": "टैक्स कॉन्फ़िग",
    "admin.companySupport": "कंपनी सपोर्ट",
    "admin.tickets": "टिकट",
    "admin.appSettings": "ऐप सेटिंग्स",
    "admin.dashboard": "एडमिन डैशबोर्ड",
    "admin.newPackage": "नया पैकेज",
    "admin.savePackage": "पैकेज सेव करें",
    "admin.createPackage": "पैकेज बनाएं",
    "admin.editPackage": "पैकेज संपादित करें",
    "admin.deactivate": "निष्क्रिय करें",
    "admin.activate": "सक्रिय करें",
    "admin.addFeature": "फीचर जोड़ें",
    "admin.newCoupon": "नया कूपन",
    "admin.saveCoupon": "कूपन सेव करें",
    "admin.newTaxRule": "नया टैक्स नियम",
    "admin.addFirstRule": "पहला नियम जोड़ें",
    "admin.extendSubscription": "सब्सक्रिप्शन बढ़ाएं",
    "admin.extend": "बढ़ाएं",
    "admin.suspend": "निलंबित करें",
    "admin.reactivate": "पुनः सक्रिय करें",
    "admin.printReport": "रिपोर्ट प्रिंट करें",
    "admin.support": "सपोर्ट",
    "admin.resolveAll": "सभी हल करें",
    "admin.closeAll": "सभी बंद करें",
    "admin.assignAll": "सभी असाइन करें",
    "admin.inProgress": "प्रगति में",
    "admin.awaitingUser": "उपयोगकर्ता की प्रतीक्षा",
    "admin.resolve": "हल करें",
    "admin.saveChanges": "बदलाव सेव करें",
    "admin.resetFilters": "फिल्टर रीसेट करें",
    "admin.clearSelection": "चयन हटाएं",
    "admin.openSupportDashboard": "सपोर्ट डैशबोर्ड खोलें",
    "admin.hideFromListings": "सदस्यता सूची से छुपाएं",
    "admin.makeVisible": "पुनः दृश्यमान बनाएं",
    "admin.overview": "अवलोकन",
    "admin.ticketDetails": "टिकट विवरण",
    "admin.companyContext": "कंपनी संदर्भ",
    "admin.activityTrail": "गतिविधि ट्रेल",
    "admin.valueExtracted": "इस अवधि में निकाला गया मूल्य",
    "admin.featureUsageBreakdown": "फीचर उपयोग विवरण",
    "admin.salesNarrative": "बिक्री विवरण",
    "admin.loginTrend": "लॉगिन ट्रेंड (साप्ताहिक)",
    "admin.extendSubscriptionDialog": "सब्सक्रिप्शन बढ़ाएं",
    "admin.editPackageTooltip": "पैकेज विवरण, मूल्य और फीचर संपादित करें",
    "admin.autoGenerateKey": "नाम से key स्वतः जनरेट करें",
    "admin.inactivePackagesTooltip": "निष्क्रिय पैकेज सार्वजनिक मूल्य पृष्ठ से छुपे रहते हैं",
    "admin.trialPackagesTooltip": "ट्रायल पैकेज नि:शुल्क और समयसीमित होते हैं।",
    "admin.removeAttachment": "अनुलग्नक हटाएं",
    "admin.suspendAccount": "खाता निलंबित करें",
    "admin.reactivateAccount": "खाता पुनः सक्रिय करें",
    "admin.unitLabelTooltip": "संख्या के बगल में दिखने वाली यूनिट लेबल (जैसे GB, users, tallies)।",
    "admin.allowTrialExtension": "सुपर-एडमिन को व्यक्तिगत कंपनियों के लिए ट्रायल बढ़ाने की अनुमति दें",
    "admin.maxTrialExtensions": "प्रति कंपनी अधिकतम ट्रायल विस्तार की संख्या",
    "admin.descriptionTooltip": "वैकल्पिक रिच टेक्स्ट विवरण। प्लान कार्ड में HTML के रूप में दिखाया जाएगा।",
    "admin.trialNoPricing": "ट्रायल प्लान में कोई मूल्य नहीं होता",
    "admin.discountedPriceTooltip": "ग्राहक वास्तव में प्रति माह INR में जो छूट मूल्य देते हैं",
    "admin.originalPriceTooltip": "बचत दिखाने के लिए स्ट्राइकथ्रू के साथ दिखाया गया मूल मूल्य",
    "admin.discountedMonthlyUsd": "USD में छूट वाली मासिक कीमत",
    "admin.totalYearlyUsd": "USD में छूट वाली कुल वार्षिक कीमत",
    "admin.displayOrder": "मूल्य कार्ड पर प्रदर्शन क्रम",
    "admin.editFeature": "फीचर संपादित करें",
    "admin.deleteFeature": "फीचर हटाएं",
    // -- Field access
    "fieldAccess.resetTooltip": "सभी को डिफ़ॉल्ट पर रीसेट करें",
    "fieldAccess.resetLabel": "डिफ़ॉल्ट पर रीसेट करें",
    "fieldAccess.confirmResetTitle": "लंबरलिंक डिफ़ॉल्ट पर रीसेट करें?",
    "fieldAccess.confirmResetMessage": "इससे हर फ़ील्ड की आपकी कस्टम पब्लिक, प्रोटेक्टेड और प्राइवेट एक्सेस सेटिंग्स हट जाएँगी और लंबरलिंक की डिफ़ॉल्ट सेटिंग बहाल हो जाएगी। इसे पूर्ववत नहीं किया जा सकता।",
    // -- App Usage Report
    "appUsage.planSubscription": "प्लान और सब्सक्रिप्शन",
    "appUsage.title": "ऐप उपयोग रिपोर्ट",
    "appUsage.desc": "आपके फीचर उपयोग और प्लान सीमाओं का लाइव व्यू। सीमा पहुंचने से पहले अपग्रेड करें।",
    "appUsage.failedToLoad": "उपयोग डेटा लोड नहीं हो सका।",
    "appUsage.validTill": "वैधता तक",
    "appUsage.timeRemaining": "शेष समय",
    "appUsage.nearLimit": "सीमा के करीब",
    "appUsage.featureUsage": "फीचर उपयोग",
    "appUsage.aiCredits": "AI इंपोर्ट क्रेडिट",
    "appUsage.aiCreditsOf": "में से",
    "appUsage.aiCreditsPageCredits": "पेज क्रेडिट",
    "appUsage.featureAccess": "फीचर एक्सेस",
    "appUsage.active": "सक्रिय",
    "appUsage.inactive": "निष्क्रिय",
    "appUsage.expiredOn": "समाप्ति दिनांक",
    "report.users.title": "यूजर रिपोर्ट",
    "report.users.subtitle": "आपके संगठन के अंतर्गत पंजीकृत सभी यूजर",
    "report.users.admins": "एडमिन",
    "report.users.role": "भूमिका",
    "report.users.type": "प्रकार",
    "report.users.timezone": "टाइमज़ोन",
    "report.users.joined": "जुड़े",
    "report.users.noUsersFound": "कोई यूजर नहीं मिला",
    // -- Stock Unit form
    "tallysheet.createTransportUnit": "स्टॉक यूनिट बनाएं",
    "tallysheet.saveStartTally": "सेव करें और टैली शुरू करें",
    "su.editDetails": "विवरण बदलें",
    "su.directionMoveShort": "स्थानांतरण",
    "su.moreDetails": "और विवरण",
    "su.lessDetails": "कम विवरण",
    "su.loadingTab": "लोड हो रहा है…",
    "su.detailsTitle": "स्टॉक यूनिट विवरण",
    "su.allSaved": "सभी बदलाव सेव हैं",
    "su.unsaved": "बदलाव सेव नहीं हुए",
    "su.saving": "सेव हो रहा है…",
    "su.moreActions": "और विकल्प",
    "su.receiveSub": "स्टॉक ट्रैकिंग शुरू होती है।",
    "su.lockMenu": "स्टॉक यूनिट लॉक करें",
    "su.lockSub": "आगे बदलाव रोक देता है।",
    "su.deleteMenu": "स्टॉक यूनिट हटाएं",
    "su.deleteSub": "पहले आपसे पुष्टि पूछता है।",
    "su.appScreenOn": "ऐप-जैसा लेआउट आज़माएँ",
    "su.appScreenOff": "पुराने लेआउट पर वापस",
    "su.appScreenSub": "ग्रिड पूरी स्क्रीन भरता है और उसका शीर्षक दिखता रहता है",
    "su.auditMenu": "शेयर लिंक एक्सेस ऑडिट",
    "su.auditSub": "शेयर लिंक से इस स्टॉक यूनिट को किसने खोला",
    "su.confirmOutSub": "यह स्टॉक इन्वेंटरी से बाहर करता है।",
    "su.notInInventory": "इन्वेंटरी में नहीं",
    "su.inInventory": "इन्वेंटरी में",
    "su.sections": "स्टॉक यूनिट के भाग",
    "su.lockedTitle": "टैली शुरू करने के लिए स्टॉक यूनिट सेव करें",
    "su.lockedSub": "हर पंक्ति स्टॉक यूनिट के नाम पर सेव होती है, इसलिए पहले उसकी ID चाहिए।",
    "su.lockedChip": "लॉक",
    "su.lockedPlaceholder": "फोटो, सारांश, मिलान और इन्वेंटरी भी यहीं खुलते हैं।",
    "su.newHint": "विवरण भरें, फिर सेव करें। स्टॉक यूनिट बनते ही टैली खुल जाती है।",
    "su.newReady": "स्टॉक यूनिट सेव हो गई। टैली तैयार है।",
    "tallysheet.selectProduct": "उत्पाद चुनें",
    "tallysheet.selectMode": "मोड चुनें",
    "tallysheet.selectLoadingSite": "स्थान चुनें",
    "tallysheet.searchProduct": "उत्पाद खोजें",
    "tallysheet.searchLoadingSite": "स्थान खोजें",
    "tallysheet.tuIdRequired": "ट्रांसपोर्ट ID आवश्यक है।",
    "tallysheet.tuIdDuplicate": "यह ट्रांसपोर्ट ID पहले से मौजूद है।",
    "tallysheet.tuMinLength": "न्यूनतम 5 अक्षर आवश्यक हैं।",
    "tallysheet.productRequired": "उत्पाद आवश्यक है।",
    "tallysheet.modeRequired": "मोड आवश्यक है।",
    "tallysheet.containerNumRequired": "कंटेनर नंबर आवश्यक है।",
    "tallysheet.vehicleNumRequired": "वाहन नंबर आवश्यक है।",
    "tallysheet.driverNameRequired": "ड्राइवर का नाम आवश्यक है।",
    "tallysheet.expectedDeliveryRequired": "अपेक्षित डिलीवरी आवश्यक है।",
    "tallysheet.expectedArrivalRequired": "अपेक्षित आगमन आवश्यक है।",
    "tallysheet.expectedPickupRequired": "अपेक्षित पिकअप समय आवश्यक है।",
    "tallysheet.pickupLocRequired": "पिकअप स्थान आवश्यक है।",
    "tallysheet.carNumRequired": "कार नंबर आवश्यक है।",
    // -- Location list subtitle
    "loadingSite.subtitle": "मौजूदा स्थान प्रोफाइल देखें और प्रबंधित करें",
    // -- Inventory Report page
    "invReport.available": "उपलब्ध",
    "invReport.openLots": "खुले लॉट (उपलब्ध)",
    "invReport.lots": "लॉट",
    "invReport.reserved": "आरक्षित",
    "invReport.inProcessing": "मिल जॉब में",
    "invReport.inShipment": "कंसाइनमेंट में",
    "invReport.shippedMonth": "भेजा (माह)",
    "invReport.cbmThisMonth": "इस माह CBM",
    "invReport.stockByStage": "चरण के अनुसार स्टॉक",
    "invReport.movementsByType": "प्रकार के अनुसार मूवमेंट",
    "invReport.stockBySite": "साइट के अनुसार स्टॉक",
    "invReport.movementLog": "मूवमेंट लॉग",
    "invReport.adjustments": "समायोजन",
    "invReport.processingRuns": "मिल जॉब",
    "invReport.filterByType": "प्रकार से फ़िल्टर करें",
    "invReport.colType": "प्रकार",
    "invReport.colTransportUnit": "स्टॉक यूनिट",
    "invReport.colSite": "साइट",
    "invReport.colReference": "संदर्भ",
    "invReport.colPartner": "पार्टनर",
    "invReport.colDate": "तारीख",
    "invReport.colRunCode": "मिल जॉब ID",
    "invReport.colMillSite": "मिल साइट",
    "invReport.colInputCbm": "इनपुट CBM",
    "invReport.colOutputCbm": "आउटपुट CBM",
    "invReport.colLossCbm": "हानि CBM",
    "invReport.colOutturn": "आउटटर्न %",
    "invReport.colCbmDelta": "CBM Δ",
    "invReport.colPcsDelta": "पीस Δ",
    "invReport.colNotes": "नोट्स",
    "invReport.noMovements": "चुने गए फ़िल्टर के लिए कोई मूवमेंट नहीं मिला।",
    "invReport.noProcessingRuns": "कोई मिल जॉब नहीं मिला।",
    "invReport.adjustmentsInfo": "समायोजन मौजूदा इन्वेंटरी रिकॉर्ड पर लागू CBM/पीस सुधार हैं। चुनी गई तिथि सीमा के भीतर समायोजन दिखाए जा रहे हैं।",
    "invReport.noAdjustments": "इस अवधि में कोई समायोजन दर्ज नहीं किया गया।",
    "invReport.noStageData": "कोई चरण डेटा नहीं",
    "invReport.noMovementsRange": "सीमा में कोई मूवमेंट नहीं",
    "invReport.noSiteStockData": "कोई साइट स्टॉक डेटा नहीं",
    "invReport.pendingCustomMadeTooltip": "कस्टम-मेड / पुनः-चीरा अनुरोध की प्रतीक्षा में स्टॉक यूनिट",
    // -- Business Partner form extras
    "business.activateDeactivate": "बिजनेस पार्टनर सक्रिय/निष्क्रिय करें",
    "business.partnerActiveHint": "पार्टनर सक्रिय है और लेनदेन में दिखाई देता है",
    "business.partnerInactiveHint": "पार्टनर निष्क्रिय है और नए लेनदेन में छिपा है",
    "business.contactInfo": "संपर्क जानकारी",
    "business.addressSection": "पता",
    "business.attachments": "अनुलग्नक",
    "business.dropFiles": "फाइलें यहाँ छोड़ें या ब्राउज़ करें",
    "business.saveFirst": "फाइलें जोड़ने के लिए पहले पार्टनर सेव करें",
    "business.maxPerFile": "प्रति फाइल",
    "business.uploadedFiles": "अपलोड की गई फाइलें",
    "business.removeAccount": "खाता हटाएं",
    "business.ifscSwift": "IFSC / SWIFT",
    "business.noBankAccounts": "अभी तक कोई बैंक खाता नहीं जोड़ा गया। जोड़ने के लिए क्लिक करें।",
    "business.backToList": "सूची पर वापस",
    "business.minCharsRequired": "न्यूनतम 2 अक्षर आवश्यक हैं।",
    "business.validGstin": "वैध GSTIN दर्ज करें।",
    "business.taxIdMin3Chars": "टैक्स ID कम से कम 3 अक्षर का होना चाहिए।",
    "business.gstin": "GSTIN",
    "business.quickAdd": "नया व्यापार भागीदार जोड़ें",
    "business.quickAddTitle": "नया व्यापार भागीदार",
    "business.quickAddedDetail": "व्यापार भागीदार बनाया गया और चुना गया।",
    "business.quickAddError": "व्यापार भागीदार नहीं बनाया जा सका। कृपया पुनः प्रयास करें।",
    "business.validEmail": "वैध ईमेल आवश्यक है।",
    "business.countryRequired": "देश आवश्यक है।",
    "business.selectCountryFirst": "पहले देश चुनें",
    "business.selectStateFirst": "पहले राज्य चुनें",
    "common.max": "अधिकतम",
    "common.min": "न्यूनतम",
    "common.company": "कंपनी",
    "chart.histogram": "हिस्टोग्राम",
    "chart.scatter": "स्कैटर",
    "chart.line": "लाइन",
    // -- Cookie consent (GDPR)
    "cookie.reject": "गैर-आवश्यक अस्वीकार करें",
    "cookie.manage": "प्रबंधित करें",
    "cookie.acceptAll": "सभी स्वीकार करें",
    "cookie.savePreferences": "प्राथमिकताएं सहेजें",
    "cookie.preferences": "कुकी और गोपनीयता प्राथमिकताएं",
    "cookie.title": "हम कुकीज़ उपयोग करते हैं 🍪",
    "cookie.desc": "हम आपको लॉगिन रखने और अनुभव बेहतर बनाने के लिए कुकीज़ उपयोग करते हैं। एनालिटिक्स कुकीज़ के लिए आपकी सहमति आवश्यक है।",
    "cookie.gdprNote": "GDPR / CCPA के अनुसार, हम केवल आपकी स्पष्ट सहमति से एनालिटिक्स कुकीज़ सक्रिय करते हैं।",
    "cookie.titleApp": "हम एनालिटिक्स उपयोग करते हैं 📊",
    "cookie.descApp": "यह ऐप आपको लॉगिन रखने और अनुभव बेहतर बनाने के लिए एनालिटिक्स उपयोग करता है। एनालिटिक्स के लिए आपकी सहमति आवश्यक है।",
    "cookie.gdprNoteApp": "GDPR / CCPA के अनुसार, हम केवल आपकी स्पष्ट सहमति से एनालिटिक्स सक्रिय करते हैं।",
    "cookie.privacyLink": "गोपनीयता नीति",
    "cookie.essential": "आवश्यक (हमेशा चालू)",
    "cookie.essentialDesc": "लॉगिन, सत्र सुरक्षा के लिए आवश्यक। प्रतिधारण: सत्र + 7 दिन। अक्षम नहीं की जा सकती।",
    "cookie.alwaysOn": "हमेशा चालू",
    "cookie.functional": "कार्यात्मक",
    "cookie.functionalDesc": "भाषा, थीम और फ़ॉन्ट आकार प्राथमिकताएं याद रखता है। प्रतिधारण: 1 वर्ष। अक्षम नहीं की जा सकती।",
    "cookie.analytics": "एनालिटिक्स (Google Analytics)",
    "cookie.analyticsDesc": "हम Google Analytics (GA4) का उपयोग सुविधाओं के उपयोग को समझने के लिए करते हैं। Google आपका IP पता, अनुमानित स्थान (शहर-स्तर), डिवाइस प्रकार एकत्र कर सकता है। यह Google LLC द्वारा उनकी गोपनीयता नीति के अनुसार संसाधित होता है। कोई व्यक्तिगत डेटा नहीं बेचा जाता। प्रतिधारण: 90 दिन।",
    "cookie.dataController": "डेटा नियंत्रक: Rikexim Private Limited · डेटा प्रोसेसर: Google LLC (Google Analytics)",
    // -- Terms & misc
    "common.termsConditions": "नियम और शर्तें",
    "common.acceptContinue": "स्वीकार करें और जारी रखें",
    // -- Missing common keys
    "common.back": "वापस",
    "common.itemsSelected": "आइटम चुने गए",
    "common.generalInformation": "सामान्य जानकारी",
    "common.operationalDetails": "परिचालन विवरण",
    "common.location": "स्थान",
    "common.locationRequired": "स्थान आवश्यक है।",
    "common.pickupLocationRequired": "पिकअप स्थान आवश्यक है।",
    "common.operatingProfile": "परिचालन प्रोफाइल",
    "common.profile": "प्रोफाइल",
    "common.paymentTerms": "भुगतान शर्तें",
    "common.incoterms": "इनकोटर्म्स",
    "common.billNo": "बिल नं.",
    "common.billOfLadingNo": "बिल ऑफ लेडिंग नं.",
    "common.billNumberRequired": "बिल नंबर आवश्यक है",
    "common.requiredForExport": "निर्यात के लिए आवश्यक",
    "common.ewaybillLrFile": "E-Waybill / LR फाइल",
    "common.billFile": "बिल फाइल",
    "common.blFile": "BL फाइल",
    "common.totalUsers": "कुल यूजर",
    "common.configured": "कॉन्फ़िगर किए गए",
    "common.noAccess": "एक्सेस नहीं",
    "common.avgCoverage": "औसत कवरेज",
    // -- Tallysheet Insights section
    "tallysheet.insights": "टैलीशीट इनसाइट्स",
    "tallysheet.totalVolume": "कुल वॉल्यूम",
    "tallysheet.avgVolume": "औसत वॉल्यूम",
    "tallysheet.activeFilter": "सक्रिय फिल्टर",
    "tallysheet.clearFilter": "फिल्टर साफ करें",
    "tallysheet.totalCft": "कुल CFT",
    "tallysheet.aggregated": "संचित",
    "tallysheet.mainVisualization": "मुख्य विज़ुअलाइज़ेशन",
    "tallysheet.girthVsVolume": "गिर्थ बनाम वॉल्यूम",
    "tallysheet.lengthDistribution": "लंबाई वितरण",
    "tallysheet.girthHistogram": "गिर्थ हिस्टोग्राम तालिका",
    "tallysheet.lengthHistogram": "लंबाई हिस्टोग्राम तालिका",
    "tallysheet.metric": "माप",
    "tallysheet.inProcessTooltip": "यह स्टॉक अभी एक चालू मिल जॉब में उपयोग हो रहा है।",
    "tallysheet.notInStock": "स्टॉक में नहीं",
    "tallysheet.notInStockTooltip": "इस स्टॉक यूनिट को अभी तक इन्वेंटरी में प्राप्त नहीं किया गया है।",
    "tallysheet.noSummary": "कोई सारांश उपलब्ध नहीं",
    "tallysheet.addDataForInsights": "इनसाइट्स और विज़ुअलाइज़ेशन के लिए पहले टैली डेटा जोड़ें।",
    "tallysheet.dynamicAnalytics": "डायनेमिक एनालिटिक्स — लंबाई · गिर्थ · वॉल्यूम",
    "tallysheet.exploreTrends": "ट्रेंड देखें",
    "tallysheet.optimizedRecords": "ऑप्टिमाइज़्ड रिकॉर्ड में",
    "tallysheet.clickRangesToFilter": "फिल्टर करने के लिए रेंज पर क्लिक करें",
    "tallysheet.bins": "बिन",
    // -- Stock Unit field labels
    "tallysheet.vehicleNumber": "वाहन नंबर",
    "tallysheet.driverName": "ड्राइवर का नाम",
    "tallysheet.enterDriverName": "ड्राइवर का नाम दर्ज करें",
    "tallysheet.containerNumber": "कंटेनर नंबर",
    "tallysheet.sealNumber": "सील नंबर",
    "tallysheet.fumigationType": "फ्यूमिगेशन प्रकार",
    "tallysheet.selectFumigationType": "फ्यूमिगेशन प्रकार चुनें",
    "fumigation.methylBromide": "मेथाइल ब्रोमाइड फ्यूमिगेशन",
    "fumigation.phosphine": "फॉस्फीन फ्यूमिगेशन",
    "fumigation.sulfurylFluoride": "सल्फ्यूरिल फ्लोराइड फ्यूमिगेशन",
    "fumigation.ethyleneOxide": "एथिलीन ऑक्साइड फ्यूमिगेशन",
    "fumigation.heatTreatment": "हीट ट्रीटमेंट",
    "fumigation.controlledAtmosphere": "नियंत्रित वातावरण (CA) फ्यूमिगेशन",
    "fumigation.vacuum": "वैक्यूम फ्यूमिगेशन",
    "fumigation.other": "अन्य",
    "tallysheet.carNumber": "कार नंबर",
    "tallysheet.railwayLine": "रेलवे लाइन",
    "tallysheet.selectDate": "तारीख चुनें",
    "tallysheet.selectDateTime": "तारीख और समय चुनें",
    "tallysheet.expectedArrival": "अपेक्षित आगमन",
    "tallysheet.pickupLocation": "पिकअप स्थान",
    // -- Business Partner dropdown options
    "bp.buyer": "खरीदार",
    "bp.seller": "विक्रेता",
    "bp.both": "दोनों",
    "bp.company": "कंपनी",
    "bp.individual": "व्यक्तिगत",
    "bp.exporter": "निर्यातक",
    "bp.importer": "आयातक",
    "bp.domestic": "घरेलू",
    "bp.international": "अंतर्राष्ट्रीय",
    // -- Dashboard chart trade type labels
    "dash.domesticSale": "घरेलू बिक्री",
    // -- Loading site
    "loading-site.selectSiteType": "साइट प्रकार चुनें",
    // -- Reconciliation
    "recon.locked": "रिकन्सिलिएशन लॉक किया",
    "recon.lockedBy": "रिकन्सिलिएशन लॉक किया",
    // -- Shipment form - existing en keys now added to hi
    "shipment.coreDetailsShort": "मुख्य विवरण",
    "shipment.consignmentInfo": "कंसाइनमेंट जानकारी",
    "shipment.documents": "दस्तावेज़",
    "shipment.financialsPaymentsHtml": "वित्तीय और भुगतान",
    "shipment.localAuditSpaced": "स्थानीय / ऑडिट",
    "shipment.localAudit": "स्थानीय/ऑडिट",
    // -- Field Access pages
    "fieldAccess.accessControl": "एक्सेस नियंत्रण",
    "fieldAccess.tallyTitle": "परिवहन इकाई फ़ील्ड एक्सेस",
    "fieldAccess.shipmentTitle": "कंसाइनमेंट फील्ड एक्सेस",
    "fieldAccess.searchPlaceholder": "फील्ड खोजें…",
    "fieldAccess.pubLegend": "लिंक वाला कोई भी",
    "fieldAccess.proLegend": "केवल LumberLinq उपयोगकर्ता",
    "fieldAccess.priLegend": "केवल मेरी टीम",
    "fieldAccess.mode.PUBLIC": "लिंक वाला कोई भी",
    "fieldAccess.mode.PROTECTED": "केवल LumberLinq उपयोगकर्ता",
    "fieldAccess.mode.PRIVATE": "केवल मेरी टीम",
    "access.hint.PUBLIC": "साइन-इन की ज़रूरत नहीं",
    "access.hint.PROTECTED": "LumberLinq में साइन-इन, कोई भी कंपनी",
    "access.hint.PRIVATE": "केवल आपकी कंपनी के लोग",
    "fieldAccess.privateAlways": "आपकी कंपनी — हमेशा हर फ़ील्ड देखती है",
    "fieldAccess.hidden": "छुपाएं",
    "fieldAccess.view": "देखें",
    "fieldAccess.alwaysVisible": "हमेशा दिखाई देगा",
    "fieldAccess.alwaysVisibleHint": "यह कॉलम साझा लिंक पर हमेशा दिखता है। इसे छुपाया नहीं जा सकता।",
    "fieldAccess.history": "इतिहास",
    "fieldAccess.historyTitle": "किसने क्या बदला",
    "fieldAccess.historyEmpty": "अभी तक कोई बदलाव दर्ज नहीं हुआ।",
    "fieldAccess.historyFailed": "इतिहास लोड नहीं हो सका।",
    "fieldAccess.historyWhen": "कब",
    "fieldAccess.historyWho": "किसने",
    "fieldAccess.historyField": "फ़ील्ड",
    "fieldAccess.historyMode": "लिंक का प्रकार",
    "fieldAccess.historyChange": "बदलाव",
    "fieldAccess.historyReset": "डिफ़ॉल्ट पर रीसेट",
    "fieldAccess.historyNote": "अंतिम 200 बदलाव दिखाए गए हैं। इस सूची से पहले किए गए बदलाव नहीं दिखते।",
    "fieldAccess.preview": "आगंतुक के रूप में देखें",
    "fieldAccess.previewTitle": "आगंतुक क्या देखता है",
    "fieldAccess.previewHint": "इस स्क्रीन की सेटिंग पर आधारित। कटे हुए फ़ील्ड इस प्रकार के आगंतुक से छुपे हैं।",
    "fieldAccess.previewVisibleCount": "फ़ील्ड दिखते हैं",
    "fieldAccess.previewSectionOff": "यह पूरा सेक्शन बंद है।",
    "fieldAccess.presets": "प्रीसेट",
    "fieldAccess.presetsTitle": "प्रीसेट लागू करें",
    "fieldAccess.presetsLead": "फ़ील्ड एक-एक करके बदलने के बजाय तैयार सेट से शुरू करें। कुछ भी सहेजने से पहले आप देख सकते हैं कि क्या बदलेगा। पैसे, कर और ऑडिट फ़ील्ड, तथा आपूर्तिकर्ता और खरीदार, प्रीसेट से कभी चालू नहीं होते।",
    "fieldAccess.presetMinimal": "सार्वजनिक (न्यूनतम)",
    "fieldAccess.presetMinimalHint": "केवल स्थिति, रूट और मात्रा। लिंक वाले किसी के लिए भी सुरक्षित।",
    "fieldAccess.presetBuyer": "खरीदार",
    "fieldAccess.presetBuyerHint": "खरीदार को चाहिए वे दस्तावेज़, पक्ष और परिवहन विवरण जोड़ता है।",
    "fieldAccess.presetAgent": "एजेंट",
    "fieldAccess.presetAgentHint": "फ़ॉरवर्डिंग एजेंट के लिए संपर्क, स्थान और टैली विवरण जोड़ता है।",
    "fieldAccess.presetApplyTo": "इन पर लागू करें",
    "fieldAccess.presetApply": "प्रीसेट लागू करें",
    "fieldAccess.presetNoChange": "चुने गए लिंक प्रकार के लिए यह प्रीसेट कुछ नहीं बदलता।",
    "fieldAccess.presetWillShow": "{count} फ़ील्ड दिखाए जाएंगे:",
    "fieldAccess.presetWillHide": "{count} फ़ील्ड छुपाए जाएंगे:",
    "fieldAccess.presetPublicWarning": "सावधान: {count} फ़ील्ड लिंक वाले किसी भी व्यक्ति को, बिना लॉगिन के, दिखने लगेंगे।",
    "fieldAccess.publicWarnTitle": "सबको दिखाएं?",
    "fieldAccess.publicWarnMessage": "लिंक वाला कोई भी व्यक्ति, बिना लॉगिन किए, \"{field}\" देख सकेगा। जारी रखें?",
    "fieldAccess.publicWarnAccept": "हाँ, दिखाएं",
    "tallysheet.tu.hiddenDetails": "कुछ विवरण इस लिंक पर साझा नहीं किए गए हैं।",
    "tallysheet.exportDownloadOff": "एक्सपोर्ट (डाउनलोड बंद)",
    "tallysheet.exportDownloadOffHint": "भेजने वाले ने इस लिंक पर डाउनलोड की अनुमति नहीं दी है।",
    "sharePack.button": "पैक डाउनलोड करें",
    "sharePack.title": "पैक डाउनलोड करें",
    "sharePack.lead": "इस लिंक में जो कुछ है, एक ही ZIP में: सारांश PDF, Excel वर्कबुक, दस्तावेज़ और फ़ोटो।",
    "sharePack.loading": "अंदर क्या है, जाँच रहे हैं…",
    "sharePack.partSummary": "सारांश PDF",
    "sharePack.partSummaryHint": "पढ़ने और प्रिंट करने के लिए एक अवलोकन",
    "sharePack.partWorkbook": "Excel वर्कबुक",
    "sharePack.partWorkbookHint": "हर आँकड़ा, फ़िल्टर करने के लिए तैयार",
    "sharePack.partDocuments": "दस्तावेज़",
    "sharePack.partDocumentsHint": "{count} फ़ाइल · {size}",
    "sharePack.partPhotos": "फ़ोटो",
    "sharePack.partPhotosHint": "{count} फ़ोटो · {size}",
    "sharePack.noneInside": "इस लिंक पर डाउनलोड करने के लिए कुछ नहीं है।",
    "sharePack.snapshotNote": "आज की स्थिति का स्नैपशॉट। भेजने वाले के बाद के बदलाव शामिल नहीं हैं।",
    "sharePack.stockUnits": "{count} स्टॉक यूनिट",
    "sharePack.start": "डाउनलोड",
    "sharePack.preparing": "आपका पैक तैयार हो रहा है। बड़े पैक में एक मिनट लग सकता है।",
    "sharePack.downloading": "डाउनलोड हो रहा है {percent}%",
    "sharePack.done": "आपका पैक डाउनलोड हो गया है।",
    "sharePack.failed": "पैक डाउनलोड नहीं हो सका।",
    "sharePack.busy": "सर्वर अभी दूसरे पैक बना रहा है। कृपया एक मिनट बाद फिर कोशिश करें।",
    "sharePack.pickOne": "कम से कम एक भाग चुनें।",
    "sharePack.close": "बंद करें",
    "sharePack.reconciliationField": "डाउनलोड पैक में रिकंसिलिएशन के आँकड़े (लोड बनाम प्राप्त)",
    "fileCounts.ownTitle": "कंसाइनमेंट के दस्तावेज़",
    "fileCounts.ofTypes": "{total} में से {have} प्रकार",
    "fileCounts.missing": "नहीं है",
    "fileCounts.unitsTitle": "स्टॉक यूनिट ({count})",
    "fileCounts.photos": "फ़ोटो",
    "fileCounts.files": "फ़ाइलें",
    "fileCounts.unitTitle": "इस स्टॉक यूनिट की फ़ाइलें",
    "fileCounts.noFiles": "अभी कोई फ़ाइल नहीं।",
    "fileCounts.tipOwn": "{count} कंसाइनमेंट फ़ाइल",
    "fileCounts.tipUnits": "स्टॉक यूनिट: {photos} फ़ोटो, {files} फ़ाइल",
    "fileCounts.typeBL": "BL",
    "fileCounts.typeInvoice": "इनवॉइस",
    "fileCounts.typeCO": "प्रमाणपत्र (मूल)",
    "fileCounts.typePhyto": "फाइटोसैनिटरी",
    "fileCounts.typeEWaybill": "ई-वेबिल",
    "fileCounts.typeOther": "अन्य",
    "fieldAccess.viewOnly": "केवल देखें",
    "fieldAccess.edit": "संपादित करें",
    "fieldAccess.editable": "संपादन योग्य",
    "fieldAccess.loading": "फील्ड कॉन्फ़िगरेशन लोड हो रहा है…",
    "fieldAccess.fields": "फील्ड",
    "fieldAccess.stockUnitsNote": "शेयर लिंक पर स्टॉक यूनिट का विवरण यहाँ नहीं, स्टॉक यूनिट फ़ील्ड एक्सेस में सेट होता है।",
    "fieldAccess.fieldColumn": "फील्ड",
    "fieldAccess.noMatch": "कोई फील्ड आपकी खोज से मेल नहीं खाती।",
    "fieldAccess.group.transportUnit": "परिवहन इकाई",
    "fieldAccess.group.roundTallyGrid": "राउंड टैली ग्रिड",
    "fieldAccess.group.squareTallyGrid": "स्क्वेयर टैली ग्रिड",
    "fieldAccess.group.photosSummary": "फोटो और सारांश",
    "fieldAccess.group.shipmentDetails": "कंसाइनमेंट विवरण",
    "fieldAccess.group.documentDetails": "दस्तावेज़ विवरण",
    "fieldAccess.group.transportCargo": "परिवहन / कार्गो",
    "fieldAccess.group.financials": "वित्तीय",
    "fieldAccess.group.parties": "पक्षकार",
    "fieldAccess.group.systemAudit": "सिस्टम / ऑडिट",
    "fieldAccess.field.transportId": "परिवहन आईडी",
    "fieldAccess.field.transportMode": "परिवहन मोड",
    "fieldAccess.field.unitVehicleNumber": "यूनिट / वाहन नंबर",
    "fieldAccess.field.fumigation": "धुआंकरण",
    "fieldAccess.field.driver": "ड्राइवर",
    "fieldAccess.field.route": "मार्ग",
    "fieldAccess.field.contactPerson": "संपर्क व्यक्ति",
    "fieldAccess.field.expectedDelivery": "अपेक्षित डिलीवरी / पिकअप",
    "fieldAccess.field.sr": "क्र.",
    "fieldAccess.field.length": "लंबाई",
    "fieldAccess.field.girth": "गोलाई",
    "fieldAccess.field.lengthAllowance": "लंबाई भत्ता",
    "fieldAccess.field.girthAllowance": "गोलाई भत्ता",
    "fieldAccess.field.netLength": "नेट लंबाई",
    "fieldAccess.field.netGirth": "नेट गोलाई",
    "fieldAccess.field.grossCbm": "कुल CBM",
    "fieldAccess.field.grossCft": "कुल CFT",
    "fieldAccess.field.netCbm": "नेट CBM",
    "fieldAccess.field.netCft": "नेट CFT",
    "fieldAccess.field.width": "चौड़ाई",
    "fieldAccess.field.thickness": "मोटाई",
    "fieldAccess.field.pieces": "नग",
    "fieldAccess.field.widthAllowance": "चौड़ाई भत्ता",
    "fieldAccess.field.thicknessAllowance": "मोटाई भत्ता",
    "fieldAccess.field.netWidth": "नेट चौड़ाई",
    "fieldAccess.field.netThickness": "नेट मोटाई",
    "fieldAccess.field.photosDocuments": "फोटो / दस्तावेज़",
    "fieldAccess.field.summary": "सारांश",
    "fieldAccess.field.chartData": "चार्ट डेटा",
    "fieldAccess.field.lengthHistogram": "लंबाई हिस्टोग्राम",
    "fieldAccess.field.girthHistogram": "गोलाई हिस्टोग्राम",
    "fieldAccess.field.sawnSquareSummary": "सॉन स्क्वेयर सारांश",
    "fieldAccess.field.modeOfTransportFmt": "परिवहन का साधन",
    "fieldAccess.field.portOfLoadingFmt": "लोडिंग बंदरगाह",
    "fieldAccess.field.portOfDischargeFmt": "डिस्चार्ज बंदरगाह",
    "fieldAccess.field.blNumberFmt": "BL नंबर",
    "fieldAccess.field.blType": "BL प्रकार",
    "fieldAccess.field.packingListNo": "पैकिंग लिस्ट नंबर",
    "fieldAccess.field.commercialInvoiceNo": "वाणिज्यिक इनवॉयस नंबर",
    "fieldAccess.field.certificateOfOrigin": "उत्पत्ति प्रमाण पत्र",
    "fieldAccess.field.fumigationCertificate": "धुआंकरण प्रमाण पत्र",
    "fieldAccess.field.insuranceDetails": "बीमा विवरण",
    "fieldAccess.field.approvedBy": "स्वीकृत करने वाला",
    "fieldAccess.field.buyerTaxNumber": "खरीदार टैक्स नंबर",
    "fieldAccess.field.createdBy": "बनाने वाला",
    "fieldAccess.field.deliveryContact": "डिलीवरी संपर्क",
    "fieldAccess.field.transporterName": "ट्रांसपोर्टर का नाम",
    "fieldAccess.field.vehicleOrLrNo": "वाहन या LR नंबर",
    "fieldAccess.field.transportUnitNumber": "स्टॉक यूनिट नंबर",
    "fieldAccess.field.insuranceValue": "बीमा मूल्य",
    "fieldAccess.field.cargoType": "कार्गो प्रकार",
    "fieldAccess.field.grossWeight": "कुल वजन",
    "fieldAccess.field.netWeight": "नेट वजन",
    "fieldAccess.field.transportUnits": "परिवहन इकाइयां",
    "fieldAccess.field.freightTerms": "माल भाड़ा शर्तें",
    "fieldAccess.field.totalInvoiceAmount": "कुल इनवॉयस राशि",
    "fieldAccess.field.salesPaymentStatus": "बिक्री भुगतान स्थिति",
    "fieldAccess.field.purchasePaymentStatus": "खरीद भुगतान स्थिति",
    "fieldAccess.field.notifyParty": "सूचना पार्टी",
    "fieldAccess.field.exporterRefNo": "निर्यातक संदर्भ नंबर",
    "fieldAccess.field.buyerOrderNo": "खरीदार ऑर्डर नंबर",
    "fieldAccess.field.countryOfOrigin": "उत्पत्ति देश",
    "fieldAccess.field.countryOfDestination": "गंतव्य देश",
    "fieldAccess.field.fromLocation": "से स्थान",
    "fieldAccess.field.toLocation": "तक स्थान",
    "fieldAccess.field.remarks": "टिप्पणियां",
    "fieldAccess.field.vesselOrFlight": "जहाज़ या उड़ान",
    "fieldAccess.field.voyageOrFlightNo": "यात्रा या उड़ान नंबर",
    "fieldAccess.field.shippingLine": "शिपिंग लाइन",
    // -- Manage Users page
    "user.member": "सदस्य",
    "user.role": "भूमिका",
    "user.login": "लॉगिन",
    "user.lastActive": "अंतिम सक्रिय",
    "user.totalMembers": "कुल सदस्य",
    "user.pendingInvites": "लंबित आमंत्रण",
    "user.pendingInvitations": "लंबित आमंत्रण",
    "user.invitedBy": "आमंत्रणकर्ता",
    "user.noTeamMembers": "अभी कोई टीम सदस्य नहीं है",
    "user.inviteToStart": "शुरू करने के लिए उपयोगकर्ता आमंत्रित करें पर क्लिक करें।",
    "user.statusPending": "लंबित",
    "user.expires": "समाप्ति",
    "user.role.owner": "स्वामी",
    "user.role.user": "उपयोगकर्ता",
    "user.role.fieldOperator": "फील्ड ऑपरेटर — टैली जोड़ें और देखें",
    "user.role.supervisor": "सुपरवाइज़र — टैली + कंसाइनमेंट + एक्सपोर्ट",
    "user.role.analyst": "विश्लेषक — सब देखें और एक्सपोर्ट, संपादन नहीं",
    "user.role.manager": "मैनेजर — यूजर प्रबंधन छोड़कर सभी सुविधाएं",
    "user.role.custom": "कस्टम — कोई अनुमति नहीं (मैन्युअल सेटअप)",
    "user.selfDeleteTitle": "मेरा खाता हटाएं",
    "user.selfDeleteSubtitle": "अपना व्यक्तिगत खाता और सभी संबंधित डेटा स्थायी रूप से हटाएं।",
    "user.selfDeleteWarning": "यह क्रिया आपके सभी सक्रिय सत्रों को तुरंत रद्द कर देगी और आपका खाता स्थायी रूप से हटा देगी।\n\n• आपके द्वारा बनाया गया सभी डेटा (टैली, कंसाइनमेंट, परिवहन इकाइयाँ) सिस्टम में बना रहेगा।\n• 30 दिनों के बाद आपके व्यक्तिगत विवरण (नाम, ईमेल, फ़ोन) गुमनाम कर दिए जाएंगे।\n• यह क्रिया वापस नहीं की जा सकती।",
    "user.selfDeleteEmailConfirm": "पुष्टि करने के लिए अपना ईमेल पता टाइप करें",
    "user.selfDeleteEmailPlaceholder": "पुष्टि के लिए ईमेल टाइप करें",
    "user.selfDeleteButton": "मेरा खाता हटाएं",
    "user.selfDeleteSuccess": "आपका खाता हटा दिया गया है। आप लॉग आउट हो गए हैं।",
    "user.selfDeleteFailed": "आपका खाता हटाया नहीं जा सका। कृपया पुनः प्रयास करें।",
    "user.soleAdminWarningTitle": "आप एकमात्र एडमिन हैं",
    "user.soleAdminWarningBody": "आपका खाता हटाने से आपकी कंपनी का वर्कस्पेस स्थायी रूप से बंद हो जाएगा। सभी उपयोगकर्ता तुरंत लॉग आउट हो जाएंगे।",
    "user.soleAdminAffectedLabel": "जो उपयोगकर्ता एक्सेस खो देंगे",
    "user.soleAdminReassignHint": "अनुशंसित: खाता हटाने से पहले किसी अन्य उपयोगकर्ता को एडमिन अधिकार दें।",
    "user.soleAdminReassignButton": "पहले एडमिन असाइन करें",
    "user.soleAdminDeleteAnyway": "फिर भी हटाएं और बंद करें",
    "user.soleAdminShutdownWarning": "यह सभी कंपनी उपयोगकर्ताओं को तुरंत लॉग आउट कर देगा।",
    "user.soleAdminShutdownSuccess": "आपका खाता हटा दिया गया है। सभी कंपनी उपयोगकर्ता लॉग आउट हो गए हैं।",
    "user.assignAdminStepTitle": "नया एडमिन असाइन करें",
    "user.assignAdminSubtitle": "जाने से पहले किसी टीम सदस्य को एडमिन नियुक्त करें।",
    "user.makeAdminBtn": "एडमिन बनाएं",
    "user.adminAssignedSuccess": "एडमिन अधिकार स्थानांतरित। अब आप अपना खाता हटा सकते हैं।",
    "user.continueToDelete": "खाता हटाने के लिए आगे बढ़ें",
    "user.shutdownConsentLabel": "मैं समझता/समझती हूं कि सभी उपयोगकर्ता तुरंत लॉग आउट हो जाएंगे, कंपनी वर्कस्पेस बंद हो जाएगा और सदस्यता समाप्त हो जाएगी।",
    "user.deleteAndShutdown": "कंपनी हटाएं और बंद करें",
    "user.noOtherUsers": "एडमिन अधिकार देने के लिए कोई अन्य सक्रिय उपयोगकर्ता नहीं है।",
    "user.promotingAdmin": "एडमिन असाइन हो रहा है…",
    "user.notificationPreferencesTitle": "सूचना प्राथमिकताएं",
    "user.marketingPushOptInLabel": "मार्केटिंग सूचनाएं",
    "user.marketingPushOptInDescription": "नई सुविधाओं और ऑफ़र के बारे में सूचित रहें।",
    "user.dangerZoneTitle": "खतरनाक क्षेत्र",
    "user.dangerZoneSubtitle": "अपरिवर्तनीय और विनाशकारी क्रियाएं।",
    // -- Shipment form new keys
    "shipment.shipmentType": "कंसाइनमेंट प्रकार",
    "shipment.modeOfTransport": "परिवहन का साधन",
    "shipment.shipmentDate": "कंसाइनमेंट तिथि",
    "shipment.finalDestination": "अंतिम गंतव्य",
    "shipment.estimatedDeparture": "अनुमानित प्रस्थान",
    "shipment.estimatedArrival": "अनुमानित आगमन",
    "shipment.partiesReferences": "पक्षकार और संदर्भ",
    "shipment.documentNumbers": "दस्तावेज़ नंबर",
    "shipment.invoicePayments": "इनवॉयस और भुगतान",
    "shipment.auditStatus": "ऑडिट और स्थिति",
    "shipment.goodsDispatchLocal": "माल / प्रेषण (स्थानीय)",
    "shipment.shipmentTypeRequired": "कंसाइनमेंट प्रकार आवश्यक है",
    "shipment.modeOfTransportRequired": "परिवहन का साधन आवश्यक है",
    "shipment.estimatedDepartureRequired": "अनुमानित प्रस्थान आवश्यक है",
    "shipment.otherDocuments": "अन्य दस्तावेज़",
    // -- Transport mode groups
    "transport.group.regularSizedCargo": "सामान्य आकार का माल",
    "transport.group.reeferContainer": "रीफर कंटेनर",
    "transport.group.oddSizedContainer": "असामान्य आकार का कंटेनर",
    "transport.group.truck": "ट्रक",
    "transport.group.trailer": "ट्रेलर",
    "transport.group.train": "ट्रेन",
    "transport.group.other": "अन्य",
    // -- Transport mode items
    "transport.item.20DryStandard": "20 ड्राई स्टैंडर्ड",
    "transport.item.40DryStandard": "40 ड्राई स्टैंडर्ड",
    "transport.item.40DryHigh": "40 ड्राई हाई",
    "transport.item.45DryHigh": "45 ड्राई हाई",
    "transport.item.20Tank": "20 टैंक",
    "transport.item.40Tank": "40 टैंक",
    "transport.item.20ReeferStandard": "20 रीफर स्टैंडर्ड",
    "transport.item.40ReeferHigh": "40 रीफर हाई",
    "transport.item.20OpenTop": "20 ओपन टॉप",
    "transport.item.40OpenTop": "40 ओपन टॉप",
    "transport.item.40OpenTopHigh": "40 ओपन टॉप हाई",
    "transport.item.40FlatStandard": "40 फ्लैट स्टैंडर्ड",
    "transport.item.40FlatHigh": "40 फ्लैट हाई",
    "transport.item.20Flat": "20 फ्लैट",
    "transport.item.smallTruck": "छोटा ट्रक",
    "transport.item.mediumTruck": "मध्यम ट्रक",
    "transport.item.largeTruck": "बड़ा ट्रक",
    "transport.item.articulatedTruck": "आर्टिकुलेटेड ट्रक",
    "transport.item.flatbedTrailer": "फ्लैटबेड ट्रेलर",
    "transport.item.dryVanTrailer": "ड्राई वैन ट्रेलर",
    "transport.item.reeferTrailer": "रीफर ट्रेलर",
    "transport.item.lowboyTrailer": "लोबॉय ट्रेलर",
    "transport.item.tankerTrailer": "टैंकर ट्रेलर",
    "transport.item.boxcar": "बॉक्सकार",
    "transport.item.flatcar": "फ्लैटकार",
    "transport.item.tankCar": "टैंक कार",
    "transport.item.reeferCar": "रीफर कार",
    "transport.item.hopperCar": "हॉपर कार",
    "transport.item.selfPickup": "स्वयं पिकअप",
    "BOTH": "दोनों",
    "COMPANY": "कंपनी",
    "Invoice Details": "इनवॉइस विवरण",
    "Freight Terms": "फ्रेट शर्तें",
    "Payment Terms": "भुगतान शर्तें",
    "Customer Payment Terms": "ग्राहक भुगतान शर्तें",
    "Supplier Payment Terms": "सप्लायर भुगतान शर्तें",
    "Select terms...": "शर्तें चुनें...",
    "Save the shipment first to record payments and payment terms.": "भुगतान और भुगतान शर्तें रिकॉर्ड करने के लिए पहले कंसाइनमेंट सेव करें।",
    "At least one of Shipper, Consignee or Notify Party must be your company. Based on shipment type, your company may be auto-filled and locked.": "Shipper, Consignee या Notify Party में से कम से कम एक आपकी कंपनी होनी चाहिए। कंसाइनमेंट प्रकार के आधार पर आपकी कंपनी अपने आप भरी और लॉक हो सकती है।",
    "Manage shipment details, parties, documents &amp; financials": "कंसाइनमेंट विवरण, पक्ष, दस्तावेज और वित्तीय जानकारी प्रबंधित करें",
    "Financials &amp; Payments": "वित्तीय और भुगतान",
    "Invoice &amp; Payments": "इनवॉइस और भुगतान",
    "Immediate / Advance": "तत्काल / अग्रिम",
    "Cash on Delivery (COD)": "डिलीवरी पर नकद (COD)",
    "L/C – Sight": "L/C – साइट",
    "L/C – Usance (days)": "L/C – यूसेंस (दिन)",
    "DP – Documents against Payment (days)": "DP – भुगतान के बदले दस्तावेज (दिन)",
    "DA – Documents against Acceptance (days)": "DA – स्वीकृति के बदले दस्तावेज (दिन)",
    "Open Account (days)": "ओपन अकाउंट (दिन)",
    "Net 7 Days": "नेट 7 दिन",
    "Net 15 Days": "नेट 15 दिन",
    "Net 30 Days": "नेट 30 दिन",
    "Net 45 Days": "नेट 45 दिन",
    "Net 60 Days": "नेट 60 दिन",
    "Net 90 Days": "नेट 90 दिन",
    "Other (Custom)": "अन्य (कस्टम)",
    "Timezone": "समय क्षेत्र",
    "Your Timezone": "आपका समय क्षेत्र",
    "Select timezone": "समय क्षेत्र चुनें",
    "Timestamps throughout the app will display in this timezone.": "पूरे ऐप में टाइमस्टैम्प इसी समय क्षेत्र में दिखेंगे।",
    "Asia/Kolkata (IST, UTC+5:30)": "Asia/Kolkata (IST, UTC+5:30)",
    "Trial": "ट्रायल",
    "Trial 7 days": "7 दिन का ट्रायल",
    "Subscription expired. Limited access": "सब्सक्रिप्शन समाप्त हो गया है। सीमित एक्सेस",
    "Transaction History": "लेन-देन इतिहास",
    "Start Date": "आरंभ तारीख",
    "End Date": "समाप्ति तारीख",
    "Transaction ID": "लेन-देन आईडी",
    "Choose Your Plan": "अपना प्लान चुनें",
    "Select the plan that best fits your needs": "अपनी जरूरत के अनुसार सबसे उपयुक्त प्लान चुनें",
    "Company Profile": "कंपनी प्रोफाइल",
    "Your Company Profile": "आपकी कंपनी प्रोफाइल",
    "Company Profile Management": "कंपनी प्रोफाइल प्रबंधन",
    "Registering as an individual": "व्यक्ति के रूप में रजिस्टर कर रहे हैं",
    "Set up company identity, address, and operating profile": "कंपनी पहचान, पता और संचालन प्रोफाइल सेट करें",
    "Legal Entity Type": "कानूनी इकाई प्रकार",
    "Select Legal Entity of Company": "कंपनी की कानूनी इकाई चुनें",
    "Private Limited": "प्राइवेट लिमिटेड",
    "Public Limited": "पब्लिक लिमिटेड",
    "Partnership": "साझेदारी",
    "Proprietorship": "प्रोप्राइटरशिप",
    "Corporation (Inc)": "कॉरपोरेशन (Inc)",
    "LLP": "LLP",
    "LLC": "LLC",
    "Branding": "ब्रांडिंग",
    "Brand Identity": "ब्रांड पहचान",
    "Use a direct image URL. The default RIK Exim logo is used when this field is empty.": "सीधा इमेज URL इस्तेमाल करें। यह फील्ड खाली होने पर डिफॉल्ट RIK Exim लोगो इस्तेमाल होगा।",
    "Buyer Tax Number": "खरीदार टैक्स नंबर",
    "Round Log": "राउंड लॉग",
    "Square / Sawn": "स्क्वेयर / सॉन",
    "For round, unprocessed logs. Uses the Hoppus formula: (girth ÷ 4)² × length.": "राउंड, बिना प्रोसेस किए लॉग के लिए। Hoppus फॉर्मूला उपयोग करता है: (girth ÷ 4)² × length।",
    "For square or sawn timber. Uses volumetric formula: length × width × height.": "स्क्वेयर या सॉन टिम्बर के लिए। वॉल्यूमेट्रिक फॉर्मूला उपयोग करता है: length × width × height।",
    "Formula guide": "फॉर्मूला गाइड",
    "Tax Number": "टैक्स नंबर",
    "Available": "उपलब्ध",
    "In Process": "मिल जॉब में",
    "In Shipment": "कंसाइनमेंट में",
    "Shipped": "भेजा गया",
    "Stock by Location": "स्थान के अनुसार स्टॉक",
    "sites": "साइटें",
    "TUs": "स्टॉक यूनिट",
    "Filtered": "फिल्टर किया गया",
    "At Forest": "फॉरेस्ट पर",
    "In Transit": "ट्रांजिट में",
    "At Mill": "मिल पर",
    "At Yard": "यार्ड पर",
    "AVAILABLE": "उपलब्ध",
    "IN_PROCESS": "मिल जॉब में",
    "PROCESSED": "मिल हुआ",
    "IN_SHIPMENT": "कंसाइनमेंट में",
    "SHIPPED": "भेजा गया",
    "COMPLETED": "पूरा हुआ",
    "Completed": "पूरा हुआ",
    "ROUND": "राउंड",
    "SQUARE": "स्क्वेयर",
    "All": "सभी",
    "IN": "इन",
    "OUT": "आउट",
    "Proc IN": "मिल को भेजा",
    "Proc OUT": "मिल से बना",
    "Adjustment": "एडजस्टमेंट",
    "Received": "प्राप्त",
    "Dispatched": "भेजा गया",
    "Sold": "बेचा",
    "New Processing Run": "नया मिल जॉब",
    "Theme": "थीम",
    "Lara Light Blue": "लारा लाइट ब्लू",
    "Lara Dark Blue": "लारा डार्क ब्लू",
    "Lara Light Indigo": "लारा लाइट इंडिगो",
    "Lara Dark Indigo": "लारा डार्क इंडिगो",
    "Bootstrap Light": "बूटस्ट्रैप लाइट",
    "Bootstrap Dark": "बूटस्ट्रैप डार्क",
    "Saga Blue": "सागा ब्लू",
    "Vela Blue (Dark)": "वेला ब्लू (डार्क)",
    "Material Light": "मटेरियल लाइट",
    "Arya Blue (Dark)": "आर्या ब्लू (डार्क)",
    "YARD": "यार्ड",
    "FOREST": "फॉरेस्ट",
    "MILL": "मिल",
    "PORT": "पोर्ट",
    "WAREHOUSE": "वेयरहाउस",
    "common.previous": "पिछला",
    // -- Payment / Checkout
    "pay.secureCheckout": "सुरक्षित चेकआउट",
    "pay.completeSubscription": "अपनी सदस्यता पूरी करें",
    "pay.oneStepAway": "LumberLinq की पूर्ण पहुँच के लिए बस एक कदम दूर हैं",
    "pay.stepPlanSelected": "प्लान चुना",
    "pay.stepAccountSetup": "खाता सेटअप",
    "pay.stepPayment": "भुगतान",
    "pay.billingDetails": "बिलिंग विवरण",
    "pay.billingDetailsDesc": "यह जानकारी आपके चालान पर दिखेगी",
    "pay.optional": "वैकल्पिक",
    "pay.taxIdHint": "उचित कर चालान के लिए अनुशंसित।",
    "pay.sslNote": "आपकी बिलिंग जानकारी SSL से एन्क्रिप्टेड है। हम आपके भुगतान कार्ड का विवरण कभी नहीं रखते।",
    "pay.annual": "वार्षिक",
    "pay.monthly": "मासिक",
    "pay.basePrice": "आधार मूल्य",
    "pay.starts": "शुरुआत",
    "pay.ends": "समाप्ति",
    "pay.promoCode": "प्रोमो कोड",
    "pay.applyCode": "कोड लगाएं →",
    "pay.enterCode": "कोड दर्ज करें",
    "pay.taxes": "कर",
    "pay.discountApplied": "छूट लागू",
    "pay.upgradeCreditApplied": "अपग्रेड क्रेडिट",
    "pay.upgradeCreditNote": "आपकी वर्तमान योजना में शेष अप्रयुक्त समय के लिए क्रेडिट।",
    "pay.farFutureQueueBanner": "आपके पास पहले से ही {date} तक सक्रिय कवरेज है। यह खरीद तभी शुरू होगी।",
    "pay.farFutureQueueHeader": "यह अभी शुरू नहीं होगा",
    "pay.farFutureQueueMessage": "आपके पास पहले से ही {date} तक चलने वाली एक सक्रिय योजना है। यह नई खरीद उसके बाद ही शुरू होने के लिए कतारबद्ध होगी — यह अभी प्रभावी नहीं होगी। फिर भी जारी रखें?",
    "pay.farFutureQueueAccept": "हां, फिर भी कतारबद्ध करें",
    "pay.farFutureQueueReject": "नहीं, रद्द करें",
    "pay.promoApplied": "कूपन लागू हो गया!",
    "pay.promoChange": "हटाएं",
    "pay.promoEnterFirst": "कृपया एक कूपन कोड दर्ज करें।",
    "pay.promoGenericError": "यह कोड मान्य नहीं है। कृपया जांचें और पुनः प्रयास करें।",
    "pay.promoErr.notFound": "यह कोड नहीं मिला। कृपया जांचें और पुनः प्रयास करें।",
    "pay.promoErr.notStarted": "यह कोड अभी सक्रिय नहीं है।",
    "pay.promoErr.expired": "इस कोड की अवधि समाप्त हो गई है।",
    "pay.promoErr.usedUp": "इस कोड की उपयोग सीमा पूरी हो चुकी है, अब इसका उपयोग नहीं हो सकता।",
    "pay.promoErr.currency": "यह कोड चुनी गई मुद्रा के लिए मान्य नहीं है।",
    "pay.promoErr.period": "यह कोड चुनी गई बिलिंग अवधि के लिए मान्य नहीं है।",
    "pay.promoErr.inrOnly": "यह कोड केवल INR बिलिंग के लिए मान्य है।",
    "pay.promoErr.alreadyUsed": "आपकी कंपनी यह कोड पहले ही इस्तेमाल कर चुकी है।",
    "pay.promoErr.ownCode": "आप अपनी ही कंपनी से जुड़े रेफ़रल कोड का उपयोग नहीं कर सकते।",
    "pay.amountPayable": "देय राशि",
    "pay.autoRenewal": "स्वतः नवीनीकरण",
    "pay.autoRenewalHint": "बिलिंग अवधि समाप्त होने पर स्वचालित रूप से नवीनीकृत करें",
    "pay.autoRenewalRequiredMonthly": "मासिक योजनाओं के लिए अनिवार्य — सदस्यता पृष्ठ से कभी भी रद्द करें",
    "pay.autoRenewalUsdNotSupported": "स्वतः नवीनीकरण केवल INR बिलिंग के लिए उपलब्ध है",
    "pay.autoRenewalCouponDisabled": "एकमुश्त छूट लागू — स्वतः नवीनीकरण अक्षम। भुगतान के बाद अपनी सदस्यता पृष्ठ से पूर्ण मूल्य पर सक्षम करें।",
    "pay.autoRenewalLifetimeCoupon": "आजीवन छूट: स्वतः नवीनीकरण इसी छूट मूल्य पर जारी रहेगा",
    "pay.iHaveReadAccept": "मैंने पढ़ा और स्वीकार करता/करती हूँ",
    "pay.tncError": "आगे बढ़ने के लिए नियम और शर्तें स्वीकार करें।",
    "pay.sslSecured": "SSL सुरक्षित",
    "pay.encrypted": "एन्क्रिप्टेड",
    "pay.tncFooterNote": "\"स्वीकार करें\" क्लिक करने से सहमति चेकबॉक्स भी चेक हो जाएगा।",
    "pay.orderSummary": "ऑर्डर सारांश",
    "pay.yr": "वर्ष",
    "pay.mo": "माह",
    // -- Tour
    "tour.next": "अगला →",
    "tour.prev": "← वापस",
    "tour.done": "पूर्ण ✓",
    "tour.progress": "{{current}} में से {{total}}",
    "tour.header.welcome.title": "LumberLinq में आपका स्वागत है!",
    "tour.header.welcome.desc": "आइए प्रमुख सुविधाओं का एक त्वरित भ्रमण करें। आप किसी भी समय × बटन दबाकर <strong>बंद</strong> कर सकते हैं।",
    "tour.header.menu.title": "नेविगेशन मेनू",
    "tour.header.menu.desc": "साइडबार नेविगेशन <strong>खोलने या बंद</strong> करने के लिए यहाँ क्लिक करें।",
    "tour.header.logo.title": "LumberLinq लोगो",
    "tour.header.logo.desc": "लोगो पर क्लिक करके <strong>कहीं से भी डैशबोर्ड पर वापस</strong> जाएँ।",
    "tour.header.language.title": "भाषा",
    "tour.header.language.desc": "<strong>अंग्रेज़ी, हिन्दी और पुर्तगाली</strong> भाषाओं के बीच स्विच करें।",
    "tour.header.fontSize.title": "फ़ॉन्ट आकार",
    "tour.header.fontSize.desc": "अपनी सुविधा के अनुसार <strong>टेक्स्ट का आकार</strong> समायोजित करें।",
    "tour.header.theme.title": "थीम",
    "tour.header.theme.desc": "अपनी पसंद का <strong>रंग थीम</strong> चुनें।",
    "tour.header.darkMode.title": "डार्क मोड",
    "tour.header.darkMode.desc": "<strong>लाइट और डार्क</strong> डिस्प्ले मोड के बीच टॉगल करें।",
    "tour.header.profile.title": "आपकी प्रोफ़ाइल",
    "tour.header.profile.desc": "यहाँ से <strong>अकाउंट सेटिंग्स, सब्सक्रिप्शन और लॉगआउट</strong> करें।",
    "tour.header.help.title": "सहायता और समर्थन",
    "tour.header.help.desc": "जब भी मदद चाहिए, <strong>गाइड, FAQ और सपोर्ट टिकट</strong> यहाँ मिलेंगे। बस इतना ही — LumberLinq का आनंद लें!",
    "tour.shipments.header.title": "कंसाइनमेंट",
    "tour.shipments.header.desc": "इस पेज से अपने सभी <strong>निर्यात कंसाइनमेंट</strong> प्रबंधित करें।",
    "tour.shipments.new.title": "नया कंसाइनमेंट",
    "tour.shipments.new.desc": "<strong>नया कंसाइनमेंट बनाने</strong> और स्टॉक यूनिट जोड़ने के लिए यहाँ क्लिक करें।",
    "tour.shipments.filter.title": "फ़िल्टर और खोज",
    "tour.shipments.filter.desc": "तारीख, स्थिति या बिज़नेस पार्टनर से <strong>कंसाइनमेंट खोजें</strong>।",
    "tour.shipments.table.title": "कंसाइनमेंट टेबल",
    "tour.shipments.table.desc": "प्रत्येक पंक्ति एक कंसाइनमेंट है। <strong>विवरण, टैली शीट और दस्तावेज़</strong> देखने के लिए क्लिक करें।",
    "tour.shipments.delete.title": "कंसाइनमेंट हटाएँ",
    "tour.shipments.delete.desc": "हटाने की क्रिया सावधानी से करें — <strong>हटाए गए कंसाइनमेंट वापस नहीं</strong> आते।",
    "tour.tally.header.title": "टैली शीट",
    "tour.tally.header.desc": "इस स्टॉक यूनिट के लिए <strong>लॉग माप</strong> दर्ज और प्रबंधित करें।",
    "tour.tally.settings.title": "टैली सेटिंग्स",
    "tour.tally.settings.desc": "इस टैली के लिए <strong>फ़ॉर्मूला, इकाई और माप के डिफ़ॉल्ट</strong> सेट करें।",
    "tour.tally.grid.title": "एंट्री ग्रिड",
    "tour.tally.grid.desc": "ग्रिड में प्रत्येक लॉग की <strong>गर्थ, लंबाई और मात्रा</strong> दर्ज करें। कुल स्वतः अपडेट होता है।",
    "tour.tally.export.title": "निर्यात",
    "tour.tally.export.desc": "टैली को <strong>PDF या Excel फ़ाइल</strong> के रूप में निर्यात करें।",
    "tour.tally.save.title": "टैली सहेजें",
    "tour.tally.save.desc": "कंसाइनमेंट में <strong>टैली डेटा सबमिट</strong> करने के लिए सहेजें पर क्लिक करें।",
    "tour.reports.header.title": "रिपोर्ट",
    "tour.reports.header.desc": "इस अनुभाग से विस्तृत <strong>बिज़नेस और टैली रिपोर्ट</strong> बनाएँ।",
    "tour.reports.filter.title": "रिपोर्ट फ़िल्टर",
    "tour.reports.filter.desc": "रिपोर्ट संकुचित करने के लिए <strong>दिनांक सीमा, बिज़नेस पार्टनर और कंसाइनमेंट</strong> सेट करें।",
    "tour.reports.generate.title": "रिपोर्ट बनाएँ",
    "tour.reports.generate.desc": "चुने गए फ़िल्टर के साथ <strong>रिपोर्ट तैयार करने</strong> के लिए Generate पर क्लिक करें।",
    "tour.reports.export.title": "रिपोर्ट निर्यात",
    "tour.reports.export.desc": "ऑफलाइन उपयोग के लिए रिपोर्ट <strong>PDF या Excel</strong> में डाउनलोड करें।",
    "tour.bp.header.title": "बिज़नेस पार्टनर",
    "tour.bp.header.desc": "इस पेज से अपने सभी <strong>खरीदार और विक्रेता</strong> प्रबंधित करें।",
    "tour.bp.new.title": "पार्टनर जोड़ें",
    "tour.bp.new.desc": "निर्देशिका में <strong>नया खरीदार या विक्रेता जोड़ने</strong> के लिए यहाँ क्लिक करें।",
    "tour.bp.stats.title": "पार्टनर आँकड़े",
    "tour.bp.stats.desc": "आपके अकाउंट में <strong>कुल खरीदार और विक्रेता</strong> का त्वरित अवलोकन।",
    "tour.bp.filter.title": "पार्टनर फ़िल्टर",
    "tour.bp.filter.desc": "<strong>नाम, प्रकार या देश</strong> से पार्टनर खोजें या फ़िल्टर करें।",
    "tour.bp.table.title": "पार्टनर टेबल",
    "tour.bp.table.desc": "<strong>विवरण संपादित करने या कंसाइनमेंट इतिहास देखने</strong> के लिए पार्टनर पंक्ति पर क्लिक करें।",
    "tour.products.header.title": "उत्पाद",
    "tour.products.header.desc": "अपनी टैली शीट में उपयोग होने वाले <strong>लकड़ी के उत्पाद</strong> परिभाषित करें।",
    "tour.products.new.title": "उत्पाद जोड़ें",
    "tour.products.new.desc": "<strong>नया लकड़ी उत्पाद बनाने</strong> के लिए यहाँ क्लिक करें।",
    "tour.products.stats.title": "उत्पाद आँकड़े",
    "tour.products.stats.desc": "आपके अकाउंट में <strong>कुल उत्पादों</strong> की संख्या देखें।",
    "tour.products.table.title": "उत्पाद टेबल",
    "tour.products.table.desc": "<strong>नाम, फ़ॉर्मूला या डिफ़ॉल्ट इकाई संपादित</strong> करने के लिए उत्पाद पंक्ति पर क्लिक करें।",
    "tour.loadingSite.header.title": "स्थान",
    "tour.loadingSite.header.desc": "यहाँ से सभी <strong>वन, यार्ड, मिल और बंदरगाह स्थान</strong> ट्रैक करें।",
    "tour.loadingSite.new.title": "स्थान जोड़ें",
    "tour.loadingSite.new.desc": "अपने अकाउंट में <strong>नया स्थान दर्ज</strong> करने के लिए यहाँ क्लिक करें।",
    "tour.loadingSite.stats.title": "स्थान आँकड़े",
    "tour.loadingSite.stats.desc": "प्रकार के अनुसार <strong>कुल स्थानों</strong> का सारांश।",
    "tour.loadingSite.table.title": "स्थान टेबल",
    "tour.loadingSite.table.desc": "<strong>नाम, प्रकार और स्थान संपादित</strong> करने के लिए स्थान पंक्ति पर क्लिक करें।",
    "tour.users.header.title": "उपयोगकर्ता",
    "tour.users.header.desc": "आपके LumberLinq अकाउंट तक पहुँच रखने वाले सभी <strong>टीम सदस्य</strong> प्रबंधित करें।",
    "tour.users.add.title": "उपयोगकर्ता आमंत्रित करें",
    "tour.users.add.desc": "ईमेल से <strong>नए टीम सदस्य को आमंत्रित</strong> करने के लिए यहाँ क्लिक करें।",
    "tour.users.stats.title": "उपयोगकर्ता आँकड़े",
    "tour.users.stats.desc": "आपकी योजना में <strong>सक्रिय उपयोगकर्ता और उपलब्ध सीटें</strong> देखें।",
    "tour.users.table.title": "उपयोगकर्ता टेबल",
    "tour.users.table.desc": "भूमिकाएँ और अनुमतियाँ प्रबंधित करें — <strong>संपादित या निष्क्रिय</strong> करने के लिए पंक्ति पर क्लिक करें।",
    "tour.dashboardV7.header.title": "आपकी बिज़नेस पल्स",
    "tour.dashboardV7.header.desc": "आपका <strong>डैशबोर्ड</strong> — पूरे कारोबार के लाइव आंकड़े देखने के लिए यहां दिनांक सीमा चुनें और रीफ्रेश करें।",
    "tour.dashboardV7.pulse.title": "बिज़नेस पल्स",
    "tour.dashboardV7.pulse.desc": "पार्टनर्स, शिपमेंट्स, स्टॉक यूनिट्स, वॉल्यूम और पीसेज़ के लिए त्वरित <strong>केपीआई कार्ड</strong> — किसी भी कार्ड पर क्लिक करके सीधे उस सूची पर जाएं।",
    "tour.dashboardV7.financial.title": "वित्तीय स्वास्थ्य",
    "tour.dashboardV7.financial.desc": "एक नज़र में <strong>राजस्व, बकाया शेष और एजिंग</strong> देखें।",
    "tour.dashboardV7.inventory.title": "इन्वेंटरी स्नैपशॉट",
    "tour.dashboardV7.inventory.desc": "आपकी साइटों पर <strong>स्टॉक स्तर</strong> का लाइव दृश्य — पूरी जानकारी के लिए 'पूर्ण इन्वेंटरी' पर क्लिक करें।",
    "tour.dashboardV7.recon.title": "सुलह (रिकंसीलिएशन)",
    "tour.dashboardV7.recon.desc": "देखें कि आपका कितना टैली डेटा <strong>शिपमेंट्स से मेल खाता है</strong>, और किसी भी कमी को ठीक करने के लिए आगे बढ़ें।",
    "tour.dashboardV7.charts.title": "ट्रेंड्स और चार्ट्स",
    "tour.dashboardV7.charts.desc": "चुनी गई दिनांक सीमा में <strong>वॉल्यूम ट्रेंड्स और टॉप प्रोडक्ट्स</strong> देखें।",
    "tour.dashboardV7.activity.title": "हाल की गतिविधि",
    "tour.dashboardV7.activity.desc": "आपकी टीम में हाल के <strong>अकाउंट और परमिशन बदलावों</strong> का ऑडिट ट्रेल।",
    "tour.inventoryOverview.header.title": "इन्वेंटरी अवलोकन",
    "tour.inventoryOverview.header.desc": "आपका स्टॉक <strong>अभी कहां है</strong> इसकी लाइव तस्वीर — फॉरेस्ट में, ट्रांज़िट में, मिल में, मिल जॉब में, यार्ड में, या कंसाइनमेंट में।",
    "tour.inventoryOverview.actions.title": "ओपनिंग स्टॉक और मिल जॉब",
    "tour.inventoryOverview.actions.desc": "मुख्य क्रियाएं: <strong>अपना ओपनिंग स्टॉक जोड़ें (जो स्टॉक पहले से है) या मिल जॉब शुरू करें</strong>। नई डिलीवरी उनके स्टॉक यूनिट (स्टॉक इन) से आती है और एक लॉट में प्राप्त होती है।",
    "tour.inventoryOverview.lots.title": "ओपन स्टॉक लॉट्स",
    "tour.inventoryOverview.lots.desc": "सिस्टम में वर्तमान में मौजूद हर <strong>ओपन लॉट</strong> — पूरा मूवमेंट इतिहास और चेन देखने के लिए किसी लॉट पर क्लिक करें।",
    "tour.inventoryInOut.header.title": "स्टॉक मूवमेंट लेजर",
    "tour.inventoryInOut.header.desc": "अब तक दर्ज हर <strong>स्टॉक मूवमेंट</strong>। किसी विसंगति को ठीक करने के लिए एडजस्टमेंट जोड़ें, या स्प्रेडशीट कॉपी के लिए एक्सपोर्ट करें।",
    "tour.inventoryInOut.filter.title": "प्रकार और दिनांक से फ़िल्टर करें",
    "tour.inventoryInOut.filter.desc": "लेजर को किसी <strong>मूवमेंट प्रकार</strong> (इन, आउट, एडजस्टमेंट, और अधिक) या <strong>दिनांक सीमा</strong> तक सीमित करें।",
    "tour.inventoryInOut.table.title": "मूवमेंट लेजर",
    "tour.inventoryInOut.table.desc": "हर पंक्ति एक <strong>मूवमेंट इवेंट</strong> है — इसके पीछे का स्टॉक यूनिट, लॉट, मिल जॉब या कंसाइनमेंट देखने के लिए उसकी ID पर टैप करें।",
    "tour.inventoryProcessing.header.title": "मिल जॉब",
    "tour.inventoryProcessing.header.desc": "यहीं पर <strong>मिल जॉब</strong> होते हैं, कस्टम-मेड / री-सॉ भी — किसी लॉट के स्टॉक से नया लॉट बनाने के लिए नया मिल जॉब शुरू करें।",
    "tour.inventoryProcessing.stats.title": "मिल जॉब प्रदर्शन",
    "tour.inventoryProcessing.stats.desc": "कुल मिल जॉब, <strong>औसत आउटटर्न</strong>, और मिल हुआ कुल वॉल्यूम — आपकी मिल की दक्षता की त्वरित जांच।",
    "tour.inventoryProcessing.table.title": "मिल जॉब",
    "tour.inventoryProcessing.table.desc": "हर मिल जॉब, उसकी <strong>स्थिति</strong>, और उसका इनपुट/आउटपुट — पूरी जानकारी के लिए एक पंक्ति पर क्लिक करें, जिसमें उसे शुरू करने वाला ऑर्डर भी है।",
    "tour.inventoryOperators.header.title": "मिल ऑपरेटर्स",
    "tour.inventoryOperators.header.desc": "मिल जॉब पर काम करने वाले <strong>ऑपरेटर्स</strong> को प्रबंधित करें — यहां नया ऑपरेटर जोड़ें।",
    "tour.inventoryOperators.stats.title": "टीम स्नैपशॉट",
    "tour.inventoryOperators.stats.desc": "कुल और <strong>सक्रिय ऑपरेटर</strong> संख्या एक नज़र में।",
    "tour.inventoryOperators.search.title": "खोजें और फ़िल्टर करें",
    "tour.inventoryOperators.search.desc": "किसी ऑपरेटर को <strong>नाम, कर्मचारी कोड, या ईमेल</strong> से खोजें, या विशेषज्ञता और सक्रिय स्थिति से फ़िल्टर करें।",
    "tour.rbacSettings.toggle.title": "भूमिका-आधारित एक्सेस कंट्रोल",
    "tour.rbacSettings.toggle.desc": "हर टीम सदस्य को केवल आवश्यक एक्सेस देने के लिए <strong>RBAC</strong> चालू करें, बजाय इसके कि सभी को सब कुछ दिखे।",
    "tour.rbacSettings.tabs.title": "यूज़र्स और रोल्स",
    "tour.rbacSettings.tabs.desc": "एक्सेस को दो तरीकों से प्रबंधित करें: प्रति-यूज़र (<strong>यूज़र परमिशन्स</strong>) या पुन: उपयोग योग्य <strong>रोल</strong> असाइन करके।",
    "tour.rbacSettings.usersTable.title": "यूज़र परमिशन्स",
    "tour.rbacSettings.usersTable.desc": "हर टीम सदस्य और वे सिस्टम का कितना एक्सेस कर सकते हैं — किसी पंक्ति पर <strong>कॉन्फ़िगर</strong> पर क्लिक करके इसे बेहतर बनाएं।",
    "tour.rbacSettings.rolesTab.title": "एक्सेस रोल्स",
    "tour.rbacSettings.rolesTab.desc": "एक बार <strong>पुन: उपयोग योग्य रोल</strong> बनाएं (जैसे 'अकाउंटेंट' या 'यार्ड सुपरवाइज़र'), फिर उसे किसी भी संख्या में यूज़र्स को असाइन करें।",
    "tour.subscriptionManagement.accordion.title": "4 चरणों में सब्सक्राइब करें",
    "tour.subscriptionManagement.accordion.desc": "एक प्लान चुनें, उसकी समीक्षा करें, बिलिंग विवरण जोड़ें, फिर भुगतान करें — पूरा करते ही हर चरण <strong>अगला चरण अनलॉक</strong> करता है।",
    "tour.subscriptionManagement.packageSelect.title": "1. पैकेज चुनें",
    "tour.subscriptionManagement.packageSelect.desc": "अपने व्यवसाय के लिए उपयुक्त <strong>प्लान और बिलिंग साइकल</strong> चुनें।",
    "tour.subscriptionManagement.billing.title": "3. बिलिंग विवरण",
    "tour.subscriptionManagement.billing.desc": "चालान के लिए अपनी <strong>कंपनी और टैक्स जानकारी</strong> दर्ज करें।",
    "tour.subscriptionManagement.pay.title": "4. ऑर्डर की समीक्षा करें और भुगतान करें",
    "tour.subscriptionManagement.pay.desc": "<strong>अंतिम कुल राशि</strong> देखें, यदि आपके पास कोई प्रोमो कोड है तो उसे लागू करें, और भुगतान पूरा करें।",
    // -- Support Tickets
    "ticket.supportTitle": "सपोर्ट टिकट",
    "ticket.subtitle": "अनुरोध दर्ज करें, प्रगति ट्रैक करें, और हमारी टीम से मदद पाएं।",
    "ticket.newTicket": "नया टिकट",
    "ticket.searchPlaceholder": "विषय, टिकट नंबर या श्रेणी से खोजें…",
    "ticket.filter": "फ़िल्टर:",
    "ticket.replies": "जवाब",
    "ticket.lastActivity": "अंतिम गतिविधि",
    "ticket.noTickets": "अभी कोई टिकट नहीं",
    "ticket.noTicketsHint": "कोई सपोर्ट अनुरोध नहीं किया? हम यहाँ मदद के लिए हैं।",
    "ticket.raiseFirst": "पहला टिकट बनाएं",
    "ticket.submitted": "टिकट सबमिट हो गया!",
    "ticket.submitReceived": "आपका सपोर्ट अनुरोध प्राप्त हो गया है।",
    "ticket.respondTime": "हमारी टीम 24 घंटे के भीतर जवाब देगी।",
    "ticket.yourId": "आपका टिकट ID",
    "ticket.viewTicket": "टिकट देखें",
    "ticket.allTickets": "सभी टिकट",
    "ticket.raiseTitle": "सपोर्ट टिकट बनाएं",
    "ticket.raiseHint": "अपनी समस्या बताएं और हम जल्द जवाब देंगे।",
    "ticket.subject": "विषय",
    "ticket.subjectPlaceholder": "अपनी समस्या संक्षेप में बताएं",
    "ticket.subjectRequired": "विषय आवश्यक है।",
    "ticket.maxChars": "अधिकतम 255 अक्षर।",
    "ticket.selectCategory": "श्रेणी चुनें",
    "ticket.categoryRequired": "श्रेणी आवश्यक है।",
    "ticket.descriptionPlaceholder": "जितना हो सके विवरण दें — समस्या के चरण, त्रुटि संदेश, स्क्रीनशॉट का संदर्भ आदि।",
    "ticket.descriptionRequired": "विवरण आवश्यक है।",
    "ticket.submitTicket": "टिकट सबमिट करें",
    "ticket.priority": "प्राथमिकता",
    "ticket.resolved": "हल हो गया",
    "ticket.closed": "बंद",
    "ticket.howDidWeDo": "हमने कैसा किया?",
    "ticket.csatPrompt": "आपका टिकट हल हो गया है। अपना अनुभव रेट करें:",
    "ticket.optionalComment": "वैकल्पिक टिप्पणी…",
    "ticket.submitRating": "रेटिंग सबमिट करें",
    "ticket.yourRating": "आपकी रेटिंग:",
    "ticket.replyPlaceholder": "यहाँ अपना जवाब लिखें…",
    "ticket.attachFile": "फ़ाइल संलग्न करें",
    "ticket.sendReply": "जवाब भेजें",
    "ticket.ticketClosed": "यह टिकट बंद हो गया है। अधिक सहायता के लिए एक नया टिकट खोलें।",
    "ticket.status.all": "सभी",
    "ticket.status.open": "खुला",
    "ticket.status.inProgress": "प्रगति में",
    "ticket.status.awaitingReply": "मेरे जवाब की प्रतीक्षा",
    "ticket.status.resolved": "हल हो गया",
    "ticket.status.closed": "बंद",
    "ticket.priority.low": "निम्न",
    "ticket.priority.medium": "मध्यम",
    "ticket.priority.high": "उच्च",
    "ticket.priority.critical": "गंभीर",
    "ticket.priority.low.desc": "निम्न — सामान्य प्रश्न",
    "ticket.priority.medium.desc": "मध्यम — गैर-जरूरी समस्या",
    "ticket.priority.high.desc": "उच्च — काम पर असर पड़ रहा है",
    "ticket.priority.critical.desc": "गंभीर — सिस्टम बंद / डेटा हानि",
    "ticket.category.billing": "बिलिंग और भुगतान",
    "ticket.category.technical": "तकनीकी समस्या",
    "ticket.category.account": "खाता और पहुँच",
    "ticket.category.featureRequest": "फीचर अनुरोध",
    "ticket.category.subscription": "सब्सक्रिप्शन",
    "ticket.category.dataRecovery": "डेटा पुनर्प्राप्ति",
    "ticket.category.other": "अन्य",
    "ticket.csat.1": "बहुत नाखुश",
    "ticket.csat.2": "नाखुश",
    "ticket.csat.3": "तटस्थ",
    "ticket.csat.4": "खुश",
    "ticket.csat.5": "बहुत खुश",
    // -- AI Chat
    "ai.chat.title": "LumberLinq AI सहायक",
    "ai.chat.placeholder": "लंबरलिंक के बारे में पूछें…",
    "ai.chat.footerNote": "जवाब हमारे नॉलेज बेस पर आधारित हैं",
    "ai.chat.send": "भेजें",
    "ai.chat.newChat": "नई चैट",
    "ai.chat.thinking": "सोच रहा है…",
    "ai.chat.sources": "स्रोत",
    "ai.chat.noSessions": "कोई पिछली बातचीत नहीं",
    "ai.chat.deleteSession": "बातचीत हटाएं",
    "ai.chat.emailTranscript": "ट्रांसक्रिप्ट ईमेल करें",
    "ai.chat.feedback.good": "उपयोगी",
    "ai.chat.feedback.bad": "उपयोगी नहीं",
    "ai.chat.attachFile": "फ़ाइल संलग्न करें",
    "ai.chat.disclaimer": "AI उत्तर हमारे ज्ञानकोश पर आधारित हैं और हमेशा पूरी तरह सटीक नहीं हो सकते। महत्वपूर्ण जानकारी सत्यापित करें।",
    "ai.chat.modeAuto": "ऑटो",
    "ai.chat.titleAuto": "Linc AI",
    "ai.chat.autoSub": "कुछ भी पूछें · Linc सही जवाब चुनता है",
    "ai.chat.autoPlaceholder": "कोई काम कैसे करें, या अपने स्टॉक और भुगतान के बारे में पूछें…",
    "ai.chat.autoGreeting": "नमस्ते, मैं Linc AI हूँ 👋",
    "ai.chat.autoTitle": "हर सवाल के लिए एक ही जगह",
    "ai.chat.autoDesc": "LumberLinq में कोई काम कैसे करना है पूछें, या अपने स्टॉक, कंसाइनमेंट और भुगतान के बारे में पूछें। मैं जवाब देने का सही तरीका चुनूँगा, और सिर्फ वही दिखाऊँगा जो आपके खाते को देखने की अनुमति है।",
    "ai.chat.goToScreen": "स्क्रीन पर जाएँ",
    "ai.chat.dataPartFailed": "मैं आपके सवाल के \"कैसे करें\" वाले हिस्से का जवाब दे सका, लेकिन लाइव डेटा वाले हिस्से का जवाब अभी नहीं दिया जा सका।",
    "ai.chat.starter.createConsignment": "कंसाइनमेंट बनाएँ",
    "ai.chat.starter.inviteTeam": "टीम सदस्य को आमंत्रित करें",
    "ai.chat.starter.shareTally": "टैली शीट शेयर करें",
    "ai.chat.starter.stockNow": "अभी का स्टॉक",
    "ai.chat.starter.toPay": "देय भुगतान",
    "ai.chat.starterQ.createConsignment": "नया कंसाइनमेंट कैसे बनाऊँ?",
    "ai.chat.starterQ.inviteTeam": "टीम के सदस्य को आमंत्रित कैसे करूँ?",
    "ai.chat.starterQ.shareTally": "टैली शीट को खरीदार के साथ कैसे साझा करूँ?",
    "ai.chat.starterQ.stockNow": "अभी हमारे पास कितना स्टॉक है?",
    "ai.chat.starterQ.toPay": "इस महीने कितना भुगतान बकाया है?",
    "ai.chat.starterQ.myAccess": "मैं अपने अकाउंट से क्या-क्या कर सकता हूँ?",
    "ai.chat.starterQ.shipmentsMonth": "इस महीने कितने शिपमेंट हुए?",
    "ai.chat.starterQ.profitMargin": "इस तिमाही में हमारा प्रॉफ़िट मार्जिन क्या है?",
    "ai.chat.starterQ.machines": "अभी कौन-सी मशीनें चल रही हैं?",
    "ai.chat.starterQ.health": "कुल मिलाकर हमारा बिज़नेस कैसा चल रहा है?",
    "ai.chat.starter.myAccess": "मैं क्या कर सकता हूँ?",
    "lincPreview.button": "Linc इस व्यक्ति को क्या दिखाता है",
    "lincPreview.title": "Linc इस व्यक्ति को क्या दिखाता है",
    "lincPreview.intro": "यह दिखाता है कि Linc (AI सहायक) इस व्यक्ति को उनकी पहुँच और कंपनी के प्लान के आधार पर क्या बता सकता है। इसे दिखाने के लिए AI को कुछ नहीं भेजा जाता।",
    "lincPreview.modulesAssumed": "आप प्लेटफ़ॉर्म स्टाफ़ के रूप में साइन इन हैं, इसलिए यहाँ मॉड्यूल स्विच (Inventory, Mill Jobs, Linc Data) जाँचे नहीं जाते।",
    "lincPreview.why.plan": "{items} इस कंपनी के मौजूदा प्लान में शामिल नहीं है (कंपनी को अपग्रेड करना या इसे जोड़ना होगा)",
    "lincPreview.why.permission": "इस अकाउंट के पास {items} की पहुँच नहीं है (टीम का कोई एडमिन इसे Manage Roles से दे सकता है)",
    "lincPreview.why.also": "; साथ ही ",
    "lincPreview.why.and": " और ",
    "lincPreview.why.dataPlan": "Linc Data इस कंपनी के प्लान में चालू नहीं है (कंपनी को इसे जोड़ना या अपग्रेड करना होगा)",
    "lincPreview.why.dataRight": "इस अकाउंट के पास Linc Data इस्तेमाल करने का अधिकार नहीं है (टीम का कोई एडमिन इसे Manage Roles से दे सकता है)",
    "lincPreview.tileAreas": "क्षेत्र",
    "lincPreview.tileQuestions": "लाइव-डेटा प्रश्न",
    "lincPreview.tileSections": "सहायता नोट्स",
    "lincPreview.tileAnswers": "तैयार उत्तर",
    "lincPreview.areasTitle": "ऐप के क्षेत्र",
    "lincPreview.questionsTitle": "लाइव-डेटा प्रश्न (Linc Data)",
    "lincPreview.notesTitle": "सहायता नोट्स",
    "lincPreview.allowed": "अनुमति है",
    "lincPreview.notAllowed": "अनुमति नहीं",
    "lincPreview.withheld": "रोके गए",
    "lincPreview.showWithheld": "रोके गए भाग दिखाएँ",
    "lincPreview.error": "पूर्वावलोकन लोड नहीं हो सका। कृपया फिर से कोशिश करें।",
    "lincPreview.close": "बंद करें",
    // -- Round Tally Summary (premium redesign)
    "tallySummaryRound.title": "गोल तल्ली सारांश",
    "tallySummaryRound.subtitle": "इस गोल लॉग लॉट के लिए आयतन, टुकड़ा संख्या और वितरण अंतर्दृष्टि",
    "tallySummaryRound.piecesAnalyzed": "टुकड़ों का विश्लेषण किया गया",
    "tallySummaryRound.histogram": "हिस्टोग्राम",
    "tallySummaryRound.bubble": "बबल",
    "tallySummaryRound.line": "लाइन",
    "tallySummaryRound.mainVisualization": "मुख्य विज़ुअलाइज़ेशन",
    "tallySummaryRound.girthVsVolume": "घेरा बनाम आयतन",
    "tallySummaryRound.lengthDistribution": "लंबाई वितरण",
    "tallySummaryRound.bubbleTitle": "घेरा x लंबाई x आयतन",
    "tallySummaryRound.activeFilterLabel": "सक्रिय फ़िल्टर",
    "tallySummaryRound.clearFilter": "फ़िल्टर हटाएं",
    "tallySummaryRound.spotlightPiece": "टुकड़ा हाइलाइट कर रहे हैं #",
    "tallySummaryRound.kpiTotalPieces": "कुल टुकड़े",
    "tallySummaryRound.kpiTotalNetCbm": "कुल नेट CBM",
    "tallySummaryRound.kpiTotalNetCft": "कुल नेट CFT",
    "tallySummaryRound.kpiAuthoritative": "संपूर्ण लॉट का कुल योग",
    "tallySummaryRound.distributionTitle": "प्रति-टुकड़ा वितरण",
    "tallySummaryRound.avgVolume": "औसत आयतन / टुकड़ा",
    "tallySummaryRound.minVolume": "सबसे छोटा टुकड़ा",
    "tallySummaryRound.maxVolume": "सबसे बड़ा टुकड़ा",
    "tallySummaryRound.outlierWatchTitle": "डेटा गुणवत्ता - आउटलायर वॉच",
    "tallySummaryRound.outlierCleanLot": "स्वच्छ लॉट - कोई माप विसंगति नहीं मिली",
    "tallySummaryRound.outlierFlaggedCount": "टुकड़े समीक्षा हेतु चिह्नित",
    "tallySummaryRound.outlierFreePercent": "आउटलायर-मुक्त",
    "tallySummaryRound.outlierExpand": "चिह्नित टुकड़े देखें",
    "tallySummaryRound.outlierCollapse": "चिह्नित टुकड़े छिपाएं",
    "tallySummaryRound.outlierColRow": "पंक्ति #",
    "tallySummaryRound.outlierColGirth": "घेरा",
    "tallySummaryRound.outlierColLength": "लंबाई",
    "tallySummaryRound.outlierColVolume": "आयतन",
    "tallySummaryRound.outlierColDeviation": "विचलन",
    "tallySummaryRound.outlierSeverityMild": "हल्का",
    "tallySummaryRound.outlierSeverityExtreme": "गंभीर",
    "tallySummaryRound.outlierNotEnoughData": "आउटलायर आकलन हेतु पर्याप्त टुकड़े नहीं (न्यूनतम 8 आवश्यक)",
    "tallySummaryRound.outlierAboveRange": "अपेक्षित सीमा से ऊपर",
    "tallySummaryRound.outlierBelowRange": "अपेक्षित सीमा से नीचे",
    "tallySummaryRound.rowPositionHint": "तल्ली शीट में दर्ज क्रम स्थिति, स्थायी आईडी नहीं",
    "tallySummaryRound.girthHistogramTitle": "घेरा वितरण",
    "tallySummaryRound.girthHistogramDesc": "टुकड़े 5 सेमी घेरा बैंड में समूहित",
    "tallySummaryRound.lengthHistogramTitle": "लंबाई वितरण तालिका",
    "tallySummaryRound.lengthHistogramDesc": "टुकड़े दर्ज लंबाई के अनुसार समूहित",
    "tallySummaryRound.metric": "मापदंड",
    "tallySummaryRound.noDataTitle": "कोई सारांश उपलब्ध नहीं",
    "tallySummaryRound.noDataDesc": "अंतर्दृष्टि और विज़ुअलाइज़ेशन बनाने के लिए पहले तल्ली डेटा जोड़ें।",
    "tallySummaryRound.lotSnapshot": "लॉट स्नैपशॉट",
    "tallySummaryRound.kpiAvgCft": "औसत CFT / टुकड़ा",
    "tallySummaryRound.distributionHelp": "वर्तमान दृश्य में प्रत्येक लॉग का औसत, सबसे छोटा और सबसे बड़ा नेट आयतन (CBM)।",
    "tallySummaryRound.outlierHelp": "उन लॉग को चिह्नित करता है जिनका आयतन इस लॉट के बाकी हिस्सों की तुलना में सांख्यिकीय रूप से असामान्य है - तल्ली को अंतिम रूप देने या साझा करने से पहले गलत मापी गई या गलत टाइप की गई प्रविष्टियों को पकड़ने का एक त्वरित तरीका।",
    "tallySummaryRound.axisGirth": "घेरा (सेमी)",
    "tallySummaryRound.axisLength": "लंबाई (सेमी)",
    "tallySummaryRound.axisPieces": "टुकड़े",
    "tallySummaryRound.axisVolume": "आयतन (m³)",
    "tallySummaryRound.rowAverage": "औसत",
    "tallySummaryRound.rowSmallest": "सबसे छोटा",
    "tallySummaryRound.rowLargest": "सबसे बड़ा",
    "tallySummaryRound.colVolume": "आयतन",
    "tallySummaryRound.colGirth": "घेरा",
    "tallySummaryRound.colLength": "लंबाई",
    "tallySummaryRound.normalGirthRange": "सामान्य घेरा सीमा",
    "tallySummaryRound.normalLengthRange": "सामान्य लंबाई सीमा",
    "tallySummaryRound.dimGirthAbnormal": "घेरा असामान्य",
    "tallySummaryRound.dimLengthAbnormal": "लंबाई असामान्य",
    "tallySummaryRound.dimBothAbnormal": "घेरा और लंबाई असामान्य",
    "tallySummaryRound.girthVsVolumeHelp": "दिखाता है कि प्रत्येक लॉग का आयतन उसके घेरे से कैसे संबंधित है - बड़ा घेरा आमतौर पर अधिक आयतन दर्शाता है, लेकिन लंबाई की भी भूमिका होती है।",
    "tallySummaryRound.holdTitle": "कौन से लॉग आपका आयतन रखते हैं",
    "tallySummaryRound.holdSubLogs": "सबसे बड़े पहले · {total} CBM का हिस्सा",
    "tallySummaryRound.holdSubBands": "घेरा बैंड, सबसे बड़े पहले · {total} CBM का हिस्सा",
    "tallySummaryRound.holdInsightOne": "आपका सबसे बड़ा लॉग लॉट के आयतन का {pct}% रखता है।",
    "tallySummaryRound.holdInsightMany": "आपके {n} सबसे बड़े लॉग लॉट के आयतन का {pct}% रखते हैं।",
    "tallySummaryRound.holdInsightBand": "{band} सेमी घेरे वाले लॉग आयतन का {pct}% रखते हैं।",
    "tallySummaryRound.holdRow": "पंक्ति {n}",
    "tallySummaryRound.holdMeta": "{girth} सेमी घेरा · {length} सेमी लंबा",
    "tallySummaryRound.holdBandMeta": "{n} लॉग",
    "tallySummaryRound.holdShowAll": "सभी {n} दिखाएँ",
    "tallySummaryRound.holdShowLess": "कम दिखाएँ",
    "tallySummaryRound.emptyHidden": "{n} खाली छिपे · दिखाएँ",
    "tallySummaryRound.emptyHide": "खाली छिपाएँ",
    "tallySummaryRound.holdInsightTop": "आपके सबसे बड़े {k}% लॉग आयतन का {pct}% रखते हैं।",
    "tallySummaryRound.holdTopLogs": "सबसे बड़े अलग-अलग लॉग",
    "tallySummaryRound.holdTabBands": "आकार के अनुसार",
    "tallySummaryRound.holdTabLogs": "सबसे बड़े लॉग",
    "tallySummaryRound.holdBandMetaOne": "{n} लॉग",
    "emailVerification.linkValidHours": "लिंक 24 घंटे के लिए मान्य है",
    "emailVerification.resendButton": "सत्यापन ईमेल फिर से भेजें",
    "emailVerification.alreadyVerifiedPill": "ईमेल पहले से सत्यापित है — कृपया आगे बढ़ें",
    "emailVerification.nowVerifiedGoToLogin": "आपका ईमेल सत्यापित हो गया है! जारी रखने के लिए कृपया लॉग इन करें।",
    "emailVerification.stillNotVerified": "अभी तक सत्यापित नहीं है — कृपया पहले अपना ईमेल देखें और लिंक पर क्लिक करें।",
    "emailVerification.resendCountdown": "{{seconds}} सेकंड में फिर से भेजें उपलब्ध होगा",
    "emailVerification.attemptsRemaining": "3 में से {{count}} पुनः भेजने के प्रयास शेष",
    "emailVerification.maxAttemptsReached": "अधिकतम पुनः भेजने के प्रयास पूरे हो गए। कृपया सहायता से संपर्क करें।",
    "emailVerification.emailInputPlaceholder": "अपना ईमेल पता दर्ज करें",
    "emailVerification.emailInputHint": "सत्यापन लिंक फिर से भेजने के लिए वह ईमेल दर्ज करें जिससे आपने साइन अप किया था।",
    "emailVerification.toastSuccessSummary": "ईमेल भेजा गया",
    "emailVerification.toastErrorSummary": "पुनः भेजना विफल",
    "emailVerification.refreshErrorSummary": "अभी जाँच नहीं हो सकी",
    "emailVerification.refreshErrorBody": "अभी आपके ईमेल की स्थिति जाँची नहीं जा सकी। कृपया थोड़ी देर बाद फिर कोशिश करें।",
    "login.securityCheckRetry": "सुरक्षा जांच पुनः प्रयास करें",
    "login.securityCheckStuck": "सामान्य से अधिक समय लग रहा है — नीचे पुनः प्रयास करें",
    "login.securityCheckExpired": "सत्यापन समाप्त हो गया — जारी रखने के लिए रीफ्रेश करें",
    "login.securityCheckErrored": "सुरक्षा जांच लोड नहीं हो सकी — पुनः प्रयास करें",
    "login.signInCancelledSummary": "साइन-इन रद्द",
    "login.signInCancelledDetail": "ऐसा लगता है साइन-इन पूरा नहीं हुआ। कृपया तैयार होने पर पुनः प्रयास करें.",
    "tallyStatusBar.row": "पंक्ति",
    "tallyStatusBar.rows": "पंक्तियाँ",
    "tallyStatusBar.piecesUnit": "पीस",
    "tallyStatusBar.updated": "अपडेट हुईं",
    "tallyStatusBar.removed": "हटाई गईं",
    "tallyStatusBar.totalRowsTooltip": "कुल पंक्तियाँ",
    "tallyStatusBar.totalPiecesTooltip": "कुल पीस",
    "tallyStatusBar.availableNowTooltip": "अभी उपलब्ध",
    "tallyStatusBar.afterThisSave": "शेष:",
    "tallyStatusBar.grossCbmTooltip": "सकल CBM",
    "tallyStatusBar.grossCbmUnit": "ग्रॉस CBM",
    "tallyStatusBar.grossCftUnit": "ग्रॉस CFT",
    "tallyStatusBar.grossCftTooltip": "सकल CFT",
    "tallyStatusBar.netCbmUnit": "नेट CBM",
    "tallyStatusBar.netCftUnit": "नेट CFT",
    "tallyStatusBar.netCbmTooltip": "नेट CBM (अलाउंस के बाद)",
    "tallyStatusBar.netCftTooltip": "नेट CFT (अलाउंस के बाद)",
    "tallyStatusBar.avgCftTooltip": "प्रति लॉग औसत CFT",
    "tallyStatusBar.unsavedChangesTooltip": "पंक्तियों में असहेजे परिवर्तन",
    "tallyStatusBar.unsavedUnit": "असहेजित",
    "tallyStatusBar.allChangesSavedTooltip": "सभी परिवर्तन सहेजे गए",
    "tallyStatusBar.allSaved": "सभी सहेजा गया",
    "tallyStatusBar.savedPrefix": "सहेजा गया —",
    "tallyStatusBar.deletedPrefix": "हटाया गया —",
    "tallyStatusBar.unsavedPressSave": "असहेजित — सेव दबाएं",
    "tallyStatusBar.lastSaved": "अंतिम बार सहेजा गया",
    "tallyStatusBar.hideVoiceControls": "वॉइस नियंत्रण छिपाएं",
    "tallyStatusBar.showVoiceControls": "वॉइस नियंत्रण दिखाएं",
    "tallyStatusBar.addRow": "पंक्ति जोड़ें",
    "tallyStatusBar.deleteSelected": "चयनित हटाएं",
    "tallyStatusBar.saveCtrlS": "सेव करें (Ctrl+S)",
    "tallyStatusBar.saveTimeout": "सेव होने में अधिक समय लग रहा है — अपना कनेक्शन जांचें",
    "tallyStatusBar.saveFailed": "सेव विफल — पुनः प्रयास करें",
    "tallyStatusBar.deletingRows": "पंक्तियाँ हटाई जा रही हैं...",
    "tallyStatusBar.deleteFailed": "हटाना विफल — पुनः प्रयास करें",
    "tallyStatusBar.fixHighlightedCells": "सेव करने से पहले हाइलाइट की गई कोशिकाओं को ठीक करें",
    "tallyStatusBar.noModifiedRows": "कोई संशोधित पंक्ति नहीं",
    "tallyStatusBar.saveMsg1": "आपके परिवर्तन सहेजे जा रहे हैं",
    "tallyStatusBar.saveMsg2": "आंकड़ों की गणना हो रही है",
    "tallyStatusBar.saveMsg3": "सर्वर से सिंक हो रहा है",
    "tallyStatusBar.saveMsg4": "लगभग हो गया",
    "tallyStatusBar.saveMsg5": "अभी भी काम चल रहा है",
    "tallyStatusBar.saveMsg6": "थोड़ा इंतज़ार करें, लगभग पूरा",
    "tallyStatusBar.saveMsg7": "आपका डेटा अंतिम रूप ले रहा है",
    "tallyStatusBar.saveMsg8": "बस एक क्षण और",
    "subscriptionPackage.cancelAutoRenewalFailedTitle": "ऑटो-नवीनीकरण रद्द नहीं हो सका",
    "subscriptionPackage.cancelAutoRenewalFailedMessage": "आपकी मौजूदा ऑटो-नवीनीकरण सदस्यता रद्द नहीं हो सकी। कृपया फिर से प्रयास करें या सहायता से संपर्क करें।",
    "subscriptionPackage.saveErrorTitle": "कुछ गलत हो गया",
    "subscriptionPackage.saveErrorMessage": "हम आपका चयन सहेज नहीं सके। कृपया फिर से प्रयास करें।",
    "subscriptionPackage.cta.selected": "{name} चयनित",
    "subscriptionPackage.cta.startTrial": "{days}-दिन का निःशुल्क परीक्षण शुरू करें",
    "subscriptionPackage.cta.choose": "{name} चुनें",
    "subscriptionPackage.trialNote": "{days}-दिन का निःशुल्क परीक्षण शामिल",
    "appSettings.title": "एप्लिकेशन सेटिंग्स",
    "appSettings.subtitle": "अपनी कंपनी की सामान्य सेटिंग्स प्रबंधित करें",
    "appSettings.nav.paymentReminders": "भुगतान रिमाइंडर",
    "paymentReminders.title": "भुगतान रिमाइंडर",
    "paymentReminders.subtitle": "व्यापार भागीदारों को भुगतान की याद दिलाएं और रोज़ाना रिपोर्ट पाएं",
    "paymentReminders.enable": "भुगतान रिमाइंडर सक्षम करें",
    "paymentReminders.daysBefore": "याद दिलाना शुरू करें",
    "paymentReminders.daysBefore.suffix": "देय तिथि से दिन पहले",
    "paymentReminders.sendTime": "भेजने का समय",
    "paymentReminders.timezone": "समय क्षेत्र",
    "paymentReminders.externalReminders": "व्यापार भागीदारों को ईमेल से याद दिलाएं",
    "paymentReminders.externalReminders.desc": "आपके शिपमेंट/ट्रेड इवेंट के खरीदार या विक्रेता को भुगतान रिमाइंडर भेजता है",
    "paymentReminders.adminReport": "मुझे रोज़ाना रिपोर्ट भेजें",
    "paymentReminders.adminReport.desc": "देय या अतिदेय सभी भुगतानों का सारांश, PDF के साथ",
    "paymentReminders.channelEmail": "ईमेल",
    "paymentReminders.channelPush": "पुश सूचना",
    "paymentReminders.timeline.title": "रिमाइंडर टाइमलाइन",
    "paymentReminders.timeline.desc": "देय तिथि तक किन दिनों रिमाइंडर भेजा जाएगा, इसका पूर्वावलोकन",
    "paymentReminders.timeline.due": "देय",
    "paymentReminders.timeline.overdue": "अतिदेय (रोज़ाना)",
    "paymentReminders.recipients.title": "रिपोर्ट किसे मिलती है?",
    "paymentReminders.recipients.desc": "जिनके पास फाइनेंशियल हेल्थ एक्सेस है उन्हें रोज़ाना रिपोर्ट मिलती है। और लोगों को यह एक्सेस यहाँ दें:",
    "paymentReminders.recipients.link": "एक्सेस कंट्रोल",
    "paymentReminders.save": "बदलाव सहेजें",
    "paymentReminders.saved": "भुगतान रिमाइंडर सेटिंग्स सहेजी गईं",
    "paymentReminders.saveError": "ये सेटिंग्स सहेजी नहीं जा सकीं। कृपया फिर से प्रयास करें।",
    "appSettings.nav.currency": "मुद्रा",
    "appSettings.nav.inventoryPolicy": "इन्वेंटरी नीति",
    "appSettings.nav.branding": "ब्रांडिंग",
    "appSettings.nav.tallyDefaults": "टैली डिफ़ॉल्ट",
    "tallyDefaults.subtitle": "डिफ़ॉल्ट माप इकाइयाँ, भत्ते और सत्यापन नियम जिनसे नई स्टॉक इकाइयाँ शुरू होती हैं — किसी भी समय प्रति स्टॉक इकाई ओवरराइड करें।",
    "tallyDefaults.square": "स्क्वायर",
    "tallyDefaults.round": "राउंड",
    "tallyDefaults.unitOfMeasure": "माप की इकाई",
    "tallyDefaults.widthUom": "चौड़ाई UoM",
    "tallyDefaults.thickUom": "मोटाई UoM",
    "tallyDefaults.lengthUom": "लंबाई UoM",
    "tallyDefaults.girthUom": "घेरा UoM",
    "tallyDefaults.decimals": "दशमलव",
    "tallyDefaults.mode": "प्रविष्टि मोड",
    "tallyDefaults.allowances": "भत्ते",
    "tallyDefaults.widthAllowance": "चौड़ाई भत्ता",
    "tallyDefaults.thickAllowance": "मोटाई भत्ता",
    "tallyDefaults.lengthAllowance": "लंबाई भत्ता",
    "tallyDefaults.girthAllowance": "घेरा भत्ता",
    "tallyDefaults.lengthAdjustments": "लंबाई समायोजन",
    "tallyDefaults.copyPrevLength": "पिछली लंबाई कॉपी करें",
    "tallyDefaults.addToLength": "लंबाई में जोड़ें",
    "tallyDefaults.addToLengthValue": "लंबाई में जोड़ें मान",
    "tallyDefaults.validationRules": "सत्यापन नियम",
    "tallyDefaults.divisibleBy5": "5 से विभाज्य",
    "tallyDefaults.girthRange": "घेरा सीमा",
    "tallyDefaults.lengthRange": "लंबाई सीमा",
    "tallyDefaults.min": "न्यूनतम",
    "tallyDefaults.max": "अधिकतम",
    "tallyDefaults.quickSearch": "क्विक सर्च",
    "tallyDefaults.toleranceHint": "एक साधारण साइज़ खोज टाइप किए गए नंबर से कितनी दूर तक भटक सकती है और फिर भी मैच मानी जाए — असली लकड़ी शायद ही कभी बिल्कुल नाममात्र आकार में मापी जाती है।",
    "tallyDefaults.searchToleranceSquare": "स्क्वायर मैच सहनशीलता",
    "tallyDefaults.searchToleranceRound": "राउंड मैच सहनशीलता",
    "tallyDefaults.resetTitle": "टैली डिफ़ॉल्ट रीसेट करें?",
    "tallyDefaults.resetBody": "इससे इस पेज के सभी डिफ़ॉल्ट मूल मानों पर रीसेट हो जाएंगे। जिन स्टॉक इकाइयों की अपनी सेव की गई सेटिंग्स पहले से हैं, वे प्रभावित नहीं होंगी।",
    "appSettings.resetAll": "सभी को डिफ़ॉल्ट पर रीसेट करें",
    "appSettings.resetAllTitle": "सभी सेटिंग्स रीसेट करें",
    "appSettings.resetAllBody": "इससे भुगतान रिमाइंडर, मुद्रा, इन्वेंटरी नीति, और ब्रांडिंग (यदि उपलब्ध हो) डिफ़ॉल्ट मानों पर वापस सेट हो जाएंगे। इसे वापस नहीं किया जा सकता।",
    "common.resetToDefault": "डिफ़ॉल्ट पर रीसेट करें",
    "account.language.label": "भाषा",
    "account.language.hint": "यह वह भाषा है जो आप LumberLinq में, किसी भी डिवाइस पर देखेंगे।",
    "currency.subtitle": "वह मुद्रा सेट करें जिसमें आपकी रिपोर्ट और डैशबोर्ड दिखाए जाते हैं।",
    "currency.resetTitle": "मुद्रा रीसेट करें",
    "currency.resetBody": "इससे आपकी रिपोर्टिंग मुद्रा अनसेट हो जाएगी। इसे वापस नहीं किया जा सकता।",
    "inventoryPolicy.subtitle": "कंपनी-व्यापी स्टॉक नीति — हर उपयोगकर्ता पर लागू होती है।",
    "inventoryPolicy.allowOversell": "उपलब्ध स्टॉक से आगे बिक्री जारी रहने दें",
    "inventoryPolicy.allowOversell.hint": "डिफ़ॉल्ट रूप से बंद — जब बिक्री वास्तविक स्टॉक से अधिक हो जाए तो वह रोक दी जाती है।",
    "inventoryPolicy.detailedTracking": "यह ट्रैक करें कि मिल जॉब की लकड़ी किस खरीद से आई है",
    "inventoryPolicy.detailedTracking.hint": "डिफ़ॉल्ट रूप से बंद — चालू करने पर आप देख और बदल सकते हैं कि मिलिंग के समय स्टॉक किस खरीद के हिसाब से गिना जाता है।",
    "inventoryPolicy.resetTitle": "इन्वेंटरी नीति रीसेट करें",
    "inventoryPolicy.resetBody": "इससे दोनों टॉगल डिफ़ॉल्ट मानों पर वापस आ जाएंगे। इसे वापस नहीं किया जा सकता।",
    "company.manageBranding": "ब्रांडिंग प्रबंधित करें",
    "company.manageBrandingHint": "एप्लिकेशन सेटिंग्स में अपनी कंपनी का लोगो अपलोड या सेट करें।",
    "company.signpost.text": "मुद्रा, इन्वेंटरी नीति, भुगतान रिमाइंडर, या ब्रांडिंग खोज रहे हैं?",
    "company.signpost.link": "एप्लिकेशन सेटिंग्स",
    "branding.lockedTitle": "कस्टम ब्रांडिंग एक Forest प्लान फीचर है",
    "branding.lockedBody": "Forest प्लान पर ऐप, एक्सपोर्ट, और ईमेल में अपनी कंपनी का लोगो अपलोड करें।",
    "branding.upgradeCta": "Forest में अपग्रेड करें",
    "branding.chooseFile": "फ़ाइल चुनें",
    "branding.dimensionHint": "PNG, JPG, या WEBP, आदर्श रूप से लगभग 584×158px (LumberLinq लोगो के आकार जैसा) — न्यूनतम 200×50px, 5 MB से कम।",
    "branding.resetTitle": "लोगो रीसेट करें",
    "branding.resetBody": "इससे आपका कस्टम लोगो हट जाएगा और डिफ़ॉल्ट LumberLinq लोगो फिर से दिखेगा। इसे वापस नहीं किया जा सकता।",
    "paymentReminders.resetTitle": "भुगतान रिमाइंडर रीसेट करें",
    "paymentReminders.resetBody": "इससे सभी भुगतान रिमाइंडर सेटिंग्स डिफ़ॉल्ट मानों पर वापस आ जाएंगी। इसे वापस नहीं किया जा सकता।",
    "notifPrefs.sectionTitle": "पुश सूचना श्रेणियां",
    "sessions.title": "आप कहाँ साइन इन हैं",
    "sessions.subtitle": "ये डिवाइस आपके खाते में साइन इन हैं। जिन्हें आप पहचानते नहीं या अब उपयोग नहीं करते, उन्हें साइन आउट करें।",
    "sessions.thisDevice": "यह डिवाइस",
    "sessions.onlineNow": "अभी ऑनलाइन",
    "sessions.unknownDevice": "अज्ञात डिवाइस",
    "sessions.slotWeb": "ब्राउज़र",
    "sessions.slotApp": "ऐप",
    "sessions.signOut": "साइन आउट",
    "sessions.signOutOthers": "अन्य सभी डिवाइस साइन आउट करें",
    "sessions.cancel": "रद्द करें",
    "sessions.confirmHeader": "इस डिवाइस को साइन आउट करें?",
    "sessions.confirmMessage": "{device} साइन आउट हो जाएगा और उसे दोबारा लॉगिन करना होगा।",
    "sessions.confirmOthersHeader": "अन्य सभी डिवाइस साइन आउट करें?",
    "sessions.confirmOthersMessage": "इस डिवाइस को छोड़कर हर डिवाइस साइन आउट हो जाएगा और उसे दोबारा लॉगिन करना होगा।",
    "sessions.signedOutToast": "डिवाइस साइन आउट कर दिया गया।",
    "sessions.signedOutOthersToast": "अन्य सभी डिवाइस साइन आउट कर दिए गए।",
    "sessions.signOutFailed": "डिवाइस को साइन आउट नहीं किया जा सका। कृपया फिर से प्रयास करें।",
    "sessions.loadFailed": "आपके डिवाइस लोड नहीं हो सके।",
    "sessions.retry": "फिर से प्रयास करें",
    "sessions.empty": "कोई डिवाइस नहीं मिला।",
    "notifPrefs.sectionHint": "यदि आप नहीं चाहते कि कोई श्रेणी आपके फ़ोन या ब्राउज़र पर बज़ करे तो उसे बंद करें — फिर भी आप इसे अपने नोटिफिकेशन बेल में देख पाएंगे।",
    "pushPrompt.title": "सूचनाएं चालू करें?",
    "pushPrompt.body": "जब शिपमेंट की स्थिति बदले, कोई आपके साथ टैली शेयर करे, या आपकी टीम इनवाइट भेजे — तुरंत जानें।",
    "pushPrompt.enable": "चालू करें",
    "pushPrompt.notNow": "अभी नहीं",
    "appFeedback.menu": "फ़ीडबैक दें",
    "appFeedback.title": "फ़ीडबैक दें",
    "appFeedback.subtitle": "बताएं कि LumberLinq आपके लिए कैसा चल रहा है",
    "appFeedback.question": "LumberLinq आपके लिए कैसा चल रहा है?",
    "appFeedback.rate.sad": "अच्छा नहीं",
    "appFeedback.rate.neutral": "ठीक है",
    "appFeedback.rate.happy": "अच्छा",
    "appFeedback.rate.love": "बहुत पसंद है",
    "appFeedback.likeLabel": "आपको सबसे ज़्यादा क्या पसंद है?",
    "appFeedback.improveLabel": "हमें क्या सुधारना चाहिए?",
    "appFeedback.privateNote": "इसे केवल LumberLinq टीम देखती है।",
    "appFeedback.showSection": "हमारी वेबसाइट पर",
    "appFeedback.showName": "LumberLinq वेबसाइट पर मेरा नाम दिखाएं",
    "appFeedback.showNameHint": "हमारी टीम की मंज़ूरी के बाद पहले नाम + पहला अक्षर दिखेगा, जैसे \"Sanjay B.\"।",
    "appFeedback.showCompany": "मेरी कंपनी का नाम भी दिखाएं",
    "appFeedback.showCompanyHint": "जब तक आप चालू न करें, बंद रहेगा।",
    "appFeedback.send": "फ़ीडबैक भेजें",
    "appFeedback.back": "वापस",
    "appFeedback.thanksTitle": "धन्यवाद!",
    "appFeedback.thanksBody": "आपका फ़ीडबैक हमारी टीम तक पहुँच गया है।",
    "appFeedback.error": "फ़ीडबैक नहीं भेजा जा सका। कृपया फिर से कोशिश करें।",
    "appFeedback.promptTitle": "LumberLinq आपके लिए कैसा चल रहा है?",
    "appFeedback.promptBody": "बस एक टैप — इससे हमें इसे बेहतर बनाने में मदद मिलती है।",
    "appFeedback.notNow": "अभी नहीं",
    "appFeedback.done": "हो गया",
    "appFeedback.chooseRating": "पहले अपनी राय चुनें",
    "adminFeedback.title": "फ़ीडबैक समीक्षा",
    "pay.offlineOr": "या",
    "pay.offlineProofLabel": "भुगतान का प्रमाण (वैकल्पिक)",
    "pay.offlineProofChoose": "फ़ोटो या PDF चुनें",
    "pay.offlineProofHint": "ट्रांसफ़र का स्क्रीनशॉट या चेक की फ़ोटो से पुष्टि जल्दी होती है। JPG, PNG, WEBP, HEIC या PDF, अधिकतम 8 MB।",
    "pay.offlineProofAttach": "प्रमाण जोड़ें",
    "pay.offlineProofReplace": "प्रमाण बदलें",
    "pay.offlineProofSavedTitle": "प्रमाण सहेजा गया",
    "pay.offlineProofSavedBody": "आपके भुगतान की जाँच के समय हम इसे देखेंगे।",
    "pay.offlineProofError": "आपका भुगतान सहेज लिया गया है, पर प्रमाण अपलोड नहीं हो सका। प्रतीक्षा कार्ड से दोबारा कोशिश करें।",
    "pay.offlineProofBadTypeTitle": "फ़ाइल की अनुमति नहीं",
    "pay.offlineProofBadType": "फ़ोटो (JPG, PNG, WEBP, HEIC) या PDF चुनें।",
    "pay.offlineProofTooBigTitle": "फ़ाइल बहुत बड़ी है",
    "pay.offlineProofTooBig": "फ़ाइल 8 MB या उससे छोटी होनी चाहिए।",
    "adminOffline.viewProof": "प्रमाण देखें",
    "adminOffline.noProof": "कोई प्रमाण नहीं जुड़ा",
    "adminOffline.proofTitle": "भुगतान का प्रमाण",
    "adminOffline.proofHint": "यह वही है जो ग्राहक कहता है कि उसने भुगतान किया। स्वीकृत करने से पहले हमेशा बैंक स्टेटमेंट में पैसा जाँचें।",
    "adminOffline.extra": "अधिक",
    "adminOffline.overWarn": "देय राशि से अधिक। अधिक राशि",
    "pay.offlineTurnOffAuto": "बैंक ट्रांसफ़र या चेक से भुगतान के लिए ऊपर ऑटो रिन्यूअल बंद करें।",
    "pay.offlineNotForMonthly": "मासिक प्लान अपने-आप रिन्यू होते हैं, इसलिए बैंक ट्रांसफ़र या चेक उपलब्ध नहीं है। इसके लिए लंबा प्लान चुनें।",
    "pay.offlineButton": "बैंक ट्रांसफ़र / चेक से भुगतान (INR)",
    "pay.offlineWaitingTitle": "आपका भुगतान पुष्टि की प्रतीक्षा में है",
    "pay.offlineWaitingBody": "हम बैंक में जाँच करके आपका प्लान चालू करेंगे। पूरा होते ही आपको संदेश मिलेगा।",
    "pay.offlineTitle": "बैंक ट्रांसफ़र / चेक से भुगतान",
    "pay.offlineAmountToPay": "भुगतान की राशि",
    "pay.offlineAmountHint": "इसमें GST और आपकी कूपन छूट शामिल है। कृपया यही राशि भेजें।",
    "pay.offlineAccountName": "खाते का नाम",
    "pay.offlineBank": "बैंक",
    "pay.offlineAccountNumber": "खाता संख्या",
    "pay.offlineBranch": "शाखा",
    "pay.offlineChequeTo": "चेक इस नाम पर बनाएँ",
    "pay.offlineChequeAddress": "चेक यहाँ भेजें",
    "pay.offlineRemarks": "रिमार्क्स में लिखें",
    "pay.offlineRemarksHint": "भुगतान के रिमार्क्स में (या चेक के पीछे) यह रेफ़रेंस लिखें ताकि हम आपका भुगतान ढूँढ सकें।",
    "pay.offlineIPaid": "मैंने भुगतान कर दिया है — विवरण भरें",
    "pay.offlineHowPaid": "आपने कैसे भुगतान किया?",
    "pay.offlineUtr": "ट्रांसफ़र का UTR नंबर",
    "pay.offlineChequeNo": "चेक नंबर",
    "pay.offlineRefError": "UTR / चेक नंबर दर्ज करें (कम से कम 4 अक्षर)।",
    "pay.offlineTransferDate": "ट्रांसफ़र की तारीख़",
    "pay.offlineChequeDate": "चेक पर तारीख़",
    "pay.offlineYourBank": "आपका बैंक (वैकल्पिक)",
    "pay.offlineNote": "हमारे लिए नोट (वैकल्पिक)",
    "pay.offlineGstHint": "भुगतान की पुष्टि होने पर आपका GST इनवॉइस भेजा जाएगा।",
    "pay.offlineCancel": "रद्द करें",
    "pay.offlineSubmit": "भुगतान विवरण भेजें",
    "pay.offlineSentTitle": "विवरण मिल गया",
    "pay.offlineSentBody": "हम आपके भुगतान की पुष्टि करके प्लान चालू करेंगे। आपको संदेश मिलेगा।",
    "pay.offlineLoadError": "बैंक विवरण लोड नहीं हो सका। कृपया दोबारा कोशिश करें।",
    "pay.offlineSubmitError": "हम आपका भुगतान विवरण सहेज नहीं सके। कुछ भी चार्ज नहीं हुआ — कृपया दोबारा कोशिश करें।",
    "adminOffline.title": "ऑफ़लाइन भुगतान",
    "lincLearning.title": "Linc सीखना",
    "lincLearning.subtitle": "जिन सवालों के जवाब गलत रहे और आपकी मंज़ूरी का इंतज़ार करते नियम बदलाव",
    "lincLearning.tabFindings": "असफल सवाल",
    "lincLearning.tabProposals": "प्रस्ताव",
    "lincLearning.tabRuleBook": "नियम पुस्तिका",
    "lincLearning.grade.OK": "सही",
    "lincLearning.grade.PART": "आंशिक सही",
    "lincLearning.grade.WRONG": "गलत",
    "lincLearning.grade.NONE": "कोई जवाब नहीं",
    "lincLearning.allGrades": "सभी परिणाम",
    "lincLearning.allRuns": "सभी जाँच",
    "lincLearning.handledAll": "निपटाए या नहीं",
    "lincLearning.handledYes": "निपटाए गए",
    "lincLearning.handledNo": "बाकी",
    "lincLearning.search": "सवाल या समूह खोजें",
    "lincLearning.colQuestion": "सवाल",
    "lincLearning.colAnswer": "दिया गया जवाब",
    "lincLearning.colTrue": "सही जवाब",
    "lincLearning.colNote": "टिप्पणी",
    "lincLearning.markHandled": "निपटाया गया चिह्नित करें",
    "lincLearning.unmark": "बाकी चिह्नित करें",
    "lincLearning.prev": "पिछला",
    "lincLearning.next": "अगला",
    "lincLearning.page": "पृष्ठ",
    "lincLearning.empty": "यहाँ कुछ नहीं है।",
    "lincLearning.kind.WORD": "व्यापार शब्द",
    "lincLearning.kind.ASK_BACK": "वापस पूछना",
    "lincLearning.kind.DEFINITION": "परिभाषा",
    "lincLearning.kind.NEW_DATA": "नया डेटा चाहिए",
    "lincLearning.kind.OTHER": "अन्य",
    "lincLearning.status.PROPOSED": "प्रतीक्षा में",
    "lincLearning.status.APPROVED": "मंज़ूर",
    "lincLearning.status.REJECTED": "अस्वीकृत",
    "lincLearning.approve": "मंज़ूर करें",
    "lincLearning.reject": "अस्वीकार करें",
    "lincLearning.undo": "वापस प्रतीक्षा में",
    "lincLearning.noteHint": "टिप्पणी (वैकल्पिक)",
    "lincLearning.reviewNow": "समीक्षा अभी चलाएँ",
    "lincLearning.reviewNote": "समीक्षा हर दूसरे दिन अपने आप भी चलती है।",
    "lincLearning.addWord": "व्यापार शब्द जोड़ें",
    "lincLearning.word": "शब्द (जैसे silly)",
    "lincLearning.means": "इसका मतलब",
    "lincLearning.add": "जोड़ें",
    "lincLearning.evidence": "इसके पीछे के सवाल",
    "lincLearning.seen": "बार पूछा गया",
    "lincLearning.companies": "कंपनियाँ",
    "lincLearning.source": "स्रोत",
    "lincLearning.decidedBy": "निर्णय",
    "lincLearning.termsTitle": "सहायक जो व्यापार शब्द जानता है",
    "lincLearning.defsTitle": "लिखित परिभाषाएँ",
    "lincLearning.rulebookNote": "अंतर्निहित नियम पुस्तिका केवल सॉफ़्टवेयर रिलीज़ के साथ बदलती है। मंज़ूर किए गए शब्द ऊपर जुड़ते हैं और तुरंत लागू होते हैं।",
    "lincLearning.done": "सहेजा गया",
    "lincLearning.failed": "यह पूरा नहीं हो सका",
    "adminOffline.subtitle": "ग्राहकों के बैंक ट्रांसफ़र और चेक भुगतान की पुष्टि करें",
    "adminOffline.waiting": "प्रतीक्षा में",
    "adminOffline.bankDetails": "बैंक विवरण",
    "adminOffline.refresh": "रीफ़्रेश",
    "adminOffline.noAccessTitle": "पहुँच नहीं है",
    "adminOffline.noAccessBody": "केवल भुगतान स्वीकृतिकर्ता यह पेज खोल सकते हैं।",
    "adminOffline.search": "कंपनी, UTR, ई-मेल खोजें",
    "adminOffline.tabWaiting": "प्रतीक्षा में",
    "adminOffline.tabApproved": "स्वीकृत",
    "adminOffline.tabRejected": "अस्वीकृत",
    "adminOffline.tabReversed": "उलटा गया",
    "offlineHist.bannerTitle": "आपका भुगतान पुष्टि की प्रतीक्षा में है",
    "offlineHist.bannerBody": "पुष्टि होते ही आपका प्लान शुरू हो जाएगा और हम आपको ईमेल करेंगे।",
    "offlineHist.viewDetails": "विवरण",
    "offlineHist.withdraw": "वापस लें",
    "offlineHist.withdrawTitle": "यह भुगतान वापस लें?",
    "offlineHist.withdrawConfirm": "अगर आपने गलत UTR या चेक नंबर डाला है या किसी और तरीके से भुगतान किया है तो इसका उपयोग करें। यह भुगतान पुष्ट नहीं होगा, और आप इसे दोबारा जमा कर सकते हैं।",
    "offlineHist.withdrawYes": "हाँ, वापस लें",
    "offlineHist.withdrawNo": "रहने दें",
    "offlineHist.withdrawnTitle": "भुगतान वापस लिया गया",
    "offlineHist.withdrawnBody": "आप भुगतान का विवरण दोबारा जमा कर सकते हैं या ऑनलाइन भुगतान कर सकते हैं।",
    "offlineHist.withdrawError": "हम भुगतान वापस नहीं ले सके। कृपया फिर कोशिश करें।",
    "offlineHist.title": "बैंक ट्रांसफर और चेक भुगतान",
    "offlineHist.subtitle": "आपकी कंपनी के लिए बताए गए भुगतान",
    "offlineHist.submitted": "जमा किया",
    "offlineHist.reason": "कारण",
    "offlineHist.statusWaiting": "पुष्टि की प्रतीक्षा",
    "offlineHist.statusConfirmed": "पुष्ट",
    "offlineHist.statusRejected": "पुष्ट नहीं हुआ",
    "offlineHist.statusReversed": "उलटा गया",
    "offlineHist.statusWithdrawn": "वापस लिया गया",
    "offlineHist.buyBlocked": "एक बैंक ट्रांसफर / चेक भुगतान पुष्टि की प्रतीक्षा में है। उसके पुष्ट होने, पुष्ट न होने या वापस लेने के बाद आप दूसरा प्लान चुन सकते हैं।",
    "adminOffline.tabWithdrawn": "वापस लिया गया",
    "adminOffline.otherPlanWarn": "इस भुगतान के जमा होने के बाद इस कंपनी को पहले ही दूसरा सक्रिय प्लान मिल चुका है:",
    "adminOffline.otherPlanConfirm": "मैंने जाँच लिया है और फिर भी मंज़ूर करना चाहता हूँ (दूसरा प्लान जुड़ जाएगा)",
    "adminOffline.colCompany": "कंपनी",
    "adminOffline.colPayment": "भुगतान",
    "adminOffline.colAmount": "राशि",
    "adminOffline.colPlan": "प्लान",
    "adminOffline.colStatus": "स्थिति",
    "adminOffline.colSubmitted": "भेजा गया",
    "adminOffline.received": "प्राप्त",
    "adminOffline.shortBy": "कम राशि",
    "adminOffline.approve": "स्वीकृत करें",
    "adminOffline.reject": "अस्वीकार करें",
    "adminOffline.reverse": "उलटें",
    "adminOffline.cancel": "रद्द करें",
    "adminOffline.save": "सहेजें",
    "adminOffline.emptyTitle": "यहाँ कुछ नहीं है",
    "adminOffline.emptyBody": "ग्राहक जो भुगतान बैंक ट्रांसफ़र या चेक से भेजेंगे वे यहाँ दिखेंगे।",
    "adminOffline.approveTitle": "भुगतान स्वीकृत करें",
    "adminOffline.dateOnPayment": "तारीख़",
    "adminOffline.amountDue": "देय राशि",
    "adminOffline.checkStatement": "पहले अपना बैंक स्टेटमेंट देखें। पैसा बैंक में आने पर ही स्वीकृत करें।",
    "adminOffline.receivedAmount": "बैंक में प्राप्त राशि",
    "adminOffline.shortWarn": "देय राशि से कम। कमी",
    "adminOffline.acceptShort": "कम भुगतान स्वीकार करें (जैसे स्रोत पर कर कटौती)",
    "adminOffline.note": "नोट",
    "adminOffline.approvedOk": "भुगतान स्वीकृत। प्लान चालू है।",
    "adminOffline.rejectTitle": "भुगतान अस्वीकार करें",
    "adminOffline.rejectReason": "कारण",
    "adminOffline.rejectHint": "ग्राहक को यह कारण दिखेगा।",
    "adminOffline.rejectedOk": "भुगतान अस्वीकृत। ग्राहक को बता दिया गया।",
    "adminOffline.reverseTitle": "भुगतान उलटें (बाउंस चेक / रिफ़ंड)",
    "adminOffline.chooseOption": "चुनें कि प्लान का क्या होगा",
    "adminOffline.optDeactivate": "प्लान अभी बंद करें",
    "adminOffline.optDeactivateSub": "कंपनी का पेड प्लान तुरंत बंद हो जाता है।",
    "adminOffline.optGrace": "छूट अवधि दें",
    "adminOffline.optGraceSub": "प्लान 7, 15 या 30 दिन और चालू रहेगा, फिर समाप्त होगा।",
    "adminOffline.optKeep": "प्लान चालू रखें",
    "adminOffline.optKeepSub": "केवल उलटने को दर्ज करें। ग्राहक से आप स्वयं निपटेंगे।",
    "adminOffline.optRefund": "रिफ़ंड करें और बंद करें",
    "adminOffline.optRefundSub": "आपने जो रिफ़ंड दिया उसे दर्ज करें और प्लान अभी समाप्त करें।",
    "adminOffline.graceDays": "छूट अवधि (दिन)",
    "adminOffline.refundAmount": "रिफ़ंड राशि",
    "adminOffline.refundRef": "रिफ़ंड का बैंक रेफ़रेंस",
    "adminOffline.creditNoteNo": "क्रेडिट नोट नंबर (वैकल्पिक)",
    "adminOffline.creditNoteHint": "ऐप क्रेडिट नोट नहीं बनाता। फ़ाइनेंस टीम के जारी करने के बाद नंबर दर्ज करें।",
    "adminOffline.commissionWarn": "एफ़िलिएट कमीशन अपने-आप वापस नहीं होता। उसे हाथ से जाँचें।",
    "adminOffline.reversedOk": "भुगतान उलटा गया। ग्राहक को बता दिया गया।",
    "adminOffline.optionOn": "ग्राहकों को यह विकल्प दिखाएँ",
    "adminOffline.optionOnHint": "सभी आवश्यक फ़ील्ड भरने के बाद ग्राहक इसे INR प्लान के भुगतान पेज पर देखते हैं।",
    "adminOffline.accountName": "खाते का नाम",
    "adminOffline.bank": "बैंक",
    "adminOffline.accountNumber": "खाता संख्या",
    "adminOffline.branch": "शाखा",
    "adminOffline.chequePayableTo": "चेक इस नाम पर बनाएँ",
    "adminOffline.chequeAddress": "चेक भेजने का पता",
    "adminOffline.instructions": "ग्राहकों के लिए अतिरिक्त निर्देश",
    "adminOffline.lastUpdated": "अंतिम बदलाव",
    "adminOffline.settingsSaved": "बैंक विवरण सहेजा गया",
    "adminOffline.errorTitle": "पूरा नहीं हो सका",
    "adminOffline.errorGeneric": "कुछ गलत हो गया। कृपया दोबारा कोशिश करें।",
    "adminFeedback.subtitle": "lumberlinq.com पर दिखने से पहले फ़ीडबैक को मंज़ूरी दें",
    "adminFeedback.pending": "लंबित",
    "adminFeedback.approved": "मंज़ूर",
    "adminFeedback.rejected": "अस्वीकृत",
    "adminFeedback.approve": "मंज़ूर करें",
    "adminFeedback.reject": "अस्वीकार करें",
    "adminFeedback.reset": "लंबित में वापस डालें",
    "adminFeedback.colPerson": "व्यक्ति",
    "adminFeedback.colRating": "रेटिंग",
    "adminFeedback.colFeedback": "फ़ीडबैक",
    "adminFeedback.colWebsite": "वेबसाइट पर",
    "adminFeedback.colSource": "स्रोत",
    "adminFeedback.colDate": "तारीख",
    "adminFeedback.sourcePublic": "वेबसाइट फ़ॉर्म",
    "adminFeedback.sourceApp": "ऐप में",
    "adminFeedback.willShowAs": "ऐसे दिखेगा",
    "adminFeedback.notOptedIn": "नाम नहीं दिखेगा (अनुमति नहीं दी)",
    "adminFeedback.noName": "कोई नाम नहीं दिया",
    "adminFeedback.emptyTitle": "अभी यहाँ कुछ नहीं",
    "adminFeedback.emptyBody": "इस सूची में कोई फ़ीडबैक नहीं है।",
    "adminFeedback.liked": "पसंद आया",
    "adminFeedback.problem": "समस्या (निजी)",
    "adminFeedback.search": "नाम, कंपनी या टेक्स्ट खोजें",
    "adminFeedback.statusChanged": "फ़ीडबैक अपडेट हुआ",
    "adminFeedback.loadError": "फ़ीडबैक लोड नहीं हो सका",
    "adminFeedback.withCompany": "कंपनी के साथ",
    "adminFeedback.refresh": "रीफ़्रेश",
    "appSettings.feedbackSection": "फ़ीडबैक और ऐप स्टोर रेटिंग",
    "appSettings.feedbackPromptEnabled": "ऐप में उपयोगकर्ताओं से फ़ीडबैक माँगें",
    "appSettings.feedbackPromptHint": "डैशबोर्ड पर एक छोटा \"LumberLinq आपके लिए कैसा चल रहा है?\" कार्ड दिखाता है। जवाब फ़ीडबैक समीक्षा में जाते हैं, ऐप स्टोर में कभी नहीं।",
    "appSettings.feedbackPromptAfterDays": "कितने दिन बाद पूछें (साइन-अप से)",
    "appSettings.feedbackPromptRepeatDays": "फिर से न पूछें (दिन)",
    "appSettings.storeReviewEnabled": "App Store / Play Store रेटिंग माँगें",
    "appSettings.storeReviewHint": "iPhone और Android पर Apple और Google का अपना रेटिंग पॉपअप। केवल उपयोग के आधार पर — फ़ीडबैक कार्ड से कभी जुड़ा नहीं।",
    "appSettings.storeReviewAfterTallies": "इतनी टैली शीट के बाद",
    "appSettings.storeReviewAfterDays": "या इतने दिन बाद (साइन-अप से)",
    "notifPrefs.pushStatusTitle": "पुश सूचनाएं",
    "notifPrefs.pushGrantedHint": "इस डिवाइस के लिए पुश सूचनाएं चालू हैं।",
    "notifPrefs.pushPromptHint": "इस डिवाइस पर अलर्ट पाने के लिए सूचनाएं चालू करें।",
    "notifPrefs.pushDeniedNativeHint": "इस डिवाइस के लिए सूचनाएं बंद हैं।",
    "notifPrefs.pushDeniedWebHint": "इस साइट के लिए सूचनाएं रोकी गई हैं — अपने ब्राउज़र की सेटिंग में उन्हें चालू करें।",
    "notifPrefs.pushUnsupportedHint": "यह डिवाइस या ब्राउज़र पुश सूचनाओं का समर्थन नहीं करता।",
    "notifPrefs.pushEnableButton": "चालू करें",
    "notifPrefs.openSettingsButton": "सेटिंग खोलें",
    "notifPrefs.teamInvites": "टीम आमंत्रण",
    "notifPrefs.teamInvites.hint": "जब कोई आपको टीम में आमंत्रित करे, या आपका आमंत्रण स्वीकार या अस्वीकार किया जाए।",
    "notifPrefs.security": "सुरक्षा अलर्ट",
    "notifPrefs.security.hint": "लॉगिन और खाता सुरक्षा सूचनाएं। महत्वपूर्ण अलर्ट, जैसे पासवर्ड बदलना, इस सेटिंग की परवाह किए बिना हमेशा भेजे जाते हैं।",
    "notifPrefs.billing": "बिलिंग और भुगतान",
    "notifPrefs.billing.hint": "सब्सक्रिप्शन नवीनीकरण, भुगतान रिमाइंडर, इनवॉइस, और बैंक ट्रांसफ़र / चेक भुगतान की अपडेट।",
    "notifPrefs.shipments": "शिपमेंट",
    "notifPrefs.shipments.hint": "आपके शिपमेंट और कंसाइनमेंट पर अपडेट।",
    "notifPrefs.tally": "टैली शीट",
    "notifPrefs.tally.hint": "आपकी टैली शीट पर अपडेट।",
    "notifPrefs.inventoryProcess": "इन्वेंटरी और मिल जॉब",
    "notifPrefs.inventoryProcess.hint": "स्टॉक मूवमेंट और मिल जॉब अपडेट।",
    "notifPrefs.masterData": "उत्पाद, पार्टनर और स्थान",
    "notifPrefs.masterData.hint": "उत्पादों, व्यापार भागीदारों, या स्थानों में बदलाव।",
    "notifPrefs.shareLinks": "साझा लिंक",
    "notifPrefs.shareLinks.hint": "आपके द्वारा साझा किए गए लिंक पर गतिविधि।",
    "notifPrefs.affiliate": "एफिलिएट प्रोग्राम",
    "notifPrefs.affiliate.hint": "आपके एफिलिएट खाते के लिए आवेदन स्थिति, कमीशन और भुगतान।",
    "notifPrefs.crm": "सेल्स CRM",
    "notifPrefs.crm.hint": "आपको सौंपे गए लीड, कार्य अनुस्मारक, उत्तर, कमीशन और भुगतान अपडेट, और लक्ष्य उपलब्धियाँ।",
    "common.typeConfirm": "आगे बढ़ने के लिए CONFIRM टाइप करें",
    "paymentReminders.offBanner": "भुगतान रिमाइंडर बंद है — ये सेटिंग्स सहेजी जाएंगी लेकिन जब तक आप ऊपर इसे चालू नहीं करते, तब तक लागू नहीं होंगी।",
    "settingsNudge.title": "अपने वर्कस्पेस की सेटअप पूरी करें",
    "settingsNudge.body": "करेंसी, ब्रांडिंग, भुगतान रिमाइंडर और भी बहुत कुछ — सब एक ही जगह पर।",
    "settingsNudge.cta": "एप्लिकेशन सेटिंग्स खोलें",
    "paymentReminders.testEmail.title": "परीक्षण ईमेल भेजें",
    "paymentReminders.testEmail.desc": "असली बिज़नेस पार्टनर्स के लिए इसे चालू करने से पहले सटीक रिमाइंडर + रिपोर्ट फॉर्मैट देखें। यह लाइव डेटा को कभी नहीं छूता।",
    "paymentReminders.testEmail.cta": "परीक्षण भेजें",
    "inventory.processing": "मिल जॉब",
    "inventory.inProcess": "मिल जॉब में",
    "inventory.newProcessingRun": "नया मिल जॉब",
    "inventory.processingDate": "मिल जॉब तिथि",
    "inventory.selectInputTus": "इनपुट स्टॉक यूनिट चुनें",
    "Mill Jobs": "मिल जॉब",
    "Stock in Hand": "हाथ में स्टॉक",
    "inventory.runCode": "मिल जॉब ID",
    "crm.liveCall.button": "वीडियो कॉल",
    "crm.liveCall.title": "वीडियो कॉल",
    "crm.liveCall.starting": "कॉल शुरू हो रही है…",
    "crm.liveCall.startFailed": "कॉल शुरू नहीं हो सकी।",
    "crm.liveCall.retry": "फिर कोशिश करें",
    "crm.liveCall.inProgress": "कॉल चल रही है।",
    "crm.liveCall.rejoin": "फिर से जुड़ें",
    "crm.liveCall.end": "कॉल समाप्त करें",
    "crm.liveCall.endConfirm": "सभी के लिए कॉल समाप्त करें?",
    "crm.liveCall.openTab": "नए टैब में खोलें",
    "crm.liveCall.frameHint": "अगर कॉल यहाँ नहीं दिखे, तो इसे नए टैब में खोलें।",
    "crm.liveCall.inviteTitle": "मेहमान को आमंत्रित करें",
    "crm.liveCall.makeLink": "मेहमान लिंक बनाएँ",
    "crm.liveCall.newLink": "नया लिंक बनाएँ",
    "crm.liveCall.copyLink": "कॉपी करें",
    "crm.liveCall.linkCopied": "कॉपी हो गया",
    "crm.liveCall.newLinkNote": "नया लिंक बनाने पर पुराना लिंक काम करना बंद कर देता है। लिंक कुछ घंटों तक चलता है।",
    "crm.liveCall.cancelLink": "लिंक रद्द करें",
    "crm.liveCall.linkCancelled": "मेहमान का लिंक अब काम नहीं करता।",
    "crm.liveCall.whoJoined": "कौन जुड़ा",
    "crm.liveCall.noOneJoined": "अभी तक लिंक से कोई नहीं जुड़ा।",
    "crm.liveCall.admitNote": "हर मेहमान तब तक इंतज़ार करता है जब तक आप उसे अंदर नहीं लेते: कॉल में Admit दबाएँ। कॉल की सेटिंग में अनुमति दिए बिना मेहमान फ़ाइलें नहीं भेज सकते।",
    "crm.liveCall.codeNote": "ई-मेल से भेजे गए लिंक के लिए उसी पते पर जाने वाला 6 अंकों का कोड भी चाहिए, इसलिए आगे भेजा गया लिंक बेकार है। खुद कॉपी किया गया लिंक भी आगे न भेजें।",
    "crm.liveCall.emailPlaceholder": "मेहमान का ईमेल",
    "crm.liveCall.sendEmail": "ईमेल से भेजें",
    "crm.liveCall.emailSent": "आमंत्रण भेज दिया गया।",
    "crm.liveCall.enterEmail": "मेहमान का ईमेल पता दर्ज करें।",
    "crm.liveCall.phoneNote": "अपनी स्क्रीन दिखाने के लिए कंप्यूटर का उपयोग करें। फ़ोन से जुड़ सकते हैं और बात कर सकते हैं।",
    "live.title": "वीडियो कॉल में शामिल हों",
    "live.host": "मेज़बान",
    "live.name": "आपका नाम",
    "live.email": "आपका ईमेल",
    "live.join": "कॉल में शामिल हों",
    "live.joining": "जुड़ रहे हैं…",
    "live.loading": "लोड हो रहा है…",
    "live.privacy": "हम आपका नाम और ईमेल केवल इस कॉल के लिए उपयोग करते हैं। कॉल रिकॉर्ड नहीं की जाती।",
    "live.phoneNote": "आप फ़ोन से जुड़ सकते हैं। पूछे जाने पर कैमरा और माइक्रोफ़ोन की अनुमति दें।",
    "live.linkOnly": "यह लिंक सिर्फ़ आपके लिए है। कृपया इसे आगे न भेजें।",
    "live.waitNote": "जुड़ने के बाद होस्ट आपको अंदर लेगा। इसमें थोड़ा समय लग सकता है।",
    "live.codeIntro": "यह पक्का करने के लिए कि यह आप ही हैं, हम उस पते पर 6 अंकों का कोड भेजते हैं जहाँ आपका निमंत्रण गया था:",
    "live.sendCode": "मुझे कोड भेजें",
    "live.sendAgain": "फिर से भेजें",
    "live.codeSent": "कोड भेज दिया गया। यह 10 मिनट तक चलता है।",
    "live.codeLabel": "6 अंकों का कोड",
    "cw.focusOn": "पूरी स्क्रीन: ऊपर की पट्टी छिपाएँ",
    "cw.focusOff": "ऊपर की पट्टी दिखाएँ",
    "ch.help": "मदद",
    "ch.guest.title": "जुड़ने में दिक्कत?",
    "ch.guest.t1": "कैमरा और माइक्रोफ़ोन वाले कंप्यूटर या फ़ोन का उपयोग करें। Chrome, Edge, Safari और Firefox सब चलते हैं।",
    "ch.guest.t2": "ब्राउज़र पूछे तो कैमरा और माइक्रोफ़ोन के लिए Allow दबाएँ।",
    "ch.guest.t3": "Join दबाने के बाद होस्ट को आपको अंदर लेना होगा। कृपया थोड़ा इंतज़ार करें।",
    "ch.guest.t4": "तस्वीर या आवाज़ नहीं आ रही? एड्रेस बार में कैमरा या ताला आइकन दबाएँ, Allow चुनें और पेज रिफ़्रेश करें।",
    "ch.guest.t5": "\"कॉल शुरू हो रही है…\" पर अटके हैं? इंटरनेट जाँचें, फिर Retry या नए टैब में खोलें दबाएँ।",
    "ch.guest.t6": "यह लिंक सिर्फ़ आपके लिए है। किसी और को जुड़ना हो तो LumberLinq टीम से उन्हें बुलाने को कहें।",
    "ch.customer.title": "स्क्रीन सपोर्ट कैसे काम करता है",
    "ch.customer.t1": "सपोर्ट आपकी स्क्रीन देखने को कहता है। जब तक आप खुद शेयर बटन नहीं दबाते, कुछ शुरू नहीं होता।",
    "ch.customer.t2": "सिर्फ़ LumberLinq टैब चुनें। पूरी स्क्रीन या कोई और विंडो न चुनें।",
    "ch.customer.t3": "सपोर्ट सिर्फ़ देख सकता है। वह आपके लिए क्लिक या टाइप नहीं कर सकता, और कुछ रिकॉर्ड नहीं होता।",
    "ch.customer.t4": "जब चाहें ऊपर Stop दबाकर रोक दें। फ़ोन या ऐप स्क्रीन शेयर नहीं कर सकते: कंप्यूटर पर Chrome या Edge इस्तेमाल करें।",
    "ch.host.title": "वीडियो कॉल गाइड",
    "ch.host.t1": "अकाउंट या डील से कॉल शुरू करें। आप होस्ट के रूप में जुड़ते हैं।",
    "ch.host.t2": "लिंक ई-मेल से भेजना सबसे सुरक्षित है: मेहमान को उसी पते पर आने वाला 6 अंकों का कोड चाहिए।",
    "ch.host.t3": "हर मेहमान तब तक इंतज़ार करता है जब तक आप कॉल में Admit नहीं दबाते। सिर्फ़ जान-पहचान वालों को अंदर लें।",
    "ch.host.t4": "नीचे \"कौन जुड़ा\" देखें। कोई अनजान हो तो उसे कॉल में हटाएँ और लिंक रद्द करें दबाएँ।",
    "ch.host.t5": "मेहमान का लिंक खुद कभी आगे न भेजें। हर व्यक्ति के लिए नया लिंक बनाएँ।",
    "ch.host.t6": "काम पूरा होने पर कॉल खत्म करें दबाएँ। अकाउंट की टाइमलाइन में वीडियो कॉल की एंट्री जुड़ जाती है। कुछ रिकॉर्ड नहीं होता।",
    "ch.check.run": "मेरा सेटअप जाँचें",
    "ch.check.testing": "जाँच हो रही है…",
    "ch.check.browserOk": "यह ब्राउज़र कॉल में जुड़ सकता है।",
    "ch.check.browserBad": "यह ब्राउज़र कॉल में नहीं जुड़ सकता। Chrome, Edge, Safari या Firefox इस्तेमाल करें।",
    "ch.check.onlineOk": "आपका इंटरनेट जुड़ा है।",
    "ch.check.onlineBad": "आप ऑफ़लाइन लग रहे हैं। इंटरनेट जाँचें।",
    "ch.check.camOk": "कैमरा चल रहा है।",
    "ch.check.camBad": "कैमरा बंद है या मिला नहीं। एड्रेस बार में अनुमति दें, फिर दोबारा जाँचें।",
    "ch.check.micOk": "माइक्रोफ़ोन चल रहा है।",
    "ch.check.micBad": "माइक्रोफ़ोन बंद है या मिला नहीं। एड्रेस बार में अनुमति दें, फिर दोबारा जाँचें।",
    "ch.check.shareOk": "आप अपनी स्क्रीन शेयर कर सकते हैं।",
    "ch.check.shareNo": "यह डिवाइस स्क्रीन शेयर नहीं कर सकता (फ़ोन और ऐप नहीं कर सकते)। आप बात और चैट कर सकते हैं।",
    "live.ended": "यह कॉल समाप्त हो चुकी है।",
    "live.expired": "यह लिंक समाप्त हो गया है। कृपया नया लिंक माँगें।",
    "live.off": "वीडियो कॉल अभी बंद हैं।",
    "live.invalid": "यह लिंक मान्य नहीं है।",
    "live.failed": "जुड़ नहीं सके। कृपया फिर कोशिश करें।",
    "live.securityWait": "कृपया सुरक्षा जाँच पूरी करें।",
    "live.frameHint": "अगर कॉल यहाँ नहीं दिखे, तो इसे नए टैब में खोलें।",
    "live.openTab": "नए टैब में खोलें",
    "ss.title": "स्क्रीन सहायता",
    "ss.joining": "जुड़ रहे हैं…",
    "ss.failed": "जुड़ नहीं सके। कृपया फिर कोशिश करें।",
    "ss.retry": "फिर कोशिश करें",
    "ss.howTitle": "अपना LumberLinq टैब कैसे साझा करें",
    "ss.step1": "कॉल के नीचे स्क्रीन-शेयर बटन (मॉनिटर आइकन) दबाएँ।",
    "ss.step2": "जिस टैब का नाम LumberLinq है (\"यह टैब\") उसे चुनें। कोई विंडो या पूरी स्क्रीन न चुनें।",
    "ss.step3": "आप अपने ब्राउज़र के \"साझा करना रोकें\" बटन से या यहाँ \"सत्र रोकें\" दबाकर कभी भी रोक सकते हैं।",
    "ss.noShare": "फ़ोन या ऐप में स्क्रीन साझा नहीं होती। अपना LumberLinq टैब साझा करने के लिए LumberLinq को कंप्यूटर ब्राउज़र (Chrome, Edge, Firefox या Safari) में खोलें। यहाँ आप सहायता टीम से बात और चैट फिर भी कर सकते हैं।",
    "ss.liveBanner": "सहायता टीम केवल वही टैब देख सकती है जिसे आप साझा करना चुनते हैं। कुछ भी रिकॉर्ड नहीं होता।",
    "ss.stop": "सत्र रोकें",
    "ss.stopConfirm": "यह स्क्रीन सहायता सत्र रोकें?",
    "ss.openTab": "नए टैब में खोलें",
    "ss.frameHint": "अगर कॉल यहाँ नहीं दिखे, तो इसे नए टैब में खोलें।",
    "ss.tabOnly": "केवल आपका LumberLinq ब्राउज़र टैब साझा होता है, और कुछ नहीं।",
    "ss.card.title": "स्क्रीन सहायता",
    "ss.card.ask": "सहायता टीम से मेरा LumberLinq टैब देखने को कहें",
    "ss.card.askHint": "सहायता टीम आपकी मदद के लिए आपका LumberLinq ब्राउज़र टैब देख सकती है। केवल वही टैब साझा होता है, शुरू आप करते हैं, और आप कभी भी रोक सकते हैं। कुछ भी रिकॉर्ड नहीं होता।",
    "ss.card.waiting": "सहायता टीम के जवाब का इंतज़ार है…",
    "ss.card.cancel": "अनुरोध रद्द करें",
    "ss.card.invited": "सहायता टीम आपका LumberLinq टैब देखना चाहती है।",
    "ss.card.invitedOther": "सहायता टीम ने आपकी कंपनी के किसी और व्यक्ति से स्क्रीन साझा करने को कहा है।",
    "ss.card.share": "मेरा LumberLinq टैब साझा करें",
    "ss.card.notNow": "अभी नहीं",
    "ss.card.live": "एक स्क्रीन सहायता सत्र खुला है।",
    "ss.card.liveOther": "आपकी कंपनी के किसी और व्यक्ति के साथ एक स्क्रीन सहायता सत्र खुला है।",
    "ss.card.rejoin": "सत्र खोलें",
    "ss.card.ended": "पिछला स्क्रीन सहायता सत्र समाप्त हो गया।",
    "ss.card.declined": "पिछला स्क्रीन सहायता अनुरोध अस्वीकार कर दिया गया।",
    "ss.card.expired": "पिछला स्क्रीन सहायता अनुरोध समाप्त हो गया।",
    "ss.card.requestFailed": "अनुरोध नहीं भेजा जा सका।",
    "ss.prompt.title": "सहायता टीम आपकी स्क्रीन देखना चाहती है",
    "ss.prompt.body": "सहायता टीम आपका इंतज़ार कर रही है। शुरू आप करते हैं और कभी भी रोक सकते हैं। कुछ भी रिकॉर्ड नहीं होता।",
    "ss.prompt.open": "अभी खोलें",
    "ss.prompt.later": "अभी नहीं",
    "ss.prompt.ticket": "टिकट खोलें",
  },
  pt: {
    "crmwa.newNumbers": "Números novos",
    "crmwa.newNumbersHint": "Pessoas que escreveram para você de um número que não está salvo no CRM.",
    "crmwa.tabNew": "Aguardando",
    "crmwa.tabBlocked": "Bloqueados",
    "crmwa.searchPlaceholder": "Buscar nome ou número…",
    "crmwa.firstMessage": "Primeira mensagem",
    "crmwa.lastMessage": "Mais recente",
    "crmwa.noName": "Nome não informado",
    "crmwa.notSaved": "Ainda não está no seu CRM",
    "crmwa.createLead": "Criar lead",
    "crmwa.block": "Bloquear como spam",
    "crmwa.unblock": "Desbloquear",
    "crmwa.blockedBadge": "Bloqueado",
    "crmwa.leadBadge": "Lead criado",
    "crmwa.openChat": "Abrir conversa",
    "crmwa.emptyTitle": "Nenhum número novo",
    "crmwa.emptySub": "Quando alguém novo enviar mensagem para o seu número de WhatsApp, a pessoa aparecerá aqui para você analisar. Contatos salvos nunca aparecem aqui.",
    "crmwa.emptyBlockedTitle": "Nenhum número bloqueado",
    "crmwa.emptyBlockedSub": "Os números que você bloqueia como spam aparecem aqui, para que você possa desbloqueá-los quando quiser.",
    "crmwa.selectTitle": "Selecione um número",
    "crmwa.selectSub": "Leia o que a pessoa escreveu e depois crie um lead ou bloqueie o número.",
    "crmwa.whatTheyWrote": "O que a pessoa escreveu",
    "crmwa.blockedNote": "As mensagens deste número são ignoradas. Desbloqueie para ver novas mensagens.",
    "crmwa.blockConfirmTitle": "Bloquear este número?",
    "crmwa.blockConfirmSub": "As novas mensagens dele serão ignoradas. Você pode desbloquear depois na aba Bloqueados.",
    "crmwa.cancel": "Cancelar",
    "crmwa.blockConfirm": "Sim, bloquear",
    "crmwa.blockedToast": "Número bloqueado",
    "crmwa.unblockedToast": "Número desbloqueado",
    "crmwa.leadCreatedToast": "Lead criado",
    "crmwa.leadCreatedSub": "A conversa agora está na sua Caixa de entrada.",
    "crmwa.errorTitle": "Algo deu errado",
    "crmwa.loadError": "Não foi possível carregar os números.",
    "crmwa.sheetTitle": "Criar lead",
    "crmwa.sheetSub": "Transforme este número de WhatsApp em um lead que sua equipe possa acompanhar.",
    "crmwa.fldName": "Nome da pessoa",
    "crmwa.fldNameHint": "Do perfil dela no WhatsApp. Você pode corrigir.",
    "crmwa.fldCompany": "Empresa (opcional)",
    "crmwa.fldCompanyHint": "Deixe em branco para usar o nome e o número da pessoa.",
    "crmwa.fldOwner": "Responsável pelo lead",
    "crmwa.ownerOnlyYou": "Este lead será seu.",
    "crmwa.fldNote": "Observação (opcional)",
    "crmwa.notePlaceholder": "Algo que a equipe deva saber…",
    "crmwa.accountWillBe": "Nome da conta",
    "crmwa.contactWillBe": "Contato",
    "crmwa.you": "Você",
    "crmwa.creating": "Criando…",
    "crmwa.whatHappens": "Isso cria uma conta, um contato com este número de celular e um negócio, e leva a conversa para a sua Caixa de entrada.",
    "crmwa.close": "Fechar",
    "crmwa.mobile": "Celular",
    "crmwa.pickOwner": "Escolha quem será o responsável por este lead",
    "crmwa.freeTextNote": "Você pode responder com texto livre por 24 horas após a última mensagem da pessoa.",
    "crmai.headerBtn": "Linc AI",
    "crmai.barOn": "O Linc AI está respondendo esta conversa",
    "crmai.barSuggest": "O Linc AI escreve sugestões de resposta para você",
    "crmai.barPaused": "Você está com esta conversa. O Linc AI fica em silêncio por um tempo.",
    "crmai.barHandoff": "O Linc AI passou esta conversa para você.",
    "crmai.barStopped": "O Linc AI está parado nesta conversa.",
    "crmai.stoppedSpam": "Parecia spam.",
    "crmai.stoppedFlood": "O cliente enviou mensagens demais, rápido demais.",
    "crmai.stoppedPerson": "Foi desligado aqui.",
    "crmai.takeOver": "Eu assumo",
    "crmai.stop": "Parar a IA aqui",
    "crmai.handBack": "Deixar o Linc AI responder",
    "crmai.draftTitle": "Sugestão do Linc AI",
    "crmai.draftHandoff": "O Linc AI acha que uma pessoa deve assumir",
    "crmai.draftUse": "Usar esta resposta",
    "crmai.draftDiscard": "Descartar",
    "crmai.takeOverToast": "O Linc AI ficará em silêncio nesta conversa",
    "crmai.stopToast": "Linc AI parado nesta conversa",
    "crmai.handBackToast": "O Linc AI voltará a responder",
    "crmai.settings": "Respostas do Linc AI",
    "crmai.settingsSub": "Escolha para quem o Linc AI responde e como.",
    "crmai.master": "Chave geral",
    "crmai.masterHint": "Desligado significa que o Linc AI nunca escreve para ninguém.",
    "crmai.modeOff": "Desligado",
    "crmai.modeSuggest": "Sugerir",
    "crmai.modeAuto": "Automático",
    "crmai.modeSuggestHint": "O Linc AI escreve um rascunho. Uma pessoa revisa e envia.",
    "crmai.modeAutoHint": "O Linc AI responde sozinho e passa para uma pessoa quando necessário.",
    "crmai.team": "Vendedores",
    "crmai.teamHint": "O Linc AI responde às conversas das contas de pessoas em Sugerir ou Automático.",
    "crmai.unowned": "Conversas sem responsável",
    "crmai.coreLocked": "Só um Super Admin ou Root pode alterar isto.",
    "crmai.limits": "Limites",
    "crmai.maxInRow": "Mensagens seguidas do Linc AI, depois passa para uma pessoa",
    "crmai.maxPerHour": "Máximo de mensagens do Linc AI por hora",
    "crmai.maxPerDay": "Máximo de mensagens do Linc AI por dia",
    "crmauto.chip": "Não revisado",
    "crmauto.chipTip": "Adicionado automaticamente a partir de uma mensagem do WhatsApp. Confira o nome e o número e toque em Confirmar.",
    "crmauto.confirm": "Confirmar contato",
    "crmauto.confirmTip": "Eu conferi este contato",
    "crmauto.confirmedTitle": "Confirmado",
    "crmauto.confirmedText": "A etiqueta Não revisado foi removida.",
    "crmauto.settingTitle": "Adicionar novos números do WhatsApp automaticamente",
    "crmauto.settingHint": "Quando alguém novo escrever no WhatsApp, adicione-o como contato automaticamente (com a etiqueta Não revisado) para que o Linc AI possa responder. Spam, excesso de mensagens e números bloqueados nunca são adicionados. Só um Super Admin ou Root pode alterar isto.",
    "crmauto.settingSwitch": "Adicionar novos números automaticamente",
    "crmauto.perDay": "Máximo de contatos adicionados automaticamente por dia",
    "legal.bannerTitleUpdated": "Documentos legais atualizados.",
    "legal.bannerLeadUpdated": "Atualizámos",
    "legal.bannerTitleNew": "Aceite os nossos documentos legais.",
    "legal.bannerLeadNew": "Reveja",
    "legal.dialogTitleUpdated": "Documentos legais atualizados",
    "legal.dialogTitleNew": "Documentos legais",
    "legal.dialogBodyUpdated": "Atualizámos os documentos abaixo. Reveja-os e confirme para continuar.",
    "legal.dialogBodyNew": "Reveja os documentos abaixo e confirme para continuar.",
    "invite.acceptTitle": "Entrar nesta empresa",
    "invite.acceptText": "Antes de entrar, confirme o acordo.",
    "invite.acceptButton": "Aceitar convite",
    "pay.offlineLive": "Esta página atualiza sozinha.",
    "pay.cardPaused": "O pagamento com cartão está pausado enquanto a sua transferência aguarda.",
    "pay.outcomeApprovedTitle": "O seu pagamento foi confirmado",
    "pay.outcomeApprovedBody": "O seu plano está ativo. Continue para começar a usar o LumberLinq.",
    "pay.outcomeContinue": "Continuar",
    "pay.outcomeRejectedTitle": "Não foi possível confirmar o seu pagamento",
    "pay.outcomeReversedTitle": "O seu pagamento foi estornado",
    "pay.outcomeTryAgainBody": "Pode enviá-lo novamente ou pagar de outra forma.",
    "pay.outcomeTryAgain": "Pagar novamente",
    "sp.seePlans": "Ver planos",
    "sp.backToWaiting": "Voltar ao meu pagamento",
    "sp.yourSelection": "A sua seleção",
    "adminOffline.waTemplate": "Mensagem de WhatsApp ao aprovar: nome do modelo",
    "adminOffline.waTemplateLang": "Idioma do modelo (por exemplo en ou hi)",
    "adminOffline.waValues": "Ordem dos valores nesse modelo (separados por vírgula: name, plan, amount, company, date, reference, method)",
    "adminOffline.waRejectedTemplate": "Nome do modelo quando um pagamento não pôde ser confirmado",
    "adminOffline.waRejectedLang": "Idioma desse modelo",
    "adminOffline.waPlanEndingTemplate": "Nome do modelo 3 dias antes do fim de um plano",
    "adminOffline.waPlanEndingLang": "Idioma desse modelo",
    "adminOffline.waValuesHint": "Cada mensagem acima só é enviada quando o nome do modelo está preenchido e aprovado na Meta. Use o idioma exatamente como a Meta mostra (en ou en_US).",
    "adminOffline.waTemplateHint": "Nome de um modelo UTILITY aprovado pela Meta, com três variáveis: primeiro nome, plano, valor. Deixe vazio para não enviar WhatsApp. O cliente sempre recebe push e e-mail.",
    "sp.seeAll": "Ver todas as funcionalidades",
    "sp.showLess": "Mostrar menos",
    "sp.chooseHint": "Escolha um plano para continuar",
    "pay.billingIncomplete": "Preencha os dados de faturação marcados a vermelho.",
    "pay.termsNotSaved": "Não foi possível guardar a sua aceitação dos termos. Tente novamente.",
    "pay.reviewAndPay": "Rever e pagar",
    "crmai.timing": "Tempo",
    "crmai.delay": "Espera antes de responder (segundos)",
    "crmai.pause": "Silêncio depois que uma pessoa responde (horas)",
    "crmai.offTitle": "Quando o Linc AI está desligado",
    "crmai.offHint": "Os clientes recebem esta mensagem no lugar, no máximo uma vez por período de silêncio em cada conversa.",
    "crmai.offSwitch": "Enviar esta mensagem quando o Linc AI estiver desligado",
    "crmai.offText": "Mensagem",
    "crmai.offPlaceholder": "Obrigado pela mensagem! Nossa equipe responderá em breve.",
    "crmai.knowledge": "O que o Linc AI pode usar",
    "crmai.links": "Links que ele pode compartilhar (um por linha)",
    "crmai.linksPlaceholder": "Preços: https://…\nTeste grátis: https://…",
    "crmai.facts": "Fatos sobre o LumberLinq (sem preços)",
    "crmai.factsPlaceholder": "O que o LumberLinq faz, para quem é, como funciona o teste…",
    "crmai.helpNotes": "Para dúvidas de como usar, ele também usa as notas da Ajuda do Linc AI.",
    "crmai.try": "Testar uma mensagem de cliente",
    "crmai.tryPlaceholder": "Digite o que um cliente poderia escrever…",
    "crmai.tryBtn": "Testar",
    "crmai.trying": "Pensando…",
    "crmai.tryIntent": "Entendido como",
    "crmai.tryHandoff": "Passaria para uma pessoa",
    "crmai.today": "Hoje",
    "crmai.statAuto": "Respondidas",
    "crmai.statDrafts": "Rascunhos",
    "crmai.statHandoffs": "Repassadas",
    "crmai.statTokens": "Tokens usados",
    "crmai.save": "Salvar",
    "crmai.saving": "Salvando…",
    "crmai.saved": "Salvo",
    "crmai.savedSub": "Configurações do Linc AI atualizadas.",
    "crmai.loadError": "Não foi possível carregar as configurações do Linc AI.",
    "crmai.abuseTitle": "Spam e mensagens demais",
    "crmai.abuseHint": "O Linc AI para por um tempo em uma conversa e depois volta a responder sozinho. Uma segunda parada em uma semana dura até uma pessoa ligá-lo. O cliente que envia mensagens demais recebe antes um aviso educado; spam evidente não recebe nada.",
    "crmai.floodMinutes": "Parar após mensagens demais (minutos)",
    "crmai.spamHours": "Parar após spam (horas)",
    "crmai.floodNotice": "Aviso enviado antes de parar por mensagens demais",
    "crmai.floodNoticePlaceholder": "Deixe vazio para usar: Não consigo responder a mais mensagens agora. Se for sobre o LumberLinq, um membro da equipe responderá em breve.",
    "crmai.resumesAt": "Volta sozinho em",
    "crmfile.kindImage": "Foto",
    "crmfile.kindVideo": "Vídeo",
    "crmfile.kindAudio": "Mensagem de voz",
    "crmfile.kindSticker": "Figurinha",
    "crmfile.kindDoc": "Documento",
    "crmfile.receiving": "Recebendo…",
    "crmfile.failed": "Não foi possível salvar. Abra o WhatsApp no celular para ver.",
    "crmfile.download": "Baixar",
    "crmfile.attach": "Anexar um arquivo",
    "crmfile.tooBigImage": "Uma foto pode ter até 5 MB.",
    "crmfile.tooBigFile": "Um arquivo pode ter até 10 MB.",
    "crmfile.notSent": "Arquivo não enviado",
    "crmfile.captionHint": "seu texto vai junto",
    "crmfile.captionPlaceholder": "Adicione uma mensagem para acompanhar o arquivo (opcional)…",
    "crmfile.remove": "Remover o arquivo",
    "crmverify.title": "Aprovar o acesso pelo WhatsApp?",
    "crmverify.text": "Alguém neste número de WhatsApp está pedindo ajuda ao assistente do LumberLinq sobre a sua conta:",
    "crmverify.hint": "Aprove somente se for você. A pessoa poderá então receber notas de ajuda que o seu perfil permite, por 15 minutos. Nada pode ser alterado.",
    "crmverify.more": "pedido(s) a mais aguardando",
    "crmverify.approve": "Aprovar",
    "crmverify.deny": "Negar",
    "crmverify.approvedTitle": "Aprovado",
    "crmverify.approvedSub": "O chat do WhatsApp pode receber ajuda por 15 minutos.",
    "crmverify.deniedTitle": "Negado",
    "crmverify.deniedSub": "Esse número fica bloqueado por uma hora.",
    "crmverify.expired": "Este pedido expirou ou já foi tratado.",
    "crmverify.settingTitle": "Suporte ao cliente pelo WhatsApp",
    "crmverify.settingHint": "O cliente que pede ajuda com a própria conta precisa provar quem é: um toque em Aprovar no aplicativo em que está logado, ou um código enviado ao e-mail cadastrado. Depois, o Linc AI responde só com as notas de ajuda que o perfil dele permite, e dados do plano só após aprovação no aplicativo por um Owner ou Admin da empresa. Nada é alterado pelo WhatsApp.",
    "crmverify.settingSwitch": "Permitir suporte ao cliente pelo WhatsApp",
    "crmqr.button": "Mensagens prontas",
    "crmqr.title": "Mensagens prontas",
    "crmqr.sub": "Escolha uma para perguntas comuns e marketing. Você pode editá-la antes de enviar.",
    "crmqr.search": "Buscar, ex.: preço, demo, offline…",
    "crmqr.all": "Todas",
    "crmqr.emptyTitle": "Nenhuma mensagem encontrada",
    "crmqr.emptySub": "Tente outras palavras ou limpe os filtros.",
    "crmqr.clear": "Limpar filtros",
    "crmqr.hint": "O primeiro nome do cliente é preenchido. A mensagem vai para a caixa e você aperta Enviar.",
    "crmqr.cat.welcome": "Boas-vindas",
    "crmqr.cat.product": "Produto",
    "crmqr.cat.pricing": "Preços",
    "crmqr.cat.start": "Começar",
    "crmqr.cat.help": "Ajuda",
    "crmqr.cat.qa": "Perguntas comuns",
    "crmqr.cat.followup": "Acompanhamento",
    "crmqr.cat.closing": "Encerramento",
    "tallysheet.tu.stockAllOrigins": "Todas as origens",
    "tallysheet.tu.stockOriginUnknown": "Origem desconhecida",
    "tallysheet.tu.pickOrigin": "Escolha uma origem",
    "inventory.rowOnlyFree": "Só {free} livres de {need} — toque para corrigir",
    "inventory.rowNoneFree": "Nenhum livre — toque para corrigir",
    "rowClash.needsOne": "linha foi adicionada no mesmo lugar que as linhas de outra pessoa",
    "rowClash.needsMany": "linhas foram adicionadas no mesmo lugar que as linhas de outra pessoa",
    "rowClash.prev": "Linha em conflito anterior",
    "rowClash.next": "Próxima linha em conflito",
    "rowClash.showOnlyTip": "Mostrar só as linhas que duas pessoas adicionaram no mesmo lugar",
    "rowClash.showAll": "Mostrar todas as linhas",
    "rowClash.showOnly": "Mostrar só estas",
    "rowClash.change": "Alterar",
    "rowClash.markCheckedTip": "Remove estas marcas para todos — nada é movido ou apagado",
    "rowClash.markChecked": "Marcar como verificado",
    "rowClash.title": "Linhas adicionadas no mesmo lugar",
    "rowClash.intro": "Duas pessoas adicionaram linhas no mesmo lugar desta planilha. Os dois conjuntos foram mantidos. Escolha a ordem, ou remova um conjunto se as mesmas toras foram medidas duas vezes.",
    "rowClash.rows": "Linhas:",
    "rowClash.wasThere": "Já estavam lá",
    "rowClash.wasPlaced": "Foram colocadas ao lado delas",
    "rowClash.chooseLabel": "O que deve acontecer?",
    "rowClash.current": "Atual",
    "rowClash.cannotMove": "Um trabalho sob medida está ligado a uma destas linhas, então a ordem não pode ser alterada.",
    "rowClash.confirmRemove": "Isto apaga estas linhas para todos. Não pode ser desfeito. Toque de novo para confirmar.",
    "rowClash.confirmYes": "Sim, remover",
    "rowClash.apply": "Aplicar",
    "rowClash.loadFailed": "Não foi possível carregar. Verifique a conexão e tente de novo.",
    "rowClash.noRoom": "Não há espaço para colocar as linhas ali. Recarregue a planilha e tente de novo.",
    "rowClash.applyFailed": "Não foi possível aplicar. Recarregue a planilha e tente de novo.",
    "rowClash.someone": "alguém",
    "rowClash.opt.mineAfter": "Manter ambos — as minhas depois das deles",
    "rowClash.opt.mineFirst": "Manter ambos — as minhas primeiro",
    "rowClash.opt.dropMine": "Manter as deles, remover as minhas",
    "rowClash.opt.deleteTheirs": "Manter as minhas, apagar as deles",
    "rowClash.opt.firstThen": "Manter ambos — primeiro as linhas de {first}, depois as de {second}",
    "rowClash.opt.keepOnly": "Manter as linhas de {keep}, remover as de {remove}",
    "rowClash.hint.order": "{first} primeiro, depois {second} — cada conjunto fica junto",
    "rowClash.hint.remove": "Remove {count} linha(s) adicionada(s) por {name}",
    "rowClash.placedTitle": "Linhas adicionadas no mesmo lugar",
    "rowClash.placedBody": "{count} das suas linhas foram colocadas depois das linhas que {names} adicionou no mesmo lugar. Use \"Linhas em conflito\" acima da planilha para verificar ou alterar.",
    "rowClash.placedAsIs": "{count} das suas linhas foram salvas, mas outra pessoa adicionou linhas no mesmo lugar. Verifique-as acima da planilha.",
    "syncIssues.keepMine": "Manter a minha (salvar sobre a alteração deles)",
    "syncIssues.rowConflict": "Outra pessoa alterou estas linhas enquanto você estava offline. Mantenha a sua, ou Descarte para manter a deles.",
    "tallysheet.rowConflict.title": "Alterado por outra pessoa",
    "tallysheet.rowConflict.message": "Outra pessoa alterou estas linhas depois que você abriu esta planilha. Linha:",
    "tallysheet.rowConflict.choice": "Manter a minha salva a sua versão por cima da outra. Ver a alteração salva as suas outras linhas e recarrega a planilha — a sua alteração nestas linhas é descartada.",
    "tallysheet.rowConflict.keepMine": "Manter a minha",
    "tallysheet.rowConflict.showTheirs": "Ver a alteração",
    "tallysheet.rowConflict.status": "Não salvo — outra pessoa alterou uma linha",
    "upload.sending": "Enviando",
    "offline.keepOffline": "Manter offline",
    "offline.removeFromOffline": "Remover do offline",
    "offline.keptOffline": "Salvo neste telefone — funciona offline com sua folha de contagem.",
    "offline.keepOfflineLater": "Será salvo neste telefone na próxima sincronização.",
    "offline.removedFromOffline": "Não é mais mantido offline (continua se for dos últimos 90 dias ou ainda aberto).",
    "offline.syncTitle": "Sincronização offline",
    "offline.lastSynced": "Última sincronização {when}",
    "offline.lastSyncedNever": "Ainda não sincronizado neste telefone",
    "offline.justNow": "agora mesmo",
    "offline.minAgo": "há {n} min",
    "offline.hoursAgo": "há {n} h",
    "offline.daysAgo": "há {n} dias",
    "offline.syncNow": "Sincronizar agora",
    "offline.youAreOffline": "Você está offline — as alterações ficam salvas neste telefone e são enviadas quando voltar a ficar online.",
    "syncIssues.tryAgain": "Tentar novamente",
    "offline.waitingSync": "aguardando sincronização",
    "offline.waitingSyncHint": "Salvo neste telefone — será enviado quando a internet voltar",
    "offlineLock.title": "Offline há muito tempo",
    "offlineLock.lead": "Este telefone está offline há 15 dias ou mais, por isso o app está bloqueado para proteger seus dados.",
    "offlineLock.changesSafe": "{n} alteração(ões) não sincronizada(s) estão guardadas neste telefone.",
    "offlineLock.waiting": "Conecte-se à internet para continuar. Depois você escolhe o que fazer com essas alterações.",
    "offlineLock.checking": "Conectando…",
    "offlineLock.askTitle": "Sincronizar suas alterações antigas?",
    "offlineLock.askBody": "Você tem {n} alteração(ões) de antes. Sim: são enviadas agora e você sai. Não: são excluídas e você sai.",
    "offlineLock.yes": "Sim, sincronizar",
    "offlineLock.no": "Não, excluir",
    "offlineLock.deletedTitle": "Alterações antigas excluídas",
    "offlineLock.deletedBody": "Suas {n} alteração(ões) antigas foram excluídas porque você escolheu Não.",
    "offline.removedTitle": "Alterações offline removidas",
    "offline.removedBody": "{n} alteração(ões) feitas offline neste telefone foram removidas, porque outro usuário entrou nele antes da sincronização. Insira-as novamente se ainda forem necessárias.",
    "offline.notSynced": "não sincronizado",
    "offline.notSyncedHint": "Alterações neste telefone ainda não salvas no servidor — toque para ver",
    "offline.itemSyncing": "item sincronizando…",
    "offline.itemsSyncing": "itens sincronizando…",
    "upload.of": "de",
    "upload.left": "restantes",
    "upload.processing": "Processando…",
    "upload.sent": "enviados",
    "upload.retry": "Tentar de novo",
    "upload.cancel": "Cancelar envio",
    "recon.piecesNotComparable": "A contagem de descarga é de outro tipo (Redonda x Quadrada), então as peças não podem ser comparadas — só a diferença de volume é usada.",
    "tallysheet.tu.reconReceived": "Recebido (conferido):",
    "tallysheet.tu.reconLoaded": "carregado",
    "tallysheet.tu.reconRecordedOnly": "apenas registrado (lote já serrado / vendido) — corrija o estoque com um ajuste",
    "recon.notReceived.title": "Esta Unidade de Estoque ainda não está no inventário.",
    "recon.notReceived.text": "Receba-a no inventário primeiro — depois faça a conferência, para que a diferença entre no estoque.",
    "recon.notReceived.askReceive": "Peça a alguém que pode receber estoque para recebê-la primeiro.",
    "recon.notReceived.done": "Recebida no inventário — agora você pode fazer a conferência.",
    "recon.notReceived.failed": "Não foi possível receber. Abra a Unidade de Estoque e confira produto, local e linhas da contagem.",
    "recon.stockWillChange": "Ao travar, o estoque passa a ser o que realmente chegou:",
    "invInOut.reconAlreadyAppliedTitle": "Conferência já aplicada",
    "invInOut.reconAlreadyAppliedText": "A conferência desta Unidade de Estoque já alterou o estoque em {cbm} CBM. Se este ajuste for pela mesma falta, o estoque foi corrigido duas vezes — desfaça com um ajuste oposto.",
    "tallysheet.tu.openingChipHint": "Estoque que a empresa já tinha no primeiro dia (adicionado com Estoque inicial).",
    "receive.volumeFromTallies": "O volume deste lote vem das contagens das suas Unidades de Estoque — corrija a contagem.",
    "invOverview.openingStock": "Estoque inicial",
    "invOverview.openingStockHint": "Adicione o estoque que você já tem",
    "tallysheet.tu.openingTitle": "Estoque inicial",
    "tallysheet.tu.openingSteps": "Estoque que você já tem. Salve, preencha a contagem (medidas e peças) e toque em Receber no Inventário. Sem modo de transporte; a remessa é opcional — vincule só se quiser o registro da compra.",
    "tallysheet.tu.openingDone": "Estoque que você já tinha — adicionado ao inventário. Vincule uma remessa só se quiser o registro da compra.",
    "appSettings.productTourSection": "Tours do produto",
    "appSettings.productTourEnabled": "Mostrar tours do produto",
    "appSettings.productTourHint": "Ligado: cada usuário vê o tour de cada página uma vez — concluído ou pulado, nunca mais aparece em nenhum dos seus dispositivos. Desligado: nenhum tour aparece e o botão Tour fica oculto.",
    "home.page.dashboard": "Painel",
    "home.page.tallySheets": "Folhas de contagem",
    "home.page.consignments": "Remessas",
    "home.page.inventory": "Estoque",
    "home.restricted.title": "Esta página ainda não faz parte da sua função",
    "home.restricted.text": "O administrador da sua empresa decide quais páginas sua função pode abrir. Você pode pedir acesso ou continuar trabalhando nas páginas abaixo.",
    "home.restricted.canOpen": "Páginas que você pode abrir",
    "home.restricted.goHome": "Ir para minha página inicial",
    "home.welcome.title": "Sua conta está pronta",
    "home.setup.title": "Preparando o seu acesso…",
    "home.setup.text": "O seu plano está ativo. Estamos preparando as suas páginas, leva alguns segundos.",
    "home.welcome.text": "Seu administrador ainda não deu nenhuma página à sua função. Peça acesso — ele receberá uma notificação na hora.",
    "home.welcome.profile": "Meu perfil",
    "home.welcome.logout": "Sair",
    "home.request.button": "Pedir acesso",
    "home.request.sent": "Pedido enviado",
    "home.request.sentNote": "Os administradores da sua empresa foram avisados. Você verá a página assim que atualizarem sua função.",
    "home.request.failed": "Não foi possível enviar o pedido. Tente novamente.",
    "home.roleHint.startsOn": "Sem Painel nesta função — os membros começarão em:",
    "home.roleHint.none": "Esta função ainda não abre nenhuma página principal — os membros verão uma tela de boas-vindas e poderão pedir acesso.",
    "plan.module.qualityGrading": "Classificação de Qualidade",
    "plan.module.inventoryModule": "Módulo de Inventário",
    "plan.module.processModule": "Módulo de Processo",
    "plan.module.dedicatedSupport": "Suporte Dedicado",
    "plan.value.unlimited": "Ilimitado",
    "plan.feature.teamMembers": "Membros da Equipa",
    "plan.feature.businessPartners": "Parceiros comerciais",
    "plan.feature.productsSpecies": "Produtos / Espécies",
    "plan.feature.loadingSites": "Locais",
    "plan.feature.tallySheets": "Folhas de contagem",
    "plan.feature.shipments": "Consignações",
    "plan.feature.transportUnits": "Unidades de Estoque",
    "plan.feature.photoUploads": "Envios de Fotos",
    "plan.feature.photoRetention": "Retenção de Fotos",
    "plan.feature.storage": "Armazenamento",
    "plan.feature.exportPdfExcel": "Exportar PDF e Excel",
    "plan.feature.importExcel": "Importar Excel",
    "plan.feature.basicReports": "Relatórios Básicos",
    "plan.feature.reconciliationReport": "Relatório de Reconciliação",
    "plan.feature.usersActivityReport": "Relatório de Atividade dos Utilizadores",
    "plan.feature.advancedAnalytics": "Análise Avançada",
    "plan.feature.aiImport": "Importação IA",
    "plan.feature.prioritySupport": "Suporte Prioritário",
    "plan.feature.consignments": "Consignações",
    "plan.feature.exportTallyPdfExcel": "Exportar Folhas (PDF+Excel)",
    "plan.feature.exportShipmentPdfExcel": "Exportar Consignação (PDF+Excel)",
    "plan.feature.importTallyExcel": "Importar Folhas (Excel)",
    "plan.feature.importShipmentExcel": "Importar Consignação (Excel)",
    "plan.unit.users": "utilizadores",
    "plan.unit.records": "registos",
    "plan.unit.sheets": "folhas",
    "plan.unit.sites": "locais",
    "plan.unit.units": "unidades",
    "plan.unit.photos": "fotos",
    "plan.unit.days": "dias",
    "plan.unit.mb": "MB",
    "plan.unit.creditsMonth": "créditos/mês",
    "common.monthly": "Mensal",
    "common.yearly": "Anual",
    "plan.compare.show": "Mostrar",
    "plan.compare.allFeatures": "Todas as Funcionalidades",
    "plan.compare.common": "Comum",
    "plan.compare.differences": "Diferenças",
    "plan.savePercentTemplate": "Poupe {pct}%",
    "plan.saveUpTo20": "Poupe até 20%",
    "plan.perMo": "/ mês",
    "plan.perYr": "/ ano",
    "common.language": "Idioma",
    "common.slowConnection": "Conexão lenta — as coisas podem demorar um pouco mais",
    "common.dismiss": "Dispensar",
    "planManagement.unavailableTitle": "Gerencie seu plano",
    "planManagement.unavailableDesc": "Isso não está disponível no aplicativo. Entre em contato com o administrador da sua conta.",
    "planManagement.backToDashboard": "Voltar ao Painel",
    "planManagement.contactAdmin": "Entre em contato com o administrador da sua conta.",
    "accountSetup.iosAllSetTitle": "Tudo pronto",
    "accountSetup.iosAllSetDesc": "Sua conta está pronta para uso. Comece a explorar o LumberLinq agora.",
    "accountSetup.iosAllSetGoToDashboard": "Ir para o Painel",
    "common.offlineStaleData": "Offline — exibindo dados em cache de",
    "common.offlineNotIncluded": "alterações neste telefone ainda não foram sincronizadas, por isso não estão incluídas aqui.",
    "common.preparingOfflineData": "Preparando dados offline…",
    "common.syncAreaBusinessPartners": "Parceiros de Negócios",
    "common.syncAreaProducts": "Produtos",
    "common.syncAreaLoadingSites": "Locais",
    "common.syncAreaTransportUnits": "Unidades de Estoque",
    "common.syncAreaDashboard": "Painel",
    "common.search": "Pesquisar",
    "common.status": "Status",
    "common.filter": "Filtrar",
    "common.actions": "Ações",
    "common.name": "Nome",
    "common.email": "Email",
    "common.user": "Usuário",
    "common.password": "Senha",
    "common.phone": "Telefone",
    "common.country": "País",
    "common.state": "Estado",
    "common.city": "Cidade",
    "common.reset": "Redefinir",
    "common.delete": "Excluir",
    "common.uploading": "Enviando...",
    "common.edit": "Editar",
    "common.active": "Ativo",
    "common.inactive": "Inativo",
    "common.blocked": "Bloqueado",
    "header.darkMode": "Modo Escuro",
    "header.newBtn": "Novo",
    "header.searchHint": "Pesquisar ou ir para…",
    "header.useClassic": "Usar cabeçalho clássico",
    "header.useNew": "Usar novo cabeçalho",
    "menuDock.useDock": "Usar menu em dock",
    "menuDock.useClassic": "Usar menu clássico",
    "menuDock.useDockRow": "Menu em dock",
    "menuDock.iconsLabel": "Ícones",
    "menuDock.iconSet.lucide": "Lucide",
    "menuDock.iconSet.phosphor": "Phosphor",
    "menuDock.iconSet.classic": "Clássico",
    "menuDock.more": "Mais",
    "menuDock.navLabel": "Menu principal",
    "menuDock.hideBar": "Ocultar barra inferior",
    "menuDock.focusMode": "Modo foco (ocultar as duas barras)",
    "menuDock.showBottomBar": "Mostrar barra inferior",
    "menuDock.showBars": "Mostrar barras",
    "menuDock.viewGroup": "Visualização",
    "menuDock.railPin": "Fixar o menu aberto",
    "menuDock.railUnpin": "Desafixar o menu",
    "companyForm.regionalSettings": "Configurações regionais",
    "companyForm.currency": "Moeda da empresa",
    "companyForm.currencyHint": "Usada como padrão para novas remessas e pagamentos e nos totais do painel. Os registros existentes mantêm a própria moeda.",
    "companyForm.timezone": "Fuso horário da empresa",
    "companyForm.timezoneHint": "Os limites mensais do plano reiniciam neste relógio. Novos membros da equipe também começam nele.",
    "quickSearch.lockedStock": "Os resultados de estoque não fazem parte do seu plano atual.",
    "quickSearch.lockedMill": "Os resultados de trabalhos de serraria não fazem parte do seu plano atual.",
    "quickSearch.seePlans": "Ver planos",
    "appSettings.nav.upgrade": "Fazer upgrade",
    "appSettings.inventoryLocked": "As configurações de estoque estão disponíveis nos planos que incluem o módulo de Estoque.",
    "tallyImport.button": "Importar do Tally",
    "tallyImport.tooltip": "Importar parceiros de uma exportação do Tally (Excel/CSV)",
    "tallyImport.dialogHeader": "Importar parceiros comerciais do Tally",
    "tallyImport.title": "Importação do Tally",
    "tallyImport.hint": "Exporte a lista de contas (ledgers) do Tally para Excel ou CSV e mantenha apenas Sundry Debtors e Sundry Creditors (as outras contas não são importadas). Devedores viram Compradores e credores viram Vendedores. O ID fiscal / GSTIN é opcional. Se as primeiras linhas do arquivo forem o título do relatório, use \"Ignorar linhas no topo\" abaixo.",
    "menuDock.railHide": "Ocultar o menu",
    "menuDock.railShow": "Mostrar o menu",
    "menuDock.hideHeader": "Ocultar barra superior",
    "menuDock.showHeader": "Mostrar barra superior",
    "menuDock.askLinc": "Perguntar ao Linc (ajuda de IA)",
    "header.lightMode": "Modo Claro",
    "header.fontSize": "Tamanho da Fonte",
    "notification.bellLabel": "Notificações",
    "notification.title": "Notificações",
    "notification.markAllRead": "Marcar tudo como lido",
    "notification.empty": "Você está em dia",
    "notification.disabled": "As notificações não estão disponíveis no momento",
    "notification.accept": "Aceitar",
    "notification.decline": "Recusar",
    "notification.accepted": "Aceito",
    "notification.switchHint": "Agora você pode alternar para ela a qualquer momento no menu do seu perfil",
    "notification.declined": "Recusado",
    "notification.viewAll": "Ver todas",
    "header.theme": "Tema",
    "header.preferences": "Preferências",
    "business.subtitle": "Gerencie seus parceiros e relacionamentos comerciais",
    "common.cancel": "Cancelar",
    "common.pcs": "pçs",
    "common.loading": "Carregando...",
    "common.unknown": "Desconhecido",
    "common.save": "Salvar",
    "sfs.pickStockUnit": "Qual Unidade de Estoque?",
    "sfs.pickConsignment": "Qual remessa?",
    "sfs.searchPlaceholder": "Digite um número ou nome",
    "sfs.searchHint": "Digite pelo menos 2 letras ou dígitos para buscar.",
    "sfs.searching": "Buscando…",
    "sfs.searchNone": "Nada encontrado. Tente outro número ou nome.",
    "sfs.searchFailed": "A busca falhou. Tente novamente.",
    "tally.keypad.addRowBelow": "Adicionar linha abaixo",
    "common.update": "Atualizar",
    "common.logout": "Sair",
    "common.clear": "Limpar",
    "common.saving": "Salvando…",
    "common.saved": "Salvo!",
    "common.saveFailed": "Falhou",
    "common.add": "Adicionar",
    "common.remove": "Remover",
    "common.calculate": "Calcular",
    "common.yes": "Sim",
    "common.no": "Não",
    "common.stayOnPage": "Permanecer Nesta Página",
    "common.signInAgain": "Entrar Novamente",
    "common.ok": "Ok",
    "common.confirmation": "Confirmação",
    "common.or": "ou",
    "common.required": "Obrigatório.",
    "common.isRequired": "é obrigatório.",
    "common.sectionHasErrors": "Esta seção tem erros de validação.",
    "common.success": "Sucesso",
    "common.error": "Erro",
    "common.created": "Criado",
    "common.somethingWentWrong": "Algo deu errado. Por favor, tente novamente.",
    "common.switchCompany": "Trocar de Empresa",
    "common.accountMenu": "Menu da conta",
    "common.confirmSwitchCompany": "Trocar de Empresa",
    "common.switchCompanyConfirmMessage": "Trocar sua empresa ativa para {{companyName}}? Você será movido para os dados e configurações desta empresa.",
    "common.switchCompanyBlockedUnsynced": "Você tem alterações que ainda não terminaram de sincronizar. Aguarde a conclusão da sincronização antes de trocar de empresa.",
    "common.leaveCompany": "Sair da empresa",
    "common.leaveCompanyConfirmMessage": "Sair de {{companyName}}? Você perderá o acesso a esta empresa, mas sua própria conta e empresa não são afetadas.",
    "common.info": "Informação",
    "common.validationError": "Erro de validação",
    "common.noRecordsFound": "Nenhum registro encontrado.",
    "common.pendingSync": "Sincronização pendente",
    "common.syncFailed": "Falha na sincronização",
    "common.needsRename": "Precisa renomear",
    "syncIssues.title": "Problemas de Sincronização",
    "syncIssues.subtitle": "Itens criados offline que o servidor rejeitou permanentemente — revise e descarte, ou corrija e recrie manualmente.",
    "syncIssues.emptyState": "Nenhum problema de sincronização — tudo o que foi criado offline foi sincronizado com sucesso.",
    "syncIssues.colType": "Tipo",
    "syncIssues.colItem": "Item",
    "syncIssues.colError": "Erro",
    "syncIssues.colCreated": "Criado",
    "syncIssues.discard": "Descartar",
    "syncIssues.confirmDiscard": "Descartar este item permanentemente? Ele nunca foi salvo no servidor e isso não pode ser desfeito.",
    "syncIssues.confirmDiscardHeader": "Descartar item",
    "syncIssues.discardedTitle": "Descartado",
    "syncIssues.discardedDetail": "O item foi removido.",
    "syncIssues.renamePlaceholder": "Novo nome",
    "syncIssues.renameAndRetry": "Renomear e tentar novamente",
    "syncIssues.retrySuccessTitle": "Sincronizado",
    "syncIssues.retrySuccessDetail": "Criado com sucesso com o novo nome.",
    "syncIssues.retryFailedTitle": "Falhou novamente",
    "common.records": "registros",
    "common.chooseColumns": "Escolher colunas",
    "common.searchKeyword": "Pesquisar palavra-chave",
    "common.hello": "Olá",
    "common.companyId": "ID da empresa",
    "common.firstName": "Nome",
    "common.lastName": "Sobrenome",
    "common.useDefault": "Usar padrão",
    "common.view": "Ver",
    "common.data": "Dados",
    "common.createdAt": "Criado em",
    "common.undo": "Desfazer",
    "common.redo": "Refazer",
    "common.import": "Importar",
    "common.refresh": "Atualizar",
    "common.downloadFailed": "Falha no Download",
    "common.downloadFailedDetail": "Não foi possível salvar o arquivo. Por favor, tente novamente.",
    "common.open": "Abrir",
    "common.copy": "Copiar",
    "common.revoke": "Revogar",
    "common.pageReport":
      "Mostrando {first} a {last} de {totalRecords} registros",
    "common.unsavedChangesHeader": "Alterações não salvas",
    "common.unsavedChangesMessage":
      "Você tem alterações não salvas. Deseja sair sem salvar?",
    "common.leaveLabel": "Sair",
    "common.stayLabel": "Ficar",
    "login.alreadyHaveAccount": "Já tem uma conta?",
    "login.signInNow": "Entrar agora!",
    "login.signUp": "Cadastrar",
    "login.nameRequired": "Nome é obrigatório.",
    "login.usernameRequired": "Usuário é obrigatório.",
    "login.validEmailRequired": "Digite um email válido.",
    "login.checkEmailTitle": "Verifique seu e-mail",
    "login.checkEmailBody": "Enviamos um link de verificação para",
    "login.checkEmailResent": "Um novo link foi enviado.",
    "login.checkEmailSignIn": "Entrar",
    "login.emailExists": "Email já existe.",
    "login.passwordRequired": "Senha é obrigatória.",
    "login.securityCheckLoading": "Carregando verificação de segurança…",
    "login.securityCheckUnavailable": "Verificação de segurança indisponível — o login fica bloqueado até que ela carregue.",
    "login.securityCheckRequired": "Conclua a verificação de segurança antes de continuar.",
    "login.choosePassword": "Escolha uma senha",
    "login.tooSimple": "Muito simples",
    "login.averageComplexity": "Complexidade média",
    "login.complexPassword": "Senha complexa",
    "login.dontHaveAccount": "Não tem uma conta?",
    "login.createToday": "Crie hoje!",
    "login.welcomeBack": "Bem-vindo de volta",
    "login.welcomeBackSub": "Entre na sua conta LumberLinq.",
    "login.createYourAccount": "Crie sua conta",
    "login.createYourAccountSub": "Comece a gerir o seu negócio de madeira em minutos.",
    "login.signIn": "Entrar",
    "login.emailRequired": "Email é obrigatório.",
    "login.forgotPassword": "Esqueceu a senha?",
    "login.loggedInAs": "Você já está logado como",
    "login.loggedInEmail": "Logado como",
    "login.errorNotification": "Notificação de erro",
    "login.userNotRegistered":
      "Nenhuma conta existe para este email. Cadastre-se primeiro.",
    "login.userAlreadyRegistered": "Esta conta já existe. Entre em vez disso.",
    "login.socialLoginFailed": "Falha no login social. Tente novamente.",
    "login.referredBy": "Você foi indicado por",
    "login.referredGeneric": "Você foi indicado ao LumberLinq.",
    "login.referredSignInInstead": "Entrar em vez disso",
    "login.signInWithApple": "Entrar com a Apple",
    "login.signUpWithApple": "Cadastrar-se com a Apple",
    "login.appleNoAccount": "Nenhuma conta LumberLinq está vinculada a este Apple ID. Crie uma conta gratuita na web e depois entre aqui.",
    "login.registrationDisabled":
      "Os cadastros estão temporariamente pausados — reservamos sua vaga e enviaremos um email assim que reabrirem.",
    "business.title": "Parceiros comerciais",
    "business.newPartner": "Novo parceiro",
    "business.bulkImport": "Importação em massa",
    "business.moreActions": "Mais ações",
    "business.selectRows": "Selecionar linhas",
    "business.selectedCount": "selecionados",
    "business.sortNameAsc": "Nome A–Z",
    "business.sortNameDesc": "Nome Z–A",
    "business.sortType": "Tipo",
    "business.sortCountry": "País",
    "common.done": "Concluído",
    "common.sort": "Ordenar",
    "common.activate": "Ativar",
    "business.deleteSelected": "Excluir selecionados",
    "business.searchPlaceholder":
      "Pesquisar por nome, email, contato, ID fiscal",
    "business.allStatus": "Todos os status",
    "business.edit": "Editar parceiro comercial",
    "business.create": "Criar parceiro comercial",
    "business.identity": "Identidade",
    "business.companyName": "Nome da empresa",
    "business.companyDetails": "Detalhes da empresa",
    "business.companyRegistration": "Registro da empresa",
    "business.industry": "Setor",
    "business.web": "Web",
    "business.companyBranding": "Marca da empresa",
    "business.logoUrl": "URL do logo",
    "business.logoPreview": "Prévia do logo da empresa",
    "business.contactPerson": "Pessoa de contato",
    "business.partyType": "Tipo de parte",
    "business.contactPersonShort": "Contato",
    "business.partyTypeShort": "Tipo",
    "business.selectType": "Selecionar tipo",
    "business.referenceCode": "Código de referência",
    "business.registrationType": "Tipo de registro",
    "business.taxId": "ID fiscal",
    "company.reportingCurrency": "Moeda de Relatório",
    "company.reportingCurrencyHint": "Os totais do painel e dos relatórios são convertidos para esta moeda.",
    "shipments.fxRateToBase": "Taxa de Câmbio para a Moeda de Relatório",
    "shipments.convertedAmount": "Valor Convertido",
    "dashV5.convertedTooltip": "Convertido para a moeda de relatório usando as taxas de câmbio registradas em cada consignação. Valores sem taxa registrada são excluídos.",
    "dashV5.approxConverted": "aprox., convertido",
    "dashV5.noRate": "sem taxa",
    "dashV5.noRateTooltip": "Nenhuma taxa de câmbio registrada — excluído do total convertido. Defina a Taxa de Câmbio para a Moeda de Relatório na consignação.",
    "business.partyCategory": "Categoria da parte",
    "business.selectCategory": "Selecionar categoria",
    "business.activePartner": "Parceiro ativo",
    "business.contactLocation": "Contato e localização",
    "business.website": "Site",
    "business.address1": "Endereço linha 1",
    "business.address2": "Endereço linha 2",
    "business.zipCode": "CEP",
    "business.operations": "Operações",
    "business.linkedUserId": "ID de usuário vinculado",
    "business.externalCode": "Código externo",
    "business.tags": "Tags",
    "business.selectTags": "Selecionar tags",
    "business.notes": "Notas",
    "business.attachFiles": "Anexar arquivos",
    "business.bankAccounts": "Contas bancárias",
    "business.bankName": "Nome do banco",
    "business.accountNo": "Número da conta",
    "business.confirmAccountNo": "Confirmar número da conta",
    "business.accountNoMismatch": "Os números da conta não coincidem",
    "business.currency": "Moeda",
    "business.addBankAccount": "Adicionar conta bancária",
    "business.savePartner": "Salvar parceiro",
    "business.updatePartner": "Atualizar parceiro",
    "business.noPartnersFound": "Nenhum parceiro encontrado.",
    "business.regType": "Tipo reg.",
    "route.login.header": "Bem-vindo de volta!",
    "route.buyers.manage": "Ver e gerenciar perfis de compradores existentes",
    "layout.searchMenu": "Pesquisar menu...",
    "layout.noMenuItems": "Nenhum item de menu encontrado.",
    "layout.footerRights": "Todos os direitos reservados.",
    "layout.poweredBy": "Desenvolvido por Lumber Linq",
    "layout.loveApp": "Gostou do app?",
    "layout.useForBusiness": "Use no seu próprio negócio!",
    "user.add": "Adicionar usuário",
    "user.create": "Criar usuário",
    "user.inputDetails": "Inserir dados do novo usuário no sistema",
    "user.manage": "Gerenciar usuário",
    "user.manageProfiles": "Ver e administrar perfis de usuários",
    "user.profile": "Editar perfil",
    "user.profileSubheader": "Modificar seus dados pessoais",
    "user.confirmDeletion": "Confirmar exclusão de usuário",
    "user.deleteConfirm": "Tem certeza de que deseja excluir este usuário?",
    "user.typeEmail": "Confirme digitando o email do usuário abaixo:",
    "user.emailPlaceholder": "Email do usuário",
    "user.addEmailAddress": "Adicionar email",
    "user.invalidEmail": "Email inválido",
    "user.enterEmail": "Digite o email",
    "user.invitationAccepted": "Convite aceito",
    "user.resend": "Reenviar",
    "user.admin": "Admin",
    "user.cannotUndo": "Esta ação não pode ser desfeita.",
    "shipment.namePlural": "Consignações",
    "tallysheet.namePlural": "Tallysheets",
    "tallysheet.all": "Todos os tallysheets",
    "tallysheet.manageDetails":
      "Ver e gerenciar detalhes dos tallysheets existentes",
    "containerPrivacy.title": "Privacidade do contêiner",
    "subscription.title": "Assinatura",
    "subscription.selectUpdatePlan":
      "Selecionar ou atualizar seu plano de assinatura",
    "subscription.view": "Ver assinatura",
    "subscription.subheader": "Subtítulo da assinatura",
    "utility.costEstimate": "Estimativa de custo",
    "utility.volumeEstimation": "Estimativa de volume",
    "utility.volumeCostEstimation": "Estimativa de volume e custo",
    "utility.unitConversion": "Conversão de unidades",
    "utility.calculator": "Calculadora",
    "utility.selectUnit": "Selecionar unidade",
    "utility.generateSlab": "Gerar preços de placas",
    "utility.decimalPlace": "Casas decimais",
    "utility.decimalPlaces": "Casas decimais",
    "utility.from": "De",
    "utility.to": "Para",
    "utility.unit": "Unidade",
    "utility.fromValue": "Valor de origem",
    "utility.fromUnit": "Unidade de origem",
    "utility.toValue": "Valor de destino",
    "utility.toUnit": "Unidade de destino",
    "utility.reverse": "Inverter",
    "utility.useCommonUnits": "Usar unidades comuns para todas as linhas",
    "utility.width": "Largura",
    "utility.widthUnit": "Unidade de largura",
    "utility.thickness": "Espessura",
    "utility.thicknessUnit": "Unidade de espessura",
    "utility.length": "Comprimento",
    "utility.lengthUnit": "Unidade de comprimento",
    "utility.price": "Preço",
    "utility.priceUnit": "Unidade de preço",
    "utility.quantity": "Quantidade",
    "utility.total": "Total",
    "utility.rate": "Taxa",
    "utility.slabOfRate": "Faixa da taxa",
    "utility.slabPriceSize": "Tamanho do preço da placa",
    "utility.slabSize": "Tamanho da placa",
    "utility.upperSlabs": "Faixas superiores",
    "utility.lowerSlabs": "Faixas inferiores",
    "utility.slabPrice": "Preço da placa",
    "utility.volumeOnly": "Só volume",
    "utility.volumeAndCost": "Volume + custo",
    "utility.clearAll": "Limpar tudo",
    "utility.clearAllConfirm": "Remover todos os itens e recomeçar?",
    "utility.addItem": "Adicionar item",
    "utility.item": "Item",
    "utility.duplicateItem": "Duplicar item",
    "utility.removeItem": "Remover item",
    "utility.itemRemoved": "Item removido",
    "utility.totals": "Totais",
    "utility.pieces": "Peças",
    "utility.cftNote": "CFT = CBM × 35,3147. Os valores só são arredondados ao exibir, e os valores em dinheiro com 2 casas decimais.",
    "utility.copySummary": "Copiar resumo",
    "utility.copyFailed": "Não foi possível copiar",
    "utility.swap": "Trocar",
    "utility.saveConversion": "Salvar no histórico",
    "utility.allUnits": "O mesmo valor em todas as unidades",
    "utility.history": "Conversões salvas",
    "utility.historyEmpty": "Toque no marcador para salvar uma conversão e ela aparecerá aqui.",
    "utility.clearHistory": "Limpar histórico",
    "utility.clearHistoryConfirm": "Remover todas as conversões salvas?",
    "utility.useThis": "Usar esta conversão",
    "utility.incompleteTitle": "Dados incompletos",
    "utility.incompleteBody": "Digite um valor e escolha as duas unidades primeiro.",
    "utility.duplicateTitle": "Já salvo",
    "utility.duplicateBody": "Esta conversão já está na sua lista.",
    "utility.savedTitle": "Salvo",
    "utility.baseSection": "Preço base",
    "utility.baseRange": "Faixa da placa base",
    "utility.stepSection": "Passos das placas",
    "utility.rangeSection": "Placas a mostrar",
    "utility.priceLadder": "Escada de preços",
    "utility.slabs": "placas",
    "utility.copyAll": "Copiar tudo",
    "utility.negativeRate": "Alguns preços estão abaixo de zero. Reduza o passo de preço ou o número de placas inferiores.",
    "utility.baseSlab": "Sua placa",
    "utility.ladderEmpty": "Informe a taxa, a placa da taxa, o tamanho da placa e o passo de preço para ver a escada de preços.",
    "dashboardNew.title": "Painel",
    "menu.dashboard": "Painel",
    "menu.dashboardNew": "Novo painel",
    "menu.shipments": "Consignações",
    "menu.tallysheets": "Tallysheets",
    "menu.newTallysheet": "Novo tallysheet",
    "menu.products": "Produtos",
    "menu.loadingSites": "Locais",
    "menu.businessPartners": "Parceiros comerciais",
    "menu.containerPrivacy": "Privacidade do contêiner",
    "menu.company": "Empresa",
    "menu.companyProfile": "Perfil da empresa",
    "menu.companyBranding": "Marca da empresa",
    "menu.subscription": "Assinatura",
    "menu.utility": "Utilitário",
    "menu.directory": "Diretório",
    "menu.tools": "Ferramentas",
    "menu.section.overview": "Visão geral",
    "menu.section.operations": "Operações",
    "menu.section.data": "Dados e Relatórios",
    "menu.section.platform": "Plataforma",
    "sidebar.recent": "Recentes",
    "sidebar.copied": "Copiado",
    "sidebar.new": "Novo",
    "sidebar.newConsignment": "Remessa",
    "sidebar.newStockUnit": "Unidade de Estoque",
    "sidebar.newBusinessPartner": "Parceiro de Negócios",
    "sidebar.newProduct": "Produto",
    "sidebar.newLocation": "Local",
    "menu.costEstimate": "Estimativa de custo",
    "menu.volumeEstimate": "Estimativa de volume",
    "menu.volumeEstimates": "Estimativas de volume",
    "menu.unitConversion": "Conversão de unidades",
    "menu.slabGenerator": "Gerador de placas",
    "menu.generateSlab": "Gerar placa",
    "menu.users": "Usuários",
    "menu.addUser": "Adicionar usuário",
    "menu.manageUsers": "Gerenciar usuários",
    "menu.userProfile": "Perfil do usuário",
    "menu.editProfile": "Editar perfil",
    "menu.addBusinessPartner": "Adicionar parceiro comercial",
    "menu.viewBusinessPartner": "Ver parceiro comercial",
    "menu.viewBusinessPartners": "Ver parceiros comerciais",
    "menu.addProduct": "Adicionar produto",
    "menu.viewProduct": "Ver produto",
    "menu.viewProducts": "Ver produtos",
    "menu.addLoadingSite": "Adicionar local",
    "menu.viewLoadingSite": "Ver local",
    "menu.viewLoadingSites": "Ver locais",
    "menu.addTallysheet": "Adicionar tallysheet",
    "menu.viewTallysheet": "Ver tallysheet",
    "menu.listTallysheet": "Listar tallysheet",
    "menu.addShipment": "Adicionar consignação",
    "menu.viewShipment": "Ver consignação",
    "menu.listShipments": "Listar consignações",
    "menu.storage": "Armazenamento",
    "menu.branding": "Marca",
    "menu.admin": "Admin",
    "menu.adminDashboard": "Painel admin",
    "menu.subscriptionDashboard": "Painel de assinatura",
    "menu.reports": "Relatórios",
    "menu.financialReport": "Relatório financeiro",
    "menu.reconciliationReport": "Relatório de conciliação",
    "menu.accessField": "Campo de acesso",
    "menu.tallysheetAccessField": "Campo de acesso do tallysheet",
    "menu.businessPartnerReport": "Relatório de parceiros comerciais",
    "menu.shipmentReport": "Relatório de consignações",
    "menu.productReport": "Relatório de produtos",
    "menu.loadingSiteReport": "Relatório de locais",
    "menu.transportUnitReport": "Relatório de unidades de estoque",
    "menu.tallysheetReport": "Relatório de tallysheet",
    "menu.operators": "Operadores",
    "menu.addTransportUnit": "Adicionar Unidade de Estoque",
    "menu.transportUnitFieldAccess": "Acesso a Campos da Unidade de Estoque",
    "menu.tallyReport": "Relatório de Contagem",
    "menu.analytics": "Análises",
    "menu.usersReport": "Relatório de usuários",
    "menu.inventoryReport": "Relatório de inventário",
    "route.companyProfile": "Perfil da sua empresa",
    "route.companyProfileDetails":
      "Ver ou editar os detalhes do perfil da sua empresa",
    "route.companyLogo": "Gerenciar o logo da sua empresa",
    "route.convertUnitsHeader": "Converter unidades",
    "route.convertUnitsSubheader":
      "Insira suas medidas e selecione unidades para conversão",
    "route.costEstimateHeader": "Estime seus custos",
    "route.costEstimateSubheader":
      "Insira os parâmetros e calcule o custo projetado",
    "route.containerPrivacyHeader":
      "Gerenciar configurações de privacidade do contêiner",
    "route.containerPrivacySubheader":
      "Ver e personalizar níveis de privacidade dos campos do contêiner",
    "dashboardNew.company": "Empresa",
    "dashboardNew.role": "Função",
    "dashboardNew.filterRange": "Filtrar período",
    "dashboardNew.refresh": "Atualizar",
    "dashboardNew.noData": "Sem dados",
    "dashboardNew.originDestination": "Origem vs destino CBM (30d)",
    "dashboardNew.topPartners": "Principais parceiros por volume",
    "dashboardNew.fleetHealth": "Saúde da frota",
    "dashboardNew.shipmentPipeline": "Pipeline de consignações",
    "dashboardNew.tallyAccuracy": "Precisão do tally por porto",
    "dashboardNew.liveOperations": "Operações ao vivo",
    "dashboardNew.alerts": "Alertas e exceções",
    "dashboardNew.recentActivity": "Atividade recente",
    "shipment.list": "Consignações",
    "shipment.singular": "Consignação",
    "shipment.new": "Nova consignação",
    "shipment.searchPlaceholder":
      "Pesquisar tudo (BL, pedido, ref. exportação, remetente...)",
    "shipment.blNumber": "Nº do Documento",
    "shipment.type": "Tipo",
    "shipment.date": "Data",
    "shipment.buyerOrder": "Pedido do comprador",
    "shipment.exportRef": "Ref. exportação",
    "shipment.shipper": "Remetente",
    "shipment.consignee": "Consignatário",
    "shipment.noFound": "Nenhuma consignação encontrada.",
    "shipment.noFoundSub": "Crie uma nova consignação para começar.",
    "shipment.noBl": "Sem BL#",
    "shipment.sharedLinks": "Links compartilhados",
    "shipment.newLink": "Novo link compartilhado",
    "shipment.access": "Acesso",
    "shipment.expiry": "Expiração",
    "shipment.active": "Ativo",
    "shipment.oneTime": "Uso único",
    "shipment.used": "Usado",
    "shipment.createEdit": "Consignação - criar / editar",
    "shipment.create": "Criar Consignação",
    "shipment.edit": "Editar Consignação",
    "shipment.saveConsignment": "Salvar Consignação",
    "shipment.updateConsignment": "Atualizar Consignação",
    "shipment.details": "Detalhes da consignação",
    "shipmentForm.tabDeal": "Negócio",
    "shipmentForm.tabRoute": "Rota e prazos",
    "shipmentForm.tabMoney": "Dinheiro",
    "shipmentForm.dealTitle": "O negócio",
    "shipmentForm.dealBasics": "Tipo, modo e data",
    "shipmentForm.dealBasicsHelp": "Escolha primeiro o tipo: ele decide quais campos aparecem em cada aba.",
    "shipmentForm.references": "Referências",
    "shipmentForm.referencesHelp": "Os números que a sua equipa e os seus parceiros usam para encontrar esta consignação.",
    "shipmentForm.referencesHelpLocal": "Os números da fatura e do documento usados para encontrar esta consignação.",
    "shipmentForm.parties": "Partes",
    "shipmentForm.partiesHelp": "Pelo menos uma das partes (expedidor, consignatário ou parte a notificar) tem de ser a sua própria empresa. É preenchida automaticamente quando o tipo o torna óbvio.",
    "shipmentForm.ownerMissing": "Uma das partes tem de ser a sua própria empresa.",
    "shipmentForm.buyerDetails": "Dados do comprador",
    "shipmentForm.buyerDetailsHelpSale": "Necessário antes de a mercadoria sair: o número fiscal do comprador e quem a recebe.",
    "shipmentForm.buyerDetailsHelpPurchase": "Opcional numa compra. O seu número fiscal é preenchido automaticamente.",
    "shipmentForm.notes": "Notas",
    "shipmentForm.routeTitle": "Rota e prazos",
    "shipmentForm.timing": "Datas, destino e condições",
    "shipmentForm.timingHelp": "Quando sai e chega, e as condições de envio acordadas. O mesmo dia é permitido.",
    "shipmentForm.transit": "Tempo de trânsito",
    "shipmentForm.sameDay": "No mesmo dia",
    "shipmentForm.days": "dias",
    "shipmentForm.docsTitle": "Documentos",
    "shipmentForm.docChecklist": "Documentos arquivados",
    "shipmentForm.docChecklistNote": "Conta um número ou um ficheiro carregado. Esta lista só lembra; nunca impede de guardar. Junte o certificado de fumigação em Outros documentos com a etiqueta Fumigation.",
    "shipmentForm.docNumbers": "Números de documentos",
    "shipmentForm.docNumbersHelp": "Números de certificados e licenças desta consignação.",
    "shipmentForm.coNo": "N.º do certificado de origem",
    "shipmentForm.fumigationNo": "N.º do certificado de fumigação",
    "shipmentForm.insuranceDetails": "Detalhes do seguro",
    "shipmentForm.ewayNo": "N.º da e-way bill",
    "shipmentForm.quickLabels": "Etiquetas rápidas",
    "shipmentForm.doc.bl": "Conhecimento de embarque",
    "shipmentForm.doc.bill": "Fatura / documento",
    "shipmentForm.doc.invoice": "Fatura comercial",
    "shipmentForm.doc.packing": "Lista de embalagem",
    "shipmentForm.doc.co": "Certificado de origem",
    "shipmentForm.doc.phyto": "Certificado fitossanitário",
    "shipmentForm.doc.fumigation": "Certificado de fumigação",
    "shipmentForm.doc.eway": "E-way bill / LR",
    "shipmentForm.sumLabel": "Resumo da consignação",
    "shipmentForm.noBlYet": "Ainda não indicado",
    "shipmentForm.unsaved": "Alterações por guardar",
    "shipmentForm.status": "Estado",
    "shipmentForm.changeStatus": "Alterar estado",
    "shipmentForm.sumToggle": "Mostrar ou ocultar o resumo",
    "shipmentForm.stepperLabel": "Progresso desta consignação",
    "shipmentForm.invoice": "Fatura",
    "shipmentForm.outstanding": "Em aberto",
    "shipmentForm.readyLabel": "pronto",
    "shipmentForm.type.EXPORT": "Exportação",
    "shipmentForm.type.IMPORT": "Importação",
    "shipmentForm.type.DOMESTIC_SALE": "Venda interna",
    "shipmentForm.type.DOMESTIC_PURCHASE": "Compra interna",
    "shipmentForm.type.TRADING": "Comércio",
    "shipmentForm.mode.SEA": "Mar",
    "shipmentForm.mode.AIR": "Ar",
    "shipmentForm.mode.ROAD": "Estrada",
    "shipmentForm.mode.RAIL": "Comboio",
    "shipmentForm.ready.type": "Tipo e modo escolhidos",
    "shipmentForm.ready.parties": "Vendedor e comprador escolhidos",
    "shipmentForm.ready.bl": "Número do conhecimento de embarque",
    "shipmentForm.ready.bill": "Número da fatura",
    "shipmentForm.ready.dates": "Datas de partida e chegada",
    "shipmentForm.ready.ports": "Portos de carga e descarga",
    "shipmentForm.ready.vehicle": "Rota e dados do veículo",
    "shipmentForm.ready.rail": "Estações de origem e destino",
    "shipmentForm.ready.units": "Pelo menos uma Unidade de Stock adicionada",
    "shipmentForm.ready.docs": "Todos os documentos esperados arquivados",
    "shipmentForm.ready.invoice": "Valor da fatura indicado",
    "shipmentForm.ready.terms": "Condições de pagamento escolhidas",
    "shipmentForm.depRequired": "A partida estimada é obrigatória",
    "shipmentForm.arrRequired": "A chegada estimada é obrigatória",
    "shipmentForm.billRequired": "O número da fatura é obrigatório",
    "shipmentForm.blRequired": "O número do conhecimento de embarque é obrigatório numa consignação marítima",
    "shipmentForm.requiredHere": "Obrigatório",
    "shipmentForm.paymentTermsNeeded": "As condições de pagamento são necessárias quando há valor da fatura",
    "shipmentForm.paymentTermsHint": "Necessárias quando indicar o valor da fatura: dão a data de vencimento e os lembretes de atraso.",
    "shipmentForm.savePaymentsFirst": "Guarde primeiro a consignação para registar pagamentos.",
    "shipmentForm.pricePerCbm": "Fatura por CBM",
    "shipmentForm.paidSoFar": "Pago até agora",
    "shipmentForm.receivedSoFar": "Recebido até agora",
    "shipmentForm.stockHelpBtn": "Que Unidades de Stock aparecem aqui?",
    "shipmentForm.stockHint": "Escreva parte do ID da Unidade de Stock, do n.º do contentor / camião ou do produto. Prima ? para ver quais são listadas.",
    "shipmentForm.stockHintNew": "Escreva parte do ID, do n.º do contentor / camião ou do produto. As unidades adicionadas ficam ligadas ao guardar. Prima ? para ver quais são listadas.",
    "shipmentForm.stockHelp.title": "Que Unidades de Stock são listadas?",
    "shipmentForm.stockHelp.lead": "A lista mostra as Unidades de Stock da sua empresa que servem para esta consignação.",
    "shipmentForm.stockHelp.shown": "Listadas",
    "shipmentForm.stockHelp.hidden": "Não listadas",
    "shipmentForm.stockHelp.s1": "Ainda sem consignação",
    "shipmentForm.stockHelp.s2": "A direção certa: Saída numa venda, Entrada numa compra",
    "shipmentForm.stockHelp.s3": "Recebida ou confirmada não importa",
    "shipmentForm.stockHelp.h1": "Já numa outra consignação",
    "shipmentForm.stockHelp.h2": "A direção oposta (uma Saída nunca aparece numa compra)",
    "shipmentForm.stockHelp.h3": "Unidades de transferência entre locais e registos de saída do moinho",
    "shipmentForm.stockHelp.h4": "Nada escrito ainda, ou sem correspondência com o ID, ID de transporte, n.º do contentor / camião ou produto",
    "shipmentForm.stockHelp.tip": "Não a encontra? Verifique a Direção no ecrã da Unidade de Stock.",
    "shipmentForm.stockHelp.locked": "Adicionar fica desligado quando a consignação está Fechada, Cancelada, ou é uma venda que já partiu.",
    "shipmentForm.statusDialogTitle": "Alterar estado",
    "shipmentForm.statusForwardNote": "O stock desta consignação já foi recebido, por isso o estado só pode avançar.",
    "shipmentForm.receiveMark": "Oferece Receber no Inventário",
    "shipmentForm.current": "Atual",
    "shipmentForm.setStatus": "Definir estado",
    "shipmentForm.statusPressUpdate": "Prima Atualizar para guardar o novo estado.",
    "shipmentForm.statusPressSave": "Prima Guardar para manter o novo estado.",
    "shipmentForm.statusForwardTitle": "O estado só pode avançar",
    "shipmentForm.statusForwardSub": "O stock desta consignação já foi recebido. O estado ainda pode avançar, mas não recuar nem passar a Cancelada.",
    "shipmentForm.activity": "Atividade",
    "shipmentForm.activityTip": "Quem criou esta consignação, quando mudou e o histórico de estados",
    "loginBar.signedIn": "Já tem sessão iniciada.",
    "loginBar.continue": "Continuar para o LumberLinq",
    "loginBar.switch": "Iniciar sessão com outra conta",
    "shipmentForm.priceCheckHigh": "Este preço por CBM é muito mais alto do que nas suas consignações anteriores (cerca de {typical}). Verifique o valor.",
    "shipmentForm.priceCheckLow": "Este preço por CBM é muito mais baixo do que nas suas consignações anteriores (cerca de {typical}). Verifique o valor.",
    "shipment.status.SHIPPED": "Expedido",
    "shipmentForm.raw.backToConsignments": "Voltar às consignações",
    "shipmentForm.raw.goodsHaveArrivedReadyToReceiveInto": "A mercadoria chegou — pronta para receber no inventário?",
    "shipmentForm.raw.filledIn": "Preenchido",
    "shipmentForm.raw.thisTabHasValidationErrors": "Este separador tem erros de validação",
    "shipmentForm.raw.consignmentDateIsRequired": "A data da consignação é obrigatória",
    "shipmentForm.raw.blType": "Tipo de BL",
    "shipmentForm.raw.searchShipper": "Procurar expedidor",
    "shipmentForm.raw.searchConsignee": "Procurar consignatário",
    "shipmentForm.raw.searchNotifyParty": "Procurar parte a notificar",
    "shipmentForm.raw.arrivalCannotBeBeforeDeparture": "A chegada não pode ser anterior à partida",
    "shipmentForm.raw.countryOfDestination": "País de destino",
    "shipmentForm.raw.portCarrierDetails": "Detalhes do porto e do transportador",
    "shipmentForm.raw.portOfLoadingIsRequired": "O porto de carga é obrigatório",
    "shipmentForm.raw.portOfDischargeIsRequired": "O porto de descarga é obrigatório",
    "shipmentForm.raw.otherNotListed": "Outro (não listado)",
    "shipmentForm.raw.enterShippingLineName": "Indique o nome da linha de navegação",
    "shipmentForm.raw.customShippingLine": "Linha de navegação personalizada",
    "shipmentForm.raw.vesselName": "Nome do navio",
    "shipmentForm.raw.voyageNumber": "Número da viagem",
    "shipmentForm.raw.flightNumber": "Número do voo",
    "shipmentForm.raw.roadTransportDetails": "Detalhes do transporte rodoviário",
    "shipmentForm.raw.vehicleLrNo": "N.º do veículo / LR",
    "shipmentForm.raw.railMovementDetails": "Detalhes do transporte ferroviário",
    "shipmentForm.raw.originStationIcd": "Estação / ICD de origem",
    "shipmentForm.raw.destinationStationIcd": "Estação / ICD de destino",
    "shipmentForm.raw.railOperator": "Operador ferroviário",
    "shipmentForm.raw.searchByStockUnitIdTransportId": "Procure por ID da Unidade de Stock, ID de transporte, n.º do contentor / camião ou produto…",
    "shipmentForm.raw.openInStockUnitEditorNewTab": "Abrir no editor da Unidade de Stock (novo separador)",
    "shipmentForm.raw.noTransportUnitsAddedYetStartBy": "Ainda não foram adicionadas unidades. Comece por pesquisar acima.",
    "shipmentForm.raw.whoCanSeeThisDocumentInShares": "Quem pode ver este documento em partilhas e exportações",
    "shipmentForm.raw.dropOrClickToUpload": "Largue ou clique para carregar",
    "shipmentForm.raw.noDocumentsAttached": "Sem documentos anexados",
    "shipmentForm.raw.max5FilesReached": "Máximo de 5 ficheiros atingido",
    "shipmentForm.raw.label": "Etiqueta",
    "shipmentForm.raw.fileLabelMax16Chars": "Etiqueta do ficheiro (máx. 16 caracteres)",
    "shipmentForm.raw.attach": "Anexar",
    "shipmentForm.raw.fileSSelected": "ficheiro(s) selecionado(s)",
    "shipmentForm.raw.dropOrClickToAddMultipleFiles": "Largue ou clique para adicionar vários ficheiros",
    "shipmentForm.raw.selectCurrency": "Selecione a moeda",
    "shipmentForm.raw.days": "Dias",
    "shipmentForm.raw.describePaymentTerms": "Descreva as condições de pagamento…",
    "shipmentForm.raw.customTerms": "Condições personalizadas",
    "shipmentForm.raw.dueDate": "Data de vencimento",
    "shipmentForm.raw.outstandingReceivable": "A receber em aberto",
    "shipmentForm.raw.outstandingPayable": "A pagar em aberto",
    "shipmentForm.raw.paymentDetails": "Detalhes do pagamento",
    "shipmentForm.raw.paymentDate": "Data do pagamento *",
    "shipmentForm.raw.utrLCNoRef": "UTR / N.º L/C / Ref.",
    "shipmentForm.raw.amountCurrency": "Valor e moeda",
    "shipmentForm.raw.amount": "Valor *",
    "shipmentForm.raw.optionalContextForThisPayment": "Contexto opcional para este pagamento…",
    "shipmentForm.raw.noPaymentsRecordedYet": "Ainda sem pagamentos registados.",
    "shipmentForm.raw.editPayment": "Editar pagamento",
    "shipmentForm.raw.deletePayment": "Eliminar pagamento",
    "shipmentForm.raw.totalReceived": "Total recebido:",
    "shipmentForm.raw.totalPaid": "Total pago:",
    "shipmentForm.raw.previousTabAltLeft": "Separador anterior (Alt + Esq.)",
    "shipmentForm.raw.nextTabAltRight": "Separador seguinte (Alt + Dir.)",
    "shipmentForm.lastUpdated": "Última atualização",
    "shipmentForm.statusHistory": "Histórico de estados",
    "shipmentForm.noHistory": "Sem histórico de estados para mostrar.",
    "shipment.status.DRAFT": "Rascunho",
    "shipment.status.CONFIRMED": "Confirmada",
    "shipment.status.PLANNED": "Planeada",
    "shipment.status.STUFFING": "Enchimento",
    "shipment.status.STUFFED": "Enchido",
    "shipment.status.GATE_OUT": "Saída do portão",
    "shipment.status.IN_TRANSIT": "Em trânsito",
    "shipment.status.ARRIVED": "Chegou",
    "shipment.status.UNSTUFFING": "Desova",
    "shipment.status.DELIVERED": "Entregue",
    "shipment.status.CLOSED": "Fechada",
    "shipment.status.CANCELLED": "Cancelada",
    "shipment.statusGroup.planning": "Planeamento",
    "shipment.statusGroup.loading": "Carga",
    "shipment.statusGroup.way": "A caminho",
    "shipment.statusGroup.arrival": "Chegada",
    "shipment.statusGroup.finished": "Concluída",
    "shipment.statusMeaning.DRAFT": "Em preparação",
    "shipment.statusMeaning.CONFIRMED": "Negócio acordado",
    "shipment.statusMeaning.PLANNED": "Envio organizado",
    "shipment.statusMeaning.STUFFING.sale": "Está a carregar a mercadoria",
    "shipment.statusMeaning.STUFFING.buy": "O fornecedor está a carregar a mercadoria",
    "shipment.statusMeaning.STUFFED.sale": "Carregado e selado",
    "shipment.statusMeaning.STUFFED.buy": "Carregado no fornecedor",
    "shipment.statusMeaning.GATE_OUT.sale": "Saiu do portão do pátio ou porto",
    "shipment.statusMeaning.GATE_OUT.buy": "O fornecedor carregou e expediu",
    "shipment.statusMeaning.IN_TRANSIT.sale": "A caminho do comprador",
    "shipment.statusMeaning.IN_TRANSIT.buy": "A caminho de si",
    "shipment.statusMeaning.ARRIVED.sale": "Chegou ao destino",
    "shipment.statusMeaning.ARRIVED.buy": "Chegou ao seu porto ou pátio",
    "shipment.statusMeaning.UNSTUFFING.sale": "O contentor está a ser descarregado",
    "shipment.statusMeaning.UNSTUFFING.buy": "O contentor está a ser descarregado",
    "shipment.statusMeaning.DELIVERED.sale": "O comprador tem a mercadoria",
    "shipment.statusMeaning.DELIVERED.buy": "A mercadoria está consigo",
    "shipment.statusMeaning.CLOSED": "Concluída e liquidada",
    "shipment.statusMeaning.CANCELLED": "Anulada",
    "shipment.statusEffect.DRAFT": "Nada muda no stock. Use enquanto faltarem dados.",
    "shipment.statusEffect.CONFIRMED": "Nada muda no stock.",
    "shipment.statusEffect.PLANNED": "Nada muda no stock.",
    "shipment.statusEffect.STUFFING.sale": "Nada muda no stock. As Unidades de Stock aparecem em Em Consignação.",
    "shipment.statusEffect.STUFFING.buy": "Nada muda no stock. As Unidades de Stock aparecem em Em Consignação.",
    "shipment.statusEffect.STUFFED.sale": "Nada muda no stock. As Unidades de Stock aparecem em Em Trânsito.",
    "shipment.statusEffect.STUFFED.buy": "Nada muda no stock. As Unidades de Stock aparecem em Em Trânsito.",
    "shipment.statusEffect.GATE_OUT.sale": "Nada muda no stock. As Unidades de Stock aparecem em Em Trânsito.",
    "shipment.statusEffect.GATE_OUT.buy": "Nada muda no stock. As Unidades de Stock aparecem em Em Trânsito.",
    "shipment.statusEffect.IN_TRANSIT.sale": "Nada muda no stock (o stock só baixa quando confirma a Saída). A partir daqui não se pode adicionar nova Unidade de Stock a esta venda.",
    "shipment.statusEffect.IN_TRANSIT.buy": "Nada muda no stock (o stock só sobe quando o recebe no inventário). As Unidades de Stock aparecem em Em Trânsito.",
    "shipment.statusEffect.ARRIVED.sale": "Nada muda no stock. Já não se podem adicionar novas Unidades de Stock a esta venda.",
    "shipment.statusEffect.ARRIVED.buy": "O stock ainda não sobe. Será perguntado se quer receber as Unidades de Stock no inventário (Receber no Inventário).",
    "shipment.statusEffect.UNSTUFFING.sale": "Nada muda no stock.",
    "shipment.statusEffect.UNSTUFFING.buy": "O stock ainda não sobe. Será perguntado se quer receber as Unidades de Stock no inventário (Receber no Inventário).",
    "shipment.statusEffect.DELIVERED.sale": "O stock só baixa quando confirma a Saída em cada Unidade de Stock, não por este estado. Já não se podem adicionar novas Unidades de Stock.",
    "shipment.statusEffect.DELIVERED.buy": "Receba as Unidades de Stock ainda não recebidas. O stock só sobe quando as recebe no inventário, não por este estado.",
    "shipment.statusEffect.CLOSED": "Não se podem adicionar mais Unidades de Stock. As quantidades de stock não mudam.",
    "shipment.statusEffect.CANCELLED": "As quantidades de stock não mudam e não se podem adicionar mais Unidades de Stock. Se o stock já foi recebido ou confirmado, corrija com Adicionar Ajuste.",
    "shipment.paymentSummaryTitle": "Resumo de Pagamento",
    "shipment.invoiceAmount": "Valor da Fatura",
    "shipment.received": "Recebido",
    "shipment.paid": "Pago",
    "shipment.salesPaymentStatus": "Status de Pagamento de Venda",
    "shipment.purchasePaymentStatus": "Status de Pagamento de Compra",
    "shipment.coreDetails": "Detalhes principais da consignação",
    "shipment.saveChanges": "Salvar alterações",
    "shipment.listSubtitle": "Acompanhe, filtre e gerencie operações de consignação",
    "shipment.filterBl": "Filtrar BL",
    "shipment.filterBuyerOrder": "Filtrar pedido do comprador",
    "shipment.filterExportRef": "Filtrar ref. exportação",
    "shipment.filterShipper": "Filtrar remetente",
    "shipment.filterConsignee": "Filtrar consignatário",
    "shipment.filterStatus": "Filtrar status",
    "shipment.viewDetails": "Ver detalhes da consignação",
    "shipment.payments": "Pagamentos",
    "common.confirm": "Confirmar",
    "shipment.changeStatus": "Alterar Status",
    "shipment.receiveIntoInventory": "Receber no Inventário",
    "share.actions": "Ações de compartilhamento",
    "share.duration": "Duração",
    "share.accessLimit": "Limite de acesso",
    "share.customAccessCount": "Contagem personalizada",
    "share.allowDownload": "Permitir exportação e downloads de arquivos",
    "share.protectedAudience": "Público protegido",
    "share.companyIdNotFound": "ID da empresa não existe",
    "share.emailNotFound": "não é um usuário registrado do LumberLinq",
    "share.createLink": "Criar link",
    "share.createTallysheetLink": "Criar link do tallysheet",
    "share.tallysheetSharedLinks": "Links compartilhados do tallysheet",
    "share.audience": "Público",
    "share.createdBy": "Criado por",
    "share.limit": "Limite",
    "share.download": "Download",
    "share.noLinksFound": "Nenhum link compartilhado encontrado.",
    "share.public": "Qualquer pessoa com o link",
    "share.protected": "Apenas usuários LumberLinq",
    "share.private": "Somente minha equipe",
    "share.publicTooltip": "Acessível a qualquer pessoa com este link — sem necessidade de login",
    "share.protectedTooltip": "Apenas usuários LumberLinq podem visualizar — login necessário",
    "share.privateTooltip": "Somente membros da sua equipe podem visualizar isso",
    "share.accessMode": "Modo de acesso",
    "share.linkSettings": "Configurações do link",
    "share.allowDownloadHint": "Quando desativado, os espectadores não podem exportar o talão ou baixar arquivos de consignação.",
    "share.linkPreview": "Mostrar detalhes na pré-visualização do link",
    "share.linkPreviewHintPublic": "Quando ativado, WhatsApp, Telegram e outros apps de conversa mostram peças, volume e produtos (apenas os campos permitidos pelas suas configurações de acesso).",
    "share.linkPreviewHintLocked": "Quando ativado, os apps de conversa mostram um cartão bloqueado com a quantidade de Stock Units. Nenhum outro detalhe é mostrado.",
    "share.preview": "Pré-visualização",
    "share.linkInventory": "Links Compartilhados",
    "share.specificCompanyIds": "IDs de empresa específicos",
    "share.specificEmails": "Emails específicos",
    "share.anyLumberlinqUser": "Qualquer usuário Lumberlinq",
    "share.manageAudience": "Gerenciar Público",
    "share.audienceEmails": "Endereços de e-mail",
    "share.audienceCompanies": "IDs de empresa",
    "share.addEntry": "Adicionar",
    "share.audienceMinOne": "Pelo menos uma entrada é necessária",
    "share.audienceDeleteGate": "Adicione uma nova entrada primeiro para habilitar a remoção",
    "share.audienceNoEntries": "Nenhuma entrada ainda",
    "share.audienceEmailPlaceholder": "Inserir endereço de e-mail",
    "share.audienceCompanyPlaceholder": "Inserir ID da empresa",
    "share.never": "Nunca",
    "share.noRestriction": "Sem restrição",
    "share.missingTransportUnit": "Unidade de Estoque ausente",
    "share.saveOrLoadTransportUnit": "Salve ou carregue uma unidade de estoque antes de criar um link.",
    "share.tallysheetLinkCreated": "Link do tallysheet criado",
    "share.linkCopiedToClipboard": "Link compartilhado copiado para a área de transferência.",
    "share.linkFailed": "Falha no link",
    "shareAudit.title": "Auditoria de Acesso ao Link Compartilhado",
    "shareAudit.accesses": "acessos",
    "shareAudit.noAccesses": "Nenhum acesso por link compartilhado registrado ainda.",
    "shareAudit.emptyHint": "Sempre que alguém abrir um link compartilhado, aparecerá aqui.",
    "shareAudit.allowed": "Permitido",
    "shareAudit.denied": "Negado",
    "shareAudit.uniqueVisitors": "Visitantes Únicos",
    "shareAudit.bots": "Bots",
    "shareAudit.emailUser": "Email / Usuário",
    "shareAudit.accessedAt": "Acessado em",
    "shareAudit.ipAddress": "Endereço IP",
    "shareAudit.location": "Localização",
    "shareAudit.browser": "Navegador",
    "shareAudit.os": "SO",
    "shareAudit.shareLink": "Link Compartilhado",
    "shareAudit.anonymous": "Anônimo",
    "shareAudit.noEntries": "Nenhuma entrada de auditoria encontrada.",
    "share.unableToCreateTallysheetLink": "Não foi possível criar o link compartilhado do tallysheet.",
    "share.oneDay": "1 dia",
    "share.sevenDays": "7 dias",
    "share.thirtyDays": "30 dias",
    "share.ninetyDays": "90 dias",
    "share.neverExpires": "Nunca expira",
    "tallysheet.rowLimit.title": "A folha de contagem está cheia",
    "tallysheet.rowLimit.message": "Uma folha de contagem aceita no máximo {max} linhas. Comece uma nova folha para o restante.",
    "tallysheet.rowLimit.importMessage": "Estas linhas levariam a folha além de {max} linhas, por isso nada foi importado. Importe menos linhas ou use uma nova folha.",
    "share.publicExpiryHint": "Os links públicos expiram sempre, por isso um link antigo não pode ser aberto por quem o encontre mais tarde.",
    "share.disableAll": "Desativar todos",
    "share.disableAllConfirm": "Desativar todos os links deste registo? Ninguém os poderá abrir.",
    "share.disableAllDone": "Links desativados",
    "share.oneTime": "Uso único",
    "share.threeAccesses": "3 acessos",
    "share.fiveAccesses": "5 acessos",
    "share.tenAccesses": "10 acessos",
    "share.custom": "Personalizado",
    "share.viewSharedLinks": "Ver links compartilhados",
    "share.copyDirectLink": "Copiar link direto",
    "share.openDirectLink": "Abrir link direto",
    "share.copyLink": "Copiar link",
    "share.openLink": "Abrir link",
    "share.anyoneWithLink": "Qualquer pessoa com o link pode acessar",
    "share.requiresVerification": "Requer verificação",
    "share.restrictedUsersOnly": "Somente usuários restritos",
    "share.addEmailAddress": "Adicionar email Lumberlinq",
    "share.addCompanyId": "Adicionar ID da empresa",
    "share.missingDetails": "Detalhes ausentes",
    "share.completeRestrictions": "Complete as restrições de compartilhamento selecionadas.",
    "share.generatingLink": "Gerando link...",
    "share.pleaseWait": "Aguarde",
    "share.linkCreated": "Link criado",
    "share.tallysheetLinkGenerated": "Link compartilhado do tallysheet gerado.",
    "share.linkGeneratedSuccessfully": "Link compartilhado gerado com sucesso",
    "share.failed": "Falhou",
    "share.unableToCreateShareLink": "Não foi possível criar o link",
    "share.unableToLoadSharedLinks": "Não foi possível carregar links compartilhados.",
    "share.docAccess": "Acesso ao Documento",
    "share.docAccessHint": "Controle o que os visualizadores podem fazer com cada documento",
    "share.doc_bl": "Arquivo BL",
    "share.doc_ewaybill": "E-Waybill / LR",
    "share.doc_co": "Certificado de Origem",
    "share.doc_phyto": "Fitossanitário",
    "share.doc_invoice": "Fatura Comercial",
    "share.doc_other": "Outros Documentos",
    "share.docFull": "Acesso Completo",
    "share.docViewOnly": "Somente Visualizar",
    "share.docFilenameOnly": "Somente Nome do Arquivo",
    "share.docHidden": "Oculto",
    "share.copied": "Copiado",
    "share.linkCopied": "Link copiado",
    "share.transportIdCopied": "ID do transporte copiado!",
    "share.confirmRevoke": "Tem certeza de que deseja revogar este link?",
    "share.confirmActivate": "Tem certeza de que deseja ativar este link?",
    "share.generateShareLink": "Gerar link compartilhado",
    "share.generateShareQuestion": "Deseja gerar",
    "share.shareLinkSuffix": "link compartilhado?",
    "share.unableToUpdateLinkStatus": "Não foi possível atualizar o status do link.",
    "subscription.transactions": "Transações",
    "subscription.purchase": "Compra",
    "subscription.customerCode": "Código do cliente",
    "subscription.currentName": "Nome da assinatura atual",
    "subscription.refresh": "Atualizar",
    "subscription.validTill": "Assinatura atual válida até",
    "subscription.lastPayment": "Último pagamento em",
    "subscription.paymentDue": "Pagamento vence em",
    "subscription.paidTill": "Pago até",
    "subscription.status": "Status da assinatura",
    "subscription.downgradedTitle": "Você está no Plano Gratuito",
    "subscription.downgradedBody": "Sua assinatura paga expirou e esta conta foi movida automaticamente para o plano gratuito. Você ainda tem acesso total a tudo o que já criou — só não pode adicionar novos itens além dos limites do plano gratuito. Renove a qualquer momento para desbloquear o acesso total novamente.",
    "subscription.utcNote":
      "Observe que nosso sistema opera com base no Tempo Universal Coordenado (UTC). Portanto, o horário de ativação e expiração da sua assinatura será calculado com base nesse fuso horário. Se você estiver em outro fuso horário, pode haver uma diferença percebida no início e fim da assinatura",
    "subscription.autoPay": "Pagamento Automático (EMandate)",
    "subscription.cancelAutoPay": "Cancelar Pagamento Automático",
    "utility.title": "Utilitário",
    "utility.slabCalculator": "Calculadora de placas",
    "utility.slabSubheader":
      "Insira as dimensões da placa para gerar estimativas de preço por diferença de tamanho",
    "tallysheet.settings": "Configurações",
    "tallysheet.validationRules": "Regras de validação",
    "tallysheet.configurationSettings": "Configurações",
    "tallysheet.transportDetails": "Detalhes do transporte",
    "tallysheet.tu.direction": "Direção",
    "tallysheet.tu.directionChangeHeader": "Alterar Direção?",
    "tallysheet.tu.directionChangeMessage": "Alterar a Direção pode redefinir alguns campos relacionados ao Estoque — continuar?",
    "tallysheet.tu.directionStockIn": "Entrada de Estoque",
    "tallysheet.tu.directionStockOut": "Saída de Estoque",
    "tallysheet.tu.directionMove": "Transferência Entre Locais",
    "tallysheet.tu.gridStyle": "Layout de Contagem",
    "tallysheet.tu.gridStyleClassicHint": "Um produto por linha, escolhido agora.",
    "tallysheet.tu.gridStyleFlexibleHint": "Escolha produtos por linha ao começar a tabular — não precisa escolher agora.",
    "tallysheet.tu.directionChangeHint": "Salvo — a direção não pode ser alterada após salvar.",
    "tallysheet.tu.gridStyleChangeHint": "Salvo — o layout não pode ser alterado após salvar.",
    "tallysheet.tu.destinationSite": "Local de Destino",
    "tallysheet.tu.destinationSiteRequired": "O Local de Destino é obrigatório.",
    "tallysheet.tu.origin": "Origem",
    "tallysheet.tu.originOptional": "Origem (opcional)",
    "tallysheet.tu.quality": "Qualidade",
    "tallysheet.tu.qualityOptional": "Qualidade (opcional)",
    "tallysheet.tu.qualityMixed": "Misto / Qualquer",
    "tallysheet.tu.cbmInStock": "CBM em estoque",
    "tallysheet.tu.inStockSuffix": "livres",
    "tallysheet.tu.clickForCft": "Clique para exibir em CFT",
    "tallysheet.tu.clickForCbm": "Clique para exibir em CBM",
    "tallysheet.tu.afterThisSave": "Restante após salvar",
    "tallysheet.tu.heldByThisSheet": "Reservado por esta folha",
    "tallysheet.tu.stockFree": "Livre",
    "tallysheet.tu.stockHeld": "Reservado",
    "tallysheet.tu.stockInStock": "Em estoque",
    "tallysheet.tu.stockRowSizeTip": "A linha clicada: livre para esta folha, reservado por outras Saídas de Estoque e o total em estoque (este comprimento ou maior)",
    "tallysheet.tu.stockAvailability": "Disponibilidade de Estoque",
    "tallysheet.tu.noStock": "Sem estoque",
    "tallysheet.tu.stockCantVerifyOffline": "Não é possível verificar — offline",
    "tallysheet.tu.noStockAtSite": "Sem estoque em",
    "tallysheet.tu.availableAtSite": "disponível em",
    "tallysheet.tu.stockBreakdownTitle": "Detalhamento do Estoque",
    "tallysheet.tu.stockOrigin": "Origem",
    "tallysheet.tu.stockQuality": "Qualidade",
    "tallysheet.tu.stockPieces": "Peças",
    "tallysheet.tu.stockSeal": "Lacre",
    "tallysheet.tu.stockSupplier": "Fornecedor",
    "tallysheet.tu.stockNoContributors": "Nenhuma Unidade de Estoque contribuinte encontrada.",
    "tallysheet.tu.confirmDeleteHeader": "Confirmar Exclusão",
    "tallysheet.tu.confirmDeleteMessage": "Tem certeza de que deseja excluir a Unidade de Estoque ({transportId})?",
    "tallysheet.tu.deleteConfirmAccept": "Sim, Excluir",
    "tallysheet.tu.deletedSuccess": "Unidade de Estoque excluída com sucesso",
    "tallysheet.tu.deleteNotAllowedHeader": "Exclusão Não Permitida",
    "tallysheet.tu.deleteNotAllowedFallback": "Esta Unidade de Estoque não pode ser excluída no momento.",
    "tallysheet.tu.deleteFailedHeader": "Falha ao Excluir",
    "tallysheet.tu.deleteFailedMessage": "Não foi possível excluir a Unidade de Estoque. Tente novamente mais tarde.",
    "tallysheet.fulfill.title": "Plano de Atendimento",
    "tallysheet.fulfill.size": "Tamanho",
    "tallysheet.fulfill.grade": "Grau",
    "tallysheet.fulfill.inStock": "Em Estoque",
    "tallysheet.fulfill.allocate": "Usar",
    "tallysheet.fulfill.waste": "Desperdício",
    "tallysheet.fulfill.why": "Motivo",
    "tallysheet.fulfill.required": "Necessário",
    "tallysheet.fulfill.covered": "Coberto",
    "tallysheet.fulfill.short": "Faltam",
    "tallysheet.fulfill.moreOptions": "Mais opções",
    "tallysheet.fulfill.noStock": "Nenhum estoque prático para este tamanho, origem e qualidade.",
    "tallysheet.fulfill.tierExact": "Correspondência exata",
    "tallysheet.fulfill.tierTrim": "Mais longo — aparar",
    "tallysheet.fulfill.tierResaw": "Resserrar de maior",
    "tallysheet.fulfill.tierGrade": "Grau diferente",
    "tallysheet.fulfill.tierOrigin": "Origem diferente",
    "tallysheet.fulfill.tierShort": "Mais curto — confirmar",
    "tallysheet.fulfill.tierMixed": "Comprimentos mistos — verificar",
    "tallysheet.quick.button": "Tally Rápido",
    "tallysheet.quick.tooltip": "Digite abreviado como 4x3x7 250 Ghana A — o sistema cria as linhas",
    "tallysheet.quick.title": "Tally Rápido",
    "tallysheet.quick.hint": "Uma entrada por vírgula ou linha: tamanho, peças, depois origem e qualidade opcionais. Exemplo: 4x3x7 250 Ghana A",
    "tallysheet.quick.notes": "Notas",
    "tallysheet.quick.apply": "Adicionar linhas",
    "tallysheet.quick.noDimensions": "Nenhum tamanho encontrado (ex. 4x3x7)",
    "tallysheet.quick.noPieces": "Quantidade de peças ausente",
    "tallysheet.quick.lengthMissing": "Comprimento ausente — preencha na grade",
    "tallysheet.flex.button": "Layout Flexível",
    "tallysheet.flex.classicOption": "Layout Padrão",
    "tallysheet.flex.searchProducts": "Buscar produtos...",
    "tallysheet.flex.noProductsFound": "Nenhum produto encontrado",
    "tallysheet.flex.pickProductFirst": "Escolha um produto primeiro para ver o estoque",
    "tallysheet.flex.switchTooltip": "Padrão: um produto por linha. Flexível: produto/origem/qualidade por linha, além de tamanhos do estoque",
    "tallysheet.flex.cascadeTitle": "Produto da Linha",
    "tallysheet.flex.stockTitle": "Escolher do estoque",
    "tallysheet.flex.noProductYet": "Nenhum produto escolhido ainda",
    "tallysheet.flex.sameAsLine": "Igual à linha",
    "tallysheet.flex.typedSoFar": "Digitado até agora",
    "tallysheet.flex.showAll": "Mostrar todos",
    "tallysheet.flex.requestCustomMade": "Não disponível — solicitar produção sob medida",
    "tallysheet.flex.cancelRequest": "Cancelar pedido",
    "tallysheet.flex.cancelRequestHeader": "Cancelar o pedido à serraria?",
    "tallysheet.flex.cancelRequestMessage": "A serraria não vai mais cortar este tamanho para esta linha. Você pode pedir de novo depois.",
    "tallysheet.flex.cancelRequestYes": "Sim, cancelar",
    "tallysheet.flex.cancelRequestDone": "Pedido à serraria cancelado",
    "tallysheet.flex.noneMatchExactly": "Nenhum destes corresponde exatamente a:",
    "tallysheet.flex.stockStaleNotice": "Mostrando estoque da última sincronização — pode estar desatualizado.",
    "tallysheet.flex.availablePcs": "peças disponíveis para este tamanho",
    "tallysheet.flex.availableCbm": "CBM disponível",
    "tallysheet.flex.availableStockTooltip": "O estoque disponível exclui o que já está reservado por outras linhas de saída de estoque salvas e tarefas ativas de serraria — ainda não confirmado, mas já comprometido. Altere isso em Empresa → Configurações de Inventário.",
    "tallysheet.flex.customMadeLockedTitle": "Linha bloqueada — tarefa de serraria em andamento",
    "tallysheet.flex.customMadeLockedDetail": "O material desta linha já está sendo cortado por uma tarefa de serraria e não pode ser editado ou excluído até que essa tarefa seja concluída. Ela é desbloqueada automaticamente quando terminar — nenhuma ação necessária.",
    "tallysheet.flex.importUnavailable": "A importação não está disponível na Visualização Flexível — mude para o Layout Padrão para importar.",
    "tallysheet.flex.customMadeLockedTooltipProducing": "Bloqueado — uma tarefa de serraria está cortando este tamanho agora. Será desbloqueado automaticamente quando essa tarefa terminar.",
    "tallysheet.flex.customMadeLockedTooltipWaiting": "Bloqueado — uma tarefa de serraria foi criada para este tamanho e está na fila para começar. Será desbloqueado automaticamente quando essa tarefa terminar.",
    "tallysheet.flex.customMadeLockedTooltipPaused": "Bloqueado — a tarefa de serraria para este tamanho já começou e está pausada agora. Será desbloqueado automaticamente quando essa tarefa terminar ou for cancelada.",
    "tally.aiReview.needsOne": "linha precisa de revisão — a IA não teve certeza ou não conseguiu ler um valor",
    "tally.aiReview.needsMany": "linhas precisam de revisão — a IA não teve certeza ou não conseguiu ler um valor",
    "tally.aiReview.showOnly": "Mostrar só estas",
    "tally.aiReview.showAll": "Mostrar todas as linhas",
    "tally.aiReview.showOnlyTip": "Mostrar só estas linhas",
    "tally.aiReview.prev": "Linha anterior para revisar",
    "tally.aiReview.next": "Próxima linha para revisar",
    "tally.aiReview.row": "Linha",
    "tally.warn.lengthRange": "Comprimento fora da faixa definida — o valor foi mantido",
    "tally.warn.girthRange": "Circunferência fora da faixa definida — o valor foi mantido",
    "tally.errorNav.lengthMissing": "Linha {row}: falta o Comprimento",
    "tally.errorNav.girthMissing": "Linha {row}: falta a Circunferência",
    "tally.errorNav.bothMissing": "Linha {row}: faltam o Comprimento e a Circunferência",
    "tally.warn.divisibleBy5": "Comprimento não é múltiplo de 5 — o valor foi mantido",
    "tallysheet.flex.deleteRowConfirm": "Excluir esta linha?",
    "tallysheet.flex.stockStatusLabel": "Status do Estoque",
    "tallysheet.flex.stockStatusNotReserved": "Ponto vermelho — ainda sem correspondência exata, nada reservado para esta linha",
    "tallysheet.flex.stockStatusMillTask": "Produzindo / Aguardando início — retido por uma tarefa ativa de serraria",
    "tallysheet.flex.stockStatusReserved": "Sem selo — correspondido a estoque real e reservado",
    "company.includeReservations.label": "Contabilizar trabalho em andamento no estoque disponível",
    "company.includeReservations.hint": "Ativado por padrão — o estoque já reservado por linhas de saída salvas ou tarefas ativas de serraria não aparecerá como disponível até ser confirmado ou liberado. Desative para ver o total físico bruto.",
    "tallysheet.flex.back": "Voltar",
    "tallysheet.flex.next": "Avançar",
    "tallysheet.flex.done": "Concluir",
    "tallysheet.flex.scEnter": "abrir assistente/seletor · em Peças: próxima linha preenchida",
    "tallysheet.flex.scAltEnter": "seletor de estoque a qualquer momento",
    "tallysheet.flex.scCtrlEnter": "nova linha",
    "tallysheet.flex.scCtrlBackspace": "limpar linha",
    "tallysheet.flex.shortcutsLabel": "Atalhos",
    "tallysheet.flex.shapeSubtitleSquare": "🔵 Este é um Tallysheet quadrado — apenas produtos de corte quadrado são exibidos. Produtos redondos não aparecerão aqui.",
    "tallysheet.flex.shapeRedirect": "Precisa de outro formato (ex. toras redondas)? Mude para o Layout Padrão — lá cada linha de produto tem seu próprio tipo de contagem.",
    "tallysheet.flex.lockedTooltip": "Bloqueado — esta planilha já tem linhas salvas. Escolha o layout antes de salvar.",
    "tallysheet.flex.confirmSwitchHeader": "Mudar para o Layout Flexível?",
    "tallysheet.flex.confirmSwitchMessage": "Você tem linhas não salvas. Mudar é seguro, mas considere salvar antes. Continuar?",
    "tallysheet.tu.stockAnyOrigin": "Qualquer origem",
    "tallysheet.tu.stockAnyQuality": "Qualquer qualidade",
    "tallysheet.tu.additionalProducts": "Produtos Adicionais",
    "tallysheet.tu.products": "Produtos",
    "tallysheet.tu.viewStock": "Ver disponibilidade de estoque",
    "tallysheet.tu.removeLineConfirmHeader": "Excluir Tallysheet",
    "tallysheet.tu.removeLineConfirmMessage": "Excluir a tallysheet de {product} excluirá permanentemente {count} registro(s) de contagem vinculados a ela. Digite CONFIRM para continuar.",
    "tallysheet.tu.addAnotherProduct": "Adicionar outro produto",
    "tallysheet.tu.removeLine": "Remover esta linha de produto",
    "tallysheet.tu.removeLineHeader": "Remover Linha de Produto",
    "tallysheet.tu.removeLineMessage": "Se esta linha já tiver linhas de contagem, elas devem ser removidas primeiro — caso contrário, o salvamento será bloqueado.",
    "tallysheet.tu.typeSwitchHeader": "O Tipo de Contagem Vai Mudar",
    "tallysheet.tu.typeSwitchMessage": "Alterar o produto em {lines} muda o tipo de contagem — as linhas de contagem existentes dessa linha serão excluídas permanentemente. Continuar?",
    "tallysheet.overStock.header": "Salvando Além do Estoque Disponível",
    "tallysheet.overStock.message": "{line} seria contado em {total} CBM, mas apenas {available} CBM está disponível em estoque. Explique por que deseja continuar mesmo assim:",
    "tallysheet.overStock.reasonPlaceholder": "Motivo (obrigatório)",
    "tallysheet.overStock.proceed": "Salvar Mesmo Assim",
    "tallysheet.stockUnitId": "ID da Unidade de Estoque",
    "tallysheet.tu.tooltipStockUnitId": "Identidade desta Unidade de Estoque — atribuída automaticamente pelo sistema, única, nunca editável. Gerada assim que você salvar.",
    "tallysheet.stockUnitIdPending": "Pendente",
    "tallysheet.transportId": "ID do transporte",
    "tallysheet.transportModeDetails": "Detalhes do modo de transporte",
    "tallysheet.tu.tooltipTransportId": "Referência opcional para o veículo/contêiner real usado — pode se repetir (ex: o mesmo caminhão pode vir mais de uma vez)",
    "tallysheet.tu.tooltipContainerNumber": "Número ISO do contêiner atribuído pelo transportador — 4 letras + 6 dígitos + dígito verificador (ex: MSCU1234567)",
    "tallysheet.tu.tooltipSealNo": "Selo de segurança físico fixado na porta do contêiner — referenciado em documentos fitossanitários e alfandegários (ex: SNHR123456)",
    "tallysheet.tu.tooltipLoadingSite": "Local onde a madeira foi originalmente carregada — local de origem (floresta, pátio, serraria ou porto)",
    "tallysheet.tu.tooltipRoute": "Trajeto do caminhão do local ao destino (ex: Raipur ao Porto de Kandla)",
    "tallysheet.tu.tooltipVehicleRegNo": "Placa de registro oficial do caminhão ou reboque (ex: MH04-AB-1234)",
    "tallysheet.tu.tooltipWagonNo": "Número do vagão ferroviário conforme impresso no vagão (ex: BOXN-67890)",
    "tallysheet.chooseColumns": "Escolher colunas",
    "tallysheet.colPreset.simple": "Simples",
    "tallysheet.colPreset.detailed": "Detalhado",
    "tallysheet.colPreset.custom": "Personalizado",
    "tallysheet.colGroup.measurements": "Medidas",
    "tallysheet.colGroup.volume": "Volume",
    "tallysheet.colGroup.allowances": "Tolerâncias",
    "tallysheet.colGroup.other": "Outros",
    "tallysheet.editSettings": "Editar configurações do tally",
    "tallysheet.decimalsShort": "casas decimais",
    "tallysheet.globalSearch": "Pesquisa global",
    "tallysheet.transportUnits": "Unidades de Estoque",
    "tallysheet.unit": "unidade",
    "tallysheet.units": "unidades",
    "tallysheet.transportUnitsSubtitle": "Revise unidades de estoque, abra tallys e gerencie links seguros",
    "tallysheet.viewTallysheet": "Ver tallysheet",
    "tallysheet.thisPage": "esta página",
    "tallysheet.allPages": "todas as páginas",
    "tallysheet.sortNewest": "Mais recentes",
    "tallysheet.sortOldest": "Mais antigos",
    "tallysheet.sortStockUnitId": "ID da unidade de estoque",
    "tallysheet.sortProduct": "Produto",
    "tallysheet.fullReportPdf": "Relatório completo (PDF)",
    "tallysheet.copyTransportId": "Copiar ID do transporte",
    "tallysheet.operations": "Operações",
    "tallysheet.newTallysheet": "Novo tallysheet",
    "tallysheet.syncedTitle": "Sincronizado",
    "tallysheet.syncedDetail": "Esta unidade de estoque foi sincronizada com o servidor.",
    "tallysheet.newTransportUnit": "Nova unidade de estoque",
    "tallysheet.newTallysheetSubtitle": "Capture detalhes da unidade de estoque, medições, fotos e resumo em um único fluxo.",
    "tallysheet.editTransportUnit": "Editar unidade de estoque",
    "tallysheet.viewTransportUnit": "Ver unidade de estoque",
    "tallysheet.editTransportUnitSubtitle": "Atualize detalhes da unidade de estoque, medições, fotos e resumo em um único fluxo.",
    "tallysheet.viewTransportUnitSubtitle": "Revise detalhes da unidade de estoque, medições, fotos e resumo em um único fluxo.",
    "tallysheet.transportUnit": "Unidade de Estoque",
    "tallysheet.switchingTu": "Carregando unidade de estoque…",
    "tallysheet.tuLoadFailed": "Não foi possível carregar esta unidade de estoque.",
    "tallysheet.tallysheet": "Tallysheet",
    "tallysheet.roundTallysheet": "Tallysheet redondo",
    "tallysheet.squareTallysheet": "Tallysheet quadrado",
    "tallysheet.measurementGrid": "Grade de medições",
    "tallysheet.measurementGridSubtitle": "Capture, valide, importe e salve medições do tally",
    "tallysheet.rows": "Linhas",
    "tallysheet.columnsSelected": "Colunas",
    "tallysheet.editActions": "Editar",
    "tallysheet.viewControls": "Visualizar",
    "tallysheet.dataActions": "Dados",
    "tallysheet.voiceControls": "Voz",
    "tallysheet.photos": "Fotos",
    "tallysheet.summary": "Resumo",
    "tallysheet.reconciliation": "Reconciliação",
    "tallysheet.goToRow": "Ir para linha",
    "tallysheet.export": "Exportar",
    "export.companyDetails": "Detalhes da Empresa",
    "export.chartsAndStats": "Gráficos e Estatísticas",
    "export.showMaskedFields": "Mostrar Campos Mascarados",
    "export.watermark": "Marca d'Água",
    "export.packingList": "Lista de Embalagem",
    "export.surveyReport": "Relatório de Vistoria",
    "export.certificate": "Certificado",
    "tallysheet.save": "Salvar",
    "tallysheet.sr": "Nº",
    "tallysheet.orderKey": "Chave do pedido",
    "tallysheet.girth": "Circunferência",
    "tallysheet.lengthAllowanceShort": "Ajuste comp.",
    "tallysheet.girthAllowanceShort": "Ajuste circ.",
    "tallysheet.netLength": "Comprimento líquido",
    "tallysheet.netGirth": "Circunferência líquida",
    "tallysheet.net": "Líquido",
    "tallysheet.gross": "Bruto",
    "tallysheet.allowance": "Desconto",
    "tallysheet.volBasisHint": "Mostrando volume líquido — toque para bruto",
    "tallysheet.volBasisHintGross": "Mostrando volume bruto — toque para líquido",
    "tallysheet.volBasisWhy": "O líquido conta para estoque, vendas e serviços de serraria. O bruto é a medida original. Toque em Líquido ou Bruto para trocar.",
    "tallysheet.volBreakdownTitle": "Volume Líquido vs Bruto",
    "tallysheet.volBreakdownExplain": "O líquido é o que conta para estoque, vendas e serviços de serraria. O bruto é a medida original, antes do desconto de casca e corte.",
    "tallysheet.switchToGross": "Trocar para Bruto",
    "tallysheet.switchToNet": "Trocar para Líquido",
    "tallysheet.grossCbm": "CBM bruto",
    "tallysheet.grossCft": "CFT bruto",
    "tallysheet.netCbm": "CBM líquido",
    "tallysheet.netCft": "CFT líquido",
    "tallysheet.supplier": "Fornecedor",
    "tallysheet.buyer": "Comprador",
    "tallysheet.driver": "Motorista",
    "tallysheet.route": "Rota",
    "tallysheet.expectedDelivery": "Entrega prevista",
    "tallysheet.mode": "Modo",
    "tallysheet.seaPort": "Porto marítimo",
    "tallysheet.locationMode": "Local e Modo",
    "tallysheet.totalPieces": "Total de peças",
    "tallysheet.netVolumeCbm": "Vol. Líq. (CBM)",
    "tallysheet.avgCft": "Média CFT",
    "tallysheet.weight": "Peso (kg)",
    "tallysheet.photoCount": "Fotos",
    "tallysheet.metrics": "Métricas",
    "tallysheet.divisibleBy5": "Divisível por 5",
    "tallysheet.divisibleBy5On": "Divisível por 5 ON",
    "tallysheet.divisibleBy5Off": "Divisível por 5 OFF",
    "tallysheet.lengthRange": "Faixa de comprimento",
    "tallysheet.lengthRangeOn": "Faixa de comprimento ON",
    "tallysheet.widthRange": "Faixa de largura",
    "tallysheet.thickRange": "Faixa de espessura",
    "tallysheet.rangeOn": "Ativado",
    "tallysheet.rangeOff": "Desativado",
    "tallysheet.rangeHint": "Valores fora da faixa ficam marcados como aviso (âmbar) e são mantidos.",
    "tallysheet.resetToCompanyDefaults": "Voltar aos padrões da empresa",
    "tallysheet.resetConfirm": "Muda unidades, tolerâncias e regras deste tally.",
    "tallysheet.resetYes": "Redefinir",
    "tallysheet.lengthRangeOff": "Faixa de comprimento OFF",
    "tallysheet.girthRange": "Faixa de circunferência",
    "tallysheet.girthRangeOn": "Faixa de circunferência ON",
    "tallysheet.girthRangeOff": "Faixa de circunferência OFF",
    "tallysheet.unitOfMeasure": "Unidade de medida",
    "tallysheet.copyPreviousLength": "Copiar comprimento anterior",
    "tallysheet.enterNavMode": "↵ Mode",
    "tallysheet.enterNavModeTooltip": "<b>Modo Linha:</b> Enter em Comprimento → Circunferência; Enter em Circunferência → nova linha.<br><b>Modo Coluna:</b> Enter em Comprimento → nova linha (fica na coluna); Enter em Circunferência → próxima linha (cria nova linha se for a última).<br><b>Ctrl+Enter</b> (qualquer modo) → forçar ação, ignora validação.",
    "tallysheet.allowances": "Ajustes",
    "tallysheet.lengthAllowance": "Ajuste de comprimento",
    "tallysheet.girthAllowance": "Ajuste de circunferência",
    "tallysheet.allowancesLocked":
      "Os ajustes ficam bloqueados quando as linhas excedem",
    "tallysheet.columns": "Colunas",
    "tallysheet.showColumns": "Mostrar colunas",
    "tallysheet.saveFormSettings": "Salvar configurações do formulário",
    "tallysheet.confirmSave": "Confirmar salvamento",
    "tallysheet.uomChangeTitle": "Alterar unidade de medida?",
    "tallysheet.uomChangeMessage":
      "Este tally já possui linhas registradas. Como os valores existentes de {field} devem ser tratados para a nova unidade?",
    "tallysheet.uomChangeKeep": "Manter números como digitados",
    "tallysheet.uomChangeKeepHint":
      "Recalcular usando os mesmos números na nova unidade — use se você digitou os números certos, mas selecionou a unidade errada.",
    "tallysheet.uomChangeConvert": "Converter valores",
    "tallysheet.uomChangeConvertHint":
      "Reescrever os números existentes para a nova unidade, mantendo a mesma medida física.",
    "tallysheet.uomChangeCancel": "Cancelar",
    "account.profilePicture": "Foto de Perfil",
    "account.yourRole": "Sua Função",
    "account.details": "Detalhes da conta",
    "account.personalDetails": "Detalhes pessoais",
    "account.detailsHint": "Seu e-mail de acesso e um número de celular verificado",
    "account.personalHint": "Sobre você, para que sua equipe e seus documentos mostrem o nome certo",
    "account.addressHeading": "Endereço",
    "account.changePassword": "Alterar senha",
    "account.emailNotVerified":
      "O email não foi verificado. Verifique seu endereço de email.",
    "account.mobile": "Celular",
    "account.enterMobile": "Digite o número do celular",
    "account.mobileNotVerified":
      "O celular não foi verificado. Verifique seu número de celular.",
    "account.sendOtp": "Enviar OTP",
    "account.editMobile": "Editar celular",
    "account.dateOfBirth": "Data de nascimento",
    "account.gender": "Gênero",
    "account.next": "Próximo",
    "account.otpSentTo": "OTP enviado para",
    "account.enterOtpBelow": "Digite o OTP abaixo para verificar seu telefone.",
    "account.resendOtpIn": "Reenviar OTP em",
    "account.seconds": "segundos",
    "account.resend": "Reenviar",
    "account.sendOtpWhatsapp": "Enviar código no WhatsApp",
    "account.sendOtpSms": "Enviar código por SMS",
    "account.otpWhatsappNote": "O código chega no WhatsApp, vindo da LumberLinq. Toque em Copiar código e cole aqui.",
    "account.otpWhatsappFailed": "Não foi possível enviar o código no WhatsApp. Verifique se este número usa WhatsApp ou envie o código por SMS.",
    "account.otpUseSms": "Enviar por SMS",
    "account.otpUseWhatsapp": "Enviar no WhatsApp",
    "account.otpPickHint": "Receba seu código de 6 dígitos no WhatsApp ou por SMS",
    "account.otpWaDelivered": "O código já está no seu WhatsApp. Abra a conversa, toque em Copiar código e cole aqui.",
    "account.otpWaNotDelivered": "O WhatsApp não conseguiu entregar o código (o número pode não estar no WhatsApp). Envie o código por SMS.",
    "account.otpWaPending": "Ainda não chegou ao celular? Aguarde um pouco, reenvie ou envie o código por SMS.",
    "account.confirm": "Confirmar",
    "account.oldPassword": "Senha antiga",
    "account.newPassword": "Nova senha",
    "account.confirmPassword": "Confirmar senha",
    "account.oldPasswordRequired": "A senha antiga é obrigatória.",
    "account.passwordMinLength": "A senha deve ter pelo menos 8 caracteres.",
    "account.passwordStrengthHint": "A senha deve conter pelo menos uma letra e um número.",
    "account.passwordChangeFailed": "Falha ao alterar a senha. Por favor, tente novamente.",
    "account.confirmPasswordRequired": "A confirmação da senha é obrigatória.",
    "account.passwordsMismatch": "As senhas não coincidem.",
    "account.mustBeAtLeast13": "Você deve ter pelo menos 13 anos de idade.",
    "user.mustBeAtLeast13": "Você deve ter pelo menos 13 anos de idade.",
    "account.notValidEmail": "não é um email válido",
    "account.passwordRule":
      "deve conter pelo menos 1 letra maiúscula, 1 letra minúscula e 1 número",
    "account.mustBeAtLeast": "deve ter pelo menos",
    "account.charactersLong": "caracteres",
    "account.profileUpdated": "Perfil atualizado com sucesso.",
    "account.profileLoadFailed": "Não foi possível carregar os detalhes do perfil.",
    "account.noProfileChanges": "Não há alterações de perfil para atualizar.",
    "account.saveAllHint": "Salva Detalhes da Conta, Dados Pessoais e Fuso Horário juntos.",
    "account.requiredAddressFields": "Preencha todos os campos obrigatórios de endereço antes de continuar.",
    "account.requiredFields": "Preencha todos os campos obrigatórios antes de continuar.",
    "account.updateFailed": "Ocorreu um erro ao atualizar o registro.",
    "account.verificationRequired": "Verificação obrigatória",
    "account.verifyMobileAndEmail": "Verifique seu celular e email primeiro.",
    "account.mobileVerified": "Celular verificado",
    "account.mobileAlreadyVerified": "Seu número de celular já foi verificado.",
    "account.mobileLocked": "O celular verificado não pode ser alterado nesta tela.",
    "account.otpSent": "OTP enviado",
    "account.otpError": "Erro de OTP",
    "account.otpUnableToSend": "Não foi possível enviar o OTP.",
    "account.tryAgainLater": "Tente novamente mais tarde",
    "account.maxOtpAttempts": "Você atingiu o número máximo de tentativas de reenvio do OTP.",
    "account.otpValidated": "OTP validado",
    "account.otpInvalidTitle": "OTP inválido",
    "account.otpInvalid": "OTP inválido.",
    "account.otpDigit": "Dígito do OTP",
    "account.invalidMobileOnly": "Somente números de celular são permitidos. Digite um número de celular válido.",
    "account.invalidPhoneFormat": "Formato de telefone inválido.",
    Male: "Masculino",
    Female: "Feminino",
    "Prefer not to say": "Prefiro não dizer",
    "product.name": "Produto",
    "product.multipleProducts": "Produtos",
    "product.multipleProductsBreakdown": "Produtos nesta unidade",
    "product.namePlural": "Produtos",
    "product.subtitle": "Gerencie produtos de madeira, espécies e códigos HS",
    "product.all": "Todos os produtos",
    "product.update": "Atualizar produto",
    "product.manageDetails": "Ver e gerenciar detalhes dos produtos existentes",
    "product.editDetails": "Editar detalhes dos produtos existentes",
    "product.hsCode": "Código HS",
    "product.formula": "Fórmula",
    "product.selectFormula": "Selecionar fórmula",
    "product.quickAdd": "Adicionar novo produto",
    "product.quickAddTitle": "Novo Produto",
    "product.nameRequiredHint": "O nome deve ter pelo menos 5 caracteres.",
    "product.hsCodeHint": "O código HS deve ter de 4 a 8 dígitos.",
    "product.quickAddedDetail": "Produto criado e selecionado.",
    "product.quickAddError": "Não foi possível criar o produto. Tente novamente.",
    "product.description": "Descrição",
    "product.species": "Espécie",
    "product.usedIn": "Usado em",
    "product.selectSpecies": "Selecionar espécie",
    "product.productCode": "Código do produto",
    "product.photos": "Fotos do produto",
    "product.addPhoto": "Adicionar foto",
    "product.setAsDP": "Definir como foto principal",
    "product.formulasGuide": "Guia de fórmulas",
    "product.formulaGuide.roundTitle": "Tora Redonda",
    "product.formulaGuide.roundFormula": "Fórmula Hoppus: (Circunferência × Circunferência × Comprimento) ÷ 160.000",
    "product.formulaGuide.roundWhen": "Para toras redondas, não processadas e madeira em tora.",
    "product.formulaGuide.roundChoose": "Escolha quando a seção transversal for circular — toras inteiras, madeira bruta e madeira redonda não processada.",
    "product.formulaGuide.squareTitle": "Quadrada / Serrada",
    "product.formulaGuide.squareFormula": "Fórmula volumétrica: Comprimento × Largura × Altura",
    "product.formulaGuide.squareWhen": "Para madeira serrada ou cortada em quadrado.",
    "product.formulaGuide.squareChoose": "Escolha quando a madeira for retangular ou cortada — tábuas, vigas, pranchas e madeira beneficiada.",
    "product.formulaGuide.notSure": "Não sabe qual escolher?",
    "product.formulaGuide.tip": "Seção transversal redonda → Tora Redonda. Retangular ou serrada → Quadrada / Serrada.",
    "product.formulaPicker": "Seletor de fórmula",
    "product.deletionRestriction": "Restrição de exclusão de produto",
    "product.addNew": "Adicionar produto",
    "product.bulkImport": "Importação em massa",
    "product.create": "Criar produto",
    "product.inputDetails": "Inserir detalhes do novo produto",
    "loadingSite.name": "Nome do local",
    "loadingSite.namePlural": "Locais",
    "loadingSite.quickAdd": "Adicionar novo local",
    "loadingSite.quickAddTitle": "Novo Local",
    "loadingSite.nameRequired": "O nome deve ter pelo menos 3 caracteres.",
    "loadingSite.quickAddedDetail": "Local criado e selecionado.",
    "loadingSite.quickAddError": "Não foi possível criar o local. Tente novamente.",
    "loadingSite.all": "Todos os locais",
    "loadingSite.update": "Atualizar local",
    "loadingSite.manageProfiles":
      "Ver e gerenciar perfis de locais existentes",
    "loadingSite.editDetails":
      "Editar detalhes dos locais existentes",
    "loadingSite.contactPerson": "Pessoa de contato",
    "loadingSite.operatingHours": "Horário de operação",
    "loadingSite.capacity": "Capacidade",
    "loadingSite.capacityCbm": "Capacidade (CBM)",
    "loadingSite.currentVolume": "Volume atual",
    "loadingSite.machinesInstalled": "Máquina(s) instalada(s)",
    "loadingSite.notes": "Notas",
    "loadingSite.addNew": "Adicionar local",
    "loadingSite.bulkImport": "Importação em massa",
    "loadingSite.create": "Criar local",
    "loadingSite.inputDetails":
      "Inserir detalhes do novo local",
    "location.selectCountry": "Selecionar país",
    "location.selectState": "Selecionar estado",
    "location.selectCity": "Selecionar cidade",
    "location.country": "País",
    "location.state": "Estado / Província",
    "location.city": "Cidade",
    "location.address1": "Endereço Linha 1",
    "location.address2": "Endereço Linha 2",
    "location.postalCode": "CEP",
    "location.cityUnavailableOffline": "Lista de cidades indisponível offline. Conecte-se uma vez para carregar as cidades deste estado.",
    "location.cityNotAvailableOffline": "Não disponível offline",
    "mediaCapture.takePhoto": "Tirar Foto",
    "mediaCapture.recordVideo": "Gravar Vídeo (máx. 30s)",
    "mediaCapture.chooseGallery": "Escolher da Galeria",
    "mediaCapture.browseFiles": "Procurar Arquivos",
    "mediaCapture.videoTooLongTitle": "Vídeo Muito Longo",
    "mediaCapture.videoTooLongDetail": "O vídeo deve ter 30 segundos ou menos. Por favor, tente novamente.",
    "mediaCapture.captureFailedTitle": "Falha na Captura",
    "mediaCapture.captureFailedDetail": "Não foi possível capturar a mídia. Por favor, tente novamente.",
    "mediaCapture.pasteRejectedTitle": "Arquivo colado não aceito",
    "mediaCapture.pasteRejectedDetail": "Esta caixa de upload não aceita esse tipo de arquivo.",
    "sfs.title": "Para onde devem ir estes arquivos?",
    "sfs.filesReady": "arquivo(s) pronto(s)",
    "sfs.consignment": "Documentos da remessa",
    "sfs.consignmentHint": "BL, fatura, certificados e mais",
    "sfs.stockUnit": "Documentos da Unidade de Estoque",
    "sfs.stockUnitHint": "Fotos e papéis de uma unidade de estoque",
    "sfs.aiImport": "Importação por IA",
    "sfs.aiImportHint": "Ler uma folha de contagem a partir de foto ou PDF",
    "sfs.aiNeedsImage": "Precisa de uma foto ou PDF",
    "sfs.ticket": "Chamado de suporte",
    "sfs.ticketHint": "Anexar a um novo chamado",
    "sfs.pickPlace": "Escolha um destino",
    "sfs.pickDocType": "Qual tipo de documento?",
    "sfs.back": "Voltar",
    "sfs.cancel": "Cancelar",
    "sfs.discard": "Descartar arquivos",
    "sfs.noAccess": "Você não tem acesso para enviar arquivos. Fale com o administrador.",
    "sfs.note": "Nada foi enviado ainda. A tela escolhida vai pedir sua confirmação.",
    "sfs.toast.title": "Arquivos aguardando",
    "sfs.toast.consignment": "Abra a remessa desejada e clique em Anexar aqui.",
    "sfs.toast.consignmentHere": "Clique em Anexar aqui na aba Documentos desta remessa.",
    "sfs.toast.aiImportHere": "Clique em Anexar aqui acima desta folha de contagem.",
    "sfs.toast.stockUnit": "Abra uma Unidade de Estoque, vá à aba Fotos e clique em Anexar aqui.",
    "sfs.toast.stockUnitHere": "Clique em Anexar aqui na aba Fotos desta Unidade de Estoque.",
    "sfs.toast.aiImport": "Abra a folha de contagem desejada e clique em Anexar aqui.",
    "sfs.toast.ticket": "Preencha o chamado. Os arquivos já estão anexados.",
    "sfs.waiting.consignment": "abra a Remessa desejada e clique em Anexar aqui",
    "sfs.waiting.stockUnit": "abra uma Unidade de Estoque, aba Fotos, e clique em Anexar aqui",
    "sfs.waiting.aiImport": "abra uma folha de contagem e clique em Anexar aqui",
    "sfs.waiting.ticket": "sendo adicionados ao seu novo chamado",
    "sfs.banner.hint": "Aguardando para serem anexados a um registro.",
    "sfs.banner.attach": "Anexar aqui",
    "sfs.banner.discard": "Descartar",
    "sfs.blocked.locked": "Esta remessa está bloqueada, então não é possível adicionar arquivos.",
    "sfs.blocked.shipped": "Esta Unidade de Estoque foi enviada e está bloqueada, então não é possível adicionar arquivos.",
    "sfs.blocked.viewMode": "Esta folha de contagem está agora só para leitura. Passe primeiro para o modo de edição e depois anexe os ficheiros.",
    "sfs.blocked.slot": "Este tipo de documento não está disponível nesta remessa.",
    "sfs.blocked.readonly": "Você só pode visualizar este tipo de documento aqui.",
    "sfs.blocked.busy": "Outro envio está em andamento. Aguarde.",
    "mediaCapture.paste": "Colar",
    "mediaCapture.pasteNothingTitle": "Nada para colar",
    "mediaCapture.pasteNothing": "Nenhum arquivo encontrado na área de transferência. Copie um arquivo primeiro ou use Compartilhar → LumberLinq no outro app.",
    "mediaCapture.pasteTextOnly": "A área de transferência tem texto, não um arquivo. Copie um arquivo primeiro ou use Compartilhar → LumberLinq no outro app.",
    "mediaCapture.pasteNoImage": "Nenhuma imagem encontrada na área de transferência. Copie uma imagem ou faça uma captura de tela e toque em Colar.",
    "sfs.native.failedTitle": "Alguns arquivos não puderam ser lidos",
    "sfs.native.failed": "Alguns arquivos compartilhados eram grandes demais ou não puderam ser abertos. Tente compartilhá-los de novo.",
    "avatar.changePhoto": "Alterar Foto",
    "avatar.chooseFile": "Escolher Arquivo",
    "avatar.removePhoto": "Remover Foto",
    "avatar.cropTitle": "Ajuste Sua Foto",
    "avatar.cropHint": "Arraste para reposicionar • Role ou belisque para ampliar",
    "avatar.cropConfirm": "Usar Foto",
    "avatar.cropCancel": "Cancelar",
    "avatar.uploading": "Enviando...",
    "avatar.uploadSuccess": "Foto de perfil atualizada",
    "permEditor.viewAddedNote": "A permissão de visualizar também foi ativada, porque esta permissão precisa dela.",
    "permEditor.actionsRemovedNote": "As permissões que precisam de visualizar também foram desativadas.",
    "permEditor.needsView": "Requer visualizar",
    "avatar.uploadFailed": "Falha no envio",
    "avatar.retry": "Tentar Novamente",
    "avatar.confirmRemoveTitle": "Remover Foto de Perfil?",
    "avatar.confirmRemoveMessage": "Seu avatar voltará a mostrar suas iniciais.",
    "avatar.invalidFileType": "Por favor, escolha um arquivo de imagem (JPG, PNG ou WEBP).",
    "avatar.fileTooLarge": "A imagem deve ter menos de 5 MB.",
    "dashV3.title": "Painel de Operações",
    "dashV3.subtitle":
      "Visão geral em tempo real das suas operações de comércio de madeira",
    "dashV3.dateFrom": "De",
    "dashV3.dateTo": "Até",
    "dashV3.apply": "Aplicar",
    "dashV3.refresh": "Atualizar",
    "dashV3.staleSnapshot": "Offline — exibindo um instantâneo em cache de",
    "dashV3.loading": "Carregando painel...",
    "offline.unavailableTitle": "Requer conexão",
    "offline.unavailableLead": "Este recurso não está disponível enquanto você está offline.",
    "offline.unavailableBody": "Exportação, importação, relatórios, consignações e inventário exigem uma conexão ativa. Unidades de Estoque, Parceiros de Negócio, Produtos e Locais continuam funcionando offline.",
    "offline.goToDashboard": "Ir para o Painel",
    "offline.autoReturnHint": "Você será levado de volta automaticamente assim que estiver online novamente.",
    "dashV3.kpi.partners": "Parceiros de Negócio",
    "dashV3.kpi.active": "Ativos",
    "dashV3.kpi.inactive": "Inativos",
    "dashV3.kpi.shipments": "Consignações",
    "dashV3.kpi.transportUnits": "Unidades de Estoque",
    "dashV3.kpi.unassigned": "Não atribuídas",
    "dashV3.kpi.volume": "Volume Total",
    "dashV3.kpi.pieces": "Total de Peças",
    "dashV3.kpi.cbm": "CBM",
    "dashV3.kpi.cft": "CFT",
    "dashV3.chart.byTradeType": "Consignações por Tipo de Comércio",
    "dashV3.chart.byMode": "Modo de Transporte",
    "dashV3.chart.volumeTrend": "Tendência de Volume",
    "dashV3.chart.topProducts": "Principais Produtos por Volume (CFT)",
    "dashV3.chart.siteUtilization": "Utilização do Local",
    "dashV3.chart.paymentStatus": "Status de Pagamento",
    "dashV3.upcoming.departures": "Próximas Partidas",
    "dashV3.upcoming.arrivals": "Próximas Chegadas",
    "dashV3.upcoming.next7days": "Próximos 7 Dias",
    "dashV3.upcoming.noDepartures": "Nenhuma partida nos próximos 7 dias",
    "dashV3.upcoming.noArrivals": "Nenhuma chegada nos próximos 7 dias",
    "dashV3.upcoming.blNo": "BL / Nº Fatura",
    "dashV3.upcoming.shipper": "Embarcador",
    "dashV3.upcoming.consignee": "Destinatário",
    "dashV3.upcoming.date": "Data",
    "dashV3.upcoming.port": "Porto",
    "dashV3.recent.title": "Unidades de Estoque Recentes",
    "dashV3.recent.transportId": "ID de Transporte",
    "dashV3.recent.product": "Produto",
    "dashV3.recent.site": "Local",
    "dashV3.recent.pieces": "Peças",
    "dashV3.recent.volume": "Volume",
    "dashV3.recent.created": "Criado em",
    "dashV3.subscription.title": "Assinatura",
    "dashV3.subscription.package": "Pacote",
    "dashV3.subscription.validTill": "Válido até",
    "dashV3.subscription.daysLeft": "dias restantes",
    "dashV3.subscription.expiringSoon": "Assinatura expirando em breve!",
    "dashV3.subscription.renew": "Renovar Agora",
    "dashV3.partners.byCountry": "Parceiros por País",
    "dashV3.kpi.upcoming": "Próximos",
    "dashV3.kpi.tallyUnits": "Unidades de Tally",
    "dashV3.upcoming.pol": "Porto de Embarque",
    "dashV3.upcoming.pod": "Porto de Descarga",
    "dashV3.upcoming.mode": "Modal",
    "dashV3.subscription.expiring": "Assinatura expirando em breve —",
    "dashV3.subscription.status": "Status",
    "dashV3.subscription.days": "dias restantes",
    "dashV3.recent.id": "ID de Transporte",
    "dashV3.recent.cbm": "CBM",
    "dashV3.recent.cft": "CFT",
    "dashV3.recent.viewAll": "Ver Todos",
    "dashV3.site.name": "Local",
    "dashV3.site.country": "País",
    "dashV3.site.capacity": "Capacidade",
    "dashV3.site.noCapacitySet": "Nenhuma capacidade definida para este local",
    "dashV3.site.current": "Atual",
    "dashV3.site.util": "Utilização",
    "dashV3.noData": "Nenhum dado disponível para o período selecionado",

    "report.title": "Relatórios",
    "report.from": "De",
    "report.to": "Até",
    "report.inventory.title": "Relatório de Inventário",
    "report.inventory.subtitle": "Níveis de estoque, histórico de movimentos, ajustes e ordens de serraria",
    "report.inventory.unitsAbbrev": "SUs",
    "report.bp.title": "Relatório de Parceiro Comercial",
    "report.bp.subtitle":
      "Análise completa de transações, volumes e pagamentos do parceiro comercial",
    "report.bp.search": "Pesquisar Parceiro Comercial",
    "report.bp.selectBp":
      "Selecione um parceiro comercial para gerar o relatório",
    "report.bp.period": "Período do Relatório",
    "report.bp.from": "Data Inicial",
    "report.bp.to": "Data Final",
    "report.bp.generate": "Gerar Relatório",
    "report.bp.generating": "Gerando...",
    "report.bp.exportExcel": "Exportar Excel",
    "report.bp.exportPdf": "Exportar PDF",
    "report.bp.noData":
      "Nenhum dado de consignação encontrado para o período selecionado.",
    "report.bp.profile": "Perfil do Parceiro",
    "report.bp.partyType": "Tipo de Parte",
    "report.bp.category": "Categoria",
    "report.bp.regType": "Tipo de Registro",
    "report.bp.taxId": "ID Fiscal",
    "report.bp.active": "Ativo",
    "report.bp.inactive": "Inativo",
    "report.bp.owner": "Proprietário",
    "report.kpi.totalShipments": "Total de Consignações",
    "report.kpi.asSeller": "Como Vendedor",
    "report.kpi.asBuyer": "Como Comprador",
    "report.kpi.totalCbm": "Net CBM",
    "report.kpi.totalCft": "Net CFT",
    "report.kpi.totalPieces": "Peças Totais",
    "report.payment.sellerTitle": "Pagamento — Como Vendedor",
    "report.payment.buyerTitle": "Pagamento — Como Comprador",
    "report.payment.totalInvoiced": "Total Faturado",
    "report.payment.received": "Totalmente Recebido",
    "report.payment.partially": "Parcialmente Pago",
    "report.payment.invoiced": "Faturado (Enviado)",
    "report.payment.notInvoiced": "Não Faturado",
    "report.payment.overdue": "Vencido",
    "report.payment.outstanding": "Em Aberto",
    "report.payment.cancelled": "Cancelado",
    "report.payment.totalPayable": "Total a Pagar",
    "report.payment.paid": "Pago",
    "report.payment.pending": "Pendente",
    "report.payment.disputed": "Disputado",
    "report.chart.monthlyVolume": "Volume Mensal e Consignações",
    "chart.emptyTitle": "Ainda sem dados",
    "chart.emptyHint": "Este gráfico é preenchido quando houver registros.",
    "report.chart.monthlyInvoice": "Valor Faturado Mensal",
    "report.chart.tradeRoleSplit": "Divisão por Função Comercial",
    "report.chart.paymentStatus": "Status de Pagamento",
    "report.table.transactions": "Transações de Consignação",
    "report.table.date": "Data",
    "report.table.role": "Função",
    "report.table.tradeType": "Tipo de Comércio",
    "report.table.pol": "Porto de Embarque",
    "report.table.pod": "Porto de Descarga",
    "report.table.origin": "País de Origem",
    "report.table.destination": "Destino",
    "report.table.currency": "Moeda",
    "report.table.invoiceAmt": "Valor da Fatura",
    "report.table.cbm": "Net CBM",
    "report.table.cft": "Net CFT",
    "report.table.pieces": "Peças",
    "report.table.units": "Unidades de Estoque",
    "report.table.payStatus": "Status de Pagamento",
    "report.table.blNo": "Nº B/L",
    "report.table.status": "Status",
    "report.table.products": "Produtos",
    "report.table.sites": "Locais",
    "report.products.title": "Resumo de Produtos",
    "report.products.name": "Produto",
    "report.products.hsCode": "Código HS",
    "report.products.cbm": "Net CBM",
    "report.products.cft": "Net CFT",
    "report.products.pieces": "Peças",
    "report.products.units": "Unidades de Estoque",
    "report.products.shipments": "Consignações",
    "report.sites.title": "Resumo de Locais",
    "report.sites.name": "Nome do Local",
    "report.sites.location": "Localização",
    "report.sites.cbm": "Net CBM",
    "report.sites.cft": "Net CFT",
    "report.sites.pieces": "Peças",
    "report.sites.units": "Unidades de Estoque",
    "report.sites.shipments": "Consignações",
    "report.role.seller": "Vendedor",
    "report.role.buyer": "Comprador",
    "report.role.notify": "Parte Notificada",
    "report.generatedAt": "Gerado em",
    "report.generate": "Gerar Relatório",
    "report.loading": "Carregando relatório...",
    "report.empty":
      "Selecione os filtros e clique em Gerar para visualizar o relatório.",
    "report.noData": "Nenhum dado encontrado para o período selecionado.",
    "report.export.excel": "Exportar Excel",
    "report.export.pdf": "Exportar PDF",
    "report.filter.from": "De",
    "report.filter.to": "Até",
    "report.filter.all": "Todos",
    "report.filter.clear": "Limpar filtros",
    "report.tab.overview": "Visão Geral",
    "report.tab.transactions": "Transações",
    "report.tab.financial": "Financeiro",
    "report.tab.products": "Produtos",
    "report.tab.sites": "Sites",
    "report.tab.trend": "Tendência Mensal",
    "report.tab.byCurrency": "Por Moeda",
    "report.tab.partners": "Principais Parceiros",
    "report.kpi.totalInvoiced": "Total Faturado",
    "report.kpi.overdue": "Vencido",
    "report.kpi.units": "Unidades de Estoque",
    "report.col.date": "Data",
    "report.col.month": "Mês",
    "report.col.tradeType": "Tipo de Comércio",
    "report.col.status": "Status",
    "report.col.shipper": "Exportador",
    "report.col.consignee": "Consignatário",
    "report.col.polPod": "POL / POD",
    "report.col.currency": "Moeda",
    "report.col.invoiceAmt": "Valor Fatura",
    "report.col.invoiced": "Faturado",
    "report.col.salesStatus": "Status de Vendas",
    "report.col.cbm": "CBM",
    "report.col.netCbm": "Net CBM",
    "report.col.cft": "CFT",
    "report.col.netCft": "Net CFT",
    "report.col.pieces": "Peças",
    "report.col.units": "Unidades",
    "report.col.shipments": "Consignações",
    "report.col.blNo": "Nº B/L",
    "report.col.product": "Produto",
    "report.col.hsCode": "Código HS",
    "report.col.avgCbmPerUnit": "CBM Médio/Unidade",
    "report.col.currentStock": "Estoque Atual",
    "report.col.lots": "lotes",
    "report.col.topPartners": "Principais Parceiros",
    "report.col.topSites": "Principais Sites",
    "report.col.topProducts": "Principais Produtos",
    "report.col.site": "Site",
    "report.col.location": "Localização",
    "report.col.capacity": "Capacidade",
    "report.col.utilization": "Utilização",
    "report.col.millThroughput": "Vazão do Moinho CBM",
    "report.col.runs": "ordens",
    "report.col.partner": "Parceiro",
    "report.col.totalInvoiced": "Total Faturado",
    "report.col.fullyPaid": "Pago Totalmente",
    "report.col.partiallyPaid": "Pago Parcialmente",
    "report.col.overdue": "Vencido",
    "report.col.outstanding": "Pendente",
    "report.col.sellerOutstanding": "Pendente Vendedor",
    "report.col.buyerTotal": "Total Comprador",
    "report.col.buyerPaid": "Pago Comprador",
    "report.col.buyerPending": "Pendente Comprador",
    "report.col.netPosition": "Posição Líquida",
    "report.col.totalAmt": "Valor Total",
    "report.col.received": "Recebido",
    "report.col.paid": "Pago",
    "report.col.payable": "A Pagar",
    "report.shipment.title": "Relatório de Consignações",
    "report.shipment.tradeType": "Tipo de Comércio",
    "report.shipment.status": "Status",
    "report.shipment.financialByCurrency": "Financeiro por Moeda",
    "report.shipment.monthlyTrend": "Tendência Mensal",
    "report.product.title": "Relatório de Produtos",
    "report.product.distinctProducts": "Produtos Distintos",
    "report.site.title": "Relatório de Locais",
    "report.site.distinctSites": "Sites Distintos",
    "report.site.noCapacity": "Dados de capacidade não disponíveis",
    "report.financial.title": "Relatório Financeiro",
    "report.financial.currency": "Moeda",
    "report.financial.currencyPlaceholder": "ex. USD",
    "report.financial.revenue": "Receita (Recebida)",
    "report.financial.cost": "Custo (Pago)",
    "report.financial.receivable": "A Receber",
    "report.financial.payable": "A Pagar",
    "report.financial.overdue": "Vencido",
    "report.financial.topRevenuePartners": "Principais Parceiros de Receita",
    "report.financial.topCostPartners": "Principais Parceiros de Custo",
    "report.financial.tradeTypeSummary": "Por Tipo de Comércio",
    "report.chart.byTradeType": "Por Tipo de Comércio",
    "report.chart.sellerPayStatus": "Status Pagamento Vendedor",
    "report.chart.topLoadingPorts": "Principais Portos de Carregamento",
    "report.chart.topProductsByCbm": "Principais Produtos por Net CBM",
    "report.chart.monthlyProductTrend": "Tendência Mensal de Produtos",
    "report.chart.siteCbm": "Net CBM por Local",
    "report.chart.utilization": "Utilização do Site",
    "report.chart.monthlyTrend": "Throughput Mensal",
    "report.chart.financialOverview": "Visão Financeira Geral",
    "report.chart.receivablesBreakdown": "Detalhamento de Recebíveis",
    "report.chart.monthlyInvoicedTrend": "Tendência Mensal Faturada",
    "report.tab.units": "Unidades de Estoque",
    "report.tab.tallies": "Fichas de Talha",
    "report.col.transportId": "ID de Transporte",
    "report.col.unitNumber": "Nº Unidade",
    "report.col.mode": "Modo",
    "report.col.shipment": "Consignação",
    "report.col.type": "Tipo",
    "report.col.created": "Criado em",
    "report.tu.title": "Relatório de Unidades de Estoque",
    "report.operator.title": "Relatório de Desempenho de Operadores",
    "report.operator.totalOperators": "Total de Operadores",
    "report.operator.activeOperators": "Operadores Ativos",
    "report.operator.runsCompleted": "Ordens de Serraria Concluídas",
    "report.operator.totalOutputCbm": "CBM Total de Saída",
    "report.operator.avgOutturn": "Rendimento Médio",
    "report.operator.byOperator": "Por Operador",
    "report.operator.name": "Nome",
    "report.operator.employeeCode": "Código do Funcionário",
    "report.operator.specializations": "Especializações",
    "report.operator.active": "Ativo",
    "report.operator.activeYes": "Ativo",
    "report.operator.activeNo": "Inativo",
    "report.operator.inputCbm": "CBM de Entrada",
    "report.operator.outputCbm": "CBM de Saída",
    "report.operator.bestOutturn": "Melhor Rendimento",
    "report.operator.avgDuration": "Duração Média (hrs)",
    "report.tu.totalUnits": "Total de Unidades",
    "report.tu.linked": "Vinculado à Consignação",
    "report.tu.inStock": "Em Estoque (Inventário)",
    "report.tu.unlinked": "Sem Vínculo",
    "report.tu.statusBreakdown": "Distribuição por Status",
    "report.tu.modeBreakdown": "Modo de Transporte",
    "report.tu.monthlyTrend": "Tendência Mensal",
    "report.tu.statusSummary": "Resumo por Status",
    "report.tally.title": "Relatório de Fichas de Talha",
    "report.tally.totalTallies": "Total de Fichas",
    "report.tally.roundTallies": "Madeira Redonda",
    "report.tally.squareTallies": "Madeira Quadrada",
    "report.tally.flexibleGrid": "Grade Flexível",
    "report.tally.typeBreakdown": "Distribuição por Tipo",
    "report.tally.monthlyCbm": "CBM Mensal por Tipo",
    "report.tally.shrinkageChart": "CBM Origem vs Destino",
    "report.tally.noShrinkageData": "Nenhum dado de destino disponível.",
    "report.tally.avgCbm": "CBM Médio / Ficha",
    "report.tally.avgPieces": "Peças Médias / Ficha",
    "report.tally.tallies": "Fichas",
    "report.tally.destCbm": "CBM Dest.",
    "report.tally.shrinkage": "Redução %",

    "inventory.inOut": "Entrada / Saída",
    "inventory.receiveIntoInventory": "Receber no Inventário",
    "inventory.receiveNeedsRows": "Adicione pelo menos uma linha ao tally antes de receber no inventário",
    "inventory.receivedIntoInventory": "Recebido no Inventário",
    "inventory.receiveConfirmMessage": "Adicionar Unidade de Estoque {transportId} ao inventário? Isto registrará como uma entrada de estoque.",
    "inventory.yesReceive": "Sim, Receber",
    "inventory.received": "Recebido",
    "inventory.receivedDetail": "{transportId} foi adicionado ao inventário.",
    "inventory.confirmStockOut": "Confirmar Saída de Estoque",
    "inventory.confirmChecking": "Verificando o estoque…",
    "inventory.confirmStockOutMessage": "Confirmar que a Unidade de Estoque {transportId} foi enviada? Isto debitará permanentemente o estoque correspondente.",
    "inventory.confirmStockOutMultiProductIntro": "Esta unidade de estoque tem {count} produtos, que serão debitados permanentemente da seguinte forma: {breakdown}. Continuar?",
    "inventory.confirmStockOutBatchIntro": "Isto será retirado de {count} lotes: {breakdown}. Continuar?",
    "inventory.confirmStockOutInsufficientWarning": "Aviso: estoque insuficiente para um ou mais destes produtos — a confirmação pode falhar.",
    "inventory.stockShortTitle": "Estoque insuficiente — nada foi salvo",
    "inventory.stockShortHint": "Corrija estas linhas ou ative “Let sales continue past available stock” em Application Settings → Inventory Policy.",
    "inventory.stockShortLineNone": "{label}: precisa de {need} pcs, sem estoque",
    "inventory.stockShortLineOnly": "{label}: precisa de {need} pcs, apenas {free} livres",
    "inventory.confirmBlockedNoStock": "Não é possível confirmar — estas linhas não têm estoque livre do seu tamanho (a madeira reservada por outra Saída de Estoque não está livre):",
    "inventory.confirmBlockedNoStockHint": "Altere o tamanho, remova a linha ou peça à serraria para produzir.",
    "inventory.confirmUnsavedChanges": "Salve o romaneio primeiro — há linhas não salvas. A confirmação conta só linhas salvas e o romaneio é bloqueado depois.",
    "inventory.receiveUnsavedChanges": "Salve o romaneio primeiro — há linhas não salvas. Só as linhas salvas entram no estoque e o romaneio é bloqueado logo depois.",
    "tallysheet.tu.soldPastStock": "Vendido além do estoque disponível — motivo: {reason}",
    "tallysheet.tu.soldPastStockBy": " (por {by})",
    "statement.soldPastStock": "Vendido além do estoque disponível",
    "inventory.rowExceedsStockReview": "Excede o estoque — toque para revisar",
    "inventory.rowInsufficientStockFix": "Estoque insuficiente — toque para corrigir",
    "inventory.rowNotReservedHint": "Nenhum estoque está reservado atualmente para esta linha.",
    "inventory.resolvedOriginAuto": "estoque mais antigo",
    "inventory.shippedLockedMessage": "Esta unidade de estoque já foi confirmada e enviada — a edição está bloqueada. Apenas um administrador pode fazer alterações.",
    "inventory.rowNeedsLookSingular": "linha precisa de uma olhada",
    "inventory.rowNeedsLookPlural": "linhas precisam de uma olhada",
    "inventory.review": "Revisar",
    "inventory.yesConfirm": "Sim, Confirmar",
    "inventory.confirmStockOutTooltip": "Debitar permanentemente o estoque do conteúdo tabulado desta Unidade de Estoque",
    "inventory.stockOutConfirmed": "Saída de Estoque Confirmada",
    "inventory.stockOutConfirmedDetail": "{transportId} foi debitado do inventário.",

    "report.financial.actualReceived": "Recebido Real",
    "report.financial.actualPaid": "Pago Real",
    "report.financial.totalReceived": "Total Recebido",
    "report.financial.totalPaid": "Total Pago",
    "report.financial.netCashflow": "Fluxo de Caixa Líquido",
    "report.financial.receivables": "Recebíveis",
    "report.financial.payables": "Pagáveis",
    "report.col.txnType": "Tipo",
    "report.col.paymentMode": "Modo",
    "report.col.reference": "Referência",
    "report.col.notes": "Notas",

    "report.recon.title": "Relatório de Reconciliação",
    "report.recon.subtitle": "Análise de variância de talão origem vs destino",
    "report.recon.totalTallies": "Total de Talões",
    "report.recon.reconciled": "Reconciliado",
    "report.recon.pending": "Pendente",
    "report.recon.srcCbm": "CBM Origem",
    "report.recon.srcPieces": "Peças Origem",
    "report.recon.dstCbm": "CBM Destino",
    "report.recon.dstPieces": "Peças Destino",
    "report.recon.varianceCbm": "Variância CBM",
    "report.recon.variancePieces": "Variância Peças",
    "report.recon.shrinkage": "Redução %",
    "report.recon.millLoss": "CBM de Perda do Moinho",
    "report.recon.reconStatus": "Status Reconciliação",
    "report.recon.shrinkageDist": "Distribuição de Redução",
    // -- Common extras
    "common.locked": "Bloqueado",
    "common.reconciled": "Reconciliado",
    "common.confirmDeletion": "Confirmar exclusão",
    "common.amount": "Valor",
    "common.size": "Tamanho",
    // -- Tallysheet lock & AI import
    "tallysheet.lockedBanner": "Este tallysheet está bloqueado — nenhuma edição adicional é permitida.",
    "tallysheet.summaryOutdated": "O resumo pode estar desatualizado. Linhas foram salvas após o carregamento desta aba.",
    "tallysheet.lockButton": "Bloquear",
    "tallysheet.lockTooltip": "Bloquear este tallysheet permanentemente",
    "tallysheet.lockNeedsRows": "Adicione pelo menos uma linha ao tally antes de bloquear",
    "tallysheet.lockNoPhotosWarning": "Ainda não há fotos para este Stock Unit. Você ainda pode bloquear, mas normalmente não será fácil adicionar fotos depois.",
    "tallysheet.lockGoToPhotos": "Ir para Fotos",
    "tallysheet.lockDialogHeader": "Bloquear Tallysheet",
    "tallysheet.lockIrreversible": "Esta ação é irreversível.",
    "tallysheet.lockOnceNote": "Uma vez bloqueado, nenhuma entrada de tally pode ser adicionada ou modificada.",
    "tallysheet.lockTypeConfirm": "Digite LOCK para confirmar:",
    "tallysheet.lockPermanently": "Bloquear Permanentemente",
    "tallysheet.inventoryTab": "Inventário",
    "tallysheet.aiImport": "Importação IA",
    "tallysheet.aiImportTooltip": "Importação IA — envie uma imagem de tallysheet manuscrito",
    "tallysheet.lengthRequired": "Comprimento obrigatório",
    "tallysheet.girthRequired": "Circunferência obrigatória",
    "tallysheet.enterRowNumber": "Inserir número da linha",
    // -- Inventory extensions
    "inventory.notYetInInventory": "Ainda não está no inventário",
    "inventory.historyLoadFailedTitle": "Não foi possível carregar o histórico",
    "inventory.historyLoadFailedSub": "Tente novamente ao voltar a ficar online",
    "inventory.receiveToStartTracking": "Receba esta Unidade de Estoque para começar a rastrear movimentos de inventário.",
    "inventory.clickToReceive": "Clique no botão abaixo para receber esta Unidade de Estoque no inventário.",
    "inventory.notInInventoryBanner": "Não está no inventário — receba esta Unidade de Estoque para iniciar o rastreamento de estoque.",
    "inventory.statusLabel": "Status do Inventário",
    "inventory.statusColon": "Status do Inventário:",
    "inventory.movementHistory": "Histórico de Movimentos",
    "inventory.noMovementsYet": "Nenhum movimento registrado ainda.",
    "inventory.addToInventoryTooltip": "Adicionar esta Unidade de Estoque ao sistema de inventário",
    "inventory.productRequiredTooltip": "Adicione um Produto antes de receber no inventário",
    "inventory.moveComingSoon": "Mover entre locais — em breve",
    "inventory.loadingSiteRequiredTooltip": "É necessário um Local antes de receber no inventário",
    "inventory.loadingSiteRequiredBanner": "Selecione um Local antes de receber esta Unidade de Estoque no inventário — caso contrário o estoque não será rastreável.",
    "inventory.transportModeRequiredTooltip": "Adicione o Modo de Transporte antes de receber no inventário",
    "inventory.transportModeRequiredForStockOut": "Adicione o Modo de Transporte antes de confirmar a saída de estoque",
    "inventory.dateAndTime": "Data e Hora",
    "inventory.movementType": "Tipo de Movimento",
    "inventory.lotStock": "Estoque em Lote",
    "inventory.openLots": "lotes abertos",
    // -- Shipment extras
    "shipment.lockedTooltip": "Bloqueado — nenhuma edição adicional permitida",
    "shipment.exportTooltip": "Exportar consignação para Excel ou PDF",
    "shipment.noTransportUnitsShared": "Nenhuma unidade de estoque disponível para esta consignação compartilhada.",
    // -- Payment panel
    "payment.loadingData": "Carregando dados de pagamento...",
    "payment.invoice": "Fatura",
    "payment.salesStatus": "Status de Vendas",
    "payment.paidOut": "Pago",
    "payment.purchaseStatus": "Status de Compra",
    "payment.unableToLoad": "Não foi possível carregar o resumo de pagamentos.",
    "payment.record": "Registrar Pagamento",
    "payment.typeLabel": "Tipo de Pagamento",
    "payment.receivable": "A Receber (Entrada)",
    "payment.payable": "A Pagar (Saída)",
    "payment.selectType": "Selecionar tipo",
    "payment.modeLabel": "Modo de Pagamento",
    "payment.selectMode": "Selecionar modo",
    "payment.referenceNo": "Nº de Referência",
    "payment.referencePlaceholder": "Nº cheque / TT ref / UTR",
    "payment.notesPlaceholder": "Notas opcionais",
    "payment.save": "Salvar Pagamento",
    "payment.history": "Histórico de Pagamentos",
    // -- Storage
    "storage.title": "Uso de Armazenamento",
    "storage.subtitle": "Acompanhe seu armazenamento de arquivos em todos os tallies, documentos e parceiros",
    "storage.usedRing": "usado",
    "storage.used": "Usado",
    "storage.quota": "Cota",
    "storage.free": "Livre",
    "storage.files": "Arquivos",
    "storage.filesCount": "arquivos",
    "storage.warningPrefix": "Você usou",
    "storage.warningBannerSuffix": "do seu armazenamento. Considere excluir arquivos não utilizados.",
    "storage.fullBanner": "Armazenamento cheio! Novos uploads estão bloqueados. Libere espaço ou atualize seu plano.",
    "storage.addedBy": "Adicionado por",
    "storage.noFilesFound": "Nenhum arquivo encontrado.",
    // -- Dashboard V4
    "dashV4.businessPulse": "Pulso do Negócio",
    "dashV4.inventorySnapshot": "Resumo do Inventário",
    "dashV4.fullInventory": "Inventário Completo",
    "dashV4.availableStock": "Estoque Disponível",
    "dashV4.inProcessing": "Em ordem de serraria",
    "dashV4.inShipment": "Em Consignação",
    "dashV4.shippedThisMonth": "Enviado Este Mês",
    "dashV4.activeSites": "Sites Ativos",
    "dashV4.locations": "locais",
    "dashV4.noInventoryData": "Nenhum dado de inventário ainda.",
    "dashV4.setUpInventory": "Configurar inventário →",
    "dashV4.volumeTrend": "Tendência de Volume (CBM)",
    "dashV4.upcomingShipments": "Próximas Consignações",
    "dashV4.departures": "Partidas",
    "dashV4.arrivals": "Chegadas",
    "dashV4.geographySites": "Geografia e Sites",
    "dashV4.recentTUs": "Unidades de Estoque Recentes",
    "dashV4.standardPlan": "Plano Padrão",
    "dashV4.validTill": "Válido até",
    "dashV4.daysLeft": "dias restantes",
    "dashV4.manage": "Gerenciar",
    "dashV4.active": "ativo",
    "dashV4.inactive": "inativo",
    "dashV4.upcoming": "próximas",
    "dashV4.unassigned": "não atribuídas",
    // -- Dashboard V5
    "dashV5.title": "Painel",
    "dashV5.subtitle": "Visão geral de negócios, finanças e inventário",
    "dashV5.financialHealth": "Saúde Financeira",
    "dashV5.totalInvoiced": "Total Faturado",
    "dashV5.totalReceived": "Recebido",
    "dashV5.outstanding": "Pendente",
    "dashV5.overdue": "Em Atraso",
    "dashV5.payables": "A Pagar",
    "dashV7.currentTooltip": "Sempre atual — não limitado ao período selecionado",
    "dashV8.goodMorning": "Bom dia",
    "dashV8.periodNote": "O período define: volume, Unidades de Estoque, peças, consignações, faturado e recebido. Todo o resto mostra a situação de agora.",
    "dashV8.vsPrevious": "vs período anterior",
    "dashV8.details": "Detalhes",
    "dashV8.freeToSell": "livres para vender",
    "dashV8.free": "Livre",
    "dashV8.held": "Retido",
    "dashV8.inMill": "Em serraria",
    "dashV8.allCounted": "Todas as Unidades de Estoque contadas",
    "dashV8.toCount": "ainda a contar",
    "dashV8.goodAfternoon": "Boa tarde",
    "dashV8.goodEvening": "Boa noite",
    "dashV8.focus": "Tudo o que esta empresa faz",
    "dashV8.newSince": "novos desde",
    "dashV8.period": "Período",
    "dashV8.p.today": "Hoje",
    "dashV8.p.7d": "7 dias",
    "dashV8.p.30d": "30 dias",
    "dashV8.p.month": "Este mês",
    "dashV8.p.pick": "Escolher datas",
    "dashV8.activeUntil": "ativo até",
    "dashV8.item": "item",
    "dashV8.items": "itens",
    "dashV8.more": "mais",
    "dashV8.showAll": "Mostrar tudo",
    "dashV8.showLess": "Mostrar menos",
    "dashV8.open": "Abrir",
    "dashV8.review": "Rever",
    "dashV8.count": "Contar",
    "dashV8.see": "Ver",
    "dashV8.needMine1": "Você tem 1 trabalho de serraria",
    "dashV8.needMineN": "Você tem {n} trabalhos de serraria",
    "dashV8.taskNeedsAccept": "{code} precisa ser aceito",
    "dashV8.taskRunning": "{code} está em andamento",
    "dashV8.needOverdue1": "1 pagamento está em atraso",
    "dashV8.needOverdueN": "{n} pagamentos estão em atraso",
    "dashV8.overdueSub": "{amount} a receber",
    "dashV8.overdueSubDays": "{amount} a receber · o mais antigo há {days} dias",
    "dashV8.needHolds1": "1 Saída de Estoque retendo madeira há 60+ dias",
    "dashV8.needHoldsN": "{n} Saídas de Estoque retendo madeira há 60+ dias",
    "dashV8.needHoldsSub": "{cbm} m³ bloqueados para venda",
    "dashV8.needRecon1": "1 Unidade de Estoque não contada",
    "dashV8.needReconN": "{n} Unidades de Estoque não contadas",
    "dashV8.needReconSub": "Contado até agora: {pct}%",
    "dashV8.needUnassigned1": "1 Unidade de Estoque ainda sem consignação",
    "dashV8.needUnassignedN": "{n} Unidades de Estoque ainda sem consignação",
    "dashV8.needMillQueued1": "1 trabalho de serraria aguardando início",
    "dashV8.needMillQueuedN": "{n} trabalhos de serraria aguardando início",
    "dashV8.needArrivals1": "1 consignação chega esta semana",
    "dashV8.needArrivalsN": "{n} consignações chegam esta semana",
    "dashV8.needArrivalsSub": "a primeira em {date}",
    "dashV8.vsLastMonth": "vs mês passado",
    "dashV8.millRunning": "Trabalhos de serraria em andamento",
    "dashV8.trends": "Tendências",
    "dashV8.tab.volume": "Volume",
    "dashV8.tab.products": "Produtos",
    "dashV8.tab.types": "Tipos",
    "dashV8.tab.transport": "Transporte",
    "dashV8.tab.payments": "Pagamentos",
    "dashV8.chip.STOCK": "Estoque",
    "dashV8.chip.MILL": "Serraria",
    "dashV8.chip.CONSIGNMENT": "Consignações",
    "dashV8.chip.MONEY": "Dinheiro",
    "dashV8.chip.RECON": "Contagens",
    "dashV8.chip.TALLY": "Unidades de Estoque",
    "dashV8.chip.TEAM": "Equipe",
    "dashV8.chip.MINE": "Meus",
    "dashV8.dayToday": "Hoje",
    "dashV8.dayYesterday": "Ontem",
    "dashV8.evt.STOCK_IN": "Estoque recebido",
    "dashV8.evt.STOCK_OUT": "Saída de Estoque confirmada",
    "dashV8.evt.STOCK_COUNT": "Contagem feita",
    "dashV8.evt.STOCK_ADJUST": "Estoque ajustado",
    "dashV8.evt.MILL_DONE": "Trabalho de serraria {ref} concluído",
    "dashV8.evt.CONSIGNMENT_NEW": "Consignação {ref} criada",
    "dashV8.evt.PAYMENT_IN": "Pagamento recebido",
    "dashV8.evt.PAYMENT_OUT": "Pagamento feito",
    "dashV8.evt.TALLY_NEW": "Unidade de Estoque {ref} criada",
    "dashV8.evt.TEAM_GRANT": "Permissão {ref} concedida",
    "dashV8.evt.TEAM_REVOKE": "Permissão {ref} retirada",
    "dashV8.teamFor": "para {name}",
    "dashV8.feedNote": "Só eventos de negócio concluídos são listados. Salvar ou editar linhas da contagem nunca aparece; uma Unidade de Estoque aparece uma vez, quando é criada.",
    "dashV7.needsTitle": "Precisa de você hoje",
    "dashV7.allClear": "Tudo em ordem. Nada está esperando por você hoje.",
    "dashV7.needOverdue": "pagamentos em atraso a receber",
    "dashV7.needRecon": "Unidades de Estoque aguardando reconciliação",
    "dashV7.needUnassigned": "Unidades de Estoque ainda sem consignação",
    "dashV7.needMyTasks": "trabalhos de serraria na sua lista",
    "dashV7.needMillQueued": "trabalhos de serraria aguardando início",
    "dashV7.chipAll": "Tudo",
    "dashV7.cat.STOCK": "Estoque",
    "dashV7.cat.MILL": "Serraria",
    "dashV7.cat.CONSIGNMENT": "Consignações",
    "dashV7.cat.MONEY": "Dinheiro",
    "dashV7.cat.TEAM": "Equipe",
    "dashV7.ev.STOCK_IN": "Estoque recebido",
    "dashV7.ev.STOCK_OUT": "Estoque enviado",
    "dashV7.ev.STOCK_COUNT": "Estoque contado",
    "dashV7.ev.STOCK_ADJUST": "Estoque ajustado",
    "dashV7.ev.MILL_DONE": "Trabalho de serraria concluído",
    "dashV7.ev.CONSIGNMENT_NEW": "Consignação criada",
    "dashV7.ev.PAYMENT_IN": "Pagamento recebido",
    "dashV7.ev.PAYMENT_OUT": "Pagamento feito",
    "dashV7.ev.TEAM_GRANT": "Permissão concedida",
    "dashV7.ev.TEAM_REVOKE": "Permissão retirada",
    "dashV7.severalSizes": "vários tamanhos",
    "dashV7.with": "com",
    "dashV7.noActivity": "Nada aconteceu aqui recentemente.",
    "dashV7.showMore": "Mostrar mais",
    "dashV7.activityFailed": "Não foi possível carregar a atividade mais recente agora.",
    "dashV7.upcomingTooltip": "Sempre mostra os próximos 7 dias — independente do período acima",
    "dashV5.receivablesAging": "Antiguidade de Recebíveis",
    "dashV5.shipmentsLabel": "consignações",
    "dashV5.reconciliation": "Status de Reconciliação",
    "dashV5.totalTUs": "Total de Unidades de Estoque",
    "dashV5.reconciled": "Reconciliado",
    "dashV5.pending": "Pendente",
    "dashV5.locked": "Bloqueado",
    "dashV5.netDiscrepancy": "Discrepância Líquida",
    "dashV5.tuId": "ID da Unidade de Estoque",
    "dashV5.sourceCbm": "CBM Origem",
    "dashV5.destCbm": "CBM Destino",
    "dashV5.discrepancy": "Diferença",
    "dashV5.noDiscrepancies": "Sem discrepâncias — todas as Unidades de Estoque conferem.",
    "dashV5.avgOutturn": "Outturn Médio",
    "dashV5.netGain": "Ganho Líquido (Ordens de Serraria)",
    "dashV5.runsLabel": "ordens de serraria",
    "dashV5.outturnNote": "Acima de 100% indica ganho de volume no corte de redondo para quadrado.",
    "dashV5.paymentFlow": "Fluxo de Pagamento",
    "dashV5.mixedCurrencies": "Múltiplas moedas",
    "dashV5.showingCurrencyOnly": "Mostrando apenas:",
    "dashV5.otherCurrencies": "outras moedas",
    "dashV5.perCurrencyBreakdown": "Detalhamento por moeda",
    // -- Dashboard V6
    "dashV6.title": "Painel",
    "dashV6.subtitle": "Visão geral do negócio, sensível a funções, em tempo real",
    "dashV6.liveTooltip": "Ao vivo — atualiza automaticamente",
    "dashV6.offlineTooltip": "Offline — mostrando dados em cache, não ao vivo",
    "dashV6.myMillTasks": "Minhas Tarefas Ativas na Serraria",
    "dashV6.millBoard": "Painel de Ordens de Serraria",
    "dashV6.viewAllRuns": "Ver Todas as Ordens de Serraria",
    "dashV6.queued": "Na Fila",
    "dashV6.inProgress": "Em Andamento",
    "dashV6.completedToday": "Concluído Hoje",
    "dashV6.machineUtil": "Máquinas Ocupadas",
    "dashV6.topOperators": "Principais Operadores por Carga Ativa",
    "dashV6.status.DRAFT": "Na Fila",
    "dashV6.status.IN_PROGRESS": "Em Andamento",
    "dashV6.status.COMPLETED": "Concluído",
    "dashV6.priority.HIGH": "Alta",
    "dashV6.priority.MEDIUM": "Média",
    "dashV6.priority.LOW": "Baixa",
    "dashV6.recentActivity": "Atividade Recente",
    "dashV6.granted": "concedeu",
    "dashV6.revoked": "revogou",
    "dashV6.forUser": "para",
    // -- Common extras
    "common.export": "Exportar",
    "common.next": "Próximo",
    "common.retry": "Tentar novamente",
    "common.clearFilters": "Limpar Filtros",
    "common.saveAll": "Salvar Tudo",
    "common.resetDefaults": "Redefinir Padrões",
    "common.configure": "Configurar",
    "common.disable": "Desativar",
    "common.close": "Fechar",
    "common.skip": "Pular",
    "common.continue": "Continuar",
    "common.deactivate": "Desativar",
    "common.reactivate": "Reativar",
    "common.preview": "Visualizar",
    "common.openNewTab": "Abrir em nova aba",
    "common.resetAllToDefaults": "Redefinir todos para padrão",
    "common.renew": "Renovar",
    "common.manage": "Gerenciar",
    "common.apply": "Aplicar",
    "common.saveTimezone": "Salvar Fuso Horário",
    // -- Shipment lock dialog
    "shipment.lockDialogHeader": "Bloquear Consignação",
    "shipment.lockButtonTooltip": "Bloquear esta consignação permanentemente — sem edições após o bloqueio",
    "shipment.lockDescription": "Uma vez bloqueada, esta consignação não pode ser editada por ninguém. Todas as alterações serão congeladas permanentemente.",
    // -- Reconciliation lock
    "recon.lockDialogHeader": "Bloquear Reconciliação",
    "recon.lockIrreversible": "Esta ação é permanente e irreversível.",
    "recon.lockDescription": "Uma vez bloqueado, ninguém pode modificar os dados de reconciliação — nem o proprietário da conta. O tallysheet permanece acessível e visualizável.",
    "recon.lockReasonLabel": "Motivo (opcional)",
    "recon.lockReasonPlaceholder": "ex: Confirmado conforme o levantamento de descarga",
    "recon.varianceDetected": "Variância detectada",
    "recon.varianceChoiceLabel": "Como isso deve ser aplicado ao estoque?",
    "recon.applyAutoLabel": "Aplicar automaticamente agora",
    "recon.applyAutoDesc": "O estoque será corrigido para corresponder à quantidade realmente recebida.",
    "recon.applyAutoNeedsReceive": "Receba este Stock Unit primeiro — ainda não há estoque para corrigir.",
    "recon.applyManualLabel": "Vou tratar isso manualmente",
    "recon.applyManualDesc": "O estoque mantém a quantidade original — ajuste depois, se necessário.",
    "recon.lockTypeConfirm": "Digite LOCK para confirmar",
    "recon.confirmLockButton": "Confirmar Bloqueio da Reconciliação",
    // -- Inventory processing page
    "invProc.title": "Ordens de Serraria",
    "invProc.subtitle": "Ordens de serraria: estoque de um Lote serrado num novo Lote",
    "invProc.totalRuns": "Total de Ordens de Serraria",
    "invProc.avgOutturn": "Rendimento Médio",
    "invProc.cbmProcessed": "CBM Serrado (Entrada)",
    "invProc.noRuns": "Nenhuma ordem de serraria ainda.",
    "invProc.noRunsHint": "Clique em Nova Ordem de Serraria para transformar toras em madeira serrada.",
    "invProc.stepLocation": "Local e Data",
    "invProc.millLocationLabel": "Serraria",
    "invProc.millPlaceholder": "Pesquisar ou digitar nome da serraria",
    "invProc.millRequired": "Local da serraria é obrigatório.",
    "invProc.notesLabel": "Notas (opcional)",
    "invProc.tuSelectionHint": "Mostrando Unidades de Estoque do tipo Redondo DISPONÍVEIS. Selecione todas que irão para a serra.",
    "invProc.noTusFound": "Nenhuma Unidade de Estoque de tora redonda disponível.",
    "invProc.noTusHint": "Receba Unidades de Estoque de tronco redondo no inventário primeiro.",
    "invProc.selected": "Selecionado:",
    "invProc.totalInput": "Total de entrada:",
    "invProc.outputProduct": "Produto de Saída",
    "invProc.outputProductPlaceholder": "Pesquisar ou digitar nome do produto",
    "invProc.noProductFound": "Nenhum produto encontrado",
    "invProc.noSiteFound": "Nenhum pátio encontrado",
    "invProc.acSearchMessage": "{0} resultados disponíveis",
    "invProc.acEmptySelectionMessage": "Nenhum item selecionado",
    "invProc.storeAt": "Armazenar em",
    "invProc.storePlaceholder": "Nome do pátio",
    "invProc.outputVolume": "Volume de Saída (CBM)",
    "invProc.fifoPanelTitle": "A qual compra isso será atribuído?",
    "invProc.fifoPanelHint": "A compra mais antiga é usada primeiro. Você pode editar a divisão abaixo, se necessário.",
    "invProc.fifoPanelMismatch": "Os valores editados devem somar o mesmo total de CBM que entrou na serraria.",
    "invProc.fifoPanelCbmLabel": "CBM",
    "invProc.fifoPanelPiecesLabel": "Peças",
    "invProc.outputPiecesLabel": "Peças de Saída",
    "invProc.inputPiecesLabel": "Quantas peças estão entrando?",
    "invProc.useFullVolume": "Usar volume total",
    "invProc.useAllPieces": "Todas as peças",
    "invProc.inputPiecesOptionalHint": "Opcional — você também pode informar isso ao concluir o trabalho.",
    "invProc.inputPiecesExceeds": "Mais do que as peças deste estoque",
    "invProc.inputPiecesUsed": "Peças de entrada usadas",
    "invProc.inputPiecesHint": "Peças retiradas do estoque de entrada. As peças de saída podem ser mais — uma peça pode gerar várias.",
    "invProc.inputPiecesReadOnlyHint": "A entrada não pode ser alterada após concluir o trabalho. Use um ajuste de estoque para corrigir.",
    "invProc.inputPiecesRequired": "Informe as peças de entrada usadas antes de concluir o trabalho.",
    "invProc.confirmSave": "Confirmar e Salvar",
    "invProc.inputHeader": "ENTRADA",
    "invProc.outputHeader": "SAÍDA",
    "invProc.inputTUs": "Unidades de Estoque de Entrada",
    "invProc.lossLabel": "Conversão",
    "invProc.step1.title": "O que vai para a serraria?",
    "invProc.step2.title": "O que saiu?",
    "invProc.inputCbmLabel": "Quanto está entrando? (CBM)",
    "invProc.moreDetails": "Mais detalhes (opcional)",
    "invProc.selectTUs": "Selecionar unidades de estoque (opcional)",
    "invProc.confirmJobSave": "Registrar Ordem de Serraria",
    "invProc.outputMethod": "Como registrar a saída?",
    "invProc.directVolume": "Inserir CBM total",
    "invProc.directVolumeDesc": "Digite o volume de saída total",
    "invProc.viaTally": "Medir peça por peça (Folha de Contagem)",
    "invProc.viaTallyDesc": "Abrir folha de contagem para contar peças",
    "invProc.viaCsv": "CSV / Excel",
    "invProc.viaCsvDesc": "Enviar planilha de medição",
    "invProc.viaAi": "AI Import",
    "invProc.viaAiDesc": "Digitalizar ou enviar documento",
    "invProc.draftNote": "A ordem de serraria será salva como Rascunho. Complete a saída após salvar.",
    "invProc.notesPlaceholder": "Ex: 4×8 pranchas, pedido personalizado",
    "invProc.inputCbmLabelHelp": "Quanto está entrando na serra?",
    "invProc.assignTo": "Atribuir ao operador",
    "invProc.needsAccept": "Atribuída a você · Aceitar",
    "invProc.assignedToYou": "Atribuída a você",
    "invProc.assignedTo": "Atribuída a",
    "invProc.createdBy": "Criado por",
    "invProc.you": "Você",
    "invProc.acceptedLabel": "Aceita",
    "invProc.onlyAssignedCanAct": "Esta tarefa está atribuída a outro operador. Só esse operador ou um gerente pode trabalhar nela.",
    "invProc.acceptTask": "Aceitar tarefa",
    "invProc.accepted": "Tarefa aceita",
    "invProc.myTasks": "Minhas tarefas",
    "invProc.big.accept": "Aceitar",
    "invProc.big.start": "Iniciar",
    "invProc.big.done": "Concluído",
    "invProc.big.resume": "Retomar",
    "invProc.big.pause": "Pausar",
    "invProc.declineButton": "Não consigo",
    "invProc.declineTitle": "Não consigo fazer esta tarefa",
    "invProc.declineIntro": "A tarefa volta para o seu gerente. Diga o motivo.",
    "invProc.declineReasonLabel": "Por que não consegue fazer?",
    "invProc.declineReasonPlaceholder": "ex.: máquina quebrada, toras erradas, não estou nesta serraria",
    "invProc.declineConfirm": "Devolver",
    "invProc.declineDone": "Tarefa devolvida ao gerente",
    "invProc.declineNeedsInternet": "Isto precisa de internet. Tente de novo quando estiver online.",
    "invProc.declinedCouldNot": "não conseguiu fazer esta tarefa",
    "invProc.declinedHint": "Agora não está atribuída a ninguém. Cancele-a e crie uma nova tarefa para outro operador.",
    "invProc.myTasksSubtitle": "Seu trabalho na serraria. Toque no botão grande para avançar a tarefa.",
    "invProc.myTasksEmpty": "Nenhuma tarefa para você agora",
    "invProc.myTasksEmptyHint": "As novas tarefas atribuídas a você aparecem aqui.",
    "invProc.big.refresh": "Atualizar",
    "user.millOperator": "Operador de serraria",
    "user.millOperatorPill": "Operador",
    "user.millOperatorOnTitle": "Operador de serraria ativado",
    "user.millOperatorOffTitle": "Operador de serraria desativado",
    "user.millOperatorOnMessage": "Esta pessoa já pode receber tarefas da serraria.",
    "user.millOperatorRightsAdded": "Esta pessoa já pode receber tarefas da serraria. View Mill Jobs e Run Mill Jobs foram adicionados ao acesso.",
    "user.millOperatorRoleMissing": "A função \"{{role}}\" não inclui View Mill Jobs e Run Mill Jobs, então ainda não pode aceitar tarefas. Adicione-os à função ou escolha outra.",
    "user.millOperatorFailed": "Não foi possível alterar o operador. Tente novamente.",
    "user.inviteAsMillOperator": "Esta pessoa é operador de serraria",
    "user.inviteAsMillOperatorHint": "Poderá receber tarefas da serraria depois de entrar.",
    "operator.linkLogin": "Vincular um login",
    "operator.linkLoginHint": "Escolha qual membro da equipe é este operador, para que veja e aceite suas tarefas. Só pode ser definido uma vez.",
    "operator.noLogin": "Sem login",
    "operator.noLoginHint": "Este operador não tem login e não pode ver nem aceitar tarefas. Toque para vincular.",
    "operator.noOperatorsHint": "Ainda não há operadores. Ative \"Operador de serraria\" para uma pessoa em Gerenciar usuários.",
    "invProc.assignHint": "Deixe em branco para salvar como Rascunho — atribua depois.",
    "invProc.willBeAssigned": "O trabalho será criado e atribuído ao operador selecionado.",
    "invProc.willBeDraft": "Nenhum operador selecionado — o trabalho será salvo como Rascunho.",
    "invProc.outputPending": "Pendente — registrado após o processamento.",
    "invProc.assignDate": "Data prevista",
    "invProc.jobCard": "SEU TRABALHO HOJE",
    "invProc.startJob": "Iniciar Trabalho",
    "invProc.customMade.requested": "Solicitado",
    "invProc.customMade.sourceChoiceLabel": "Estoque de origem",
    "invProc.customMade.pickMyself": "Escolher eu mesmo",
    "invProc.customMade.letOperatorDecide": "Deixar o operador decidir",
    "invProc.customMade.operatorPicksLater": "O operador escolherá o lote de origem ao iniciar este trabalho.",
    "invProc.customMade.chooseLotToStart": "Escolher lote de origem",
    "invProc.customMade.rowWaiting": "Aguardando início",
    "invProc.customMade.rowProducing": "Produzindo…",
    "invProc.customMade.rowPaused": "Pausado na serraria",
    "invProc.customMade.peekTitle": "Tarefa da serraria",
    "invProc.customMade.peekUnavailable": "Não foi possível carregar os detalhes desta tarefa.",
    "invProc.customMade.dialogTitle": "Solicitar Produção Sob Medida",
    "invProc.customMade.dialogExplainer": "Não encontramos esse tamanho exato em estoque — solicite que seja cortado na serraria.",
    "invProc.customMade.sizeUnknown": "tamanho desconhecido — verifique antes de escolher",
    "invProc.lotHeldBy": "Reservado por",
    "invProc.customMade.sizeTooSmall": "menor que o necessário",
    "invProc.customMade.tooSmallWarning": "Este lote é menor do que o necessário — uma serraria só pode cortar, não adicionar material.",
    "invProc.customMade.inputCbmLabel": "Quanto vai entrar? (CBM)",
    "invProc.customMade.inputCbmHint": "Sua linha precisa de aproximadamente",
    "invProc.customMade.previewOutturn": "rendimento estimado",
    "invProc.customMade.inputCbmTooLow": "Isso é menos do que o necessário — aumente para permitir a perda na serraria. Sua linha precisa de pelo menos",
    "invProc.customMade.priorityLabel": "Prioridade",
    "invProc.customMade.priorityLow": "Baixa",
    "invProc.customMade.priorityMedium": "Média",
    "invProc.customMade.priorityHigh": "Alta",
    "invProc.customMade.priorityHighHint": "Isso vai bloquear um envio até ser concluído — marcado como prioridade Alta.",
    "invProc.customMade.neededByLabel": "Necessário até",
    "invProc.customMade.neededByHint": "Opcional. Você e a serraria são lembrados uma vez se o trabalho ainda estiver aberto depois deste dia.",
    "invProc.customMade.targetLabel": "O pedido precisa de",
    "invProc.customMade.late": "Atrasado",
    "invProc.customMade.short": "Faltando",
    "invProc.customMade.shortBy": "faltam",
    "invProc.customMade.madeOf": "Produzido",
    "invProc.customMade.stillMissing": "peças ainda faltam. O pedido continua incompleto: peça o restante à serraria novamente.",
    "invProc.customMade.inputBelowTarget": "O volume de entrada é menor do que o pedido precisa. Confira antes de cortar.",
    "invProc.customMade.submitCta": "Solicitar",
    "invProc.customMade.requestedToast": "Solicitação sob medida enviada",
    "invProc.customMade.requestFailed": "Não foi possível enviar a solicitação",
    "invProc.customMade.queuedOfflineRunCode": "Na fila — será sincronizado",
    "invProc.customMade.queuedOfflineToast": "Solicitação sob medida salva offline",
    "invProc.customMade.queuedOfflineDetail": "Será enviada automaticamente assim que você estiver online novamente.",
    "invProc.customMade.staleLotsNotice": "Mostrando lotes da última sincronização — podem estar desatualizados.",
    "invProc.customMade.recommended": "Recomendado",
    "invProc.customMade.estimatedOutturn": "Rendimento estimado",
    "invProc.customMade.viewSizes": "Ver tamanhos",
    "common.optional": "opcional",
    "invProc.customMade.tuPreparing": "Preparando",
    "invProc.customMade.tuPreparingTooltip": "Um ou mais itens desta folha estão sendo produzidos na serraria.",
    "invProc.completeJob": "Trabalho Concluído",
    "invProc.cancelJob": "Cancelar Ordem de Serraria",
    "invProc.pauseJob": "Pausar",
    "invProc.resumeJob": "Retomar",
    "invProc.pauseReasonLabel": "Por que está pausando isto?",
    "invProc.pauseReasonPlaceholder": "ex.: Um pedido urgente chegou",
    "invProc.filterStatus": "Status",
    "invProc.filterAll": "Todos",
    "invProc.filterDraft": "Rascunho",
    "invProc.filterRunning": "Em Execução",
    "invProc.filterPaused": "Pausado",
    "invProc.filterFinished": "Finalizado",
    "invProc.filterCompleted": "Concluído",
    "invProc.filterCancelled": "Cancelado",
    "invProc.sortLabel": "Ordenar",
    "invProc.sortNewest": "Mais Recente Primeiro",
    "invProc.sortOldest": "Mais Antigo Primeiro",
    "invProc.sortCode": "ID da Ordem A-Z",
    "invProc.noJobToday": "Nenhum trabalho atribuído hoje.",
    "invProc.jobAssignedBy": "Atribuído por",
    "invProc.editOutput": "Editar Saída",
    "invProc.outputAboveInput": "A saída é maior do que o que entrou na serraria. A serragem não pode gerar mais madeira do que recebeu: verifique a tally de saída e o volume de entrada.",
    "invProc.directEntry": "Volume Direto",
    "invProc.viaTallySheet": "Via Folha de Contagem",
    "invProc.taskNo": "Nº da Tarefa",
    "invProc.viewInMill": "Ver na Serraria",
    "invProc.sourceOrder": "Pedido de Origem",
    "invProc.viewSourceOrder": "Ver pedido de origem",
    "invProc.selectTallySheet": "Pesquisar folha de contagem...",
    "invProc.tallyLinked": "Folha vinculada — CBM preenchido",
    "invProc.directDesc": "Inserir CBM total manualmente",
    "invProc.tallyDesc": "Registrar peças → CBM totaliza automaticamente",
    "invProc.csvImport": "CSV / Excel",
    "invProc.csvDesc": "Importar planilha → verificar na contagem",
    "invProc.aiImport": "Importação IA",
    "invProc.aiDesc": "Escanear documento → verificar na contagem",
    "invProc.openTally": "Abrir Contagem →",
    "invProc.tallyTypeLabel": "Tipo de Contagem",
    "invProc.tallyTypeRound": "Redondo",
    "invProc.tallyTypeSquare": "Quadrado",
    "invProc.tallyTypeDerivedHint": "Detectado automaticamente do produto",
    "invProc.tallyTypePickProduct": "Escolha primeiro o produto de saída. O tipo de contagem (Redonda ou Esquadrada) é definido a partir dele.",
    "invProc.odWhatCameOut": "O que saiu",
    "invProc.odHowRecord": "Como registrar?",
    "invProc.odTotals": "Totais",
    "invProc.odSquareRule": "A entrada é madeira serrada (Esquadrada), então a saída também é Esquadrada. Madeira serrada não vira tora redonda.",
    "invProc.volumeUnit": "Unidade de volume",
    "invProc.odChooseProductFirst": "Escolha primeiro o produto de saída. Depois você escolhe como registrar.",
    "invProc.odTotalsFromTally": "Os totais aparecem aqui depois de salvar a contagem.",
    "invProc.odProductTypeLocked": "A contagem desta ordem já tem linhas {type}, por isso só são mostrados produtos {type}.",
    "invProc.noProductOfType": "Nenhum produto {type} encontrado",
    "invProc.odDraftSaving": "Salvando sua escolha…",
    "invProc.odDraftSaved": "Sua escolha foi salva",
    "invProc.odDraftError": "Não foi possível salvar sua escolha ainda.",
    "invProc.soFar": "até agora",
    "invProc.recordedSoFar": "Registrado até agora",
    "invProc.recordedBeforeCancel": "Registrado antes de cancelar",
    "invProc.notStockYet": "Ainda não é estoque. Vira estoque quando a ordem for concluída.",
    "invProc.cancelWithOutputWarn": "A ordem <b>{run}</b> já tem {cbm} CBM ({pcs} peças) registrados na contagem de saída. Se cancelar, essa contagem fica só como registro e nada vira estoque. Para colocá-la no estoque, conclua a ordem.",
    "invProc.cancelAnyway": "Cancelar mesmo assim",
    "invProc.keepJob": "Manter ordem",
    "invProc.atMill": "Na serraria",
    "invProc.atMillJobs": "Ordens em andamento",
    "invProc.atMillInput": "Entrada retida",
    "invProc.atMillOutput": "Saída até agora",
    "invProc.atMillNote": "Ainda não é estoque",
    "invProc.openingTally": "Abrindo contagem…",
    "invProc.preparingRun": "Preparando o novo trabalho de serraria…",
    "invProc.odTotalsLocked": "Escolha primeiro o produto de saída e depois informe os totais.",
    "invProc.odPrepareSizes": "Preparar tamanhos (opcional)",
    "invProc.odPrepareSizesHint": "A contagem abre com estes tamanhos prontos com 0 peças. O layout Operador os mostra como cartões.",
    "invProc.odSizesReady": "{n} tamanhos prontos",
    "invProc.odSizesNotSaved": "Não foi possível salvar os tamanhos. Escolha-os de novo em Escolher tamanhos no layout Operador.",
    "invProc.odEditInputPieces": "Alterar peças de entrada",
    "millOp.layoutAria": "Layout da contagem",
    "millOp.layoutGrid": "Grade",
    "millOp.layoutOperator": "Operador",
    "millOp.loadError": "Não foi possível carregar a folha.",
    "millOp.retry": "Tentar de novo",
    "millOp.outputPieces": "Peças de saída",
    "millOp.outputVolume": "Volume de saída",
    "millOp.volumeUnit": "Unidade de volume",
    "millOp.input": "Entrada",
    "millOp.outturn": "Rendimento",
    "millOp.ofInput": "do volume de entrada",
    "millOp.moreThanInput": "mais que a entrada: confira os tamanhos",
    "millOp.saved": "Salvo",
    "millOp.saving": "Salvando…",
    "millOp.unsaved": "Não salvo",
    "millOp.saveFailed": "Não foi possível salvar",
    "millOp.show": "Mostrar",
    "millOp.sheetSizes": "Tamanhos da folha",
    "millOp.used": "Usados",
    "millOp.view": "Exibição",
    "millOp.textSize": "Tamanho do texto",
    "millOp.cardSize": "Tamanho dos cartões",
    "millOp.cardTiny": "Mínimo",
    "millOp.cardSmall": "Pequeno",
    "millOp.cardMedium": "Médio",
    "millOp.cardLarge": "Grande",
    "millOp.tapSound": "Som ao tocar",
    "millOp.keepScreenOn": "Manter a tela ligada",
    "millOp.keepScreenOnUnsupported": "Este aparelho ou navegador não consegue manter a tela ligada.",
    "millOp.unitsNote": "As unidades seguem as configurações da folha. Para mudar, abra Configurações no layout Grade.",
    "millOp.resetView": "Restaurar o padrão",
    "millOp.oneLess": "Uma peça a menos",
    "millOp.oneMore": "Uma peça a mais",
    "millOp.piecesTapToType": "Peças. Toque para digitar um número",
    "millOp.noUsed": "Nenhum tamanho usado ainda. Mude para “Tamanhos da folha” e toque em +.",
    "millOp.noSizesTitle": "Esta folha ainda não tem tamanhos",
    "millOp.noSizesText": "Escolha os tamanhos esperados ou adicione um novo.",
    "millOp.newSize": "Novo tamanho",
    "millOp.pickSizes": "Escolher tamanhos",
    "millOp.autoSaves": "Salva sozinho logo após o último toque",
    "millOp.screenStaysOn": "Tela permanece ligada",
    "millOp.undo": "Desfazer",
    "millOp.setPieces": "Definir peças",
    "millOp.piecesForSize": "Peças deste tamanho",
    "millOp.clear": "Limpar",
    "millOp.newSizeHint": "Toque numa caixa e depois num valor rápido ou nas teclas",
    "millOp.width": "Largura",
    "millOp.thickness": "Espessura",
    "millOp.length": "Comprimento",
    "millOp.addSize": "Adicionar tamanho",
    "millOp.pickHint": "Marque os tamanhos esperados. Você ainda pode adicionar um novo depois.",
    "millOp.searchSize": "Buscar um tamanho, ex.: 4 x 2",
    "millOp.listView": "Lista",
    "millOp.chipView": "Blocos",
    "millOp.addAll": "Adicionar todos",
    "millOp.hasPieces": "tem peças",
    "millOp.noSuggestions": "Ainda não há tamanhos anteriores. Use “Novo tamanho”.",
    "millOp.addNSizes": "Adicionar {n} tamanhos",
    "millOp.removeNSizes": "Remover {n} tamanhos",
    "millOp.onSheet": "Nesta folha",
    "millOp.sameAsLast": "Igual ao último trabalho {code}",
    "millOp.mostUsed": "Mais usados",
    "millOp.recent": "Recentes",
    "millOp.changeToast": "{size}: {from} → {to} pç",
    "invProc.odTypeFromInput": "porque a entrada é madeira serrada",
    "invProc.squareInputRoundBlocked": "Madeira serrada (entrada Esquadrada) não pode virar tora redonda. Escolha um produto de saída Esquadrado.",
    "invProc.tallyTypeMismatch": "A contagem deste trabalho já tem linhas do tipo {tally}, mas o produto de saída é {product}. Escolha um produto de saída {tally} ou mude para Volume direto.",
    "invProc.tallyTypeLinkedHint": "Da contagem vinculada",
    "invProc.linkedTally": "Vinculado",
    "invProc.tallyRows": "linhas",
    "invProc.cbmFromTally": "Preenchido automaticamente da contagem",
    "invProc.tallyManualHint": "Registre as peças na contagem, depois volte aqui",
    "invProc.csvHint": "O diálogo de importação CSV abrirá automaticamente",
    "invProc.aiHint": "O diálogo de importação IA abrirá automaticamente",
    "invProc.dispatchOutput": "Enviar para Consignação →",
    "invProc.selectShipment": "Selecionar Consignação",
    "invProc.shipmentPlaceholder": "Escolha uma consignação ativa...",
    "invProc.confirmDispatch": "Confirmar Despacho",
    "tally.processingBanner": "Registrando saída da Ordem de Serraria:",
    "tally.outputLockedTitle": "Esta saída é definitiva",
    "tally.outputLockedText": "Esta Ordem de Serraria está concluída e a madeira já está em estoque como um novo Lote, por isso este romaneio é somente leitura — ele sempre confere com o estoque que criou. Para alterar a saída, use Editar Saída na Ordem de Serraria. Para corrigir um valor de estoque, use Ajuste. Ambos deixam registro.",
    "tally.returnToRun": "Concluído — Voltar à Ordem de Serraria",
    "tally.saveAndReturnToRun": "Salvar e voltar à Ordem de Serraria",
    "field.stockIn.title": "Registrar Chegada de Estoque",
    "field.millRun.title": "Seu Trabalho",
    "field.sendOut.title": "Registrar Despacho",
    "field.selectProduct": "O que chegou?",
    "field.cbmAmount": "Quanto? (CBM)",
    "field.location": "Onde será armazenado?",
    "field.submitBtn": "Concluído",
    "field.noJobAssigned": "Nenhum trabalho hoje.",
    // -- Inventory in-out page
    "invInOut.title": "Razão Entrada / Saída",
    "invInOut.subtitle": "Cada movimento de inventário com carimbo de data/hora e detalhes",
    "invInOut.addAdjustment": "Adicionar Ajuste",
    "invInOut.adjTooltip": "Registrar uma correção manual de estoque",
    "invInOut.exportTooltip": "Exportar razão filtrada para Excel",
    "invInOut.dateRange": "Período",
    "invInOut.allDates": "Todas as datas",
    "invInOut.movements": "movimentos",
    "invInOut.netChange": "Variação líquida",
    "invInOut.businessPartner": "Parceiro Comercial",
    "invInOut.noMovements": "Nenhum movimento encontrado.",
    "invInOut.clearFiltersHint": "Tente limpar os filtros acima.",
    "invInOut.adjDialogHeader": "Adicionar Ajuste de Inventário",
    "invInOut.tuPlaceholder": "Pesquisar unidade de estoque, nº do contêiner / caminhão ou produto",
    "ledger.s.received": "Recebido",
    "ledger.s.at": "em",
    "ledger.s.as": "como",
    "ledger.s.dispatched": "Despachado",
    "ledger.s.from": "de",
    "ledger.s.on": "em",
    "ledger.s.to": "para",
    "ledger.s.sentToMill": "Enviado à serraria",
    "ledger.s.forJob": "para o trabalho",
    "ledger.s.job": "Trabalho",
    "ledger.s.produced": "produziu",
    "ledger.s.into": "em",
    "ledger.s.addedToConsignment": "adicionado à remessa",
    "ledger.s.allowance": "Tolerância de tora",
    "ledger.s.tallyCorrected": "Tally corrigido em",
    "ledger.s.stockCorrected": "Estoque corrigido em",
    "Reconciliation": "Reconciliação",
    "Allowance": "Tolerância",
    "Tally correction": "Correção da contagem",
    "ledger.s.reconciled": "Reconciliado",
    "ledger.col.whatHappened": "O que aconteceu",
    "ledger.col.by": "Por",
    "ledger.job.show": "Trabalho completo",
    "ledger.job.in": "Entrada",
    "ledger.job.out": "Saída",
    "ledger.job.started": "Início",
    "ledger.job.finished": "Fim",
    "ledger.job.notFinished": "Ainda não concluído",
    "ledger.job.wastage": "Perda",
    "invInOut.tuRequired": "Selecione uma Unidade de Estoque.",
    "invInOut.reason": "Motivo",
    "invInOut.reasonPlaceholder": "Selecionar motivo",
    "invInOut.reasonRequired": "Selecione um motivo.",
    "invInOut.cbmChange": "Variação CBM",
    "invInOut.cbmHint": "Negativo = perda, positivo = ganho",
    "invInOut.piecesChange": "Variação de Peças",
    "terms.open": "O que são Unidade de Estoque, Lote e Ordem de Serraria?",
    "terms.flowLabel": "Como o estoque se move: Entrada, Lote, Ordem de Serraria, novo Lote, Saída",
    "terms.stockIn": "Entrada",
    "terms.stockOut": "Saída",
    "terms.lot": "Lote",
    "terms.newLot": "Novo Lote",
    "terms.millJob": "Ordem de Serraria",
    "terms.suName": "Unidade de Estoque",
    "terms.suText": "Uma carga — contêiner, caminhão ou vagão — com suas linhas de contagem. Entrada = comprado, Saída = vendido. As linhas travam após recebida / confirmada.",
    "terms.lotText": "Um monte da mesma madeira em estoque (produto, local, origem, qualidade). A Entrada é recebida nele; Saídas e Ordens de Serraria tiram dele — o Lote mais antigo primeiro.",
    "terms.lotOld": "(antes chamado de Batch)",
    "terms.jobText": "Madeira enviada de um Lote para a serraria; registra o que entrou, o que saiu e a perda, e cria um novo Lote.",
    "terms.jobOld": "(antes chamado de Processamento)",
    "terms.more": "Como o estoque se move — guia completo",
    "so.fromPurchase": "Da compra",
    "so.whereFrom": "De onde veio",
    "so.show": "Mostrar",
    "so.showPath": "Mostrar o caminho todo",
    "so.hidePath": "Ocultar o caminho",
    "so.error": "Não foi possível rastrear.",
    "so.nothing": "Nada retirado do estoque ainda.",
    "so.inputNote": "Antes de uma serraria os números são a madeira que entrou, incluindo a perda. Volume líquido.",
    "so.in": "entrada",
    "so.out": "saída",
    "so.waste": "perda",
    "so.now": "Agora",
    "so.adjusted": "Ajustado",
    "so.reconciled": "Reconciliado",
    "so.allowance": "Tolerância",
    "so.traceToPurchase": "Rastrear até a compra",
    "so.kind.LOT": "Lote",
    "so.kind.MILL_JOB": "Ordem de Serraria",
    "so.kind.STOCK_UNIT": "Unidade de estoque",
    "so.kind.OPENING_STOCK": "Estoque inicial",
    "so.kind.HAND": "Lote criado à mão",
    "so.kind.ADJUSTMENT": "Adicionado por ajuste",
    "so.kind.NOT_TRACED": "Não rastreado",
    "adj.what": "Unidade de estoque, saída ou lote",
    "adj.whatPlaceholder": "Buscar unidade de entrada / saída, contêiner / caminhão, lote ou produto",
    "adj.kind.IN": "Entrada",
    "adj.kind.OUT": "Saída",
    "adj.kind.LOT": "Lote",
    "adj.reconHint": "Diferença da reconciliação — informe por medida:",
    "adj.noLot": "Esta unidade ainda não entrou em um lote — nada para ajustar.",
    "adj.outLine": "Qual linha desta saída",
    "adj.outLinePlaceholder": "Escolha lote · medida · peças",
    "adj.noOutLines": "Esta saída ainda não retirou estoque — nada para ajustar.",
    "adj.batchNow": "tem agora",
    "adj.dir.gain": "Adicionar ao estoque",
    "adj.dir.loss": "Retirar do estoque",
    "adj.dir.outGain": "Enviado menos que o registrado",
    "adj.dir.outLoss": "Enviado mais que o registrado",
    "adj.size": "Medida",
    "adj.sizePlaceholder": "Escolha uma medida",
    "adj.anotherSize": "Outra medida…",
    "adj.sec.what": "O que ajustar",
    "adj.sec.amount": "Medida e quantidade",
    "adj.sec.why": "Motivo",
    "adj.origin": "Origem",
    "adj.quality": "Qualidade",
    "adj.originNote": "O ajuste entra neste Lote — a origem e a qualidade continuam as mesmas.",
    "adj.volume": "Volume",
    "adj.sizeSearch": "Buscar medida, ex. 4x3x6",
    "adj.width": "Largura (pol)",
    "adj.thick": "Espessura (pol)",
    "adj.length": "Comprimento (pés)",
    "adj.pieces": "Peças",
    "adj.cbm": "CBM",
    "adj.maxPcs": "Até {n} peças disto em estoque",
    "adj.pcsInStock": "{n} peças",
    "adj.tooMuch": "Isso é mais do que este lote / medida realmente tem.",
    "adj.outNoteTitle": "Saída ajustada",
    "adj.outNote": "O estoque foi corrigido; as linhas da saída ficam como estavam. Totais de consignação / fatura NÃO mudam — corrija-os também se preciso.",
    "adj.offline": "Ajustes precisam de conexão.",
    "adj.saved": "Ajuste registrado — estoque atualizado.",
    "adj.roundPart": "Toras redondas (sem medida)",
    "adj.reason.RECONCILIATION_DELTA": "Diferença de reconciliação",
    "adj.reason.RECONCILIATION_AFTER_MILLING": "Reconciliação após serragem",
    "adj.reason.DAMAGE": "Dano",
    "adj.reason.MOISTURE_LOSS": "Perda por umidade / secagem",
    "adj.reason.MEASUREMENT_ERROR": "Erro de medição",
    "adj.reason.MANUAL_CORRECTION": "Correção manual",
    "adj.reason.OTHER": "Outro",
    "adj.notesRequired": "Descreva o que aconteceu (obrigatório quando o motivo é Outro).",
    "adj.large.title": "Este é um ajuste grande",
    "adj.large.text": "Confira bem a quantidade — um erro de digitação (como um zero a mais) mudaria muito o seu estoque.",
    "adj.large.confirm": "Conferi esta quantidade",
    "adj.holdShortTitle": "Outras saídas ficaram sem estoque",
    "adj.holdShortText": "Estas saídas abertas reservam mais deste lote do que ele tem: {units}",
    "adj.alreadyAdjusted": "ajustado",
    "ledger.s.adjustedAfterConfirm": "Ajustado após confirmar",
    "ledger.s.recordedOnly": "(apenas registrado — sem mudança no estoque)",
    "invInOut.postAdjustment": "Lançar Ajuste",
    "invInOut.descPlaceholder": "Descreva o que aconteceu (opcional)",
    // -- Inventory overview page
    "invOverview.title": "Visão Geral do Inventário",
    "invOverview.subtitle": "Snapshot de estoque ao vivo em todos os locais",
    "invOverview.thisMonth": "Este mês",
    "invOverview.clearStageHint": "Clique no mesmo estágio para limpar o filtro",
    "invOverview.filterTooltip": "Clique para filtrar a tabela de estoque",
    "invOverview.openTu": "Abrir Unidade de Estoque",
    "invOverview.noStock": "Nenhum estoque no inventário ainda.",
    "invOverview.noStockHint": "Clique em Entrada de Estoque para registrar a primeira entrada.",
    "invOverview.showAllTus": "Mostrar todos",
    "invOverview.receiveHint": "Caminhão chegou — registrar novo estoque",
    "invOverview.processHint": "Enviar troncos para a serraria",
    "invOverview.dispatchHint": "Estoque saindo",
    "invOverview.recordInInventory": "Registrar no Inventário",
    "invOverview.linkedToInventory": "No Inventário",
    "invOverview.modeToggle": "Modo de visualização",
    "inv.modeSimple": "Simples",
    "inv.modeAdvanced": "Avançado",
    "inv.modeTooltip": "Simples: menos campos · Avançado: rastreamento completo",
    "inv.stockIn": "Entrada",
    "inv.millRun": "Ordem de Serraria",
    "inv.sendOut": "Saída",
    // -- Inventory Lots / Wizards
    "lot.receive": "Entrada",
    "lot.process": "→ Serraria",
    "lot.sendToMill": "Enviar à serraria",
    "lot.more.label": "Mais",
    "lot.more.details": "Ver detalhes",
    "lot.more.statement": "Extrato de estoque",
    "lot.more.openJob": "Abrir trabalho",
    "lot.more.rename": "Renomear lote",
    "lot.warn.short": "Abaixo do contrato em",
    "lot.dispatch": "Despachar",
    "lot.stockBatch": "Lotes de Estoque",
    "lot.inputLotLabel": "Lote de Estoque de Entrada",
    "lot.selectLotPlaceholder": "Selecionar lote (opcional)",
    "lot.searchLotPlaceholder": "Buscar produto, origem, código do lote ou trabalho de moagem…",
    "lot.searchLotEmpty": "Nenhum lote corresponde à busca",
    "lot.pickSearchPlaceholder": "Buscar produto, lote, Unidade de Estoque, contêiner, BL…",
    "lot.pickOriginPlaceholder": "Origem: todas",
    "lot.pickOriginUnknown": "Origem desconhecida",
    "lot.pickOpenLots": "lotes abertos",
    "lot.pickFree": "CBM livre",
    "lot.pickMadeBy": "feito por",
    "lot.pickHide": "ocultar",
    "lot.pickStockUnit": "Unidade de Estoque",
    "lot.pickContainer": "Contêiner / caminhão · ID de transporte",
    "lot.pickSource": "origem",
    "lot.pickThisLot": "este lote",
    "lot.pickUnitsCount": "Unidades de Estoque",
    "lot.pickReceived": "recebidas neste lote",
    "lot.pickTraced": "rastreadas pelo trabalho de moagem",
    "lot.pickClose": "Fechar",
    // -- Mill Operators
    "operator.label": "Operador",
    "operator.multiCompanyBadge": "Multiempresa",
    "operator.multiCompanyTooltip": "Esta pessoa também está ativa em outra empresa — a conta dela não é exclusiva da sua.",
    "operator.selectPlaceholder": "Atribuir operador (opcional)",
    "operator.title": "Operadores de Serraria",
    "operator.subtitle": "Gerencie operadores de serraria e acompanhe o desempenho",
    "operator.backToInventory": "Voltar ao Inventário",
    "operator.addOperator": "Adicionar Operador",
    "machine.title": "Máquinas",
    "machine.subtitle": "Gerencie máquinas e equipamentos da serraria",
    "machine.backToInventory": "Voltar ao Inventário",
    "machine.addMachine": "Adicionar Máquina",
    "machine.editMachine": "Editar Máquina",
    "machine.name": "Nome",
    "machine.namePlaceholder": "ex. Serra de Recorte 2",
    "machine.type": "Tipo",
    "machine.typePlaceholder": "ex. Serra de Recorte, Desempenadeira, Serra Circular",
    "machine.location": "Local",
    "machine.status": "Status",
    "machine.active": "Ativo",
    "machine.inactive": "Inativo",
    "machine.deactivate": "Desativar",
    "machine.reactivate": "Reativar",
    "machine.confirmMachine": "Confirmar",
    "machine.searchPlaceholder": "Buscar máquinas...",
    "machine.allLocations": "Todos os Locais",
    "machine.allStatus": "Todos os Status",
    "machine.needsReview": "Requer Revisão",
    "machine.needsReviewTooltip": "Importado do campo de texto livre de um Local — confirme se está correto",
    "machine.importFromLocations": "Importar dos Locais",
    "machine.statTotal": "Total de Máquinas",
    "machine.machineSingular": "máquina",
    "machine.machinePlural": "máquinas",
    "machine.emptyState": "Nenhuma máquina ainda. Adicione uma, ou importe dos seus Locais existentes.",
    "shortcuts.title": "Atalhos de Teclado",
    "shortcuts.macHint": "⌘ = Cmd no Mac. Os atalhos de Salvar/Excluir de formulário abaixo hoje só funcionam em teclados Mac.",
    "shortcuts.group.anywhere": "Em qualquer lugar",
    "shortcuts.group.search": "Dentro da Busca",
    "shortcuts.group.tally": "Lançamento de Tally",
    "shortcuts.group.forms": "Formulários de Produto / Local",
    "shortcuts.group.photos": "Visualizador de Fotos",
    "shortcuts.group.calculator": "Calculadora",
    "shortcuts.group.aiChat": "Chat de IA",
    "shortcuts.globalSearch": "Abrir Busca Global",
    "shortcuts.openSearch": "Abrir busca",
    "shortcuts.calculator": "Abrir Calculadora",
    "shortcuts.quickSearch": "Abrir Busca Rápida",
    "shortcuts.showShortcuts": "Mostrar esta lista",
    "shortcuts.expandMenu": "Expandir menu lateral",
    "shortcuts.moveSelection": "Mover seleção para cima/baixo",
    "shortcuts.openSelected": "Abrir resultado selecionado",
    "shortcuts.closeSearch": "Fechar",
    "shortcuts.saveTally": "Salvar alterações do tally",
    "shortcuts.tallyEnter": "Próximo campo / próxima linha (no fim adiciona uma linha)",
    "shortcuts.tallyAddRowBelow": "Adicionar linha abaixo (tally redondo)",
    "shortcuts.tallyStockPicker": "Escolher do estoque (layout flexível do Square)",
    "shortcuts.tallyForceNext": "Avançar sem verificar o valor (layout flexível do Square: adiciona uma linha abaixo)",
    "shortcuts.tallyMoveCells": "Mover entre células",
    "shortcuts.saveForm": "Salvar (somente Mac)",
    "shortcuts.deleteForm": "Excluir, durante edição (somente Mac)",
    "shortcuts.prevNextPhoto": "Foto anterior / próxima",
    "shortcuts.closePhoto": "Fechar visualizador de fotos",
    "shortcuts.calcDigits": "Digitar números",
    "shortcuts.calcOperators": "Operadores",
    "shortcuts.calcPercent": "Porcentagem",
    "shortcuts.calcEquals": "Calcular",
    "shortcuts.calcBackspace": "Apagar último dígito",
    "shortcuts.calcClearOrClose": "Limpar, depois fechar",
    "shortcuts.aiChatSend": "Enviar mensagem",
    "shortcuts.aiChatNewLine": "Nova linha, sem enviar",
    "globalSearch.help.viewAllShortcuts": "Ver todos os atalhos de teclado",
    "globalSearch.trigger": "Busca Global",
    "unifiedSearch.trigger": "Buscar",
    "unifiedSearch.placeholder": "Busque qualquer coisa, ou digite um cálculo…",
    "unifiedSearch.shortcutHint": "/",
    "unifiedSearch.mode.auto": "Automático",
    "unifiedSearch.mode.records": "Registros",
    "unifiedSearch.mode.stock": "Estoque",
    "unifiedSearch.mode.calculator": "Calculadora",
    "unifiedSearch.autoInterpreting": "Buscando como",
    "unifiedSearch.mathOpenHint": "toque ou pressione enter para abrir a calculadora",
    "globalSearch.placeholder": "Buscar unidades de estoque, remessas, parceiros, produtos, locais, usuários…",
    "globalSearch.shortcutHint": "/",
    "globalSearch.searching": "Buscando…",
    "globalSearch.noResults": "Nenhum resultado encontrado",
    "globalSearch.minChars": "Continue digitando para buscar…",
    "globalSearch.category.transportUnit": "Unidades de Estoque",
    "globalSearch.category.shipment": "Remessas",
    "globalSearch.category.businessPartner": "Parceiros de Negócios",
    "globalSearch.category.product": "Produtos",
    "globalSearch.category.loadingSite": "Locais",
    "globalSearch.category.user": "Usuários",
    "globalSearch.category.menuItem": "Páginas",
    "globalSearch.askLinc.cta": "Perguntar ao Linc",
    "globalSearch.askLinc.subtitle": "Pergunte ao Linc sobre seus registros e estoque",
    "globalSearch.calculatorTooltip": "Calculadora",
    "globalSearch.mathOpenHint": "Toque para continuar calculando",
    "globalSearch.help.toggleTooltip": "Como buscar",
    "globalSearch.help.intro": "Buscar em:",
    "globalSearch.help.shortcutText": "Pressione / em qualquer lugar para abrir esta busca. Digite pelo menos 2 caracteres — códigos curtos funcionam a partir de 2, nomes longos a partir de 4.",
    "globalSearch.recentTitle": "Recentes",
    "quickSearch.trigger": "Busca Rápida",
    "quickSearch.placeholder": "ex. 4x3x7 teca gana a",
    "quickSearch.fuzzyTooltip": "Correspondência aproximada — não exata",
    "quickSearch.unrecognizedTooltip": "Não reconhecido como espécie, origem ou qualidade — ignorado",
    "quickSearch.recent": "Buscas recentes",
    "planLimit.dialogTitle": "Limite do Plano Atingido",
    "planLimit.dialogUsage": "Você usou {used} de {limit} {feature}.",
    "planLimit.manageButton": "Gerenciar {feature}",
    "planLimit.upgradeButton": "Atualizar Plano",
    "quickSearch.searching": "Buscando...",
    "quickSearch.notFound": "Nenhum resultado — tente outra grafia ou menos detalhes.",
    "quickSearch.availableNow": "Disponível agora",
    "quickSearch.pendingStockIn": "Entrada de estoque pendente",
    "quickSearch.groups": "grupos",
    "quickSearch.pcs": "peças",
    "quickSearch.eta": "Previsão",
    "quickSearch.details": "Detalhes de compra",
    "shipment.tuAllProducts": "Todos os produtos nesta unidade",
    "quickSearch.invoiceAmount": "Valor da fatura",
    "quickSearch.billNo": "Número da nota",
    "quickSearch.billOfLadingNo": "Número do Conhecimento de Embarque",
    "quickSearch.viewConsignment": "Ver Consignação",
    "quickSearch.mixedConsignments": "Misto — toque para ver detalhes",
    "quickSearch.noPurchasingInfo": "Nenhuma informação de compra registrada para este estoque.",
    "quickSearch.calculator": "Calculadora",
    "quickSearch.quickPrice": "Preço rápido",
    "quickSearch.pricePerCbm": "Preço / CBM",
    "quickSearch.pricePerCft": "Preço / CFT",
    "quickSearch.inProcess": "Em ordem de serraria",
    "quickSearch.didYouMean": "Você quis dizer",
    "quickSearch.arrivingSoon": "Chegando em breve",
    "quickSearch.departingSoon": "Partindo em breve",
    "quickSearch.preparing": "Em preparação",
    "quickSearch.hint": "Digite espécie, dimensões, origem ou qualidade — em qualquer ordem.",
    "quickSearch.help.toggleTooltip": "Como funciona",
    "quickSearch.help.back": "Voltar à busca",
    "quickSearch.help.basicsTitle": "O básico",
    "quickSearch.help.basicsText": "Combine espécie, tamanho, origem ou qualidade em qualquer ordem — nada é obrigatório.",
    "quickSearch.help.sizesTitle": "Tamanhos",
    "quickSearch.help.sizesExactText": "Tamanho exato, sem precisar de palavras:",
    "quickSearch.help.sizesRangeText": "Ou um intervalo — adicione um comparador e uma medida nomeada:",
    "quickSearch.help.sizesTypeText": "Números soltos podem ser ambíguos — adicione \"square\" (quadrado) ou \"round\" (redondo) para esclarecer:",
    "quickSearch.help.sizesAnyText": "Use \"?\" para uma medida que não importa — \"4x3x?\" significa 4x3, qualquer comprimento:",
    "quickSearch.help.speciesTitle": "Espécie, origem, qualidade",
    "quickSearch.help.speciesText": "Erros de digitação não são problema — correspondências próximas são encontradas automaticamente. Uma marca \"?\" significa que foi um palpite, não exato.",
    "quickSearch.help.legendTitle": "O que os grupos de resultado significam",
    "quickSearch.help.legendAvailable": "Disponível Agora — pronto para uso hoje",
    "quickSearch.help.legendPending": "Entrada de Estoque Pendente — tabulado, ainda não recebido no Estoque",
    "quickSearch.help.legendProcess": "Em ordem de serraria — sendo serrado ou re-serrado agora",
    "quickSearch.help.legendArriving": "Chegando / Partindo / Preparando — embarques futuros",
    "quickSearch.help.aiTitle": "Perguntar à IA",
    "quickSearch.help.aiText": "Dificuldade em formular? Perguntar à IA entende linguagem mais natural e menos precisa. Usa créditos de IA (plano Forest) — a busca comum continua sempre gratuita.",
    "commandCenter.title": "Central de Comando",
    "commandCenter.asOf": "Em",
    "commandCenter.offlineNoCopyTitle": "Ainda não salvo neste telefone",
    "commandCenter.offlineNoCopyText": "Abra o Centro de Comando uma vez com internet. Depois disso, os últimos números ficam salvos neste telefone e você pode vê-los offline.",
    "commandCenter.tab.overview": "Visão Geral",
    "commandCenter.tab.inventory": "Inventário",
    "commandCenter.tab.floor": "Chão de Fábrica e Rendimento",
    "commandCenter.tab.money": "Financeiro",
    "commandCenter.tab.consignments": "Consignações",
    "commandCenter.cons.arriving": "Chegando esta semana",
    "commandCenter.cons.leaving": "Saindo esta semana",
    "commandCenter.cons.preparing": "Em preparação",
    "commandCenter.cons.shipped": "Enviado este mês",
    "commandCenter.cons.inShipment": "em consignação",
    "commandCenter.cons.arrives": "Chega",
    "commandCenter.cons.departs": "Parte",
    "commandCenter.cons.all": "Todas as consignações",
    "commandCenter.howSure": "Quão confiáveis são os números",
    "commandCenter.counted": "contado",
    "commandCenter.notCountedYet": "Unidades de Estoque ainda não contadas",
    "commandCenter.reviewThem": "Revisar",
    "commandCenter.allSizes": "Todos os tamanhos",
    "commandCenter.allSites": "Todos os locais",
    "commandCenter.btn.open": "Abrir",
    "commandCenter.btn.review": "Rever",
    "commandCenter.btn.count": "Contar",
    "commandCenter.btn.see": "Ver",
    "commandCenter.btn.assign": "Atribuir",
    "commandCenter.attn.noMachineOne": "O trabalho de serraria {code} não tem máquina",
    "commandCenter.attn.noMachineMany": "{n} trabalhos de serraria em andamento não têm máquina",
    "commandCenter.attn.holdsOne": "1 Saída de Estoque retendo madeira há 60+ dias",
    "commandCenter.attn.holdsMany": "{n} Saídas de Estoque retendo madeira há 60+ dias",
    "commandCenter.attn.holdsSub": "{cbm} m³ bloqueados para venda",
    "commandCenter.tabShort.inventory": "Estoque",
    "commandCenter.tabShort.floor": "Chão",
    "commandCenter.tabShort.consignments": "Cargas",
    "commandCenter.confidence": "Confiança",
    "commandCenter.inventoryConfidence": "Confiança do Inventário",
    "commandCenter.of": "de",
    "commandCenter.reconciledCopy": "unidades de estoque estão reconciliadas",
    "commandCenter.reviewUnreconciled": "Revisar não reconciliados",
    "commandCenter.stockOnHand": "Estoque disponível",
    "commandCenter.machinesRunning": "Máquinas em operação",
    "commandCenter.owedToYou": "A receber",
    "commandCenter.thisWeek": "Esta semana (saída / entrada)",
    "commandCenter.thisWeekTitle": "Esta semana",
    "commandCenter.split.out": "Saída",
    "commandCenter.split.in": "Entrada",
    "commandCenter.preparing": "em preparação",
    "commandCenter.jobsWithoutMachine": "em andamento sem máquina",
    "commandCenter.needsAttention": "Requer Atenção",
    "commandCenter.allClear": "Tudo certo — nada requer atenção agora.",
    "commandCenter.stockAtGlance": "Estoque em Resumo",
    "commandCenter.product": "Produto",
    "commandCenter.site": "Local",
    "commandCenter.origin": "Origem",
    "commandCenter.quality": "Qualidade",
    "commandCenter.dims": "Dimensões",
    "commandCenter.available": "Disponível",
    "commandCenter.round": "Redondo",
    "commandCenter.viewAllGroups": "Ver todos os grupos",
    "commandCenter.sortNewest": "Mais recentes",
    "commandCenter.sortMostStock": "Mais estoque",
    "commandCenter.sortAz": "A–Z",
    "commandCenter.added": "Adicionado",
    "commandCenter.showLess": "Mostrar menos",
    "commandCenter.rangeOf": "de",
    "commandCenter.conversionYield": "Rendimento por espécie",
    "commandCenter.avgOutturn": "Rendimento médio",
    "commandCenter.netVolume": "Volume líquido das ordens de serraria",
    "commandCenter.reconciliationStatus": "Status de Reconciliação",
    "commandCenter.total": "Total",
    "commandCenter.reconciled": "Reconciliado",
    "commandCenter.pending": "Pendente",
    "commandCenter.locked": "Bloqueado",
    "commandCenter.siteUtilisation": "Utilização do Local",
    "commandCenter.floorNow": "No chão agora",
    "commandCenter.operator": "Operador",
    "commandCenter.machine": "Máquina",
    "commandCenter.location": "Local",
    "commandCenter.started": "Iniciado",
    "commandCenter.status": "Status",
    "commandCenter.noActiveRuns": "Nenhuma ordem de serraria ativa agora.",
    "commandCenter.toCollect": "A receber",
    "commandCenter.toPay": "A pagar",
    "commandCenter.overdueToCollect": "Atrasado a receber",
    "commandCenter.overdueToPay": "Atrasado a pagar",
    "commandCenter.overdueToCollectByAge": "Atrasado a receber por idade",
    "commandCenter.invoices": "faturas",
    "commandCenter.inTotal": "no total",
    "commandCenter.received": "Recebido",
    "commandCenter.paidOut": "Pago",
    "commandCenter.futureDated": "A data deste pagamento está no futuro — verifique",
    "commandCenter.futureDatedShort": "data futura",
    "commandCenter.last30Days": "(últimos 30 dias)",
    "commandCenter.attn.overdueCollectOne": "1 fatura a receber está atrasada",
    "commandCenter.attn.overdueCollectMany": "{n} faturas a receber estão atrasadas",
    "commandCenter.attn.atRisk": "{amount} {cur} em risco",
    "commandCenter.attn.overduePayOne": "1 fatura que você deve está vencida",
    "commandCenter.attn.overduePayMany": "{n} faturas que você deve estão vencidas",
    "commandCenter.attn.toPaySub": "{amount} {cur} a pagar",
    "commandCenter.attn.pendingReconOne": "1 unidade de estoque aguardando reconciliação",
    "commandCenter.attn.pendingReconMany": "{n} unidades de estoque aguardando reconciliação",
    "commandCenter.attn.netDiscrepancy": "{v} CBM de diferença líquida",
    "commandCenter.attn.tallySyncOne": "1 correção de talão precisa da sua decisão",
    "commandCenter.attn.tallySyncMany": "{n} correções de talão precisam da sua decisão",
    "commandCenter.attn.tallySyncSub": "O estoque não foi alterado automaticamente — revise em Inventário → Entradas e Saídas",
    "tallySync.title": "Correções de talão aguardando você",
    "tallySync.subtitle": "Um talão foi alterado depois que este estoque foi recebido. O estoque NÃO foi alterado automaticamente.",
    "tallySync.change": "O talão alterou o estoque em",
    "tallySync.reasonNegative": "Deixaria o lote abaixo de zero, e sua empresa não permite vender além do estoque disponível (Configurações → Política de Inventário).",
    "tallySync.reasonReconLocked": "A reconciliação já está bloqueada, então os números de chegada (destino) definem o estoque.",
    "tallySync.reasonShipped": "Esta Stock Unit já foi enviada.",
    "tallySync.reasonOther": "Precisa da decisão de uma pessoa.",
    "tallySync.apply": "Aplicar ao estoque",
    "tallySync.dismiss": "Descartar",
    "tallySync.appliedToast": "Estoque atualizado",
    "tallySync.dismissedToast": "Correção de talão descartada — estoque inalterado",
    "tallySync.actionFailed": "Não foi possível concluir",
    "tallySync.noPermission": "Você não tem permissão para alterar o estoque.",
    "commandCenter.attn.siteFull": "{name} está com {pct}% da capacidade",
    "commandCenter.attn.siteSub": "{cur} de {cap} CBM",
    "commandCenter.attn.departingOne": "1 remessa saindo esta semana",
    "commandCenter.attn.departingMany": "{n} remessas saindo esta semana",
    "commandCenter.attn.soonest": "Mais próxima: {date}",
    "commandCenter.money.atSavedRates": "Às taxas de câmbio salvas",
    "commandCenter.money.partial": "Parcial",
    "commandCenter.money.partialTip": "Alguns valores não têm taxa de câmbio e não entram neste total",
    "commandCenter.money.noRate": "sem taxa",
    "commandCenter.money.noRateCountOne": "1 remessa sem taxa de câmbio — fora dos totais",
    "commandCenter.money.noRateCountMany": "{n} remessas sem taxa de câmbio — fora dos totais",
    "commandCenter.money.addRate": "Adicionar taxa",
    "commandCenter.money.unmatchedOne": "1 pagamento em outra moeda sem taxa — não contado",
    "commandCenter.money.unmatchedMany": "{n} pagamentos em outra moeda sem taxa — não contados",
    "commandCenter.money.net": "Posição líquida",
    "commandCenter.money.inFavour": "a seu favor",
    "commandCenter.money.youOweMore": "você deve mais",
    "commandCenter.money.overdueByAge": "Atrasados por idade",
    "commandCenter.money.nothingOverdue": "Nada atrasado",
    "commandCenter.money.overdueOne": "{amount} atrasado · 1 fatura",
    "commandCenter.money.overdueMany": "{amount} atrasado · {n} faturas",
    "commandCenter.money.invoiceOne": "1 fatura",
    "commandCenter.money.invoiceMany": "{n} faturas",
    "commandCenter.money.dueToday": "Vence hoje",
    "commandCenter.money.dueTomorrow": "Amanhã",
    "commandCenter.money.inDays": "em {n} dias",
    "commandCenter.money.lateOne": "1 dia de atraso",
    "commandCenter.money.lateMany": "{n} dias de atraso",
    "commandCenter.notAssigned": "Não atribuído",
    "commandCenter.notStarted": "Não iniciado",
    "commandCenter.waiting": "Aguardando há",
    "commandCenter.days": "dias",
    "commandCenter.openJob": "Abrir trabalho",
    "commandCenter.moneyToday": "Financeiro Hoje",
    "commandCenter.totalReceivable": "Total a receber",
    "commandCenter.totalPayable": "Total a pagar",
    "commandCenter.overdue": "Vencido",
    "commandCenter.overdueCount": "Faturas vencidas",
    "commandCenter.recentPayments": "Pagamentos recentes",
    "commandCenter.noRecentPayments": "Nenhum pagamento recente.",
    "commandCenter.dueSoon": "Vencendo em breve",
    "commandCenter.noDueSoon": "Nada vencendo em breve.",
    "commandCenter.consignmentRadar": "Próximos 7 dias",
    "commandCenter.recentActivity": "Consignações recentes",
    "commandCenter.tradeMix": "Mix Comercial",
    "quickSearch.ai.toggle": "Perguntar à IA",
    "quickSearch.ai.toggleTooltip": "Plano Forest — entende frases mais confusas que a busca comum, consome créditos de IA a cada uso",
    "quickSearch.ai.ask": "Perguntar à IA",
    "quickSearch.ai.creditsUsedThisCall": "Créditos usados",
    "quickSearch.ai.used": "dos seus créditos de IA usados",
    "quickSearch.ai.outOfCredits": "Créditos de IA esgotados neste período. A busca comum ainda funciona sem custo de crédito.",
    "quickSearch.ai.rateLimited": "Limite diário de uso de IA atingido. Tente novamente amanhã, ou use a busca comum.",
    "quickSearch.ai.forestOnly": "Perguntar à IA está disponível no plano Forest. A busca comum ainda funciona.",
    "quickSearch.ai.genericError": "A IA não conseguiu responder — tente a busca comum.",
    "invProc.machineLabel": "Máquina (opcional)",
    "invProc.machinePlaceholder": "Selecionar máquina",
    "operator.name": "Nome",
    "operator.employeeCode": "Código do Funcionário",
    "operator.expertise": "Especialização",
    "operator.hireDate": "Data de Contratação",
    "operator.active": "Ativo",
    "operator.inactive": "Inativo",
    "operator.runsCompleted": "Ordens de Serraria Concluídas",
    "operator.avgOutturn": "Média de Rendimento",
    "operator.bestOutturn": "Melhor Rendimento",
    "operator.searchPlaceholder": "Pesquisar operadores...",
    "operator.allExpertise": "Toda Especialização",
    "operator.allStatus": "Todo Status",
    "operator.statTotal": "Total",
    "operator.operatorSingular": "operador",
    "operator.operatorPlural": "operadores",
    "operator.viewPerformance": "Ver Desempenho",
    "operator.performance": "Desempenho",
    "operator.deactivate": "Desativar",
    "operator.noOperatorsFound": "Nenhum operador encontrado",
    "operator.noOperatorsSub": "Ajuste os filtros ou adicione seu primeiro operador de serraria para começar.",
    "operator.editOperator": "Editar Operador",
    "operator.reactivate": "Reativar",
    "operator.currentlyAssigned": "Atualmente Atribuído",
    "operator.pending": "Pendente",
    "operator.noTasks": "Nenhuma tarefa",
    "operator.viewFullHistory": "Ver Histórico Completo",
    "operator.fullHistory": "Histórico Completo",
    "operator.taskCode": "Tarefa",
    "operator.materials": "Materiais",
    "operator.processingDate": "Data da Ordem de Serraria",
    "operator.outturn": "Rendimento",
    "common.from": "De",
    "common.to": "Até",
    // -- Lot card detail keys
    "lot.noOpenLots": "Nenhum lote de estoque aberto. Clique em Receber para adicionar estoque.",
    "lot.showMore": "Mostrar mais",
    "lot.showLess": "Mostrar menos",
    "lot.availableCbm": "disponível",
    "lot.seeDeliveries": "Ver entregas",
    "lot.seeConsignments": "Ver consignações",
    "lot.otherDeliveries": "Outras entregas",
    "lot.whereFrom": "Ver de onde este lote veio",
    "lot.madeAtMill": "Feito no moinho",
    "lot.purchasedFrom": "Comprado de",
    "lot.category.millOutput": "Produzido na Serraria",
    "lot.category.openingStock": "Estoque Inicial",
    "lot.category.notLinked": "Sem Registro de Compra",
    "lot.category.partiallyLinked": "Parcialmente Vinculado",
    "lot.category.linked": "Vinculado a uma Compra",
    "lot.millActivity.queued": "Na Fila para Serrar",
    "lot.millActivity.running": "Na Serraria Agora",
    "lot.millActivity.paused": "Pausado",
    "lot.millActivity.partiallyMilled": "Parcialmente Serrado",
    "lot.cancelledAttemptsNote": "Este lote teve {count} tentativa(s) de moagem cancelada(s).",
    "lot.viewCancelledAttempt": "Ver",
    "lot.filter.all": "Todos",
    "lot.filter.attention": "Precisa de Atenção",
    "lot.filter.atMill": "Na Serraria",
    "lot.filter.fromMill": "Produzido na Serraria",
    "lot.filter.finished": "Esgotado",
    "lot.status.open": "Aberto",
    "lot.status.depleted": "Esgotado",
    "lot.status.closed": "Fechado",
    "lot.status.empty": "Vazio",
    "lot.status.help": "Aberto — estoque disponível · Vazio — ainda aberto, mas sem nada · Esgotado — todo o estoque usado (serrado ou vendido) · Fechado — fechado manualmente, sem mais atividade",
    "lot.sort.label": "Ordenar",
    "lot.sort.newest": "Mais Recente Primeiro",
    "lot.sort.oldest": "Mais Antigo Primeiro",
    "lot.sort.name": "Nome A-Z",
    "lot.sort.amountDesc": "Mais Estoque Primeiro",
    "lot.sort.amountAsc": "Menos Estoque Primeiro",
    "lot.category.notLinkedHelp": "A entrega deste lote não está vinculada a uma compra registrada. Isso é normal para uma coleta doméstica registrada sem uma ordem de compra formal — mas verifique o campo Consignação da entrega se você esperava um vínculo.",
    "lot.category.partiallyLinkedHelp": "Algumas entregas deste lote estão vinculadas a uma compra, mas pelo menos uma não está.",
    "inv.millWarningHeader": "Verifique Antes de Começar",
    "mpc.title": "Verifique antes de começar",
    "mpc.checking": "Verificando…",
    "mpc.notReconciled": "ainda não foi reconciliada.",
    "mpc.diff": "A contagem de descarga mostra",
    "mpc.noCount": "A contagem de descarga ainda não foi lançada.",
    "mpc.alreadyConfirmed": "— serrar sem reconciliar já foi confirmado.",
    "mpc.closedWithoutCount": "foi fechada sem contagem de descarga — o que chegou nunca foi conferido.",
    "mpc.reconcileNow": "Reconciliar agora",
    "mpc.afterStart": "Depois que o trabalho na serraria começar, a diferença só poderá ser registrada — o estoque é corrigido com um ajuste.",
    "mpc.typeConfirm": "Digite CONFIRM para começar sem reconciliar",
    "mpc.confirmHint": "Uma palavra — espaços nas pontas não importam.",
    "mpc.confirmOk": "Confirmado — pode continuar.",
    "recon.afterMill.title": "Esta Unidade de Estoque não foi reconciliada antes de ir para a serraria.",
    "recon.afterMill.titleSold": "Esta Unidade de Estoque não foi reconciliada antes da venda do estoque.",
    "recon.afterMill.cantApply": "já usou este estoque, então reconciliar aqui não muda mais o estoque. Para acertar, corrija o estoque com um ajuste:",
    "recon.afterMill.pooledNote": "Dica: trabalhos de serraria ou vendas anteriores já usaram madeira até esta Stock Unit, por isso a sua contagem só é registrada. Corrija qualquer diferença com um ajuste.",
    "inv.smartSearch.label": "Buscar item",
    "legal.agree.prefix": "Concordo com os",
    "legal.agree.terms": "Termos de Serviço",
    "legal.agree.and": "e a",
    "legal.agree.privacy": "Política de Privacidade",
    "legal.agree.required": "Marque “Concordo” para continuar.",
    "inv.smartSearch.openStatement": "Abrir extrato completo de",
    "recon.afterMill.noCount": "Nenhuma contagem de descarga foi lançada — digite no ajuste a diferença encontrada.",
    "recon.afterMill.step1": "Registre o que chegou: informe a contagem de descarga abaixo e bloqueie como de costume. Assim os registros do fornecedor e os relatórios ficam corretos.",
    "recon.afterMill.step2": "Corrija o estoque: depois de bloquear, use “Corrigir com um ajuste” — ele abre já preenchido.",
    "recon.afterMill.recorded": "Diferença registrada:",
    "recon.afterMill.correctBtn": "Corrigir com um ajuste",
    "recon.afterMill.askAdjust": "Peça a alguém com permissão de ajuste para corrigir o estoque.",
    "recon.afterMill.lockRecordsOnly": "este bloqueio apenas registra; corrija o estoque depois com um ajuste.",
    "adj.negative.title": "Isto deixa o lote abaixo de zero",
    "adj.negative.typeConfirm": "Digite CONFIRM para lançar mesmo assim",
    "inv.millWarningNotLinked": "O lote {lotCode} não tem um registro de compra vinculado. Você ainda pode iniciar a Ordem de Serraria — vincule-o a uma compra primeiro, se tiver essa informação.",
    "inv.millWarningPartial": "Algumas entregas do lote {lotCode} não estão vinculadas a um registro de compra. Você ainda pode iniciar a Ordem de Serraria.",
    "inv.millWarningContinue": "Continuar Mesmo Assim",
    "inventory.receiveNotLinkedWarning": "Esta entrega ainda não está vinculada a um registro de compra (Consignação).",
    "lot.unitNumber": "Nº do Contêiner/Caminhão/Trem",
    "origin.cameFrom": "Origem",
    "origin.stockUnitsWord": "Unidades de Estoque",
    "origin.blsWord": "BLs",
    "origin.order": "Pedido",
    "origin.via": "via",
    "origin.noStockUnit": "Sem Unidade de Estoque — estoque inicial",
    "origin.returned": "Mercadoria devolvida — sem Unidade de Estoque",
    "lot.loading": "Carregando...",
    "lot.searchPlaceholder": "Pesquisar por ID",
    "lot.searchIncludeClosed": "Também pesquisar lotes esgotados",
    "lot.searchResultSingular": "lote encontrado",
    "lot.searchResultPlural": "lotes encontrados",
    "lot.receivedCbm": "Recebido",
    "lot.purchasedCbm": "contratado",
    "lot.daysOld": "dias",
    "lot.procurementOutturn": "rendimento de compra",
    "lot.openingBalance": "Saldo inicial",
    "lot.openingBalanceNote": "Estoque anterior — sem histórico de compra",
    // -- Receive wizard
    "receive.wizard.title": "Estoque Chegou",
    "receive.wizard.editTitle": "Editar Lote de Estoque",
    "receive.step1.title": "O que chegou e de onde?",
    "receive.step2.title": "Quanto chegou?",
    "receive.step3.title": "Quanto você recebeu?",
    "receive.step4.title": "Confirmar recebimento",
    "receive.selectSite": "Selecionar local de armazenamento",
    "receive.selectSupplier": "Selecionar fornecedor",
    "receive.quantity": "CBM Recebido",
    "receive.pieces": "Número de peças",
    "receive.purchaseDate": "Data de compra",
    "receive.confirmed": "Registrar Entrada",
    "receive.moreDetails": "Adicionar detalhes da compra (opcional)",
    "receive.isOpeningBalance": "Este é estoque anterior (saldo inicial)",
    // -- Dispatch wizard
    "dispatch.wizard.title": "Enviar Estoque",
    "dispatch.step1.title": "Qual estoque está saindo?",
    "dispatch.step2.title": "Para onde está indo?",
    "dispatch.step3.title": "Detalhes do despacho",
    "dispatch.step4.title": "Confirmar despacho",
    "dispatch.counterparty": "Cliente / destino",
    "dispatch.reference": "Fatura / número de referência",
    "dispatch.confirmed": "Confirmar Saída",
    "dispatch.destination": "Indo para (comprador / destino)",
    "dispatch.linkTrade": "Vincular a Registro Comercial / Consignação (opcional)",
    "dispatch.invoiceRef": "Fatura / referência do pedido (opcional)",
    "dispatch.actingAs": "Despachando como",
    "dispatch.actingNow": "agora",
    "dispatch.shipment": "Vincular à Consignação",
    "dispatch.shipment.placeholder": "Selecionar consignação (opcional)",
    "dispatch.stepSplit.title": "Confirmar divisão do estoque",
    "dispatch.stepSplit.hint": "Estoque mais antigo primeiro — você pode ajustar a divisão abaixo.",
    "dispatch.filters.toggle": "Filtros (opcional)",
    "dispatch.filters.product": "Produto",
    "dispatch.filters.widthIn": "Largura (pol)",
    "dispatch.filters.thicknessIn": "Espessura (pol)",
    "dispatch.filters.origin": "Origem",
    "dispatch.filters.quality": "Qualidade",
    "dispatch.roundLogs": "Toras redondas",
    "dispatch.unsorted": "Não classificado",
    "dispatch.qtyPlaceholder": "Quantidade",
    "dispatch.noStock": "Nenhum estoque correspondente encontrado.",
    "dispatch.itemsAdded": "Itens adicionados",
    "dispatch.shortfall": "Faltam",
    "dispatch.shortfallSuffix": "— adicione mais lotes ou reduza a quantidade",
    "receive.origin": "Origem (país)",
    "receive.originPlaceholder": "ex.: Gana, Brasil",
    "receive.quality": "Qualidade / grau",
    "receive.salePrice": "Preço de venda",
    "receive.size": "Tamanho (Largura × Espessura × Comprimento)",
    "receive.lengthOpenEnded": "sem máximo",
    "receive.lengthOpenEndedHint": "Deixe o segundo comprimento em branco para final aberto (ex.: \"7ft+\").",
    "tally.qualityForTu": "Qualidade — todas as toras nesta unidade de estoque",
    "tally.qualityPerRow": "Por linha (definir individualmente)",
    "tally.qualityForTuHint": "Deixe em branco para definir a qualidade por linha na grade.",
    "tally.qualityForTuHintRound": "Aplica-se a todas as toras nesta unidade de estoque.",
    "tally.qualityNone": "Nenhuma qualidade definida",
    "tally.qualityNoneShort": "Nenhuma",
    "tally.qualityEnableLabel": "Ativar Qualidade para esta Unidade de Estoque",
    "tally.qualityDisabledHint": "O rastreamento de qualidade está desativado para esta unidade de estoque. Os dados de qualidade existentes são mantidos e reaparecerão se você ativar novamente.",
    "tally.qualityDisableConfirmTitle": "Desativar Qualidade?",
    "tally.qualityDisableConfirmBodyPrefix": "Isso apagará permanentemente o grau de Qualidade de",
    "tally.qualityDisableConfirmBodySuffix": "linha(s) nesta unidade de estoque. Isso não pode ser desfeito.",
    "tally.qualityDisableConfirmInputLabel": "Digite CONFIRM para continuar",
    "tally.qualityDisableConfirmButton": "Desativar e Limpar Qualidade",
    "tally.qualityDisableCancelButton": "Cancelar",
    "tally.qualityDisabledToastTitle": "Qualidade Desativada",
    "tally.qualityDisabledToastDetail": "O rastreamento de qualidade foi desativado e limpo para esta unidade de estoque.",
    "tally.qualityDisableFailed": "Falha ao desativar a Qualidade. Tente novamente.",
    "tally.saveNow": "Salvar Agora",
    "tally.settingsSaving": "Salvando…",
    "tally.settingsSaved": "Salvo",
    "tally.settingsSaveFailedRetry": "Falha ao salvar — toque para tentar novamente",
    "tally.settingsAutoSaveFailed": "Não foi possível salvar suas alterações. Verifique sua conexão e tente novamente.",
    "quality.renameGrades": "Renomear graus",
    "quality.renameGradesTitle": "Rótulos de Grau de Qualidade",
    "quality.renameGradesHint": "Esses nomes aparecem em todos os lugares onde a qualidade é exibida — entradas antigas são atualizadas automaticamente.",
    "chain.viewChain": "Ver Cadeia do Lote",
    "trace.fullTrace": "Rastreio Completo",
    "statement.title": "Extrato de Estoque",
    "statement.subtitle": "Prova do que entrou, foi para a serraria, foi vendido e ainda está em estoque",
    "statement.openStatement": "Extrato de Estoque",
    "statement.unit": "Unidade de volume",
    "statement.exportPdf": "PDF",
    "statement.exportExcel": "Excel",
    "statement.searchPlaceholder": "Unidade de estoque, nº do contêiner / caminhão, lote, ordem de serraria ou BL",
    "statement.suggest.recent": "Recentes",
    "statement.suggest.stockUnits": "Unidades de estoque",
    "statement.suggest.batches": "Lotes",
    "statement.suggest.millJobs": "Trabalhos de serraria",
    "statement.suggest.consignments": "Remessas (BL)",
    "statement.suggest.none": "Nada encontrado - tente unidade de estoque, nº do contêiner / caminhão, lote, ordem de serraria ou BL",
    "statement.show": "Mostrar extrato",
    "statement.emptyTitle": "Comprove qualquer estoque em um só lugar",
    "statement.emptyText": "Digite uma unidade de estoque, contêiner, lote, ordem de serraria ou BL. Você verá o balanço, a perda na serraria, cada lançamento e se confere com os registros do lote.",
    "statement.notFound": "Nada encontrado para esse código",
    "statement.notFoundHint": "Confira a grafia ou tente o ID da unidade, contêiner, LOT-…, PR-… ou BL.",
    "statement.generated": "Gerado em",
    "statement.balanced": "Conferido",
    "statement.balancedSub": "Cada lote confere com seu registro e entradas = saídas",
    "statement.difference": "Diferença encontrada",
    "statement.differenceSub": "Um lote não confere com o registro — veja o lote em vermelho",
    "statement.balanceSheet": "Balanço",
    "statement.inSide": "Entradas",
    "statement.outSide": "Saídas e saldo",
    "statement.totalIn": "Total de entradas",
    "statement.totalOut": "Total de saídas e saldo",
    "statement.opening": "Estoque inicial",
    "statement.received": "Recebido",
    "statement.producedOutside": "Produzido de outros lotes",
    "statement.adjustedNet": "Ajustes (líquido)",
    "statement.allowanceNet": "Desconto (perímetro e comprimento)",
    "statement.story": "O que aconteceu, passo a passo",
    "statement.storySub": "Por ordem de data, em palavras simples",
    "statement.step.startingStock": "Estoque inicial",
    "statement.step.cameIn": "Entrou",
    "statement.step.allowance": "Desconto retirado (casca e corte)",
    "statement.step.sentToMill": "Enviado à serraria",
    "statement.step.millMade": "A serraria produziu",
    "statement.step.sold": "Vendido e saiu",
    "statement.step.correction": "Correção",
    "statement.step.heldForSale": "Reservado para uma venda — ainda não saiu",
    "statement.step.heldForJob": "Reservado para um serviço de serraria — ainda não começou",
    "statement.step.stillInStock": "Ainda em estoque",
    "statement.storyMillSentence": "A serraria usou {in} e produziu {out}. {loss} foi serragem e aparas ({pct}%).",
    "statement.storyNothingSold": "Ainda nada foi vendido.",
    "statement.storyHeldSentence": "{pieces} peças estão reservadas para {code} e sairão do estoque quando essa venda for confirmada.",
    "statement.storySoldSentence": "{cbm} saiu para clientes.",
    "statement.allowance": "Desconto",
    "statement.allowanceHint": "Casca e corte descontados das toras medidas — medida bruta menos medida líquida.",
    "statement.kind.ALLOWANCE": "Desconto",
    "statement.sold": "Vendido / despachado",
    "statement.sentToMillOutside": "Enviado à serraria (saída fora deste extrato)",
    "statement.sentToMillShort": "Enviado à serraria",
    "statement.wastage": "Perda na serraria",
    "statement.closing": "Ainda em estoque",
    "statement.held": "Reservado",
    "statement.free": "Livre",
    "statement.heldPartOf": "de",
    "statement.heldRestOther": "resto em outros Lotes",
    "stockInHand.title": "Estoque em mãos",
    "stockInHand.subtitle": "O que está realmente em estoque agora — reservado e livre, por produto e medida",
    "stockInHand.inStock": "Em estoque",
    "stockInHand.held": "Reservado",
    "stockInHand.free": "Livre",
    "stockInHand.overHeld": "Reserva excedente",
    "stockInHand.overHeldHint": "Algumas Saídas de Estoque ou trabalhos de serraria reservam mais madeira do que o lote contém. Abra os rascunhos antigos e libere ou conclua.",
    "stockInHand.negativeStock": "Estoque negativo",
    "stockInHand.negativeStockHint": "Uma contagem ou venda tirou mais do que o lote tinha, então o saldo está abaixo de zero. Abra o lote e corrija com um ajuste (adicione o que falta).",
    "stockInHand.explain": "Em estoque = Reservado + Livre. Reservado fica para Saídas de Estoque e Ordens de Serraria abertas; Livre ainda pode ser vendido ou serrado. Volume líquido.",
    "stockInHand.searchPlaceholder": "Buscar produto, medida (4x3x6), origem, local ou Lote",
    "stockInHand.rows": "linhas",
    "stockInHand.groupBy": "Agrupar por produto",
    "stockInHand.expandAll": "Expandir tudo",
    "stockInHand.collapseAll": "Recolher tudo",
    "stockInHand.sizeOne": "tamanho",
    "stockInHand.sizeMany": "tamanhos",
    "stockInHand.sortBy": "Ordenar",
    "stockInHand.sortDefault": "Ordem padrão",
    "stockInHand.sortFree": "Livre: maior para menor",
    "stockInHand.sortIn": "Em estoque: maior para menor",
    "stockInHand.sortSize": "Tamanho",
    "stockInHand.sortProduct": "Produto A–Z",
    "stockInHand.searchShort": "Buscar produto ou tamanho",
    "stockInHand.howCounted": "Como isto é contado?",
    "stockInHand.hideHow": "Ocultar",
    "stockInHand.splitTitle": "Retido vs livre",
    "stockInHand.product": "Produto",
    "stockInHand.size": "Medida",
    "stockInHand.site": "Local",
    "stockInHand.lot": "Lote",
    "stockInHand.lots": "Lotes",
    "stockInHand.round": "Toras redondas",
    "stockInHand.tipIn": "Toda a madeira fisicamente disponível, reservada ou não.",
    "stockInHand.tipHeld": "Parte do estoque reservada para Saídas de Estoque e Ordens de Serraria abertas. Continua sendo sua e pode ser vendida ou serrada.",
    "stockInHand.tipFree": "Em estoque menos Reservado: o que está disponível agora para uma nova venda ou Ordem de Serraria.",
    "stockInHand.roundPcs": "Redonda",
    "stockInHand.squarePcs": "Quadrada",
    "stockInHand.logsUnit": "toras",
    "stockInHand.openStatement": "Extrato de estoque",
    "stockInHand.holdsTitle": "Retido por Saídas de Estoque abertas",
    "stockInHand.holdsHint": "Madeira reservada para Saídas ainda não confirmadas. Libere uma esquecida para liberar a madeira.",
    "stockInHand.holdsShowAll": "Mostrar todas",
    "stockInHand.holdsShowFewer": "Mostrar menos",
    "stockInHand.idleToday": "Parado hoje",
    "stockInHand.idleDays": "Parado há {n} d",
    "stockInHand.release": "Liberar",
    "stockInHand.releaseSure": "Liberar as reservas?",
    "stockInHand.releaseYes": "Sim, liberar",
    "stockInHand.released": "Reservas liberadas — voltam quando alguém abrir ou salvar essa Saída.",
    "stockInHand.releaseFailed": "Não foi possível liberar — tente novamente.",
    "stockInHand.openUnit": "Abrir esta Saída de Estoque",
    "stockInHand.empty": "Ainda sem estoque em mãos",
    "stockInHand.noMatch": "Nada corresponde a esta busca",
    "stockInHand.failed": "Não foi possível carregar o estoque",
    "stockInHand.footnote": "As linhas mostram medidas com estoque livre. Reservado por linha = Saídas de Estoque abertas nessa medida; reservas de Ordens de Serraria já saem do Livre e entram no total Reservado acima.",
    "statement.whereItWent": "Para onde foi o estoque",
    "statement.millJobs": "Serragens",
    "statement.outturn": "Rendimento",
    "statement.input": "Entrada",
    "statement.output": "Saída",
    "statement.jobPartial": "Só um lado desta ordem de serraria está neste extrato, então a perda não é contada aqui.",
    "statement.batches": "Lotes",
    "statement.producedBy": "Produzido por",
    "statement.fromBatch": "de",
    "statement.matchesRecord": "Confere",
    "statement.differenceShort": "Diferença",
    "statement.negativeStock": "Estoque negativo",
    "statement.negativeStockTooltip": "O número de estoque deste lote está abaixo de zero — provavelmente uma correção (Reconciliação ou Ajuste) foi feita sem considerar o estoque já enviado ao moinho ou vendido. Verifique.",
    "statement.produced": "Produzido",
    "statement.milled": "Para serraria",
    "statement.adjusted": "Ajustado",
    "statement.pcs": "pçs",
    "statement.batchRecord": "Registro do lote",
    "statement.differenceBy": "diferença",
    "statement.notInStockTitle": "Não está em estoque agora",
    "statement.notInStockLeft": "Saiu do estoque por Stock Outs confirmados:",
    "statement.notInStockNone": "Nenhum lote tem isto agora e nenhum Stock Out confirmado foi encontrado.",
    "statement.diffPanelTitle": "Onde, quanto e por quê",
    "statement.diffPanelWhyBtn": "Por quê? O que fazer?",
    "statement.diffPanelHide": "Ocultar",
    "statement.diffPanelRecord": "Registro do lote",
    "statement.diffPanelMoves": "movimentos somam",
    "statement.diffPanelWhyLabel": "Por quê:",
    "statement.diffPanelWhy": "O número salvo do lote e o total dos seus movimentos foram alterados separadamente — por exemplo, uma alteração feita fora das telas normais ou um movimento não registrado.",
    "statement.diffPanelDoLabel": "O que fazer:",
    "statement.diffPanelDo": "Abra o lote e confira os movimentos. Corrija com Add Adjustment para que o registro e o histórico voltem a coincidir. Não edite o número diretamente.",
    "statement.heldForSale": "Reservado p/ venda",
    "statement.heldForJob": "Reservado p/ ordem de serraria",
    "statement.showEntries": "Mostrar lançamentos",
    "statement.hideEntries": "Ocultar lançamentos",
    "statement.when": "Data e hora",
    "statement.entry": "Lançamento",
    "statement.reference": "Referência",
    "statement.partner": "Parceiro",
    "statement.noEntries": "Sem lançamentos.",
    "statement.timeline": "Linha do tempo",
    "statement.proof": "Gerado a partir dos lançamentos:",
    "statement.netVolume": "volumes líquidos",
    "statement.piecesIndicative": "alguns lançamentos não têm peças, totais de peças são indicativos",
    "statement.type.STOCK_UNIT": "Unidade de estoque",
    "statement.type.BATCH": "Lote",
    "statement.type.MILL_JOB": "Ordem de Serraria",
    "statement.type.CONSIGNMENT": "Remessa",
    "statement.kind.OPENING": "Estoque inicial",
    "statement.kind.RECEIVED": "Recebido",
    "statement.kind.PRODUCED": "Produzido na serraria",
    "statement.kind.MILLED": "Enviado à serraria",
    "statement.kind.SOLD": "Vendido / despachado",
    "statement.kind.ADJUSTED": "Ajustado",
    "statement.kind.RECONCILED": "Conciliado",
    "statement.kind.ASSIGNED": "Adicionado à remessa",
    "statement.kind.OTHER": "Outro",
    "statement.modeItem": "Um item",
    "statement.modeFilter": "Filtrar estoque",
    "statement.filterProduct": "Produto",
    "statement.filterOrigin": "Origem",
    "statement.filterSite": "Local",
    "statement.filterQuality": "Qualidade",
    "statement.filterSize": "Medida (qualquer unidade)",
    "statement.sizePlaceholder": "3x2x8 ft · 76 x 50 mm · girth 90cm x 8m",
    "statement.sizeInvalid": "Medida não entendida — tente 3x2x8 ft, 76 x 50 mm ou girth 90cm",
    "statement.filterFrom": "De",
    "statement.filterTo": "Até",
    "statement.filterHint": "Deixe vazio para qualquer. Sem datas = do início até agora.",
    "statement.any": "Qualquer",
    "statement.clear": "Limpar",
    "statement.emptyFilterText": "Escolha filtros e toque em Mostrar extrato — ou sem filtros para todo o estoque.",
    "statement.noResults": "Nenhum estoque com esses filtros",
    "statement.noResultsHint": "Remova um filtro ou amplie as datas.",
    "statement.type.FILTER": "Estoque filtrado",
    "statement.periodStatement": "Extrato do período",
    "statement.periodStatementSub": "Saldos na data final; entradas = saídas",
    "statement.groups": "Grupos de estoque",
    "statement.group": "Produto · origem · local",
    "statement.batchesLower": "lotes",
    "statement.inShort": "Entrada",
    "statement.sizeNow": "Esta medida agora",
    "statement.total": "Total",
    "statement.inventoryReportLink": "Extrato de Estoque",
    "trace.seeWhereFrom": "Ver de onde isso veio",
    "trace.rel.includesStockUnit": "Inclui Unidade de Estoque",
    "trace.rel.linkedToConsignment": "Ligado à Remessa",
    "trace.rel.receivedInto": "Recebido em",
    "trace.rel.dispatchedFrom": "Despachado de",
    "trace.rel.fedAsInput": "Entrada para",
    "trace.rel.drewStockFrom": "Retirou estoque de",
    "trace.rel.receivedIntoLot": "Recebido neste Lote",
    "trace.rel.producedByJob": "Produzido pelo Trabalho de Serraria",
    "trace.rel.milledInto": "Serrado em",
    "trace.rel.soldVia": "Vendido via",
    "trace.rel.sentOutUnlinked": "Enviado (sem vínculo)",
    "trace.rel.fedFromLot": "Veio do Lote",
    "trace.rel.fedFromUnit": "Veio da Unidade de Estoque",
    "trace.rel.mainOutput": "Saída principal",
    "trace.rel.byproduct": "Saída de subproduto",
    "trace.date.created": "Criado",
    "trace.date.shipped": "Enviado",
    "trace.date.purchased": "Comprado",
    "trace.date.produced": "Produzido",
    "trace.date.completed": "Concluído",
    "trace.date.started": "Iniciado",
    "trace.date.scheduled": "Agendado",
    "trace.date.openingStock": "Estoque inicial",
    "trace.story.showMore": "Mostrar mais",
    "trace.story.sharesNote": "Esta divisão é um cálculo (estoque mais antigo primeiro), não um fato registrado.",
    "trace.share.adjustment": "Madeira de um ajuste",
    "trace.share.hand": "Lote lançado à mão",
    "trace.label.printAll": "Imprimir etiquetas de todas as Unidades de Estoque",
    "trace.label.popup": "Permita pop-ups para imprimir as etiquetas.",
    "trace.unlinked.one": "Ainda não ligado a uma venda",
    "trace.unlinked.many": "{n} despachos ainda não ligados a uma venda",
    "trace.search.placeholder": "Busque um contêiner, BL, Unidade de Estoque, Lote ou Trabalho de Serraria…",
    "trace.search.none": "Nada encontrado",
    "trace.search.hintTitle": "Rastreie qualquer número",
    "trace.search.hintSub": "Digite acima um número de contêiner, BL, Unidade de Estoque, Lote ou Trabalho de Serraria para ver toda a sua história.",
    "trace.view.story": "História",
    "trace.view.graph": "Gráfico",
    "trace.story.cameFrom": "De onde veio",
    "trace.story.wentTo": "Para onde foi",
    "trace.story.nothingBefore": "Nada antes disto. A história começa aqui.",
    "trace.story.nothingAfter": "Nada depois disto ainda.",
    "trace.story.truncated": "Cadeia muito longa: só os passos mais próximos são mostrados. Abra um passo para ir mais longe.",
    "trace.story.madeFrom": "Feito de",
    "trace.story.couldNot": "Não foi possível carregar a história. Tente novamente.",
    "trace.kind.stockUnit": "Unidade de Estoque",
    "trace.kind.lot": "Lote",
    "trace.kind.millJob": "Trabalho de Serraria",
    "trace.kind.consignment": "Remessa",
    "trace.kind.sentOut": "Enviado",
    "trace.label.print": "Imprimir etiqueta",
    "trace.label.title": "Etiqueta da Unidade de Estoque",
    "trace.label.printBtn": "Imprimir",
    "trace.label.scan": "Escaneie para ver toda a história desta madeira",
    "trace.label.scanSub": "De onde veio, o que a serraria fez com ela e para onde foi.",
    "trace.couldNotLoad": "Não foi possível carregar este rastreio",
    "trace.pickAncestorTitle": "Qual deles?",
    "trace.pickAncestorHint": "Isso veio de mais de uma compra — escolha uma para explorar.",
    "trace.history": "Histórico",
    "trace.noHistory": "Nenhum histórico registrado ainda",
    "trace.consignment": "Consignação",
    "trace.viewConsignment": "Ver Consignação",
    "trace.viewDispatches": "Ver despachos",
    "trace.quickView": "Visualização rápida",
    "trace.loadingTrace": "Carregando...",
    "trace.zoomIn": "Aumentar zoom",
    "trace.zoomOut": "Diminuir zoom",
    "trace.zoomReset": "Redefinir zoom",
    "trace.viewLot": "Ver Lote",
    "trace.viewRun": "Ver Ordem de Serraria",
    "lot.lotCode": "Código do Lote",
    "lot.quality": "Qualidade",
    "lot.received": "Recebido",
    "lot.currentStock": "Estoque Atual",
    "lot.supplier": "Fornecedor",
    "lot.purchasePrice": "Preço de Compra",
    "lot.purchaseDate": "Data de Compra",
    "processing.millSite": "Local da Serraria",
    "processing.machine": "Máquina",
    "processing.operator": "Operador",
    "processing.input": "Entrada",
    "processing.output": "Saída",
    "processing.outturn": "Rendimento",
    "chain.sourceLot": "Lote de Origem",
    "chain.rootLot": "Origem Original",
    "chain.earlierLot": "Lote Anterior",
    "chain.thisLot": "Este Lote",
    "chain.outputLot": "Lote de Saída",
    "chain.recovery": "recuperação",
    "chain.received": "recebido",
    "chain.remaining": "disponível",
    "chain.dispatches": "Despachado",
    "chain.directDispatch": "Despacho Direto",
    "chain.noChain": "Nenhum vínculo upstream ou downstream para este lote ainda.",
    "chain.finished": "Concluído",
    "inventory.viewTask": "Ver Tarefa",
    "inventory.created": "Criado",
    "inventory.lastUpdated": "Última Atualização",
    "inventory.by": "por",
    "inventory.viewOrder": "Ver Pedido",
    "inventory.viewInTallysheet": "Ver na Folha de Contagem",
    // -- Manage users
    "user.invite": "Convidar Usuário",
    "user.sendInvite": "Enviar Convite",
    "user.teamMembers": "Membros da Equipe",
    "user.accessRights": "Direitos de Acesso",
    "user.deactivateTooltip": "Desativar — bloqueia login, dados preservados",
    "user.reactivateTooltip": "Reativar — restaurar acesso ao login",
    "user.resendInvitation": "Reenviar convite",
    "user.expired": "Expirado",
    "user.declined": "Recusado",
    "user.declinedTooltip": "O convidado recusou este convite no aplicativo — o link por e-mail ainda é válido caso mude de ideia",
    "user.membershipBasedTooltip": "Membro via acesso multiempresa — a conta dele existe em outro lugar. Você pode remover a associação dele nesta empresa, mas a conta em si é gerenciada do lado dele.",
    "user.removeFromCompany": "Remover da empresa",
    "user.confirmRemoveMemberTitle": "Remover Membro",
    "user.confirmRemoveMemberMessage": "{{email}} perderá o acesso a esta empresa. A conta dele e quaisquer outras empresas às quais pertence não são afetadas.",
    "user.memberRemovedTitle": "Membro removido",
    "user.memberRemovedMessage": "{{email}} não tem mais acesso a esta empresa.",
    "user.memberRemoveFailedMessage": "Falha ao remover membro.",
    "user.removeAdminBtn": "Remover Admin",
    "user.confirmMakeAdminTitle": "Tornar Admin",
    "user.confirmMakeAdminMessage": "{{email}} terá acesso total de administrador a esta empresa, incluindo gerir utilizadores. Pode remover mais tarde.",
    "user.madeAdminTitle": "Admin adicionado",
    "user.madeAdminMessage": "{{email}} agora é admin.",
    "user.makeAdminFailedMessage": "Não foi possível tornar este utilizador admin.",
    "user.confirmRemoveAdminTitle": "Remover Admin",
    "user.confirmRemoveAdminMessage": "{{email}} continuará na empresa como membro comum, mas perderá o acesso de administrador.",
    "user.removedAdminTitle": "Admin removido",
    "user.removedAdminMessage": "{{email}} agora é um membro comum.",
    "user.removeAdminFailedMessage": "Não foi possível remover os direitos de admin.",
    "user.emailAddresses": "Endereços de Email",
    "user.roleTemplate": "Modelo de Função",
    "user.roleTemplatePlaceholder": "Selecionar modelo de função",
    "user.inviteDialogHeader": "Convidar Usuário",
    "user.upgradeToAdd": "Limite de usuários atingido — faça upgrade do plano",
    "plan.featureNotAvailable": "Este recurso não está disponível no seu plano atual.",
    "plan.availableOnGroveAndAbove": "Disponível no Tree e acima. Faça upgrade para desbloquear.",
    "plan.upgradeNow": "Fazer Upgrade",
    // -- Auth flows
    "auth.sendResetLink": "Enviar Link de Redefinição",
    "auth.backToLogin": "Voltar ao Login",
    "auth.resetPassword": "Redefinir Senha",
    "auth.createMyAccount": "Criar Minha Conta",
    "auth.iAcceptClose": "Aceito e Fechar",
    "auth.tryDifferentEmail": "Tentar outro email",
    "auth.sessionExpired": "Sessão Expirada",
    "auth.sessionExpiredMessage": "Sua sessão foi encerrada por motivos de segurança. Faça login novamente para continuar de onde parou.",
    "auth.confirmLogout": "Confirmar Logout",
    "auth.logoutConfirmMessage": "Tem certeza que deseja sair?",
    "auth.logoutSuccess": "Logout Realizado",
    "auth.logoutSuccessMsg": "Você foi desconectado com sucesso.",
    "auth.logoutFailed": "Falha no logout",
    "auth.logoutFailedMsg": "Erro ao sair",
    "confirmLogoutDevices.header": "Já conectado em outro lugar",
    "confirmLogoutDevices.questionWithDevice": "Sair desse dispositivo e continuar entrando por aqui?",
    "confirmLogoutDevices.messageGeneric": "Sair dele e continuar entrando por aqui?",
    "confirmLogoutDevices.openApp": "Abrir o LumberLinq",
    "confirmLogoutDevices.openAppTitle": "Você entrou",
    "confirmLogoutDevices.openAppHint": "Toque no botão para voltar ao aplicativo.",
    "confirmLogoutDevices.messageWithDevicePrefix": "Você está atualmente conectado em ",
    "confirmLogoutDevices.messageWithDeviceNear": " perto de ",
    "confirmLogoutDevices.messageWithDeviceSuffix": ". Tem certeza de que deseja sair desse dispositivo e entrar por aqui?",
    "confirmLogoutDevices.acceptLabel": "Cancelar",
    "confirmLogoutDevices.rejectLabel": "Sair e continuar",
    "forcedLogout.header": "Sessão Encerrada",
    "forcedLogout.bodyGeneric": "Você foi desconectado porque sua conta entrou em outro dispositivo.",
    "forcedLogout.explanation": "Esta sessão foi encerrada porque sua conta acabou de entrar em outro dispositivo:",
    "forcedLogout.goToLogin": "Ir para Login",
    // -- Layout
    "layout.copyCompanyId": "Copiar ID da Empresa",
    "layout.productTour": "Tour do Produto",
    // -- Loading site documents
    "siteDocs.uploadDialogHeader": "Enviar Documentos",
    "siteDocs.upload": "Enviar",
    "siteDocs.downloadFile": "Baixar Arquivo",
    "siteDocs.changeCategory": "Clique para alterar categoria",
    // -- RBAC settings
    "rbac.enableAcl": "Ativar Controle de Acesso",
    "rbac.disableAcl": "Desativar Controle de Acesso",
    "rbac.title": "Controle de Acesso",
    "rbac.subtitle": "Controle exatamente o que cada usuário pode ver e fazer no LumberLinq.",
    "rbac.perUserStatus": "Controle de acesso por usuário está",
    "rbac.enabled": "ATIVADO",
    "rbac.disabled": "DESATIVADO",
    "rbac.disabledDesc": "Quando desativado, todos os usuários têm acesso total a tudo. Ative para atribuir permissões granulares por pessoa.",
    "rbac.enabledDesc": "Ativo — as permissões são aplicadas em tempo real. Revogar uma permissão entra em vigor na próxima chamada de API do usuário.",
    "rbac.userPermissions": "Permissões do Usuário",
    "rbac.configureHint": "Clique no botão de configuração para atribuir ou revogar permissões para cada usuário.",
    "rbac.permissions": "Permissões",
    "rbac.lastModified": "Última Modificação",
    "rbac.noPermissions": "Sem permissões — o usuário não pode acessar nada",
    "rbac.noUsers": "Nenhum usuário não administrador encontrado.",
    "rbac.notActiveTitle": "Controle de Acesso não está ativo",
    "rbac.notActiveDesc": "Quando ativado, você pode atribuir exatamente quais recursos cada usuário pode acessar.",
    "rbac.notActiveDesc2": "O comportamento existente é totalmente preservado até você ativar isto.",
    "rbac.disableFullAccess": "Todos os usuários recuperarão imediatamente acesso total a tudo.",
    "rbac.disablePreserved": "Suas configurações de permissão existentes são preservadas — elas serão reativadas automaticamente se você reativar o Controle de Acesso.",
    "rbac.configureTooltip": "Atribuir / revogar permissões",
    // -- Onboarding
    "onboarding.welcome": "Bem-vindo ao Lumberlinq",
    // -- Admin / root module
    "admin.packages": "Pacotes",
    "admin.subscriptionPackages": "Pacotes de Assinatura",
    "admin.packageListSubtitle": "Gerencie planos, preços e recursos visíveis aos clientes",
    "admin.totalPlans": "Total de Planos",
    "admin.trialPlans": "Planos de Teste",
    "admin.featured": "Em destaque",
    "admin.trial": "Teste",
    "admin.mostPopular": "Mais Popular",
    "admin.perMonth": "/mês",
    "admin.free": "Grátis",
    "admin.dayTrialSuffix": "dias de teste",
    "admin.features": "recursos",
    "admin.extendable": "Extensível",
    "admin.noPackagesYet": "Ainda não há pacotes",
    "admin.createFirstSubscriptionPackage": "Crie seu primeiro pacote de assinatura para começar.",
    "admin.coupons": "Cupons",
    "admin.taxConfig": "Config. Fiscal",
    "admin.companySupport": "Suporte à Empresa",
    "admin.tickets": "Tickets",
    "admin.appSettings": "Configurações do App",
    "admin.dashboard": "Painel Admin",
    "admin.newPackage": "Novo Pacote",
    "admin.savePackage": "Salvar Pacote",
    "admin.createPackage": "Criar Pacote",
    "admin.editPackage": "Editar Pacote",
    "admin.deactivate": "Desativar",
    "admin.activate": "Ativar",
    "admin.addFeature": "Adicionar Recurso",
    "admin.newCoupon": "Novo Cupom",
    "admin.saveCoupon": "Salvar Cupom",
    "admin.newTaxRule": "Nova Regra Fiscal",
    "admin.addFirstRule": "Adicionar Primeira Regra",
    "admin.extendSubscription": "Estender Assinatura",
    "admin.extend": "Estender",
    "admin.suspend": "Suspender",
    "admin.reactivate": "Reativar",
    "admin.printReport": "Imprimir Relatório",
    "admin.support": "Suporte",
    "admin.resolveAll": "Resolver Todos",
    "admin.closeAll": "Fechar Todos",
    "admin.assignAll": "Atribuir Todos",
    "admin.inProgress": "Em Andamento",
    "admin.awaitingUser": "Aguardando Usuário",
    "admin.resolve": "Resolver",
    "admin.saveChanges": "Salvar Alterações",
    "admin.resetFilters": "Redefinir filtros",
    "admin.clearSelection": "Limpar seleção",
    "admin.openSupportDashboard": "Abrir Painel de Suporte",
    "admin.hideFromListings": "Ocultar das listagens",
    "admin.makeVisible": "Tornar visível novamente",
    "admin.overview": "Visão Geral",
    "admin.ticketDetails": "Detalhes do Ticket",
    "admin.companyContext": "Contexto da Empresa",
    "admin.activityTrail": "Trilha de Atividade",
    "admin.valueExtracted": "Valor Extraído Neste Período",
    "admin.featureUsageBreakdown": "Detalhamento de Uso de Recursos",
    "admin.salesNarrative": "Narrativa de Vendas",
    "admin.loginTrend": "Tendência de Login (Semanal)",
    "admin.extendSubscriptionDialog": "Estender Assinatura",
    "admin.editPackageTooltip": "Editar detalhes, preços e recursos do pacote",
    "admin.autoGenerateKey": "Gerar chave automaticamente a partir do nome",
    "admin.inactivePackagesTooltip": "Pacotes inativos ficam ocultos na página pública de preços",
    "admin.trialPackagesTooltip": "Pacotes de teste são gratuitos e limitados no tempo.",
    "admin.removeAttachment": "Remover anexo",
    "admin.suspendAccount": "Suspender Conta",
    "admin.reactivateAccount": "Reativar Conta",
    "admin.unitLabelTooltip": "Rótulo da unidade exibido ao lado do número (ex: GB, usuários, tallies).",
    "admin.allowTrialExtension": "Permitir que super-admins estendam o trial para empresas individuais",
    "admin.maxTrialExtensions": "Número máximo de extensões de trial por empresa",
    "admin.descriptionTooltip": "Descrição rich text opcional. Renderizado como HTML no cartão do plano.",
    "admin.trialNoPricing": "Planos de teste não têm preço",
    "admin.discountedPriceTooltip": "O preço com desconto que os clientes realmente pagam por mês em INR",
    "admin.originalPriceTooltip": "O preço original exibido com tachado para mostrar economias",
    "admin.discountedMonthlyUsd": "Preço mensal com desconto em USD",
    "admin.totalYearlyUsd": "Preço anual total com desconto em USD",
    "admin.displayOrder": "Ordem de exibição no cartão de preços",
    "admin.editFeature": "Editar recurso",
    "admin.deleteFeature": "Excluir recurso",
    // -- Field access
    "fieldAccess.resetTooltip": "Redefinir todos para padrão",
    "fieldAccess.resetLabel": "Redefinir para Padrão",
    "fieldAccess.confirmResetTitle": "Redefinir para os padrões do LumberLinq?",
    "fieldAccess.confirmResetMessage": "Isso descartará todas as suas configurações personalizadas de acesso Público, Protegido e Privado para cada campo e restaurará a configuração padrão do LumberLinq. Esta ação não pode ser desfeita.",
    // -- App Usage Report
    "appUsage.planSubscription": "Plano e Assinatura",
    "appUsage.title": "Relatório de Uso do App",
    "appUsage.desc": "Visualização em tempo real do uso vs. limites do plano. Faça upgrade antes de atingir o limite.",
    "appUsage.failedToLoad": "Falha ao carregar dados de uso.",
    "appUsage.validTill": "Válido Até",
    "appUsage.timeRemaining": "Tempo Restante",
    "appUsage.nearLimit": "Próximo ao Limite",
    "appUsage.featureUsage": "Uso de Recursos",
    "appUsage.aiCredits": "Créditos de Importação IA",
    "appUsage.aiCreditsOf": "de",
    "appUsage.aiCreditsPageCredits": "créditos de página",
    "appUsage.featureAccess": "Acesso a Recursos",
    "appUsage.active": "Ativo",
    "appUsage.inactive": "Inativo",
    "appUsage.expiredOn": "Expirou em",
    "report.users.title": "Relatório de Usuários",
    "report.users.subtitle": "Todos os usuários registrados na sua organização",
    "report.users.admins": "Administradores",
    "report.users.role": "Função",
    "report.users.type": "Tipo",
    "report.users.timezone": "Fuso horário",
    "report.users.joined": "Ingressou",
    "report.users.noUsersFound": "Nenhum usuário encontrado",
    // -- Stock Unit form
    "tallysheet.createTransportUnit": "Criar unidade de estoque",
    "tallysheet.saveStartTally": "Salvar e iniciar a contagem",
    "su.editDetails": "Editar detalhes",
    "su.directionMoveShort": "Mover",
    "su.moreDetails": "Mais detalhes",
    "su.lessDetails": "Menos detalhes",
    "su.loadingTab": "Carregando…",
    "su.detailsTitle": "Detalhes da unidade de estoque",
    "su.allSaved": "Todas as alterações salvas",
    "su.unsaved": "Alterações não salvas",
    "su.saving": "Salvando…",
    "su.moreActions": "Mais ações",
    "su.receiveSub": "Inicia o controle do estoque.",
    "su.lockMenu": "Bloquear unidade de estoque",
    "su.lockSub": "Impede novas edições.",
    "su.deleteMenu": "Excluir unidade de estoque",
    "su.deleteSub": "Pede confirmação antes.",
    "su.appScreenOn": "Experimentar o layout estilo app",
    "su.appScreenOff": "Voltar ao layout clássico",
    "su.appScreenSub": "A grade ocupa a tela e o cabeçalho fica sempre visível",
    "su.auditMenu": "Auditoria de acesso por link",
    "su.auditSub": "Quem abriu esta unidade de estoque por um link compartilhado",
    "su.confirmOutSub": "Retira este estoque do inventário.",
    "su.notInInventory": "Fora do inventário",
    "su.inInventory": "No inventário",
    "su.sections": "Seções da unidade de estoque",
    "su.lockedTitle": "Salve a unidade de estoque para iniciar a contagem",
    "su.lockedSub": "Cada linha é guardada na unidade de estoque, por isso ela precisa do ID primeiro.",
    "su.lockedChip": "Bloqueada",
    "su.lockedPlaceholder": "Fotos, Resumo, Conciliação e Inventário também abrem aqui.",
    "su.newHint": "Preencha os detalhes e salve. A contagem abre assim que a unidade existir.",
    "su.newReady": "Unidade de estoque salva. A contagem está pronta.",
    "tallysheet.selectProduct": "Selecionar produto",
    "tallysheet.selectMode": "Selecionar modo",
    "tallysheet.selectLoadingSite": "Selecionar local",
    "tallysheet.searchProduct": "Pesquisar produto",
    "tallysheet.searchLoadingSite": "Pesquisar local",
    "tallysheet.tuIdRequired": "ID de transporte é obrigatório.",
    "tallysheet.tuIdDuplicate": "Este ID de transporte já existe.",
    "tallysheet.tuMinLength": "Mínimo 5 caracteres.",
    "tallysheet.productRequired": "Produto é obrigatório.",
    "tallysheet.modeRequired": "Modo é obrigatório.",
    "tallysheet.containerNumRequired": "Número do contêiner é obrigatório.",
    "tallysheet.vehicleNumRequired": "Número do veículo é obrigatório.",
    "tallysheet.driverNameRequired": "Nome do motorista é obrigatório.",
    "tallysheet.expectedDeliveryRequired": "Entrega esperada é obrigatória.",
    "tallysheet.expectedArrivalRequired": "Chegada esperada é obrigatória.",
    "tallysheet.expectedPickupRequired": "Hora de coleta esperada é obrigatória.",
    "tallysheet.pickupLocRequired": "Local de coleta é obrigatório.",
    "tallysheet.carNumRequired": "Número do vagão é obrigatório.",
    // -- Location list subtitle
    "loadingSite.subtitle": "Ver e gerenciar perfis de locais existentes",
    // -- Inventory Report page
    "invReport.available": "Disponível",
    "invReport.openLots": "Lotes Abertos (Disponível)",
    "invReport.lots": "lotes",
    "invReport.reserved": "reservado",
    "invReport.inProcessing": "Em ordem de serraria",
    "invReport.inShipment": "Em consignação",
    "invReport.shippedMonth": "Enviado (mês)",
    "invReport.cbmThisMonth": "CBM neste mês",
    "invReport.stockByStage": "Estoque por etapa",
    "invReport.movementsByType": "Movimentações por tipo",
    "invReport.stockBySite": "Estoque por local",
    "invReport.movementLog": "Registro de movimentações",
    "invReport.adjustments": "Ajustes",
    "invReport.processingRuns": "Ordens de Serraria",
    "invReport.filterByType": "Filtrar por tipo",
    "invReport.colType": "Tipo",
    "invReport.colTransportUnit": "Unidade de Estoque",
    "invReport.colSite": "Local",
    "invReport.colReference": "Referência",
    "invReport.colPartner": "Parceiro",
    "invReport.colDate": "Data",
    "invReport.colRunCode": "ID da Ordem de Serraria",
    "invReport.colMillSite": "Local da fábrica",
    "invReport.colInputCbm": "CBM entrada",
    "invReport.colOutputCbm": "CBM saída",
    "invReport.colLossCbm": "CBM perda",
    "invReport.colOutturn": "Rendimento %",
    "invReport.colCbmDelta": "CBM Δ",
    "invReport.colPcsDelta": "Pcs Δ",
    "invReport.colNotes": "Notas",
    "invReport.noMovements": "Nenhuma movimentação encontrada para os filtros selecionados.",
    "invReport.noProcessingRuns": "Nenhuma ordem de serraria encontrada.",
    "invReport.adjustmentsInfo": "Ajustes são correções manuais de CBM/peças em registros de inventário existentes. Mostrando ajustes dentro do período selecionado.",
    "invReport.noAdjustments": "Nenhum ajuste registrado neste período.",
    "invReport.noStageData": "Sem dados de etapa",
    "invReport.noMovementsRange": "Sem movimentações no período",
    "invReport.noSiteStockData": "Sem dados de estoque por local",
    "invReport.pendingCustomMadeTooltip": "Unidades de Estoque aguardando um pedido Custom-Made / re-serragem",
    // -- Business Partner form extras
    "business.activateDeactivate": "Ativar / Desativar Parceiro Comercial",
    "business.partnerActiveHint": "Parceiro ativo e visível em transações",
    "business.partnerInactiveHint": "Parceiro inativo e oculto de novas transações",
    "business.contactInfo": "Informações de contato",
    "business.addressSection": "Endereço",
    "business.attachments": "Anexos",
    "business.dropFiles": "Arraste arquivos aqui ou clique para navegar",
    "business.saveFirst": "Salve o parceiro primeiro para anexar arquivos",
    "business.maxPerFile": "por arquivo",
    "business.uploadedFiles": "Arquivos enviados",
    "business.removeAccount": "Remover conta",
    "business.ifscSwift": "IFSC / SWIFT",
    "business.noBankAccounts": "Nenhuma conta bancária adicionada ainda. Clique para adicionar.",
    "business.backToList": "Voltar à lista",
    "business.minCharsRequired": "Mínimo 2 caracteres necessários.",
    "business.validGstin": "Digite um GSTIN válido.",
    "business.taxIdMin3Chars": "O ID fiscal deve ter pelo menos 3 caracteres.",
    "business.gstin": "GSTIN",
    "business.quickAdd": "Adicionar novo parceiro comercial",
    "business.quickAddTitle": "Novo Parceiro Comercial",
    "business.quickAddedDetail": "Parceiro comercial criado e selecionado.",
    "business.quickAddError": "Não foi possível criar o parceiro comercial. Tente novamente.",
    "business.validEmail": "Email válido é obrigatório.",
    "business.countryRequired": "País é obrigatório.",
    "business.selectCountryFirst": "Selecione o país primeiro",
    "business.selectStateFirst": "Selecione o estado primeiro",
    "common.max": "Máx",
    "common.min": "Mín",
    "common.company": "Empresa",
    "chart.histogram": "Histograma",
    "chart.scatter": "Dispersão",
    "chart.line": "Linha",
    // -- Cookie consent (GDPR)
    "cookie.reject": "Rejeitar Não Essenciais",
    "cookie.manage": "Gerenciar",
    "cookie.acceptAll": "Aceitar Tudo",
    "cookie.savePreferences": "Salvar preferências",
    "cookie.preferences": "Preferências de Cookies e Privacidade",
    "cookie.title": "Usamos cookies 🍪",
    "cookie.desc": "Usamos cookies para mantê-lo conectado e melhorar sua experiência. Cookies analíticos exigem seu consentimento.",
    "cookie.gdprNote": "De acordo com GDPR / LGPD, ativamos cookies analíticos apenas com seu consentimento explícito.",
    "cookie.titleApp": "Usamos análise de dados 📊",
    "cookie.descApp": "Este aplicativo usa análise de dados para mantê-lo conectado e melhorar sua experiência. A análise de dados exige seu consentimento.",
    "cookie.gdprNoteApp": "De acordo com GDPR / LGPD, ativamos a análise de dados apenas com seu consentimento explícito.",
    "cookie.privacyLink": "Política de Privacidade",
    "cookie.essential": "Essenciais (Sempre Ativo)",
    "cookie.essentialDesc": "Necessários para login e segurança da sessão. Retenção: sessão + 7 dias. Não podem ser desativados.",
    "cookie.alwaysOn": "Sempre Ativo",
    "cookie.functional": "Funcionais",
    "cookie.functionalDesc": "Lembram idioma, tema e preferências de fonte. Retenção: 1 ano. Não podem ser desativados.",
    "cookie.analytics": "Analíticos (Google Analytics)",
    "cookie.analyticsDesc": "Usamos Google Analytics (GA4) para entender o uso de funcionalidades. O Google pode coletar seu endereço IP, localização aproximada (nível de cidade) e tipo de dispositivo. Processado pela Google LLC conforme sua Política de Privacidade. Nenhum dado pessoal é vendido. Retenção: 90 dias.",
    "cookie.dataController": "Controlador de Dados: Rikexim Private Limited · Processador de Dados: Google LLC (Google Analytics)",
    // -- Terms & misc
    "common.termsConditions": "Termos e Condições",
    "common.acceptContinue": "Aceitar e Continuar",
    // -- Missing common keys
    "common.back": "Voltar",
    "common.itemsSelected": "Itens Selecionados",
    "common.generalInformation": "Informações Gerais",
    "common.operationalDetails": "Detalhes Operacionais",
    "common.location": "Localização",
    "common.locationRequired": "Localização é obrigatória.",
    "common.pickupLocationRequired": "Local de coleta é obrigatório.",
    "common.operatingProfile": "Perfil Operacional",
    "common.profile": "Perfil",
    "common.paymentTerms": "Condições de Pagamento",
    "common.incoterms": "Incoterms",
    "common.billNo": "Nº da Fatura",
    "common.billOfLadingNo": "Nº do Conhecimento de Embarque",
    "common.billNumberRequired": "Número da fatura é obrigatório",
    "common.requiredForExport": "Obrigatório para exportação",
    "common.ewaybillLrFile": "E-Waybill / Arquivo LR",
    "common.billFile": "Arquivo de Fatura",
    "common.blFile": "Arquivo BL",
    "common.totalUsers": "Total de usuários",
    "common.configured": "Configurados",
    "common.noAccess": "Sem acesso",
    "common.avgCoverage": "Cobertura média",
    // -- Tallysheet Insights section
    "tallysheet.insights": "Insights do Tallysheet",
    "tallysheet.totalVolume": "Volume Total",
    "tallysheet.avgVolume": "Volume Médio",
    "tallysheet.activeFilter": "Filtro Ativo",
    "tallysheet.clearFilter": "Limpar Filtro",
    "tallysheet.totalCft": "CFT Total",
    "tallysheet.aggregated": "Agregado",
    "tallysheet.mainVisualization": "Visualização Principal",
    "tallysheet.girthVsVolume": "Circunferência vs Volume",
    "tallysheet.lengthDistribution": "Distribuição de Comprimento",
    "tallysheet.girthHistogram": "Tabela de Histograma de Circunferência",
    "tallysheet.lengthHistogram": "Tabela de Histograma de Comprimento",
    "tallysheet.metric": "Métrica",
    "tallysheet.inProcessTooltip": "Este estoque está sendo usado por uma ordem de serraria ativa agora.",
    "tallysheet.notInStock": "Não em Estoque",
    "tallysheet.notInStockTooltip": "Esta unidade de estoque ainda não foi recebida no estoque.",
    "tallysheet.noSummary": "Nenhum Resumo Disponível",
    "tallysheet.addDataForInsights": "Adicione dados de tally primeiro para gerar insights e visualizações.",
    "tallysheet.dynamicAnalytics": "Análises Dinâmicas — Comprimento · Circunferência · Volume",
    "tallysheet.exploreTrends": "Explore tendências em",
    "tallysheet.optimizedRecords": "registros otimizados",
    "tallysheet.clickRangesToFilter": "Clique nos intervalos para filtrar",
    "tallysheet.bins": "faixas",
    // -- Stock Unit field labels
    "tallysheet.vehicleNumber": "Número do Veículo",
    "tallysheet.driverName": "Nome do Motorista",
    "tallysheet.enterDriverName": "Digite o Nome do Motorista",
    "tallysheet.containerNumber": "Número do Contêiner",
    "tallysheet.sealNumber": "Número do Lacre",
    "tallysheet.fumigationType": "Tipo de Fumigação",
    "tallysheet.selectFumigationType": "Selecione um Tipo de Fumigação",
    "fumigation.methylBromide": "Fumigação com Brometo de Metila",
    "fumigation.phosphine": "Fumigação com Fosfina",
    "fumigation.sulfurylFluoride": "Fumigação com Fluoreto de Sulfurila",
    "fumigation.ethyleneOxide": "Fumigação com Óxido de Etileno",
    "fumigation.heatTreatment": "Tratamento Térmico",
    "fumigation.controlledAtmosphere": "Fumigação em Atmosfera Controlada (CA)",
    "fumigation.vacuum": "Fumigação a Vácuo",
    "fumigation.other": "Outro",
    "tallysheet.carNumber": "Número do Vagão",
    "tallysheet.railwayLine": "Linha Ferroviária",
    "tallysheet.selectDate": "Selecionar Data",
    "tallysheet.selectDateTime": "Selecionar Data e Hora",
    "tallysheet.expectedArrival": "Chegada Prevista",
    "tallysheet.pickupLocation": "Local de Coleta",
    // -- Business Partner dropdown options
    "bp.buyer": "Comprador",
    "bp.seller": "Vendedor",
    "bp.both": "Ambos",
    "bp.company": "Empresa",
    "bp.individual": "Individual",
    "bp.exporter": "Exportador",
    "bp.importer": "Importador",
    "bp.domestic": "Doméstico",
    "bp.international": "Internacional",
    // -- Dashboard chart trade type labels
    "dash.domesticSale": "Venda Doméstica",
    // -- Loading site
    "loading-site.selectSiteType": "Selecionar tipo de local",
    // -- Reconciliation
    "recon.locked": "Reconciliação Bloqueada",
    "recon.lockedBy": "Reconciliação bloqueada por",
    // -- Shipment form - existing en keys now added to pt
    "shipment.coreDetailsShort": "Detalhes Principais",
    "shipment.consignmentInfo": "Informações de Consignação",
    "shipment.documents": "Documentos",
    "shipment.financialsPaymentsHtml": "Financeiro e Pagamentos",
    "shipment.localAuditSpaced": "Local / Auditoria",
    "shipment.localAudit": "Local/Auditoria",
    // -- Field Access pages
    "fieldAccess.accessControl": "Controle de Acesso",
    "fieldAccess.tallyTitle": "Acesso a Campos da Unidade de Estoque",
    "fieldAccess.shipmentTitle": "Acesso de Campos da Consignação",
    "fieldAccess.searchPlaceholder": "Pesquisar campos…",
    "fieldAccess.pubLegend": "Qualquer pessoa com o link",
    "fieldAccess.proLegend": "Apenas usuários LumberLinq",
    "fieldAccess.priLegend": "Apenas minha equipe",
    "fieldAccess.mode.PUBLIC": "Qualquer pessoa com o link",
    "fieldAccess.mode.PROTECTED": "Apenas usuários LumberLinq",
    "fieldAccess.mode.PRIVATE": "Apenas minha equipe",
    "access.hint.PUBLIC": "Sem necessidade de login",
    "access.hint.PROTECTED": "Com login no LumberLinq, qualquer empresa",
    "access.hint.PRIVATE": "Somente pessoas da sua empresa",
    "fieldAccess.privateAlways": "Sua empresa — sempre vê todos os campos",
    "fieldAccess.hidden": "Oculto",
    "fieldAccess.view": "Visualizar",
    "fieldAccess.alwaysVisible": "Sempre visível",
    "fieldAccess.alwaysVisibleHint": "Esta coluna é sempre mostrada nos links compartilhados. Não pode ser ocultada.",
    "fieldAccess.history": "Histórico",
    "fieldAccess.historyTitle": "Quem alterou o quê",
    "fieldAccess.historyEmpty": "Nenhuma alteração registrada ainda.",
    "fieldAccess.historyFailed": "Não foi possível carregar o histórico.",
    "fieldAccess.historyWhen": "Quando",
    "fieldAccess.historyWho": "Quem",
    "fieldAccess.historyField": "Campo",
    "fieldAccess.historyMode": "Tipo de link",
    "fieldAccess.historyChange": "Alteração",
    "fieldAccess.historyReset": "Redefinir para o padrão",
    "fieldAccess.historyNote": "Mostra as últimas 200 alterações. Alterações feitas antes desta lista existir não aparecem.",
    "fieldAccess.preview": "Pré-visualizar como visitante",
    "fieldAccess.previewTitle": "O que um visitante vê",
    "fieldAccess.previewHint": "Baseado nas configurações desta tela. Campos riscados ficam ocultos para este tipo de visitante.",
    "fieldAccess.previewVisibleCount": "campos visíveis",
    "fieldAccess.previewSectionOff": "Esta seção inteira está desativada.",
    "fieldAccess.presets": "Predefinições",
    "fieldAccess.presetsTitle": "Aplicar uma predefinição",
    "fieldAccess.presetsLead": "Comece de um conjunto pronto em vez de alterar os campos um a um. Você vê o que muda antes de salvar. Campos de dinheiro, impostos e auditoria, e o fornecedor e o comprador, nunca são ativados por uma predefinição.",
    "fieldAccess.presetMinimal": "Público (mínimo)",
    "fieldAccess.presetMinimalHint": "Apenas status, rota e quantidades. Seguro para qualquer pessoa com o link.",
    "fieldAccess.presetBuyer": "Comprador",
    "fieldAccess.presetBuyerHint": "Adiciona documentos, partes e dados de transporte de que um comprador precisa.",
    "fieldAccess.presetAgent": "Agente",
    "fieldAccess.presetAgentHint": "Adiciona contatos, locais e dados do romaneio para um agente de carga.",
    "fieldAccess.presetApplyTo": "Aplicar a",
    "fieldAccess.presetApply": "Aplicar predefinição",
    "fieldAccess.presetNoChange": "Esta predefinição não altera nada para o tipo de link escolhido.",
    "fieldAccess.presetWillShow": "{count} campo(s) serão exibidos:",
    "fieldAccess.presetWillHide": "{count} campo(s) serão ocultados:",
    "fieldAccess.presetPublicWarning": "Atenção: {count} campo(s) ficarão visíveis para qualquer pessoa com o link, sem login.",
    "fieldAccess.publicWarnTitle": "Mostrar para todos?",
    "fieldAccess.publicWarnMessage": "Qualquer pessoa com o link, sem fazer login, verá \"{field}\". Continuar?",
    "fieldAccess.publicWarnAccept": "Sim, mostrar",
    "tallysheet.tu.hiddenDetails": "Alguns detalhes não são compartilhados neste link.",
    "tallysheet.exportDownloadOff": "Exportar (download desativado)",
    "tallysheet.exportDownloadOffHint": "O remetente não permitiu downloads neste link.",
    "sharePack.button": "Baixar pacote",
    "sharePack.title": "Baixar pacote",
    "sharePack.lead": "Tudo o que este link contém, em um único ZIP: PDF de resumo, planilha Excel, documentos e fotos.",
    "sharePack.loading": "Verificando o que há dentro…",
    "sharePack.partSummary": "PDF de resumo",
    "sharePack.partSummaryHint": "Uma visão geral para ler e imprimir",
    "sharePack.partWorkbook": "Planilha Excel",
    "sharePack.partWorkbookHint": "Todos os números, prontos para filtrar",
    "sharePack.partDocuments": "Documentos",
    "sharePack.partDocumentsHint": "{count} arquivo(s) · {size}",
    "sharePack.partPhotos": "Fotos",
    "sharePack.partPhotosHint": "{count} foto(s) · {size}",
    "sharePack.noneInside": "Não há nada para baixar neste link.",
    "sharePack.snapshotNote": "Um retrato de hoje. Alterações posteriores do remetente não estão incluídas.",
    "sharePack.stockUnits": "{count} Unidade(s) de Estoque",
    "sharePack.start": "Baixar",
    "sharePack.preparing": "Preparando seu pacote. Um pacote grande pode levar um minuto.",
    "sharePack.downloading": "Baixando {percent}%",
    "sharePack.done": "Seu pacote foi baixado.",
    "sharePack.failed": "Não foi possível baixar o pacote.",
    "sharePack.busy": "O servidor está ocupado criando outros pacotes. Tente novamente em um minuto.",
    "sharePack.pickOne": "Escolha pelo menos uma parte.",
    "sharePack.close": "Fechar",
    "sharePack.reconciliationField": "Números de conciliação no pacote para download (carregado vs recebido)",
    "fileCounts.ownTitle": "Documentos da consignação",
    "fileCounts.ofTypes": "{have} de {total} tipos",
    "fileCounts.missing": "falta",
    "fileCounts.unitsTitle": "Unidades de Estoque ({count})",
    "fileCounts.photos": "fotos",
    "fileCounts.files": "arquivos",
    "fileCounts.unitTitle": "Arquivos desta Unidade de Estoque",
    "fileCounts.noFiles": "Ainda não há arquivos.",
    "fileCounts.tipOwn": "{count} arquivo(s) da consignação",
    "fileCounts.tipUnits": "Unidades de Estoque: {photos} foto(s), {files} arquivo(s)",
    "fileCounts.typeBL": "BL",
    "fileCounts.typeInvoice": "Fatura",
    "fileCounts.typeCO": "Certificado de Origem",
    "fileCounts.typePhyto": "Fitossanitário",
    "fileCounts.typeEWaybill": "E-Waybill",
    "fileCounts.typeOther": "Outro",
    "fieldAccess.viewOnly": "Apenas Visualizar",
    "fieldAccess.edit": "Editar",
    "fieldAccess.editable": "Editável",
    "fieldAccess.loading": "Carregando configuração de campos…",
    "fieldAccess.fields": "campos",
    "fieldAccess.stockUnitsNote": "Os detalhes da Unidade de Estoque em um link compartilhado são definidos em Acesso a Campos da Unidade de Estoque, não aqui.",
    "fieldAccess.fieldColumn": "Campo",
    "fieldAccess.noMatch": "Nenhum campo corresponde à sua pesquisa.",
    "fieldAccess.group.transportUnit": "Unidade de Estoque",
    "fieldAccess.group.roundTallyGrid": "Grade de Tally Redondo",
    "fieldAccess.group.squareTallyGrid": "Grade de Tally Quadrado",
    "fieldAccess.group.photosSummary": "Fotos e Resumo",
    "fieldAccess.group.shipmentDetails": "Detalhes da Consignação",
    "fieldAccess.group.documentDetails": "Detalhes do Documento",
    "fieldAccess.group.transportCargo": "Transporte / Carga",
    "fieldAccess.group.financials": "Financeiro",
    "fieldAccess.group.parties": "Partes",
    "fieldAccess.group.systemAudit": "Sistema / Auditoria",
    "fieldAccess.field.transportId": "ID do Transporte",
    "fieldAccess.field.transportMode": "Modo de Transporte",
    "fieldAccess.field.unitVehicleNumber": "Unidade / Número do Veículo",
    "fieldAccess.field.fumigation": "Fumigação",
    "fieldAccess.field.driver": "Motorista",
    "fieldAccess.field.route": "Rota",
    "fieldAccess.field.contactPerson": "Pessoa de Contato",
    "fieldAccess.field.expectedDelivery": "Entrega / Coleta Esperada",
    "fieldAccess.field.sr": "Nº",
    "fieldAccess.field.length": "Comprimento",
    "fieldAccess.field.girth": "Circunferência",
    "fieldAccess.field.lengthAllowance": "Tolerância de Comprimento",
    "fieldAccess.field.girthAllowance": "Tolerância de Circunferência",
    "fieldAccess.field.netLength": "Comprimento Líquido",
    "fieldAccess.field.netGirth": "Circunferência Líquida",
    "fieldAccess.field.grossCbm": "CBM Bruto",
    "fieldAccess.field.grossCft": "CFT Bruto",
    "fieldAccess.field.netCbm": "CBM Líquido",
    "fieldAccess.field.netCft": "CFT Líquido",
    "fieldAccess.field.width": "Largura",
    "fieldAccess.field.thickness": "Espessura",
    "fieldAccess.field.pieces": "Peças",
    "fieldAccess.field.widthAllowance": "Tolerância de Largura",
    "fieldAccess.field.thicknessAllowance": "Tolerância de Espessura",
    "fieldAccess.field.netWidth": "Largura Líquida",
    "fieldAccess.field.netThickness": "Espessura Líquida",
    "fieldAccess.field.photosDocuments": "Fotos / Documentos",
    "fieldAccess.field.summary": "Resumo",
    "fieldAccess.field.chartData": "Dados do Gráfico",
    "fieldAccess.field.lengthHistogram": "Histograma de Comprimento",
    "fieldAccess.field.girthHistogram": "Histograma de Circunferência",
    "fieldAccess.field.sawnSquareSummary": "Resumo de Madeira Serrada Quadrada",
    "fieldAccess.field.modeOfTransportFmt": "Modo De Transporte",
    "fieldAccess.field.portOfLoadingFmt": "Porto De Carregamento",
    "fieldAccess.field.portOfDischargeFmt": "Porto De Descarga",
    "fieldAccess.field.blNumberFmt": "Número BL",
    "fieldAccess.field.blType": "Tipo BL",
    "fieldAccess.field.packingListNo": "Nº da Lista de Embalagem",
    "fieldAccess.field.commercialInvoiceNo": "Nº da Fatura Comercial",
    "fieldAccess.field.certificateOfOrigin": "Certificado De Origem",
    "fieldAccess.field.fumigationCertificate": "Certificado de Fumigação",
    "fieldAccess.field.insuranceDetails": "Detalhes do Seguro",
    "fieldAccess.field.approvedBy": "Aprovado por",
    "fieldAccess.field.buyerTaxNumber": "Número fiscal do comprador",
    "fieldAccess.field.createdBy": "Criado por",
    "fieldAccess.field.deliveryContact": "Contato de entrega",
    "fieldAccess.field.transporterName": "Nome do transportador",
    "fieldAccess.field.vehicleOrLrNo": "Veículo ou Nº LR",
    "fieldAccess.field.transportUnitNumber": "Número da unidade de estoque",
    "fieldAccess.field.insuranceValue": "Valor do seguro",
    "fieldAccess.field.cargoType": "Tipo de Carga",
    "fieldAccess.field.grossWeight": "Peso Bruto",
    "fieldAccess.field.netWeight": "Peso Líquido",
    "fieldAccess.field.transportUnits": "Unidades de Estoque",
    "fieldAccess.field.freightTerms": "Termos de Frete",
    "fieldAccess.field.totalInvoiceAmount": "Valor Total da Fatura",
    "fieldAccess.field.salesPaymentStatus": "Status de Pagamento de Vendas",
    "fieldAccess.field.purchasePaymentStatus": "Status de Pagamento de Compras",
    "fieldAccess.field.notifyParty": "Parte Notificada",
    "fieldAccess.field.exporterRefNo": "Nº de Referência do Exportador",
    "fieldAccess.field.buyerOrderNo": "Nº do Pedido do Comprador",
    "fieldAccess.field.countryOfOrigin": "País De Origem",
    "fieldAccess.field.countryOfDestination": "País De Destino",
    "fieldAccess.field.fromLocation": "De Localização",
    "fieldAccess.field.toLocation": "Para Localização",
    "fieldAccess.field.remarks": "Observações",
    "fieldAccess.field.vesselOrFlight": "Navio Ou Voo",
    "fieldAccess.field.voyageOrFlightNo": "Nº da Viagem Ou Voo",
    "fieldAccess.field.shippingLine": "Linha de Navegação",
    // -- Manage Users page
    "user.member": "Membro",
    "user.role": "Função",
    "user.login": "Login",
    "user.lastActive": "Último Acesso",
    "user.totalMembers": "Total de Membros",
    "user.pendingInvites": "Convites Pendentes",
    "user.pendingInvitations": "Convites Pendentes",
    "user.invitedBy": "Convidado por",
    "user.noTeamMembers": "Ainda não há membros na equipe",
    "user.inviteToStart": "Clique em Convidar Usuário para começar.",
    "user.statusPending": "Pendente",
    "user.expires": "Expira",
    "user.role.owner": "Proprietário",
    "user.role.user": "Usuário",
    "user.role.fieldOperator": "Operador de Campo — Adicionar e visualizar tally",
    "user.role.supervisor": "Supervisor — Tally + Consignações + Exportar",
    "user.role.analyst": "Analista — Visualizar e exportar tudo, sem edições",
    "user.role.manager": "Gerente — Todos os recursos exceto gestão de usuários",
    "user.role.custom": "Personalizado — Sem permissões (configurar manualmente)",
    "user.selfDeleteTitle": "Excluir Minha Conta",
    "user.selfDeleteSubtitle": "Exclua permanentemente sua conta pessoal e todos os dados associados.",
    "user.selfDeleteWarning": "Esta ação revogará IMEDIATAMENTE todas as suas sessões ativas e excluirá permanentemente sua conta.\n\n• Todos os dados que você criou (tallies, consignações, unidades de estoque) permanecerão no sistema.\n• Após 30 dias, seus detalhes pessoais (nome, e-mail, telefone) serão anonimizados e não poderão ser recuperados.\n• Esta ação NÃO pode ser desfeita.",
    "user.selfDeleteEmailConfirm": "Digite seu endereço de e-mail para confirmar",
    "user.selfDeleteEmailPlaceholder": "Digite seu e-mail para confirmar",
    "user.selfDeleteButton": "Excluir Minha Conta",
    "user.selfDeleteSuccess": "Sua conta foi excluída. Você foi desconectado.",
    "user.selfDeleteFailed": "Não foi possível excluir sua conta. Por favor, tente novamente.",
    "user.soleAdminWarningTitle": "Você é o Único Administrador",
    "user.soleAdminWarningBody": "Excluir sua conta encerrará permanentemente o espaço de trabalho da sua empresa. Todos os usuários serão desconectados imediatamente.",
    "user.soleAdminAffectedLabel": "Usuários que perderão acesso",
    "user.soleAdminReassignHint": "Recomendado: atribua direitos de administrador a outro usuário antes de excluir sua conta.",
    "user.soleAdminReassignButton": "Atribuir Admin Primeiro",
    "user.soleAdminDeleteAnyway": "Excluir Mesmo Assim e Encerrar",
    "user.soleAdminShutdownWarning": "Isso desconectará imediatamente todos os usuários da empresa.",
    "user.soleAdminShutdownSuccess": "Sua conta foi excluída. Todos os usuários da empresa foram desconectados.",
    "user.assignAdminStepTitle": "Atribuir Novo Admin",
    "user.assignAdminSubtitle": "Selecione um membro da equipe para assumir como administrador antes de sair.",
    "user.makeAdminBtn": "Tornar Admin",
    "user.adminAssignedSuccess": "Direitos de admin transferidos. Agora você pode excluir sua conta.",
    "user.continueToDelete": "Continuar para Excluir Conta",
    "user.shutdownConsentLabel": "Entendo que todos os usuários serão desconectados imediatamente, o espaço de trabalho da empresa será encerrado e a assinatura expirará.",
    "user.deleteAndShutdown": "Excluir e Encerrar Empresa",
    "user.noOtherUsers": "Não há outros usuários ativos para atribuir direitos de admin.",
    "user.promotingAdmin": "Atribuindo admin…",
    "user.notificationPreferencesTitle": "Preferências de Notificação",
    "user.marketingPushOptInLabel": "Notificações de marketing",
    "user.marketingPushOptInDescription": "Receba notificações sobre novos recursos e ofertas.",
    "user.dangerZoneTitle": "Zona de Perigo",
    "user.dangerZoneSubtitle": "Ações irreversíveis e destrutivas.",
    // -- Shipment form new keys
    "shipment.shipmentType": "Tipo de Consignação",
    "shipment.modeOfTransport": "Modo de Transporte",
    "shipment.shipmentDate": "Data da Consignação",
    "shipment.finalDestination": "Destino Final",
    "shipment.estimatedDeparture": "Partida Estimada",
    "shipment.estimatedArrival": "Chegada Estimada",
    "shipment.partiesReferences": "Partes e Referências",
    "shipment.documentNumbers": "Números de Documentos",
    "shipment.invoicePayments": "Fatura e Pagamentos",
    "shipment.auditStatus": "Auditoria e Status",
    "shipment.goodsDispatchLocal": "Mercadorias / Despacho (Local)",
    "shipment.shipmentTypeRequired": "Tipo de consignação é obrigatório",
    "shipment.modeOfTransportRequired": "Modo de transporte é obrigatório",
    "shipment.estimatedDepartureRequired": "Partida estimada é obrigatória",
    "shipment.otherDocuments": "Outros Documentos",
    // -- Transport mode groups
    "transport.group.regularSizedCargo": "Carga de Tamanho Regular",
    "transport.group.reeferContainer": "Contêiner Refrigerado",
    "transport.group.oddSizedContainer": "Contêiner de Tamanho Irregular",
    "transport.group.truck": "Caminhão",
    "transport.group.trailer": "Reboque",
    "transport.group.train": "Trem",
    "transport.group.other": "Outro",
    // -- Transport mode items
    "transport.item.20DryStandard": "20 Seco Padrão",
    "transport.item.40DryStandard": "40 Seco Padrão",
    "transport.item.40DryHigh": "40 Seco Alto",
    "transport.item.45DryHigh": "45 Seco Alto",
    "transport.item.20Tank": "20 Tanque",
    "transport.item.40Tank": "40 Tanque",
    "transport.item.20ReeferStandard": "20 Refrigerado Padrão",
    "transport.item.40ReeferHigh": "40 Refrigerado Alto",
    "transport.item.20OpenTop": "20 Topo Aberto",
    "transport.item.40OpenTop": "40 Topo Aberto",
    "transport.item.40OpenTopHigh": "40 Topo Aberto Alto",
    "transport.item.40FlatStandard": "40 Plataforma Padrão",
    "transport.item.40FlatHigh": "40 Plataforma Alta",
    "transport.item.20Flat": "20 Plataforma",
    "transport.item.smallTruck": "Caminhão Pequeno",
    "transport.item.mediumTruck": "Caminhão Médio",
    "transport.item.largeTruck": "Caminhão Grande",
    "transport.item.articulatedTruck": "Caminhão Articulado",
    "transport.item.flatbedTrailer": "Reboque Plataforma",
    "transport.item.dryVanTrailer": "Reboque Seco",
    "transport.item.reeferTrailer": "Reboque Refrigerado",
    "transport.item.lowboyTrailer": "Reboque Lowboy",
    "transport.item.tankerTrailer": "Reboque Tanque",
    "transport.item.boxcar": "Vagão Fechado",
    "transport.item.flatcar": "Vagão Plataforma",
    "transport.item.tankCar": "Vagão Tanque",
    "transport.item.reeferCar": "Vagão Refrigerado",
    "transport.item.hopperCar": "Vagão Tremonha",
    "transport.item.selfPickup": "Coleta Própria",
    "BOTH": "Ambos",
    "COMPANY": "Empresa",
    "Invoice Details": "Detalhes da fatura",
    "Freight Terms": "Termos de frete",
    "Payment Terms": "Termos de pagamento",
    "Customer Payment Terms": "Termos de pagamento do cliente",
    "Supplier Payment Terms": "Termos de pagamento do fornecedor",
    "Select terms...": "Selecione os termos...",
    "Save the shipment first to record payments and payment terms.": "Salve a consignação primeiro para registrar pagamentos e termos de pagamento.",
    "At least one of Shipper, Consignee or Notify Party must be your company. Based on shipment type, your company may be auto-filled and locked.": "Pelo menos um entre Shipper, Consignee ou Notify Party deve ser a sua empresa. Conforme o tipo de consignação, sua empresa pode ser preenchida automaticamente e bloqueada.",
    "Manage shipment details, parties, documents &amp; financials": "Gerencie detalhes da consignação, partes, documentos e informações financeiras",
    "Financials &amp; Payments": "Financeiro e pagamentos",
    "Invoice &amp; Payments": "Fatura e pagamentos",
    "Immediate / Advance": "Imediato / antecipado",
    "Cash on Delivery (COD)": "Pagamento na entrega (COD)",
    "L/C – Sight": "L/C – à vista",
    "L/C – Usance (days)": "L/C – usance (dias)",
    "DP – Documents against Payment (days)": "DP – documentos contra pagamento (dias)",
    "DA – Documents against Acceptance (days)": "DA – documentos contra aceite (dias)",
    "Open Account (days)": "Conta aberta (dias)",
    "Net 7 Days": "Líquido 7 dias",
    "Net 15 Days": "Líquido 15 dias",
    "Net 30 Days": "Líquido 30 dias",
    "Net 45 Days": "Líquido 45 dias",
    "Net 60 Days": "Líquido 60 dias",
    "Net 90 Days": "Líquido 90 dias",
    "Other (Custom)": "Outro (personalizado)",
    "Timezone": "Fuso horário",
    "Your Timezone": "Seu fuso horário",
    "Select timezone": "Selecione o fuso horário",
    "Timestamps throughout the app will display in this timezone.": "Os horários em todo o app serão exibidos neste fuso horário.",
    "Asia/Kolkata (IST, UTC+5:30)": "Asia/Kolkata (IST, UTC+5:30)",
    "Trial": "Teste",
    "Trial 7 days": "Teste de 7 dias",
    "Subscription expired. Limited access": "Assinatura expirada. Acesso limitado",
    "Transaction History": "Histórico de transações",
    "Start Date": "Data inicial",
    "End Date": "Data final",
    "Transaction ID": "ID da transação",
    "Choose Your Plan": "Escolha seu plano",
    "Select the plan that best fits your needs": "Selecione o plano que melhor atende às suas necessidades",
    "Company Profile": "Perfil da empresa",
    "Your Company Profile": "Perfil da sua empresa",
    "Company Profile Management": "Gerenciamento do perfil da empresa",
    "Registering as an individual": "Registrando como pessoa física",
    "Set up company identity, address, and operating profile": "Configure a identidade, endereço e perfil operacional da empresa",
    "Legal Entity Type": "Tipo de entidade legal",
    "Select Legal Entity of Company": "Selecione a entidade legal da empresa",
    "Private Limited": "Sociedade limitada privada",
    "Public Limited": "Sociedade anônima",
    "Partnership": "Parceria",
    "Proprietorship": "Empresa individual",
    "Corporation (Inc)": "Corporação (Inc)",
    "LLP": "LLP",
    "LLC": "LLC",
    "Branding": "Marca",
    "Brand Identity": "Identidade da marca",
    "Use a direct image URL. The default RIK Exim logo is used when this field is empty.": "Use uma URL direta da imagem. O logo padrão da RIK Exim será usado quando este campo estiver vazio.",
    "Buyer Tax Number": "Número fiscal do comprador",
    "Round Log": "Tora redonda",
    "Square / Sawn": "Quadrada / serrada",
    "For round, unprocessed logs. Uses the Hoppus formula: (girth ÷ 4)² × length.": "Para toras redondas, não processadas. Usa a fórmula Hoppus: (circunferência ÷ 4)² × comprimento.",
    "For square or sawn timber. Uses volumetric formula: length × width × height.": "Para madeira quadrada ou serrada. Usa a fórmula volumétrica: comprimento × largura × altura.",
    "Formula guide": "Guia de fórmulas",
    "Tax Number": "Número fiscal",
    "Available": "Disponível",
    "In Process": "Em ordem de serraria",
    "In Shipment": "Em consignação",
    "Shipped": "Enviado",
    "Stock by Location": "Estoque por local",
    "sites": "locais",
    "TUs": "Unidades de Estoque",
    "Filtered": "Filtrado",
    "At Forest": "Na floresta",
    "In Transit": "Em trânsito",
    "At Mill": "Na serraria",
    "At Yard": "No pátio",
    "AVAILABLE": "Disponível",
    "IN_PROCESS": "Em ordem de serraria",
    "PROCESSED": "Serrado",
    "IN_SHIPMENT": "Em consignação",
    "SHIPPED": "Enviado",
    "COMPLETED": "Concluído",
    "Completed": "Concluído",
    "ROUND": "Redondo",
    "SQUARE": "Quadrado",
    "All": "Todos",
    "IN": "Entrada",
    "OUT": "Saída",
    "Proc IN": "Enviado à serraria",
    "Proc OUT": "Feito pela serraria",
    "Adjustment": "Ajuste",
    "Received": "Recebido",
    "Dispatched": "Despachado",
    "Sold": "Vendido",
    "New Processing Run": "Nova Ordem de Serraria",
    "Theme": "Tema",
    "Lara Light Blue": "Lara azul claro",
    "Lara Dark Blue": "Lara azul escuro",
    "Lara Light Indigo": "Lara índigo claro",
    "Lara Dark Indigo": "Lara índigo escuro",
    "Bootstrap Light": "Bootstrap claro",
    "Bootstrap Dark": "Bootstrap escuro",
    "Saga Blue": "Saga azul",
    "Vela Blue (Dark)": "Vela azul (escuro)",
    "Material Light": "Material claro",
    "Arya Blue (Dark)": "Arya azul (escuro)",
    "YARD": "Pátio",
    "FOREST": "Floresta",
    "MILL": "Serraria",
    "PORT": "Porto",
    "WAREHOUSE": "Armazém",
    "common.previous": "Anterior",
    // -- Payment / Checkout
    "pay.secureCheckout": "Checkout Seguro",
    "pay.completeSubscription": "Conclua Sua Assinatura",
    "pay.oneStepAway": "Você está a um passo de desbloquear o acesso completo ao LumberLinq",
    "pay.stepPlanSelected": "Plano Selecionado",
    "pay.stepAccountSetup": "Configuração da Conta",
    "pay.stepPayment": "Pagamento",
    "pay.billingDetails": "Dados de Faturamento",
    "pay.billingDetailsDesc": "Essas informações aparecerão na sua fatura",
    "pay.optional": "Opcional",
    "pay.taxIdHint": "Recomendado para emissão correta de nota fiscal.",
    "pay.sslNote": "Suas informações de faturamento são criptografadas com SSL. Nunca armazenamos os dados do seu cartão.",
    "pay.annual": "Anual",
    "pay.monthly": "Mensal",
    "pay.basePrice": "Preço Base",
    "pay.starts": "Início",
    "pay.ends": "Término",
    "pay.promoCode": "Código Promocional",
    "pay.applyCode": "Aplicar código →",
    "pay.enterCode": "Inserir código",
    "pay.taxes": "Impostos",
    "pay.discountApplied": "Desconto Aplicado",
    "pay.upgradeCreditApplied": "Crédito de Upgrade",
    "pay.upgradeCreditNote": "Crédito pelo tempo não utilizado restante no seu plano atual.",
    "pay.farFutureQueueBanner": "Você já tem cobertura ativa até {date}. Esta compra só começará depois disso.",
    "pay.farFutureQueueHeader": "Isso não começará por um tempo",
    "pay.farFutureQueueMessage": "Você já tem um plano ativo até {date}. Esta nova compra ficará na fila para começar somente depois disso — não terá efeito agora. Continuar mesmo assim?",
    "pay.farFutureQueueAccept": "Sim, colocar na fila mesmo assim",
    "pay.farFutureQueueReject": "Não, cancelar",
    "pay.promoApplied": "Cupom Aplicado!",
    "pay.promoChange": "Remover",
    "pay.promoEnterFirst": "Insira um código de cupom.",
    "pay.promoGenericError": "Este código não é válido. Verifique e tente novamente.",
    "pay.promoErr.notFound": "Não encontramos este código. Verifique e tente novamente.",
    "pay.promoErr.notStarted": "Este código ainda não está ativo.",
    "pay.promoErr.expired": "Este código expirou.",
    "pay.promoErr.usedUp": "Este código atingiu o limite de uso e não pode mais ser usado.",
    "pay.promoErr.currency": "Este código não é válido para a moeda selecionada.",
    "pay.promoErr.period": "Este código não é válido para o período de cobrança selecionado.",
    "pay.promoErr.inrOnly": "Este código só é válido para cobrança em INR.",
    "pay.promoErr.alreadyUsed": "Sua empresa já usou este código.",
    "pay.promoErr.ownCode": "Você não pode usar um código de indicação que pertence à sua própria empresa.",
    "pay.amountPayable": "Valor a Pagar",
    "pay.autoRenewal": "Renovação Automática",
    "pay.autoRenewalHint": "Renovar automaticamente ao fim do período de faturamento",
    "pay.autoRenewalRequiredMonthly": "Obrigatório para planos mensais — cancele a qualquer momento na página de assinaturas",
    "pay.autoRenewalUsdNotSupported": "Renovação automática disponível apenas para faturamento em INR",
    "pay.autoRenewalCouponDisabled": "Desconto único aplicado — renovação automática desativada. Ative após o pagamento na sua página de assinatura pelo preço integral.",
    "pay.autoRenewalLifetimeCoupon": "Desconto vitalício: a renovação automática continuará neste preço com desconto",
    "pay.iHaveReadAccept": "Li e aceito os",
    "pay.tncError": "Você deve aceitar os Termos e Condições para continuar.",
    "pay.sslSecured": "Protegido por SSL",
    "pay.encrypted": "Criptografado",
    "pay.tncFooterNote": "Clicar em \"Aceitar\" também marca a caixa de seleção de concordância.",
    "pay.orderSummary": "Resumo do Pedido",
    "pay.yr": "ano",
    "pay.mo": "mês",
    // -- Tour
    "tour.next": "Próximo →",
    "tour.prev": "← Voltar",
    "tour.done": "Concluído ✓",
    "tour.progress": "{{current}} de {{total}}",
    "tour.header.welcome.title": "Bem-vindo ao LumberLinq!",
    "tour.header.welcome.desc": "Vamos fazer um tour rápido pelos principais recursos. Você pode <strong>dispensar</strong> a qualquer momento clicando no botão ×.",
    "tour.header.menu.title": "Menu de Navegação",
    "tour.header.menu.desc": "Clique aqui para <strong>abrir ou recolher</strong> a navegação lateral.",
    "tour.header.logo.title": "Logo do LumberLinq",
    "tour.header.logo.desc": "Clique no logo para <strong>voltar ao Painel</strong> de qualquer lugar.",
    "tour.header.language.title": "Idioma",
    "tour.header.language.desc": "Alterne o idioma entre <strong>Inglês, Hindi e Português</strong>.",
    "tour.header.fontSize.title": "Tamanho da Fonte",
    "tour.header.fontSize.desc": "Ajuste o <strong>tamanho do texto</strong> ao seu conforto.",
    "tour.header.theme.title": "Tema",
    "tour.header.theme.desc": "Escolha um <strong>tema de cor</strong> de sua preferência.",
    "tour.header.darkMode.title": "Modo Escuro",
    "tour.header.darkMode.desc": "Alterne entre os modos <strong>Claro e Escuro</strong>.",
    "tour.header.profile.title": "Seu Perfil",
    "tour.header.profile.desc": "Acesse <strong>configurações de conta, assinatura e logout</strong> aqui.",
    "tour.header.help.title": "Ajuda e Suporte",
    "tour.header.help.desc": "Encontre <strong>guias, FAQs e tickets de suporte</strong> sempre que precisar. É tudo — aproveite o LumberLinq!",
    "tour.shipments.header.title": "Consignações",
    "tour.shipments.header.desc": "Gerencie todos os seus <strong>consignações de exportação</strong> desta página.",
    "tour.shipments.new.title": "Nova Consignação",
    "tour.shipments.new.desc": "Clique aqui para <strong>criar uma nova consignação</strong> e adicionar unidades de estoque.",
    "tour.shipments.filter.title": "Filtrar e Pesquisar",
    "tour.shipments.filter.desc": "Use estes filtros para <strong>pesquisar consignações</strong> por data, status ou parceiro.",
    "tour.shipments.table.title": "Tabela de Consignações",
    "tour.shipments.table.desc": "Cada linha é uma consignação. Clique para <strong>ver detalhes, tallies e documentos</strong>.",
    "tour.shipments.delete.title": "Excluir Consignação",
    "tour.shipments.delete.desc": "Use a ação de exclusão com cuidado — <strong>consignações removidas não podem ser recuperadas</strong>.",
    "tour.tally.header.title": "Folha de Tally",
    "tour.tally.header.desc": "Registre e gerencie <strong>medições de toras</strong> para esta unidade de estoque.",
    "tour.tally.settings.title": "Configurações de Tally",
    "tour.tally.settings.desc": "Configure <strong>fórmula, unidade e padrões de medição</strong> para este tally.",
    "tour.tally.grid.title": "Grade de Entrada",
    "tour.tally.grid.desc": "Insira a <strong>circunferência, comprimento e quantidade</strong> de cada tora na grade. Os totais são atualizados automaticamente.",
    "tour.tally.export.title": "Exportar",
    "tour.tally.export.desc": "Exporte o tally como <strong>PDF ou Excel</strong> para compartilhar ou arquivar.",
    "tour.tally.save.title": "Salvar Tally",
    "tour.tally.save.desc": "Clique em Salvar para <strong>enviar os dados do tally</strong> à consignação.",
    "tour.reports.header.title": "Relatórios",
    "tour.reports.header.desc": "Gere <strong>relatórios detalhados de negócios e tally</strong> nesta seção.",
    "tour.reports.filter.title": "Filtros de Relatório",
    "tour.reports.filter.desc": "Defina <strong>período, parceiro e consignação</strong> para refinar o relatório.",
    "tour.reports.generate.title": "Gerar Relatório",
    "tour.reports.generate.desc": "Clique em Gerar para <strong>criar o relatório</strong> com os filtros selecionados.",
    "tour.reports.export.title": "Exportar Relatório",
    "tour.reports.export.desc": "Baixe o relatório em <strong>PDF ou Excel</strong> para uso offline.",
    "tour.bp.header.title": "Parceiros de Negócios",
    "tour.bp.header.desc": "Gerencie todos os seus <strong>compradores e vendedores</strong> nesta página.",
    "tour.bp.new.title": "Adicionar Parceiro",
    "tour.bp.new.desc": "Clique aqui para <strong>adicionar um novo comprador ou vendedor</strong> ao seu diretório.",
    "tour.bp.stats.title": "Estatísticas de Parceiros",
    "tour.bp.stats.desc": "Uma visão geral de <strong>compradores e vendedores totais</strong> em sua conta.",
    "tour.bp.filter.title": "Filtrar Parceiros",
    "tour.bp.filter.desc": "Pesquise ou filtre parceiros por <strong>nome, tipo ou país</strong>.",
    "tour.bp.table.title": "Tabela de Parceiros",
    "tour.bp.table.desc": "Clique em uma linha para <strong>editar detalhes ou ver o histórico de consignações</strong>.",
    "tour.products.header.title": "Produtos",
    "tour.products.header.desc": "Defina os <strong>produtos de madeira</strong> usados nas suas folhas de tally.",
    "tour.products.new.title": "Adicionar Produto",
    "tour.products.new.desc": "Clique aqui para <strong>criar um novo produto de madeira</strong> com fórmula e unidade.",
    "tour.products.stats.title": "Estatísticas de Produtos",
    "tour.products.stats.desc": "Veja o <strong>número total de produtos</strong> configurados em sua conta.",
    "tour.products.table.title": "Tabela de Produtos",
    "tour.products.table.desc": "Clique em uma linha para <strong>editar nome, fórmula ou unidade padrão</strong>.",
    "tour.loadingSite.header.title": "Locais",
    "tour.loadingSite.header.desc": "Rastreie todos os <strong>locais de floresta, pátio, serraria e porto</strong> aqui.",
    "tour.loadingSite.new.title": "Adicionar Local",
    "tour.loadingSite.new.desc": "Clique aqui para <strong>registrar um novo local</strong> em sua conta.",
    "tour.loadingSite.stats.title": "Estatísticas de Locais",
    "tour.loadingSite.stats.desc": "Um resumo dos <strong>locais totais</strong> por tipo.",
    "tour.loadingSite.table.title": "Tabela de Locais",
    "tour.loadingSite.table.desc": "Clique em uma linha para <strong>editar nome, tipo e localização</strong>.",
    "tour.users.header.title": "Usuários",
    "tour.users.header.desc": "Gerencie todos os <strong>membros da equipe</strong> com acesso à sua conta LumberLinq.",
    "tour.users.add.title": "Convidar Usuário",
    "tour.users.add.desc": "Clique aqui para <strong>convidar um novo membro da equipe</strong> por e-mail.",
    "tour.users.stats.title": "Estatísticas de Usuários",
    "tour.users.stats.desc": "Veja quantos <strong>usuários ativos e assentos disponíveis</strong> seu plano permite.",
    "tour.users.table.title": "Tabela de Usuários",
    "tour.users.table.desc": "Gerencie funções e permissões — clique para <strong>editar ou desativar</strong>.",
    "tour.dashboardV7.header.title": "Seu Pulso do Negócio",
    "tour.dashboardV7.header.desc": "Seu <strong>Painel</strong> — escolha um período e atualize aqui para ver números ao vivo de toda a sua operação.",
    "tour.dashboardV7.pulse.title": "Pulso do Negócio",
    "tour.dashboardV7.pulse.desc": "Cartões rápidos de <strong>KPI</strong> para parceiros, remessas, unidades de estoque, volume e peças — clique em qualquer cartão para ir direto para essa lista.",
    "tour.dashboardV7.financial.title": "Saúde Financeira",
    "tour.dashboardV7.financial.desc": "Acompanhe <strong>receita, saldos em aberto e vencimentos</strong> rapidamente.",
    "tour.dashboardV7.inventory.title": "Resumo do Estoque",
    "tour.dashboardV7.inventory.desc": "Uma visão ao vivo dos <strong>níveis de estoque em todos os seus locais</strong> — clique em 'Estoque Completo' para o quadro completo.",
    "tour.dashboardV7.recon.title": "Reconciliação",
    "tour.dashboardV7.recon.desc": "Veja quanto dos seus dados de tally estão <strong>reconciliados com remessas</strong>, e avance para corrigir lacunas.",
    "tour.dashboardV7.charts.title": "Tendências e Gráficos",
    "tour.dashboardV7.charts.desc": "Visualize <strong>tendências de volume e principais produtos</strong> no período selecionado.",
    "tour.dashboardV7.activity.title": "Atividade Recente",
    "tour.dashboardV7.activity.desc": "Um registro de auditoria de <strong>alterações recentes de conta e permissões</strong> em sua equipe.",
    "tour.inventoryOverview.header.title": "Visão Geral do Estoque",
    "tour.inventoryOverview.header.desc": "Uma visão ao vivo de <strong>onde seu estoque está agora</strong> — na Floresta, em Trânsito, na Serraria, em ordem de serraria, no Pátio ou em Consignação.",
    "tour.inventoryOverview.actions.title": "Estoque inicial e Ordem de Serraria",
    "tour.inventoryOverview.actions.desc": "As ações principais: <strong>adicionar seu estoque inicial (o que você já tem) ou iniciar uma ordem de serraria</strong>. Novas entregas entram pela sua Unidade de Estoque (Entrada) e são recebidas num Lote.",
    "tour.inventoryOverview.lots.title": "Lotes de Estoque Abertos",
    "tour.inventoryOverview.lots.desc": "Todo <strong>lote aberto</strong> atualmente no sistema — clique em um lote para ver seu histórico completo de movimentação e cadeia.",
    "tour.inventoryInOut.header.title": "Livro de Movimentações de Estoque",
    "tour.inventoryInOut.header.desc": "Toda <strong>movimentação de estoque</strong> já registrada. Use Adicionar Ajuste para corrigir uma discrepância, ou Exportar para uma cópia em planilha.",
    "tour.inventoryInOut.filter.title": "Filtrar por Tipo e Data",
    "tour.inventoryInOut.filter.desc": "Restrinja o livro a um <strong>tipo de movimentação</strong> (Entrada, Saída, Ajuste, e mais) ou a um <strong>intervalo de datas</strong>.",
    "tour.inventoryInOut.table.title": "Livro de Movimentações",
    "tour.inventoryInOut.table.desc": "Cada linha é um <strong>evento de movimentação</strong> — toque num código para ver a Unidade de Estoque, Lote, Ordem de Serraria ou Consignação por trás dele.",
    "tour.inventoryProcessing.header.title": "Ordens de Serraria",
    "tour.inventoryProcessing.header.desc": "É aqui que acontecem as <strong>ordens de serraria</strong>, incluindo Custom-Made / Re-serragem — inicie uma nova ordem para transformar estoque de um Lote em um novo Lote.",
    "tour.inventoryProcessing.stats.title": "Desempenho das Ordens de Serraria",
    "tour.inventoryProcessing.stats.desc": "Total de ordens de serraria, <strong>rendimento médio</strong>, e volume total serrado — uma verificação rápida da eficiência da sua serraria.",
    "tour.inventoryProcessing.table.title": "Ordens de Serraria",
    "tour.inventoryProcessing.table.desc": "Cada ordem de serraria, seu <strong>status</strong> e sua entrada/saída — clique numa linha para ver todos os detalhes, incluindo o pedido que a originou.",
    "tour.inventoryOperators.header.title": "Operadores da Serraria",
    "tour.inventoryOperators.header.desc": "Gerencie os <strong>operadores</strong> que trabalham nas ordens de serraria — adicione um novo operador aqui.",
    "tour.inventoryOperators.stats.title": "Resumo da Equipe",
    "tour.inventoryOperators.stats.desc": "Total de operadores e <strong>operadores ativos</strong> em um relance.",
    "tour.inventoryOperators.search.title": "Buscar e Filtrar",
    "tour.inventoryOperators.search.desc": "Encontre um operador por <strong>nome, código de funcionário, ou e-mail</strong>, ou filtre por especialidade e status ativo.",
    "tour.rbacSettings.toggle.title": "Controle de Acesso Baseado em Função",
    "tour.rbacSettings.toggle.desc": "Ative o <strong>RBAC</strong> para dar a cada membro da equipe apenas o acesso de que precisa, em vez de todos verem tudo.",
    "tour.rbacSettings.tabs.title": "Usuários e Funções",
    "tour.rbacSettings.tabs.desc": "Gerencie o acesso de duas formas: por usuário (<strong>Permissões de Usuário</strong>) ou atribuindo uma <strong>Função</strong> reutilizável.",
    "tour.rbacSettings.usersTable.title": "Permissões de Usuário",
    "tour.rbacSettings.usersTable.desc": "Cada membro da equipe e quanto do sistema ele pode acessar — clique em <strong>Configurar</strong> em uma linha para ajustar.",
    "tour.rbacSettings.rolesTab.title": "Funções de Acesso",
    "tour.rbacSettings.rolesTab.desc": "Crie uma <strong>função reutilizável</strong> (como 'Contador' ou 'Supervisor de Pátio') uma vez, depois atribua-a a quantos usuários quiser.",
    "tour.subscriptionManagement.accordion.title": "Assine em 4 Passos",
    "tour.subscriptionManagement.accordion.desc": "Escolha um plano, revise-o, adicione os dados de cobrança e depois pague — cada passo <strong>libera o próximo</strong> ao ser concluído.",
    "tour.subscriptionManagement.packageSelect.title": "1. Selecionar Pacote",
    "tour.subscriptionManagement.packageSelect.desc": "Escolha o <strong>plano e ciclo de cobrança</strong> que se encaixa no seu negócio.",
    "tour.subscriptionManagement.billing.title": "3. Dados de Cobrança",
    "tour.subscriptionManagement.billing.desc": "Insira os <strong>dados da sua empresa e informações fiscais</strong> para a fatura.",
    "tour.subscriptionManagement.pay.title": "4. Avaliar Pedido e Pagar",
    "tour.subscriptionManagement.pay.desc": "Revise o <strong>total final</strong>, aplique um código promocional se tiver um, e conclua o pagamento.",
    // -- Support Tickets
    "ticket.supportTitle": "Tickets de Suporte",
    "ticket.subtitle": "Registre uma solicitação, acompanhe o progresso e receba ajuda da nossa equipe.",
    "ticket.newTicket": "Novo Ticket",
    "ticket.searchPlaceholder": "Pesquisar por assunto, número do ticket ou categoria…",
    "ticket.filter": "Filtrar:",
    "ticket.replies": "respostas",
    "ticket.lastActivity": "Última atividade",
    "ticket.noTickets": "Nenhum ticket ainda",
    "ticket.noTicketsHint": "Não fez uma solicitação de suporte? Estamos aqui para ajudar.",
    "ticket.raiseFirst": "Criar Primeiro Ticket",
    "ticket.submitted": "Ticket Enviado!",
    "ticket.submitReceived": "Sua solicitação de suporte foi recebida.",
    "ticket.respondTime": "Nossa equipe responderá em 24 horas.",
    "ticket.yourId": "Seu ID de Ticket",
    "ticket.viewTicket": "Ver Ticket",
    "ticket.allTickets": "Todos os Tickets",
    "ticket.raiseTitle": "Abrir Ticket de Suporte",
    "ticket.raiseHint": "Descreva seu problema e retornaremos em breve.",
    "ticket.subject": "Assunto",
    "ticket.subjectPlaceholder": "Descreva brevemente seu problema",
    "ticket.subjectRequired": "Assunto é obrigatório.",
    "ticket.maxChars": "Máximo 255 caracteres.",
    "ticket.selectCategory": "Selecionar categoria",
    "ticket.categoryRequired": "Categoria é obrigatória.",
    "ticket.descriptionPlaceholder": "Forneça o máximo de detalhes possível — passos para reproduzir, mensagens de erro, contexto de capturas de tela, etc.",
    "ticket.descriptionRequired": "Descrição é obrigatória.",
    "ticket.submitTicket": "Enviar Ticket",
    "ticket.priority": "Prioridade",
    "ticket.resolved": "Resolvido",
    "ticket.closed": "Fechado",
    "ticket.howDidWeDo": "Como nos saímos?",
    "ticket.csatPrompt": "Seu ticket foi resolvido. Avalie sua experiência de suporte:",
    "ticket.optionalComment": "Comentário opcional…",
    "ticket.submitRating": "Enviar Avaliação",
    "ticket.yourRating": "Sua avaliação:",
    "ticket.replyPlaceholder": "Digite sua resposta aqui…",
    "ticket.attachFile": "Anexar arquivo",
    "ticket.sendReply": "Enviar Resposta",
    "ticket.ticketClosed": "Este ticket está fechado. Abra um novo ticket se precisar de mais assistência.",
    "ticket.status.all": "Todos",
    "ticket.status.open": "Aberto",
    "ticket.status.inProgress": "Em Andamento",
    "ticket.status.awaitingReply": "Aguardando Minha Resposta",
    "ticket.status.resolved": "Resolvido",
    "ticket.status.closed": "Fechado",
    "ticket.priority.low": "Baixo",
    "ticket.priority.medium": "Médio",
    "ticket.priority.high": "Alto",
    "ticket.priority.critical": "Crítico",
    "ticket.priority.low.desc": "Baixo — pergunta geral",
    "ticket.priority.medium.desc": "Médio — problema não urgente",
    "ticket.priority.high.desc": "Alto — afetando meu trabalho",
    "ticket.priority.critical.desc": "Crítico — sistema fora / perda de dados",
    "ticket.category.billing": "Faturamento e Pagamentos",
    "ticket.category.technical": "Problema Técnico",
    "ticket.category.account": "Conta e Acesso",
    "ticket.category.featureRequest": "Solicitação de Funcionalidade",
    "ticket.category.subscription": "Assinatura",
    "ticket.category.dataRecovery": "Recuperação de Dados",
    "ticket.category.other": "Outro",
    "ticket.csat.1": "Muito Insatisfeito",
    "ticket.csat.2": "Insatisfeito",
    "ticket.csat.3": "Neutro",
    "ticket.csat.4": "Satisfeito",
    "ticket.csat.5": "Muito Satisfeito",
    // -- AI Chat
    "ai.chat.title": "Assistente IA LumberLinq",
    "ai.chat.placeholder": "Pergunte sobre o LumberLinq…",
    "ai.chat.footerNote": "Respostas baseadas na nossa Base de Conhecimento",
    "ai.chat.send": "Enviar",
    "ai.chat.newChat": "Nova Conversa",
    "ai.chat.thinking": "Pensando…",
    "ai.chat.sources": "Fontes",
    "ai.chat.noSessions": "Sem conversas anteriores",
    "ai.chat.deleteSession": "Excluir conversa",
    "ai.chat.emailTranscript": "Enviar transcrição por e-mail",
    "ai.chat.feedback.good": "Útil",
    "ai.chat.feedback.bad": "Não útil",
    "ai.chat.attachFile": "Anexar arquivo",
    "ai.chat.disclaimer": "As respostas da IA são baseadas na nossa base de conhecimento e podem não ser totalmente precisas. Sempre verifique informações importantes.",
    "ai.chat.modeAuto": "Auto",
    "ai.chat.titleAuto": "Linc AI",
    "ai.chat.autoSub": "Pergunte qualquer coisa · o Linc escolhe a melhor resposta",
    "ai.chat.autoPlaceholder": "Pergunte como fazer algo, ou sobre o seu estoque e pagamentos…",
    "ai.chat.autoGreeting": "Olá, eu sou o Linc AI 👋",
    "ai.chat.autoTitle": "Um só lugar para todas as perguntas",
    "ai.chat.autoDesc": "Pergunte como fazer algo no LumberLinq, ou sobre o seu próprio estoque, consignações e pagamentos. Eu escolho a melhor forma de responder e só mostro o que a sua conta pode ver.",
    "ai.chat.goToScreen": "Ir para a tela",
    "ai.chat.dataPartFailed": "Consegui responder à parte \"como fazer\" da sua pergunta, mas a parte com dados em tempo real não pôde ser respondida agora.",
    "ai.chat.starter.createConsignment": "Criar uma Consignação",
    "ai.chat.starter.inviteTeam": "Convidar um membro da equipe",
    "ai.chat.starter.shareTally": "Compartilhar uma folha de contagem",
    "ai.chat.starter.stockNow": "Estoque agora",
    "ai.chat.starter.toPay": "Pagamentos a vencer",
    "ai.chat.starterQ.createConsignment": "Como crio uma nova Consignação?",
    "ai.chat.starterQ.inviteTeam": "Como convido um membro da equipe?",
    "ai.chat.starterQ.shareTally": "Como compartilho uma folha de tally com um comprador?",
    "ai.chat.starterQ.stockNow": "Quanto estoque temos agora?",
    "ai.chat.starterQ.toPay": "O que está pendente de pagamento neste mês?",
    "ai.chat.starterQ.myAccess": "O que posso fazer com a minha conta?",
    "ai.chat.starterQ.shipmentsMonth": "Quantos embarques neste mês?",
    "ai.chat.starterQ.profitMargin": "Qual é a nossa margem de lucro neste trimestre?",
    "ai.chat.starterQ.machines": "Quais máquinas estão funcionando agora?",
    "ai.chat.starterQ.health": "Como está o nosso negócio, no geral?",
    "ai.chat.starter.myAccess": "O que posso fazer?",
    "lincPreview.button": "O que o Linc mostra a esta pessoa",
    "lincPreview.title": "O que o Linc mostra a esta pessoa",
    "lincPreview.intro": "Isto é o que o Linc (o assistente de IA) pode dizer a esta pessoa, de acordo com o acesso dela e o plano da empresa. Nada é enviado à IA para mostrar isto.",
    "lincPreview.modulesAssumed": "Você está conectado como equipe da plataforma, então os interruptores de módulo (Inventory, Mill Jobs, Linc Data) não são verificados aqui.",
    "lincPreview.why.plan": "{items} não está incluído no plano atual desta empresa (a empresa precisaria fazer upgrade ou adicioná-lo)",
    "lincPreview.why.permission": "esta conta não tem acesso a {items} (um administrador da equipe pode conceder em Manage Roles)",
    "lincPreview.why.also": "; além disso, ",
    "lincPreview.why.and": " e ",
    "lincPreview.why.dataPlan": "O Linc Data não está ativado no plano desta empresa (a empresa precisaria adicioná-lo ou fazer upgrade)",
    "lincPreview.why.dataRight": "esta conta não tem o direito de usar o Linc Data (um administrador da equipe pode conceder em Manage Roles)",
    "lincPreview.tileAreas": "Áreas",
    "lincPreview.tileQuestions": "Perguntas de dados em tempo real",
    "lincPreview.tileSections": "Notas de ajuda",
    "lincPreview.tileAnswers": "Respostas prontas",
    "lincPreview.areasTitle": "Áreas do aplicativo",
    "lincPreview.questionsTitle": "Perguntas de dados em tempo real (Linc Data)",
    "lincPreview.notesTitle": "Notas de ajuda",
    "lincPreview.allowed": "Permitido",
    "lincPreview.notAllowed": "Não permitido",
    "lincPreview.withheld": "retidas",
    "lincPreview.showWithheld": "Mostrar seções retidas",
    "lincPreview.error": "Não foi possível carregar a pré-visualização. Tente novamente.",
    "lincPreview.close": "Fechar",
    // -- Round Tally Summary (premium redesign)
    "tallySummaryRound.title": "Resumo do Romaneio Redondo",
    "tallySummaryRound.subtitle": "Volume, contagem de peças e insights de distribuição para este lote de toras redondas",
    "tallySummaryRound.piecesAnalyzed": "peças analisadas",
    "tallySummaryRound.histogram": "Histograma",
    "tallySummaryRound.bubble": "Bolhas",
    "tallySummaryRound.line": "Linha",
    "tallySummaryRound.mainVisualization": "Visualização Principal",
    "tallySummaryRound.girthVsVolume": "Circunferência vs Volume",
    "tallySummaryRound.lengthDistribution": "Distribuição de Comprimento",
    "tallySummaryRound.bubbleTitle": "Circunferência x Comprimento x Volume",
    "tallySummaryRound.activeFilterLabel": "Filtro Ativo",
    "tallySummaryRound.clearFilter": "Limpar Filtro",
    "tallySummaryRound.spotlightPiece": "Destacando peça #",
    "tallySummaryRound.kpiTotalPieces": "Total de Peças",
    "tallySummaryRound.kpiTotalNetCbm": "Total CBM Líquido",
    "tallySummaryRound.kpiTotalNetCft": "Total CFT Líquido",
    "tallySummaryRound.kpiAuthoritative": "Total oficial do lote",
    "tallySummaryRound.distributionTitle": "Distribuição por Peça",
    "tallySummaryRound.avgVolume": "Volume Médio / Peça",
    "tallySummaryRound.minVolume": "Menor Peça",
    "tallySummaryRound.maxVolume": "Maior Peça",
    "tallySummaryRound.outlierWatchTitle": "Qualidade dos Dados - Monitor de Anomalias",
    "tallySummaryRound.outlierCleanLot": "Lote limpo - nenhuma anomalia de medição detectada",
    "tallySummaryRound.outlierFlaggedCount": "peça(s) sinalizada(s) para revisão",
    "tallySummaryRound.outlierFreePercent": "Sem anomalias",
    "tallySummaryRound.outlierExpand": "Ver peças sinalizadas",
    "tallySummaryRound.outlierCollapse": "Ocultar peças sinalizadas",
    "tallySummaryRound.outlierColRow": "Linha #",
    "tallySummaryRound.outlierColGirth": "Circunferência",
    "tallySummaryRound.outlierColLength": "Comprimento",
    "tallySummaryRound.outlierColVolume": "Volume",
    "tallySummaryRound.outlierColDeviation": "Desvio",
    "tallySummaryRound.outlierSeverityMild": "Leve",
    "tallySummaryRound.outlierSeverityExtreme": "Extremo",
    "tallySummaryRound.outlierNotEnoughData": "Peças insuficientes para avaliar anomalias (mínimo de 8 necessárias)",
    "tallySummaryRound.outlierAboveRange": "acima da faixa esperada",
    "tallySummaryRound.outlierBelowRange": "abaixo da faixa esperada",
    "tallySummaryRound.rowPositionHint": "Posição de entrada no romaneio, não é um ID permanente",
    "tallySummaryRound.girthHistogramTitle": "Distribuição de Circunferência",
    "tallySummaryRound.girthHistogramDesc": "Peças agrupadas em faixas de circunferência de 5 cm",
    "tallySummaryRound.lengthHistogramTitle": "Tabela de Distribuição de Comprimento",
    "tallySummaryRound.lengthHistogramDesc": "Peças agrupadas pelo comprimento informado",
    "tallySummaryRound.metric": "Métrica",
    "tallySummaryRound.noDataTitle": "Nenhum Resumo Disponível",
    "tallySummaryRound.noDataDesc": "Adicione dados do romaneio primeiro para gerar insights e visualizações.",
    "tallySummaryRound.lotSnapshot": "Instantâneo do Lote",
    "tallySummaryRound.kpiAvgCft": "CFT Médio / Peça",
    "tallySummaryRound.distributionHelp": "Volume líquido médio, menor e maior (CBM) por tora individual na visualização atual.",
    "tallySummaryRound.outlierHelp": "Sinaliza toras cujo volume é estatisticamente incomum em relação ao restante deste lote - uma forma rápida de detectar entradas mal medidas ou digitadas incorretamente antes de finalizar ou compartilhar este romaneio.",
    "tallySummaryRound.axisGirth": "Circunferência (cm)",
    "tallySummaryRound.axisLength": "Comprimento (cm)",
    "tallySummaryRound.axisPieces": "Peças",
    "tallySummaryRound.axisVolume": "Volume (m³)",
    "tallySummaryRound.rowAverage": "Média",
    "tallySummaryRound.rowSmallest": "Menor",
    "tallySummaryRound.rowLargest": "Maior",
    "tallySummaryRound.colVolume": "Volume",
    "tallySummaryRound.colGirth": "Circunferência",
    "tallySummaryRound.colLength": "Comprimento",
    "tallySummaryRound.normalGirthRange": "Faixa Normal de Circunferência",
    "tallySummaryRound.normalLengthRange": "Faixa Normal de Comprimento",
    "tallySummaryRound.dimGirthAbnormal": "Circunferência anormal",
    "tallySummaryRound.dimLengthAbnormal": "Comprimento anormal",
    "tallySummaryRound.dimBothAbnormal": "Circunferência e Comprimento anormais",
    "tallySummaryRound.girthVsVolumeHelp": "Mostra como o volume de cada tora se relaciona com sua circunferência - maior circunferência geralmente significa mais volume, mas o comprimento também tem seu papel.",
    "tallySummaryRound.holdTitle": "Quais toras concentram seu volume",
    "tallySummaryRound.holdSubLogs": "Maiores primeiro · parte de {total} CBM",
    "tallySummaryRound.holdSubBands": "Faixas de circunferência, maiores primeiro · parte de {total} CBM",
    "tallySummaryRound.holdInsightOne": "Sua maior tora concentra {pct}% do volume do lote.",
    "tallySummaryRound.holdInsightMany": "Suas {n} maiores toras concentram {pct}% do volume do lote.",
    "tallySummaryRound.holdInsightBand": "Toras de {band} cm de circunferência concentram {pct}% do volume.",
    "tallySummaryRound.holdRow": "Linha {n}",
    "tallySummaryRound.holdMeta": "{girth} cm de circunferência · {length} cm de comprimento",
    "tallySummaryRound.holdBandMeta": "{n} toras",
    "tallySummaryRound.holdShowAll": "Mostrar todas ({n})",
    "tallySummaryRound.holdShowLess": "Mostrar menos",
    "tallySummaryRound.emptyHidden": "{n} vazias ocultas · Mostrar",
    "tallySummaryRound.emptyHide": "Ocultar vazias",
    "tallySummaryRound.holdInsightTop": "Os seus {k}% maiores toras concentram {pct}% do volume.",
    "tallySummaryRound.holdTopLogs": "Maiores toras individuais",
    "tallySummaryRound.holdTabBands": "Por faixa",
    "tallySummaryRound.holdTabLogs": "Maiores toras",
    "tallySummaryRound.holdBandMetaOne": "{n} tora",
    "emailVerification.linkValidHours": "Link válido por 24 horas",
    "emailVerification.resendButton": "Reenviar Email de Verificação",
    "emailVerification.alreadyVerifiedPill": "Email já verificado — por favor, continue",
    "emailVerification.nowVerifiedGoToLogin": "Seu email foi verificado! Faça login para continuar.",
    "emailVerification.stillNotVerified": "Ainda não verificado — verifique seu email e clique no link primeiro.",
    "emailVerification.resendCountdown": "Reenvio disponível em {{seconds}}s",
    "emailVerification.attemptsRemaining": "{{count}} de 3 tentativas de reenvio restantes",
    "emailVerification.maxAttemptsReached": "Número máximo de tentativas de reenvio atingido. Entre em contato com o suporte.",
    "emailVerification.emailInputPlaceholder": "Digite seu endereço de email",
    "emailVerification.emailInputHint": "Digite o email usado no cadastro para reenviar o link de verificação.",
    "emailVerification.toastSuccessSummary": "Email Enviado",
    "emailVerification.toastErrorSummary": "Falha ao Reenviar",
    "emailVerification.refreshErrorSummary": "Não foi possível verificar",
    "emailVerification.refreshErrorBody": "Não foi possível verificar o status do seu e-mail agora. Tente novamente em instantes.",
    "login.securityCheckRetry": "Repetir verificação de segurança",
    "login.securityCheckStuck": "Demorando mais que o normal — toque em repetir abaixo",
    "login.securityCheckExpired": "Verificação expirada — toque em atualizar para continuar",
    "login.securityCheckErrored": "Não foi possível carregar a verificação de segurança — toque em repetir",
    "login.signInCancelledSummary": "Login Cancelado",
    "login.signInCancelledDetail": "Parece que o login não foi concluído. Tente novamente quando estiver pronto.",
    "tallyStatusBar.row": "linha",
    "tallyStatusBar.rows": "linhas",
    "tallyStatusBar.piecesUnit": "pçs",
    "tallyStatusBar.updated": "atualizada(s)",
    "tallyStatusBar.removed": "removida(s)",
    "tallyStatusBar.totalRowsTooltip": "Total de linhas",
    "tallyStatusBar.totalPiecesTooltip": "Total de peças",
    "tallyStatusBar.availableNowTooltip": "Disponível agora",
    "tallyStatusBar.afterThisSave": "Restante:",
    "tallyStatusBar.grossCbmTooltip": "CBM bruto",
    "tallyStatusBar.grossCbmUnit": "CBM bruto",
    "tallyStatusBar.grossCftUnit": "CFT bruto",
    "tallyStatusBar.grossCftTooltip": "CFT bruto",
    "tallyStatusBar.netCbmUnit": "CBM líquido",
    "tallyStatusBar.netCftUnit": "CFT líquido",
    "tallyStatusBar.netCbmTooltip": "CBM líquido (após tolerâncias)",
    "tallyStatusBar.netCftTooltip": "CFT líquido (após tolerâncias)",
    "tallyStatusBar.avgCftTooltip": "CFT médio por tora",
    "tallyStatusBar.unsavedChangesTooltip": "linhas com alterações não salvas",
    "tallyStatusBar.unsavedUnit": "não salvo",
    "tallyStatusBar.allChangesSavedTooltip": "Todas as alterações salvas",
    "tallyStatusBar.allSaved": "Tudo salvo",
    "tallyStatusBar.savedPrefix": "Salvo —",
    "tallyStatusBar.deletedPrefix": "Excluído —",
    "tallyStatusBar.unsavedPressSave": "não salvo — pressione Salvar",
    "tallyStatusBar.lastSaved": "Salvo pela última vez",
    "tallyStatusBar.hideVoiceControls": "Ocultar controles de voz",
    "tallyStatusBar.showVoiceControls": "Mostrar controles de voz",
    "tallyStatusBar.addRow": "Adicionar linha",
    "tallyStatusBar.deleteSelected": "Excluir selecionados",
    "tallyStatusBar.saveCtrlS": "Salvar (Ctrl+S)",
    "tallyStatusBar.saveTimeout": "Salvar está demorando muito — verifique sua conexão",
    "tallyStatusBar.saveFailed": "Falha ao salvar — tente novamente",
    "tallyStatusBar.deletingRows": "Excluindo linhas...",
    "tallyStatusBar.deleteFailed": "Falha ao excluir — tente novamente",
    "tallyStatusBar.fixHighlightedCells": "Corrija as células destacadas antes de salvar",
    "tallyStatusBar.noModifiedRows": "Nenhuma linha modificada",
    "tallyStatusBar.saveMsg1": "Salvando suas alterações",
    "tallyStatusBar.saveMsg2": "Calculando os números",
    "tallyStatusBar.saveMsg3": "Sincronizando com o servidor",
    "tallyStatusBar.saveMsg4": "Quase lá",
    "tallyStatusBar.saveMsg5": "Ainda trabalhando nisso",
    "tallyStatusBar.saveMsg6": "Aguarde, quase pronto",
    "tallyStatusBar.saveMsg7": "Finalizando seus dados",
    "tallyStatusBar.saveMsg8": "Só mais um momento",
    "subscriptionPackage.cancelAutoRenewalFailedTitle": "Não foi possível cancelar a renovação automática",
    "subscriptionPackage.cancelAutoRenewalFailedMessage": "Não foi possível cancelar sua assinatura de renovação automática atual. Tente novamente ou entre em contato com o suporte.",
    "subscriptionPackage.saveErrorTitle": "Algo deu errado",
    "subscriptionPackage.saveErrorMessage": "Não foi possível salvar sua seleção. Tente novamente.",
    "subscriptionPackage.cta.selected": "{name} selecionado",
    "subscriptionPackage.cta.startTrial": "Teste gratuito de {days} dias",
    "subscriptionPackage.cta.choose": "Escolher {name}",
    "subscriptionPackage.trialNote": "Teste gratuito de {days} dias incluído",
    "appSettings.title": "Configurações do Aplicativo",
    "appSettings.subtitle": "Gerencie as configurações gerais da sua empresa",
    "appSettings.nav.paymentReminders": "Lembretes de Pagamento",
    "paymentReminders.title": "Lembretes de Pagamento",
    "paymentReminders.subtitle": "Lembre automaticamente os parceiros de negócios sobre pagamentos e receba um relatório diário",
    "paymentReminders.enable": "Ativar Lembretes de Pagamento",
    "paymentReminders.daysBefore": "Começar a lembrar",
    "paymentReminders.daysBefore.suffix": "dias antes do vencimento",
    "paymentReminders.sendTime": "Horário de envio",
    "paymentReminders.timezone": "Fuso horário",
    "paymentReminders.externalReminders": "Lembrar parceiros de negócios por e-mail",
    "paymentReminders.externalReminders.desc": "Envia um lembrete de pagamento ao comprador ou vendedor dos seus embarques/eventos comerciais",
    "paymentReminders.adminReport": "Enviar-me um relatório diário",
    "paymentReminders.adminReport.desc": "Um resumo de tudo vencido ou em atraso, com um PDF anexado",
    "paymentReminders.channelEmail": "E-mail",
    "paymentReminders.channelPush": "Notificação push",
    "paymentReminders.timeline.title": "Linha do Tempo do Lembrete",
    "paymentReminders.timeline.desc": "Pré-visualização de em quais dias um lembrete é enviado, até a data de vencimento",
    "paymentReminders.timeline.due": "Vencimento",
    "paymentReminders.timeline.overdue": "Atrasado (diariamente)",
    "paymentReminders.recipients.title": "Quem recebe o relatório?",
    "paymentReminders.recipients.desc": "Qualquer pessoa com acesso à Saúde Financeira recebe o relatório diário. Conceda a mais pessoas em",
    "paymentReminders.recipients.link": "Controle de Acesso",
    "paymentReminders.save": "Salvar Alterações",
    "paymentReminders.saved": "Configurações de lembrete de pagamento salvas",
    "paymentReminders.saveError": "Não foi possível salvar estas configurações. Tente novamente.",
    "appSettings.nav.currency": "Moeda",
    "appSettings.nav.inventoryPolicy": "Política de Inventário",
    "appSettings.nav.branding": "Identidade Visual",
    "appSettings.nav.tallyDefaults": "Padrões de Tally",
    "tallyDefaults.subtitle": "Unidades de medida, tolerâncias e regras de validação padrão com que novas Unidades de Estoque começam — substitua por Unidade de Estoque a qualquer momento.",
    "tallyDefaults.square": "Quadrado",
    "tallyDefaults.round": "Redondo",
    "tallyDefaults.unitOfMeasure": "Unidade de Medida",
    "tallyDefaults.widthUom": "UdM de Largura",
    "tallyDefaults.thickUom": "UdM de Espessura",
    "tallyDefaults.lengthUom": "UdM de Comprimento",
    "tallyDefaults.girthUom": "UdM de Circunferência",
    "tallyDefaults.decimals": "Decimais",
    "tallyDefaults.mode": "Modo de Entrada",
    "tallyDefaults.allowances": "Tolerâncias",
    "tallyDefaults.widthAllowance": "Tolerância de Largura",
    "tallyDefaults.thickAllowance": "Tolerância de Espessura",
    "tallyDefaults.lengthAllowance": "Tolerância de Comprimento",
    "tallyDefaults.girthAllowance": "Tolerância de Circunferência",
    "tallyDefaults.lengthAdjustments": "Ajustes de Comprimento",
    "tallyDefaults.copyPrevLength": "Copiar Comprimento Anterior",
    "tallyDefaults.addToLength": "Adicionar ao Comprimento",
    "tallyDefaults.addToLengthValue": "Valor a Adicionar ao Comprimento",
    "tallyDefaults.validationRules": "Regras de Validação",
    "tallyDefaults.divisibleBy5": "Divisível por 5",
    "tallyDefaults.girthRange": "Faixa de Circunferência",
    "tallyDefaults.lengthRange": "Faixa de Comprimento",
    "tallyDefaults.min": "Mín",
    "tallyDefaults.max": "Máx",
    "tallyDefaults.quickSearch": "Busca Rápida",
    "tallyDefaults.toleranceHint": "O quanto uma busca de tamanho simples pode se desviar do número digitado e ainda contar como correspondência — madeira real raramente mede exatamente o tamanho nominal.",
    "tallyDefaults.searchToleranceSquare": "Tolerância de Busca — Quadrado",
    "tallyDefaults.searchToleranceRound": "Tolerância de Busca — Redondo",
    "tallyDefaults.resetTitle": "Redefinir Padrões de Tally?",
    "tallyDefaults.resetBody": "Isso redefine todos os padrões desta página para os valores originais. Unidades de Estoque que já têm suas próprias configurações salvas não são afetadas.",
    "appSettings.resetAll": "Redefinir Tudo para o Padrão",
    "appSettings.resetAllTitle": "Redefinir Todas as Configurações",
    "appSettings.resetAllBody": "Isso redefine Lembretes de Pagamento, Moeda, Política de Inventário e Identidade Visual (se disponível) para os valores padrão. Isso não pode ser desfeito.",
    "common.resetToDefault": "Redefinir para o Padrão",
    "account.language.label": "Idioma",
    "account.language.hint": "Este é o idioma que você verá em todo o LumberLinq, em qualquer dispositivo.",
    "currency.subtitle": "Defina a moeda em que seus relatórios e painéis são exibidos.",
    "currency.resetTitle": "Redefinir Moeda",
    "currency.resetBody": "Isso limpa sua moeda de relatório de volta para não definida. Isso não pode ser desfeito.",
    "inventoryPolicy.subtitle": "Política de estoque em toda a empresa — aplica-se a todos os usuários.",
    "inventoryPolicy.allowOversell": "Permitir que as vendas continuem além do estoque disponível",
    "inventoryPolicy.allowOversell.hint": "Desativado por padrão — uma venda é bloqueada quando usaria mais do que o que realmente há em estoque.",
    "inventoryPolicy.detailedTracking": "Rastrear de qual compra vem a madeira de uma Ordem de Serraria",
    "inventoryPolicy.detailedTracking.hint": "Desativado por padrão — ative para ver e ajustar a qual compra o estoque de um Lote agrupado é atribuído ao ser processado.",
    "inventoryPolicy.resetTitle": "Redefinir Política de Inventário",
    "inventoryPolicy.resetBody": "Isso restaura ambos os interruptores para seus valores padrão. Isso não pode ser desfeito.",
    "company.manageBranding": "Gerenciar Identidade Visual",
    "company.manageBrandingHint": "Envie ou defina o logotipo da sua empresa em Configurações do Aplicativo.",
    "company.signpost.text": "Procurando por Moeda, Política de Inventário, Lembretes de Pagamento ou Identidade Visual?",
    "company.signpost.link": "Configurações do Aplicativo",
    "branding.lockedTitle": "A identidade visual personalizada é um recurso do plano Forest",
    "branding.lockedBody": "Envie o logotipo da sua própria empresa em todo o aplicativo, exportações e e-mails no plano Forest.",
    "branding.upgradeCta": "Atualizar para o Forest",
    "branding.chooseFile": "Escolher Arquivo",
    "branding.dimensionHint": "PNG, JPG ou WEBP, idealmente com cerca de 584×158px (mesmo tamanho do logotipo do LumberLinq) — mínimo de 200×50px, menos de 5 MB.",
    "branding.resetTitle": "Redefinir Logotipo",
    "branding.resetBody": "Isso remove seu logotipo personalizado e mostra o logotipo padrão do LumberLinq novamente. Isso não pode ser desfeito.",
    "paymentReminders.resetTitle": "Redefinir Lembretes de Pagamento",
    "paymentReminders.resetBody": "Isso restaura todas as configurações de Lembretes de Pagamento para os valores padrão. Isso não pode ser desfeito.",
    "notifPrefs.sectionTitle": "Categorias de Notificação Push",
    "sessions.title": "Onde Você Está Conectado",
    "sessions.subtitle": "Estes dispositivos estão conectados à sua conta. Saia dos que você não reconhece ou não usa mais.",
    "sessions.thisDevice": "Este dispositivo",
    "sessions.onlineNow": "Online agora",
    "sessions.unknownDevice": "Dispositivo desconhecido",
    "sessions.slotWeb": "Navegador",
    "sessions.slotApp": "App",
    "sessions.signOut": "Sair",
    "sessions.signOutOthers": "Sair de todos os outros dispositivos",
    "sessions.cancel": "Cancelar",
    "sessions.confirmHeader": "Sair deste dispositivo?",
    "sessions.confirmMessage": "{device} será desconectado e precisará fazer login novamente.",
    "sessions.confirmOthersHeader": "Sair de todos os outros dispositivos?",
    "sessions.confirmOthersMessage": "Todos os dispositivos, exceto este, serão desconectados e precisarão fazer login novamente.",
    "sessions.signedOutToast": "O dispositivo foi desconectado.",
    "sessions.signedOutOthersToast": "Todos os outros dispositivos foram desconectados.",
    "sessions.signOutFailed": "Não foi possível desconectar o dispositivo. Tente novamente.",
    "sessions.loadFailed": "Não foi possível carregar seus dispositivos.",
    "sessions.retry": "Tentar novamente",
    "sessions.empty": "Nenhum dispositivo encontrado.",
    "notifPrefs.sectionHint": "Desative uma categoria se não quiser que ela avise no seu celular ou navegador — você ainda a verá no sino de notificações de qualquer forma.",
    "pushPrompt.title": "Ativar notificações?",
    "pushPrompt.body": "Saiba na hora quando o status de um embarque mudar, alguém compartilhar uma tally com você, ou sua equipe enviar um convite.",
    "pushPrompt.enable": "Ativar",
    "pushPrompt.notNow": "Agora não",
    "appFeedback.menu": "Enviar Feedback",
    "appFeedback.title": "Enviar Feedback",
    "appFeedback.subtitle": "Diga-nos como o LumberLinq está funcionando para você",
    "appFeedback.question": "Como o LumberLinq está funcionando para você?",
    "appFeedback.rate.sad": "Não está bom",
    "appFeedback.rate.neutral": "Razoável",
    "appFeedback.rate.happy": "Bom",
    "appFeedback.rate.love": "Adoro",
    "appFeedback.likeLabel": "Do que você mais gosta?",
    "appFeedback.improveLabel": "O que devemos melhorar?",
    "appFeedback.privateNote": "Apenas a equipe LumberLinq vê isto.",
    "appFeedback.showSection": "No nosso site",
    "appFeedback.showName": "Mostrar meu nome no site do LumberLinq",
    "appFeedback.showNameHint": "Exibido como primeiro nome + inicial, ex.: \"Sanjay B.\", após aprovação da nossa equipe.",
    "appFeedback.showCompany": "Mostrar também o nome da minha empresa",
    "appFeedback.showCompanyHint": "Desativado, a menos que você ative.",
    "appFeedback.send": "Enviar Feedback",
    "appFeedback.back": "Voltar",
    "appFeedback.thanksTitle": "Obrigado!",
    "appFeedback.thanksBody": "Seu feedback chegou à nossa equipe.",
    "appFeedback.error": "Não foi possível enviar seu feedback. Tente novamente.",
    "appFeedback.promptTitle": "Como o LumberLinq está funcionando para você?",
    "appFeedback.promptBody": "Um toque — isso nos ajuda a melhorar.",
    "appFeedback.notNow": "Agora não",
    "appFeedback.done": "Concluído",
    "appFeedback.chooseRating": "Escolha primeiro como você se sente",
    "adminFeedback.title": "Revisão de Feedback",
    "pay.offlineOr": "ou",
    "pay.offlineProofLabel": "Comprovativo de pagamento (opcional)",
    "pay.offlineProofChoose": "Escolher foto ou PDF",
    "pay.offlineProofHint": "Uma captura do ecrã da transferência ou uma foto do cheque ajuda-nos a confirmar mais depressa. JPG, PNG, WEBP, HEIC ou PDF, até 8 MB.",
    "pay.offlineProofAttach": "Anexar comprovativo",
    "pay.offlineProofReplace": "Substituir comprovativo",
    "pay.offlineProofSavedTitle": "Comprovativo guardado",
    "pay.offlineProofSavedBody": "Vamos vê-lo ao verificar o seu pagamento.",
    "pay.offlineProofError": "O pagamento foi guardado, mas o comprovativo não foi enviado. Tente novamente no cartão de espera.",
    "pay.offlineProofBadTypeTitle": "Ficheiro não permitido",
    "pay.offlineProofBadType": "Escolha uma foto (JPG, PNG, WEBP, HEIC) ou um PDF.",
    "pay.offlineProofTooBigTitle": "Ficheiro demasiado grande",
    "pay.offlineProofTooBig": "O ficheiro deve ter no máximo 8 MB.",
    "adminOffline.viewProof": "Ver comprovativo",
    "adminOffline.noProof": "Sem comprovativo",
    "adminOffline.proofTitle": "Comprovativo de pagamento",
    "adminOffline.proofHint": "Isto é o que o cliente diz ter pago. Confirme sempre o dinheiro no extrato bancário antes de aprovar.",
    "adminOffline.extra": "Excedente",
    "adminOffline.overWarn": "Mais do que o valor devido. Excedente",
    "pay.offlineTurnOffAuto": "Desative a renovação automática acima para pagar por transferência ou cheque.",
    "pay.offlineNotForMonthly": "Os planos mensais renovam automaticamente, por isso transferência ou cheque não está disponível. Escolha um plano mais longo.",
    "pay.offlineButton": "Pagar por transferência bancária / cheque (INR)",
    "pay.offlineWaitingTitle": "O seu pagamento aguarda confirmação",
    "pay.offlineWaitingBody": "Verificamos o banco e ativamos o seu plano. Receberá uma mensagem assim que estiver concluído.",
    "pay.offlineTitle": "Pagar por transferência bancária / cheque",
    "pay.offlineAmountToPay": "Valor a pagar",
    "pay.offlineAmountHint": "Inclui GST e o desconto do cupão. Pague exatamente este valor.",
    "pay.offlineAccountName": "Nome da conta",
    "pay.offlineBank": "Banco",
    "pay.offlineAccountNumber": "Número da conta",
    "pay.offlineBranch": "Agência",
    "pay.offlineChequeTo": "Cheque à ordem de",
    "pay.offlineChequeAddress": "Enviar o cheque para",
    "pay.offlineRemarks": "Escreva nas observações",
    "pay.offlineRemarksHint": "Escreva esta referência nas observações do pagamento (ou no verso do cheque) para encontrarmos o seu pagamento.",
    "pay.offlineIPaid": "Já paguei — indique os detalhes",
    "pay.offlineHowPaid": "Como pagou?",
    "pay.offlineUtr": "Número UTR da transferência",
    "pay.offlineChequeNo": "Número do cheque",
    "pay.offlineRefError": "Indique o número UTR / cheque (mínimo 4 caracteres).",
    "pay.offlineTransferDate": "Data da transferência",
    "pay.offlineChequeDate": "Data no cheque",
    "pay.offlineYourBank": "O seu banco (opcional)",
    "pay.offlineNote": "Nota para nós (opcional)",
    "pay.offlineGstHint": "A fatura GST é enviada quando o pagamento for confirmado.",
    "pay.offlineCancel": "Cancelar",
    "pay.offlineSubmit": "Enviar detalhes do pagamento",
    "pay.offlineSentTitle": "Detalhes recebidos",
    "pay.offlineSentBody": "Vamos confirmar o pagamento e ativar o seu plano. Receberá uma mensagem.",
    "pay.offlineLoadError": "Não foi possível carregar os dados bancários. Tente novamente.",
    "pay.offlineSubmitError": "Não foi possível guardar os detalhes. Nada foi cobrado — tente novamente.",
    "adminOffline.title": "Pagamentos offline",
    "lincLearning.title": "Aprendizado do Linc",
    "lincLearning.subtitle": "Perguntas que o Assistente errou e mudanças de regras aguardando sua aprovação",
    "lincLearning.tabFindings": "Perguntas com falha",
    "lincLearning.tabProposals": "Propostas",
    "lincLearning.tabRuleBook": "Livro de regras",
    "lincLearning.grade.OK": "Correta",
    "lincLearning.grade.PART": "Parcial",
    "lincLearning.grade.WRONG": "Errada",
    "lincLearning.grade.NONE": "Sem resposta",
    "lincLearning.allGrades": "Todos os resultados",
    "lincLearning.allRuns": "Todas as verificações",
    "lincLearning.handledAll": "Tratadas ou não",
    "lincLearning.handledYes": "Tratadas",
    "lincLearning.handledNo": "Pendentes",
    "lincLearning.search": "Buscar pergunta ou grupo",
    "lincLearning.colQuestion": "Pergunta",
    "lincLearning.colAnswer": "Resposta dada",
    "lincLearning.colTrue": "Resposta correta",
    "lincLearning.colNote": "Nota",
    "lincLearning.markHandled": "Marcar como tratada",
    "lincLearning.unmark": "Marcar como pendente",
    "lincLearning.prev": "Anterior",
    "lincLearning.next": "Próximo",
    "lincLearning.page": "Página",
    "lincLearning.empty": "Nada aqui.",
    "lincLearning.kind.WORD": "Palavra do ofício",
    "lincLearning.kind.ASK_BACK": "Perguntar de volta",
    "lincLearning.kind.DEFINITION": "Definição",
    "lincLearning.kind.NEW_DATA": "Novos dados necessários",
    "lincLearning.kind.OTHER": "Outro",
    "lincLearning.status.PROPOSED": "Aguardando",
    "lincLearning.status.APPROVED": "Aprovada",
    "lincLearning.status.REJECTED": "Rejeitada",
    "lincLearning.approve": "Aprovar",
    "lincLearning.reject": "Rejeitar",
    "lincLearning.undo": "Voltar para aguardando",
    "lincLearning.noteHint": "Nota (opcional)",
    "lincLearning.reviewNow": "Executar a revisão agora",
    "lincLearning.reviewNote": "A revisão também roda sozinha a cada dois dias.",
    "lincLearning.addWord": "Adicionar palavra do ofício",
    "lincLearning.word": "Palavra (por exemplo silly)",
    "lincLearning.means": "O que significa",
    "lincLearning.add": "Adicionar",
    "lincLearning.evidence": "Perguntas por trás disso",
    "lincLearning.seen": "vezes perguntado",
    "lincLearning.companies": "empresas",
    "lincLearning.source": "Origem",
    "lincLearning.decidedBy": "Decidido por",
    "lincLearning.termsTitle": "Palavras do ofício que o Assistente conhece",
    "lincLearning.defsTitle": "Definições escritas",
    "lincLearning.rulebookNote": "O livro de regras embutido só muda com uma versão do software. As palavras aprovadas são somadas e valem na hora.",
    "lincLearning.done": "Salvo",
    "lincLearning.failed": "Não foi possível concluir",
    "adminOffline.subtitle": "Confirme transferências e cheques pagos pelos clientes",
    "adminOffline.waiting": "em espera",
    "adminOffline.bankDetails": "Dados bancários",
    "adminOffline.refresh": "Atualizar",
    "adminOffline.noAccessTitle": "Sem acesso",
    "adminOffline.noAccessBody": "Só os aprovadores de pagamentos podem abrir esta página.",
    "adminOffline.search": "Pesquisar empresa, UTR, e-mail",
    "adminOffline.tabWaiting": "Em espera",
    "adminOffline.tabApproved": "Aprovado",
    "adminOffline.tabRejected": "Rejeitado",
    "adminOffline.tabReversed": "Revertido",
    "offlineHist.bannerTitle": "Seu pagamento aguarda confirmação",
    "offlineHist.bannerBody": "Seu plano começa assim que for confirmado, e enviaremos um e-mail.",
    "offlineHist.viewDetails": "Detalhes",
    "offlineHist.withdraw": "Retirar",
    "offlineHist.withdrawTitle": "Retirar este pagamento?",
    "offlineHist.withdrawConfirm": "Use se digitou um UTR ou número de cheque errado, ou pagou de outra forma. O pagamento não será confirmado e você poderá enviá-lo novamente.",
    "offlineHist.withdrawYes": "Sim, retirar",
    "offlineHist.withdrawNo": "Manter",
    "offlineHist.withdrawnTitle": "Pagamento retirado",
    "offlineHist.withdrawnBody": "Você pode enviar os dados do pagamento novamente ou pagar online.",
    "offlineHist.withdrawError": "Não foi possível retirar o pagamento. Tente novamente.",
    "offlineHist.title": "Pagamentos por transferência bancária e cheque",
    "offlineHist.subtitle": "Pagamentos informados para sua empresa",
    "offlineHist.submitted": "Enviado em",
    "offlineHist.reason": "Motivo",
    "offlineHist.statusWaiting": "Aguardando confirmação",
    "offlineHist.statusConfirmed": "Confirmado",
    "offlineHist.statusRejected": "Não confirmado",
    "offlineHist.statusReversed": "Revertido",
    "offlineHist.statusWithdrawn": "Retirado",
    "offlineHist.buyBlocked": "Um pagamento por transferência bancária / cheque aguarda confirmação. Você poderá escolher outro plano depois que ele for confirmado, não confirmado ou retirado.",
    "adminOffline.tabWithdrawn": "Retirado",
    "adminOffline.otherPlanWarn": "Esta empresa já recebeu outro plano ativo depois do envio deste pagamento:",
    "adminOffline.otherPlanConfirm": "Verifiquei e quero aprovar mesmo assim (um segundo plano será adicionado)",
    "adminOffline.colCompany": "Empresa",
    "adminOffline.colPayment": "Pagamento",
    "adminOffline.colAmount": "Valor",
    "adminOffline.colPlan": "Plano",
    "adminOffline.colStatus": "Estado",
    "adminOffline.colSubmitted": "Enviado",
    "adminOffline.received": "Recebido",
    "adminOffline.shortBy": "Em falta",
    "adminOffline.approve": "Aprovar",
    "adminOffline.reject": "Rejeitar",
    "adminOffline.reverse": "Reverter",
    "adminOffline.cancel": "Cancelar",
    "adminOffline.save": "Guardar",
    "adminOffline.emptyTitle": "Nada aqui",
    "adminOffline.emptyBody": "Os pagamentos enviados pelos clientes por transferência ou cheque aparecem aqui.",
    "adminOffline.approveTitle": "Aprovar pagamento",
    "adminOffline.dateOnPayment": "Data",
    "adminOffline.amountDue": "Valor devido",
    "adminOffline.checkStatement": "Verifique primeiro o extrato bancário. Aprove só quando o dinheiro tiver chegado ao banco.",
    "adminOffline.receivedAmount": "Valor recebido no banco",
    "adminOffline.shortWarn": "Menos do que o valor devido. Em falta",
    "adminOffline.acceptShort": "Aceitar o pagamento parcial (por exemplo, imposto retido na fonte)",
    "adminOffline.note": "Nota",
    "adminOffline.approvedOk": "Pagamento aprovado. O plano está ativo.",
    "adminOffline.rejectTitle": "Rejeitar pagamento",
    "adminOffline.rejectReason": "Motivo",
    "adminOffline.rejectHint": "O cliente vê este motivo.",
    "adminOffline.rejectedOk": "Pagamento rejeitado. O cliente foi informado.",
    "adminOffline.reverseTitle": "Reverter pagamento (cheque devolvido / reembolso)",
    "adminOffline.chooseOption": "Escolha o que acontece ao plano",
    "adminOffline.optDeactivate": "Desativar o plano agora",
    "adminOffline.optDeactivateSub": "A empresa perde o plano pago de imediato.",
    "adminOffline.optGrace": "Dar um período de tolerância",
    "adminOffline.optGraceSub": "O plano fica ativo mais 7, 15 ou 30 dias e depois termina.",
    "adminOffline.optKeep": "Manter o plano ativo",
    "adminOffline.optKeepSub": "Só regista a reversão. Resolve com o cliente.",
    "adminOffline.optRefund": "Reembolsar e desativar",
    "adminOffline.optRefundSub": "Registe o reembolso pago e termine o plano agora.",
    "adminOffline.graceDays": "Período de tolerância (dias)",
    "adminOffline.refundAmount": "Valor do reembolso",
    "adminOffline.refundRef": "Referência bancária do reembolso",
    "adminOffline.creditNoteNo": "Número da nota de crédito (opcional)",
    "adminOffline.creditNoteHint": "A aplicação não emite notas de crédito. Indique o número depois de a emitir.",
    "adminOffline.commissionWarn": "A comissão de afiliado não é revertida automaticamente. Verifique manualmente.",
    "adminOffline.reversedOk": "Pagamento revertido. O cliente foi informado.",
    "adminOffline.optionOn": "Oferecer esta opção aos clientes",
    "adminOffline.optionOnHint": "Os clientes veem-na na página de pagamento dos planos INR, depois de preencher os campos obrigatórios.",
    "adminOffline.accountName": "Nome da conta",
    "adminOffline.bank": "Banco",
    "adminOffline.accountNumber": "Número da conta",
    "adminOffline.branch": "Agência",
    "adminOffline.chequePayableTo": "Cheque à ordem de",
    "adminOffline.chequeAddress": "Morada para envio de cheques",
    "adminOffline.instructions": "Instruções adicionais para clientes",
    "adminOffline.lastUpdated": "Última alteração por",
    "adminOffline.settingsSaved": "Dados bancários guardados",
    "adminOffline.errorTitle": "Não foi possível concluir",
    "adminOffline.errorGeneric": "Algo correu mal. Tente novamente.",
    "adminFeedback.subtitle": "Aprove o feedback antes de aparecer em lumberlinq.com",
    "adminFeedback.pending": "Pendentes",
    "adminFeedback.approved": "Aprovados",
    "adminFeedback.rejected": "Rejeitados",
    "adminFeedback.approve": "Aprovar",
    "adminFeedback.reject": "Rejeitar",
    "adminFeedback.reset": "Voltar para Pendente",
    "adminFeedback.colPerson": "Pessoa",
    "adminFeedback.colRating": "Avaliação",
    "adminFeedback.colFeedback": "Feedback",
    "adminFeedback.colWebsite": "No site",
    "adminFeedback.colSource": "Origem",
    "adminFeedback.colDate": "Data",
    "adminFeedback.sourcePublic": "Formulário do site",
    "adminFeedback.sourceApp": "No app",
    "adminFeedback.willShowAs": "Será exibido como",
    "adminFeedback.notOptedIn": "Nome não exibido (sem permissão)",
    "adminFeedback.noName": "Nenhum nome informado",
    "adminFeedback.emptyTitle": "Nada aqui ainda",
    "adminFeedback.emptyBody": "Nenhum feedback nesta lista.",
    "adminFeedback.liked": "Gostou",
    "adminFeedback.problem": "Problema (privado)",
    "adminFeedback.search": "Pesquisar nome, empresa ou texto",
    "adminFeedback.statusChanged": "Feedback atualizado",
    "adminFeedback.loadError": "Não foi possível carregar o feedback",
    "adminFeedback.withCompany": "com empresa",
    "adminFeedback.refresh": "Atualizar",
    "appSettings.feedbackSection": "Feedback e Avaliações nas Lojas",
    "appSettings.feedbackPromptEnabled": "Pedir feedback aos usuários no app",
    "appSettings.feedbackPromptHint": "Mostra um pequeno cartão \"Como o LumberLinq está funcionando para você?\" no Painel. As respostas vão para a Revisão de Feedback, nunca para as lojas.",
    "appSettings.feedbackPromptAfterDays": "Perguntar após (dias desde o cadastro)",
    "appSettings.feedbackPromptRepeatDays": "Não perguntar novamente por (dias)",
    "appSettings.storeReviewEnabled": "Pedir avaliação na App Store / Play Store",
    "appSettings.storeReviewHint": "Usa o próprio pop-up de avaliação da Apple e do Google no iPhone e Android. Acionado apenas pelo uso — nunca ligado ao cartão de feedback.",
    "appSettings.storeReviewAfterTallies": "Após esta quantidade de folhas de contagem",
    "appSettings.storeReviewAfterDays": "Ou após (dias desde o cadastro)",
    "notifPrefs.pushStatusTitle": "Notificações Push",
    "notifPrefs.pushGrantedHint": "As notificações push estão ativadas para este dispositivo.",
    "notifPrefs.pushPromptHint": "Ative as notificações para receber alertas neste dispositivo.",
    "notifPrefs.pushDeniedNativeHint": "As notificações estão desativadas para este dispositivo.",
    "notifPrefs.pushDeniedWebHint": "As notificações estão bloqueadas para este site — ative-as nas configurações do seu navegador.",
    "notifPrefs.pushUnsupportedHint": "Este dispositivo ou navegador não suporta notificações push.",
    "notifPrefs.pushEnableButton": "Ativar",
    "notifPrefs.openSettingsButton": "Abrir Configurações",
    "notifPrefs.teamInvites": "Convites de equipe",
    "notifPrefs.teamInvites.hint": "Quando alguém te convida para uma equipe, ou seu convite é aceito ou recusado.",
    "notifPrefs.security": "Alertas de segurança",
    "notifPrefs.security.hint": "Avisos de login e segurança da conta. Alertas críticos, como troca de senha, são sempre enviados independentemente desta configuração.",
    "notifPrefs.billing": "Cobrança e pagamentos",
    "notifPrefs.billing.hint": "Renovações de assinatura, lembretes de pagamento, faturas e atualizações de pagamentos por transferência / cheque.",
    "notifPrefs.shipments": "Embarques",
    "notifPrefs.shipments.hint": "Atualizações sobre seus embarques e remessas.",
    "notifPrefs.tally": "Fichas de tally",
    "notifPrefs.tally.hint": "Atualizações sobre as fichas de tally em que você está trabalhando.",
    "notifPrefs.inventoryProcess": "Inventário e ordens de serraria",
    "notifPrefs.inventoryProcess.hint": "Movimentações de estoque e atualizações de ordens de serraria.",
    "notifPrefs.masterData": "Produtos, parceiros e locais",
    "notifPrefs.masterData.hint": "Alterações em produtos, parceiros de negócios ou locais.",
    "notifPrefs.shareLinks": "Links compartilhados",
    "notifPrefs.shareLinks.hint": "Atividade nos links que você compartilhou com outras pessoas.",
    "notifPrefs.affiliate": "Programa de afiliados",
    "notifPrefs.affiliate.hint": "Status da inscrição, comissões e pagamentos da sua conta de afiliado.",
    "notifPrefs.crm": "CRM de Vendas",
    "notifPrefs.crm.hint": "Leads atribuídos a você, lembretes de tarefas, respostas, atualizações de comissão e pagamento, e marcos de metas.",
    "common.typeConfirm": "Digite CONFIRM para continuar",
    "paymentReminders.offBanner": "Lembretes de Pagamento está desativado — estas configurações são salvas, mas só terão efeito quando você o ativar acima.",
    "settingsNudge.title": "Termine de configurar seu espaço de trabalho",
    "settingsNudge.body": "Moeda, marca, lembretes de pagamento e muito mais — tudo em um só lugar.",
    "settingsNudge.cta": "Abrir Configurações do Aplicativo",
    "paymentReminders.testEmail.title": "Enviar e-mails de teste",
    "paymentReminders.testEmail.desc": "Veja o formato exato do lembrete + relatório antes de ativar para Parceiros de Negócios reais. Nunca afeta dados reais.",
    "paymentReminders.testEmail.cta": "Enviar Teste",
    "inventory.processing": "Ordens de Serraria",
    "inventory.inProcess": "Em ordem de serraria",
    "inventory.newProcessingRun": "Nova Ordem de Serraria",
    "inventory.processingDate": "Data da Ordem de Serraria",
    "inventory.selectInputTus": "Selecionar Unidades de Estoque de entrada",
    "Mill Jobs": "Ordens de Serraria",
    "Stock in Hand": "Estoque em mãos",
    "inventory.runCode": "ID da Ordem de Serraria",
    "crm.liveCall.button": "Chamada de vídeo",
    "crm.liveCall.title": "Chamada de vídeo",
    "crm.liveCall.starting": "Iniciando a chamada…",
    "crm.liveCall.startFailed": "Não foi possível iniciar a chamada.",
    "crm.liveCall.retry": "Tentar novamente",
    "crm.liveCall.inProgress": "Uma chamada está em andamento.",
    "crm.liveCall.rejoin": "Entrar de novo",
    "crm.liveCall.end": "Encerrar chamada",
    "crm.liveCall.endConfirm": "Encerrar a chamada para todos?",
    "crm.liveCall.openTab": "Abrir em uma nova aba",
    "crm.liveCall.frameHint": "Se a chamada não aparecer aqui, abra-a em uma nova aba.",
    "crm.liveCall.inviteTitle": "Convidar um convidado",
    "crm.liveCall.makeLink": "Criar link de convidado",
    "crm.liveCall.newLink": "Criar um novo link",
    "crm.liveCall.copyLink": "Copiar",
    "crm.liveCall.linkCopied": "Copiado",
    "crm.liveCall.newLinkNote": "Criar um novo link faz o anterior parar de funcionar. O link vale por algumas horas.",
    "crm.liveCall.cancelLink": "Cancelar link",
    "crm.liveCall.linkCancelled": "O link do convidado não funciona mais.",
    "crm.liveCall.whoJoined": "Quem entrou",
    "crm.liveCall.noOneJoined": "Ninguém entrou pelo link ainda.",
    "crm.liveCall.admitNote": "Cada convidado espera até você deixá-lo entrar: toque em Admit na chamada. Convidados não podem enviar arquivos, a menos que você permita nas configurações da chamada.",
    "crm.liveCall.codeNote": "Um link enviado por e-mail também exige um código de 6 dígitos enviado ao mesmo endereço, então um link encaminhado não serve. Não encaminhe também um link que você mesmo copiou.",
    "crm.liveCall.emailPlaceholder": "E-mail do convidado",
    "crm.liveCall.sendEmail": "Enviar por e-mail",
    "crm.liveCall.emailSent": "O convite foi enviado.",
    "crm.liveCall.enterEmail": "Digite o e-mail do convidado.",
    "crm.liveCall.phoneNote": "Para apresentar sua tela, use um computador. Celulares podem entrar e conversar.",
    "live.title": "Entrar na chamada de vídeo",
    "live.host": "Anfitrião",
    "live.name": "Seu nome",
    "live.email": "Seu e-mail",
    "live.join": "Entrar na chamada",
    "live.joining": "Entrando…",
    "live.loading": "Carregando…",
    "live.privacy": "Usamos seu nome e e-mail apenas para esta chamada. A chamada não é gravada.",
    "live.phoneNote": "Você pode entrar pelo celular. Permita a câmera e o microfone quando solicitado.",
    "live.linkOnly": "Este link é só para você. Por favor, não o encaminhe.",
    "live.waitNote": "Depois de entrar, o anfitrião deixa você participar. Isso pode levar um instante.",
    "live.codeIntro": "Para ter certeza de que é você, enviamos um código de 6 dígitos para o endereço que recebeu o convite:",
    "live.sendCode": "Enviar um código",
    "live.sendAgain": "Enviar de novo",
    "live.codeSent": "Código enviado. Vale por 10 minutos.",
    "live.codeLabel": "Código de 6 dígitos",
    "cw.focusOn": "Tela cheia: ocultar a barra superior",
    "cw.focusOff": "Mostrar a barra superior",
    "ch.help": "Ajuda",
    "ch.guest.title": "Problemas para entrar?",
    "ch.guest.t1": "Use um computador ou celular com câmera e microfone. Chrome, Edge, Safari e Firefox funcionam.",
    "ch.guest.t2": "Quando o navegador perguntar, toque em Permitir para a câmera e o microfone.",
    "ch.guest.t3": "Depois de tocar em Entrar, o anfitrião precisa deixar você entrar. Aguarde um momento.",
    "ch.guest.t4": "Sem imagem ou som? Clique no ícone de câmera ou cadeado na barra de endereço, escolha Permitir e atualize a página.",
    "ch.guest.t5": "Preso em \"Iniciando a chamada…\"? Verifique a internet e toque em Tentar de novo ou Abrir em nova aba.",
    "ch.guest.t6": "Este link é só para você. Se outra pessoa precisar entrar, peça à equipe LumberLinq para convidá-la.",
    "ch.customer.title": "Como funciona o suporte por tela",
    "ch.customer.t1": "O suporte pede para ver sua tela. Nada começa até você apertar o botão de compartilhar.",
    "ch.customer.t2": "Escolha somente a aba do LumberLinq. Não escolha a tela inteira nem outra janela.",
    "ch.customer.t3": "O suporte só pode olhar. Não pode clicar nem digitar por você, e nada é gravado.",
    "ch.customer.t4": "Toque em Parar no alto quando quiser encerrar. Celular ou app não compartilham tela: use Chrome ou Edge no computador.",
    "ch.host.title": "Guia da chamada de vídeo",
    "ch.host.t1": "Inicie a chamada pela conta ou pelo negócio. Você entra como anfitrião.",
    "ch.host.t2": "Enviar o link por e-mail é mais seguro: o convidado precisa de um código de 6 dígitos enviado a esse endereço.",
    "ch.host.t3": "Cada convidado espera até você tocar em Admit na chamada. Admita só quem você conhece.",
    "ch.host.t4": "Veja \"Quem entrou\" abaixo. Se houver alguém desconhecido, remova-o na chamada e toque em Cancelar link.",
    "ch.host.t5": "Nunca encaminhe um link de convidado você mesmo. Crie um link novo para cada pessoa.",
    "ch.host.t6": "Toque em Encerrar chamada ao terminar. Uma entrada de chamada de vídeo vai para a linha do tempo da conta. Nada é gravado.",
    "ch.check.run": "Verificar minha configuração",
    "ch.check.testing": "Testando…",
    "ch.check.browserOk": "Este navegador pode entrar em uma chamada.",
    "ch.check.browserBad": "Este navegador não pode entrar em uma chamada. Use Chrome, Edge, Safari ou Firefox.",
    "ch.check.onlineOk": "Sua internet está conectada.",
    "ch.check.onlineBad": "Você parece estar offline. Verifique a internet.",
    "ch.check.camOk": "A câmera funciona.",
    "ch.check.camBad": "A câmera está bloqueada ou não foi encontrada. Permita na barra de endereço e teste de novo.",
    "ch.check.micOk": "O microfone funciona.",
    "ch.check.micBad": "O microfone está bloqueado ou não foi encontrado. Permita na barra de endereço e teste de novo.",
    "ch.check.shareOk": "Você pode compartilhar sua tela.",
    "ch.check.shareNo": "Este dispositivo não compartilha tela (celulares e o app não compartilham). Você ainda pode falar e conversar.",
    "live.ended": "Esta chamada terminou.",
    "live.expired": "Este link expirou. Peça um novo.",
    "live.off": "As chamadas de vídeo estão desativadas no momento.",
    "live.invalid": "Este link não é válido.",
    "live.failed": "Não foi possível entrar. Tente novamente.",
    "live.securityWait": "Conclua a verificação de segurança.",
    "live.frameHint": "Se a chamada não aparecer aqui, abra-a em uma nova aba.",
    "live.openTab": "Abrir em uma nova aba",
    "ss.title": "Suporte por tela",
    "ss.joining": "Conectando…",
    "ss.failed": "Não foi possível conectar. Tente novamente.",
    "ss.retry": "Tentar novamente",
    "ss.howTitle": "Como compartilhar sua aba do LumberLinq",
    "ss.step1": "Pressione o botão de compartilhar tela (o ícone de monitor) na parte inferior da chamada.",
    "ss.step2": "Escolha a aba chamada LumberLinq (\"Esta aba\"). Não escolha uma janela nem a tela inteira.",
    "ss.step3": "Você pode parar a qualquer momento com o botão \"Parar de compartilhar\" do navegador, ou pressionar Encerrar sessão aqui.",
    "ss.noShare": "O compartilhamento de tela não funciona em celular nem no app. Abra o LumberLinq em um navegador de computador (Chrome, Edge, Firefox ou Safari) para compartilhar sua aba do LumberLinq. Você ainda pode falar e conversar com o suporte aqui.",
    "ss.liveBanner": "O suporte vê somente a aba que você escolher compartilhar. Nada é gravado.",
    "ss.stop": "Encerrar sessão",
    "ss.stopConfirm": "Encerrar esta sessão de suporte por tela?",
    "ss.openTab": "Abrir em uma nova aba",
    "ss.frameHint": "Se a chamada não aparecer aqui, abra-a em uma nova aba.",
    "ss.tabOnly": "Somente a sua aba do LumberLinq é compartilhada, nada mais.",
    "ss.card.title": "Suporte por tela",
    "ss.card.ask": "Pedir ao suporte para ver minha aba do LumberLinq",
    "ss.card.askHint": "O suporte pode ver a sua aba do LumberLinq para ajudar você. Somente essa aba é compartilhada, você decide iniciar e pode parar a qualquer momento. Nada é gravado.",
    "ss.card.waiting": "Aguardando a resposta do suporte…",
    "ss.card.cancel": "Cancelar pedido",
    "ss.card.invited": "O suporte gostaria de ver a sua aba do LumberLinq.",
    "ss.card.invitedOther": "O suporte pediu a outra pessoa da sua empresa para compartilhar a tela.",
    "ss.card.share": "Compartilhar minha aba do LumberLinq",
    "ss.card.notNow": "Agora não",
    "ss.card.live": "Há uma sessão de suporte por tela aberta.",
    "ss.card.liveOther": "Há uma sessão de suporte por tela aberta com outra pessoa da sua empresa.",
    "ss.card.rejoin": "Abrir sessão",
    "ss.card.ended": "A última sessão de suporte por tela terminou.",
    "ss.card.declined": "O último pedido de suporte por tela foi recusado.",
    "ss.card.expired": "O último pedido de suporte por tela expirou.",
    "ss.card.requestFailed": "Não foi possível enviar o pedido.",
    "ss.prompt.title": "O suporte gostaria de ver a sua tela",
    "ss.prompt.body": "O suporte está aguardando você. Você decide iniciar e pode parar a qualquer momento. Nada é gravado.",
    "ss.prompt.open": "Abrir agora",
    "ss.prompt.later": "Agora não",
    "ss.prompt.ticket": "Abrir o ticket",
  },
  fr: {
    "crmwa.newNumbers": "Nouveaux numéros",
    "crmwa.newNumbersHint": "Des personnes qui vous ont écrit depuis un numéro non enregistré dans le CRM.",
    "crmwa.tabNew": "En attente",
    "crmwa.tabBlocked": "Bloqués",
    "crmwa.searchPlaceholder": "Rechercher un nom ou un numéro…",
    "crmwa.firstMessage": "Premier message",
    "crmwa.lastMessage": "Dernier",
    "crmwa.noName": "Nom non communiqué",
    "crmwa.notSaved": "Pas encore dans votre CRM",
    "crmwa.createLead": "Créer un lead",
    "crmwa.block": "Bloquer comme spam",
    "crmwa.unblock": "Débloquer",
    "crmwa.blockedBadge": "Bloqué",
    "crmwa.leadBadge": "Lead créé",
    "crmwa.openChat": "Ouvrir la discussion",
    "crmwa.emptyTitle": "Aucun nouveau numéro",
    "crmwa.emptySub": "Quand une nouvelle personne écrit à votre numéro WhatsApp, elle apparaît ici pour examen. Les contacts enregistrés n'apparaissent jamais ici.",
    "crmwa.emptyBlockedTitle": "Aucun numéro bloqué",
    "crmwa.emptyBlockedSub": "Les numéros que vous bloquez comme spam sont listés ici, pour que vous puissiez les débloquer à tout moment.",
    "crmwa.selectTitle": "Sélectionnez un numéro",
    "crmwa.selectSub": "Lisez ce que la personne a écrit, puis créez un lead ou bloquez le numéro.",
    "crmwa.whatTheyWrote": "Ce que la personne a écrit",
    "crmwa.blockedNote": "Les messages de ce numéro sont ignorés. Débloquez-le pour voir les nouveaux messages.",
    "crmwa.blockConfirmTitle": "Bloquer ce numéro ?",
    "crmwa.blockConfirmSub": "Ses nouveaux messages seront ignorés. Vous pourrez le débloquer plus tard depuis l'onglet Bloqués.",
    "crmwa.cancel": "Annuler",
    "crmwa.blockConfirm": "Oui, bloquer",
    "crmwa.blockedToast": "Numéro bloqué",
    "crmwa.unblockedToast": "Numéro débloqué",
    "crmwa.leadCreatedToast": "Lead créé",
    "crmwa.leadCreatedSub": "La discussion est maintenant dans votre boîte de réception.",
    "crmwa.errorTitle": "Un problème est survenu",
    "crmwa.loadError": "Impossible de charger les numéros.",
    "crmwa.sheetTitle": "Créer un lead",
    "crmwa.sheetSub": "Transformez ce numéro WhatsApp en lead que votre équipe peut suivre.",
    "crmwa.fldName": "Nom de la personne",
    "crmwa.fldNameHint": "Issu de son profil WhatsApp. Vous pouvez le corriger.",
    "crmwa.fldCompany": "Entreprise (facultatif)",
    "crmwa.fldCompanyHint": "Laissez vide pour utiliser son nom et son numéro.",
    "crmwa.fldOwner": "Responsable du lead",
    "crmwa.ownerOnlyYou": "Ce lead sera à vous.",
    "crmwa.fldNote": "Note (facultatif)",
    "crmwa.notePlaceholder": "Tout ce que l'équipe doit savoir…",
    "crmwa.accountWillBe": "Nom du compte",
    "crmwa.contactWillBe": "Contact",
    "crmwa.you": "Vous",
    "crmwa.creating": "Création…",
    "crmwa.whatHappens": "Cela crée un compte, un contact avec ce numéro de mobile et une affaire, et place la discussion dans votre boîte de réception.",
    "crmwa.close": "Fermer",
    "crmwa.mobile": "Mobile",
    "crmwa.pickOwner": "Choisissez le responsable de ce lead",
    "crmwa.freeTextNote": "Vous pouvez répondre en texte libre pendant 24 heures après son dernier message.",
    "crmai.headerBtn": "Linc AI",
    "crmai.barOn": "Linc AI répond à cette discussion",
    "crmai.barSuggest": "Linc AI rédige des réponses suggérées pour vous",
    "crmai.barPaused": "Vous avez cette discussion. Linc AI reste silencieux un moment.",
    "crmai.barHandoff": "Linc AI vous a passé cette discussion.",
    "crmai.barStopped": "Linc AI est arrêté dans cette discussion.",
    "crmai.stoppedSpam": "Cela ressemblait à du spam.",
    "crmai.stoppedFlood": "Le client a envoyé trop de messages trop vite.",
    "crmai.stoppedPerson": "Il a été désactivé ici.",
    "crmai.takeOver": "Je m'en occupe",
    "crmai.stop": "Arrêter l'IA ici",
    "crmai.handBack": "Laisser Linc AI répondre",
    "crmai.draftTitle": "Suggestion de Linc AI",
    "crmai.draftHandoff": "Linc AI pense qu'une personne doit prendre le relais",
    "crmai.draftUse": "Utiliser cette réponse",
    "crmai.draftDiscard": "Ignorer",
    "crmai.takeOverToast": "Linc AI restera silencieux dans cette discussion",
    "crmai.stopToast": "Linc AI arrêté dans cette discussion",
    "crmai.handBackToast": "Linc AI répondra de nouveau",
    "crmai.settings": "Réponses de Linc AI",
    "crmai.settingsSub": "Choisissez pour qui Linc AI répond, et comment.",
    "crmai.master": "Interrupteur général",
    "crmai.masterHint": "Désactivé signifie que Linc AI n'écrit jamais à personne.",
    "crmai.modeOff": "Désactivé",
    "crmai.modeSuggest": "Suggérer",
    "crmai.modeAuto": "Auto",
    "crmai.modeSuggestHint": "Linc AI rédige un brouillon. Une personne le relit et l'envoie.",
    "crmai.modeAutoHint": "Linc AI répond seul et passe la main quand il le faut.",
    "crmai.team": "Commerciaux",
    "crmai.teamHint": "Linc AI répond aux discussions des comptes dont le responsable est en Suggérer ou Auto.",
    "crmai.unowned": "Discussions sans responsable",
    "crmai.coreLocked": "Seul un Super Admin ou Root peut modifier ceci.",
    "crmai.limits": "Limites",
    "crmai.maxInRow": "Messages de Linc AI d'affilée, puis passage à une personne",
    "crmai.maxPerHour": "Maximum de messages de Linc AI par heure",
    "crmai.maxPerDay": "Maximum de messages de Linc AI par jour",
    "crmauto.chip": "Non vérifié",
    "crmauto.chipTip": "Ajouté automatiquement à partir d’un message WhatsApp. Vérifiez le nom et le numéro, puis touchez Confirmer.",
    "crmauto.confirm": "Confirmer le contact",
    "crmauto.confirmTip": "J’ai vérifié ce contact",
    "crmauto.confirmedTitle": "Confirmé",
    "crmauto.confirmedText": "L’étiquette Non vérifié a disparu.",
    "crmauto.settingTitle": "Ajouter automatiquement les nouveaux numéros WhatsApp",
    "crmauto.settingHint": "Quand une nouvelle personne écrit sur WhatsApp, l’ajouter automatiquement comme contact (étiquette Non vérifié) pour que Linc AI puisse répondre. Le spam, l’excès de messages et les numéros bloqués ne sont jamais ajoutés. Seul un Super Admin ou Root peut modifier ceci.",
    "crmauto.settingSwitch": "Ajouter les nouveaux numéros automatiquement",
    "crmauto.perDay": "Nombre maximum de contacts ajoutés automatiquement par jour",
    "legal.bannerTitleUpdated": "Documents juridiques mis à jour.",
    "legal.bannerLeadUpdated": "Nous avons mis à jour",
    "legal.bannerTitleNew": "Veuillez accepter nos documents juridiques.",
    "legal.bannerLeadNew": "Veuillez consulter",
    "legal.dialogTitleUpdated": "Documents juridiques mis à jour",
    "legal.dialogTitleNew": "Documents juridiques",
    "legal.dialogBodyUpdated": "Nous avons mis à jour les documents ci-dessous. Veuillez les consulter et confirmer pour continuer.",
    "legal.dialogBodyNew": "Veuillez consulter les documents ci-dessous et confirmer pour continuer.",
    "invite.acceptTitle": "Rejoindre cette entreprise",
    "invite.acceptText": "Avant de rejoindre, veuillez confirmer l’accord.",
    "invite.acceptButton": "Accepter l’invitation",
    "pay.offlineLive": "Cette page se met à jour toute seule.",
    "pay.cardPaused": "Le paiement par carte est suspendu pendant que votre virement est en attente.",
    "pay.outcomeApprovedTitle": "Votre paiement a été confirmé",
    "pay.outcomeApprovedBody": "Votre forfait est actif. Continuez pour commencer à utiliser LumberLinq.",
    "pay.outcomeContinue": "Continuer",
    "pay.outcomeRejectedTitle": "Votre paiement n’a pas pu être confirmé",
    "pay.outcomeReversedTitle": "Votre paiement a été annulé",
    "pay.outcomeTryAgainBody": "Vous pouvez le soumettre à nouveau ou payer autrement.",
    "pay.outcomeTryAgain": "Payer à nouveau",
    "sp.seePlans": "Voir les forfaits",
    "sp.backToWaiting": "Retour à mon paiement",
    "sp.yourSelection": "Votre sélection",
    "adminOffline.waTemplate": "Message WhatsApp à l’approbation : nom du modèle",
    "adminOffline.waTemplateLang": "Langue du modèle (par exemple en ou hi)",
    "adminOffline.waValues": "Ordre des valeurs dans ce modèle (séparées par des virgules : name, plan, amount, company, date, reference, method)",
    "adminOffline.waRejectedTemplate": "Nom du modèle quand un paiement n’a pas pu être confirmé",
    "adminOffline.waRejectedLang": "Langue de ce modèle",
    "adminOffline.waPlanEndingTemplate": "Nom du modèle 3 jours avant la fin d’un forfait",
    "adminOffline.waPlanEndingLang": "Langue de ce modèle",
    "adminOffline.waValuesHint": "Chaque message ci-dessus n’est envoyé que si le nom du modèle est rempli et approuvé chez Meta. Utilisez la langue exactement comme Meta l’affiche (en ou en_US).",
    "adminOffline.waTemplateHint": "Nom d’un modèle UTILITY approuvé par Meta, avec trois variables : prénom, forfait, montant. Laissez vide pour ne pas envoyer de WhatsApp. Le client reçoit toujours une notification push et un e-mail.",
    "sp.seeAll": "Voir toutes les fonctionnalités",
    "sp.showLess": "Voir moins",
    "sp.chooseHint": "Choisissez un forfait pour continuer",
    "pay.billingIncomplete": "Veuillez compléter les informations de facturation signalées en rouge.",
    "pay.termsNotSaved": "Nous n’avons pas pu enregistrer votre acceptation des conditions. Veuillez réessayer.",
    "pay.reviewAndPay": "Vérifier et payer",
    "crmai.timing": "Délais",
    "crmai.delay": "Attente avant de répondre (secondes)",
    "crmai.pause": "Silence après la réponse d'une personne (heures)",
    "crmai.offTitle": "Quand Linc AI est désactivé",
    "crmai.offHint": "Les clients reçoivent ce message à la place, au plus une fois par période de silence dans chaque discussion.",
    "crmai.offSwitch": "Envoyer ce message quand Linc AI est désactivé",
    "crmai.offText": "Message",
    "crmai.offPlaceholder": "Merci pour votre message ! Notre équipe vous répondra bientôt.",
    "crmai.knowledge": "Ce que Linc AI peut utiliser",
    "crmai.links": "Liens qu'il peut partager (un par ligne)",
    "crmai.linksPlaceholder": "Tarifs : https://…\nEssai gratuit : https://…",
    "crmai.facts": "Faits sur LumberLinq (sans prix)",
    "crmai.factsPlaceholder": "Ce que fait LumberLinq, pour qui, comment fonctionne l'essai…",
    "crmai.helpNotes": "Pour les questions d'utilisation, il se sert aussi des notes d'aide de Linc AI.",
    "crmai.try": "Essayer un message de client",
    "crmai.tryPlaceholder": "Écrivez ce qu'un client pourrait écrire…",
    "crmai.tryBtn": "Essayer",
    "crmai.trying": "Réflexion…",
    "crmai.tryIntent": "Compris comme",
    "crmai.tryHandoff": "Passerait la main à une personne",
    "crmai.today": "Aujourd'hui",
    "crmai.statAuto": "Répondu",
    "crmai.statDrafts": "Brouillons",
    "crmai.statHandoffs": "Transmis",
    "crmai.statTokens": "Jetons utilisés",
    "crmai.save": "Enregistrer",
    "crmai.saving": "Enregistrement…",
    "crmai.saved": "Enregistré",
    "crmai.savedSub": "Paramètres de Linc AI mis à jour.",
    "crmai.loadError": "Impossible de charger les paramètres de Linc AI.",
    "crmai.abuseTitle": "Spam et trop de messages",
    "crmai.abuseHint": "Linc AI s'arrête un moment dans une discussion, puis répond de nouveau tout seul. Un deuxième arrêt dans la semaine dure jusqu'à ce qu'une personne le réactive. Un client qui envoie trop de messages reçoit d'abord un avis poli ; un spam évident n'en reçoit aucun.",
    "crmai.floodMinutes": "Arrêt après trop de messages (minutes)",
    "crmai.spamHours": "Arrêt après un spam (heures)",
    "crmai.floodNotice": "Avis envoyé avant un arrêt pour trop de messages",
    "crmai.floodNoticePlaceholder": "Laissez vide pour utiliser : Je ne peux plus répondre à d'autres messages pour le moment. Si cela concerne LumberLinq, un membre de l'équipe vous répondra bientôt.",
    "crmai.resumesAt": "Il reprend tout seul à",
    "crmfile.kindImage": "Photo",
    "crmfile.kindVideo": "Vidéo",
    "crmfile.kindAudio": "Message vocal",
    "crmfile.kindSticker": "Autocollant",
    "crmfile.kindDoc": "Document",
    "crmfile.receiving": "Réception…",
    "crmfile.failed": "Impossible de l'enregistrer. Ouvrez WhatsApp sur le téléphone pour le voir.",
    "crmfile.download": "Télécharger",
    "crmfile.attach": "Joindre un fichier",
    "crmfile.tooBigImage": "Une photo peut faire jusqu'à 5 Mo.",
    "crmfile.tooBigFile": "Un fichier peut faire jusqu'à 10 Mo.",
    "crmfile.notSent": "Fichier non envoyé",
    "crmfile.captionHint": "votre texte l'accompagne",
    "crmfile.captionPlaceholder": "Ajoutez un message pour accompagner le fichier (facultatif)…",
    "crmfile.remove": "Retirer le fichier",
    "crmverify.title": "Approuver l'accès WhatsApp ?",
    "crmverify.text": "Quelqu'un, depuis ce numéro WhatsApp, demande l'aide de l'assistant LumberLinq pour votre compte :",
    "crmverify.hint": "N'approuvez que si c'est vous. La personne pourra alors obtenir les notes d'aide que votre rôle autorise, pendant 15 minutes. Rien ne peut être modifié.",
    "crmverify.more": "autre(s) demande(s) en attente",
    "crmverify.approve": "Approuver",
    "crmverify.deny": "Refuser",
    "crmverify.approvedTitle": "Approuvé",
    "crmverify.approvedSub": "La discussion WhatsApp peut maintenant recevoir de l'aide pendant 15 minutes.",
    "crmverify.deniedTitle": "Refusé",
    "crmverify.deniedSub": "Ce numéro est bloqué pendant une heure.",
    "crmverify.expired": "Cette demande a expiré ou a déjà été traitée.",
    "crmverify.settingTitle": "Support client sur WhatsApp",
    "crmverify.settingHint": "Un client qui demande de l'aide pour son propre compte doit d'abord prouver son identité : un appui sur Approuver dans son application connectée, ou un code envoyé à son e-mail enregistré. Linc AI ne répond alors qu'avec les notes d'aide que son rôle autorise, et les informations de forfait seulement après une approbation dans l'application par un Owner ou Admin de l'entreprise. Rien n'est jamais modifié via WhatsApp.",
    "crmverify.settingSwitch": "Autoriser le support client sur WhatsApp",
    "crmqr.button": "Messages prêts à l'emploi",
    "crmqr.title": "Messages prêts à l'emploi",
    "crmqr.sub": "Choisissez-en un pour les questions courantes et le marketing. Vous pouvez le modifier avant l'envoi.",
    "crmqr.search": "Rechercher, ex. : prix, démo, hors ligne…",
    "crmqr.all": "Tous",
    "crmqr.emptyTitle": "Aucun message trouvé",
    "crmqr.emptySub": "Essayez d'autres mots ou effacez les filtres.",
    "crmqr.clear": "Effacer les filtres",
    "crmqr.hint": "Le prénom du client est rempli. Le message va dans la zone de saisie, et vous appuyez sur Envoyer.",
    "crmqr.cat.welcome": "Accueil",
    "crmqr.cat.product": "Produit",
    "crmqr.cat.pricing": "Tarifs",
    "crmqr.cat.start": "Démarrer",
    "crmqr.cat.help": "Aide",
    "crmqr.cat.qa": "Questions courantes",
    "crmqr.cat.followup": "Relance",
    "crmqr.cat.closing": "Clôture",
    "tallysheet.tu.stockAllOrigins": "Toutes origines",
    "tallysheet.tu.stockOriginUnknown": "Origine inconnue",
    "tallysheet.tu.pickOrigin": "Choisir une origine",
    "inventory.rowOnlyFree": "Seulement {free} libres sur {need} — touchez pour corriger",
    "inventory.rowNoneFree": "Aucun libre — touchez pour corriger",
    "rowClash.needsOne": "ligne a été ajoutée au même endroit que les lignes de quelqu'un d'autre",
    "rowClash.needsMany": "lignes ont été ajoutées au même endroit que les lignes de quelqu'un d'autre",
    "rowClash.prev": "Ligne en conflit précédente",
    "rowClash.next": "Ligne en conflit suivante",
    "rowClash.showOnlyTip": "N'afficher que les lignes ajoutées au même endroit par deux personnes",
    "rowClash.showAll": "Afficher toutes les lignes",
    "rowClash.showOnly": "N'afficher que celles-ci",
    "rowClash.change": "Modifier",
    "rowClash.markCheckedTip": "Efface ces marques pour tous — rien n'est déplacé ni supprimé",
    "rowClash.markChecked": "Marquer comme vérifié",
    "rowClash.title": "Lignes ajoutées au même endroit",
    "rowClash.intro": "Deux personnes ont ajouté des lignes au même endroit de cette feuille. Les deux ensembles sont gardés. Choisissez l'ordre, ou supprimez un ensemble si les mêmes grumes ont été mesurées deux fois.",
    "rowClash.rows": "Lignes :",
    "rowClash.wasThere": "Étaient là en premier",
    "rowClash.wasPlaced": "Ont été placées à côté",
    "rowClash.chooseLabel": "Que faut-il faire ?",
    "rowClash.current": "Actuel",
    "rowClash.cannotMove": "Une commande sur mesure est liée à l'une de ces lignes, l'ordre ne peut donc pas être changé.",
    "rowClash.confirmRemove": "Cela supprime ces lignes pour tous. C'est définitif. Touchez encore pour confirmer.",
    "rowClash.confirmYes": "Oui, supprimer",
    "rowClash.apply": "Appliquer",
    "rowClash.loadFailed": "Impossible de charger. Vérifiez la connexion et réessayez.",
    "rowClash.noRoom": "Pas de place pour y mettre les lignes. Rechargez la feuille et réessayez.",
    "rowClash.applyFailed": "Impossible d'appliquer. Rechargez la feuille et réessayez.",
    "rowClash.someone": "quelqu'un",
    "rowClash.opt.mineAfter": "Garder les deux — les miennes après les leurs",
    "rowClash.opt.mineFirst": "Garder les deux — les miennes d'abord",
    "rowClash.opt.dropMine": "Garder les leurs, retirer les miennes",
    "rowClash.opt.deleteTheirs": "Garder les miennes, supprimer les leurs",
    "rowClash.opt.firstThen": "Garder les deux — d'abord les lignes de {first}, puis celles de {second}",
    "rowClash.opt.keepOnly": "Garder les lignes de {keep}, retirer celles de {remove}",
    "rowClash.hint.order": "{first} d'abord, puis {second} — chaque ensemble reste groupé",
    "rowClash.hint.remove": "Retire {count} ligne(s) ajoutée(s) par {name}",
    "rowClash.placedTitle": "Lignes ajoutées au même endroit",
    "rowClash.placedBody": "{count} de vos lignes ont été placées après les lignes que {names} a ajoutées au même endroit. Utilisez « Lignes en conflit » au-dessus de la feuille pour vérifier ou modifier.",
    "rowClash.placedAsIs": "{count} de vos lignes ont été enregistrées, mais quelqu'un d'autre a ajouté des lignes au même endroit. Vérifiez-les au-dessus de la feuille.",
    "syncIssues.keepMine": "Garder la mienne (enregistrer par-dessus)",
    "syncIssues.rowConflict": "Quelqu'un d'autre a modifié ces lignes pendant que vous étiez hors ligne. Gardez la vôtre, ou Supprimez pour garder la leur.",
    "tallysheet.rowConflict.title": "Modifié par quelqu'un d'autre",
    "tallysheet.rowConflict.message": "Quelqu'un d'autre a modifié ces lignes après l'ouverture de cette feuille. Ligne :",
    "tallysheet.rowConflict.choice": "Garder la mienne enregistre votre version à la place de la leur. Voir leur modification enregistre vos autres lignes puis recharge la feuille — votre modification de ces lignes est abandonnée.",
    "tallysheet.rowConflict.keepMine": "Garder la mienne",
    "tallysheet.rowConflict.showTheirs": "Voir leur modification",
    "tallysheet.rowConflict.status": "Non enregistré — quelqu'un d'autre a modifié une ligne",
    "upload.sending": "Envoi de",
    "offline.keepOffline": "Garder hors ligne",
    "offline.removeFromOffline": "Retirer du hors ligne",
    "offline.keptOffline": "Enregistré sur ce téléphone — fonctionne hors ligne avec sa feuille de pointage.",
    "offline.keepOfflineLater": "Il sera enregistré sur ce téléphone à la prochaine synchronisation.",
    "offline.removedFromOffline": "N'est plus gardé hors ligne (reste gardé s'il date des 90 derniers jours ou est encore ouvert).",
    "offline.syncTitle": "Synchronisation hors ligne",
    "offline.lastSynced": "Dernière synchronisation {when}",
    "offline.lastSyncedNever": "Pas encore synchronisé sur ce téléphone",
    "offline.justNow": "à l'instant",
    "offline.minAgo": "il y a {n} min",
    "offline.hoursAgo": "il y a {n} h",
    "offline.daysAgo": "il y a {n} jours",
    "offline.syncNow": "Synchroniser",
    "offline.youAreOffline": "Vous êtes hors ligne — les modifications sont enregistrées sur ce téléphone et envoyées au retour de la connexion.",
    "syncIssues.tryAgain": "Réessayer",
    "offline.waitingSync": "en attente de synchronisation",
    "offline.waitingSyncHint": "Enregistré sur ce téléphone — sera envoyé au retour d'Internet",
    "offlineLock.title": "Hors ligne depuis trop longtemps",
    "offlineLock.lead": "Ce téléphone est hors ligne depuis 15 jours ou plus, l'app est donc verrouillée pour protéger vos données.",
    "offlineLock.changesSafe": "{n} modification(s) non synchronisée(s) sont conservées sur ce téléphone.",
    "offlineLock.waiting": "Connectez-vous à Internet pour continuer. Vous choisirez ensuite quoi faire de ces modifications.",
    "offlineLock.checking": "Connexion…",
    "offlineLock.askTitle": "Synchroniser vos anciennes modifications ?",
    "offlineLock.askBody": "Vous avez {n} modification(s) d'avant. Oui : elles sont envoyées puis vous êtes déconnecté. Non : elles sont supprimées puis vous êtes déconnecté.",
    "offlineLock.yes": "Oui, synchroniser",
    "offlineLock.no": "Non, supprimer",
    "offlineLock.deletedTitle": "Anciennes modifications supprimées",
    "offlineLock.deletedBody": "Vos {n} ancienne(s) modification(s) ont été supprimées car vous avez choisi Non.",
    "offline.removedTitle": "Modifications hors ligne supprimées",
    "offline.removedBody": "{n} modification(s) faites hors ligne sur ce téléphone ont été supprimées, car un autre utilisateur s'y est connecté avant leur synchronisation. Saisissez-les à nouveau si nécessaire.",
    "offline.notSynced": "non synchronisé",
    "offline.notSyncedHint": "Modifications sur ce téléphone pas encore enregistrées sur le serveur — touchez pour les voir",
    "offline.itemSyncing": "élément en synchronisation…",
    "offline.itemsSyncing": "éléments en synchronisation…",
    "upload.of": "sur",
    "upload.left": "restant",
    "upload.processing": "Traitement…",
    "upload.sent": "envoyés",
    "upload.retry": "Réessayer",
    "upload.cancel": "Annuler l'envoi",
    "recon.piecesNotComparable": "Le pointage de déchargement est d'un autre type (Rond / Carré) : les pièces ne peuvent pas être comparées — seul l'écart de volume est utilisé.",
    "tallysheet.tu.reconReceived": "Reçu (rapproché) :",
    "tallysheet.tu.reconLoaded": "chargé",
    "tallysheet.tu.reconRecordedOnly": "enregistré seulement (lot déjà scié / vendu) — corrigez le stock par un ajustement",
    "recon.notReceived.title": "Cette Unité de stock n'est pas encore dans l'inventaire.",
    "recon.notReceived.text": "Réceptionnez-la d'abord dans l'inventaire — puis faites le rapprochement, pour que l'écart aille dans le stock.",
    "recon.notReceived.askReceive": "Demandez à quelqu'un qui peut réceptionner le stock de le faire d'abord.",
    "recon.notReceived.done": "Réceptionnée — vous pouvez faire le rapprochement.",
    "recon.notReceived.failed": "Réception impossible. Ouvrez l'Unité de stock et vérifiez produit, site et lignes du pointage.",
    "recon.stockWillChange": "Le verrouillage met en stock ce qui est vraiment arrivé :",
    "invInOut.reconAlreadyAppliedTitle": "Rapprochement déjà appliqué",
    "invInOut.reconAlreadyAppliedText": "Le rapprochement de cette Unité de stock a déjà modifié le stock de {cbm} CBM. Si cet ajustement concerne le même manque, le stock est corrigé deux fois — annulez-le par un ajustement inverse.",
    "tallysheet.tu.openingChipHint": "Stock que l'entreprise avait déjà au premier jour (ajouté avec Stock d'ouverture).",
    "receive.volumeFromTallies": "Le volume de ce lot vient des pointages de ses Unités de stock — corrigez plutôt le pointage.",
    "invOverview.openingStock": "Stock d'ouverture",
    "invOverview.openingStockHint": "Ajoutez le stock que vous avez déjà",
    "tallysheet.tu.openingTitle": "Stock d'ouverture",
    "tallysheet.tu.openingSteps": "Du stock que vous avez déjà. Enregistrez, remplissez le pointage (dimensions et pièces), puis appuyez sur Réceptionner dans l'Inventaire. Aucun mode de transport requis ; l'expédition est facultative — liez-en une seulement pour garder l'achat.",
    "tallysheet.tu.openingDone": "Du stock que vous aviez déjà — ajouté à l'inventaire. Liez une expédition seulement pour garder l'achat.",
    "appSettings.productTourSection": "Visites guidées",
    "appSettings.productTourEnabled": "Afficher les visites guidées",
    "appSettings.productTourHint": "Activé : chaque utilisateur voit la visite de chaque page une fois — terminée ou ignorée, elle ne réapparaît sur aucun de ses appareils. Désactivé : aucune visite et le bouton Visite est masqué.",
    "home.page.dashboard": "Tableau de bord",
    "home.page.tallySheets": "Feuilles de pointage",
    "home.page.consignments": "Expéditions",
    "home.page.inventory": "Inventaire",
    "home.restricted.title": "Cette page ne fait pas encore partie de votre rôle",
    "home.restricted.text": "L'administrateur de votre entreprise décide des pages que votre rôle peut ouvrir. Vous pouvez lui demander l'accès ou continuer sur les pages ci-dessous.",
    "home.restricted.canOpen": "Pages que vous pouvez ouvrir",
    "home.restricted.goHome": "Aller à ma page d'accueil",
    "home.welcome.title": "Votre compte est prêt",
    "home.setup.title": "Préparation de votre accès…",
    "home.setup.text": "Votre forfait est actif. Nous préparons vos pages, cela prend quelques secondes.",
    "home.welcome.text": "Votre administrateur n'a encore attribué aucune page à votre rôle. Demandez-lui l'accès — il recevra une notification immédiatement.",
    "home.welcome.profile": "Mon profil",
    "home.welcome.logout": "Se déconnecter",
    "home.request.button": "Demander l'accès",
    "home.request.sent": "Demande envoyée",
    "home.request.sentNote": "Les administrateurs de votre entreprise ont été prévenus. Vous verrez la page dès qu'ils mettront votre rôle à jour.",
    "home.request.failed": "Impossible d'envoyer la demande. Veuillez réessayer.",
    "home.roleHint.startsOn": "Pas de tableau de bord dans ce rôle — les membres commenceront sur :",
    "home.roleHint.none": "Ce rôle n'ouvre encore aucune page principale — les membres verront un écran d'accueil et pourront demander l'accès.",
    "plan.module.qualityGrading": "Classement Qualité",
    "plan.module.inventoryModule": "Module Inventaire",
    "plan.module.processModule": "Module Traitement",
    "plan.module.dedicatedSupport": "Support Dédié",
    "plan.value.unlimited": "Illimité",
    "plan.feature.teamMembers": "Membres de l'équipe",
    "plan.feature.businessPartners": "Partenaires commerciaux",
    "plan.feature.productsSpecies": "Produits / Essences",
    "plan.feature.loadingSites": "Sites",
    "plan.feature.tallySheets": "Feuilles de décompte",
    "plan.feature.shipments": "Consignations",
    "plan.feature.transportUnits": "Unités de transport",
    "plan.feature.photoUploads": "Téléversements de photos",
    "plan.feature.photoRetention": "Conservation des photos",
    "plan.feature.storage": "Stockage",
    "plan.feature.exportPdfExcel": "Export PDF et Excel",
    "plan.feature.importExcel": "Import Excel",
    "plan.feature.basicReports": "Rapports de base",
    "plan.feature.reconciliationReport": "Rapport de rapprochement",
    "plan.feature.usersActivityReport": "Rapport d'activité des utilisateurs",
    "plan.feature.advancedAnalytics": "Analyses avancées",
    "plan.feature.aiImport": "Import IA",
    "plan.feature.prioritySupport": "Support prioritaire",
    "plan.feature.consignments": "Consignations",
    "plan.feature.exportTallyPdfExcel": "Export Fiches (PDF+Excel)",
    "plan.feature.exportShipmentPdfExcel": "Export Consignation (PDF+Excel)",
    "plan.feature.importTallyExcel": "Import Fiches (Excel)",
    "plan.feature.importShipmentExcel": "Import Consignation (Excel)",
    "plan.unit.users": "utilisateurs",
    "plan.unit.records": "enregistrements",
    "plan.unit.sheets": "fiches",
    "plan.unit.sites": "sites",
    "plan.unit.units": "unités",
    "plan.unit.photos": "photos",
    "plan.unit.days": "jours",
    "plan.unit.mb": "Mo",
    "plan.unit.creditsMonth": "crédits/mois",
    "common.monthly": "Mensuel",
    "common.yearly": "Annuel",
    "plan.compare.show": "Afficher",
    "plan.compare.allFeatures": "Toutes les fonctionnalités",
    "plan.compare.common": "Commun",
    "plan.compare.differences": "Différences",
    "plan.savePercentTemplate": "Économisez {pct}%",
    "plan.saveUpTo20": "Économisez jusqu'à 20%",
    "plan.perMo": "/ mois",
    "plan.perYr": "/ an",
    "common.language": "Langue",
    "common.slowConnection": "Connexion lente — certaines actions peuvent prendre un peu plus de temps",
    "common.dismiss": "Ignorer",
    "planManagement.unavailableTitle": "Gérez votre forfait",
    "planManagement.unavailableDesc": "Cette fonctionnalité n'est pas disponible dans l'application. Veuillez contacter l'administrateur de votre compte.",
    "planManagement.backToDashboard": "Retour au tableau de bord",
    "planManagement.contactAdmin": "Veuillez contacter l'administrateur de votre compte.",
    "accountSetup.iosAllSetTitle": "Tout est prêt",
    "accountSetup.iosAllSetDesc": "Votre compte est prêt à l'emploi. Commencez à découvrir LumberLinq dès maintenant.",
    "accountSetup.iosAllSetGoToDashboard": "Aller au tableau de bord",
    "common.offlineStaleData": "Hors ligne — affichage des données en cache du",
    "common.offlineNotIncluded": "modifications sur ce téléphone ne sont pas encore synchronisées, elles ne sont donc pas incluses ici.",
    "common.preparingOfflineData": "Préparation des données hors ligne…",
    "common.syncAreaBusinessPartners": "Partenaires Commerciaux",
    "common.syncAreaProducts": "Produits",
    "common.syncAreaLoadingSites": "Sites",
    "common.syncAreaTransportUnits": "Unités de Stock",
    "common.syncAreaDashboard": "Tableau de Bord",
    "common.search": "Rechercher",
    "common.status": "Statut",
    "common.filter": "Filtrer",
    "common.actions": "Actions",
    "common.name": "Nom",
    "common.email": "E-mail",
    "common.user": "Utilisateur",
    "common.password": "Mot de passe",
    "common.phone": "Téléphone",
    "common.country": "Pays",
    "common.state": "État",
    "common.city": "Ville",
    "common.reset": "Réinitialiser",
    "common.delete": "Supprimer",
    "common.uploading": "Téléversement...",
    "common.edit": "Modifier",
    "common.active": "Actif",
    "common.inactive": "Inactif",
    "common.blocked": "Bloqué",
    "header.darkMode": "Mode sombre",
    "header.newBtn": "Nouveau",
    "header.searchHint": "Rechercher ou aller à…",
    "header.useClassic": "Utiliser l'en-tête classique",
    "header.useNew": "Utiliser le nouvel en-tête",
    "menuDock.useDock": "Utiliser le menu dock",
    "menuDock.useClassic": "Utiliser le menu classique",
    "menuDock.useDockRow": "Menu dock",
    "menuDock.iconsLabel": "Icônes",
    "menuDock.iconSet.lucide": "Lucide",
    "menuDock.iconSet.phosphor": "Phosphor",
    "menuDock.iconSet.classic": "Classique",
    "menuDock.more": "Plus",
    "menuDock.navLabel": "Menu principal",
    "menuDock.hideBar": "Masquer la barre du bas",
    "menuDock.focusMode": "Mode focus (masquer les deux barres)",
    "menuDock.showBottomBar": "Afficher la barre du bas",
    "menuDock.showBars": "Afficher les barres",
    "menuDock.viewGroup": "Affichage",
    "menuDock.railPin": "Garder le menu ouvert",
    "menuDock.railUnpin": "Ne plus garder le menu ouvert",
    "companyForm.regionalSettings": "Paramètres régionaux",
    "companyForm.currency": "Devise de l'entreprise",
    "companyForm.currencyHint": "Utilisée par défaut pour les nouveaux envois et paiements et pour les totaux du tableau de bord. Les enregistrements existants gardent leur propre devise.",
    "companyForm.timezone": "Fuseau horaire de l'entreprise",
    "companyForm.timezoneHint": "Les quotas mensuels du forfait se réinitialisent sur cette horloge. Les nouveaux membres de l'équipe démarrent aussi dessus.",
    "quickSearch.lockedStock": "Les résultats de stock ne font pas partie de votre forfait actuel.",
    "quickSearch.lockedMill": "Les résultats des travaux de scierie ne font pas partie de votre forfait actuel.",
    "quickSearch.seePlans": "Voir les forfaits",
    "appSettings.nav.upgrade": "Mettre à niveau",
    "appSettings.inventoryLocked": "Les paramètres de stock sont disponibles avec les forfaits qui incluent le module Stock.",
    "tallyImport.button": "Importer depuis Tally",
    "tallyImport.tooltip": "Importer des partenaires depuis un export Tally (Excel/CSV)",
    "tallyImport.dialogHeader": "Importer des partenaires commerciaux depuis Tally",
    "tallyImport.title": "Import depuis Tally",
    "tallyImport.hint": "Exportez votre liste de comptes (ledgers) de Tally en Excel ou CSV et gardez uniquement les Sundry Debtors et Sundry Creditors (les autres comptes ne sont pas importés). Les débiteurs deviennent Acheteurs et les créanciers deviennent Vendeurs. Le numéro fiscal / GSTIN est facultatif. Si les premières lignes du fichier sont un titre de rapport, utilisez « Ignorer les lignes en haut » ci-dessous.",
    "menuDock.railHide": "Masquer le menu",
    "menuDock.railShow": "Afficher le menu",
    "menuDock.hideHeader": "Masquer la barre du haut",
    "menuDock.showHeader": "Afficher la barre du haut",
    "menuDock.askLinc": "Demander à Linc (aide IA)",
    "header.lightMode": "Mode clair",
    "header.fontSize": "Taille de Police",
    "notification.bellLabel": "Notifications",
    "notification.title": "Notifications",
    "notification.markAllRead": "Tout marquer comme lu",
    "notification.empty": "Vous êtes à jour",
    "notification.disabled": "Les notifications ne sont pas disponibles pour le moment",
    "notification.accept": "Accepter",
    "notification.decline": "Refuser",
    "notification.accepted": "Accepté",
    "notification.switchHint": "Vous pouvez désormais y basculer à tout moment depuis votre menu de profil",
    "notification.declined": "Refusé",
    "notification.viewAll": "Tout voir",
    "header.theme": "Thème",
    "header.preferences": "Préférences",
    "business.subtitle": "Gérer your trading partners and business relationships",
    "common.cancel": "Annuler",
    "common.pcs": "pcs",
    "common.loading": "Chargement...",
    "common.unknown": "Inconnu",
    "common.save": "Enregistrer",
    "sfs.pickStockUnit": "Quelle unité de stock ?",
    "sfs.pickConsignment": "Quelle expédition ?",
    "sfs.searchPlaceholder": "Saisissez un numéro ou un nom",
    "sfs.searchHint": "Saisissez au moins 2 lettres ou chiffres pour chercher.",
    "sfs.searching": "Recherche…",
    "sfs.searchNone": "Rien trouvé. Essayez un autre numéro ou nom.",
    "sfs.searchFailed": "La recherche a échoué. Réessayez.",
    "tally.keypad.addRowBelow": "Ajouter une ligne dessous",
    "common.update": "Mettre à jour",
    "common.logout": "Se déconnecter",
    "common.clear": "Effacer",
    "common.saving": "Enregistrement…",
    "common.saved": "Enregistré !",
    "common.saveFailed": "Échec",
    "common.add": "Ajouter",
    "common.remove": "Retirer",
    "common.calculate": "Calculer",
    "common.yes": "Oui",
    "common.no": "Non",
    "common.stayOnPage": "Rester sur cette page",
    "common.signInAgain": "Se reconnecter",
    "common.ok": "Ok",
    "common.confirmation": "Confirmation",
    "common.or": "or",
    "common.required": "Obligatoire.",
    "common.isRequired": "est obligatoire.",
    "common.sectionHasErrors": "Cette section comporte des erreurs de validation.",
    "common.success": "Succès",
    "common.error": "Erreur",
    "common.created": "Créé",
    "common.somethingWentWrong": "Une erreur s'est produite. Veuillez réessayer.",
    "common.switchCompany": "Changer d'entreprise",
    "common.accountMenu": "Menu du compte",
    "common.confirmSwitchCompany": "Changer d'entreprise",
    "common.switchCompanyConfirmMessage": "Changer votre entreprise active pour {{companyName}} ? Vous serez déplacé vers les données et paramètres de cette entreprise.",
    "common.switchCompanyBlockedUnsynced": "Certaines de vos modifications ne sont pas encore synchronisées. Veuillez attendre la fin de la synchronisation avant de changer d'entreprise.",
    "common.leaveCompany": "Quitter l'entreprise",
    "common.leaveCompanyConfirmMessage": "Quitter {{companyName}} ? Vous perdrez l'accès à cette entreprise, mais votre propre compte et votre propre entreprise ne sont pas affectés.",
    "common.info": "Info",
    "common.validationError": "Validation Erreur",
    "common.noRecordsFound": "Aucun enregistrement trouvé.",
    "common.pendingSync": "Synchronisation en attente",
    "common.syncFailed": "Échec de la synchronisation",
    "common.needsRename": "Renommage nécessaire",
    "syncIssues.title": "Problèmes de synchronisation",
    "syncIssues.subtitle": "Éléments créés hors ligne que le serveur a définitivement rejetés — vérifiez et supprimez, ou corrigez et recréez manuellement.",
    "syncIssues.emptyState": "Aucun problème de synchronisation — tout ce qui a été créé hors ligne a été synchronisé avec succès.",
    "syncIssues.colType": "Type",
    "syncIssues.colItem": "Élément",
    "syncIssues.colError": "Erreur",
    "syncIssues.colCreated": "Créé",
    "syncIssues.discard": "Supprimer",
    "syncIssues.confirmDiscard": "Supprimer définitivement cet élément ? Il n'a jamais été enregistré sur le serveur et cette action est irréversible.",
    "syncIssues.confirmDiscardHeader": "Supprimer l'élément",
    "syncIssues.discardedTitle": "Supprimé",
    "syncIssues.discardedDetail": "L'élément a été supprimé.",
    "syncIssues.renamePlaceholder": "Nouveau nom",
    "syncIssues.renameAndRetry": "Renommer et réessayer",
    "syncIssues.retrySuccessTitle": "Synchronisé",
    "syncIssues.retrySuccessDetail": "Créé avec succès sous le nouveau nom.",
    "syncIssues.retryFailedTitle": "Échec à nouveau",
    "common.records": "enregistrements",
    "common.chooseColumns": "Choisir Columns",
    "common.searchKeyword": "Rechercher keyword",
    "common.hello": "Hello",
    "common.companyId": "Entreprise ID",
    "common.firstName": "First Name",
    "common.lastName": "Last Name",
    "common.useDefault": "Use Default",
    "common.view": "Voir",
    "common.data": "Données",
    "common.createdAt": "Created At",
    "common.undo": "Undo",
    "common.redo": "Redo",
    "common.import": "Import",
    "common.refresh": "Actualiser",
    "common.downloadFailed": "Échec du Téléchargement",
    "common.downloadFailedDetail": "Impossible d'enregistrer le fichier. Veuillez réessayer.",
    "common.open": "Ouvert",
    "common.copy": "Copy",
    "common.revoke": "Revoke",
    "common.back": "Retour",
    "common.itemsSelected": "Items Selected",
    "common.generalInformation": "General Information",
    "common.operationalDetails": "Operational Détails",
    "common.location": "Emplacement",
    "common.locationRequired": "Emplacement est obligatoire.",
    "common.pickupLocationRequired": "Pickup Emplacement est obligatoire.",
    "common.operatingProfile": "Operating Profil",
    "common.profile": "Profil",
    "common.paymentTerms": "Conditions de paiement",
    "common.incoterms": "Incoterms",
    "common.billNo": "Bill No",
    "common.billOfLadingNo": "Bill of Lading No",
    "common.billNumberRequired": "Bill number est obligatoire",
    "common.requiredForExport": "Obligatoire for export",
    "common.ewaybillLrFile": "E-Waybill / LR File",
    "common.billFile": "Bill File",
    "common.blFile": "BL File",
    "common.totalUsers": "Total Utilisateurs",
    "common.configured": "Configured",
    "common.noAccess": "No Accès",
    "common.avgCoverage": "Avg Coverage",
    "tallysheet.createTransportUnit": "Créer Unité de Stock",
    "tallysheet.saveStartTally": "Enregistrer et commencer le pointage",
    "su.editDetails": "Modifier les détails",
    "su.directionMoveShort": "Déplacer",
    "su.moreDetails": "Plus de détails",
    "su.lessDetails": "Moins de détails",
    "su.loadingTab": "Chargement…",
    "su.detailsTitle": "Détails de l'unité de stock",
    "su.allSaved": "Toutes les modifications sont enregistrées",
    "su.unsaved": "Modifications non enregistrées",
    "su.saving": "Enregistrement…",
    "su.moreActions": "Plus d'actions",
    "su.receiveSub": "Démarre le suivi du stock.",
    "su.lockMenu": "Verrouiller l'unité de stock",
    "su.lockSub": "Empêche toute autre modification.",
    "su.deleteMenu": "Supprimer l'unité de stock",
    "su.deleteSub": "Demande d'abord une confirmation.",
    "su.appScreenOn": "Essayer la disposition façon application",
    "su.appScreenOff": "Revenir à la disposition classique",
    "su.appScreenSub": "La grille remplit l'écran et son en-tête reste visible",
    "su.auditMenu": "Audit d'accès par lien",
    "su.auditSub": "Qui a ouvert cette unité de stock par un lien de partage",
    "su.confirmOutSub": "Retire ce stock de l'inventaire.",
    "su.notInInventory": "Hors inventaire",
    "su.inInventory": "En inventaire",
    "su.sections": "Sections de l'unité de stock",
    "su.lockedTitle": "Enregistrez l'unité de stock pour commencer le pointage",
    "su.lockedSub": "Chaque ligne est liée à l'unité de stock, il lui faut donc d'abord son ID.",
    "su.lockedChip": "Verrouillé",
    "su.lockedPlaceholder": "Photos, Résumé, Rapprochement et Inventaire s'ouvrent aussi ici.",
    "su.newHint": "Remplissez les détails puis enregistrez. Le pointage s'ouvre dès que l'unité existe.",
    "su.newReady": "Unité de stock enregistrée. Le pointage est prêt.",
    "tallysheet.selectProduct": "Sélectionner Produit",
    "tallysheet.selectMode": "Sélectionner Mode",
    "tallysheet.selectLoadingSite": "Sélectionner un Site",
    "common.pageReport": "Showing {first} to {last} of {totalRecords} entries",
    "common.unsavedChangesHeader": "Unsaved Changes",
    "common.unsavedChangesMessage": "You have unsaved changes. Are you sure you want to leave without saving?",
    "common.leaveLabel": "Leave",
    "common.stayLabel": "Stay",
    "login.alreadyHaveAccount": "Already have an account?",
    "login.signInNow": "Sign in now!",
    "login.signUp": "Sign Up",
    "login.nameRequired": "Name est obligatoire.",
    "login.usernameRequired": "Username est obligatoire.",
    "login.validEmailRequired": "Please enter a valid email address.",
    "login.checkEmailTitle": "Vérifiez votre e-mail",
    "login.checkEmailBody": "Nous avons envoyé un lien de vérification à",
    "login.checkEmailResent": "Un nouveau lien a été envoyé.",
    "login.checkEmailSignIn": "Se connecter",
    "login.emailExists": "Email already exists.",
    "login.passwordRequired": "Password est obligatoire.",
    "login.securityCheckLoading": "Chargement de la vérification de sécurité…",
    "login.securityCheckUnavailable": "Vérification de sécurité indisponible — la connexion est bloquée tant qu'elle n'est pas chargée.",
    "login.securityCheckRequired": "Veuillez terminer la vérification de sécurité avant de continuer.",
    "login.choosePassword": "Choisir a password",
    "login.tooSimple": "Too simple",
    "login.averageComplexity": "Moyenne complexity",
    "login.complexPassword": "Complex password",
    "login.dontHaveAccount": "Don't have an account?",
    "login.createToday": "Créer today!",
    "login.welcomeBack": "Bon retour",
    "login.welcomeBackSub": "Connectez-vous à votre compte LumberLinq.",
    "login.createYourAccount": "Créez votre compte",
    "login.createYourAccountSub": "Commencez à gérer votre commerce de bois en quelques minutes.",
    "login.signIn": "Sign In",
    "login.emailRequired": "Email est obligatoire.",
    "login.forgotPassword": "Forgot Password?",
    "login.loggedInAs": "You're already logged in as",
    "login.loggedInEmail": "Logged in as",
    "login.errorNotification": "Erreur Notification",
    "login.userNotRegistered": "No account exists for this email. Please sign up first.",
    "login.userAlreadyRegistered": "This account already exists. Please sign in instead.",
    "login.socialLoginFailed": "Social login failed. Please try again.",
    "login.referredBy": "Vous avez été recommandé par",
    "login.referredGeneric": "Vous avez été recommandé à LumberLinq.",
    "login.referredSignInInstead": "Se connecter à la place",
    "login.signInWithApple": "Se connecter avec Apple",
    "login.signUpWithApple": "S'inscrire avec Apple",
    "login.appleNoAccount": "Aucun compte LumberLinq n'est lié à cet identifiant Apple. Créez un compte gratuit sur le Web, puis connectez-vous ici.",
    "login.registrationDisabled":
      "Les inscriptions sont temporairement suspendues — nous avons réservé votre place et vous enverrons un email dès leur réouverture.",
    "business.title": "Partenaires commerciaux",
    "business.newPartner": "New Partenaire",
    "business.bulkImport": "Import en masse",
    "business.moreActions": "Plus d’actions",
    "business.selectRows": "Sélectionner des lignes",
    "business.selectedCount": "sélectionnés",
    "business.sortNameAsc": "Nom A–Z",
    "business.sortNameDesc": "Nom Z–A",
    "business.sortType": "Type",
    "business.sortCountry": "Pays",
    "common.done": "Terminé",
    "common.sort": "Trier",
    "common.activate": "Activer",
    "business.deleteSelected": "Supprimer Selected",
    "business.searchPlaceholder": "Rechercher by Name, Email, Contact, Tax ID",
    "business.allStatus": "All Statut",
    "business.edit": "Modifier Commercial Partenaire",
    "business.create": "Créer Commercial Partenaire",
    "business.identity": "Identité",
    "business.companyName": "Nom de l’entreprise",
    "business.companyDetails": "Détails de l’entreprise",
    "business.companyRegistration": "Entreprise Registration",
    "business.industry": "Industry",
    "business.web": "Web",
    "business.companyBranding": "Image de marque de l’entreprise",
    "business.logoUrl": "Logo URL",
    "business.logoPreview": "Entreprise logo preview",
    "business.contactPerson": "Contact Person",
    "business.partyType": "Party Type",
    "business.contactPersonShort": "Contact",
    "business.partyTypeShort": "Type",
    "business.selectType": "Sélectionner Type",
    "business.referenceCode": "Reference Code",
    "business.registrationType": "Registration Type",
    "business.taxId": "Tax ID",
    "company.reportingCurrency": "Devise de reporting",
    "company.reportingCurrencyHint": "Les totaux du tableau de bord et des rapports sont convertis dans cette devise.",
    "shipments.fxRateToBase": "Taux de change vers la devise de reporting",
    "shipments.convertedAmount": "Montant converti",
    "dashV5.convertedTooltip": "Converti dans la devise de reporting à l'aide des taux de change enregistrés sur chaque consignation. Les montants sans taux enregistré sont exclus.",
    "dashV5.approxConverted": "approx., converti",
    "dashV5.noRate": "aucun taux",
    "dashV5.noRateTooltip": "Aucun taux de change enregistré — exclu du total converti. Définissez le taux de change vers la devise de reporting sur la consignation.",
    "business.partyCategory": "Party Category",
    "business.selectCategory": "Sélectionner Category",
    "business.activePartner": "Active Partenaire",
    "business.contactLocation": "Contact & Emplacement",
    "business.website": "Website",
    "business.address1": "Adresse Line 1",
    "business.address2": "Adresse Line 2",
    "business.zipCode": "Zip Code",
    "business.operations": "Operations",
    "business.linkedUserId": "Linked Utilisateur ID",
    "business.externalCode": "External Code",
    "business.tags": "Tags",
    "business.selectTags": "Sélectionner Tags",
    "business.notes": "Notes",
    "business.attachFiles": "Attach Files",
    "business.bankAccounts": "Bank Accounts",
    "business.bankName": "Bank Name",
    "business.accountNo": "Account No",
    "business.confirmAccountNo": "Confirm Account No",
    "business.accountNoMismatch": "Account numbers don't match",
    "business.currency": "Devise",
    "business.addBankAccount": "Ajouter Bank Account",
    "business.savePartner": "Enregistrer Partenaire",
    "business.updatePartner": "Mettre à jour Partenaire",
    "business.noPartnersFound": "No partners found.",
    "business.regType": "Reg. Type",
    "route.login.header": "Welcome Back!",
    "route.buyers.manage": "Voir and manage existing buyer profiles",
    "layout.searchMenu": "Rechercher menu...",
    "layout.noMenuItems": "No menu items found.",
    "layout.footerRights": "All Rights Reserved.",
    "layout.poweredBy": "Powered By Lumber Linq",
    "layout.loveApp": "Love our app?",
    "layout.useForBusiness": "Use it for your own business!",
    "user.add": "Ajouter user",
    "user.create": "Créer Utilisateur",
    "user.inputDetails": "Input new user details to the system",
    "user.manage": "Gérer Utilisateur",
    "user.manageProfiles": "Voir and administer user profiles",
    "user.profile": "Modifier Profil",
    "user.profileSubheader": "Modify your personal user details",
    "user.confirmDeletion": "Confirm Utilisateur Deletion",
    "user.deleteConfirm": "Are you sure you want to delete this user?",
    "user.typeEmail": "Please confirm by typing the user's email below:",
    "user.emailPlaceholder": "Utilisateur Email",
    "user.addEmailAddress": "Ajouter Email Adresse",
    "user.invalidEmail": "Invalide Email Adresse",
    "user.enterEmail": "Enter Email Adresse",
    "user.invitationAccepted": "Invitation accepted",
    "user.resend": "Resend",
    "user.admin": "Admin",
    "user.cannotUndo": "This action cannot be undone.",
    "shipment.namePlural": "Consignations",
    "tallysheet.namePlural": "Tallysheets",
    "tallysheet.all": "All Feuille de cubage",
    "tallysheet.manageDetails": "Voir and manage existing tallysheet details",
    "containerPrivacy.title": "Conteneur Privacy",
    "subscription.title": "Abonnement",
    "subscription.selectUpdatePlan": "Sélectionner or update your subscription plan",
    "subscription.view": "Voir Subscription",
    "subscription.subheader": "Subheader Subscription",
    "utility.costEstimate": "Cost Estimate",
    "utility.volumeEstimation": "Volume Estimation",
    "utility.volumeCostEstimation": "Volume and Cost Estimation",
    "utility.unitConversion": "Unit Conversion",
    "utility.calculator": "Calculator",
    "utility.selectUnit": "Sélectionner Unit",
    "utility.generateSlab": "Generate Slab Prices",
    "utility.decimalPlace": "Decimal Place",
    "utility.decimalPlaces": "Decimal places",
    "utility.from": "From",
    "utility.to": "To",
    "utility.unit": "Unit",
    "utility.fromValue": "From Value",
    "utility.fromUnit": "From Unit",
    "utility.toValue": "To Value",
    "utility.toUnit": "To Unit",
    "utility.reverse": "Reverse",
    "utility.useCommonUnits": "Use common units for all rows",
    "utility.width": "Largeur",
    "utility.widthUnit": "Largeur Unit",
    "utility.thickness": "Thickness",
    "utility.thicknessUnit": "Thickness Unit",
    "utility.length": "Longueur",
    "utility.lengthUnit": "Longueur Unit",
    "utility.price": "Price",
    "utility.priceUnit": "Price Unit",
    "utility.quantity": "Quantity",
    "utility.total": "Total",
    "utility.rate": "Rate",
    "utility.slabOfRate": "Slab of Rate",
    "utility.slabPriceSize": "Slab Price Size",
    "utility.slabSize": "Slab Size",
    "utility.upperSlabs": "Upper Slabs",
    "utility.lowerSlabs": "Lower Slabs",
    "utility.slabPrice": "Slab Price",
    "utility.volumeOnly": "Volume seul",
    "utility.volumeAndCost": "Volume + coût",
    "utility.clearAll": "Tout effacer",
    "utility.clearAllConfirm": "Supprimer tous les articles et recommencer ?",
    "utility.addItem": "Ajouter un article",
    "utility.item": "Article",
    "utility.duplicateItem": "Dupliquer l'article",
    "utility.removeItem": "Supprimer l'article",
    "utility.itemRemoved": "Article supprimé",
    "utility.totals": "Totaux",
    "utility.pieces": "Pièces",
    "utility.cftNote": "CFT = CBM × 35,3147. Les chiffres ne sont arrondis qu'à l'affichage, et les montants à 2 décimales.",
    "utility.copySummary": "Copier le résumé",
    "utility.copyFailed": "Copie impossible",
    "utility.swap": "Inverser",
    "utility.saveConversion": "Enregistrer dans l'historique",
    "utility.allUnits": "La même valeur dans chaque unité",
    "utility.history": "Conversions enregistrées",
    "utility.historyEmpty": "Touchez le marque-page pour enregistrer une conversion, elle apparaîtra ici.",
    "utility.clearHistory": "Effacer l'historique",
    "utility.clearHistoryConfirm": "Supprimer toutes les conversions enregistrées ?",
    "utility.useThis": "Utiliser cette conversion",
    "utility.incompleteTitle": "Données incomplètes",
    "utility.incompleteBody": "Saisissez d'abord une valeur et choisissez les deux unités.",
    "utility.duplicateTitle": "Déjà enregistré",
    "utility.duplicateBody": "Cette conversion figure déjà dans votre liste.",
    "utility.savedTitle": "Enregistré",
    "utility.baseSection": "Prix de base",
    "utility.baseRange": "Plage de la tranche de base",
    "utility.stepSection": "Pas des tranches",
    "utility.rangeSection": "Tranches à afficher",
    "utility.priceLadder": "Échelle de prix",
    "utility.slabs": "tranches",
    "utility.copyAll": "Tout copier",
    "utility.negativeRate": "Certains prix sont inférieurs à zéro. Réduisez le pas de prix ou le nombre de tranches inférieures.",
    "utility.baseSlab": "Votre tranche",
    "utility.ladderEmpty": "Saisissez le tarif, la tranche du tarif, la taille de tranche et le pas de prix pour voir l'échelle de prix.",
    "dashboardNew.title": "Tableau de bord",
    "menu.dashboard": "Tableau de bord",
    "menu.dashboardNew": "Dashboard New",
    "menu.shipments": "Consignations",
    "menu.tallysheets": "Tallysheets",
    "menu.newTallysheet": "New Feuille de cubage",
    "menu.products": "Produits",
    "menu.loadingSites": "Sites",
    "menu.businessPartners": "Partenaires commerciaux",
    "menu.containerPrivacy": "Conteneur Privacy",
    "menu.company": "Entreprise",
    "menu.companyProfile": "Profil de l’entreprise",
    "menu.companyBranding": "Image de marque de l’entreprise",
    "menu.subscription": "Abonnement",
    "menu.utility": "Utility",
    "menu.directory": "Répertoire",
    "menu.tools": "Outils",
    "menu.section.overview": "Aperçu",
    "menu.section.operations": "Opérations",
    "menu.section.data": "Données et rapports",
    "menu.section.platform": "Plateforme",
    "sidebar.recent": "Récents",
    "sidebar.copied": "Copié",
    "sidebar.new": "Nouveau",
    "sidebar.newConsignment": "Envoi",
    "sidebar.newStockUnit": "Unité de stock",
    "sidebar.newBusinessPartner": "Partenaire commercial",
    "sidebar.newProduct": "Produit",
    "sidebar.newLocation": "Emplacement",
    "menu.costEstimate": "Cost Estimate",
    "menu.volumeEstimate": "Volume Estimate",
    "menu.volumeEstimates": "Volume Estimates",
    "menu.unitConversion": "Unit Conversion",
    "menu.slabGenerator": "Slab Generator",
    "menu.generateSlab": "Generate Slab",
    "menu.users": "Utilisateurs",
    "menu.addUser": "Ajouter Utilisateur",
    "menu.manageUsers": "Gérer Utilisateurs",
    "menu.userProfile": "Utilisateur Profil",
    "menu.editProfile": "Modifier Profil",
    "menu.addBusinessPartner": "Ajouter Commercial Partenaire",
    "menu.viewBusinessPartner": "Voir Commercial Partenaire",
    "menu.viewBusinessPartners": "Voir les partenaires commerciaux",
    "menu.addProduct": "Ajouter Produit",
    "menu.viewProduct": "Voir Produit",
    "menu.viewProducts": "Voir les produits",
    "menu.addLoadingSite": "Ajouter un Site",
    "menu.viewLoadingSite": "Voir le Site",
    "menu.viewLoadingSites": "Voir les Sites",
    "menu.addTallysheet": "Ajouter Feuille de cubage",
    "menu.viewTallysheet": "Voir Feuille de cubage",
    "menu.listTallysheet": "Liste des feuilles de cubage",
    "menu.addShipment": "Ajouter Consignation",
    "menu.viewShipment": "Voir Consignation",
    "menu.listShipments": "Liste des consignations",
    "menu.storage": "Stockage",
    "menu.branding": "Image de marque",
    "menu.admin": "Admin",
    "menu.adminDashboard": "Admin Dashboard",
    "menu.subscriptionDashboard": "Subscription Dashboard",
    "menu.reports": "Rapports",
    "menu.financialReport": "Financial Rapport",
    "menu.reconciliationReport": "Reconciliation Rapport",
    "menu.accessField": "Accès Field",
    "menu.tallysheetAccessField": "Feuille de cubage Accès Field",
    "menu.businessPartnerReport": "Commercial Partenaire Rapport",
    "menu.shipmentReport": "Consignation Rapport",
    "menu.productReport": "Produit Rapport",
    "menu.loadingSiteReport": "Rapport des Sites",
    "menu.transportUnitReport": "Rapport de l'Unité de Stock",
    "menu.tallysheetReport": "Feuille de cubage Rapport",
    "menu.operators": "Opérateurs",
    "menu.addTransportUnit": "Ajouter une Unité de Stock",
    "menu.transportUnitFieldAccess": "Accès aux Champs de l'Unité de Stock",
    "menu.tallyReport": "Rapport de Cubage",
    "menu.analytics": "Analytique",
    "route.companyProfile": "Profil de votre entreprise",
    "route.companyProfileDetails": "Voir or edit your company's profile details",
    "route.companyLogo": "Gérer your company logo",
    "route.convertUnitsHeader": "Convert Units",
    "route.convertUnitsSubheader": "Enter your measurements and select units for conversion",
    "route.costEstimateHeader": "Estimate Your Costs",
    "route.costEstimateSubheader": "Input your parameters and calculate the projected cost",
    "route.containerPrivacyHeader": "Gérer Conteneur Privacy Configurations",
    "route.containerPrivacySubheader": "Voir and customize privacy levels for container fields",
    "dashboardNew.company": "Entreprise",
    "dashboardNew.role": "Rôle",
    "dashboardNew.filterRange": "Filter Range",
    "dashboardNew.refresh": "Actualiser",
    "dashboardNew.noData": "No data",
    "dashboardNew.originDestination": "Origin vs Destination CBM (30d)",
    "dashboardNew.topPartners": "Top Partenaires by Volume",
    "dashboardNew.fleetHealth": "Fleet Health",
    "dashboardNew.shipmentPipeline": "Consignation Pipeline",
    "dashboardNew.tallyAccuracy": "Cubage Accuracy by Port",
    "dashboardNew.liveOperations": "Live Operations",
    "dashboardNew.alerts": "Alerts & Exceptions",
    "dashboardNew.recentActivity": "Recent Activity",
    "shipment.list": "Consignations",
    "shipment.singular": "Consignation",
    "shipment.new": "New Consignation",
    "shipment.searchPlaceholder": "Rechercher anything (BL, Order, Export Ref, Shipper...)",
    "shipment.blNumber": "N° de document",
    "shipment.type": "Type",
    "shipment.date": "Date",
    "shipment.buyerOrder": "Buyer Order",
    "shipment.exportRef": "Export Ref",
    "shipment.shipper": "Shipper",
    "shipment.consignee": "Consignee",
    "shipment.noFound": "No consignments found.",
    "shipment.noFoundSub": "Créez une nouvelle consignation pour commencer.",
    "shipment.noBl": "Pas de BL#",
    "shipment.sharedLinks": "Shared Links",
    "shipment.newLink": "Nouveau lien partagé",
    "shipment.access": "Accès",
    "shipment.expiry": "Expiry",
    "shipment.active": "Actif",
    "shipment.oneTime": "One Time",
    "shipment.used": "Used",
    "shipment.createEdit": "Consignation - Créer / Modifier",
    "shipment.create": "Créer une Consignation",
    "shipment.edit": "Modifier la Consignation",
    "shipment.saveConsignment": "Enregistrer la Consignation",
    "shipment.updateConsignment": "Mettre à Jour la Consignation",
    "shipment.coreDetailsShort": "Core Détails",
    "shipment.financialsPaymentsHtml": "Finances et paiements",
    "shipment.financials": "Financials",
    "shipment.localAuditSpaced": "Local / Audit",
    "shipment.consignmentInfo": "Consignment Info",
    "shipment.documents": "Documents",
    "shipment.financialPayments": "Financial & Paiements",
    "shipment.localAudit": "Local/Audit",
    "shipment.breadcrumbs": "Breadcrumbs",
    "shipment.details": "Consignation Détails",
    "shipmentForm.tabDeal": "Affaire",
    "shipmentForm.tabRoute": "Itinéraire et dates",
    "shipmentForm.tabMoney": "Argent",
    "shipmentForm.dealTitle": "L'affaire",
    "shipmentForm.dealBasics": "Type, mode et date",
    "shipmentForm.dealBasicsHelp": "Choisissez d'abord le type : il détermine les champs affichés dans chaque onglet.",
    "shipmentForm.references": "Références",
    "shipmentForm.referencesHelp": "Les numéros que votre équipe et vos partenaires utilisent pour retrouver cette expédition.",
    "shipmentForm.referencesHelpLocal": "Les numéros de facture et de bon utilisés pour retrouver cette expédition.",
    "shipmentForm.parties": "Parties",
    "shipmentForm.partiesHelp": "Au moins une des parties (expéditeur, destinataire ou partie à notifier) doit être votre propre société. Elle est remplie pour vous quand le type le rend évident.",
    "shipmentForm.ownerMissing": "Une des parties doit être votre propre société.",
    "shipmentForm.buyerDetails": "Détails de l'acheteur",
    "shipmentForm.buyerDetailsHelpSale": "Requis avant le départ de la marchandise : le numéro fiscal de l'acheteur et qui réceptionne.",
    "shipmentForm.buyerDetailsHelpPurchase": "Facultatif pour un achat. Votre numéro fiscal est rempli pour vous.",
    "shipmentForm.notes": "Notes",
    "shipmentForm.routeTitle": "Itinéraire et dates",
    "shipmentForm.timing": "Dates, destination et conditions",
    "shipmentForm.timingHelp": "Quand il part et arrive, et les conditions d'expédition convenues. Le même jour est accepté.",
    "shipmentForm.transit": "Durée du transit",
    "shipmentForm.sameDay": "Le même jour",
    "shipmentForm.days": "jours",
    "shipmentForm.docsTitle": "Documents",
    "shipmentForm.docChecklist": "Documents au dossier",
    "shipmentForm.docChecklistNote": "Un numéro ou un fichier téléversé compte. Cette liste sert de rappel ; elle ne bloque jamais l'enregistrement. Ajoutez le certificat de fumigation dans Autres documents avec l'étiquette Fumigation.",
    "shipmentForm.docNumbers": "Numéros de documents",
    "shipmentForm.docNumbersHelp": "Numéros de certificats et de permis de cette expédition.",
    "shipmentForm.coNo": "N° du certificat d'origine",
    "shipmentForm.fumigationNo": "N° du certificat de fumigation",
    "shipmentForm.insuranceDetails": "Détails de l'assurance",
    "shipmentForm.ewayNo": "N° de e-way bill",
    "shipmentForm.quickLabels": "Étiquettes rapides",
    "shipmentForm.doc.bl": "Connaissement",
    "shipmentForm.doc.bill": "Facture / bon",
    "shipmentForm.doc.invoice": "Facture commerciale",
    "shipmentForm.doc.packing": "Liste de colisage",
    "shipmentForm.doc.co": "Certificat d'origine",
    "shipmentForm.doc.phyto": "Certificat phytosanitaire",
    "shipmentForm.doc.fumigation": "Certificat de fumigation",
    "shipmentForm.doc.eway": "E-way bill / LR",
    "shipmentForm.sumLabel": "Résumé de l'expédition",
    "shipmentForm.noBlYet": "Pas encore saisi",
    "shipmentForm.unsaved": "Modifications non enregistrées",
    "shipmentForm.status": "Statut",
    "shipmentForm.changeStatus": "Changer le statut",
    "shipmentForm.sumToggle": "Afficher ou masquer le résumé",
    "shipmentForm.stepperLabel": "Avancement de cette expédition",
    "shipmentForm.invoice": "Facture",
    "shipmentForm.outstanding": "Restant dû",
    "shipmentForm.readyLabel": "prêt",
    "shipmentForm.type.EXPORT": "Export",
    "shipmentForm.type.IMPORT": "Import",
    "shipmentForm.type.DOMESTIC_SALE": "Vente nationale",
    "shipmentForm.type.DOMESTIC_PURCHASE": "Achat national",
    "shipmentForm.type.TRADING": "Négoce",
    "shipmentForm.mode.SEA": "Mer",
    "shipmentForm.mode.AIR": "Air",
    "shipmentForm.mode.ROAD": "Route",
    "shipmentForm.mode.RAIL": "Rail",
    "shipmentForm.ready.type": "Type et mode choisis",
    "shipmentForm.ready.parties": "Vendeur et acheteur choisis",
    "shipmentForm.ready.bl": "Numéro de connaissement",
    "shipmentForm.ready.bill": "Numéro de facture",
    "shipmentForm.ready.dates": "Dates de départ et d’arrivée",
    "shipmentForm.ready.ports": "Ports de chargement et de déchargement",
    "shipmentForm.ready.vehicle": "Itinéraire et détails du véhicule",
    "shipmentForm.ready.rail": "Gares d'origine et de destination",
    "shipmentForm.ready.units": "Au moins une unité de stock ajoutée",
    "shipmentForm.ready.docs": "Tous les documents attendus au dossier",
    "shipmentForm.ready.invoice": "Montant de la facture saisi",
    "shipmentForm.ready.terms": "Conditions de paiement choisies",
    "shipmentForm.depRequired": "Le départ estimé est obligatoire",
    "shipmentForm.arrRequired": "L'arrivée estimée est obligatoire",
    "shipmentForm.billRequired": "Le numéro de facture est obligatoire",
    "shipmentForm.blRequired": "Le numéro de connaissement est obligatoire pour une expédition maritime",
    "shipmentForm.requiredHere": "Obligatoire",
    "shipmentForm.paymentTermsNeeded": "Les conditions de paiement sont requises dès qu'un montant de facture est saisi",
    "shipmentForm.paymentTermsHint": "Requises dès que vous saisissez un montant de facture : elles donnent l'échéance et les relances de retard.",
    "shipmentForm.savePaymentsFirst": "Enregistrez d'abord l'expédition pour saisir des paiements.",
    "shipmentForm.pricePerCbm": "Facture par CBM",
    "shipmentForm.paidSoFar": "Payé à ce jour",
    "shipmentForm.receivedSoFar": "Reçu à ce jour",
    "shipmentForm.stockHelpBtn": "Quelles unités de stock apparaissent ici ?",
    "shipmentForm.stockHint": "Saisissez une partie de l'ID de l'unité de stock, du n° de conteneur / camion ou du produit. Appuyez sur ? pour voir lesquelles sont listées.",
    "shipmentForm.stockHintNew": "Saisissez une partie de l'ID, du n° de conteneur / camion ou du produit. Les unités ajoutées sont liées à l'enregistrement. Appuyez sur ? pour voir lesquelles sont listées.",
    "shipmentForm.stockHelp.title": "Quelles unités de stock sont listées ?",
    "shipmentForm.stockHelp.lead": "La liste montre les unités de stock de votre société qui conviennent à cette expédition.",
    "shipmentForm.stockHelp.shown": "Listées",
    "shipmentForm.stockHelp.hidden": "Non listées",
    "shipmentForm.stockHelp.s1": "Pas encore dans une expédition",
    "shipmentForm.stockHelp.s2": "Le bon sens : sortie pour une vente, entrée pour un achat",
    "shipmentForm.stockHelp.s3": "Reçue ou confirmée, peu importe",
    "shipmentForm.stockHelp.h1": "Déjà dans une autre expédition",
    "shipmentForm.stockHelp.h2": "Le sens opposé (une sortie n'apparaît jamais sur un achat)",
    "shipmentForm.stockHelp.h3": "Unités de transfert entre sites et enregistrements de sortie de scierie",
    "shipmentForm.stockHelp.h4": "Rien de saisi, ou aucune correspondance avec l'ID, l'ID de transport, le n° de conteneur / camion ou le produit",
    "shipmentForm.stockHelp.tip": "Introuvable ? Vérifiez son sens (Direction) sur l'écran de l'unité de stock.",
    "shipmentForm.stockHelp.locked": "L'ajout est désactivé quand l'expédition est Clôturée, Annulée, ou une vente déjà partie.",
    "shipmentForm.statusDialogTitle": "Changer le statut",
    "shipmentForm.statusForwardNote": "Le stock de cette expédition a été reçu : le statut ne peut donc qu'avancer.",
    "shipmentForm.receiveMark": "Propose la réception en inventaire",
    "shipmentForm.current": "Actuel",
    "shipmentForm.setStatus": "Appliquer le statut",
    "shipmentForm.statusPressUpdate": "Appuyez sur Mettre à jour pour enregistrer le nouveau statut.",
    "shipmentForm.statusPressSave": "Appuyez sur Enregistrer pour conserver le nouveau statut.",
    "shipmentForm.statusForwardTitle": "Le statut ne peut qu'avancer",
    "shipmentForm.statusForwardSub": "Le stock de cette expédition a déjà été reçu. Le statut peut encore avancer, mais pas reculer ni passer à Annulée.",
    "shipmentForm.activity": "Activité",
    "shipmentForm.activityTip": "Qui a créé cette expédition, quand elle a changé et l'historique des statuts",
    "loginBar.signedIn": "Vous êtes déjà connecté.",
    "loginBar.continue": "Continuer vers LumberLinq",
    "loginBar.switch": "Se connecter avec un autre compte",
    "shipmentForm.priceCheckHigh": "Ce prix par CBM est bien plus élevé que vos expéditions précédentes (environ {typical}). Vérifiez le montant.",
    "shipmentForm.priceCheckLow": "Ce prix par CBM est bien plus bas que vos expéditions précédentes (environ {typical}). Vérifiez le montant.",
    "shipment.status.SHIPPED": "Expédié",
    "shipmentForm.raw.backToConsignments": "Retour aux expéditions",
    "shipmentForm.raw.goodsHaveArrivedReadyToReceiveInto": "La marchandise est arrivée — prête à être reçue en inventaire ?",
    "shipmentForm.raw.filledIn": "Rempli",
    "shipmentForm.raw.thisTabHasValidationErrors": "Cet onglet contient des erreurs de validation",
    "shipmentForm.raw.consignmentDateIsRequired": "La date de l'expédition est obligatoire",
    "shipmentForm.raw.blType": "Type de BL",
    "shipmentForm.raw.searchShipper": "Rechercher l'expéditeur",
    "shipmentForm.raw.searchConsignee": "Rechercher le destinataire",
    "shipmentForm.raw.searchNotifyParty": "Rechercher la partie à notifier",
    "shipmentForm.raw.arrivalCannotBeBeforeDeparture": "L'arrivée ne peut pas précéder le départ",
    "shipmentForm.raw.countryOfDestination": "Pays de destination",
    "shipmentForm.raw.portCarrierDetails": "Détails du port et du transporteur",
    "shipmentForm.raw.portOfLoadingIsRequired": "Le port de chargement est obligatoire",
    "shipmentForm.raw.portOfDischargeIsRequired": "Le port de déchargement est obligatoire",
    "shipmentForm.raw.otherNotListed": "Autre (non listé)",
    "shipmentForm.raw.enterShippingLineName": "Saisissez le nom de la compagnie maritime",
    "shipmentForm.raw.customShippingLine": "Compagnie maritime personnalisée",
    "shipmentForm.raw.vesselName": "Nom du navire",
    "shipmentForm.raw.voyageNumber": "Numéro de voyage",
    "shipmentForm.raw.flightNumber": "Numéro de vol",
    "shipmentForm.raw.roadTransportDetails": "Détails du transport routier",
    "shipmentForm.raw.vehicleLrNo": "N° du véhicule / LR",
    "shipmentForm.raw.railMovementDetails": "Détails du transport ferroviaire",
    "shipmentForm.raw.originStationIcd": "Gare / ICD d'origine",
    "shipmentForm.raw.destinationStationIcd": "Gare / ICD de destination",
    "shipmentForm.raw.railOperator": "Opérateur ferroviaire",
    "shipmentForm.raw.searchByStockUnitIdTransportId": "Recherchez par ID d'unité de stock, ID de transport, n° de conteneur / camion ou produit…",
    "shipmentForm.raw.openInStockUnitEditorNewTab": "Ouvrir dans l'éditeur d'unité de stock (nouvel onglet)",
    "shipmentForm.raw.noTransportUnitsAddedYetStartBy": "Aucune unité ajoutée pour l'instant. Commencez par rechercher ci-dessus.",
    "shipmentForm.raw.whoCanSeeThisDocumentInShares": "Qui peut voir ce document dans les partages et exports",
    "shipmentForm.raw.dropOrClickToUpload": "Déposez ou cliquez pour téléverser",
    "shipmentForm.raw.noDocumentsAttached": "Aucun document joint",
    "shipmentForm.raw.max5FilesReached": "Maximum de 5 fichiers atteint",
    "shipmentForm.raw.label": "Étiquette",
    "shipmentForm.raw.fileLabelMax16Chars": "Étiquette du fichier (16 caractères max.)",
    "shipmentForm.raw.attach": "Joindre",
    "shipmentForm.raw.fileSSelected": "fichier(s) sélectionné(s)",
    "shipmentForm.raw.dropOrClickToAddMultipleFiles": "Déposez ou cliquez pour ajouter plusieurs fichiers",
    "shipmentForm.raw.selectCurrency": "Sélectionnez la devise",
    "shipmentForm.raw.days": "Jours",
    "shipmentForm.raw.describePaymentTerms": "Décrivez les conditions de paiement…",
    "shipmentForm.raw.customTerms": "Conditions personnalisées",
    "shipmentForm.raw.dueDate": "Date d'échéance",
    "shipmentForm.raw.outstandingReceivable": "Créances en attente",
    "shipmentForm.raw.outstandingPayable": "Dettes en attente",
    "shipmentForm.raw.paymentDetails": "Détails du paiement",
    "shipmentForm.raw.paymentDate": "Date de paiement *",
    "shipmentForm.raw.utrLCNoRef": "UTR / N° L/C / Réf.",
    "shipmentForm.raw.amountCurrency": "Montant et devise",
    "shipmentForm.raw.amount": "Montant *",
    "shipmentForm.raw.optionalContextForThisPayment": "Contexte facultatif pour ce paiement…",
    "shipmentForm.raw.noPaymentsRecordedYet": "Aucun paiement enregistré.",
    "shipmentForm.raw.editPayment": "Modifier le paiement",
    "shipmentForm.raw.deletePayment": "Supprimer le paiement",
    "shipmentForm.raw.totalReceived": "Total reçu :",
    "shipmentForm.raw.totalPaid": "Total payé :",
    "shipmentForm.raw.previousTabAltLeft": "Onglet précédent (Alt + Gauche)",
    "shipmentForm.raw.nextTabAltRight": "Onglet suivant (Alt + Droite)",
    "shipmentForm.lastUpdated": "Dernière mise à jour",
    "shipmentForm.statusHistory": "Historique des statuts",
    "shipmentForm.noHistory": "Aucun historique de statut à afficher.",
    "shipment.status.DRAFT": "Brouillon",
    "shipment.status.CONFIRMED": "Confirmée",
    "shipment.status.PLANNED": "Planifiée",
    "shipment.status.STUFFING": "Empotage",
    "shipment.status.STUFFED": "Empoté",
    "shipment.status.GATE_OUT": "Sortie du portail",
    "shipment.status.IN_TRANSIT": "En transit",
    "shipment.status.ARRIVED": "Arrivé",
    "shipment.status.UNSTUFFING": "Dépotage",
    "shipment.status.DELIVERED": "Livré",
    "shipment.status.CLOSED": "Clôturée",
    "shipment.status.CANCELLED": "Annulée",
    "shipment.statusGroup.planning": "Préparation",
    "shipment.statusGroup.loading": "Chargement",
    "shipment.statusGroup.way": "En route",
    "shipment.statusGroup.arrival": "Arrivée",
    "shipment.statusGroup.finished": "Terminée",
    "shipment.statusMeaning.DRAFT": "En préparation",
    "shipment.statusMeaning.CONFIRMED": "Affaire convenue",
    "shipment.statusMeaning.PLANNED": "Expédition organisée",
    "shipment.statusMeaning.STUFFING.sale": "Vous chargez la marchandise",
    "shipment.statusMeaning.STUFFING.buy": "Le fournisseur charge la marchandise",
    "shipment.statusMeaning.STUFFED.sale": "Chargé et scellé",
    "shipment.statusMeaning.STUFFED.buy": "Chargé chez le fournisseur",
    "shipment.statusMeaning.GATE_OUT.sale": "A quitté le portail du parc ou du port",
    "shipment.statusMeaning.GATE_OUT.buy": "Le fournisseur a chargé et expédié",
    "shipment.statusMeaning.IN_TRANSIT.sale": "En route vers l'acheteur",
    "shipment.statusMeaning.IN_TRANSIT.buy": "En route vers vous",
    "shipment.statusMeaning.ARRIVED.sale": "Arrivé à destination",
    "shipment.statusMeaning.ARRIVED.buy": "Arrivé à votre port ou parc",
    "shipment.statusMeaning.UNSTUFFING.sale": "Le conteneur est en cours de dépotage",
    "shipment.statusMeaning.UNSTUFFING.buy": "Le conteneur est en cours de dépotage",
    "shipment.statusMeaning.DELIVERED.sale": "L'acheteur a la marchandise",
    "shipment.statusMeaning.DELIVERED.buy": "La marchandise est chez vous",
    "shipment.statusMeaning.CLOSED": "Terminée et réglée",
    "shipment.statusMeaning.CANCELLED": "Annulée",
    "shipment.statusEffect.DRAFT": "Rien ne change en stock. À utiliser tant que des informations manquent.",
    "shipment.statusEffect.CONFIRMED": "Rien ne change en stock.",
    "shipment.statusEffect.PLANNED": "Rien ne change en stock.",
    "shipment.statusEffect.STUFFING.sale": "Rien ne change en stock. Les unités de stock apparaissent sous En expédition.",
    "shipment.statusEffect.STUFFING.buy": "Rien ne change en stock. Les unités de stock apparaissent sous En expédition.",
    "shipment.statusEffect.STUFFED.sale": "Rien ne change en stock. Les unités de stock apparaissent sous En transit.",
    "shipment.statusEffect.STUFFED.buy": "Rien ne change en stock. Les unités de stock apparaissent sous En transit.",
    "shipment.statusEffect.GATE_OUT.sale": "Rien ne change en stock. Les unités de stock apparaissent sous En transit.",
    "shipment.statusEffect.GATE_OUT.buy": "Rien ne change en stock. Les unités de stock apparaissent sous En transit.",
    "shipment.statusEffect.IN_TRANSIT.sale": "Rien ne change en stock (le stock ne baisse qu'à la confirmation de la sortie). À partir de maintenant, aucune nouvelle unité de stock ne peut être ajoutée à cette vente.",
    "shipment.statusEffect.IN_TRANSIT.buy": "Rien ne change en stock (le stock n'augmente qu'à la réception en inventaire). Les unités de stock apparaissent sous En transit.",
    "shipment.statusEffect.ARRIVED.sale": "Rien ne change en stock. On ne peut plus ajouter d'unités de stock à cette vente.",
    "shipment.statusEffect.ARRIVED.buy": "Le stock n'augmente pas encore. On vous proposera de recevoir les unités de stock en inventaire (Réception en inventaire).",
    "shipment.statusEffect.UNSTUFFING.sale": "Rien ne change en stock.",
    "shipment.statusEffect.UNSTUFFING.buy": "Le stock n'augmente pas encore. On vous proposera de recevoir les unités de stock en inventaire (Réception en inventaire).",
    "shipment.statusEffect.DELIVERED.sale": "Le stock ne baisse qu'à la confirmation de la sortie de chaque unité de stock, pas à cause de ce statut. On ne peut plus ajouter d'unités de stock.",
    "shipment.statusEffect.DELIVERED.buy": "Recevez les unités de stock pas encore reçues. Le stock n'augmente qu'à la réception en inventaire, pas à cause de ce statut.",
    "shipment.statusEffect.CLOSED": "On ne peut plus ajouter d'unités de stock. Les quantités en stock ne changent pas.",
    "shipment.statusEffect.CANCELLED": "Les quantités en stock ne changent pas et on ne peut plus ajouter d'unités de stock. Si le stock a déjà été reçu ou confirmé, corrigez avec Ajouter un ajustement.",
    "shipment.paymentSummaryTitle": "Résumé des Paiements",
    "shipment.invoiceAmount": "Montant de la Facture",
    "shipment.received": "Reçu",
    "shipment.paid": "Payé",
    "shipment.salesPaymentStatus": "Statut de Paiement des Ventes",
    "shipment.purchasePaymentStatus": "Statut de Paiement des Achats",
    "shipment.coreDetails": "Core Consignation Détails",
    "shipment.saveChanges": "Enregistrer Changes",
    "shipment.listSubtitle": "Track, filter, and manage consignment operations",
    "shipment.filterBl": "Filter BL",
    "shipment.filterBuyerOrder": "Filter Buyer Order",
    "shipment.filterExportRef": "Filter Export Ref",
    "shipment.filterShipper": "Filter Shipper",
    "shipment.filterConsignee": "Filter Consignee",
    "shipment.filterStatus": "Filter Statut",
    "shipment.viewDetails": "Voir consignment details",
    "shipment.payments": "Paiements",
    "common.confirm": "Confirmer",
    "shipment.changeStatus": "Changer le Statut",
    "shipment.receiveIntoInventory": "Réceptionner dans l'Inventaire",
    "share.actions": "Share actions",
    "share.duration": "Duration",
    "share.accessLimit": "Accès limit",
    "share.customAccessCount": "Custom access count",
    "share.allowDownload": "Autoriser l'export et les téléchargements",
    "share.protectedAudience": "Protégé audience",
    "share.companyIdNotFound": "l'ID de l'entreprise n'existe pas",
    "share.emailNotFound": "non enregistré dans LumberLinq",
    "share.createLink": "Créer Link",
    "share.createTallysheetLink": "Créer tallysheet link",
    "share.tallysheetSharedLinks": "Feuille de cubage Shared Links",
    "share.audience": "Audience",
    "share.createdBy": "Créé par",
    "share.limit": "Limit",
    "share.download": "Télécharger",
    "share.noLinksFound": "No shared links found.",
    "share.public": "Tout le monde avec le lien",
    "share.protected": "Utilisateurs LumberLinq uniquement",
    "share.private": "Mon équipe uniquement",
    "share.publicTooltip": "Accessible à toute personne ayant ce lien — aucune connexion requise",
    "share.protectedTooltip": "Seuls les utilisateurs LumberLinq peuvent voir — connexion requise",
    "share.privateTooltip": "Seuls les membres de votre équipe peuvent voir ceci",
    "share.accessMode": "Accès mode",
    "share.linkSettings": "Link settings",
    "share.allowDownloadHint": "Lorsque désactivé, les spectateurs ne peuvent pas exporter le relevé ni télécharger les fichiers de consignation.",
    "share.linkPreview": "Afficher les détails dans l'aperçu du lien",
    "share.linkPreviewHintPublic": "Lorsqu'activé, WhatsApp, Telegram et les autres messageries affichent les pièces, le volume et les produits (uniquement les champs autorisés par vos paramètres d'accès).",
    "share.linkPreviewHintLocked": "Lorsqu'activé, les messageries affichent une carte verrouillée avec le nombre de Stock Units. Aucun autre détail n'est affiché.",
    "share.preview": "Aperçu",
    "share.linkInventory": "Liens Partagés",
    "share.specificCompanyIds": "Specific Entreprise IDs",
    "share.specificEmails": "Specific Email Addresses",
    "share.anyLumberlinqUser": "Any Lumberlinq Utilisateur",
    "share.manageAudience": "Gérer l'audience",
    "share.audienceEmails": "Adresses e-mail",
    "share.audienceCompanies": "IDs d'entreprise",
    "share.addEntry": "Ajouter",
    "share.audienceMinOne": "Au moins une entrée est requise",
    "share.audienceDeleteGate": "Ajoutez d'abord une nouvelle entrée pour activer la suppression",
    "share.audienceNoEntries": "Aucune entrée pour l'instant",
    "share.audienceEmailPlaceholder": "Saisir une adresse e-mail",
    "share.audienceCompanyPlaceholder": "Saisir un ID d'entreprise",
    "share.never": "Never",
    "share.noRestriction": "No restriction",
    "share.missingTransportUnit": "Missing stock unit",
    "share.saveOrLoadTransportUnit": "Enregistrer or load a stock unit before creating a share link.",
    "share.tallysheetLinkCreated": "Feuille de cubage link created",
    "share.linkCopiedToClipboard": "Share link copied to clipboard.",
    "share.linkFailed": "Link failed",
    "shareAudit.title": "Share Link Accès Audit",
    "shareAudit.accesses": "accesses",
    "shareAudit.noAccesses": "No share link accesses recorded yet.",
    "shareAudit.emptyHint": "Every time someone opens a share link, it will appear here.",
    "shareAudit.allowed": "Allowed",
    "shareAudit.denied": "Denied",
    "shareAudit.uniqueVisitors": "Unique Visitors",
    "shareAudit.bots": "Bots",
    "shareAudit.emailUser": "Email / Utilisateur",
    "shareAudit.accessedAt": "Accessed At",
    "shareAudit.ipAddress": "IP Adresse",
    "shareAudit.location": "Standort",
    "shareAudit.browser": "Browser",
    "shareAudit.os": "OS",
    "shareAudit.shareLink": "Share Link",
    "shareAudit.anonymous": "Anonymous",
    "shareAudit.noEntries": "No audit entries found.",
    "share.unableToCreateTallysheetLink": "Unable to create tallysheet share link.",
    "share.oneDay": "1 day",
    "share.sevenDays": "7 days",
    "share.thirtyDays": "30 days",
    "share.ninetyDays": "90 jours",
    "share.neverExpires": "Never expires",
    "tallysheet.rowLimit.title": "La feuille de pointage est pleine",
    "tallysheet.rowLimit.message": "Une feuille de pointage peut contenir au maximum {max} lignes. Commencez une nouvelle feuille pour le reste.",
    "tallysheet.rowLimit.importMessage": "Ces lignes dépasseraient {max} lignes sur la feuille, rien n'a donc été importé. Importez moins de lignes ou utilisez une nouvelle feuille.",
    "share.publicExpiryHint": "Les liens publics expirent toujours : un ancien lien ne peut pas être ouvert par quelqu'un qui le trouve plus tard.",
    "share.disableAll": "Tout désactiver",
    "share.disableAllConfirm": "Désactiver tous les liens de cet enregistrement ? Personne ne pourra plus les ouvrir.",
    "share.disableAllDone": "Liens désactivés",
    "share.oneTime": "One time",
    "share.threeAccesses": "3 accesses",
    "share.fiveAccesses": "5 accesses",
    "share.tenAccesses": "10 accesses",
    "share.custom": "Custom",
    "share.viewSharedLinks": "Voir shared links",
    "share.copyDirectLink": "Copy direct link",
    "share.openDirectLink": "Open direct link",
    "share.copyLink": "Copy Link",
    "share.openLink": "Open Link",
    "share.anyoneWithLink": "Anyone with link can access",
    "share.requiresVerification": "Requires verification",
    "share.restrictedUsersOnly": "Restricted users only",
    "share.addEmailAddress": "Ajouter Lumberlinq email address",
    "share.addCompanyId": "Ajouter company ID",
    "share.missingDetails": "Missing details",
    "share.completeRestrictions": "Please complete the selected sharing restrictions.",
    "share.generatingLink": "Generating link...",
    "share.pleaseWait": "Please wait",
    "share.linkCreated": "Link created",
    "share.tallysheetLinkGenerated": "Feuille de cubage share link generated.",
    "share.linkGeneratedSuccessfully": "Share link generated successfully",
    "share.failed": "Failed",
    "share.unableToCreateShareLink": "Unable to create share link",
    "share.unableToLoadSharedLinks": "Unable to load shared links.",
    "share.docAccess": "Accès au Document",
    "share.docAccessHint": "Contrôlez ce que les spectateurs peuvent faire avec chaque document",
    "share.doc_bl": "Fichier BL",
    "share.doc_ewaybill": "E-Waybill / LR",
    "share.doc_co": "Certificat d'Origine",
    "share.doc_phyto": "Phytosanitaire",
    "share.doc_invoice": "Facture Commerciale",
    "share.doc_other": "Autres Documents",
    "share.docFull": "Accès Complet",
    "share.docViewOnly": "Voir Seulement",
    "share.docFilenameOnly": "Nom de Fichier Seulement",
    "share.docHidden": "Caché",
    "share.copied": "Copied",
    "share.linkCopied": "Link copied",
    "share.transportIdCopied": "Transport ID copied!",
    "share.confirmRevoke": "Are you sure you want to revoke this link?",
    "share.confirmActivate": "Are you sure you want to activate this link?",
    "share.generateShareLink": "Generate Share Link",
    "share.generateShareQuestion": "Do you want to generate",
    "share.shareLinkSuffix": "share link?",
    "share.unableToUpdateLinkStatus": "Unable to update link status.",
    "subscription.transactions": "Transactions",
    "subscription.purchase": "Purchase",
    "subscription.customerCode": "Customer Code",
    "subscription.currentName": "Current Subscription Name",
    "subscription.refresh": "Actualiser",
    "subscription.validTill": "Current Subscription Valid Till",
    "subscription.lastPayment": "Last Paiement Made On",
    "subscription.paymentDue": "Paiement Due On",
    "subscription.paidTill": "Paid Till",
    "subscription.status": "Subscription Statut",
    "subscription.downgradedTitle": "Vous êtes sur le Plan Gratuit",
    "subscription.downgradedBody": "Votre abonnement payant a expiré et ce compte est passé automatiquement au plan gratuit. Vous avez toujours un accès complet à tout ce que vous avez déjà créé — vous ne pouvez simplement pas ajouter de nouveaux éléments au-delà des limites du plan gratuit. Renouvelez à tout moment pour débloquer à nouveau l'accès complet.",
    "subscription.utcNote": "Please note that our system operates based on Coordinated Universal Time (UTC). Therefore, the time of your subscription's activation and expiration will be calculated based on this time zone. If you are in a different time zone, there may be a perceived difference in the timing of your subscription's start and end dates",
    "subscription.autoPay": "Paiement Automatique (EMandate)",
    "subscription.cancelAutoPay": "Annuler le Paiement Automatique",
    "utility.title": "Utility",
    "utility.slabCalculator": "Slab Calculator",
    "utility.slabSubheader": "Input slab dimensions to generate price estimations per size difference",
    "tallysheet.settings": "Paramètres",
    "tallysheet.validationRules": "Validation Rules",
    "tallysheet.configurationSettings": "Configuration Paramètres",
    "tallysheet.transportDetails": "Transport Détails",
    "tallysheet.tu.direction": "Direction",
    "tallysheet.tu.directionChangeHeader": "Changer la Direction ?",
    "tallysheet.tu.directionChangeMessage": "Changer la Direction peut réinitialiser certains champs liés à l'Inventaire — continuer ?",
    "tallysheet.tu.directionStockIn": "Entrée de Stock",
    "tallysheet.tu.directionStockOut": "Sortie de Stock",
    "tallysheet.tu.directionMove": "Transfert Entre Sites",
    "tallysheet.tu.gridStyle": "Disposition de Comptage",
    "tallysheet.tu.gridStyleClassicHint": "Un produit par ligne, choisi maintenant.",
    "tallysheet.tu.gridStyleFlexibleHint": "Choisissez les produits par ligne une fois le comptage commencé — pas besoin de choisir maintenant.",
    "tallysheet.tu.directionChangeHint": "Enregistré — la direction ne peut plus être modifiée après l'enregistrement.",
    "tallysheet.tu.gridStyleChangeHint": "Enregistré — la disposition ne peut plus être modifiée après l'enregistrement.",
    "tallysheet.tu.destinationSite": "Site de Destination",
    "tallysheet.tu.destinationSiteRequired": "Le site de destination est requis.",
    "tallysheet.tu.origin": "Origine",
    "tallysheet.tu.originOptional": "Origine (facultatif)",
    "tallysheet.tu.quality": "Qualité",
    "tallysheet.tu.qualityOptional": "Qualité (facultatif)",
    "tallysheet.tu.qualityMixed": "Mixte / Toute",
    "tallysheet.tu.cbmInStock": "CBM en stock",
    "tallysheet.tu.inStockSuffix": "libres",
    "tallysheet.tu.clickForCft": "Cliquez pour afficher en CFT",
    "tallysheet.tu.clickForCbm": "Cliquez pour afficher en CBM",
    "tallysheet.tu.afterThisSave": "Restant après l'enregistrement",
    "tallysheet.tu.heldByThisSheet": "Réservé par cette feuille",
    "tallysheet.tu.stockFree": "Libre",
    "tallysheet.tu.stockHeld": "Réservé",
    "tallysheet.tu.stockInStock": "En stock",
    "tallysheet.tu.stockRowSizeTip": "La ligne cliquée : libre pour cette feuille, réservé par d'autres Sorties de stock, et le total en stock (cette longueur ou plus)",
    "tallysheet.tu.stockAvailability": "Disponibilité du Stock",
    "tallysheet.tu.noStock": "Aucun stock",
    "tallysheet.tu.stockCantVerifyOffline": "Impossible de vérifier — hors ligne",
    "tallysheet.tu.noStockAtSite": "Aucun stock à",
    "tallysheet.tu.availableAtSite": "disponible à",
    "tallysheet.tu.stockBreakdownTitle": "Détail du Stock",
    "tallysheet.tu.stockOrigin": "Origine",
    "tallysheet.tu.stockQuality": "Qualité",
    "tallysheet.tu.stockPieces": "Pièces",
    "tallysheet.tu.stockSeal": "Scellé",
    "tallysheet.tu.stockSupplier": "Fournisseur",
    "tallysheet.tu.stockNoContributors": "Aucune Unité de Stock contributrice trouvée.",
    "tallysheet.tu.confirmDeleteHeader": "Confirmer la Suppression",
    "tallysheet.tu.confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer l'Unité de Stock ({transportId}) ?",
    "tallysheet.tu.deleteConfirmAccept": "Oui, Supprimer",
    "tallysheet.tu.deletedSuccess": "Unité de Stock supprimée avec succès",
    "tallysheet.tu.deleteNotAllowedHeader": "Suppression Non Autorisée",
    "tallysheet.tu.deleteNotAllowedFallback": "Cette Unité de Stock ne peut pas être supprimée pour le moment.",
    "tallysheet.tu.deleteFailedHeader": "Échec de la Suppression",
    "tallysheet.tu.deleteFailedMessage": "Impossible de supprimer l'Unité de Stock. Veuillez réessayer plus tard.",
    "tallysheet.fulfill.title": "Plan d'Exécution",
    "tallysheet.fulfill.size": "Taille",
    "tallysheet.fulfill.grade": "Qualité",
    "tallysheet.fulfill.inStock": "En Stock",
    "tallysheet.fulfill.allocate": "Utiliser",
    "tallysheet.fulfill.waste": "Perte",
    "tallysheet.fulfill.why": "Raison",
    "tallysheet.fulfill.required": "Requis",
    "tallysheet.fulfill.covered": "Couvert",
    "tallysheet.fulfill.short": "Manque",
    "tallysheet.fulfill.moreOptions": "Plus d'options",
    "tallysheet.fulfill.noStock": "Aucun stock pratique pour cette taille, origine et qualité.",
    "tallysheet.fulfill.tierExact": "Correspondance exacte",
    "tallysheet.fulfill.tierTrim": "Plus long — recouper",
    "tallysheet.fulfill.tierResaw": "Resciage depuis plus grand",
    "tallysheet.fulfill.tierGrade": "Qualité différente",
    "tallysheet.fulfill.tierOrigin": "Origine différente",
    "tallysheet.fulfill.tierShort": "Plus court — confirmer",
    "tallysheet.fulfill.tierMixed": "Longueurs mixtes — vérifier",
    "tallysheet.quick.button": "Tally Rapide",
    "tallysheet.quick.tooltip": "Tapez en abrégé comme 4x3x7 250 Ghana A — le système crée les lignes",
    "tallysheet.quick.title": "Tally Rapide",
    "tallysheet.quick.hint": "Une entrée par virgule ou ligne : taille, pièces, puis origine et qualité optionnelles. Exemple : 4x3x7 250 Ghana A",
    "tallysheet.quick.notes": "Notes",
    "tallysheet.quick.apply": "Ajouter les lignes",
    "tallysheet.quick.noDimensions": "Aucune taille trouvée (ex. 4x3x7)",
    "tallysheet.quick.noPieces": "Nombre de pièces manquant",
    "tallysheet.quick.lengthMissing": "Longueur manquante — à remplir dans la grille",
    "tallysheet.flex.button": "Disposition Flexible",
    "tallysheet.flex.classicOption": "Disposition Standard",
    "tallysheet.flex.searchProducts": "Rechercher des produits...",
    "tallysheet.flex.noProductsFound": "Aucun produit trouvé",
    "tallysheet.flex.pickProductFirst": "Choisissez d'abord un produit pour voir son stock",
    "tallysheet.flex.switchTooltip": "Standard : un produit par ligne. Flexible : produit/origine/qualité par ligne, plus tailles depuis le stock",
    "tallysheet.flex.cascadeTitle": "Produit de la Ligne",
    "tallysheet.flex.stockTitle": "Choisir depuis le stock",
    "tallysheet.flex.noProductYet": "Aucun produit choisi pour le moment",
    "tallysheet.flex.sameAsLine": "Identique à la ligne",
    "tallysheet.flex.typedSoFar": "Saisi jusqu'ici",
    "tallysheet.flex.showAll": "Tout afficher",
    "tallysheet.flex.requestCustomMade": "Non disponible — demander une fabrication sur mesure",
    "tallysheet.flex.cancelRequest": "Annuler la demande",
    "tallysheet.flex.cancelRequestHeader": "Annuler la demande à la scierie ?",
    "tallysheet.flex.cancelRequestMessage": "La scierie ne coupera plus cette taille pour cette ligne. Vous pourrez la redemander plus tard.",
    "tallysheet.flex.cancelRequestYes": "Oui, annuler",
    "tallysheet.flex.cancelRequestDone": "Demande à la scierie annulée",
    "tallysheet.flex.noneMatchExactly": "Aucun de ces éléments ne correspond exactement à :",
    "tallysheet.flex.stockStaleNotice": "Stock affiché depuis votre dernière synchronisation — peut être obsolète.",
    "tallysheet.flex.availablePcs": "pièces disponibles pour cette taille",
    "tallysheet.flex.availableCbm": "CBM disponible",
    "tallysheet.flex.availableStockTooltip": "Le stock disponible exclut ce qui est déjà réservé par d'autres lignes de sortie de stock enregistrées et des tâches de scierie actives — pas encore confirmé, mais déjà engagé. Modifiez ceci dans Entreprise → Paramètres d'inventaire.",
    "tallysheet.flex.customMadeLockedTitle": "Ligne verrouillée — tâche de scierie en cours",
    "tallysheet.flex.customMadeLockedDetail": "Le matériau de cette ligne est déjà en cours de découpe par une tâche de scierie et ne peut pas être modifié ou supprimé tant que cette tâche n'est pas terminée. Elle se déverrouille automatiquement une fois terminée — aucune action requise.",
    "tallysheet.flex.importUnavailable": "L'import n'est pas disponible en Vue Flexible — passez en Mise en page Standard pour importer.",
    "tallysheet.flex.customMadeLockedTooltipProducing": "Verrouillé — une tâche de scierie découpe actuellement cette taille. Elle se déverrouille automatiquement une fois cette tâche terminée.",
    "tallysheet.flex.customMadeLockedTooltipWaiting": "Verrouillé — une tâche de scierie a été créée pour cette taille et est en attente de démarrage. Elle se déverrouille automatiquement une fois cette tâche terminée.",
    "tallysheet.flex.customMadeLockedTooltipPaused": "Verrouillé — la tâche de scierie pour cette taille a commencé et est en pause. Elle se déverrouille automatiquement une fois cette tâche terminée ou annulée.",
    "tally.aiReview.needsOne": "ligne à vérifier — l'IA n'était pas sûre ou n'a pas pu lire une valeur",
    "tally.aiReview.needsMany": "lignes à vérifier — l'IA n'était pas sûre ou n'a pas pu lire une valeur",
    "tally.aiReview.showOnly": "Afficher seulement celles-ci",
    "tally.aiReview.showAll": "Afficher toutes les lignes",
    "tally.aiReview.showOnlyTip": "Afficher seulement ces lignes",
    "tally.aiReview.prev": "Ligne précédente à vérifier",
    "tally.aiReview.next": "Ligne suivante à vérifier",
    "tally.aiReview.row": "Ligne",
    "tally.warn.lengthRange": "Longueur hors de la plage définie — valeur conservée",
    "tally.warn.girthRange": "Circonférence hors de la plage définie — valeur conservée",
    "tally.errorNav.lengthMissing": "Ligne {row} : la Longueur est manquante",
    "tally.errorNav.girthMissing": "Ligne {row} : la Circonférence est manquante",
    "tally.errorNav.bothMissing": "Ligne {row} : la Longueur et la Circonférence sont manquantes",
    "tally.warn.divisibleBy5": "Longueur non divisible par 5 — valeur conservée",
    "tallysheet.flex.deleteRowConfirm": "Supprimer cette ligne ?",
    "tallysheet.flex.stockStatusLabel": "État du Stock",
    "tallysheet.flex.stockStatusNotReserved": "Point rouge — pas encore de correspondance exacte, rien de réservé pour cette ligne",
    "tallysheet.flex.stockStatusMillTask": "En production / En attente de démarrage — retenu par une tâche de scierie active",
    "tallysheet.flex.stockStatusReserved": "Pas d'insigne — correspond à un stock réel et réservé",
    "company.includeReservations.label": "Comptabiliser le travail en cours dans le stock disponible",
    "company.includeReservations.hint": "Activé par défaut — le stock déjà réclamé par des lignes de sortie enregistrées ou des tâches de scierie actives n'apparaîtra pas comme disponible tant qu'il n'est pas confirmé ou libéré. Désactivez pour voir le total physique brut.",
    "tallysheet.flex.back": "Retour",
    "tallysheet.flex.next": "Suivant",
    "tallysheet.flex.done": "Terminer",
    "tallysheet.flex.scEnter": "ouvrir l'assistant/sélecteur · sur Pièces : ligne remplie suivante",
    "tallysheet.flex.scAltEnter": "sélecteur de stock à tout moment",
    "tallysheet.flex.scCtrlEnter": "nouvelle ligne",
    "tallysheet.flex.scCtrlBackspace": "vider la ligne",
    "tallysheet.flex.shortcutsLabel": "Raccourcis",
    "tallysheet.flex.shapeSubtitleSquare": "🔵 Ceci est un Tallysheet carré — seuls les produits de coupe carrée sont affichés. Les produits ronds n'apparaîtront pas ici.",
    "tallysheet.flex.shapeRedirect": "Besoin d'une autre forme (ex. grumes rondes) ? Passez à la Disposition Standard — chaque ligne de produit y a son propre type de comptage.",
    "tallysheet.flex.lockedTooltip": "Verrouillé — cette feuille a déjà des lignes enregistrées. Choisissez la disposition avant d'enregistrer.",
    "tallysheet.flex.confirmSwitchHeader": "Passer à la Disposition Flexible ?",
    "tallysheet.flex.confirmSwitchMessage": "Vous avez des lignes non enregistrées. Le changement est sûr, mais pensez à enregistrer d'abord. Continuer ?",
    "tallysheet.tu.stockAnyOrigin": "Toute origine",
    "tallysheet.tu.stockAnyQuality": "Toute qualité",
    "tallysheet.tu.additionalProducts": "Produits Supplémentaires",
    "tallysheet.tu.products": "Produits",
    "tallysheet.tu.viewStock": "Voir la disponibilité du stock",
    "tallysheet.tu.removeLineConfirmHeader": "Supprimer la Fiche de Comptage",
    "tallysheet.tu.removeLineConfirmMessage": "Supprimer la fiche de comptage de {product} supprimera définitivement {count} enregistrement(s) de comptage qui y sont liés. Tapez CONFIRM pour continuer.",
    "tallysheet.tu.addAnotherProduct": "Ajouter un autre produit",
    "tallysheet.tu.removeLine": "Supprimer cette ligne de produit",
    "tallysheet.tu.removeLineHeader": "Supprimer la Ligne de Produit",
    "tallysheet.tu.removeLineMessage": "Si cette ligne contient déjà des lignes de comptage, elles doivent d'abord être supprimées — sinon l'enregistrement sera bloqué.",
    "tallysheet.tu.typeSwitchHeader": "Le Type de Comptage Va Changer",
    "tallysheet.tu.typeSwitchMessage": "Changer le produit sur {lines} modifie son type de comptage — les lignes de comptage existantes de cette ligne seront définitivement supprimées. Continuer ?",
    "tallysheet.overStock.header": "Enregistrement Au-delà du Stock Disponible",
    "tallysheet.overStock.message": "{line} serait comptabilisé à {total} CBM, mais seulement {available} CBM est disponible en stock. Veuillez indiquer pourquoi vous souhaitez continuer :",
    "tallysheet.overStock.reasonPlaceholder": "Raison (obligatoire)",
    "tallysheet.overStock.proceed": "Enregistrer Quand Même",
    "tallysheet.stockUnitId": "ID de l'unité de stock",
    "tallysheet.tu.tooltipStockUnitId": "Identité de cette unité de stock — attribuée automatiquement par le système, unique, jamais modifiable. Générée dès l'enregistrement.",
    "tallysheet.stockUnitIdPending": "En attente",
    "tallysheet.transportId": "Transport ID",
    "tallysheet.transportModeDetails": "Transport Mode Détails",
    "tallysheet.tu.tooltipTransportId": "Référence optionnelle pour le véhicule/conteneur réel utilisé — peut se répéter (ex : le même camion peut revenir plusieurs fois)",
    "tallysheet.tu.tooltipContainerNumber": "Numéro de conteneur ISO attribué par le transporteur — 4 lettres + 6 chiffres + chiffre de contrôle (ex : MSCU1234567)",
    "tallysheet.tu.tooltipSealNo": "Sceau de sécurité physique fixé sur la porte du conteneur — référencé dans les documents phytosanitaires et douaniers (ex : SNHR123456)",
    "tallysheet.tu.tooltipLoadingSite": "Lieu d'origine du chargement du bois — site d'origine (forêt, chantier, scierie ou port)",
    "tallysheet.tu.tooltipRoute": "Trajet du camion du site à la destination (ex : Raipur au Port de Kandla)",
    "tallysheet.tu.tooltipVehicleRegNo": "Plaque d'immatriculation officielle du camion ou de la remorque (ex : MH04-AB-1234)",
    "tallysheet.tu.tooltipWagonNo": "Numéro du wagon ferroviaire tel qu'imprimé sur le wagon (ex : BOXN-67890)",
    "tallysheet.chooseColumns": "Choisir Columns",
    "tallysheet.colPreset.simple": "Simple",
    "tallysheet.colPreset.detailed": "Détaillé",
    "tallysheet.colPreset.custom": "Personnalisé",
    "tallysheet.colGroup.measurements": "Mesures",
    "tallysheet.colGroup.volume": "Volume",
    "tallysheet.colGroup.allowances": "Tolérances",
    "tallysheet.colGroup.other": "Autres",
    "tallysheet.editSettings": "Modifier les paramètres du tally",
    "tallysheet.decimalsShort": "décimales",
    "tallysheet.globalSearch": "Global Rechercher",
    "tallysheet.transportUnits": "Unités de Stock",
    "tallysheet.unit": "unité",
    "tallysheet.units": "unités",
    "tallysheet.transportUnitsSubtitle": "Review stock units, open tallies, and manage secure share links",
    "tallysheet.viewTallysheet": "Voir tallysheet",
    "tallysheet.thisPage": "cette page",
    "tallysheet.allPages": "toutes les pages",
    "tallysheet.sortNewest": "Plus récents",
    "tallysheet.sortOldest": "Plus anciens",
    "tallysheet.sortStockUnitId": "ID d’unité de stock",
    "tallysheet.sortProduct": "Produit",
    "tallysheet.fullReportPdf": "Rapport complet (PDF)",
    "tallysheet.copyTransportId": "Copy transport ID",
    "tallysheet.operations": "Operations",
    "tallysheet.newTallysheet": "New Feuille de cubage",
    "tallysheet.syncedTitle": "Synchronisé",
    "tallysheet.syncedDetail": "Cette unité de stock a été synchronisée avec le serveur.",
    "tallysheet.newTransportUnit": "Nouvelle unité de stock",
    "tallysheet.newTallysheetSubtitle": "Capture stock unit details, tally measurements, photos, and summary in one workflow.",
    "tallysheet.editTransportUnit": "Modifier l'unité de stock",
    "tallysheet.viewTransportUnit": "Voir l'unité de stock",
    "tallysheet.editTransportUnitSubtitle": "Mettez à jour les détails de l'unité de stock, les mesures de cubage, les photos et le résumé en un seul flux.",
    "tallysheet.viewTransportUnitSubtitle": "Consultez les détails de l'unité de stock, les mesures de cubage, les photos et le résumé en un seul flux.",
    "tallysheet.transportUnit": "Unité de Stock",
    "tallysheet.switchingTu": "Chargement de l'unité de stock…",
    "tallysheet.tuLoadFailed": "Échec du chargement de cette unité de stock.",
    "tallysheet.tallysheet": "Feuille de cubage",
    "tallysheet.roundTallysheet": "Round Feuille de cubage",
    "tallysheet.squareTallysheet": "Square Feuille de cubage",
    "tallysheet.measurementGrid": "Measurement grid",
    "tallysheet.measurementGridSubtitle": "Capture, validate, import, and save tally measurements",
    "tallysheet.rows": "Rows",
    "tallysheet.columnsSelected": "Columns",
    "tallysheet.editActions": "Modifier",
    "tallysheet.viewControls": "Voir",
    "tallysheet.dataActions": "Data",
    "tallysheet.voiceControls": "Voice",
    "tallysheet.photos": "Photos",
    "tallysheet.summary": "Résumé",
    "tallysheet.reconciliation": "Reconciliation",
    "tallysheet.goToRow": "Go to Row",
    "tallysheet.export": "Exporter",
    "tallysheet.quickExcelExport": "Quick Excel",
    "tallysheet.exportOptions": "Export Options…",
    "export.companyDetails": "Détails de l'Entreprise",
    "export.chartsAndStats": "Graphiques et Statistiques",
    "export.showMaskedFields": "Afficher les Champs Masqués",
    "export.watermark": "Filigrane",
    "export.packingList": "Liste de Colisage",
    "export.surveyReport": "Rapport d'Expertise",
    "export.certificate": "Certificat",
    "tallysheet.save": "Enregistrer",
    "tallysheet.sr": "Sr",
    "tallysheet.orderKey": "Order Key",
    "tallysheet.girth": "Girth",
    "tallysheet.lengthAllowanceShort": "Longueur Allow.",
    "tallysheet.girthAllowanceShort": "Girth Allow.",
    "tallysheet.netLength": "Net Longueur",
    "tallysheet.netGirth": "Net Girth",
    "tallysheet.net": "Net",
    "tallysheet.gross": "Brut",
    "tallysheet.allowance": "Déduction",
    "tallysheet.volBasisHint": "Volume net affiché — appuyez pour le brut",
    "tallysheet.volBasisHintGross": "Volume brut affiché — appuyez pour le net",
    "tallysheet.volBasisWhy": "Le net compte pour le stock, les ventes et les travaux de scierie. Le brut est la taille mesurée au départ. Appuyez sur Net ou Brut pour changer.",
    "tallysheet.volBreakdownTitle": "Volume Net vs Brut",
    "tallysheet.volBreakdownExplain": "Le net est ce qui compte pour le stock, les ventes et les travaux de scierie. Le brut est la taille mesurée au départ, avant la déduction d'écorce et de coupe.",
    "tallysheet.switchToGross": "Passer au Brut",
    "tallysheet.switchToNet": "Passer au Net",
    "tallysheet.grossCbm": "Gross CBM",
    "tallysheet.grossCft": "Gross CFT",
    "tallysheet.netCbm": "Net CBM",
    "tallysheet.netCft": "Net CFT",
    "tallysheet.supplier": "Supplier",
    "tallysheet.buyer": "Buyer",
    "tallysheet.driver": "Driver",
    "tallysheet.route": "Route",
    "tallysheet.expectedDelivery": "Expected Delivery",
    "tallysheet.mode": "Mode",
    "tallysheet.seaPort": "Sea Port",
    "tallysheet.locationMode": "Lieu et Mode",
    "tallysheet.totalPieces": "Total Pièces",
    "tallysheet.netVolumeCbm": "Vol. Net (CBM)",
    "tallysheet.avgCft": "Moy CFT",
    "tallysheet.weight": "Poids (kg)",
    "tallysheet.photoCount": "Photos",
    "tallysheet.metrics": "Métriques",
    "tallysheet.divisibleBy5": "Divisible by 5",
    "tallysheet.divisibleBy5On": "Divisible by 5 ON",
    "tallysheet.divisibleBy5Off": "Divisible by 5 OFF",
    "tallysheet.lengthRange": "Longueur Range",
    "tallysheet.lengthRangeOn": "Longueur Range ON",
    "tallysheet.widthRange": "Plage de largeur",
    "tallysheet.thickRange": "Plage d'épaisseur",
    "tallysheet.rangeOn": "Activé",
    "tallysheet.rangeOff": "Désactivé",
    "tallysheet.rangeHint": "Les valeurs hors plage sont signalées en orange et conservées.",
    "tallysheet.resetToCompanyDefaults": "Revenir aux paramètres de l'entreprise",
    "tallysheet.resetConfirm": "Change les unités, tolérances et règles de ce tally.",
    "tallysheet.resetYes": "Réinitialiser",
    "tallysheet.lengthRangeOff": "Longueur Range OFF",
    "tallysheet.girthRange": "Girth Range",
    "tallysheet.girthRangeOn": "Girth Range ON",
    "tallysheet.girthRangeOff": "Girth Range OFF",
    "tallysheet.unitOfMeasure": "Unit of Measure",
    "tallysheet.copyPreviousLength": "Copy Previous Longueur",
    "tallysheet.enterNavMode": "↵ Mode",
    "tallysheet.enterNavModeTooltip": "<b>Mode Ligne:</b> Entrée sur Longueur → Circonférence; Entrée sur Circonférence → nouvelle ligne.<br><b>Mode Colonne:</b> Entrée sur Longueur → nouvelle ligne (reste en colonne); Entrée sur Circonférence → ligne suivante (crée une nouvelle ligne si c&#39;est la dernière).<br><b>Ctrl+Entrée</b> (tout mode) → forcer l&#39;action, ignorer la validation.",
    "tallysheet.allowances": "Allowances",
    "tallysheet.lengthAllowance": "Longueur Allowance",
    "tallysheet.girthAllowance": "Girth Allowance",
    "tallysheet.allowancesLocked": "Allowances are locked once rows exceed",
    "tallysheet.columns": "Columns",
    "tallysheet.showColumns": "Show columns",
    "tallysheet.saveFormSettings": "Enregistrer Form Paramètres",
    "tallysheet.confirmSave": "Confirm Enregistrer",
    "tallysheet.uomChangeTitle": "Changer l'unité de mesure ?",
    "tallysheet.uomChangeMessage":
      "Ce relevé contient déjà des lignes. Comment les valeurs existantes de {field} doivent-elles être traitées pour la nouvelle unité ?",
    "tallysheet.uomChangeKeep": "Conserver les nombres tels que saisis",
    "tallysheet.uomChangeKeepHint":
      "Recalculer avec les mêmes nombres dans la nouvelle unité — à utiliser si vous avez saisi les bons nombres mais choisi la mauvaise unité.",
    "tallysheet.uomChangeConvert": "Convertir les valeurs",
    "tallysheet.uomChangeConvertHint":
      "Réécrire les nombres existants dans la nouvelle unité, en conservant la même mesure physique.",
    "tallysheet.uomChangeCancel": "Annuler",
    "account.profilePicture": "Photo de Profil",
    "account.yourRole": "Votre Rôle",
    "account.details": "Account Détails",
    "account.personalDetails": "Personal Détails",
    "account.detailsHint": "Votre e-mail de connexion et un numéro de mobile vérifié",
    "account.personalHint": "À propos de vous, pour que votre équipe et vos documents affichent le bon nom",
    "account.addressHeading": "Adresse",
    "account.changePassword": "Change Password",
    "account.emailNotVerified": "Email is not verified. Please verify your email address.",
    "account.mobile": "Mobile",
    "account.enterMobile": "Enter mobile Number",
    "account.mobileNotVerified": "Mobile is not verified. Please verify your mobile number.",
    "account.sendOtp": "Send OTP",
    "account.editMobile": "Modifier Mobile",
    "account.dateOfBirth": "Date of Birth",
    "account.gender": "Gender",
    "account.next": "Suivant",
    "account.otpSentTo": "OTP has been sent to",
    "account.enterOtpBelow": "Please enter the OTP below to verify your phone number.",
    "account.resendOtpIn": "Resend OTP in",
    "account.seconds": "seconds",
    "account.resend": "Resend",
    "account.sendOtpWhatsapp": "Envoyer le code sur WhatsApp",
    "account.sendOtpSms": "Envoyer le code par SMS",
    "account.otpWhatsappNote": "Le code arrive sur WhatsApp de la part de LumberLinq. Touchez Copier le code, puis collez-le ici.",
    "account.otpWhatsappFailed": "Nous n'avons pas pu envoyer le code sur WhatsApp. Vérifiez que ce numéro est sur WhatsApp ou envoyez le code par SMS.",
    "account.otpUseSms": "Envoyer par SMS à la place",
    "account.otpUseWhatsapp": "Envoyer sur WhatsApp à la place",
    "account.otpPickHint": "Recevez votre code à 6 chiffres sur WhatsApp ou par SMS",
    "account.otpWaDelivered": "Le code est maintenant sur votre WhatsApp. Ouvrez la conversation, touchez Copier le code et collez-le ici.",
    "account.otpWaNotDelivered": "WhatsApp n'a pas pu livrer le code (le numéro n'est peut-être pas sur WhatsApp). Envoyez plutôt le code par SMS.",
    "account.otpWaPending": "Pas encore sur votre téléphone ? Patientez un peu, renvoyez-le ou envoyez le code par SMS.",
    "account.confirm": "Confirm",
    "account.oldPassword": "Old Password",
    "account.newPassword": "New Password",
    "account.confirmPassword": "Confirm Password",
    "account.oldPasswordRequired": "Old Password est obligatoire.",
    "account.passwordMinLength": "Le mot de passe doit comporter au moins 8 caractères.",
    "account.passwordStrengthHint": "Le mot de passe doit contenir au moins une lettre et un chiffre.",
    "account.passwordChangeFailed": "Échec du changement de mot de passe. Veuillez réessayer.",
    "account.confirmPasswordRequired": "Confirm Password est obligatoire.",
    "account.passwordsMismatch": "Passwords do not match.",
    "account.mustBeAtLeast13": "Vous devez avoir au moins 13 ans.",
    "user.mustBeAtLeast13": "Vous devez avoir au moins 13 ans.",
    "account.notValidEmail": "is not a valid email",
    "account.passwordRule": "must contain at least 1 uppercase, 1 lowercase letter, and 1 number",
    "account.mustBeAtLeast": "must be at least",
    "account.charactersLong": "characters long",
    "account.profileUpdated": "Profil updated successfully.",
    "account.profileLoadFailed": "Unable to load profile details.",
    "account.noProfileChanges": "No profile changes to update.",
    "account.saveAllHint": "Enregistre les Détails du Compte, Données Personnelles et Fuseau Horaire ensemble.",
    "account.requiredAddressFields": "Please complete all required address fields before continuing.",
    "account.requiredFields": "Please complete all required fields before continuing.",
    "account.updateFailed": "An error occurred while updating the record.",
    "account.verificationRequired": "Verification Obligatoire",
    "account.verifyMobileAndEmail": "Please verify your mobile and email first.",
    "account.mobileVerified": "Mobile verified",
    "account.mobileAlreadyVerified": "Your mobile number is already verified.",
    "account.mobileLocked": "Verified mobile number cannot be changed from this screen.",
    "account.otpSent": "OTP Sent",
    "account.otpError": "OTP Erreur",
    "account.otpUnableToSend": "Unable to send OTP.",
    "account.tryAgainLater": "Please try again later",
    "account.maxOtpAttempts": "You have reached the maximum number of OTP resend attempts.",
    "account.otpValidated": "OTP Validated",
    "account.otpInvalidTitle": "OTP is Invalide",
    "account.otpInvalid": "Invalide OTP.",
    "account.otpDigit": "OTP digit",
    "account.invalidMobileOnly": "Only mobile numbers are allowed. Please enter a valid mobile number.",
    "account.invalidPhoneFormat": "Invalide phone number format.",
    "Male": "Male",
    "Female": "Female",
    "Prefer not to say": "Prefer not to say",
    "product.name": "Produit",
    "product.multipleProducts": "Produits",
    "product.multipleProductsBreakdown": "Produits dans cette unité",
    "product.namePlural": "Produits",
    "product.subtitle": "Gérez les produits bois, espèces et codes SH",
    "product.all": "All Produits",
    "product.update": "Mettre à jour Produit",
    "product.manageDetails": "Voir and manage existing product details",
    "product.editDetails": "Modifier details of existing products",
    "product.hsCode": "HS Code",
    "product.formula": "Formule",
    "product.selectFormula": "Sélectionner Formula",
    "product.quickAdd": "Ajouter un nouveau produit",
    "product.quickAddTitle": "Nouveau Produit",
    "product.nameRequiredHint": "Le nom doit comporter au moins 5 caractères.",
    "product.hsCodeHint": "Le code SH doit comporter 4 à 8 chiffres.",
    "product.quickAddedDetail": "Produit créé et sélectionné.",
    "product.quickAddError": "Impossible de créer le produit. Veuillez réessayer.",
    "product.description": "Description",
    "product.species": "Espèce",
    "product.usedIn": "Utilisé dans",
    "product.selectSpecies": "Sélectionner l'espèce",
    "product.productCode": "Code produit",
    "product.photos": "Photos du produit",
    "product.addPhoto": "Ajouter une photo",
    "product.setAsDP": "Définir comme photo principale",
    "product.formulasGuide": "Formulas Guide",
    "product.formulaGuide.roundTitle": "Grume ronde",
    "product.formulaGuide.roundFormula": "Hoppus formula: (Girth × Girth × Longueur) ÷ 160,000",
    "product.formulaGuide.roundWhen": "For round, unprocessed logs and roundwood.",
    "product.formulaGuide.roundChoose": "Choisir this when the cross-section is circular — whole logs, rawwood, and unprocessed round timber.",
    "product.formulaGuide.squareTitle": "Équarri / scié",
    "product.formulaGuide.squareFormula": "Volumetric formula: Longueur × Largeur × Hauteur",
    "product.formulaGuide.squareWhen": "For sawn or square-cut timber.",
    "product.formulaGuide.squareChoose": "Choisir this when the timber is rectangular or square-cut — planks, beams, lumber, and dressed wood.",
    "product.formulaGuide.notSure": "Not sure which to pick?",
    "product.formulaGuide.tip": "Round cross-section → Round Log. Rectangular or square-cut → Square / Sawn.",
    "product.formulaPicker": "Formula Picker",
    "product.deletionRestriction": "Produit Deletion Restriction",
    "product.addNew": "Ajouter New Produit",
    "product.bulkImport": "Import en masse",
    "product.create": "Créer Produit",
    "product.inputDetails": "Input new product details",
    "loadingSite.name": "Nom du site",
    "loadingSite.namePlural": "Sites",
    "loadingSite.quickAdd": "Ajouter un nouveau site",
    "loadingSite.quickAddTitle": "Nouveau Site",
    "loadingSite.nameRequired": "Le nom doit comporter au moins 3 caractères.",
    "loadingSite.quickAddedDetail": "Site créé et sélectionné.",
    "loadingSite.quickAddError": "Impossible de créer le site. Veuillez réessayer.",
    "loadingSite.all": "Tous les Sites",
    "loadingSite.update": "Mettre à jour le Site",
    "loadingSite.manageProfiles": "Voir et gérer les profils de sites existants",
    "loadingSite.editDetails": "Modifier les détails des sites existants",
    "loadingSite.contactPerson": "Personne à contacter",
    "loadingSite.operatingHours": "Heures d'ouverture",
    "loadingSite.capacity": "Capacité",
    "loadingSite.capacityCbm": "Capacité (CBM)",
    "loadingSite.currentVolume": "Volume actuel",
    "loadingSite.machinesInstalled": "Machine(s) installée(s)",
    "loadingSite.notes": "Remarques",
    "loadingSite.addNew": "Ajouter un Nouveau Site",
    "loadingSite.bulkImport": "Import en masse",
    "loadingSite.create": "Créer un Site",
    "loadingSite.inputDetails": "Saisir les détails du nouveau site",
    "location.selectCountry": "Sélectionner un pays",
    "location.selectState": "Sélectionner un État",
    "location.selectCity": "Sélectionner une ville",
    "location.country": "Pays",
    "location.state": "État / Province",
    "location.city": "Ville",
    "location.address1": "Adresse Line 1",
    "location.address2": "Adresse Line 2",
    "location.postalCode": "Postal Code",
    "location.cityUnavailableOffline": "Liste des villes indisponible hors ligne. Connectez-vous une fois pour charger les villes de cet état.",
    "location.cityNotAvailableOffline": "Non disponible hors ligne",
    "mediaCapture.takePhoto": "Prendre une Photo",
    "mediaCapture.recordVideo": "Enregistrer une Vidéo (max 30s)",
    "mediaCapture.chooseGallery": "Choisir depuis la Galerie",
    "mediaCapture.browseFiles": "Parcourir les Fichiers",
    "mediaCapture.videoTooLongTitle": "Vidéo Trop Longue",
    "mediaCapture.videoTooLongDetail": "La vidéo doit durer 30 secondes ou moins. Veuillez réessayer.",
    "mediaCapture.captureFailedTitle": "Échec de la Capture",
    "mediaCapture.captureFailedDetail": "Impossible de capturer le média. Veuillez réessayer.",
    "mediaCapture.pasteRejectedTitle": "Fichier collé refusé",
    "mediaCapture.pasteRejectedDetail": "Cette zone de dépôt n'accepte pas ce type de fichier.",
    "sfs.title": "Où ces fichiers doivent-ils aller ?",
    "sfs.filesReady": "fichier(s) prêt(s)",
    "sfs.consignment": "Documents de l'expédition",
    "sfs.consignmentHint": "BL, facture, certificats et plus",
    "sfs.stockUnit": "Documents de l'unité de stock",
    "sfs.stockUnitHint": "Photos et papiers d'une unité de stock",
    "sfs.aiImport": "Import IA",
    "sfs.aiImportHint": "Lire une feuille de pointage depuis une photo ou un PDF",
    "sfs.aiNeedsImage": "Il faut une photo ou un PDF",
    "sfs.ticket": "Ticket de support",
    "sfs.ticketHint": "Joindre à un nouveau ticket",
    "sfs.pickPlace": "Choisir un emplacement",
    "sfs.pickDocType": "Quel type de document ?",
    "sfs.back": "Retour",
    "sfs.cancel": "Annuler",
    "sfs.discard": "Ignorer les fichiers",
    "sfs.noAccess": "Vous n'avez pas le droit d'envoyer des fichiers. Demandez à votre administrateur.",
    "sfs.note": "Rien n'est encore envoyé. L'écran choisi vous demandera de confirmer.",
    "sfs.toast.title": "Fichiers en attente",
    "sfs.toast.consignment": "Ouvrez l'expédition voulue, puis appuyez sur Joindre ici.",
    "sfs.toast.consignmentHere": "Appuyez sur Joindre ici dans l'onglet Documents de cette expédition.",
    "sfs.toast.aiImportHere": "Appuyez sur Joindre ici au-dessus de cette feuille de pointage.",
    "sfs.toast.stockUnit": "Ouvrez une unité de stock, allez à l'onglet Photos, puis appuyez sur Joindre ici.",
    "sfs.toast.stockUnitHere": "Appuyez sur Joindre ici dans l'onglet Photos de cette unité de stock.",
    "sfs.toast.aiImport": "Ouvrez la feuille de pointage voulue, puis appuyez sur Joindre ici.",
    "sfs.toast.ticket": "Remplissez le ticket. Les fichiers sont déjà ajoutés.",
    "sfs.waiting.consignment": "ouvrez l'expédition voulue et appuyez sur Joindre ici",
    "sfs.waiting.stockUnit": "ouvrez une unité de stock, onglet Photos, et appuyez sur Joindre ici",
    "sfs.waiting.aiImport": "ouvrez une feuille de pointage et appuyez sur Joindre ici",
    "sfs.waiting.ticket": "ajoutés à votre nouveau ticket",
    "sfs.banner.hint": "En attente d'être joints à un enregistrement.",
    "sfs.banner.attach": "Joindre ici",
    "sfs.banner.discard": "Ignorer",
    "sfs.blocked.locked": "Cette expédition est verrouillée, les fichiers ne peuvent pas être ajoutés.",
    "sfs.blocked.shipped": "Cette unité de stock a été expédiée et est verrouillée, les fichiers ne peuvent pas être ajoutés.",
    "sfs.blocked.viewMode": "Cette feuille de pointage est en lecture seule pour l'instant. Passez d'abord en mode édition, puis joignez les fichiers.",
    "sfs.blocked.slot": "Ce type de document n'est pas disponible sur cette expédition.",
    "sfs.blocked.readonly": "Vous pouvez seulement consulter ce type de document ici.",
    "sfs.blocked.busy": "Un autre envoi est en cours. Veuillez patienter.",
    "mediaCapture.paste": "Coller",
    "mediaCapture.pasteNothingTitle": "Rien à coller",
    "mediaCapture.pasteNothing": "Aucun fichier dans le presse-papiers. Copiez d'abord un fichier, ou utilisez Partager → LumberLinq depuis l'autre application.",
    "mediaCapture.pasteTextOnly": "Le presse-papiers contient du texte, pas un fichier. Copiez d'abord un fichier, ou utilisez Partager → LumberLinq depuis l'autre application.",
    "mediaCapture.pasteNoImage": "Aucune image dans le presse-papiers. Copiez une image ou faites une capture d'écran, puis appuyez sur Coller.",
    "sfs.native.failedTitle": "Certains fichiers n'ont pas pu être lus",
    "sfs.native.failed": "Certains fichiers partagés étaient trop volumineux ou n'ont pas pu être ouverts. Veuillez les partager à nouveau.",
    "avatar.changePhoto": "Changer la Photo",
    "avatar.chooseFile": "Choisir un Fichier",
    "avatar.removePhoto": "Supprimer la Photo",
    "avatar.cropTitle": "Ajustez Votre Photo",
    "avatar.cropHint": "Glissez pour repositionner • Faites défiler ou pincez pour zoomer",
    "avatar.cropConfirm": "Utiliser la Photo",
    "avatar.cropCancel": "Annuler",
    "avatar.uploading": "Téléchargement...",
    "avatar.uploadSuccess": "Photo de profil mise à jour",
    "permEditor.viewAddedNote": "Le droit de consultation a aussi été activé, car ce droit en a besoin.",
    "permEditor.actionsRemovedNote": "Les droits qui nécessitent la consultation ont aussi été désactivés.",
    "permEditor.needsView": "Nécessite la consultation",
    "avatar.uploadFailed": "Échec du téléchargement",
    "avatar.retry": "Réessayer",
    "avatar.confirmRemoveTitle": "Supprimer la Photo de Profil ?",
    "avatar.confirmRemoveMessage": "Votre avatar affichera à nouveau vos initiales.",
    "avatar.invalidFileType": "Veuillez choisir un fichier image (JPG, PNG ou WEBP).",
    "avatar.fileTooLarge": "L'image doit faire moins de 5 Mo.",
    "dashV3.title": "Operations Dashboard",
    "dashV3.subtitle": "Real-time overview of your timber trade operations",
    "dashV3.dateFrom": "From",
    "dashV3.dateTo": "To",
    "dashV3.apply": "Apply",
    "dashV3.refresh": "Actualiser",
    "dashV3.staleSnapshot": "Hors ligne — affichage d'un instantané en cache du",
    "dashV3.loading": "Loading dashboard...",
    "offline.unavailableTitle": "Connexion requise",
    "offline.unavailableLead": "Cette fonctionnalité n'est pas disponible hors ligne.",
    "offline.unavailableBody": "L'exportation, l'importation, les rapports, les consignations et l'inventaire nécessitent tous une connexion active. Les unités de stock, partenaires commerciaux, produits et sites fonctionnent toujours hors ligne.",
    "offline.goToDashboard": "Aller au tableau de bord",
    "offline.autoReturnHint": "Vous serez ramené ici automatiquement dès que vous serez de nouveau en ligne.",
    "dashV3.kpi.partners": "Partenaires commerciaux",
    "dashV3.kpi.active": "Actif",
    "dashV3.kpi.inactive": "Inactif",
    "dashV3.kpi.shipments": "Consignations",
    "dashV3.kpi.transportUnits": "Unités de Stock",
    "dashV3.kpi.unassigned": "Unassigned",
    "dashV3.kpi.volume": "Total Volume",
    "dashV3.kpi.pieces": "Total Pièces",
    "dashV3.kpi.cbm": "CBM",
    "dashV3.kpi.cft": "CFT",
    "dashV3.chart.byTradeType": "Consignations by Trade Type",
    "dashV3.chart.byMode": "Transport Mode",
    "dashV3.chart.volumeTrend": "Volume Trend",
    "dashV3.chart.topProducts": "Top Produits by Volume (CFT)",
    "dashV3.chart.siteUtilization": "Utilisation du Site",
    "dashV3.chart.paymentStatus": "Paiement Statut",
    "dashV3.upcoming.departures": "Upcoming Departures",
    "dashV3.upcoming.arrivals": "Upcoming Arrivals",
    "dashV3.upcoming.next7days": "Next 7 Jours",
    "dashV3.upcoming.noDepartures": "No departures in the next 7 days",
    "dashV3.upcoming.noArrivals": "No arrivals in the next 7 days",
    "dashV3.upcoming.blNo": "BL / Bill No",
    "dashV3.upcoming.shipper": "Shipper",
    "dashV3.upcoming.consignee": "Consignee",
    "dashV3.upcoming.date": "Date",
    "dashV3.upcoming.port": "Port",
    "dashV3.recent.title": "Recent Unités de Stock",
    "dashV3.recent.transportId": "Transport ID",
    "dashV3.recent.product": "Produit",
    "dashV3.recent.site": "Site",
    "dashV3.recent.pieces": "Pièces",
    "dashV3.recent.volume": "Volume",
    "dashV3.recent.created": "Created",
    "dashV3.subscription.title": "Abonnement",
    "dashV3.subscription.package": "Forfait",
    "dashV3.subscription.validTill": "Valid Till",
    "dashV3.subscription.daysLeft": "days left",
    "dashV3.subscription.expiringSoon": "Subscription expiring soon!",
    "dashV3.subscription.renew": "Renew Now",
    "dashV3.partners.byCountry": "Partenaires by Pays",
    "dashV3.kpi.upcoming": "Upcoming",
    "dashV3.kpi.tallyUnits": "Cubage Units",
    "dashV3.upcoming.pol": "Port of Loading",
    "dashV3.upcoming.pod": "Port of Discharge",
    "dashV3.upcoming.mode": "Mode",
    "dashV3.subscription.expiring": "Subscription expiring soon —",
    "dashV3.subscription.status": "Statut",
    "dashV3.subscription.days": "days remaining",
    "dashV3.recent.id": "Transport ID",
    "dashV3.recent.cbm": "CBM",
    "dashV3.recent.cft": "CFT",
    "dashV3.recent.viewAll": "Voir All",
    "dashV3.site.name": "Site",
    "dashV3.site.country": "Pays",
    "dashV3.site.capacity": "Capacity",
    "dashV3.site.noCapacitySet": "Aucune capacité définie pour ce site",
    "dashV3.site.current": "Current",
    "dashV3.site.util": "Utilization",
    "dashV3.noData": "No data available for the selected period",
    "report.title": "Rapports",
    "report.from": "From",
    "report.to": "To",
    "report.inventory.title": "Inventaire Rapport",
    "report.inventory.subtitle": "Niveaux de stock, historique des mouvements, ajustements et ordres de sciage",
    "report.inventory.unitsAbbrev": "SUs",
    "report.bp.title": "Commercial Partenaire Rapport",
    "report.bp.subtitle": "Comprehensive analysis of business partner transactions, volumes and payments",
    "report.bp.search": "Rechercher Commercial Partenaire",
    "report.bp.selectBp": "Sélectionnez un partenaire commercial pour générer le rapport",
    "report.bp.period": "Rapport Period",
    "report.bp.from": "From Date",
    "report.bp.to": "To Date",
    "report.bp.generate": "Generate Rapport",
    "report.bp.generating": "Generating...",
    "report.bp.exportExcel": "Export Excel",
    "report.bp.exportPdf": "Export PDF",
    "report.bp.noData": "No consignment data found for the selected period.",
    "report.bp.profile": "Partenaire Profil",
    "report.bp.partyType": "Party Type",
    "report.bp.category": "Catégorie",
    "report.bp.regType": "Registration Type",
    "report.bp.taxId": "Tax ID",
    "report.bp.active": "Actif",
    "report.bp.inactive": "Inactif",
    "report.bp.owner": "Propriétaire",
    "report.kpi.totalShipments": "Total Consignations",
    "report.kpi.asSeller": "As Seller",
    "report.kpi.asBuyer": "As Buyer",
    "report.kpi.totalCbm": "Net CBM",
    "report.kpi.totalCft": "Net CFT",
    "report.kpi.totalPieces": "Total Pièces",
    "report.payment.sellerTitle": "Paiement — As Seller",
    "report.payment.buyerTitle": "Paiement — As Buyer",
    "report.payment.totalInvoiced": "Total Invoiced",
    "report.payment.received": "Fully Received",
    "report.payment.partially": "Partially Paid",
    "report.payment.invoiced": "Invoiced (Sent)",
    "report.payment.notInvoiced": "Not Invoiced",
    "report.payment.overdue": "Overdue",
    "report.payment.outstanding": "Outstanding",
    "report.payment.cancelled": "Cancelled",
    "report.payment.totalPayable": "Total Payable",
    "report.payment.paid": "Paid",
    "report.payment.pending": "En attente",
    "report.payment.disputed": "Disputed",
    "report.chart.monthlyVolume": "Mensuel Volume & Consignations",
    "chart.emptyTitle": "Pas encore de données",
    "chart.emptyHint": "Ce graphique se remplit dès qu'il y a des enregistrements.",
    "report.chart.monthlyInvoice": "Mensuel Facture Montant",
    "report.chart.tradeRoleSplit": "Trade Rôle Split",
    "report.chart.paymentStatus": "Paiement Statut",
    "report.table.transactions": "Consignation Transactions",
    "report.table.date": "Date",
    "report.table.role": "Rôle",
    "report.table.tradeType": "Trade Type",
    "report.table.pol": "Port of Loading",
    "report.table.pod": "Port of Discharge",
    "report.table.origin": "Pays of Origin",
    "report.table.destination": "Destination",
    "report.table.currency": "Devise",
    "report.table.invoiceAmt": "Facture Montant",
    "report.table.cbm": "Net CBM",
    "report.table.cft": "Net CFT",
    "report.table.pieces": "Pièces",
    "report.table.units": "Unités de stock",
    "report.table.payStatus": "Pay Statut",
    "report.table.blNo": "B/L No.",
    "report.table.status": "Statut",
    "report.table.products": "Produits",
    "report.table.sites": "Sites",
    "report.products.title": "Produits Résumé",
    "report.products.name": "Produit",
    "report.products.hsCode": "HS Code",
    "report.products.cbm": "Net CBM",
    "report.products.cft": "Net CFT",
    "report.products.pieces": "Pièces",
    "report.products.units": "Unités de Stock",
    "report.products.shipments": "Consignations",
    "report.sites.title": "Résumé des Sites",
    "report.sites.name": "Site Name",
    "report.sites.location": "Emplacement",
    "report.sites.cbm": "Net CBM",
    "report.sites.cft": "Net CFT",
    "report.sites.pieces": "Pièces",
    "report.sites.units": "Unités de Stock",
    "report.sites.shipments": "Consignations",
    "report.role.seller": "Seller",
    "report.role.buyer": "Buyer",
    "report.role.notify": "Notify Party",
    "report.generatedAt": "Generated",
    "report.generate": "Generate",
    "report.loading": "Loading report...",
    "report.empty": "Sélectionner filters and click Generate to view the report.",
    "report.noData": "Aucune donnée trouvée for selected period.",
    "report.export.excel": "Export Excel",
    "report.export.pdf": "Export PDF",
    "report.filter.from": "From",
    "report.filter.to": "To",
    "report.filter.all": "Tous",
    "report.filter.clear": "Effacer les filtres",
    "report.tab.overview": "Overview",
    "report.tab.transactions": "Transactions",
    "report.tab.financial": "Financial",
    "report.tab.products": "Produits",
    "report.tab.sites": "Sites",
    "report.tab.trend": "Mensuel Trend",
    "report.tab.byCurrency": "By Currency",
    "report.tab.partners": "Top Partenaires",
    "report.kpi.totalInvoiced": "Total Invoiced",
    "report.kpi.overdue": "Overdue",
    "report.kpi.units": "Unités de Stock",
    "report.col.date": "Date",
    "report.col.month": "Mois",
    "report.col.tradeType": "Trade Type",
    "report.col.status": "Statut",
    "report.col.shipper": "Shipper",
    "report.col.consignee": "Consignee",
    "report.col.polPod": "POL / POD",
    "report.col.currency": "Devise",
    "report.col.invoiceAmt": "Facture Amt",
    "report.col.invoiced": "Invoiced",
    "report.col.salesStatus": "Sales Statut",
    "report.col.cbm": "CBM",
    "report.col.netCbm": "Net CBM",
    "report.col.cft": "CFT",
    "report.col.netCft": "Net CFT",
    "report.col.pieces": "Pièces",
    "report.col.units": "Units",
    "report.col.shipments": "Consignations",
    "report.col.blNo": "B/L No.",
    "report.col.product": "Produit",
    "report.col.hsCode": "HS Code",
    "report.col.avgCbmPerUnit": "Avg Net CBM/Unit",
    "report.col.currentStock": "Stock Actuel",
    "report.col.lots": "lots",
    "report.col.topPartners": "Top Partenaires",
    "report.col.topSites": "Top Sites",
    "report.col.topProducts": "Top Produits",
    "report.col.site": "Site",
    "report.col.location": "Emplacement",
    "report.col.capacity": "Capacity",
    "report.col.utilization": "Utilization",
    "report.col.millThroughput": "Débit Scierie CBM",
    "report.col.runs": "ordres",
    "report.col.partner": "Partenaire",
    "report.col.totalInvoiced": "Total Invoiced",
    "report.col.fullyPaid": "Fully Paid",
    "report.col.partiallyPaid": "Partially Paid",
    "report.col.overdue": "Overdue",
    "report.col.outstanding": "Outstanding",
    "report.col.sellerOutstanding": "Seller Outstanding",
    "report.col.buyerTotal": "Buyer Total",
    "report.col.buyerPaid": "Buyer Paid",
    "report.col.buyerPending": "Buyer En attente",
    "report.col.netPosition": "Net Position",
    "report.col.totalAmt": "Total Montant",
    "report.col.received": "Reçu",
    "report.col.paid": "Paid",
    "report.col.payable": "Payable",
    "report.shipment.title": "Consignation Rapport",
    "report.shipment.tradeType": "Trade Type",
    "report.shipment.status": "Statut",
    "report.shipment.financialByCurrency": "Financial by Currency",
    "report.shipment.monthlyTrend": "Mensuel Trend",
    "report.product.title": "Produit Rapport",
    "report.product.distinctProducts": "Distinct Produits",
    "report.site.title": "Rapport des Sites",
    "report.site.distinctSites": "Distinct Sites",
    "report.site.noCapacity": "No capacity data available",
    "report.financial.title": "Financial Résumé Rapport",
    "report.financial.currency": "Devise",
    "report.financial.currencyPlaceholder": "e.g. USD",
    "report.financial.revenue": "Revenue (Received)",
    "report.financial.cost": "Cost (Paid)",
    "report.financial.receivable": "Receivable",
    "report.financial.payable": "Payable",
    "report.financial.overdue": "Overdue",
    "report.financial.topRevenuePartners": "Top Revenue Partenaires (As Seller)",
    "report.financial.topCostPartners": "Top Cost Partenaires (As Buyer)",
    "report.financial.tradeTypeSummary": "By Trade Type",
    "report.chart.byTradeType": "By Trade Type",
    "report.chart.sellerPayStatus": "Seller Paiement Statut",
    "report.chart.topLoadingPorts": "Top Ports of Loading",
    "report.chart.topProductsByCbm": "Top Produits by Net CBM",
    "report.chart.monthlyProductTrend": "Mensuel Produit Trend",
    "report.chart.siteCbm": "Net CBM par Site",
    "report.chart.utilization": "Site Utilization",
    "report.chart.monthlyTrend": "Mensuel Throughput",
    "report.chart.financialOverview": "Financial Overview",
    "report.chart.receivablesBreakdown": "Receivables Breakdown",
    "report.chart.monthlyInvoicedTrend": "Mensuel Invoiced Trend",
    "report.tab.units": "Unités de Stock",
    "report.tab.tallies": "Cubage Sheets",
    "report.col.transportId": "Transport ID",
    "report.col.unitNumber": "Unit No.",
    "report.col.mode": "Mode",
    "report.col.shipment": "Consignation",
    "report.col.type": "Type",
    "report.col.created": "Created",
    "report.tu.title": "Rapport de l'Unité de Stock",
    "report.operator.title": "Rapport de Performance des Opérateurs",
    "report.operator.totalOperators": "Total des Opérateurs",
    "report.operator.activeOperators": "Opérateurs Actifs",
    "report.operator.runsCompleted": "Ordres de sciage terminés",
    "report.operator.totalOutputCbm": "CBM de Sortie Total",
    "report.operator.avgOutturn": "Rendement Moyen",
    "report.operator.byOperator": "Par Opérateur",
    "report.operator.name": "Nom",
    "report.operator.employeeCode": "Code Employé",
    "report.operator.specializations": "Spécialisations",
    "report.operator.active": "Actif",
    "report.operator.activeYes": "Actif",
    "report.operator.activeNo": "Inactif",
    "report.operator.inputCbm": "CBM d'Entrée",
    "report.operator.outputCbm": "CBM de Sortie",
    "report.operator.bestOutturn": "Meilleur Rendement",
    "report.operator.avgDuration": "Durée Moyenne (hrs)",
    "report.tu.totalUnits": "Total Units",
    "report.tu.linked": "Linked to Consignation",
    "report.tu.inStock": "En Stock (Inventaire)",
    "report.tu.unlinked": "Unlinked",
    "report.tu.statusBreakdown": "Statut Breakdown",
    "report.tu.modeBreakdown": "Transport Mode",
    "report.tu.monthlyTrend": "Mensuel Trend",
    "report.tu.statusSummary": "Statut Résumé",
    "report.tally.title": "Cubage Sheet Rapport",
    "report.tally.totalTallies": "Total Tallies",
    "report.tally.roundTallies": "Round Timber",
    "report.tally.squareTallies": "Square Timber",
    "report.tally.flexibleGrid": "Grille Flexible",
    "report.tally.typeBreakdown": "Type Breakdown",
    "report.tally.monthlyCbm": "Mensuel CBM by Type",
    "report.tally.shrinkageChart": "Source vs Destination CBM",
    "report.tally.noShrinkageData": "No destination data available.",
    "report.tally.avgCbm": "Avg CBM / Cubage",
    "report.tally.avgPieces": "Avg Pièces / Cubage",
    "report.tally.tallies": "Tallies",
    "report.tally.destCbm": "Dest. CBM",
    "report.tally.shrinkage": "Shrinkage %",
    "report.financial.actualReceived": "Actual Received",
    "report.financial.actualPaid": "Actual Paid",
    "report.financial.totalReceived": "Total Received",
    "report.financial.totalPaid": "Total Paid",
    "report.financial.netCashflow": "Net Cashflow",
    "report.financial.receivables": "Receivables",
    "report.financial.minAmount": "Min amount",
    "report.financial.maxAmount": "Max amount",
    "report.financial.paymentStatus": "Payment status",
    "report.financial.paymentFrom": "Payment from",
    "report.financial.paymentTo": "Payment to",
    "report.financial.payables": "Payables",
    "report.col.txnType": "Type",
    "report.col.paymentMode": "Mode",
    "report.col.reference": "Reference",
    "report.col.notes": "Notes",
    "report.recon.title": "Reconciliation Rapport",
    "report.recon.subtitle": "Source vs Destination tally variance analysis",
    "report.recon.totalTallies": "Total Tallies",
    "report.recon.reconciled": "Reconciled",
    "report.recon.pending": "En attente",
    "report.recon.srcCbm": "Source CBM",
    "report.recon.srcPieces": "Source Pièces",
    "report.recon.dstCbm": "Dest. CBM",
    "report.recon.dstPieces": "Dest. Pièces",
    "report.recon.varianceCbm": "CBM Variance",
    "report.recon.variancePieces": "Pièces Variance",
    "report.recon.shrinkage": "Shrinkage %",
    "report.recon.millLoss": "CBM de Perte de Scierie",
    "report.recon.reconStatus": "Reconciliation Statut",
    "report.recon.shrinkageDist": "Shrinkage Distribution",
    "inventory.title": "Inventaire",
    "inventory.overview": "Overview",
    "inventory.inOut": "Entrée / Sortie",
    "inventory.processing": "Ordres de sciage",
    "inventory.available": "Disponible",
    "inventory.inProcess": "En ordre de sciage",
    "inventory.inShipment": "En consignation",
    "inventory.shipped": "Expédié",
    "inventory.lotStock": "Stock en lot",
    "inventory.openLots": "lots ouverts",
    "inventory.atForest": "En forêt",
    "inventory.inTransit": "En transit",
    "inventory.atMill": "À la scierie",
    "inventory.atYard": "Au parc",
    "inventory.receiveIntoInventory": "Receive into Inventaire",
    "inventory.receiveNeedsRows": "Ajoutez au moins une ligne au tally avant de recevoir en inventaire",
    "inventory.receivedIntoInventory": "Received into Inventaire",
    "inventory.receiveConfirmMessage": "Ajouter Unité de Stock {transportId} to inventory? This will record it as an incoming stock movement.",
    "inventory.yesReceive": "Yes, Receive",
    "inventory.received": "Reçu",
    "inventory.receivedDetail": "{transportId} has been added to inventory.",
    "inventory.confirmStockOut": "Confirmer la Sortie de Stock",
    "inventory.confirmChecking": "Vérification du stock…",
    "inventory.confirmStockOutMessage": "Confirmer que l'Unité de Stock {transportId} a été expédiée ? Cela débitera définitivement le stock correspondant.",
    "inventory.confirmStockOutMultiProductIntro": "Cette unité de stock comporte {count} produits, qui seront débités définitivement comme suit : {breakdown}. Continuer ?",
    "inventory.confirmStockOutBatchIntro": "Ceci sera prélevé sur {count} lots : {breakdown}. Continuer ?",
    "inventory.confirmStockOutInsufficientWarning": "Attention : stock insuffisant pour un ou plusieurs de ces produits — la confirmation peut échouer.",
    "inventory.stockShortTitle": "Stock insuffisant — rien n’a été enregistré",
    "inventory.stockShortHint": "Corrigez ces lignes ou activez « Let sales continue past available stock » dans Application Settings → Inventory Policy.",
    "inventory.stockShortLineNone": "{label} : besoin de {need} pcs, aucun stock",
    "inventory.stockShortLineOnly": "{label} : besoin de {need} pcs, seulement {free} disponibles",
    "inventory.confirmBlockedNoStock": "Confirmation impossible — ces lignes n’ont pas de stock libre à leur dimension (le bois retenu par une autre sortie de stock n’est pas libre) :",
    "inventory.confirmBlockedNoStockHint": "Changez la dimension, supprimez la ligne ou demandez à la scierie de la produire.",
    "inventory.confirmUnsavedChanges": "Enregistrez d’abord le relevé — il contient des lignes non enregistrées. La confirmation ne compte que les lignes enregistrées, puis le relevé est verrouillé.",
    "inventory.receiveUnsavedChanges": "Enregistrez d’abord le relevé — il contient des lignes non enregistrées. Seules les lignes enregistrées entrent en stock, puis le relevé est verrouillé.",
    "tallysheet.tu.soldPastStock": "Vendu au-delà du stock disponible — motif : {reason}",
    "tallysheet.tu.soldPastStockBy": " (par {by})",
    "statement.soldPastStock": "Vendu au-delà du stock disponible",
    "inventory.rowExceedsStockReview": "Dépasse le stock — appuyez pour vérifier",
    "inventory.rowInsufficientStockFix": "Stock insuffisant — appuyez pour corriger",
    "inventory.rowNotReservedHint": "Aucun stock n'est actuellement réservé pour cette ligne.",
    "inventory.resolvedOriginAuto": "stock le plus ancien",
    "inventory.shippedLockedMessage": "Cette unité de stock a déjà été confirmée et expédiée — la modification est verrouillée. Seul un administrateur peut apporter des modifications.",
    "inventory.rowNeedsLookSingular": "ligne nécessite un coup d'œil",
    "inventory.rowNeedsLookPlural": "lignes nécessitent un coup d'œil",
    "inventory.review": "Vérifier",
    "inventory.yesConfirm": "Oui, Confirmer",
    "inventory.confirmStockOutTooltip": "Débiter définitivement le stock pour le contenu comptabilisé de cette Unité de Stock",
    "inventory.stockOutConfirmed": "Sortie de Stock Confirmée",
    "inventory.stockOutConfirmedDetail": "{transportId} a été débité de l'inventaire.",
    "inventory.newProcessingRun": "Nouvel ordre de sciage",
    "inventory.outturn": "Outturn",
    "inventory.inputCbm": "Input CBM",
    "inventory.outputCbm": "Output CBM",
    "inventory.stockByLocation": "Stock par emplacement",
    "inventory.whereIsYourMaterial": "Where is your material right now?",
    "inventory.daysInYard": "Jours in Yard",
    "inventory.runCode": "ID de l'ordre de sciage",
    "inventory.millLocation": "Mill / Emplacement",
    "inventory.processingDate": "Date de l'ordre de sciage",
    "inventory.selectInputTus": "Sélectionner les unités de stock d'entrée",
    "inventory.recordOutput": "Record Output",
    "inventory.movementLedger": "Movement Ledger",
    "loading-site.siteType": "Type de site",
    "loading-site.siteType.FOREST": "Forêt",
    "loading-site.siteType.MILL": "Scierie",
    "loading-site.siteType.YARD": "Parc / zone de préparation",
    "loading-site.siteType.PORT": "Port",
    "loading-site.siteType.WAREHOUSE": "Entrepôt",
    "common.locked": "Verrouillé",
    "common.reconciled": "Réconcilié",
    "common.confirmDeletion": "Confirm Deletion",
    "common.amount": "Montant",
    "common.size": "Size",
    "tallysheet.lockedBanner": "This tallysheet is locked — no further edits are allowed.",
    "tallysheet.summaryOutdated": "Le résumé peut être périmé. Des lignes ont été sauvegardées après le dernier chargement.",
    "tallysheet.lockButton": "Lock",
    "tallysheet.lockTooltip": "Lock this tallysheet permanently",
    "tallysheet.lockNeedsRows": "Ajoutez au moins une ligne au tally avant de verrouiller",
    "tallysheet.lockNoPhotosWarning": "Aucune photo pour ce Stock Unit pour le moment. Vous pouvez tout de même verrouiller, mais il ne sera généralement pas facile d'ajouter des photos ensuite.",
    "tallysheet.lockGoToPhotos": "Aller aux Photos",
    "tallysheet.lockDialogHeader": "Lock Feuille de cubage",
    "tallysheet.lockIrreversible": "This action is irreversible.",
    "tallysheet.lockOnceNote": "Once locked, no tally entries can be added or modified.",
    "tallysheet.lockTypeConfirm": "Type LOCK to confirm:",
    "tallysheet.lockPermanently": "Lock Permanently",
    "tallysheet.inventoryTab": "Inventaire",
    "tallysheet.aiImport": "AI Import",
    "tallysheet.aiImportTooltip": "AI Import — upload a handwritten tallysheet image",
    "tallysheet.lengthRequired": "Longueur required",
    "tallysheet.girthRequired": "Girth required",
    "tallysheet.enterRowNumber": "Enter Row Number",
    "inventory.notYetInInventory": "Pas encore en inventaire",
    "inventory.historyLoadFailedTitle": "Impossible de charger l'historique",
    "inventory.historyLoadFailedSub": "Réessayez une fois de retour en ligne",
    "inventory.receiveToStartTracking": "Recevez cette Unité de Stock pour commencer à suivre les mouvements d'inventaire.",
    "inventory.clickToReceive": "Cliquez sur le bouton ci-dessous pour recevoir cette Unité de Stock dans l'inventaire.",
    "inventory.notInInventoryBanner": "Pas encore en inventaire — recevez cette Unité de Stock pour commencer le suivi du stock.",
    "inventory.statusLabel": "Inventaire Statut",
    "inventory.statusColon": "Inventaire Statut:",
    "inventory.movementHistory": "Movement Historique",
    "inventory.noMovementsYet": "No movements recorded yet.",
    "inventory.addToInventoryTooltip": "Ajouter cette Unité de Stock au système d'inventaire",
    "inventory.productRequiredTooltip": "Ajoutez un Produit avant de recevoir dans l'inventaire",
    "inventory.moveComingSoon": "Déplacement entre sites — bientôt disponible",
    "inventory.loadingSiteRequiredTooltip": "Un site est requis avant de recevoir dans l'inventaire",
    "inventory.loadingSiteRequiredBanner": "Sélectionnez un site avant de recevoir cette unité de stock dans l'inventaire — sinon le stock ne sera pas traçable.",
    "inventory.transportModeRequiredTooltip": "Ajoutez le Mode de Transport avant de recevoir dans l'inventaire",
    "inventory.transportModeRequiredForStockOut": "Ajoutez le Mode de Transport avant de confirmer la sortie de stock",
    "inventory.dateAndTime": "Date & Time",
    "inventory.movementType": "Movement Type",
    "shipment.lockedTooltip": "Locked — no further edits allowed",
    "shipment.exportTooltip": "Export consignment to Excel or PDF",
    "shipment.noTransportUnitsShared": "No stock units are available for this shared consignment.",
    "payment.loadingData": "Loading payment data...",
    "payment.invoice": "Facture",
    "payment.salesStatus": "Sales Statut",
    "payment.paidOut": "Paid Out",
    "payment.purchaseStatus": "Purchase Statut",
    "payment.unableToLoad": "Unable to load payment summary.",
    "payment.record": "Record Paiement",
    "payment.typeLabel": "Paiement Type",
    "payment.receivable": "Receivable (Money In)",
    "payment.payable": "Payable (Money Out)",
    "payment.selectType": "Sélectionner type",
    "payment.modeLabel": "Paiement Mode",
    "payment.selectMode": "Sélectionner mode",
    "payment.referenceNo": "Reference No",
    "payment.referencePlaceholder": "Cheque no / TT ref / UTR",
    "payment.notesPlaceholder": "Optional notes",
    "payment.save": "Enregistrer Paiement",
    "payment.history": "Paiement Historique",
    "storage.title": "Storage Usage",
    "storage.subtitle": "Track your file storage across all tallies, documents and business partners",
    "storage.usedRing": "used",
    "storage.used": "Used",
    "storage.quota": "Quota",
    "storage.free": "Free",
    "storage.files": "Files",
    "storage.filesCount": "files",
    "storage.warningPrefix": "You have used",
    "storage.warningBannerSuffix": "of your storage. Consider deleting unused files.",
    "storage.fullBanner": "Storage full! New file uploads are blocked. Please free up space or upgrade your plan.",
    "storage.addedBy": "Added By",
    "storage.noFilesFound": "No files found.",
    "dashV4.businessPulse": "Commercial Pulse",
    "dashV4.inventorySnapshot": "Inventaire Snapshot",
    "dashV4.fullInventory": "Full Inventaire",
    "dashV4.availableStock": "Available Stock",
    "dashV4.inProcessing": "En ordre de sciage",
    "dashV4.inShipment": "En consignation",
    "dashV4.shippedThisMonth": "Shipped This Mois",
    "dashV4.activeSites": "Active Sites",
    "dashV4.locations": "locations",
    "dashV4.noInventoryData": "No inventory data yet.",
    "dashV4.setUpInventory": "Set up inventory →",
    "dashV4.volumeTrend": "Volume Trend (CBM)",
    "dashV4.upcomingShipments": "Upcoming Consignations",
    "dashV4.departures": "Departures",
    "dashV4.arrivals": "Arrivals",
    "dashV4.geographySites": "Geography & Sites",
    "dashV4.recentTUs": "Recent Unités de Stock",
    "dashV4.standardPlan": "Standard Forfait",
    "dashV4.validTill": "Valid till",
    "dashV4.daysLeft": "days left",
    "dashV4.manage": "Gérer",
    "dashV4.active": "active",
    "dashV4.inactive": "inactive",
    "dashV4.upcoming": "upcoming",
    "dashV4.unassigned": "unassigned",
    // -- Dashboard V5
    "dashV5.title": "Tableau de bord",
    "dashV5.subtitle": "Vue d'ensemble des activités, finances et inventaire",
    "dashV5.financialHealth": "Santé Financière",
    "dashV5.totalInvoiced": "Total Facturé",
    "dashV5.totalReceived": "Reçu",
    "dashV5.outstanding": "En attente",
    "dashV5.overdue": "En retard",
    "dashV5.payables": "À payer",
    "dashV7.currentTooltip": "Toujours actuel — non limité à la période sélectionnée",
    "dashV8.goodMorning": "Bonjour",
    "dashV8.periodNote": "La période détermine : volume, Unités de stock, pièces, envois, facturé et encaissé. Tout le reste montre la situation actuelle.",
    "dashV8.vsPrevious": "vs la période précédente",
    "dashV8.details": "Détails",
    "dashV8.freeToSell": "libres à la vente",
    "dashV8.free": "Libre",
    "dashV8.held": "Retenu",
    "dashV8.inMill": "En scierie",
    "dashV8.allCounted": "Toutes les Unités de stock comptées",
    "dashV8.toCount": "encore à compter",
    "dashV8.goodAfternoon": "Bon après-midi",
    "dashV8.goodEvening": "Bonsoir",
    "dashV8.focus": "Tout ce que fait cette entreprise",
    "dashV8.newSince": "nouveaux depuis",
    "dashV8.period": "Période",
    "dashV8.p.today": "Aujourd'hui",
    "dashV8.p.7d": "7 jours",
    "dashV8.p.30d": "30 jours",
    "dashV8.p.month": "Ce mois-ci",
    "dashV8.p.pick": "Choisir les dates",
    "dashV8.activeUntil": "actif jusqu'au",
    "dashV8.item": "élément",
    "dashV8.items": "éléments",
    "dashV8.more": "de plus",
    "dashV8.showAll": "Tout afficher",
    "dashV8.showLess": "Afficher moins",
    "dashV8.open": "Ouvrir",
    "dashV8.review": "Vérifier",
    "dashV8.count": "Compter",
    "dashV8.see": "Voir",
    "dashV8.needMine1": "Vous avez 1 travail de scierie",
    "dashV8.needMineN": "Vous avez {n} travaux de scierie",
    "dashV8.taskNeedsAccept": "{code} doit être accepté",
    "dashV8.taskRunning": "{code} est en cours",
    "dashV8.needOverdue1": "1 paiement est en retard",
    "dashV8.needOverdueN": "{n} paiements sont en retard",
    "dashV8.overdueSub": "{amount} à encaisser",
    "dashV8.overdueSubDays": "{amount} à encaisser · le plus ancien depuis {days} jours",
    "dashV8.needHolds1": "1 Sortie de stock retient du bois depuis 60+ jours",
    "dashV8.needHoldsN": "{n} Sorties de stock retiennent du bois depuis 60+ jours",
    "dashV8.needHoldsSub": "{cbm} m³ bloqués à la vente",
    "dashV8.needRecon1": "1 Unité de stock non comptée",
    "dashV8.needReconN": "{n} Unités de stock non comptées",
    "dashV8.needReconSub": "Compté jusqu'ici : {pct} %",
    "dashV8.needUnassigned1": "1 Unité de stock pas encore sur un envoi",
    "dashV8.needUnassignedN": "{n} Unités de stock pas encore sur un envoi",
    "dashV8.needMillQueued1": "1 travail de scierie attend de démarrer",
    "dashV8.needMillQueuedN": "{n} travaux de scierie attendent de démarrer",
    "dashV8.needArrivals1": "1 envoi arrive cette semaine",
    "dashV8.needArrivalsN": "{n} envois arrivent cette semaine",
    "dashV8.needArrivalsSub": "le premier le {date}",
    "dashV8.vsLastMonth": "vs mois dernier",
    "dashV8.millRunning": "Travaux de scierie en cours",
    "dashV8.trends": "Tendances",
    "dashV8.tab.volume": "Volume",
    "dashV8.tab.products": "Produits",
    "dashV8.tab.types": "Types",
    "dashV8.tab.transport": "Transport",
    "dashV8.tab.payments": "Paiements",
    "dashV8.chip.STOCK": "Stock",
    "dashV8.chip.MILL": "Scierie",
    "dashV8.chip.CONSIGNMENT": "Envois",
    "dashV8.chip.MONEY": "Argent",
    "dashV8.chip.RECON": "Comptages",
    "dashV8.chip.TALLY": "Unités de stock",
    "dashV8.chip.TEAM": "Équipe",
    "dashV8.chip.MINE": "Les miens",
    "dashV8.dayToday": "Aujourd'hui",
    "dashV8.dayYesterday": "Hier",
    "dashV8.evt.STOCK_IN": "Stock reçu",
    "dashV8.evt.STOCK_OUT": "Sortie de stock confirmée",
    "dashV8.evt.STOCK_COUNT": "Comptage fait",
    "dashV8.evt.STOCK_ADJUST": "Stock ajusté",
    "dashV8.evt.MILL_DONE": "Travail de scierie {ref} terminé",
    "dashV8.evt.CONSIGNMENT_NEW": "Envoi {ref} créé",
    "dashV8.evt.PAYMENT_IN": "Paiement reçu",
    "dashV8.evt.PAYMENT_OUT": "Paiement effectué",
    "dashV8.evt.TALLY_NEW": "Unité de stock {ref} créée",
    "dashV8.evt.TEAM_GRANT": "Droit {ref} accordé",
    "dashV8.evt.TEAM_REVOKE": "Droit {ref} retiré",
    "dashV8.teamFor": "pour {name}",
    "dashV8.feedNote": "Seuls les événements métier terminés sont listés. L'enregistrement ou la modification de lignes de pointage n'apparaît jamais ; une Unité de stock apparaît une fois, à sa création.",
    "dashV7.needsTitle": "À traiter aujourd'hui",
    "dashV7.allClear": "Tout est en ordre. Rien ne vous attend aujourd'hui.",
    "dashV7.needOverdue": "paiements en retard à encaisser",
    "dashV7.needRecon": "Unités de stock à réconcilier",
    "dashV7.needUnassigned": "Unités de stock pas encore sur un envoi",
    "dashV7.needMyTasks": "travaux de scierie sur votre liste",
    "dashV7.needMillQueued": "travaux de scierie en attente de démarrage",
    "dashV7.chipAll": "Tout",
    "dashV7.cat.STOCK": "Stock",
    "dashV7.cat.MILL": "Scierie",
    "dashV7.cat.CONSIGNMENT": "Envois",
    "dashV7.cat.MONEY": "Argent",
    "dashV7.cat.TEAM": "Équipe",
    "dashV7.ev.STOCK_IN": "Stock reçu",
    "dashV7.ev.STOCK_OUT": "Stock sorti",
    "dashV7.ev.STOCK_COUNT": "Stock compté",
    "dashV7.ev.STOCK_ADJUST": "Stock ajusté",
    "dashV7.ev.MILL_DONE": "Travail de scierie terminé",
    "dashV7.ev.CONSIGNMENT_NEW": "Envoi créé",
    "dashV7.ev.PAYMENT_IN": "Paiement reçu",
    "dashV7.ev.PAYMENT_OUT": "Paiement effectué",
    "dashV7.ev.TEAM_GRANT": "Droit accordé",
    "dashV7.ev.TEAM_REVOKE": "Droit retiré",
    "dashV7.severalSizes": "plusieurs tailles",
    "dashV7.with": "avec",
    "dashV7.noActivity": "Rien ne s'est passé ici récemment.",
    "dashV7.showMore": "Afficher plus",
    "dashV7.activityFailed": "Impossible de charger l'activité récente pour le moment.",
    "dashV7.upcomingTooltip": "Affiche toujours les 7 prochains jours — indépendamment de la période ci-dessus",
    "dashV5.receivablesAging": "Âge des créances",
    "dashV5.shipmentsLabel": "consignations",
    "dashV5.reconciliation": "Statut de réconciliation",
    "dashV5.totalTUs": "Total des unités de stock",
    "dashV5.reconciled": "Réconcilié",
    "dashV5.pending": "En attente",
    "dashV5.locked": "Verrouillé",
    "dashV5.netDiscrepancy": "Écart net",
    "dashV5.tuId": "ID de l'unité de stock",
    "dashV5.sourceCbm": "CBM Source",
    "dashV5.destCbm": "CBM Dest.",
    "dashV5.discrepancy": "Écart",
    "dashV5.noDiscrepancies": "Aucun écart — toutes les unités de stock correspondent.",
    "dashV5.avgOutturn": "Outturn Moyen",
    "dashV5.netGain": "Gain net (ordres de sciage)",
    "dashV5.runsLabel": "ordres de sciage",
    "dashV5.outturnNote": "Au-dessus de 100% signifie un gain de volume au sciage rond-carré.",
    "dashV5.paymentFlow": "Flux de paiement",
    "dashV5.mixedCurrencies": "Plusieurs devises",
    "dashV5.showingCurrencyOnly": "Affichage uniquement :",
    "dashV5.otherCurrencies": "autres devises",
    "dashV5.perCurrencyBreakdown": "Répartition par devise",
    // -- Dashboard V6
    "dashV6.title": "Tableau de bord",
    "dashV6.subtitle": "Vue d'ensemble métier en temps réel, adaptée au rôle",
    "dashV6.liveTooltip": "En direct — se met à jour automatiquement",
    "dashV6.offlineTooltip": "Hors ligne — affiche des données en cache, pas en direct",
    "dashV6.myMillTasks": "Mes Tâches de Scierie Actives",
    "dashV6.millBoard": "Tableau des ordres de sciage",
    "dashV6.viewAllRuns": "Voir tous les ordres de sciage",
    "dashV6.queued": "En Attente",
    "dashV6.inProgress": "En Cours",
    "dashV6.completedToday": "Terminé Aujourd'hui",
    "dashV6.machineUtil": "Machines Occupées",
    "dashV6.topOperators": "Meilleurs Opérateurs par Charge Active",
    "dashV6.status.DRAFT": "En Attente",
    "dashV6.status.IN_PROGRESS": "En Cours",
    "dashV6.status.COMPLETED": "Terminé",
    "dashV6.priority.HIGH": "Haute",
    "dashV6.priority.MEDIUM": "Moyenne",
    "dashV6.priority.LOW": "Basse",
    "dashV6.recentActivity": "Activité Récente",
    "dashV6.granted": "a accordé",
    "dashV6.revoked": "a révoqué",
    "dashV6.forUser": "pour",
    "common.export": "Exporter",
    "common.next": "Suivant",
    "common.retry": "Retry",
    "common.clearFilters": "Clear Filters",
    "common.saveAll": "Enregistrer All",
    "common.resetDefaults": "Reset to Defaults",
    "common.configure": "Configure",
    "common.disable": "Disable",
    "common.close": "Fermer",
    "common.skip": "Skip",
    "common.continue": "Continue",
    "common.deactivate": "Deactivate",
    "common.reactivate": "Reactivate",
    "common.preview": "Preview",
    "common.openNewTab": "Open in new tab",
    "common.resetAllToDefaults": "Reset all to defaults",
    "common.renew": "Renew",
    "common.manage": "Gérer",
    "common.apply": "Apply",
    "common.saveTimezone": "Enregistrer Timezone",
    "shipment.lockDialogHeader": "Lock Consignation",
    "shipment.lockButtonTooltip": "Lock this consignment permanently — no edits after lock",
    "shipment.lockDescription": "Once locked, this consignment cannot be edited by anyone. All changes will be permanently frozen.",
    "recon.lockDialogHeader": "Lock Reconciliation",
    "recon.lockIrreversible": "This action is permanent and irreversible.",
    "recon.lockDescription": "Once locked, no one can modify reconciliation data — not even the account owner. The tallysheet itself remains accessible and viewable.",
    "recon.lockReasonLabel": "Reason (optional)",
    "recon.lockReasonPlaceholder": "e.g. Confirmed against discharge survey",
    "recon.varianceDetected": "Variance detected",
    "recon.varianceChoiceLabel": "How should this be applied to inventory?",
    "recon.applyAutoLabel": "Apply automatically now",
    "recon.applyAutoDesc": "Inventory will be corrected to match the actual arrived quantity.",
    "recon.applyAutoNeedsReceive": "Recevez d'abord ce Stock Unit — il n'y a pas encore de stock à corriger.",
    "recon.applyManualLabel": "I'll handle it manually",
    "recon.applyManualDesc": "Inventory keeps the original quantity — adjust it yourself later if needed.",
    "recon.lockTypeConfirm": "Type LOCK to confirm",
    "recon.confirmLockButton": "Confirm Lock Reconciliation",
    "invProc.title": "Ordres de sciage",
    "invProc.subtitle": "Ordres de sciage : le stock d'un lot scié en un nouveau lot",
    "invProc.totalRuns": "Total des ordres de sciage",
    "invProc.avgOutturn": "Avg Outturn",
    "invProc.cbmProcessed": "CBM scié (entrée)",
    "invProc.noRuns": "Aucun ordre de sciage pour l'instant.",
    "invProc.noRunsHint": "Cliquez sur Nouvel ordre de sciage pour transformer les grumes en bois scié.",
    "invProc.stepLocation": "Emplacement & Date",
    "invProc.millLocationLabel": "Scierie",
    "invProc.millPlaceholder": "Rechercher or type mill name",
    "invProc.millRequired": "Mill location est obligatoire.",
    "invProc.notesLabel": "Notes (optional)",
    "invProc.tuSelectionHint": "Showing AVAILABLE round-type Unités de Stock. Sélectionner all that will go into the saw.",
    "invProc.noTusFound": "Aucune unité de stock de grumes disponible.",
    "invProc.noTusHint": "Receive round log Unités de Stock into inventory first.",
    "invProc.selected": "Selected:",
    "invProc.totalInput": "Total input:",
    "invProc.outputProduct": "Output Produit",
    "invProc.outputProductPlaceholder": "Rechercher or type product name",
    "invProc.noProductFound": "Aucun produit trouvé",
    "invProc.noSiteFound": "Aucune cour trouvée",
    "invProc.acSearchMessage": "{0} résultats disponibles",
    "invProc.acEmptySelectionMessage": "Aucun élément sélectionné",
    "invProc.storeAt": "Store At",
    "invProc.storePlaceholder": "Yard name",
    "invProc.outputVolume": "Output Volume (CBM)",
    "invProc.fifoPanelTitle": "À quel achat cela est-il attribué ?",
    "invProc.fifoPanelHint": "L'achat le plus ancien est utilisé en premier. Vous pouvez modifier la répartition ci-dessous si besoin.",
    "invProc.fifoPanelMismatch": "Les montants modifiés doivent totaliser le même CBM que ce qui est entré à la scierie.",
    "invProc.fifoPanelCbmLabel": "CBM",
    "invProc.fifoPanelPiecesLabel": "Pièces",
    "invProc.outputPiecesLabel": "Output Pièces",
    "invProc.inputPiecesLabel": "Combien de pièces entrent ?",
    "invProc.useFullVolume": "Tout le volume",
    "invProc.useAllPieces": "Toutes les pièces",
    "invProc.inputPiecesOptionalHint": "Facultatif — vous pouvez aussi le saisir en terminant le travail.",
    "invProc.inputPiecesExceeds": "Plus que les pièces de ce stock",
    "invProc.inputPiecesUsed": "Pièces d'entrée utilisées",
    "invProc.inputPiecesHint": "Pièces prises dans le stock d'entrée. Les pièces de sortie peuvent être plus nombreuses — une pièce peut en donner plusieurs.",
    "invProc.inputPiecesReadOnlyHint": "L'entrée ne peut plus être modifiée une fois le travail terminé. Utilisez un ajustement de stock pour corriger.",
    "invProc.inputPiecesRequired": "Saisissez les pièces d'entrée utilisées avant de terminer le travail.",
    "invProc.confirmSave": "Confirm & Enregistrer",
    "invProc.inputHeader": "INPUT",
    "invProc.outputHeader": "OUTPUT",
    "invProc.inputTUs": "Input Unités de Stock",
    "invProc.lossLabel": "Conversion",
    "invProc.step1.title": "Qu'est-ce qui va à la scierie?",
    "invProc.step2.title": "Qu'est-ce qui en est sorti?",
    "invProc.inputCbmLabel": "Quelle quantité entre? (CBM)",
    "invProc.moreDetails": "Plus de détails (optionnel)",
    "invProc.selectTUs": "Sélectionner unités de stock (optionnel)",
    "invProc.confirmJobSave": "Enregistrer l'ordre de sciage",
    "invProc.outputMethod": "Comment enregistrer la sortie?",
    "invProc.directVolume": "Saisir le CBM total",
    "invProc.directVolumeDesc": "Saisir le volume de sortie total",
    "invProc.viaTally": "Mesurer pièce par pièce (Feuille de Comptage)",
    "invProc.viaTallyDesc": "Ouvrir la feuille de comptage",
    "invProc.viaCsv": "CSV / Excel",
    "invProc.viaCsvDesc": "Charger une feuille de mesure",
    "invProc.viaAi": "AI Import",
    "invProc.viaAiDesc": "Scanner ou charger un document",
    "invProc.draftNote": "L'ordre de sciage sera enregistré comme brouillon. Complétez la sortie après l'enregistrement.",
    "invProc.notesPlaceholder": "Ex : planches 4×8, commande personnalisée",
    "invProc.inputCbmLabelHelp": "Quelle quantité entre dans la scie?",
    "invProc.assignTo": "Attribuer à l'opérateur",
    "invProc.needsAccept": "Attribuée à vous · Accepter",
    "invProc.assignedToYou": "Attribuée à vous",
    "invProc.assignedTo": "Attribuée à",
    "invProc.createdBy": "Créé par",
    "invProc.you": "Vous",
    "invProc.acceptedLabel": "Acceptée",
    "invProc.onlyAssignedCanAct": "Cette tâche est attribuée à un autre opérateur. Seul cet opérateur ou un responsable peut y travailler.",
    "invProc.acceptTask": "Accepter la tâche",
    "invProc.accepted": "Tâche acceptée",
    "invProc.myTasks": "Mes tâches",
    "invProc.big.accept": "Accepter",
    "invProc.big.start": "Démarrer",
    "invProc.big.done": "Terminé",
    "invProc.big.resume": "Reprendre",
    "invProc.big.pause": "Pause",
    "invProc.declineButton": "Impossible",
    "invProc.declineTitle": "Impossible de faire cette tâche",
    "invProc.declineIntro": "La tâche retourne à votre responsable. Dites-lui pourquoi.",
    "invProc.declineReasonLabel": "Pourquoi ne pouvez-vous pas la faire ?",
    "invProc.declineReasonPlaceholder": "ex. machine en panne, mauvaises grumes, pas à cette scierie",
    "invProc.declineConfirm": "Renvoyer",
    "invProc.declineDone": "Tâche renvoyée à votre responsable",
    "invProc.declineNeedsInternet": "Internet est nécessaire. Réessayez une fois en ligne.",
    "invProc.declinedCouldNot": "n'a pas pu faire cette tâche",
    "invProc.declinedHint": "Elle n'est assignée à personne. Annulez-la et créez une nouvelle tâche pour un autre opérateur.",
    "invProc.myTasksSubtitle": "Votre travail à la scierie. Touchez le grand bouton pour avancer la tâche.",
    "invProc.myTasksEmpty": "Aucune tâche pour vous en ce moment",
    "invProc.myTasksEmptyHint": "Les nouvelles tâches qui vous sont confiées apparaîtront ici.",
    "invProc.big.refresh": "Actualiser",
    "user.millOperator": "Opérateur de scierie",
    "user.millOperatorPill": "Opérateur",
    "user.millOperatorOnTitle": "Opérateur de scierie activé",
    "user.millOperatorOffTitle": "Opérateur de scierie désactivé",
    "user.millOperatorOnMessage": "Cette personne peut maintenant recevoir des tâches de scierie.",
    "user.millOperatorRightsAdded": "Cette personne peut maintenant recevoir des tâches de scierie. View Mill Jobs et Run Mill Jobs ont été ajoutés à ses accès.",
    "user.millOperatorRoleMissing": "Le rôle \"{{role}}\" n'inclut pas View Mill Jobs et Run Mill Jobs : elle ne peut pas encore accepter de tâches. Ajoutez-les au rôle ou choisissez un autre rôle.",
    "user.millOperatorFailed": "Impossible de modifier l'opérateur. Réessayez.",
    "user.inviteAsMillOperator": "Cette personne est opérateur de scierie",
    "user.inviteAsMillOperatorHint": "Elle pourra recevoir des tâches de scierie après avoir rejoint.",
    "operator.linkLogin": "Lier un compte",
    "operator.linkLoginHint": "Choisissez le membre de l'équipe correspondant à cet opérateur, pour qu'il voie et accepte ses tâches. Réglable une seule fois.",
    "operator.noLogin": "Sans compte",
    "operator.noLoginHint": "Cet opérateur n'a pas de compte et ne peut ni voir ni accepter de tâches. Touchez pour en lier un.",
    "operator.noOperatorsHint": "Aucun opérateur pour l'instant. Activez \"Opérateur de scierie\" pour une personne dans Gérer les utilisateurs.",
    "invProc.assignHint": "Laisser vide pour enregistrer comme Brouillon — attribuer plus tard.",
    "invProc.willBeAssigned": "Le travail sera créé et attribué à l'opérateur sélectionné.",
    "invProc.willBeDraft": "Aucun opérateur sélectionné — le travail sera enregistré comme Brouillon.",
    "invProc.outputPending": "En attente — enregistré après le sciage.",
    "invProc.assignDate": "Date prévue",
    "invProc.jobCard": "VOTRE TRAVAIL DU JOUR",
    "invProc.startJob": "Démarrer",
    "invProc.customMade.requested": "Demandé",
    "invProc.customMade.sourceChoiceLabel": "Stock source",
    "invProc.customMade.pickMyself": "Choisir moi-même",
    "invProc.customMade.letOperatorDecide": "Laisser l'opérateur décider",
    "invProc.customMade.operatorPicksLater": "L'opérateur choisira le lot source au démarrage de ce travail.",
    "invProc.customMade.chooseLotToStart": "Choisir le lot source",
    "invProc.customMade.rowWaiting": "En attente de démarrage",
    "invProc.customMade.rowProducing": "En production…",
    "invProc.customMade.rowPaused": "En pause à la scierie",
    "invProc.customMade.peekTitle": "Tâche de scierie",
    "invProc.customMade.peekUnavailable": "Impossible de charger les détails de cette tâche.",
    "invProc.customMade.dialogTitle": "Demander une fabrication sur mesure",
    "invProc.customMade.dialogExplainer": "Nous n'avons pas trouvé cette taille exacte en stock — demandez qu'elle soit coupée à la scierie.",
    "invProc.customMade.sizeUnknown": "taille inconnue — vérifiez avant de choisir",
    "invProc.lotHeldBy": "Réservé par",
    "invProc.customMade.sizeTooSmall": "plus petit que nécessaire",
    "invProc.customMade.tooSmallWarning": "Ce lot est plus petit que nécessaire — une scierie ne peut que couper, pas ajouter de matière.",
    "invProc.customMade.inputCbmLabel": "Quelle quantité entre ? (CBM)",
    "invProc.customMade.inputCbmHint": "Votre ligne a besoin d'environ",
    "invProc.customMade.previewOutturn": "rendement estimé",
    "invProc.customMade.inputCbmTooLow": "C'est moins que ce qui est nécessaire — augmentez pour tenir compte de la perte en scierie. Votre ligne a besoin d'au moins",
    "invProc.customMade.priorityLabel": "Priorité",
    "invProc.customMade.priorityLow": "Basse",
    "invProc.customMade.priorityMedium": "Moyenne",
    "invProc.customMade.priorityHigh": "Haute",
    "invProc.customMade.priorityHighHint": "Cela bloquera une expédition tant que ce n'est pas terminé — marqué comme priorité Haute.",
    "invProc.customMade.neededByLabel": "Nécessaire pour le",
    "invProc.customMade.neededByHint": "Facultatif. Vous et la scierie êtes prévenus une fois si le travail est encore ouvert après ce jour.",
    "invProc.customMade.targetLabel": "La commande demande",
    "invProc.customMade.late": "En retard",
    "invProc.customMade.short": "Manque",
    "invProc.customMade.shortBy": "il manque",
    "invProc.customMade.madeOf": "Produit",
    "invProc.customMade.stillMissing": "pièces manquent encore. La commande est toujours incomplète : demandez le reste à la scierie.",
    "invProc.customMade.inputBelowTarget": "Le volume d'entrée est inférieur à ce que la commande demande. Vérifiez avant de scier.",
    "invProc.customMade.submitCta": "Envoyer la demande",
    "invProc.customMade.requestedToast": "Demande sur mesure envoyée",
    "invProc.customMade.requestFailed": "Impossible d'envoyer la demande",
    "invProc.customMade.queuedOfflineRunCode": "En file d'attente — sera synchronisé",
    "invProc.customMade.queuedOfflineToast": "Demande sur mesure enregistrée hors ligne",
    "invProc.customMade.queuedOfflineDetail": "Sera envoyée automatiquement dès que vous serez de nouveau en ligne.",
    "invProc.customMade.staleLotsNotice": "Lots affichés depuis votre dernière synchronisation — peuvent être obsolètes.",
    "invProc.customMade.recommended": "Recommandé",
    "invProc.customMade.estimatedOutturn": "Rendement estimé",
    "invProc.customMade.viewSizes": "Voir les tailles",
    "common.optional": "facultatif",
    "invProc.customMade.tuPreparing": "En préparation",
    "invProc.customMade.tuPreparingTooltip": "Un ou plusieurs articles de cette fiche sont en cours de production à la scierie.",
    "invProc.completeJob": "Travail Terminé",
    "invProc.cancelJob": "Annuler l'ordre de sciage",
    "invProc.pauseJob": "Suspendre",
    "invProc.resumeJob": "Reprendre",
    "invProc.pauseReasonLabel": "Pourquoi suspendez-vous ceci ?",
    "invProc.pauseReasonPlaceholder": "ex. : Une commande urgente est arrivée",
    "invProc.filterStatus": "Statut",
    "invProc.filterAll": "Tous",
    "invProc.filterDraft": "Brouillon",
    "invProc.filterRunning": "En Cours",
    "invProc.filterPaused": "Suspendu",
    "invProc.filterFinished": "Terminé",
    "invProc.filterCompleted": "Terminé (Réussi)",
    "invProc.filterCancelled": "Annulé",
    "invProc.sortLabel": "Trier",
    "invProc.sortNewest": "Plus Récent d'Abord",
    "invProc.sortOldest": "Plus Ancien d'Abord",
    "invProc.sortCode": "ID de l'ordre A-Z",
    "invProc.noJobToday": "Aucune tâche assignée aujourd'hui.",
    "invProc.jobAssignedBy": "Assigné par",
    "invProc.editOutput": "Modifier la Sortie",
    "invProc.outputAboveInput": "La sortie dépasse ce qui est entré à la scierie. Le sciage ne peut pas produire plus de bois qu'il n'en a reçu : vérifiez le tally de sortie et le volume d'entrée.",
    "invProc.directEntry": "Volume Direct",
    "invProc.viaTallySheet": "Via Feuille de Comptage",
    "invProc.taskNo": "N° de Tâche",
    "invProc.viewInMill": "Voir à la scierie",
    "invProc.sourceOrder": "Commande Source",
    "invProc.viewSourceOrder": "Voir la commande source",
    "invProc.selectTallySheet": "Rechercher une feuille...",
    "invProc.tallyLinked": "Feuille liée — CBM renseigné",
    "invProc.directDesc": "Saisir le CBM total manuellement",
    "invProc.tallyDesc": "Enregistrer les pièces → CBM calculé auto",
    "invProc.csvImport": "CSV / Excel",
    "invProc.csvDesc": "Importer tableur → vérifier dans la feuille",
    "invProc.aiImport": "Import IA",
    "invProc.aiDesc": "Scanner document → vérifier dans la feuille",
    "invProc.openTally": "Ouvrir la Feuille →",
    "invProc.tallyTypeLabel": "Type de Comptage",
    "invProc.tallyTypeRound": "Rond",
    "invProc.tallyTypeSquare": "Carré",
    "invProc.tallyTypeDerivedHint": "Détecté automatiquement depuis le produit",
    "invProc.tallyTypePickProduct": "Choisissez d'abord le produit de sortie. Le type de pointage (Rond ou Carré) en découle.",
    "invProc.odWhatCameOut": "Ce qui est sorti",
    "invProc.odHowRecord": "Comment l’enregistrer ?",
    "invProc.odTotals": "Totaux",
    "invProc.odSquareRule": "L’entrée est du bois scié (Carré), donc la sortie est aussi Carrée. Le bois scié ne peut pas redevenir des grumes rondes.",
    "invProc.volumeUnit": "Unité de volume",
    "invProc.odChooseProductFirst": "Choisissez d'abord le produit de sortie. Vous pourrez ensuite choisir comment l'enregistrer.",
    "invProc.odTotalsFromTally": "Les totaux s'afficheront ici une fois le pointage enregistré.",
    "invProc.odProductTypeLocked": "Le pointage de cet ordre contient déjà des lignes {type}, donc seuls les produits {type} sont proposés.",
    "invProc.noProductOfType": "Aucun produit {type} trouvé",
    "invProc.odDraftSaving": "Enregistrement de votre choix…",
    "invProc.odDraftSaved": "Votre choix est enregistré",
    "invProc.odDraftError": "Impossible d'enregistrer votre choix pour l'instant.",
    "invProc.soFar": "à ce jour",
    "invProc.recordedSoFar": "Enregistré à ce jour",
    "invProc.recordedBeforeCancel": "Enregistré avant l'annulation",
    "invProc.notStockYet": "Pas encore du stock. Cela devient du stock quand l'ordre est terminé.",
    "invProc.cancelWithOutputWarn": "L'ordre <b>{run}</b> a déjà {cbm} CBM ({pcs} pièces) enregistrés dans son pointage de sortie. Si vous annulez, ce pointage est gardé comme simple trace et rien ne devient du stock. Pour le mettre en stock, terminez plutôt l'ordre.",
    "invProc.cancelAnyway": "Annuler quand même",
    "invProc.keepJob": "Garder l'ordre",
    "invProc.atMill": "À la scierie",
    "invProc.atMillJobs": "Ordres en cours",
    "invProc.atMillInput": "Entrée retenue",
    "invProc.atMillOutput": "Sortie à ce jour",
    "invProc.atMillNote": "Pas encore du stock",
    "invProc.openingTally": "Ouverture du pointage…",
    "invProc.preparingRun": "Préparation du nouveau travail de scierie…",
    "invProc.odTotalsLocked": "Choisissez d'abord le produit de sortie, puis saisissez les totaux.",
    "invProc.odPrepareSizes": "Préparer les dimensions (facultatif)",
    "invProc.odPrepareSizesHint": "Le pointage s'ouvre avec ces dimensions prêtes à 0 pièce. La disposition Opérateur les affiche en cartes.",
    "invProc.odSizesReady": "{n} dimensions prêtes",
    "invProc.odSizesNotSaved": "Impossible d'enregistrer les dimensions. Choisissez-les à nouveau avec Choisir des dimensions dans la disposition Opérateur.",
    "invProc.odEditInputPieces": "Modifier les pièces en entrée",
    "millOp.layoutAria": "Disposition du pointage",
    "millOp.layoutGrid": "Grille",
    "millOp.layoutOperator": "Opérateur",
    "millOp.loadError": "Impossible de charger la feuille.",
    "millOp.retry": "Réessayer",
    "millOp.outputPieces": "Pièces en sortie",
    "millOp.outputVolume": "Volume en sortie",
    "millOp.volumeUnit": "Unité de volume",
    "millOp.input": "Entrée",
    "millOp.outturn": "Rendement",
    "millOp.ofInput": "du volume d'entrée",
    "millOp.moreThanInput": "plus que l'entrée : vérifiez les dimensions",
    "millOp.saved": "Enregistré",
    "millOp.saving": "Enregistrement…",
    "millOp.unsaved": "Non enregistré",
    "millOp.saveFailed": "Enregistrement impossible",
    "millOp.show": "Afficher",
    "millOp.sheetSizes": "Dimensions de la feuille",
    "millOp.used": "Utilisées",
    "millOp.view": "Affichage",
    "millOp.textSize": "Taille du texte",
    "millOp.cardSize": "Taille des cartes",
    "millOp.cardTiny": "Minuscule",
    "millOp.cardSmall": "Petit",
    "millOp.cardMedium": "Moyen",
    "millOp.cardLarge": "Grand",
    "millOp.tapSound": "Son au toucher",
    "millOp.keepScreenOn": "Garder l'écran allumé",
    "millOp.keepScreenOnUnsupported": "Cet appareil ou navigateur ne peut pas garder l'écran allumé.",
    "millOp.unitsNote": "Les unités suivent les réglages de la feuille. Pour les changer, ouvrez Réglages dans la disposition Grille.",
    "millOp.resetView": "Rétablir par défaut",
    "millOp.oneLess": "Une pièce de moins",
    "millOp.oneMore": "Une pièce de plus",
    "millOp.piecesTapToType": "Pièces. Touchez pour saisir un nombre",
    "millOp.noUsed": "Aucune dimension utilisée. Passez à « Dimensions de la feuille » et touchez +.",
    "millOp.noSizesTitle": "Cette feuille n'a pas encore de dimensions",
    "millOp.noSizesText": "Choisissez les dimensions attendues ou ajoutez-en une.",
    "millOp.newSize": "Nouvelle dimension",
    "millOp.pickSizes": "Choisir des dimensions",
    "millOp.autoSaves": "Enregistre tout seul peu après votre dernier toucher",
    "millOp.screenStaysOn": "L'écran reste allumé",
    "millOp.undo": "Annuler",
    "millOp.setPieces": "Définir les pièces",
    "millOp.piecesForSize": "Pièces pour cette dimension",
    "millOp.clear": "Effacer",
    "millOp.newSizeHint": "Touchez une case puis une valeur rapide ou les touches",
    "millOp.width": "Largeur",
    "millOp.thickness": "Épaisseur",
    "millOp.length": "Longueur",
    "millOp.addSize": "Ajouter la dimension",
    "millOp.pickHint": "Cochez les dimensions attendues. Vous pourrez en ajouter d'autres plus tard.",
    "millOp.searchSize": "Chercher une dimension, p. ex. 4 x 2",
    "millOp.listView": "Liste",
    "millOp.chipView": "Pastilles",
    "millOp.addAll": "Tout ajouter",
    "millOp.hasPieces": "a des pièces",
    "millOp.noSuggestions": "Aucune dimension antérieure. Utilisez « Nouvelle dimension ».",
    "millOp.addNSizes": "Ajouter {n} dimensions",
    "millOp.removeNSizes": "Retirer {n} dimensions",
    "millOp.onSheet": "Sur cette feuille",
    "millOp.sameAsLast": "Comme le dernier travail {code}",
    "millOp.mostUsed": "Les plus utilisées",
    "millOp.recent": "Récentes",
    "millOp.changeToast": "{size} : {from} → {to} pcs",
    "invProc.odTypeFromInput": "car l’entrée est du bois scié",
    "invProc.squareInputRoundBlocked": "Le bois scié (entrée Carrée) ne peut pas devenir des grumes rondes. Choisissez un produit de sortie Carré.",
    "invProc.tallyTypeMismatch": "Le pointage de ce travail contient déjà des lignes de type {tally}, mais le produit de sortie est de type {product}. Choisissez un produit de sortie {tally} ou passez au Volume direct.",
    "invProc.tallyTypeLinkedHint": "De la feuille liée",
    "invProc.linkedTally": "Lié",
    "invProc.tallyRows": "lignes",
    "invProc.cbmFromTally": "Rempli auto depuis la feuille",
    "invProc.tallyManualHint": "Enregistrez les pièces dans la feuille, puis revenez ici",
    "invProc.csvHint": "Le dialogue d'import CSV s'ouvrira automatiquement",
    "invProc.aiHint": "Le dialogue d'import IA s'ouvrira automatiquement",
    "invProc.dispatchOutput": "Envoyer vers la Consignation →",
    "invProc.selectShipment": "Sélectionner la Consignation",
    "invProc.shipmentPlaceholder": "Choisir une consignation active...",
    "invProc.confirmDispatch": "Confirmer l'Expédition",
    "tally.processingBanner": "Enregistrement de la sortie de l'ordre de sciage :",
    "tally.outputLockedTitle": "Cette sortie est définitive",
    "tally.outputLockedText": "Cet ordre de sciage est terminé et son bois est déjà en stock sous forme de nouveau lot ; ce relevé est donc en lecture seule — il correspond toujours au stock qu'il a créé. Pour modifier la sortie, utilisez Modifier la Sortie sur l'ordre de sciage. Pour corriger une quantité en stock, utilisez Ajustement. Les deux laissent une trace.",
    "tally.returnToRun": "Terminé — Retour à l'ordre de sciage",
    "tally.saveAndReturnToRun": "Enregistrer et revenir à l'ordre de sciage",
    "field.stockIn.title": "Enregistrer l'Arrivée",
    "field.millRun.title": "Votre Tâche",
    "field.sendOut.title": "Enregistrer l'Expédition",
    "field.selectProduct": "Qu'est arrivé?",
    "field.cbmAmount": "Combien? (CBM)",
    "field.location": "Où est stocké?",
    "field.submitBtn": "Terminé",
    "field.noJobAssigned": "Aucune tâche aujourd'hui.",
    "invInOut.title": "Journal Entrées / Sorties",
    "invInOut.subtitle": "Chaque mouvement de stock avec horodatage et détails",
    "invInOut.addAdjustment": "Ajouter Adjustment",
    "invInOut.adjTooltip": "Enregistrer une correction manuelle du stock",
    "invInOut.exportTooltip": "Exporter le journal filtré vers Excel",
    "invInOut.dateRange": "Plage de dates",
    "invInOut.allDates": "Toutes les dates",
    "invInOut.movements": "mouvements",
    "invInOut.netChange": "Variation nette",
    "invInOut.businessPartner": "Commercial Partenaire",
    "invInOut.noMovements": "Aucun mouvement trouvé.",
    "invInOut.clearFiltersHint": "Essayez d'effacer les filtres ci-dessus.",
    "invInOut.adjDialogHeader": "Ajouter Inventaire Adjustment",
    "invInOut.tuPlaceholder": "Rechercher unité de stock, n° de conteneur / camion ou produit",
    "ledger.s.received": "Reçu",
    "ledger.s.at": "à",
    "ledger.s.as": "comme",
    "ledger.s.dispatched": "Expédié",
    "ledger.s.from": "de",
    "ledger.s.on": "sur",
    "ledger.s.to": "à",
    "ledger.s.sentToMill": "Envoyé à la scierie",
    "ledger.s.forJob": "pour le travail",
    "ledger.s.job": "Travail",
    "ledger.s.produced": "a produit",
    "ledger.s.into": "dans",
    "ledger.s.addedToConsignment": "ajouté à l'envoi",
    "ledger.s.allowance": "Tolérance grume",
    "ledger.s.tallyCorrected": "Tally corrigé de",
    "ledger.s.stockCorrected": "Stock corrigé de",
    "Reconciliation": "Rapprochement",
    "Allowance": "Tolérance",
    "Tally correction": "Correction du pointage",
    "ledger.s.reconciled": "Rapproché",
    "ledger.col.whatHappened": "Ce qui s'est passé",
    "ledger.col.by": "Par",
    "ledger.job.show": "Travail complet",
    "ledger.job.in": "Entrée",
    "ledger.job.out": "Sortie",
    "ledger.job.started": "Début",
    "ledger.job.finished": "Fin",
    "ledger.job.notFinished": "Pas encore terminé",
    "ledger.job.wastage": "Perte",
    "invInOut.tuRequired": "Sélectionnez une Unité de Stock.",
    "invInOut.reason": "Motif",
    "invInOut.reasonPlaceholder": "Sélectionner un motif",
    "invInOut.reasonRequired": "Sélectionnez un motif.",
    "invInOut.cbmChange": "Variation en CBM",
    "invInOut.cbmHint": "Négatif = perte, positif = gain",
    "invInOut.piecesChange": "Pièces Change",
    "terms.open": "Que signifient unité de stock, lot et ordre de sciage ?",
    "terms.flowLabel": "Comment le stock circule : entrée, lot, ordre de sciage, nouveau lot, sortie",
    "terms.stockIn": "Entrée",
    "terms.stockOut": "Sortie",
    "terms.lot": "Lot",
    "terms.newLot": "Nouveau lot",
    "terms.millJob": "Ordre de sciage",
    "terms.suName": "Unité de stock",
    "terms.suText": "Un chargement — conteneur, camion ou wagon — avec ses lignes de pointage. Entrée = acheté, Sortie = vendu. Les lignes se verrouillent une fois reçu / confirmé.",
    "terms.lotText": "Un tas du même bois en stock (produit, site, origine, qualité). L'entrée y est reçue ; sorties et ordres de sciage y prennent — le lot le plus ancien d'abord.",
    "terms.lotOld": "(appelé Batch avant)",
    "terms.jobText": "Bois envoyé d'un lot à la scierie ; il enregistre l'entrée, la sortie et la perte, et crée un nouveau lot.",
    "terms.jobOld": "(appelé Traitement avant)",
    "terms.more": "Comment le stock circule — guide complet",
    "so.fromPurchase": "De l'achat",
    "so.whereFrom": "D'où ça vient",
    "so.show": "Afficher",
    "so.showPath": "Afficher tout le chemin",
    "so.hidePath": "Masquer le chemin",
    "so.error": "Impossible de retracer.",
    "so.nothing": "Rien de pris dans le stock pour l'instant.",
    "so.inputNote": "Avant une scierie, les chiffres sont le bois entré, pertes comprises. Volume net.",
    "so.in": "entrée",
    "so.out": "sortie",
    "so.waste": "perte",
    "so.now": "Maintenant",
    "so.adjusted": "Ajusté",
    "so.reconciled": "Rapproché",
    "so.allowance": "Tolérance",
    "so.traceToPurchase": "Retracer jusqu'à l'achat",
    "so.kind.LOT": "Lot",
    "so.kind.MILL_JOB": "Ordre de sciage",
    "so.kind.STOCK_UNIT": "Unité de stock",
    "so.kind.OPENING_STOCK": "Stock d'ouverture",
    "so.kind.HAND": "Lot saisi à la main",
    "so.kind.ADJUSTMENT": "Ajouté par ajustement",
    "so.kind.NOT_TRACED": "Non retracé",
    "adj.what": "Unité de stock, sortie ou lot",
    "adj.whatPlaceholder": "Rechercher unité d'entrée / sortie, conteneur / camion, lot ou produit",
    "adj.kind.IN": "Entrée",
    "adj.kind.OUT": "Sortie",
    "adj.kind.LOT": "Lot",
    "adj.reconHint": "Écart de rapprochement — saisissez-le taille par taille :",
    "adj.noLot": "Cette unité n'est pas encore reçue dans un lot — rien à ajuster.",
    "adj.outLine": "Quelle ligne de cette sortie",
    "adj.outLinePlaceholder": "Choisir lot · taille · pièces",
    "adj.noOutLines": "Cette sortie n'a encore rien pris — rien à ajuster.",
    "adj.batchNow": "contient maintenant",
    "adj.dir.gain": "Ajouter au stock",
    "adj.dir.loss": "Retirer du stock",
    "adj.dir.outGain": "Envoyé moins que prévu",
    "adj.dir.outLoss": "Envoyé plus que prévu",
    "adj.size": "Taille",
    "adj.sizePlaceholder": "Choisir une taille",
    "adj.anotherSize": "Autre taille…",
    "adj.sec.what": "Quoi ajuster",
    "adj.sec.amount": "Taille et quantité",
    "adj.sec.why": "Pourquoi",
    "adj.origin": "Origine",
    "adj.quality": "Qualité",
    "adj.originNote": "L'ajustement va dans ce Lot — son origine et sa qualité ne changent pas.",
    "adj.volume": "Volume",
    "adj.sizeSearch": "Chercher une taille, ex. 4x3x6",
    "adj.width": "Largeur (po)",
    "adj.thick": "Épaisseur (po)",
    "adj.length": "Longueur (pi)",
    "adj.pieces": "Pièces",
    "adj.cbm": "CBM",
    "adj.maxPcs": "Jusqu'à {n} pièces en stock",
    "adj.pcsInStock": "{n} pièces",
    "adj.tooMuch": "C'est plus que ce que ce lot / cette taille contient.",
    "adj.outNoteTitle": "Sortie ajustée",
    "adj.outNote": "Le stock est corrigé ; les lignes de la sortie restent inchangées. Les totaux d'envoi / facture ne changent PAS — corrigez-les aussi si besoin.",
    "adj.offline": "Les ajustements nécessitent une connexion.",
    "adj.saved": "Ajustement enregistré — stock mis à jour.",
    "adj.roundPart": "Grumes rondes (sans dimension)",
    "adj.reason.RECONCILIATION_DELTA": "Écart de rapprochement",
    "adj.reason.RECONCILIATION_AFTER_MILLING": "Rapprochement après sciage",
    "adj.reason.DAMAGE": "Dommage",
    "adj.reason.MOISTURE_LOSS": "Perte d'humidité / séchage",
    "adj.reason.MEASUREMENT_ERROR": "Erreur de mesure",
    "adj.reason.MANUAL_CORRECTION": "Correction manuelle",
    "adj.reason.OTHER": "Autre",
    "adj.notesRequired": "Décrivez ce qui s'est passé (obligatoire quand le motif est Autre).",
    "adj.large.title": "Ceci est un grand ajustement",
    "adj.large.text": "Vérifiez bien la quantité — une faute de frappe (un zéro en trop) changerait beaucoup votre stock.",
    "adj.large.confirm": "J'ai vérifié cette quantité",
    "adj.holdShortTitle": "D'autres sorties manquent de stock",
    "adj.holdShortText": "Ces sorties ouvertes réservent plus que ce lot ne contient : {units}",
    "adj.alreadyAdjusted": "ajusté",
    "ledger.s.adjustedAfterConfirm": "Ajusté après confirmation",
    "ledger.s.recordedOnly": "(enregistré seulement — stock inchangé)",
    "invInOut.postAdjustment": "Enregistrer l'ajustement",
    "invInOut.descPlaceholder": "Décrivez ce qui s'est passé (facultatif)",
    "invOverview.title": "Inventaire Overview",
    "invOverview.subtitle": "Live stock snapshot across all locations",
    "invOverview.thisMonth": "This month",
    "invOverview.clearStageHint": "Cliquez the same stage to clear filter",
    "invOverview.filterTooltip": "Cliquez to filter stock table",
    "invOverview.openTu": "Ouvrir Unité de Stock",
    "invOverview.noStock": "Aucun stock dans l'inventaire.",
    "invOverview.noStockHint": "Cliquez sur Entrée Stock pour enregistrer votre première arrivée.",
    "invOverview.showAllTus": "Tout afficher",
    "invOverview.receiveHint": "Camion arrivé — enregistrer nouveau stock",
    "invOverview.processHint": "Envoyer les grumes à la scierie",
    "invOverview.dispatchHint": "Stock sortant",
    "invOverview.recordInInventory": "Enregistrer dans l'Inventaire",
    "invOverview.linkedToInventory": "Dans l'Inventaire",
    "invOverview.modeToggle": "Mode d'affichage",
    "inv.modeSimple": "Simple",
    "inv.modeAdvanced": "Avancé",
    "inv.modeTooltip": "Simple: moins de champs · Avancé: suivi complet",
    "inv.stockIn": "Entrée Stock",
    "inv.millRun": "Ordre de sciage",
    "inv.sendOut": "Sortie Stock",
    // -- Inventory Lots / Wizards
    "lot.receive": "Entrée",
    "lot.process": "→ Scierie",
    "lot.sendToMill": "Envoyer à la scierie",
    "lot.more.label": "Plus",
    "lot.more.details": "Voir les détails",
    "lot.more.statement": "Relevé de stock",
    "lot.more.openJob": "Ouvrir le travail",
    "lot.more.rename": "Renommer le lot",
    "lot.warn.short": "Sous le contrat de",
    "lot.dispatch": "Expédier",
    "lot.stockBatch": "Lots de Stock",
    "lot.inputLotLabel": "Lot d'Entrée",
    "lot.selectLotPlaceholder": "Sélectionner un lot (optionnel)",
    "lot.searchLotPlaceholder": "Rechercher produit, origine, code du lot ou travail de scierie…",
    "lot.searchLotEmpty": "Aucun lot ne correspond à la recherche",
    "lot.pickSearchPlaceholder": "Rechercher produit, lot, Stock Unit, conteneur, BL…",
    "lot.pickOriginPlaceholder": "Origine : toutes",
    "lot.pickOriginUnknown": "Origine inconnue",
    "lot.pickOpenLots": "lots ouverts",
    "lot.pickFree": "CBM libre",
    "lot.pickMadeBy": "fait par",
    "lot.pickHide": "masquer",
    "lot.pickStockUnit": "Stock Unit",
    "lot.pickContainer": "Conteneur / camion · ID de transport",
    "lot.pickSource": "source",
    "lot.pickThisLot": "ce lot",
    "lot.pickUnitsCount": "Stock Units",
    "lot.pickReceived": "reçues dans ce lot",
    "lot.pickTraced": "tracées via le travail de scierie",
    "lot.pickClose": "Fermer",
    // -- Mill Operators
    "operator.label": "Opérateur",
    "operator.multiCompanyBadge": "Multi-entreprise",
    "operator.multiCompanyTooltip": "Cette personne est également active dans une autre entreprise — son compte n'est pas exclusif à la vôtre.",
    "operator.selectPlaceholder": "Assigner un opérateur (optionnel)",
    "operator.title": "Opérateurs de Scierie",
    "operator.subtitle": "Gérez les opérateurs de scierie et suivez la performance",
    "operator.backToInventory": "Retour à l'Inventaire",
    "operator.addOperator": "Ajouter Opérateur",
    "machine.title": "Machines",
    "machine.subtitle": "Gérez les machines et équipements de la scierie",
    "machine.backToInventory": "Retour à l'Inventaire",
    "machine.addMachine": "Ajouter une Machine",
    "machine.editMachine": "Modifier la Machine",
    "machine.name": "Nom",
    "machine.namePlaceholder": "ex. Reciseuse 2",
    "machine.type": "Type",
    "machine.typePlaceholder": "ex. Reciseuse, Dégauchisseuse, Tronçonneuse",
    "machine.location": "Emplacement",
    "machine.status": "Statut",
    "machine.active": "Actif",
    "machine.inactive": "Inactif",
    "machine.deactivate": "Désactiver",
    "machine.reactivate": "Réactiver",
    "machine.confirmMachine": "Confirmer",
    "machine.searchPlaceholder": "Rechercher des machines...",
    "machine.allLocations": "Tous les Emplacements",
    "machine.allStatus": "Tous les Statuts",
    "machine.needsReview": "À Vérifier",
    "machine.needsReviewTooltip": "Importé du champ de texte libre d'un Emplacement — veuillez confirmer que c'est correct",
    "machine.importFromLocations": "Importer depuis les Emplacements",
    "machine.statTotal": "Total des Machines",
    "machine.machineSingular": "machine",
    "machine.machinePlural": "machines",
    "machine.emptyState": "Aucune machine pour l'instant. Ajoutez-en une, ou importez depuis vos Emplacements existants.",
    "shortcuts.title": "Raccourcis Clavier",
    "shortcuts.macHint": "⌘ = Cmd sur Mac. Les raccourcis Enregistrer/Supprimer des formulaires ci-dessous ne fonctionnent actuellement que sur clavier Mac.",
    "shortcuts.group.anywhere": "Partout",
    "shortcuts.group.search": "Dans la Recherche",
    "shortcuts.group.tally": "Saisie de Tally",
    "shortcuts.group.forms": "Formulaires Produit / Site",
    "shortcuts.group.photos": "Visionneuse de Photos",
    "shortcuts.group.calculator": "Calculatrice",
    "shortcuts.group.aiChat": "Chat IA",
    "shortcuts.globalSearch": "Ouvrir la Recherche Globale",
    "shortcuts.openSearch": "Ouvrir la recherche",
    "shortcuts.calculator": "Ouvrir la Calculatrice",
    "shortcuts.quickSearch": "Ouvrir la Recherche Rapide",
    "shortcuts.showShortcuts": "Afficher cette liste",
    "shortcuts.expandMenu": "Développer le menu latéral",
    "shortcuts.moveSelection": "Déplacer la sélection haut/bas",
    "shortcuts.openSelected": "Ouvrir le résultat surligné",
    "shortcuts.closeSearch": "Fermer",
    "shortcuts.saveTally": "Enregistrer les modifications du tally",
    "shortcuts.tallyEnter": "Champ suivant / ligne suivante (ajoute une ligne à la fin)",
    "shortcuts.tallyAddRowBelow": "Ajouter une ligne dessous (tally rond)",
    "shortcuts.tallyStockPicker": "Choisir dans le stock (disposition flexible Square)",
    "shortcuts.tallyForceNext": "Passer sans vérifier la valeur (disposition flexible Square : ajoute une ligne dessous)",
    "shortcuts.tallyMoveCells": "Se déplacer entre les cellules",
    "shortcuts.saveForm": "Enregistrer (Mac uniquement)",
    "shortcuts.deleteForm": "Supprimer, en cours d'édition (Mac uniquement)",
    "shortcuts.prevNextPhoto": "Photo précédente / suivante",
    "shortcuts.closePhoto": "Fermer la visionneuse de photos",
    "shortcuts.calcDigits": "Saisir des chiffres",
    "shortcuts.calcOperators": "Opérateurs",
    "shortcuts.calcPercent": "Pourcentage",
    "shortcuts.calcEquals": "Calculer",
    "shortcuts.calcBackspace": "Effacer le dernier chiffre",
    "shortcuts.calcClearOrClose": "Effacer, puis fermer",
    "shortcuts.aiChatSend": "Envoyer le message",
    "shortcuts.aiChatNewLine": "Nouvelle ligne, sans envoyer",
    "globalSearch.help.viewAllShortcuts": "Voir tous les raccourcis clavier",
    "globalSearch.trigger": "Recherche Globale",
    "unifiedSearch.trigger": "Rechercher",
    "unifiedSearch.placeholder": "Rechercher, ou taper un calcul…",
    "unifiedSearch.shortcutHint": "/",
    "unifiedSearch.mode.auto": "Auto",
    "unifiedSearch.mode.records": "Dossiers",
    "unifiedSearch.mode.stock": "Stock",
    "unifiedSearch.mode.calculator": "Calculatrice",
    "unifiedSearch.autoInterpreting": "Recherche comme",
    "unifiedSearch.mathOpenHint": "touchez ou appuyez sur entrée pour ouvrir la calculatrice",
    "globalSearch.placeholder": "Rechercher unités de stock, expéditions, partenaires, produits, sites, utilisateurs…",
    "globalSearch.shortcutHint": "/",
    "globalSearch.searching": "Recherche en cours…",
    "globalSearch.noResults": "Aucun résultat trouvé",
    "globalSearch.minChars": "Continuez à taper pour rechercher…",
    "globalSearch.category.transportUnit": "Unités de Stock",
    "globalSearch.category.shipment": "Expéditions",
    "globalSearch.category.businessPartner": "Partenaires Commerciaux",
    "globalSearch.category.product": "Produits",
    "globalSearch.category.loadingSite": "Sites",
    "globalSearch.category.user": "Utilisateurs",
    "globalSearch.category.menuItem": "Pages",
    "globalSearch.askLinc.cta": "Demander à Linc",
    "globalSearch.askLinc.subtitle": "Interrogez Linc sur vos enregistrements et votre stock",
    "globalSearch.calculatorTooltip": "Calculatrice",
    "globalSearch.mathOpenHint": "Touchez pour continuer le calcul",
    "globalSearch.help.toggleTooltip": "Comment rechercher",
    "globalSearch.help.intro": "Rechercher dans :",
    "globalSearch.help.shortcutText": "Appuyez sur / n'importe où pour ouvrir cette recherche. Tapez au moins 2 caractères — les codes courts fonctionnent dès 2, les noms longs à partir de 4.",
    "globalSearch.recentTitle": "Récentes",
    "quickSearch.trigger": "Recherche Rapide",
    "quickSearch.placeholder": "ex. 4x3x7 teck ghana a",
    "quickSearch.fuzzyTooltip": "Correspondance approximative — pas exacte",
    "quickSearch.unrecognizedTooltip": "Non reconnu comme espèce, origine ou qualité — ignoré",
    "quickSearch.recent": "Recherches récentes",
    "planLimit.dialogTitle": "Limite du Forfait Atteinte",
    "planLimit.dialogUsage": "Vous avez utilisé {used} sur {limit} {feature}.",
    "planLimit.manageButton": "Gérer {feature}",
    "planLimit.upgradeButton": "Mettre à Niveau",
    "quickSearch.searching": "Recherche...",
    "quickSearch.notFound": "Aucun résultat — essayez une autre orthographe ou moins de détails.",
    "quickSearch.availableNow": "Disponible maintenant",
    "quickSearch.pendingStockIn": "Entrée en stock en attente",
    "quickSearch.groups": "groupes",
    "quickSearch.pcs": "pcs",
    "quickSearch.eta": "ETA",
    "quickSearch.details": "Détails d'achat",
    "shipment.tuAllProducts": "Tous les produits de cette unité",
    "quickSearch.invoiceAmount": "Montant de la facture",
    "quickSearch.billNo": "N° de facture",
    "quickSearch.billOfLadingNo": "N° de connaissement",
    "quickSearch.viewConsignment": "Voir la consignation",
    "quickSearch.mixedConsignments": "Mixte — appuyez pour le détail",
    "quickSearch.noPurchasingInfo": "Aucune information d'achat enregistrée pour ce stock.",
    "quickSearch.calculator": "Calculatrice",
    "quickSearch.quickPrice": "Prix rapide",
    "quickSearch.pricePerCbm": "Prix / CBM",
    "quickSearch.pricePerCft": "Prix / CFT",
    "quickSearch.inProcess": "En ordre de sciage",
    "quickSearch.didYouMean": "Vouliez-vous dire",
    "quickSearch.arrivingSoon": "Arrivée prochaine",
    "quickSearch.departingSoon": "Départ prochain",
    "quickSearch.preparing": "En préparation",
    "quickSearch.hint": "Tapez une espèce, des dimensions, une origine ou une qualité — dans n'importe quel ordre.",
    "quickSearch.help.toggleTooltip": "Comment ça marche",
    "quickSearch.help.back": "Retour à la recherche",
    "quickSearch.help.basicsTitle": "Les bases",
    "quickSearch.help.basicsText": "Combinez espèce, taille, origine ou qualité dans n'importe quel ordre — rien n'est obligatoire.",
    "quickSearch.help.sizesTitle": "Tailles",
    "quickSearch.help.sizesExactText": "Taille exacte, aucun mot nécessaire :",
    "quickSearch.help.sizesRangeText": "Ou une plage — ajoutez un comparateur et une mesure nommée :",
    "quickSearch.help.sizesTypeText": "Des nombres seuls peuvent être ambigus — ajoutez \"square\" (carré) ou \"round\" (rond) pour préciser :",
    "quickSearch.help.sizesAnyText": "Utilisez \"?\" pour une dimension sans importance — \"4x3x?\" signifie 4x3, n'importe quelle longueur :",
    "quickSearch.help.speciesTitle": "Espèce, origine, qualité",
    "quickSearch.help.speciesText": "Les fautes de frappe ne posent pas de problème — les correspondances proches sont trouvées automatiquement. Un repère \"?\" signifie qu'il s'agit d'une estimation, pas d'une correspondance exacte.",
    "quickSearch.help.legendTitle": "Ce que signifient les groupes de résultats",
    "quickSearch.help.legendAvailable": "Disponible Maintenant — prêt à l'emploi aujourd'hui",
    "quickSearch.help.legendPending": "Entrée en Stock en Attente — comptabilisé, pas encore reçu en Inventaire",
    "quickSearch.help.legendProcess": "En ordre de sciage — en cours de sciage ou de resciage",
    "quickSearch.help.legendArriving": "Arrivée / Départ / Préparation — expéditions à venir",
    "quickSearch.help.aiTitle": "Demander à l'IA",
    "quickSearch.help.aiText": "Du mal à formuler votre recherche ? Demander à l'IA comprend un langage plus naturel et moins précis. Utilise des crédits IA (forfait Forest) — la recherche normale reste toujours gratuite.",
    "commandCenter.title": "Centre de Commande",
    "commandCenter.asOf": "À",
    "commandCenter.offlineNoCopyTitle": "Pas encore enregistré sur ce téléphone",
    "commandCenter.offlineNoCopyText": "Ouvrez le Centre de commande une fois en ligne. Ensuite, les derniers chiffres sont enregistrés sur ce téléphone et visibles hors ligne.",
    "commandCenter.tab.overview": "Aperçu",
    "commandCenter.tab.inventory": "Inventaire",
    "commandCenter.tab.floor": "Atelier et Rendement",
    "commandCenter.tab.money": "Finances",
    "commandCenter.tab.consignments": "Expéditions",
    "commandCenter.cons.arriving": "Arrivent cette semaine",
    "commandCenter.cons.leaving": "Partent cette semaine",
    "commandCenter.cons.preparing": "En préparation",
    "commandCenter.cons.shipped": "Expédié ce mois-ci",
    "commandCenter.cons.inShipment": "en envoi",
    "commandCenter.cons.arrives": "Arrive",
    "commandCenter.cons.departs": "Part",
    "commandCenter.cons.all": "Tous les envois",
    "commandCenter.howSure": "Fiabilité des chiffres",
    "commandCenter.counted": "comptés",
    "commandCenter.notCountedYet": "Unités de stock pas encore comptées",
    "commandCenter.reviewThem": "Les vérifier",
    "commandCenter.allSizes": "Toutes les tailles",
    "commandCenter.allSites": "Tous les sites",
    "commandCenter.btn.open": "Ouvrir",
    "commandCenter.btn.review": "Vérifier",
    "commandCenter.btn.count": "Compter",
    "commandCenter.btn.see": "Voir",
    "commandCenter.btn.assign": "Affecter",
    "commandCenter.attn.noMachineOne": "Le travail de scierie {code} n'a pas de machine",
    "commandCenter.attn.noMachineMany": "{n} travaux de scierie en cours n'ont pas de machine",
    "commandCenter.attn.holdsOne": "1 Sortie de stock retient du bois depuis 60+ jours",
    "commandCenter.attn.holdsMany": "{n} Sorties de stock retiennent du bois depuis 60+ jours",
    "commandCenter.attn.holdsSub": "{cbm} m³ bloqués à la vente",
    "commandCenter.tabShort.inventory": "Stock",
    "commandCenter.tabShort.floor": "Atelier",
    "commandCenter.tabShort.consignments": "Envois",
    "commandCenter.confidence": "Confiance",
    "commandCenter.inventoryConfidence": "Confiance de l'Inventaire",
    "commandCenter.of": "sur",
    "commandCenter.reconciledCopy": "unités de stock sont réconciliées",
    "commandCenter.reviewUnreconciled": "Revoir les non réconciliées",
    "commandCenter.stockOnHand": "Stock disponible",
    "commandCenter.machinesRunning": "Machines en marche",
    "commandCenter.owedToYou": "Créances",
    "commandCenter.thisWeek": "Cette semaine (sortie / entrée)",
    "commandCenter.thisWeekTitle": "Cette semaine",
    "commandCenter.split.out": "Sortie",
    "commandCenter.split.in": "Entrée",
    "commandCenter.preparing": "en préparation",
    "commandCenter.jobsWithoutMachine": "en cours sans machine",
    "commandCenter.needsAttention": "Nécessite Votre Attention",
    "commandCenter.allClear": "Tout est en ordre — rien ne nécessite d'attention pour le moment.",
    "commandCenter.stockAtGlance": "Stock en Un Coup d'Œil",
    "commandCenter.product": "Produit",
    "commandCenter.site": "Site",
    "commandCenter.origin": "Origine",
    "commandCenter.quality": "Qualité",
    "commandCenter.dims": "Dimensions",
    "commandCenter.available": "Disponible",
    "commandCenter.round": "Rond",
    "commandCenter.viewAllGroups": "Voir tous les groupes",
    "commandCenter.sortNewest": "Plus récents",
    "commandCenter.sortMostStock": "Plus de stock",
    "commandCenter.sortAz": "A–Z",
    "commandCenter.added": "Ajouté",
    "commandCenter.showLess": "Afficher moins",
    "commandCenter.rangeOf": "sur",
    "commandCenter.conversionYield": "Rendement par essence",
    "commandCenter.avgOutturn": "Rendement moyen",
    "commandCenter.netVolume": "Volume net des ordres de sciage",
    "commandCenter.reconciliationStatus": "Statut de Réconciliation",
    "commandCenter.total": "Total",
    "commandCenter.reconciled": "Réconcilié",
    "commandCenter.pending": "En attente",
    "commandCenter.locked": "Verrouillé",
    "commandCenter.siteUtilisation": "Utilisation du Site",
    "commandCenter.floorNow": "Sur l'atelier maintenant",
    "commandCenter.operator": "Opérateur",
    "commandCenter.machine": "Machine",
    "commandCenter.location": "Emplacement",
    "commandCenter.started": "Démarré",
    "commandCenter.status": "Statut",
    "commandCenter.noActiveRuns": "Aucun ordre de sciage actif pour l'instant.",
    "commandCenter.toCollect": "À encaisser",
    "commandCenter.toPay": "À payer",
    "commandCenter.overdueToCollect": "En retard à encaisser",
    "commandCenter.overdueToPay": "En retard à payer",
    "commandCenter.overdueToCollectByAge": "En retard à encaisser par ancienneté",
    "commandCenter.invoices": "factures",
    "commandCenter.inTotal": "au total",
    "commandCenter.received": "Reçu",
    "commandCenter.paidOut": "Payé",
    "commandCenter.futureDated": "La date de ce paiement est dans le futur — vérifiez-la",
    "commandCenter.futureDatedShort": "date future",
    "commandCenter.last30Days": "(30 derniers jours)",
    "commandCenter.attn.overdueCollectOne": "1 facture à encaisser est en retard",
    "commandCenter.attn.overdueCollectMany": "{n} factures à encaisser sont en retard",
    "commandCenter.attn.atRisk": "{amount} {cur} à risque",
    "commandCenter.attn.overduePayOne": "1 facture que vous devez est échue",
    "commandCenter.attn.overduePayMany": "{n} factures que vous devez sont échues",
    "commandCenter.attn.toPaySub": "{amount} {cur} à payer",
    "commandCenter.attn.pendingReconOne": "1 unité de stock en attente de réconciliation",
    "commandCenter.attn.pendingReconMany": "{n} unités de stock en attente de réconciliation",
    "commandCenter.attn.netDiscrepancy": "{v} CBM d'écart net",
    "commandCenter.attn.tallySyncOne": "1 correction de relevé attend votre décision",
    "commandCenter.attn.tallySyncMany": "{n} corrections de relevé attendent votre décision",
    "commandCenter.attn.tallySyncSub": "Le stock n'a pas été modifié automatiquement — à revoir dans Inventaire → Entrées et sorties",
    "tallySync.title": "Corrections de relevé en attente",
    "tallySync.subtitle": "Un relevé a été modifié après la réception de ce stock. Le stock n'a PAS été modifié automatiquement.",
    "tallySync.change": "Le relevé a changé le stock de",
    "tallySync.reasonNegative": "Le lot passerait sous zéro, et votre entreprise n'autorise pas la vente au-delà du stock disponible (Paramètres → Politique d'inventaire).",
    "tallySync.reasonReconLocked": "La réconciliation est déjà verrouillée : les chiffres d'arrivée (destination) font foi pour le stock.",
    "tallySync.reasonShipped": "Cette Stock Unit a déjà été expédiée.",
    "tallySync.reasonOther": "Une personne doit décider.",
    "tallySync.apply": "Appliquer au stock",
    "tallySync.dismiss": "Ignorer",
    "tallySync.appliedToast": "Stock mis à jour",
    "tallySync.dismissedToast": "Correction de relevé ignorée — stock inchangé",
    "tallySync.actionFailed": "Action impossible",
    "tallySync.noPermission": "Vous n'avez pas l'autorisation de modifier le stock.",
    "commandCenter.attn.siteFull": "{name} est à {pct}% de sa capacité",
    "commandCenter.attn.siteSub": "{cur} sur {cap} CBM",
    "commandCenter.attn.departingOne": "1 expédition part cette semaine",
    "commandCenter.attn.departingMany": "{n} expéditions partent cette semaine",
    "commandCenter.attn.soonest": "Au plus tôt : {date}",
    "commandCenter.money.atSavedRates": "Aux taux de change enregistrés",
    "commandCenter.money.partial": "Partiel",
    "commandCenter.money.partialTip": "Certains montants n'ont pas de taux de change et ne sont pas inclus dans ce total",
    "commandCenter.money.noRate": "sans taux",
    "commandCenter.money.noRateCountOne": "1 expédition sans taux de change — hors des totaux",
    "commandCenter.money.noRateCountMany": "{n} expéditions sans taux de change — hors des totaux",
    "commandCenter.money.addRate": "Ajouter le taux",
    "commandCenter.money.unmatchedOne": "1 paiement dans une autre devise sans taux — non compté",
    "commandCenter.money.unmatchedMany": "{n} paiements dans une autre devise sans taux — non comptés",
    "commandCenter.money.net": "Position nette",
    "commandCenter.money.inFavour": "en votre faveur",
    "commandCenter.money.youOweMore": "vous devez plus",
    "commandCenter.money.overdueByAge": "Retards par ancienneté",
    "commandCenter.money.nothingOverdue": "Rien en retard",
    "commandCenter.money.overdueOne": "{amount} en retard · 1 facture",
    "commandCenter.money.overdueMany": "{amount} en retard · {n} factures",
    "commandCenter.money.invoiceOne": "1 facture",
    "commandCenter.money.invoiceMany": "{n} factures",
    "commandCenter.money.dueToday": "Échéance aujourd'hui",
    "commandCenter.money.dueTomorrow": "Demain",
    "commandCenter.money.inDays": "dans {n} jours",
    "commandCenter.money.lateOne": "1 jour de retard",
    "commandCenter.money.lateMany": "{n} jours de retard",
    "commandCenter.notAssigned": "Non attribué",
    "commandCenter.notStarted": "Pas commencé",
    "commandCenter.waiting": "En attente depuis",
    "commandCenter.days": "jours",
    "commandCenter.openJob": "Ouvrir le travail",
    "commandCenter.moneyToday": "Finances Aujourd'hui",
    "commandCenter.totalReceivable": "Total à recevoir",
    "commandCenter.totalPayable": "Total à payer",
    "commandCenter.overdue": "En retard",
    "commandCenter.overdueCount": "Factures en retard",
    "commandCenter.recentPayments": "Paiements récents",
    "commandCenter.noRecentPayments": "Aucun paiement récent.",
    "commandCenter.dueSoon": "Échéance proche",
    "commandCenter.noDueSoon": "Rien à échéance proche.",
    "commandCenter.consignmentRadar": "7 prochains jours",
    "commandCenter.recentActivity": "Envois récents",
    "commandCenter.tradeMix": "Répartition Commerciale",
    "quickSearch.ai.toggle": "Demander à l'IA",
    "quickSearch.ai.toggleTooltip": "Plan Forest — comprend des formulations plus floues que la recherche normale, consomme des crédits IA à chaque utilisation",
    "quickSearch.ai.ask": "Demander à l'IA",
    "quickSearch.ai.creditsUsedThisCall": "Crédits utilisés",
    "quickSearch.ai.used": "de vos crédits IA utilisés",
    "quickSearch.ai.outOfCredits": "Crédits IA épuisés pour cette période. La recherche normale fonctionne toujours sans coût de crédit.",
    "quickSearch.ai.rateLimited": "Limite quotidienne d'utilisation de l'IA atteinte. Réessayez demain, ou utilisez la recherche normale.",
    "quickSearch.ai.forestOnly": "Demander à l'IA est disponible avec le plan Forest. La recherche normale fonctionne toujours.",
    "quickSearch.ai.genericError": "L'IA n'a pas pu répondre — essayez la recherche normale.",
    "invProc.machineLabel": "Machine (optionnel)",
    "invProc.machinePlaceholder": "Sélectionner une machine",
    "operator.name": "Nom",
    "operator.employeeCode": "Code Employé",
    "operator.expertise": "Expertise",
    "operator.hireDate": "Date d'Embauche",
    "operator.active": "Actif",
    "operator.inactive": "Inactif",
    "operator.runsCompleted": "Ordres de sciage terminés",
    "operator.avgOutturn": "Rendement Moyen",
    "operator.bestOutturn": "Meilleur Rendement",
    "operator.searchPlaceholder": "Rechercher des opérateurs...",
    "operator.allExpertise": "Toute Expertise",
    "operator.allStatus": "Tout Statut",
    "operator.statTotal": "Total",
    "operator.operatorSingular": "opérateur",
    "operator.operatorPlural": "opérateurs",
    "operator.viewPerformance": "Voir la Performance",
    "operator.performance": "Performance",
    "operator.deactivate": "Désactiver",
    "operator.noOperatorsFound": "Aucun opérateur trouvé",
    "operator.noOperatorsSub": "Ajustez les filtres ou ajoutez votre premier opérateur de scierie pour commencer.",
    "operator.editOperator": "Modifier l'opérateur",
    "operator.reactivate": "Réactiver",
    "operator.currentlyAssigned": "Actuellement assigné",
    "operator.pending": "En attente",
    "operator.noTasks": "Aucune tâche",
    "operator.viewFullHistory": "Voir l'historique complet",
    "operator.fullHistory": "Historique complet",
    "operator.taskCode": "Tâche",
    "operator.materials": "Matériaux",
    "operator.processingDate": "Date de l'ordre de sciage",
    "operator.outturn": "Rendement",
    "common.from": "De",
    "common.to": "À",
    // -- Lot card detail keys
    "lot.noOpenLots": "Aucun lot de stock ouvert. Cliquez sur Recevoir pour ajouter du stock.",
    "lot.showMore": "Afficher plus",
    "lot.showLess": "Afficher moins",
    "lot.availableCbm": "disponible",
    "lot.seeDeliveries": "Voir les livraisons",
    "lot.seeConsignments": "Voir les consignations",
    "lot.otherDeliveries": "Autres livraisons",
    "lot.whereFrom": "Voir d'où provient ce lot",
    "lot.madeAtMill": "Fabriqué au moulin",
    "lot.purchasedFrom": "Acheté auprès de",
    "lot.category.millOutput": "Produit par la scierie",
    "lot.category.openingStock": "Stock de Départ",
    "lot.category.notLinked": "Aucun Achat Enregistré",
    "lot.category.partiallyLinked": "Partiellement Lié",
    "lot.category.linked": "Lié à un Achat",
    "lot.millActivity.queued": "En attente à la scierie",
    "lot.millActivity.running": "À la scierie en ce moment",
    "lot.millActivity.paused": "En Pause",
    "lot.millActivity.partiallyMilled": "Partiellement Scié",
    "lot.cancelledAttemptsNote": "Ce lot a eu {count} tentative(s) de sciage annulée(s).",
    "lot.viewCancelledAttempt": "Voir",
    "lot.filter.all": "Tous",
    "lot.filter.attention": "Nécessite une Attention",
    "lot.filter.atMill": "À la scierie",
    "lot.filter.fromMill": "Produit par la scierie",
    "lot.filter.finished": "Épuisé",
    "lot.status.open": "Ouvert",
    "lot.status.depleted": "Épuisé",
    "lot.status.closed": "Fermé",
    "lot.status.empty": "Vide",
    "lot.status.help": "Ouvert — stock utilisable · Vide — encore ouvert mais plus rien dedans · Épuisé — tout le stock utilisé (scié ou vendu) · Fermé — fermé à la main, plus d'activité",
    "lot.sort.label": "Trier",
    "lot.sort.newest": "Plus Récent d'Abord",
    "lot.sort.oldest": "Plus Ancien d'Abord",
    "lot.sort.name": "Nom A-Z",
    "lot.sort.amountDesc": "Plus de Stock d'Abord",
    "lot.sort.amountAsc": "Moins de Stock d'Abord",
    "lot.category.notLinkedHelp": "La livraison de ce lot n'est liée à aucun achat enregistré. C'est normal pour une collecte locale enregistrée sans bon de commande formel — mais vérifiez le champ Consignation de la livraison si vous attendiez un lien.",
    "lot.category.partiallyLinkedHelp": "Certaines livraisons de ce lot sont liées à un achat, mais au moins une ne l'est pas.",
    "inv.millWarningHeader": "Vérifiez Avant de Commencer",
    "mpc.title": "Vérifier avant de commencer",
    "mpc.checking": "Vérification…",
    "mpc.notReconciled": "n'est pas encore rapprochée.",
    "mpc.diff": "Le comptage au déchargement indique",
    "mpc.noCount": "Le comptage au déchargement n'est pas encore saisi.",
    "mpc.alreadyConfirmed": "— scier sans rapprochement a déjà été confirmé.",
    "mpc.closedWithoutCount": "a été clôturée sans comptage au déchargement — ce qui est arrivé n'a jamais été vérifié.",
    "mpc.reconcileNow": "Rapprocher maintenant",
    "mpc.afterStart": "Une fois le travail de scierie commencé, l'écart pourra seulement être enregistré — le stock se corrige ensuite par un ajustement.",
    "mpc.typeConfirm": "Tapez CONFIRM pour commencer sans rapprochement",
    "mpc.confirmHint": "Un seul mot — les espaces aux extrémités sont acceptés.",
    "mpc.confirmOk": "Confirmé — vous pouvez continuer.",
    "recon.afterMill.title": "Cette unité de stock n'a pas été rapprochée avant le sciage.",
    "recon.afterMill.titleSold": "Cette unité de stock n'a pas été rapprochée avant la vente du stock.",
    "recon.afterMill.cantApply": "a déjà utilisé ce stock, un rapprochement ici ne change donc plus le stock. Pour rectifier, corrigez le stock par un ajustement :",
    "recon.afterMill.pooledNote": "Astuce : des travaux de scierie ou des ventes antérieurs ont déjà utilisé du bois jusqu’à ce Stock Unit, votre comptage est donc seulement enregistré. Corrigez toute différence avec un ajustement.",
    "inv.smartSearch.label": "Rechercher",
    "legal.agree.prefix": "J'accepte les",
    "legal.agree.terms": "Conditions d'utilisation",
    "legal.agree.and": "et la",
    "legal.agree.privacy": "Politique de confidentialité",
    "legal.agree.required": "Cochez « J’accepte » pour continuer.",
    "inv.smartSearch.openStatement": "Ouvrir le relevé complet de",
    "recon.afterMill.noCount": "Aucun comptage au déchargement n'a été saisi — tapez l'écart constaté dans l'ajustement.",
    "recon.afterMill.step1": "Enregistrez ce qui est arrivé : saisissez le comptage au déchargement ci-dessous et verrouillez comme d'habitude. Les données fournisseur et les rapports restent justes.",
    "recon.afterMill.step2": "Corrigez le stock : après le verrouillage, utilisez « Corriger par un ajustement » — il s’ouvre déjà rempli.",
    "recon.afterMill.recorded": "Écart enregistré :",
    "recon.afterMill.correctBtn": "Corriger par un ajustement",
    "recon.afterMill.askAdjust": "Demandez à une personne ayant le droit d'ajuster de corriger le stock.",
    "recon.afterMill.lockRecordsOnly": "ce verrouillage enregistre seulement ; corrigez le stock ensuite par un ajustement.",
    "adj.negative.title": "Cela fait passer le lot sous zéro",
    "adj.negative.typeConfirm": "Tapez CONFIRM pour enregistrer quand même",
    "inv.millWarningNotLinked": "Le lot {lotCode} n'a aucun achat enregistré lié. Vous pouvez quand même démarrer l'ordre de sciage — liez-le d'abord à un achat si vous avez l'information.",
    "inv.millWarningPartial": "Certaines livraisons du lot {lotCode} ne sont pas liées à un achat enregistré. Vous pouvez quand même démarrer l'ordre de sciage.",
    "inv.millWarningContinue": "Continuer Quand Même",
    "inventory.receiveNotLinkedWarning": "Cette livraison n'est pas encore liée à un achat enregistré (Consignation).",
    "lot.unitNumber": "N° Conteneur/Camion/Train",
    "origin.cameFrom": "Provenance",
    "origin.stockUnitsWord": "Unités de stock",
    "origin.blsWord": "BL",
    "origin.order": "Commande",
    "origin.via": "via",
    "origin.noStockUnit": "Aucune unité de stock — stock initial",
    "origin.returned": "Marchandise retournée — aucune unité de stock",
    "lot.loading": "Chargement...",
    "lot.searchPlaceholder": "Rechercher par ID",
    "lot.searchIncludeClosed": "Rechercher aussi les lots épuisés",
    "lot.searchResultSingular": "lot trouvé",
    "lot.searchResultPlural": "lots trouvés",
    "lot.receivedCbm": "Reçu",
    "lot.purchasedCbm": "contracté",
    "lot.daysOld": "jours",
    "lot.procurementOutturn": "rendement d'achat",
    "lot.openingBalance": "Solde initial",
    "lot.openingBalanceNote": "Stock antérieur — sans historique d'achat",
    // -- Receive wizard
    "receive.wizard.title": "Stock Arrivé",
    "receive.wizard.editTitle": "Modifier le Lot de Stock",
    "receive.step1.title": "Qu'est arrivé et d'où?",
    "receive.step2.title": "Quelle quantité est arrivée?",
    "receive.step3.title": "Combien avez-vous reçu?",
    "receive.step4.title": "Confirmer la réception",
    "receive.selectSite": "Sélectionner le site de stockage",
    "receive.selectSupplier": "Sélectionner le fournisseur",
    "receive.quantity": "CBM Reçu",
    "receive.pieces": "Nombre de pièces",
    "receive.purchaseDate": "Date d'achat",
    "receive.confirmed": "Enregistrer l'Entrée",
    "receive.moreDetails": "Ajouter détails d'achat (optionnel)",
    "receive.isOpeningBalance": "C'est un stock antérieur (solde initial)",
    // -- Dispatch wizard
    "dispatch.wizard.title": "Envoyer le Stock",
    "dispatch.step1.title": "Quel stock part?",
    "dispatch.step2.title": "Où va-t-il?",
    "dispatch.step3.title": "Détails de l'expédition",
    "dispatch.step4.title": "Confirmer l'expédition",
    "dispatch.counterparty": "Client / destination",
    "dispatch.reference": "Facture / numéro de référence",
    "dispatch.confirmed": "Confirmer la Sortie",
    "dispatch.destination": "Destinataire (acheteur / destination)",
    "dispatch.linkTrade": "Lier au Dossier Commercial / Consignation (optionnel)",
    "dispatch.invoiceRef": "Référence facture / commande (optionnel)",
    "dispatch.actingAs": "Expédition en tant que",
    "dispatch.actingNow": "maintenant",
    "dispatch.shipment": "Lier à la Consignation",
    "dispatch.shipment.placeholder": "Sélectionner la consignation (optionnel)",
    "dispatch.stepSplit.title": "Confirmer la répartition du stock",
    "dispatch.stepSplit.hint": "Stock le plus ancien en premier — vous pouvez ajuster la répartition ci-dessous.",
    "dispatch.filters.toggle": "Filtres (optionnel)",
    "dispatch.filters.product": "Produit",
    "dispatch.filters.widthIn": "Largeur (po)",
    "dispatch.filters.thicknessIn": "Épaisseur (po)",
    "dispatch.filters.origin": "Origine",
    "dispatch.filters.quality": "Qualité",
    "dispatch.roundLogs": "Grumes rondes",
    "dispatch.unsorted": "Non trié",
    "dispatch.qtyPlaceholder": "Quantité",
    "dispatch.noStock": "Aucun stock correspondant trouvé.",
    "dispatch.itemsAdded": "Articles ajoutés",
    "dispatch.shortfall": "Manque",
    "dispatch.shortfallSuffix": "— ajoutez plus de lots ou réduisez la quantité",
    "receive.origin": "Origine (pays)",
    "receive.originPlaceholder": "ex. Ghana, Brésil",
    "receive.quality": "Qualité / grade",
    "receive.salePrice": "Prix de vente",
    "receive.size": "Taille (Largeur × Épaisseur × Longueur)",
    "receive.lengthOpenEnded": "pas de max",
    "receive.lengthOpenEndedHint": "Laissez la seconde longueur vide pour une fin ouverte (ex. \"7ft+\").",
    "tally.qualityForTu": "Qualité — toutes les grumes de cette unité de stock",
    "tally.qualityPerRow": "Par ligne (définir individuellement)",
    "tally.qualityForTuHint": "Laissez vide pour définir la qualité ligne par ligne dans la grille.",
    "tally.qualityForTuHintRound": "S'applique à toutes les grumes de cette unité de stock.",
    "tally.qualityNone": "Aucune qualité définie",
    "tally.qualityNoneShort": "Aucune",
    "tally.qualityEnableLabel": "Activer la Qualité pour cette unité de stock",
    "tally.qualityDisabledHint": "Le suivi de la qualité est désactivé pour cette unité de stock. Les données de qualité existantes sont conservées et réapparaîtront si vous réactivez cette option.",
    "tally.qualityDisableConfirmTitle": "Désactiver la Qualité ?",
    "tally.qualityDisableConfirmBodyPrefix": "Cela effacera définitivement le grade de Qualité de",
    "tally.qualityDisableConfirmBodySuffix": "ligne(s) dans cette unité de stock. Cette action est irréversible.",
    "tally.qualityDisableConfirmInputLabel": "Tapez CONFIRM pour continuer",
    "tally.qualityDisableConfirmButton": "Désactiver et effacer la Qualité",
    "tally.qualityDisableCancelButton": "Annuler",
    "tally.qualityDisabledToastTitle": "Qualité désactivée",
    "tally.qualityDisabledToastDetail": "Le suivi de la qualité a été désactivé et effacé pour cette unité de stock.",
    "tally.qualityDisableFailed": "Échec de la désactivation de la Qualité. Veuillez réessayer.",
    "tally.saveNow": "Enregistrer maintenant",
    "tally.settingsSaving": "Enregistrement…",
    "tally.settingsSaved": "Enregistré",
    "tally.settingsSaveFailedRetry": "Échec de l'enregistrement — appuyez pour réessayer",
    "tally.settingsAutoSaveFailed": "Impossible d'enregistrer vos modifications. Vérifiez votre connexion et réessayez.",
    "quality.renameGrades": "Renommer les grades",
    "quality.renameGradesTitle": "Libellés des Grades de Qualité",
    "quality.renameGradesHint": "Ces noms apparaissent partout où la qualité est affichée — les entrées existantes se mettent à jour automatiquement.",
    "chain.viewChain": "Voir la Chaîne du Lot",
    "trace.fullTrace": "Traçabilité Complète",
    "statement.title": "Relevé de Stock",
    "statement.subtitle": "Preuve de ce qui est entré, parti en scierie, vendu et encore en stock",
    "statement.openStatement": "Relevé de Stock",
    "statement.unit": "Unité de volume",
    "statement.exportPdf": "PDF",
    "statement.exportExcel": "Excel",
    "statement.searchPlaceholder": "Unité de stock, n° de conteneur / camion, lot, ordre de sciage ou BL",
    "statement.suggest.recent": "Récents",
    "statement.suggest.stockUnits": "Unités de stock",
    "statement.suggest.batches": "Lots",
    "statement.suggest.millJobs": "Travaux de scierie",
    "statement.suggest.consignments": "Envois (BL)",
    "statement.suggest.none": "Aucun résultat - essayez une unité de stock, n° de conteneur / camion, lot, ordre de sciage ou BL",
    "statement.show": "Afficher le relevé",
    "statement.emptyTitle": "Prouvez n'importe quel stock en un seul endroit",
    "statement.emptyText": "Saisissez une unité de stock, un conteneur, un lot, un travail de scierie ou un BL. Vous obtenez le bilan, la perte en scierie, chaque écriture et la concordance avec les lots.",
    "statement.notFound": "Rien trouvé pour ce code",
    "statement.notFoundHint": "Vérifiez l'orthographe ou essayez l'ID de l'unité, le conteneur, LOT-…, PR-… ou le BL.",
    "statement.generated": "Généré le",
    "statement.balanced": "Équilibré",
    "statement.balancedSub": "Chaque lot correspond à son registre et entrées = sorties",
    "statement.difference": "Écart trouvé",
    "statement.differenceSub": "Un lot ne correspond pas à son registre — voir le lot en rouge",
    "statement.balanceSheet": "Bilan",
    "statement.inSide": "Entrées",
    "statement.outSide": "Sorties et reste",
    "statement.totalIn": "Total entrées",
    "statement.totalOut": "Total sorties et reste",
    "statement.opening": "Stock initial",
    "statement.received": "Reçu",
    "statement.producedOutside": "Produit d'autres lots",
    "statement.adjustedNet": "Ajustements (net)",
    "statement.allowanceNet": "Déduction (circonférence et longueur)",
    "statement.story": "Ce qui s'est passé, étape par étape",
    "statement.storySub": "Par ordre de date, en mots simples",
    "statement.step.startingStock": "Stock de départ",
    "statement.step.cameIn": "Entré",
    "statement.step.allowance": "Déduction retirée (écorce et coupe)",
    "statement.step.sentToMill": "Envoyé à la scierie",
    "statement.step.millMade": "La scierie a produit",
    "statement.step.sold": "Vendu et sorti",
    "statement.step.correction": "Correction",
    "statement.step.heldForSale": "Réservé pour une vente — pas encore sorti",
    "statement.step.heldForJob": "Réservé pour un travail de scierie — pas encore commencé",
    "statement.step.stillInStock": "Encore en stock",
    "statement.storyMillSentence": "La scierie a utilisé {in} et produit {out}. {loss} était sciure et chutes ({pct}%).",
    "statement.storyNothingSold": "Rien n'a encore été vendu.",
    "statement.storyHeldSentence": "{pieces} pièces sont réservées pour {code} et quitteront le stock une fois cette vente confirmée.",
    "statement.storySoldSentence": "{cbm} est parti chez des clients.",
    "statement.allowance": "Déduction",
    "statement.allowanceHint": "Écorce et coupe déduites des billes mesurées — mesure brute moins mesure nette.",
    "statement.kind.ALLOWANCE": "Déduction",
    "statement.sold": "Vendu / expédié",
    "statement.sentToMillOutside": "Envoyé en scierie (sortie hors de ce relevé)",
    "statement.sentToMillShort": "Envoyé en scierie",
    "statement.wastage": "Perte en scierie",
    "statement.closing": "Encore en stock",
    "statement.held": "Réservé",
    "statement.free": "Libre",
    "statement.heldPartOf": "sur",
    "statement.heldRestOther": "le reste sur d'autres Lots",
    "stockInHand.title": "Stock disponible",
    "stockInHand.subtitle": "Ce qui est vraiment en stock maintenant — réservé et libre, par produit et taille",
    "stockInHand.inStock": "En stock",
    "stockInHand.held": "Réservé",
    "stockInHand.free": "Libre",
    "stockInHand.overHeld": "Surréservé",
    "stockInHand.overHeldHint": "Certaines sorties de stock ou travaux de scierie retiennent plus de bois que le lot n’en contient. Ouvrez les anciens brouillons et libérez-les ou terminez-les.",
    "stockInHand.negativeStock": "Stock négatif",
    "stockInHand.negativeStockHint": "Un comptage ou une vente a retiré plus que le lot ne contenait, son solde est donc inférieur à zéro. Ouvrez le lot et corrigez-le avec un ajustement (ajoutez ce qui manque).",
    "stockInHand.explain": "En stock = Réservé + Libre. Réservé est gardé pour les Sorties de stock et ordres de sciage ouverts ; Libre peut encore être vendu ou scié. Volume net.",
    "stockInHand.searchPlaceholder": "Chercher produit, taille (4x3x6), origine, site ou Lot",
    "stockInHand.rows": "lignes",
    "stockInHand.groupBy": "Grouper par produit",
    "stockInHand.expandAll": "Tout déplier",
    "stockInHand.collapseAll": "Tout replier",
    "stockInHand.sizeOne": "taille",
    "stockInHand.sizeMany": "tailles",
    "stockInHand.sortBy": "Trier",
    "stockInHand.sortDefault": "Ordre par défaut",
    "stockInHand.sortFree": "Libre : du plus au moins",
    "stockInHand.sortIn": "En stock : du plus au moins",
    "stockInHand.sortSize": "Taille",
    "stockInHand.sortProduct": "Produit A–Z",
    "stockInHand.searchShort": "Chercher produit ou taille",
    "stockInHand.howCounted": "Comment est-ce compté ?",
    "stockInHand.hideHow": "Masquer",
    "stockInHand.splitTitle": "Réservé vs libre",
    "stockInHand.product": "Produit",
    "stockInHand.size": "Taille",
    "stockInHand.site": "Site",
    "stockInHand.lot": "Lot",
    "stockInHand.lots": "Lots",
    "stockInHand.round": "Grumes rondes",
    "stockInHand.tipIn": "Tout le bois physiquement présent, réservé ou non.",
    "stockInHand.tipHeld": "Partie du stock gardée pour les Sorties de stock et ordres de sciage ouverts. Elle reste à vous et peut encore être vendue ou sciée.",
    "stockInHand.tipFree": "En stock moins Réservé : ce qui est disponible maintenant pour une nouvelle vente ou un ordre de sciage.",
    "stockInHand.roundPcs": "Ronde",
    "stockInHand.squarePcs": "Carrée",
    "stockInHand.logsUnit": "grumes",
    "stockInHand.openStatement": "Relevé de stock",
    "stockInHand.holdsTitle": "Retenu par des Sorties de Stock ouvertes",
    "stockInHand.holdsHint": "Bois promis à des Sorties de Stock non encore confirmées. Libérez celles oubliées pour libérer le bois.",
    "stockInHand.holdsShowAll": "Tout afficher",
    "stockInHand.holdsShowFewer": "Afficher moins",
    "stockInHand.idleToday": "Inactif aujourd’hui",
    "stockInHand.idleDays": "Inactif depuis {n} j",
    "stockInHand.release": "Libérer",
    "stockInHand.releaseSure": "Libérer ses réservations ?",
    "stockInHand.releaseYes": "Oui, libérer",
    "stockInHand.released": "Réservations libérées — elles reviennent quand quelqu’un ouvre ou enregistre cette Sortie.",
    "stockInHand.releaseFailed": "Impossible de libérer — réessayez.",
    "stockInHand.openUnit": "Ouvrir cette Sortie de Stock",
    "stockInHand.empty": "Pas encore de stock",
    "stockInHand.noMatch": "Rien ne correspond à cette recherche",
    "stockInHand.failed": "Impossible de charger le stock",
    "stockInHand.footnote": "Les lignes montrent les tailles avec du stock libre. Réservé par ligne = Sorties de stock ouvertes à cette taille ; les réservations d'ordres de sciage sont déjà retirées du Libre et comptées dans le total Réservé en haut.",
    "statement.whereItWent": "Où est allé le stock",
    "statement.millJobs": "Travaux de scierie",
    "statement.outturn": "Rendement",
    "statement.input": "Entrée",
    "statement.output": "Sortie",
    "statement.jobPartial": "Un seul côté de ce travail figure dans ce relevé, sa perte n'est donc pas comptée ici.",
    "statement.batches": "Lots",
    "statement.producedBy": "Produit par",
    "statement.fromBatch": "depuis",
    "statement.matchesRecord": "Conforme",
    "statement.differenceShort": "Écart",
    "statement.negativeStock": "Stock négatif",
    "statement.negativeStockTooltip": "Le stock de ce lot est en dessous de zéro — une correction (Rapprochement ou Ajustement) a probablement été saisie sans tenir compte du stock déjà envoyé au moulin ou vendu. Veuillez vérifier.",
    "statement.produced": "Produit",
    "statement.milled": "En scierie",
    "statement.adjusted": "Ajusté",
    "statement.pcs": "pcs",
    "statement.batchRecord": "Registre du lot",
    "statement.differenceBy": "écart",
    "statement.notInStockTitle": "Pas en stock actuellement",
    "statement.notInStockLeft": "Sorti du stock par des Stock Outs confirmés :",
    "statement.notInStockNone": "Aucun lot n'en contient actuellement et aucun Stock Out confirmé n'a été trouvé.",
    "statement.diffPanelTitle": "Où, combien et pourquoi",
    "statement.diffPanelWhyBtn": "Pourquoi ? Que faire ?",
    "statement.diffPanelHide": "Masquer",
    "statement.diffPanelRecord": "Enregistrement du lot",
    "statement.diffPanelMoves": "les mouvements totalisent",
    "statement.diffPanelWhyLabel": "Pourquoi :",
    "statement.diffPanelWhy": "Le nombre enregistré du lot et le total de ses mouvements ont été modifiés séparément — par exemple une modification faite hors des écrans normaux, ou un mouvement non enregistré.",
    "statement.diffPanelDoLabel": "Que faire :",
    "statement.diffPanelDo": "Ouvrez le lot et vérifiez ses mouvements. Corrigez avec Add Adjustment pour que l'enregistrement et l'historique concordent de nouveau. Ne modifiez pas le nombre directement.",
    "statement.heldForSale": "Réservé vente",
    "statement.heldForJob": "Réservé scierie",
    "statement.showEntries": "Afficher les écritures",
    "statement.hideEntries": "Masquer les écritures",
    "statement.when": "Date et heure",
    "statement.entry": "Écriture",
    "statement.reference": "Référence",
    "statement.partner": "Partenaire",
    "statement.noEntries": "Aucune écriture.",
    "statement.timeline": "Chronologie",
    "statement.proof": "Établi à partir des écritures :",
    "statement.netVolume": "volumes nets",
    "statement.piecesIndicative": "certaines écritures n'ont pas de pièces, les totaux de pièces sont indicatifs",
    "statement.type.STOCK_UNIT": "Unité de stock",
    "statement.type.BATCH": "Lot",
    "statement.type.MILL_JOB": "Ordre de sciage",
    "statement.type.CONSIGNMENT": "Expédition",
    "statement.kind.OPENING": "Stock initial",
    "statement.kind.RECEIVED": "Reçu",
    "statement.kind.PRODUCED": "Produit en scierie",
    "statement.kind.MILLED": "Envoyé en scierie",
    "statement.kind.SOLD": "Vendu / expédié",
    "statement.kind.ADJUSTED": "Ajusté",
    "statement.kind.RECONCILED": "Rapproché",
    "statement.kind.ASSIGNED": "Ajouté à l'expédition",
    "statement.kind.OTHER": "Autre",
    "statement.modeItem": "Un élément",
    "statement.modeFilter": "Filtrer le stock",
    "statement.filterProduct": "Produit",
    "statement.filterOrigin": "Origine",
    "statement.filterSite": "Site",
    "statement.filterQuality": "Qualité",
    "statement.filterSize": "Dimension (toute unité)",
    "statement.sizePlaceholder": "3x2x8 ft · 76 x 50 mm · girth 90cm x 8m",
    "statement.sizeInvalid": "Dimension non comprise — essayez 3x2x8 ft, 76 x 50 mm ou girth 90cm",
    "statement.filterFrom": "Du",
    "statement.filterTo": "Au",
    "statement.filterHint": "Laissez vide pour tout. Sans dates = du début à maintenant.",
    "statement.any": "Tous",
    "statement.clear": "Effacer",
    "statement.emptyFilterText": "Choisissez des filtres et appuyez sur Afficher le relevé — ou sans filtre pour tout le stock.",
    "statement.noResults": "Aucun stock ne correspond à ces filtres",
    "statement.noResultsHint": "Retirez un filtre ou élargissez les dates.",
    "statement.type.FILTER": "Stock filtré",
    "statement.periodStatement": "Relevé de période",
    "statement.periodStatementSub": "Soldes à la date de fin ; entrées = sorties",
    "statement.groups": "Groupes de stock",
    "statement.group": "Produit · origine · site",
    "statement.batchesLower": "lots",
    "statement.inShort": "Entrée",
    "statement.sizeNow": "Cette dimension maintenant",
    "statement.total": "Total",
    "statement.inventoryReportLink": "Relevé de Stock",
    "trace.seeWhereFrom": "Voir d'où cela provient",
    "trace.rel.includesStockUnit": "Inclut l'Unité de Stock",
    "trace.rel.linkedToConsignment": "Lié à l'Expédition",
    "trace.rel.receivedInto": "Reçu dans",
    "trace.rel.dispatchedFrom": "Expédié depuis",
    "trace.rel.fedAsInput": "Fourni en entrée à",
    "trace.rel.drewStockFrom": "A prélevé du stock sur",
    "trace.rel.receivedIntoLot": "Reçu dans ce Lot",
    "trace.rel.producedByJob": "Produit par le Travail de Scierie",
    "trace.rel.milledInto": "Scié en",
    "trace.rel.soldVia": "Vendu via",
    "trace.rel.sentOutUnlinked": "Envoyé (non lié)",
    "trace.rel.fedFromLot": "Vient du Lot",
    "trace.rel.fedFromUnit": "Vient de l'Unité de Stock",
    "trace.rel.mainOutput": "Sortie principale",
    "trace.rel.byproduct": "Sortie de sous-produit",
    "trace.date.created": "Créé",
    "trace.date.shipped": "Expédié",
    "trace.date.purchased": "Acheté",
    "trace.date.produced": "Produit",
    "trace.date.completed": "Terminé",
    "trace.date.started": "Démarré",
    "trace.date.scheduled": "Planifié",
    "trace.date.openingStock": "Stock d'ouverture",
    "trace.story.showMore": "Afficher plus",
    "trace.story.sharesNote": "Cette répartition est un calcul (stock le plus ancien d'abord), pas un fait enregistré.",
    "trace.share.adjustment": "Bois issu d'un ajustement",
    "trace.share.hand": "Lot saisi à la main",
    "trace.label.printAll": "Imprimer les étiquettes de toutes les Unités de Stock",
    "trace.label.popup": "Autorisez les fenêtres pop-up pour imprimer les étiquettes.",
    "trace.unlinked.one": "Pas encore lié à une vente",
    "trace.unlinked.many": "{n} expéditions pas encore liées à une vente",
    "trace.search.placeholder": "Cherchez un conteneur, BL, Unité de Stock, Lot ou Travail de Scierie…",
    "trace.search.none": "Aucun résultat",
    "trace.search.hintTitle": "Tracez n'importe quel numéro",
    "trace.search.hintSub": "Saisissez ci-dessus un numéro de conteneur, BL, Unité de Stock, Lot ou Travail de Scierie pour voir toute son histoire.",
    "trace.view.story": "Histoire",
    "trace.view.graph": "Graphique",
    "trace.story.cameFrom": "D'où cela vient",
    "trace.story.wentTo": "Où cela est allé",
    "trace.story.nothingBefore": "Rien avant. L'histoire commence ici.",
    "trace.story.nothingAfter": "Rien après pour l'instant.",
    "trace.story.truncated": "Chaîne très longue : seules les étapes les plus proches sont affichées. Ouvrez une étape pour aller plus loin.",
    "trace.story.madeFrom": "Fait à partir de",
    "trace.story.couldNot": "Impossible de charger l'histoire. Veuillez réessayer.",
    "trace.kind.stockUnit": "Unité de Stock",
    "trace.kind.lot": "Lot",
    "trace.kind.millJob": "Travail de Scierie",
    "trace.kind.consignment": "Expédition",
    "trace.kind.sentOut": "Expédié",
    "trace.label.print": "Imprimer l'étiquette",
    "trace.label.title": "Étiquette de l'Unité de Stock",
    "trace.label.printBtn": "Imprimer",
    "trace.label.scan": "Scannez pour voir toute l'histoire de ce bois",
    "trace.label.scanSub": "D'où il vient, ce que la scierie en a fait, et où il est allé.",
    "trace.couldNotLoad": "Impossible de charger cette traçabilité",
    "trace.pickAncestorTitle": "Lequel ?",
    "trace.pickAncestorHint": "Cela provient de plusieurs achats — choisissez-en un à explorer.",
    "trace.history": "Historique",
    "trace.noHistory": "Aucun historique enregistré pour le moment",
    "trace.consignment": "Consignation",
    "trace.viewConsignment": "Voir la Consignation",
    "trace.viewDispatches": "Voir les expéditions",
    "trace.quickView": "Aperçu rapide",
    "trace.loadingTrace": "Chargement...",
    "trace.zoomIn": "Zoom avant",
    "trace.zoomOut": "Zoom arrière",
    "trace.zoomReset": "Réinitialiser le zoom",
    "trace.viewLot": "Voir le Lot",
    "trace.viewRun": "Voir l'ordre de sciage",
    "lot.lotCode": "Code du Lot",
    "lot.quality": "Qualité",
    "lot.received": "Reçu",
    "lot.currentStock": "Stock Actuel",
    "lot.supplier": "Fournisseur",
    "lot.purchasePrice": "Prix d'Achat",
    "lot.purchaseDate": "Date d'Achat",
    "processing.millSite": "Site de la Scierie",
    "processing.machine": "Machine",
    "processing.operator": "Opérateur",
    "processing.input": "Entrée",
    "processing.output": "Sortie",
    "processing.outturn": "Rendement",
    "chain.sourceLot": "Lot Source",
    "chain.rootLot": "Origine Réelle",
    "chain.earlierLot": "Lot Antérieur",
    "chain.thisLot": "Ce Lot",
    "chain.outputLot": "Lot de Sortie",
    "chain.recovery": "récupération",
    "chain.received": "reçu",
    "chain.remaining": "disponible",
    "chain.dispatches": "Expédié",
    "chain.directDispatch": "Expédition Directe",
    "chain.noChain": "Aucun lien amont ou aval pour ce lot pour l'instant.",
    "chain.finished": "Terminé",
    "inventory.viewTask": "Voir la Tâche",
    "inventory.created": "Créé",
    "inventory.lastUpdated": "Dernière Mise à Jour",
    "inventory.by": "par",
    "inventory.viewOrder": "Voir la Commande",
    "inventory.viewInTallysheet": "Voir dans la Feuille de Comptage",
    "user.invite": "Invite Utilisateur",
    "user.sendInvite": "Send Invite",
    "user.teamMembers": "Team Members",
    "user.accessRights": "Accès Rights",
    "user.deactivateTooltip": "Deactivate — blocks login, data preserved",
    "user.reactivateTooltip": "Reactivate — restore login access",
    "user.resendInvitation": "Resend invitation",
    "user.expired": "Expired",
    "user.declined": "Refusé",
    "user.declinedTooltip": "L'invité a refusé cette invitation dans l'application — le lien par e-mail reste valide s'il change d'avis",
    "user.membershipBasedTooltip": "Membre via l'accès multi-entreprise — son propre compte se trouve ailleurs. Vous pouvez retirer son appartenance à cette entreprise, mais son compte est géré de son côté.",
    "user.removeFromCompany": "Retirer de l'entreprise",
    "user.confirmRemoveMemberTitle": "Retirer le membre",
    "user.confirmRemoveMemberMessage": "{{email}} perdra l'accès à cette entreprise. Son propre compte et les autres entreprises auxquelles il appartient ne sont pas affectés.",
    "user.memberRemovedTitle": "Membre retiré",
    "user.memberRemovedMessage": "{{email}} n'a plus accès à cette entreprise.",
    "user.memberRemoveFailedMessage": "Échec du retrait du membre.",
    "user.removeAdminBtn": "Retirer Admin",
    "user.confirmMakeAdminTitle": "Nommer Admin",
    "user.confirmMakeAdminMessage": "{{email}} aura un accès administrateur complet à cette entreprise, y compris la gestion des utilisateurs. Vous pourrez le retirer plus tard.",
    "user.madeAdminTitle": "Admin ajouté",
    "user.madeAdminMessage": "{{email}} est maintenant admin.",
    "user.makeAdminFailedMessage": "Impossible de nommer cet utilisateur admin.",
    "user.confirmRemoveAdminTitle": "Retirer Admin",
    "user.confirmRemoveAdminMessage": "{{email}} restera dans l'entreprise comme membre ordinaire mais perdra l'accès administrateur.",
    "user.removedAdminTitle": "Admin retiré",
    "user.removedAdminMessage": "{{email}} est maintenant un membre ordinaire.",
    "user.removeAdminFailedMessage": "Impossible de retirer les droits d'admin.",
    "user.emailAddresses": "Email Addresses",
    "user.roleTemplate": "Rôle Template",
    "user.roleTemplatePlaceholder": "Sélectionner un modèle de rôle",
    "user.inviteDialogHeader": "Invite Utilisateur",
    "user.upgradeToAdd": "Utilisateur limit reached — upgrade your plan",
    "plan.featureNotAvailable": "Cette fonctionnalité n'est pas disponible sur votre abonnement actuel.",
    "plan.availableOnGroveAndAbove": "Disponible sur Tree et supérieur. Mettez à niveau pour déverrouiller.",
    "plan.upgradeNow": "Mettre à niveau",
    "auth.sendResetLink": "Send Reset Link",
    "auth.backToLogin": "Back to Login",
    "auth.resetPassword": "Reset Password",
    "auth.createMyAccount": "Créer My Account",
    "auth.iAcceptClose": "I Accept & Close",
    "auth.tryDifferentEmail": "Try a different email",
    "auth.sessionExpired": "Session Expired",
    "auth.sessionExpiredMessage": "Votre session a été fermée pour des raisons de sécurité. Veuillez vous reconnecter pour continuer là où vous vous étiez arrêté.",
    "auth.confirmLogout": "Confirm Logout",
    "auth.logoutConfirmMessage": "Are you sure you want to logout?",
    "auth.logoutSuccess": "Logout Successful",
    "auth.logoutSuccessMsg": "You have been successfully logged out.",
    "auth.logoutFailed": "Logout failed",
    "auth.logoutFailedMsg": "Erreur while logging out",
    "confirmLogoutDevices.header": "Déjà connecté ailleurs",
    "confirmLogoutDevices.questionWithDevice": "Se déconnecter de cet appareil et continuer la connexion ici ?",
    "confirmLogoutDevices.messageGeneric": "S'en déconnecter et continuer la connexion ici ?",
    "confirmLogoutDevices.openApp": "Ouvrir LumberLinq",
    "confirmLogoutDevices.openAppTitle": "Vous êtes connecté",
    "confirmLogoutDevices.openAppHint": "Touchez le bouton pour revenir à l'application.",
    "confirmLogoutDevices.messageWithDevicePrefix": "Vous êtes actuellement connecté sur ",
    "confirmLogoutDevices.messageWithDeviceNear": " près de ",
    "confirmLogoutDevices.messageWithDeviceSuffix": ". Voulez-vous vraiment vous déconnecter de cet appareil et vous connecter ici à la place ?",
    "confirmLogoutDevices.acceptLabel": "Annuler",
    "confirmLogoutDevices.rejectLabel": "Se déconnecter et continuer",
    "forcedLogout.header": "Déconnecté",
    "forcedLogout.bodyGeneric": "Vous avez été déconnecté car votre compte s'est connecté depuis un autre appareil.",
    "forcedLogout.explanation": "Cette session a été déconnectée car votre compte vient de se connecter depuis un autre appareil :",
    "forcedLogout.goToLogin": "Aller à la connexion",
    "layout.copyCompanyId": "Copy Entreprise ID",
    "layout.productTour": "Produit Tour",
    "siteDocs.uploadDialogHeader": "Upload Documents",
    "siteDocs.upload": "Importer",
    "siteDocs.downloadFile": "Download File",
    "siteDocs.changeCategory": "Cliquez to change category",
    "rbac.enableAcl": "Enable Accès Control",
    "rbac.disableAcl": "Disable Accès Control",
    "rbac.title": "Accès Control",
    "rbac.subtitle": "Control exactly what each user can see and do in LumberLinq.",
    "rbac.perUserStatus": "Per-Utilisateur Accès Control is",
    "rbac.enabled": "ENABLED",
    "rbac.disabled": "DISABLED",
    "rbac.disabledDesc": "When disabled, all users have full access to everything. Enable to assign granular permissions per person.",
    "rbac.enabledDesc": "Active — permissions are enforced in real time. Revoking a permission takes effect on the user's next API call.",
    "rbac.userPermissions": "Utilisateur Permissions",
    "rbac.configureHint": "Cliquez the configure button to assign or revoke permissions for each user.",
    "rbac.permissions": "Permissions",
    "rbac.lastModified": "Last Modified",
    "rbac.noPermissions": "No permissions — user cannot access anything",
    "rbac.noUsers": "No non-admin users found.",
    "rbac.notActiveTitle": "Accès Control is not active",
    "rbac.notActiveDesc": "When enabled, you can assign exactly which features each user can access.",
    "rbac.notActiveDesc2": "Existing behaviour is fully preserved until you enable this.",
    "rbac.disableFullAccess": "All users will immediately regain full access to everything.",
    "rbac.disablePreserved": "Your existing permission configurations are preserved — they will reactivate automatically if you re-enable Accès Control.",
    "rbac.configureTooltip": "Assign / revoke permissions",
    "onboarding.welcome": "Welcome to Lumberlinq",
    "admin.packages": "Packages",
    "admin.subscriptionPackages": "Subscription Packages",
    "admin.packageListSubtitle": "Gérer plans, pricing and feature sets visible to customers",
    "admin.totalPlans": "Total Plans",
    "admin.trialPlans": "Trial Plans",
    "admin.featured": "Featured",
    "admin.trial": "Essai",
    "admin.mostPopular": "Most Popular",
    "admin.perMonth": "/mo",
    "admin.free": "Free",
    "admin.dayTrialSuffix": "d trial",
    "admin.features": "features",
    "admin.extendable": "Extendable",
    "admin.noPackagesYet": "No packages yet",
    "admin.createFirstSubscriptionPackage": "Créer your first subscription package to get started.",
    "admin.coupons": "Coupons",
    "admin.taxConfig": "Tax Config",
    "admin.companySupport": "Entreprise Support",
    "admin.tickets": "Tickets",
    "admin.appSettings": "Paramètres App",
    "admin.dashboard": "Admin Dashboard",
    "admin.newPackage": "New Forfait",
    "admin.savePackage": "Enregistrer Forfait",
    "admin.createPackage": "Créer Forfait",
    "admin.editPackage": "Modifier Forfait",
    "admin.deactivate": "Deactivate",
    "admin.activate": "Activate",
    "admin.addFeature": "Ajouter Feature",
    "admin.newCoupon": "New Coupon",
    "admin.saveCoupon": "Enregistrer Coupon",
    "admin.newTaxRule": "New Tax Rule",
    "admin.addFirstRule": "Ajouter First Rule",
    "admin.extendSubscription": "Extend Subscription",
    "admin.extend": "Extend",
    "admin.suspend": "Suspend",
    "admin.reactivate": "Reactivate",
    "admin.printReport": "Print Rapport",
    "admin.support": "Support",
    "admin.resolveAll": "Resolve All",
    "admin.closeAll": "Close All",
    "admin.assignAll": "Assign All",
    "admin.inProgress": "En cours",
    "admin.awaitingUser": "Awaiting Utilisateur",
    "admin.resolve": "Resolve",
    "admin.saveChanges": "Enregistrer Changes",
    "admin.resetFilters": "Reset filters",
    "admin.clearSelection": "Clear selection",
    "admin.openSupportDashboard": "Open Support Dashboard",
    "admin.hideFromListings": "Hide from subscription listings",
    "admin.makeVisible": "Make visible again",
    "admin.overview": "Overview",
    "admin.ticketDetails": "Ticket Détails",
    "admin.companyContext": "Entreprise Context",
    "admin.activityTrail": "Activity Trail",
    "admin.valueExtracted": "Value Extracted in This Period",
    "admin.featureUsageBreakdown": "Feature Usage Breakdown",
    "admin.salesNarrative": "Sales Narrative",
    "admin.loginTrend": "Login Trend (Weekly)",
    "admin.extendSubscriptionDialog": "Extend Subscription",
    "admin.editPackageTooltip": "Modifier package details, pricing and features",
    "admin.autoGenerateKey": "Auto-generate key from name",
    "admin.inactivePackagesTooltip": "Inactive packages are hidden from the public pricing page",
    "admin.trialPackagesTooltip": "Trial packages are free and time-limited. The pricing section is hidden for trial plans.",
    "admin.removeAttachment": "Remove attachment",
    "admin.suspendAccount": "Suspend Account",
    "admin.reactivateAccount": "Reactivate Account",
    "admin.unitLabelTooltip": "Unit label shown next to the number (e.g. GB, users, tallies). Leave blank for boolean features.",
    "admin.allowTrialExtension": "Allow super-admins to extend the trial for individual companies",
    "admin.maxTrialExtensions": "Maximum number of times the trial can be extended per company",
    "admin.descriptionTooltip": "Optional rich text description. Rendered as HTML inside the plan card. Leave blank if not needed.",
    "admin.trialNoPricing": "Trial plans have no pricing",
    "admin.discountedPriceTooltip": "The discounted price customers actually pay per month in INR",
    "admin.originalPriceTooltip": "The original price shown with a strikethrough to show savings",
    "admin.discountedMonthlyUsd": "Discounted monthly price in USD",
    "admin.totalYearlyUsd": "Total yearly price at a discount in USD",
    "admin.displayOrder": "Display order on pricing card",
    "admin.editFeature": "Modifier feature",
    "admin.deleteFeature": "Supprimer feature",
    "fieldAccess.resetTooltip": "Réinitialiser tout aux valeurs par défaut",
    "fieldAccess.resetLabel": "Réinitialiser par défaut",
    "fieldAccess.confirmResetTitle": "Réinitialiser aux valeurs par défaut de LumberLinq ?",
    "fieldAccess.confirmResetMessage": "Cela supprimera tous vos réglages personnalisés d'accès Public, Protégé et Privé pour chaque champ et restaurera la configuration par défaut de LumberLinq. Cette action est irréversible.",
    "appUsage.planSubscription": "Forfait & Subscription",
    "appUsage.title": "App Usage Rapport",
    "appUsage.desc": "Live view of your feature usage vs. plan limits. Upgrade before you hit a ceiling.",
    "appUsage.failedToLoad": "Failed to load usage data.",
    "appUsage.validTill": "Valid Till",
    "appUsage.timeRemaining": "Time Remaining",
    "appUsage.nearLimit": "Near Limit",
    "appUsage.featureUsage": "Feature Usage",
    "appUsage.aiCredits": "AI Import Credits",
    "appUsage.aiCreditsOf": "of",
    "appUsage.aiCreditsPageCredits": "page credits",
    "appUsage.featureAccess": "Feature Accès",
    "appUsage.active": "Actif",
    "appUsage.inactive": "Inactif",
    "appUsage.expiredOn": "Expiré le",
    "report.users.title": "Utilisateurs Rapport",
    "report.users.subtitle": "All users registered under your organisation",
    "report.users.admins": "Admins",
    "report.users.role": "Rôle",
    "report.users.type": "Type",
    "report.users.timezone": "Fuseau horaire",
    "report.users.joined": "Joined",
    "report.users.noUsersFound": "No users found",
    "tallysheet.searchProduct": "Rechercher Produit",
    "tallysheet.searchLoadingSite": "Rechercher un Site",
    "tallysheet.tuIdRequired": "Transport ID est obligatoire.",
    "tallysheet.tuIdDuplicate": "This Transport ID already exists.",
    "tallysheet.tuMinLength": "Minimum 5 characters.",
    "tallysheet.productRequired": "Produit est obligatoire.",
    "tallysheet.modeRequired": "Mode est obligatoire.",
    "tallysheet.containerNumRequired": "Conteneur Number est obligatoire.",
    "tallysheet.vehicleNumRequired": "Véhicule Number est obligatoire.",
    "tallysheet.driverNameRequired": "Driver Name est obligatoire.",
    "tallysheet.expectedDeliveryRequired": "Expected Delivery est obligatoire.",
    "tallysheet.expectedArrivalRequired": "Expected Arrival est obligatoire.",
    "tallysheet.expectedPickupRequired": "Expected Pickup Time est obligatoire.",
    "tallysheet.pickupLocRequired": "Pickup Emplacement est obligatoire.",
    "tallysheet.carNumRequired": "Car Number est obligatoire.",
    "menu.usersReport": "Utilisateurs Rapport",
    "menu.inventoryReport": "Inventaire Rapport",
    "loadingSite.subtitle": "Voir et gérer les profils de sites existants",
    "invReport.available": "Disponible",
    "invReport.openLots": "Lots Ouverts (Disponible)",
    "invReport.lots": "lots",
    "invReport.reserved": "réservé",
    "invReport.inProcessing": "En ordre de sciage",
    "invReport.inShipment": "En consignation",
    "invReport.shippedMonth": "Shipped (Mois)",
    "invReport.cbmThisMonth": "CBM this month",
    "invReport.stockByStage": "Stock by Stage",
    "invReport.movementsByType": "Movements by Type",
    "invReport.stockBySite": "Stock by Site",
    "invReport.movementLog": "Movement Log",
    "invReport.adjustments": "Adjustments",
    "invReport.processingRuns": "Ordres de sciage",
    "invReport.filterByType": "Filter by type",
    "invReport.colType": "Type",
    "invReport.colTransportUnit": "Unité de Stock",
    "invReport.colSite": "Site",
    "invReport.colReference": "Reference",
    "invReport.colPartner": "Partenaire",
    "invReport.colDate": "Date",
    "invReport.colRunCode": "ID de l'ordre de sciage",
    "invReport.colMillSite": "Mill Site",
    "invReport.colInputCbm": "Input CBM",
    "invReport.colOutputCbm": "Output CBM",
    "invReport.colLossCbm": "Loss CBM",
    "invReport.colOutturn": "Outturn %",
    "invReport.colCbmDelta": "CBM Δ",
    "invReport.colPcsDelta": "Pcs Δ",
    "invReport.colNotes": "Notes",
    "invReport.noMovements": "No movements found for the selected filters.",
    "invReport.noProcessingRuns": "Aucun ordre de sciage trouvé.",
    "invReport.adjustmentsInfo": "Adjustments are manual CBM/piece corrections applied to existing inventory enregistrements. Showing adjustments within the selected date range.",
    "invReport.noAdjustments": "No adjustments recorded in this period.",
    "invReport.noStageData": "No stage data",
    "invReport.noMovementsRange": "No movements in range",
    "invReport.noSiteStockData": "No site stock data",
    "invReport.pendingCustomMadeTooltip": "Unités de stock en attente d'une demande Custom-Made / re-sciage",
    "business.activateDeactivate": "Activate / Deactivate Commercial Partenaire",
    "business.partnerActiveHint": "Partenaire is active and visible in transactions",
    "business.partnerInactiveHint": "Partenaire is inactive and hidden from new transactions",
    "business.contactInfo": "Contact Information",
    "business.addressSection": "Adresse",
    "business.attachments": "Attachments",
    "business.dropFiles": "Drop files here or click to browse",
    "business.saveFirst": "Enregistrer the partner first to attach files",
    "business.maxPerFile": "per file",
    "business.removeAccount": "Remove account",
    "business.ifscSwift": "IFSC / SWIFT",
    "business.noBankAccounts": "No bank accounts added yet. Cliquez to add one.",
    "business.backToList": "Back to list",
    "business.minCharsRequired": "Min 2 characters required.",
    "business.validGstin": "Enter a valid GSTIN.",
    "business.taxIdMin3Chars": "L'identifiant fiscal doit comporter au moins 3 caractères.",
    "business.gstin": "GSTIN",
    "business.quickAdd": "Ajouter un nouveau partenaire commercial",
    "business.quickAddTitle": "Nouveau Partenaire Commercial",
    "business.quickAddedDetail": "Partenaire commercial créé et sélectionné.",
    "business.quickAddError": "Impossible de créer le partenaire commercial. Veuillez réessayer.",
    "business.uploadedFiles": "Fichiers téléchargés",
    "business.validEmail": "Valid email required.",
    "business.countryRequired": "Pays est obligatoire.",
    "business.selectCountryFirst": "Sélectionner country first",
    "business.selectStateFirst": "Sélectionner state first",
    "common.max": "Max",
    "common.min": "Min",
    "common.company": "Entreprise",
    "chart.histogram": "Histogram",
    "chart.scatter": "Scatter",
    "chart.line": "Line",
    "cookie.reject": "Refuser Non Essentiels",
    "cookie.manage": "Gérer",
    "cookie.acceptAll": "Tout Accepter",
    "cookie.savePreferences": "Enregistrer préférences",
    "cookie.preferences": "Préférences Cookies et Confidentialité",
    "cookie.title": "Nous utilisons des cookies 🍪",
    "cookie.desc": "Nous utilisons des cookies pour maintenir votre connexion et améliorer votre expérience. Les cookies analytiques nécessitent votre consentement.",
    "cookie.gdprNote": "Conformément au RGPD, nous ne déposons des cookies non essentiels qu'avec votre consentement.",
    "cookie.titleApp": "Nous utilisons des analyses 📊",
    "cookie.descApp": "Cette application utilise des analyses pour maintenir votre connexion et améliorer votre expérience. Les analyses nécessitent votre consentement.",
    "cookie.gdprNoteApp": "Conformément au RGPD, nous n'activons les analyses qu'avec votre consentement.",
    "cookie.privacyLink": "Politique de Confidentialité",
    "cookie.essential": "Essentiels (Toujours Actifs)",
    "cookie.essentialDesc": "Nécessaires pour la connexion et la sécurité de session. Rétention: session + 7 jours. Ne peut pas être désactivé.",
    "cookie.alwaysOn": "Toujours Actif",
    "cookie.functional": "Fonctionnels",
    "cookie.functionalDesc": "Mémorisent la langue, le thème et la taille de police. Rétention: 1 an. Ne peut pas être désactivé.",
    "cookie.analytics": "Analytiques (Google Analytics)",
    "cookie.analyticsDesc": "Nous utilisons Google Analytics (GA4) pour comprendre l'utilisation des fonctionnalités. Google peut collecter votre adresse IP, votre localisation approximative (niveau ville) et le type d'appareil. Traité par Google LLC selon leur Politique de Confidentialité. Aucune donnée personnelle n'est vendue. Rétention: 90 jours.",
    "cookie.dataController": "Responsable du traitement: Rikexim Private Limited · Sous-traitant: Google LLC (Google Analytics)",
    "common.termsConditions": "Terms & Conditions",
    "common.acceptContinue": "Accept & Continue",
    "tallysheet.insights": "Feuille de cubage Insights",
    "tallysheet.totalVolume": "Total Volume",
    "tallysheet.avgVolume": "Moyenne Volume",
    "tallysheet.activeFilter": "Active Filter",
    "tallysheet.clearFilter": "Clear Filter",
    "tallysheet.totalCft": "Total CFT",
    "tallysheet.aggregated": "Aggregated",
    "tallysheet.mainVisualization": "Main Visualization",
    "tallysheet.girthVsVolume": "Girth vs Volume",
    "tallysheet.lengthDistribution": "Longueur Distribution",
    "tallysheet.girthHistogram": "Girth Histogram Table",
    "tallysheet.lengthHistogram": "Longueur Histogram Table",
    "tallysheet.metric": "Metric",
    "tallysheet.inProcessTooltip": "Ce stock est utilisé en ce moment par un ordre de sciage actif.",
    "tallysheet.notInStock": "Pas en Stock",
    "tallysheet.notInStockTooltip": "Cette unité de stock n'a pas encore été reçue dans l'inventaire.",
    "tallysheet.noSummary": "No Résumé Available",
    "tallysheet.addDataForInsights": "Ajouter tally data first to generate insights and visualizations.",
    "tallysheet.dynamicAnalytics": "Dynamic Analytics — Longueur · Girth · Volume",
    "tallysheet.exploreTrends": "Explore trends across",
    "tallysheet.optimizedRecords": "optimized enregistrements",
    "tallysheet.clickRangesToFilter": "Cliquez ranges to filter",
    "tallysheet.bins": "bins",
    "tallysheet.vehicleNumber": "Véhicule Number",
    "tallysheet.driverName": "Driver Name",
    "tallysheet.enterDriverName": "Enter Driver Name",
    "tallysheet.containerNumber": "Conteneur Number",
    "tallysheet.sealNumber": "Seal Number",
    "tallysheet.fumigationType": "Fumigation Type",
    "tallysheet.selectFumigationType": "Sélectionner un type de fumigation",
    "fumigation.methylBromide": "Methyl Bromide Fumigation",
    "fumigation.phosphine": "Phosphine Fumigation",
    "fumigation.sulfurylFluoride": "Sulfuryl Fluoride Fumigation",
    "fumigation.ethyleneOxide": "Ethylene Oxide Fumigation",
    "fumigation.heatTreatment": "Heat Treatment",
    "fumigation.controlledAtmosphere": "Controlled Atmosphere (CA) Fumigation",
    "fumigation.vacuum": "Vacuum Fumigation",
    "fumigation.other": "Autre",
    "tallysheet.carNumber": "Car Number",
    "tallysheet.railwayLine": "Railway Line",
    "tallysheet.selectDate": "Sélectionner Date",
    "tallysheet.selectDateTime": "Sélectionner Date & Time",
    "tallysheet.expectedArrival": "Expected Arrival",
    "tallysheet.pickupLocation": "Pickup Emplacement",
    "bp.buyer": "Buyer",
    "bp.seller": "Seller",
    "bp.both": "Both",
    "bp.company": "Entreprise",
    "bp.individual": "Individual",
    "bp.exporter": "Exporter",
    "bp.importer": "Importer",
    "bp.domestic": "Domestic",
    "bp.international": "International",
    "dash.domesticSale": "Domestic Sale",
    "loading-site.selectSiteType": "Sélectionner le type de site",
    "recon.locked": "Reconciliation Locked",
    "recon.lockedBy": "Reconciliation locked by",
    "fieldAccess.accessControl": "Accès Control",
    "fieldAccess.tallyTitle": "Accès aux Champs de l'Unité de Stock",
    "fieldAccess.shipmentTitle": "Consignation Field Accès",
    "fieldAccess.searchPlaceholder": "Rechercher fields…",
    "fieldAccess.pubLegend": "Toute personne avec le lien",
    "fieldAccess.proLegend": "Utilisateurs LumberLinq uniquement",
    "fieldAccess.priLegend": "Mon équipe uniquement",
    "fieldAccess.mode.PUBLIC": "Toute personne avec le lien",
    "fieldAccess.mode.PROTECTED": "Utilisateurs LumberLinq uniquement",
    "fieldAccess.mode.PRIVATE": "Mon équipe uniquement",
    "access.hint.PUBLIC": "Aucune connexion requise",
    "access.hint.PROTECTED": "Connecté à LumberLinq, toute entreprise",
    "access.hint.PRIVATE": "Uniquement les personnes de votre entreprise",
    "fieldAccess.privateAlways": "Votre entreprise — voit toujours tous les champs",
    "fieldAccess.hidden": "Hidden",
    "fieldAccess.view": "Voir",
    "fieldAccess.alwaysVisible": "Toujours visible",
    "fieldAccess.alwaysVisibleHint": "Cette colonne est toujours affichée sur les liens partagés. Elle ne peut pas être masquée.",
    "fieldAccess.history": "Historique",
    "fieldAccess.historyTitle": "Qui a changé quoi",
    "fieldAccess.historyEmpty": "Aucune modification enregistrée pour le moment.",
    "fieldAccess.historyFailed": "Impossible de charger l'historique.",
    "fieldAccess.historyWhen": "Quand",
    "fieldAccess.historyWho": "Qui",
    "fieldAccess.historyField": "Champ",
    "fieldAccess.historyMode": "Type de lien",
    "fieldAccess.historyChange": "Modification",
    "fieldAccess.historyReset": "Réinitialisé par défaut",
    "fieldAccess.historyNote": "Affiche les 200 dernières modifications. Les modifications antérieures à cette liste ne sont pas affichées.",
    "fieldAccess.preview": "Aperçu en tant que visiteur",
    "fieldAccess.previewTitle": "Ce que voit un visiteur",
    "fieldAccess.previewHint": "D'après les réglages de cet écran. Les champs barrés sont masqués pour ce type de visiteur.",
    "fieldAccess.previewVisibleCount": "champs visibles",
    "fieldAccess.previewSectionOff": "Toute cette section est désactivée.",
    "fieldAccess.presets": "Préréglages",
    "fieldAccess.presetsTitle": "Appliquer un préréglage",
    "fieldAccess.presetsLead": "Partez d'un ensemble prêt à l'emploi au lieu de modifier les champs un par un. Vous voyez ce qui change avant tout enregistrement. Les champs d'argent, de taxe et d'audit, ainsi que le fournisseur et l'acheteur, ne sont jamais activés par un préréglage.",
    "fieldAccess.presetMinimal": "Public (minimal)",
    "fieldAccess.presetMinimalHint": "Statut, itinéraire et quantités uniquement. Sans risque pour toute personne ayant le lien.",
    "fieldAccess.presetBuyer": "Acheteur",
    "fieldAccess.presetBuyerHint": "Ajoute les documents, parties et détails de transport dont un acheteur a besoin.",
    "fieldAccess.presetAgent": "Agent",
    "fieldAccess.presetAgentHint": "Ajoute contacts, lieux et détails du pointage pour un transitaire.",
    "fieldAccess.presetApplyTo": "Appliquer à",
    "fieldAccess.presetApply": "Appliquer le préréglage",
    "fieldAccess.presetNoChange": "Ce préréglage ne change rien pour le type de lien choisi.",
    "fieldAccess.presetWillShow": "{count} champ(s) seront affichés :",
    "fieldAccess.presetWillHide": "{count} champ(s) seront masqués :",
    "fieldAccess.presetPublicWarning": "Attention : {count} champ(s) deviendront visibles pour toute personne ayant le lien, sans connexion.",
    "fieldAccess.publicWarnTitle": "Afficher à tout le monde ?",
    "fieldAccess.publicWarnMessage": "Toute personne ayant le lien, sans se connecter, verra « {field} ». Continuer ?",
    "fieldAccess.publicWarnAccept": "Oui, afficher",
    "tallysheet.tu.hiddenDetails": "Certains détails ne sont pas partagés sur ce lien.",
    "tallysheet.exportDownloadOff": "Exporter (téléchargement désactivé)",
    "tallysheet.exportDownloadOffHint": "L'expéditeur n'a pas autorisé les téléchargements sur ce lien.",
    "sharePack.button": "Télécharger le pack",
    "sharePack.title": "Télécharger le pack",
    "sharePack.lead": "Tout ce que contient ce lien, dans un seul ZIP : PDF de synthèse, classeur Excel, documents et photos.",
    "sharePack.loading": "Vérification du contenu…",
    "sharePack.partSummary": "PDF de synthèse",
    "sharePack.partSummaryHint": "Un aperçu à lire et à imprimer",
    "sharePack.partWorkbook": "Classeur Excel",
    "sharePack.partWorkbookHint": "Tous les chiffres, prêts à filtrer",
    "sharePack.partDocuments": "Documents",
    "sharePack.partDocumentsHint": "{count} fichier(s) · {size}",
    "sharePack.partPhotos": "Photos",
    "sharePack.partPhotosHint": "{count} photo(s) · {size}",
    "sharePack.noneInside": "Il n'y a rien à télécharger sur ce lien.",
    "sharePack.snapshotNote": "Un instantané d'aujourd'hui. Les modifications ultérieures de l'expéditeur ne sont pas incluses.",
    "sharePack.stockUnits": "{count} unité(s) de stock",
    "sharePack.start": "Télécharger",
    "sharePack.preparing": "Préparation de votre pack. Un gros pack peut prendre une minute.",
    "sharePack.downloading": "Téléchargement {percent} %",
    "sharePack.done": "Votre pack a été téléchargé.",
    "sharePack.failed": "Le pack n'a pas pu être téléchargé.",
    "sharePack.busy": "Le serveur est occupé à créer d'autres packs. Réessayez dans une minute.",
    "sharePack.pickOne": "Choisissez au moins une partie.",
    "sharePack.close": "Fermer",
    "sharePack.reconciliationField": "Chiffres de rapprochement dans le pack (chargé vs reçu)",
    "fileCounts.ownTitle": "Documents de la consignation",
    "fileCounts.ofTypes": "{have} types sur {total}",
    "fileCounts.missing": "manquant",
    "fileCounts.unitsTitle": "Unités de stock ({count})",
    "fileCounts.photos": "photos",
    "fileCounts.files": "fichiers",
    "fileCounts.unitTitle": "Fichiers de cette unité de stock",
    "fileCounts.noFiles": "Aucun fichier pour le moment.",
    "fileCounts.tipOwn": "{count} fichier(s) de la consignation",
    "fileCounts.tipUnits": "Unités de stock : {photos} photo(s), {files} fichier(s)",
    "fileCounts.typeBL": "BL",
    "fileCounts.typeInvoice": "Facture",
    "fileCounts.typeCO": "Certificat d'origine",
    "fileCounts.typePhyto": "Phytosanitaire",
    "fileCounts.typeEWaybill": "E-Waybill",
    "fileCounts.typeOther": "Autre",
    "fieldAccess.viewOnly": "Voir Only",
    "fieldAccess.edit": "Modifier",
    "fieldAccess.editable": "Editable",
    "fieldAccess.loading": "Loading field configuration…",
    "fieldAccess.fields": "fields",
    "fieldAccess.stockUnitsNote": "Les détails de l'unité de stock sur un lien partagé se règlent dans l'accès aux champs de l'unité de stock, pas ici.",
    "fieldAccess.fieldColumn": "Field",
    "fieldAccess.noMatch": "No fields match your search.",
    "fieldAccess.group.transportUnit": "Unité de Stock",
    "fieldAccess.group.roundTallyGrid": "Round Cubage Grid",
    "fieldAccess.group.squareTallyGrid": "Square Cubage Grid",
    "fieldAccess.group.photosSummary": "Photos & Résumé",
    "fieldAccess.group.shipmentDetails": "Consignation Détails",
    "fieldAccess.group.documentDetails": "Document Détails",
    "fieldAccess.group.transportCargo": "Transport / Cargo",
    "fieldAccess.group.financials": "Financials",
    "fieldAccess.group.parties": "Parties",
    "fieldAccess.group.systemAudit": "System / Audit",
    "fieldAccess.field.transportId": "Transport ID",
    "fieldAccess.field.transportMode": "Transport Mode",
    "fieldAccess.field.unitVehicleNumber": "Unit / Véhicule Number",
    "fieldAccess.field.fumigation": "Fumigation",
    "fieldAccess.field.driver": "Driver",
    "fieldAccess.field.route": "Route",
    "fieldAccess.field.contactPerson": "Contact Person",
    "fieldAccess.field.expectedDelivery": "Expected Delivery / Pickup",
    "fieldAccess.field.sr": "Sr",
    "fieldAccess.field.length": "Longueur",
    "fieldAccess.field.girth": "Girth",
    "fieldAccess.field.lengthAllowance": "Longueur Allowance",
    "fieldAccess.field.girthAllowance": "Girth Allowance",
    "fieldAccess.field.netLength": "Net Longueur",
    "fieldAccess.field.netGirth": "Net Girth",
    "fieldAccess.field.grossCbm": "Gross CBM",
    "fieldAccess.field.grossCft": "Gross CFT",
    "fieldAccess.field.netCbm": "Net CBM",
    "fieldAccess.field.netCft": "Net CFT",
    "fieldAccess.field.width": "Largeur",
    "fieldAccess.field.thickness": "Thickness",
    "fieldAccess.field.pieces": "Pièces",
    "fieldAccess.field.widthAllowance": "Largeur Allowance",
    "fieldAccess.field.thicknessAllowance": "Thickness Allowance",
    "fieldAccess.field.netWidth": "Net Largeur",
    "fieldAccess.field.netThickness": "Net Thickness",
    "fieldAccess.field.photosDocuments": "Photos / Documents",
    "fieldAccess.field.summary": "Résumé",
    "fieldAccess.field.chartData": "Chart Data",
    "fieldAccess.field.lengthHistogram": "Longueur Histogram",
    "fieldAccess.field.girthHistogram": "Girth Histogram",
    "fieldAccess.field.sawnSquareSummary": "Sawn Square Résumé",
    "fieldAccess.field.modeOfTransportFmt": "Mode Of Transport",
    "fieldAccess.field.portOfLoadingFmt": "Port Of Loading",
    "fieldAccess.field.portOfDischargeFmt": "Port Of Discharge",
    "fieldAccess.field.blNumberFmt": "Bl Number",
    "fieldAccess.field.blType": "Bl Type",
    "fieldAccess.field.packingListNo": "Packing Liste No",
    "fieldAccess.field.commercialInvoiceNo": "Commercial Facture No",
    "fieldAccess.field.certificateOfOrigin": "Certificate Of Origin",
    "fieldAccess.field.fumigationCertificate": "Fumigation Certificate",
    "fieldAccess.field.insuranceDetails": "Insurance Détails",
    "fieldAccess.field.approvedBy": "Approuvé By",
    "fieldAccess.field.buyerTaxNumber": "Numéro fiscal de l’acheteur",
    "fieldAccess.field.createdBy": "Created By",
    "fieldAccess.field.deliveryContact": "Delivery Contact",
    "fieldAccess.field.transporterName": "Transporter Name",
    "fieldAccess.field.vehicleOrLrNo": "Véhicule or LR No.",
    "fieldAccess.field.transportUnitNumber": "Numéro de l'Unité de Stock",
    "fieldAccess.field.insuranceValue": "Valeur d’assurance",
    "fieldAccess.field.cargoType": "Cargo Type",
    "fieldAccess.field.grossWeight": "Gross Weight",
    "fieldAccess.field.netWeight": "Net Weight",
    "fieldAccess.field.transportUnits": "Unités de Stock",
    "fieldAccess.field.freightTerms": "Conditions de fret",
    "fieldAccess.field.totalInvoiceAmount": "Montant total de la facture",
    "fieldAccess.field.salesPaymentStatus": "Sales Paiement Statut",
    "fieldAccess.field.purchasePaymentStatus": "Purchase Paiement Statut",
    "fieldAccess.field.notifyParty": "Notify Party",
    "fieldAccess.field.exporterRefNo": "Exporter Ref No",
    "fieldAccess.field.buyerOrderNo": "Buyer Order No",
    "fieldAccess.field.countryOfOrigin": "Pays Of Origin",
    "fieldAccess.field.countryOfDestination": "Pays Of Destination",
    "fieldAccess.field.fromLocation": "From Emplacement",
    "fieldAccess.field.toLocation": "To Emplacement",
    "fieldAccess.field.remarks": "Remarks",
    "fieldAccess.field.vesselOrFlight": "Vessel Or Flight",
    "fieldAccess.field.voyageOrFlightNo": "Voyage Or Flight No",
    "fieldAccess.field.shippingLine": "Shipping Line",
    "user.member": "Member",
    "user.role": "Rôle",
    "user.login": "Login",
    "user.lastActive": "Last Active",
    "user.totalMembers": "Total Members",
    "user.pendingInvites": "En attente Invites",
    "user.pendingInvitations": "En attente Invitations",
    "user.invitedBy": "Invité par",
    "user.noTeamMembers": "No team members yet",
    "user.inviteToStart": "Cliquez Invite Utilisateur to get started.",
    "user.statusPending": "En attente",
    "user.expires": "Expires",
    "user.role.owner": "Propriétaire",
    "user.role.user": "Utilisateur",
    "user.role.fieldOperator": "Field Operator — Cubage add & view only",
    "user.role.supervisor": "Supervisor — Cubage + Consignations + Export",
    "user.role.analyst": "Analyst — Voir & export everything, no edits",
    "user.role.manager": "Manager — All features except user management",
    "user.role.custom": "Custom — No permissions (configure manually)",
    "user.selfDeleteTitle": "Supprimer Mon Compte",
    "user.selfDeleteSubtitle": "Supprimez définitivement votre compte personnel et toutes les données associées.",
    "user.selfDeleteWarning": "Cette action révoquera IMMÉDIATEMENT toutes vos sessions actives et supprimera définitivement votre compte.\n\n• Toutes les données que vous avez créées (tallies, consignations, unités de stock) resteront dans le système.\n• Après 30 jours, vos informations personnelles (nom, e-mail, téléphone) seront anonymisées et ne pourront pas être récupérées.\n• Cette action NE PEUT PAS être annulée.",
    "user.selfDeleteEmailConfirm": "Saisissez votre adresse e-mail pour confirmer",
    "user.selfDeleteEmailPlaceholder": "Saisissez votre e-mail pour confirmer",
    "user.selfDeleteButton": "Supprimer Mon Compte",
    "user.selfDeleteSuccess": "Votre compte a été supprimé. Vous avez été déconnecté.",
    "user.selfDeleteFailed": "Impossible de supprimer votre compte. Veuillez réessayer.",
    "user.soleAdminWarningTitle": "Vous êtes le seul administrateur",
    "user.soleAdminWarningBody": "La suppression de votre compte fermera définitivement l'espace de travail de votre entreprise. Tous les utilisateurs seront immédiatement déconnectés.",
    "user.soleAdminAffectedLabel": "Utilisateurs qui perdront l'accès",
    "user.soleAdminReassignHint": "Recommandé : attribuez les droits d'administrateur à un autre utilisateur avant de supprimer votre compte.",
    "user.soleAdminReassignButton": "Attribuer un admin d'abord",
    "user.soleAdminDeleteAnyway": "Supprimer quand même et fermer",
    "user.soleAdminShutdownWarning": "Cela déconnectera immédiatement tous les utilisateurs de l'entreprise.",
    "user.soleAdminShutdownSuccess": "Votre compte a été supprimé. Tous les utilisateurs de l'entreprise ont été déconnectés.",
    "user.assignAdminStepTitle": "Attribuer un Nouvel Admin",
    "user.assignAdminSubtitle": "Sélectionnez un membre de l'équipe pour devenir administrateur avant de partir.",
    "user.makeAdminBtn": "Nommer Admin",
    "user.adminAssignedSuccess": "Droits d'admin transférés. Vous pouvez maintenant supprimer votre compte.",
    "user.continueToDelete": "Continuer vers la Suppression",
    "user.shutdownConsentLabel": "Je comprends que tous les utilisateurs seront immédiatement déconnectés, l'espace de travail sera fermé et l'abonnement expirera.",
    "user.deleteAndShutdown": "Supprimer et Fermer l'Entreprise",
    "user.noOtherUsers": "Il n'y a pas d'autres utilisateurs actifs à qui attribuer les droits d'admin.",
    "user.promotingAdmin": "Attribution de l'admin…",
    "user.notificationPreferencesTitle": "Préférences de notification",
    "user.marketingPushOptInLabel": "Notifications marketing",
    "user.marketingPushOptInDescription": "Recevez des notifications sur les nouvelles fonctionnalités et offres.",
    "user.dangerZoneTitle": "Zone de danger",
    "user.dangerZoneSubtitle": "Actions irréversibles et destructives.",
    "shipment.shipmentType": "Consignation Type",
    "shipment.modeOfTransport": "Mode of Transport",
    "shipment.shipmentDate": "Consignation Date",
    "shipment.finalDestination": "Final Destination",
    "shipment.estimatedDeparture": "Estimated Departure",
    "shipment.estimatedArrival": "Estimated Arrival",
    "shipment.partiesReferences": "Parties &amp; References",
    "shipment.documentNumbers": "Document Numbers",
    "shipment.invoicePayments": "Facture et paiements",
    "shipment.auditStatus": "Audit &amp; Statut",
    "shipment.goodsDispatchLocal": "Goods / Dispatch (Local)",
    "shipment.shipmentTypeRequired": "Consignation Type est obligatoire",
    "shipment.modeOfTransportRequired": "Mode of Transport est obligatoire",
    "shipment.estimatedDepartureRequired": "Estimated Departure est obligatoire",
    "shipment.otherDocuments": "Other Documents",
    "transport.group.regularSizedCargo": "Regular Sized Cargo",
    "transport.group.reeferContainer": "Reefer Conteneur",
    "transport.group.oddSizedContainer": "Odd Sized Conteneur",
    "transport.group.truck": "Truck",
    "transport.group.trailer": "Trailer",
    "transport.group.train": "Train",
    "transport.group.other": "Autre",
    "transport.item.20DryStandard": "20 Dry Standard",
    "transport.item.40DryStandard": "40 Dry Standard",
    "transport.item.40DryHigh": "40 Dry High",
    "transport.item.45DryHigh": "45 Dry High",
    "transport.item.20Tank": "20 Tank",
    "transport.item.40Tank": "40 Tank",
    "transport.item.20ReeferStandard": "20 Reefer Standard",
    "transport.item.40ReeferHigh": "40 Reefer High",
    "transport.item.20OpenTop": "20 Open Top",
    "transport.item.40OpenTop": "40 Open Top",
    "transport.item.40OpenTopHigh": "40 Open Top High",
    "transport.item.40FlatStandard": "40 Flat Standard",
    "transport.item.40FlatHigh": "40 Flat High",
    "transport.item.20Flat": "20 Flat",
    "transport.item.smallTruck": "Small Truck",
    "transport.item.mediumTruck": "Medium Truck",
    "transport.item.largeTruck": "Large Truck",
    "transport.item.articulatedTruck": "Articulated Truck",
    "transport.item.flatbedTrailer": "Flatbed Trailer",
    "transport.item.dryVanTrailer": "Dry Van Trailer",
    "transport.item.reeferTrailer": "Reefer Trailer",
    "transport.item.lowboyTrailer": "Lowboy Trailer",
    "transport.item.tankerTrailer": "Tanker Trailer",
    "transport.item.boxcar": "Boxcar",
    "transport.item.flatcar": "Flatcar",
    "transport.item.tankCar": "Tank Car",
    "transport.item.reeferCar": "Reefer Car",
    "transport.item.hopperCar": "Hopper Car",
    "transport.item.selfPickup": "Self Pickup",
    "BOTH": "BOTH",
    "COMPANY": "COMPANY",
    "Invoice Details": "Détails de la facture",
    "Freight Terms": "Conditions de fret",
    "Payment Terms": "Conditions de paiement",
    "Customer Payment Terms": "Conditions de paiement client",
    "Supplier Payment Terms": "Conditions de paiement fournisseur",
    "Select terms...": "Sélectionner les conditions...",
    "Save the shipment first to record payments and payment terms.": "Enregistrer the consignment first to record payments and payment terms.",
    "At least one of Shipper, Consignee or Notify Party must be your company. Based on shipment type, your company may be auto-filled and locked.": "At least one of Shipper, Consignee or Notify Party must be your company. Based on consignment type, your company may be auto-filled and locked.",
    "Manage shipment details, parties, documents &amp; financials": "Gérer consignment details, parties, documents &amp; financials",
    "Financials &amp; Payments": "Finances et paiements",
    "Invoice &amp; Payments": "Facture et paiements",
    "Immediate / Advance": "Immédiat / avance",
    "Cash on Delivery (COD)": "Paiement à la livraison (COD)",
    "L/C – Sight": "L/C – à vue",
    "L/C – Usance (days)": "L/C – usance (jours)",
    "DP – Documents against Payment (days)": "DP – documents contre paiement (jours)",
    "DA – Documents against Acceptance (days)": "DA – documents contre acceptation (jours)",
    "Open Account (days)": "Compte ouvert (jours)",
    "Net 7 Days": "Net 7 jours",
    "Net 15 Days": "Net 15 jours",
    "Net 30 Days": "Net 30 jours",
    "Net 45 Days": "Net 45 jours",
    "Net 60 Days": "Net 60 jours",
    "Net 90 Days": "Net 90 jours",
    "Other (Custom)": "Autre (personnalisé)",
    "Timezone": "Fuseau horaire",
    "Your Timezone": "Votre fuseau horaire",
    "Select timezone": "Sélectionner le fuseau horaire",
    "Timestamps throughout the app will display in this timezone.": "Timestamps throughout the app will display in this timezone.",
    "Asia/Kolkata (IST, UTC+5:30)": "Asia/Kolkata (IST, UTC+5:30)",
    "Trial": "Essai",
    "Trial 7 days": "Essai de 7 jours",
    "Subscription expired. Limited access": "Abonnement expiré. Accès limité",
    "Transaction History": "Historique des transactions",
    "Start Date": "Date de début",
    "End Date": "Date de fin",
    "Transaction ID": "ID de transaction",
    "Choose Your Plan": "Choisissez votre forfait",
    "Select the plan that best fits your needs": "Sélectionnez le forfait qui correspond le mieux à vos besoins",
    "Company Profile": "Profil de l’entreprise",
    "Your Company Profile": "Profil de votre entreprise",
    "Company Profile Management": "Gestion du profil de l’entreprise",
    "Registering as an individual": "Inscription en tant que particulier",
    "Set up company identity, address, and operating profile": "Set up company identity, address, and operating profile",
    "Legal Entity Type": "Type d’entité juridique",
    "Select Legal Entity of Company": "Sélectionner l’entité juridique de l’entreprise",
    "Private Limited": "Société privée à responsabilité limitée",
    "Public Limited": "Société anonyme",
    "Partnership": "Partenariat",
    "Proprietorship": "Entreprise individuelle",
    "Corporation (Inc)": "Société (Inc)",
    "LLP": "LLP",
    "LLC": "LLC",
    "Branding": "Image de marque",
    "Brand Identity": "Identité de marque",
    "Use a direct image URL. The default RIK Exim logo is used when this field is empty.": "Use a direct image URL. The default RIK Exim logo is used when this field is empty.",
    "Buyer Tax Number": "Numéro fiscal de l’acheteur",
    "Round Log": "Grume ronde",
    "Square / Sawn": "Équarri / scié",
    "For round, unprocessed logs. Uses the Hoppus formula: (girth ÷ 4)² × length.": "Pour les grumes rondes non transformées. Utilise la formule Hoppus : (circonférence ÷ 4)² × longueur.",
    "For square or sawn timber. Uses volumetric formula: length × width × height.": "Pour le bois équarri ou scié. Utilise la formule volumétrique : longueur × largeur × hauteur.",
    "Formula guide": "Guide des formules",
    "Tax Number": "Numéro fiscal",
    "Available": "Disponible",
    "In Process": "En ordre de sciage",
    "In Shipment": "En consignation",
    "Shipped": "Expédié",
    "Stock by Location": "Stock par emplacement",
    "sites": "sites",
    "TUs": "Unités de stock",
    "Filtered": "Filtré",
    "At Forest": "En forêt",
    "In Transit": "En transit",
    "At Mill": "À la scierie",
    "At Yard": "Au parc",
    "AVAILABLE": "Disponible",
    "IN_PROCESS": "En ordre de sciage",
    "PROCESSED": "Scié",
    "IN_SHIPMENT": "En consignation",
    "SHIPPED": "Expédié",
    "COMPLETED": "Terminé",
    "Completed": "Terminé",
    "ROUND": "Rond",
    "SQUARE": "Carré",
    "All": "Tous",
    "IN": "In",
    "OUT": "Out",
    "Proc IN": "Envoyé à la scierie",
    "Proc OUT": "Produit par la scierie",
    "Adjustment": "Ajustement",
    "Received": "Reçu",
    "Dispatched": "Expédié",
    "Sold": "Vendu",
    "New Processing Run": "Nouvel ordre de sciage",
    "Theme": "Thème",
    "Lara Light Blue": "Lara bleu clair",
    "Lara Dark Blue": "Lara bleu foncé",
    "Lara Light Indigo": "Lara indigo clair",
    "Lara Dark Indigo": "Lara indigo foncé",
    "Bootstrap Light": "Bootstrap clair",
    "Bootstrap Dark": "Bootstrap sombre",
    "Saga Blue": "Saga bleu",
    "Vela Blue (Dark)": "Vela bleu (sombre)",
    "Material Light": "Material clair",
    "Arya Blue (Dark)": "Arya bleu (sombre)",
    "YARD": "Yard",
    "FOREST": "Forêt",
    "MILL": "Mill",
    "PORT": "Port",
    "WAREHOUSE": "Entrepôt",
    "common.previous": "Previous",
    "pay.secureCheckout": "Secure Checkout",
    "pay.completeSubscription": "Complete Your Subscription",
    "pay.oneStepAway": "You're one step away from unlocking full access to LumberLinq",
    "pay.stepPlanSelected": "Forfait Selected",
    "pay.stepAccountSetup": "Account Setup",
    "pay.stepPayment": "Paiement",
    "pay.billingDetails": "Billing Détails",
    "pay.billingDetailsDesc": "This information will appear on your invoice",
    "pay.optional": "Optional",
    "pay.taxIdHint": "Recommended for proper tax invoicing.",
    "pay.sslNote": "Your billing information is encrypted with SSL. We never store your payment card details.",
    "pay.annual": "Annual",
    "pay.monthly": "Mensuel",
    "pay.basePrice": "Base Price",
    "pay.starts": "Starts",
    "pay.ends": "Ends",
    "pay.promoCode": "Promo Code",
    "pay.applyCode": "Apply code →",
    "pay.enterCode": "Enter code",
    "pay.taxes": "Taxes",
    "pay.discountApplied": "Discount Applied",
    "pay.upgradeCreditApplied": "Crédit de Mise à Niveau",
    "pay.upgradeCreditNote": "Crédit pour le temps non utilisé restant sur votre forfait actuel.",
    "pay.farFutureQueueBanner": "Vous avez déjà une couverture active jusqu'au {date}. Cet achat ne démarrera qu'après.",
    "pay.farFutureQueueHeader": "Cela ne démarrera pas tout de suite",
    "pay.farFutureQueueMessage": "Vous avez déjà un forfait actif jusqu'au {date}. Cet nouvel achat sera mis en file d'attente pour ne démarrer qu'après — il ne prendra pas effet maintenant. Continuer quand même ?",
    "pay.farFutureQueueAccept": "Oui, mettre en file d'attente quand même",
    "pay.farFutureQueueReject": "Non, annuler",
    "pay.promoApplied": "Coupon Appliqué !",
    "pay.promoChange": "Retirer",
    "pay.promoEnterFirst": "Veuillez saisir un code promo.",
    "pay.promoGenericError": "Ce code n'est pas valide. Veuillez vérifier et réessayer.",
    "pay.promoErr.notFound": "Ce code est introuvable. Veuillez vérifier et réessayer.",
    "pay.promoErr.notStarted": "Ce code n'est pas encore actif.",
    "pay.promoErr.expired": "Ce code a expiré.",
    "pay.promoErr.usedUp": "Ce code a atteint sa limite d'utilisation et ne peut plus être utilisé.",
    "pay.promoErr.currency": "Ce code n'est pas valable pour la devise choisie.",
    "pay.promoErr.period": "Ce code n'est pas valable pour la période de facturation choisie.",
    "pay.promoErr.inrOnly": "Ce code n'est valable que pour une facturation en INR.",
    "pay.promoErr.alreadyUsed": "Votre entreprise a déjà utilisé ce code.",
    "pay.promoErr.ownCode": "Vous ne pouvez pas utiliser un code de parrainage appartenant à votre propre entreprise.",
    "pay.amountPayable": "Montant Payable",
    "pay.autoRenewal": "Renouvellement Automatique",
    "pay.autoRenewalHint": "Renouveler automatiquement à la fin de la période de facturation",
    "pay.autoRenewalRequiredMonthly": "Obligatoire pour les plans mensuels — annulez à tout moment depuis la page abonnements",
    "pay.autoRenewalUsdNotSupported": "Le renouvellement automatique est disponible uniquement pour la facturation en INR",
    "pay.autoRenewalCouponDisabled": "Remise unique appliquée — renouvellement automatique désactivé. Activez-le après paiement depuis votre page Abonnement au prix plein.",
    "pay.autoRenewalLifetimeCoupon": "Remise à vie : le renouvellement automatique continuera à ce prix réduit",
    "pay.iHaveReadAccept": "J'ai lu et accepte les",
    "pay.tncError": "You must accept the Terms & Conditions to proceed.",
    "pay.sslSecured": "SSL Secured",
    "pay.encrypted": "Encrypted",
    "pay.tncFooterNote": "Clicking \"Accept\" also checks the agreement checkbox.",
    "pay.orderSummary": "Order Résumé",
    "pay.yr": "yr",
    "pay.mo": "mo",
    "tour.next": "Next →",
    "tour.prev": "← Back",
    "tour.done": "Done ✓",
    "tour.progress": "{{current}} of {{total}}",
    "tour.header.welcome.title": "Welcome to LumberLinq!",
    "tour.header.welcome.desc": "Let's take a quick tour of the key features. You can <strong>dismiss</strong> this at any time by clicking the × button.",
    "tour.header.menu.title": "Navigation Menu",
    "tour.header.menu.desc": "Cliquez here to <strong>open or collapse</strong> the sidebar navigation.",
    "tour.header.logo.title": "LumberLinq Logo",
    "tour.header.logo.desc": "Cliquez the logo to <strong>return to the Dashboard</strong> from anywhere.",
    "tour.header.language.title": "Langue",
    "tour.header.language.desc": "Switch the app language between <strong>English, Hindi, and Portuguese</strong>.",
    "tour.header.fontSize.title": "Font Size",
    "tour.header.fontSize.desc": "Adjust the <strong>text size</strong> to your comfort level.",
    "tour.header.theme.title": "Thème",
    "tour.header.theme.desc": "Pick a <strong>colour theme</strong> that suits your preference.",
    "tour.header.darkMode.title": "Mode sombre",
    "tour.header.darkMode.desc": "Toggle between <strong>Light and Dark</strong> display modes.",
    "tour.header.profile.title": "Your Profil",
    "tour.header.profile.desc": "Accès your <strong>account settings, subscription, and logout</strong> from here.",
    "tour.header.help.title": "Help & Support",
    "tour.header.help.desc": "Find <strong>guides, FAQs, and support tickets</strong> whenever you need help. That's all — enjoy LumberLinq!",
    "tour.shipments.header.title": "Consignations",
    "tour.shipments.header.desc": "Gérer all your <strong>export consignments</strong> from this page.",
    "tour.shipments.new.title": "New Consignation",
    "tour.shipments.new.desc": "Cliquez here to <strong>create a new consignment</strong> and start adding stock units.",
    "tour.shipments.filter.title": "Filter & Rechercher",
    "tour.shipments.filter.desc": "Use these filters to <strong>search consignments</strong> by date, status, or business partner.",
    "tour.shipments.table.title": "Consignations Table",
    "tour.shipments.table.desc": "Each row is a consignment. Cliquez a row to <strong>view details, tally sheets, and documents</strong>.",
    "tour.shipments.delete.title": "Supprimer Consignation",
    "tour.shipments.delete.desc": "Use the delete action carefully — <strong>removed consignments cannot be recovered</strong>.",
    "tour.tally.header.title": "Cubage Sheet",
    "tour.tally.header.desc": "Record and manage <strong>log measurements</strong> for this stock unit.",
    "tour.tally.settings.title": "Cubage Paramètres",
    "tour.tally.settings.desc": "Configure <strong>formula, unit, and measurement defaults</strong> for this tally.",
    "tour.tally.grid.title": "Entry Grid",
    "tour.tally.grid.desc": "Enter each log's <strong>girth, length, and quantity</strong> directly in the grid. Totals update automatically.",
    "tour.tally.export.title": "Exporter",
    "tour.tally.export.desc": "Export the tally as a <strong>PDF or Excel file</strong> for sharing or enregistrements.",
    "tour.tally.save.title": "Enregistrer Cubage",
    "tour.tally.save.desc": "Cliquez Enregistrer to <strong>submit the tally</strong> data to the consignment.",
    "tour.reports.header.title": "Rapports",
    "tour.reports.header.desc": "Generate detailed <strong>business and tally reports</strong> from this section.",
    "tour.reports.filter.title": "Rapport Filters",
    "tour.reports.filter.desc": "Set the <strong>date range, business partner, and consignment</strong> to narrow the report.",
    "tour.reports.generate.title": "Generate Rapport",
    "tour.reports.generate.desc": "Cliquez Generate to <strong>build the report</strong> with your selected filters.",
    "tour.reports.export.title": "Export Rapport",
    "tour.reports.export.desc": "Download the report as <strong>PDF or Excel</strong> for offline use.",
    "tour.bp.header.title": "Partenaires commerciaux",
    "tour.bp.header.desc": "Gérer your <strong>buyers and sellers</strong> from this page.",
    "tour.bp.new.title": "Ajouter Partenaire",
    "tour.bp.new.desc": "Cliquez here to <strong>add a new buyer or seller</strong> to your directory.",
    "tour.bp.stats.title": "Partenaire Stats",
    "tour.bp.stats.desc": "A quick overview of <strong>total buyers and sellers</strong> in your account.",
    "tour.bp.filter.title": "Filter Partenaires",
    "tour.bp.filter.desc": "Rechercher or filter partners by <strong>name, type, or country</strong>.",
    "tour.bp.table.title": "Partenaires Table",
    "tour.bp.table.desc": "Cliquez a partner row to <strong>edit details or view their consignment history</strong>.",
    "tour.products.header.title": "Produits",
    "tour.products.header.desc": "Define the <strong>timber products</strong> used in your tally sheets.",
    "tour.products.new.title": "Ajouter Produit",
    "tour.products.new.desc": "Cliquez here to <strong>create a new timber product</strong> with its formula and unit.",
    "tour.products.stats.title": "Produit Stats",
    "tour.products.stats.desc": "See the <strong>total number of products</strong> configured in your account.",
    "tour.products.table.title": "Produits Table",
    "tour.products.table.desc": "Cliquez a product row to <strong>edit its name, formula, or default unit</strong>.",
    "tour.loadingSite.header.title": "Sites",
    "tour.loadingSite.header.desc": "Suivez tous les <strong>emplacements de forêt, cour, scierie et port</strong> ici.",
    "tour.loadingSite.new.title": "Ajouter un Site",
    "tour.loadingSite.new.desc": "Cliquez ici pour <strong>enregistrer un nouveau site</strong> sur votre compte.",
    "tour.loadingSite.stats.title": "Statistiques des Sites",
    "tour.loadingSite.stats.desc": "Un résumé du <strong>nombre total de sites</strong> par type.",
    "tour.loadingSite.table.title": "Tableau des Sites",
    "tour.loadingSite.table.desc": "Cliquez sur une ligne pour <strong>modifier son nom, son type et son emplacement</strong>.",
    "tour.users.header.title": "Utilisateurs",
    "tour.users.header.desc": "Gérer all <strong>team members</strong> who have access to your LumberLinq account.",
    "tour.users.add.title": "Invite Utilisateur",
    "tour.users.add.desc": "Cliquez here to <strong>invite a new team member</strong> by email.",
    "tour.users.stats.title": "Utilisateur Stats",
    "tour.users.stats.desc": "See how many <strong>active users and available seats</strong> your plan allows.",
    "tour.users.table.title": "Utilisateurs Table",
    "tour.users.table.desc": "Gérer roles and permissions — click a user row to <strong>edit or deactivate</strong>.",
    "tour.dashboardV7.header.title": "Votre pouls d'activité",
    "tour.dashboardV7.header.desc": "Votre <strong>tableau de bord</strong> — choisissez une période et actualisez ici pour voir les chiffres en direct de toute votre activité.",
    "tour.dashboardV7.pulse.title": "Pouls d'activité",
    "tour.dashboardV7.pulse.desc": "Des <strong>cartes KPI</strong> rapides pour les partenaires, expéditions, unités de stock, volume et pièces — cliquez sur une carte pour accéder directement à cette liste.",
    "tour.dashboardV7.financial.title": "Santé financière",
    "tour.dashboardV7.financial.desc": "Suivez <strong>le chiffre d'affaires, les soldes impayés et l'ancienneté</strong> en un coup d'œil.",
    "tour.dashboardV7.inventory.title": "Aperçu des stocks",
    "tour.dashboardV7.inventory.desc": "Une vue en direct des <strong>niveaux de stock sur tous vos sites</strong> — cliquez sur « Inventaire complet » pour la vue d'ensemble.",
    "tour.dashboardV7.recon.title": "Réconciliation",
    "tour.dashboardV7.recon.desc": "Voyez quelle part de vos données de pointage est <strong>réconciliée avec les expéditions</strong>, et intervenez pour combler les écarts.",
    "tour.dashboardV7.charts.title": "Tendances et graphiques",
    "tour.dashboardV7.charts.desc": "Visualisez <strong>les tendances de volume et les meilleurs produits</strong> sur la période sélectionnée.",
    "tour.dashboardV7.activity.title": "Activité récente",
    "tour.dashboardV7.activity.desc": "Un journal d'audit des <strong>changements récents de compte et de permissions</strong> au sein de votre équipe.",
    "tour.inventoryOverview.header.title": "Aperçu de l'inventaire",
    "tour.inventoryOverview.header.desc": "Une vue en direct de <strong>où se trouve votre stock actuellement</strong> — en forêt, en transit, à la scierie, en ordre de sciage, au dépôt ou en expédition.",
    "tour.inventoryOverview.actions.title": "Stock d'ouverture et ordre de sciage",
    "tour.inventoryOverview.actions.desc": "Les actions principales : <strong>ajouter votre stock d'ouverture (le stock que vous avez déjà) ou démarrer un ordre de sciage</strong>. Les nouvelles livraisons arrivent par leur unité de stock (entrée) et sont reçues dans un lot.",
    "tour.inventoryOverview.lots.title": "Lots de stock ouverts",
    "tour.inventoryOverview.lots.desc": "Chaque <strong>lot ouvert</strong> actuellement dans le système — cliquez sur un lot pour voir tout son historique de mouvements et sa chaîne.",
    "tour.inventoryInOut.header.title": "Registre des mouvements de stock",
    "tour.inventoryInOut.header.desc": "Chaque <strong>mouvement de stock</strong> jamais enregistré. Utilisez Ajouter un ajustement pour corriger un écart, ou Exporter pour une copie sous forme de tableur.",
    "tour.inventoryInOut.filter.title": "Filtrer par type et date",
    "tour.inventoryInOut.filter.desc": "Restreignez le registre à un <strong>type de mouvement</strong> (Entrée, Sortie, Ajustement, et plus) ou à une <strong>période</strong>.",
    "tour.inventoryInOut.table.title": "Registre des mouvements",
    "tour.inventoryInOut.table.desc": "Chaque ligne est un <strong>événement de mouvement</strong> — touchez un code pour voir l'unité de stock, le lot, l'ordre de sciage ou l'expédition derrière.",
    "tour.inventoryProcessing.header.title": "Ordres de sciage",
    "tour.inventoryProcessing.header.desc": "C'est ici que se déroulent les <strong>ordres de sciage</strong>, y compris Custom-Made / Re-sciage — démarrez un nouvel ordre pour transformer le stock d'un lot en un nouveau lot.",
    "tour.inventoryProcessing.stats.title": "Performance des ordres de sciage",
    "tour.inventoryProcessing.stats.desc": "Nombre total d'ordres de sciage, <strong>rendement moyen</strong>, et volume total scié — un contrôle rapide de l'efficacité de votre scierie.",
    "tour.inventoryProcessing.table.title": "Ordres de sciage",
    "tour.inventoryProcessing.table.desc": "Chaque ordre de sciage, son <strong>statut</strong> et son entrée/sortie — cliquez sur une ligne pour tous les détails, y compris la commande d'origine.",
    "tour.inventoryOperators.header.title": "Opérateurs de scierie",
    "tour.inventoryOperators.header.desc": "Gérez les <strong>opérateurs</strong> qui travaillent sur les ordres de sciage — ajoutez un nouvel opérateur ici.",
    "tour.inventoryOperators.stats.title": "Aperçu de l'équipe",
    "tour.inventoryOperators.stats.desc": "Nombre total d'opérateurs et d'<strong>opérateurs actifs</strong> en un coup d'œil.",
    "tour.inventoryOperators.search.title": "Rechercher et filtrer",
    "tour.inventoryOperators.search.desc": "Trouvez un opérateur par <strong>nom, code employé, ou e-mail</strong>, ou filtrez par expertise et statut actif.",
    "tour.rbacSettings.toggle.title": "Contrôle d'accès basé sur les rôles",
    "tour.rbacSettings.toggle.desc": "Activez le <strong>RBAC</strong> pour ne donner à chaque membre de l'équipe que l'accès dont il a besoin, au lieu que tout le monde voie tout.",
    "tour.rbacSettings.tabs.title": "Utilisateurs et rôles",
    "tour.rbacSettings.tabs.desc": "Gérez l'accès de deux façons : par utilisateur (<strong>Permissions utilisateur</strong>) ou en attribuant un <strong>rôle</strong> réutilisable.",
    "tour.rbacSettings.usersTable.title": "Permissions utilisateur",
    "tour.rbacSettings.usersTable.desc": "Chaque membre de l'équipe et l'étendue de son accès au système — cliquez sur <strong>Configurer</strong> sur une ligne pour l'affiner.",
    "tour.rbacSettings.rolesTab.title": "Rôles d'accès",
    "tour.rbacSettings.rolesTab.desc": "Créez un <strong>rôle réutilisable</strong> (comme « Comptable » ou « Superviseur de dépôt ») une fois, puis attribuez-le à autant d'utilisateurs que vous voulez.",
    "tour.subscriptionManagement.accordion.title": "S'abonner en 4 étapes",
    "tour.subscriptionManagement.accordion.desc": "Choisissez un forfait, examinez-le, ajoutez les détails de facturation, puis payez — chaque étape <strong>débloque la suivante</strong> une fois terminée.",
    "tour.subscriptionManagement.packageSelect.title": "1. Choisir un forfait",
    "tour.subscriptionManagement.packageSelect.desc": "Choisissez le <strong>forfait et le cycle de facturation</strong> adaptés à votre entreprise.",
    "tour.subscriptionManagement.billing.title": "3. Détails de facturation",
    "tour.subscriptionManagement.billing.desc": "Saisissez les <strong>informations de votre entreprise et fiscales</strong> pour la facture.",
    "tour.subscriptionManagement.pay.title": "4. Évaluer la commande et payer",
    "tour.subscriptionManagement.pay.desc": "Vérifiez le <strong>total final</strong>, appliquez un code promo si vous en avez un, et finalisez le paiement.",
    "ticket.supportTitle": "Tickets de support",
    "ticket.subtitle": "Raise a request, track progress, and get help from our team.",
    "ticket.newTicket": "New Ticket",
    "ticket.searchPlaceholder": "Rechercher by subject, ticket number or category…",
    "ticket.filter": "Filter:",
    "ticket.replies": "replies",
    "ticket.lastActivity": "Last activity",
    "ticket.noTickets": "No tickets yet",
    "ticket.noTicketsHint": "Haven't raised a support request? We're here to help.",
    "ticket.raiseFirst": "Raise First Ticket",
    "ticket.submitted": "Ticket Submitted!",
    "ticket.submitReceived": "Your support request has been received.",
    "ticket.respondTime": "Our team will respond within 24 hours.",
    "ticket.yourId": "Your Ticket ID",
    "ticket.viewTicket": "Voir Ticket",
    "ticket.allTickets": "All Tickets",
    "ticket.raiseTitle": "Raise a Support Ticket",
    "ticket.raiseHint": "Describe your issue and we will get back to you promptly.",
    "ticket.subject": "Subject",
    "ticket.subjectPlaceholder": "Briefly describe your issue",
    "ticket.subjectRequired": "Subject est obligatoire.",
    "ticket.maxChars": "Max 255 characters.",
    "ticket.selectCategory": "Sélectionner category",
    "ticket.categoryRequired": "Category est obligatoire.",
    "ticket.descriptionPlaceholder": "Provide as much detail as possible — steps to reproduce, error messages, screenshots context, etc.",
    "ticket.descriptionRequired": "Description est obligatoire.",
    "ticket.submitTicket": "Submit Ticket",
    "ticket.priority": "Priorité",
    "ticket.resolved": "Résolu",
    "ticket.closed": "Fermé",
    "ticket.howDidWeDo": "How did we do?",
    "ticket.csatPrompt": "Your ticket has been resolved. Rate your support experience:",
    "ticket.optionalComment": "Optional comment…",
    "ticket.submitRating": "Submit Rating",
    "ticket.yourRating": "Your rating:",
    "ticket.replyPlaceholder": "Type your reply here…",
    "ticket.attachFile": "Attach file",
    "ticket.sendReply": "Send Reply",
    "ticket.ticketClosed": "This ticket is closed. Please open a new ticket if you need further assistance.",
    "ticket.status.all": "Tous",
    "ticket.status.open": "Ouvert",
    "ticket.status.inProgress": "En cours",
    "ticket.status.awaitingReply": "Awaiting My Reply",
    "ticket.status.resolved": "Résolu",
    "ticket.status.closed": "Fermé",
    "ticket.priority.low": "Faible",
    "ticket.priority.medium": "Moyenne",
    "ticket.priority.high": "Élevée",
    "ticket.priority.critical": "Critique",
    "ticket.priority.low.desc": "Low — general question",
    "ticket.priority.medium.desc": "Medium — non-urgent issue",
    "ticket.priority.high.desc": "High — affecting my work",
    "ticket.priority.critical.desc": "Critical — system down / data loss",
    "ticket.category.billing": "Facturation et paiements",
    "ticket.category.technical": "Problème technique",
    "ticket.category.account": "Compte et accès",
    "ticket.category.featureRequest": "Demande de fonctionnalité",
    "ticket.category.subscription": "Abonnement",
    "ticket.category.dataRecovery": "Récupération de données",
    "ticket.category.other": "Autre",
    "ticket.csat.1": "Very Unhappy",
    "ticket.csat.2": "Unhappy",
    "ticket.csat.3": "Neutre",
    "ticket.csat.4": "Happy",
    "ticket.csat.5": "Very Happy",
    // -- AI Chat
    "ai.chat.title": "Assistant IA LumberLinq",
    "ai.chat.placeholder": "Une question sur LumberLinq…",
    "ai.chat.footerNote": "Réponses basées sur notre Base de Connaissances",
    "ai.chat.send": "Envoyer",
    "ai.chat.newChat": "Nouvelle conversation",
    "ai.chat.thinking": "En train de réfléchir…",
    "ai.chat.sources": "Sources",
    "ai.chat.noSessions": "Aucune conversation précédente",
    "ai.chat.deleteSession": "Supprimer la conversation",
    "ai.chat.emailTranscript": "Envoyer la transcription par e-mail",
    "ai.chat.feedback.good": "Utile",
    "ai.chat.feedback.bad": "Pas utile",
    "ai.chat.attachFile": "Joindre un fichier",
    "ai.chat.disclaimer": "Les réponses de l'IA sont basées sur notre base de connaissances et peuvent ne pas être totalement exactes. Vérifiez toujours les informations importantes.",
    "ai.chat.modeAuto": "Auto",
    "ai.chat.titleAuto": "Linc AI",
    "ai.chat.autoSub": "Demandez ce que vous voulez · Linc choisit la bonne réponse",
    "ai.chat.autoPlaceholder": "Demandez comment faire quelque chose, ou posez une question sur votre stock et vos paiements…",
    "ai.chat.autoGreeting": "Bonjour, je suis Linc AI 👋",
    "ai.chat.autoTitle": "Un seul endroit pour toutes vos questions",
    "ai.chat.autoDesc": "Demandez comment faire quelque chose dans LumberLinq, ou posez une question sur votre propre stock, vos consignations et vos paiements. Je choisis la bonne façon de répondre et je n'affiche que ce que votre compte est autorisé à voir.",
    "ai.chat.goToScreen": "Aller à l'écran",
    "ai.chat.dataPartFailed": "J'ai pu répondre à la partie « comment faire » de votre question, mais la partie sur les données en direct n'a pas pu être traitée pour le moment.",
    "ai.chat.starter.createConsignment": "Créer une consignation",
    "ai.chat.starter.inviteTeam": "Inviter un membre de l'équipe",
    "ai.chat.starter.shareTally": "Partager une feuille de décompte",
    "ai.chat.starter.stockNow": "Stock actuel",
    "ai.chat.starter.toPay": "Paiements à régler",
    "ai.chat.starterQ.createConsignment": "Comment créer une nouvelle Consignation ?",
    "ai.chat.starterQ.inviteTeam": "Comment inviter un membre de l'équipe ?",
    "ai.chat.starterQ.shareTally": "Comment partager une feuille de tally avec un acheteur ?",
    "ai.chat.starterQ.stockNow": "Combien de stock avons-nous en ce moment ?",
    "ai.chat.starterQ.toPay": "Que reste-t-il à payer ce mois-ci ?",
    "ai.chat.starterQ.myAccess": "Que puis-je faire avec mon compte ?",
    "ai.chat.starterQ.shipmentsMonth": "Combien d'expéditions ce mois-ci ?",
    "ai.chat.starterQ.profitMargin": "Quelle est notre marge bénéficiaire ce trimestre ?",
    "ai.chat.starterQ.machines": "Quelles machines tournent en ce moment ?",
    "ai.chat.starterQ.health": "Comment va notre activité dans l'ensemble ?",
    "ai.chat.starter.myAccess": "Que puis-je faire ?",
    "lincPreview.button": "Ce que Linc montre à cette personne",
    "lincPreview.title": "Ce que Linc montre à cette personne",
    "lincPreview.intro": "Voici ce que Linc (l'assistant IA) peut dire à cette personne, selon son accès et le forfait de l'entreprise. Rien n'est envoyé à l'IA pour l'afficher.",
    "lincPreview.modulesAssumed": "Vous êtes connecté en tant que personnel de la plateforme : les interrupteurs de module (Inventory, Mill Jobs, Linc Data) ne sont pas vérifiés ici.",
    "lincPreview.why.plan": "{items} n'est pas inclus dans la formule actuelle de cette société (la société devrait la mettre à niveau ou l'ajouter)",
    "lincPreview.why.permission": "ce compte n'a pas accès à {items} (un administrateur de l'équipe peut l'accorder depuis Manage Roles)",
    "lincPreview.why.also": " ; en outre, ",
    "lincPreview.why.and": " et ",
    "lincPreview.why.dataPlan": "Linc Data n'est pas activé dans la formule de cette société (la société devrait l'ajouter ou changer de formule)",
    "lincPreview.why.dataRight": "ce compte n'a pas le droit d'utiliser Linc Data (un administrateur de l'équipe peut l'accorder depuis Manage Roles)",
    "lincPreview.tileAreas": "Zones",
    "lincPreview.tileQuestions": "Questions sur les données en direct",
    "lincPreview.tileSections": "Notes d'aide",
    "lincPreview.tileAnswers": "Réponses toutes prêtes",
    "lincPreview.areasTitle": "Zones de l'application",
    "lincPreview.questionsTitle": "Questions sur les données en direct (Linc Data)",
    "lincPreview.notesTitle": "Notes d'aide",
    "lincPreview.allowed": "Autorisé",
    "lincPreview.notAllowed": "Non autorisé",
    "lincPreview.withheld": "retenues",
    "lincPreview.showWithheld": "Afficher les sections retenues",
    "lincPreview.error": "Impossible de charger l'aperçu. Veuillez réessayer.",
    "lincPreview.close": "Fermer",
    // -- Round Tally Summary (premium redesign)
    "tallySummaryRound.title": "Résumé du Cubage Rond",
    "tallySummaryRound.subtitle": "Volume, nombre de pièces et informations de distribution pour ce lot de grumes rondes",
    "tallySummaryRound.piecesAnalyzed": "pièces analysées",
    "tallySummaryRound.histogram": "Histogramme",
    "tallySummaryRound.bubble": "Bulles",
    "tallySummaryRound.line": "Ligne",
    "tallySummaryRound.mainVisualization": "Visualisation Principale",
    "tallySummaryRound.girthVsVolume": "Circonférence vs Volume",
    "tallySummaryRound.lengthDistribution": "Distribution de Longueur",
    "tallySummaryRound.bubbleTitle": "Circonférence x Longueur x Volume",
    "tallySummaryRound.activeFilterLabel": "Filtre Actif",
    "tallySummaryRound.clearFilter": "Effacer le Filtre",
    "tallySummaryRound.spotlightPiece": "Mise en évidence de la pièce #",
    "tallySummaryRound.kpiTotalPieces": "Total des Pièces",
    "tallySummaryRound.kpiTotalNetCbm": "Total CBM Net",
    "tallySummaryRound.kpiTotalNetCft": "Total CFT Net",
    "tallySummaryRound.kpiAuthoritative": "Total officiel du lot",
    "tallySummaryRound.distributionTitle": "Distribution par Pièce",
    "tallySummaryRound.avgVolume": "Volume Moyen / Pièce",
    "tallySummaryRound.minVolume": "Plus Petite Pièce",
    "tallySummaryRound.maxVolume": "Plus Grande Pièce",
    "tallySummaryRound.outlierWatchTitle": "Qualité des Données - Surveillance des Anomalies",
    "tallySummaryRound.outlierCleanLot": "Lot propre - aucune anomalie de mesure détectée",
    "tallySummaryRound.outlierFlaggedCount": "pièce(s) signalée(s) pour examen",
    "tallySummaryRound.outlierFreePercent": "Sans anomalie",
    "tallySummaryRound.outlierExpand": "Voir les pièces signalées",
    "tallySummaryRound.outlierCollapse": "Masquer les pièces signalées",
    "tallySummaryRound.outlierColRow": "Ligne #",
    "tallySummaryRound.outlierColGirth": "Circonférence",
    "tallySummaryRound.outlierColLength": "Longueur",
    "tallySummaryRound.outlierColVolume": "Volume",
    "tallySummaryRound.outlierColDeviation": "Écart",
    "tallySummaryRound.outlierSeverityMild": "Léger",
    "tallySummaryRound.outlierSeverityExtreme": "Extrême",
    "tallySummaryRound.outlierNotEnoughData": "Pas assez de pièces pour évaluer les anomalies (minimum 8 requis)",
    "tallySummaryRound.outlierAboveRange": "au-dessus de la plage attendue",
    "tallySummaryRound.outlierBelowRange": "en dessous de la plage attendue",
    "tallySummaryRound.rowPositionHint": "Position d'entrée dans la feuille de cubage, pas un identifiant permanent",
    "tallySummaryRound.girthHistogramTitle": "Distribution de Circonférence",
    "tallySummaryRound.girthHistogramDesc": "Pièces regroupées en bandes de circonférence de 5 cm",
    "tallySummaryRound.lengthHistogramTitle": "Tableau de Distribution de Longueur",
    "tallySummaryRound.lengthHistogramDesc": "Pièces regroupées par longueur saisie",
    "tallySummaryRound.metric": "Mesure",
    "tallySummaryRound.noDataTitle": "Aucun Résumé Disponible",
    "tallySummaryRound.noDataDesc": "Ajoutez d'abord des données de cubage pour générer des informations et des visualisations.",
    "tallySummaryRound.lotSnapshot": "Aperçu du Lot",
    "tallySummaryRound.kpiAvgCft": "CFT Moyen / Pièce",
    "tallySummaryRound.distributionHelp": "Volume net moyen, le plus petit et le plus grand (CBM) par grume individuelle dans la vue actuelle.",
    "tallySummaryRound.outlierHelp": "Signale les grumes dont le volume est statistiquement inhabituel par rapport au reste de ce lot - un moyen rapide de repérer les entrées mal mesurées ou mal saisies avant de finaliser ou de partager ce cubage.",
    "tallySummaryRound.axisGirth": "Circonférence (cm)",
    "tallySummaryRound.axisLength": "Longueur (cm)",
    "tallySummaryRound.axisPieces": "Pièces",
    "tallySummaryRound.axisVolume": "Volume (m³)",
    "tallySummaryRound.rowAverage": "Moyenne",
    "tallySummaryRound.rowSmallest": "Plus petite",
    "tallySummaryRound.rowLargest": "Plus grande",
    "tallySummaryRound.colVolume": "Volume",
    "tallySummaryRound.colGirth": "Circonférence",
    "tallySummaryRound.colLength": "Longueur",
    "tallySummaryRound.normalGirthRange": "Plage Normale de Circonférence",
    "tallySummaryRound.normalLengthRange": "Plage Normale de Longueur",
    "tallySummaryRound.dimGirthAbnormal": "Circonférence anormale",
    "tallySummaryRound.dimLengthAbnormal": "Longueur anormale",
    "tallySummaryRound.dimBothAbnormal": "Circonférence et Longueur anormales",
    "tallySummaryRound.girthVsVolumeHelp": "Montre comment le volume de chaque grume est lié à sa circonférence - une circonférence plus grande signifie généralement plus de volume, mais la longueur joue aussi un rôle.",
    "tallySummaryRound.holdTitle": "Quelles grumes portent votre volume",
    "tallySummaryRound.holdSubLogs": "Les plus grosses d'abord · part de {total} CBM",
    "tallySummaryRound.holdSubBands": "Classes de circonférence, les plus grosses d'abord · part de {total} CBM",
    "tallySummaryRound.holdInsightOne": "Votre plus grosse grume représente {pct}% du volume du lot.",
    "tallySummaryRound.holdInsightMany": "Vos {n} plus grosses grumes représentent {pct}% du volume du lot.",
    "tallySummaryRound.holdInsightBand": "Les grumes de {band} cm de circonférence représentent {pct}% du volume.",
    "tallySummaryRound.holdRow": "Ligne {n}",
    "tallySummaryRound.holdMeta": "{girth} cm de circonférence · {length} cm de long",
    "tallySummaryRound.holdBandMeta": "{n} grumes",
    "tallySummaryRound.holdShowAll": "Tout afficher ({n})",
    "tallySummaryRound.holdShowLess": "Afficher moins",
    "tallySummaryRound.emptyHidden": "{n} vides masquées · Afficher",
    "tallySummaryRound.emptyHide": "Masquer les vides",
    "tallySummaryRound.holdInsightTop": "Vos {k}% de grumes les plus grosses représentent {pct}% du volume.",
    "tallySummaryRound.holdTopLogs": "Plus grosses grumes individuelles",
    "tallySummaryRound.holdTabBands": "Par classe",
    "tallySummaryRound.holdTabLogs": "Plus grosses grumes",
    "tallySummaryRound.holdBandMetaOne": "{n} grume",
    "emailVerification.linkValidHours": "Lien valable 24 heures",
    "emailVerification.resendButton": "Renvoyer l'email de vérification",
    "emailVerification.alreadyVerifiedPill": "Email déjà vérifié — veuillez continuer",
    "emailVerification.nowVerifiedGoToLogin": "Votre email est vérifié ! Veuillez vous connecter pour continuer.",
    "emailVerification.stillNotVerified": "Pas encore vérifié — veuillez d'abord consulter votre email et cliquer sur le lien.",
    "emailVerification.resendCountdown": "Renvoi possible dans {{seconds}}s",
    "emailVerification.attemptsRemaining": "{{count}} tentative(s) de renvoi restante(s) sur 3",
    "emailVerification.maxAttemptsReached": "Nombre maximal de tentatives de renvoi atteint. Veuillez contacter le support.",
    "emailVerification.emailInputPlaceholder": "Entrez votre adresse email",
    "emailVerification.emailInputHint": "Entrez l'email utilisé lors de l'inscription pour renvoyer le lien de vérification.",
    "emailVerification.toastSuccessSummary": "Email envoyé",
    "emailVerification.toastErrorSummary": "Échec du renvoi",
    "emailVerification.refreshErrorSummary": "Vérification impossible",
    "emailVerification.refreshErrorBody": "Nous n'avons pas pu vérifier l'état de votre e-mail. Veuillez réessayer dans un instant.",
    "login.securityCheckRetry": "Réessayer la vérification de sécurité",
    "login.securityCheckStuck": "Cela prend plus de temps que prévu — appuyez sur réessayer ci-dessous",
    "login.securityCheckExpired": "Vérification expirée — appuyez sur actualiser pour continuer",
    "login.securityCheckErrored": "Impossible de charger la vérification de sécurité — réessayez",
    "login.signInCancelledSummary": "Connexion annulée",
    "login.signInCancelledDetail": "Il semble que la connexion ne se soit pas terminée. Veuillez réessayer quand vous serez prêt.",
    "tallyStatusBar.row": "ligne",
    "tallyStatusBar.rows": "lignes",
    "tallyStatusBar.piecesUnit": "pcs",
    "tallyStatusBar.updated": "mise(s) à jour",
    "tallyStatusBar.removed": "supprimée(s)",
    "tallyStatusBar.totalRowsTooltip": "Total des lignes",
    "tallyStatusBar.totalPiecesTooltip": "Total des pièces",
    "tallyStatusBar.availableNowTooltip": "Disponible maintenant",
    "tallyStatusBar.afterThisSave": "Restant :",
    "tallyStatusBar.grossCbmTooltip": "CBM brut",
    "tallyStatusBar.grossCbmUnit": "CBM brut",
    "tallyStatusBar.grossCftUnit": "CFT brut",
    "tallyStatusBar.grossCftTooltip": "CFT brut",
    "tallyStatusBar.netCbmUnit": "CBM net",
    "tallyStatusBar.netCftUnit": "CFT net",
    "tallyStatusBar.netCbmTooltip": "CBM net (après tolérances)",
    "tallyStatusBar.netCftTooltip": "CFT net (après tolérances)",
    "tallyStatusBar.avgCftTooltip": "CFT moyen par grume",
    "tallyStatusBar.unsavedChangesTooltip": "lignes avec modifications non enregistrées",
    "tallyStatusBar.unsavedUnit": "non enregistré",
    "tallyStatusBar.allChangesSavedTooltip": "Toutes les modifications enregistrées",
    "tallyStatusBar.allSaved": "Tout est enregistré",
    "tallyStatusBar.savedPrefix": "Enregistré —",
    "tallyStatusBar.deletedPrefix": "Supprimé —",
    "tallyStatusBar.unsavedPressSave": "non enregistré — appuyez sur Enregistrer",
    "tallyStatusBar.lastSaved": "Dernier enregistrement",
    "tallyStatusBar.hideVoiceControls": "Masquer les commandes vocales",
    "tallyStatusBar.showVoiceControls": "Afficher les commandes vocales",
    "tallyStatusBar.addRow": "Ajouter une ligne",
    "tallyStatusBar.deleteSelected": "Supprimer la sélection",
    "tallyStatusBar.saveCtrlS": "Enregistrer (Ctrl+S)",
    "tallyStatusBar.saveTimeout": "L'enregistrement prend trop de temps — vérifiez votre connexion",
    "tallyStatusBar.saveFailed": "Échec de l'enregistrement — réessayez",
    "tallyStatusBar.deletingRows": "Suppression des lignes...",
    "tallyStatusBar.deleteFailed": "Échec de la suppression — réessayez",
    "tallyStatusBar.fixHighlightedCells": "Corrigez les cellules surlignées avant d'enregistrer",
    "tallyStatusBar.noModifiedRows": "Aucune ligne modifiée",
    "tallyStatusBar.saveMsg1": "Enregistrement de vos modifications",
    "tallyStatusBar.saveMsg2": "Calcul des chiffres",
    "tallyStatusBar.saveMsg3": "Synchronisation avec le serveur",
    "tallyStatusBar.saveMsg4": "Presque terminé",
    "tallyStatusBar.saveMsg5": "Toujours en cours",
    "tallyStatusBar.saveMsg6": "Patientez, c'est presque fini",
    "tallyStatusBar.saveMsg7": "Finalisation de vos données",
    "tallyStatusBar.saveMsg8": "Encore un instant",
    "subscriptionPackage.cancelAutoRenewalFailedTitle": "Impossible d'annuler le renouvellement automatique",
    "subscriptionPackage.cancelAutoRenewalFailedMessage": "Impossible d'annuler votre abonnement à renouvellement automatique actuel. Veuillez réessayer ou contacter le support.",
    "subscriptionPackage.saveErrorTitle": "Une erreur s'est produite",
    "subscriptionPackage.saveErrorMessage": "Nous n'avons pas pu enregistrer votre sélection. Veuillez réessayer.",
    "subscriptionPackage.cta.selected": "{name} sélectionné",
    "subscriptionPackage.cta.startTrial": "Essai gratuit de {days} jours",
    "subscriptionPackage.cta.choose": "Choisir {name}",
    "subscriptionPackage.trialNote": "Essai gratuit de {days} jours inclus",
    "appSettings.title": "Paramètres de l'application",
    "appSettings.subtitle": "Gérez les paramètres généraux de votre entreprise",
    "appSettings.nav.paymentReminders": "Rappels de paiement",
    "paymentReminders.title": "Rappels de paiement",
    "paymentReminders.subtitle": "Rappelez automatiquement les paiements à vos partenaires commerciaux et recevez un rapport quotidien",
    "paymentReminders.enable": "Activer les rappels de paiement",
    "paymentReminders.daysBefore": "Commencer à rappeler",
    "paymentReminders.daysBefore.suffix": "jours avant l'échéance",
    "paymentReminders.sendTime": "Heure d'envoi",
    "paymentReminders.timezone": "Fuseau horaire",
    "paymentReminders.externalReminders": "Rappeler les partenaires commerciaux par e-mail",
    "paymentReminders.externalReminders.desc": "Envoie un rappel de paiement à l'acheteur ou au vendeur de vos expéditions et opérations commerciales",
    "paymentReminders.adminReport": "M'envoyer un rapport quotidien",
    "paymentReminders.adminReport.desc": "Un résumé de tout ce qui est dû ou en retard, avec un PDF joint",
    "paymentReminders.channelEmail": "E-mail",
    "paymentReminders.channelPush": "Notification push",
    "paymentReminders.timeline.title": "Chronologie des rappels",
    "paymentReminders.timeline.desc": "Aperçu des jours où un rappel est envoyé, jusqu'à la date d'échéance",
    "paymentReminders.timeline.due": "Échéance",
    "paymentReminders.timeline.overdue": "En retard (quotidien)",
    "paymentReminders.recipients.title": "Qui reçoit le rapport ?",
    "paymentReminders.recipients.desc": "Toute personne ayant accès à la Santé financière reçoit le rapport quotidien. Accordez cet accès à d'autres personnes dans",
    "paymentReminders.recipients.link": "Contrôle d'accès",
    "paymentReminders.save": "Enregistrer les modifications",
    "paymentReminders.saved": "Paramètres de rappel de paiement enregistrés",
    "paymentReminders.saveError": "Impossible d'enregistrer ces paramètres. Veuillez réessayer.",
    "appSettings.nav.currency": "Devise",
    "appSettings.nav.inventoryPolicy": "Politique d'inventaire",
    "appSettings.nav.branding": "Image de marque",
    "appSettings.nav.tallyDefaults": "Valeurs par Défaut du Tally",
    "tallyDefaults.subtitle": "Unités de mesure, tolérances et règles de validation par défaut avec lesquelles les nouvelles Unités de Stock démarrent — remplaçables par Unité de Stock à tout moment.",
    "tallyDefaults.square": "Carré",
    "tallyDefaults.round": "Rond",
    "tallyDefaults.unitOfMeasure": "Unité de Mesure",
    "tallyDefaults.widthUom": "UdM Largeur",
    "tallyDefaults.thickUom": "UdM Épaisseur",
    "tallyDefaults.lengthUom": "UdM Longueur",
    "tallyDefaults.girthUom": "UdM Circonférence",
    "tallyDefaults.decimals": "Décimales",
    "tallyDefaults.mode": "Mode de Saisie",
    "tallyDefaults.allowances": "Tolérances",
    "tallyDefaults.widthAllowance": "Tolérance de Largeur",
    "tallyDefaults.thickAllowance": "Tolérance d'Épaisseur",
    "tallyDefaults.lengthAllowance": "Tolérance de Longueur",
    "tallyDefaults.girthAllowance": "Tolérance de Circonférence",
    "tallyDefaults.lengthAdjustments": "Ajustements de Longueur",
    "tallyDefaults.copyPrevLength": "Copier la Longueur Précédente",
    "tallyDefaults.addToLength": "Ajouter à la Longueur",
    "tallyDefaults.addToLengthValue": "Valeur à Ajouter à la Longueur",
    "tallyDefaults.validationRules": "Règles de Validation",
    "tallyDefaults.divisibleBy5": "Divisible par 5",
    "tallyDefaults.girthRange": "Plage de Circonférence",
    "tallyDefaults.lengthRange": "Plage de Longueur",
    "tallyDefaults.min": "Min",
    "tallyDefaults.max": "Max",
    "tallyDefaults.quickSearch": "Recherche Rapide",
    "tallyDefaults.toleranceHint": "Jusqu'où une recherche de taille simple peut s'écarter du nombre saisi tout en étant considérée comme correspondante — le bois réel correspond rarement exactement à la taille nominale.",
    "tallyDefaults.searchToleranceSquare": "Tolérance de Recherche — Carré",
    "tallyDefaults.searchToleranceRound": "Tolérance de Recherche — Rond",
    "tallyDefaults.resetTitle": "Réinitialiser les Valeurs par Défaut du Tally ?",
    "tallyDefaults.resetBody": "Cela réinitialise toutes les valeurs par défaut de cette page à leurs valeurs d'origine. Les Unités de Stock ayant déjà leurs propres paramètres enregistrés ne sont pas affectées.",
    "appSettings.resetAll": "Tout réinitialiser",
    "appSettings.resetAllTitle": "Réinitialiser tous les paramètres",
    "appSettings.resetAllBody": "Cela réinitialise les Rappels de paiement, la Devise, la Politique d'inventaire et l'Image de marque (si disponible) à leurs valeurs par défaut. Cette action est irréversible.",
    "common.resetToDefault": "Réinitialiser",
    "account.language.label": "Langue",
    "account.language.hint": "C'est la langue que vous verrez dans LumberLinq, sur n'importe quel appareil.",
    "currency.subtitle": "Définissez la devise dans laquelle vos rapports et tableaux de bord sont affichés.",
    "currency.resetTitle": "Réinitialiser la devise",
    "currency.resetBody": "Cela réinitialise votre devise de reporting à non définie. Cette action est irréversible.",
    "inventoryPolicy.subtitle": "Politique de stock à l'échelle de l'entreprise — s'applique à tous les utilisateurs.",
    "inventoryPolicy.allowOversell": "Autoriser les ventes au-delà du stock disponible",
    "inventoryPolicy.allowOversell.hint": "Désactivé par défaut — une vente est bloquée dès qu'elle utiliserait plus que ce qui est réellement en stock.",
    "inventoryPolicy.detailedTracking": "Suivre de quel achat provient le bois d'un ordre de sciage",
    "inventoryPolicy.detailedTracking.hint": "Désactivé par défaut — activez pour voir et ajuster à quel achat le stock d'un Lot groupé est attribué lors du sciage.",
    "inventoryPolicy.resetTitle": "Réinitialiser la politique d'inventaire",
    "inventoryPolicy.resetBody": "Cela restaure les deux options à leurs valeurs par défaut. Cette action est irréversible.",
    "company.manageBranding": "Gérer l'image de marque",
    "company.manageBrandingHint": "Téléversez ou définissez le logo de votre entreprise dans les Paramètres de l'application.",
    "company.signpost.text": "Vous cherchez la Devise, la Politique d'inventaire, les Rappels de paiement ou l'Image de marque ?",
    "company.signpost.link": "Paramètres de l'application",
    "branding.lockedTitle": "L'image de marque personnalisée est une fonctionnalité du forfait Forest",
    "branding.lockedBody": "Téléversez le logo de votre propre entreprise dans l'application, les exports et les e-mails avec le forfait Forest.",
    "branding.upgradeCta": "Passer au forfait Forest",
    "branding.chooseFile": "Choisir un fichier",
    "branding.dimensionHint": "PNG, JPG ou WEBP, idéalement autour de 584×158px (comme le logo LumberLinq lui-même) — minimum 200×50px, moins de 5 Mo.",
    "branding.resetTitle": "Réinitialiser le logo",
    "branding.resetBody": "Cela supprime votre logo personnalisé et réaffiche le logo LumberLinq par défaut. Cette action est irréversible.",
    "paymentReminders.resetTitle": "Réinitialiser les rappels de paiement",
    "paymentReminders.resetBody": "Cela restaure tous les paramètres des rappels de paiement à leurs valeurs par défaut. Cette action est irréversible.",
    "notifPrefs.sectionTitle": "Catégories de notifications push",
    "sessions.title": "Où vous êtes connecté",
    "sessions.subtitle": "Ces appareils sont connectés à votre compte. Déconnectez ceux que vous ne reconnaissez pas ou n’utilisez plus.",
    "sessions.thisDevice": "Cet appareil",
    "sessions.onlineNow": "En ligne maintenant",
    "sessions.unknownDevice": "Appareil inconnu",
    "sessions.slotWeb": "Navigateur",
    "sessions.slotApp": "Application",
    "sessions.signOut": "Se déconnecter",
    "sessions.signOutOthers": "Déconnecter tous les autres appareils",
    "sessions.cancel": "Annuler",
    "sessions.confirmHeader": "Déconnecter cet appareil ?",
    "sessions.confirmMessage": "{device} sera déconnecté et devra se reconnecter.",
    "sessions.confirmOthersHeader": "Déconnecter tous les autres appareils ?",
    "sessions.confirmOthersMessage": "Tous les appareils sauf celui-ci seront déconnectés et devront se reconnecter.",
    "sessions.signedOutToast": "L’appareil a été déconnecté.",
    "sessions.signedOutOthersToast": "Tous les autres appareils ont été déconnectés.",
    "sessions.signOutFailed": "Impossible de déconnecter l’appareil. Veuillez réessayer.",
    "sessions.loadFailed": "Impossible de charger vos appareils.",
    "sessions.retry": "Réessayer",
    "sessions.empty": "Aucun appareil trouvé.",
    "notifPrefs.sectionHint": "Désactivez une catégorie si vous ne voulez pas qu'elle alerte votre téléphone ou navigateur — vous la verrez quand même dans votre cloche de notifications.",
    "pushPrompt.title": "Activer les notifications ?",
    "pushPrompt.body": "Soyez informé dès qu'un statut d'expédition change, que quelqu'un partage un relevé avec vous, ou que votre équipe envoie une invitation.",
    "pushPrompt.enable": "Activer",
    "pushPrompt.notNow": "Pas maintenant",
    "appFeedback.menu": "Donner un avis",
    "appFeedback.title": "Donner un avis",
    "appFeedback.subtitle": "Dites-nous comment LumberLinq fonctionne pour vous",
    "appFeedback.question": "Comment LumberLinq fonctionne-t-il pour vous ?",
    "appFeedback.rate.sad": "Pas bien",
    "appFeedback.rate.neutral": "Correct",
    "appFeedback.rate.happy": "Bien",
    "appFeedback.rate.love": "J'adore",
    "appFeedback.likeLabel": "Qu'est-ce qui vous plaît le plus ?",
    "appFeedback.improveLabel": "Que devrions-nous améliorer ?",
    "appFeedback.privateNote": "Seule l'équipe LumberLinq voit ceci.",
    "appFeedback.showSection": "Sur notre site",
    "appFeedback.showName": "Afficher mon nom sur le site LumberLinq",
    "appFeedback.showNameHint": "Affiché avec le prénom + l'initiale, ex. \"Sanjay B.\", après validation par notre équipe.",
    "appFeedback.showCompany": "Afficher aussi le nom de mon entreprise",
    "appFeedback.showCompanyHint": "Désactivé sauf si vous l'activez.",
    "appFeedback.send": "Envoyer l'avis",
    "appFeedback.back": "Retour",
    "appFeedback.thanksTitle": "Merci !",
    "appFeedback.thanksBody": "Votre avis est bien parvenu à notre équipe.",
    "appFeedback.error": "Impossible d'envoyer votre avis. Veuillez réessayer.",
    "appFeedback.promptTitle": "Comment LumberLinq fonctionne-t-il pour vous ?",
    "appFeedback.promptBody": "Un seul geste — cela nous aide à l'améliorer.",
    "appFeedback.notNow": "Pas maintenant",
    "appFeedback.done": "Terminé",
    "appFeedback.chooseRating": "Choisissez d'abord votre ressenti",
    "adminFeedback.title": "Revue des avis",
    "pay.offlineOr": "ou",
    "pay.offlineProofLabel": "Justificatif de paiement (facultatif)",
    "pay.offlineProofChoose": "Choisir une photo ou un PDF",
    "pay.offlineProofHint": "Une capture d'écran du virement ou une photo du chèque nous aide à confirmer plus vite. JPG, PNG, WEBP, HEIC ou PDF, 8 Mo maximum.",
    "pay.offlineProofAttach": "Joindre un justificatif",
    "pay.offlineProofReplace": "Remplacer le justificatif",
    "pay.offlineProofSavedTitle": "Justificatif enregistré",
    "pay.offlineProofSavedBody": "Nous le verrons en vérifiant votre paiement.",
    "pay.offlineProofError": "Votre paiement est enregistré, mais le justificatif n'a pas pu être envoyé. Réessayez depuis la carte d'attente.",
    "pay.offlineProofBadTypeTitle": "Fichier non autorisé",
    "pay.offlineProofBadType": "Choisissez une photo (JPG, PNG, WEBP, HEIC) ou un PDF.",
    "pay.offlineProofTooBigTitle": "Fichier trop volumineux",
    "pay.offlineProofTooBig": "Le fichier doit faire 8 Mo maximum.",
    "adminOffline.viewProof": "Voir le justificatif",
    "adminOffline.noProof": "Aucun justificatif",
    "adminOffline.proofTitle": "Justificatif de paiement",
    "adminOffline.proofHint": "C'est ce que le client dit avoir payé. Vérifiez toujours l'argent sur votre relevé bancaire avant d'approuver.",
    "adminOffline.extra": "Excédent",
    "adminOffline.overWarn": "Supérieur au montant dû. Excédent",
    "pay.offlineTurnOffAuto": "Désactivez le renouvellement automatique ci-dessus pour payer par virement ou chèque.",
    "pay.offlineNotForMonthly": "Les offres mensuelles se renouvellent automatiquement : virement et chèque ne sont pas disponibles. Choisissez une offre plus longue.",
    "pay.offlineButton": "Payer par virement bancaire / chèque (INR)",
    "pay.offlineWaitingTitle": "Votre paiement attend une confirmation",
    "pay.offlineWaitingBody": "Nous vérifions la banque et activons votre offre. Vous recevrez un message dès que ce sera fait.",
    "pay.offlineTitle": "Payer par virement bancaire / chèque",
    "pay.offlineAmountToPay": "Montant à payer",
    "pay.offlineAmountHint": "Ce montant inclut la GST et votre remise. Veuillez payer exactement ce montant.",
    "pay.offlineAccountName": "Nom du compte",
    "pay.offlineBank": "Banque",
    "pay.offlineAccountNumber": "Numéro de compte",
    "pay.offlineBranch": "Agence",
    "pay.offlineChequeTo": "Chèque à l'ordre de",
    "pay.offlineChequeAddress": "Envoyer le chèque à",
    "pay.offlineRemarks": "À indiquer en référence",
    "pay.offlineRemarksHint": "Indiquez cette référence dans le motif du paiement (ou au dos du chèque) pour que nous retrouvions votre paiement.",
    "pay.offlineIPaid": "J'ai payé — saisissez les détails",
    "pay.offlineHowPaid": "Comment avez-vous payé ?",
    "pay.offlineUtr": "Numéro UTR du virement",
    "pay.offlineChequeNo": "Numéro du chèque",
    "pay.offlineRefError": "Saisissez le numéro UTR / chèque (4 caractères minimum).",
    "pay.offlineTransferDate": "Date du virement",
    "pay.offlineChequeDate": "Date du chèque",
    "pay.offlineYourBank": "Votre banque (facultatif)",
    "pay.offlineNote": "Note pour nous (facultatif)",
    "pay.offlineGstHint": "Votre facture GST vous est envoyée dès que le paiement est confirmé.",
    "pay.offlineCancel": "Annuler",
    "pay.offlineSubmit": "Envoyer les détails du paiement",
    "pay.offlineSentTitle": "Détails reçus",
    "pay.offlineSentBody": "Nous confirmerons votre paiement et activerons votre offre. Vous recevrez un message.",
    "pay.offlineLoadError": "Impossible de charger les coordonnées bancaires. Réessayez.",
    "pay.offlineSubmitError": "Impossible d'enregistrer les détails. Rien n'a été débité — réessayez.",
    "adminOffline.title": "Paiements hors ligne",
    "lincLearning.title": "Apprentissage de Linc",
    "lincLearning.subtitle": "Questions mal traitées par l’Assistant et changements de règles en attente de votre approbation",
    "lincLearning.tabFindings": "Questions en échec",
    "lincLearning.tabProposals": "Propositions",
    "lincLearning.tabRuleBook": "Livre de règles",
    "lincLearning.grade.OK": "Correct",
    "lincLearning.grade.PART": "Partiel",
    "lincLearning.grade.WRONG": "Faux",
    "lincLearning.grade.NONE": "Sans réponse",
    "lincLearning.allGrades": "Tous les résultats",
    "lincLearning.allRuns": "Toutes les vérifications",
    "lincLearning.handledAll": "Traitées ou non",
    "lincLearning.handledYes": "Traitées",
    "lincLearning.handledNo": "À traiter",
    "lincLearning.search": "Rechercher une question ou un groupe",
    "lincLearning.colQuestion": "Question",
    "lincLearning.colAnswer": "Réponse donnée",
    "lincLearning.colTrue": "Bonne réponse",
    "lincLearning.colNote": "Note",
    "lincLearning.markHandled": "Marquer comme traitée",
    "lincLearning.unmark": "Marquer à traiter",
    "lincLearning.prev": "Précédent",
    "lincLearning.next": "Suivant",
    "lincLearning.page": "Page",
    "lincLearning.empty": "Rien ici.",
    "lincLearning.kind.WORD": "Mot du métier",
    "lincLearning.kind.ASK_BACK": "Poser la question",
    "lincLearning.kind.DEFINITION": "Définition",
    "lincLearning.kind.NEW_DATA": "Nouvelles données nécessaires",
    "lincLearning.kind.OTHER": "Autre",
    "lincLearning.status.PROPOSED": "En attente",
    "lincLearning.status.APPROVED": "Approuvée",
    "lincLearning.status.REJECTED": "Rejetée",
    "lincLearning.approve": "Approuver",
    "lincLearning.reject": "Rejeter",
    "lincLearning.undo": "Remettre en attente",
    "lincLearning.noteHint": "Note (facultatif)",
    "lincLearning.reviewNow": "Lancer la revue maintenant",
    "lincLearning.reviewNote": "La revue se lance aussi toute seule un jour sur deux.",
    "lincLearning.addWord": "Ajouter un mot du métier",
    "lincLearning.word": "Mot (par exemple silly)",
    "lincLearning.means": "Ce que cela veut dire",
    "lincLearning.add": "Ajouter",
    "lincLearning.evidence": "Questions à l’origine",
    "lincLearning.seen": "fois demandé",
    "lincLearning.companies": "entreprises",
    "lincLearning.source": "Source",
    "lincLearning.decidedBy": "Décidé par",
    "lincLearning.termsTitle": "Mots du métier que l’Assistant connaît",
    "lincLearning.defsTitle": "Définitions écrites",
    "lincLearning.rulebookNote": "Le livre de règles intégré ne change qu’avec une version du logiciel. Les mots approuvés s’ajoutent et agissent aussitôt.",
    "lincLearning.done": "Enregistré",
    "lincLearning.failed": "Impossible de terminer",
    "adminOffline.subtitle": "Confirmez les virements et chèques payés par les clients",
    "adminOffline.waiting": "en attente",
    "adminOffline.bankDetails": "Coordonnées bancaires",
    "adminOffline.refresh": "Actualiser",
    "adminOffline.noAccessTitle": "Pas d'accès",
    "adminOffline.noAccessBody": "Seuls les approbateurs de paiements peuvent ouvrir cette page.",
    "adminOffline.search": "Rechercher société, UTR, e-mail",
    "adminOffline.tabWaiting": "En attente",
    "adminOffline.tabApproved": "Approuvé",
    "adminOffline.tabRejected": "Rejeté",
    "adminOffline.tabReversed": "Annulé",
    "offlineHist.bannerTitle": "Votre paiement attend sa confirmation",
    "offlineHist.bannerBody": "Votre forfait démarre dès la confirmation, et nous vous enverrons un e-mail.",
    "offlineHist.viewDetails": "Détails",
    "offlineHist.withdraw": "Retirer",
    "offlineHist.withdrawTitle": "Retirer ce paiement ?",
    "offlineHist.withdrawConfirm": "À utiliser si vous avez saisi un mauvais UTR ou numéro de chèque, ou payé autrement. Le paiement ne sera pas confirmé et vous pourrez le soumettre à nouveau.",
    "offlineHist.withdrawYes": "Oui, retirer",
    "offlineHist.withdrawNo": "Conserver",
    "offlineHist.withdrawnTitle": "Paiement retiré",
    "offlineHist.withdrawnBody": "Vous pouvez soumettre à nouveau les détails du paiement ou payer en ligne.",
    "offlineHist.withdrawError": "Impossible de retirer le paiement. Veuillez réessayer.",
    "offlineHist.title": "Paiements par virement bancaire et chèque",
    "offlineHist.subtitle": "Paiements déclarés pour votre entreprise",
    "offlineHist.submitted": "Soumis le",
    "offlineHist.reason": "Motif",
    "offlineHist.statusWaiting": "En attente de confirmation",
    "offlineHist.statusConfirmed": "Confirmé",
    "offlineHist.statusRejected": "Non confirmé",
    "offlineHist.statusReversed": "Annulé",
    "offlineHist.statusWithdrawn": "Retiré",
    "offlineHist.buyBlocked": "Un paiement par virement / chèque attend sa confirmation. Vous pourrez choisir un autre forfait une fois qu'il sera confirmé, non confirmé ou retiré.",
    "adminOffline.tabWithdrawn": "Retirés",
    "adminOffline.otherPlanWarn": "Cette entreprise a déjà obtenu un autre forfait actif après la soumission de ce paiement :",
    "adminOffline.otherPlanConfirm": "J'ai vérifié et je veux approuver quand même (un deuxième forfait sera ajouté)",
    "adminOffline.colCompany": "Société",
    "adminOffline.colPayment": "Paiement",
    "adminOffline.colAmount": "Montant",
    "adminOffline.colPlan": "Offre",
    "adminOffline.colStatus": "Statut",
    "adminOffline.colSubmitted": "Envoyé",
    "adminOffline.received": "Reçu",
    "adminOffline.shortBy": "Manquant",
    "adminOffline.approve": "Approuver",
    "adminOffline.reject": "Rejeter",
    "adminOffline.reverse": "Annuler",
    "adminOffline.cancel": "Annuler",
    "adminOffline.save": "Enregistrer",
    "adminOffline.emptyTitle": "Rien ici",
    "adminOffline.emptyBody": "Les paiements soumis par virement ou chèque apparaîtront ici.",
    "adminOffline.approveTitle": "Approuver le paiement",
    "adminOffline.dateOnPayment": "Date",
    "adminOffline.amountDue": "Montant dû",
    "adminOffline.checkStatement": "Vérifiez d'abord votre relevé bancaire. N'approuvez que lorsque l'argent est arrivé.",
    "adminOffline.receivedAmount": "Montant reçu à la banque",
    "adminOffline.shortWarn": "Inférieur au montant dû. Manque",
    "adminOffline.acceptShort": "Accepter le paiement partiel (par exemple, retenue à la source)",
    "adminOffline.note": "Note",
    "adminOffline.approvedOk": "Paiement approuvé. L'offre est active.",
    "adminOffline.rejectTitle": "Rejeter le paiement",
    "adminOffline.rejectReason": "Motif",
    "adminOffline.rejectHint": "Le client voit ce motif.",
    "adminOffline.rejectedOk": "Paiement rejeté. Le client a été informé.",
    "adminOffline.reverseTitle": "Annuler le paiement (chèque rejeté / remboursement)",
    "adminOffline.chooseOption": "Choisissez ce qui arrive à l'offre",
    "adminOffline.optDeactivate": "Désactiver l'offre maintenant",
    "adminOffline.optDeactivateSub": "La société perd l'offre payante immédiatement.",
    "adminOffline.optGrace": "Accorder un délai",
    "adminOffline.optGraceSub": "L'offre reste active 7, 15 ou 30 jours de plus, puis prend fin.",
    "adminOffline.optKeep": "Garder l'offre active",
    "adminOffline.optKeepSub": "Enregistre seulement l'annulation. Vous réglez avec le client.",
    "adminOffline.optRefund": "Rembourser et désactiver",
    "adminOffline.optRefundSub": "Enregistrez le remboursement effectué et terminez l'offre maintenant.",
    "adminOffline.graceDays": "Délai (jours)",
    "adminOffline.refundAmount": "Montant du remboursement",
    "adminOffline.refundRef": "Référence bancaire du remboursement",
    "adminOffline.creditNoteNo": "Numéro de l'avoir (facultatif)",
    "adminOffline.creditNoteHint": "L'application ne crée pas d'avoirs. Saisissez le numéro une fois émis par votre équipe finance.",
    "adminOffline.commissionWarn": "La commission d'affiliation n'est pas annulée automatiquement. Vérifiez-la à la main.",
    "adminOffline.reversedOk": "Paiement annulé. Le client a été informé.",
    "adminOffline.optionOn": "Proposer cette option aux clients",
    "adminOffline.optionOnHint": "Les clients la voient sur la page de paiement des offres INR, une fois les champs obligatoires remplis.",
    "adminOffline.accountName": "Nom du compte",
    "adminOffline.bank": "Banque",
    "adminOffline.accountNumber": "Numéro de compte",
    "adminOffline.branch": "Agence",
    "adminOffline.chequePayableTo": "Chèque à l'ordre de",
    "adminOffline.chequeAddress": "Adresse d'envoi des chèques",
    "adminOffline.instructions": "Instructions supplémentaires pour les clients",
    "adminOffline.lastUpdated": "Dernière modification par",
    "adminOffline.settingsSaved": "Coordonnées enregistrées",
    "adminOffline.errorTitle": "Impossible de terminer",
    "adminOffline.errorGeneric": "Une erreur s'est produite. Réessayez.",
    "adminFeedback.subtitle": "Validez les avis avant leur affichage sur lumberlinq.com",
    "adminFeedback.pending": "En attente",
    "adminFeedback.approved": "Validés",
    "adminFeedback.rejected": "Refusés",
    "adminFeedback.approve": "Valider",
    "adminFeedback.reject": "Refuser",
    "adminFeedback.reset": "Remettre en attente",
    "adminFeedback.colPerson": "Personne",
    "adminFeedback.colRating": "Note",
    "adminFeedback.colFeedback": "Avis",
    "adminFeedback.colWebsite": "Sur le site",
    "adminFeedback.colSource": "Source",
    "adminFeedback.colDate": "Date",
    "adminFeedback.sourcePublic": "Formulaire du site",
    "adminFeedback.sourceApp": "Dans l'app",
    "adminFeedback.willShowAs": "S'affichera comme",
    "adminFeedback.notOptedIn": "Nom non affiché (pas d'accord donné)",
    "adminFeedback.noName": "Aucun nom indiqué",
    "adminFeedback.emptyTitle": "Rien ici pour l'instant",
    "adminFeedback.emptyBody": "Aucun avis dans cette liste.",
    "adminFeedback.liked": "A aimé",
    "adminFeedback.problem": "Problème (privé)",
    "adminFeedback.search": "Rechercher un nom, une entreprise ou un texte",
    "adminFeedback.statusChanged": "Avis mis à jour",
    "adminFeedback.loadError": "Impossible de charger les avis",
    "adminFeedback.withCompany": "avec entreprise",
    "adminFeedback.refresh": "Actualiser",
    "appSettings.feedbackSection": "Avis et notes sur les stores",
    "appSettings.feedbackPromptEnabled": "Demander un avis aux utilisateurs dans l'app",
    "appSettings.feedbackPromptHint": "Affiche une petite carte \"Comment LumberLinq fonctionne-t-il pour vous ?\" sur le tableau de bord. Les réponses vont dans la Revue des avis, jamais vers les stores.",
    "appSettings.feedbackPromptAfterDays": "Demander après (jours depuis l'inscription)",
    "appSettings.feedbackPromptRepeatDays": "Ne plus demander pendant (jours)",
    "appSettings.storeReviewEnabled": "Demander une note App Store / Play Store",
    "appSettings.storeReviewHint": "Utilise la fenêtre de notation d'Apple et de Google sur iPhone et Android. Déclenchée uniquement par l'usage — jamais liée à la carte d'avis.",
    "appSettings.storeReviewAfterTallies": "Après ce nombre de fiches de pointage",
    "appSettings.storeReviewAfterDays": "Ou après (jours depuis l'inscription)",
    "notifPrefs.pushStatusTitle": "Notifications Push",
    "notifPrefs.pushGrantedHint": "Les notifications push sont activées pour cet appareil.",
    "notifPrefs.pushPromptHint": "Activez les notifications pour recevoir des alertes sur cet appareil.",
    "notifPrefs.pushDeniedNativeHint": "Les notifications sont désactivées pour cet appareil.",
    "notifPrefs.pushDeniedWebHint": "Les notifications sont bloquées pour ce site — activez-les dans les paramètres de votre navigateur.",
    "notifPrefs.pushUnsupportedHint": "Cet appareil ou navigateur ne prend pas en charge les notifications push.",
    "notifPrefs.pushEnableButton": "Activer",
    "notifPrefs.openSettingsButton": "Ouvrir les paramètres",
    "notifPrefs.teamInvites": "Invitations d'équipe",
    "notifPrefs.teamInvites.hint": "Quand quelqu'un vous invite dans une équipe, ou que votre invitation est acceptée ou refusée.",
    "notifPrefs.security": "Alertes de sécurité",
    "notifPrefs.security.hint": "Avis de connexion et de sécurité du compte. Les alertes critiques, comme un changement de mot de passe, sont toujours envoyées quel que soit ce réglage.",
    "notifPrefs.billing": "Facturation et paiements",
    "notifPrefs.billing.hint": "Renouvellements d'abonnement, rappels de paiement, factures et mises à jour des paiements par virement / chèque.",
    "notifPrefs.shipments": "Expéditions",
    "notifPrefs.shipments.hint": "Mises à jour sur vos expéditions et envois.",
    "notifPrefs.tally": "Fiches de tally",
    "notifPrefs.tally.hint": "Mises à jour sur les fiches de tally sur lesquelles vous travaillez.",
    "notifPrefs.inventoryProcess": "Inventaire et ordres de sciage",
    "notifPrefs.inventoryProcess.hint": "Mouvements de stock et mises à jour des ordres de sciage.",
    "notifPrefs.masterData": "Produits, partenaires et sites",
    "notifPrefs.masterData.hint": "Modifications des produits, partenaires commerciaux ou sites.",
    "notifPrefs.shareLinks": "Liens partagés",
    "notifPrefs.shareLinks.hint": "Activité sur les liens que vous avez partagés avec d'autres.",
    "notifPrefs.affiliate": "Programme d'affiliation",
    "notifPrefs.affiliate.hint": "Statut de candidature, commissions et paiements de votre compte affilié.",
    "notifPrefs.crm": "CRM commercial",
    "notifPrefs.crm.hint": "Prospects qui vous sont attribués, rappels de tâches, réponses, mises à jour de commissions et de paiements, et jalons d'objectifs.",
    "common.typeConfirm": "Tapez CONFIRM pour continuer",
    "paymentReminders.offBanner": "Les rappels de paiement sont désactivés — ces paramètres sont enregistrés mais ne prendront effet que lorsque vous les activerez ci-dessus.",
    "settingsNudge.title": "Terminez la configuration de votre espace de travail",
    "settingsNudge.body": "Devise, image de marque, rappels de paiement et plus encore — tout au même endroit.",
    "settingsNudge.cta": "Ouvrir les paramètres de l'application",
    "paymentReminders.testEmail.title": "Envoyer des e-mails de test",
    "paymentReminders.testEmail.desc": "Prévisualisez le format exact du rappel + rapport avant de l'activer pour de vrais partenaires commerciaux. N'affecte jamais les données réelles.",
    "paymentReminders.testEmail.cta": "Envoyer le test",
    "Mill Jobs": "Ordres de sciage",
    "Stock in Hand": "Stock disponible",
    "crm.liveCall.button": "Appel vidéo",
    "crm.liveCall.title": "Appel vidéo",
    "crm.liveCall.starting": "Démarrage de l'appel…",
    "crm.liveCall.startFailed": "Impossible de démarrer l'appel.",
    "crm.liveCall.retry": "Réessayer",
    "crm.liveCall.inProgress": "Un appel est en cours.",
    "crm.liveCall.rejoin": "Rejoindre à nouveau",
    "crm.liveCall.end": "Terminer l'appel",
    "crm.liveCall.endConfirm": "Terminer l'appel pour tout le monde ?",
    "crm.liveCall.openTab": "Ouvrir dans un nouvel onglet",
    "crm.liveCall.frameHint": "Si l'appel ne s'affiche pas ici, ouvrez-le dans un nouvel onglet.",
    "crm.liveCall.inviteTitle": "Inviter un invité",
    "crm.liveCall.makeLink": "Créer le lien d'invité",
    "crm.liveCall.newLink": "Créer un nouveau lien",
    "crm.liveCall.copyLink": "Copier",
    "crm.liveCall.linkCopied": "Copié",
    "crm.liveCall.newLinkNote": "Créer un nouveau lien désactive l'ancien. Le lien reste valable quelques heures.",
    "crm.liveCall.cancelLink": "Annuler le lien",
    "crm.liveCall.linkCancelled": "Le lien invité ne fonctionne plus.",
    "crm.liveCall.whoJoined": "Qui a rejoint",
    "crm.liveCall.noOneJoined": "Personne n'a encore rejoint via le lien.",
    "crm.liveCall.admitNote": "Chaque invité attend que vous le laissiez entrer : appuyez sur Admit dans l'appel. Les invités ne peuvent pas envoyer de fichiers sauf si vous l'autorisez dans les réglages de l'appel.",
    "crm.liveCall.codeNote": "Un lien envoyé par e-mail demande aussi un code à 6 chiffres envoyé à cette même adresse : un lien transféré ne sert à rien. Ne transférez pas non plus un lien que vous avez copié vous-même.",
    "crm.liveCall.emailPlaceholder": "E-mail de l'invité",
    "crm.liveCall.sendEmail": "Envoyer par e-mail",
    "crm.liveCall.emailSent": "L'invitation a été envoyée.",
    "crm.liveCall.enterEmail": "Saisissez l'adresse e-mail de l'invité.",
    "crm.liveCall.phoneNote": "Pour présenter votre écran, utilisez un ordinateur. Les téléphones peuvent rejoindre et parler.",
    "live.title": "Rejoindre l'appel vidéo",
    "live.host": "Hôte",
    "live.name": "Votre nom",
    "live.email": "Votre e-mail",
    "live.join": "Rejoindre l'appel",
    "live.joining": "Connexion…",
    "live.loading": "Chargement…",
    "live.privacy": "Nous utilisons votre nom et votre e-mail uniquement pour cet appel. L'appel n'est pas enregistré.",
    "live.phoneNote": "Vous pouvez rejoindre depuis un téléphone. Autorisez la caméra et le micro lorsque c'est demandé.",
    "live.linkOnly": "Ce lien est uniquement pour vous. Merci de ne pas le transférer.",
    "live.waitNote": "Une fois connecté, l'hôte vous laisse entrer. Cela peut prendre un instant.",
    "live.codeIntro": "Pour vérifier que c'est bien vous, nous envoyons un code à 6 chiffres à l'adresse qui a reçu l'invitation :",
    "live.sendCode": "M'envoyer un code",
    "live.sendAgain": "Renvoyer",
    "live.codeSent": "Code envoyé. Il est valable 10 minutes.",
    "live.codeLabel": "Code à 6 chiffres",
    "cw.focusOn": "Plein écran : masquer la barre du haut",
    "cw.focusOff": "Afficher la barre du haut",
    "ch.help": "Aide",
    "ch.guest.title": "Difficulté pour rejoindre ?",
    "ch.guest.t1": "Utilisez un ordinateur ou un téléphone avec caméra et micro. Chrome, Edge, Safari et Firefox fonctionnent.",
    "ch.guest.t2": "Quand le navigateur le demande, appuyez sur Autoriser pour la caméra et le micro.",
    "ch.guest.t3": "Après avoir appuyé sur Rejoindre, l'hôte doit vous laisser entrer. Patientez un instant.",
    "ch.guest.t4": "Pas d'image ni de son ? Cliquez sur l'icône caméra ou cadenas dans la barre d'adresse, choisissez Autoriser, puis actualisez la page.",
    "ch.guest.t5": "Bloqué sur « Démarrage de l'appel… » ? Vérifiez votre connexion, puis appuyez sur Réessayer ou Ouvrir dans un nouvel onglet.",
    "ch.guest.t6": "Ce lien est uniquement pour vous. Si quelqu'un d'autre doit rejoindre, demandez à l'équipe LumberLinq de l'inviter.",
    "ch.customer.title": "Comment fonctionne l'assistance par écran",
    "ch.customer.t1": "L'assistance demande à voir votre écran. Rien ne démarre tant que vous n'appuyez pas vous-même sur le bouton de partage.",
    "ch.customer.t2": "Choisissez uniquement l'onglet LumberLinq. Ne choisissez pas tout l'écran ni une autre fenêtre.",
    "ch.customer.t3": "L'assistance peut seulement regarder. Elle ne peut ni cliquer ni écrire à votre place, et rien n'est enregistré.",
    "ch.customer.t4": "Appuyez sur Arrêter en haut quand vous voulez finir. Un téléphone ou l'application ne peut pas partager l'écran : utilisez Chrome ou Edge sur ordinateur.",
    "ch.host.title": "Guide de l'appel vidéo",
    "ch.host.t1": "Démarrez l'appel depuis le compte ou l'affaire. Vous rejoignez en tant qu'hôte.",
    "ch.host.t2": "Envoyer le lien par e-mail est le plus sûr : l'invité a besoin d'un code à 6 chiffres envoyé à cette adresse.",
    "ch.host.t3": "Chaque invité attend que vous appuyiez sur Admit dans l'appel. Admettez seulement des personnes que vous connaissez.",
    "ch.host.t4": "Voyez « Qui a rejoint » ci-dessous. Si une personne inconnue est là, retirez-la dans l'appel et appuyez sur Annuler le lien.",
    "ch.host.t5": "Ne transférez jamais vous-même un lien d'invité. Créez un nouveau lien pour chaque personne.",
    "ch.host.t6": "Appuyez sur Terminer l'appel à la fin. Une entrée d'appel vidéo est ajoutée à la chronologie du compte. Rien n'est enregistré.",
    "ch.check.run": "Vérifier ma configuration",
    "ch.check.testing": "Test en cours…",
    "ch.check.browserOk": "Ce navigateur peut rejoindre un appel.",
    "ch.check.browserBad": "Ce navigateur ne peut pas rejoindre un appel. Utilisez Chrome, Edge, Safari ou Firefox.",
    "ch.check.onlineOk": "Votre connexion internet fonctionne.",
    "ch.check.onlineBad": "Vous semblez hors ligne. Vérifiez votre connexion.",
    "ch.check.camOk": "La caméra fonctionne.",
    "ch.check.camBad": "La caméra est bloquée ou introuvable. Autorisez-la dans la barre d'adresse, puis testez à nouveau.",
    "ch.check.micOk": "Le micro fonctionne.",
    "ch.check.micBad": "Le micro est bloqué ou introuvable. Autorisez-le dans la barre d'adresse, puis testez à nouveau.",
    "ch.check.shareOk": "Vous pouvez partager votre écran.",
    "ch.check.shareNo": "Cet appareil ne peut pas partager l'écran (téléphones et application non). Vous pouvez quand même parler et écrire.",
    "live.ended": "Cet appel est terminé.",
    "live.expired": "Ce lien a expiré. Demandez-en un nouveau.",
    "live.off": "Les appels vidéo sont désactivés pour le moment.",
    "live.invalid": "Ce lien n'est pas valide.",
    "live.failed": "Connexion impossible. Veuillez réessayer.",
    "live.securityWait": "Veuillez terminer la vérification de sécurité.",
    "live.frameHint": "Si l'appel ne s'affiche pas ici, ouvrez-le dans un nouvel onglet.",
    "live.openTab": "Ouvrir dans un nouvel onglet",
    "ss.title": "Assistance par écran",
    "ss.joining": "Connexion…",
    "ss.failed": "Connexion impossible. Veuillez réessayer.",
    "ss.retry": "Réessayer",
    "ss.howTitle": "Comment partager votre onglet LumberLinq",
    "ss.step1": "Appuyez sur le bouton de partage d'écran (l'icône d'écran) en bas de l'appel.",
    "ss.step2": "Choisissez l'onglet nommé LumberLinq (\"Cet onglet\"). Ne choisissez ni une fenêtre ni tout l'écran.",
    "ss.step3": "Vous pouvez arrêter à tout moment avec le bouton « Arrêter le partage » de votre navigateur, ou appuyer sur Arrêter la session ici.",
    "ss.noShare": "Le partage d'écran ne fonctionne pas sur un téléphone ni dans l'application. Ouvrez LumberLinq dans un navigateur d'ordinateur (Chrome, Edge, Firefox ou Safari) pour partager votre onglet LumberLinq. Vous pouvez quand même parler et discuter avec l'assistance ici.",
    "ss.liveBanner": "L'assistance ne voit que l'onglet que vous choisissez de partager. Rien n'est enregistré.",
    "ss.stop": "Arrêter la session",
    "ss.stopConfirm": "Arrêter cette session d'assistance par écran ?",
    "ss.openTab": "Ouvrir dans un nouvel onglet",
    "ss.frameHint": "Si l'appel ne s'affiche pas ici, ouvrez-le dans un nouvel onglet.",
    "ss.tabOnly": "Seul votre onglet LumberLinq est partagé, rien d'autre.",
    "ss.card.title": "Assistance par écran",
    "ss.card.ask": "Demander à l'assistance de voir mon onglet LumberLinq",
    "ss.card.askHint": "L'assistance peut regarder votre onglet LumberLinq pour vous aider. Seul cet onglet est partagé, c'est vous qui démarrez, et vous pouvez arrêter à tout moment. Rien n'est enregistré.",
    "ss.card.waiting": "En attente de la réponse de l'assistance…",
    "ss.card.cancel": "Annuler la demande",
    "ss.card.invited": "L'assistance aimerait voir votre onglet LumberLinq.",
    "ss.card.invitedOther": "L'assistance a demandé à une autre personne de votre entreprise de partager son écran.",
    "ss.card.share": "Partager mon onglet LumberLinq",
    "ss.card.notNow": "Pas maintenant",
    "ss.card.live": "Une session d'assistance par écran est ouverte.",
    "ss.card.liveOther": "Une session d'assistance par écran est ouverte avec une autre personne de votre entreprise.",
    "ss.card.rejoin": "Ouvrir la session",
    "ss.card.ended": "La dernière session d'assistance par écran est terminée.",
    "ss.card.declined": "La dernière demande d'assistance par écran a été refusée.",
    "ss.card.expired": "La dernière demande d'assistance par écran a expiré.",
    "ss.card.requestFailed": "Impossible d'envoyer la demande.",
    "ss.prompt.title": "L'assistance aimerait voir votre écran",
    "ss.prompt.body": "L'assistance vous attend. C'est vous qui démarrez et vous pouvez arrêter à tout moment. Rien n'est enregistré.",
    "ss.prompt.open": "Ouvrir maintenant",
    "ss.prompt.later": "Pas maintenant",
    "ss.prompt.ticket": "Ouvrir le ticket",
  },
  es: {
    "crmwa.newNumbers": "Números nuevos",
    "crmwa.newNumbersHint": "Personas que te escribieron desde un número que no está guardado en el CRM.",
    "crmwa.tabNew": "En espera",
    "crmwa.tabBlocked": "Bloqueados",
    "crmwa.searchPlaceholder": "Buscar nombre o número…",
    "crmwa.firstMessage": "Primer mensaje",
    "crmwa.lastMessage": "Último",
    "crmwa.noName": "Nombre no compartido",
    "crmwa.notSaved": "Aún no está en tu CRM",
    "crmwa.createLead": "Crear lead",
    "crmwa.block": "Bloquear como spam",
    "crmwa.unblock": "Desbloquear",
    "crmwa.blockedBadge": "Bloqueado",
    "crmwa.leadBadge": "Lead creado",
    "crmwa.openChat": "Abrir chat",
    "crmwa.emptyTitle": "No hay números nuevos",
    "crmwa.emptySub": "Cuando alguien nuevo escriba a tu número de WhatsApp, aparecerá aquí para que lo revises. Los contactos guardados nunca aparecen aquí.",
    "crmwa.emptyBlockedTitle": "No hay números bloqueados",
    "crmwa.emptyBlockedSub": "Los números que bloqueas como spam aparecen aquí, para que puedas desbloquearlos cuando quieras.",
    "crmwa.selectTitle": "Selecciona un número",
    "crmwa.selectSub": "Lee lo que escribió y luego crea un lead o bloquea el número.",
    "crmwa.whatTheyWrote": "Lo que escribió",
    "crmwa.blockedNote": "Los mensajes de este número se ignoran. Desbloquéalo para ver mensajes nuevos.",
    "crmwa.blockConfirmTitle": "¿Bloquear este número?",
    "crmwa.blockConfirmSub": "Sus mensajes nuevos se ignorarán. Puedes desbloquearlo después desde la pestaña Bloqueados.",
    "crmwa.cancel": "Cancelar",
    "crmwa.blockConfirm": "Sí, bloquear",
    "crmwa.blockedToast": "Número bloqueado",
    "crmwa.unblockedToast": "Número desbloqueado",
    "crmwa.leadCreatedToast": "Lead creado",
    "crmwa.leadCreatedSub": "El chat ya está en tu Bandeja de entrada.",
    "crmwa.errorTitle": "Algo salió mal",
    "crmwa.loadError": "No se pudieron cargar los números.",
    "crmwa.sheetTitle": "Crear lead",
    "crmwa.sheetSub": "Convierte este número de WhatsApp en un lead que tu equipo pueda seguir.",
    "crmwa.fldName": "Nombre de la persona",
    "crmwa.fldNameHint": "De su perfil de WhatsApp. Puedes corregirlo.",
    "crmwa.fldCompany": "Empresa (opcional)",
    "crmwa.fldCompanyHint": "Déjalo vacío para usar su nombre y número.",
    "crmwa.fldOwner": "Responsable del lead",
    "crmwa.ownerOnlyYou": "Este lead será tuyo.",
    "crmwa.fldNote": "Nota (opcional)",
    "crmwa.notePlaceholder": "Algo que el equipo deba saber…",
    "crmwa.accountWillBe": "Nombre de la cuenta",
    "crmwa.contactWillBe": "Contacto",
    "crmwa.you": "Tú",
    "crmwa.creating": "Creando…",
    "crmwa.whatHappens": "Esto crea una cuenta, un contacto con este número móvil y un negocio, y lleva el chat a tu Bandeja de entrada.",
    "crmwa.close": "Cerrar",
    "crmwa.mobile": "Móvil",
    "crmwa.pickOwner": "Elige quién será el responsable de este lead",
    "crmwa.freeTextNote": "Puedes responder con texto libre durante 24 horas después de su último mensaje.",
    "crmai.headerBtn": "Linc AI",
    "crmai.barOn": "Linc AI está respondiendo este chat",
    "crmai.barSuggest": "Linc AI escribe respuestas sugeridas para ti",
    "crmai.barPaused": "Tienes este chat. Linc AI guarda silencio por un tiempo.",
    "crmai.barHandoff": "Linc AI te pasó este chat.",
    "crmai.barStopped": "Linc AI está detenido en este chat.",
    "crmai.stoppedSpam": "Parecía spam.",
    "crmai.stoppedFlood": "El cliente envió demasiados mensajes demasiado rápido.",
    "crmai.stoppedPerson": "Se desactivó aquí.",
    "crmai.takeOver": "Yo me encargo",
    "crmai.stop": "Detener la IA aquí",
    "crmai.handBack": "Dejar que Linc AI responda",
    "crmai.draftTitle": "Sugerencia de Linc AI",
    "crmai.draftHandoff": "Linc AI cree que una persona debe encargarse",
    "crmai.draftUse": "Usar esta respuesta",
    "crmai.draftDiscard": "Descartar",
    "crmai.takeOverToast": "Linc AI guardará silencio en este chat",
    "crmai.stopToast": "Linc AI detenido en este chat",
    "crmai.handBackToast": "Linc AI volverá a responder",
    "crmai.settings": "Respuestas de Linc AI",
    "crmai.settingsSub": "Elige para quién responde Linc AI y cómo.",
    "crmai.master": "Interruptor general",
    "crmai.masterHint": "Apagado significa que Linc AI nunca escribe a nadie.",
    "crmai.modeOff": "Apagado",
    "crmai.modeSuggest": "Sugerir",
    "crmai.modeAuto": "Automático",
    "crmai.modeSuggestHint": "Linc AI escribe un borrador. Una persona lo revisa y lo envía.",
    "crmai.modeAutoHint": "Linc AI responde solo y pasa a una persona cuando hace falta.",
    "crmai.team": "Vendedores",
    "crmai.teamHint": "Linc AI responde los chats de las cuentas de personas en Sugerir o Automático.",
    "crmai.unowned": "Chats sin responsable",
    "crmai.coreLocked": "Solo un Super Admin o Root puede cambiar esto.",
    "crmai.limits": "Límites",
    "crmai.maxInRow": "Mensajes seguidos de Linc AI, luego pasa a una persona",
    "crmai.maxPerHour": "Máximo de mensajes de Linc AI por hora",
    "crmai.maxPerDay": "Máximo de mensajes de Linc AI por día",
    "crmauto.chip": "Sin revisar",
    "crmauto.chipTip": "Añadido automáticamente desde un mensaje de WhatsApp. Revise el nombre y el número y pulse Confirmar.",
    "crmauto.confirm": "Confirmar contacto",
    "crmauto.confirmTip": "He revisado este contacto",
    "crmauto.confirmedTitle": "Confirmado",
    "crmauto.confirmedText": "La etiqueta Sin revisar ha desaparecido.",
    "crmauto.settingTitle": "Añadir automáticamente los nuevos números de WhatsApp",
    "crmauto.settingHint": "Cuando alguien nuevo escriba por WhatsApp, añadirlo automáticamente como contacto (con la etiqueta Sin revisar) para que Linc AI pueda responder. El spam, el exceso de mensajes y los números bloqueados nunca se añaden. Solo un Super Admin o Root puede cambiar esto.",
    "crmauto.settingSwitch": "Añadir números nuevos automáticamente",
    "crmauto.perDay": "Máximo de contactos añadidos automáticamente por día",
    "legal.bannerTitleUpdated": "Documentos legales actualizados.",
    "legal.bannerLeadUpdated": "Hemos actualizado",
    "legal.bannerTitleNew": "Acepte nuestros documentos legales.",
    "legal.bannerLeadNew": "Revise",
    "legal.dialogTitleUpdated": "Documentos legales actualizados",
    "legal.dialogTitleNew": "Documentos legales",
    "legal.dialogBodyUpdated": "Hemos actualizado los documentos siguientes. Revíselos y confirme para continuar.",
    "legal.dialogBodyNew": "Revise los documentos siguientes y confirme para continuar.",
    "invite.acceptTitle": "Unirse a esta empresa",
    "invite.acceptText": "Antes de unirse, confirme el acuerdo.",
    "invite.acceptButton": "Aceptar invitación",
    "pay.offlineLive": "Esta página se actualiza sola.",
    "pay.cardPaused": "El pago con tarjeta está en pausa mientras su transferencia espera.",
    "pay.outcomeApprovedTitle": "Su pago fue confirmado",
    "pay.outcomeApprovedBody": "Su plan está activo. Continúe para empezar a usar LumberLinq.",
    "pay.outcomeContinue": "Continuar",
    "pay.outcomeRejectedTitle": "No se pudo confirmar su pago",
    "pay.outcomeReversedTitle": "Su pago fue revertido",
    "pay.outcomeTryAgainBody": "Puede enviarlo de nuevo o pagar de otra forma.",
    "pay.outcomeTryAgain": "Pagar de nuevo",
    "sp.seePlans": "Ver planes",
    "sp.backToWaiting": "Volver a mi pago",
    "sp.yourSelection": "Su selección",
    "adminOffline.waTemplate": "Mensaje de WhatsApp al aprobar: nombre de la plantilla",
    "adminOffline.waTemplateLang": "Idioma de la plantilla (por ejemplo en o hi)",
    "adminOffline.waValues": "Orden de los valores en esa plantilla (separados por comas: name, plan, amount, company, date, reference, method)",
    "adminOffline.waRejectedTemplate": "Nombre de la plantilla cuando un pago no pudo confirmarse",
    "adminOffline.waRejectedLang": "Idioma de esa plantilla",
    "adminOffline.waPlanEndingTemplate": "Nombre de la plantilla 3 días antes de que termine un plan",
    "adminOffline.waPlanEndingLang": "Idioma de esa plantilla",
    "adminOffline.waValuesHint": "Cada mensaje de arriba solo se envía si el nombre de la plantilla está completo y aprobado en Meta. Use el idioma tal como lo muestra Meta (en o en_US).",
    "adminOffline.waTemplateHint": "Nombre de una plantilla UTILITY aprobada por Meta, con tres variables: nombre, plan, importe. Déjelo vacío para no enviar WhatsApp. El cliente siempre recibe push y correo.",
    "sp.seeAll": "Ver todas las funciones",
    "sp.showLess": "Ver menos",
    "sp.chooseHint": "Elija un plan para continuar",
    "pay.billingIncomplete": "Complete los datos de facturación marcados en rojo.",
    "pay.termsNotSaved": "No pudimos guardar su aceptación de los términos. Inténtelo de nuevo.",
    "pay.reviewAndPay": "Revisar y pagar",
    "crmai.timing": "Tiempos",
    "crmai.delay": "Espera antes de responder (segundos)",
    "crmai.pause": "Silencio después de que una persona responde (horas)",
    "crmai.offTitle": "Cuando Linc AI está apagado",
    "crmai.offHint": "Los clientes reciben este mensaje en su lugar, como máximo una vez por período de silencio en cada chat.",
    "crmai.offSwitch": "Enviar este mensaje cuando Linc AI esté apagado",
    "crmai.offText": "Mensaje",
    "crmai.offPlaceholder": "¡Gracias por tu mensaje! Nuestro equipo responderá pronto.",
    "crmai.knowledge": "Lo que Linc AI puede usar",
    "crmai.links": "Enlaces que puede compartir (uno por línea)",
    "crmai.linksPlaceholder": "Precios: https://…\nPrueba gratis: https://…",
    "crmai.facts": "Datos sobre LumberLinq (sin precios)",
    "crmai.factsPlaceholder": "Qué hace LumberLinq, para quién es, cómo funciona la prueba…",
    "crmai.helpNotes": "Para dudas de uso, también usa las notas de la Ayuda de Linc AI.",
    "crmai.try": "Probar un mensaje de cliente",
    "crmai.tryPlaceholder": "Escribe lo que un cliente podría escribir…",
    "crmai.tryBtn": "Probar",
    "crmai.trying": "Pensando…",
    "crmai.tryIntent": "Entendido como",
    "crmai.tryHandoff": "Pasaría a una persona",
    "crmai.today": "Hoy",
    "crmai.statAuto": "Respondidos",
    "crmai.statDrafts": "Borradores",
    "crmai.statHandoffs": "Traspasados",
    "crmai.statTokens": "Tokens usados",
    "crmai.save": "Guardar",
    "crmai.saving": "Guardando…",
    "crmai.saved": "Guardado",
    "crmai.savedSub": "Ajustes de Linc AI actualizados.",
    "crmai.loadError": "No se pudieron cargar los ajustes de Linc AI.",
    "crmai.abuseTitle": "Spam y demasiados mensajes",
    "crmai.abuseHint": "Linc AI se detiene un rato en un chat y luego vuelve a responder solo. Una segunda parada en una semana dura hasta que una persona lo active. Un cliente que envía demasiados mensajes recibe antes un aviso amable; el spam evidente no recibe nada.",
    "crmai.floodMinutes": "Detener tras demasiados mensajes (minutos)",
    "crmai.spamHours": "Detener tras spam (horas)",
    "crmai.floodNotice": "Aviso enviado antes de detener por demasiados mensajes",
    "crmai.floodNoticePlaceholder": "Déjalo vacío para usar: Ahora no puedo responder más mensajes. Si es sobre LumberLinq, un miembro del equipo te responderá pronto.",
    "crmai.resumesAt": "Se reactiva solo a las",
    "crmfile.kindImage": "Foto",
    "crmfile.kindVideo": "Vídeo",
    "crmfile.kindAudio": "Mensaje de voz",
    "crmfile.kindSticker": "Sticker",
    "crmfile.kindDoc": "Documento",
    "crmfile.receiving": "Recibiendo…",
    "crmfile.failed": "No se pudo guardar. Abre WhatsApp en el teléfono para verlo.",
    "crmfile.download": "Descargar",
    "crmfile.attach": "Adjuntar un archivo",
    "crmfile.tooBigImage": "Una foto puede pesar hasta 5 MB.",
    "crmfile.tooBigFile": "Un archivo puede pesar hasta 10 MB.",
    "crmfile.notSent": "Archivo no enviado",
    "crmfile.captionHint": "tu texto va con él",
    "crmfile.captionPlaceholder": "Añade un mensaje para acompañar el archivo (opcional)…",
    "crmfile.remove": "Quitar el archivo",
    "crmverify.title": "¿Aprobar el acceso por WhatsApp?",
    "crmverify.text": "Alguien desde este número de WhatsApp pide ayuda al asistente de LumberLinq sobre tu cuenta:",
    "crmverify.hint": "Aprueba solo si eres tú. Esa persona podrá recibir las notas de ayuda que tu rol permite, durante 15 minutos. No se puede cambiar nada.",
    "crmverify.more": "solicitud(es) más en espera",
    "crmverify.approve": "Aprobar",
    "crmverify.deny": "Denegar",
    "crmverify.approvedTitle": "Aprobado",
    "crmverify.approvedSub": "El chat de WhatsApp puede recibir ayuda durante 15 minutos.",
    "crmverify.deniedTitle": "Denegado",
    "crmverify.deniedSub": "Ese número queda bloqueado una hora.",
    "crmverify.expired": "Esta solicitud caducó o ya fue atendida.",
    "crmverify.settingTitle": "Soporte al cliente por WhatsApp",
    "crmverify.settingHint": "Un cliente que pide ayuda con su propia cuenta debe demostrar primero quién es: un toque en Aprobar en su aplicación con sesión iniciada, o un código enviado a su correo registrado. Entonces Linc AI responde solo con las notas de ayuda que su rol permite, y los datos del plan solo tras una aprobación en la aplicación de un Owner o Admin de la empresa. Nunca se cambia nada por WhatsApp.",
    "crmverify.settingSwitch": "Permitir soporte al cliente por WhatsApp",
    "crmqr.button": "Mensajes listos",
    "crmqr.title": "Mensajes listos",
    "crmqr.sub": "Elige uno para preguntas comunes y marketing. Puedes editarlo antes de enviar.",
    "crmqr.search": "Buscar, p. ej.: precio, demo, sin conexión…",
    "crmqr.all": "Todos",
    "crmqr.emptyTitle": "No se encontró ningún mensaje",
    "crmqr.emptySub": "Prueba otras palabras o borra los filtros.",
    "crmqr.clear": "Borrar filtros",
    "crmqr.hint": "Se rellena el nombre del cliente. El mensaje pasa al cuadro y tú pulsas Enviar.",
    "crmqr.cat.welcome": "Bienvenida",
    "crmqr.cat.product": "Producto",
    "crmqr.cat.pricing": "Precios",
    "crmqr.cat.start": "Empezar",
    "crmqr.cat.help": "Ayuda",
    "crmqr.cat.qa": "Preguntas comunes",
    "crmqr.cat.followup": "Seguimiento",
    "crmqr.cat.closing": "Cierre",
    "tallysheet.tu.stockAllOrigins": "Todos los orígenes",
    "tallysheet.tu.stockOriginUnknown": "Origen desconocido",
    "tallysheet.tu.pickOrigin": "Elige un origen",
    "inventory.rowOnlyFree": "Solo {free} libres de {need} — toca para corregir",
    "inventory.rowNoneFree": "Ninguno libre — toca para corregir",
    "rowClash.needsOne": "fila se agregó en el mismo lugar que las filas de otra persona",
    "rowClash.needsMany": "filas se agregaron en el mismo lugar que las filas de otra persona",
    "rowClash.prev": "Fila en conflicto anterior",
    "rowClash.next": "Siguiente fila en conflicto",
    "rowClash.showOnlyTip": "Mostrar solo las filas que dos personas agregaron en el mismo lugar",
    "rowClash.showAll": "Mostrar todas las filas",
    "rowClash.showOnly": "Mostrar solo estas",
    "rowClash.change": "Cambiar",
    "rowClash.markCheckedTip": "Quita estas marcas para todos — nada se mueve ni se borra",
    "rowClash.markChecked": "Marcar como revisado",
    "rowClash.title": "Filas agregadas en el mismo lugar",
    "rowClash.intro": "Dos personas agregaron filas en el mismo lugar de esta hoja. Se conservan ambos grupos. Elige el orden, o quita un grupo si se midieron los mismos troncos dos veces.",
    "rowClash.rows": "Filas:",
    "rowClash.wasThere": "Estaban primero",
    "rowClash.wasPlaced": "Se colocaron junto a ellas",
    "rowClash.chooseLabel": "¿Qué debe pasar?",
    "rowClash.current": "Actual",
    "rowClash.cannotMove": "Un trabajo a medida está ligado a una de estas filas, así que el orden no se puede cambiar.",
    "rowClash.confirmRemove": "Esto borra estas filas para todos. No se puede deshacer. Toca de nuevo para confirmar.",
    "rowClash.confirmYes": "Sí, quitar",
    "rowClash.apply": "Aplicar",
    "rowClash.loadFailed": "No se pudo cargar. Revisa la conexión e inténtalo de nuevo.",
    "rowClash.noRoom": "No hay espacio para poner las filas ahí. Recarga la hoja e inténtalo de nuevo.",
    "rowClash.applyFailed": "No se pudo aplicar. Recarga la hoja e inténtalo de nuevo.",
    "rowClash.someone": "alguien",
    "rowClash.opt.mineAfter": "Mantener ambos — las mías después de las suyas",
    "rowClash.opt.mineFirst": "Mantener ambos — las mías primero",
    "rowClash.opt.dropMine": "Mantener las suyas, quitar las mías",
    "rowClash.opt.deleteTheirs": "Mantener las mías, borrar las suyas",
    "rowClash.opt.firstThen": "Mantener ambos — primero las filas de {first}, luego las de {second}",
    "rowClash.opt.keepOnly": "Mantener las filas de {keep}, quitar las de {remove}",
    "rowClash.hint.order": "{first} primero, luego {second} — cada grupo queda junto",
    "rowClash.hint.remove": "Quita {count} fila(s) agregada(s) por {name}",
    "rowClash.placedTitle": "Filas agregadas en el mismo lugar",
    "rowClash.placedBody": "{count} de tus filas se colocaron después de las filas que {names} agregó en el mismo lugar. Usa \"Filas en conflicto\" arriba de la hoja para revisarlo o cambiarlo.",
    "rowClash.placedAsIs": "{count} de tus filas se guardaron, pero otra persona agregó filas en el mismo lugar. Revísalas arriba de la hoja.",
    "syncIssues.keepMine": "Mantener la mía (guardar sobre su cambio)",
    "syncIssues.rowConflict": "Otra persona cambió estas filas mientras estabas sin conexión. Mantén la tuya, o Descarta para mantener la suya.",
    "tallysheet.rowConflict.title": "Cambiado por otra persona",
    "tallysheet.rowConflict.message": "Otra persona cambió estas filas después de que abriste esta hoja. Fila:",
    "tallysheet.rowConflict.choice": "Mantener la mía guarda tu versión sobre la suya. Ver su cambio guarda tus otras filas y recarga la hoja — tu cambio en estas filas se descarta.",
    "tallysheet.rowConflict.keepMine": "Mantener la mía",
    "tallysheet.rowConflict.showTheirs": "Ver su cambio",
    "tallysheet.rowConflict.status": "No guardado — otra persona cambió una fila",
    "upload.sending": "Enviando",
    "offline.keepOffline": "Mantener sin conexión",
    "offline.removeFromOffline": "Quitar de sin conexión",
    "offline.keptOffline": "Guardado en este teléfono — funciona sin conexión con su hoja de conteo.",
    "offline.keepOfflineLater": "Se guardará en este teléfono en la próxima sincronización.",
    "offline.removedFromOffline": "Ya no se mantiene sin conexión (se mantiene si es de los últimos 90 días o sigue abierto).",
    "offline.syncTitle": "Sincronización sin conexión",
    "offline.lastSynced": "Última sincronización {when}",
    "offline.lastSyncedNever": "Aún no sincronizado en este teléfono",
    "offline.justNow": "justo ahora",
    "offline.minAgo": "hace {n} min",
    "offline.hoursAgo": "hace {n} h",
    "offline.daysAgo": "hace {n} días",
    "offline.syncNow": "Sincronizar ahora",
    "offline.youAreOffline": "Está sin conexión — los cambios se guardan en este teléfono y se envían al volver a estar en línea.",
    "syncIssues.tryAgain": "Intentar de nuevo",
    "offline.waitingSync": "esperando sincronizar",
    "offline.waitingSyncHint": "Guardado en este teléfono — se enviará cuando vuelva internet",
    "offlineLock.title": "Sin conexión demasiado tiempo",
    "offlineLock.lead": "Este teléfono lleva 15 días o más sin conexión, por eso la app está bloqueada para proteger sus datos.",
    "offlineLock.changesSafe": "{n} cambio(s) sin sincronizar se guardan en este teléfono.",
    "offlineLock.waiting": "Conéctese a internet para continuar. Luego elegirá qué hacer con estos cambios.",
    "offlineLock.checking": "Conectando…",
    "offlineLock.askTitle": "¿Sincronizar sus cambios anteriores?",
    "offlineLock.askBody": "Tiene {n} cambio(s) de antes. Sí: se envían ahora y luego se cierra la sesión. No: se eliminan y luego se cierra la sesión.",
    "offlineLock.yes": "Sí, sincronizar",
    "offlineLock.no": "No, eliminarlos",
    "offlineLock.deletedTitle": "Cambios anteriores eliminados",
    "offlineLock.deletedBody": "Sus {n} cambio(s) anteriores se eliminaron porque eligió No.",
    "offline.removedTitle": "Cambios sin conexión eliminados",
    "offline.removedBody": "{n} cambio(s) hechos sin conexión en este teléfono se eliminaron, porque otro usuario inició sesión en él antes de sincronizarlos. Vuelva a ingresarlos si aún los necesita.",
    "offline.notSynced": "sin sincronizar",
    "offline.notSyncedHint": "Cambios en este teléfono aún no guardados en el servidor — toque para verlos",
    "offline.itemSyncing": "elemento sincronizando…",
    "offline.itemsSyncing": "elementos sincronizando…",
    "upload.of": "de",
    "upload.left": "restantes",
    "upload.processing": "Procesando…",
    "upload.sent": "enviados",
    "upload.retry": "Reintentar",
    "upload.cancel": "Cancelar subida",
    "recon.piecesNotComparable": "El conteo de descarga es de otro tipo (Redonda vs Cuadrada), así que las piezas no se pueden comparar — solo se usa la diferencia de volumen.",
    "tallysheet.tu.reconReceived": "Recibido (conciliado):",
    "tallysheet.tu.reconLoaded": "cargado",
    "tallysheet.tu.reconRecordedOnly": "solo registrado (lote ya aserrado / vendido) — corrige el stock con un ajuste",
    "recon.notReceived.title": "Esta Unidad de Stock aún no está en el inventario.",
    "recon.notReceived.text": "Recíbela primero en el inventario — luego concilia, para que la diferencia pase al stock.",
    "recon.notReceived.askReceive": "Pide a alguien que pueda recibir stock que la reciba primero.",
    "recon.notReceived.done": "Recibida en el inventario — ya puedes conciliar.",
    "recon.notReceived.failed": "No se pudo recibir. Abre la Unidad de Stock y revisa producto, sitio y filas del conteo.",
    "recon.stockWillChange": "Al bloquear, el stock pasa a ser lo que realmente llegó:",
    "invInOut.reconAlreadyAppliedTitle": "Conciliación ya aplicada",
    "invInOut.reconAlreadyAppliedText": "La conciliación de esta Unidad de Stock ya cambió el stock en {cbm} CBM. Si este ajuste es por la misma falta, el stock quedó corregido dos veces — deshazlo con un ajuste opuesto.",
    "tallysheet.tu.openingChipHint": "Stock que la empresa ya tenía el primer día (agregado con Stock inicial).",
    "receive.volumeFromTallies": "El volumen de este lote viene de los conteos de sus Unidades de Stock — corrige el conteo.",
    "invOverview.openingStock": "Stock inicial",
    "invOverview.openingStockHint": "Agrega el stock que ya tienes",
    "tallysheet.tu.openingTitle": "Stock inicial",
    "tallysheet.tu.openingSteps": "Stock que ya tienes. Guarda, completa el conteo (medidas y piezas) y pulsa Recibir en Inventario. No hace falta modo de transporte; el envío es opcional — vincúlalo solo si quieres el registro de compra.",
    "tallysheet.tu.openingDone": "Stock que ya tenías — agregado al inventario. Vincula un envío solo si quieres el registro de compra.",
    "appSettings.productTourSection": "Recorridos del producto",
    "appSettings.productTourEnabled": "Mostrar recorridos del producto",
    "appSettings.productTourHint": "Activado: cada usuario ve el recorrido de cada página una vez — terminado u omitido, no vuelve a aparecer en ninguno de sus dispositivos. Desactivado: no se muestra ningún recorrido y el botón se oculta.",
    "home.page.dashboard": "Panel",
    "home.page.tallySheets": "Hojas de conteo",
    "home.page.consignments": "Envíos",
    "home.page.inventory": "Inventario",
    "home.restricted.title": "Esta página aún no forma parte de tu rol",
    "home.restricted.text": "El administrador de tu empresa decide qué páginas puede abrir tu rol. Puedes pedirle acceso o seguir trabajando en las páginas de abajo.",
    "home.restricted.canOpen": "Páginas que puedes abrir",
    "home.restricted.goHome": "Ir a mi página de inicio",
    "home.welcome.title": "Tu cuenta está lista",
    "home.setup.title": "Preparando tu acceso…",
    "home.setup.text": "Tu plan está activo. Estamos preparando tus páginas, tarda unos segundos.",
    "home.welcome.text": "Tu administrador aún no ha dado ninguna página a tu rol. Pídele acceso — recibirá una notificación al instante.",
    "home.welcome.profile": "Mi perfil",
    "home.welcome.logout": "Cerrar sesión",
    "home.request.button": "Solicitar acceso",
    "home.request.sent": "Solicitud enviada",
    "home.request.sentNote": "Se avisó a los administradores de tu empresa. Verás la página en cuanto actualicen tu rol.",
    "home.request.failed": "No se pudo enviar la solicitud. Inténtalo de nuevo.",
    "home.roleHint.startsOn": "Sin Panel en este rol — los miembros empezarán en:",
    "home.roleHint.none": "Este rol aún no abre ninguna página principal — los miembros verán una pantalla de bienvenida y podrán solicitar acceso.",
    "plan.module.qualityGrading": "Clasificación de Calidad",
    "plan.module.inventoryModule": "Módulo de Inventario",
    "plan.module.processModule": "Módulo de Proceso",
    "plan.module.dedicatedSupport": "Soporte Dedicado",
    "plan.value.unlimited": "Ilimitado",
    "plan.feature.teamMembers": "Miembros del Equipo",
    "plan.feature.businessPartners": "Socios comerciales",
    "plan.feature.productsSpecies": "Productos / Especies",
    "plan.feature.loadingSites": "Sitios",
    "plan.feature.tallySheets": "Hojas de recuento",
    "plan.feature.shipments": "Consignaciones",
    "plan.feature.transportUnits": "Unidades de Stock",
    "plan.feature.photoUploads": "Cargas de Fotos",
    "plan.feature.photoRetention": "Retención de Fotos",
    "plan.feature.storage": "Almacenamiento",
    "plan.feature.exportPdfExcel": "Exportar PDF y Excel",
    "plan.feature.importExcel": "Importar Excel",
    "plan.feature.basicReports": "Informes Básicos",
    "plan.feature.reconciliationReport": "Informe de Conciliación",
    "plan.feature.usersActivityReport": "Informe de Actividad de Usuarios",
    "plan.feature.advancedAnalytics": "Análisis Avanzado",
    "plan.feature.aiImport": "Importación IA",
    "plan.feature.prioritySupport": "Soporte Prioritario",
    "plan.feature.consignments": "Consignaciones",
    "plan.feature.exportTallyPdfExcel": "Exportar Hojas (PDF+Excel)",
    "plan.feature.exportShipmentPdfExcel": "Exportar Consignación (PDF+Excel)",
    "plan.feature.importTallyExcel": "Importar Hojas (Excel)",
    "plan.feature.importShipmentExcel": "Importar Consignación (Excel)",
    "plan.unit.users": "usuarios",
    "plan.unit.records": "registros",
    "plan.unit.sheets": "hojas",
    "plan.unit.sites": "sitios",
    "plan.unit.units": "unidades",
    "plan.unit.photos": "fotos",
    "plan.unit.days": "días",
    "plan.unit.mb": "MB",
    "plan.unit.creditsMonth": "créditos/mes",
    "common.monthly": "Mensual",
    "common.yearly": "Anual",
    "plan.compare.show": "Mostrar",
    "plan.compare.allFeatures": "Todas las Funciones",
    "plan.compare.common": "Común",
    "plan.compare.differences": "Diferencias",
    "plan.savePercentTemplate": "Ahorra {pct}%",
    "plan.saveUpTo20": "Ahorra hasta el 20%",
    "plan.perMo": "/ mes",
    "plan.perYr": "/ año",
    "common.language": "Idioma",
    "common.slowConnection": "Conexión lenta — algunas acciones pueden tardar un poco más",
    "common.dismiss": "Descartar",
    "planManagement.unavailableTitle": "Gestiona tu plan",
    "planManagement.unavailableDesc": "Esto no está disponible en la aplicación. Ponte en contacto con el administrador de tu cuenta.",
    "planManagement.backToDashboard": "Volver al panel",
    "planManagement.contactAdmin": "Ponte en contacto con el administrador de tu cuenta.",
    "accountSetup.iosAllSetTitle": "Todo listo",
    "accountSetup.iosAllSetDesc": "Tu cuenta está lista para usar. Empieza a explorar LumberLinq ahora.",
    "accountSetup.iosAllSetGoToDashboard": "Ir al panel",
    "common.offlineStaleData": "Sin conexión — mostrando datos en caché de",
    "common.offlineNotIncluded": "cambios en este teléfono aún no se han sincronizado, por eso no se incluyen aquí.",
    "common.preparingOfflineData": "Preparando datos sin conexión…",
    "common.syncAreaBusinessPartners": "Socios Comerciales",
    "common.syncAreaProducts": "Productos",
    "common.syncAreaLoadingSites": "Sitios",
    "common.syncAreaTransportUnits": "Unidades de Stock",
    "common.syncAreaDashboard": "Panel",
    "common.search": "Buscar",
    "common.status": "Estado",
    "common.filter": "Filtrar",
    "common.actions": "Acciones",
    "common.name": "Nombre",
    "common.email": "Correo electrónico",
    "common.user": "Usuario",
    "common.password": "Contraseña",
    "common.phone": "Teléfono",
    "common.country": "País",
    "common.state": "Estado",
    "common.city": "Ciudad",
    "common.reset": "Restablecer",
    "common.delete": "Eliminar",
    "common.uploading": "Subiendo...",
    "common.edit": "Editar",
    "common.active": "Activo",
    "common.inactive": "Inactivo",
    "common.blocked": "Bloqueado",
    "header.darkMode": "Modo oscuro",
    "header.newBtn": "Nuevo",
    "header.searchHint": "Buscar o ir a…",
    "header.useClassic": "Usar encabezado clásico",
    "header.useNew": "Usar encabezado nuevo",
    "menuDock.useDock": "Usar menú en dock",
    "menuDock.useClassic": "Usar menú clásico",
    "menuDock.useDockRow": "Menú en dock",
    "menuDock.iconsLabel": "Iconos",
    "menuDock.iconSet.lucide": "Lucide",
    "menuDock.iconSet.phosphor": "Phosphor",
    "menuDock.iconSet.classic": "Clásico",
    "menuDock.more": "Más",
    "menuDock.navLabel": "Menú principal",
    "menuDock.hideBar": "Ocultar barra inferior",
    "menuDock.focusMode": "Modo enfoque (ocultar ambas barras)",
    "menuDock.showBottomBar": "Mostrar barra inferior",
    "menuDock.showBars": "Mostrar barras",
    "menuDock.viewGroup": "Vista",
    "menuDock.railPin": "Mantener el menú abierto",
    "menuDock.railUnpin": "Dejar de mantener el menú abierto",
    "companyForm.regionalSettings": "Configuración regional",
    "companyForm.currency": "Moneda de la empresa",
    "companyForm.currencyHint": "Se usa por defecto en nuevos envíos y pagos y en los totales del panel. Los registros existentes mantienen su propia moneda.",
    "companyForm.timezone": "Zona horaria de la empresa",
    "companyForm.timezoneHint": "Los límites mensuales del plan se reinician con este reloj. Los nuevos miembros del equipo también empiezan con ella.",
    "quickSearch.lockedStock": "Los resultados de stock no forman parte de su plan actual.",
    "quickSearch.lockedMill": "Los resultados de trabajos de aserradero no forman parte de su plan actual.",
    "quickSearch.seePlans": "Ver planes",
    "appSettings.nav.upgrade": "Mejorar plan",
    "appSettings.inventoryLocked": "Los ajustes de stock están disponibles en los planes que incluyen el módulo de Stock.",
    "tallyImport.button": "Importar desde Tally",
    "tallyImport.tooltip": "Importar socios desde una exportación de Tally (Excel/CSV)",
    "tallyImport.dialogHeader": "Importar socios comerciales desde Tally",
    "tallyImport.title": "Importación desde Tally",
    "tallyImport.hint": "Exporte su lista de cuentas (ledgers) de Tally a Excel o CSV y conserve solo los Sundry Debtors y Sundry Creditors (las demás cuentas no se importan). Los deudores pasan a ser Compradores y los acreedores pasan a ser Vendedores. El ID fiscal / GSTIN es opcional. Si las primeras filas del archivo son un título de informe, use «Omitir filas al inicio» abajo.",
    "menuDock.railHide": "Ocultar el menú",
    "menuDock.railShow": "Mostrar el menú",
    "menuDock.hideHeader": "Ocultar barra superior",
    "menuDock.showHeader": "Mostrar barra superior",
    "menuDock.askLinc": "Preguntar a Linc (ayuda de IA)",
    "header.lightMode": "Modo claro",
    "header.fontSize": "Tamaño de Fuente",
    "notification.bellLabel": "Notificaciones",
    "notification.title": "Notificaciones",
    "notification.markAllRead": "Marcar todo como leído",
    "notification.empty": "Estás al día",
    "notification.disabled": "Las notificaciones no están disponibles en este momento",
    "notification.accept": "Aceptar",
    "notification.decline": "Rechazar",
    "notification.accepted": "Aceptado",
    "notification.switchHint": "Ahora puedes cambiar a ella en cualquier momento desde tu menú de perfil",
    "notification.declined": "Rechazado",
    "notification.viewAll": "Ver todas",
    "header.theme": "Tema",
    "header.preferences": "Preferencias",
    "business.subtitle": "Gestionar your trading partners and business relationships",
    "common.cancel": "Cancelar",
    "common.pcs": "pzs",
    "common.loading": "Cargando...",
    "common.unknown": "Desconocido",
    "common.save": "Guardar",
    "sfs.pickStockUnit": "¿Qué unidad de stock?",
    "sfs.pickConsignment": "¿Qué envío?",
    "sfs.searchPlaceholder": "Escribe un número o nombre",
    "sfs.searchHint": "Escribe al menos 2 letras o dígitos para buscar.",
    "sfs.searching": "Buscando…",
    "sfs.searchNone": "No se encontró nada. Prueba otro número o nombre.",
    "sfs.searchFailed": "La búsqueda falló. Inténtalo de nuevo.",
    "tally.keypad.addRowBelow": "Añadir fila debajo",
    "common.update": "Actualizar",
    "common.logout": "Cerrar sesión",
    "common.clear": "Limpiar",
    "common.saving": "Guardando…",
    "common.saved": "¡Guardado!",
    "common.saveFailed": "Fallido",
    "common.add": "Agregar",
    "common.remove": "Quitar",
    "common.calculate": "Calcular",
    "common.yes": "Sí",
    "common.no": "No",
    "common.stayOnPage": "Permanecer en esta página",
    "common.signInAgain": "Volver a Iniciar Sesión",
    "common.ok": "Ok",
    "common.confirmation": "Confirmation",
    "common.or": "or",
    "common.required": "Obligatorio.",
    "common.isRequired": "es obligatorio.",
    "common.sectionHasErrors": "Esta sección tiene errores de validación.",
    "common.success": "Éxito",
    "common.error": "Error",
    "common.created": "Creado",
    "common.somethingWentWrong": "Algo salió mal. Por favor, inténtelo de nuevo.",
    "common.switchCompany": "Cambiar de Empresa",
    "common.accountMenu": "Menú de cuenta",
    "common.confirmSwitchCompany": "Cambiar de Empresa",
    "common.switchCompanyConfirmMessage": "¿Cambiar su empresa activa a {{companyName}}? Será trasladado a los datos y configuraciones de esta empresa.",
    "common.switchCompanyBlockedUnsynced": "Tiene cambios que aún no se han sincronizado. Espere a que finalice la sincronización antes de cambiar de empresa.",
    "common.leaveCompany": "Salir de la empresa",
    "common.leaveCompanyConfirmMessage": "¿Salir de {{companyName}}? Perderás el acceso a esta empresa, pero tu propia cuenta y empresa no se ven afectadas.",
    "common.info": "Info",
    "common.validationError": "Validation Error",
    "common.noRecordsFound": "No se encontraron registros.",
    "common.pendingSync": "Sincronización pendiente",
    "common.syncFailed": "Error de sincronización",
    "common.needsRename": "Requiere renombrar",
    "syncIssues.title": "Problemas de sincronización",
    "syncIssues.subtitle": "Elementos creados sin conexión que el servidor rechazó permanentemente — revise y descarte, o corrija y vuelva a crear manualmente.",
    "syncIssues.emptyState": "No hay problemas de sincronización — todo lo creado sin conexión se sincronizó correctamente.",
    "syncIssues.colType": "Tipo",
    "syncIssues.colItem": "Elemento",
    "syncIssues.colError": "Error",
    "syncIssues.colCreated": "Creado",
    "syncIssues.discard": "Descartar",
    "syncIssues.confirmDiscard": "¿Descartar este elemento de forma permanente? Nunca se guardó en el servidor y esto no se puede deshacer.",
    "syncIssues.confirmDiscardHeader": "Descartar elemento",
    "syncIssues.discardedTitle": "Descartado",
    "syncIssues.discardedDetail": "El elemento ha sido eliminado.",
    "syncIssues.renamePlaceholder": "Nuevo nombre",
    "syncIssues.renameAndRetry": "Renombrar y reintentar",
    "syncIssues.retrySuccessTitle": "Sincronizado",
    "syncIssues.retrySuccessDetail": "Creado correctamente con el nuevo nombre.",
    "syncIssues.retryFailedTitle": "Falló de nuevo",
    "common.records": "registros",
    "common.chooseColumns": "Elegir Columns",
    "common.searchKeyword": "Buscar keyword",
    "common.hello": "Hello",
    "common.companyId": "Empresa ID",
    "common.firstName": "First Name",
    "common.lastName": "Last Name",
    "common.useDefault": "Use Default",
    "common.view": "Ver",
    "common.data": "Datos",
    "common.createdAt": "Created At",
    "common.undo": "Undo",
    "common.redo": "Redo",
    "common.import": "Import",
    "common.refresh": "Actualizar",
    "common.downloadFailed": "Descarga Fallida",
    "common.downloadFailedDetail": "No se pudo guardar el archivo. Por favor, inténtelo de nuevo.",
    "common.open": "Abierto",
    "common.copy": "Copy",
    "common.revoke": "Revoke",
    "common.back": "Atrás",
    "common.itemsSelected": "Items Selected",
    "common.generalInformation": "General Information",
    "common.operationalDetails": "Operational Detalles",
    "common.location": "Ubicación",
    "common.locationRequired": "Ubicación es obligatorio.",
    "common.pickupLocationRequired": "Pickup Ubicación es obligatorio.",
    "common.operatingProfile": "Operating Perfil",
    "common.profile": "Perfil",
    "common.paymentTerms": "Términos de pago",
    "common.incoterms": "Incoterms",
    "common.billNo": "Bill No",
    "common.billOfLadingNo": "Bill of Lading No",
    "common.billNumberRequired": "Bill number es obligatorio",
    "common.requiredForExport": "Obligatorio for export",
    "common.ewaybillLrFile": "E-Waybill / LR File",
    "common.billFile": "Bill File",
    "common.blFile": "BL File",
    "common.totalUsers": "Total Usuarios",
    "common.configured": "Configured",
    "common.noAccess": "No Acceso",
    "common.avgCoverage": "Avg Coverage",
    "tallysheet.createTransportUnit": "Crear Unidad de Stock",
    "tallysheet.saveStartTally": "Guardar y empezar el conteo",
    "su.editDetails": "Editar detalles",
    "su.directionMoveShort": "Mover",
    "su.moreDetails": "Más detalles",
    "su.lessDetails": "Menos detalles",
    "su.loadingTab": "Cargando…",
    "su.detailsTitle": "Detalles de la unidad de stock",
    "su.allSaved": "Todos los cambios guardados",
    "su.unsaved": "Cambios sin guardar",
    "su.saving": "Guardando…",
    "su.moreActions": "Más acciones",
    "su.receiveSub": "Inicia el control de stock.",
    "su.lockMenu": "Bloquear unidad de stock",
    "su.lockSub": "Impide más ediciones.",
    "su.deleteMenu": "Eliminar unidad de stock",
    "su.deleteSub": "Pide confirmación antes.",
    "su.appScreenOn": "Probar el diseño tipo app",
    "su.appScreenOff": "Volver al diseño clásico",
    "su.appScreenSub": "La cuadrícula llena la pantalla y su encabezado siempre se ve",
    "su.auditMenu": "Auditoría de acceso por enlace",
    "su.auditSub": "Quién abrió esta unidad de stock con un enlace compartido",
    "su.confirmOutSub": "Saca este stock del inventario.",
    "su.notInInventory": "Fuera del inventario",
    "su.inInventory": "En el inventario",
    "su.sections": "Secciones de la unidad de stock",
    "su.lockedTitle": "Guarde la unidad de stock para empezar el conteo",
    "su.lockedSub": "Cada fila se guarda en la unidad de stock, por eso primero necesita su ID.",
    "su.lockedChip": "Bloqueada",
    "su.lockedPlaceholder": "Fotos, Resumen, Conciliación e Inventario también se abren aquí.",
    "su.newHint": "Complete los detalles y guarde. El conteo se abre en cuanto exista la unidad.",
    "su.newReady": "Unidad de stock guardada. El conteo está listo.",
    "tallysheet.selectProduct": "Seleccionar Producto",
    "tallysheet.selectMode": "Seleccionar Mode",
    "tallysheet.selectLoadingSite": "Seleccionar un Sitio",
    "common.pageReport": "Showing {first} to {last} of {totalRecords} entries",
    "common.unsavedChangesHeader": "Unsaved Changes",
    "common.unsavedChangesMessage": "You have unsaved changes. Are you sure you want to leave without saving?",
    "common.leaveLabel": "Leave",
    "common.stayLabel": "Stay",
    "login.alreadyHaveAccount": "Already have an account?",
    "login.signInNow": "Sign in now!",
    "login.signUp": "Sign Up",
    "login.nameRequired": "Name es obligatorio.",
    "login.usernameRequired": "Username es obligatorio.",
    "login.validEmailRequired": "Please enter a valid email address.",
    "login.checkEmailTitle": "Revisa tu correo",
    "login.checkEmailBody": "Enviamos un enlace de verificación a",
    "login.checkEmailResent": "Se envió un nuevo enlace.",
    "login.checkEmailSignIn": "Iniciar sesión",
    "login.emailExists": "Email already exists.",
    "login.passwordRequired": "Password es obligatorio.",
    "login.securityCheckLoading": "Cargando verificación de seguridad…",
    "login.securityCheckUnavailable": "Verificación de seguridad no disponible — el inicio de sesión está bloqueado hasta que cargue.",
    "login.securityCheckRequired": "Completa la verificación de seguridad antes de continuar.",
    "login.choosePassword": "Elegir a password",
    "login.tooSimple": "Too simple",
    "login.averageComplexity": "Promedio complexity",
    "login.complexPassword": "Complex password",
    "login.dontHaveAccount": "Don't have an account?",
    "login.createToday": "Crear today!",
    "login.welcomeBack": "Bienvenido de nuevo",
    "login.welcomeBackSub": "Inicie sesión en su cuenta de LumberLinq.",
    "login.createYourAccount": "Cree su cuenta",
    "login.createYourAccountSub": "Empiece a gestionar su negocio de madera en minutos.",
    "login.signIn": "Sign In",
    "login.emailRequired": "Email es obligatorio.",
    "login.forgotPassword": "Forgot Password?",
    "login.loggedInAs": "You're already logged in as",
    "login.loggedInEmail": "Logged in as",
    "login.errorNotification": "Error Notification",
    "login.userNotRegistered": "No account exists for this email. Please sign up first.",
    "login.userAlreadyRegistered": "This account already exists. Please sign in instead.",
    "login.socialLoginFailed": "Social login failed. Please try again.",
    "login.referredBy": "Has sido recomendado por",
    "login.referredGeneric": "Has sido recomendado a LumberLinq.",
    "login.referredSignInInstead": "Iniciar sesión en su lugar",
    "login.signInWithApple": "Iniciar sesión con Apple",
    "login.signUpWithApple": "Registrarse con Apple",
    "login.appleNoAccount": "Ninguna cuenta de LumberLinq está vinculada a este ID de Apple. Crea una cuenta gratuita en la web y luego inicia sesión aquí.",
    "login.registrationDisabled":
      "Los registros están pausados temporalmente — hemos guardado tu lugar y te enviaremos un correo en cuanto reabran.",
    "business.title": "Socios comerciales",
    "business.newPartner": "New Socio",
    "business.bulkImport": "Importación masiva",
    "business.moreActions": "Más acciones",
    "business.selectRows": "Seleccionar filas",
    "business.selectedCount": "seleccionados",
    "business.sortNameAsc": "Nombre A–Z",
    "business.sortNameDesc": "Nombre Z–A",
    "business.sortType": "Tipo",
    "business.sortCountry": "País",
    "common.done": "Listo",
    "common.sort": "Ordenar",
    "common.activate": "Activar",
    "business.deleteSelected": "Eliminar Selected",
    "business.searchPlaceholder": "Buscar by Name, Email, Contact, Tax ID",
    "business.allStatus": "All Estado",
    "business.edit": "Editar Comercial Socio",
    "business.create": "Crear Comercial Socio",
    "business.identity": "Identidad",
    "business.companyName": "Nombre de la empresa",
    "business.companyDetails": "Detalles de la empresa",
    "business.companyRegistration": "Empresa Registration",
    "business.industry": "Industry",
    "business.web": "Web",
    "business.companyBranding": "Marca de la empresa",
    "business.logoUrl": "Logo URL",
    "business.logoPreview": "Empresa logo preview",
    "business.contactPerson": "Contact Person",
    "business.partyType": "Party Type",
    "business.contactPersonShort": "Contacto",
    "business.partyTypeShort": "Tipo",
    "business.selectType": "Seleccionar Type",
    "business.referenceCode": "Reference Code",
    "business.registrationType": "Registration Type",
    "business.taxId": "Tax ID",
    "company.reportingCurrency": "Moneda de Informe",
    "company.reportingCurrencyHint": "Los totales del panel e informes se convierten a esta moneda.",
    "shipments.fxRateToBase": "Tipo de Cambio a la Moneda de Informe",
    "shipments.convertedAmount": "Monto Convertido",
    "dashV5.convertedTooltip": "Convertido a la moneda de informe usando los tipos de cambio registrados en cada consignación. Los montos sin tipo de cambio registrado se excluyen.",
    "dashV5.approxConverted": "aprox., convertido",
    "dashV5.noRate": "sin tipo de cambio",
    "dashV5.noRateTooltip": "No hay tipo de cambio registrado — excluido del total convertido. Configure el Tipo de Cambio a la Moneda de Informe en la consignación.",
    "business.partyCategory": "Party Category",
    "business.selectCategory": "Seleccionar Category",
    "business.activePartner": "Active Socio",
    "business.contactLocation": "Contact & Ubicación",
    "business.website": "Website",
    "business.address1": "Dirección Line 1",
    "business.address2": "Dirección Line 2",
    "business.zipCode": "Zip Code",
    "business.operations": "Operations",
    "business.linkedUserId": "Linked Usuario ID",
    "business.externalCode": "External Code",
    "business.tags": "Tags",
    "business.selectTags": "Seleccionar Tags",
    "business.notes": "Notes",
    "business.attachFiles": "Attach Files",
    "business.bankAccounts": "Bank Accounts",
    "business.bankName": "Bank Name",
    "business.accountNo": "Account No",
    "business.confirmAccountNo": "Confirm Account No",
    "business.accountNoMismatch": "Account numbers don't match",
    "business.currency": "Moneda",
    "business.addBankAccount": "Agregar Bank Account",
    "business.savePartner": "Guardar Socio",
    "business.updatePartner": "Actualizar Socio",
    "business.noPartnersFound": "No partners found.",
    "business.regType": "Reg. Type",
    "route.login.header": "Welcome Back!",
    "route.buyers.manage": "Ver and manage existing buyer profiles",
    "layout.searchMenu": "Buscar menu...",
    "layout.noMenuItems": "No menu items found.",
    "layout.footerRights": "All Rights Reserved.",
    "layout.poweredBy": "Powered By Lumber Linq",
    "layout.loveApp": "Love our app?",
    "layout.useForBusiness": "Use it for your own business!",
    "user.add": "Agregar user",
    "user.create": "Crear Usuario",
    "user.inputDetails": "Input new user details to the system",
    "user.manage": "Gestionar Usuario",
    "user.manageProfiles": "Ver and administer user profiles",
    "user.profile": "Editar Perfil",
    "user.profileSubheader": "Modify your personal user details",
    "user.confirmDeletion": "Confirm Usuario Deletion",
    "user.deleteConfirm": "Are you sure you want to delete this user?",
    "user.typeEmail": "Please confirm by typing the user's email below:",
    "user.emailPlaceholder": "Usuario Email",
    "user.addEmailAddress": "Agregar Email Dirección",
    "user.invalidEmail": "Inválido Email Dirección",
    "user.enterEmail": "Enter Email Dirección",
    "user.invitationAccepted": "Invitation accepted",
    "user.resend": "Resend",
    "user.admin": "Admin",
    "user.cannotUndo": "This action cannot be undone.",
    "shipment.namePlural": "Consignaciones",
    "tallysheet.namePlural": "Tallysheets",
    "tallysheet.all": "All Hoja de cubicación",
    "tallysheet.manageDetails": "Ver and manage existing tallysheet details",
    "containerPrivacy.title": "Contenedor Privacy",
    "subscription.title": "Suscripción",
    "subscription.selectUpdatePlan": "Seleccionar or update your subscription plan",
    "subscription.view": "Ver Subscription",
    "subscription.subheader": "Subheader Subscription",
    "utility.costEstimate": "Cost Estimate",
    "utility.volumeEstimation": "Volumen Estimation",
    "utility.volumeCostEstimation": "Volumen and Cost Estimation",
    "utility.unitConversion": "Unit Conversion",
    "utility.calculator": "Calculator",
    "utility.selectUnit": "Seleccionar Unit",
    "utility.generateSlab": "Generate Slab Prices",
    "utility.decimalPlace": "Decimal Place",
    "utility.decimalPlaces": "Decimal places",
    "utility.from": "From",
    "utility.to": "To",
    "utility.unit": "Unit",
    "utility.fromValue": "From Value",
    "utility.fromUnit": "From Unit",
    "utility.toValue": "To Value",
    "utility.toUnit": "To Unit",
    "utility.reverse": "Reverse",
    "utility.useCommonUnits": "Use common units for all rows",
    "utility.width": "Ancho",
    "utility.widthUnit": "Ancho Unit",
    "utility.thickness": "Thickness",
    "utility.thicknessUnit": "Thickness Unit",
    "utility.length": "Longitud",
    "utility.lengthUnit": "Longitud Unit",
    "utility.price": "Price",
    "utility.priceUnit": "Price Unit",
    "utility.quantity": "Quantity",
    "utility.total": "Total",
    "utility.rate": "Rate",
    "utility.slabOfRate": "Slab of Rate",
    "utility.slabPriceSize": "Slab Price Size",
    "utility.slabSize": "Slab Size",
    "utility.upperSlabs": "Upper Slabs",
    "utility.lowerSlabs": "Lower Slabs",
    "utility.slabPrice": "Slab Price",
    "utility.volumeOnly": "Solo volumen",
    "utility.volumeAndCost": "Volumen + costo",
    "utility.clearAll": "Borrar todo",
    "utility.clearAllConfirm": "¿Eliminar todos los artículos y empezar de nuevo?",
    "utility.addItem": "Agregar artículo",
    "utility.item": "Artículo",
    "utility.duplicateItem": "Duplicar artículo",
    "utility.removeItem": "Eliminar artículo",
    "utility.itemRemoved": "Artículo eliminado",
    "utility.totals": "Totales",
    "utility.pieces": "Piezas",
    "utility.cftNote": "CFT = CBM × 35,3147. Las cifras solo se redondean al mostrarse, y los importes a 2 decimales.",
    "utility.copySummary": "Copiar resumen",
    "utility.copyFailed": "No se pudo copiar",
    "utility.swap": "Intercambiar",
    "utility.saveConversion": "Guardar en el historial",
    "utility.allUnits": "El mismo valor en cada unidad",
    "utility.history": "Conversiones guardadas",
    "utility.historyEmpty": "Toque el marcador para guardar una conversión y aparecerá aquí.",
    "utility.clearHistory": "Borrar historial",
    "utility.clearHistoryConfirm": "¿Eliminar todas las conversiones guardadas?",
    "utility.useThis": "Usar esta conversión",
    "utility.incompleteTitle": "Datos incompletos",
    "utility.incompleteBody": "Primero ingrese un valor y elija las dos unidades.",
    "utility.duplicateTitle": "Ya guardado",
    "utility.duplicateBody": "Esta conversión ya está en su lista.",
    "utility.savedTitle": "Guardado",
    "utility.baseSection": "Precio base",
    "utility.baseRange": "Rango del tramo base",
    "utility.stepSection": "Pasos de los tramos",
    "utility.rangeSection": "Tramos a mostrar",
    "utility.priceLadder": "Escalera de precios",
    "utility.slabs": "tramos",
    "utility.copyAll": "Copiar todo",
    "utility.negativeRate": "Algunos precios están por debajo de cero. Reduzca el paso de precio o el número de tramos inferiores.",
    "utility.baseSlab": "Su tramo",
    "utility.ladderEmpty": "Ingrese la tarifa, el tramo de la tarifa, el tamaño del tramo y el paso de precio para ver la escalera de precios.",
    "dashboardNew.title": "Panel",
    "menu.dashboard": "Panel",
    "menu.dashboardNew": "Dashboard New",
    "menu.shipments": "Consignaciones",
    "menu.tallysheets": "Tallysheets",
    "menu.newTallysheet": "New Hoja de cubicación",
    "menu.products": "Productos",
    "menu.loadingSites": "Sitios",
    "menu.businessPartners": "Socios comerciales",
    "menu.containerPrivacy": "Contenedor Privacy",
    "menu.company": "Empresa",
    "menu.companyProfile": "Perfil de la empresa",
    "menu.companyBranding": "Marca de la empresa",
    "menu.subscription": "Suscripción",
    "menu.utility": "Utility",
    "menu.directory": "Directorio",
    "menu.tools": "Herramientas",
    "menu.section.overview": "Resumen",
    "menu.section.operations": "Operaciones",
    "menu.section.data": "Datos e informes",
    "menu.section.platform": "Plataforma",
    "sidebar.recent": "Recientes",
    "sidebar.copied": "Copiado",
    "sidebar.new": "Nuevo",
    "sidebar.newConsignment": "Envío",
    "sidebar.newStockUnit": "Unidad de stock",
    "sidebar.newBusinessPartner": "Socio comercial",
    "sidebar.newProduct": "Producto",
    "sidebar.newLocation": "Ubicación",
    "menu.costEstimate": "Cost Estimate",
    "menu.volumeEstimate": "Volumen Estimate",
    "menu.volumeEstimates": "Volumen Estimates",
    "menu.unitConversion": "Unit Conversion",
    "menu.slabGenerator": "Slab Generator",
    "menu.generateSlab": "Generate Slab",
    "menu.users": "Usuarios",
    "menu.addUser": "Agregar Usuario",
    "menu.manageUsers": "Gestionar Usuarios",
    "menu.userProfile": "Usuario Perfil",
    "menu.editProfile": "Editar Perfil",
    "menu.addBusinessPartner": "Agregar Comercial Socio",
    "menu.viewBusinessPartner": "Ver Comercial Socio",
    "menu.viewBusinessPartners": "Ver socios comerciales",
    "menu.addProduct": "Agregar Producto",
    "menu.viewProduct": "Ver Producto",
    "menu.viewProducts": "Ver productos",
    "menu.addLoadingSite": "Agregar Sitio",
    "menu.viewLoadingSite": "Ver Sitio",
    "menu.viewLoadingSites": "Ver Sitios",
    "menu.addTallysheet": "Agregar Hoja de cubicación",
    "menu.viewTallysheet": "Ver Hoja de cubicación",
    "menu.listTallysheet": "Listar hojas de cubicación",
    "menu.addShipment": "Agregar Consignación",
    "menu.viewShipment": "Ver Consignación",
    "menu.listShipments": "Listar consignaciones",
    "menu.storage": "Almacenamiento",
    "menu.branding": "Marca",
    "menu.admin": "Admin",
    "menu.adminDashboard": "Admin Dashboard",
    "menu.subscriptionDashboard": "Subscription Dashboard",
    "menu.reports": "Informes",
    "menu.financialReport": "Financial Informe",
    "menu.reconciliationReport": "Reconciliation Informe",
    "menu.accessField": "Acceso Field",
    "menu.tallysheetAccessField": "Hoja de cubicación Acceso Field",
    "menu.businessPartnerReport": "Comercial Socio Informe",
    "menu.shipmentReport": "Consignación Informe",
    "menu.productReport": "Producto Informe",
    "menu.loadingSiteReport": "Informe de Sitios",
    "menu.transportUnitReport": "Informe de Unidad de Stock",
    "menu.tallysheetReport": "Hoja de cubicación Informe",
    "menu.operators": "Operadores",
    "menu.addTransportUnit": "Agregar Unidad de Stock",
    "menu.transportUnitFieldAccess": "Acceso a Campos de la Unidad de Stock",
    "menu.tallyReport": "Informe de Cubicación",
    "menu.analytics": "Análisis",
    "route.companyProfile": "Perfil de su empresa",
    "route.companyProfileDetails": "Ver or edit your company's profile details",
    "route.companyLogo": "Gestionar your company logo",
    "route.convertUnitsHeader": "Convert Units",
    "route.convertUnitsSubheader": "Enter your measurements and select units for conversion",
    "route.costEstimateHeader": "Estimate Your Costs",
    "route.costEstimateSubheader": "Input your parameters and calculate the projected cost",
    "route.containerPrivacyHeader": "Gestionar Contenedor Privacy Configurations",
    "route.containerPrivacySubheader": "Ver and customize privacy levels for container fields",
    "dashboardNew.company": "Empresa",
    "dashboardNew.role": "Rol",
    "dashboardNew.filterRange": "Filter Range",
    "dashboardNew.refresh": "Actualizar",
    "dashboardNew.noData": "No data",
    "dashboardNew.originDestination": "Origin vs Destination CBM (30d)",
    "dashboardNew.topPartners": "Top Socios by Volumen",
    "dashboardNew.fleetHealth": "Fleet Health",
    "dashboardNew.shipmentPipeline": "Consignación Pipeline",
    "dashboardNew.tallyAccuracy": "Cubicación Accuracy by Port",
    "dashboardNew.liveOperations": "Live Operations",
    "dashboardNew.alerts": "Alerts & Exceptions",
    "dashboardNew.recentActivity": "Recent Activity",
    "shipment.list": "Consignaciones",
    "shipment.singular": "Consignación",
    "shipment.new": "New Consignación",
    "shipment.searchPlaceholder": "Buscar anything (BL, Order, Export Ref, Shipper...)",
    "shipment.blNumber": "N.° de Documento",
    "shipment.type": "Type",
    "shipment.date": "Fecha",
    "shipment.buyerOrder": "Buyer Order",
    "shipment.exportRef": "Export Ref",
    "shipment.shipper": "Shipper",
    "shipment.consignee": "Consignee",
    "shipment.noFound": "No consignments found.",
    "shipment.noFoundSub": "Cree una nueva consignación para empezar.",
    "shipment.noBl": "Sin BL#",
    "shipment.sharedLinks": "Shared Links",
    "shipment.newLink": "Nuevo enlace compartido",
    "shipment.access": "Acceso",
    "shipment.expiry": "Expiry",
    "shipment.active": "Activo",
    "shipment.oneTime": "One Time",
    "shipment.used": "Used",
    "shipment.createEdit": "Consignación - Crear / Editar",
    "shipment.create": "Crear Consignación",
    "shipment.edit": "Editar Consignación",
    "shipment.saveConsignment": "Guardar Consignación",
    "shipment.updateConsignment": "Actualizar Consignación",
    "shipment.coreDetailsShort": "Core Detalles",
    "shipment.financialsPaymentsHtml": "Finanzas y pagos",
    "shipment.financials": "Financials",
    "shipment.localAuditSpaced": "Local / Audit",
    "shipment.consignmentInfo": "Consignment Info",
    "shipment.documents": "Documentos",
    "shipment.financialPayments": "Financial & Pagos",
    "shipment.localAudit": "Local/Audit",
    "shipment.breadcrumbs": "Breadcrumbs",
    "shipment.details": "Consignación Detalles",
    "shipmentForm.tabDeal": "Operación",
    "shipmentForm.tabRoute": "Ruta y fechas",
    "shipmentForm.tabMoney": "Dinero",
    "shipmentForm.dealTitle": "La operación",
    "shipmentForm.dealBasics": "Tipo, modo y fecha",
    "shipmentForm.dealBasicsHelp": "Elija primero el tipo: decide qué campos aparecen en cada pestaña.",
    "shipmentForm.references": "Referencias",
    "shipmentForm.referencesHelp": "Los números que su equipo y sus socios usan para encontrar este envío.",
    "shipmentForm.referencesHelpLocal": "Los números de factura y de albarán usados para encontrar este envío.",
    "shipmentForm.parties": "Partes",
    "shipmentForm.partiesHelp": "Al menos una de las partes (remitente, consignatario o parte a notificar) debe ser su propia empresa. Se rellena sola cuando el tipo lo hace evidente.",
    "shipmentForm.ownerMissing": "Una de las partes debe ser su propia empresa.",
    "shipmentForm.buyerDetails": "Datos del comprador",
    "shipmentForm.buyerDetailsHelpSale": "Necesario antes de que salga la mercancía: el número fiscal del comprador y quién la recibe.",
    "shipmentForm.buyerDetailsHelpPurchase": "Opcional en una compra. Su número fiscal se rellena solo.",
    "shipmentForm.notes": "Notas",
    "shipmentForm.routeTitle": "Ruta y fechas",
    "shipmentForm.timing": "Fechas, destino y condiciones",
    "shipmentForm.timingHelp": "Cuándo sale y llega, y las condiciones de envío acordadas. El mismo día es válido.",
    "shipmentForm.transit": "Tiempo de tránsito",
    "shipmentForm.sameDay": "El mismo día",
    "shipmentForm.days": "días",
    "shipmentForm.docsTitle": "Documentos",
    "shipmentForm.docChecklist": "Documentos archivados",
    "shipmentForm.docChecklistNote": "Cuenta un número o un archivo subido. Esta lista solo recuerda; nunca impide guardar. Añada el certificado de fumigación en Otros documentos con la etiqueta Fumigation.",
    "shipmentForm.docNumbers": "Números de documentos",
    "shipmentForm.docNumbersHelp": "Números de certificados y permisos de este envío.",
    "shipmentForm.coNo": "N.º del certificado de origen",
    "shipmentForm.fumigationNo": "N.º del certificado de fumigación",
    "shipmentForm.insuranceDetails": "Detalles del seguro",
    "shipmentForm.ewayNo": "N.º de e-way bill",
    "shipmentForm.quickLabels": "Etiquetas rápidas",
    "shipmentForm.doc.bl": "Conocimiento de embarque",
    "shipmentForm.doc.bill": "Factura / albarán",
    "shipmentForm.doc.invoice": "Factura comercial",
    "shipmentForm.doc.packing": "Lista de empaque",
    "shipmentForm.doc.co": "Certificado de origen",
    "shipmentForm.doc.phyto": "Certificado fitosanitario",
    "shipmentForm.doc.fumigation": "Certificado de fumigación",
    "shipmentForm.doc.eway": "E-way bill / LR",
    "shipmentForm.sumLabel": "Resumen del envío",
    "shipmentForm.noBlYet": "Aún no indicado",
    "shipmentForm.unsaved": "Cambios sin guardar",
    "shipmentForm.status": "Estado",
    "shipmentForm.changeStatus": "Cambiar estado",
    "shipmentForm.sumToggle": "Mostrar u ocultar el resumen",
    "shipmentForm.stepperLabel": "Progreso de este envío",
    "shipmentForm.invoice": "Factura",
    "shipmentForm.outstanding": "Pendiente",
    "shipmentForm.readyLabel": "listo",
    "shipmentForm.type.EXPORT": "Exportación",
    "shipmentForm.type.IMPORT": "Importación",
    "shipmentForm.type.DOMESTIC_SALE": "Venta nacional",
    "shipmentForm.type.DOMESTIC_PURCHASE": "Compra nacional",
    "shipmentForm.type.TRADING": "Comercio",
    "shipmentForm.mode.SEA": "Mar",
    "shipmentForm.mode.AIR": "Aire",
    "shipmentForm.mode.ROAD": "Carretera",
    "shipmentForm.mode.RAIL": "Tren",
    "shipmentForm.ready.type": "Tipo y modo elegidos",
    "shipmentForm.ready.parties": "Vendedor y comprador elegidos",
    "shipmentForm.ready.bl": "Número de conocimiento de embarque",
    "shipmentForm.ready.bill": "Número de factura",
    "shipmentForm.ready.dates": "Fechas de salida y llegada",
    "shipmentForm.ready.ports": "Puertos de carga y descarga",
    "shipmentForm.ready.vehicle": "Ruta y datos del vehículo",
    "shipmentForm.ready.rail": "Estaciones de origen y destino",
    "shipmentForm.ready.units": "Al menos una unidad de stock añadida",
    "shipmentForm.ready.docs": "Todos los documentos esperados archivados",
    "shipmentForm.ready.invoice": "Importe de la factura indicado",
    "shipmentForm.ready.terms": "Condiciones de pago elegidas",
    "shipmentForm.depRequired": "La salida estimada es obligatoria",
    "shipmentForm.arrRequired": "La llegada estimada es obligatoria",
    "shipmentForm.billRequired": "El número de factura es obligatorio",
    "shipmentForm.blRequired": "El número de conocimiento de embarque es obligatorio en un envío marítimo",
    "shipmentForm.requiredHere": "Obligatorio",
    "shipmentForm.paymentTermsNeeded": "Las condiciones de pago son necesarias cuando hay importe de factura",
    "shipmentForm.paymentTermsHint": "Necesarias cuando indique el importe de la factura: dan la fecha de vencimiento y los avisos de retraso.",
    "shipmentForm.savePaymentsFirst": "Guarde primero el envío para registrar pagos.",
    "shipmentForm.pricePerCbm": "Factura por CBM",
    "shipmentForm.paidSoFar": "Pagado hasta ahora",
    "shipmentForm.receivedSoFar": "Recibido hasta ahora",
    "shipmentForm.stockHelpBtn": "¿Qué unidades de stock aparecen aquí?",
    "shipmentForm.stockHint": "Escriba parte del ID de la unidad de stock, del n.º de contenedor / camión o del producto. Pulse ? para ver cuáles se listan.",
    "shipmentForm.stockHintNew": "Escriba parte del ID, del n.º de contenedor / camión o del producto. Las unidades añadidas se vinculan al guardar. Pulse ? para ver cuáles se listan.",
    "shipmentForm.stockHelp.title": "¿Qué unidades de stock se listan?",
    "shipmentForm.stockHelp.lead": "La lista muestra las unidades de stock de su empresa que encajan con este envío.",
    "shipmentForm.stockHelp.shown": "Listadas",
    "shipmentForm.stockHelp.hidden": "No listadas",
    "shipmentForm.stockHelp.s1": "Aún sin envío",
    "shipmentForm.stockHelp.s2": "La dirección correcta: salida en una venta, entrada en una compra",
    "shipmentForm.stockHelp.s3": "Recibida o confirmada, da igual",
    "shipmentForm.stockHelp.h1": "Ya en otro envío",
    "shipmentForm.stockHelp.h2": "La dirección opuesta (una salida nunca aparece en una compra)",
    "shipmentForm.stockHelp.h3": "Unidades de traslado entre sitios y registros de salida de aserradero",
    "shipmentForm.stockHelp.h4": "Nada escrito aún, o sin coincidencia con el ID, ID de transporte, n.º de contenedor / camión o producto",
    "shipmentForm.stockHelp.tip": "¿No la encuentra? Compruebe su Dirección en la pantalla de la unidad de stock.",
    "shipmentForm.stockHelp.locked": "Añadir se desactiva cuando el envío está Cerrado, Cancelado, o es una venta que ya salió.",
    "shipmentForm.statusDialogTitle": "Cambiar estado",
    "shipmentForm.statusForwardNote": "El stock de este envío ya se recibió, así que el estado solo puede avanzar.",
    "shipmentForm.receiveMark": "Ofrece Recibir en inventario",
    "shipmentForm.current": "Actual",
    "shipmentForm.setStatus": "Aplicar estado",
    "shipmentForm.statusPressUpdate": "Pulse Actualizar para guardar el nuevo estado.",
    "shipmentForm.statusPressSave": "Pulse Guardar para conservar el nuevo estado.",
    "shipmentForm.statusForwardTitle": "El estado solo puede avanzar",
    "shipmentForm.statusForwardSub": "El stock de este envío ya se recibió. El estado aún puede avanzar, pero no retroceder ni pasar a Cancelado.",
    "shipmentForm.activity": "Actividad",
    "shipmentForm.activityTip": "Quién creó este envío, cuándo cambió y su historial de estados",
    "loginBar.signedIn": "Ya ha iniciado sesión.",
    "loginBar.continue": "Continuar a LumberLinq",
    "loginBar.switch": "Iniciar sesión con otra cuenta",
    "shipmentForm.priceCheckHigh": "Este precio por CBM es mucho más alto que en sus envíos anteriores (unos {typical}). Compruebe el importe.",
    "shipmentForm.priceCheckLow": "Este precio por CBM es mucho más bajo que en sus envíos anteriores (unos {typical}). Compruebe el importe.",
    "shipment.status.SHIPPED": "Enviado",
    "shipmentForm.raw.backToConsignments": "Volver a los envíos",
    "shipmentForm.raw.goodsHaveArrivedReadyToReceiveInto": "La mercancía llegó — ¿lista para recibir en el inventario?",
    "shipmentForm.raw.filledIn": "Completado",
    "shipmentForm.raw.thisTabHasValidationErrors": "Esta pestaña tiene errores de validación",
    "shipmentForm.raw.consignmentDateIsRequired": "La fecha del envío es obligatoria",
    "shipmentForm.raw.blType": "Tipo de BL",
    "shipmentForm.raw.searchShipper": "Buscar remitente",
    "shipmentForm.raw.searchConsignee": "Buscar consignatario",
    "shipmentForm.raw.searchNotifyParty": "Buscar parte a notificar",
    "shipmentForm.raw.arrivalCannotBeBeforeDeparture": "La llegada no puede ser anterior a la salida",
    "shipmentForm.raw.countryOfDestination": "País de destino",
    "shipmentForm.raw.portCarrierDetails": "Detalles del puerto y del transportista",
    "shipmentForm.raw.portOfLoadingIsRequired": "El puerto de carga es obligatorio",
    "shipmentForm.raw.portOfDischargeIsRequired": "El puerto de descarga es obligatorio",
    "shipmentForm.raw.otherNotListed": "Otro (no listado)",
    "shipmentForm.raw.enterShippingLineName": "Escriba el nombre de la naviera",
    "shipmentForm.raw.customShippingLine": "Naviera personalizada",
    "shipmentForm.raw.vesselName": "Nombre del buque",
    "shipmentForm.raw.voyageNumber": "Número de viaje",
    "shipmentForm.raw.flightNumber": "Número de vuelo",
    "shipmentForm.raw.roadTransportDetails": "Detalles del transporte por carretera",
    "shipmentForm.raw.vehicleLrNo": "N.º de vehículo / LR",
    "shipmentForm.raw.railMovementDetails": "Detalles del transporte ferroviario",
    "shipmentForm.raw.originStationIcd": "Estación / ICD de origen",
    "shipmentForm.raw.destinationStationIcd": "Estación / ICD de destino",
    "shipmentForm.raw.railOperator": "Operador ferroviario",
    "shipmentForm.raw.searchByStockUnitIdTransportId": "Busque por ID de unidad de stock, ID de transporte, n.º de contenedor / camión o producto…",
    "shipmentForm.raw.openInStockUnitEditorNewTab": "Abrir en el editor de la unidad de stock (nueva pestaña)",
    "shipmentForm.raw.noTransportUnitsAddedYetStartBy": "Aún no se añadió ninguna unidad. Empiece buscando arriba.",
    "shipmentForm.raw.whoCanSeeThisDocumentInShares": "Quién puede ver este documento en comparticiones y exportaciones",
    "shipmentForm.raw.dropOrClickToUpload": "Suelte o haga clic para subir",
    "shipmentForm.raw.noDocumentsAttached": "Sin documentos adjuntos",
    "shipmentForm.raw.max5FilesReached": "Máximo de 5 archivos alcanzado",
    "shipmentForm.raw.label": "Etiqueta",
    "shipmentForm.raw.fileLabelMax16Chars": "Etiqueta del archivo (máx. 16 caracteres)",
    "shipmentForm.raw.attach": "Adjuntar",
    "shipmentForm.raw.fileSSelected": "archivo(s) seleccionado(s)",
    "shipmentForm.raw.dropOrClickToAddMultipleFiles": "Suelte o haga clic para añadir varios archivos",
    "shipmentForm.raw.selectCurrency": "Seleccione la moneda",
    "shipmentForm.raw.days": "Días",
    "shipmentForm.raw.describePaymentTerms": "Describa las condiciones de pago…",
    "shipmentForm.raw.customTerms": "Condiciones personalizadas",
    "shipmentForm.raw.dueDate": "Fecha de vencimiento",
    "shipmentForm.raw.outstandingReceivable": "Pendiente de cobro",
    "shipmentForm.raw.outstandingPayable": "Pendiente de pago",
    "shipmentForm.raw.paymentDetails": "Detalles del pago",
    "shipmentForm.raw.paymentDate": "Fecha de pago *",
    "shipmentForm.raw.utrLCNoRef": "UTR / N.º L/C / Ref.",
    "shipmentForm.raw.amountCurrency": "Importe y moneda",
    "shipmentForm.raw.amount": "Importe *",
    "shipmentForm.raw.optionalContextForThisPayment": "Contexto opcional para este pago…",
    "shipmentForm.raw.noPaymentsRecordedYet": "Aún no hay pagos registrados.",
    "shipmentForm.raw.editPayment": "Editar pago",
    "shipmentForm.raw.deletePayment": "Eliminar pago",
    "shipmentForm.raw.totalReceived": "Total recibido:",
    "shipmentForm.raw.totalPaid": "Total pagado:",
    "shipmentForm.raw.previousTabAltLeft": "Pestaña anterior (Alt + Izquierda)",
    "shipmentForm.raw.nextTabAltRight": "Pestaña siguiente (Alt + Derecha)",
    "shipmentForm.lastUpdated": "Última actualización",
    "shipmentForm.statusHistory": "Historial de estados",
    "shipmentForm.noHistory": "No hay historial de estados que mostrar.",
    "shipment.status.DRAFT": "Borrador",
    "shipment.status.CONFIRMED": "Confirmado",
    "shipment.status.PLANNED": "Planificado",
    "shipment.status.STUFFING": "Estiba",
    "shipment.status.STUFFED": "Estibado",
    "shipment.status.GATE_OUT": "Salida de puerta",
    "shipment.status.IN_TRANSIT": "En tránsito",
    "shipment.status.ARRIVED": "Llegó",
    "shipment.status.UNSTUFFING": "Desestiba",
    "shipment.status.DELIVERED": "Entregado",
    "shipment.status.CLOSED": "Cerrado",
    "shipment.status.CANCELLED": "Cancelado",
    "shipment.statusGroup.planning": "Planificación",
    "shipment.statusGroup.loading": "Carga",
    "shipment.statusGroup.way": "En camino",
    "shipment.statusGroup.arrival": "Llegada",
    "shipment.statusGroup.finished": "Finalizado",
    "shipment.statusMeaning.DRAFT": "En preparación",
    "shipment.statusMeaning.CONFIRMED": "Operación acordada",
    "shipment.statusMeaning.PLANNED": "Envío organizado",
    "shipment.statusMeaning.STUFFING.sale": "Está cargando la mercancía",
    "shipment.statusMeaning.STUFFING.buy": "El proveedor está cargando la mercancía",
    "shipment.statusMeaning.STUFFED.sale": "Cargado y precintado",
    "shipment.statusMeaning.STUFFED.buy": "Cargado en el proveedor",
    "shipment.statusMeaning.GATE_OUT.sale": "Salió de la puerta del patio o puerto",
    "shipment.statusMeaning.GATE_OUT.buy": "El proveedor lo cargó y lo envió",
    "shipment.statusMeaning.IN_TRANSIT.sale": "De camino al comprador",
    "shipment.statusMeaning.IN_TRANSIT.buy": "De camino a usted",
    "shipment.statusMeaning.ARRIVED.sale": "Llegó al destino",
    "shipment.statusMeaning.ARRIVED.buy": "Llegó a su puerto o patio",
    "shipment.statusMeaning.UNSTUFFING.sale": "Se está descargando el contenedor",
    "shipment.statusMeaning.UNSTUFFING.buy": "Se está descargando el contenedor",
    "shipment.statusMeaning.DELIVERED.sale": "El comprador tiene la mercancía",
    "shipment.statusMeaning.DELIVERED.buy": "La mercancía está con usted",
    "shipment.statusMeaning.CLOSED": "Finalizado y liquidado",
    "shipment.statusMeaning.CANCELLED": "Anulado",
    "shipment.statusEffect.DRAFT": "Nada cambia en el stock. Úselo mientras falten datos.",
    "shipment.statusEffect.CONFIRMED": "Nada cambia en el stock.",
    "shipment.statusEffect.PLANNED": "Nada cambia en el stock.",
    "shipment.statusEffect.STUFFING.sale": "Nada cambia en el stock. Las unidades de stock aparecen en En envío.",
    "shipment.statusEffect.STUFFING.buy": "Nada cambia en el stock. Las unidades de stock aparecen en En envío.",
    "shipment.statusEffect.STUFFED.sale": "Nada cambia en el stock. Las unidades de stock aparecen en En tránsito.",
    "shipment.statusEffect.STUFFED.buy": "Nada cambia en el stock. Las unidades de stock aparecen en En tránsito.",
    "shipment.statusEffect.GATE_OUT.sale": "Nada cambia en el stock. Las unidades de stock aparecen en En tránsito.",
    "shipment.statusEffect.GATE_OUT.buy": "Nada cambia en el stock. Las unidades de stock aparecen en En tránsito.",
    "shipment.statusEffect.IN_TRANSIT.sale": "Nada cambia en el stock (el stock solo baja al confirmar la salida). Desde aquí no se puede añadir ninguna unidad de stock nueva a esta venta.",
    "shipment.statusEffect.IN_TRANSIT.buy": "Nada cambia en el stock (el stock solo sube al recibirlo en el inventario). Las unidades de stock aparecen en En tránsito.",
    "shipment.statusEffect.ARRIVED.sale": "Nada cambia en el stock. Ya no se pueden añadir unidades de stock a esta venta.",
    "shipment.statusEffect.ARRIVED.buy": "El stock aún no sube. Se le preguntará si desea recibir las unidades de stock en el inventario (Recibir en inventario).",
    "shipment.statusEffect.UNSTUFFING.sale": "Nada cambia en el stock.",
    "shipment.statusEffect.UNSTUFFING.buy": "El stock aún no sube. Se le preguntará si desea recibir las unidades de stock en el inventario (Recibir en inventario).",
    "shipment.statusEffect.DELIVERED.sale": "El stock solo baja al confirmar la salida de cada unidad de stock, no por este estado. Ya no se pueden añadir unidades de stock.",
    "shipment.statusEffect.DELIVERED.buy": "Reciba las unidades de stock que aún no se recibieron. El stock solo sube al recibirlas en el inventario, no por este estado.",
    "shipment.statusEffect.CLOSED": "No se pueden añadir más unidades de stock. Las cantidades de stock no cambian.",
    "shipment.statusEffect.CANCELLED": "Las cantidades de stock no cambian y no se pueden añadir más unidades de stock. Si el stock ya se recibió o confirmó, corríjalo con Añadir ajuste.",
    "shipment.paymentSummaryTitle": "Resumen de Pago",
    "shipment.invoiceAmount": "Monto de la Factura",
    "shipment.received": "Recibido",
    "shipment.paid": "Pagado",
    "shipment.salesPaymentStatus": "Estado de Pago de Ventas",
    "shipment.purchasePaymentStatus": "Estado de Pago de Compras",
    "shipment.coreDetails": "Core Consignación Detalles",
    "shipment.saveChanges": "Guardar Changes",
    "shipment.listSubtitle": "Track, filter, and manage consignment operations",
    "shipment.filterBl": "Filter BL",
    "shipment.filterBuyerOrder": "Filter Buyer Order",
    "shipment.filterExportRef": "Filter Export Ref",
    "shipment.filterShipper": "Filter Shipper",
    "shipment.filterConsignee": "Filter Consignee",
    "shipment.filterStatus": "Filter Estado",
    "shipment.viewDetails": "Ver consignment details",
    "shipment.payments": "Pagos",
    "common.confirm": "Confirmar",
    "shipment.changeStatus": "Cambiar Estado",
    "shipment.receiveIntoInventory": "Recibir en Inventario",
    "share.actions": "Share actions",
    "share.duration": "Duration",
    "share.accessLimit": "Acceso limit",
    "share.customAccessCount": "Custom access count",
    "share.allowDownload": "Permitir exportación y descargas",
    "share.protectedAudience": "Protegido audience",
    "share.companyIdNotFound": "el ID de empresa no existe",
    "share.emailNotFound": "no es un usuario registrado de LumberLinq",
    "share.createLink": "Crear Link",
    "share.createTallysheetLink": "Crear tallysheet link",
    "share.tallysheetSharedLinks": "Hoja de cubicación Shared Links",
    "share.audience": "Audience",
    "share.createdBy": "Creado por",
    "share.limit": "Limit",
    "share.download": "Descargar",
    "share.noLinksFound": "No shared links found.",
    "share.public": "Cualquiera con el enlace",
    "share.protected": "Solo usuarios de LumberLinq",
    "share.private": "Solo mi equipo",
    "share.publicTooltip": "Accesible para cualquiera con este enlace — no se requiere inicio de sesión",
    "share.protectedTooltip": "Solo los usuarios de LumberLinq pueden ver — se requiere inicio de sesión",
    "share.privateTooltip": "Solo los miembros de tu equipo pueden ver esto",
    "share.accessMode": "Acceso mode",
    "share.linkSettings": "Link settings",
    "share.allowDownloadHint": "Cuando está desactivado, los espectadores no pueden exportar el albarán ni descargar archivos de consignación.",
    "share.linkPreview": "Mostrar detalles en la vista previa del enlace",
    "share.linkPreviewHintPublic": "Cuando está activado, WhatsApp, Telegram y otras apps de mensajería muestran piezas, volumen y productos (solo los campos que permiten sus ajustes de acceso).",
    "share.linkPreviewHintLocked": "Cuando está activado, las apps de mensajería muestran una tarjeta bloqueada con el número de Stock Units. No se muestra ningún otro detalle.",
    "share.preview": "Vista previa",
    "share.linkInventory": "Enlaces Compartidos",
    "share.specificCompanyIds": "Specific Empresa IDs",
    "share.specificEmails": "Specific Email Addresses",
    "share.anyLumberlinqUser": "Any Lumberlinq Usuario",
    "share.manageAudience": "Gestionar audiencia",
    "share.audienceEmails": "Direcciones de correo",
    "share.audienceCompanies": "IDs de empresa",
    "share.addEntry": "Agregar",
    "share.audienceMinOne": "Se requiere al menos una entrada",
    "share.audienceDeleteGate": "Añade primero una nueva entrada para habilitar la eliminación",
    "share.audienceNoEntries": "Sin entradas aún",
    "share.audienceEmailPlaceholder": "Introducir dirección de correo",
    "share.audienceCompanyPlaceholder": "Introducir ID de empresa",
    "share.never": "Never",
    "share.noRestriction": "No restriction",
    "share.missingTransportUnit": "Missing stock unit",
    "share.saveOrLoadTransportUnit": "Guardar or load a stock unit before creating a share link.",
    "share.tallysheetLinkCreated": "Hoja de cubicación link created",
    "share.linkCopiedToClipboard": "Share link copied to clipboard.",
    "share.linkFailed": "Link failed",
    "shareAudit.title": "Share Link Acceso Audit",
    "shareAudit.accesses": "accesses",
    "shareAudit.noAccesses": "No share link accesses recorded yet.",
    "shareAudit.emptyHint": "Every time someone opens a share link, it will appear here.",
    "shareAudit.allowed": "Allowed",
    "shareAudit.denied": "Denied",
    "shareAudit.uniqueVisitors": "Unique Visitors",
    "shareAudit.bots": "Bots",
    "shareAudit.emailUser": "Email / Usuario",
    "shareAudit.accessedAt": "Accessed At",
    "shareAudit.ipAddress": "IP Dirección",
    "shareAudit.location": "Ubicación",
    "shareAudit.browser": "Browser",
    "shareAudit.os": "OS",
    "shareAudit.shareLink": "Share Link",
    "shareAudit.anonymous": "Anonymous",
    "shareAudit.noEntries": "No audit entries found.",
    "share.unableToCreateTallysheetLink": "Unable to create tallysheet share link.",
    "share.oneDay": "1 day",
    "share.sevenDays": "7 days",
    "share.thirtyDays": "30 days",
    "share.ninetyDays": "90 días",
    "share.neverExpires": "Never expires",
    "tallysheet.rowLimit.title": "La hoja de conteo está llena",
    "tallysheet.rowLimit.message": "Una hoja de conteo admite como máximo {max} filas. Cree una hoja nueva para el resto.",
    "tallysheet.rowLimit.importMessage": "Estas filas llevarían la hoja más allá de {max} filas, por lo que no se importó nada. Importe menos filas o use una hoja nueva.",
    "share.publicExpiryHint": "Los enlaces públicos siempre caducan, así que un enlace antiguo no puede abrirlo quien lo encuentre más tarde.",
    "share.disableAll": "Desactivar todos",
    "share.disableAllConfirm": "¿Desactivar todos los enlaces de este registro? Nadie podrá abrirlos.",
    "share.disableAllDone": "Enlaces desactivados",
    "share.oneTime": "One time",
    "share.threeAccesses": "3 accesses",
    "share.fiveAccesses": "5 accesses",
    "share.tenAccesses": "10 accesses",
    "share.custom": "Custom",
    "share.viewSharedLinks": "Ver shared links",
    "share.copyDirectLink": "Copy direct link",
    "share.openDirectLink": "Open direct link",
    "share.copyLink": "Copy Link",
    "share.openLink": "Open Link",
    "share.anyoneWithLink": "Anyone with link can access",
    "share.requiresVerification": "Requires verification",
    "share.restrictedUsersOnly": "Restricted users only",
    "share.addEmailAddress": "Agregar Lumberlinq email address",
    "share.addCompanyId": "Agregar company ID",
    "share.missingDetails": "Missing details",
    "share.completeRestrictions": "Please complete the selected sharing restrictions.",
    "share.generatingLink": "Generating link...",
    "share.pleaseWait": "Please wait",
    "share.linkCreated": "Link created",
    "share.tallysheetLinkGenerated": "Hoja de cubicación share link generated.",
    "share.linkGeneratedSuccessfully": "Share link generated successfully",
    "share.failed": "Failed",
    "share.unableToCreateShareLink": "Unable to create share link",
    "share.unableToLoadSharedLinks": "Unable to load shared links.",
    "share.docAccess": "Acceso al Documento",
    "share.docAccessHint": "Controla lo que los espectadores pueden hacer con cada documento",
    "share.doc_bl": "Archivo BL",
    "share.doc_ewaybill": "E-Waybill / LR",
    "share.doc_co": "Certificado de Origen",
    "share.doc_phyto": "Fitosanitario",
    "share.doc_invoice": "Factura Comercial",
    "share.doc_other": "Otros Documentos",
    "share.docFull": "Acceso Completo",
    "share.docViewOnly": "Solo Ver",
    "share.docFilenameOnly": "Solo Nombre de Archivo",
    "share.docHidden": "Oculto",
    "share.copied": "Copied",
    "share.linkCopied": "Link copied",
    "share.transportIdCopied": "Transporte ID copied!",
    "share.confirmRevoke": "Are you sure you want to revoke this link?",
    "share.confirmActivate": "Are you sure you want to activate this link?",
    "share.generateShareLink": "Generate Share Link",
    "share.generateShareQuestion": "Do you want to generate",
    "share.shareLinkSuffix": "share link?",
    "share.unableToUpdateLinkStatus": "Unable to update link status.",
    "subscription.transactions": "Transactions",
    "subscription.purchase": "Purchase",
    "subscription.customerCode": "Customer Code",
    "subscription.currentName": "Current Subscription Name",
    "subscription.refresh": "Actualizar",
    "subscription.validTill": "Current Subscription Valid Till",
    "subscription.lastPayment": "Last Pago Made On",
    "subscription.paymentDue": "Pago Due On",
    "subscription.paidTill": "Paid Till",
    "subscription.status": "Subscription Estado",
    "subscription.downgradedTitle": "Estás en el Plan Gratuito",
    "subscription.downgradedBody": "Tu suscripción de pago venció y esta cuenta pasó automáticamente al plan gratuito. Sigues teniendo acceso completo a todo lo que ya creaste — simplemente no puedes agregar elementos nuevos más allá de los límites del plan gratuito. Renueva en cualquier momento para desbloquear el acceso completo de nuevo.",
    "subscription.utcNote": "Please note that our system operates based on Coordinated Universal Time (UTC). Therefore, the time of your subscription's activation and expiration will be calculated based on this time zone. If you are in a different time zone, there may be a perceived difference in the timing of your subscription's start and end dates",
    "subscription.autoPay": "Pago Automático (EMandate)",
    "subscription.cancelAutoPay": "Cancelar Pago Automático",
    "utility.title": "Utility",
    "utility.slabCalculator": "Slab Calculator",
    "utility.slabSubheader": "Input slab dimensions to generate price estimations per size difference",
    "tallysheet.settings": "Configuración",
    "tallysheet.validationRules": "Validation Rules",
    "tallysheet.configurationSettings": "Configuration Configuración",
    "tallysheet.transportDetails": "Transporte Detalles",
    "tallysheet.tu.direction": "Dirección",
    "tallysheet.tu.directionChangeHeader": "¿Cambiar Dirección?",
    "tallysheet.tu.directionChangeMessage": "Cambiar la Dirección puede restablecer algunos campos relacionados con el Inventario — ¿continuar?",
    "tallysheet.tu.directionStockIn": "Entrada de Stock",
    "tallysheet.tu.directionStockOut": "Salida de Stock",
    "tallysheet.tu.directionMove": "Traslado Entre Sitios",
    "tallysheet.tu.gridStyle": "Diseño de Conteo",
    "tallysheet.tu.gridStyleClassicHint": "Un producto por línea, elegido ahora.",
    "tallysheet.tu.gridStyleFlexibleHint": "Elija productos por fila al empezar a tabular — no hace falta elegir ahora.",
    "tallysheet.tu.directionChangeHint": "Guardado — la dirección no se puede cambiar después de guardar.",
    "tallysheet.tu.gridStyleChangeHint": "Guardado — el diseño no se puede cambiar después de guardar.",
    "tallysheet.tu.destinationSite": "Sitio de Destino",
    "tallysheet.tu.destinationSiteRequired": "El sitio de destino es obligatorio.",
    "tallysheet.tu.origin": "Origen",
    "tallysheet.tu.originOptional": "Origen (opcional)",
    "tallysheet.tu.quality": "Calidad",
    "tallysheet.tu.qualityOptional": "Calidad (opcional)",
    "tallysheet.tu.qualityMixed": "Mixto / Cualquiera",
    "tallysheet.tu.cbmInStock": "CBM en stock",
    "tallysheet.tu.inStockSuffix": "libres",
    "tallysheet.tu.clickForCft": "Haga clic para mostrar en CFT",
    "tallysheet.tu.clickForCbm": "Haga clic para mostrar en CBM",
    "tallysheet.tu.afterThisSave": "Restante después de guardar",
    "tallysheet.tu.heldByThisSheet": "Reservado por esta hoja",
    "tallysheet.tu.stockFree": "Libre",
    "tallysheet.tu.stockHeld": "Reservado",
    "tallysheet.tu.stockInStock": "En stock",
    "tallysheet.tu.stockRowSizeTip": "La fila pulsada: libre para esta hoja, reservado por otras Salidas de stock y el total en stock (este largo o más)",
    "tallysheet.tu.stockAvailability": "Disponibilidad de Stock",
    "tallysheet.tu.noStock": "Sin stock",
    "tallysheet.tu.stockCantVerifyOffline": "No se puede verificar — sin conexión",
    "tallysheet.tu.noStockAtSite": "Sin stock en",
    "tallysheet.tu.availableAtSite": "disponible en",
    "tallysheet.tu.stockBreakdownTitle": "Desglose de Stock",
    "tallysheet.tu.stockOrigin": "Origen",
    "tallysheet.tu.stockQuality": "Calidad",
    "tallysheet.tu.stockPieces": "Piezas",
    "tallysheet.tu.stockSeal": "Sello",
    "tallysheet.tu.stockSupplier": "Proveedor",
    "tallysheet.tu.stockNoContributors": "No se encontraron Unidades de Stock contribuyentes.",
    "tallysheet.tu.confirmDeleteHeader": "Confirmar Eliminación",
    "tallysheet.tu.confirmDeleteMessage": "¿Está seguro de que desea eliminar la Unidad de Stock ({transportId})?",
    "tallysheet.tu.deleteConfirmAccept": "Sí, Eliminar",
    "tallysheet.tu.deletedSuccess": "Unidad de Stock eliminada con éxito",
    "tallysheet.tu.deleteNotAllowedHeader": "Eliminación No Permitida",
    "tallysheet.tu.deleteNotAllowedFallback": "Esta Unidad de Stock no se puede eliminar en este momento.",
    "tallysheet.tu.deleteFailedHeader": "Error al Eliminar",
    "tallysheet.tu.deleteFailedMessage": "No se pudo eliminar la Unidad de Stock. Inténtelo de nuevo más tarde.",
    "tallysheet.fulfill.title": "Plan de Cumplimiento",
    "tallysheet.fulfill.size": "Tamaño",
    "tallysheet.fulfill.grade": "Grado",
    "tallysheet.fulfill.inStock": "En Stock",
    "tallysheet.fulfill.allocate": "Usar",
    "tallysheet.fulfill.waste": "Merma",
    "tallysheet.fulfill.why": "Motivo",
    "tallysheet.fulfill.required": "Requerido",
    "tallysheet.fulfill.covered": "Cubierto",
    "tallysheet.fulfill.short": "Faltan",
    "tallysheet.fulfill.moreOptions": "Más opciones",
    "tallysheet.fulfill.noStock": "No hay stock práctico para este tamaño, origen y calidad.",
    "tallysheet.fulfill.tierExact": "Coincidencia exacta",
    "tallysheet.fulfill.tierTrim": "Más largo — recortar",
    "tallysheet.fulfill.tierResaw": "Reaserrar de mayor",
    "tallysheet.fulfill.tierGrade": "Grado diferente",
    "tallysheet.fulfill.tierOrigin": "Origen diferente",
    "tallysheet.fulfill.tierShort": "Más corto — confirmar",
    "tallysheet.fulfill.tierMixed": "Largos mixtos — verificar",
    "tallysheet.quick.button": "Tally Rápido",
    "tallysheet.quick.tooltip": "Escriba abreviado como 4x3x7 250 Ghana A — el sistema crea las filas",
    "tallysheet.quick.title": "Tally Rápido",
    "tallysheet.quick.hint": "Una entrada por coma o línea: tamaño, piezas, luego origen y calidad opcionales. Ejemplo: 4x3x7 250 Ghana A",
    "tallysheet.quick.notes": "Notas",
    "tallysheet.quick.apply": "Agregar filas",
    "tallysheet.quick.noDimensions": "No se encontró tamaño (ej. 4x3x7)",
    "tallysheet.quick.noPieces": "Falta la cantidad de piezas",
    "tallysheet.quick.lengthMissing": "Falta el largo — complételo en la cuadrícula",
    "tallysheet.flex.button": "Diseño Flexible",
    "tallysheet.flex.classicOption": "Diseño Estándar",
    "tallysheet.flex.searchProducts": "Buscar productos...",
    "tallysheet.flex.noProductsFound": "No se encontraron productos",
    "tallysheet.flex.pickProductFirst": "Elija primero un producto para ver su stock",
    "tallysheet.flex.switchTooltip": "Estándar: un producto por línea. Flexible: producto/origen/calidad por fila, además de tamaños del stock",
    "tallysheet.flex.cascadeTitle": "Producto de la Fila",
    "tallysheet.flex.stockTitle": "Elegir del stock",
    "tallysheet.flex.noProductYet": "Aún no se ha elegido un producto",
    "tallysheet.flex.sameAsLine": "Igual que la línea",
    "tallysheet.flex.typedSoFar": "Escrito hasta ahora",
    "tallysheet.flex.showAll": "Mostrar todos",
    "tallysheet.flex.requestCustomMade": "No disponible — solicitar fabricación a medida",
    "tallysheet.flex.cancelRequest": "Cancelar solicitud",
    "tallysheet.flex.cancelRequestHeader": "¿Cancelar la solicitud al aserradero?",
    "tallysheet.flex.cancelRequestMessage": "El aserradero ya no cortará este tamaño para esta fila. Puede volver a pedirlo más tarde.",
    "tallysheet.flex.cancelRequestYes": "Sí, cancelar",
    "tallysheet.flex.cancelRequestDone": "Solicitud al aserradero cancelada",
    "tallysheet.flex.noneMatchExactly": "Ninguno de estos coincide exactamente con:",
    "tallysheet.flex.stockStaleNotice": "Mostrando existencias de su última sincronización — pueden estar desactualizadas.",
    "tallysheet.flex.availablePcs": "piezas disponibles para este tamaño",
    "tallysheet.flex.availableCbm": "CBM disponible",
    "tallysheet.flex.availableStockTooltip": "El stock disponible excluye lo que ya está reservado por otras filas de salida de stock guardadas y tareas activas de aserradero — aún no confirmado, pero ya comprometido. Cambie esto en Empresa → Configuración de inventario.",
    "tallysheet.flex.customMadeLockedTitle": "Fila bloqueada — tarea de aserradero en curso",
    "tallysheet.flex.customMadeLockedDetail": "El material de esta fila ya está siendo cortado por una tarea de aserradero y no se puede editar ni eliminar hasta que esa tarea termine. Se desbloquea automáticamente al finalizar — no se requiere ninguna acción.",
    "tallysheet.flex.importUnavailable": "La importación no está disponible en Vista Flexible — cambia a Diseño Estándar para importar.",
    "tallysheet.flex.customMadeLockedTooltipProducing": "Bloqueado — una tarea de aserradero está cortando este tamaño ahora mismo. Se desbloqueará automáticamente cuando esa tarea termine.",
    "tallysheet.flex.customMadeLockedTooltipWaiting": "Bloqueado — se ha creado una tarea de aserradero para este tamaño y está en cola para comenzar. Se desbloqueará automáticamente cuando esa tarea termine.",
    "tallysheet.flex.customMadeLockedTooltipPaused": "Bloqueado — la tarea de aserradero para este tamaño ya comenzó y está en pausa. Se desbloqueará automáticamente cuando esa tarea termine o se cancele.",
    "tally.aiReview.needsOne": "fila necesita revisión — la IA no estaba segura o no pudo leer un valor",
    "tally.aiReview.needsMany": "filas necesitan revisión — la IA no estaba segura o no pudo leer un valor",
    "tally.aiReview.showOnly": "Mostrar solo estas",
    "tally.aiReview.showAll": "Mostrar todas las filas",
    "tally.aiReview.showOnlyTip": "Mostrar solo estas filas",
    "tally.aiReview.prev": "Fila anterior por revisar",
    "tally.aiReview.next": "Siguiente fila por revisar",
    "tally.aiReview.row": "Fila",
    "tally.warn.lengthRange": "Longitud fuera del rango configurado — se conserva el valor",
    "tally.warn.girthRange": "Circunferencia fuera del rango configurado — se conserva el valor",
    "tally.errorNav.lengthMissing": "Fila {row}: falta la Longitud",
    "tally.errorNav.girthMissing": "Fila {row}: falta la Circunferencia",
    "tally.errorNav.bothMissing": "Fila {row}: faltan la Longitud y la Circunferencia",
    "tally.warn.divisibleBy5": "La longitud no es múltiplo de 5 — se conserva el valor",
    "tallysheet.flex.deleteRowConfirm": "¿Eliminar esta fila?",
    "tallysheet.flex.stockStatusLabel": "Estado del Stock",
    "tallysheet.flex.stockStatusNotReserved": "Punto rojo — aún sin coincidencia exacta, nada reservado para esta fila",
    "tallysheet.flex.stockStatusMillTask": "Produciendo / Esperando inicio — retenido por una tarea activa de aserradero",
    "tallysheet.flex.stockStatusReserved": "Sin insignia — coincide con stock real y reservado",
    "company.includeReservations.label": "Contabilizar el trabajo en curso en el stock disponible",
    "company.includeReservations.hint": "Activado de forma predeterminada — el stock ya reclamado por filas de salida guardadas o tareas activas de aserradero no aparecerá como disponible hasta que se confirme o libere. Desactive para ver el total físico bruto.",
    "tallysheet.flex.back": "Atrás",
    "tallysheet.flex.next": "Siguiente",
    "tallysheet.flex.done": "Listo",
    "tallysheet.flex.scEnter": "abrir asistente/selector · en Piezas: siguiente fila llena",
    "tallysheet.flex.scAltEnter": "selector de stock en cualquier momento",
    "tallysheet.flex.scCtrlEnter": "nueva fila",
    "tallysheet.flex.scCtrlBackspace": "limpiar fila",
    "tallysheet.flex.shortcutsLabel": "Atajos",
    "tallysheet.flex.shapeSubtitleSquare": "🔵 Esto es un Tallysheet cuadrado — solo se muestran productos de corte cuadrado. Los productos redondos no aparecerán aquí.",
    "tallysheet.flex.shapeRedirect": "¿Necesita otra forma (ej. troncos redondos)? Cambie al Diseño Estándar — allí cada línea de producto tiene su propio tipo de conteo.",
    "tallysheet.flex.lockedTooltip": "Bloqueado — esta hoja ya tiene filas guardadas. Elija el diseño antes de guardar.",
    "tallysheet.flex.confirmSwitchHeader": "¿Cambiar al Diseño Flexible?",
    "tallysheet.flex.confirmSwitchMessage": "Tiene filas sin guardar. Cambiar es seguro, pero considere guardar primero. ¿Continuar?",
    "tallysheet.tu.stockAnyOrigin": "Cualquier origen",
    "tallysheet.tu.stockAnyQuality": "Cualquier calidad",
    "tallysheet.tu.additionalProducts": "Productos Adicionales",
    "tallysheet.tu.products": "Productos",
    "tallysheet.tu.viewStock": "Ver disponibilidad de stock",
    "tallysheet.tu.removeLineConfirmHeader": "Eliminar Hoja de Conteo",
    "tallysheet.tu.removeLineConfirmMessage": "Eliminar la hoja de conteo de {product} eliminará permanentemente {count} registro(s) de conteo vinculados. Escriba CONFIRM para continuar.",
    "tallysheet.tu.addAnotherProduct": "Agregar otro producto",
    "tallysheet.tu.removeLine": "Eliminar esta línea de producto",
    "tallysheet.tu.removeLineHeader": "Eliminar Línea de Producto",
    "tallysheet.tu.removeLineMessage": "Si esta línea ya tiene filas de conteo, primero deben eliminarse — de lo contrario, no se podrá guardar.",
    "tallysheet.tu.typeSwitchHeader": "El Tipo de Conteo Cambiará",
    "tallysheet.tu.typeSwitchMessage": "Cambiar el producto en {lines} cambia su tipo de conteo — las filas de conteo existentes de esa línea se eliminarán permanentemente. ¿Continuar?",
    "tallysheet.overStock.header": "Guardando Más Allá del Stock Disponible",
    "tallysheet.overStock.message": "{line} se contaría en {total} CBM, pero solo hay {available} CBM disponible en stock. Indique por qué desea continuar de todos modos:",
    "tallysheet.overStock.reasonPlaceholder": "Motivo (obligatorio)",
    "tallysheet.overStock.proceed": "Guardar de Todos Modos",
    "tallysheet.stockUnitId": "ID de Unidad de Stock",
    "tallysheet.tu.tooltipStockUnitId": "Identidad de esta Unidad de Stock — asignada automáticamente por el sistema, única, nunca editable. Generada al guardar.",
    "tallysheet.stockUnitIdPending": "Pendiente",
    "tallysheet.transportId": "Transporte ID",
    "tallysheet.transportModeDetails": "Transporte Mode Detalles",
    "tallysheet.tu.tooltipTransportId": "Referencia opcional para el vehículo/contenedor real usado — puede repetirse (ej: el mismo camión puede volver más de una vez)",
    "tallysheet.tu.tooltipContainerNumber": "Número de contenedor ISO asignado por el transportista — 4 letras + 6 dígitos + dígito de control (ej: MSCU1234567)",
    "tallysheet.tu.tooltipSealNo": "Sello de seguridad físico fijado a la puerta del contenedor — referenciado en documentos fitosanitarios y aduaneros (ej: SNHR123456)",
    "tallysheet.tu.tooltipLoadingSite": "Lugar donde se cargó originalmente la madera — sitio de origen (bosque, patio, aserradero o puerto)",
    "tallysheet.tu.tooltipRoute": "Ruta del camión desde el sitio hasta el destino (ej: Raipur al Puerto de Kandla)",
    "tallysheet.tu.tooltipVehicleRegNo": "Matrícula oficial del camión o remolque (ej: MH04-AB-1234)",
    "tallysheet.tu.tooltipWagonNo": "Número del vagón ferroviario como aparece impreso en el vagón (ej: BOXN-67890)",
    "tallysheet.chooseColumns": "Elegir Columns",
    "tallysheet.colPreset.simple": "Simple",
    "tallysheet.colPreset.detailed": "Detallado",
    "tallysheet.colPreset.custom": "Personalizado",
    "tallysheet.colGroup.measurements": "Medidas",
    "tallysheet.colGroup.volume": "Volumen",
    "tallysheet.colGroup.allowances": "Tolerancias",
    "tallysheet.colGroup.other": "Otros",
    "tallysheet.editSettings": "Editar ajustes de la tally",
    "tallysheet.decimalsShort": "decimales",
    "tallysheet.globalSearch": "Global Buscar",
    "tallysheet.transportUnits": "Unidades de Stock",
    "tallysheet.unit": "unidad",
    "tallysheet.units": "unidades",
    "tallysheet.transportUnitsSubtitle": "Revise unidades de stock, abra tallys y gestione enlaces seguros",
    "tallysheet.viewTallysheet": "Ver tallysheet",
    "tallysheet.thisPage": "esta página",
    "tallysheet.allPages": "todas las páginas",
    "tallysheet.sortNewest": "Más recientes",
    "tallysheet.sortOldest": "Más antiguos",
    "tallysheet.sortStockUnitId": "ID de unidad de stock",
    "tallysheet.sortProduct": "Producto",
    "tallysheet.fullReportPdf": "Informe completo (PDF)",
    "tallysheet.copyTransportId": "Copy transport ID",
    "tallysheet.operations": "Operations",
    "tallysheet.newTallysheet": "New Hoja de cubicación",
    "tallysheet.syncedTitle": "Sincronizado",
    "tallysheet.syncedDetail": "Esta unidad de stock se ha sincronizado con el servidor.",
    "tallysheet.newTransportUnit": "Nueva unidad de stock",
    "tallysheet.newTallysheetSubtitle": "Capture stock unit details, tally measurements, photos, and summary in one workflow.",
    "tallysheet.editTransportUnit": "Editar unidad de stock",
    "tallysheet.viewTransportUnit": "Ver unidad de stock",
    "tallysheet.editTransportUnitSubtitle": "Actualice los detalles de la unidad de stock, las mediciones de cubicación, las fotos y el resumen en un solo flujo.",
    "tallysheet.viewTransportUnitSubtitle": "Revise los detalles de la unidad de stock, las mediciones de cubicación, las fotos y el resumen en un solo flujo.",
    "tallysheet.transportUnit": "Unidad de Stock",
    "tallysheet.switchingTu": "Cargando unidad de stock…",
    "tallysheet.tuLoadFailed": "No se pudo cargar esta unidad de stock.",
    "tallysheet.tallysheet": "Hoja de cubicación",
    "tallysheet.roundTallysheet": "Round Hoja de cubicación",
    "tallysheet.squareTallysheet": "Square Hoja de cubicación",
    "tallysheet.measurementGrid": "Measurement grid",
    "tallysheet.measurementGridSubtitle": "Capture, validate, import, and save tally measurements",
    "tallysheet.rows": "Rows",
    "tallysheet.columnsSelected": "Columns",
    "tallysheet.editActions": "Editar",
    "tallysheet.viewControls": "Ver",
    "tallysheet.dataActions": "Data",
    "tallysheet.voiceControls": "Voice",
    "tallysheet.photos": "Photos",
    "tallysheet.summary": "Resumen",
    "tallysheet.reconciliation": "Reconciliation",
    "tallysheet.goToRow": "Go to Row",
    "tallysheet.export": "Exportar",
    "tallysheet.quickExcelExport": "Quick Excel",
    "tallysheet.exportOptions": "Export Options…",
    "export.companyDetails": "Detalles de la Empresa",
    "export.chartsAndStats": "Gráficos y Estadísticas",
    "export.showMaskedFields": "Mostrar Campos Enmascarados",
    "export.watermark": "Marca de Agua",
    "export.packingList": "Lista de Embalaje",
    "export.surveyReport": "Informe de Inspección",
    "export.certificate": "Certificado",
    "tallysheet.save": "Guardar",
    "tallysheet.sr": "Sr",
    "tallysheet.orderKey": "Order Key",
    "tallysheet.girth": "Girth",
    "tallysheet.lengthAllowanceShort": "Longitud Allow.",
    "tallysheet.girthAllowanceShort": "Girth Allow.",
    "tallysheet.netLength": "Net Longitud",
    "tallysheet.netGirth": "Net Girth",
    "tallysheet.net": "Neto",
    "tallysheet.gross": "Bruto",
    "tallysheet.allowance": "Descuento",
    "tallysheet.volBasisHint": "Mostrando volumen neto — toque para bruto",
    "tallysheet.volBasisHintGross": "Mostrando volumen bruto — toque para neto",
    "tallysheet.volBasisWhy": "El neto cuenta para existencias, ventas y trabajos de aserradero. El bruto es la medida original. Toque Neto o Bruto para cambiar.",
    "tallysheet.volBreakdownTitle": "Volumen Neto vs Bruto",
    "tallysheet.volBreakdownExplain": "El neto es lo que cuenta para existencias, ventas y trabajos de aserradero. El bruto es la medida original, antes del descuento de corteza y corte.",
    "tallysheet.switchToGross": "Cambiar a Bruto",
    "tallysheet.switchToNet": "Cambiar a Neto",
    "tallysheet.grossCbm": "Gross CBM",
    "tallysheet.grossCft": "Gross CFT",
    "tallysheet.netCbm": "Net CBM",
    "tallysheet.netCft": "Net CFT",
    "tallysheet.supplier": "Supplier",
    "tallysheet.buyer": "Buyer",
    "tallysheet.driver": "Driver",
    "tallysheet.route": "Route",
    "tallysheet.expectedDelivery": "Expected Delivery",
    "tallysheet.mode": "Mode",
    "tallysheet.seaPort": "Sea Port",
    "tallysheet.locationMode": "Ubicación y Modo",
    "tallysheet.totalPieces": "Total Piezas",
    "tallysheet.netVolumeCbm": "Vol. Neto (CBM)",
    "tallysheet.avgCft": "Prom CFT",
    "tallysheet.weight": "Peso (kg)",
    "tallysheet.photoCount": "Fotos",
    "tallysheet.metrics": "Métricas",
    "tallysheet.divisibleBy5": "Divisible by 5",
    "tallysheet.divisibleBy5On": "Divisible by 5 ON",
    "tallysheet.divisibleBy5Off": "Divisible by 5 OFF",
    "tallysheet.lengthRange": "Longitud Range",
    "tallysheet.lengthRangeOn": "Longitud Range ON",
    "tallysheet.widthRange": "Rango de ancho",
    "tallysheet.thickRange": "Rango de espesor",
    "tallysheet.rangeOn": "Activado",
    "tallysheet.rangeOff": "Desactivado",
    "tallysheet.rangeHint": "Los valores fuera del rango se marcan como aviso (ámbar) y se conservan.",
    "tallysheet.resetToCompanyDefaults": "Restablecer a los valores de la empresa",
    "tallysheet.resetConfirm": "Cambia unidades, tolerancias y reglas de esta tally.",
    "tallysheet.resetYes": "Restablecer",
    "tallysheet.lengthRangeOff": "Longitud Range OFF",
    "tallysheet.girthRange": "Girth Range",
    "tallysheet.girthRangeOn": "Girth Range ON",
    "tallysheet.girthRangeOff": "Girth Range OFF",
    "tallysheet.unitOfMeasure": "Unit of Measure",
    "tallysheet.copyPreviousLength": "Copy Previous Longitud",
    "tallysheet.enterNavMode": "↵ Mode",
    "tallysheet.enterNavModeTooltip": "<b>Modo Fila:</b> Intro en Longitud → Circunferencia; Intro en Circunferencia → nueva fila.<br><b>Modo Columna:</b> Intro en Longitud → nueva fila (permanece en columna); Intro en Circunferencia → fila siguiente (crea nueva fila si es la última).<br><b>Ctrl+Intro</b> (cualquier modo) → forzar acción, omite validación.",
    "tallysheet.allowances": "Allowances",
    "tallysheet.lengthAllowance": "Longitud Allowance",
    "tallysheet.girthAllowance": "Girth Allowance",
    "tallysheet.allowancesLocked": "Allowances are locked once rows exceed",
    "tallysheet.columns": "Columns",
    "tallysheet.showColumns": "Show columns",
    "tallysheet.saveFormSettings": "Guardar Form Configuración",
    "tallysheet.confirmSave": "Confirm Guardar",
    "tallysheet.uomChangeTitle": "¿Cambiar la unidad de medida?",
    "tallysheet.uomChangeMessage":
      "Este tally ya tiene filas registradas. ¿Cómo deben tratarse los valores existentes de {field} para la nueva unidad?",
    "tallysheet.uomChangeKeep": "Mantener los números como se escribieron",
    "tallysheet.uomChangeKeepHint":
      "Recalcular usando los mismos números en la nueva unidad — úselo si escribió los números correctos pero seleccionó la unidad incorrecta.",
    "tallysheet.uomChangeConvert": "Convertir valores",
    "tallysheet.uomChangeConvertHint":
      "Reescribir los números existentes a la nueva unidad, manteniendo la misma medida física.",
    "tallysheet.uomChangeCancel": "Cancelar",
    "account.profilePicture": "Foto de Perfil",
    "account.yourRole": "Su Rol",
    "account.details": "Account Detalles",
    "account.personalDetails": "Personal Detalles",
    "account.detailsHint": "Su correo de acceso y un número móvil verificado",
    "account.personalHint": "Sobre usted, para que su equipo y sus documentos muestren el nombre correcto",
    "account.addressHeading": "Dirección",
    "account.changePassword": "Change Password",
    "account.emailNotVerified": "Email is not verified. Please verify your email address.",
    "account.mobile": "Mobile",
    "account.enterMobile": "Enter mobile Number",
    "account.mobileNotVerified": "Mobile is not verified. Please verify your mobile number.",
    "account.sendOtp": "Send OTP",
    "account.editMobile": "Editar Mobile",
    "account.dateOfBirth": "Fecha of Birth",
    "account.gender": "Gender",
    "account.next": "Siguiente",
    "account.otpSentTo": "OTP has been sent to",
    "account.enterOtpBelow": "Please enter the OTP below to verify your phone number.",
    "account.resendOtpIn": "Resend OTP in",
    "account.seconds": "seconds",
    "account.resend": "Resend",
    "account.sendOtpWhatsapp": "Enviar código por WhatsApp",
    "account.sendOtpSms": "Enviar código por SMS",
    "account.otpWhatsappNote": "El código llega por WhatsApp de parte de LumberLinq. Toca Copiar código y pégalo aquí.",
    "account.otpWhatsappFailed": "No pudimos enviar el código por WhatsApp. Comprueba que este número usa WhatsApp o envía el código por SMS.",
    "account.otpUseSms": "Enviar por SMS en su lugar",
    "account.otpUseWhatsapp": "Enviar por WhatsApp en su lugar",
    "account.otpPickHint": "Recibe tu código de 6 dígitos por WhatsApp o SMS",
    "account.otpWaDelivered": "El código ya está en tu WhatsApp. Abre el chat, toca Copiar código y pégalo aquí.",
    "account.otpWaNotDelivered": "WhatsApp no pudo entregar el código (puede que el número no esté en WhatsApp). Envía el código por SMS.",
    "account.otpWaPending": "¿Aún no llega a tu teléfono? Espera un poco, reenvíalo o envía el código por SMS.",
    "account.confirm": "Confirm",
    "account.oldPassword": "Old Password",
    "account.newPassword": "New Password",
    "account.confirmPassword": "Confirm Password",
    "account.oldPasswordRequired": "Old Password es obligatorio.",
    "account.passwordMinLength": "La contraseña debe tener al menos 8 caracteres.",
    "account.passwordStrengthHint": "La contraseña debe contener al menos una letra y un número.",
    "account.passwordChangeFailed": "Error al cambiar la contraseña. Por favor, inténtelo de nuevo.",
    "account.confirmPasswordRequired": "Confirm Password es obligatorio.",
    "account.passwordsMismatch": "Passwords do not match.",
    "account.mustBeAtLeast13": "Debes tener al menos 13 años.",
    "user.mustBeAtLeast13": "Debes tener al menos 13 años.",
    "account.notValidEmail": "is not a valid email",
    "account.passwordRule": "must contain at least 1 uppercase, 1 lowercase letter, and 1 number",
    "account.mustBeAtLeast": "must be at least",
    "account.charactersLong": "characters long",
    "account.profileUpdated": "Perfil updated successfully.",
    "account.profileLoadFailed": "Unable to load profile details.",
    "account.noProfileChanges": "No profile changes to update.",
    "account.saveAllHint": "Guarda Detalles de Cuenta, Datos Personales y Zona Horaria juntos.",
    "account.requiredAddressFields": "Please complete all required address fields before continuing.",
    "account.requiredFields": "Please complete all required fields before continuing.",
    "account.updateFailed": "An error occurred while updating the record.",
    "account.verificationRequired": "Verification Obligatorio",
    "account.verifyMobileAndEmail": "Please verify your mobile and email first.",
    "account.mobileVerified": "Mobile verified",
    "account.mobileAlreadyVerified": "Your mobile number is already verified.",
    "account.mobileLocked": "Verified mobile number cannot be changed from this screen.",
    "account.otpSent": "OTP Sent",
    "account.otpError": "OTP Error",
    "account.otpUnableToSend": "Unable to send OTP.",
    "account.tryAgainLater": "Please try again later",
    "account.maxOtpAttempts": "You have reached the maximum number of OTP resend attempts.",
    "account.otpValidated": "OTP Validated",
    "account.otpInvalidTitle": "OTP is Inválido",
    "account.otpInvalid": "Inválido OTP.",
    "account.otpDigit": "OTP digit",
    "account.invalidMobileOnly": "Only mobile numbers are allowed. Please enter a valid mobile number.",
    "account.invalidPhoneFormat": "Inválido phone number format.",
    "Male": "Male",
    "Female": "Female",
    "Prefer not to say": "Prefer not to say",
    "product.name": "Producto",
    "product.multipleProducts": "Productos",
    "product.multipleProductsBreakdown": "Productos en esta unidad",
    "product.namePlural": "Productos",
    "product.subtitle": "Gestione productos de madera, especies y códigos HS",
    "product.all": "All Productos",
    "product.update": "Actualizar Producto",
    "product.manageDetails": "Ver and manage existing product details",
    "product.editDetails": "Editar details of existing products",
    "product.hsCode": "HS Code",
    "product.formula": "Fórmula",
    "product.selectFormula": "Seleccionar Formula",
    "product.quickAdd": "Agregar nuevo producto",
    "product.quickAddTitle": "Nuevo Producto",
    "product.nameRequiredHint": "El nombre debe tener al menos 5 caracteres.",
    "product.hsCodeHint": "El código HS debe tener de 4 a 8 dígitos.",
    "product.quickAddedDetail": "Producto creado y seleccionado.",
    "product.quickAddError": "No se pudo crear el producto. Inténtalo de nuevo.",
    "product.description": "Descripción",
    "product.species": "Especie",
    "product.usedIn": "Usado en",
    "product.selectSpecies": "Seleccionar especie",
    "product.productCode": "Código de producto",
    "product.photos": "Fotos del producto",
    "product.addPhoto": "Agregar foto",
    "product.setAsDP": "Establecer como foto principal",
    "product.formulasGuide": "Formulas Guide",
    "product.formulaGuide.roundTitle": "Troza redonda",
    "product.formulaGuide.roundFormula": "Hoppus formula: (Girth × Girth × Longitud) ÷ 160,000",
    "product.formulaGuide.roundWhen": "For round, unprocessed logs and roundwood.",
    "product.formulaGuide.roundChoose": "Elegir this when the cross-section is circular — whole logs, rawwood, and unprocessed round timber.",
    "product.formulaGuide.squareTitle": "Cuadrada / aserrada",
    "product.formulaGuide.squareFormula": "Volumetric formula: Longitud × Ancho × Altura",
    "product.formulaGuide.squareWhen": "For sawn or square-cut timber.",
    "product.formulaGuide.squareChoose": "Elegir this when the timber is rectangular or square-cut — planks, beams, lumber, and dressed wood.",
    "product.formulaGuide.notSure": "Not sure which to pick?",
    "product.formulaGuide.tip": "Round cross-section → Round Log. Rectangular or square-cut → Square / Sawn.",
    "product.formulaPicker": "Formula Picker",
    "product.deletionRestriction": "Producto Deletion Restriction",
    "product.addNew": "Agregar New Producto",
    "product.bulkImport": "Importación masiva",
    "product.create": "Crear Producto",
    "product.inputDetails": "Input new product details",
    "loadingSite.name": "Nombre del Sitio",
    "loadingSite.namePlural": "Sitios",
    "loadingSite.quickAdd": "Agregar nuevo sitio",
    "loadingSite.quickAddTitle": "Nuevo Sitio",
    "loadingSite.nameRequired": "El nombre debe tener al menos 3 caracteres.",
    "loadingSite.quickAddedDetail": "Sitio creado y seleccionado.",
    "loadingSite.quickAddError": "No se pudo crear el sitio. Inténtalo de nuevo.",
    "loadingSite.all": "Todos los Sitios",
    "loadingSite.update": "Actualizar Sitio",
    "loadingSite.manageProfiles": "Ver y gestionar los perfiles de sitios existentes",
    "loadingSite.editDetails": "Editar detalles de sitios existentes",
    "loadingSite.contactPerson": "Persona de contacto",
    "loadingSite.operatingHours": "Horario de operación",
    "loadingSite.capacity": "Capacidad",
    "loadingSite.capacityCbm": "Capacidad (CBM)",
    "loadingSite.currentVolume": "Volumen actual",
    "loadingSite.machinesInstalled": "Máquina(s) instalada(s)",
    "loadingSite.notes": "Notas",
    "loadingSite.addNew": "Agregar Nuevo Sitio",
    "loadingSite.bulkImport": "Importación masiva",
    "loadingSite.create": "Crear Sitio",
    "loadingSite.inputDetails": "Ingresar detalles del nuevo sitio",
    "location.selectCountry": "Seleccionar país",
    "location.selectState": "Seleccionar estado",
    "location.selectCity": "Seleccionar ciudad",
    "location.country": "País",
    "location.state": "Estado / Province",
    "location.city": "Ciudad",
    "location.address1": "Dirección Line 1",
    "location.address2": "Dirección Line 2",
    "location.postalCode": "Postal Code",
    "location.cityUnavailableOffline": "Lista de ciudades no disponible sin conexión. Conéctese una vez para cargar las ciudades de este estado.",
    "location.cityNotAvailableOffline": "No disponible sin conexión",
    "mediaCapture.takePhoto": "Tomar Foto",
    "mediaCapture.recordVideo": "Grabar Video (máx. 30s)",
    "mediaCapture.chooseGallery": "Elegir de la Galería",
    "mediaCapture.browseFiles": "Explorar Archivos",
    "mediaCapture.videoTooLongTitle": "Video Demasiado Largo",
    "mediaCapture.videoTooLongDetail": "El video debe durar 30 segundos o menos. Por favor, inténtelo de nuevo.",
    "mediaCapture.captureFailedTitle": "Captura Fallida",
    "mediaCapture.captureFailedDetail": "No se pudo capturar el medio. Por favor, inténtelo de nuevo.",
    "mediaCapture.pasteRejectedTitle": "Archivo pegado no aceptado",
    "mediaCapture.pasteRejectedDetail": "Este cuadro de carga no acepta ese tipo de archivo.",
    "sfs.title": "¿Adónde deben ir estos archivos?",
    "sfs.filesReady": "archivo(s) listo(s)",
    "sfs.consignment": "Documentos del envío",
    "sfs.consignmentHint": "BL, factura, certificados y más",
    "sfs.stockUnit": "Documentos de la unidad de stock",
    "sfs.stockUnitHint": "Fotos y papeles de una unidad de stock",
    "sfs.aiImport": "Importación con IA",
    "sfs.aiImportHint": "Leer una hoja de conteo desde una foto o PDF",
    "sfs.aiNeedsImage": "Se necesita una foto o un PDF",
    "sfs.ticket": "Ticket de soporte",
    "sfs.ticketHint": "Adjuntar a un ticket nuevo",
    "sfs.pickPlace": "Elige un lugar",
    "sfs.pickDocType": "¿Qué tipo de documento?",
    "sfs.back": "Atrás",
    "sfs.cancel": "Cancelar",
    "sfs.discard": "Descartar archivos",
    "sfs.noAccess": "No tienes acceso para subir archivos. Consulta a tu administrador.",
    "sfs.note": "Todavía no se ha subido nada. La pantalla que elijas te pedirá confirmar.",
    "sfs.toast.title": "Archivos en espera",
    "sfs.toast.consignment": "Abre el envío que quieras y pulsa Adjuntar aquí.",
    "sfs.toast.consignmentHere": "Pulsa Adjuntar aquí en la pestaña Documentos de este envío.",
    "sfs.toast.aiImportHere": "Pulsa Adjuntar aquí encima de esta hoja de conteo.",
    "sfs.toast.stockUnit": "Abre una unidad de stock, ve a su pestaña Fotos y pulsa Adjuntar aquí.",
    "sfs.toast.stockUnitHere": "Pulsa Adjuntar aquí en la pestaña Fotos de esta unidad de stock.",
    "sfs.toast.aiImport": "Abre la hoja de conteo que quieras y pulsa Adjuntar aquí.",
    "sfs.toast.ticket": "Completa el ticket. Los archivos ya están añadidos.",
    "sfs.waiting.consignment": "abre el envío que quieras y pulsa Adjuntar aquí",
    "sfs.waiting.stockUnit": "abre una unidad de stock, pestaña Fotos, y pulsa Adjuntar aquí",
    "sfs.waiting.aiImport": "abre una hoja de conteo y pulsa Adjuntar aquí",
    "sfs.waiting.ticket": "añadiéndose a tu ticket nuevo",
    "sfs.banner.hint": "Esperando a ser adjuntados a un registro.",
    "sfs.banner.attach": "Adjuntar aquí",
    "sfs.banner.discard": "Descartar",
    "sfs.blocked.locked": "Este envío está bloqueado, no se pueden añadir archivos.",
    "sfs.blocked.shipped": "Esta unidad de stock ya fue enviada y está bloqueada, no se pueden añadir archivos.",
    "sfs.blocked.viewMode": "Esta hoja de conteo está ahora en solo lectura. Pase primero al modo de edición y luego adjunte los archivos.",
    "sfs.blocked.slot": "Este tipo de documento no está disponible en este envío.",
    "sfs.blocked.readonly": "Aquí solo puedes ver este tipo de documento.",
    "sfs.blocked.busy": "Hay otra subida en curso. Espera, por favor.",
    "mediaCapture.paste": "Pegar",
    "mediaCapture.pasteNothingTitle": "Nada que pegar",
    "mediaCapture.pasteNothing": "No se encontró ningún archivo en el portapapeles. Copia un archivo primero o usa Compartir → LumberLinq desde la otra app.",
    "mediaCapture.pasteTextOnly": "El portapapeles tiene texto, no un archivo. Copia un archivo primero o usa Compartir → LumberLinq desde la otra app.",
    "mediaCapture.pasteNoImage": "No se encontró ninguna imagen en el portapapeles. Copia una imagen o haz una captura de pantalla y toca Pegar.",
    "sfs.native.failedTitle": "No se pudieron leer algunos archivos",
    "sfs.native.failed": "Algunos archivos compartidos eran demasiado grandes o no se pudieron abrir. Inténtalo de nuevo.",
    "avatar.changePhoto": "Cambiar Foto",
    "avatar.chooseFile": "Elegir Archivo",
    "avatar.removePhoto": "Eliminar Foto",
    "avatar.cropTitle": "Ajusta Tu Foto",
    "avatar.cropHint": "Arrastra para reposicionar • Desplaza o pellizca para hacer zoom",
    "avatar.cropConfirm": "Usar Foto",
    "avatar.cropCancel": "Cancelar",
    "avatar.uploading": "Subiendo...",
    "avatar.uploadSuccess": "Foto de perfil actualizada",
    "permEditor.viewAddedNote": "El permiso de ver también se activó, porque este permiso lo necesita.",
    "permEditor.actionsRemovedNote": "Los permisos que necesitan ver también se desactivaron.",
    "permEditor.needsView": "Requiere ver",
    "avatar.uploadFailed": "Error al subir",
    "avatar.retry": "Reintentar",
    "avatar.confirmRemoveTitle": "¿Eliminar Foto de Perfil?",
    "avatar.confirmRemoveMessage": "Tu avatar volverá a mostrar tus iniciales.",
    "avatar.invalidFileType": "Por favor elige un archivo de imagen (JPG, PNG o WEBP).",
    "avatar.fileTooLarge": "La imagen debe ser menor a 5 MB.",
    "dashV3.title": "Operations Dashboard",
    "dashV3.subtitle": "Real-time overview of your timber trade operations",
    "dashV3.dateFrom": "From",
    "dashV3.dateTo": "To",
    "dashV3.apply": "Apply",
    "dashV3.refresh": "Actualizar",
    "dashV3.staleSnapshot": "Sin conexión — mostrando una instantánea en caché de",
    "dashV3.loading": "Loading dashboard...",
    "offline.unavailableTitle": "Requiere conexión",
    "offline.unavailableLead": "Esta función no está disponible sin conexión.",
    "offline.unavailableBody": "La exportación, importación, informes, consignaciones e inventario requieren una conexión activa. Las unidades de stock, socios comerciales, productos y sitios siguen funcionando sin conexión.",
    "offline.goToDashboard": "Ir al panel",
    "offline.autoReturnHint": "Serás llevado de vuelta aquí automáticamente en cuanto vuelvas a estar en línea.",
    "dashV3.kpi.partners": "Socios comerciales",
    "dashV3.kpi.active": "Activo",
    "dashV3.kpi.inactive": "Inactivo",
    "dashV3.kpi.shipments": "Consignaciones",
    "dashV3.kpi.transportUnits": "Unidades de Stock",
    "dashV3.kpi.unassigned": "Unassigned",
    "dashV3.kpi.volume": "Total Volumen",
    "dashV3.kpi.pieces": "Total Piezas",
    "dashV3.kpi.cbm": "CBM",
    "dashV3.kpi.cft": "CFT",
    "dashV3.chart.byTradeType": "Consignaciones by Trade Type",
    "dashV3.chart.byMode": "Transporte Mode",
    "dashV3.chart.volumeTrend": "Volumen Trend",
    "dashV3.chart.topProducts": "Top Productos by Volumen (CFT)",
    "dashV3.chart.siteUtilization": "Utilización del Sitio",
    "dashV3.chart.paymentStatus": "Pago Estado",
    "dashV3.upcoming.departures": "Upcoming Departures",
    "dashV3.upcoming.arrivals": "Upcoming Arrivals",
    "dashV3.upcoming.next7days": "Next 7 Días",
    "dashV3.upcoming.noDepartures": "No departures in the next 7 days",
    "dashV3.upcoming.noArrivals": "No arrivals in the next 7 days",
    "dashV3.upcoming.blNo": "BL / Bill No",
    "dashV3.upcoming.shipper": "Shipper",
    "dashV3.upcoming.consignee": "Consignee",
    "dashV3.upcoming.date": "Fecha",
    "dashV3.upcoming.port": "Port",
    "dashV3.recent.title": "Recent Unidades de Stock",
    "dashV3.recent.transportId": "Transporte ID",
    "dashV3.recent.product": "Producto",
    "dashV3.recent.site": "Sitio",
    "dashV3.recent.pieces": "Piezas",
    "dashV3.recent.volume": "Volumen",
    "dashV3.recent.created": "Created",
    "dashV3.subscription.title": "Suscripción",
    "dashV3.subscription.package": "Paquete",
    "dashV3.subscription.validTill": "Valid Till",
    "dashV3.subscription.daysLeft": "days left",
    "dashV3.subscription.expiringSoon": "Subscription expiring soon!",
    "dashV3.subscription.renew": "Renew Now",
    "dashV3.partners.byCountry": "Socios by País",
    "dashV3.kpi.upcoming": "Upcoming",
    "dashV3.kpi.tallyUnits": "Cubicación Units",
    "dashV3.upcoming.pol": "Port of Loading",
    "dashV3.upcoming.pod": "Port of Discharge",
    "dashV3.upcoming.mode": "Mode",
    "dashV3.subscription.expiring": "Subscription expiring soon —",
    "dashV3.subscription.status": "Estado",
    "dashV3.subscription.days": "days remaining",
    "dashV3.recent.id": "Transporte ID",
    "dashV3.recent.cbm": "CBM",
    "dashV3.recent.cft": "CFT",
    "dashV3.recent.viewAll": "Ver All",
    "dashV3.site.name": "Sitio",
    "dashV3.site.country": "País",
    "dashV3.site.capacity": "Capacity",
    "dashV3.site.noCapacitySet": "No se ha establecido capacidad para este sitio",
    "dashV3.site.current": "Current",
    "dashV3.site.util": "Utilization",
    "dashV3.noData": "No data available for the selected period",
    "report.title": "Informes",
    "report.from": "From",
    "report.to": "To",
    "report.inventory.title": "Inventario Informe",
    "report.inventory.subtitle": "Niveles de stock, historial de movimientos, ajustes y órdenes de aserrado",
    "report.inventory.unitsAbbrev": "SUs",
    "report.bp.title": "Comercial Socio Informe",
    "report.bp.subtitle": "Comprehensive analysis of business partner transactions, volumes and payments",
    "report.bp.search": "Buscar Comercial Socio",
    "report.bp.selectBp": "Selecciona un socio comercial para generar el informe",
    "report.bp.period": "Informe Period",
    "report.bp.from": "From Fecha",
    "report.bp.to": "To Fecha",
    "report.bp.generate": "Generate Informe",
    "report.bp.generating": "Generating...",
    "report.bp.exportExcel": "Export Excel",
    "report.bp.exportPdf": "Export PDF",
    "report.bp.noData": "No consignment data found for the selected period.",
    "report.bp.profile": "Socio Perfil",
    "report.bp.partyType": "Party Type",
    "report.bp.category": "Categoría",
    "report.bp.regType": "Registration Type",
    "report.bp.taxId": "Tax ID",
    "report.bp.active": "Activo",
    "report.bp.inactive": "Inactivo",
    "report.bp.owner": "Propietario",
    "report.kpi.totalShipments": "Total Consignaciones",
    "report.kpi.asSeller": "As Seller",
    "report.kpi.asBuyer": "As Buyer",
    "report.kpi.totalCbm": "Net CBM",
    "report.kpi.totalCft": "Net CFT",
    "report.kpi.totalPieces": "Total Piezas",
    "report.payment.sellerTitle": "Pago — As Seller",
    "report.payment.buyerTitle": "Pago — As Buyer",
    "report.payment.totalInvoiced": "Total Invoiced",
    "report.payment.received": "Fully Received",
    "report.payment.partially": "Partially Paid",
    "report.payment.invoiced": "Invoiced (Sent)",
    "report.payment.notInvoiced": "Not Invoiced",
    "report.payment.overdue": "Overdue",
    "report.payment.outstanding": "Outstanding",
    "report.payment.cancelled": "Cancelled",
    "report.payment.totalPayable": "Total Payable",
    "report.payment.paid": "Paid",
    "report.payment.pending": "Pendiente",
    "report.payment.disputed": "Disputed",
    "report.chart.monthlyVolume": "Mensual Volumen & Consignaciones",
    "chart.emptyTitle": "Aún no hay datos",
    "chart.emptyHint": "Este gráfico se llena cuando haya registros.",
    "report.chart.monthlyInvoice": "Mensual Factura Importe",
    "report.chart.tradeRoleSplit": "Trade Rol Split",
    "report.chart.paymentStatus": "Pago Estado",
    "report.table.transactions": "Consignación Transactions",
    "report.table.date": "Fecha",
    "report.table.role": "Rol",
    "report.table.tradeType": "Trade Type",
    "report.table.pol": "Port of Loading",
    "report.table.pod": "Port of Discharge",
    "report.table.origin": "País of Origin",
    "report.table.destination": "Destination",
    "report.table.currency": "Moneda",
    "report.table.invoiceAmt": "Factura Importe",
    "report.table.cbm": "Net CBM",
    "report.table.cft": "Net CFT",
    "report.table.pieces": "Piezas",
    "report.table.units": "Unidades de stock",
    "report.table.payStatus": "Pay Estado",
    "report.table.blNo": "B/L No.",
    "report.table.status": "Estado",
    "report.table.products": "Productos",
    "report.table.sites": "Sitios",
    "report.products.title": "Productos Resumen",
    "report.products.name": "Producto",
    "report.products.hsCode": "HS Code",
    "report.products.cbm": "Net CBM",
    "report.products.cft": "Net CFT",
    "report.products.pieces": "Piezas",
    "report.products.units": "Unidades de Stock",
    "report.products.shipments": "Consignaciones",
    "report.sites.title": "Resumen de Sitios",
    "report.sites.name": "Sitio Name",
    "report.sites.location": "Ubicación",
    "report.sites.cbm": "Net CBM",
    "report.sites.cft": "Net CFT",
    "report.sites.pieces": "Piezas",
    "report.sites.units": "Unidades de Stock",
    "report.sites.shipments": "Consignaciones",
    "report.role.seller": "Seller",
    "report.role.buyer": "Buyer",
    "report.role.notify": "Notify Party",
    "report.generatedAt": "Generated",
    "report.generate": "Generate",
    "report.loading": "Loading report...",
    "report.empty": "Seleccionar filters and click Generate to view the report.",
    "report.noData": "No se encontraron datos for selected period.",
    "report.export.excel": "Export Excel",
    "report.export.pdf": "Export PDF",
    "report.filter.from": "From",
    "report.filter.to": "To",
    "report.filter.all": "Todos",
    "report.filter.clear": "Limpiar filtros",
    "report.tab.overview": "Overview",
    "report.tab.transactions": "Transactions",
    "report.tab.financial": "Financial",
    "report.tab.products": "Productos",
    "report.tab.sites": "Sites",
    "report.tab.trend": "Mensual Trend",
    "report.tab.byCurrency": "By Currency",
    "report.tab.partners": "Top Socios",
    "report.kpi.totalInvoiced": "Total Invoiced",
    "report.kpi.overdue": "Overdue",
    "report.kpi.units": "Unidades de Stock",
    "report.col.date": "Fecha",
    "report.col.month": "Mes",
    "report.col.tradeType": "Trade Type",
    "report.col.status": "Estado",
    "report.col.shipper": "Shipper",
    "report.col.consignee": "Consignee",
    "report.col.polPod": "POL / POD",
    "report.col.currency": "Moneda",
    "report.col.invoiceAmt": "Factura Amt",
    "report.col.invoiced": "Invoiced",
    "report.col.salesStatus": "Sales Estado",
    "report.col.cbm": "CBM",
    "report.col.netCbm": "Net CBM",
    "report.col.cft": "CFT",
    "report.col.netCft": "Net CFT",
    "report.col.pieces": "Piezas",
    "report.col.units": "Units",
    "report.col.shipments": "Consignaciones",
    "report.col.blNo": "B/L No.",
    "report.col.product": "Producto",
    "report.col.hsCode": "HS Code",
    "report.col.avgCbmPerUnit": "Avg Net CBM/Unit",
    "report.col.currentStock": "Stock Actual",
    "report.col.lots": "lotes",
    "report.col.topPartners": "Top Socios",
    "report.col.topSites": "Top Sites",
    "report.col.topProducts": "Top Productos",
    "report.col.site": "Sitio",
    "report.col.location": "Ubicación",
    "report.col.capacity": "Capacity",
    "report.col.utilization": "Utilization",
    "report.col.millThroughput": "Rendimiento del Molino CBM",
    "report.col.runs": "órdenes",
    "report.col.partner": "Socio",
    "report.col.totalInvoiced": "Total Invoiced",
    "report.col.fullyPaid": "Fully Paid",
    "report.col.partiallyPaid": "Partially Paid",
    "report.col.overdue": "Overdue",
    "report.col.outstanding": "Outstanding",
    "report.col.sellerOutstanding": "Seller Outstanding",
    "report.col.buyerTotal": "Buyer Total",
    "report.col.buyerPaid": "Buyer Paid",
    "report.col.buyerPending": "Buyer Pendiente",
    "report.col.netPosition": "Net Position",
    "report.col.totalAmt": "Total Importe",
    "report.col.received": "Recibido",
    "report.col.paid": "Paid",
    "report.col.payable": "Payable",
    "report.shipment.title": "Consignación Informe",
    "report.shipment.tradeType": "Trade Type",
    "report.shipment.status": "Estado",
    "report.shipment.financialByCurrency": "Financial by Currency",
    "report.shipment.monthlyTrend": "Mensual Trend",
    "report.product.title": "Producto Informe",
    "report.product.distinctProducts": "Distinct Productos",
    "report.site.title": "Informe de Sitios",
    "report.site.distinctSites": "Distinct Sites",
    "report.site.noCapacity": "No capacity data available",
    "report.financial.title": "Financial Resumen Informe",
    "report.financial.currency": "Moneda",
    "report.financial.currencyPlaceholder": "e.g. USD",
    "report.financial.revenue": "Revenue (Received)",
    "report.financial.cost": "Cost (Paid)",
    "report.financial.receivable": "Receivable",
    "report.financial.payable": "Payable",
    "report.financial.overdue": "Overdue",
    "report.financial.topRevenuePartners": "Top Revenue Socios (As Seller)",
    "report.financial.topCostPartners": "Top Cost Socios (As Buyer)",
    "report.financial.tradeTypeSummary": "By Trade Type",
    "report.chart.byTradeType": "By Trade Type",
    "report.chart.sellerPayStatus": "Seller Pago Estado",
    "report.chart.topLoadingPorts": "Top Ports of Loading",
    "report.chart.topProductsByCbm": "Top Productos by Net CBM",
    "report.chart.monthlyProductTrend": "Mensual Producto Trend",
    "report.chart.siteCbm": "Net CBM por Sitio",
    "report.chart.utilization": "Sitio Utilization",
    "report.chart.monthlyTrend": "Mensual Throughput",
    "report.chart.financialOverview": "Financial Overview",
    "report.chart.receivablesBreakdown": "Receivables Breakdown",
    "report.chart.monthlyInvoicedTrend": "Mensual Invoiced Trend",
    "report.tab.units": "Unidades de Stock",
    "report.tab.tallies": "Cubicación Sheets",
    "report.col.transportId": "Transporte ID",
    "report.col.unitNumber": "Unit No.",
    "report.col.mode": "Mode",
    "report.col.shipment": "Consignación",
    "report.col.type": "Type",
    "report.col.created": "Created",
    "report.tu.title": "Informe de Unidad de Stock",
    "report.operator.title": "Informe de Desempeño de Operadores",
    "report.operator.totalOperators": "Total de Operadores",
    "report.operator.activeOperators": "Operadores Activos",
    "report.operator.runsCompleted": "Órdenes de aserrado completadas",
    "report.operator.totalOutputCbm": "CBM Total de Salida",
    "report.operator.avgOutturn": "Rendimiento Promedio",
    "report.operator.byOperator": "Por Operador",
    "report.operator.name": "Nombre",
    "report.operator.employeeCode": "Código de Empleado",
    "report.operator.specializations": "Especializaciones",
    "report.operator.active": "Activo",
    "report.operator.activeYes": "Activo",
    "report.operator.activeNo": "Inactivo",
    "report.operator.inputCbm": "CBM de Entrada",
    "report.operator.outputCbm": "CBM de Salida",
    "report.operator.bestOutturn": "Mejor Rendimiento",
    "report.operator.avgDuration": "Duración Promedio (hrs)",
    "report.tu.totalUnits": "Total Units",
    "report.tu.linked": "Linked to Consignación",
    "report.tu.inStock": "En Stock (Inventario)",
    "report.tu.unlinked": "Unlinked",
    "report.tu.statusBreakdown": "Estado Breakdown",
    "report.tu.modeBreakdown": "Transporte Mode",
    "report.tu.monthlyTrend": "Mensual Trend",
    "report.tu.statusSummary": "Estado Resumen",
    "report.tally.title": "Cubicación Sheet Informe",
    "report.tally.totalTallies": "Total Tallies",
    "report.tally.roundTallies": "Round Timber",
    "report.tally.squareTallies": "Square Timber",
    "report.tally.flexibleGrid": "Cuadrícula Flexible",
    "report.tally.typeBreakdown": "Type Breakdown",
    "report.tally.monthlyCbm": "Mensual CBM by Type",
    "report.tally.shrinkageChart": "Source vs Destination CBM",
    "report.tally.noShrinkageData": "No destination data available.",
    "report.tally.avgCbm": "Avg CBM / Cubicación",
    "report.tally.avgPieces": "Avg Piezas / Cubicación",
    "report.tally.tallies": "Tallies",
    "report.tally.destCbm": "Dest. CBM",
    "report.tally.shrinkage": "Shrinkage %",
    "report.financial.actualReceived": "Actual Received",
    "report.financial.actualPaid": "Actual Paid",
    "report.financial.totalReceived": "Total Received",
    "report.financial.totalPaid": "Total Paid",
    "report.financial.netCashflow": "Net Cashflow",
    "report.financial.receivables": "Receivables",
    "report.financial.minAmount": "Min amount",
    "report.financial.maxAmount": "Max amount",
    "report.financial.paymentStatus": "Payment status",
    "report.financial.paymentFrom": "Payment from",
    "report.financial.paymentTo": "Payment to",
    "report.financial.payables": "Payables",
    "report.col.txnType": "Type",
    "report.col.paymentMode": "Mode",
    "report.col.reference": "Reference",
    "report.col.notes": "Notes",
    "report.recon.title": "Reconciliation Informe",
    "report.recon.subtitle": "Source vs Destination tally variance analysis",
    "report.recon.totalTallies": "Total Tallies",
    "report.recon.reconciled": "Reconciled",
    "report.recon.pending": "Pendiente",
    "report.recon.srcCbm": "Source CBM",
    "report.recon.srcPieces": "Source Piezas",
    "report.recon.dstCbm": "Dest. CBM",
    "report.recon.dstPieces": "Dest. Piezas",
    "report.recon.varianceCbm": "CBM Variance",
    "report.recon.variancePieces": "Piezas Variance",
    "report.recon.shrinkage": "Shrinkage %",
    "report.recon.millLoss": "CBM de Pérdida de Molino",
    "report.recon.reconStatus": "Reconciliation Estado",
    "report.recon.shrinkageDist": "Shrinkage Distribution",
    "inventory.title": "Inventario",
    "inventory.overview": "Overview",
    "inventory.inOut": "Entrada / Salida",
    "inventory.processing": "Órdenes de aserrado",
    "inventory.available": "Disponible",
    "inventory.inProcess": "En orden de aserrado",
    "inventory.inShipment": "En consignación",
    "inventory.shipped": "Enviado",
    "inventory.lotStock": "Stock en Lote",
    "inventory.openLots": "lotes abiertos",
    "inventory.atForest": "En bosque",
    "inventory.inTransit": "En tránsito",
    "inventory.atMill": "En aserradero",
    "inventory.atYard": "En patio",
    "inventory.receiveIntoInventory": "Receive into Inventario",
    "inventory.receiveNeedsRows": "Añade al menos una fila al tally antes de recibir en inventario",
    "inventory.receivedIntoInventory": "Received into Inventario",
    "inventory.receiveConfirmMessage": "Agregar Unidad de Stock {transportId} to inventory? This will record it as an incoming stock movement.",
    "inventory.yesReceive": "Yes, Receive",
    "inventory.received": "Recibido",
    "inventory.receivedDetail": "{transportId} has been added to inventory.",
    "inventory.confirmStockOut": "Confirmar Salida de Stock",
    "inventory.confirmChecking": "Comprobando el stock…",
    "inventory.confirmStockOutMessage": "¿Confirmar que la Unidad de Stock {transportId} ha sido enviada? Esto debitará permanentemente el stock correspondiente.",
    "inventory.confirmStockOutMultiProductIntro": "Esta unidad de stock tiene {count} productos, que se debitarán permanentemente de la siguiente manera: {breakdown}. ¿Continuar?",
    "inventory.confirmStockOutBatchIntro": "Esto se tomará de {count} lotes: {breakdown}. ¿Continuar?",
    "inventory.confirmStockOutInsufficientWarning": "Advertencia: stock insuficiente para uno o más de estos productos — la confirmación puede fallar.",
    "inventory.stockShortTitle": "Stock insuficiente — no se guardó nada",
    "inventory.stockShortHint": "Corrija estas filas o active “Let sales continue past available stock” en Application Settings → Inventory Policy.",
    "inventory.stockShortLineNone": "{label}: necesita {need} pzs, sin stock",
    "inventory.stockShortLineOnly": "{label}: necesita {need} pzs, solo {free} libres",
    "inventory.confirmBlockedNoStock": "No se puede confirmar — estas filas no tienen stock libre de su tamaño (la madera retenida por otra salida de stock no está libre):",
    "inventory.confirmBlockedNoStockHint": "Cambie el tamaño, elimine la fila o pida al aserradero que lo produzca.",
    "inventory.confirmUnsavedChanges": "Guarde primero la planilla — tiene filas sin guardar. La confirmación solo cuenta las filas guardadas y luego la planilla se bloquea.",
    "inventory.receiveUnsavedChanges": "Guarde primero la planilla — tiene filas sin guardar. Solo las filas guardadas entran al stock y luego la planilla se bloquea.",
    "tallysheet.tu.soldPastStock": "Vendido por encima del stock disponible — motivo: {reason}",
    "tallysheet.tu.soldPastStockBy": " (por {by})",
    "statement.soldPastStock": "Vendido por encima del stock disponible",
    "inventory.rowExceedsStockReview": "Excede el stock — toca para revisar",
    "inventory.rowInsufficientStockFix": "No hay suficiente stock — toca para corregir",
    "inventory.rowNotReservedHint": "No hay stock reservado actualmente para esta fila.",
    "inventory.resolvedOriginAuto": "existencia más antigua",
    "inventory.shippedLockedMessage": "Esta unidad de stock ya fue confirmada y enviada — la edición está bloqueada. Solo un administrador puede hacer cambios.",
    "inventory.rowNeedsLookSingular": "fila necesita una revisión rápida",
    "inventory.rowNeedsLookPlural": "filas necesitan una revisión rápida",
    "inventory.review": "Revisar",
    "inventory.yesConfirm": "Sí, Confirmar",
    "inventory.confirmStockOutTooltip": "Debitar permanentemente el stock del contenido registrado de esta Unidad de Stock",
    "inventory.stockOutConfirmed": "Salida de Stock Confirmada",
    "inventory.stockOutConfirmedDetail": "{transportId} ha sido debitado del inventario.",
    "inventory.newProcessingRun": "Nueva orden de aserrado",
    "inventory.outturn": "Outturn",
    "inventory.inputCbm": "Input CBM",
    "inventory.outputCbm": "Output CBM",
    "inventory.stockByLocation": "Stock por ubicación",
    "inventory.whereIsYourMaterial": "Where is your material right now?",
    "inventory.daysInYard": "Días in Yard",
    "inventory.runCode": "ID de la orden de aserrado",
    "inventory.millLocation": "Mill / Ubicación",
    "inventory.processingDate": "Fecha de la orden de aserrado",
    "inventory.selectInputTus": "Seleccionar unidades de stock de entrada",
    "inventory.recordOutput": "Record Output",
    "inventory.movementLedger": "Movement Ledger",
    "loading-site.siteType": "Tipo de sitio",
    "loading-site.siteType.FOREST": "Bosque",
    "loading-site.siteType.MILL": "Molino / aserradero",
    "loading-site.siteType.YARD": "Patio / preparación",
    "loading-site.siteType.PORT": "Puerto",
    "loading-site.siteType.WAREHOUSE": "Almacén",
    "common.locked": "Bloqueado",
    "common.reconciled": "Reconciliado",
    "common.confirmDeletion": "Confirm Deletion",
    "common.amount": "Importe",
    "common.size": "Size",
    "tallysheet.lockedBanner": "This tallysheet is locked — no further edits are allowed.",
    "tallysheet.summaryOutdated": "El resumen puede estar desactualizado. Las filas fueron guardadas después de la última carga.",
    "tallysheet.lockButton": "Lock",
    "tallysheet.lockTooltip": "Lock this tallysheet permanently",
    "tallysheet.lockNeedsRows": "Añade al menos una fila al tally antes de bloquear",
    "tallysheet.lockNoPhotosWarning": "Aún no hay fotos para este Stock Unit. Puedes bloquearlo igualmente, pero normalmente no será fácil añadir fotos después.",
    "tallysheet.lockGoToPhotos": "Ir a Fotos",
    "tallysheet.lockDialogHeader": "Lock Hoja de cubicación",
    "tallysheet.lockIrreversible": "This action is irreversible.",
    "tallysheet.lockOnceNote": "Once locked, no tally entries can be added or modified.",
    "tallysheet.lockTypeConfirm": "Type LOCK to confirm:",
    "tallysheet.lockPermanently": "Lock Permanently",
    "tallysheet.inventoryTab": "Inventario",
    "tallysheet.aiImport": "AI Import",
    "tallysheet.aiImportTooltip": "AI Import — upload a handwritten tallysheet image",
    "tallysheet.lengthRequired": "Longitud required",
    "tallysheet.girthRequired": "Girth required",
    "tallysheet.enterRowNumber": "Enter Row Number",
    "inventory.notYetInInventory": "Aún no está en inventario",
    "inventory.historyLoadFailedTitle": "No se pudo cargar el historial",
    "inventory.historyLoadFailedSub": "Inténtalo de nuevo cuando vuelvas a estar en línea",
    "inventory.receiveToStartTracking": "Reciba esta Unidad de Stock para comenzar a rastrear los movimientos de inventario.",
    "inventory.clickToReceive": "Haga clic en el botón de abajo para recibir esta Unidad de Stock en el inventario.",
    "inventory.notInInventoryBanner": "Aún no está en inventario — reciba esta Unidad de Stock para comenzar el seguimiento de stock.",
    "inventory.statusLabel": "Inventario Estado",
    "inventory.statusColon": "Inventario Estado:",
    "inventory.movementHistory": "Movement Historial",
    "inventory.noMovementsYet": "No movements recorded yet.",
    "inventory.addToInventoryTooltip": "Agregar esta Unidad de Stock al sistema de inventario",
    "inventory.productRequiredTooltip": "Agregue un Producto antes de recibir en el inventario",
    "inventory.moveComingSoon": "Mover entre sitios — próximamente",
    "inventory.loadingSiteRequiredTooltip": "Se requiere un Sitio antes de recibir en el inventario",
    "inventory.loadingSiteRequiredBanner": "Seleccione un Sitio antes de recibir esta unidad de stock en el inventario — de lo contrario el stock no será rastreable.",
    "inventory.transportModeRequiredTooltip": "Agregue el Modo de Transporte antes de recibir en el inventario",
    "inventory.transportModeRequiredForStockOut": "Agregue el Modo de Transporte antes de confirmar la salida de stock",
    "inventory.dateAndTime": "Fecha & Time",
    "inventory.movementType": "Movement Type",
    "shipment.lockedTooltip": "Locked — no further edits allowed",
    "shipment.exportTooltip": "Export consignment to Excel or PDF",
    "shipment.noTransportUnitsShared": "No stock units are available for this shared consignment.",
    "payment.loadingData": "Loading payment data...",
    "payment.invoice": "Factura",
    "payment.salesStatus": "Sales Estado",
    "payment.paidOut": "Paid Out",
    "payment.purchaseStatus": "Purchase Estado",
    "payment.unableToLoad": "Unable to load payment summary.",
    "payment.record": "Record Pago",
    "payment.typeLabel": "Pago Type",
    "payment.receivable": "Receivable (Money In)",
    "payment.payable": "Payable (Money Out)",
    "payment.selectType": "Seleccionar type",
    "payment.modeLabel": "Pago Mode",
    "payment.selectMode": "Seleccionar mode",
    "payment.referenceNo": "Reference No",
    "payment.referencePlaceholder": "Cheque no / TT ref / UTR",
    "payment.notesPlaceholder": "Optional notes",
    "payment.save": "Guardar Pago",
    "payment.history": "Pago Historial",
    "storage.title": "Storage Usage",
    "storage.subtitle": "Track your file storage across all tallies, documents and business partners",
    "storage.usedRing": "used",
    "storage.used": "Used",
    "storage.quota": "Quota",
    "storage.free": "Free",
    "storage.files": "Files",
    "storage.filesCount": "files",
    "storage.warningPrefix": "You have used",
    "storage.warningBannerSuffix": "of your storage. Consider deleting unused files.",
    "storage.fullBanner": "Storage full! New file uploads are blocked. Please free up space or upgrade your plan.",
    "storage.addedBy": "Added By",
    "storage.noFilesFound": "No files found.",
    "dashV4.businessPulse": "Comercial Pulse",
    "dashV4.inventorySnapshot": "Inventario Snapshot",
    "dashV4.fullInventory": "Full Inventario",
    "dashV4.availableStock": "Available Stock",
    "dashV4.inProcessing": "En orden de aserrado",
    "dashV4.inShipment": "En consignación",
    "dashV4.shippedThisMonth": "Shipped This Mes",
    "dashV4.activeSites": "Active Sites",
    "dashV4.locations": "locations",
    "dashV4.noInventoryData": "No inventory data yet.",
    "dashV4.setUpInventory": "Set up inventory →",
    "dashV4.volumeTrend": "Volumen Trend (CBM)",
    "dashV4.upcomingShipments": "Upcoming Consignaciones",
    "dashV4.departures": "Departures",
    "dashV4.arrivals": "Arrivals",
    "dashV4.geographySites": "Geography & Sites",
    "dashV4.recentTUs": "Recent Unidades de Stock",
    "dashV4.standardPlan": "Standard Plan",
    "dashV4.validTill": "Valid till",
    "dashV4.daysLeft": "days left",
    "dashV4.manage": "Gestionar",
    "dashV4.active": "active",
    "dashV4.inactive": "inactive",
    "dashV4.upcoming": "upcoming",
    "dashV4.unassigned": "unassigned",
    // -- Dashboard V5
    "dashV5.title": "Panel",
    "dashV5.subtitle": "Resumen de negocios, finanzas e inventario",
    "dashV5.financialHealth": "Salud Financiera",
    "dashV5.totalInvoiced": "Total Facturado",
    "dashV5.totalReceived": "Recibido",
    "dashV5.outstanding": "Pendiente",
    "dashV5.overdue": "Vencido",
    "dashV5.payables": "Por pagar",
    "dashV7.currentTooltip": "Siempre actual — no limitado al rango de fechas seleccionado",
    "dashV8.goodMorning": "Buenos días",
    "dashV8.periodNote": "El periodo define: volumen, Unidades de stock, piezas, envíos, facturado y cobrado. Todo lo demás muestra la situación actual.",
    "dashV8.vsPrevious": "vs el periodo anterior",
    "dashV8.details": "Detalles",
    "dashV8.freeToSell": "libres para vender",
    "dashV8.free": "Libre",
    "dashV8.held": "Retenido",
    "dashV8.inMill": "En aserradero",
    "dashV8.allCounted": "Todas las Unidades de stock contadas",
    "dashV8.toCount": "aún por contar",
    "dashV8.goodAfternoon": "Buenas tardes",
    "dashV8.goodEvening": "Buenas noches",
    "dashV8.focus": "Todo lo que hace esta empresa",
    "dashV8.newSince": "nuevos desde",
    "dashV8.period": "Periodo",
    "dashV8.p.today": "Hoy",
    "dashV8.p.7d": "7 días",
    "dashV8.p.30d": "30 días",
    "dashV8.p.month": "Este mes",
    "dashV8.p.pick": "Elegir fechas",
    "dashV8.activeUntil": "activo hasta",
    "dashV8.item": "elemento",
    "dashV8.items": "elementos",
    "dashV8.more": "más",
    "dashV8.showAll": "Mostrar todo",
    "dashV8.showLess": "Mostrar menos",
    "dashV8.open": "Abrir",
    "dashV8.review": "Revisar",
    "dashV8.count": "Contar",
    "dashV8.see": "Ver",
    "dashV8.needMine1": "Tienes 1 trabajo de aserradero",
    "dashV8.needMineN": "Tienes {n} trabajos de aserradero",
    "dashV8.taskNeedsAccept": "{code} debe aceptarse",
    "dashV8.taskRunning": "{code} está en marcha",
    "dashV8.needOverdue1": "1 pago está vencido",
    "dashV8.needOverdueN": "{n} pagos están vencidos",
    "dashV8.overdueSub": "{amount} por cobrar",
    "dashV8.overdueSubDays": "{amount} por cobrar · el más antiguo de hace {days} días",
    "dashV8.needHolds1": "1 Salida de stock retiene madera hace 60+ días",
    "dashV8.needHoldsN": "{n} Salidas de stock retienen madera hace 60+ días",
    "dashV8.needHoldsSub": "{cbm} m³ bloqueados para la venta",
    "dashV8.needRecon1": "1 Unidad de stock sin contar",
    "dashV8.needReconN": "{n} Unidades de stock sin contar",
    "dashV8.needReconSub": "Contado hasta ahora: {pct}%",
    "dashV8.needUnassigned1": "1 Unidad de stock aún sin envío",
    "dashV8.needUnassignedN": "{n} Unidades de stock aún sin envío",
    "dashV8.needMillQueued1": "1 trabajo de aserradero espera para empezar",
    "dashV8.needMillQueuedN": "{n} trabajos de aserradero esperan para empezar",
    "dashV8.needArrivals1": "1 envío llega esta semana",
    "dashV8.needArrivalsN": "{n} envíos llegan esta semana",
    "dashV8.needArrivalsSub": "el primero el {date}",
    "dashV8.vsLastMonth": "vs el mes pasado",
    "dashV8.millRunning": "Trabajos de aserradero en marcha",
    "dashV8.trends": "Tendencias",
    "dashV8.tab.volume": "Volumen",
    "dashV8.tab.products": "Productos",
    "dashV8.tab.types": "Tipos",
    "dashV8.tab.transport": "Transporte",
    "dashV8.tab.payments": "Pagos",
    "dashV8.chip.STOCK": "Stock",
    "dashV8.chip.MILL": "Aserradero",
    "dashV8.chip.CONSIGNMENT": "Envíos",
    "dashV8.chip.MONEY": "Dinero",
    "dashV8.chip.RECON": "Conteos",
    "dashV8.chip.TALLY": "Unidades de stock",
    "dashV8.chip.TEAM": "Equipo",
    "dashV8.chip.MINE": "Míos",
    "dashV8.dayToday": "Hoy",
    "dashV8.dayYesterday": "Ayer",
    "dashV8.evt.STOCK_IN": "Stock recibido",
    "dashV8.evt.STOCK_OUT": "Salida de stock confirmada",
    "dashV8.evt.STOCK_COUNT": "Conteo hecho",
    "dashV8.evt.STOCK_ADJUST": "Stock ajustado",
    "dashV8.evt.MILL_DONE": "Trabajo de aserradero {ref} terminado",
    "dashV8.evt.CONSIGNMENT_NEW": "Envío {ref} creado",
    "dashV8.evt.PAYMENT_IN": "Pago recibido",
    "dashV8.evt.PAYMENT_OUT": "Pago realizado",
    "dashV8.evt.TALLY_NEW": "Unidad de stock {ref} creada",
    "dashV8.evt.TEAM_GRANT": "Permiso {ref} concedido",
    "dashV8.evt.TEAM_REVOKE": "Permiso {ref} retirado",
    "dashV8.teamFor": "para {name}",
    "dashV8.feedNote": "Solo se listan eventos de negocio terminados. Guardar o editar filas del conteo nunca aparece; una Unidad de stock aparece una vez, cuando se crea.",
    "dashV7.needsTitle": "Te necesita hoy",
    "dashV7.allClear": "Todo en orden. Nada te espera hoy.",
    "dashV7.needOverdue": "pagos vencidos por cobrar",
    "dashV7.needRecon": "Unidades de stock pendientes de conciliar",
    "dashV7.needUnassigned": "Unidades de stock aún sin envío",
    "dashV7.needMyTasks": "trabajos de aserradero en tu lista",
    "dashV7.needMillQueued": "trabajos de aserradero esperando para empezar",
    "dashV7.chipAll": "Todo",
    "dashV7.cat.STOCK": "Stock",
    "dashV7.cat.MILL": "Aserradero",
    "dashV7.cat.CONSIGNMENT": "Envíos",
    "dashV7.cat.MONEY": "Dinero",
    "dashV7.cat.TEAM": "Equipo",
    "dashV7.ev.STOCK_IN": "Stock recibido",
    "dashV7.ev.STOCK_OUT": "Stock enviado",
    "dashV7.ev.STOCK_COUNT": "Stock contado",
    "dashV7.ev.STOCK_ADJUST": "Stock ajustado",
    "dashV7.ev.MILL_DONE": "Trabajo de aserradero terminado",
    "dashV7.ev.CONSIGNMENT_NEW": "Envío creado",
    "dashV7.ev.PAYMENT_IN": "Pago recibido",
    "dashV7.ev.PAYMENT_OUT": "Pago realizado",
    "dashV7.ev.TEAM_GRANT": "Permiso concedido",
    "dashV7.ev.TEAM_REVOKE": "Permiso retirado",
    "dashV7.severalSizes": "varias medidas",
    "dashV7.with": "con",
    "dashV7.noActivity": "No ha pasado nada aquí últimamente.",
    "dashV7.showMore": "Mostrar más",
    "dashV7.activityFailed": "No se pudo cargar la actividad reciente en este momento.",
    "dashV7.upcomingTooltip": "Siempre muestra los próximos 7 días — independiente del rango de fechas anterior",
    "dashV5.receivablesAging": "Antigüedad de cuentas por cobrar",
    "dashV5.shipmentsLabel": "consignaciones",
    "dashV5.reconciliation": "Estado de reconciliación",
    "dashV5.totalTUs": "Total de unidades de stock",
    "dashV5.reconciled": "Reconciliado",
    "dashV5.pending": "Pendiente",
    "dashV5.locked": "Bloqueado",
    "dashV5.netDiscrepancy": "Discrepancia neta",
    "dashV5.tuId": "ID de la unidad de stock",
    "dashV5.sourceCbm": "CBM Origen",
    "dashV5.destCbm": "CBM Destino",
    "dashV5.discrepancy": "Diferencia",
    "dashV5.noDiscrepancies": "Sin discrepancias — todas las unidades de stock coinciden.",
    "dashV5.avgOutturn": "Outturn Promedio",
    "dashV5.netGain": "Ganancia neta (órdenes de aserrado)",
    "dashV5.runsLabel": "órdenes de aserrado",
    "dashV5.outturnNote": "Más de 100% indica ganancia de volumen en el aserrado de redondo a cuadrado.",
    "dashV5.paymentFlow": "Flujo de pago",
    "dashV5.mixedCurrencies": "Varias monedas",
    "dashV5.showingCurrencyOnly": "Mostrando solo:",
    "dashV5.otherCurrencies": "otras monedas",
    "dashV5.perCurrencyBreakdown": "Desglose por moneda",
    // -- Dashboard V6
    "dashV6.title": "Panel",
    "dashV6.subtitle": "Visión general del negocio en tiempo real, según el rol",
    "dashV6.liveTooltip": "En vivo — se actualiza automáticamente",
    "dashV6.offlineTooltip": "Sin conexión — mostrando datos en caché, no en vivo",
    "dashV6.myMillTasks": "Mis Tareas Activas del Aserradero",
    "dashV6.millBoard": "Panel de órdenes de aserrado",
    "dashV6.viewAllRuns": "Ver todas las órdenes de aserrado",
    "dashV6.queued": "En Cola",
    "dashV6.inProgress": "En Progreso",
    "dashV6.completedToday": "Completado Hoy",
    "dashV6.machineUtil": "Máquinas Ocupadas",
    "dashV6.topOperators": "Mejores Operadores por Carga Activa",
    "dashV6.status.DRAFT": "En Cola",
    "dashV6.status.IN_PROGRESS": "En Progreso",
    "dashV6.status.COMPLETED": "Completado",
    "dashV6.priority.HIGH": "Alta",
    "dashV6.priority.MEDIUM": "Media",
    "dashV6.priority.LOW": "Baja",
    "dashV6.recentActivity": "Actividad Reciente",
    "dashV6.granted": "otorgó",
    "dashV6.revoked": "revocó",
    "dashV6.forUser": "para",
    "common.export": "Exportar",
    "common.next": "Siguiente",
    "common.retry": "Retry",
    "common.clearFilters": "Clear Filters",
    "common.saveAll": "Guardar All",
    "common.resetDefaults": "Reset to Defaults",
    "common.configure": "Configure",
    "common.disable": "Disable",
    "common.close": "Cerrar",
    "common.skip": "Skip",
    "common.continue": "Continue",
    "common.deactivate": "Deactivate",
    "common.reactivate": "Reactivate",
    "common.preview": "Preview",
    "common.openNewTab": "Open in new tab",
    "common.resetAllToDefaults": "Reset all to defaults",
    "common.renew": "Renew",
    "common.manage": "Administrar",
    "common.apply": "Apply",
    "common.saveTimezone": "Guardar Timezone",
    "shipment.lockDialogHeader": "Lock Consignación",
    "shipment.lockButtonTooltip": "Lock this consignment permanently — no edits after lock",
    "shipment.lockDescription": "Once locked, this consignment cannot be edited by anyone. All changes will be permanently frozen.",
    "recon.lockDialogHeader": "Lock Reconciliation",
    "recon.lockIrreversible": "This action is permanent and irreversible.",
    "recon.lockDescription": "Once locked, no one can modify reconciliation data — not even the account owner. The tallysheet itself remains accessible and viewable.",
    "recon.lockReasonLabel": "Reason (optional)",
    "recon.lockReasonPlaceholder": "e.g. Confirmed against discharge survey",
    "recon.varianceDetected": "Variance detected",
    "recon.varianceChoiceLabel": "How should this be applied to inventory?",
    "recon.applyAutoLabel": "Apply automatically now",
    "recon.applyAutoDesc": "Inventory will be corrected to match the actual arrived quantity.",
    "recon.applyAutoNeedsReceive": "Recibe este Stock Unit primero — todavía no hay stock que corregir.",
    "recon.applyManualLabel": "I'll handle it manually",
    "recon.applyManualDesc": "Inventory keeps the original quantity — adjust it yourself later if needed.",
    "recon.lockTypeConfirm": "Type LOCK to confirm",
    "recon.confirmLockButton": "Confirm Lock Reconciliation",
    "invProc.title": "Órdenes de aserrado",
    "invProc.subtitle": "Órdenes de aserrado: stock de un lote aserrado en un nuevo lote",
    "invProc.totalRuns": "Total de órdenes de aserrado",
    "invProc.avgOutturn": "Avg Outturn",
    "invProc.cbmProcessed": "CBM aserrado (entrada)",
    "invProc.noRuns": "Aún no hay órdenes de aserrado.",
    "invProc.noRunsHint": "Haga clic en Nueva orden de aserrado para convertir trozas en madera aserrada.",
    "invProc.stepLocation": "Ubicación & Fecha",
    "invProc.millLocationLabel": "Aserradero",
    "invProc.millPlaceholder": "Buscar or type mill name",
    "invProc.millRequired": "Mill location es obligatorio.",
    "invProc.notesLabel": "Notes (optional)",
    "invProc.tuSelectionHint": "Showing AVAILABLE round-type Unidades de Stock. Seleccionar all that will go into the saw.",
    "invProc.noTusFound": "No hay unidades de stock de trozas disponibles.",
    "invProc.noTusHint": "Receive round log Unidades de Stock into inventory first.",
    "invProc.selected": "Selected:",
    "invProc.totalInput": "Total input:",
    "invProc.outputProduct": "Output Producto",
    "invProc.outputProductPlaceholder": "Buscar or type product name",
    "invProc.noProductFound": "No se encontraron productos",
    "invProc.noSiteFound": "No se encontraron patios",
    "invProc.acSearchMessage": "{0} resultados disponibles",
    "invProc.acEmptySelectionMessage": "Ningún elemento seleccionado",
    "invProc.storeAt": "Store At",
    "invProc.storePlaceholder": "Yard name",
    "invProc.outputVolume": "Output Volumen (CBM)",
    "invProc.fifoPanelTitle": "¿A qué compra se atribuye esto?",
    "invProc.fifoPanelHint": "Se usa primero la compra más antigua. Puede editar el reparto abajo si es necesario.",
    "invProc.fifoPanelMismatch": "Los montos editados deben sumar el mismo total de CBM que entró al aserradero.",
    "invProc.fifoPanelCbmLabel": "CBM",
    "invProc.fifoPanelPiecesLabel": "Piezas",
    "invProc.outputPiecesLabel": "Output Piezas",
    "invProc.inputPiecesLabel": "¿Cuántas piezas entran?",
    "invProc.useFullVolume": "Usar todo el volumen",
    "invProc.useAllPieces": "Todas las piezas",
    "invProc.inputPiecesOptionalHint": "Opcional — también puede ingresarlo al terminar el trabajo.",
    "invProc.inputPiecesExceeds": "Más que las piezas de este stock",
    "invProc.inputPiecesUsed": "Piezas de entrada usadas",
    "invProc.inputPiecesHint": "Piezas tomadas del stock de entrada. Las piezas de salida pueden ser más — una pieza puede dar varias.",
    "invProc.inputPiecesReadOnlyHint": "La entrada no se puede cambiar después de terminar el trabajo. Use un ajuste de stock para corregirla.",
    "invProc.inputPiecesRequired": "Ingrese las piezas de entrada usadas antes de terminar el trabajo.",
    "invProc.confirmSave": "Confirm & Guardar",
    "invProc.inputHeader": "ENTRADA",
    "invProc.outputHeader": "SALIDA",
    "invProc.inputTUs": "Unidades de Stock de Entrada",
    "invProc.lossLabel": "Conversión",
    "invProc.step1.title": "¿Qué va al aserradero?",
    "invProc.step2.title": "¿Qué salió?",
    "invProc.inputCbmLabel": "¿Cuánto entra? (CBM)",
    "invProc.moreDetails": "Más detalles (opcional)",
    "invProc.selectTUs": "Seleccionar unidades de stock (opcional)",
    "invProc.confirmJobSave": "Registrar orden de aserrado",
    "invProc.outputMethod": "¿Cómo registrar la salida?",
    "invProc.directVolume": "Ingresar CBM total",
    "invProc.directVolumeDesc": "Escribir volumen de salida total",
    "invProc.viaTally": "Medir pieza por pieza (Hoja de Conteo)",
    "invProc.viaTallyDesc": "Abrir hoja de conteo para contar piezas",
    "invProc.viaCsv": "CSV / Excel",
    "invProc.viaCsvDesc": "Subir hoja de medición",
    "invProc.viaAi": "AI Import",
    "invProc.viaAiDesc": "Escanear o subir documento",
    "invProc.draftNote": "La orden de aserrado se guardará como borrador. Complete la salida después de guardar.",
    "invProc.notesPlaceholder": "Ej: tablones 4×8, pedido personalizado",
    "invProc.inputCbmLabelHelp": "¿Cuánto entra en el aserradero?",
    "invProc.assignTo": "Asignar al operador",
    "invProc.needsAccept": "Asignada a ti · Aceptar",
    "invProc.assignedToYou": "Asignada a ti",
    "invProc.assignedTo": "Asignada a",
    "invProc.createdBy": "Creado por",
    "invProc.you": "Tú",
    "invProc.acceptedLabel": "Aceptada",
    "invProc.onlyAssignedCanAct": "Esta tarea está asignada a otro operador. Solo ese operador o un gerente puede trabajar en ella.",
    "invProc.acceptTask": "Aceptar tarea",
    "invProc.accepted": "Tarea aceptada",
    "invProc.myTasks": "Mis tareas",
    "invProc.big.accept": "Aceptar",
    "invProc.big.start": "Iniciar",
    "invProc.big.done": "Terminado",
    "invProc.big.resume": "Reanudar",
    "invProc.big.pause": "Pausa",
    "invProc.declineButton": "No puedo",
    "invProc.declineTitle": "No puedo hacer esta tarea",
    "invProc.declineIntro": "La tarea vuelve a tu gerente. Dile por qué.",
    "invProc.declineReasonLabel": "¿Por qué no puedes hacerla?",
    "invProc.declineReasonPlaceholder": "p. ej. máquina rota, troncos equivocados, no estoy en este aserradero",
    "invProc.declineConfirm": "Devolver",
    "invProc.declineDone": "Tarea devuelta a tu gerente",
    "invProc.declineNeedsInternet": "Esto necesita internet. Inténtalo de nuevo cuando estés en línea.",
    "invProc.declinedCouldNot": "no pudo hacer esta tarea",
    "invProc.declinedHint": "Ya no está asignada a nadie. Cancélala y crea una nueva tarea para otro operador.",
    "invProc.myTasksSubtitle": "Su trabajo en el aserradero. Toque el botón grande para avanzar la tarea.",
    "invProc.myTasksEmpty": "No tiene tareas ahora",
    "invProc.myTasksEmptyHint": "Las nuevas tareas asignadas a usted aparecerán aquí.",
    "invProc.big.refresh": "Actualizar",
    "user.millOperator": "Operador de aserradero",
    "user.millOperatorPill": "Operador",
    "user.millOperatorOnTitle": "Operador de aserradero activado",
    "user.millOperatorOffTitle": "Operador de aserradero desactivado",
    "user.millOperatorOnMessage": "Ahora se le pueden asignar tareas del aserradero.",
    "user.millOperatorRightsAdded": "Ahora se le pueden asignar tareas del aserradero. Se añadieron View Mill Jobs y Run Mill Jobs a su acceso.",
    "user.millOperatorRoleMissing": "Su rol \"{{role}}\" no incluye View Mill Jobs y Run Mill Jobs, así que aún no puede aceptar tareas. Añádalos al rol o elija otro rol.",
    "user.millOperatorFailed": "No se pudo cambiar el operador. Inténtelo de nuevo.",
    "user.inviteAsMillOperator": "Esta persona es operador de aserradero",
    "user.inviteAsMillOperatorHint": "Se le podrán asignar tareas del aserradero cuando se una.",
    "operator.linkLogin": "Vincular un acceso",
    "operator.linkLoginHint": "Elija qué miembro del equipo es este operador, para que vea y acepte sus tareas. Solo se puede fijar una vez.",
    "operator.noLogin": "Sin acceso",
    "operator.noLoginHint": "Este operador no tiene acceso y no puede ver ni aceptar tareas. Toque para vincular uno.",
    "operator.noOperatorsHint": "Aún no hay operadores. Active \"Operador de aserradero\" para una persona en Gestionar usuarios.",
    "invProc.assignHint": "Dejar en blanco para guardar como Borrador — asignar después.",
    "invProc.willBeAssigned": "El trabajo se creará y asignará al operador seleccionado.",
    "invProc.willBeDraft": "Sin operador seleccionado — el trabajo se guardará como Borrador.",
    "invProc.outputPending": "Pendiente — registrado después del aserrado.",
    "invProc.assignDate": "Fecha esperada",
    "invProc.jobCard": "TU TRABAJO HOY",
    "invProc.startJob": "Iniciar",
    "invProc.customMade.requested": "Solicitado",
    "invProc.customMade.sourceChoiceLabel": "Stock de origen",
    "invProc.customMade.pickMyself": "Elegir yo mismo",
    "invProc.customMade.letOperatorDecide": "Dejar que el operador decida",
    "invProc.customMade.operatorPicksLater": "El operador elegirá el lote de origen al iniciar este trabajo.",
    "invProc.customMade.chooseLotToStart": "Elegir lote de origen",
    "invProc.customMade.rowWaiting": "Esperando para iniciar",
    "invProc.customMade.rowProducing": "Produciendo…",
    "invProc.customMade.rowPaused": "Pausado en el aserradero",
    "invProc.customMade.peekTitle": "Tarea del aserradero",
    "invProc.customMade.peekUnavailable": "No se pudieron cargar los detalles de esta tarea.",
    "invProc.customMade.dialogTitle": "Solicitar Fabricación a Medida",
    "invProc.customMade.dialogExplainer": "No encontramos este tamaño exacto en stock — solicite que se corte en el aserradero.",
    "invProc.customMade.sizeUnknown": "tamaño desconocido — verifique antes de elegir",
    "invProc.lotHeldBy": "Reservado por",
    "invProc.customMade.sizeTooSmall": "más pequeño de lo necesario",
    "invProc.customMade.tooSmallWarning": "Este lote es más pequeño de lo necesario — un aserradero solo puede cortar, no agregar material.",
    "invProc.customMade.inputCbmLabel": "¿Cuánto va a entrar? (CBM)",
    "invProc.customMade.inputCbmHint": "Su fila necesita aproximadamente",
    "invProc.customMade.previewOutturn": "rendimiento estimado",
    "invProc.customMade.inputCbmTooLow": "Esto es menos de lo necesario — auméntelo para permitir la pérdida en el aserradero. Su fila necesita al menos",
    "invProc.customMade.priorityLabel": "Prioridad",
    "invProc.customMade.priorityLow": "Baja",
    "invProc.customMade.priorityMedium": "Media",
    "invProc.customMade.priorityHigh": "Alta",
    "invProc.customMade.priorityHighHint": "Esto bloqueará un envío hasta que se complete — marcado como prioridad Alta.",
    "invProc.customMade.neededByLabel": "Necesario para el",
    "invProc.customMade.neededByHint": "Opcional. Usted y el aserradero reciben un aviso una vez si el trabajo sigue abierto después de este día.",
    "invProc.customMade.targetLabel": "El pedido necesita",
    "invProc.customMade.late": "Atrasado",
    "invProc.customMade.short": "Faltan",
    "invProc.customMade.shortBy": "faltan",
    "invProc.customMade.madeOf": "Producido",
    "invProc.customMade.stillMissing": "piezas siguen faltando. El pedido sigue incompleto: pida el resto al aserradero otra vez.",
    "invProc.customMade.inputBelowTarget": "El volumen de entrada es menor que el que necesita el pedido. Revíselo antes de cortar.",
    "invProc.customMade.submitCta": "Enviar Solicitud",
    "invProc.customMade.requestedToast": "Solicitud a medida enviada",
    "invProc.customMade.requestFailed": "No se pudo enviar la solicitud",
    "invProc.customMade.queuedOfflineRunCode": "En cola — se sincronizará",
    "invProc.customMade.queuedOfflineToast": "Solicitud a medida guardada sin conexión",
    "invProc.customMade.queuedOfflineDetail": "Se enviará automáticamente en cuanto vuelva a estar en línea.",
    "invProc.customMade.staleLotsNotice": "Mostrando lotes de su última sincronización — pueden estar desactualizados.",
    "invProc.customMade.recommended": "Recomendado",
    "invProc.customMade.estimatedOutturn": "Rendimiento estimado",
    "invProc.customMade.viewSizes": "Ver tamaños",
    "common.optional": "opcional",
    "invProc.customMade.tuPreparing": "Preparando",
    "invProc.customMade.tuPreparingTooltip": "Uno o más artículos de esta hoja se están produciendo en el aserradero.",
    "invProc.completeJob": "Trabajo Listo",
    "invProc.cancelJob": "Cancelar orden de aserrado",
    "invProc.pauseJob": "Pausar",
    "invProc.resumeJob": "Reanudar",
    "invProc.pauseReasonLabel": "¿Por qué está pausando esto?",
    "invProc.pauseReasonPlaceholder": "ej.: Llegó un pedido urgente",
    "invProc.filterStatus": "Estado",
    "invProc.filterAll": "Todos",
    "invProc.filterDraft": "Borrador",
    "invProc.filterRunning": "En Curso",
    "invProc.filterPaused": "Pausado",
    "invProc.filterFinished": "Terminado",
    "invProc.filterCompleted": "Completado",
    "invProc.filterCancelled": "Cancelado",
    "invProc.sortLabel": "Ordenar",
    "invProc.sortNewest": "Más Reciente Primero",
    "invProc.sortOldest": "Más Antiguo Primero",
    "invProc.sortCode": "ID de la orden A-Z",
    "invProc.noJobToday": "Sin tarea asignada hoy.",
    "invProc.jobAssignedBy": "Asignado por",
    "invProc.editOutput": "Editar Salida",
    "invProc.outputAboveInput": "La salida es mayor que lo que entró al aserradero. El aserrado no puede producir más madera de la que recibió: revise el tally de salida y el volumen de entrada.",
    "invProc.directEntry": "Volumen Directo",
    "invProc.viaTallySheet": "Via Hoja de Conteo",
    "invProc.taskNo": "Nº de Tarea",
    "invProc.viewInMill": "Ver en el Molino",
    "invProc.sourceOrder": "Pedido de Origen",
    "invProc.viewSourceOrder": "Ver pedido de origen",
    "invProc.selectTallySheet": "Buscar hoja de conteo...",
    "invProc.tallyLinked": "Hoja vinculada — CBM rellenado",
    "invProc.directDesc": "Ingresar CBM total manualmente",
    "invProc.tallyDesc": "Registrar piezas → CBM se totaliza solo",
    "invProc.csvImport": "CSV / Excel",
    "invProc.csvDesc": "Importar hoja → verificar en conteo",
    "invProc.aiImport": "Importación IA",
    "invProc.aiDesc": "Escanear documento → verificar en conteo",
    "invProc.openTally": "Abrir Conteo →",
    "invProc.tallyTypeLabel": "Tipo de Conteo",
    "invProc.tallyTypeRound": "Redondo",
    "invProc.tallyTypeSquare": "Cuadrado",
    "invProc.tallyTypeDerivedHint": "Detectado automáticamente del producto",
    "invProc.tallyTypePickProduct": "Elija primero el producto de salida. El tipo de conteo (Redondo o Escuadrado) se define a partir de él.",
    "invProc.odWhatCameOut": "Qué salió",
    "invProc.odHowRecord": "¿Cómo lo registra?",
    "invProc.odTotals": "Totales",
    "invProc.odSquareRule": "La entrada es madera aserrada (Escuadrada), así que la salida también es Escuadrada. La madera aserrada no puede volver a ser troza redonda.",
    "invProc.volumeUnit": "Unidad de volumen",
    "invProc.odChooseProductFirst": "Elija primero el producto de salida. Luego podrá elegir cómo registrarlo.",
    "invProc.odTotalsFromTally": "Los totales aparecerán aquí cuando guarde el conteo.",
    "invProc.odProductTypeLocked": "El conteo de esta orden ya tiene filas {type}, por eso solo se ofrecen productos {type}.",
    "invProc.noProductOfType": "No se encontró ningún producto {type}",
    "invProc.odDraftSaving": "Guardando su elección…",
    "invProc.odDraftSaved": "Su elección está guardada",
    "invProc.odDraftError": "Todavía no se pudo guardar su elección.",
    "invProc.soFar": "hasta ahora",
    "invProc.recordedSoFar": "Registrado hasta ahora",
    "invProc.recordedBeforeCancel": "Registrado antes de cancelar",
    "invProc.notStockYet": "Todavía no es stock. Pasa a ser stock cuando termine la orden.",
    "invProc.cancelWithOutputWarn": "La orden <b>{run}</b> ya tiene {cbm} CBM ({pcs} piezas) registrados en su conteo de salida. Si cancela, ese conteo queda solo como registro y nada pasa a ser stock. Para llevarlo al stock, termine la orden.",
    "invProc.cancelAnyway": "Cancelar de todos modos",
    "invProc.keepJob": "Mantener orden",
    "invProc.atMill": "En el aserradero",
    "invProc.atMillJobs": "Órdenes en curso",
    "invProc.atMillInput": "Entrada retenida",
    "invProc.atMillOutput": "Salida hasta ahora",
    "invProc.atMillNote": "Todavía no es stock",
    "invProc.openingTally": "Abriendo conteo…",
    "invProc.preparingRun": "Preparando el nuevo trabajo de aserradero…",
    "invProc.odTotalsLocked": "Elija primero el producto de salida y luego ingrese los totales.",
    "invProc.odPrepareSizes": "Preparar medidas (opcional)",
    "invProc.odPrepareSizesHint": "El conteo se abre con estas medidas listas en 0 piezas. El diseño Operador las muestra como tarjetas.",
    "invProc.odSizesReady": "{n} medidas listas",
    "invProc.odSizesNotSaved": "No se pudieron guardar las medidas. Elíjalas de nuevo con Elegir medidas en el diseño Operador.",
    "invProc.odEditInputPieces": "Cambiar piezas de entrada",
    "millOp.layoutAria": "Diseño del conteo",
    "millOp.layoutGrid": "Cuadrícula",
    "millOp.layoutOperator": "Operador",
    "millOp.loadError": "No se pudo cargar la hoja.",
    "millOp.retry": "Intentar de nuevo",
    "millOp.outputPieces": "Piezas de salida",
    "millOp.outputVolume": "Volumen de salida",
    "millOp.volumeUnit": "Unidad de volumen",
    "millOp.input": "Entrada",
    "millOp.outturn": "Rendimiento",
    "millOp.ofInput": "del volumen de entrada",
    "millOp.moreThanInput": "más que la entrada: revise las medidas",
    "millOp.saved": "Guardado",
    "millOp.saving": "Guardando…",
    "millOp.unsaved": "Sin guardar",
    "millOp.saveFailed": "No se pudo guardar",
    "millOp.show": "Mostrar",
    "millOp.sheetSizes": "Medidas de la hoja",
    "millOp.used": "Usadas",
    "millOp.view": "Vista",
    "millOp.textSize": "Tamaño del texto",
    "millOp.cardSize": "Tamaño de las tarjetas",
    "millOp.cardTiny": "Mínimo",
    "millOp.cardSmall": "Pequeño",
    "millOp.cardMedium": "Medio",
    "millOp.cardLarge": "Grande",
    "millOp.tapSound": "Sonido al tocar",
    "millOp.keepScreenOn": "Mantener la pantalla encendida",
    "millOp.keepScreenOnUnsupported": "Este dispositivo o navegador no puede mantener la pantalla encendida.",
    "millOp.unitsNote": "Las unidades siguen los ajustes de la hoja. Para cambiarlas, abra Ajustes en el diseño Cuadrícula.",
    "millOp.resetView": "Restablecer",
    "millOp.oneLess": "Una pieza menos",
    "millOp.oneMore": "Una pieza más",
    "millOp.piecesTapToType": "Piezas. Toque para escribir un número",
    "millOp.noUsed": "Aún no se usó ninguna medida. Cambie a «Medidas de la hoja» y toque +.",
    "millOp.noSizesTitle": "Esta hoja aún no tiene medidas",
    "millOp.noSizesText": "Elija las medidas esperadas o agregue una nueva.",
    "millOp.newSize": "Nueva medida",
    "millOp.pickSizes": "Elegir medidas",
    "millOp.autoSaves": "Se guarda solo poco después del último toque",
    "millOp.screenStaysOn": "La pantalla sigue encendida",
    "millOp.undo": "Deshacer",
    "millOp.setPieces": "Fijar piezas",
    "millOp.piecesForSize": "Piezas de esta medida",
    "millOp.clear": "Borrar",
    "millOp.newSizeHint": "Toque una casilla y luego un valor rápido o las teclas",
    "millOp.width": "Ancho",
    "millOp.thickness": "Grosor",
    "millOp.length": "Largo",
    "millOp.addSize": "Agregar medida",
    "millOp.pickHint": "Marque las medidas esperadas. Podrá agregar otra nueva más tarde.",
    "millOp.searchSize": "Buscar una medida, p. ej. 4 x 2",
    "millOp.listView": "Lista",
    "millOp.chipView": "Fichas",
    "millOp.addAll": "Agregar todas",
    "millOp.hasPieces": "tiene piezas",
    "millOp.noSuggestions": "Aún no hay medidas anteriores. Use «Nueva medida».",
    "millOp.addNSizes": "Agregar {n} medidas",
    "millOp.removeNSizes": "Quitar {n} medidas",
    "millOp.onSheet": "En esta hoja",
    "millOp.sameAsLast": "Igual que el último trabajo {code}",
    "millOp.mostUsed": "Más usadas",
    "millOp.recent": "Recientes",
    "millOp.changeToast": "{size}: {from} → {to} pzas",
    "invProc.odTypeFromInput": "porque la entrada es madera aserrada",
    "invProc.squareInputRoundBlocked": "La madera aserrada (entrada Escuadrada) no puede convertirse en troza redonda. Elija un producto de salida Escuadrado.",
    "invProc.tallyTypeMismatch": "El conteo de este trabajo ya tiene filas de tipo {tally}, pero el producto de salida es {product}. Elija un producto de salida {tally} o cambie a Volumen directo.",
    "invProc.tallyTypeLinkedHint": "De la contabilización vinculada",
    "invProc.linkedTally": "Vinculado",
    "invProc.tallyRows": "filas",
    "invProc.cbmFromTally": "Rellenado automáticamente del conteo",
    "invProc.tallyManualHint": "Registre las piezas en el conteo, luego vuelva aquí",
    "invProc.csvHint": "El diálogo de importación CSV se abrirá automáticamente",
    "invProc.aiHint": "El diálogo de importación IA se abrirá automáticamente",
    "invProc.dispatchOutput": "Enviar a Consignación →",
    "invProc.selectShipment": "Seleccionar Consignación",
    "invProc.shipmentPlaceholder": "Elija una consignación activa...",
    "invProc.confirmDispatch": "Confirmar Despacho",
    "tally.processingBanner": "Registrando salida de la orden de aserrado:",
    "tally.outputLockedTitle": "Esta salida es definitiva",
    "tally.outputLockedText": "Esta orden de aserrado está terminada y su madera ya está en stock como un nuevo lote, por lo que esta planilla es de solo lectura — siempre coincide con el stock que creó. Para cambiar la salida, use Editar Salida en la orden de aserrado. Para corregir una cifra de stock, use Ajuste. Ambos dejan registro.",
    "tally.returnToRun": "Listo — Volver a la orden de aserrado",
    "tally.saveAndReturnToRun": "Guardar y volver a la orden de aserrado",
    "field.stockIn.title": "Registrar Llegada de Stock",
    "field.millRun.title": "Tu Trabajo",
    "field.sendOut.title": "Registrar Despacho",
    "field.selectProduct": "¿Qué llegó?",
    "field.cbmAmount": "¿Cuánto? (CBM)",
    "field.location": "¿Dónde se almacena?",
    "field.submitBtn": "Listo",
    "field.noJobAssigned": "Sin trabajo hoy.",
    "invInOut.title": "Libro de Entradas / Salidas",
    "invInOut.subtitle": "Cada movimiento de inventario con fecha y detalles",
    "invInOut.addAdjustment": "Agregar Ajuste",
    "invInOut.adjTooltip": "Registrar una corrección manual del stock",
    "invInOut.exportTooltip": "Exportar el libro filtrado a Excel",
    "invInOut.dateRange": "Fecha Range",
    "invInOut.allDates": "Todas las fechas",
    "invInOut.movements": "movimientos",
    "invInOut.netChange": "Variación neta",
    "invInOut.businessPartner": "Comercial Socio",
    "invInOut.noMovements": "No se encontraron movimientos.",
    "invInOut.clearFiltersHint": "Prueba a quitar los filtros de arriba.",
    "invInOut.adjDialogHeader": "Agregar Inventario Adjustment",
    "invInOut.tuPlaceholder": "Buscar unidad de stock, n.º de contenedor / camión o producto",
    "ledger.s.received": "Recibido",
    "ledger.s.at": "en",
    "ledger.s.as": "como",
    "ledger.s.dispatched": "Despachado",
    "ledger.s.from": "de",
    "ledger.s.on": "en",
    "ledger.s.to": "a",
    "ledger.s.sentToMill": "Enviado al aserradero",
    "ledger.s.forJob": "para el trabajo",
    "ledger.s.job": "Trabajo",
    "ledger.s.produced": "produjo",
    "ledger.s.into": "en",
    "ledger.s.addedToConsignment": "añadido al envío",
    "ledger.s.allowance": "Tolerancia de rollo",
    "ledger.s.tallyCorrected": "Tally corregido en",
    "ledger.s.stockCorrected": "Stock corregido en",
    "Reconciliation": "Conciliación",
    "Allowance": "Tolerancia",
    "Tally correction": "Corrección del conteo",
    "ledger.s.reconciled": "Conciliado",
    "ledger.col.whatHappened": "Qué pasó",
    "ledger.col.by": "Por",
    "ledger.job.show": "Trabajo completo",
    "ledger.job.in": "Entrada",
    "ledger.job.out": "Salida",
    "ledger.job.started": "Inicio",
    "ledger.job.finished": "Fin",
    "ledger.job.notFinished": "Aún no terminado",
    "ledger.job.wastage": "Merma",
    "invInOut.tuRequired": "Selecciona una Unidad de Stock.",
    "invInOut.reason": "Motivo",
    "invInOut.reasonPlaceholder": "Seleccionar motivo",
    "invInOut.reasonRequired": "Selecciona un motivo.",
    "invInOut.cbmChange": "Cambio en CBM",
    "invInOut.cbmHint": "Negativo = pérdida, positivo = ganancia",
    "invInOut.piecesChange": "Piezas Change",
    "terms.open": "¿Qué son unidad de stock, lote y orden de aserrado?",
    "terms.flowLabel": "Cómo se mueve el stock: entrada, lote, orden de aserrado, nuevo lote, salida",
    "terms.stockIn": "Entrada",
    "terms.stockOut": "Salida",
    "terms.lot": "Lote",
    "terms.newLot": "Nuevo lote",
    "terms.millJob": "Orden de aserrado",
    "terms.suName": "Unidad de stock",
    "terms.suText": "Una carga — contenedor, camión o vagón — con sus filas de conteo. Entrada = comprado, Salida = vendido. Las filas se bloquean al recibir / confirmar.",
    "terms.lotText": "Una pila de la misma madera en stock (producto, sitio, origen, calidad). La entrada se recibe en él; salidas y órdenes de aserrado toman de él — el lote más antiguo primero.",
    "terms.lotOld": "(antes llamado Batch)",
    "terms.jobText": "Madera enviada de un lote al aserradero; registra lo que entró, lo que salió y la merma, y crea un nuevo lote.",
    "terms.jobOld": "(antes llamado Procesamiento)",
    "terms.more": "Cómo se mueve el stock — guía completa",
    "so.fromPurchase": "De la compra",
    "so.whereFrom": "De dónde vino",
    "so.show": "Mostrar",
    "so.showPath": "Mostrar todo el camino",
    "so.hidePath": "Ocultar el camino",
    "so.error": "No se pudo rastrear.",
    "so.nothing": "Aún no se tomó nada del stock.",
    "so.inputNote": "Antes de un aserrado las cifras son la madera que entró, incluida la merma. Volumen neto.",
    "so.in": "entrada",
    "so.out": "salida",
    "so.waste": "merma",
    "so.now": "Ahora",
    "so.adjusted": "Ajustado",
    "so.reconciled": "Conciliado",
    "so.allowance": "Tolerancia",
    "so.traceToPurchase": "Rastrear hasta la compra",
    "so.kind.LOT": "Lote",
    "so.kind.MILL_JOB": "Orden de aserrado",
    "so.kind.STOCK_UNIT": "Unidad de stock",
    "so.kind.OPENING_STOCK": "Stock inicial",
    "so.kind.HAND": "Lote creado a mano",
    "so.kind.ADJUSTMENT": "Añadido por ajuste",
    "so.kind.NOT_TRACED": "No rastreado",
    "adj.what": "Unidad de stock, salida o lote",
    "adj.whatPlaceholder": "Buscar unidad de entrada / salida, contenedor / camión, lote o producto",
    "adj.kind.IN": "Entrada",
    "adj.kind.OUT": "Salida",
    "adj.kind.LOT": "Lote",
    "adj.reconHint": "Diferencia de conciliación — ingrésela por medida:",
    "adj.noLot": "Esta unidad aún no está en un lote — nada que ajustar.",
    "adj.outLine": "Qué línea de esta salida",
    "adj.outLinePlaceholder": "Elija lote · medida · piezas",
    "adj.noOutLines": "Esta salida aún no tomó stock — nada que ajustar.",
    "adj.batchNow": "tiene ahora",
    "adj.dir.gain": "Añadir al stock",
    "adj.dir.loss": "Quitar del stock",
    "adj.dir.outGain": "Enviado menos de lo registrado",
    "adj.dir.outLoss": "Enviado más de lo registrado",
    "adj.size": "Medida",
    "adj.sizePlaceholder": "Elija una medida",
    "adj.anotherSize": "Otra medida…",
    "adj.sec.what": "Qué ajustar",
    "adj.sec.amount": "Medida y cantidad",
    "adj.sec.why": "Motivo",
    "adj.origin": "Origen",
    "adj.quality": "Calidad",
    "adj.originNote": "El ajuste va a este Lote — su origen y calidad no cambian.",
    "adj.volume": "Volumen",
    "adj.sizeSearch": "Buscar medida, ej. 4x3x6",
    "adj.width": "Ancho (pulg)",
    "adj.thick": "Espesor (pulg)",
    "adj.length": "Largo (pies)",
    "adj.pieces": "Piezas",
    "adj.cbm": "CBM",
    "adj.maxPcs": "Hasta {n} piezas en stock",
    "adj.pcsInStock": "{n} piezas",
    "adj.tooMuch": "Es más de lo que este lote / medida realmente tiene.",
    "adj.outNoteTitle": "Salida ajustada",
    "adj.outNote": "El stock se corrige; las filas de la salida quedan igual. Los totales de envío / factura NO cambian — corríjalos también si hace falta.",
    "adj.offline": "Los ajustes necesitan conexión.",
    "adj.saved": "Ajuste registrado — stock actualizado.",
    "adj.roundPart": "Trozas redondas (sin medida)",
    "adj.reason.RECONCILIATION_DELTA": "Diferencia de conciliación",
    "adj.reason.RECONCILIATION_AFTER_MILLING": "Conciliación tras el aserrado",
    "adj.reason.DAMAGE": "Daño",
    "adj.reason.MOISTURE_LOSS": "Pérdida por humedad / secado",
    "adj.reason.MEASUREMENT_ERROR": "Error de medición",
    "adj.reason.MANUAL_CORRECTION": "Corrección manual",
    "adj.reason.OTHER": "Otro",
    "adj.notesRequired": "Describe qué pasó (obligatorio cuando el motivo es Otro).",
    "adj.large.title": "Este es un ajuste grande",
    "adj.large.text": "Revisa bien la cantidad: un error de tecleo (un cero de más) cambiaría mucho tu stock.",
    "adj.large.confirm": "He revisado esta cantidad",
    "adj.holdShortTitle": "Otras salidas quedan cortas",
    "adj.holdShortText": "Estas salidas abiertas reservan más de lo que tiene este lote: {units}",
    "adj.alreadyAdjusted": "ajustado",
    "ledger.s.adjustedAfterConfirm": "Ajustado tras confirmar",
    "ledger.s.recordedOnly": "(solo registrado — sin cambio de stock)",
    "invInOut.postAdjustment": "Registrar ajuste",
    "invInOut.descPlaceholder": "Describe qué pasó (opcional)",
    "invOverview.title": "Inventario Overview",
    "invOverview.subtitle": "Live stock snapshot across all locations",
    "invOverview.thisMonth": "This month",
    "invOverview.clearStageHint": "Haga clic the same stage to clear filter",
    "invOverview.filterTooltip": "Haga clic to filter stock table",
    "invOverview.openTu": "Abrir Unidad de Stock",
    "invOverview.noStock": "Sin stock en inventario todavía.",
    "invOverview.noStockHint": "Haga clic en Entrada de Stock para registrar la primera llegada.",
    "invOverview.showAllTus": "Mostrar todos",
    "invOverview.receiveHint": "Camión llegó — registrar nuevo stock",
    "invOverview.processHint": "Enviar troncos al aserradero",
    "invOverview.dispatchHint": "Stock saliendo",
    "invOverview.recordInInventory": "Registrar en Inventario",
    "invOverview.linkedToInventory": "En Inventario",
    "invOverview.modeToggle": "Modo de vista",
    "inv.modeSimple": "Simple",
    "inv.modeAdvanced": "Avanzado",
    "inv.modeTooltip": "Simple: menos campos · Avanzado: seguimiento completo",
    "inv.stockIn": "Entrada",
    "inv.millRun": "Orden de aserrado",
    "inv.sendOut": "Salida",
    // -- Inventory Lots / Wizards
    "lot.receive": "Entrada",
    "lot.process": "→ Aserradero",
    "lot.sendToMill": "Enviar al aserradero",
    "lot.more.label": "Más",
    "lot.more.details": "Ver detalles",
    "lot.more.statement": "Estado de stock",
    "lot.more.openJob": "Abrir trabajo",
    "lot.more.rename": "Renombrar lote",
    "lot.warn.short": "Por debajo del contrato en",
    "lot.dispatch": "Despachar",
    "lot.stockBatch": "Lotes de Stock",
    "lot.inputLotLabel": "Lote de Entrada",
    "lot.selectLotPlaceholder": "Seleccionar lote (opcional)",
    "lot.searchLotPlaceholder": "Buscar producto, origen, código de lote o trabajo de aserradero…",
    "lot.searchLotEmpty": "Ningún lote coincide con la búsqueda",
    "lot.pickSearchPlaceholder": "Buscar producto, lote, Unidad de Stock, contenedor, BL…",
    "lot.pickOriginPlaceholder": "Origen: todos",
    "lot.pickOriginUnknown": "Origen desconocido",
    "lot.pickOpenLots": "lotes abiertos",
    "lot.pickFree": "CBM libre",
    "lot.pickMadeBy": "hecho por",
    "lot.pickHide": "ocultar",
    "lot.pickStockUnit": "Unidad de Stock",
    "lot.pickContainer": "Contenedor / camión · ID de transporte",
    "lot.pickSource": "origen",
    "lot.pickThisLot": "este lote",
    "lot.pickUnitsCount": "Unidades de Stock",
    "lot.pickReceived": "recibidas en este lote",
    "lot.pickTraced": "rastreadas por el trabajo de aserradero",
    "lot.pickClose": "Cerrar",
    // -- Mill Operators
    "operator.label": "Operador",
    "operator.multiCompanyBadge": "Multiempresa",
    "operator.multiCompanyTooltip": "Esta persona también está activa en otra empresa — su cuenta no es exclusiva de la tuya.",
    "operator.selectPlaceholder": "Asignar operador (opcional)",
    "operator.title": "Operadores de Aserradero",
    "operator.subtitle": "Administre los operadores de aserradero y realice un seguimiento del rendimiento",
    "operator.backToInventory": "Volver al Inventario",
    "operator.addOperator": "Agregar Operador",
    "machine.title": "Máquinas",
    "machine.subtitle": "Administre las máquinas y equipos del aserradero",
    "machine.backToInventory": "Volver al Inventario",
    "machine.addMachine": "Agregar Máquina",
    "machine.editMachine": "Editar Máquina",
    "machine.name": "Nombre",
    "machine.namePlaceholder": "ej. Resierra 2",
    "machine.type": "Tipo",
    "machine.typePlaceholder": "ej. Resierra, Canteadora, Sierra de Corte",
    "machine.location": "Ubicación",
    "machine.status": "Estado",
    "machine.active": "Activo",
    "machine.inactive": "Inactivo",
    "machine.deactivate": "Desactivar",
    "machine.reactivate": "Reactivar",
    "machine.confirmMachine": "Confirmar",
    "machine.searchPlaceholder": "Buscar máquinas...",
    "machine.allLocations": "Todas las Ubicaciones",
    "machine.allStatus": "Todos los Estados",
    "machine.needsReview": "Requiere Revisión",
    "machine.needsReviewTooltip": "Importado del campo de texto libre de una Ubicación — confirme que sea correcto",
    "machine.importFromLocations": "Importar desde Ubicaciones",
    "machine.statTotal": "Total de Máquinas",
    "machine.machineSingular": "máquina",
    "machine.machinePlural": "máquinas",
    "machine.emptyState": "Aún no hay máquinas. Agregue una, o impórtelas desde sus Ubicaciones existentes.",
    "shortcuts.title": "Atajos de Teclado",
    "shortcuts.macHint": "⌘ = Cmd en Mac. Los atajos de Guardar/Eliminar de los formularios de abajo hoy solo funcionan en teclados Mac.",
    "shortcuts.group.anywhere": "En cualquier lugar",
    "shortcuts.group.search": "Dentro de la Búsqueda",
    "shortcuts.group.tally": "Registro de Tally",
    "shortcuts.group.forms": "Formularios de Producto / Sitio",
    "shortcuts.group.photos": "Visor de Fotos",
    "shortcuts.group.calculator": "Calculadora",
    "shortcuts.group.aiChat": "Chat de IA",
    "shortcuts.globalSearch": "Abrir Búsqueda Global",
    "shortcuts.openSearch": "Abrir búsqueda",
    "shortcuts.calculator": "Abrir Calculadora",
    "shortcuts.quickSearch": "Abrir Búsqueda Rápida",
    "shortcuts.showShortcuts": "Mostrar esta lista",
    "shortcuts.expandMenu": "Expandir menú lateral",
    "shortcuts.moveSelection": "Mover selección arriba/abajo",
    "shortcuts.openSelected": "Abrir resultado seleccionado",
    "shortcuts.closeSearch": "Cerrar",
    "shortcuts.saveTally": "Guardar cambios del tally",
    "shortcuts.tallyEnter": "Campo siguiente / fila siguiente (al final añade una fila)",
    "shortcuts.tallyAddRowBelow": "Añadir fila debajo (tally redondo)",
    "shortcuts.tallyStockPicker": "Elegir del stock (diseño flexible Square)",
    "shortcuts.tallyForceNext": "Avanzar sin comprobar el valor (diseño flexible Square: añade una fila debajo)",
    "shortcuts.tallyMoveCells": "Moverse entre celdas",
    "shortcuts.saveForm": "Guardar (solo Mac)",
    "shortcuts.deleteForm": "Eliminar, mientras edita (solo Mac)",
    "shortcuts.prevNextPhoto": "Foto anterior / siguiente",
    "shortcuts.closePhoto": "Cerrar visor de fotos",
    "shortcuts.calcDigits": "Ingresar dígitos",
    "shortcuts.calcOperators": "Operadores",
    "shortcuts.calcPercent": "Porcentaje",
    "shortcuts.calcEquals": "Calcular",
    "shortcuts.calcBackspace": "Borrar último dígito",
    "shortcuts.calcClearOrClose": "Borrar, luego cerrar",
    "shortcuts.aiChatSend": "Enviar mensaje",
    "shortcuts.aiChatNewLine": "Nueva línea, sin enviar",
    "globalSearch.help.viewAllShortcuts": "Ver todos los atajos de teclado",
    "globalSearch.trigger": "Búsqueda Global",
    "unifiedSearch.trigger": "Buscar",
    "unifiedSearch.placeholder": "Busque cualquier cosa, o escriba un cálculo…",
    "unifiedSearch.shortcutHint": "/",
    "unifiedSearch.mode.auto": "Automático",
    "unifiedSearch.mode.records": "Registros",
    "unifiedSearch.mode.stock": "Existencias",
    "unifiedSearch.mode.calculator": "Calculadora",
    "unifiedSearch.autoInterpreting": "Buscando como",
    "unifiedSearch.mathOpenHint": "toque o presione enter para abrir la calculadora",
    "globalSearch.placeholder": "Buscar unidades de stock, envíos, socios, productos, sitios, usuarios…",
    "globalSearch.shortcutHint": "/",
    "globalSearch.searching": "Buscando…",
    "globalSearch.noResults": "Sin resultados",
    "globalSearch.minChars": "Sigue escribiendo para buscar…",
    "globalSearch.category.transportUnit": "Unidades de Stock",
    "globalSearch.category.shipment": "Envíos",
    "globalSearch.category.businessPartner": "Socios Comerciales",
    "globalSearch.category.product": "Productos",
    "globalSearch.category.loadingSite": "Sitios",
    "globalSearch.category.user": "Usuarios",
    "globalSearch.category.menuItem": "Páginas",
    "globalSearch.askLinc.cta": "Preguntar a Linc",
    "globalSearch.askLinc.subtitle": "Pregunta a Linc sobre tus registros y stock",
    "globalSearch.calculatorTooltip": "Calculadora",
    "globalSearch.mathOpenHint": "Toca para seguir calculando",
    "globalSearch.help.toggleTooltip": "Cómo buscar",
    "globalSearch.help.intro": "Buscar en:",
    "globalSearch.help.shortcutText": "Presiona / en cualquier lugar para abrir esta búsqueda. Escribe al menos 2 caracteres — los códigos cortos funcionan desde 2, los nombres largos desde 4.",
    "globalSearch.recentTitle": "Recientes",
    "quickSearch.trigger": "Búsqueda Rápida",
    "quickSearch.placeholder": "ej. 4x3x7 teca ghana a",
    "quickSearch.fuzzyTooltip": "Coincidencia aproximada — no exacta",
    "quickSearch.unrecognizedTooltip": "No reconocido como especie, origen o calidad — ignorado",
    "quickSearch.recent": "Búsquedas recientes",
    "planLimit.dialogTitle": "Límite del Plan Alcanzado",
    "planLimit.dialogUsage": "Has usado {used} de {limit} {feature}.",
    "planLimit.manageButton": "Gestionar {feature}",
    "planLimit.upgradeButton": "Actualizar Plan",
    "quickSearch.searching": "Buscando...",
    "quickSearch.notFound": "Sin resultados — pruebe otra ortografía o menos detalles.",
    "quickSearch.availableNow": "Disponible ahora",
    "quickSearch.pendingStockIn": "Entrada de stock pendiente",
    "quickSearch.groups": "grupos",
    "quickSearch.pcs": "uds",
    "quickSearch.eta": "ETA",
    "quickSearch.details": "Detalles de compra",
    "shipment.tuAllProducts": "Todos los productos en esta unidad",
    "quickSearch.invoiceAmount": "Importe de la factura",
    "quickSearch.billNo": "N.º de factura",
    "quickSearch.billOfLadingNo": "N.º de conocimiento de embarque",
    "quickSearch.viewConsignment": "Ver Consignación",
    "quickSearch.mixedConsignments": "Mixto — toque para ver el desglose",
    "quickSearch.noPurchasingInfo": "No hay información de compra registrada para este stock.",
    "quickSearch.calculator": "Calculadora",
    "quickSearch.quickPrice": "Precio rápido",
    "quickSearch.pricePerCbm": "Precio / CBM",
    "quickSearch.pricePerCft": "Precio / CFT",
    "quickSearch.inProcess": "En orden de aserrado",
    "quickSearch.didYouMean": "¿Quiso decir",
    "quickSearch.arrivingSoon": "Llegando pronto",
    "quickSearch.departingSoon": "Saliendo pronto",
    "quickSearch.preparing": "En preparación",
    "quickSearch.hint": "Escriba especie, dimensiones, origen o calidad — en cualquier orden.",
    "quickSearch.help.toggleTooltip": "Cómo funciona",
    "quickSearch.help.back": "Volver a la búsqueda",
    "quickSearch.help.basicsTitle": "Lo básico",
    "quickSearch.help.basicsText": "Combine especie, tamaño, origen o calidad en cualquier orden — nada es obligatorio.",
    "quickSearch.help.sizesTitle": "Tamaños",
    "quickSearch.help.sizesExactText": "Tamaño exacto, sin necesidad de palabras:",
    "quickSearch.help.sizesRangeText": "O un rango — agregue un comparador y una medida con nombre:",
    "quickSearch.help.sizesTypeText": "Los números solos pueden ser ambiguos — agregue \"square\" (cuadrado) o \"round\" (redondo) para aclarar:",
    "quickSearch.help.sizesAnyText": "Use \"?\" para una medida que no importa — \"4x3x?\" significa 4x3, cualquier largo:",
    "quickSearch.help.speciesTitle": "Especie, origen, calidad",
    "quickSearch.help.speciesText": "Los errores de escritura no son problema — las coincidencias cercanas se encuentran automáticamente. Una marca \"?\" significa que fue una suposición, no exacta.",
    "quickSearch.help.legendTitle": "Qué significan los grupos de resultados",
    "quickSearch.help.legendAvailable": "Disponible Ahora — listo para usar hoy",
    "quickSearch.help.legendPending": "Entrada de Stock Pendiente — registrado, aún no recibido en Inventario",
    "quickSearch.help.legendProcess": "En orden de aserrado — siendo aserrado o re-aserrado ahora",
    "quickSearch.help.legendArriving": "Llegando / Saliendo / Preparando — envíos próximos",
    "quickSearch.help.aiTitle": "Preguntar a la IA",
    "quickSearch.help.aiText": "¿Le cuesta formularlo? Preguntar a la IA entiende un lenguaje más natural y menos preciso. Usa créditos de IA (plan Forest) — la búsqueda normal siempre sigue siendo gratuita.",
    "commandCenter.title": "Centro de Comando",
    "commandCenter.asOf": "A las",
    "commandCenter.offlineNoCopyTitle": "Aún no guardado en este teléfono",
    "commandCenter.offlineNoCopyText": "Abre el Centro de Mando una vez con conexión. Después, las últimas cifras quedan guardadas en este teléfono y podrás verlas sin conexión.",
    "commandCenter.tab.overview": "Resumen",
    "commandCenter.tab.inventory": "Inventario",
    "commandCenter.tab.floor": "Piso y Rendimiento",
    "commandCenter.tab.money": "Finanzas",
    "commandCenter.tab.consignments": "Consignaciones",
    "commandCenter.cons.arriving": "Llegan esta semana",
    "commandCenter.cons.leaving": "Salen esta semana",
    "commandCenter.cons.preparing": "En preparación",
    "commandCenter.cons.shipped": "Enviado este mes",
    "commandCenter.cons.inShipment": "en envío",
    "commandCenter.cons.arrives": "Llega",
    "commandCenter.cons.departs": "Sale",
    "commandCenter.cons.all": "Todos los envíos",
    "commandCenter.howSure": "Qué tan fiables son los números",
    "commandCenter.counted": "contado",
    "commandCenter.notCountedYet": "Unidades de stock aún sin contar",
    "commandCenter.reviewThem": "Revisarlas",
    "commandCenter.allSizes": "Todas las medidas",
    "commandCenter.allSites": "Todos los sitios",
    "commandCenter.btn.open": "Abrir",
    "commandCenter.btn.review": "Revisar",
    "commandCenter.btn.count": "Contar",
    "commandCenter.btn.see": "Ver",
    "commandCenter.btn.assign": "Asignar",
    "commandCenter.attn.noMachineOne": "El trabajo de aserradero {code} no tiene máquina",
    "commandCenter.attn.noMachineMany": "{n} trabajos de aserradero en marcha no tienen máquina",
    "commandCenter.attn.holdsOne": "1 Salida de stock retiene madera hace 60+ días",
    "commandCenter.attn.holdsMany": "{n} Salidas de stock retienen madera hace 60+ días",
    "commandCenter.attn.holdsSub": "{cbm} m³ bloqueados para la venta",
    "commandCenter.tabShort.inventory": "Stock",
    "commandCenter.tabShort.floor": "Planta",
    "commandCenter.tabShort.consignments": "Envíos",
    "commandCenter.confidence": "Confianza",
    "commandCenter.inventoryConfidence": "Confianza del Inventario",
    "commandCenter.of": "de",
    "commandCenter.reconciledCopy": "unidades de stock están reconciliadas",
    "commandCenter.reviewUnreconciled": "Revisar lo no reconciliado",
    "commandCenter.stockOnHand": "Stock disponible",
    "commandCenter.machinesRunning": "Máquinas en funcionamiento",
    "commandCenter.owedToYou": "Por cobrar",
    "commandCenter.thisWeek": "Esta semana (salida / entrada)",
    "commandCenter.thisWeekTitle": "Esta semana",
    "commandCenter.split.out": "Salida",
    "commandCenter.split.in": "Entrada",
    "commandCenter.preparing": "en preparación",
    "commandCenter.jobsWithoutMachine": "en curso sin máquina",
    "commandCenter.needsAttention": "Requiere Su Atención",
    "commandCenter.allClear": "Todo en orden — nada requiere atención ahora.",
    "commandCenter.stockAtGlance": "Stock de un Vistazo",
    "commandCenter.product": "Producto",
    "commandCenter.site": "Sitio",
    "commandCenter.origin": "Origen",
    "commandCenter.quality": "Calidad",
    "commandCenter.dims": "Dimensiones",
    "commandCenter.available": "Disponible",
    "commandCenter.round": "Redondo",
    "commandCenter.viewAllGroups": "Ver todos los grupos",
    "commandCenter.sortNewest": "Más recientes",
    "commandCenter.sortMostStock": "Más stock",
    "commandCenter.sortAz": "A–Z",
    "commandCenter.added": "Añadido",
    "commandCenter.showLess": "Mostrar menos",
    "commandCenter.rangeOf": "de",
    "commandCenter.conversionYield": "Rendimiento por especie",
    "commandCenter.avgOutturn": "Rendimiento promedio",
    "commandCenter.netVolume": "Volumen neto de las órdenes de aserrado",
    "commandCenter.reconciliationStatus": "Estado de Reconciliación",
    "commandCenter.total": "Total",
    "commandCenter.reconciled": "Reconciliado",
    "commandCenter.pending": "Pendiente",
    "commandCenter.locked": "Bloqueado",
    "commandCenter.siteUtilisation": "Utilización del Sitio",
    "commandCenter.floorNow": "En planta ahora",
    "commandCenter.operator": "Operador",
    "commandCenter.machine": "Máquina",
    "commandCenter.location": "Ubicación",
    "commandCenter.started": "Iniciado",
    "commandCenter.status": "Estado",
    "commandCenter.noActiveRuns": "No hay órdenes de aserrado activas ahora.",
    "commandCenter.toCollect": "Por cobrar",
    "commandCenter.toPay": "Por pagar",
    "commandCenter.overdueToCollect": "Vencido por cobrar",
    "commandCenter.overdueToPay": "Vencido por pagar",
    "commandCenter.overdueToCollectByAge": "Vencido por cobrar por antigüedad",
    "commandCenter.invoices": "facturas",
    "commandCenter.inTotal": "en total",
    "commandCenter.received": "Recibido",
    "commandCenter.paidOut": "Pagado",
    "commandCenter.futureDated": "La fecha de este pago está en el futuro — revísala",
    "commandCenter.futureDatedShort": "fecha futura",
    "commandCenter.last30Days": "(últimos 30 días)",
    "commandCenter.attn.overdueCollectOne": "1 factura por cobrar está vencida",
    "commandCenter.attn.overdueCollectMany": "{n} facturas por cobrar están vencidas",
    "commandCenter.attn.atRisk": "{amount} {cur} en riesgo",
    "commandCenter.attn.overduePayOne": "1 factura que debes está vencida",
    "commandCenter.attn.overduePayMany": "{n} facturas que debes están vencidas",
    "commandCenter.attn.toPaySub": "{amount} {cur} por pagar",
    "commandCenter.attn.pendingReconOne": "1 unidad de stock pendiente de reconciliación",
    "commandCenter.attn.pendingReconMany": "{n} unidades de stock pendientes de reconciliación",
    "commandCenter.attn.netDiscrepancy": "{v} CBM de diferencia neta",
    "commandCenter.attn.tallySyncOne": "1 corrección de albarán necesita su decisión",
    "commandCenter.attn.tallySyncMany": "{n} correcciones de albarán necesitan su decisión",
    "commandCenter.attn.tallySyncSub": "El stock no se cambió automáticamente — revise en Inventario → Entradas y salidas",
    "tallySync.title": "Correcciones de albarán pendientes",
    "tallySync.subtitle": "Se cambió un albarán después de recibir este stock. El stock NO se cambió automáticamente.",
    "tallySync.change": "El albarán cambió el stock en",
    "tallySync.reasonNegative": "Dejaría el lote por debajo de cero, y su empresa no permite vender más allá del stock disponible (Configuración → Política de inventario).",
    "tallySync.reasonReconLocked": "La conciliación ya está bloqueada, así que las cifras de llegada (destino) deciden el stock.",
    "tallySync.reasonShipped": "Esta Stock Unit ya fue enviada.",
    "tallySync.reasonOther": "Necesita la decisión de una persona.",
    "tallySync.apply": "Aplicar al stock",
    "tallySync.dismiss": "Descartar",
    "tallySync.appliedToast": "Stock actualizado",
    "tallySync.dismissedToast": "Corrección de albarán descartada — stock sin cambios",
    "tallySync.actionFailed": "No se pudo completar",
    "tallySync.noPermission": "No tiene permiso para cambiar el stock.",
    "commandCenter.attn.siteFull": "{name} está al {pct}% de su capacidad",
    "commandCenter.attn.siteSub": "{cur} de {cap} CBM",
    "commandCenter.attn.departingOne": "1 envío sale esta semana",
    "commandCenter.attn.departingMany": "{n} envíos salen esta semana",
    "commandCenter.attn.soonest": "Más próximo: {date}",
    "commandCenter.money.atSavedRates": "A los tipos de cambio guardados",
    "commandCenter.money.partial": "Parcial",
    "commandCenter.money.partialTip": "Algunos importes no tienen tipo de cambio y no están en este total",
    "commandCenter.money.noRate": "sin tipo",
    "commandCenter.money.noRateCountOne": "1 envío sin tipo de cambio — fuera de los totales",
    "commandCenter.money.noRateCountMany": "{n} envíos sin tipo de cambio — fuera de los totales",
    "commandCenter.money.addRate": "Añadir tipo",
    "commandCenter.money.unmatchedOne": "1 pago en otra moneda sin tipo — no contado",
    "commandCenter.money.unmatchedMany": "{n} pagos en otra moneda sin tipo — no contados",
    "commandCenter.money.net": "Posición neta",
    "commandCenter.money.inFavour": "a tu favor",
    "commandCenter.money.youOweMore": "debes más",
    "commandCenter.money.overdueByAge": "Vencidos por antigüedad",
    "commandCenter.money.nothingOverdue": "Nada vencido",
    "commandCenter.money.overdueOne": "{amount} vencido · 1 factura",
    "commandCenter.money.overdueMany": "{amount} vencido · {n} facturas",
    "commandCenter.money.invoiceOne": "1 factura",
    "commandCenter.money.invoiceMany": "{n} facturas",
    "commandCenter.money.dueToday": "Vence hoy",
    "commandCenter.money.dueTomorrow": "Mañana",
    "commandCenter.money.inDays": "en {n} días",
    "commandCenter.money.lateOne": "1 día de retraso",
    "commandCenter.money.lateMany": "{n} días de retraso",
    "commandCenter.notAssigned": "Sin asignar",
    "commandCenter.notStarted": "No iniciado",
    "commandCenter.waiting": "Esperando",
    "commandCenter.days": "días",
    "commandCenter.openJob": "Abrir trabajo",
    "commandCenter.moneyToday": "Finanzas Hoy",
    "commandCenter.totalReceivable": "Total por cobrar",
    "commandCenter.totalPayable": "Total por pagar",
    "commandCenter.overdue": "Vencido",
    "commandCenter.overdueCount": "Facturas vencidas",
    "commandCenter.recentPayments": "Pagos recientes",
    "commandCenter.noRecentPayments": "No hay pagos recientes.",
    "commandCenter.dueSoon": "Por vencer pronto",
    "commandCenter.noDueSoon": "Nada por vencer pronto.",
    "commandCenter.consignmentRadar": "Próximos 7 días",
    "commandCenter.recentActivity": "Envíos recientes",
    "commandCenter.tradeMix": "Mezcla Comercial",
    "quickSearch.ai.toggle": "Preguntar a la IA",
    "quickSearch.ai.toggleTooltip": "Plan Forest — entiende frases más confusas que la búsqueda normal, consume créditos de IA en cada uso",
    "quickSearch.ai.ask": "Preguntar a la IA",
    "quickSearch.ai.creditsUsedThisCall": "Créditos usados",
    "quickSearch.ai.used": "de tus créditos de IA usados",
    "quickSearch.ai.outOfCredits": "Créditos de IA agotados para este período. La búsqueda normal sigue funcionando sin costo de créditos.",
    "quickSearch.ai.rateLimited": "Límite diario de uso de IA alcanzado. Intenta de nuevo mañana, o usa la búsqueda normal.",
    "quickSearch.ai.forestOnly": "Preguntar a la IA está disponible en el plan Forest. La búsqueda normal sigue funcionando.",
    "quickSearch.ai.genericError": "La IA no pudo responder — prueba la búsqueda normal.",
    "invProc.machineLabel": "Máquina (opcional)",
    "invProc.machinePlaceholder": "Seleccionar máquina",
    "operator.name": "Nombre",
    "operator.employeeCode": "Código de Empleado",
    "operator.expertise": "Especialización",
    "operator.hireDate": "Fecha de Contratación",
    "operator.active": "Activo",
    "operator.inactive": "Inactivo",
    "operator.runsCompleted": "Órdenes de aserrado completadas",
    "operator.avgOutturn": "Rendimiento Promedio",
    "operator.bestOutturn": "Mejor Rendimiento",
    "operator.searchPlaceholder": "Buscar operadores...",
    "operator.allExpertise": "Toda Especialización",
    "operator.allStatus": "Todo Estado",
    "operator.statTotal": "Total",
    "operator.operatorSingular": "operador",
    "operator.operatorPlural": "operadores",
    "operator.viewPerformance": "Ver Rendimiento",
    "operator.performance": "Rendimiento",
    "operator.deactivate": "Desactivar",
    "operator.noOperatorsFound": "No se encontraron operadores",
    "operator.noOperatorsSub": "Ajuste los filtros o agregue su primer operador de aserradero para comenzar.",
    "operator.editOperator": "Editar Operador",
    "operator.reactivate": "Reactivar",
    "operator.currentlyAssigned": "Actualmente Asignado",
    "operator.pending": "Pendiente",
    "operator.noTasks": "Sin tareas",
    "operator.viewFullHistory": "Ver Historial Completo",
    "operator.fullHistory": "Historial Completo",
    "operator.taskCode": "Tarea",
    "operator.materials": "Materiales",
    "operator.processingDate": "Fecha de la orden de aserrado",
    "operator.outturn": "Rendimiento",
    "common.from": "Desde",
    "common.to": "Hasta",
    // -- Lot card detail keys
    "lot.noOpenLots": "Sin lotes de stock abiertos. Haga clic en Recibir para agregar stock.",
    "lot.showMore": "Mostrar más",
    "lot.showLess": "Mostrar menos",
    "lot.availableCbm": "disponible",
    "lot.seeDeliveries": "Ver entregas",
    "lot.seeConsignments": "Ver consignaciones",
    "lot.otherDeliveries": "Otras entregas",
    "lot.whereFrom": "Ver de dónde proviene este lote",
    "lot.madeAtMill": "Hecho en el aserradero",
    "lot.purchasedFrom": "Comprado a",
    "lot.category.millOutput": "Producido en el Aserradero",
    "lot.category.openingStock": "Existencias Iniciales",
    "lot.category.notLinked": "Sin Compra Registrada",
    "lot.category.partiallyLinked": "Parcialmente Vinculado",
    "lot.category.linked": "Vinculado a una Compra",
    "lot.millActivity.queued": "En Cola para el Aserradero",
    "lot.millActivity.running": "En el Aserradero Ahora",
    "lot.millActivity.paused": "Pausado",
    "lot.millActivity.partiallyMilled": "Parcialmente Aserrado",
    "lot.cancelledAttemptsNote": "Este lote ha tenido {count} intento(s) de aserrado cancelado(s).",
    "lot.viewCancelledAttempt": "Ver",
    "lot.filter.all": "Todos",
    "lot.filter.attention": "Necesita Atención",
    "lot.filter.atMill": "En el Aserradero",
    "lot.filter.fromMill": "Producido en el Aserradero",
    "lot.filter.finished": "Agotado",
    "lot.status.open": "Abierto",
    "lot.status.depleted": "Agotado",
    "lot.status.closed": "Cerrado",
    "lot.status.empty": "Vacío",
    "lot.status.help": "Abierto — stock que puedes usar · Vacío — sigue abierto pero sin nada · Agotado — todo el stock usado (aserrado o vendido) · Cerrado — cerrado a mano, sin más actividad",
    "lot.sort.label": "Ordenar",
    "lot.sort.newest": "Más Reciente Primero",
    "lot.sort.oldest": "Más Antiguo Primero",
    "lot.sort.name": "Nombre A-Z",
    "lot.sort.amountDesc": "Más Existencias Primero",
    "lot.sort.amountAsc": "Menos Existencias Primero",
    "lot.category.notLinkedHelp": "La entrega de este lote no está vinculada a una compra registrada. Esto es normal para una recogida doméstica registrada sin una orden de compra formal — pero revise el campo Consignación de la entrega si esperaba un vínculo.",
    "lot.category.partiallyLinkedHelp": "Algunas entregas de este lote están vinculadas a una compra, pero al menos una no lo está.",
    "inv.millWarningHeader": "Verifique Antes de Empezar",
    "mpc.title": "Revisa antes de empezar",
    "mpc.checking": "Revisando…",
    "mpc.notReconciled": "aún no está conciliada.",
    "mpc.diff": "El conteo de descarga muestra",
    "mpc.noCount": "El conteo de descarga aún no se ha ingresado.",
    "mpc.alreadyConfirmed": "— aserrar sin conciliar ya fue confirmado.",
    "mpc.closedWithoutCount": "se cerró sin conteo de descarga — lo que llegó nunca se revisó.",
    "mpc.reconcileNow": "Conciliar ahora",
    "mpc.afterStart": "Una vez que empiece el trabajo en el aserradero, la diferencia solo se podrá registrar — el stock se corrige luego con un ajuste.",
    "mpc.typeConfirm": "Escribe CONFIRM para empezar sin conciliar",
    "mpc.confirmHint": "Una palabra — los espacios en los extremos no importan.",
    "mpc.confirmOk": "Confirmado — puedes continuar.",
    "recon.afterMill.title": "Esta Unidad de Stock no se concilió antes del aserrado.",
    "recon.afterMill.titleSold": "Esta Unidad de Stock no se concilió antes de vender el stock.",
    "recon.afterMill.cantApply": "ya usó este stock, así que conciliar aquí ya no cambia el stock. Para corregirlo, ajusta el stock con un ajuste:",
    "recon.afterMill.pooledNote": "Consejo: trabajos de aserradero o ventas anteriores ya usaron madera hasta esta Stock Unit, por eso su conteo solo se registra. Corrija cualquier diferencia con un ajuste.",
    "inv.smartSearch.label": "Buscar elemento",
    "legal.agree.prefix": "Acepto los",
    "legal.agree.terms": "Términos del Servicio",
    "legal.agree.and": "y la",
    "legal.agree.privacy": "Política de Privacidad",
    "legal.agree.required": "Marca “Acepto” para continuar.",
    "inv.smartSearch.openStatement": "Abrir estado completo de",
    "recon.afterMill.noCount": "No se ingresó conteo de descarga — escribe en el ajuste la diferencia encontrada.",
    "recon.afterMill.step1": "Registra lo que llegó: ingresa el conteo de descarga abajo y bloquea como siempre. Así los registros del proveedor y los reportes quedan correctos.",
    "recon.afterMill.step2": "Corrige el stock: después de bloquear, usa “Corregir con un ajuste” — se abre ya completado.",
    "recon.afterMill.recorded": "Diferencia registrada:",
    "recon.afterMill.correctBtn": "Corregir con un ajuste",
    "recon.afterMill.askAdjust": "Pide a alguien con permiso de ajuste que corrija el stock.",
    "recon.afterMill.lockRecordsOnly": "este bloqueo solo lo registra; corrige el stock después con un ajuste.",
    "adj.negative.title": "Esto deja el lote por debajo de cero",
    "adj.negative.typeConfirm": "Escribe CONFIRM para registrarlo igualmente",
    "inv.millWarningNotLinked": "El lote {lotCode} no tiene una compra registrada vinculada. Aún puede iniciar la orden de aserrado — vincúlelo a una compra primero si tiene esa información.",
    "inv.millWarningPartial": "Algunas entregas del lote {lotCode} no están vinculadas a una compra registrada. Aún puede iniciar la orden de aserrado.",
    "inv.millWarningContinue": "Continuar de Todos Modos",
    "inventory.receiveNotLinkedWarning": "Esta entrega aún no está vinculada a una compra registrada (Consignación).",
    "lot.unitNumber": "N.º Contenedor/Camión/Tren",
    "origin.cameFrom": "Procedencia",
    "origin.stockUnitsWord": "Unidades de Stock",
    "origin.blsWord": "BL",
    "origin.order": "Pedido",
    "origin.via": "vía",
    "origin.noStockUnit": "Sin Unidad de Stock — stock inicial",
    "origin.returned": "Mercancía devuelta — sin Unidad de Stock",
    "lot.loading": "Cargando...",
    "lot.searchPlaceholder": "Buscar por ID",
    "lot.searchIncludeClosed": "También buscar lotes agotados",
    "lot.searchResultSingular": "lote encontrado",
    "lot.searchResultPlural": "lotes encontrados",
    "lot.receivedCbm": "Recibido",
    "lot.purchasedCbm": "contratado",
    "lot.daysOld": "días",
    "lot.procurementOutturn": "rendimiento de compra",
    "lot.openingBalance": "Saldo inicial",
    "lot.openingBalanceNote": "Stock anterior — sin historial de compra",
    // -- Receive wizard
    "receive.wizard.title": "Stock Llegó",
    "receive.wizard.editTitle": "Editar Lote de Stock",
    "receive.step1.title": "¿Qué llegó y de dónde?",
    "receive.step2.title": "¿Cuánto llegó?",
    "receive.step3.title": "¿Cuánto recibió?",
    "receive.step4.title": "Confirmar recibo",
    "receive.selectSite": "Seleccionar sitio de almacenamiento",
    "receive.selectSupplier": "Seleccionar proveedor",
    "receive.quantity": "CBM Recibido",
    "receive.pieces": "Número de piezas",
    "receive.purchaseDate": "Fecha de compra",
    "receive.confirmed": "Registrar Entrada",
    "receive.moreDetails": "Agregar detalles de compra (opcional)",
    "receive.isOpeningBalance": "Este es stock anterior (saldo inicial)",
    // -- Dispatch wizard
    "dispatch.wizard.title": "Enviar Stock",
    "dispatch.step1.title": "¿Qué stock sale?",
    "dispatch.step2.title": "¿Adónde va?",
    "dispatch.step3.title": "Detalles del despacho",
    "dispatch.step4.title": "Confirmar despacho",
    "dispatch.counterparty": "Cliente / destino",
    "dispatch.reference": "Factura / número de referencia",
    "dispatch.confirmed": "Confirmar Salida",
    "dispatch.destination": "Va a (comprador / destino)",
    "dispatch.linkTrade": "Vincular a Registro Comercial / Consignación (opcional)",
    "dispatch.invoiceRef": "Referencia factura / pedido (opcional)",
    "dispatch.actingAs": "Despachando como",
    "dispatch.actingNow": "ahora",
    "dispatch.shipment": "Vincular a la Consignación",
    "dispatch.shipment.placeholder": "Seleccionar consignación (opcional)",
    "dispatch.stepSplit.title": "Confirmar división de stock",
    "dispatch.stepSplit.hint": "Stock más antiguo primero — puede ajustar la división abajo.",
    "dispatch.filters.toggle": "Filtros (opcional)",
    "dispatch.filters.product": "Producto",
    "dispatch.filters.widthIn": "Ancho (pulg)",
    "dispatch.filters.thicknessIn": "Espesor (pulg)",
    "dispatch.filters.origin": "Origen",
    "dispatch.filters.quality": "Calidad",
    "dispatch.roundLogs": "Troncos redondos",
    "dispatch.unsorted": "Sin clasificar",
    "dispatch.qtyPlaceholder": "Cantidad",
    "dispatch.noStock": "No se encontró stock coincidente.",
    "dispatch.itemsAdded": "Artículos agregados",
    "dispatch.shortfall": "Falta",
    "dispatch.shortfallSuffix": "— agregue más lotes o reduzca la cantidad",
    "receive.origin": "Origen (país)",
    "receive.originPlaceholder": "ej. Ghana, Brasil",
    "receive.quality": "Calidad / grado",
    "receive.salePrice": "Precio de venta",
    "receive.size": "Tamaño (Ancho × Espesor × Largo)",
    "receive.lengthOpenEnded": "sin máximo",
    "receive.lengthOpenEndedHint": "Deje el segundo largo en blanco para final abierto (ej. \"7ft+\").",
    "tally.qualityForTu": "Calidad — todos los troncos en esta unidad de stock",
    "tally.qualityPerRow": "Por fila (establecer individualmente)",
    "tally.qualityForTuHint": "Deje en blanco para establecer la calidad por fila en la cuadrícula.",
    "tally.qualityForTuHintRound": "Se aplica a todos los troncos en esta unidad de stock.",
    "tally.qualityNone": "Sin calidad establecida",
    "tally.qualityNoneShort": "Ninguna",
    "tally.qualityEnableLabel": "Habilitar Calidad para esta Unidad de Stock",
    "tally.qualityDisabledHint": "El seguimiento de calidad está desactivado para esta unidad de stock. Los datos de calidad existentes se conservan y reaparecerán si vuelve a activarlo.",
    "tally.qualityDisableConfirmTitle": "¿Deshabilitar Calidad?",
    "tally.qualityDisableConfirmBodyPrefix": "Esto borrará permanentemente el grado de Calidad de",
    "tally.qualityDisableConfirmBodySuffix": "fila(s) en esta unidad de stock. Esta acción no se puede deshacer.",
    "tally.qualityDisableConfirmInputLabel": "Escriba CONFIRM para continuar",
    "tally.qualityDisableConfirmButton": "Deshabilitar y Borrar Calidad",
    "tally.qualityDisableCancelButton": "Cancelar",
    "tally.qualityDisabledToastTitle": "Calidad Deshabilitada",
    "tally.qualityDisabledToastDetail": "El seguimiento de calidad se ha desactivado y borrado para esta unidad de stock.",
    "tally.qualityDisableFailed": "Error al deshabilitar la Calidad. Inténtelo de nuevo.",
    "tally.saveNow": "Guardar Ahora",
    "tally.settingsSaving": "Guardando…",
    "tally.settingsSaved": "Guardado",
    "tally.settingsSaveFailedRetry": "Error al guardar — toque para reintentar",
    "tally.settingsAutoSaveFailed": "No se pudieron guardar los cambios. Verifique su conexión e inténtelo de nuevo.",
    "quality.renameGrades": "Renombrar grados",
    "quality.renameGradesTitle": "Etiquetas de Grado de Calidad",
    "quality.renameGradesHint": "Estos nombres aparecen en todas partes donde se muestra la calidad — las entradas antiguas se actualizan automáticamente.",
    "chain.viewChain": "Ver Cadena del Lote",
    "trace.fullTrace": "Trazabilidad Completa",
    "statement.title": "Estado de Stock",
    "statement.subtitle": "Prueba de lo que entró, fue al aserradero, se vendió y sigue en stock",
    "statement.openStatement": "Estado de Stock",
    "statement.unit": "Unidad de volumen",
    "statement.exportPdf": "PDF",
    "statement.exportExcel": "Excel",
    "statement.searchPlaceholder": "Unidad de stock, n.º de contenedor / camión, lote, orden de aserrado o BL",
    "statement.suggest.recent": "Recientes",
    "statement.suggest.stockUnits": "Unidades de stock",
    "statement.suggest.batches": "Lotes",
    "statement.suggest.millJobs": "Trabajos de aserradero",
    "statement.suggest.consignments": "Envíos (BL)",
    "statement.suggest.none": "Sin resultados - pruebe unidad de stock, n.º de contenedor / camión, lote, orden de aserrado o BL",
    "statement.show": "Mostrar estado",
    "statement.emptyTitle": "Demuestra cualquier stock en un solo lugar",
    "statement.emptyText": "Escribe una unidad de stock, contenedor, lote, trabajo de aserradero o BL. Verás el balance, la merma del aserradero, cada movimiento y si cuadra con los lotes.",
    "statement.notFound": "No se encontró nada para ese código",
    "statement.notFoundHint": "Revisa la escritura o prueba el ID de la unidad, contenedor, LOT-…, PR-… o BL.",
    "statement.generated": "Generado",
    "statement.balanced": "Cuadrado",
    "statement.balancedSub": "Cada lote cuadra con su registro y entradas = salidas",
    "statement.difference": "Diferencia encontrada",
    "statement.differenceSub": "Un lote no cuadra con su registro — mira el lote en rojo",
    "statement.balanceSheet": "Balance",
    "statement.inSide": "Entradas",
    "statement.outSide": "Salidas y saldo",
    "statement.totalIn": "Total entradas",
    "statement.totalOut": "Total salidas y saldo",
    "statement.opening": "Stock inicial",
    "statement.received": "Recibido",
    "statement.producedOutside": "Producido de otros lotes",
    "statement.adjustedNet": "Ajustes (neto)",
    "statement.allowanceNet": "Descuento (circunferencia y longitud)",
    "statement.story": "Qué pasó, paso a paso",
    "statement.storySub": "En orden de fecha, en palabras sencillas",
    "statement.step.startingStock": "Existencias iniciales",
    "statement.step.cameIn": "Entró",
    "statement.step.allowance": "Descuento aplicado (corteza y corte)",
    "statement.step.sentToMill": "Enviado al aserradero",
    "statement.step.millMade": "El aserradero produjo",
    "statement.step.sold": "Vendido y salió",
    "statement.step.correction": "Corrección",
    "statement.step.heldForSale": "Reservado para una venta — aún no ha salido",
    "statement.step.heldForJob": "Reservado para un trabajo de aserradero — aún no ha empezado",
    "statement.step.stillInStock": "Aún en existencias",
    "statement.storyMillSentence": "El aserradero usó {in} y produjo {out}. {loss} fue aserrín y recortes ({pct}%).",
    "statement.storyNothingSold": "Todavía no se ha vendido nada.",
    "statement.storyHeldSentence": "{pieces} piezas están reservadas para {code} y saldrán de existencias cuando se confirme esa venta.",
    "statement.storySoldSentence": "{cbm} ha salido a clientes.",
    "statement.allowance": "Descuento",
    "statement.allowanceHint": "Corteza y corte descontados de los troncos medidos — medida bruta menos medida neta.",
    "statement.kind.ALLOWANCE": "Descuento",
    "statement.sold": "Vendido / despachado",
    "statement.sentToMillOutside": "Enviado al aserradero (salida fuera de este estado)",
    "statement.sentToMillShort": "Enviado al aserradero",
    "statement.wastage": "Merma de aserradero",
    "statement.closing": "Aún en stock",
    "statement.held": "Reservado",
    "statement.free": "Libre",
    "statement.heldPartOf": "de",
    "statement.heldRestOther": "el resto en otros Lotes",
    "stockInHand.title": "Stock en mano",
    "stockInHand.subtitle": "Lo que hay realmente en stock ahora — reservado y libre, por producto y medida",
    "stockInHand.inStock": "En stock",
    "stockInHand.held": "Reservado",
    "stockInHand.free": "Libre",
    "stockInHand.overHeld": "Sobrerreservado",
    "stockInHand.overHeldHint": "Algunas salidas de stock o trabajos de aserradero retienen más madera de la que contiene el lote. Abra los borradores antiguos y libérelos o termínelos.",
    "stockInHand.negativeStock": "Stock negativo",
    "stockInHand.negativeStockHint": "Un conteo o una venta quitó más de lo que tenía el lote, por eso su saldo está por debajo de cero. Abra el lote y corríjalo con un ajuste (añada lo que falta).",
    "stockInHand.explain": "En stock = Reservado + Libre. Reservado queda para Salidas de stock y órdenes de aserrado abiertas; Libre aún se puede vender o aserrar. Volumen neto.",
    "stockInHand.searchPlaceholder": "Buscar producto, medida (4x3x6), origen, sitio o Lote",
    "stockInHand.rows": "filas",
    "stockInHand.groupBy": "Agrupar por producto",
    "stockInHand.expandAll": "Expandir todo",
    "stockInHand.collapseAll": "Contraer todo",
    "stockInHand.sizeOne": "tamaño",
    "stockInHand.sizeMany": "tamaños",
    "stockInHand.sortBy": "Ordenar",
    "stockInHand.sortDefault": "Orden predeterminado",
    "stockInHand.sortFree": "Libre: de mayor a menor",
    "stockInHand.sortIn": "En stock: de mayor a menor",
    "stockInHand.sortSize": "Tamaño",
    "stockInHand.sortProduct": "Producto A–Z",
    "stockInHand.searchShort": "Buscar producto o tamaño",
    "stockInHand.howCounted": "¿Cómo se cuenta esto?",
    "stockInHand.hideHow": "Ocultar",
    "stockInHand.splitTitle": "Retenido vs libre",
    "stockInHand.product": "Producto",
    "stockInHand.size": "Medida",
    "stockInHand.site": "Sitio",
    "stockInHand.lot": "Lote",
    "stockInHand.lots": "Lotes",
    "stockInHand.round": "Trozas redondas",
    "stockInHand.tipIn": "Toda la madera físicamente disponible, reservada o no.",
    "stockInHand.tipHeld": "Parte del stock reservada para Salidas de stock y órdenes de aserrado abiertas. Sigue siendo suya y aún se puede vender o aserrar.",
    "stockInHand.tipFree": "En stock menos Reservado: lo disponible ahora para una nueva venta u orden de aserrado.",
    "stockInHand.roundPcs": "Redonda",
    "stockInHand.squarePcs": "Cuadrada",
    "stockInHand.logsUnit": "trozas",
    "stockInHand.openStatement": "Extracto de stock",
    "stockInHand.holdsTitle": "Retenido por Salidas de Stock abiertas",
    "stockInHand.holdsHint": "Madera prometida a Salidas de Stock aún sin confirmar. Libere una olvidada para liberar la madera.",
    "stockInHand.holdsShowAll": "Mostrar todas",
    "stockInHand.holdsShowFewer": "Mostrar menos",
    "stockInHand.idleToday": "Inactivo hoy",
    "stockInHand.idleDays": "Inactivo hace {n} d",
    "stockInHand.release": "Liberar",
    "stockInHand.releaseSure": "¿Liberar sus reservas?",
    "stockInHand.releaseYes": "Sí, liberar",
    "stockInHand.released": "Reservas liberadas — vuelven cuando alguien abra o guarde esa Salida.",
    "stockInHand.releaseFailed": "No se pudo liberar — inténtelo de nuevo.",
    "stockInHand.openUnit": "Abrir esta Salida de Stock",
    "stockInHand.empty": "Todavía no hay stock",
    "stockInHand.noMatch": "Nada coincide con esta búsqueda",
    "stockInHand.failed": "No se pudo cargar el stock",
    "stockInHand.footnote": "Las filas muestran medidas con stock libre. Reservado por fila = Salidas de stock abiertas en esa medida; las reservas de órdenes de aserrado ya se restan de Libre y cuentan en el total Reservado arriba.",
    "statement.whereItWent": "A dónde fue el stock",
    "statement.millJobs": "Trabajos de aserradero",
    "statement.outturn": "Rendimiento",
    "statement.input": "Entrada",
    "statement.output": "Salida",
    "statement.jobPartial": "Solo un lado de este trabajo está en este estado, así que su merma no se cuenta aquí.",
    "statement.batches": "Lotes",
    "statement.producedBy": "Producido por",
    "statement.fromBatch": "de",
    "statement.matchesRecord": "Cuadra",
    "statement.differenceShort": "Diferencia",
    "statement.negativeStock": "Stock negativo",
    "statement.negativeStockTooltip": "El stock de este lote está por debajo de cero — probablemente una corrección (Conciliación o Ajuste) se registró sin tener en cuenta el stock ya enviado al aserradero o vendido. Verifique.",
    "statement.produced": "Producido",
    "statement.milled": "Al aserradero",
    "statement.adjusted": "Ajustado",
    "statement.pcs": "pzs",
    "statement.batchRecord": "Registro del lote",
    "statement.differenceBy": "diferencia",
    "statement.notInStockTitle": "No hay en stock ahora",
    "statement.notInStockLeft": "Salió del stock por Stock Outs confirmados:",
    "statement.notInStockNone": "Ningún lote lo tiene ahora y no se encontró ningún Stock Out confirmado.",
    "statement.diffPanelTitle": "Dónde, cuánto y por qué",
    "statement.diffPanelWhyBtn": "¿Por qué? ¿Qué hacer?",
    "statement.diffPanelHide": "Ocultar",
    "statement.diffPanelRecord": "Registro del lote",
    "statement.diffPanelMoves": "los movimientos suman",
    "statement.diffPanelWhyLabel": "Por qué:",
    "statement.diffPanelWhy": "El número guardado del lote y el total de sus movimientos se cambiaron por separado — por ejemplo, un cambio hecho fuera de las pantallas normales o un movimiento no registrado.",
    "statement.diffPanelDoLabel": "Qué hacer:",
    "statement.diffPanelDo": "Abra el lote y revise sus movimientos. Corríjalo con Add Adjustment para que el registro y el historial vuelvan a coincidir. No edite el número directamente.",
    "statement.heldForSale": "Reservado venta",
    "statement.heldForJob": "Reservado aserradero",
    "statement.showEntries": "Mostrar movimientos",
    "statement.hideEntries": "Ocultar movimientos",
    "statement.when": "Fecha y hora",
    "statement.entry": "Movimiento",
    "statement.reference": "Referencia",
    "statement.partner": "Socio",
    "statement.noEntries": "Sin movimientos.",
    "statement.timeline": "Cronología",
    "statement.proof": "Generado a partir de los movimientos:",
    "statement.netVolume": "volúmenes netos",
    "statement.piecesIndicative": "algunos movimientos no tienen piezas, los totales de piezas son orientativos",
    "statement.type.STOCK_UNIT": "Unidad de stock",
    "statement.type.BATCH": "Lote",
    "statement.type.MILL_JOB": "Orden de aserrado",
    "statement.type.CONSIGNMENT": "Envío",
    "statement.kind.OPENING": "Stock inicial",
    "statement.kind.RECEIVED": "Recibido",
    "statement.kind.PRODUCED": "Producido en aserradero",
    "statement.kind.MILLED": "Enviado al aserradero",
    "statement.kind.SOLD": "Vendido / despachado",
    "statement.kind.ADJUSTED": "Ajustado",
    "statement.kind.RECONCILED": "Conciliado",
    "statement.kind.ASSIGNED": "Añadido al envío",
    "statement.kind.OTHER": "Otro",
    "statement.modeItem": "Un elemento",
    "statement.modeFilter": "Filtrar stock",
    "statement.filterProduct": "Producto",
    "statement.filterOrigin": "Origen",
    "statement.filterSite": "Sitio",
    "statement.filterQuality": "Calidad",
    "statement.filterSize": "Medida (cualquier unidad)",
    "statement.sizePlaceholder": "3x2x8 ft · 76 x 50 mm · girth 90cm x 8m",
    "statement.sizeInvalid": "Medida no entendida — prueba 3x2x8 ft, 76 x 50 mm o girth 90cm",
    "statement.filterFrom": "Desde",
    "statement.filterTo": "Hasta",
    "statement.filterHint": "Deja vacío para cualquiera. Sin fechas = desde el inicio hasta ahora.",
    "statement.any": "Cualquiera",
    "statement.clear": "Limpiar",
    "statement.emptyFilterText": "Elige filtros y pulsa Mostrar estado — o sin filtros para todo el stock.",
    "statement.noResults": "Ningún stock coincide con estos filtros",
    "statement.noResultsHint": "Quita un filtro o amplía las fechas.",
    "statement.type.FILTER": "Stock filtrado",
    "statement.periodStatement": "Estado del período",
    "statement.periodStatementSub": "Saldos a la fecha final; entradas = salidas",
    "statement.groups": "Grupos de stock",
    "statement.group": "Producto · origen · sitio",
    "statement.batchesLower": "lotes",
    "statement.inShort": "Entrada",
    "statement.sizeNow": "Esta medida ahora",
    "statement.total": "Total",
    "statement.inventoryReportLink": "Estado de Stock",
    "trace.seeWhereFrom": "Ver de dónde viene esto",
    "trace.rel.includesStockUnit": "Incluye Unidad de Stock",
    "trace.rel.linkedToConsignment": "Vinculado al Envío",
    "trace.rel.receivedInto": "Recibido en",
    "trace.rel.dispatchedFrom": "Despachado desde",
    "trace.rel.fedAsInput": "Entrada para",
    "trace.rel.drewStockFrom": "Tomó stock de",
    "trace.rel.receivedIntoLot": "Recibido en este Lote",
    "trace.rel.producedByJob": "Producido por el Trabajo de Aserradero",
    "trace.rel.milledInto": "Aserrado en",
    "trace.rel.soldVia": "Vendido vía",
    "trace.rel.sentOutUnlinked": "Enviado (sin vincular)",
    "trace.rel.fedFromLot": "Viene del Lote",
    "trace.rel.fedFromUnit": "Viene de la Unidad de Stock",
    "trace.rel.mainOutput": "Salida principal",
    "trace.rel.byproduct": "Salida de subproducto",
    "trace.date.created": "Creado",
    "trace.date.shipped": "Enviado",
    "trace.date.purchased": "Comprado",
    "trace.date.produced": "Producido",
    "trace.date.completed": "Completado",
    "trace.date.started": "Iniciado",
    "trace.date.scheduled": "Programado",
    "trace.date.openingStock": "Stock inicial",
    "trace.story.showMore": "Mostrar más",
    "trace.story.sharesNote": "Este reparto es un cálculo (primero el stock más antiguo), no un hecho registrado.",
    "trace.share.adjustment": "Madera de un ajuste",
    "trace.share.hand": "Lote ingresado a mano",
    "trace.label.printAll": "Imprimir etiquetas de todas las Unidades de Stock",
    "trace.label.popup": "Permita las ventanas emergentes para imprimir las etiquetas.",
    "trace.unlinked.one": "Aún no vinculado a una venta",
    "trace.unlinked.many": "{n} despachos aún no vinculados a una venta",
    "trace.search.placeholder": "Busque un contenedor, BL, Unidad de Stock, Lote o Trabajo de Aserradero…",
    "trace.search.none": "No se encontró nada",
    "trace.search.hintTitle": "Rastree cualquier número",
    "trace.search.hintSub": "Escriba arriba un número de contenedor, BL, Unidad de Stock, Lote o Trabajo de Aserradero para ver toda su historia.",
    "trace.view.story": "Historia",
    "trace.view.graph": "Gráfico",
    "trace.story.cameFrom": "De dónde viene",
    "trace.story.wentTo": "A dónde fue",
    "trace.story.nothingBefore": "Nada antes de esto. La historia empieza aquí.",
    "trace.story.nothingAfter": "Nada después de esto todavía.",
    "trace.story.truncated": "Cadena muy larga: solo se muestran los pasos más cercanos. Abra un paso para ir más lejos.",
    "trace.story.madeFrom": "Hecho de",
    "trace.story.couldNot": "No se pudo cargar la historia. Inténtelo de nuevo.",
    "trace.kind.stockUnit": "Unidad de Stock",
    "trace.kind.lot": "Lote",
    "trace.kind.millJob": "Trabajo de Aserradero",
    "trace.kind.consignment": "Envío",
    "trace.kind.sentOut": "Enviado",
    "trace.label.print": "Imprimir etiqueta",
    "trace.label.title": "Etiqueta de la Unidad de Stock",
    "trace.label.printBtn": "Imprimir",
    "trace.label.scan": "Escanee para ver toda la historia de esta madera",
    "trace.label.scanSub": "De dónde viene, qué hizo el aserradero con ella y a dónde fue.",
    "trace.couldNotLoad": "No se pudo cargar esta trazabilidad",
    "trace.pickAncestorTitle": "¿Cuál?",
    "trace.pickAncestorHint": "Esto proviene de más de una compra — elija una para explorar.",
    "trace.history": "Historial",
    "trace.noHistory": "Aún no hay historial registrado",
    "trace.consignment": "Consignación",
    "trace.viewConsignment": "Ver Consignación",
    "trace.viewDispatches": "Ver despachos",
    "trace.quickView": "Vista rápida",
    "trace.loadingTrace": "Cargando...",
    "trace.zoomIn": "Acercar",
    "trace.zoomOut": "Alejar",
    "trace.zoomReset": "Restablecer zoom",
    "trace.viewLot": "Ver Lote",
    "trace.viewRun": "Ver orden de aserrado",
    "lot.lotCode": "Código de Lote",
    "lot.quality": "Calidad",
    "lot.received": "Recibido",
    "lot.currentStock": "Stock Actual",
    "lot.supplier": "Proveedor",
    "lot.purchasePrice": "Precio de Compra",
    "lot.purchaseDate": "Fecha de Compra",
    "processing.millSite": "Sitio del Aserradero",
    "processing.machine": "Máquina",
    "processing.operator": "Operador",
    "processing.input": "Entrada",
    "processing.output": "Salida",
    "processing.outturn": "Rendimiento",
    "chain.sourceLot": "Lote de Origen",
    "chain.rootLot": "Origen Original",
    "chain.earlierLot": "Lote Anterior",
    "chain.thisLot": "Este Lote",
    "chain.outputLot": "Lote de Salida",
    "chain.recovery": "recuperación",
    "chain.received": "recibido",
    "chain.remaining": "disponible",
    "chain.dispatches": "Despachado",
    "chain.directDispatch": "Despacho Directo",
    "chain.noChain": "Aún no hay vínculos aguas arriba o aguas abajo para este lote.",
    "chain.finished": "Finalizado",
    "inventory.viewTask": "Ver Tarea",
    "inventory.created": "Creado",
    "inventory.lastUpdated": "Última Actualización",
    "inventory.by": "por",
    "inventory.viewOrder": "Ver Pedido",
    "inventory.viewInTallysheet": "Ver en la Hoja de Conteo",
    "user.invite": "Invite Usuario",
    "user.sendInvite": "Send Invite",
    "user.teamMembers": "Team Members",
    "user.accessRights": "Acceso Rights",
    "user.deactivateTooltip": "Deactivate — blocks login, data preserved",
    "user.reactivateTooltip": "Reactivate — restore login access",
    "user.resendInvitation": "Resend invitation",
    "user.expired": "Expired",
    "user.declined": "Rechazado",
    "user.declinedTooltip": "El invitado rechazó esta invitación en la app — el enlace por correo sigue siendo válido si cambia de opinión",
    "user.membershipBasedTooltip": "Miembro vía acceso multiempresa — su propia cuenta está en otro lugar. Puedes eliminar su membresía en esta empresa, pero su cuenta se gestiona desde su lado.",
    "user.removeFromCompany": "Eliminar de la empresa",
    "user.confirmRemoveMemberTitle": "Eliminar Miembro",
    "user.confirmRemoveMemberMessage": "{{email}} perderá el acceso a esta empresa. Su propia cuenta y cualquier otra empresa a la que pertenezca no se ven afectadas.",
    "user.memberRemovedTitle": "Miembro eliminado",
    "user.memberRemovedMessage": "{{email}} ya no tiene acceso a esta empresa.",
    "user.memberRemoveFailedMessage": "Error al eliminar al miembro.",
    "user.removeAdminBtn": "Quitar Admin",
    "user.confirmMakeAdminTitle": "Hacer Admin",
    "user.confirmMakeAdminMessage": "{{email}} tendrá acceso total de administrador a esta empresa, incluida la gestión de usuarios. Puede quitarlo más tarde.",
    "user.madeAdminTitle": "Admin añadido",
    "user.madeAdminMessage": "{{email}} ahora es admin.",
    "user.makeAdminFailedMessage": "No se pudo hacer admin a este usuario.",
    "user.confirmRemoveAdminTitle": "Quitar Admin",
    "user.confirmRemoveAdminMessage": "{{email}} seguirá en la empresa como miembro normal pero perderá el acceso de administrador.",
    "user.removedAdminTitle": "Admin quitado",
    "user.removedAdminMessage": "{{email}} ahora es un miembro normal.",
    "user.removeAdminFailedMessage": "No se pudieron quitar los derechos de admin.",
    "user.emailAddresses": "Email Addresses",
    "user.roleTemplate": "Rol Template",
    "user.roleTemplatePlaceholder": "Seleccionar plantilla de rol",
    "user.inviteDialogHeader": "Invite Usuario",
    "user.upgradeToAdd": "Usuario limit reached — upgrade your plan",
    "plan.featureNotAvailable": "Esta función no está disponible en tu plan actual.",
    "plan.availableOnGroveAndAbove": "Disponible en Tree y superiores. Actualiza para desbloquear.",
    "plan.upgradeNow": "Actualizar Plan",
    "auth.sendResetLink": "Send Reset Link",
    "auth.backToLogin": "Back to Login",
    "auth.resetPassword": "Reset Password",
    "auth.createMyAccount": "Crear My Account",
    "auth.iAcceptClose": "I Accept & Close",
    "auth.tryDifferentEmail": "Try a different email",
    "auth.sessionExpired": "Session Expired",
    "auth.sessionExpiredMessage": "Tu sesión ha finalizado por motivos de seguridad. Vuelve a iniciar sesión para continuar donde lo dejaste.",
    "auth.confirmLogout": "Confirm Logout",
    "auth.logoutConfirmMessage": "Are you sure you want to logout?",
    "auth.logoutSuccess": "Logout Successful",
    "auth.logoutSuccessMsg": "You have been successfully logged out.",
    "auth.logoutFailed": "Logout failed",
    "auth.logoutFailedMsg": "Error while logging out",
    "confirmLogoutDevices.header": "Ya tiene una sesión iniciada en otro lugar",
    "confirmLogoutDevices.questionWithDevice": "¿Cerrar sesión en ese dispositivo y continuar iniciando sesión aquí?",
    "confirmLogoutDevices.messageGeneric": "¿Cerrar sesión en él y continuar iniciando sesión aquí?",
    "confirmLogoutDevices.openApp": "Abrir LumberLinq",
    "confirmLogoutDevices.openAppTitle": "Has iniciado sesión",
    "confirmLogoutDevices.openAppHint": "Toca el botón para volver a la aplicación.",
    "confirmLogoutDevices.messageWithDevicePrefix": "Actualmente tiene la sesión iniciada en ",
    "confirmLogoutDevices.messageWithDeviceNear": " cerca de ",
    "confirmLogoutDevices.messageWithDeviceSuffix": ". ¿Está seguro de que desea cerrar sesión en ese dispositivo e iniciar sesión aquí en su lugar?",
    "confirmLogoutDevices.acceptLabel": "Cancelar",
    "confirmLogoutDevices.rejectLabel": "Cerrar sesión y continuar",
    "forcedLogout.header": "Sesión Cerrada",
    "forcedLogout.bodyGeneric": "Se cerró su sesión porque su cuenta inició sesión desde otro dispositivo.",
    "forcedLogout.explanation": "Esta sesión se cerró porque su cuenta acaba de iniciar sesión desde otro dispositivo:",
    "forcedLogout.goToLogin": "Ir a Iniciar sesión",
    "layout.copyCompanyId": "Copy Empresa ID",
    "layout.productTour": "Producto Tour",
    "siteDocs.uploadDialogHeader": "Upload Documentos",
    "siteDocs.upload": "Subir",
    "siteDocs.downloadFile": "Download File",
    "siteDocs.changeCategory": "Haga clic to change category",
    "rbac.enableAcl": "Enable Acceso Control",
    "rbac.disableAcl": "Disable Acceso Control",
    "rbac.title": "Acceso Control",
    "rbac.subtitle": "Control exactly what each user can see and do in LumberLinq.",
    "rbac.perUserStatus": "Per-Usuario Acceso Control is",
    "rbac.enabled": "ENABLED",
    "rbac.disabled": "DISABLED",
    "rbac.disabledDesc": "When disabled, all users have full access to everything. Enable to assign granular permissions per person.",
    "rbac.enabledDesc": "Active — permissions are enforced in real time. Revoking a permission takes effect on the user's next API call.",
    "rbac.userPermissions": "Usuario Permissions",
    "rbac.configureHint": "Haga clic the configure button to assign or revoke permissions for each user.",
    "rbac.permissions": "Permissions",
    "rbac.lastModified": "Last Modified",
    "rbac.noPermissions": "No permissions — user cannot access anything",
    "rbac.noUsers": "No non-admin users found.",
    "rbac.notActiveTitle": "Acceso Control is not active",
    "rbac.notActiveDesc": "When enabled, you can assign exactly which features each user can access.",
    "rbac.notActiveDesc2": "Existing behaviour is fully preserved until you enable this.",
    "rbac.disableFullAccess": "All users will immediately regain full access to everything.",
    "rbac.disablePreserved": "Your existing permission configurations are preserved — they will reactivate automatically if you re-enable Acceso Control.",
    "rbac.configureTooltip": "Assign / revoke permissions",
    "onboarding.welcome": "Welcome to Lumberlinq",
    "admin.packages": "Packages",
    "admin.subscriptionPackages": "Subscription Packages",
    "admin.packageListSubtitle": "Gestionar plans, pricing and feature sets visible to customers",
    "admin.totalPlans": "Total Plans",
    "admin.trialPlans": "Trial Plans",
    "admin.featured": "Featured",
    "admin.trial": "Prueba",
    "admin.mostPopular": "Most Popular",
    "admin.perMonth": "/mo",
    "admin.free": "Free",
    "admin.dayTrialSuffix": "d trial",
    "admin.features": "features",
    "admin.extendable": "Extendable",
    "admin.noPackagesYet": "No packages yet",
    "admin.createFirstSubscriptionPackage": "Crear your first subscription package to get started.",
    "admin.coupons": "Coupons",
    "admin.taxConfig": "Tax Config",
    "admin.companySupport": "Empresa Support",
    "admin.tickets": "Tickets",
    "admin.appSettings": "Configuración App",
    "admin.dashboard": "Admin Dashboard",
    "admin.newPackage": "New Paquete",
    "admin.savePackage": "Guardar Paquete",
    "admin.createPackage": "Crear Paquete",
    "admin.editPackage": "Editar Paquete",
    "admin.deactivate": "Deactivate",
    "admin.activate": "Activate",
    "admin.addFeature": "Agregar Feature",
    "admin.newCoupon": "New Coupon",
    "admin.saveCoupon": "Guardar Coupon",
    "admin.newTaxRule": "New Tax Rule",
    "admin.addFirstRule": "Agregar First Rule",
    "admin.extendSubscription": "Extend Subscription",
    "admin.extend": "Extend",
    "admin.suspend": "Suspend",
    "admin.reactivate": "Reactivate",
    "admin.printReport": "Print Informe",
    "admin.support": "Support",
    "admin.resolveAll": "Resolve All",
    "admin.closeAll": "Close All",
    "admin.assignAll": "Assign All",
    "admin.inProgress": "En curso",
    "admin.awaitingUser": "Awaiting Usuario",
    "admin.resolve": "Resolve",
    "admin.saveChanges": "Guardar Changes",
    "admin.resetFilters": "Reset filters",
    "admin.clearSelection": "Clear selection",
    "admin.openSupportDashboard": "Open Support Dashboard",
    "admin.hideFromListings": "Hide from subscription listings",
    "admin.makeVisible": "Make visible again",
    "admin.overview": "Overview",
    "admin.ticketDetails": "Ticket Detalles",
    "admin.companyContext": "Empresa Context",
    "admin.activityTrail": "Activity Trail",
    "admin.valueExtracted": "Value Extracted in This Period",
    "admin.featureUsageBreakdown": "Feature Usage Breakdown",
    "admin.salesNarrative": "Sales Narrative",
    "admin.loginTrend": "Login Trend (Weekly)",
    "admin.extendSubscriptionDialog": "Extend Subscription",
    "admin.editPackageTooltip": "Editar package details, pricing and features",
    "admin.autoGenerateKey": "Auto-generate key from name",
    "admin.inactivePackagesTooltip": "Inactive packages are hidden from the public pricing page",
    "admin.trialPackagesTooltip": "Trial packages are free and time-limited. The pricing section is hidden for trial plans.",
    "admin.removeAttachment": "Remove attachment",
    "admin.suspendAccount": "Suspend Account",
    "admin.reactivateAccount": "Reactivate Account",
    "admin.unitLabelTooltip": "Unit label shown next to the number (e.g. GB, users, tallies). Leave blank for boolean features.",
    "admin.allowTrialExtension": "Allow super-admins to extend the trial for individual companies",
    "admin.maxTrialExtensions": "Maximum number of times the trial can be extended per company",
    "admin.descriptionTooltip": "Optional rich text description. Rendered as HTML inside the plan card. Leave blank if not needed.",
    "admin.trialNoPricing": "Trial plans have no pricing",
    "admin.discountedPriceTooltip": "The discounted price customers actually pay per month in INR",
    "admin.originalPriceTooltip": "The original price shown with a strikethrough to show savings",
    "admin.discountedMonthlyUsd": "Discounted monthly price in USD",
    "admin.totalYearlyUsd": "Total yearly price at a discount in USD",
    "admin.displayOrder": "Display order on pricing card",
    "admin.editFeature": "Editar feature",
    "admin.deleteFeature": "Eliminar feature",
    "fieldAccess.resetTooltip": "Restablecer todo a los valores predeterminados",
    "fieldAccess.resetLabel": "Restablecer valores predeterminados",
    "fieldAccess.confirmResetTitle": "¿Restablecer los valores predeterminados de LumberLinq?",
    "fieldAccess.confirmResetMessage": "Esto descartará todas sus configuraciones personalizadas de acceso Público, Protegido y Privado para cada campo y restaurará la configuración predeterminada de LumberLinq. Esta acción no se puede deshacer.",
    "appUsage.planSubscription": "Plan & Subscription",
    "appUsage.title": "App Usage Informe",
    "appUsage.desc": "Live view of your feature usage vs. plan limits. Upgrade before you hit a ceiling.",
    "appUsage.failedToLoad": "Failed to load usage data.",
    "appUsage.validTill": "Valid Till",
    "appUsage.timeRemaining": "Time Remaining",
    "appUsage.nearLimit": "Near Limit",
    "appUsage.featureUsage": "Feature Usage",
    "appUsage.aiCredits": "AI Import Credits",
    "appUsage.aiCreditsOf": "of",
    "appUsage.aiCreditsPageCredits": "page credits",
    "appUsage.featureAccess": "Feature Acceso",
    "appUsage.active": "Activo",
    "appUsage.inactive": "Inactivo",
    "appUsage.expiredOn": "Venció el",
    "report.users.title": "Usuarios Informe",
    "report.users.subtitle": "All users registered under your organisation",
    "report.users.admins": "Admins",
    "report.users.role": "Rol",
    "report.users.type": "Type",
    "report.users.timezone": "Zona horaria",
    "report.users.joined": "Joined",
    "report.users.noUsersFound": "No users found",
    "tallysheet.searchProduct": "Buscar Producto",
    "tallysheet.searchLoadingSite": "Buscar un Sitio",
    "tallysheet.tuIdRequired": "Transporte ID es obligatorio.",
    "tallysheet.tuIdDuplicate": "This Transporte ID already exists.",
    "tallysheet.tuMinLength": "Minimum 5 characters.",
    "tallysheet.productRequired": "Producto es obligatorio.",
    "tallysheet.modeRequired": "Mode es obligatorio.",
    "tallysheet.containerNumRequired": "Contenedor Number es obligatorio.",
    "tallysheet.vehicleNumRequired": "Vehículo Number es obligatorio.",
    "tallysheet.driverNameRequired": "Driver Name es obligatorio.",
    "tallysheet.expectedDeliveryRequired": "Expected Delivery es obligatorio.",
    "tallysheet.expectedArrivalRequired": "Expected Arrival es obligatorio.",
    "tallysheet.expectedPickupRequired": "Expected Pickup Time es obligatorio.",
    "tallysheet.pickupLocRequired": "Pickup Ubicación es obligatorio.",
    "tallysheet.carNumRequired": "Car Number es obligatorio.",
    "menu.usersReport": "Usuarios Informe",
    "menu.inventoryReport": "Inventario Informe",
    "loadingSite.subtitle": "Ver y gestionar los perfiles de sitios existentes",
    "invReport.available": "Disponible",
    "invReport.openLots": "Lotes Abiertos (Disponible)",
    "invReport.lots": "lotes",
    "invReport.reserved": "reservado",
    "invReport.inProcessing": "En orden de aserrado",
    "invReport.inShipment": "En consignación",
    "invReport.shippedMonth": "Shipped (Mes)",
    "invReport.cbmThisMonth": "CBM this month",
    "invReport.stockByStage": "Stock by Stage",
    "invReport.movementsByType": "Movements by Type",
    "invReport.stockBySite": "Stock by Sitio",
    "invReport.movementLog": "Movement Log",
    "invReport.adjustments": "Adjustments",
    "invReport.processingRuns": "Órdenes de aserrado",
    "invReport.filterByType": "Filter by type",
    "invReport.colType": "Type",
    "invReport.colTransportUnit": "Unidad de Stock",
    "invReport.colSite": "Sitio",
    "invReport.colReference": "Reference",
    "invReport.colPartner": "Socio",
    "invReport.colDate": "Fecha",
    "invReport.colRunCode": "ID de la orden de aserrado",
    "invReport.colMillSite": "Mill Sitio",
    "invReport.colInputCbm": "Input CBM",
    "invReport.colOutputCbm": "Output CBM",
    "invReport.colLossCbm": "Loss CBM",
    "invReport.colOutturn": "Outturn %",
    "invReport.colCbmDelta": "CBM Δ",
    "invReport.colPcsDelta": "Pcs Δ",
    "invReport.colNotes": "Notes",
    "invReport.noMovements": "No movements found for the selected filters.",
    "invReport.noProcessingRuns": "No se encontraron órdenes de aserrado.",
    "invReport.adjustmentsInfo": "Adjustments are manual CBM/piece corrections applied to existing inventory registros. Showing adjustments within the selected date range.",
    "invReport.noAdjustments": "No adjustments recorded in this period.",
    "invReport.noStageData": "No stage data",
    "invReport.noMovementsRange": "No movements in range",
    "invReport.noSiteStockData": "No site stock data",
    "invReport.pendingCustomMadeTooltip": "Unidades de stock esperando una solicitud Custom-Made / re-aserrado",
    "business.activateDeactivate": "Activate / Deactivate Comercial Socio",
    "business.partnerActiveHint": "Socio is active and visible in transactions",
    "business.partnerInactiveHint": "Socio is inactive and hidden from new transactions",
    "business.contactInfo": "Contact Information",
    "business.addressSection": "Dirección",
    "business.attachments": "Attachments",
    "business.dropFiles": "Drop files here or click to browse",
    "business.saveFirst": "Guardar the partner first to attach files",
    "business.maxPerFile": "per file",
    "business.removeAccount": "Remove account",
    "business.ifscSwift": "IFSC / SWIFT",
    "business.noBankAccounts": "No bank accounts added yet. Haga clic to add one.",
    "business.backToList": "Back to list",
    "business.minCharsRequired": "Mín 2 characters required.",
    "business.validGstin": "Enter a valid GSTIN.",
    "business.taxIdMin3Chars": "El ID fiscal debe tener al menos 3 caracteres.",
    "business.gstin": "GSTIN",
    "business.quickAdd": "Agregar nuevo socio comercial",
    "business.quickAddTitle": "Nuevo Socio Comercial",
    "business.quickAddedDetail": "Socio comercial creado y seleccionado.",
    "business.quickAddError": "No se pudo crear el socio comercial. Inténtalo de nuevo.",
    "business.uploadedFiles": "Archivos Subidos",
    "business.validEmail": "Valid email required.",
    "business.countryRequired": "País es obligatorio.",
    "business.selectCountryFirst": "Seleccionar country first",
    "business.selectStateFirst": "Seleccionar state first",
    "common.max": "Máx",
    "common.min": "Mín",
    "common.company": "Empresa",
    "chart.histogram": "Histogram",
    "chart.scatter": "Scatter",
    "chart.line": "Line",
    "cookie.reject": "Rechazar No Esenciales",
    "cookie.manage": "Gestionar",
    "cookie.acceptAll": "Aceptar Todo",
    "cookie.savePreferences": "Guardar preferencias",
    "cookie.preferences": "Preferencias de Cookies y Privacidad",
    "cookie.title": "Usamos cookies 🍪",
    "cookie.desc": "Usamos cookies para mantenerle conectado y mejorar su experiencia. Las cookies analíticas requieren su consentimiento.",
    "cookie.gdprNote": "De acuerdo con GDPR, solo configuramos cookies no esenciales con su consentimiento.",
    "cookie.titleApp": "Usamos análisis 📊",
    "cookie.descApp": "Esta aplicación usa análisis para mantenerle conectado y mejorar su experiencia. El análisis requiere su consentimiento.",
    "cookie.gdprNoteApp": "De acuerdo con GDPR, solo activamos el análisis con su consentimiento explícito.",
    "cookie.privacyLink": "Política de Privacidad",
    "cookie.essential": "Esenciales (Siempre Activas)",
    "cookie.essentialDesc": "Necesarias para el inicio de sesión y seguridad. Retención: sesión + 7 días. No se pueden desactivar.",
    "cookie.alwaysOn": "Siempre Activo",
    "cookie.functional": "Funcionales",
    "cookie.functionalDesc": "Recuerdan idioma, tema y tamaño de fuente. Retención: 1 año. No se pueden desactivar.",
    "cookie.analytics": "Analíticas (Google Analytics)",
    "cookie.analyticsDesc": "Usamos Google Analytics (GA4) para entender el uso de funcionalidades. Google puede recopilar su dirección IP, ubicación aproximada (nivel ciudad) y tipo de dispositivo. Procesado por Google LLC según su Política de Privacidad. No se venden datos personales. Retención: 90 días.",
    "cookie.dataController": "Responsable del tratamiento: Rikexim Private Limited · Encargado del tratamiento: Google LLC (Google Analytics)",
    "common.termsConditions": "Terms & Conditions",
    "common.acceptContinue": "Accept & Continue",
    "tallysheet.insights": "Hoja de cubicación Insights",
    "tallysheet.totalVolume": "Total Volumen",
    "tallysheet.avgVolume": "Promedio Volumen",
    "tallysheet.activeFilter": "Active Filter",
    "tallysheet.clearFilter": "Clear Filter",
    "tallysheet.totalCft": "Total CFT",
    "tallysheet.aggregated": "Aggregated",
    "tallysheet.mainVisualization": "Main Visualization",
    "tallysheet.girthVsVolume": "Girth vs Volumen",
    "tallysheet.lengthDistribution": "Longitud Distribution",
    "tallysheet.girthHistogram": "Girth Histogram Table",
    "tallysheet.lengthHistogram": "Longitud Histogram Table",
    "tallysheet.metric": "Metric",
    "tallysheet.inProcessTooltip": "Este stock está siendo usado ahora por una orden de aserrado activa.",
    "tallysheet.notInStock": "No en Stock",
    "tallysheet.notInStockTooltip": "Esta unidad de stock aún no ha sido recibida en el inventario.",
    "tallysheet.noSummary": "No Resumen Available",
    "tallysheet.addDataForInsights": "Agregar tally data first to generate insights and visualizations.",
    "tallysheet.dynamicAnalytics": "Dynamic Analytics — Longitud · Girth · Volumen",
    "tallysheet.exploreTrends": "Explore trends across",
    "tallysheet.optimizedRecords": "optimized registros",
    "tallysheet.clickRangesToFilter": "Haga clic ranges to filter",
    "tallysheet.bins": "bins",
    "tallysheet.vehicleNumber": "Vehículo Number",
    "tallysheet.driverName": "Driver Name",
    "tallysheet.enterDriverName": "Enter Driver Name",
    "tallysheet.containerNumber": "Contenedor Number",
    "tallysheet.sealNumber": "Seal Number",
    "tallysheet.fumigationType": "Fumigation Type",
    "tallysheet.selectFumigationType": "Seleccionar tipo de fumigación",
    "fumigation.methylBromide": "Methyl Bromide Fumigation",
    "fumigation.phosphine": "Phosphine Fumigation",
    "fumigation.sulfurylFluoride": "Sulfuryl Fluoride Fumigation",
    "fumigation.ethyleneOxide": "Ethylene Oxide Fumigation",
    "fumigation.heatTreatment": "Heat Treatment",
    "fumigation.controlledAtmosphere": "Controlled Atmosphere (CA) Fumigation",
    "fumigation.vacuum": "Vacuum Fumigation",
    "fumigation.other": "Otro",
    "tallysheet.carNumber": "Car Number",
    "tallysheet.railwayLine": "Railway Line",
    "tallysheet.selectDate": "Seleccionar Fecha",
    "tallysheet.selectDateTime": "Seleccionar Fecha & Time",
    "tallysheet.expectedArrival": "Expected Arrival",
    "tallysheet.pickupLocation": "Pickup Ubicación",
    "bp.buyer": "Buyer",
    "bp.seller": "Seller",
    "bp.both": "Both",
    "bp.company": "Empresa",
    "bp.individual": "Individual",
    "bp.exporter": "Exporter",
    "bp.importer": "Importer",
    "bp.domestic": "Domestic",
    "bp.international": "International",
    "dash.domesticSale": "Domestic Sale",
    "loading-site.selectSiteType": "Seleccione el tipo de sitio",
    "recon.locked": "Reconciliation Locked",
    "recon.lockedBy": "Reconciliation locked by",
    "fieldAccess.accessControl": "Acceso Control",
    "fieldAccess.tallyTitle": "Acceso a Campos de la Unidad de Stock",
    "fieldAccess.shipmentTitle": "Consignación Field Acceso",
    "fieldAccess.searchPlaceholder": "Buscar fields…",
    "fieldAccess.pubLegend": "Cualquiera con el enlace",
    "fieldAccess.proLegend": "Solo usuarios de LumberLinq",
    "fieldAccess.priLegend": "Solo mi equipo",
    "fieldAccess.mode.PUBLIC": "Cualquiera con el enlace",
    "fieldAccess.mode.PROTECTED": "Solo usuarios de LumberLinq",
    "fieldAccess.mode.PRIVATE": "Solo mi equipo",
    "access.hint.PUBLIC": "No requiere iniciar sesión",
    "access.hint.PROTECTED": "Con sesión en LumberLinq, cualquier empresa",
    "access.hint.PRIVATE": "Solo personas de tu empresa",
    "fieldAccess.privateAlways": "Tu empresa — siempre ve todos los campos",
    "fieldAccess.hidden": "Hidden",
    "fieldAccess.view": "Ver",
    "fieldAccess.alwaysVisible": "Siempre visible",
    "fieldAccess.alwaysVisibleHint": "Esta columna siempre se muestra en los enlaces compartidos. No se puede ocultar.",
    "fieldAccess.history": "Historial",
    "fieldAccess.historyTitle": "Quién cambió qué",
    "fieldAccess.historyEmpty": "Aún no hay cambios registrados.",
    "fieldAccess.historyFailed": "No se pudo cargar el historial.",
    "fieldAccess.historyWhen": "Cuándo",
    "fieldAccess.historyWho": "Quién",
    "fieldAccess.historyField": "Campo",
    "fieldAccess.historyMode": "Tipo de enlace",
    "fieldAccess.historyChange": "Cambio",
    "fieldAccess.historyReset": "Restablecido a los valores predeterminados",
    "fieldAccess.historyNote": "Muestra los últimos 200 cambios. Los cambios hechos antes de que existiera esta lista no aparecen.",
    "fieldAccess.preview": "Vista previa como visitante",
    "fieldAccess.previewTitle": "Lo que ve un visitante",
    "fieldAccess.previewHint": "Según los ajustes de esta pantalla. Los campos tachados están ocultos para este tipo de visitante.",
    "fieldAccess.previewVisibleCount": "campos visibles",
    "fieldAccess.previewSectionOff": "Toda esta sección está desactivada.",
    "fieldAccess.presets": "Preajustes",
    "fieldAccess.presetsTitle": "Aplicar un preajuste",
    "fieldAccess.presetsLead": "Empiece desde un conjunto listo en lugar de cambiar los campos uno por uno. Verá qué cambia antes de guardar. Los campos de dinero, impuestos y auditoría, y el proveedor y el comprador, nunca los activa un preajuste.",
    "fieldAccess.presetMinimal": "Público (mínimo)",
    "fieldAccess.presetMinimalHint": "Solo estado, ruta y cantidades. Seguro para cualquiera con el enlace.",
    "fieldAccess.presetBuyer": "Comprador",
    "fieldAccess.presetBuyerHint": "Añade documentos, partes y datos de transporte que necesita un comprador.",
    "fieldAccess.presetAgent": "Agente",
    "fieldAccess.presetAgentHint": "Añade contactos, ubicaciones y datos del conteo para un agente de carga.",
    "fieldAccess.presetApplyTo": "Aplicar a",
    "fieldAccess.presetApply": "Aplicar preajuste",
    "fieldAccess.presetNoChange": "Este preajuste no cambia nada para el tipo de enlace elegido.",
    "fieldAccess.presetWillShow": "{count} campo(s) se mostrarán:",
    "fieldAccess.presetWillHide": "{count} campo(s) se ocultarán:",
    "fieldAccess.presetPublicWarning": "Cuidado: {count} campo(s) serán visibles para cualquiera con el enlace, sin iniciar sesión.",
    "fieldAccess.publicWarnTitle": "Mostrar a todos?",
    "fieldAccess.publicWarnMessage": "Cualquiera con el enlace, sin iniciar sesión, verá \"{field}\". ¿Continuar?",
    "fieldAccess.publicWarnAccept": "Sí, mostrar",
    "tallysheet.tu.hiddenDetails": "Algunos detalles no se comparten en este enlace.",
    "tallysheet.exportDownloadOff": "Exportar (descarga desactivada)",
    "tallysheet.exportDownloadOffHint": "El remitente no ha permitido descargas en este enlace.",
    "sharePack.button": "Descargar paquete",
    "sharePack.title": "Descargar paquete",
    "sharePack.lead": "Todo lo que contiene este enlace, en un solo ZIP: PDF de resumen, libro de Excel, documentos y fotos.",
    "sharePack.loading": "Comprobando el contenido…",
    "sharePack.partSummary": "PDF de resumen",
    "sharePack.partSummaryHint": "Una vista general para leer e imprimir",
    "sharePack.partWorkbook": "Libro de Excel",
    "sharePack.partWorkbookHint": "Todas las cifras, listas para filtrar",
    "sharePack.partDocuments": "Documentos",
    "sharePack.partDocumentsHint": "{count} archivo(s) · {size}",
    "sharePack.partPhotos": "Fotos",
    "sharePack.partPhotosHint": "{count} foto(s) · {size}",
    "sharePack.noneInside": "No hay nada que descargar en este enlace.",
    "sharePack.snapshotNote": "Una instantánea de hoy. Los cambios posteriores del remitente no están incluidos.",
    "sharePack.stockUnits": "{count} unidad(es) de stock",
    "sharePack.start": "Descargar",
    "sharePack.preparing": "Preparando su paquete. Un paquete grande puede tardar un minuto.",
    "sharePack.downloading": "Descargando {percent} %",
    "sharePack.done": "Su paquete se ha descargado.",
    "sharePack.failed": "No se pudo descargar el paquete.",
    "sharePack.busy": "El servidor está ocupado creando otros paquetes. Inténtelo de nuevo en un minuto.",
    "sharePack.pickOne": "Elija al menos una parte.",
    "sharePack.close": "Cerrar",
    "sharePack.reconciliationField": "Cifras de conciliación en el paquete de descarga (cargado vs recibido)",
    "fileCounts.ownTitle": "Documentos de la consignación",
    "fileCounts.ofTypes": "{have} de {total} tipos",
    "fileCounts.missing": "falta",
    "fileCounts.unitsTitle": "Unidades de stock ({count})",
    "fileCounts.photos": "fotos",
    "fileCounts.files": "archivos",
    "fileCounts.unitTitle": "Archivos de esta unidad de stock",
    "fileCounts.noFiles": "Aún no hay archivos.",
    "fileCounts.tipOwn": "{count} archivo(s) de la consignación",
    "fileCounts.tipUnits": "Unidades de stock: {photos} foto(s), {files} archivo(s)",
    "fileCounts.typeBL": "BL",
    "fileCounts.typeInvoice": "Factura",
    "fileCounts.typeCO": "Certificado de Origen",
    "fileCounts.typePhyto": "Fitosanitario",
    "fileCounts.typeEWaybill": "E-Waybill",
    "fileCounts.typeOther": "Otro",
    "fieldAccess.viewOnly": "Ver Only",
    "fieldAccess.edit": "Editar",
    "fieldAccess.editable": "Editable",
    "fieldAccess.loading": "Loading field configuration…",
    "fieldAccess.fields": "fields",
    "fieldAccess.stockUnitsNote": "Los detalles de la unidad de stock en un enlace compartido se definen en Acceso a campos de la unidad de stock, no aquí.",
    "fieldAccess.fieldColumn": "Field",
    "fieldAccess.noMatch": "No fields match your search.",
    "fieldAccess.group.transportUnit": "Unidad de Stock",
    "fieldAccess.group.roundTallyGrid": "Round Cubicación Grid",
    "fieldAccess.group.squareTallyGrid": "Square Cubicación Grid",
    "fieldAccess.group.photosSummary": "Photos & Resumen",
    "fieldAccess.group.shipmentDetails": "Consignación Detalles",
    "fieldAccess.group.documentDetails": "Documento Detalles",
    "fieldAccess.group.transportCargo": "Transporte / Cargo",
    "fieldAccess.group.financials": "Financials",
    "fieldAccess.group.parties": "Parties",
    "fieldAccess.group.systemAudit": "System / Audit",
    "fieldAccess.field.transportId": "Transporte ID",
    "fieldAccess.field.transportMode": "Transporte Mode",
    "fieldAccess.field.unitVehicleNumber": "Unit / Vehículo Number",
    "fieldAccess.field.fumigation": "Fumigation",
    "fieldAccess.field.driver": "Driver",
    "fieldAccess.field.route": "Route",
    "fieldAccess.field.contactPerson": "Contact Person",
    "fieldAccess.field.expectedDelivery": "Expected Delivery / Pickup",
    "fieldAccess.field.sr": "Sr",
    "fieldAccess.field.length": "Longitud",
    "fieldAccess.field.girth": "Girth",
    "fieldAccess.field.lengthAllowance": "Longitud Allowance",
    "fieldAccess.field.girthAllowance": "Girth Allowance",
    "fieldAccess.field.netLength": "Net Longitud",
    "fieldAccess.field.netGirth": "Net Girth",
    "fieldAccess.field.grossCbm": "Gross CBM",
    "fieldAccess.field.grossCft": "Gross CFT",
    "fieldAccess.field.netCbm": "Net CBM",
    "fieldAccess.field.netCft": "Net CFT",
    "fieldAccess.field.width": "Ancho",
    "fieldAccess.field.thickness": "Thickness",
    "fieldAccess.field.pieces": "Piezas",
    "fieldAccess.field.widthAllowance": "Ancho Allowance",
    "fieldAccess.field.thicknessAllowance": "Thickness Allowance",
    "fieldAccess.field.netWidth": "Net Ancho",
    "fieldAccess.field.netThickness": "Net Thickness",
    "fieldAccess.field.photosDocuments": "Photos / Documentos",
    "fieldAccess.field.summary": "Resumen",
    "fieldAccess.field.chartData": "Chart Data",
    "fieldAccess.field.lengthHistogram": "Longitud Histogram",
    "fieldAccess.field.girthHistogram": "Girth Histogram",
    "fieldAccess.field.sawnSquareSummary": "Sawn Square Resumen",
    "fieldAccess.field.modeOfTransportFmt": "Mode Of Transporte",
    "fieldAccess.field.portOfLoadingFmt": "Port Of Loading",
    "fieldAccess.field.portOfDischargeFmt": "Port Of Discharge",
    "fieldAccess.field.blNumberFmt": "Bl Number",
    "fieldAccess.field.blType": "Bl Type",
    "fieldAccess.field.packingListNo": "Packing Lista No",
    "fieldAccess.field.commercialInvoiceNo": "Commercial Factura No",
    "fieldAccess.field.certificateOfOrigin": "Certificate Of Origin",
    "fieldAccess.field.fumigationCertificate": "Fumigation Certificate",
    "fieldAccess.field.insuranceDetails": "Insurance Detalles",
    "fieldAccess.field.approvedBy": "Aprobado By",
    "fieldAccess.field.buyerTaxNumber": "Número fiscal del comprador",
    "fieldAccess.field.createdBy": "Created By",
    "fieldAccess.field.deliveryContact": "Delivery Contact",
    "fieldAccess.field.transporterName": "Transporter Name",
    "fieldAccess.field.vehicleOrLrNo": "Vehículo or LR No.",
    "fieldAccess.field.transportUnitNumber": "Número de Unidad de Stock",
    "fieldAccess.field.insuranceValue": "Valor del seguro",
    "fieldAccess.field.cargoType": "Cargo Type",
    "fieldAccess.field.grossWeight": "Gross Weight",
    "fieldAccess.field.netWeight": "Net Weight",
    "fieldAccess.field.transportUnits": "Unidades de Stock",
    "fieldAccess.field.freightTerms": "Términos de flete",
    "fieldAccess.field.totalInvoiceAmount": "Importe total de la factura",
    "fieldAccess.field.salesPaymentStatus": "Sales Pago Estado",
    "fieldAccess.field.purchasePaymentStatus": "Purchase Pago Estado",
    "fieldAccess.field.notifyParty": "Notify Party",
    "fieldAccess.field.exporterRefNo": "Exporter Ref No",
    "fieldAccess.field.buyerOrderNo": "Buyer Order No",
    "fieldAccess.field.countryOfOrigin": "País Of Origin",
    "fieldAccess.field.countryOfDestination": "País Of Destination",
    "fieldAccess.field.fromLocation": "From Ubicación",
    "fieldAccess.field.toLocation": "To Ubicación",
    "fieldAccess.field.remarks": "Remarks",
    "fieldAccess.field.vesselOrFlight": "Vessel Or Flight",
    "fieldAccess.field.voyageOrFlightNo": "Voyage Or Flight No",
    "fieldAccess.field.shippingLine": "Shipping Line",
    "user.member": "Member",
    "user.role": "Rol",
    "user.login": "Login",
    "user.lastActive": "Last Active",
    "user.totalMembers": "Total Members",
    "user.pendingInvites": "Pendiente Invites",
    "user.pendingInvitations": "Pendiente Invitations",
    "user.invitedBy": "Invitado por",
    "user.noTeamMembers": "No team members yet",
    "user.inviteToStart": "Haga clic Invite Usuario to get started.",
    "user.statusPending": "Pendiente",
    "user.expires": "Expires",
    "user.role.owner": "Propietario",
    "user.role.user": "Usuario",
    "user.role.fieldOperator": "Field Operator — Cubicación add & view only",
    "user.role.supervisor": "Supervisor — Cubicación + Consignaciones + Export",
    "user.role.analyst": "Analyst — Ver & export everything, no edits",
    "user.role.manager": "Manager — All features except user management",
    "user.role.custom": "Custom — No permissions (configure manually)",
    "user.selfDeleteTitle": "Eliminar Mi Cuenta",
    "user.selfDeleteSubtitle": "Elimine permanentemente su cuenta personal y todos los datos asociados.",
    "user.selfDeleteWarning": "Esta acción revocará INMEDIATAMENTE todas sus sesiones activas y eliminará permanentemente su cuenta.\n\n• Todos los datos que creó (tallies, consignaciones, unidades de stock) permanecerán en el sistema.\n• Después de 30 días, sus datos personales (nombre, correo, teléfono) serán anonimizados y no podrán recuperarse.\n• Esta acción NO se puede deshacer.",
    "user.selfDeleteEmailConfirm": "Escriba su dirección de correo electrónico para confirmar",
    "user.selfDeleteEmailPlaceholder": "Escriba su correo para confirmar",
    "user.selfDeleteButton": "Eliminar Mi Cuenta",
    "user.selfDeleteSuccess": "Su cuenta ha sido eliminada. Ha cerrado sesión.",
    "user.selfDeleteFailed": "No se pudo eliminar su cuenta. Por favor, inténtelo de nuevo.",
    "user.soleAdminWarningTitle": "Usted es el único administrador",
    "user.soleAdminWarningBody": "Eliminar su cuenta cerrará permanentemente el espacio de trabajo de su empresa. Todos los usuarios serán desconectados inmediatamente.",
    "user.soleAdminAffectedLabel": "Usuarios que perderán acceso",
    "user.soleAdminReassignHint": "Recomendado: asigne derechos de administrador a otro usuario antes de eliminar su cuenta.",
    "user.soleAdminReassignButton": "Asignar Admin primero",
    "user.soleAdminDeleteAnyway": "Eliminar de todos modos y cerrar",
    "user.soleAdminShutdownWarning": "Esto desconectará inmediatamente a todos los usuarios de la empresa.",
    "user.soleAdminShutdownSuccess": "Su cuenta ha sido eliminada. Todos los usuarios de la empresa han cerrado sesión.",
    "user.assignAdminStepTitle": "Asignar Nuevo Admin",
    "user.assignAdminSubtitle": "Seleccione un miembro del equipo para ser el nuevo administrador antes de irse.",
    "user.makeAdminBtn": "Hacer Admin",
    "user.adminAssignedSuccess": "Derechos de admin transferidos. Ahora puede eliminar su cuenta.",
    "user.continueToDelete": "Continuar para Eliminar Cuenta",
    "user.shutdownConsentLabel": "Entiendo que todos los usuarios serán desconectados inmediatamente, el espacio de trabajo será cerrado y la suscripción expirará.",
    "user.deleteAndShutdown": "Eliminar y Cerrar Empresa",
    "user.noOtherUsers": "No hay otros usuarios activos a quienes asignar derechos de admin.",
    "user.promotingAdmin": "Asignando admin…",
    "user.notificationPreferencesTitle": "Preferencias de notificación",
    "user.marketingPushOptInLabel": "Notificaciones de marketing",
    "user.marketingPushOptInDescription": "Recibe notificaciones sobre nuevas funciones y ofertas.",
    "user.dangerZoneTitle": "Zona de peligro",
    "user.dangerZoneSubtitle": "Acciones irreversibles y destructivas.",
    "shipment.shipmentType": "Consignación Type",
    "shipment.modeOfTransport": "Mode of Transporte",
    "shipment.shipmentDate": "Consignación Fecha",
    "shipment.finalDestination": "Final Destination",
    "shipment.estimatedDeparture": "Estimated Departure",
    "shipment.estimatedArrival": "Estimated Arrival",
    "shipment.partiesReferences": "Parties &amp; References",
    "shipment.documentNumbers": "Documento Numbers",
    "shipment.invoicePayments": "Factura y pagos",
    "shipment.auditStatus": "Audit &amp; Estado",
    "shipment.goodsDispatchLocal": "Goods / Dispatch (Local)",
    "shipment.shipmentTypeRequired": "Consignación Type es obligatorio",
    "shipment.modeOfTransportRequired": "Mode of Transporte es obligatorio",
    "shipment.estimatedDepartureRequired": "Estimated Departure es obligatorio",
    "shipment.otherDocuments": "Other Documentos",
    "transport.group.regularSizedCargo": "Regular Sized Cargo",
    "transport.group.reeferContainer": "Reefer Contenedor",
    "transport.group.oddSizedContainer": "Odd Sized Contenedor",
    "transport.group.truck": "Truck",
    "transport.group.trailer": "Trailer",
    "transport.group.train": "Train",
    "transport.group.other": "Otro",
    "transport.item.20DryStandard": "20 Dry Standard",
    "transport.item.40DryStandard": "40 Dry Standard",
    "transport.item.40DryHigh": "40 Dry High",
    "transport.item.45DryHigh": "45 Dry High",
    "transport.item.20Tank": "20 Tank",
    "transport.item.40Tank": "40 Tank",
    "transport.item.20ReeferStandard": "20 Reefer Standard",
    "transport.item.40ReeferHigh": "40 Reefer High",
    "transport.item.20OpenTop": "20 Open Top",
    "transport.item.40OpenTop": "40 Open Top",
    "transport.item.40OpenTopHigh": "40 Open Top High",
    "transport.item.40FlatStandard": "40 Flat Standard",
    "transport.item.40FlatHigh": "40 Flat High",
    "transport.item.20Flat": "20 Flat",
    "transport.item.smallTruck": "Small Truck",
    "transport.item.mediumTruck": "Medium Truck",
    "transport.item.largeTruck": "Large Truck",
    "transport.item.articulatedTruck": "Articulated Truck",
    "transport.item.flatbedTrailer": "Flatbed Trailer",
    "transport.item.dryVanTrailer": "Dry Van Trailer",
    "transport.item.reeferTrailer": "Reefer Trailer",
    "transport.item.lowboyTrailer": "Lowboy Trailer",
    "transport.item.tankerTrailer": "Tanker Trailer",
    "transport.item.boxcar": "Boxcar",
    "transport.item.flatcar": "Flatcar",
    "transport.item.tankCar": "Tank Car",
    "transport.item.reeferCar": "Reefer Car",
    "transport.item.hopperCar": "Hopper Car",
    "transport.item.selfPickup": "Self Pickup",
    "BOTH": "BOTH",
    "COMPANY": "COMPANY",
    "Invoice Details": "Detalles de la factura",
    "Freight Terms": "Términos de flete",
    "Payment Terms": "Términos de pago",
    "Customer Payment Terms": "Términos de pago del cliente",
    "Supplier Payment Terms": "Términos de pago del proveedor",
    "Select terms...": "Seleccione términos...",
    "Save the shipment first to record payments and payment terms.": "Guardar the consignment first to record payments and payment terms.",
    "At least one of Shipper, Consignee or Notify Party must be your company. Based on shipment type, your company may be auto-filled and locked.": "At least one of Shipper, Consignee or Notify Party must be your company. Based on consignment type, your company may be auto-filled and locked.",
    "Manage shipment details, parties, documents &amp; financials": "Gestionar consignment details, parties, documents &amp; financials",
    "Financials &amp; Payments": "Finanzas y pagos",
    "Invoice &amp; Payments": "Factura y pagos",
    "Immediate / Advance": "Inmediato / anticipo",
    "Cash on Delivery (COD)": "Pago contra entrega (COD)",
    "L/C – Sight": "L/C – a la vista",
    "L/C – Usance (days)": "L/C – plazo (días)",
    "DP – Documents against Payment (days)": "DP – documentos contra pago (días)",
    "DA – Documents against Acceptance (days)": "DA – documentos contra aceptación (días)",
    "Open Account (days)": "Cuenta abierta (días)",
    "Net 7 Days": "Neto 7 días",
    "Net 15 Days": "Neto 15 días",
    "Net 30 Days": "Neto 30 días",
    "Net 45 Days": "Neto 45 días",
    "Net 60 Days": "Neto 60 días",
    "Net 90 Days": "Neto 90 días",
    "Other (Custom)": "Otro (personalizado)",
    "Timezone": "Zona horaria",
    "Your Timezone": "Su zona horaria",
    "Select timezone": "Seleccione zona horaria",
    "Timestamps throughout the app will display in this timezone.": "Timestamps throughout the app will display in this timezone.",
    "Asia/Kolkata (IST, UTC+5:30)": "Asia/Kolkata (IST, UTC+5:30)",
    "Trial": "Prueba",
    "Trial 7 days": "Prueba de 7 días",
    "Subscription expired. Limited access": "Suscripción vencida. Acceso limitado",
    "Transaction History": "Historial de transacciones",
    "Start Date": "Fecha de inicio",
    "End Date": "Fecha de fin",
    "Transaction ID": "ID de transacción",
    "Choose Your Plan": "Elija su plan",
    "Select the plan that best fits your needs": "Seleccione el plan que mejor se adapte a sus necesidades",
    "Company Profile": "Perfil de la empresa",
    "Your Company Profile": "Perfil de su empresa",
    "Company Profile Management": "Gestión del perfil de la empresa",
    "Registering as an individual": "Registrándose como individuo",
    "Set up company identity, address, and operating profile": "Set up company identity, address, and operating profile",
    "Legal Entity Type": "Tipo de entidad legal",
    "Select Legal Entity of Company": "Seleccione la entidad legal de la empresa",
    "Private Limited": "Sociedad privada limitada",
    "Public Limited": "Sociedad anónima",
    "Partnership": "Sociedad",
    "Proprietorship": "Empresa individual",
    "Corporation (Inc)": "Corporación (Inc)",
    "LLP": "LLP",
    "LLC": "LLC",
    "Branding": "Marca",
    "Brand Identity": "Identidad de marca",
    "Use a direct image URL. The default RIK Exim logo is used when this field is empty.": "Use a direct image URL. The default RIK Exim logo is used when this field is empty.",
    "Buyer Tax Number": "Número fiscal del comprador",
    "Round Log": "Troza redonda",
    "Square / Sawn": "Cuadrada / aserrada",
    "For round, unprocessed logs. Uses the Hoppus formula: (girth ÷ 4)² × length.": "Para trozas redondas sin procesar. Usa la fórmula Hoppus: (circunferencia ÷ 4)² × longitud.",
    "For square or sawn timber. Uses volumetric formula: length × width × height.": "Para madera cuadrada o aserrada. Usa la fórmula volumétrica: longitud × ancho × alto.",
    "Formula guide": "Guía de fórmulas",
    "Tax Number": "Número fiscal",
    "Available": "Disponible",
    "In Process": "En orden de aserrado",
    "In Shipment": "En consignación",
    "Shipped": "Enviado",
    "Stock by Location": "Stock por ubicación",
    "sites": "sitios",
    "TUs": "Unidades de stock",
    "Filtered": "Filtrado",
    "At Forest": "En bosque",
    "In Transit": "En tránsito",
    "At Mill": "En aserradero",
    "At Yard": "En patio",
    "AVAILABLE": "Disponible",
    "IN_PROCESS": "En orden de aserrado",
    "PROCESSED": "Aserrado",
    "IN_SHIPMENT": "En consignación",
    "SHIPPED": "Enviado",
    "COMPLETED": "Completado",
    "Completed": "Completado",
    "ROUND": "Redondo",
    "SQUARE": "Cuadrado",
    "All": "Todos",
    "IN": "In",
    "OUT": "Out",
    "Proc IN": "Enviado al aserradero",
    "Proc OUT": "Producido por el aserradero",
    "Adjustment": "Ajuste",
    "Received": "Recibido",
    "Dispatched": "Despachado",
    "Sold": "Vendido",
    "New Processing Run": "Nueva orden de aserrado",
    "Theme": "Tema",
    "Lara Light Blue": "Lara azul claro",
    "Lara Dark Blue": "Lara azul oscuro",
    "Lara Light Indigo": "Lara índigo claro",
    "Lara Dark Indigo": "Lara índigo oscuro",
    "Bootstrap Light": "Bootstrap claro",
    "Bootstrap Dark": "Bootstrap oscuro",
    "Saga Blue": "Saga azul",
    "Vela Blue (Dark)": "Vela azul (oscuro)",
    "Material Light": "Material claro",
    "Arya Blue (Dark)": "Arya azul (oscuro)",
    "YARD": "Yard",
    "FOREST": "Bosque",
    "MILL": "Mill",
    "PORT": "Port",
    "WAREHOUSE": "Almacén",
    "common.previous": "Previous",
    "pay.secureCheckout": "Secure Checkout",
    "pay.completeSubscription": "Complete Your Subscription",
    "pay.oneStepAway": "You're one step away from unlocking full access to LumberLinq",
    "pay.stepPlanSelected": "Plan Selected",
    "pay.stepAccountSetup": "Account Setup",
    "pay.stepPayment": "Pago",
    "pay.billingDetails": "Billing Detalles",
    "pay.billingDetailsDesc": "This information will appear on your invoice",
    "pay.optional": "Optional",
    "pay.taxIdHint": "Recommended for proper tax invoicing.",
    "pay.sslNote": "Your billing information is encrypted with SSL. We never store your payment card details.",
    "pay.annual": "Annual",
    "pay.monthly": "Mensual",
    "pay.basePrice": "Base Price",
    "pay.starts": "Starts",
    "pay.ends": "Ends",
    "pay.promoCode": "Promo Code",
    "pay.applyCode": "Apply code →",
    "pay.enterCode": "Enter code",
    "pay.taxes": "Taxes",
    "pay.discountApplied": "Discount Applied",
    "pay.upgradeCreditApplied": "Crédito de Actualización",
    "pay.upgradeCreditNote": "Crédito por el tiempo no utilizado restante en tu plan actual.",
    "pay.farFutureQueueBanner": "Ya tienes cobertura activa hasta el {date}. Esta compra no comenzará hasta entonces.",
    "pay.farFutureQueueHeader": "Esto no comenzará por un tiempo",
    "pay.farFutureQueueMessage": "Ya tienes un plan activo hasta el {date}. Esta nueva compra quedará en cola para comenzar solo después de eso — no tendrá efecto ahora. ¿Continuar de todos modos?",
    "pay.farFutureQueueAccept": "Sí, poner en cola de todos modos",
    "pay.farFutureQueueReject": "No, cancelar",
    "pay.promoApplied": "¡Cupón Aplicado!",
    "pay.promoChange": "Quitar",
    "pay.promoEnterFirst": "Por favor, introduce un código de cupón.",
    "pay.promoGenericError": "Este código no es válido. Verifícalo e inténtalo de nuevo.",
    "pay.promoErr.notFound": "No encontramos este código. Verifícalo e inténtalo de nuevo.",
    "pay.promoErr.notStarted": "Este código aún no está activo.",
    "pay.promoErr.expired": "Este código ha caducado.",
    "pay.promoErr.usedUp": "Este código alcanzó su límite de uso y ya no se puede usar.",
    "pay.promoErr.currency": "Este código no es válido para la moneda seleccionada.",
    "pay.promoErr.period": "Este código no es válido para el período de facturación seleccionado.",
    "pay.promoErr.inrOnly": "Este código solo es válido para facturación en INR.",
    "pay.promoErr.alreadyUsed": "Tu empresa ya usó este código.",
    "pay.promoErr.ownCode": "No puedes usar un código de referido que pertenece a tu propia empresa.",
    "pay.amountPayable": "Importe Pagable",
    "pay.autoRenewal": "Renovación Automática",
    "pay.autoRenewalHint": "Renovar automáticamente al final del período de facturación",
    "pay.autoRenewalRequiredMonthly": "Obligatorio para planes mensuales — cancela en cualquier momento desde la página de suscripciones",
    "pay.autoRenewalUsdNotSupported": "La renovación automática solo está disponible para facturación en INR",
    "pay.autoRenewalCouponDisabled": "Descuento único aplicado — renovación automática desactivada. Actívala después del pago desde tu página de suscripción al precio completo.",
    "pay.autoRenewalLifetimeCoupon": "Descuento de por vida: la renovación automática continuará a este precio con descuento",
    "pay.iHaveReadAccept": "He leído y acepto los",
    "pay.tncError": "You must accept the Terms & Conditions to proceed.",
    "pay.sslSecured": "SSL Secured",
    "pay.encrypted": "Encrypted",
    "pay.tncFooterNote": "Clicking \"Accept\" also checks the agreement checkbox.",
    "pay.orderSummary": "Order Resumen",
    "pay.yr": "yr",
    "pay.mo": "mo",
    "tour.next": "Next →",
    "tour.prev": "← Back",
    "tour.done": "Done ✓",
    "tour.progress": "{{current}} of {{total}}",
    "tour.header.welcome.title": "Welcome to LumberLinq!",
    "tour.header.welcome.desc": "Let's take a quick tour of the key features. You can <strong>dismiss</strong> this at any time by clicking the × button.",
    "tour.header.menu.title": "Navigation Menu",
    "tour.header.menu.desc": "Haga clic here to <strong>open or collapse</strong> the sidebar navigation.",
    "tour.header.logo.title": "LumberLinq Logo",
    "tour.header.logo.desc": "Haga clic the logo to <strong>return to the Dashboard</strong> from anywhere.",
    "tour.header.language.title": "Idioma",
    "tour.header.language.desc": "Switch the app language between <strong>English, Hindi, and Portuguese</strong>.",
    "tour.header.fontSize.title": "Font Size",
    "tour.header.fontSize.desc": "Adjust the <strong>text size</strong> to your comfort level.",
    "tour.header.theme.title": "Tema",
    "tour.header.theme.desc": "Pick a <strong>colour theme</strong> that suits your preference.",
    "tour.header.darkMode.title": "Modo oscuro",
    "tour.header.darkMode.desc": "Toggle between <strong>Light and Dark</strong> display modes.",
    "tour.header.profile.title": "Your Perfil",
    "tour.header.profile.desc": "Acceso your <strong>account settings, subscription, and logout</strong> from here.",
    "tour.header.help.title": "Help & Support",
    "tour.header.help.desc": "Find <strong>guides, FAQs, and support tickets</strong> whenever you need help. That's all — enjoy LumberLinq!",
    "tour.shipments.header.title": "Consignaciones",
    "tour.shipments.header.desc": "Gestionar all your <strong>export consignments</strong> from this page.",
    "tour.shipments.new.title": "New Consignación",
    "tour.shipments.new.desc": "Haga clic here to <strong>create a new consignment</strong> and start adding stock units.",
    "tour.shipments.filter.title": "Filter & Buscar",
    "tour.shipments.filter.desc": "Use these filters to <strong>search consignments</strong> by date, status, or business partner.",
    "tour.shipments.table.title": "Consignaciones Table",
    "tour.shipments.table.desc": "Each row is a consignment. Haga clic a row to <strong>view details, tally sheets, and documents</strong>.",
    "tour.shipments.delete.title": "Eliminar Consignación",
    "tour.shipments.delete.desc": "Use the delete action carefully — <strong>removed consignments cannot be recovered</strong>.",
    "tour.tally.header.title": "Cubicación Sheet",
    "tour.tally.header.desc": "Record and manage <strong>log measurements</strong> for this stock unit.",
    "tour.tally.settings.title": "Cubicación Configuración",
    "tour.tally.settings.desc": "Configure <strong>formula, unit, and measurement defaults</strong> for this tally.",
    "tour.tally.grid.title": "Entry Grid",
    "tour.tally.grid.desc": "Enter each log's <strong>girth, length, and quantity</strong> directly in the grid. Totals update automatically.",
    "tour.tally.export.title": "Exportar",
    "tour.tally.export.desc": "Export the tally as a <strong>PDF or Excel file</strong> for sharing or registros.",
    "tour.tally.save.title": "Guardar Cubicación",
    "tour.tally.save.desc": "Haga clic Guardar to <strong>submit the tally</strong> data to the consignment.",
    "tour.reports.header.title": "Informes",
    "tour.reports.header.desc": "Generate detailed <strong>business and tally reports</strong> from this section.",
    "tour.reports.filter.title": "Informe Filters",
    "tour.reports.filter.desc": "Set the <strong>date range, business partner, and consignment</strong> to narrow the report.",
    "tour.reports.generate.title": "Generate Informe",
    "tour.reports.generate.desc": "Haga clic Generate to <strong>build the report</strong> with your selected filters.",
    "tour.reports.export.title": "Export Informe",
    "tour.reports.export.desc": "Download the report as <strong>PDF or Excel</strong> for offline use.",
    "tour.bp.header.title": "Socios comerciales",
    "tour.bp.header.desc": "Gestionar your <strong>buyers and sellers</strong> from this page.",
    "tour.bp.new.title": "Agregar Socio",
    "tour.bp.new.desc": "Haga clic here to <strong>add a new buyer or seller</strong> to your directory.",
    "tour.bp.stats.title": "Socio Stats",
    "tour.bp.stats.desc": "A quick overview of <strong>total buyers and sellers</strong> in your account.",
    "tour.bp.filter.title": "Filter Socios",
    "tour.bp.filter.desc": "Buscar or filter partners by <strong>name, type, or country</strong>.",
    "tour.bp.table.title": "Socios Table",
    "tour.bp.table.desc": "Haga clic a partner row to <strong>edit details or view their consignment history</strong>.",
    "tour.products.header.title": "Productos",
    "tour.products.header.desc": "Define the <strong>timber products</strong> used in your tally sheets.",
    "tour.products.new.title": "Agregar Producto",
    "tour.products.new.desc": "Haga clic here to <strong>create a new timber product</strong> with its formula and unit.",
    "tour.products.stats.title": "Producto Stats",
    "tour.products.stats.desc": "See the <strong>total number of products</strong> configured in your account.",
    "tour.products.table.title": "Productos Table",
    "tour.products.table.desc": "Haga clic a product row to <strong>edit its name, formula, or default unit</strong>.",
    "tour.loadingSite.header.title": "Sitios",
    "tour.loadingSite.header.desc": "Rastree todas las <strong>ubicaciones de bosque, patio, aserradero y puerto</strong> desde aquí.",
    "tour.loadingSite.new.title": "Agregar Sitio",
    "tour.loadingSite.new.desc": "Haga clic aquí para <strong>registrar un nuevo sitio</strong> en su cuenta.",
    "tour.loadingSite.stats.title": "Estadísticas de Sitios",
    "tour.loadingSite.stats.desc": "Un resumen del <strong>total de sitios</strong> por tipo.",
    "tour.loadingSite.table.title": "Tabla de Sitios",
    "tour.loadingSite.table.desc": "Haga clic en una fila para <strong>editar su nombre, tipo y ubicación</strong>.",
    "tour.users.header.title": "Usuarios",
    "tour.users.header.desc": "Gestionar all <strong>team members</strong> who have access to your LumberLinq account.",
    "tour.users.add.title": "Invite Usuario",
    "tour.users.add.desc": "Haga clic here to <strong>invite a new team member</strong> by email.",
    "tour.users.stats.title": "Usuario Stats",
    "tour.users.stats.desc": "See how many <strong>active users and available seats</strong> your plan allows.",
    "tour.users.table.title": "Usuarios Table",
    "tour.users.table.desc": "Gestionar roles and permissions — click a user row to <strong>edit or deactivate</strong>.",
    "tour.dashboardV7.header.title": "El pulso de tu negocio",
    "tour.dashboardV7.header.desc": "Tu <strong>panel</strong> — elige un rango de fechas y actualiza aquí para ver cifras en vivo de toda tu operación.",
    "tour.dashboardV7.pulse.title": "Pulso del negocio",
    "tour.dashboardV7.pulse.desc": "Tarjetas rápidas de <strong>KPI</strong> para socios, envíos, unidades de stock, volumen y piezas — haz clic en cualquier tarjeta para ir directo a esa lista.",
    "tour.dashboardV7.financial.title": "Salud financiera",
    "tour.dashboardV7.financial.desc": "Sigue <strong>ingresos, saldos pendientes y antigüedad</strong> de un vistazo.",
    "tour.dashboardV7.inventory.title": "Resumen de inventario",
    "tour.dashboardV7.inventory.desc": "Una vista en vivo de los <strong>niveles de stock en todas tus sedes</strong> — haz clic en 'Inventario completo' para el panorama completo.",
    "tour.dashboardV7.recon.title": "Conciliación",
    "tour.dashboardV7.recon.desc": "Mira cuánto de tus datos de tally está <strong>conciliado con los envíos</strong>, y actúa para corregir cualquier brecha.",
    "tour.dashboardV7.charts.title": "Tendencias y gráficos",
    "tour.dashboardV7.charts.desc": "Visualiza <strong>tendencias de volumen y productos principales</strong> en el rango de fechas seleccionado.",
    "tour.dashboardV7.activity.title": "Actividad reciente",
    "tour.dashboardV7.activity.desc": "Un registro de auditoría de <strong>cambios recientes de cuenta y permisos</strong> en tu equipo.",
    "tour.inventoryOverview.header.title": "Resumen de Inventario",
    "tour.inventoryOverview.header.desc": "Una vista en vivo de <strong>dónde está tu stock ahora mismo</strong> — en Bosque, en Tránsito, en Aserradero, en orden de aserrado, en Patio o en Consignación.",
    "tour.inventoryOverview.actions.title": "Stock inicial y orden de aserrado",
    "tour.inventoryOverview.actions.desc": "Las acciones principales: <strong>agregar tu stock inicial (el que ya tienes) o iniciar una orden de aserrado</strong>. Las entregas nuevas llegan por su unidad de stock (entrada) y se reciben en un lote.",
    "tour.inventoryOverview.lots.title": "Lotes de Stock Abiertos",
    "tour.inventoryOverview.lots.desc": "Cada <strong>lote abierto</strong> actualmente en el sistema — haz clic en un lote para ver su historial completo de movimientos y cadena.",
    "tour.inventoryInOut.header.title": "Libro de Movimientos de Stock",
    "tour.inventoryInOut.header.desc": "Cada <strong>movimiento de stock</strong> registrado hasta ahora. Usa Agregar Ajuste para corregir una discrepancia, o Exportar para una copia en hoja de cálculo.",
    "tour.inventoryInOut.filter.title": "Filtrar por Tipo y Fecha",
    "tour.inventoryInOut.filter.desc": "Limita el libro a un <strong>tipo de movimiento</strong> (Entrada, Salida, Ajuste, y más) o a un <strong>rango de fechas</strong>.",
    "tour.inventoryInOut.table.title": "Libro de Movimientos",
    "tour.inventoryInOut.table.desc": "Cada fila es un <strong>evento de movimiento</strong> — toca un código para ver la unidad de stock, lote, orden de aserrado o consignación detrás.",
    "tour.inventoryProcessing.header.title": "Órdenes de aserrado",
    "tour.inventoryProcessing.header.desc": "Aquí ocurren las <strong>órdenes de aserrado</strong>, incluido Custom-Made / Re-aserrado — inicia una nueva orden para convertir stock de un lote en un nuevo lote.",
    "tour.inventoryProcessing.stats.title": "Rendimiento de las órdenes de aserrado",
    "tour.inventoryProcessing.stats.desc": "Total de órdenes de aserrado, <strong>rendimiento promedio</strong>, y volumen total aserrado — una verificación rápida de la eficiencia de tu aserradero.",
    "tour.inventoryProcessing.table.title": "Órdenes de aserrado",
    "tour.inventoryProcessing.table.desc": "Cada orden de aserrado, su <strong>estado</strong> y su entrada/salida — haz clic en una fila para ver todos los detalles, incluido el pedido que la originó.",
    "tour.inventoryOperators.header.title": "Operadores del Aserradero",
    "tour.inventoryOperators.header.desc": "Gestiona a los <strong>operadores</strong> que trabajan en las órdenes de aserrado — agrega un nuevo operador aquí.",
    "tour.inventoryOperators.stats.title": "Resumen del Equipo",
    "tour.inventoryOperators.stats.desc": "Total de operadores y <strong>operadores activos</strong> de un vistazo.",
    "tour.inventoryOperators.search.title": "Buscar y Filtrar",
    "tour.inventoryOperators.search.desc": "Encuentra un operador por <strong>nombre, código de empleado, o correo</strong>, o filtra por especialidad y estado activo.",
    "tour.rbacSettings.toggle.title": "Control de Acceso Basado en Roles",
    "tour.rbacSettings.toggle.desc": "Activa <strong>RBAC</strong> para darle a cada miembro del equipo solo el acceso que necesita, en lugar de que todos vean todo.",
    "tour.rbacSettings.tabs.title": "Usuarios y Roles",
    "tour.rbacSettings.tabs.desc": "Gestiona el acceso de dos formas: por usuario (<strong>Permisos de Usuario</strong>) o asignando un <strong>Rol</strong> reutilizable.",
    "tour.rbacSettings.usersTable.title": "Permisos de Usuario",
    "tour.rbacSettings.usersTable.desc": "Cada miembro del equipo y cuánto del sistema puede acceder — haz clic en <strong>Configurar</strong> en una fila para ajustarlo.",
    "tour.rbacSettings.rolesTab.title": "Roles de Acceso",
    "tour.rbacSettings.rolesTab.desc": "Crea un <strong>rol reutilizable</strong> (como 'Contador' o 'Supervisor de Patio') una vez, y luego asígnalo a cualquier cantidad de usuarios.",
    "tour.subscriptionManagement.accordion.title": "Suscríbete en 4 Pasos",
    "tour.subscriptionManagement.accordion.desc": "Elige un plan, revísalo, agrega los datos de facturación y luego paga — cada paso <strong>desbloquea el siguiente</strong> al completarse.",
    "tour.subscriptionManagement.packageSelect.title": "1. Seleccionar Paquete",
    "tour.subscriptionManagement.packageSelect.desc": "Elige el <strong>plan y ciclo de facturación</strong> que se ajusta a tu negocio.",
    "tour.subscriptionManagement.billing.title": "3. Datos de Facturación",
    "tour.subscriptionManagement.billing.desc": "Ingresa los <strong>datos de tu empresa e información fiscal</strong> para la factura.",
    "tour.subscriptionManagement.pay.title": "4. Evaluar Pedido y Pagar",
    "tour.subscriptionManagement.pay.desc": "Revisa el <strong>total final</strong>, aplica un código promocional si tienes uno, y completa el pago.",
    "ticket.supportTitle": "Tickets de soporte",
    "ticket.subtitle": "Raise a request, track progress, and get help from our team.",
    "ticket.newTicket": "New Ticket",
    "ticket.searchPlaceholder": "Buscar by subject, ticket number or category…",
    "ticket.filter": "Filter:",
    "ticket.replies": "replies",
    "ticket.lastActivity": "Last activity",
    "ticket.noTickets": "No tickets yet",
    "ticket.noTicketsHint": "Haven't raised a support request? We're here to help.",
    "ticket.raiseFirst": "Raise First Ticket",
    "ticket.submitted": "Ticket Submitted!",
    "ticket.submitReceived": "Your support request has been received.",
    "ticket.respondTime": "Our team will respond within 24 hours.",
    "ticket.yourId": "Your Ticket ID",
    "ticket.viewTicket": "Ver Ticket",
    "ticket.allTickets": "All Tickets",
    "ticket.raiseTitle": "Raise a Support Ticket",
    "ticket.raiseHint": "Describe your issue and we will get back to you promptly.",
    "ticket.subject": "Subject",
    "ticket.subjectPlaceholder": "Briefly describe your issue",
    "ticket.subjectRequired": "Subject es obligatorio.",
    "ticket.maxChars": "Máx 255 characters.",
    "ticket.selectCategory": "Seleccionar category",
    "ticket.categoryRequired": "Category es obligatorio.",
    "ticket.descriptionPlaceholder": "Provide as much detail as possible — steps to reproduce, error messages, screenshots context, etc.",
    "ticket.descriptionRequired": "Descripción es obligatorio.",
    "ticket.submitTicket": "Submit Ticket",
    "ticket.priority": "Prioridad",
    "ticket.resolved": "Resuelto",
    "ticket.closed": "Cerrado",
    "ticket.howDidWeDo": "How did we do?",
    "ticket.csatPrompt": "Your ticket has been resolved. Rate your support experience:",
    "ticket.optionalComment": "Optional comment…",
    "ticket.submitRating": "Submit Rating",
    "ticket.yourRating": "Your rating:",
    "ticket.replyPlaceholder": "Type your reply here…",
    "ticket.attachFile": "Attach file",
    "ticket.sendReply": "Send Reply",
    "ticket.ticketClosed": "This ticket is closed. Please open a new ticket if you need further assistance.",
    "ticket.status.all": "Todos",
    "ticket.status.open": "Abierto",
    "ticket.status.inProgress": "En curso",
    "ticket.status.awaitingReply": "Awaiting My Reply",
    "ticket.status.resolved": "Resuelto",
    "ticket.status.closed": "Cerrado",
    "ticket.priority.low": "Baja",
    "ticket.priority.medium": "Media",
    "ticket.priority.high": "Alta",
    "ticket.priority.critical": "Crítica",
    "ticket.priority.low.desc": "Low — general question",
    "ticket.priority.medium.desc": "Medium — non-urgent issue",
    "ticket.priority.high.desc": "High — affecting my work",
    "ticket.priority.critical.desc": "Critical — system down / data loss",
    "ticket.category.billing": "Facturación y pagos",
    "ticket.category.technical": "Problema técnico",
    "ticket.category.account": "Cuenta y acceso",
    "ticket.category.featureRequest": "Solicitud de función",
    "ticket.category.subscription": "Suscripción",
    "ticket.category.dataRecovery": "Recuperación de datos",
    "ticket.category.other": "Otro",
    "ticket.csat.1": "Very Unhappy",
    "ticket.csat.2": "Unhappy",
    "ticket.csat.3": "Neutral",
    "ticket.csat.4": "Happy",
    "ticket.csat.5": "Very Happy",
    // -- AI Chat
    "ai.chat.title": "Asistente IA de LumberLinq",
    "ai.chat.placeholder": "Pregunta sobre LumberLinq…",
    "ai.chat.footerNote": "Respuestas basadas en nuestra Base de Conocimientos",
    "ai.chat.send": "Enviar",
    "ai.chat.newChat": "Nueva conversación",
    "ai.chat.thinking": "Pensando…",
    "ai.chat.sources": "Fuentes",
    "ai.chat.noSessions": "Sin conversaciones anteriores",
    "ai.chat.deleteSession": "Eliminar conversación",
    "ai.chat.emailTranscript": "Enviar transcripción por correo",
    "ai.chat.feedback.good": "Útil",
    "ai.chat.feedback.bad": "No útil",
    "ai.chat.attachFile": "Adjuntar archivo",
    "ai.chat.disclaimer": "Las respuestas de IA se basan en nuestra base de conocimientos y pueden no ser siempre totalmente precisas. Verifica siempre la información importante.",
    "ai.chat.modeAuto": "Auto",
    "ai.chat.titleAuto": "Linc AI",
    "ai.chat.autoSub": "Pregunta lo que quieras · Linc elige la respuesta correcta",
    "ai.chat.autoPlaceholder": "Pregunta cómo hacer algo, o por tu stock y tus pagos…",
    "ai.chat.autoGreeting": "Hola, soy Linc AI 👋",
    "ai.chat.autoTitle": "Un solo lugar para todas las preguntas",
    "ai.chat.autoDesc": "Pregunta cómo hacer algo en LumberLinq, o consulta tu propio stock, consignaciones y pagos. Elijo la mejor forma de responder y solo muestro lo que tu cuenta puede ver.",
    "ai.chat.goToScreen": "Ir a la pantalla",
    "ai.chat.dataPartFailed": "Pude responder a la parte de \"cómo hacerlo\" de tu pregunta, pero la parte con datos en vivo no se pudo responder ahora.",
    "ai.chat.starter.createConsignment": "Crear una consignación",
    "ai.chat.starter.inviteTeam": "Invitar a un miembro del equipo",
    "ai.chat.starter.shareTally": "Compartir una hoja de recuento",
    "ai.chat.starter.stockNow": "Stock actual",
    "ai.chat.starter.toPay": "Pagos pendientes",
    "ai.chat.starterQ.createConsignment": "¿Cómo creo una nueva Consignación?",
    "ai.chat.starterQ.inviteTeam": "¿Cómo invito a un miembro del equipo?",
    "ai.chat.starterQ.shareTally": "¿Cómo comparto una hoja de tally con un comprador?",
    "ai.chat.starterQ.stockNow": "¿Cuánto stock tenemos ahora?",
    "ai.chat.starterQ.toPay": "¿Qué queda pendiente de pago este mes?",
    "ai.chat.starterQ.myAccess": "¿Qué puedo hacer con mi cuenta?",
    "ai.chat.starterQ.shipmentsMonth": "¿Cuántos envíos este mes?",
    "ai.chat.starterQ.profitMargin": "¿Cuál es nuestro margen de beneficio este trimestre?",
    "ai.chat.starterQ.machines": "¿Qué máquinas están funcionando ahora?",
    "ai.chat.starterQ.health": "¿Cómo va nuestro negocio en general?",
    "ai.chat.starter.myAccess": "¿Qué puedo hacer?",
    "lincPreview.button": "Lo que Linc muestra a esta persona",
    "lincPreview.title": "Lo que Linc muestra a esta persona",
    "lincPreview.intro": "Esto es lo que Linc (el asistente de IA) puede decirle a esta persona, según su acceso y el plan de la empresa. No se envía nada a la IA para mostrarlo.",
    "lincPreview.modulesAssumed": "Has iniciado sesión como personal de la plataforma, así que aquí no se comprueban los interruptores de módulo (Inventory, Mill Jobs, Linc Data).",
    "lincPreview.why.plan": "{items} no está incluido en el plan actual de esta empresa (la empresa tendría que mejorar el plan o añadirlo)",
    "lincPreview.why.permission": "esta cuenta no tiene acceso a {items} (un administrador del equipo puede concedérselo desde Manage Roles)",
    "lincPreview.why.also": "; además, ",
    "lincPreview.why.and": " y ",
    "lincPreview.why.dataPlan": "Linc Data no está activado en el plan de esta empresa (la empresa tendría que añadirlo o mejorar el plan)",
    "lincPreview.why.dataRight": "esta cuenta no tiene derecho a usar Linc Data (un administrador del equipo puede concedérselo desde Manage Roles)",
    "lincPreview.tileAreas": "Áreas",
    "lincPreview.tileQuestions": "Preguntas de datos en vivo",
    "lincPreview.tileSections": "Notas de ayuda",
    "lincPreview.tileAnswers": "Respuestas listas",
    "lincPreview.areasTitle": "Áreas de la aplicación",
    "lincPreview.questionsTitle": "Preguntas de datos en vivo (Linc Data)",
    "lincPreview.notesTitle": "Notas de ayuda",
    "lincPreview.allowed": "Permitido",
    "lincPreview.notAllowed": "No permitido",
    "lincPreview.withheld": "retenidas",
    "lincPreview.showWithheld": "Mostrar secciones retenidas",
    "lincPreview.error": "No se pudo cargar la vista previa. Inténtalo de nuevo.",
    "lincPreview.close": "Cerrar",
    // -- Round Tally Summary (premium redesign)
    "tallySummaryRound.title": "Resumen del Romaneo Redondo",
    "tallySummaryRound.subtitle": "Volumen, cantidad de piezas e información de distribución para este lote de trozas redondas",
    "tallySummaryRound.piecesAnalyzed": "piezas analizadas",
    "tallySummaryRound.histogram": "Histograma",
    "tallySummaryRound.bubble": "Burbujas",
    "tallySummaryRound.line": "Línea",
    "tallySummaryRound.mainVisualization": "Visualización Principal",
    "tallySummaryRound.girthVsVolume": "Circunferencia vs Volumen",
    "tallySummaryRound.lengthDistribution": "Distribución de Longitud",
    "tallySummaryRound.bubbleTitle": "Circunferencia x Longitud x Volumen",
    "tallySummaryRound.activeFilterLabel": "Filtro Activo",
    "tallySummaryRound.clearFilter": "Borrar Filtro",
    "tallySummaryRound.spotlightPiece": "Destacando pieza #",
    "tallySummaryRound.kpiTotalPieces": "Total de Piezas",
    "tallySummaryRound.kpiTotalNetCbm": "Total CBM Neto",
    "tallySummaryRound.kpiTotalNetCft": "Total CFT Neto",
    "tallySummaryRound.kpiAuthoritative": "Total oficial del lote",
    "tallySummaryRound.distributionTitle": "Distribución por Pieza",
    "tallySummaryRound.avgVolume": "Volumen Promedio / Pieza",
    "tallySummaryRound.minVolume": "Pieza Más Pequeña",
    "tallySummaryRound.maxVolume": "Pieza Más Grande",
    "tallySummaryRound.outlierWatchTitle": "Calidad de Datos - Monitor de Anomalías",
    "tallySummaryRound.outlierCleanLot": "Lote limpio - no se detectaron anomalías de medición",
    "tallySummaryRound.outlierFlaggedCount": "pieza(s) marcada(s) para revisión",
    "tallySummaryRound.outlierFreePercent": "Sin anomalías",
    "tallySummaryRound.outlierExpand": "Ver piezas marcadas",
    "tallySummaryRound.outlierCollapse": "Ocultar piezas marcadas",
    "tallySummaryRound.outlierColRow": "Fila #",
    "tallySummaryRound.outlierColGirth": "Circunferencia",
    "tallySummaryRound.outlierColLength": "Longitud",
    "tallySummaryRound.outlierColVolume": "Volumen",
    "tallySummaryRound.outlierColDeviation": "Desviación",
    "tallySummaryRound.outlierSeverityMild": "Leve",
    "tallySummaryRound.outlierSeverityExtreme": "Extremo",
    "tallySummaryRound.outlierNotEnoughData": "No hay suficientes piezas para evaluar anomalías (mínimo 8 requerido)",
    "tallySummaryRound.outlierAboveRange": "por encima del rango esperado",
    "tallySummaryRound.outlierBelowRange": "por debajo del rango esperado",
    "tallySummaryRound.rowPositionHint": "Posición de entrada en la hoja de romaneo, no es un ID permanente",
    "tallySummaryRound.girthHistogramTitle": "Distribución de Circunferencia",
    "tallySummaryRound.girthHistogramDesc": "Piezas agrupadas en bandas de circunferencia de 5 cm",
    "tallySummaryRound.lengthHistogramTitle": "Tabla de Distribución de Longitud",
    "tallySummaryRound.lengthHistogramDesc": "Piezas agrupadas por longitud ingresada",
    "tallySummaryRound.metric": "Métrica",
    "tallySummaryRound.noDataTitle": "No Hay Resumen Disponible",
    "tallySummaryRound.noDataDesc": "Agregue datos de romaneo primero para generar información y visualizaciones.",
    "tallySummaryRound.lotSnapshot": "Instantánea del Lote",
    "tallySummaryRound.kpiAvgCft": "CFT Promedio / Pieza",
    "tallySummaryRound.distributionHelp": "Volumen neto promedio, más pequeño y más grande (CBM) por troza individual en la vista actual.",
    "tallySummaryRound.outlierHelp": "Marca trozas cuyo volumen es estadísticamente inusual comparado con el resto de este lote - una forma rápida de detectar entradas mal medidas o mal escritas antes de finalizar o compartir este romaneo.",
    "tallySummaryRound.axisGirth": "Circunferencia (cm)",
    "tallySummaryRound.axisLength": "Longitud (cm)",
    "tallySummaryRound.axisPieces": "Piezas",
    "tallySummaryRound.axisVolume": "Volumen (m³)",
    "tallySummaryRound.rowAverage": "Promedio",
    "tallySummaryRound.rowSmallest": "Más Pequeña",
    "tallySummaryRound.rowLargest": "Más Grande",
    "tallySummaryRound.colVolume": "Volumen",
    "tallySummaryRound.colGirth": "Circunferencia",
    "tallySummaryRound.colLength": "Longitud",
    "tallySummaryRound.normalGirthRange": "Rango Normal de Circunferencia",
    "tallySummaryRound.normalLengthRange": "Rango Normal de Longitud",
    "tallySummaryRound.dimGirthAbnormal": "Circunferencia anormal",
    "tallySummaryRound.dimLengthAbnormal": "Longitud anormal",
    "tallySummaryRound.dimBothAbnormal": "Circunferencia y Longitud anormales",
    "tallySummaryRound.girthVsVolumeHelp": "Muestra cómo el volumen de cada troza se relaciona con su circunferencia - una circunferencia mayor generalmente significa más volumen, pero la longitud también influye.",
    "tallySummaryRound.holdTitle": "Qué trozas concentran su volumen",
    "tallySummaryRound.holdSubLogs": "Las más grandes primero · parte de {total} CBM",
    "tallySummaryRound.holdSubBands": "Rangos de circunferencia, los más grandes primero · parte de {total} CBM",
    "tallySummaryRound.holdInsightOne": "Su troza más grande concentra el {pct}% del volumen del lote.",
    "tallySummaryRound.holdInsightMany": "Sus {n} trozas más grandes concentran el {pct}% del volumen del lote.",
    "tallySummaryRound.holdInsightBand": "Las trozas de {band} cm de circunferencia concentran el {pct}% del volumen.",
    "tallySummaryRound.holdRow": "Fila {n}",
    "tallySummaryRound.holdMeta": "{girth} cm de circunferencia · {length} cm de largo",
    "tallySummaryRound.holdBandMeta": "{n} trozas",
    "tallySummaryRound.holdShowAll": "Mostrar todas ({n})",
    "tallySummaryRound.holdShowLess": "Mostrar menos",
    "tallySummaryRound.emptyHidden": "{n} vacías ocultas · Mostrar",
    "tallySummaryRound.emptyHide": "Ocultar vacías",
    "tallySummaryRound.holdInsightTop": "Su {k}% de trozas más grandes concentra el {pct}% del volumen.",
    "tallySummaryRound.holdTopLogs": "Trozas individuales más grandes",
    "tallySummaryRound.holdTabBands": "Por rango",
    "tallySummaryRound.holdTabLogs": "Trozas más grandes",
    "tallySummaryRound.holdBandMetaOne": "{n} troza",
    "emailVerification.linkValidHours": "Enlace válido por 24 horas",
    "emailVerification.resendButton": "Reenviar Email de Verificación",
    "emailVerification.alreadyVerifiedPill": "Email ya verificado — por favor continúa",
    "emailVerification.nowVerifiedGoToLogin": "¡Tu email está verificado! Inicia sesión para continuar.",
    "emailVerification.stillNotVerified": "Aún no verificado — revisa tu email y haz clic en el enlace primero.",
    "emailVerification.resendCountdown": "Reenvío disponible en {{seconds}}s",
    "emailVerification.attemptsRemaining": "{{count}} de 3 intentos de reenvío restantes",
    "emailVerification.maxAttemptsReached": "Se alcanzó el número máximo de intentos de reenvío. Por favor contacte a soporte.",
    "emailVerification.emailInputPlaceholder": "Ingrese su dirección de correo electrónico",
    "emailVerification.emailInputHint": "Ingrese el correo que usó para registrarse y así reenviar el enlace de verificación.",
    "emailVerification.toastSuccessSummary": "Email Enviado",
    "emailVerification.toastErrorSummary": "Error al Reenviar",
    "emailVerification.refreshErrorSummary": "No se pudo comprobar",
    "emailVerification.refreshErrorBody": "No pudimos comprobar el estado de tu correo ahora. Inténtalo de nuevo en un momento.",
    "login.securityCheckRetry": "Reintentar verificación de seguridad",
    "login.securityCheckStuck": "Está tardando más de lo habitual — toca reintentar abajo",
    "login.securityCheckExpired": "Verificación caducada — toca actualizar para continuar",
    "login.securityCheckErrored": "No se pudo cargar la verificación de seguridad — reintenta",
    "login.signInCancelledSummary": "Inicio de sesión cancelado",
    "login.signInCancelledDetail": "Parece que el inicio de sesión no se completó. Inténtalo de nuevo cuando estés listo.",
    "tallyStatusBar.row": "fila",
    "tallyStatusBar.rows": "filas",
    "tallyStatusBar.piecesUnit": "pzs",
    "tallyStatusBar.updated": "actualizada(s)",
    "tallyStatusBar.removed": "eliminada(s)",
    "tallyStatusBar.totalRowsTooltip": "Total de filas",
    "tallyStatusBar.totalPiecesTooltip": "Total de piezas",
    "tallyStatusBar.availableNowTooltip": "Disponible ahora",
    "tallyStatusBar.afterThisSave": "Restante:",
    "tallyStatusBar.grossCbmTooltip": "CBM bruto",
    "tallyStatusBar.grossCbmUnit": "CBM bruto",
    "tallyStatusBar.grossCftUnit": "CFT bruto",
    "tallyStatusBar.grossCftTooltip": "CFT bruto",
    "tallyStatusBar.netCbmUnit": "CBM neto",
    "tallyStatusBar.netCftUnit": "CFT neto",
    "tallyStatusBar.netCbmTooltip": "CBM neto (tras tolerancias)",
    "tallyStatusBar.netCftTooltip": "CFT neto (tras tolerancias)",
    "tallyStatusBar.avgCftTooltip": "CFT promedio por tronco",
    "tallyStatusBar.unsavedChangesTooltip": "filas con cambios sin guardar",
    "tallyStatusBar.unsavedUnit": "sin guardar",
    "tallyStatusBar.allChangesSavedTooltip": "Todos los cambios guardados",
    "tallyStatusBar.allSaved": "Todo guardado",
    "tallyStatusBar.savedPrefix": "Guardado —",
    "tallyStatusBar.deletedPrefix": "Eliminado —",
    "tallyStatusBar.unsavedPressSave": "sin guardar — pulsa Guardar",
    "tallyStatusBar.lastSaved": "Guardado por última vez",
    "tallyStatusBar.hideVoiceControls": "Ocultar controles de voz",
    "tallyStatusBar.showVoiceControls": "Mostrar controles de voz",
    "tallyStatusBar.addRow": "Agregar fila",
    "tallyStatusBar.deleteSelected": "Eliminar seleccionados",
    "tallyStatusBar.saveCtrlS": "Guardar (Ctrl+S)",
    "tallyStatusBar.saveTimeout": "Guardar está tardando demasiado — verifica tu conexión",
    "tallyStatusBar.saveFailed": "Error al guardar — inténtalo de nuevo",
    "tallyStatusBar.deletingRows": "Eliminando filas...",
    "tallyStatusBar.deleteFailed": "Error al eliminar — inténtalo de nuevo",
    "tallyStatusBar.fixHighlightedCells": "Corrige las celdas resaltadas antes de guardar",
    "tallyStatusBar.noModifiedRows": "No hay filas modificadas",
    "tallyStatusBar.saveMsg1": "Guardando tus cambios",
    "tallyStatusBar.saveMsg2": "Procesando los números",
    "tallyStatusBar.saveMsg3": "Sincronizando con el servidor",
    "tallyStatusBar.saveMsg4": "Casi listo",
    "tallyStatusBar.saveMsg5": "Todavía trabajando en ello",
    "tallyStatusBar.saveMsg6": "Un momento, casi termina",
    "tallyStatusBar.saveMsg7": "Finalizando tus datos",
    "tallyStatusBar.saveMsg8": "Solo un momento más",
    "subscriptionPackage.cancelAutoRenewalFailedTitle": "No se pudo cancelar la renovación automática",
    "subscriptionPackage.cancelAutoRenewalFailedMessage": "No se pudo cancelar tu suscripción de renovación automática actual. Inténtalo de nuevo o contacta con soporte.",
    "subscriptionPackage.saveErrorTitle": "Algo salió mal",
    "subscriptionPackage.saveErrorMessage": "No pudimos guardar tu selección. Inténtalo de nuevo.",
    "subscriptionPackage.cta.selected": "{name} seleccionado",
    "subscriptionPackage.cta.startTrial": "Prueba gratuita de {days} días",
    "subscriptionPackage.cta.choose": "Elegir {name}",
    "subscriptionPackage.trialNote": "Prueba gratuita de {days} días incluida",
    "appSettings.title": "Configuración de la aplicación",
    "appSettings.subtitle": "Administre la configuración general de su empresa",
    "appSettings.nav.paymentReminders": "Recordatorios de pago",
    "paymentReminders.title": "Recordatorios de pago",
    "paymentReminders.subtitle": "Recuerde automáticamente los pagos a sus socios comerciales y reciba un informe diario",
    "paymentReminders.enable": "Activar recordatorios de pago",
    "paymentReminders.daysBefore": "Empezar a recordar",
    "paymentReminders.daysBefore.suffix": "días antes del vencimiento",
    "paymentReminders.sendTime": "Hora de envío",
    "paymentReminders.timezone": "Zona horaria",
    "paymentReminders.externalReminders": "Recordar a los socios comerciales por correo electrónico",
    "paymentReminders.externalReminders.desc": "Envía un recordatorio de pago al comprador o vendedor de sus envíos y eventos comerciales",
    "paymentReminders.adminReport": "Enviarme un informe diario",
    "paymentReminders.adminReport.desc": "Un resumen de todo lo vencido o atrasado, con un PDF adjunto",
    "paymentReminders.channelEmail": "Correo electrónico",
    "paymentReminders.channelPush": "Notificación push",
    "paymentReminders.timeline.title": "Cronología de recordatorios",
    "paymentReminders.timeline.desc": "Vista previa de en qué días se envía un recordatorio, hasta la fecha de vencimiento",
    "paymentReminders.timeline.due": "Vencimiento",
    "paymentReminders.timeline.overdue": "Atrasado (diario)",
    "paymentReminders.recipients.title": "¿Quién recibe el informe?",
    "paymentReminders.recipients.desc": "Cualquier persona con acceso a Salud Financiera recibe el informe diario. Otorgue este acceso a más personas en",
    "paymentReminders.recipients.link": "Control de acceso",
    "paymentReminders.save": "Guardar cambios",
    "paymentReminders.saved": "Configuración de recordatorios de pago guardada",
    "paymentReminders.saveError": "No se pudo guardar esta configuración. Inténtelo de nuevo.",
    "appSettings.nav.currency": "Moneda",
    "appSettings.nav.inventoryPolicy": "Política de inventario",
    "appSettings.nav.branding": "Marca",
    "appSettings.nav.tallyDefaults": "Valores Predeterminados de Tally",
    "tallyDefaults.subtitle": "Unidades de medida, tolerancias y reglas de validación predeterminadas con las que empiezan las nuevas Unidades de Stock — anúlalas por Unidad de Stock en cualquier momento.",
    "tallyDefaults.square": "Cuadrado",
    "tallyDefaults.round": "Redondo",
    "tallyDefaults.unitOfMeasure": "Unidad de Medida",
    "tallyDefaults.widthUom": "UdM de Ancho",
    "tallyDefaults.thickUom": "UdM de Espesor",
    "tallyDefaults.lengthUom": "UdM de Longitud",
    "tallyDefaults.girthUom": "UdM de Circunferencia",
    "tallyDefaults.decimals": "Decimales",
    "tallyDefaults.mode": "Modo de Entrada",
    "tallyDefaults.allowances": "Tolerancias",
    "tallyDefaults.widthAllowance": "Tolerancia de Ancho",
    "tallyDefaults.thickAllowance": "Tolerancia de Espesor",
    "tallyDefaults.lengthAllowance": "Tolerancia de Longitud",
    "tallyDefaults.girthAllowance": "Tolerancia de Circunferencia",
    "tallyDefaults.lengthAdjustments": "Ajustes de Longitud",
    "tallyDefaults.copyPrevLength": "Copiar Longitud Anterior",
    "tallyDefaults.addToLength": "Agregar a la Longitud",
    "tallyDefaults.addToLengthValue": "Valor a Agregar a la Longitud",
    "tallyDefaults.validationRules": "Reglas de Validación",
    "tallyDefaults.divisibleBy5": "Divisible entre 5",
    "tallyDefaults.girthRange": "Rango de Circunferencia",
    "tallyDefaults.lengthRange": "Rango de Longitud",
    "tallyDefaults.min": "Mín",
    "tallyDefaults.max": "Máx",
    "tallyDefaults.quickSearch": "Búsqueda Rápida",
    "tallyDefaults.toleranceHint": "Cuánto puede desviarse una búsqueda de tamaño simple del número escrito y aun así contar como coincidencia — la madera real rara vez mide exactamente el tamaño nominal.",
    "tallyDefaults.searchToleranceSquare": "Tolerancia de Búsqueda — Cuadrado",
    "tallyDefaults.searchToleranceRound": "Tolerancia de Búsqueda — Redondo",
    "tallyDefaults.resetTitle": "¿Restablecer los Valores Predeterminados de Tally?",
    "tallyDefaults.resetBody": "Esto restablece todos los valores predeterminados de esta página a sus valores originales. Las Unidades de Stock que ya tienen su propia configuración guardada no se ven afectadas.",
    "appSettings.resetAll": "Restablecer todo",
    "appSettings.resetAllTitle": "Restablecer todas las configuraciones",
    "appSettings.resetAllBody": "Esto restablece los Recordatorios de pago, la Moneda, la Política de inventario y la Marca (si está disponible) a sus valores predeterminados. Esto no se puede deshacer.",
    "common.resetToDefault": "Restablecer",
    "account.language.label": "Idioma",
    "account.language.hint": "Este es el idioma que verá en LumberLinq, en cualquier dispositivo.",
    "currency.subtitle": "Establezca la moneda en la que se muestran sus informes y paneles.",
    "currency.resetTitle": "Restablecer moneda",
    "currency.resetBody": "Esto restablece su moneda de informes a no definida. Esto no se puede deshacer.",
    "inventoryPolicy.subtitle": "Política de stock de toda la empresa — se aplica a todos los usuarios.",
    "inventoryPolicy.allowOversell": "Permitir que las ventas continúen más allá del stock disponible",
    "inventoryPolicy.allowOversell.hint": "Desactivado de forma predeterminada — una venta se bloquea cuando usaría más de lo que realmente hay en stock.",
    "inventoryPolicy.detailedTracking": "Rastrear de qué compra proviene la madera de una orden de aserrado",
    "inventoryPolicy.detailedTracking.hint": "Desactivado de forma predeterminada — actívelo para ver y ajustar a qué compra se atribuye el stock de un Lote agrupado al ser aserrado.",
    "inventoryPolicy.resetTitle": "Restablecer política de inventario",
    "inventoryPolicy.resetBody": "Esto restaura ambos interruptores a sus valores predeterminados. Esto no se puede deshacer.",
    "company.manageBranding": "Administrar marca",
    "company.manageBrandingHint": "Suba o configure el logotipo de su empresa en Configuración de la aplicación.",
    "company.signpost.text": "¿Busca Moneda, Política de inventario, Recordatorios de pago o Marca?",
    "company.signpost.link": "Configuración de la aplicación",
    "branding.lockedTitle": "La marca personalizada es una función del plan Forest",
    "branding.lockedBody": "Suba el logotipo de su propia empresa en la aplicación, exportaciones y correos electrónicos con el plan Forest.",
    "branding.upgradeCta": "Actualizar a Forest",
    "branding.chooseFile": "Elegir archivo",
    "branding.dimensionHint": "PNG, JPG o WEBP, idealmente de unos 584×158px (el mismo tamaño que el logotipo de LumberLinq) — mínimo 200×50px, menos de 5 MB.",
    "branding.resetTitle": "Restablecer logotipo",
    "branding.resetBody": "Esto elimina su logotipo personalizado y muestra nuevamente el logotipo predeterminado de LumberLinq. Esto no se puede deshacer.",
    "paymentReminders.resetTitle": "Restablecer recordatorios de pago",
    "paymentReminders.resetBody": "Esto restaura todas las configuraciones de recordatorios de pago a sus valores predeterminados. Esto no se puede deshacer.",
    "notifPrefs.sectionTitle": "Categorías de notificaciones push",
    "sessions.title": "Dónde Has Iniciado Sesión",
    "sessions.subtitle": "Estos dispositivos tienen la sesión iniciada en tu cuenta. Cierra la sesión de los que no reconozcas o ya no uses.",
    "sessions.thisDevice": "Este dispositivo",
    "sessions.onlineNow": "En línea ahora",
    "sessions.unknownDevice": "Dispositivo desconocido",
    "sessions.slotWeb": "Navegador",
    "sessions.slotApp": "App",
    "sessions.signOut": "Cerrar sesión",
    "sessions.signOutOthers": "Cerrar sesión en todos los demás dispositivos",
    "sessions.cancel": "Cancelar",
    "sessions.confirmHeader": "¿Cerrar sesión en este dispositivo?",
    "sessions.confirmMessage": "Se cerrará la sesión de {device} y tendrá que iniciar sesión de nuevo.",
    "sessions.confirmOthersHeader": "¿Cerrar sesión en todos los demás dispositivos?",
    "sessions.confirmOthersMessage": "Se cerrará la sesión de todos los dispositivos excepto este y tendrán que iniciar sesión de nuevo.",
    "sessions.signedOutToast": "Se cerró la sesión del dispositivo.",
    "sessions.signedOutOthersToast": "Se cerró la sesión de todos los demás dispositivos.",
    "sessions.signOutFailed": "No se pudo cerrar la sesión del dispositivo. Inténtalo de nuevo.",
    "sessions.loadFailed": "No se pudieron cargar tus dispositivos.",
    "sessions.retry": "Reintentar",
    "sessions.empty": "No se encontraron dispositivos.",
    "notifPrefs.sectionHint": "Desactive una categoría si no quiere que avise en su teléfono o navegador — de todos modos la seguirá viendo en su campana de notificaciones.",
    "pushPrompt.title": "¿Activar notificaciones?",
    "pushPrompt.body": "Entérate al instante cuando cambie el estado de un envío, alguien comparta un tally contigo, o tu equipo envíe una invitación.",
    "pushPrompt.enable": "Activar",
    "pushPrompt.notNow": "Ahora no",
    "appFeedback.menu": "Dar opinión",
    "appFeedback.title": "Dar opinión",
    "appFeedback.subtitle": "Cuéntanos cómo te está funcionando LumberLinq",
    "appFeedback.question": "¿Cómo te está funcionando LumberLinq?",
    "appFeedback.rate.sad": "No está bien",
    "appFeedback.rate.neutral": "Regular",
    "appFeedback.rate.happy": "Bien",
    "appFeedback.rate.love": "Me encanta",
    "appFeedback.likeLabel": "¿Qué es lo que más te gusta?",
    "appFeedback.improveLabel": "¿Qué deberíamos mejorar?",
    "appFeedback.privateNote": "Solo el equipo de LumberLinq ve esto.",
    "appFeedback.showSection": "En nuestro sitio web",
    "appFeedback.showName": "Mostrar mi nombre en el sitio web de LumberLinq",
    "appFeedback.showNameHint": "Se muestra como nombre + inicial, p. ej. \"Sanjay B.\", tras la aprobación de nuestro equipo.",
    "appFeedback.showCompany": "Mostrar también el nombre de mi empresa",
    "appFeedback.showCompanyHint": "Desactivado a menos que lo actives.",
    "appFeedback.send": "Enviar opinión",
    "appFeedback.back": "Volver",
    "appFeedback.thanksTitle": "¡Gracias!",
    "appFeedback.thanksBody": "Tu opinión ha llegado a nuestro equipo.",
    "appFeedback.error": "No se pudo enviar tu opinión. Inténtalo de nuevo.",
    "appFeedback.promptTitle": "¿Cómo te está funcionando LumberLinq?",
    "appFeedback.promptBody": "Un toque — nos ayuda a mejorarlo.",
    "appFeedback.notNow": "Ahora no",
    "appFeedback.done": "Listo",
    "appFeedback.chooseRating": "Primero elige cómo te sientes",
    "adminFeedback.title": "Revisión de opiniones",
    "pay.offlineOr": "o",
    "pay.offlineProofLabel": "Comprobante de pago (opcional)",
    "pay.offlineProofChoose": "Elegir foto o PDF",
    "pay.offlineProofHint": "Una captura de la transferencia o una foto del cheque nos ayuda a confirmar más rápido. JPG, PNG, WEBP, HEIC o PDF, hasta 8 MB.",
    "pay.offlineProofAttach": "Adjuntar comprobante",
    "pay.offlineProofReplace": "Reemplazar comprobante",
    "pay.offlineProofSavedTitle": "Comprobante guardado",
    "pay.offlineProofSavedBody": "Lo veremos al revisar su pago.",
    "pay.offlineProofError": "Su pago está guardado, pero no se pudo subir el comprobante. Inténtelo de nuevo desde la tarjeta de espera.",
    "pay.offlineProofBadTypeTitle": "Archivo no permitido",
    "pay.offlineProofBadType": "Elija una foto (JPG, PNG, WEBP, HEIC) o un PDF.",
    "pay.offlineProofTooBigTitle": "Archivo demasiado grande",
    "pay.offlineProofTooBig": "El archivo debe pesar 8 MB o menos.",
    "adminOffline.viewProof": "Ver comprobante",
    "adminOffline.noProof": "Sin comprobante",
    "adminOffline.proofTitle": "Comprobante de pago",
    "adminOffline.proofHint": "Esto es lo que el cliente dice haber pagado. Confirme siempre el dinero en su extracto bancario antes de aprobar.",
    "adminOffline.extra": "Excedente",
    "adminOffline.overWarn": "Más del importe adeudado. Excedente",
    "pay.offlineTurnOffAuto": "Desactive la renovación automática arriba para pagar por transferencia o cheque.",
    "pay.offlineNotForMonthly": "Los planes mensuales se renuevan automáticamente, por lo que no hay transferencia ni cheque. Elija un plan más largo.",
    "pay.offlineButton": "Pagar por transferencia bancaria / cheque (INR)",
    "pay.offlineWaitingTitle": "Su pago está esperando confirmación",
    "pay.offlineWaitingBody": "Revisamos el banco y activamos su plan. Recibirá un mensaje en cuanto esté listo.",
    "pay.offlineTitle": "Pagar por transferencia bancaria / cheque",
    "pay.offlineAmountToPay": "Importe a pagar",
    "pay.offlineAmountHint": "Incluye GST y el descuento del cupón. Pague exactamente este importe.",
    "pay.offlineAccountName": "Nombre de la cuenta",
    "pay.offlineBank": "Banco",
    "pay.offlineAccountNumber": "Número de cuenta",
    "pay.offlineBranch": "Sucursal",
    "pay.offlineChequeTo": "Cheque a nombre de",
    "pay.offlineChequeAddress": "Enviar el cheque a",
    "pay.offlineRemarks": "Escriba en observaciones",
    "pay.offlineRemarksHint": "Escriba esta referencia en las observaciones del pago (o al dorso del cheque) para que podamos encontrar su pago.",
    "pay.offlineIPaid": "Ya pagué — ingrese los detalles",
    "pay.offlineHowPaid": "¿Cómo pagó?",
    "pay.offlineUtr": "Número UTR de la transferencia",
    "pay.offlineChequeNo": "Número de cheque",
    "pay.offlineRefError": "Ingrese el número UTR / cheque (mínimo 4 caracteres).",
    "pay.offlineTransferDate": "Fecha de la transferencia",
    "pay.offlineChequeDate": "Fecha del cheque",
    "pay.offlineYourBank": "Su banco (opcional)",
    "pay.offlineNote": "Nota para nosotros (opcional)",
    "pay.offlineGstHint": "Su factura GST se envía cuando se confirme el pago.",
    "pay.offlineCancel": "Cancelar",
    "pay.offlineSubmit": "Enviar detalles del pago",
    "pay.offlineSentTitle": "Detalles recibidos",
    "pay.offlineSentBody": "Confirmaremos su pago y activaremos su plan. Recibirá un mensaje.",
    "pay.offlineLoadError": "No se pudieron cargar los datos bancarios. Inténtelo de nuevo.",
    "pay.offlineSubmitError": "No pudimos guardar los detalles. No se cobró nada — inténtelo de nuevo.",
    "adminOffline.title": "Pagos offline",
    "lincLearning.title": "Aprendizaje de Linc",
    "lincLearning.subtitle": "Preguntas que el Asistente respondió mal y cambios de reglas pendientes de su aprobación",
    "lincLearning.tabFindings": "Preguntas fallidas",
    "lincLearning.tabProposals": "Propuestas",
    "lincLearning.tabRuleBook": "Libro de reglas",
    "lincLearning.grade.OK": "Correcta",
    "lincLearning.grade.PART": "Parcial",
    "lincLearning.grade.WRONG": "Incorrecta",
    "lincLearning.grade.NONE": "Sin respuesta",
    "lincLearning.allGrades": "Todos los resultados",
    "lincLearning.allRuns": "Todas las verificaciones",
    "lincLearning.handledAll": "Tratadas o no",
    "lincLearning.handledYes": "Tratadas",
    "lincLearning.handledNo": "Pendientes",
    "lincLearning.search": "Buscar pregunta o grupo",
    "lincLearning.colQuestion": "Pregunta",
    "lincLearning.colAnswer": "Respuesta dada",
    "lincLearning.colTrue": "Respuesta correcta",
    "lincLearning.colNote": "Nota",
    "lincLearning.markHandled": "Marcar como tratada",
    "lincLearning.unmark": "Marcar como pendiente",
    "lincLearning.prev": "Anterior",
    "lincLearning.next": "Siguiente",
    "lincLearning.page": "Página",
    "lincLearning.empty": "Nada aquí.",
    "lincLearning.kind.WORD": "Palabra del oficio",
    "lincLearning.kind.ASK_BACK": "Preguntar de vuelta",
    "lincLearning.kind.DEFINITION": "Definición",
    "lincLearning.kind.NEW_DATA": "Se necesitan datos nuevos",
    "lincLearning.kind.OTHER": "Otro",
    "lincLearning.status.PROPOSED": "En espera",
    "lincLearning.status.APPROVED": "Aprobada",
    "lincLearning.status.REJECTED": "Rechazada",
    "lincLearning.approve": "Aprobar",
    "lincLearning.reject": "Rechazar",
    "lincLearning.undo": "Volver a espera",
    "lincLearning.noteHint": "Nota (opcional)",
    "lincLearning.reviewNow": "Ejecutar la revisión ahora",
    "lincLearning.reviewNote": "La revisión también se ejecuta sola cada dos días.",
    "lincLearning.addWord": "Agregar palabra del oficio",
    "lincLearning.word": "Palabra (por ejemplo silly)",
    "lincLearning.means": "Qué significa",
    "lincLearning.add": "Agregar",
    "lincLearning.evidence": "Preguntas detrás de esto",
    "lincLearning.seen": "veces preguntado",
    "lincLearning.companies": "empresas",
    "lincLearning.source": "Origen",
    "lincLearning.decidedBy": "Decidido por",
    "lincLearning.termsTitle": "Palabras del oficio que conoce el Asistente",
    "lincLearning.defsTitle": "Definiciones escritas",
    "lincLearning.rulebookNote": "El libro de reglas integrado solo cambia con una versión del software. Las palabras aprobadas se suman y valen de inmediato.",
    "lincLearning.done": "Guardado",
    "lincLearning.failed": "No se pudo completar",
    "adminOffline.subtitle": "Confirme las transferencias y cheques pagados por los clientes",
    "adminOffline.waiting": "en espera",
    "adminOffline.bankDetails": "Datos bancarios",
    "adminOffline.refresh": "Actualizar",
    "adminOffline.noAccessTitle": "Sin acceso",
    "adminOffline.noAccessBody": "Solo los aprobadores de pagos pueden abrir esta página.",
    "adminOffline.search": "Buscar empresa, UTR, correo",
    "adminOffline.tabWaiting": "En espera",
    "adminOffline.tabApproved": "Aprobado",
    "adminOffline.tabRejected": "Rechazado",
    "adminOffline.tabReversed": "Revertido",
    "offlineHist.bannerTitle": "Su pago está esperando confirmación",
    "offlineHist.bannerBody": "Su plan comienza en cuanto se confirme, y le enviaremos un correo.",
    "offlineHist.viewDetails": "Detalles",
    "offlineHist.withdraw": "Retirar",
    "offlineHist.withdrawTitle": "¿Retirar este pago?",
    "offlineHist.withdrawConfirm": "Úselo si escribió un UTR o número de cheque incorrecto, o pagó de otra forma. El pago no se confirmará y podrá enviarlo de nuevo.",
    "offlineHist.withdrawYes": "Sí, retirar",
    "offlineHist.withdrawNo": "Conservar",
    "offlineHist.withdrawnTitle": "Pago retirado",
    "offlineHist.withdrawnBody": "Puede enviar de nuevo los datos del pago o pagar en línea.",
    "offlineHist.withdrawError": "No se pudo retirar el pago. Inténtelo de nuevo.",
    "offlineHist.title": "Pagos por transferencia bancaria y cheque",
    "offlineHist.subtitle": "Pagos informados para su empresa",
    "offlineHist.submitted": "Enviado el",
    "offlineHist.reason": "Motivo",
    "offlineHist.statusWaiting": "Esperando confirmación",
    "offlineHist.statusConfirmed": "Confirmado",
    "offlineHist.statusRejected": "No confirmado",
    "offlineHist.statusReversed": "Revertido",
    "offlineHist.statusWithdrawn": "Retirado",
    "offlineHist.buyBlocked": "Un pago por transferencia / cheque está esperando confirmación. Podrá elegir otro plan cuando se confirme, no se confirme o se retire.",
    "adminOffline.tabWithdrawn": "Retirados",
    "adminOffline.otherPlanWarn": "Esta empresa ya obtuvo otro plan activo después de enviar este pago:",
    "adminOffline.otherPlanConfirm": "Lo revisé y aun así quiero aprobar (se añadirá un segundo plan)",
    "adminOffline.colCompany": "Empresa",
    "adminOffline.colPayment": "Pago",
    "adminOffline.colAmount": "Importe",
    "adminOffline.colPlan": "Plan",
    "adminOffline.colStatus": "Estado",
    "adminOffline.colSubmitted": "Enviado",
    "adminOffline.received": "Recibido",
    "adminOffline.shortBy": "Faltante",
    "adminOffline.approve": "Aprobar",
    "adminOffline.reject": "Rechazar",
    "adminOffline.reverse": "Revertir",
    "adminOffline.cancel": "Cancelar",
    "adminOffline.save": "Guardar",
    "adminOffline.emptyTitle": "Nada aquí",
    "adminOffline.emptyBody": "Los pagos enviados por transferencia o cheque aparecerán aquí.",
    "adminOffline.approveTitle": "Aprobar pago",
    "adminOffline.dateOnPayment": "Fecha",
    "adminOffline.amountDue": "Importe adeudado",
    "adminOffline.checkStatement": "Revise primero el extracto bancario. Apruebe solo cuando el dinero haya llegado al banco.",
    "adminOffline.receivedAmount": "Importe recibido en el banco",
    "adminOffline.shortWarn": "Menos del importe adeudado. Faltan",
    "adminOffline.acceptShort": "Aceptar el pago parcial (por ejemplo, impuesto retenido en origen)",
    "adminOffline.note": "Nota",
    "adminOffline.approvedOk": "Pago aprobado. El plan está activo.",
    "adminOffline.rejectTitle": "Rechazar pago",
    "adminOffline.rejectReason": "Motivo",
    "adminOffline.rejectHint": "El cliente verá este motivo.",
    "adminOffline.rejectedOk": "Pago rechazado. Se informó al cliente.",
    "adminOffline.reverseTitle": "Revertir pago (cheque rechazado / reembolso)",
    "adminOffline.chooseOption": "Elija qué pasa con el plan",
    "adminOffline.optDeactivate": "Desactivar el plan ahora",
    "adminOffline.optDeactivateSub": "La empresa pierde el plan de pago de inmediato.",
    "adminOffline.optGrace": "Dar un periodo de gracia",
    "adminOffline.optGraceSub": "El plan sigue activo 7, 15 o 30 días más y luego termina.",
    "adminOffline.optKeep": "Mantener el plan activo",
    "adminOffline.optKeepSub": "Solo registra la reversión. Usted lo resuelve con el cliente.",
    "adminOffline.optRefund": "Reembolsar y desactivar",
    "adminOffline.optRefundSub": "Registre el reembolso pagado y termine el plan ahora.",
    "adminOffline.graceDays": "Periodo de gracia (días)",
    "adminOffline.refundAmount": "Importe del reembolso",
    "adminOffline.refundRef": "Referencia bancaria del reembolso",
    "adminOffline.creditNoteNo": "Número de nota de crédito (opcional)",
    "adminOffline.creditNoteHint": "La aplicación no crea notas de crédito. Ingrese el número cuando su equipo financiero la emita.",
    "adminOffline.commissionWarn": "La comisión de afiliado no se revierte automáticamente. Revísela a mano.",
    "adminOffline.reversedOk": "Pago revertido. Se informó al cliente.",
    "adminOffline.optionOn": "Ofrecer esta opción a los clientes",
    "adminOffline.optionOnHint": "Los clientes la ven en la página de pago de los planes INR, cuando estén completos los campos obligatorios.",
    "adminOffline.accountName": "Nombre de la cuenta",
    "adminOffline.bank": "Banco",
    "adminOffline.accountNumber": "Número de cuenta",
    "adminOffline.branch": "Sucursal",
    "adminOffline.chequePayableTo": "Cheque a nombre de",
    "adminOffline.chequeAddress": "Dirección para enviar cheques",
    "adminOffline.instructions": "Instrucciones adicionales para clientes",
    "adminOffline.lastUpdated": "Último cambio por",
    "adminOffline.settingsSaved": "Datos bancarios guardados",
    "adminOffline.errorTitle": "No se pudo completar",
    "adminOffline.errorGeneric": "Algo salió mal. Inténtelo de nuevo.",
    "adminFeedback.subtitle": "Aprueba las opiniones antes de que aparezcan en lumberlinq.com",
    "adminFeedback.pending": "Pendientes",
    "adminFeedback.approved": "Aprobadas",
    "adminFeedback.rejected": "Rechazadas",
    "adminFeedback.approve": "Aprobar",
    "adminFeedback.reject": "Rechazar",
    "adminFeedback.reset": "Volver a Pendiente",
    "adminFeedback.colPerson": "Persona",
    "adminFeedback.colRating": "Valoración",
    "adminFeedback.colFeedback": "Opinión",
    "adminFeedback.colWebsite": "En el sitio web",
    "adminFeedback.colSource": "Origen",
    "adminFeedback.colDate": "Fecha",
    "adminFeedback.sourcePublic": "Formulario del sitio web",
    "adminFeedback.sourceApp": "En la app",
    "adminFeedback.willShowAs": "Se mostrará como",
    "adminFeedback.notOptedIn": "Nombre no mostrado (sin permiso)",
    "adminFeedback.noName": "Sin nombre",
    "adminFeedback.emptyTitle": "Aún no hay nada aquí",
    "adminFeedback.emptyBody": "No hay opiniones en esta lista.",
    "adminFeedback.liked": "Le gustó",
    "adminFeedback.problem": "Problema (privado)",
    "adminFeedback.search": "Buscar nombre, empresa o texto",
    "adminFeedback.statusChanged": "Opinión actualizada",
    "adminFeedback.loadError": "No se pudieron cargar las opiniones",
    "adminFeedback.withCompany": "con empresa",
    "adminFeedback.refresh": "Actualizar",
    "appSettings.feedbackSection": "Opiniones y valoraciones en tiendas",
    "appSettings.feedbackPromptEnabled": "Pedir opinión a los usuarios en la app",
    "appSettings.feedbackPromptHint": "Muestra una pequeña tarjeta \"¿Cómo te está funcionando LumberLinq?\" en el Panel. Las respuestas van a Revisión de opiniones, nunca a las tiendas.",
    "appSettings.feedbackPromptAfterDays": "Preguntar después de (días desde el registro)",
    "appSettings.feedbackPromptRepeatDays": "No volver a preguntar durante (días)",
    "appSettings.storeReviewEnabled": "Pedir valoración en App Store / Play Store",
    "appSettings.storeReviewHint": "Usa la ventana de valoración propia de Apple y Google en iPhone y Android. Se activa solo por uso — nunca vinculada a la tarjeta de opinión.",
    "appSettings.storeReviewAfterTallies": "Después de esta cantidad de hojas de conteo",
    "appSettings.storeReviewAfterDays": "O después de (días desde el registro)",
    "notifPrefs.pushStatusTitle": "Notificaciones Push",
    "notifPrefs.pushGrantedHint": "Las notificaciones push están activadas para este dispositivo.",
    "notifPrefs.pushPromptHint": "Active las notificaciones para recibir alertas en este dispositivo.",
    "notifPrefs.pushDeniedNativeHint": "Las notificaciones están desactivadas para este dispositivo.",
    "notifPrefs.pushDeniedWebHint": "Las notificaciones están bloqueadas para este sitio — actívelas en la configuración de su navegador.",
    "notifPrefs.pushUnsupportedHint": "Este dispositivo o navegador no admite notificaciones push.",
    "notifPrefs.pushEnableButton": "Activar",
    "notifPrefs.openSettingsButton": "Abrir configuración",
    "notifPrefs.teamInvites": "Invitaciones de equipo",
    "notifPrefs.teamInvites.hint": "Cuando alguien lo invita a un equipo, o su invitación es aceptada o rechazada.",
    "notifPrefs.security": "Alertas de seguridad",
    "notifPrefs.security.hint": "Avisos de inicio de sesión y seguridad de la cuenta. Las alertas críticas, como un cambio de contraseña, siempre se envían sin importar esta configuración.",
    "notifPrefs.billing": "Facturación y pagos",
    "notifPrefs.billing.hint": "Renovaciones de suscripción, recordatorios de pago, facturas y novedades de pagos por transferencia / cheque.",
    "notifPrefs.shipments": "Envíos",
    "notifPrefs.shipments.hint": "Actualizaciones sobre sus envíos y remesas.",
    "notifPrefs.tally": "Hojas de tally",
    "notifPrefs.tally.hint": "Actualizaciones sobre las hojas de tally en las que está trabajando.",
    "notifPrefs.inventoryProcess": "Inventario y órdenes de aserrado",
    "notifPrefs.inventoryProcess.hint": "Movimientos de stock y actualizaciones de órdenes de aserrado.",
    "notifPrefs.masterData": "Productos, socios y ubicaciones",
    "notifPrefs.masterData.hint": "Cambios en productos, socios comerciales o ubicaciones.",
    "notifPrefs.shareLinks": "Enlaces compartidos",
    "notifPrefs.shareLinks.hint": "Actividad en los enlaces que ha compartido con otros.",
    "notifPrefs.affiliate": "Programa de afiliados",
    "notifPrefs.affiliate.hint": "Estado de la solicitud, comisiones y pagos de tu cuenta de afiliado.",
    "notifPrefs.crm": "CRM de ventas",
    "notifPrefs.crm.hint": "Clientes potenciales asignados a ti, recordatorios de tareas, respuestas, actualizaciones de comisiones y pagos, e hitos de objetivos.",
    "common.typeConfirm": "Escriba CONFIRM para continuar",
    "paymentReminders.offBanner": "Los recordatorios de pago están desactivados — esta configuración se guarda, pero no tendrá efecto hasta que la active arriba.",
    "settingsNudge.title": "Termina de configurar tu espacio de trabajo",
    "settingsNudge.body": "Moneda, marca, recordatorios de pago y más — todo en un solo lugar.",
    "settingsNudge.cta": "Abrir Configuración de la Aplicación",
    "paymentReminders.testEmail.title": "Enviar correos de prueba",
    "paymentReminders.testEmail.desc": "Vea el formato exacto del recordatorio + informe antes de activarlo para socios comerciales reales. Nunca afecta datos reales.",
    "paymentReminders.testEmail.cta": "Enviar Prueba",
    "Mill Jobs": "Órdenes de aserrado",
    "Stock in Hand": "Stock en mano",
    "crm.liveCall.button": "Videollamada",
    "crm.liveCall.title": "Videollamada",
    "crm.liveCall.starting": "Iniciando la llamada…",
    "crm.liveCall.startFailed": "No se pudo iniciar la llamada.",
    "crm.liveCall.retry": "Intentar de nuevo",
    "crm.liveCall.inProgress": "Hay una llamada en curso.",
    "crm.liveCall.rejoin": "Volver a entrar",
    "crm.liveCall.end": "Finalizar llamada",
    "crm.liveCall.endConfirm": "¿Finalizar la llamada para todos?",
    "crm.liveCall.openTab": "Abrir en una pestaña nueva",
    "crm.liveCall.frameHint": "Si la llamada no aparece aquí, ábrela en una pestaña nueva.",
    "crm.liveCall.inviteTitle": "Invitar a un invitado",
    "crm.liveCall.makeLink": "Crear enlace de invitado",
    "crm.liveCall.newLink": "Crear un enlace nuevo",
    "crm.liveCall.copyLink": "Copiar",
    "crm.liveCall.linkCopied": "Copiado",
    "crm.liveCall.newLinkNote": "Crear un enlace nuevo deja sin efecto el anterior. El enlace funciona unas horas.",
    "crm.liveCall.cancelLink": "Cancelar enlace",
    "crm.liveCall.linkCancelled": "El enlace de invitado ya no funciona.",
    "crm.liveCall.whoJoined": "Quién entró",
    "crm.liveCall.noOneJoined": "Nadie ha entrado todavía con el enlace.",
    "crm.liveCall.admitNote": "Cada invitado espera hasta que lo dejes entrar: pulsa Admit en la llamada. Los invitados no pueden enviar archivos salvo que lo permitas en los ajustes de la llamada.",
    "crm.liveCall.codeNote": "Un enlace enviado por correo también pide un código de 6 dígitos que va a esa misma dirección, así que un enlace reenviado no sirve. Tampoco reenvíes un enlace que copiaste tú.",
    "crm.liveCall.emailPlaceholder": "Correo del invitado",
    "crm.liveCall.sendEmail": "Enviar por correo",
    "crm.liveCall.emailSent": "La invitación fue enviada.",
    "crm.liveCall.enterEmail": "Escribe el correo del invitado.",
    "crm.liveCall.phoneNote": "Para presentar tu pantalla, usa un ordenador. Los teléfonos pueden entrar y hablar.",
    "live.title": "Unirse a la videollamada",
    "live.host": "Anfitrión",
    "live.name": "Tu nombre",
    "live.email": "Tu correo",
    "live.join": "Unirse a la llamada",
    "live.joining": "Entrando…",
    "live.loading": "Cargando…",
    "live.privacy": "Usamos tu nombre y correo solo para esta llamada. La llamada no se graba.",
    "live.phoneNote": "Puedes entrar desde un teléfono. Permite la cámara y el micrófono cuando se te pida.",
    "live.linkOnly": "Este enlace es solo para ti. Por favor, no lo reenvíes.",
    "live.waitNote": "Cuando entres, el anfitrión te dejará pasar. Puede tardar un momento.",
    "live.codeIntro": "Para asegurarnos de que eres tú, enviamos un código de 6 dígitos a la dirección que recibió la invitación:",
    "live.sendCode": "Enviarme un código",
    "live.sendAgain": "Enviar de nuevo",
    "live.codeSent": "Código enviado. Vale 10 minutos.",
    "live.codeLabel": "Código de 6 dígitos",
    "cw.focusOn": "Pantalla completa: ocultar la barra superior",
    "cw.focusOff": "Mostrar la barra superior",
    "ch.help": "Ayuda",
    "ch.guest.title": "¿Problemas para entrar?",
    "ch.guest.t1": "Usa un ordenador o teléfono con cámara y micrófono. Chrome, Edge, Safari y Firefox funcionan.",
    "ch.guest.t2": "Cuando el navegador pregunte, pulsa Permitir para la cámara y el micrófono.",
    "ch.guest.t3": "Después de pulsar Entrar, el anfitrión tiene que dejarte pasar. Espera un momento.",
    "ch.guest.t4": "¿Sin imagen o sonido? Haz clic en el icono de cámara o candado de la barra de direcciones, elige Permitir y recarga la página.",
    "ch.guest.t5": "¿Atascado en «Iniciando la llamada…»? Revisa tu internet y pulsa Reintentar o Abrir en una pestaña nueva.",
    "ch.guest.t6": "Este enlace es solo para ti. Si otra persona necesita entrar, pide al equipo de LumberLinq que la invite.",
    "ch.customer.title": "Cómo funciona el soporte por pantalla",
    "ch.customer.t1": "Soporte pide ver tu pantalla. No empieza nada hasta que pulses tú el botón de compartir.",
    "ch.customer.t2": "Elige solo la pestaña de LumberLinq. No elijas toda la pantalla ni otra ventana.",
    "ch.customer.t3": "Soporte solo puede mirar. No puede hacer clic ni escribir por ti, y no se graba nada.",
    "ch.customer.t4": "Pulsa Detener arriba cuando quieras terminar. Un teléfono o la app no pueden compartir pantalla: usa Chrome o Edge en un ordenador.",
    "ch.host.title": "Guía de la videollamada",
    "ch.host.t1": "Inicia la llamada desde la cuenta o el negocio. Entras como anfitrión.",
    "ch.host.t2": "Enviar el enlace por correo es lo más seguro: el invitado necesita un código de 6 dígitos que llega a esa dirección.",
    "ch.host.t3": "Cada invitado espera hasta que pulses Admit en la llamada. Admite solo a personas que conozcas.",
    "ch.host.t4": "Mira «Quién entró» abajo. Si hay alguien desconocido, quítalo en la llamada y pulsa Cancelar enlace.",
    "ch.host.t5": "Nunca reenvíes tú un enlace de invitado. Crea un enlace nuevo para cada persona.",
    "ch.host.t6": "Pulsa Terminar llamada al acabar. Se añade una entrada de videollamada a la línea de tiempo de la cuenta. No se graba nada.",
    "ch.check.run": "Comprobar mi configuración",
    "ch.check.testing": "Probando…",
    "ch.check.browserOk": "Este navegador puede entrar en una llamada.",
    "ch.check.browserBad": "Este navegador no puede entrar en una llamada. Usa Chrome, Edge, Safari o Firefox.",
    "ch.check.onlineOk": "Tu internet está conectado.",
    "ch.check.onlineBad": "Pareces estar sin conexión. Revisa tu internet.",
    "ch.check.camOk": "La cámara funciona.",
    "ch.check.camBad": "La cámara está bloqueada o no se encuentra. Permítela en la barra de direcciones y prueba de nuevo.",
    "ch.check.micOk": "El micrófono funciona.",
    "ch.check.micBad": "El micrófono está bloqueado o no se encuentra. Permítelo en la barra de direcciones y prueba de nuevo.",
    "ch.check.shareOk": "Puedes compartir tu pantalla.",
    "ch.check.shareNo": "Este dispositivo no puede compartir pantalla (teléfonos y la app no pueden). Aun así puedes hablar y chatear.",
    "live.ended": "Esta llamada ha terminado.",
    "live.expired": "Este enlace ha caducado. Pide uno nuevo.",
    "live.off": "Las videollamadas están desactivadas ahora mismo.",
    "live.invalid": "Este enlace no es válido.",
    "live.failed": "No se pudo entrar. Inténtalo de nuevo.",
    "live.securityWait": "Completa la verificación de seguridad.",
    "live.frameHint": "Si la llamada no aparece aquí, ábrela en una pestaña nueva.",
    "live.openTab": "Abrir en una pestaña nueva",
    "ss.title": "Soporte por pantalla",
    "ss.joining": "Conectando…",
    "ss.failed": "No se pudo conectar. Inténtalo de nuevo.",
    "ss.retry": "Intentar de nuevo",
    "ss.howTitle": "Cómo compartir tu pestaña de LumberLinq",
    "ss.step1": "Pulsa el botón de compartir pantalla (el icono de monitor) en la parte inferior de la llamada.",
    "ss.step2": "Elige la pestaña llamada LumberLinq (\"Esta pestaña\"). No elijas una ventana ni toda la pantalla.",
    "ss.step3": "Puedes parar en cualquier momento con el botón \"Dejar de compartir\" del navegador, o pulsar Detener sesión aquí.",
    "ss.noShare": "Compartir pantalla no funciona en un teléfono ni en la app. Abre LumberLinq en un navegador de ordenador (Chrome, Edge, Firefox o Safari) para compartir tu pestaña de LumberLinq. Aquí aún puedes hablar y chatear con soporte.",
    "ss.liveBanner": "Soporte solo ve la pestaña que decidas compartir. No se graba nada.",
    "ss.stop": "Detener sesión",
    "ss.stopConfirm": "¿Detener esta sesión de soporte por pantalla?",
    "ss.openTab": "Abrir en una pestaña nueva",
    "ss.frameHint": "Si la llamada no aparece aquí, ábrela en una pestaña nueva.",
    "ss.tabOnly": "Solo se comparte tu pestaña de LumberLinq, nada más.",
    "ss.card.title": "Soporte por pantalla",
    "ss.card.ask": "Pedir a soporte que vea mi pestaña de LumberLinq",
    "ss.card.askHint": "Soporte puede ver tu pestaña de LumberLinq para ayudarte. Solo se comparte esa pestaña, tú decides empezar y puedes parar en cualquier momento. No se graba nada.",
    "ss.card.waiting": "Esperando la respuesta de soporte…",
    "ss.card.cancel": "Cancelar solicitud",
    "ss.card.invited": "Soporte quiere ver tu pestaña de LumberLinq.",
    "ss.card.invitedOther": "Soporte pidió a otra persona de tu empresa que comparta su pantalla.",
    "ss.card.share": "Compartir mi pestaña de LumberLinq",
    "ss.card.notNow": "Ahora no",
    "ss.card.live": "Hay una sesión de soporte por pantalla abierta.",
    "ss.card.liveOther": "Hay una sesión de soporte por pantalla abierta con otra persona de tu empresa.",
    "ss.card.rejoin": "Abrir sesión",
    "ss.card.ended": "La última sesión de soporte por pantalla terminó.",
    "ss.card.declined": "La última solicitud de soporte por pantalla fue rechazada.",
    "ss.card.expired": "La última solicitud de soporte por pantalla caducó.",
    "ss.card.requestFailed": "No se pudo enviar la solicitud.",
    "ss.prompt.title": "Soporte quiere ver tu pantalla",
    "ss.prompt.body": "Soporte te está esperando. Tú decides empezar y puedes parar en cualquier momento. No se graba nada.",
    "ss.prompt.open": "Abrir ahora",
    "ss.prompt.later": "Ahora no",
    "ss.prompt.ticket": "Abrir el ticket",
  },
};
